export const aData = {
  data: [
    {
      id: "dc32c057-9dcc-4ceb-ab27-25589b917f9e",
      text: "B2 - DH-A - Pull Feeders Bussways - Data Hall A",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2520"
    },
    {
      id: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 208,
      parent: "984b19cb-e113-48d8-94eb-b3babf498cee",
      progress: 0,
      source_task_id: "7995108"
    },
    {
      id: "fb530ced-bdce-4605-99a0-4f3b546e3840",
      text: "B1 - mCUP-9 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9330"
    },
    {
      id: "6bef790a-6ff6-4f20-b09b-e512ebc08dc3",
      text: "B1 - 1N1E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5350"
    },
    {
      id: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      text: "Electrical / IDF Room",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 360,
      parent: null,
      progress: 0,
      source_task_id: "8243685"
    },
    {
      id: "255a47ab-14a9-458e-aa70-e6089cdc1429",
      text: "BLDG- - Submittal Rvw/App'l - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: null,
      duration: 168,
      parent: null,
      progress: 0.6,
      source_task_id: "B1.CFCI.6490"
    },
    {
      id: "ea9a21bf-e817-43c1-bcc8-763009f2c839",
      text: "B1 - 1D2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 8,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2070"
    },
    {
      id: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      text: "Corridor 2A2",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 976,
      parent: "e90cdcbe-e185-46c0-b35d-3e4b46b93bb8",
      progress: 0,
      source_task_id: "7995089"
    },
    {
      id: "58e69692-582f-4ed8-b81b-9b3aed1968c9",
      text: "UG Electrical",
      type: 0,
      start_date: "2025-02-04T00:00:00",
      end_date: "2025-02-08T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8130"
    },
    {
      id: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd",
      text: "B1 - DH-A - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 40,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1560"
    },
    {
      id: "46128479-b4b7-4e4f-9f65-335735d39d3a",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 64,
      parent: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      progress: 0,
      source_task_id: "MECO-1060.10"
    },
    {
      id: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      text: "Skin",
      type: 5,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 560,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995407"
    },
    {
      id: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      text: "Interior Construction",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 1408,
      parent: null,
      progress: 0,
      source_task_id: "8243672"
    },
    {
      id: "ec8c324c-6463-48e9-b903-80266c8ff78f",
      text: "Deep Underground - Plumbing",
      type: 0,
      start_date: "2024-12-13T00:00:00",
      end_date: "2024-12-24T08:00:00",
      duration: 64,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1100"
    },
    {
      id: "4b2ccbf5-ac0d-4c64-a01b-42e199315640",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2010"
    },
    {
      id: "b9314653-77f0-48d1-bde5-474d6e0c7b50",
      text: "B1 - 1N1E - Corridor - OH Rough In Feeder",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5330"
    },
    {
      id: "3ce860a8-26f7-4488-b6a9-d8ef9fcee184",
      text: "Adverse Weather Event 17- 11.07.2024",
      type: 0,
      start_date: "2024-11-07T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1017"
    },
    {
      id: "718288bc-dc43-488f-837b-e5cfdcdbc6ad",
      text: "B2 - mCUP-1 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 48,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1220"
    },
    {
      id: "60a784f9-46e6-429a-aa4e-aa888c93bfcd",
      text: "Building -1",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-01-10T08:00:00",
      duration: 264,
      parent: "05726f27-0840-4b3c-be5a-5c1b8cb2930d",
      progress: 0,
      source_task_id: "8444254"
    },
    {
      id: "dc72aba6-4aeb-4210-b919-c8cf0233965f",
      text: "Mass Grading",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 1784,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0.97,
      source_task_id: "7995182"
    },
    {
      id: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8",
      text: "B2 - 2E2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-01-21T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 24,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6200"
    },
    {
      id: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      text: "mCUP-1-9",
      type: 5,
      start_date: "2024-12-10T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 2864,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995361"
    },
    {
      id: "94535701-0b2c-47fb-8884-38987644a8c3",
      text: "B2 - SSB - 2E1 - Common - Install Cable Tray",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1200"
    },
    {
      id: "79b21e2b-9e78-4e8f-957a-3654e2fdea61",
      text: "Steel Erection Start - DCB2",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-06T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1360"
    },
    {
      id: "a893b11a-9b41-49b4-af57-f4810ebf888c",
      text: "Fire Water",
      type: 5,
      start_date: "2024-10-15T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 168,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995159"
    },
    {
      id: "ff0a3b6f-673a-4683-b7d6-3632c9704274",
      text: "Fab and Deliver - Substation MSG-Alpha - Area SS-1 (2) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 2304,
      parent: "26e5948f-129c-48df-8881-cfc73de88da4",
      progress: 0.3,
      source_task_id: "B1.OFCI.1940"
    },
    {
      id: "d2122c78-55fe-482c-88c1-30ff5b193643",
      text: "[DCB1] DEC-C Ready: Overhead cable tray complete [Area D]",
      type: 0,
      start_date: "2026-03-16T08:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3855"
    },
    {
      id: "32239216-1d56-4b8c-8717-cb39ff680350",
      text: "B1 - 1N2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 24,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5640"
    },
    {
      id: "cb855200-15a5-4ab3-a9f1-53f8d05284a9",
      text: "Substation 1 -  Fabricate / Deliver - H-Frame MOAB",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: "2025-04-01T08:00:00",
      duration: 648,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5810"
    },
    {
      id: "c529e288-1d7f-4a33-8003-8b79b1fb68e2",
      text: "Set Gluelam Columns",
      type: 0,
      start_date: "2025-02-20T00:00:00",
      end_date: "2025-03-19T08:00:00",
      duration: 160,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1020"
    },
    {
      id: "b1e1e1ba-828d-4965-b0fc-93a744d1a672",
      text: "Substation-2 - Ready for Overhead hookups from Santee cooper",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-13T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.7050"
    },
    {
      id: "1cb10928-4d0c-4981-b367-630dddd7d4a2",
      text: "B2 - DH-C - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 240,
      parent: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      progress: 0,
      source_task_id: "B2.C.STR.1780"
    },
    {
      id: "5b5c2b55-e054-4921-b7de-090dc8aad851",
      text: "B2 - DH-D  - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-03-21T08:00:00",
      duration: 40,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1230"
    },
    {
      id: "1a02e549-e5a9-47a5-aaca-4900287d18d3",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-04-27T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1580"
    },
    {
      id: "ebad7460-caeb-4971-b637-b9040af3ff5c",
      text: "B2 - DH-D - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 24,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1440"
    },
    {
      id: "50c5be2e-449e-457d-9b68-640fd14e85e6",
      text: "Kitchen Equipment",
      type: 0,
      start_date: "2024-06-03T00:00:00",
      end_date: "2024-06-03T00:00:00",
      duration: 240,
      parent: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      progress: 0,
      source_task_id: "PRE1520"
    },
    {
      id: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      text: "Substation-1 B Lineup SF6 Breaker",
      type: 5,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 1064,
      parent: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      progress: 0,
      source_task_id: "7995233"
    },
    {
      id: "123bf9e4-d984-4550-8552-c982b6d44c73",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2650"
    },
    {
      id: "4f1da317-0146-4673-8bf4-c6c307a4177c",
      text: "L3 - B1 DHB",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 400,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX3.B1.DHB.1000"
    },
    {
      id: "cb54a186-4490-474c-84c1-b33eba367999",
      text: "BLDG-1 - Area C - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.4350"
    },
    {
      id: "5c9ae33e-5f69-4888-bdde-75af599f05ca",
      text: "B1 - SSB - 1E1 - Common - Install Carpet",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2460"
    },
    {
      id: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 280,
      parent: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      progress: 0,
      source_task_id: "7995101"
    },
    {
      id: "f27f3e64-32fe-4fd7-96c6-d2bbf1f08dd1",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1240"
    },
    {
      id: "a245aa08-11aa-4809-ad44-52e2c2572582",
      text: "L3 Start DH D - DCB2",
      type: 0,
      start_date: "2026-12-18T00:00:00",
      end_date: "2026-12-18T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2032"
    },
    {
      id: "22e77ee8-8fa8-4302-b3c8-4a3c60a98c6d",
      text: "L4 - B1 EY 1C *On Temp Power*",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 40,
      parent: "8d364ed6-8d95-4622-8f88-85275fa83049",
      progress: 0,
      source_task_id: "CX4.B1.MSG.1040"
    },
    {
      id: "70055513-b1cf-403a-b484-c8e2913ef6c0",
      text: "Data Hall B",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 1056,
      parent: "874b638d-a34b-446f-b6f5-a02e31a00edc",
      progress: 0,
      source_task_id: "7995349"
    },
    {
      id: "a81feec3-c833-4eba-b6a2-ef63cd01e43b",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2080"
    },
    {
      id: "535e3d21-5659-4077-8990-7ef7635045e3",
      text: "FRP Equipment Pads",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1000"
    },
    {
      id: "7f963270-d436-447c-bb7f-0dfa4164c6b5",
      text: "B1 - DH-B - Foundations",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 144,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1090"
    },
    {
      id: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      text: "ISP - B2 - Phase 3 (UG and Priority)",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-09-21T08:00:00",
      duration: 1144,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995462"
    },
    {
      id: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 1256,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "7995251"
    },
    {
      id: "a684ba1e-a62f-4426-a990-cf14abf15739",
      text: "Power Alley DH-C",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-11-15T08:00:00",
      duration: 664,
      parent: "e7143409-9746-43ab-abe3-3a9fb88b3f47",
      progress: 0,
      source_task_id: "7995282"
    },
    {
      id: "24056a14-73d9-4677-bb70-dd606edbfc10",
      text: "(CFCI) Div. 05 - Misc Steel (Roof Stairs)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "34ca79b6-dd19-4968-869d-fe70e871b4ad",
      progress: 0,
      source_task_id: "7994931"
    },
    {
      id: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      text: "Slab on Grade",
      type: 5,
      start_date: "2025-04-21T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 688,
      parent: "7b87499f-6094-4da2-9138-6f3e096589f1",
      progress: 0,
      source_task_id: "7995390"
    },
    {
      id: "4504c57c-90c8-40fe-bd78-a8ef31b054bf",
      text: "L4 Start DH C - DCB2",
      type: 0,
      start_date: "2027-01-07T00:00:00",
      end_date: "2027-01-07T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2110"
    },
    {
      id: "02a073d8-cbd9-4dd9-9bc5-4d3542e867d4",
      text: "B1 - mCUP-4 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 80,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.9280"
    },
    {
      id: "70e53b9c-8889-4153-8d55-665a2d13087c",
      text: "Hardlid Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 16,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1120"
    },
    {
      id: "0b1b385e-5b7e-4978-859b-4f7f47a21776",
      text: "[DCB2] FacNet Live [Area B]",
      type: 0,
      start_date: "2026-09-16T08:00:00",
      end_date: "2026-09-16T08:00:00",
      duration: 0,
      parent: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      progress: 0,
      source_task_id: "ICM.B2.3637"
    },
    {
      id: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      text: "Steel",
      type: 5,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 712,
      parent: "7b87499f-6094-4da2-9138-6f3e096589f1",
      progress: 0,
      source_task_id: "7995376"
    },
    {
      id: "cfaf7920-164e-4d55-ad2a-a21cdfa185d2",
      text: "B2 - DH-C - Install Underground Controls",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 80,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1460"
    },
    {
      id: "a187e15c-5311-477e-8dcb-810084b7ae80",
      text: "BLDG-2 DH-A",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 200,
      parent: null,
      progress: 0,
      source_task_id: "8444268"
    },
    {
      id: "57dbfc97-1b1c-4006-8887-97233c57a5fe",
      text: "FRP - Foundations & Spread Footings",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 96,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1010"
    },
    {
      id: "b0a1dc8f-0534-4180-bc09-7ecaeb67015d",
      text: "B1 - DH-B - Connect Buss/Cable Tray Sections - Data Hall B",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2630"
    },
    {
      id: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      text: "Area B",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 640,
      parent: null,
      progress: 0,
      source_task_id: "8258376"
    },
    {
      id: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      text: "GS.IDF.2C1",
      type: 5,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 736,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "7995034"
    },
    {
      id: "45fd1ece-f1fe-430f-97d2-91da4c830bb8",
      text: "Startup & Commissioning",
      type: 5,
      start_date: "2025-01-17T00:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 4720,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0,
      source_task_id: "7994994"
    },
    {
      id: "8787aa3b-3758-4afe-8e7c-459106f3786b",
      text: "B2 - 2A1 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1540"
    },
    {
      id: "594eb490-1320-4f47-81f7-f5c262453d79",
      text: "IBOS - Fabricate / Deliver - PTX",
      type: 0,
      start_date: "2024-09-07T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 1040,
      parent: "c95dcc31-539f-443e-987b-e84c0c944d47",
      progress: 0,
      source_task_id: "IBOS.PROC.1030"
    },
    {
      id: "64c7fe05-0b37-40a6-9022-1bb150ea52ee",
      text: "Tier 2, 3, 4 - B1-1-C",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994793"
    },
    {
      id: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      text: "Cx B2",
      type: 5,
      start_date: "2026-05-27T00:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 1864,
      parent: "b2388eb1-2513-4edc-986a-dda628936e34",
      progress: 0,
      source_task_id: "7994997"
    },
    {
      id: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      text: "Lift station 3 & 4",
      type: 0,
      start_date: "2025-01-16T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 240,
      parent: null,
      progress: 0,
      source_task_id: "8725182"
    },
    {
      id: "e268c818-d3e5-4b88-8a92-e9fe836f88aa",
      text: "B1 - SSB - Install Joists",
      type: 0,
      start_date: "2025-03-25T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 80,
      parent: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      progress: 0,
      source_task_id: "B1.C.STR.1520"
    },
    {
      id: "049aa288-2c9d-40ad-94f5-5139834b37cd",
      text: "Tier 0 - B2-2-B- Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      progress: 0,
      source_task_id: "7994765"
    },
    {
      id: "c02bb0d9-a0ba-46c8-8c9c-98131322446d",
      text: "Building 2",
      type: 5,
      start_date: "2027-03-05T08:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 400,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "7995421"
    },
    {
      id: "c0dc662c-8200-4f0e-90a0-2d410ebc3806",
      text: "Start mCUP Unit Set-In-Place",
      type: 0,
      start_date: "2025-09-29T08:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1182"
    },
    {
      id: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      text: "BLDG-2 SSB",
      type: 5,
      start_date: "2025-10-13T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 672,
      parent: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      progress: 0,
      source_task_id: "7995114"
    },
    {
      id: "00cf1250-f7aa-4db9-b212-6d61f70ddcec",
      text: "B2 - DH-C - Connect Buss/Cable Tray Sections - Data Hall C",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2260"
    },
    {
      id: "b199a1e6-cd22-493b-b634-8549d0c9b3cc",
      text: "B1 - DH-B - Install Tech Water - Data Hall B",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2450"
    },
    {
      id: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      text: "B1 - DH-C - Precast",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 48,
      parent: "207ff153-3106-400e-81bf-813e6c81e518",
      progress: 0,
      source_task_id: "B1.C.1880"
    },
    {
      id: "9ed39b75-5a51-4da4-b811-ee9fc4d666a1",
      text: "Area B",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "ecfebf51-313f-4853-b0ae-977885b2fd85",
      progress: 0,
      source_task_id: "8148737"
    },
    {
      id: "a5943787-f73a-451a-9248-b3dfb00f4b1f",
      text: "WHIDF 2",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "8148734"
    },
    {
      id: "e510d725-9928-4c9c-a856-67b10efca024",
      text: "Restrooms and Janitor Closet",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "8147640"
    },
    {
      id: "b23b0a5f-d4cf-4609-b58f-abfa5f0e9428",
      text: "Install Resinous Flooring",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 24,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1470"
    },
    {
      id: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      text: "Power Alley DH-D",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-06-13T08:00:00",
      duration: 600,
      parent: "4fa3accc-c8b6-477e-8cfb-161dd5586af2",
      progress: 0,
      source_task_id: "7995063"
    },
    {
      id: "223856b2-e50a-4bef-9561-17d9c641c077",
      text: "DH-D",
      type: 5,
      start_date: "2025-08-21T00:00:00",
      end_date: "2026-03-28T08:00:00",
      duration: 1408,
      parent: "b1c751be-46df-40c6-9525-a10c4e362601",
      progress: 0,
      source_task_id: "7995313"
    },
    {
      id: "a4ceac61-6473-41c0-ac65-5807931580c8",
      text: "FR 21 - META Issues CCD #15",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 0,
      parent: "c1f6a7ac-1c93-432b-b5fe-30be07168a44",
      progress: 1,
      source_task_id: "FR.21.1000"
    },
    {
      id: "0ca04492-7b8e-4a4b-aa19-51b6665f0eff",
      text: "WHIDF 1",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "aa5950d5-0931-4f56-8be7-f351baee61ce",
      progress: 0,
      source_task_id: "8148735"
    },
    {
      id: "41c6a663-b2c6-4385-8d87-5aa5fc2c8980",
      text: "B2 - DH-C - Install Joists",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 120,
      parent: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      progress: 0,
      source_task_id: "B2.C.STR.1830"
    },
    {
      id: "87a82d89-6e51-4da3-8339-b6d71883c54f",
      text: "Install Millwork",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1330"
    },
    {
      id: "89cb16bb-25b2-4e5f-bb8c-a9ab72eb9905",
      text: "L3 Finish Network Core - DCB1",
      type: 0,
      start_date: "2026-03-31T08:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2271"
    },
    {
      id: "13069121-3a57-482b-b6ea-e96a60e649ad",
      text: "Area 3 - Cx - Lvl-2, Lvl-3",
      type: 0,
      start_date: "2025-04-16T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8120"
    },
    {
      id: "e2d2bd2c-64b7-4979-b6c4-e062153f7454",
      text: "Tier 1 - B1-1-B - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994800"
    },
    {
      id: "f4555b14-34b1-40f7-b4ba-d44218efa144",
      text: "Fire Water",
      type: 5,
      start_date: "2024-10-02T00:00:00",
      end_date: "2024-11-15T08:00:00",
      duration: 96,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995164"
    },
    {
      id: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      text: "B1 - DH-B - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 40,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1290"
    },
    {
      id: "d0e819bb-a11b-40eb-b54d-89d6687be513",
      text: "B1 - mCUP-8 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8070"
    },
    {
      id: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      text: "(OFCI) B1 Distribution Panels HMD",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3648,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.35,
      source_task_id: "7994976"
    },
    {
      id: "c1ba2981-6a67-4cf7-92fb-4b5136880638",
      text: "Admin Electrical Rooms",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994824"
    },
    {
      id: "d0497d74-20ae-495c-acad-544d6350cd38",
      text: "UG Electrical",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8190"
    },
    {
      id: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      text: "Cx B1",
      type: 5,
      start_date: "2025-10-28T00:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 1792,
      parent: "b2388eb1-2513-4edc-986a-dda628936e34",
      progress: 0,
      source_task_id: "7995006"
    },
    {
      id: "db0dda39-b5f6-4804-bd6f-fa2f5ef3ea3a",
      text: "Finished Carpentry, FRP & Security Panels",
      type: 5,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 1080,
      parent: "e46a1b76-18a8-4bad-aa28-b45be9e9f2c2",
      progress: 0,
      source_task_id: "7994889"
    },
    {
      id: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      text: "BLDG-1 Network",
      type: 5,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-03-18T08:00:00",
      duration: 240,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995401"
    },
    {
      id: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      text: "FCA Gallery DH-C",
      type: 5,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-07-30T08:00:00",
      duration: 568,
      parent: "3750cb98-03f6-4090-9afc-515a595e07ff",
      progress: 0,
      source_task_id: "7995039"
    },
    {
      id: "3e52e142-cda7-417f-b9a7-1aca56e438f7",
      text: "(CFCI) Div. 11 - Kitchen Equip.",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-03-06T08:00:00",
      duration: 0,
      parent: "fe426be2-0e9f-4710-8fb3-13f55f18c43f",
      progress: 0,
      source_task_id: "7994906"
    },
    {
      id: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e",
      text: "B1 - 1D1W - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1790"
    },
    {
      id: "42dbaa91-9879-4ea3-bd17-7c2d7147469b",
      text: "ADMIN  - Submittal Rvw/App'l - Specialities",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6250"
    },
    {
      id: "a21d879b-6b70-43cc-b1d8-40b64e767197",
      text: "IBOS - Fabricate / Deliver - MSB Procurement",
      type: 0,
      start_date: "2024-09-07T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 1040,
      parent: "c95dcc31-539f-443e-987b-e84c0c944d47",
      progress: 0,
      source_task_id: "IBOS.PROC.1040"
    },
    {
      id: "79436c82-c9f4-4f1d-a41c-adae8ff7fcd0",
      text: "B2 - DH-A - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 40,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1290"
    },
    {
      id: "f7a97eec-bc4f-4438-8800-d09c11771317",
      text: "B1 - Fine Grading",
      type: 0,
      start_date: "2025-02-18T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 48,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1030"
    },
    {
      id: "30037543-5725-4df8-9357-01689dbe82c3",
      text: "Area A - OH Security",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1162"
    },
    {
      id: "024d71ac-19c8-4bb6-b95e-9275f25b04ff",
      text: "B1 - 1D1W - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1710"
    },
    {
      id: "298681a4-7398-4abc-bc37-7786f86bcde2",
      text: "B1 - DH-D - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1550"
    },
    {
      id: "d30c3576-6b1d-48cb-b3c9-4ad5620191b8",
      text: "B1 - mCUP-6 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 16,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6010"
    },
    {
      id: "9a25fe95-d613-4fb7-a5c2-313f7a7cb34b",
      text: "B1 - SSB - 1E1 - GSMDF1 - Fire Alarm Wire Pulls/Terms to devices",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 48,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1720"
    },
    {
      id: "b8f22adb-c35a-4940-98cf-9ee8f90cd60f",
      text: "Area 1 - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 120,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1970"
    },
    {
      id: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      text: "B1 - DH-D - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 120,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1480"
    },
    {
      id: "77f3fab3-7eec-42d2-9f00-a300fecd6ca7",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-01T08:00:00",
      duration: 64,
      parent: "82459529-b222-4604-bce3-f899e6205dbc",
      progress: 0,
      source_task_id: "MECO-1060.30"
    },
    {
      id: "df66ea19-518d-4376-a130-f40390d845b0",
      text: "Sprinkler Pipe Connections to Pump",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 40,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1070"
    },
    {
      id: "b490997f-9eef-48b7-9eb0-a07c6491831b",
      text: "Substation-2 - Install Stone Base",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 144,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.7070"
    },
    {
      id: "bf6187b5-e96d-44aa-afd3-3c0e407eb0e8",
      text: "BLDG-2 SSB",
      type: 5,
      start_date: "2025-10-24T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 1296,
      parent: "9a439d8f-7507-4d44-a057-90cba25b759a",
      progress: 0,
      source_task_id: "7995040"
    },
    {
      id: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78",
      text: "B1 - Network - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 120,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1120"
    },
    {
      id: "0865d74e-8b0c-48e0-b17b-b7b82d590b9c",
      text: "Substation-2 - MSG A - Medium Voltage Wire Pulls to HV/MV Transformer (Pulls and Terms)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 104,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4710"
    },
    {
      id: "07b55cfe-9e28-44c9-92c0-80e8fd883c9f",
      text: "(CFCI) Div. 03 - Arch. Precast Concrete",
      type: 5,
      start_date: "2024-10-24T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 664,
      parent: "36b087b6-3ffb-4aea-873b-73cacb04dbd0",
      progress: 0,
      source_task_id: "7994853"
    },
    {
      id: "513d473e-9095-411f-a640-812a54427afc",
      text: "B2 - 2E2E - 02.01.E2.01 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6270"
    },
    {
      id: "f2ecc5b5-e60e-4734-9ef5-8d4465b980c4",
      text: "B1 - 1N1W - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5100"
    },
    {
      id: "d6bfe962-7f86-41ad-b9a2-539ac9c384e6",
      text: "B1 - Network Room 1/4 - Power Alley - Ductwork/EF Install",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1510"
    },
    {
      id: "40c28c28-89aa-4424-b526-6fa909ea3458",
      text: "Building 2 mCUP-1",
      type: 5,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 296,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995148"
    },
    {
      id: "0eea6e98-be15-45ba-bbb7-8612ed4451c8",
      text: "Equipment Installation by Morgan",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8090"
    },
    {
      id: "36589e72-60af-433f-b7dc-d70a600fd0cf",
      text: "Area 2 - UG RI -Generator/LB/GSB -DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1250"
    },
    {
      id: "b91354dd-90da-428d-8013-c5c267d8063e",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2170"
    },
    {
      id: "e7aafb32-b338-4efe-a927-e2163beb72d3",
      text: "Concrete Batch Plant - Foundations",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: null,
      duration: 168,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1080"
    },
    {
      id: "8ee4c4ad-81a5-48ff-8281-1f243e2ea0fb",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.1990"
    },
    {
      id: "e06c64a0-3d93-482b-af80-a8877a5b586c",
      text: "Install Roof IMP System",
      type: 0,
      start_date: "2025-05-08T00:00:00",
      end_date: "2025-05-21T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1040"
    },
    {
      id: "d2608689-c286-449e-9760-9f41fc47b9c8",
      text: "Power Alley NW 1/4",
      type: 5,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 728,
      parent: "36beab78-fbfe-4a35-bcd4-46229816c1f9",
      progress: 0,
      source_task_id: "7995340"
    },
    {
      id: "37518056-3e59-4260-b045-055eb02daf0d",
      text: "B2 - 2E1E - 02.01.E1.01 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5400"
    },
    {
      id: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-A - Coordination / Sign-off",
      type: 0,
      start_date: "2024-08-28T00:00:00",
      end_date: "2024-09-11T00:00:00",
      duration: 240,
      parent: "924e57f3-3d32-432b-aaa2-a93728330198",
      progress: 0,
      source_task_id: "B1.VDC.1550"
    },
    {
      id: "a622cbd7-8c22-4ac6-b430-5ec203d5956b",
      text: "B1 - Network Room 1/4 - FCA Gallery - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.2050"
    },
    {
      id: "9da5f81b-8614-46c6-991f-45da12733b0a",
      text: "(OFCI) LLE - Substation",
      type: 5,
      start_date: "2023-09-08T08:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 3688,
      parent: "8820736c-410e-4efe-a06b-d0fc26d82040",
      progress: 0.38,
      source_task_id: "7994936"
    },
    {
      id: "85b7d3ea-5339-4772-8aed-799cc26f33aa",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-07-13T00:00:00",
      end_date: "2026-07-24T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2360"
    },
    {
      id: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      text: "Signage",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 520,
      parent: null,
      progress: 0,
      source_task_id: "8717097"
    },
    {
      id: "f6076341-e1f4-4fe3-be97-589ae5c1d403",
      text: "Fab and Deliver - HMD - Area B - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 0.35,
      source_task_id: "B2.OFCI.2590"
    },
    {
      id: "a2533a20-0d53-45ea-b590-91cd67e41c2a",
      text: "B1 - 1N2W - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1470"
    },
    {
      id: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      text: "Central Plant Piping Racks",
      type: 5,
      start_date: "2025-07-07T08:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 328,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994831"
    },
    {
      id: "9558fc2d-f9ce-4a1e-8305-7e1b12077a4f",
      text: "B1 - 1D1W - 01D.09 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2660"
    },
    {
      id: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae",
      text: "Substation XFMR - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "670bdb28-db62-4fc2-b89a-d1ad6f28ec8c",
      progress: 1,
      source_task_id: "B1.OFCI.1330"
    },
    {
      id: "c326228f-8c65-44f9-bab9-b8f64730433f",
      text: "Commissioning - IBOS - Level 3 *ON TEMP POWER*",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 200,
      parent: "b902ca4e-8c84-46aa-960c-fe4f123249ab",
      progress: 0,
      source_task_id: "IBOS.CON.1100"
    },
    {
      id: "73113448-b7bf-4cd2-871a-20a72e48c232",
      text: "Temp Cx Power Available",
      type: 0,
      start_date: "2025-07-01T08:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2001"
    },
    {
      id: "e1e70b1c-59e1-4500-b17a-b85ea53e6deb",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-10-14T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6070"
    },
    {
      id: "0a6b1d56-7242-4666-9d25-f6d170e3a30c",
      text: "B2 - 2D2 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 160,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1740"
    },
    {
      id: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      text: "Corridor 1A2E",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 976,
      parent: "054a9e24-8b55-4c38-9a7c-33e8c68c8bc1",
      progress: 0,
      source_task_id: "7995308"
    },
    {
      id: "03b1cd35-79d5-48f0-a78d-368c4e4a2d8b",
      text: "Precast Area C",
      type: 5,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 40,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "7995023"
    },
    {
      id: "5b840173-dcdf-4dc4-87cb-568de87b9576",
      text: "B2 - 2D1W - 02D.09 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1830"
    },
    {
      id: "4a484421-8677-4582-b1c2-bf084eda3a6e",
      text: "B2 - mCUP-2 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 48,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2060"
    },
    {
      id: "7b0ff082-1a8d-4fbb-823a-51a904e0bf1d",
      text: "FR 02 - META Review and Approve/Provide comments on  draft TIA#1",
      type: 0,
      start_date: "2024-08-28T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 1,
      source_task_id: "FR.02.1060"
    },
    {
      id: "f1cd5b7a-b7b4-44f8-8b2b-0bba0044e6c6",
      text: "Domestic Water",
      type: 5,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 56,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995195"
    },
    {
      id: "f1e70243-6fd8-4fee-99a0-182941be0a6d",
      text: "(OFCI) B1 MRPP Mobile Row Power Panel",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0,
      source_task_id: "7994982"
    },
    {
      id: "f5fd7581-bc99-48e6-9c5f-e9c3ee6de080",
      text: "B1 - Specialties - Lighting/Pulls/Terms",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 160,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1030"
    },
    {
      id: "206283d0-e423-4c0a-a891-8e8b3ddff94a",
      text: "B1 - DH-A - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1270"
    },
    {
      id: "bfc6e3fc-f68d-4c7b-aa41-55b6f0a76c8f",
      text: "(CFCI) Div. 26 - Substation (Permanent)",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2025-03-06T08:00:00",
      duration: 880,
      parent: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      progress: 0,
      source_task_id: "7994870"
    },
    {
      id: "7085aaf1-4a32-4af6-aab6-cc21a3c34f7b",
      text: "NWS Electrical Yard Skids",
      type: 5,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994833"
    },
    {
      id: "764226b4-1845-478e-acbb-28aa60f66f32",
      text: "L4 - NS *On Temp Power*",
      type: 0,
      start_date: "2026-03-11T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 240,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX4.B1.NS.1000"
    },
    {
      id: "1c32d3c5-2162-416b-b490-7789ede3fe93",
      text: "Install Walk-In coolers",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1090"
    },
    {
      id: "44f5801c-e795-4119-bc54-671db47310a9",
      text: "Mechanical / Plumbing - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1300"
    },
    {
      id: "75feb546-72f5-485e-9123-df0822ccf857",
      text: "B1 - SSB - 1E2 - Common - Install Devices in Tile/OH Sprinkler",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2050"
    },
    {
      id: "e96d272f-5153-4181-9fdc-b3c332b99bdc",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [2] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-02-18T08:00:00",
      duration: 2360,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.59,
      source_task_id: "B2.OFCI.2800"
    },
    {
      id: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1840"
    },
    {
      id: "7a1ffe3a-b0ef-4afc-abb2-f0320e1dff02",
      text: "B2 - DH-B - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-03-27T08:00:00",
      duration: 40,
      parent: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      progress: 0,
      source_task_id: "B2.C.EY.1490"
    },
    {
      id: "43fa6348-9137-47d6-98c6-58502b3ad1cd",
      text: "Install Countertops",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1280"
    },
    {
      id: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664",
      text: "B1 - mCUP-5 - Install Electrical /  Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5070"
    },
    {
      id: "ad6ea47d-0227-4c90-93ae-18a23b637e99",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1520"
    },
    {
      id: "95942b49-8cc2-4727-8c5c-c892c766937c",
      text: "B2 - mCUP-2 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2070"
    },
    {
      id: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      text: "L4 - B1 DHA",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 280,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHA.1000"
    },
    {
      id: "3259bfff-3b82-4026-ba38-67b655d69e5d",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Interior Metal Panels",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 120,
      parent: "340322b8-8cb9-43d8-b4b9-513b36f312e3",
      progress: 0,
      source_task_id: "B1.CFCI.3800"
    },
    {
      id: "d0fe2a47-291c-4527-8865-41785c38f7e5",
      text: "L4 - NS - Server Migration",
      type: 0,
      start_date: "2026-04-22T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 16,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX4.B1.NS.1020"
    },
    {
      id: "2d8de93f-1b26-44ab-866b-6b03baf2b090",
      text: "Phase 2 - Cut/Fill and Establish Grade",
      type: 0,
      start_date: "2026-08-27T00:00:00",
      end_date: "2026-09-24T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1090"
    },
    {
      id: "97f20729-8bf3-434f-b95e-51d046df0f22",
      text: "B2 - mCUP-2 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2100"
    },
    {
      id: "1e199cbb-5a6c-4990-816c-4b3c64e4b862",
      text: "Window Treatments - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5840"
    },
    {
      id: "d9b4bf3e-fb02-4ca1-92c7-2a7d791e068f",
      text: "B2 - DH-B - Grout Column Baseplates",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      progress: 0,
      source_task_id: "B2.C.STR.1860"
    },
    {
      id: "7487f917-9201-4929-bdfe-a4192e4496dd",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Plumbing",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1540"
    },
    {
      id: "aa74099b-0c1f-464d-ba37-712d8efd9636",
      text: "Delivery of FCA - Fan Coil Assembly (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-05-13T08:00:00",
      end_date: "2025-05-13T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1835"
    },
    {
      id: "026e3909-8c5e-443b-830c-4d8cfc419135",
      text: "PHASE Admin Substantial completion",
      type: 0,
      start_date: "2026-05-06T08:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.B1.1120"
    },
    {
      id: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      text: "BLDG-1 Network Rooms 1/2/3/4",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 1176,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995323"
    },
    {
      id: "c3663f49-f9fe-4488-95ae-cd7c7fffcf60",
      text: "FR 37 - META review and respond to RFI #315",
      type: 0,
      start_date: "2024-11-15T00:00:00",
      end_date: null,
      duration: 48,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0.5,
      source_task_id: "FR.38.1130"
    },
    {
      id: "50f5196d-2758-41f7-896e-2e6190d0ed68",
      text: "(CFCI) Div. 32 - Landscape/ Irrigation",
      type: 5,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 800,
      parent: "5897d1e2-fe31-4d56-b344-c64086e9b0ca",
      progress: 0,
      source_task_id: "7994914"
    },
    {
      id: "cd745684-2268-4d67-9108-311eed425b56",
      text: "B2 - DH-A - El Equip Yd - Buildout MSG and Set-In Place inspections",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 80,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1050"
    },
    {
      id: "19953082-3717-43fe-93f3-417e81747798",
      text: "B1 - DH-C - Install IMP Ceiling - Data Hall C",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2150"
    },
    {
      id: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366",
      text: "B1 - DH-C - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall C",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2670"
    },
    {
      id: "dc727030-3436-4830-b662-f823bffdb9cc",
      text: "FR 36 - META review and respond to RFI #163",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: null,
      duration: 56,
      parent: "402f3329-410a-4e55-9edb-1757470a7890",
      progress: 1,
      source_task_id: "FR.09.1930"
    },
    {
      id: "20872aa2-d7af-43f1-a3dd-a82ee57e4bfc",
      text: "B1 - Network Room 2/3 - Install Ceiling Tiles",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2080"
    },
    {
      id: "18ca2253-1620-475c-ae66-5a44a0184907",
      text: "Area A - Install Storage Racks",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 80,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1371"
    },
    {
      id: "57f56bd9-6efa-4388-ac15-59b161054478",
      text: "B2 - 2D1W - 02D.08 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1670"
    },
    {
      id: "95ab295b-61c8-4540-9644-ae764ce03ac4",
      text: "Fire Pump and Electrical Room",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "8147641"
    },
    {
      id: "0030099f-bbea-4b45-9ffb-9bcfe33c7559",
      text: "Eq Hookups Data Halls C/D",
      type: 5,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 408,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995370"
    },
    {
      id: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      text: "Area 5 - Sanitary Sewer Install",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: "2024-08-30T08:00:00",
      duration: 136,
      parent: "399c6478-9304-4e18-b7dc-7362df4ac7a7",
      progress: 0,
      source_task_id: "C.CSU.A5.2000"
    },
    {
      id: "61ef7534-771e-4cdd-9a80-638e1490c940",
      text: "PEMB - IBOS - Issue Subcontract",
      type: 0,
      start_date: "2024-05-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "Design.PreC.5970"
    },
    {
      id: "6725cdd6-3932-4749-933f-a357ed54d695",
      text: "B1 - DH-C - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 40,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1340"
    },
    {
      id: "e54677f6-2002-4889-a4b6-e599fa7e607d",
      text: "B2 - DH-C - Lightning Protection",
      type: 0,
      start_date: "2026-02-25T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B2.C.RF.1430"
    },
    {
      id: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      text: "Procurement",
      type: 5,
      start_date: "2023-11-15T00:00:00",
      end_date: "2024-11-26T08:00:00",
      duration: 2088,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 0.56,
      source_task_id: "7994728"
    },
    {
      id: "e867ac94-6bee-479f-b924-c25290e08341",
      text: "BLDG-1 - Area A - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.4790"
    },
    {
      id: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61",
      text: "B1 - DH-C - Set CDU's - Data Hall C (16 total; 4 per day)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 64,
      parent: "0346efe3-b63f-4628-9749-3c3592992deb",
      progress: 0,
      source_task_id: "B1.C.C.3065"
    },
    {
      id: "9194dc8f-640b-4d87-958e-4b6998f0d0cd",
      text: "L3 Finish mCUP  - DCB1",
      type: 0,
      start_date: "2026-02-17T08:00:00",
      end_date: "2026-02-17T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2071"
    },
    {
      id: "53c9a6e9-fb4e-4050-afd8-3489cd9fd586",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 8,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1420"
    },
    {
      id: "0cfa7d46-6fa8-4c2f-8681-6bbbbc779220",
      text: "B1 - DH-D - Grout Column Baseplates",
      type: 0,
      start_date: "2025-06-23T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 48,
      parent: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      progress: 0,
      source_task_id: "B1.C.STR.2240"
    },
    {
      id: "4fa3accc-c8b6-477e-8cfb-161dd5586af2",
      text: "Data Hall D",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 1384,
      parent: "6b113e4f-7c30-4f40-87bf-7db528dc210c",
      progress: 0,
      source_task_id: "7995062"
    },
    {
      id: "86b147cb-cbfe-4863-bb5b-52adde86f2de",
      text: "B1 - 1N1E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1660"
    },
    {
      id: "3d32e5fb-ab4b-48e0-89f7-bea181ac0e57",
      text: "Tier 0 - B2-2-E - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      progress: 0,
      source_task_id: "7994763"
    },
    {
      id: "686f42a3-672f-4965-a1fe-24b484a11a33",
      text: "(CFCI) Div. 14 - Conveyance",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994910"
    },
    {
      id: "cb891f47-ae1b-4b60-bc54-add7c2a5d451",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-B - Coordination / Sign-off",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: "2025-01-10T08:00:00",
      duration: 240,
      parent: "7b800596-3c18-4eef-a601-dc65353e5660",
      progress: 0,
      source_task_id: "B1.VDC.1590"
    },
    {
      id: "7ced8c30-c0f2-42f2-95e4-44502bd2bbbb",
      text: "B2 - DH-B - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1090"
    },
    {
      id: "2d6d9e7d-7442-49ba-983b-be39be3955c1",
      text: "Substructure - IBOS (LOE)",
      type: 0,
      start_date: "2024-12-13T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 400,
      parent: "ecfebf51-313f-4853-b0ae-977885b2fd85",
      progress: 0,
      source_task_id: "IBOS.CON.1000"
    },
    {
      id: "49d33848-79d4-4f84-926b-2a2ad57df1b4",
      text: "B1 - DH-C - L2 CDU Install Verification - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 144,
      parent: "dcac32fd-f134-4e86-b43f-bafd5526cedf",
      progress: 0,
      source_task_id: "B1.C.C.3200"
    },
    {
      id: "8a74d03f-f968-44c2-9b53-777ec90bbc73",
      text: "L3 - B2 DHC",
      type: 0,
      start_date: "2026-11-18T00:00:00",
      end_date: "2027-02-02T08:00:00",
      duration: 400,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX3.B2.DHC.1000"
    },
    {
      id: "407c4104-58c9-4abc-ba55-72d26fcb7aba",
      text: "B2 - 2C1W - 02C.07 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-04-01T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1860"
    },
    {
      id: "57671927-a311-474e-8989-77df905ce949",
      text: "B1 - DH-C - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 24,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1440"
    },
    {
      id: "81b4eafb-1d38-447e-81d2-2fb02f964330",
      text: "Site / UG BIM - Critical Early Release - Lift Station Design Change Delay (Post IFP)",
      type: 0,
      start_date: "2024-04-09T00:00:00",
      end_date: "2024-04-19T08:00:00",
      duration: 72,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1120"
    },
    {
      id: "f59aaf4a-72a6-47ad-94e8-6c24c7984bb6",
      text: "OH MEPF Work (Above Hard Ceiling)",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 40,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1010"
    },
    {
      id: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346",
      text: "Power Available from Utility",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-22T00:00:00",
      duration: 0,
      parent: "343acf74-d115-412c-91e3-d35be32f0404",
      progress: 0,
      source_task_id: "CX.MIL.1010"
    },
    {
      id: "56b53c19-ad96-4fd5-a1e7-89aceb850c87",
      text: "BLDG-1 DH-A - Equipment Final Clean",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1080"
    },
    {
      id: "527d81e1-c1f2-451f-a6a7-2901ef53f45b",
      text: "Substation-1 - TX A - NETA Testing Cables",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 160,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4110"
    },
    {
      id: "cedeb8b1-272c-49fb-a5a4-d879e3270874",
      text: "B1 - 1C2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1280"
    },
    {
      id: "99543c36-bac6-4afc-9da4-f27a16a479e3",
      text: "B1 - 1B2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1320"
    },
    {
      id: "fdd08f87-943d-4f29-810a-c64b8bbc8c73",
      text: "B2 - 2D1 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1170"
    },
    {
      id: "05162f5f-6979-48fc-b69f-7d33a5c9783c",
      text: "BLDG-1 - BIM - Tier 0 - iBOS - Coordination / Sign-off",
      type: 0,
      start_date: "2024-06-21T00:00:00",
      end_date: "2024-08-02T08:00:00",
      duration: 240,
      parent: "17f7bc24-cabe-4894-87dd-c247c97c43ef",
      progress: 0.03,
      source_task_id: "B1.VDC.1700"
    },
    {
      id: "7d349ec9-b5b0-46eb-9861-cc3e5d3c1039",
      text: "B2 - DH-B - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2026-05-29T08:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 0,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2790"
    },
    {
      id: "5d6b61b4-8b2e-4901-821d-125438c2d3e1",
      text: "B2 - 2A1 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 120,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.2530"
    },
    {
      id: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      text: "UPS Room 01N3.06",
      type: 5,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 480,
      parent: "19d232aa-0dc1-49f0-93d6-1893cfabaf59",
      progress: 0,
      source_task_id: "7995326"
    },
    {
      id: "62fef0d4-9d43-4611-98d6-e390de33ea94",
      text: "B2 - mCUP-1-8 - Equipment Pads (Sequence 2 )",
      type: 0,
      start_date: "2025-04-16T00:00:00",
      end_date: "2025-05-08T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1030"
    },
    {
      id: "6df58375-5083-47ae-b1ca-cfde0da13f35",
      text: "B2 - DH-C - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 192,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1960"
    },
    {
      id: "75606926-de16-4a15-80c1-938e9788b30a",
      text: "Area B - Seal Concrete Floors",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1390"
    },
    {
      id: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      text: "Fragnet 38 - IBOS Structural Design delay",
      type: 0,
      start_date: "2024-11-14T00:00:00",
      end_date: null,
      duration: 248,
      parent: null,
      progress: 0,
      source_task_id: "8784276"
    },
    {
      id: "e8e087a2-228d-4d9a-91a8-4636f0923181",
      text: "Doors, Frames & Hardware (HM and Wood)",
      type: 5,
      start_date: "2024-09-09T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 640,
      parent: "4fc673cb-0d55-4b7a-adb1-7bee9f658bfd",
      progress: 0,
      source_task_id: "7994898"
    },
    {
      id: "fb45b960-09a6-4197-b4e2-b2c45e54f7e3",
      text: "Site Sewer Available",
      type: 0,
      start_date: "2024-07-31T08:00:00",
      end_date: "2024-07-31T08:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "ICM.B1.4140"
    },
    {
      id: "b6935558-e269-48b5-9d3a-58f50aa9c697",
      text: "B2 - SSB - Install Mullions for Curtain Wall",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 120,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "B2.C.5010"
    },
    {
      id: "48fc00e1-5e72-4adf-8abf-9845dda9b95b",
      text: "B1 - DH-B - Rough in HAC Lighting - Data Hall B",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2460"
    },
    {
      id: "9c99b40c-006f-432f-9db7-7a9c413cb800",
      text: "DFSMA - DC2 DHD HAC ROJ - MOFE",
      type: 0,
      start_date: "2026-05-19T08:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 0,
      parent: "f0d9ef4f-191d-4d39-9779-5b0274a8fb64",
      progress: 0,
      source_task_id: "B2.DFSMA.1040"
    },
    {
      id: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9",
      text: "B1 - Deep Telecom - EF2",
      type: 0,
      start_date: "2024-12-03T00:00:00",
      end_date: "2024-12-07T08:00:00",
      duration: 40,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2390"
    },
    {
      id: "ed7deb49-ca4e-4b2b-888b-59bc1e4264c8",
      text: "B2 - DH-D - SOG",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-17T08:00:00",
      duration: 208,
      parent: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      progress: 0,
      source_task_id: "B2.C.STR.2210"
    },
    {
      id: "82776877-17c6-4167-b7d2-8129286a7a23",
      text: "B2 - SSB - 2E2 - Common - Install Ceiling Tiles",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 80,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1760"
    },
    {
      id: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      text: "Open",
      type: 0,
      start_date: "2023-12-01T00:00:00",
      end_date: null,
      duration: 4112,
      parent: null,
      progress: 0.13,
      source_task_id: "8519838"
    },
    {
      id: "8d4d8256-409e-4d95-892b-af9af8c83747",
      text: "B1 - Network - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-05-08T00:00:00",
      end_date: "2025-05-13T08:00:00",
      duration: 40,
      parent: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      progress: 0,
      source_task_id: "B1.C.STR.1940"
    },
    {
      id: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      text: "Substation-2 Yard",
      type: 5,
      start_date: "2025-04-01T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 3048,
      parent: "164cb27d-1630-4aff-a06d-f1118a0a3eaf",
      progress: 0,
      source_task_id: "7995214"
    },
    {
      id: "65a406fa-3b1d-4063-ae0b-56a8371486ef",
      text: "Area 2 - NCP Duct Bank & Equipment Install",
      type: 0,
      start_date: "2024-12-05T00:00:00",
      end_date: "2024-12-19T08:00:00",
      duration: 104,
      parent: "7b5ca09d-c5ae-42c2-ae95-b99448c62504",
      progress: 0,
      source_task_id: "C.CSU.A2.6000"
    },
    {
      id: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      text: "B2 - 2D2 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-31T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 24,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1200"
    },
    {
      id: "0497b6bf-f811-43f6-b6dc-b788f581380d",
      text: "Fragnet 03 - Telecom Redesign",
      type: 5,
      start_date: "2024-05-10T00:00:00",
      end_date: "2024-06-07T08:00:00",
      duration: 184,
      parent: "6083e472-b9b9-4ec9-90de-2a721818dc61",
      progress: 1,
      source_task_id: "8044946"
    },
    {
      id: "aa5950d5-0931-4f56-8be7-f351baee61ce",
      text: "Warehouse",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "8147638"
    },
    {
      id: "78f3161b-0e60-4435-802c-e2aeb322f78c",
      text: "Conditioned Storage",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "8147639"
    },
    {
      id: "dc78887d-8014-48b1-ad06-f9bf1be85152",
      text: "Fragnet 04 - BMcD VE Lighting Efforts",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: null,
      duration: 152,
      parent: null,
      progress: 0.12,
      source_task_id: "8401870"
    },
    {
      id: "f5cede49-5629-40ad-881c-25df81197815",
      text: "Fragnet 02 - Additional Civil & Building Permit Review Time",
      type: 5,
      start_date: "2024-05-06T00:00:00",
      end_date: "2024-08-12T08:00:00",
      duration: 552,
      parent: "6083e472-b9b9-4ec9-90de-2a721818dc61",
      progress: 0.49,
      source_task_id: "8044945"
    },
    {
      id: "3da8b446-dc80-4510-a879-8a4d247ed8cd",
      text: "Area A",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "ecfebf51-313f-4853-b0ae-977885b2fd85",
      progress: 0,
      source_task_id: "8148736"
    },
    {
      id: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      text: "Fragnet 01 - Sanitary Sewer Redesign",
      type: 5,
      start_date: "2024-04-26T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 168,
      parent: "6083e472-b9b9-4ec9-90de-2a721818dc61",
      progress: 1,
      source_task_id: "8008773"
    },
    {
      id: "3a811488-a6fd-4147-bcb0-45f64ab043e7",
      text: "B1 - SSB - 1E2 - Common - Install Plumbing Fixtures",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2220"
    },
    {
      id: "cdb9662a-4d36-4ffc-810b-6f207678f0c6",
      text: "B1 - DH-B - Roofing (Converted to LOE)",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 120,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1300"
    },
    {
      id: "1f7ec1bf-d38a-4189-9e5d-391c669e7e7a",
      text: "Install Vanity",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 24,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1160"
    },
    {
      id: "7e7a2d37-8a90-4f62-a952-2571c980458a",
      text: "B2 - SSB - 2E2 - Common - Point-Up Drywall",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-04-30T08:00:00",
      duration: 64,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1870"
    },
    {
      id: "9287437c-e384-4366-8e16-d6d212da27dd",
      text: "B2 - DH-B - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 80,
      parent: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      progress: 0,
      source_task_id: "B2.C.STR.2120"
    },
    {
      id: "817722c1-e053-4a58-a9fe-2de4c72680d8",
      text: "Substation-1 - A Lineup - Install Transformer Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-01-27T08:00:00",
      duration: 128,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3860"
    },
    {
      id: "cb9ddad6-dc85-427d-a3ce-d7471522dab1",
      text: "(CFCI) Div. 23 - Building Controls",
      type: 5,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 600,
      parent: "68eac5c6-f18e-45f7-880e-8d00154eca77",
      progress: 0,
      source_task_id: "7994904"
    },
    {
      id: "1cd8272e-8d86-4a77-881d-f6e520bf9689",
      text: "Roofing",
      type: 5,
      start_date: "2024-08-02T00:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 560,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994844"
    },
    {
      id: "e81c75e4-bb55-4435-a062-96ab7ab7401f",
      text: "FR 01 - Sanitary Sewer Redesign - Review and Respond to City Comments",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "FR.01.1140"
    },
    {
      id: "06ab6661-40d3-4488-a4b4-db4606d96d4b",
      text: "Security Testing & Commissioning",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.CON.1401"
    },
    {
      id: "05158e38-22d1-4982-9173-ef51acc8a698",
      text: "B2 - DH-C - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 80,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1080"
    },
    {
      id: "e77a0b64-8729-4402-ae64-a99c43ef4805",
      text: "B1 - mCUP-2 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2120"
    },
    {
      id: "ae84b1f4-1253-4a87-a5d7-dc7ee0651f5d",
      text: "Mechanical SA - Meta Authorized",
      type: 0,
      start_date: "2024-04-22T08:00:00",
      end_date: "2024-04-22T08:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "ICM.PRE.1425"
    },
    {
      id: "568ddf74-0210-4ab7-aa8e-7756a7e1c6f0",
      text: "B2 - 2E1E - EF3 - Pull Wire for Lighting/Outlet/Racks (EF3)",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-20T08:00:00",
      duration: 24,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5290"
    },
    {
      id: "8378fdd1-5f48-4fe7-9aa0-90e91ba14421",
      text: "B1 - DH-A - Install HAC Lights - Data Hall A",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2290"
    },
    {
      id: "228f0caf-751b-4c4b-8a9a-b80fc683303d",
      text: "B2 - mCUP-4 - Set in Place Inspections",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 8,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4030"
    },
    {
      id: "303bc0b0-19d9-4996-90c8-75148ad426cd",
      text: "B1 - DH-B - Pull/Term BMS - Data Hall B",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2770"
    },
    {
      id: "09141679-aaef-480d-b587-ffc86af0ed79",
      text: "B1 - 1A2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1470"
    },
    {
      id: "df94fa3d-488e-489f-a649-834674dc00a7",
      text: "Install Louvers",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1090"
    },
    {
      id: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      text: "UPS Room 02C.08",
      type: 5,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 440,
      parent: "df4d1504-15cd-4330-b115-33d36d9863b8",
      progress: 0,
      source_task_id: "7995030"
    },
    {
      id: "6763bb71-859c-4913-bfa4-514ccc75fe1a",
      text: "BLDG-1 DH-D - Equipment Final Clean",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-05-02T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1110"
    },
    {
      id: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e",
      text: "Drywall  Metal Studs - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-06-21T00:00:00",
      end_date: "2024-07-12T08:00:00",
      duration: 120,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0,
      source_task_id: "Design.PreC.1350"
    },
    {
      id: "a8e44ba8-65b0-4924-a399-7d62bc04838c",
      text: "Tier 2, 3, 4 - B2-2-E",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      progress: 0,
      source_task_id: "7994770"
    },
    {
      id: "ad44e771-dd21-4b11-9790-99bd8efe45d1",
      text: "B1 - SSB - 1E2 - Common - Install Light Fixtures",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1990"
    },
    {
      id: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 24,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.1900"
    },
    {
      id: "68c2e9eb-72fc-4028-92be-108879b7b463",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1310"
    },
    {
      id: "04cae6b1-1ca2-4ca5-b054-a176ccf35389",
      text: "Data Hall C (Area 1-C)",
      type: 5,
      start_date: "2024-09-12T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 760,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994816"
    },
    {
      id: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0",
      text: "B2 - DH-A - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 80,
      parent: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      progress: 0,
      source_task_id: "B2.C.STR.2070"
    },
    {
      id: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b",
      text: "B2 - DH-D - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall D",
      type: 0,
      start_date: "2026-09-25T00:00:00",
      end_date: "2026-10-22T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2670"
    },
    {
      id: "405c3e70-d61a-4ad1-b0c0-2459454f102f",
      text: "Install U/G - Plumbing",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1110"
    },
    {
      id: "da5287b0-2e40-4902-bfef-ea8fcb680728",
      text: "B1 - 1N2E - EF3 - Terms for Lighting/Outlet/Racks (EF3)",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 24,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5860"
    },
    {
      id: "6d362162-e47f-4d95-86e2-c479d7641d24",
      text: "B1 - DH-D -Lightning Protection",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1530"
    },
    {
      id: "890be0e6-7ddd-4afb-9208-5be8d777d0f6",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 8,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1480"
    },
    {
      id: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      text: "BLDG-1 Network Electrical Pulls",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 224,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "7995257"
    },
    {
      id: "b321ca87-ddcf-4aa5-97e8-4eed32aaa1e6",
      text: "Install Roof Steel",
      type: 0,
      start_date: "2025-05-01T00:00:00",
      end_date: "2025-05-07T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1030"
    },
    {
      id: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c",
      text: "BLDG-1/2 - Prep / Submit for Review - Plumbing (OH / In Wall)",
      type: 0,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 160,
      parent: "425a3675-d964-4bcd-981d-bc45ef37bf99",
      progress: 0,
      source_task_id: "B1.CFCI.3370"
    },
    {
      id: "28417da3-1430-46f2-a529-29b6830c1d8b",
      text: "B1 - Deep Telecom - EF3",
      type: 0,
      start_date: "2024-11-23T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 40,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2400"
    },
    {
      id: "2c03a27c-9f28-4721-8193-3dd1f3ff7394",
      text: "Substation-1 - MSG A - MSG A Neta Testing",
      type: 0,
      start_date: "2025-05-14T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 152,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3980"
    },
    {
      id: "6e960331-d195-47e6-8456-62d515dbad0e",
      text: "B1 - mCUP-9 - Install Electrical /  Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9070"
    },
    {
      id: "6dd06b46-cefc-408b-b842-c9dc9ddca936",
      text: "Substation-1 - MSG A - Assembly",
      type: 0,
      start_date: "2025-04-26T00:00:00",
      end_date: "2025-05-15T08:00:00",
      duration: 136,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3930"
    },
    {
      id: "6218b51c-4099-4730-8159-d4fece7b402e",
      text: "B1 - SSB - 1E1 - EF1 - Terms for Lighting/Outlet/Racks (EF1)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1860"
    },
    {
      id: "c99bb305-7e29-4836-9aab-de9bf1a5d259",
      text: "(CFCI) Div. 12 - Furnishing`s",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994848"
    },
    {
      id: "05cfe7b3-61a5-42ad-a516-dbad1252fc95",
      text: "B2 - DH-C - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 40,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1750"
    },
    {
      id: "86f6a138-f42f-494f-88ff-6328921697fc",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1340"
    },
    {
      id: "3cb746d5-7da7-4ae2-9158-2a8f2b65f544",
      text: "B2 - DH-A - Install Insulation",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 40,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1240"
    },
    {
      id: "e8c10fa9-fc51-430a-97d0-c66993f2cbe6",
      text: "B1 - 1C1W - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 80,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1860"
    },
    {
      id: "7b323a55-def1-45a9-a444-6364d37527f1",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Erect Building",
      type: 0,
      start_date: "2025-05-09T00:00:00",
      end_date: "2025-06-03T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1050"
    },
    {
      id: "5d7f445c-bab8-459c-a2d9-76286a836653",
      text: "B1 - Network - Install Vapor Barrier",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 40,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1080"
    },
    {
      id: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      text: "BLDG-2 SSB",
      type: 5,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 200,
      parent: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      progress: 0,
      source_task_id: "7995122"
    },
    {
      id: "3e847e73-ae72-4d8b-8537-75b619b72bae",
      text: "Substation-2 - MSG A - Pre-energization MSG A and DC System",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 128,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4790"
    },
    {
      id: "8a4a3438-8ac6-4998-8089-b67abc2eac74",
      text: "B1 - Network Room 2/3 - Install Cable Tray for Perimeter",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2170"
    },
    {
      id: "7161ff52-e6c7-4e5d-8072-2b8e3832367b",
      text: "Phase 2 - Final Clean/Completion",
      type: 0,
      start_date: "2026-10-23T00:00:00",
      end_date: "2026-11-05T08:00:00",
      duration: 80,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1110"
    },
    {
      id: "7d42f996-04d9-4694-b075-de33ad444174",
      text: "[DCB2] FacNet Live [GS EXTERIOR - CRITICAL]",
      type: 0,
      start_date: "2026-05-26T08:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 0,
      parent: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      progress: 0,
      source_task_id: "ICM.B2.3676"
    },
    {
      id: "9e72c1c8-f8b4-498c-958f-8757010c1955",
      text: "B1 - DH-A - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 24,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1580"
    },
    {
      id: "d1105f58-85cd-499a-b014-ff15c6300089",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1620"
    },
    {
      id: "9574aad7-a5ad-4c70-bd12-ae74243eb666",
      text: "FR 29 - DPR Prepare and Submit PCO#27",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "76f1b205-6d2d-4956-8ca6-877a6aaee359",
      progress: 0.5,
      source_task_id: "FR.29.1010"
    },
    {
      id: "20251cd5-70d1-4539-8e49-10e0938be5e9",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2490"
    },
    {
      id: "4b763aab-f0f5-492d-b7d2-832fcfac94f0",
      text: "B2 - DH-D - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 40,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1090"
    },
    {
      id: "4c830df3-5263-4d67-bb71-607442c832de",
      text: "Substation 2 -  Review for Approval - H-Frame Deadend",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-11T08:00:00",
      duration: 72,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5750"
    },
    {
      id: "b762eb08-4b33-4463-a267-d190ae2f80e4",
      text: "FR 08 - DPR Prepare and Submit PCO#4 (Final)",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: null,
      duration: 232,
      parent: null,
      progress: 0.6,
      source_task_id: "FR.08.1060"
    },
    {
      id: "75fa18c7-7c37-4630-a864-781d2429f8f4",
      text: "Adverse Weather Event 17r - 11.08.2024",
      type: 0,
      start_date: "2024-11-08T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1017r"
    },
    {
      id: "d4d4f77a-6856-4cde-9316-deca7201edb9",
      text: "B1 - Rough Grading",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 96,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1010"
    },
    {
      id: "bdd6bcc9-6cee-478a-9438-c01d15187d91",
      text: "B2 - mCUP-3 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3110"
    },
    {
      id: "538fc6c9-bb4f-4f2c-bd27-f7c727136670",
      text: "[DCB2] DEC-C Ready: Overhead cable tray complete [Area B]",
      type: 0,
      start_date: "2026-08-04T08:00:00",
      end_date: "2026-08-04T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3835"
    },
    {
      id: "19026280-2181-479c-b868-57dd673909a0",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2250"
    },
    {
      id: "67b83c41-6c23-46c7-9e0f-ccfffe4510d0",
      text: "PTX & HPT - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 56,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 1,
      source_task_id: "B2.OFCI.1290"
    },
    {
      id: "b63c96da-36fa-47b4-8be9-58a7048706df",
      text: "Power Delay - Delayed Start",
      type: 0,
      start_date: "2023-12-01T00:00:00",
      end_date: null,
      duration: 4112,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0,
      source_task_id: "8519898"
    },
    {
      id: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be",
      text: "Substation Circuit Breaker - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "dce7c311-c42c-460b-bd76-db76204a1acf",
      progress: 1,
      source_task_id: "B1.OFCI.1320"
    },
    {
      id: "c6fe840f-be52-4ca8-9561-7bcdf0c15e44",
      text: "B2 - DH-C - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 40,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1130"
    },
    {
      id: "1b18bdc7-99fb-421e-a5bc-45006d449246",
      text: "Set PTX",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 16,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1080"
    },
    {
      id: "a87dfde1-e047-40d8-85cb-47ce8d4c2680",
      text: "(OFCI) Substation Shelf-Mounted UPS",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0,
      source_task_id: "7994940"
    },
    {
      id: "d58e2573-0b10-4fec-bd22-00b3e57d4e10",
      text: "(OFCI) B2 BMDS Battery Monitoring & Diagnostic System",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0,
      source_task_id: "7994966"
    },
    {
      id: "18f6549c-2d1d-4618-aa99-e759b881d1e0",
      text: "B2 - SSB - 2E1 - Common - Install Devices in Tile/OH Electrical",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1220"
    },
    {
      id: "26c0cf0e-5c92-41c5-bafa-3e5a7e31dffa",
      text: "Fab and Deliver - PTX-DHAux - Area A (2) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-04-18T08:00:00",
      duration: 2456,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.47,
      source_task_id: "B1.OFCI.2450"
    },
    {
      id: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      text: "Meta Contract Milestones",
      type: 5,
      start_date: "2023-10-16T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 7176,
      parent: "5f1ffaa6-2f9b-4373-bdf7-e99300bec629",
      progress: 0.61,
      source_task_id: "7995419"
    },
    {
      id: "ec1a8792-c342-40d1-89c5-b1b3edd3acbf",
      text: "B1 - DH-A - Install Tech Water - Data Hall A",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2120"
    },
    {
      id: "1c474a2a-d77c-41b4-8e2d-8bd7c188f564",
      text: "Area 1 - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: "2024-12-21T08:00:00",
      duration: 296,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1000"
    },
    {
      id: "22a98aa1-9258-445a-88c8-ec8fc61b3775",
      text: "Substation XFMR - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-09-08T08:00:00",
      end_date: "2023-09-08T08:00:00",
      duration: 0,
      parent: "670bdb28-db62-4fc2-b89a-d1ad6f28ec8c",
      progress: 1,
      source_task_id: "B1.OFCI.1190"
    },
    {
      id: "86d85c19-b61d-4c00-a11f-35d2218ec2a5",
      text: "Area B - Specialties",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1380"
    },
    {
      id: "84e77a30-74d9-4f42-82be-12329d0e59fa",
      text: "Campus - Install Campus Hardscape - Sequence 3",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 288,
      parent: "0fbbf7fa-904a-48e8-8721-806fbcb106b9",
      progress: 0,
      source_task_id: "C.SI.HS.1020"
    },
    {
      id: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc",
      text: "B1 - DH-A - Install Decking",
      type: 0,
      start_date: "2025-05-20T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 80,
      parent: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      progress: 0,
      source_task_id: "B1.C.STR.2020"
    },
    {
      id: "7a612763-86ea-4351-9df5-89b71caf4155",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-09-30T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 1200,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "7995129"
    },
    {
      id: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43",
      text: "B2 - DH-A - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2026-02-26T08:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 0,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2070"
    },
    {
      id: "5f497766-2796-4921-b67d-7291ce48d6c4",
      text: "B1 - DH-B - Hookup CDU's - Data Hall B",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 144,
      parent: "b38b9d81-df08-4732-9a53-49eb573b0138",
      progress: 0,
      source_task_id: "B1.C.B.3035"
    },
    {
      id: "9c25f2dc-266e-49fd-9486-f02cd5642489",
      text: "Corridor 1B2E (Spr Riser Rm/Control Rm/GS IDF (2)/ Flex Sp)",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 1056,
      parent: "874b638d-a34b-446f-b6f5-a02e31a00edc",
      progress: 0,
      source_task_id: "7995353"
    },
    {
      id: "f153f900-cd8c-4305-9011-6d0a6cbea678",
      text: "Final Clean",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 8,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1090"
    },
    {
      id: "04c8fdc7-c659-4485-a013-3e2a70e908dc",
      text: "DFSMA - DC2 EY-C Skids ROJ - MOFE",
      type: 0,
      start_date: "2026-03-04T08:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 0,
      parent: "76b1ad37-499d-4ec3-8342-ec0ede70139c",
      progress: 0,
      source_task_id: "B2.DFSMA.1010"
    },
    {
      id: "59e34313-e3f6-4b49-9775-a1cd083a8451",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (A)",
      type: 0,
      start_date: "2025-11-21T08:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 0,
      parent: "a9b0b7b3-691c-4bf3-b255-5085ef8b94aa",
      progress: 0,
      source_task_id: "B2.DFSMA.1380"
    },
    {
      id: "c2e5e0ef-0450-4c12-b7fd-2e114900beb4",
      text: "Fire Protection Rough-In Hardlids",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1110"
    },
    {
      id: "f300c1c1-efdb-4e47-8bbb-a0cfbc3391f6",
      text: "B2 - DH-B - Rough in HAC Lighting - Data Hall B",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2620"
    },
    {
      id: "8fb0b86f-49a9-441a-b227-381decb9e778",
      text: "B1 - DH-D - Steel (Hang Pre-Fab Racks- ROJ)(Converted to LOE)",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-06-21T08:00:00",
      duration: 240,
      parent: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      progress: 0,
      source_task_id: "B1.C.STR.2030"
    },
    {
      id: "c163c2c2-1247-4ae1-8866-8edc23e60da2",
      text: "B2 - SSB - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2026-01-20T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 80,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1310"
    },
    {
      id: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      text: "Kitchen Inspections",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 1248,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "8243676"
    },
    {
      id: "c346d21a-2d3f-4186-814e-b1d3fa714fec",
      text: "B2 - DH-A - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 80,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1200"
    },
    {
      id: "37a12727-fc32-4909-bd72-674264e22d8e",
      text: "B2 - DH-D - Hookup CDU's - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-08-17T00:00:00",
      end_date: "2026-09-08T08:00:00",
      duration: 144,
      parent: "9de23734-57e7-4283-a531-2f57ac2525e9",
      progress: 0,
      source_task_id: "B2.C.D.3350"
    },
    {
      id: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      text: "Admin Procurement",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: null,
      duration: 1160,
      parent: null,
      progress: 0,
      source_task_id: "8243667"
    },
    {
      id: "45263bb1-cb48-4d3e-b94f-d928722eb5c2",
      text: "FR 26 - META review and Approve PCO#24",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "24dee1b8-ef96-4c88-8860-44cdc0415f08",
      progress: 0,
      source_task_id: "FR.26.1020"
    },
    {
      id: "d9da5ebd-01e2-4c37-bd1f-888c5ec86252",
      text: "Fab and Deliver - Fan Coil Assembly - Area A - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 2872,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.37,
      source_task_id: "B1.OFCI.3140"
    },
    {
      id: "20b8f869-0c8e-4a21-9c77-0c6bac5e755d",
      text: "Substation-1 - Hookup of (GS IDF Hut) ((SUBIDF1))",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 80,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6170"
    },
    {
      id: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      text: "BLDG-1 Connectivity",
      type: 5,
      start_date: "2025-06-05T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 2112,
      parent: "cb1dcb5c-8829-4b31-9b55-e2d7b49a06ad",
      progress: 0,
      source_task_id: "7995448"
    },
    {
      id: "ec74b241-b5f5-41a8-8422-5bac868bbf11",
      text: "L3 - B1 DHC",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-07-15T08:00:00",
      duration: 400,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX3.B1.DHC.1000"
    },
    {
      id: "a8404001-50fe-4ad5-9496-6ac0bb33cfd8",
      text: "Gaurd House Constuction Complete",
      type: 0,
      start_date: "2025-12-02T08:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1060"
    },
    {
      id: "da1fe208-5966-4a45-aae4-20418703f1a5",
      text: "B2 - 2B2 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1180"
    },
    {
      id: "75b640bf-5ba2-4aed-95fd-74f3f0339021",
      text: "(CFCI) NCB - Long Lead Elec (Lite Fixtures)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994919"
    },
    {
      id: "9d27a7bb-0b3e-4370-98e3-5fd0c9b6865d",
      text: "B1 - 1N2E - Corridor - Room Fit Out Activities - Set/Hook-Up Equipment",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 160,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6380"
    },
    {
      id: "d158ae2a-501b-459b-9652-20322558222c",
      text: "B1 - DH-A - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 216,
      parent: "55203d15-6a05-4636-aac5-eb996029b878",
      progress: 0,
      source_task_id: "B1.C.STR.2150"
    },
    {
      id: "8393b526-e02f-40a8-bba9-3358e4f77d6f",
      text: "Tier 1 - B1-1-A, - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994798"
    },
    {
      id: "0a63157d-2a02-43f0-9a8e-f26af83b655f",
      text: "B1 - DH-C - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 80,
      parent: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      progress: 0,
      source_task_id: "B1.C.C.3110"
    },
    {
      id: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2025-10-29T00:00:00",
      end_date: "2026-03-07T08:00:00",
      duration: 760,
      parent: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      progress: 0,
      source_task_id: "7995112"
    },
    {
      id: "927e9731-7ace-4d8c-b6d2-b55b2ff6958f",
      text: "FR 25 - META issue CCD #23",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 0,
      parent: "1ac29f4d-573b-42c4-b1bb-fe67a376ad74",
      progress: 1,
      source_task_id: "FR.25.1000"
    },
    {
      id: "3ecc29de-0bef-426d-88a8-e44589e45dcd",
      text: "B1 - DH-C - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 24,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1430"
    },
    {
      id: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      text: "B1 - DH-C - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1690"
    },
    {
      id: "257c3f20-4b6c-4f95-adc0-24b5c749172e",
      text: "Feild measure / Fab Pipe Rails / Bollards",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 320,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1070"
    },
    {
      id: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b",
      text: "B1 - DH-A - El Equip Yd - Set Equipment (12)MVS, (24) PTX, (1)GEN, (1)LB",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2910"
    },
    {
      id: "c44c4f6c-2d81-439a-b235-b65f241133f7",
      text: "B2 - DH-A - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 240,
      parent: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      progress: 0,
      source_task_id: "B2.C.STR.1630"
    },
    {
      id: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      text: "Building 1 mCUP-3",
      type: 5,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 416,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995364"
    },
    {
      id: "d75faebe-8c44-4b46-8f9d-246d49a25804",
      text: "(CFCI) Div. 11 - Loading Dock Equip.",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "fe426be2-0e9f-4710-8fb3-13f55f18c43f",
      progress: 0,
      source_task_id: "7994908"
    },
    {
      id: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      text: "BLDG-2 SSB",
      type: 5,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 120,
      parent: "984b19cb-e113-48d8-94eb-b3babf498cee",
      progress: 0,
      source_task_id: "7995107"
    },
    {
      id: "12e2f435-f4a8-4b0d-a09f-8e43870a1c8c",
      text: "B1 - DH-A - Install BMS Conduit -Data Hall A",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2510"
    },
    {
      id: "2a418e1c-a9bc-4def-82e4-af3354c9c999",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1630"
    },
    {
      id: "642403c1-08c6-42d6-af56-a45514d470ca",
      text: "Substation-2 - MSG A - Install IDF Rack (SUBIDF2)",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 40,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4820"
    },
    {
      id: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      text: "B1 - Network Room 2/3 - Frame Walls (ROJ Facnet Module)Pre-Fab",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1010"
    },
    {
      id: "0d9328c0-cd5f-4004-aad9-a0637e72a123",
      text: "Install Screenwall",
      type: 0,
      start_date: "2025-07-10T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 16,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1060"
    },
    {
      id: "32114684-d80e-47b0-b1ed-dc8ddfcee013",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2080"
    },
    {
      id: "b38b9d81-df08-4732-9a53-49eb573b0138",
      text: "FCA Gallery DH-B",
      type: 5,
      start_date: "2025-10-22T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 576,
      parent: "70055513-b1cf-403a-b484-c8e2913ef6c0",
      progress: 0,
      source_task_id: "7995352"
    },
    {
      id: "3671e562-2962-48c3-9017-e93a291df0ac",
      text: "Fab and Deliver - Fan Coil Assembly - Area B - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 3072,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 0.48,
      source_task_id: "B2.OFCI.2690"
    },
    {
      id: "556f6761-f13c-4fd4-b607-ba5bc889528f",
      text: "[DCB1] FacNet Live [Area B]",
      type: 0,
      start_date: "2026-03-16T08:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3637"
    },
    {
      id: "b015faa4-3a45-43f4-8c84-8c0da0c2c68a",
      text: "UG RI -Panel Boards (PB)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "f4a0770e-db07-467c-95bd-9d401485c3b6",
      progress: 0,
      source_task_id: "MECO-1640.50"
    },
    {
      id: "512c7e2f-0143-4a3c-b17f-a8688702d3d8",
      text: "B1 - DH-C - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1170"
    },
    {
      id: "7cca6b68-f498-4e88-9bf1-7b2e170caa26",
      text: "Area A - Camera Install",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1421"
    },
    {
      id: "2dd5e89e-59fa-4ee2-a53e-5d0f0c8d6152",
      text: "B2 - DH-B - Install Joists",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 120,
      parent: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      progress: 0,
      source_task_id: "B2.C.STR.1710"
    },
    {
      id: "cec068d6-061d-440d-8715-145782365d80",
      text: "B2 - DH-B - Install Coping",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 80,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1340"
    },
    {
      id: "f03a05b0-19e3-4304-947c-06a1bbdcdbde",
      text: "B1 - Network - Roofing (Converted to LOE)",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 120,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1090"
    },
    {
      id: "a8eee6e3-2d89-4dc5-a2ca-5f4d70e31cc0",
      text: "OH Mechanical Rough-In",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1150"
    },
    {
      id: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927",
      text: "[DCB2] DEC-C Ready: Production Cabling [Area C]",
      type: 0,
      start_date: "2026-09-15T08:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3547"
    },
    {
      id: "5aa96d0f-3611-4599-b345-2abdc9204217",
      text: "B2 - DH-C - Install Coping",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-24T08:00:00",
      duration: 80,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1350"
    },
    {
      id: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5",
      text: "L3 Finish EY2 - DCB1",
      type: 0,
      start_date: "2025-12-19T08:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2261"
    },
    {
      id: "09c4ef69-3e77-4cee-8d13-4354a7248ca5",
      text: "TVA Phase 3 Expansion",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "164cb27d-1630-4aff-a06d-f1118a0a3eaf",
      progress: 0,
      source_task_id: "7995227"
    },
    {
      id: "440ebd2a-c3aa-4bc3-8ad4-63f498236ba6",
      text: "Final Clean",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1390"
    },
    {
      id: "510bc2d0-baa0-4dae-92aa-8a3ee8bd7ff3",
      text: "Campus - Construct Permanent Campus Roadways / Lighting - Sequence 2",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 288,
      parent: "26327ae0-6c90-4f36-b131-6ebdf49b7bd8",
      progress: 0,
      source_task_id: "C.SI.RW.1170"
    },
    {
      id: "a889b01a-9e63-4cf7-8e55-f28e9bb68b17",
      text: "Design",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-10-23T00:00:00",
      duration: 0,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 0,
      source_task_id: "7994739"
    },
    {
      id: "6142b5a6-5085-4013-b75a-161e1b24f0a4",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2510"
    },
    {
      id: "ecfebf51-313f-4853-b0ae-977885b2fd85",
      text: "Substructure",
      type: 5,
      start_date: "2024-12-13T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 400,
      parent: "39855758-26c2-45c7-8a00-84dc36793e26",
      progress: 0,
      source_task_id: "8147634"
    },
    {
      id: "1523c30c-a070-48b9-8d6a-445fb0af575f",
      text: "Drywall / Ceilings",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-20T00:00:00",
      duration: 160,
      parent: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      progress: 0,
      source_task_id: "PRE1730"
    },
    {
      id: "e95237f4-3c52-4fdb-86e9-0dee2aecb54e",
      text: "B2 - DH-A - El Equip Yd - Set Equipment (2)MSG",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 80,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1020"
    },
    {
      id: "b76548b6-fbb8-4060-93d6-96869bb2790b",
      text: "B2 - DH-A - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 160,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1830"
    },
    {
      id: "0ed50256-e659-41ad-b5ff-2c9c088bc72c",
      text: "B1 - mCUP-7 - Install FA  (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7110"
    },
    {
      id: "6ccf8e11-2550-49a1-9505-eda80e16d169",
      text: "Substation-1 - MSG A - MSG A Install Control Cabling",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 88,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3960"
    },
    {
      id: "c44f2f8c-314c-4a74-ade0-0ffc414d3176",
      text: "B2 - mCUP-7 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 48,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7000"
    },
    {
      id: "a186b242-b288-4250-b87d-d866ac28f219",
      text: "(CFCI) Div. 09 - Carpet",
      type: 5,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 600,
      parent: "6f5d15b6-3801-4b83-9da3-89ba5b3dc781",
      progress: 0,
      source_task_id: "7994880"
    },
    {
      id: "1b573127-21b9-4d1c-b69b-ddaf4855b3e8",
      text: "Telecom",
      type: 5,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 336,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995198"
    },
    {
      id: "78af96cc-0132-489e-86ac-a457790848a0",
      text: "Campus - Submittal Rvw/App'l -  Sanitary Manholes and Inlets (Early Release) - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-05-31T00:00:00",
      end_date: "2024-05-31T08:00:00",
      duration: 8,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5870"
    },
    {
      id: "629e492e-82fc-4cf7-beab-04f919cf07fe",
      text: "Substation-1 - B Lineup - Install Dead-End Structure Excavate / Form / Pour",
      type: 0,
      start_date: "2024-12-17T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 168,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3360"
    },
    {
      id: "34e8a7cf-289a-4ab0-8e83-86f5b07f43bf",
      text: "GC PWO Exhibits Received",
      type: 0,
      start_date: "2023-11-14T00:00:00",
      end_date: "2023-11-14T00:00:00",
      duration: 0,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "ICM.PRE.1010"
    },
    {
      id: "160e27aa-e51b-4b59-9cf9-62bce45a94be",
      text: "B1 - DH-B - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 40,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1300"
    },
    {
      id: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      text: "B1 - mCUP-9 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9040"
    },
    {
      id: "4146d9bf-f377-4b78-afee-5669b0a41f0b",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Plumbing/Insulation",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1500"
    },
    {
      id: "8df6571f-36b6-4e33-bf2c-f35a98a9a416",
      text: "Substation-2 - MSG B - Install Temp Power / Permenant AC / Anchoring / Set In Place Inspection",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 120,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4340"
    },
    {
      id: "1f7905d5-8d35-4ccb-bdac-e4372f7f0b36",
      text: "Steel Mill Order Placed",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: "2024-07-15T00:00:00",
      duration: 0,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "PRE-PP-1051"
    },
    {
      id: "ccba67c8-adc4-4740-beb2-3df108bebc9a",
      text: "B2 - DH-B - Install Ceiling Tiles - Data Hall B",
      type: 0,
      start_date: "2026-07-08T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 40,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2860"
    },
    {
      id: "f4599d44-08e1-4bc8-a38b-ce840bc83a57",
      text: "Campus - Fabricate / Deliver - Water flow meters",
      type: 0,
      start_date: "2024-10-10T00:00:00",
      end_date: null,
      duration: 960,
      parent: null,
      progress: 0.1,
      source_task_id: "B1.CFCI.6450"
    },
    {
      id: "2b687114-0497-4328-8745-8ddfe24fd8c9",
      text: "B1 - DH-C - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 96,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2130"
    },
    {
      id: "e6ee1a47-00c1-438a-bf5f-47dc81062bef",
      text: "B1 - 1A2E - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1880"
    },
    {
      id: "970684d1-c1b9-4a65-ae7d-e7c725eac5de",
      text: "Install IMP-2 Metal Wall Panels",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 80,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1100"
    },
    {
      id: "89f5c053-9eda-47dc-936b-083b97812fe1",
      text: "Substation-2 - TX A - Pre-energization / Control Power / Dead Bus Checkout",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 152,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4890"
    },
    {
      id: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      text: "FCA Gallery DH-A",
      type: 5,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 416,
      parent: "a8ee1bd4-65c3-4e10-beab-79fa57b9ff73",
      progress: 0,
      source_task_id: "7995302"
    },
    {
      id: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      text: "Corridor 2C2",
      type: 5,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 1056,
      parent: "df4d1504-15cd-4330-b115-33d36d9863b8",
      progress: 0,
      source_task_id: "7995033"
    },
    {
      id: "5c09997c-51e7-4091-98f7-d875a51a2120",
      text: "FR 33 - META issue  CC #224",
      type: 0,
      start_date: "2024-09-21T00:00:00",
      end_date: null,
      duration: 0,
      parent: "cfd3da95-4550-42a9-b5c7-a1c53c8da4cb",
      progress: 1,
      source_task_id: "FR.33.1000"
    },
    {
      id: "0ab563fa-599a-429d-8244-197aea2ebe1a",
      text: "B2 - DH-A - L2 CDU Pre-Eng Inspection - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2026-04-22T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 144,
      parent: "813899cd-a520-4613-8209-38f409169670",
      progress: 0,
      source_task_id: "B2.C.A.3250"
    },
    {
      id: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a",
      text: "B1 - DH-A - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 80,
      parent: "bbb49ac4-d9a7-4848-87c0-a96e61e2e9d9",
      progress: 0,
      source_task_id: "B1.C.A.2850"
    },
    {
      id: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4",
      text: "B1 - SSB - 1E2 - Common - Install Doors and Hardware",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2280"
    },
    {
      id: "9f659885-3b0e-4e27-b922-74f05bf35b5c",
      text: "mCup",
      type: 0,
      start_date: "2024-10-14T00:00:00",
      end_date: "2024-11-06T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "8487777"
    },
    {
      id: "c038d0bd-2c7d-4d4b-b664-9295f06c5fc7",
      text: "Lightning Protection",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1150"
    },
    {
      id: "c77b66a8-a3d3-476b-9c9f-282e513511a2",
      text: "MV Electric",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995197"
    },
    {
      id: "6c43cf58-e286-4fd6-bdf0-87628601b6b1",
      text: "Data Hall A & B Electrical Yard",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "7995004"
    },
    {
      id: "1cdd472a-682f-4de0-8803-4f3b594e6d94",
      text: "B1 - 1N1E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5490"
    },
    {
      id: "9ebe6678-c0b9-4911-b104-b5a4c6175ccd",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1730"
    },
    {
      id: "40b622d9-8ece-4974-8acf-9da8669c4293",
      text: "Tier 0 - B1-1-D - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994807"
    },
    {
      id: "94c84b47-fe68-47e5-8d41-48f07b23bc83",
      text: "B2 - DH-C - WAP Provisioning",
      type: 0,
      start_date: "2026-09-10T00:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 160,
      parent: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      progress: 0,
      source_task_id: "B2.CONN.1260"
    },
    {
      id: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      text: "Kitchen",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 1328,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "8243675"
    },
    {
      id: "da24255a-bc70-4d21-9e35-7a8c48eddcd9",
      text: "B1 - Network Room 1/4  - OH Rough In Branch",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1140"
    },
    {
      id: "ad29afc0-cad3-44f3-ba65-4af58ed0a655",
      text: "B2 - OSP Cabling - EF to GSIDF 2X1",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 40,
      parent: "48b3b449-97e1-4e8d-96ff-da2222ec41de",
      progress: 0,
      source_task_id: "B2.CONN.1000"
    },
    {
      id: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      text: "DEC-C Ready: Production Cabling",
      type: 5,
      start_date: "2026-07-14T08:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 616,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995439"
    },
    {
      id: "f4ea5fb6-6272-4861-9d67-9f10dd8634bd",
      text: "B2 - DH-C - Install Celing Devices BMS - Data Hall C",
      type: 0,
      start_date: "2026-06-15T00:00:00",
      end_date: "2026-07-13T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2570"
    },
    {
      id: "3e8c0791-484f-4914-9287-0377f0681b71",
      text: "B1 - Network Room 1/4  -  E-cure/Seal Floors/QA/QC/Wall Base/Final Paint",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2280"
    },
    {
      id: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 24,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1350"
    },
    {
      id: "5ade9eac-0776-415b-96fd-152a897defdc",
      text: "Hard Ceiling MEPF Rough-In Inspection & QAQC Walks (Area B)",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1310"
    },
    {
      id: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      text: "WAP",
      type: 5,
      start_date: "2025-11-03T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 992,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995454"
    },
    {
      id: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      text: "Campus Make Ready Work",
      type: 5,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-07-17T08:00:00",
      duration: 608,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0.76,
      source_task_id: "7995202"
    },
    {
      id: "036f9220-f14d-4120-816d-cc8e31dbd3d0",
      text: "Install Specialties",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1420"
    },
    {
      id: "b2bf8efa-9f46-4ebe-a15b-98a3a8191296",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1790"
    },
    {
      id: "310f58d8-21bd-41df-aaee-8e33f675e213",
      text: "Area B - Install Millwork / Food Service Equipment",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1370"
    },
    {
      id: "0ca9d33d-ff30-4f12-b143-278fe80add01",
      text: "Substation-2 - B Lineup - Install MSG Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 168,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4250"
    },
    {
      id: "39a3ae66-32ac-404b-abe4-060edea977f7",
      text: "UPS Room 01D.09",
      type: 5,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 480,
      parent: "8b063fd8-f4b7-446c-8f75-0d37bdf1593d",
      progress: 0,
      source_task_id: "7995318"
    },
    {
      id: "65fb539d-2884-4e5b-929c-9b64174cbc72",
      text: "B2 - SSB - 2E1 - Common - Clean",
      type: 0,
      start_date: "2026-05-22T00:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 48,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1420"
    },
    {
      id: "119cc502-8ae5-49f3-a97c-5258d4f4a413",
      text: "B2 - DH-C - Set FCA's - Data Hall C",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1610"
    },
    {
      id: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1410"
    },
    {
      id: "dc25ef75-f235-42ca-9ca9-e941d2d5aa47",
      text: "Exterior Framing / Sheathing",
      type: 0,
      start_date: "2025-05-01T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 80,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1080"
    },
    {
      id: "fb6c8350-7808-4325-a543-4e6cdc271468",
      text: "B2 - Deep Telecom - EF1 - Concrete Scope",
      type: 0,
      start_date: "2025-03-10T00:00:00",
      end_date: "2025-03-14T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B2.C.STR.2480"
    },
    {
      id: "227e4277-f809-4052-8ee9-596efcaeadde",
      text: "Substation-2 - B Lineup SF6 Breaker - L3 Dead Bus Checkout and NETA Testing",
      type: 0,
      start_date: "2026-04-04T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 48,
      parent: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4590"
    },
    {
      id: "a0f193ed-2cfb-4127-8716-6072ecb0d7ec",
      text: "B1 - DH-A - Install Perimeter Cable Tray - Data Hall A",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2710"
    },
    {
      id: "752e1424-4966-438f-9f13-63617950bdd2",
      text: "B2 - DH-B - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 80,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1650"
    },
    {
      id: "b315f00f-2866-48cb-93cf-5c3c98bbac49",
      text: "Concrete Batch Plant - Install/testing",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 0,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1090"
    },
    {
      id: "66d5fb70-4127-4bd5-acfc-d7e8b903a2f0",
      text: "L4 Start DH D - DCB2",
      type: 0,
      start_date: "2027-01-27T00:00:00",
      end_date: "2027-01-27T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2112"
    },
    {
      id: "838408f9-1bdf-4241-b195-b2f3e3568f42",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [1] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 2320,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.6,
      source_task_id: "B2.OFCI.1810"
    },
    {
      id: "0cbde58a-db23-4c77-a8dc-98ff59357956",
      text: "B2 - 2A1 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 160,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1790"
    },
    {
      id: "84186393-ecde-4829-a602-78b7e3b0c994",
      text: "B1 - 1B2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1370"
    },
    {
      id: "6aca4f91-66bc-4158-b0fd-2177a79f139e",
      text: "Fab and Deliver - Control Power STC/SB - Area A - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 3168,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.38,
      source_task_id: "B1.OFCI.2970"
    },
    {
      id: "fbf09de8-1e78-4ba5-94bf-3b04fd044756",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1350"
    },
    {
      id: "6b28c5c6-661a-489f-b668-4e0eb274e4eb",
      text: "B2 - SSB - 2E1 - Common - Install Fire Extinguishers/FECs",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 32,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1350"
    },
    {
      id: "13a9a0eb-6e18-45d1-824d-a57444672783",
      text: "FR 36 - META review and Approve PCO#XX",
      type: 0,
      start_date: "2024-11-26T00:00:00",
      end_date: "2024-12-11T08:00:00",
      duration: 80,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 0,
      source_task_id: "FR.36.1040"
    },
    {
      id: "cd45a412-c5fb-489b-9017-427b73ac339d",
      text: "B1 - 1N1E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6160"
    },
    {
      id: "8ad8975e-64a1-47f8-801f-d0470b7b123f",
      text: "L3 - B1 DHD",
      type: 0,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-08-05T08:00:00",
      duration: 400,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX3.B1.DHD.1000"
    },
    {
      id: "541ef03e-36b9-412a-b477-6af807fe2299",
      text: "Building IFP Design Completion",
      type: 0,
      start_date: "2024-03-29T08:00:00",
      end_date: "2024-03-29T08:00:00",
      duration: 0,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.2300"
    },
    {
      id: "8cee5bf1-1f8b-4db6-a6fe-0033ef97818f",
      text: "BLDG-1/2 - Prep / Submit for Review - Food Service",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6210"
    },
    {
      id: "1aca1855-4070-4470-9d81-e3461d849d96",
      text: "ATS - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 1,
      source_task_id: "B1.OFCI.1040"
    },
    {
      id: "2f4bed0a-c4bb-4262-ba3d-c7cde7a4094c",
      text: "Erect Precast",
      type: 0,
      start_date: "2025-05-15T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 120,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1070"
    },
    {
      id: "054a9e24-8b55-4c38-9a7c-33e8c68c8bc1",
      text: "Corridor 1A2E (GS IDF)/Spoke Parts Area",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 976,
      parent: "be9cecea-8dfc-446f-b163-72434a897bd2",
      progress: 0,
      source_task_id: "7995307"
    },
    {
      id: "0d7cbfaf-7842-41a9-979a-e42998cf714c",
      text: "Substation-1 - MSG B - Install Control Cabling",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-05-31T08:00:00",
      duration: 88,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3580"
    },
    {
      id: "670aec9a-e1eb-4076-9b88-4d9eb7984678",
      text: "[DCB1] DEC-C Ready: OSP Pathways [DAS TOWER #1, GH]",
      type: 0,
      start_date: "2025-11-13T08:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3565"
    },
    {
      id: "1455a002-7d07-41c4-85f5-43fec32823fd",
      text: "L4 Start mCUP  - DCB2",
      type: 0,
      start_date: "2026-07-17T00:00:00",
      end_date: "2026-07-17T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2132"
    },
    {
      id: "f86301b1-0c36-4abf-9ded-349e58977e73",
      text: "B2 - DH-C - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 24,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1440"
    },
    {
      id: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      text: "Corridor 2E1E/ Entrance Facility 3 and 4/UPS (2)",
      type: 5,
      start_date: "2025-11-25T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 816,
      parent: "2190598a-f73d-49e3-90be-8cc832c8ba79",
      progress: 0,
      source_task_id: "7995043"
    },
    {
      id: "54ffb185-2a3c-45de-8a3a-fb9a2d5d0f15",
      text: "Fab and Deliver - STC - Area NW-2 - DCB1 *NEED TO FIND OR DELETE*",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2024-10-15T08:00:00",
      duration: 1688,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.62,
      source_task_id: "B1.OFCI.2820"
    },
    {
      id: "7dff313c-818e-4d23-ad3e-62718f685b52",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Storage racks",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6400"
    },
    {
      id: "94338bcd-7706-43b1-8a41-2c70a99d957b",
      text: "DFSMA - NWS North EY Skids ROJ - MOFE",
      type: 0,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "7085aaf1-4a32-4af6-aab6-cc21a3c34f7b",
      progress: 0,
      source_task_id: "B1.DFSMA.1060"
    },
    {
      id: "858a959c-41a7-4d86-8b40-78d80e3f8433",
      text: "Commissioning - IBOS - Level 4 + 5",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "b902ca4e-8c84-46aa-960c-fe4f123249ab",
      progress: 0,
      source_task_id: "IBOS.CON.1120"
    },
    {
      id: "e3df7dae-a7dc-464f-b17e-801d34dd0f97",
      text: "B1 - DH-B - Install Celing Devices BMS - Data Hall B",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2810"
    },
    {
      id: "76044c4a-8691-42d0-8c22-77d05c84bf4e",
      text: "Phase 1 - De-energize Electrical Equipment",
      type: 0,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1000"
    },
    {
      id: "ca1ccbd8-2a35-49f0-b37e-da2ec19961e4",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2380"
    },
    {
      id: "ba5d547c-dd87-45f6-80f8-6efe121db3ad",
      text: "B1 - RF-Tower-1 - Foundations for Tower 1",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 80,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2170"
    },
    {
      id: "27942519-4b3d-4062-aac5-6d9381642a1d",
      text: "Resource actrivities",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 992,
      parent: null,
      progress: 0,
      source_task_id: "8437453"
    },
    {
      id: "ad824291-d506-42f6-a968-e48d853eec45",
      text: "B2 - DH-B - DEC -C Turnover Walk - Data Hall B",
      type: 0,
      start_date: "2026-08-21T00:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 16,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2920"
    },
    {
      id: "953a1605-7beb-4246-9d00-29478bb5313c",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2260"
    },
    {
      id: "0b1b586a-c09b-4b81-96f1-3bbd4df80534",
      text: "B2 - DH-C - Install IMP Walls @ FCAs - Data Hall C",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1660"
    },
    {
      id: "7c46710d-2c50-4406-a802-78d06cc0a1dc",
      text: "Hang/Tape/Finish Walls",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 48,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1070"
    },
    {
      id: "16b6b02c-c823-4efe-a251-44d995b20682",
      text: "B2 - OSP Cabling - B2 BEV-5,6,7,8 to B2 EF1, EF2, EF3, EF4",
      type: 0,
      start_date: "2026-01-12T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 40,
      parent: "48b3b449-97e1-4e8d-96ff-da2222ec41de",
      progress: 0,
      source_task_id: "B1.CONN.1460"
    },
    {
      id: "85c6cd03-3b65-4583-8a69-7c728f8bc568",
      text: "Install Loose Kitchen Equipment",
      type: 0,
      start_date: "2025-12-15T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1290"
    },
    {
      id: "597b2421-4a81-416d-af5c-e1b336bae474",
      text: "OH Fire Protection",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1410"
    },
    {
      id: "3a343c17-53ff-48a5-8893-78f2791bca9f",
      text: "B2 - DH-C - L2 CDU Install Verification - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-07-13T00:00:00",
      end_date: "2026-08-01T08:00:00",
      duration: 144,
      parent: "b59787b1-4034-47f1-b469-52b087cc7b04",
      progress: 0,
      source_task_id: "B2.C.C.5040"
    },
    {
      id: "43c4736e-bd32-449a-a47a-c4d84ccd371c",
      text: "FR 40 - Review and Approve",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: null,
      duration: 80,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1060"
    },
    {
      id: "698f923b-8739-420e-892e-4ab9e7511606",
      text: "OH Fire Protection",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1160"
    },
    {
      id: "868748e7-75a6-4570-8c91-162cc1574366",
      text: "Substation-2 - MSG B - terminations of MECO scope",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 72,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.6410.1"
    },
    {
      id: "053bca37-c49d-4ae8-b392-2bfa1d70169c",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-A - Coordination / Sign-off",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 240,
      parent: "924e57f3-3d32-432b-aaa2-a93728330198",
      progress: 0,
      source_task_id: "B1.VDC.1570"
    },
    {
      id: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      text: "Approve Permits - Mass Grading",
      type: 0,
      start_date: "2024-04-05T08:00:00",
      end_date: "2024-04-05T08:00:00",
      duration: 0,
      parent: "68519373-5be8-4c94-895d-f8db4c1edde5",
      progress: 1,
      source_task_id: "Design.PreC.5690"
    },
    {
      id: "663380fc-5e84-44c8-9084-4e7d770f64a0",
      text: "L4 Start DH D - DCB1",
      type: 0,
      start_date: "2026-07-01T00:00:00",
      end_date: "2026-07-01T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2112"
    },
    {
      id: "5ad95125-4ed7-4ee8-ad00-2a35b61df06c",
      text: "B2 - DH-D - L2 CDU Pre-Eng Inspection - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-08-31T00:00:00",
      end_date: "2026-09-22T08:00:00",
      duration: 144,
      parent: "9de23734-57e7-4283-a531-2f57ac2525e9",
      progress: 0,
      source_task_id: "B2.C.D.3370"
    },
    {
      id: "e7cd3b17-9525-472a-9f9b-573d1515725a",
      text: "B2 - 2C1W - 02C.07 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 160,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1980"
    },
    {
      id: "5cc06ab5-92a7-4e7d-9ef2-61ece064ce5e",
      text: "B2 - 2A2 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 120,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1120"
    },
    {
      id: "c564465c-020b-4753-8e67-a48c4a5e5f86",
      text: "B2 - DH-C - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 200,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1630"
    },
    {
      id: "37fbd780-08a1-4a12-876d-54b337755932",
      text: "B2 - 2E2E - 02.01.E2.01 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6540"
    },
    {
      id: "9b65810f-93cc-453e-8de8-a75c5f4cb8b5",
      text: "Cx SS B1",
      type: 5,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 120,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995008"
    },
    {
      id: "3348f161-0c63-4379-ad02-7d64020e73be",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Cold Formed Metal Framing",
      type: 0,
      start_date: "2025-02-13T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 80,
      parent: "cdab7e2f-666b-4468-a664-79d098844933",
      progress: 0,
      source_task_id: "B1.CFCI.4530"
    },
    {
      id: "f49b68eb-5a5d-470c-8445-43456b534234",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1580"
    },
    {
      id: "cc151cd6-c099-4849-ad83-f4b5e8927bd7",
      text: "L4 - B1 EY 1 NS/ B *On Temp Power*",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "b4e5a005-102e-4fbf-949a-1ed89d200a5c",
      progress: 0,
      source_task_id: "CX4.B1.MSG.1030"
    },
    {
      id: "8d4fc066-79be-40ac-8740-db2e45be0cca",
      text: "Fab and Deliver - MSB Accessories - Area A - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3808,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.35,
      source_task_id: "B2.OFCI.2410"
    },
    {
      id: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 280,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995400"
    },
    {
      id: "7a91b721-ec5e-45ec-beb7-3df106555700",
      text: "Fab and Deliver - RSB - Area D - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2824,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.42,
      source_task_id: "B1.OFCI.3260"
    },
    {
      id: "5f086f11-ca53-41de-a54b-d75a43515214",
      text: "B1 - DH-A - Install Thermal Concrete",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 120,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1350"
    },
    {
      id: "1c7db9d7-9299-4149-86e9-653c289d3de4",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1540"
    },
    {
      id: "7a2e01a8-6d3e-495c-a300-790d3ddea24b",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-A - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-12T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 240,
      parent: "924e57f3-3d32-432b-aaa2-a93728330198",
      progress: 0,
      source_task_id: "B1.VDC.1560"
    },
    {
      id: "d9daeef8-71e8-4668-a999-3f46fe2b356d",
      text: "Interior Construction - Tie Ins - GH",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 160,
      parent: "960a3230-3d18-4a8d-9b60-7f435cfb3995",
      progress: 0,
      source_task_id: "GH.CON.1040"
    },
    {
      id: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      text: "B1 - 1N2E - EF3 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF3)",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 8,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5880"
    },
    {
      id: "89b2557e-00ff-4d8b-90bf-c6da1ce43e8a",
      text: "Area 1 - UG RI -MVS to MVS-DCB1",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1100"
    },
    {
      id: "fde509e0-182d-4d99-8df9-c211ab1f6171",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2240"
    },
    {
      id: "5454c703-49ce-4aa8-ae74-dd2b1e50f616",
      text: "Fab and Deliver - Cooling Distribution Unit - Area C - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 3624,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 0.11,
      source_task_id: "B1.OFCI.3320"
    },
    {
      id: "d66d5383-0992-47bc-a319-b3c126dd8fb3",
      text: "B1 - ISP Cabling - EF to IDFA (UG)",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 80,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1270"
    },
    {
      id: "438f412b-6494-40f3-b116-bec3886fb730",
      text: "Substation 1 -  Fabricate / Deliver - H-Frame Deadend",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 648,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5730"
    },
    {
      id: "ba86530e-5eca-411e-a699-a302d80aca16",
      text: "Tier 1 - B2-2-B - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994775"
    },
    {
      id: "347a5a1c-1296-4577-bd61-0caa76198185",
      text: "B1 - ISP Cabling - IDFA to DHA (GS tray)",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-02-13T08:00:00",
      duration: 200,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1320"
    },
    {
      id: "5e0ab870-8ba8-4af3-b706-662a8310bfdb",
      text: "Install Rebar",
      type: 0,
      start_date: "2025-06-17T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 80,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1040"
    },
    {
      id: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 288,
      parent: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      progress: 0,
      source_task_id: "7995121"
    },
    {
      id: "290bb770-987c-4351-9b79-8bd7a8d13876",
      text: "B1 - 1N1E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5370"
    },
    {
      id: "21a7d107-4b36-4a1d-8809-18a4e6f812fe",
      text: "B1 - Network Rooms - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 240,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1000"
    },
    {
      id: "70851053-4f54-4459-a013-50a79c09d6c6",
      text: "Install AHU's",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1050"
    },
    {
      id: "2c891d1b-402c-4013-acd2-ae057b6e9343",
      text: "Substation-2 - B Lineup - Install Breaker and Misc Pad / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 168,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4260"
    },
    {
      id: "dfcfd488-9570-420a-acf2-6629d2d6e291",
      text: "FR 37 - DPR Prepare and Submit PCO#XX",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "3379c616-a9bf-4246-981a-9eef20f2a943",
      progress: 0,
      source_task_id: "FR.36.1090"
    },
    {
      id: "357c010b-aa25-4aeb-860c-f7b7b050e152",
      text: "B1 - DH-C - Set FCA's - Data Hall C",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1930"
    },
    {
      id: "e21c36c1-917f-435e-bf13-1f54fde6a4cc",
      text: "B1 - DH-D - Power Alley - Power Alley -Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 160,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1610"
    },
    {
      id: "80cf1291-915a-49f3-81de-94c6598fe971",
      text: "B1 - 1N2E - 01N3.05 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.5900"
    },
    {
      id: "287d835c-892a-4506-8655-68d940de31a2",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2120"
    },
    {
      id: "64b9fffe-cd95-4ebe-9d96-44888cb955ad",
      text: "L4 - B2 DHA",
      type: 0,
      start_date: "2026-10-14T00:00:00",
      end_date: "2026-12-03T08:00:00",
      duration: 280,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHA.1000"
    },
    {
      id: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      text: "Interior Trades SA - Meta Review / Authorization",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-10-29T08:00:00",
      duration: 1736,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 0.58,
      source_task_id: "7994732"
    },
    {
      id: "e0343347-e2ef-4132-8bc8-38a3ec8723e2",
      text: "B1 - SSB - 1E2 - GSMDF2 - OH Rough In Ductwork, Elec, Vedsa,  for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-14T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 80,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "B1.C.SSB.1220"
    },
    {
      id: "100fd2b2-44bd-4a77-aa12-962d54fb58fc",
      text: "Campus PH1 - Fabricate / Deliver - T-Comm Vaults (Site) ((Early Release))",
      type: 0,
      start_date: "2024-08-09T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 320,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0,
      source_task_id: "B1.CFCI.3350"
    },
    {
      id: "647c6a43-beb6-4657-9f02-65549581d252",
      text: "[DCB1] DEC-C Ready: Production Cabling [Area B]",
      type: 0,
      start_date: "2026-02-05T08:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3537"
    },
    {
      id: "06bb4c1d-17c1-40aa-8119-ce73fc84576b",
      text: "Install Epoxy Flooring",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1220"
    },
    {
      id: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      text: "mCUP-1-8",
      type: 5,
      start_date: "2025-03-12T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 2480,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995141"
    },
    {
      id: "a775049e-3296-4c5d-839c-488a6d77d33b",
      text: "(OFCI) B1 Make Up Water Module",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0,
      source_task_id: "7994978"
    },
    {
      id: "41120383-8f38-4628-8077-188a15a1d1dd",
      text: "Building -2",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 248,
      parent: "05726f27-0840-4b3c-be5a-5c1b8cb2930d",
      progress: 0,
      source_task_id: "8444263"
    },
    {
      id: "b0ba8bbf-c4a7-408b-951a-d965e834c0c4",
      text: "(CFCI) Div. 27 - Communications",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994858"
    },
    {
      id: "0b661544-5c79-43c8-9469-95408c208f3b",
      text: "(CFCI) Div. 03 - (Slurry) Non-Struc Concrete",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "104ad1d0-cc1d-442f-b628-bbf43f4a07d2",
      progress: 0,
      source_task_id: "7994855"
    },
    {
      id: "2109a001-e8e0-4844-aba4-40433a68f69b",
      text: "Tier 2, 3, 4 - B1-1-D",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994789"
    },
    {
      id: "7ff8625a-dc89-41f6-8d33-dd61dacc1595",
      text: "BLDG-1 DH-B",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444260"
    },
    {
      id: "0346efe3-b63f-4628-9749-3c3592992deb",
      text: "FCA Gallery DH-C",
      type: 5,
      start_date: "2025-12-03T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 600,
      parent: "e7143409-9746-43ab-abe3-3a9fb88b3f47",
      progress: 0,
      source_task_id: "7995284"
    },
    {
      id: "37de87a5-7c12-4763-95c3-bd1586a52de8",
      text: "B2 - DH-B - Install Cable Tray - Data Hall B",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-30T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2520"
    },
    {
      id: "51abcd05-c3b5-465b-bea1-861c83da7f5b",
      text: "Signage - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5810"
    },
    {
      id: "fd758a27-05c3-4b0d-9503-13ba8db8deac",
      text: "FR 37 - META review and respond to PCO #XX",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: null,
      duration: 80,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "FR.38.1150"
    },
    {
      id: "a5d0db8b-db6d-4a2a-b0f9-6257aa6894d4",
      text: "B1 - SSB - Underground (ConveLOE)",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 200,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1050"
    },
    {
      id: "86f6ad65-38f0-4598-a223-a655c7f555fc",
      text: "Shell - Admin",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 480,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1020"
    },
    {
      id: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      text: "FacNet Live",
      type: 5,
      start_date: "2026-05-26T08:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 1032,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995440"
    },
    {
      id: "cd5aaf0a-e770-44be-b9ba-fee46a3c762d",
      text: "Top-Out Walls",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1030"
    },
    {
      id: "51b7dd10-27ab-4a4f-a848-cc783925cf1c",
      text: "B2 - DH-C - Install Underground Telecom",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 80,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1480"
    },
    {
      id: "f6a9de30-a201-4f48-9680-b089149b4a87",
      text: "IBOS - Prep / Submit for Review - Lighting",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-09-24T00:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1050"
    },
    {
      id: "efad5a6e-a996-4df6-a846-2f21686930ea",
      text: "Fireproofing (Applied) (Spec 07 81 00)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994841"
    },
    {
      id: "4fc673cb-0d55-4b7a-adb1-7bee9f658bfd",
      text: "(CFCI) Div. 08 - Openings",
      type: 5,
      start_date: "2024-09-09T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 912,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994896"
    },
    {
      id: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 280,
      parent: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      progress: 0,
      source_task_id: "7995099"
    },
    {
      id: "ab22db60-975f-4a11-bc67-c7021ebd3342",
      text: "Tier 0 - B1-1-B- Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994805"
    },
    {
      id: "96c4da44-9951-472e-8a46-30de0eeb2781",
      text: "L4 - mCUP 1-8",
      type: 0,
      start_date: "2026-07-17T00:00:00",
      end_date: "2026-09-11T08:00:00",
      duration: 320,
      parent: "b7e80775-db75-4aaf-b309-1a2626cd6965",
      progress: 0,
      source_task_id: "CX4.B2.MCUP.1000"
    },
    {
      id: "efe9f773-401a-4846-9bf5-ddd4e151cc7c",
      text: "B2 - DH-C - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 40,
      parent: "7e2c4263-df53-41a3-b764-1e6e272793de",
      progress: 0,
      source_task_id: "B2.C.EY.1700"
    },
    {
      id: "d8e9652a-71e7-4530-a5fd-e90941a312c5",
      text: "B2 - 2D1W - 02D.08 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-05-12T00:00:00",
      end_date: "2026-05-18T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1860"
    },
    {
      id: "14ecde25-a3d6-493e-8687-7a255f86dc23",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1530"
    },
    {
      id: "3b299e1e-0904-4e57-8f27-5571141efbf9",
      text: "B2 - mCUP-1-8 - Equipment Pads (Sequence 1)",
      type: 0,
      start_date: "2025-04-04T00:00:00",
      end_date: "2025-04-26T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1020"
    },
    {
      id: "204f59f9-2335-4a2e-95bc-43e92c038cb3",
      text: "Substation 2 -  Fabricate / Deliver - H-Frame Deadend",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 648,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5760"
    },
    {
      id: "9fd8dfe3-3f66-4128-b716-d49e13192ef0",
      text: "BLDG-2 - BIM - Tier 2-4 - Area 2-B - Coordination / Sign-off",
      type: 0,
      start_date: "2025-05-14T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 280,
      parent: "18d840dc-fbca-4944-bbc5-73c1783bea63",
      progress: 0,
      source_task_id: "B2.VDC.3130"
    },
    {
      id: "a9c8e62f-f8aa-4a97-b987-8c643db8c643",
      text: "BLDG-1/2 - Prep / Submit for Review - SOG/SOMD/Pads Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 120,
      parent: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      progress: 0,
      source_task_id: "B1.CFCI.5650"
    },
    {
      id: "e83af6fb-81e2-4758-aa2f-90b56e081c3f",
      text: "Start DCB1 MTR Installation - Phase1",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-05-31T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1655"
    },
    {
      id: "f167a6a8-f349-4333-9ee9-4eec52bf4647",
      text: "B1 - West Entrance - Rough Grade behind Curb",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 80,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1040"
    },
    {
      id: "4f6ae5c3-f5da-4c81-9266-2a6c3771c00e",
      text: "B2 - DH-C - Install Cable Tray - Data Hall C",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1890"
    },
    {
      id: "0bda8450-81d7-4933-9869-7af781dff2ea",
      text: "Install Ceiling Grid",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 64,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1120"
    },
    {
      id: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b",
      text: "[DCB2] DEC-C Ready: Production Cabling [Area D]",
      type: 0,
      start_date: "2026-10-30T08:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3557"
    },
    {
      id: "eb3ea98a-2cf4-45ea-aad1-d7789c9747d1",
      text: "(OFCI) B1 Generators",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.29,
      source_task_id: "7994986"
    },
    {
      id: "1aba69bc-7a36-4f6a-9e1a-c9bbc81333ce",
      text: "UG RI -Fire Alarm-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 80,
      parent: "a187e15c-5311-477e-8dcb-810084b7ae80",
      progress: 0,
      source_task_id: "MECO-1680.20"
    },
    {
      id: "821159ff-a838-469c-b1ca-c32aa54b4b35",
      text: "Transfer from Construction Power to Permanent power",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.CON.1550"
    },
    {
      id: "e5862044-0aeb-40d6-b111-9bb0dad28651",
      text: "B2 - DH-A - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 80,
      parent: "af73992b-f173-45bc-944e-dd449681c36e",
      progress: 0,
      source_task_id: "B2.C.EY.1270"
    },
    {
      id: "5c6ac608-03d9-441f-8e7d-10a7ca30bc8c",
      text: "BLDG-2 - BIM - Tier 1 - Area 2-E / 2-F - Coordination / Sign-off",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 240,
      parent: "8855a153-2324-48fc-9f24-01a929f6553d",
      progress: 0,
      source_task_id: "B2.VDC.1030"
    },
    {
      id: "0e38b366-0370-44f3-98bc-11d1f59d7bcd",
      text: "L3 - B1 MSG-A *On Temp Power*",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 40,
      parent: "9b65810f-93cc-453e-8de8-a75c5f4cb8b5",
      progress: 0,
      source_task_id: "CX3.B1.SS.1000"
    },
    {
      id: "c385aca0-4ede-4be3-a5aa-795231043061",
      text: "B2 - mCUP-1 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1240"
    },
    {
      id: "31389c05-3498-4e65-b28d-8e33e30155f2",
      text: "Area 3 - MV Electric Install - Priority for Foundations (Sub to MV Loop) - Concrete Scope",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 136,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A3.8070"
    },
    {
      id: "d8c751e3-5dbf-4be1-873b-7260c217dc23",
      text: "OH MEPF Inspections & QAQC Walks",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1190"
    },
    {
      id: "cb613105-a613-4d73-bee4-6ccfdf821957",
      text: "Install Plumbing Fixtures",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1180"
    },
    {
      id: "7d79a0be-ac68-475c-90e5-83ff2979f057",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [4] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 2912,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.37,
      source_task_id: "B2.OFCI.2750"
    },
    {
      id: "6107621f-b871-4996-91bb-531496b31376",
      text: "BLDG-1 - BIM - Tier 2-4 - Admin - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-10-17T08:00:00",
      duration: 240,
      parent: "0b068a4f-9be9-40d8-99dd-d9f5c60a2d1f",
      progress: 0,
      source_task_id: "B1.VDC.1690"
    },
    {
      id: "c5da019b-8006-4178-9500-48ec2ab31d05",
      text: "B1 - 1N2W - 01N2.06 - Lighting and Devices",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6370"
    },
    {
      id: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      text: "IFP",
      type: 5,
      start_date: "2024-01-24T00:00:00",
      end_date: "2024-03-29T08:00:00",
      duration: 376,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "7994742"
    },
    {
      id: "26da9252-5527-471f-b6cd-064be6fea286",
      text: "Final Punch - B2 DHC & DHD",
      type: 0,
      start_date: "2027-03-24T00:00:00",
      end_date: "2027-03-30T08:00:00",
      duration: 40,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHC.1010"
    },
    {
      id: "17a01b6d-ec77-4618-a625-fb5e30858866",
      text: "Start Foundations - IBOS",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2024-12-26T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1000"
    },
    {
      id: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      text: "Building 2",
      type: 5,
      start_date: "2024-10-16T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 1280,
      parent: "b36bc5ee-f112-4677-a654-d4337c07b419",
      progress: 0,
      source_task_id: "7994761"
    },
    {
      id: "c860143a-268a-4c26-a550-24782dd68030",
      text: "B2 - mCUP-3 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 48,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3020"
    },
    {
      id: "4d8012f8-784e-4a61-b265-aeddc9169a8f",
      text: "B2 - DH-D - Install Perimeter Cable Tray - Data Hall D",
      type: 0,
      start_date: "2026-09-03T00:00:00",
      end_date: "2026-10-01T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2640"
    },
    {
      id: "717a8229-924b-4895-8c35-45ceaaf5396f",
      text: "B2 - 2D1 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 120,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1970"
    },
    {
      id: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      text: "Design Kick Off ( with Product Development Design Package)",
      type: 0,
      start_date: "2023-10-16T00:00:00",
      end_date: "2023-10-16T00:00:00",
      duration: 0,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 1,
      source_task_id: "ICM.PRE.1100"
    },
    {
      id: "42832c2c-fc45-4b3c-b184-9a2b8ffa9506",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-06-19T00:00:00",
      end_date: "2026-07-02T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2450"
    },
    {
      id: "d070eea9-3a87-4e64-9150-62af34dfceec",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1390"
    },
    {
      id: "11b9389f-6d9f-4c01-9169-e121cc6f453c",
      text: "Adverse Weather Event 9 - 09.27.2024  (Hurricane Helene)",
      type: 0,
      start_date: "2024-09-27T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1009"
    },
    {
      id: "4949ba81-be89-407f-b605-aa6d5eabfd65",
      text: "Area 1 - MV Electric Install - Remaining (EY into ER) - Concrete Scope",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 96,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A1.8070"
    },
    {
      id: "1cd228e5-fb3a-4160-b25b-7b34435c4866",
      text: "B1 - DH-D - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 80,
      parent: "62872b9b-6759-4561-825b-c00ed5bb886c",
      progress: 0,
      source_task_id: "B1.C.D.3050"
    },
    {
      id: "8098d509-112a-47e7-9d6b-5eb780bd7e95",
      text: "Substation MSG - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "26e5948f-129c-48df-8881-cfc73de88da4",
      progress: 1,
      source_task_id: "B1.OFCI.1170"
    },
    {
      id: "50bb0af6-dd60-4e81-8b34-caf205f920b4",
      text: "B1 - 1N1W - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5080"
    },
    {
      id: "ed4dfcd2-381d-42cc-ae72-a7f2a9395619",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Vesda System",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 120,
      parent: "3e0c2709-f6dd-4154-90ac-684cc2b77033",
      progress: 0,
      source_task_id: "B1.CFCI.4990"
    },
    {
      id: "1356ebc2-8fda-4c8e-85c0-490063c40197",
      text: "Tier 2, 3, 4 - B2-2-D",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      progress: 0,
      source_task_id: "7994773"
    },
    {
      id: "d30a5345-e996-411f-8835-bf6612bc2f94",
      text: "B1 - DH-A - Hookup CDU's - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 144,
      parent: "a565da4e-47a6-49f6-9a35-7baee475a452",
      progress: 0,
      source_task_id: "B1.C.A.3030"
    },
    {
      id: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      text: "B1 - mCUP-6 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6040"
    },
    {
      id: "9ee1805a-47c2-4cf5-9fb4-47a96cf970a7",
      text: "Area 1 - UG RI -Network Infrastructure Vaults-Campus-",
      type: 0,
      start_date: "2024-11-08T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 296,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1010"
    },
    {
      id: "82f421e6-a86f-470c-bee8-e90fa20b7eaf",
      text: "mCUP - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 1,
      source_task_id: "B2.OFCI.1220"
    },
    {
      id: "bb3858f7-e8b9-464a-8425-37009e0bb88a",
      text: "BLDG-2 - BIM - Tier 2-4 - Area 2-D - Coordination / Sign-off",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 280,
      parent: "1cb75608-ea15-4d7d-a6f5-dc6bf4d3a50a",
      progress: 0,
      source_task_id: "B2.VDC.3190"
    },
    {
      id: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5",
      text: "Substation-1 - TX B - Set Transformer",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3710"
    },
    {
      id: "6fd8490f-4a09-4e79-9a09-a9f4911f3206",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2220"
    },
    {
      id: "0f82ffd9-4f57-43bb-9c72-b8708a12cfd2",
      text: "Area 1 - UG RI -Generator/LB/GSB -DCB1-",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1070"
    },
    {
      id: "2d4312e1-0f2d-4d43-897b-8edc0c454a2b",
      text: "B1 - DH-B - Install Celing Devices Security - Data Hall B",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2830"
    },
    {
      id: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      text: "Corridor 2E2E/ Entrance Facility 1 and 2/UPS (2)",
      type: 5,
      start_date: "2025-12-15T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 816,
      parent: "33388fbb-9d5a-4d59-bd4a-dbf183464b7b",
      progress: 0,
      source_task_id: "7995051"
    },
    {
      id: "ea730a35-0276-4f13-8f08-7c61d90758ac",
      text: "B2 - DH-A - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 40,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1820"
    },
    {
      id: "26e5948f-129c-48df-8881-cfc73de88da4",
      text: "(OFCI) Substation MSG",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 2304,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0.47,
      source_task_id: "7994937"
    },
    {
      id: "b0576fda-8791-4b71-9c9a-050246414d26",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-D - Coordination / Sign-off",
      type: 0,
      start_date: "2025-01-13T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 240,
      parent: "3458751c-652e-4bca-a6eb-75a1f58feb41",
      progress: 0,
      source_task_id: "B1.VDC.1650"
    },
    {
      id: "535a341a-1726-44cf-9562-21479d30ef59",
      text: "Fab and Deliver - PLC Panels - Area D - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2832,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.34,
      source_task_id: "B1.OFCI.3270"
    },
    {
      id: "f63227a1-2d37-45bf-b6c4-986a8a6d50b9",
      text: "BLDG-2 DH-D Level 2 Checkout",
      type: 5,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 320,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "7995128"
    },
    {
      id: "57476b2f-e2af-4635-9fc6-c8ec51bdd64f",
      text: "B1 - DH-C - Install Celing Devices BMS - Data Hall C",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2600"
    },
    {
      id: "3b23982e-8925-4bfe-95f9-7a456bc1b309",
      text: "Water Proof Columns",
      type: 0,
      start_date: "2025-03-27T00:00:00",
      end_date: "2025-04-02T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1040"
    },
    {
      id: "6e25f688-d12e-453f-9fac-0b6552fe54c9",
      text: "B1 - DH-B - Corpnet Provisioning",
      type: 0,
      start_date: "2026-01-27T00:00:00",
      end_date: "2026-02-17T08:00:00",
      duration: 120,
      parent: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      progress: 0,
      source_task_id: "B1.CONN.1310"
    },
    {
      id: "be989221-1474-4327-b00b-6970f7e48d22",
      text: "(OFCI) B2 FCA Fan Coil Assembly",
      type: 5,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 3264,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.46,
      source_task_id: "7994961"
    },
    {
      id: "f988e438-2d85-44bc-88ba-ea522d9bd07e",
      text: "Area 2 - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 208,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1200"
    },
    {
      id: "207ff153-3106-400e-81bf-813e6c81e518",
      text: "Precast Area C",
      type: 5,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 48,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995412"
    },
    {
      id: "7cae47f1-147a-485b-8d51-a7f73323af28",
      text: "Temp trailer (quad) - Energize",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 232,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1060"
    },
    {
      id: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      text: "Campus Site Improvements",
      type: 5,
      start_date: "2025-01-14T00:00:00",
      end_date: "2026-09-16T08:00:00",
      duration: 3456,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0,
      source_task_id: "7995203"
    },
    {
      id: "69e3d9b2-fe5a-4360-b3c1-59af1905de13",
      text: "Trailer/Trailer city/Office space - Lift and Set Units",
      type: 0,
      start_date: "2024-08-26T00:00:00",
      end_date: null,
      duration: 272,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1070"
    },
    {
      id: "b686b55d-fde0-4841-b50f-cd89274c44d0",
      text: "Steel SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 336,
      parent: "94a1c3e5-7f04-47aa-9c64-e23c0509b3f5",
      progress: 1,
      source_task_id: "PRE1570"
    },
    {
      id: "390a2070-20e5-4004-b193-4ac20d205c01",
      text: "B2 - DH-B - Install Underground Controls",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1340"
    },
    {
      id: "da769131-1105-41b0-a2db-e3db97ff9d98",
      text: "B1 - DH-B - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 80,
      parent: "475fbabe-89c3-43ba-986e-c5e612752c64",
      progress: 0,
      source_task_id: "B1.C.B.3120"
    },
    {
      id: "51c00c83-bd57-417a-a005-a3275c0bb913",
      text: "BLDG-2 DH-C Level 2 Checkout",
      type: 5,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 200,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "7995138"
    },
    {
      id: "4d3555c8-0ee9-4d0d-95a0-26b160540a01",
      text: "B1 - DH-B - Install Ceiling Tiles - Data Hall B",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 48,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2850"
    },
    {
      id: "0b7accdd-1d96-404e-a601-f06046601bd5",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 24,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1710"
    },
    {
      id: "c249ab2c-cfe1-452a-9c38-a2a761b1553c",
      text: "B1 - DH-B - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 120,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1930"
    },
    {
      id: "e38ed0fa-2663-4b0c-bf48-30907319fe5a",
      text: "Corridor 1C1W (Ups Room(2)/Spoke Tech)",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 816,
      parent: "dc0db725-f1c1-4687-8a98-61e9f8a18049",
      progress: 0,
      source_task_id: "7995273"
    },
    {
      id: "0a167a2b-48b1-43c2-9f20-61d0ad03eb25",
      text: "Phase 2 - Complete Landscape/Hardscape/Misc. Work",
      type: 0,
      start_date: "2026-09-25T00:00:00",
      end_date: "2026-10-22T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1100"
    },
    {
      id: "bd41fbbd-26fa-466d-9f39-a0af92ec00a8",
      text: "B2 - 2D1 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.2000"
    },
    {
      id: "29d8126e-d41e-44c0-ac74-b21977de94af",
      text: "B1 - mCUP-5 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 48,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5000"
    },
    {
      id: "d14d0c88-2ba5-406f-a462-75af420345b4",
      text: "B2 - DH-A - El Equip Yd - Set Equipment (12)MVS, (24) PTX, (1)GEN, (1)LB",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 80,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1110"
    },
    {
      id: "7c976095-02e3-4e16-a5bc-8e12dc814d7a",
      text: "B2 - DH-C - Install Thermal Concrete",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 120,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1430"
    },
    {
      id: "3d191c74-f499-449a-a053-531f073348a5",
      text: "B1 - 1D1W - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1700"
    },
    {
      id: "492dd585-663c-4e43-9251-2677e89f9334",
      text: "Substation-1 - Equipment Hookup's Utility Provider (Overhead from utitlity provider substation)",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 1280,
      parent: "c58d12bf-614f-4c63-b273-87839b55d090",
      progress: 0,
      source_task_id: "CAMPUS.AUX.1020"
    },
    {
      id: "1ec7094b-6b88-4d57-9049-d2fa2f1bec68",
      text: "B1 - 1N1E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 120,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1960"
    },
    {
      id: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a",
      text: "[DCB2] DEC-C Ready: Production Cabling [Area A]",
      type: 0,
      start_date: "2026-07-27T08:00:00",
      end_date: "2026-07-27T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3527"
    },
    {
      id: "84b96093-028f-4acd-842d-9d74b72628c2",
      text: "DFSMA - DC1 DHC HAC ROJ - MOFE",
      type: 0,
      start_date: "2025-10-16T08:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 0,
      parent: "86efc612-6e21-491b-98fc-5aba04020712",
      progress: 0,
      source_task_id: "B1.DFSMA.1090"
    },
    {
      id: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      text: "B2 - DH-A - Precast",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "6335258a-85e5-4d7a-a733-6de7b21846ec",
      progress: 0,
      source_task_id: "B2.C.1540"
    },
    {
      id: "c670e2d6-6ddc-4069-96cd-5b0f1558589d",
      text: "Exterior Metal Panels - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-06-18T00:00:00",
      end_date: "2024-07-09T08:00:00",
      duration: 120,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0.26,
      source_task_id: "Design.PreC.5030"
    },
    {
      id: "fb3b773d-6b3f-4a38-99a0-d2d6a90bd42c",
      text: "B1 - ISP Cabling - Carrier2 to MDF1 (UG)",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 40,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1100"
    },
    {
      id: "7f23957a-6912-4549-a52f-01b1e24686d7",
      text: "B2 - West Entrance - install irrigation branch and heads",
      type: 0,
      start_date: "2026-08-12T00:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1130"
    },
    {
      id: "acfcd823-2062-4638-9352-8bd5cc797749",
      text: "B2 - 2E1E - EF4 - Pull Wire for Lighting/Outlet/Racks (EF4)",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-20T08:00:00",
      duration: 24,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5300"
    },
    {
      id: "24e11816-d070-43b5-bcf7-b6cc73c1d1b3",
      text: "Substation-2 - A Lineup SF6 Breaker - NETA Testing (Control Cabling)",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 120,
      parent: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4930"
    },
    {
      id: "688e2ee9-2485-40df-8525-5862f3338be7",
      text: "B2 - 2D1 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1140"
    },
    {
      id: "9da0335d-c875-4f71-b1f7-b24826145553",
      text: "Fab and Deliver - MSB - Area mCUP Dry - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2024-12-24T08:00:00",
      duration: 2072,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.42,
      source_task_id: "B1.OFCI.2070"
    },
    {
      id: "2b11ac05-4186-4b5f-af73-3ee87235f0b1",
      text: "Substation-1 - B Lineup SF6 Breaker - NETA Testing (Control Cabling)",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3810"
    },
    {
      id: "b6df6ecb-e802-4ece-8ab5-1c6c30c6c3cb",
      text: "B2 - mCUP-7 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7090"
    },
    {
      id: "24dee1b8-ef96-4c88-8860-44cdc0415f08",
      text: "Fragnet 26 - PCO # 24 CSI-0016 Mech mCUP Delay Scenario",
      type: 0,
      start_date: "2024-09-21T00:00:00",
      end_date: null,
      duration: 320,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8690700"
    },
    {
      id: "71e2ed77-fe57-458d-aadc-3eeb5cab854b",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-03-16T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 24,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1810"
    },
    {
      id: "b509c79a-66c1-4a87-96dd-916a294eaedf",
      text: "B1 - DH-A - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 96,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2330"
    },
    {
      id: "16894202-a081-4b62-8267-cbc7973df00c",
      text: "FR 30 - DPR Prepare and Submit PCO#28",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: null,
      duration: 176,
      parent: "4c402718-830a-4c9c-9cfa-044c255c93bf",
      progress: 0.5,
      source_task_id: "FR.30.1010"
    },
    {
      id: "40c8357a-eb0a-4583-9445-126761f0c315",
      text: "In Wall Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1180"
    },
    {
      id: "c0b3d2d7-0913-404d-8a98-8cf7b7465319",
      text: "ADMIN  - Fabricate / Deliver - Specialities",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6260"
    },
    {
      id: "0bc000c0-a4a6-48c2-b637-fdec31501313",
      text: "B2 - SSB - 2E1 - Common - Complete Interior Build-Out (DEC-C Ready)",
      type: 0,
      start_date: "2026-06-01T08:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 0,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1430"
    },
    {
      id: "fdcaa3e4-3c93-483c-abda-22ed1ceeebbe",
      text: "B1 - 1A2E - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2210"
    },
    {
      id: "1c86e773-0a6c-4587-a20a-9192a5a2145f",
      text: "B1 - DH-B - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 80,
      parent: "475fbabe-89c3-43ba-986e-c5e612752c64",
      progress: 0,
      source_task_id: "B1.C.B.3100"
    },
    {
      id: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea",
      text: "B1 - mCUP-3 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3090"
    },
    {
      id: "cb51919a-1622-40c2-8ef2-b8d016e5936a",
      text: "B2 - mCUP-2 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2080"
    },
    {
      id: "63093767-f8ce-44d1-8142-2ed6229c04c9",
      text: "B2 - DH-A - El Equip Yd - Pour Pads (MSG ONLY) Needs steel to go by",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 120,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1000"
    },
    {
      id: "8820736c-410e-4efe-a06b-d0fc26d82040",
      text: "Owner Furnished Equip. (OFCI)",
      type: 5,
      start_date: "2023-09-08T08:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 5336,
      parent: "cee57e06-8220-46f4-bf48-e8124ce9e922",
      progress: 0.15,
      source_task_id: "7994935"
    },
    {
      id: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      text: "B1 - Network - Install Deep Electric  (Inside building foot print only)",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 120,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1110"
    },
    {
      id: "fd3d8b4b-e38a-40db-a77f-069df925520f",
      text: "B2 - 2D2 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-31T08:00:00",
      duration: 160,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2350"
    },
    {
      id: "5306793e-af2a-4042-a75e-256b21d5f175",
      text: "B1 - 1C2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1270"
    },
    {
      id: "8dabe4e5-612d-468d-96f3-8de7d4eb74d8",
      text: "B2 - DH-A - Install Fire Alarm Conduit/Vesda -Data Hall A",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2500"
    },
    {
      id: "f3232f7d-2b92-47c2-b4dc-7666717eb648",
      text: "FR 05 - Install Storm at Lower elevation before aldrige can start",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: null,
      duration: 16,
      parent: null,
      progress: 0,
      source_task_id: "FR.05.1040"
    },
    {
      id: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90",
      text: "B1 - SSB - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-04-21T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 40,
      parent: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      progress: 0,
      source_task_id: "B1.C.STR.1770"
    },
    {
      id: "13271001-2e22-408b-be08-3d8849f2f6ba",
      text: "(OFCI) B2 Generator Switchboard GSB",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 3696,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.37,
      source_task_id: "7994958"
    },
    {
      id: "f7ebcb3e-c5f0-48ed-be11-32253d3fd236",
      text: "B1 - DH-D - Roofing (Converted to LOE)",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 120,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1320"
    },
    {
      id: "d6296d70-4cb9-49d5-a086-aa2fe674c745",
      text: "B1 - SSB - 1E1 - Common - Install Wall Devices Electrical",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 48,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2300"
    },
    {
      id: "3827116c-d2ce-4b4d-9d95-d9babf2ef69a",
      text: "B2 - DH-D  - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-04T08:00:00",
      duration: 16,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1560"
    },
    {
      id: "a2dc4dbb-83f5-475a-a0d9-9d0f242836e3",
      text: "B1 - DH-A - L2 CDU Install Verification - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 144,
      parent: "a565da4e-47a6-49f6-9a35-7baee475a452",
      progress: 0,
      source_task_id: "B1.C.A.3040"
    },
    {
      id: "87e40065-edac-422c-9029-9d578d47e7ef",
      text: "B2 - DH-D - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 40,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1240"
    },
    {
      id: "7ed2ac77-5edd-495a-b6f0-baa018720a86",
      text: "BLDG-2 - BIM - Tier 2-4 - Area 2-E / 2-F - Coordination / Sign-off",
      type: 0,
      start_date: "2025-03-14T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 240,
      parent: "8855a153-2324-48fc-9f24-01a929f6553d",
      progress: 0,
      source_task_id: "B2.VDC.1040"
    },
    {
      id: "e87e871a-aa38-4544-a91e-0527e07cde1a",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2140"
    },
    {
      id: "cd6b3a75-0cca-40a8-9389-38ccefdeb5d8",
      text: "PLC Panels - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-04-10T08:00:00",
      duration: 304,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 1,
      source_task_id: "B1.OFCI.1710"
    },
    {
      id: "9471bbea-2b52-43c3-a5ce-da8d6a215ec9",
      text: "Trade Partner (Civil) Authorized to Start VDC Work",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-18T00:00:00",
      duration: 0,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC22.1550"
    },
    {
      id: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      text: "B1 - Network Room 2/3 - OH Rough In Feeder",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1120"
    },
    {
      id: "d22ff3ef-1527-4921-9134-ea2f12a4daba",
      text: "DFSMA - DC2 - mCUP - GS.IDF Remote Module ROJ - MOFE (2X1)",
      type: 0,
      start_date: "2025-10-08T08:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 0,
      parent: "d70530f6-b13d-4b0a-940b-9b1bf24a563d",
      progress: 0,
      source_task_id: "B2.DFSMA.1090"
    },
    {
      id: "8330e26c-e0c4-4216-848c-9a29ee130104",
      text: "B1 - 1D1W - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1810"
    },
    {
      id: "244e2659-62ad-403e-bf8f-b143d2d8816e",
      text: "Overall Project Substantial Completion Date",
      type: 0,
      start_date: "2027-05-14T08:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "ICM.G.9999"
    },
    {
      id: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0",
      text: "B2 - 2B1 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1660"
    },
    {
      id: "ba6ff22d-0f1a-4135-97b3-d14f6955b995",
      text: "B1 - Network Room 2/3 - OH Rough In Security",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1110"
    },
    {
      id: "3be33cd4-0000-4dcf-b947-833b127dbccf",
      text: "B1 - Network Room 1/4  - Cable terms/testing between EL Room and Busway",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1990"
    },
    {
      id: "03e28f86-f603-4b29-b598-2bded4b4233f",
      text: "B1 - DH-B - Install Grounding Loop - Data Hall B",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2860"
    },
    {
      id: "f5622644-5fae-4de5-b073-5e130ffd3c9c",
      text: "Water Cooler Chillers - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 1,
      source_task_id: "B2.OFCI.1230"
    },
    {
      id: "37268a6d-2688-4afd-9f63-d1ce86477ead",
      text: "Install Kitchen Hood & Stainless",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1070"
    },
    {
      id: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      text: "GS.IDF.2C2",
      type: 5,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-07-17T08:00:00",
      duration: 776,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "7995035"
    },
    {
      id: "99792bed-9a5d-495f-9110-16ad29e1982c",
      text: "B2 - DH-B - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 96,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2390"
    },
    {
      id: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b",
      text: "B1 - mCUP-3 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 48,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3000"
    },
    {
      id: "acbf35b3-a9f3-44a3-8930-8f19a6e02524",
      text: "B1 - DH-A - Install Celing Devices Fire Protection - Data Hall A",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2640"
    },
    {
      id: "e25e0c73-df43-45d3-87ce-6609c9d860ba",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-N - Coordination / Sign-off",
      type: 0,
      start_date: "2024-10-28T00:00:00",
      end_date: "2025-01-17T08:00:00",
      duration: 240,
      parent: "025f7736-8841-42ad-887c-bb57088ea671",
      progress: 0,
      source_task_id: "B1.VDC.1540"
    },
    {
      id: "34506e78-7808-45bd-a08a-14f00001a7a8",
      text: "Issue for Permit Package",
      type: 5,
      start_date: "2024-06-04T00:00:00",
      end_date: "2024-11-26T08:00:00",
      duration: 992,
      parent: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      progress: 0.11,
      source_task_id: "7994735"
    },
    {
      id: "8625a852-145a-4a75-a37e-e3b127b50f09",
      text: "B1 - DH-B - Prime and 1st Coat",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 40,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1810"
    },
    {
      id: "dbe8d274-563a-4d1d-9983-5627f06750f1",
      text: "iGMP Reconciliation",
      type: 0,
      start_date: "2024-04-10T00:00:00",
      end_date: "2024-05-10T08:00:00",
      duration: 184,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1100"
    },
    {
      id: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      text: "Multi-Trade/Pipe Racks",
      type: 5,
      start_date: "2025-05-30T08:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 792,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994830"
    },
    {
      id: "7e4bd4e5-15e9-4668-8278-7afebb96f8f6",
      text: "FR 12 - DPR email to county Engieer for means and method",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: null,
      duration: 0,
      parent: "0bab80ea-8808-4fcd-bcf8-5c2534153920",
      progress: 1,
      source_task_id: "FR.12.1000"
    },
    {
      id: "c2925f12-f929-4bdc-866b-6f6965cb9037",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 8,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1470"
    },
    {
      id: "1052d4ad-79dc-4cd7-8c87-3a06a04e0ddb",
      text: "B1 - mCUP-5 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 48,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5060"
    },
    {
      id: "22160898-4722-4d54-98bd-c5a65765f5a4",
      text: "B1 - DH-B - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 160,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2000"
    },
    {
      id: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 24,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1150"
    },
    {
      id: "0bed6b06-2271-4990-b73d-14b7dba7e392",
      text: "Roofing SA - Meta Authorized",
      type: 0,
      start_date: "2024-07-13T00:00:00",
      end_date: "2024-07-13T00:00:00",
      duration: 0,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 1,
      source_task_id: "ICM.PRE.1435"
    },
    {
      id: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      text: "Area-1",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: null,
      duration: 1968,
      parent: null,
      progress: 0,
      source_task_id: "8444250"
    },
    {
      id: "b3bd6c8a-9e7c-4f71-bd78-2c40deb5bae0",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [1] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 2792,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.39,
      source_task_id: "B2.OFCI.1800"
    },
    {
      id: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      text: "B2 - DH-A - Install Vapor Barrier",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 40,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1180"
    },
    {
      id: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce",
      text: "B2 - SSB - 2E2 - Common - Install Doors and Hardware",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1850"
    },
    {
      id: "328aa2d6-3da6-4a25-9205-f2c59752d210",
      text: "B2 - SSB - SOG",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 104,
      parent: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      progress: 0,
      source_task_id: "B2.C.STR.2010"
    },
    {
      id: "18f4fed5-d104-4471-b11a-99098c0d1900",
      text: "BLDG-2 - Area D - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 80,
      parent: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      progress: 0,
      source_task_id: "B1.CFCI.5450"
    },
    {
      id: "a6296ed0-7331-46ac-8bec-051b7c5f3ecf",
      text: "B1 - DH-D - Install Thermal Concrete",
      type: 0,
      start_date: "2025-04-09T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 120,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1670"
    },
    {
      id: "51d5c1c1-7aaf-40b6-9a0a-a8e8cdb437d6",
      text: "B2 - DH-A - Roofing(Converted to LOE)",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1190"
    },
    {
      id: "f9521e9a-0a5d-4806-969d-99217ffb5956",
      text: "OSP - B1 - Phase 2 (BEV to IDF Huts)",
      type: 5,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 360,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995450"
    },
    {
      id: "4865a613-5ace-432c-a43d-67581230527d",
      text: "FR 08 - DPR Prepare and Submit PCO#4 (ROM)",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: null,
      duration: 64,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 1,
      source_task_id: "FR.08.1030"
    },
    {
      id: "039940a4-6a28-4ad4-ba53-495178b98448",
      text: "Product Review Set (PRS)",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2023-12-21T00:00:00",
      duration: 0,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "Design.PreC.2120"
    },
    {
      id: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      text: "DH-B",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 1056,
      parent: "70055513-b1cf-403a-b484-c8e2913ef6c0",
      progress: 0,
      source_task_id: "7995351"
    },
    {
      id: "1124313a-6f29-41cd-9c87-5ed39b5cc6a9",
      text: "Fab and Deliver - STC - Area NW-1 - DCB1 *NEED TO FIND OR DELETE*",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2024-10-15T08:00:00",
      duration: 1688,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.62,
      source_task_id: "B1.OFCI.2810"
    },
    {
      id: "8127850e-496c-4570-98b4-625b77cd1a69",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 160,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5740"
    },
    {
      id: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2",
      text: "L3 Start DH C - DCB2",
      type: 0,
      start_date: "2026-11-18T00:00:00",
      end_date: "2026-11-18T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2030"
    },
    {
      id: "aecb3155-a072-400f-ac87-21c55b5bc4be",
      text: "L4 Finish Admin - DCB1",
      type: 0,
      start_date: "2026-04-02T08:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2047"
    },
    {
      id: "a8ee1bd4-65c3-4e10-beab-79fa57b9ff73",
      text: "Data Hall A",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2026-01-12T08:00:00",
      duration: 1152,
      parent: "be9cecea-8dfc-446f-b163-72434a897bd2",
      progress: 0,
      source_task_id: "7995299"
    },
    {
      id: "0ab0a760-a3f9-4f53-952d-979f81188747",
      text: "B2 - DH-D - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 80,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1020"
    },
    {
      id: "9a40c74c-0517-4c16-bd48-c4c4ad122b9b",
      text: "B2 - DH-B - Hookup FCAs Mechanical - Data Hall B",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2410"
    },
    {
      id: "edc05425-9bcc-430a-8272-b24f5a1dd983",
      text: "Placeholder - Predecessor - HRA Activities",
      type: 0,
      start_date: "2024-08-26T00:00:00",
      end_date: null,
      duration: 0,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 1,
      source_task_id: "HRA.1120"
    },
    {
      id: "e747de92-3612-4383-a084-d397869ed83b",
      text: "Final Punch - B1 DHC",
      type: 0,
      start_date: "2026-08-11T00:00:00",
      end_date: "2026-08-17T08:00:00",
      duration: 40,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHC.1020"
    },
    {
      id: "34086c88-4b53-4b77-a887-9cc7b3f2276a",
      text: "B2 - DH-A - El Equip Yd - Pull Cable for (2)HPT, (2)HPD, (1)GS-IDF Hut",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 80,
      parent: "af73992b-f173-45bc-944e-dd449681c36e",
      progress: 0,
      source_task_id: "B2.C.EY.1430"
    },
    {
      id: "b733a21d-1483-4162-a070-02eed079bbb3",
      text: "B1 - 1N2W - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 120,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2780"
    },
    {
      id: "af515cab-25ca-4f40-abbe-b7f3236d4cb4",
      text: "Substation 1 - Prep / Submit for Rvw - H-Frame Deadend",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-09-30T08:00:00",
      duration: 160,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5710"
    },
    {
      id: "8e449900-672f-44c2-9d55-6874aa7e4efa",
      text: "FR 21 - META review and Approve PCO#17",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2024-12-24T08:00:00",
      duration: 80,
      parent: "c1f6a7ac-1c93-432b-b5fe-30be07168a44",
      progress: 0,
      source_task_id: "FR.21.1030"
    },
    {
      id: "922a62c7-3b0b-43b6-83ec-8061154b1c11",
      text: "B1 - 1N2W - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1950"
    },
    {
      id: "de24ae8e-0898-4f38-9280-beb84ca3df27",
      text: "B1 - DH-D - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 24,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1060"
    },
    {
      id: "f5487c10-f21d-41c2-aa9b-5f722204ff81",
      text: "B1 - DH-D - Install Lighting/Branch Conduit -Data Hall D",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1240"
    },
    {
      id: "e3353933-f5e1-444c-8fa4-fee82a71d295",
      text: "B1 - Network - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 936,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1000"
    },
    {
      id: "3651607f-c77a-402c-a830-1117193d4b62",
      text: "B2 - DH-C - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2026-04-08T08:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 0,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1930"
    },
    {
      id: "c62c0640-0c4d-4bc2-aad9-de11d6b50f1a",
      text: "Admin - Submittals - Doors, Frames and Hardware",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-09-17T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1130"
    },
    {
      id: "f8af2cb3-ca70-48cd-877f-9742798a870c",
      text: "Develop Baseline 1 Budget",
      type: 0,
      start_date: "2023-10-24T00:00:00",
      end_date: "2023-12-01T08:00:00",
      duration: 216,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1190"
    },
    {
      id: "fb23b602-223b-43fd-a506-50b38bbe1ec8",
      text: "B1 - SSB - 1E2 - CMDF2 - Pull Wire for Lighting/Outlet/Racks (Carrier MDF2)",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 24,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1900"
    },
    {
      id: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      text: "Tier 1 - B2- Core / Shell",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994774"
    },
    {
      id: "794f3e4f-a49b-4db9-a4f6-dde641d2b349",
      text: "Area 4 - UG RI -MVS to PTX-DCB2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1720"
    },
    {
      id: "9001437d-6b98-45b4-a4ce-c021d340e89e",
      text: "B2 - 2A1 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1220"
    },
    {
      id: "f1fe2607-f433-484c-8b00-a3613a5933bc",
      text: "B2 - DH-C - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 1176,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "B2.C.EY.1130"
    },
    {
      id: "a3586561-e9c6-4a5a-9d0b-1cedba88d7bb",
      text: "B1 - DH-A - Install Celing Devices Security - Data Hall A",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2630"
    },
    {
      id: "d6f961d4-1b78-4dff-b024-572f5b564b45",
      text: "B2 - mCUP-1 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 80,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.8160"
    },
    {
      id: "0603ac53-b38b-4aaf-ac07-7009e740acc0",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1370"
    },
    {
      id: "af4317c5-b524-43ef-9861-100cf6dee12e",
      text: "BLDG-1/2 - Fabricate / Deliver - Glass / Frames",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 360,
      parent: "d80cc1a6-c3ae-4d12-a355-ea20aea6ef84",
      progress: 0,
      source_task_id: "B1.CFCI.5690"
    },
    {
      id: "5565e178-4b72-4587-bdca-3728e274025f",
      text: "Campus - Submittals - Sanitary Manholes and Inlets (Early Release) - Area 4 & 5",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-06-06T08:00:00",
      duration: 64,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.6010"
    },
    {
      id: "7ffdd1c9-3897-467a-92b3-67d2e38c8c76",
      text: "B2 - Deep Telecom - EF2 - Concrete Scope",
      type: 0,
      start_date: "2025-03-07T00:00:00",
      end_date: "2025-03-13T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B2.C.STR.2470"
    },
    {
      id: "33388fbb-9d5a-4d59-bd4a-dbf183464b7b",
      text: "BLDG-2 SSB 2E2",
      type: 5,
      start_date: "2025-11-11T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 1200,
      parent: "bf6187b5-e96d-44aa-afd3-3c0e407eb0e8",
      progress: 0,
      source_task_id: "7995049"
    },
    {
      id: "28c6b98f-7a79-46c0-872d-87d148c820c6",
      text: "IST Start DH A - DCB1",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-05-18T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2154"
    },
    {
      id: "4b230b21-0d2b-4d57-a8d8-67226d0d800c",
      text: "L3 Start DH B - DCB1",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-03-17T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2003"
    },
    {
      id: "3d82739f-538c-45f9-9ff3-ef46627954e9",
      text: "B2 - 2E2E - 02.01.E1.02 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6530"
    },
    {
      id: "67827417-dfd8-4da1-b3b6-04a5b75a8242",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.1970"
    },
    {
      id: "402f3329-410a-4e55-9edb-1757470a7890",
      text: "Fragnet XX - PCO # 29 RFI-163 Sani Tie Exist MH Across Giant Tire Pkwy",
      type: 0,
      start_date: "2024-09-18T00:00:00",
      end_date: null,
      duration: 344,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717479"
    },
    {
      id: "cb84dcdb-d649-480a-8f41-a9ab04aae985",
      text: "MV Electric",
      type: 5,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 232,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995179"
    },
    {
      id: "9f2285bd-838a-4496-b283-72265a23b8d8",
      text: "B1 - 1N2W - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1480"
    },
    {
      id: "c7d489ae-fe79-40f1-acbf-69e1729b64dc",
      text: "B2 - DH-B - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-24T08:00:00",
      duration: 80,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1360"
    },
    {
      id: "31eec9cd-e990-473d-8e92-96658cb5fa78",
      text: "B1 - 1N1W - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 8,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5280"
    },
    {
      id: "048a717d-1dd9-484b-b2b0-c9e8c398d997",
      text: "EPMS - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5830"
    },
    {
      id: "6817dfc1-0273-4e9f-a884-cfbf3a513d62",
      text: "B1 - DH-A - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall A",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2740"
    },
    {
      id: "b8b19f95-836c-4a04-93d9-a593c429f061",
      text: "Doors frames and Hardware - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5960"
    },
    {
      id: "2cd5ff34-bbe2-42c3-8131-bac1e3822c9a",
      text: "B2 - 2E1E - 02.01.E1.01 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5470"
    },
    {
      id: "e6c023fe-80ab-4201-b7a2-197edcdc60cd",
      text: "Substation-1 - MSG A - Medium Voltage Wire Pulls to HV/MV Transformer (Pulls and Terms)",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 104,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3950"
    },
    {
      id: "521ec5ab-abd2-4360-bdb9-3d7a78597e78",
      text: "FR 20 - DPR Prepare and Submit PCO#16",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-19T08:00:00",
      duration: 80,
      parent: "a464ca61-32ce-4bd2-8aa4-8f60eccf8e8c",
      progress: 0,
      source_task_id: "FR.20.1020"
    },
    {
      id: "c7da6cfd-4d2f-4191-9a0c-8213f859b0b0",
      text: "B1 - SSB - Install Coping",
      type: 0,
      start_date: "2025-07-17T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 80,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1180"
    },
    {
      id: "4dd96660-d407-4d4d-bcbf-009e684bdc85",
      text: "Fab and Deliver - PLC Panels - IWM MNGR - mCUP (Integrator) - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2632,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.35,
      source_task_id: "B2.OFCI.1880"
    },
    {
      id: "bfb5cc5c-7778-4d3c-abe9-79b59f95e755",
      text: "B1 - DH-D - Pull/Term Fire Alarm - Data Hall D",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-02-07T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1300"
    },
    {
      id: "4452f354-5177-4ee2-aa07-72081789d9e9",
      text: "B2 - DH-C - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2026-06-05T08:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 0,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2520"
    },
    {
      id: "34969fc4-6301-4034-be1e-1be102445f8e",
      text: "BLDG-1 DH-C - L2 Checkout for Building",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 200,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1040"
    },
    {
      id: "8b5b9430-3767-4927-b57d-e8aa7614519b",
      text: "Substation-1 - MSG A - Wire Pulls From Building - Sequence 2",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 48,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6230"
    },
    {
      id: "5b4e3422-8569-4f25-b569-4001bfb1cde6",
      text: "Fab and Deliver - Busway Kits - Area B - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2824,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.21,
      source_task_id: "B1.OFCI.3420"
    },
    {
      id: "76b1ad37-499d-4ec3-8342-ec0ede70139c",
      text: "DH Electrical Yard Skids",
      type: 5,
      start_date: "2026-01-21T08:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 424,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994823"
    },
    {
      id: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e",
      text: "[DCB1] FacNet Live [AREA D]",
      type: 0,
      start_date: "2026-05-11T08:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3685"
    },
    {
      id: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      text: "Substation-2 A Lineup SF6 Breaker",
      type: 5,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 1616,
      parent: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      progress: 0,
      source_task_id: "7995220"
    },
    {
      id: "d80db510-2ed7-4232-abb6-0f43a4f5e8b1",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.1980"
    },
    {
      id: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      text: "BLDG-1 SSB",
      type: 5,
      start_date: "2025-04-21T00:00:00",
      end_date: "2025-05-10T08:00:00",
      duration: 112,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995395"
    },
    {
      id: "a8dfce16-4457-4a44-8166-994d5b6786b3",
      text: "(CFCI) Div. 09 - Resilient Flooring",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f5d15b6-3801-4b83-9da3-89ba5b3dc781",
      progress: 0,
      source_task_id: "7994878"
    },
    {
      id: "5fce8a14-6a36-49c0-9d10-3f7c885781a2",
      text: "Cx - Lvl-3",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8170"
    },
    {
      id: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      text: "Tier 2, 3, 4 - B2 - Overhead/In-Wall",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994768"
    },
    {
      id: "eacd2f9f-8e27-4dcf-bd58-c0773cb3abf1",
      text: "Tier 2, 3, 4 - B2-2-B",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      progress: 0,
      source_task_id: "7994769"
    },
    {
      id: "337dc302-bd6e-4e08-afb9-ba97c6503bf3",
      text: "B2 - DH-A - Install Decking",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 80,
      parent: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      progress: 0,
      source_task_id: "B2.C.STR.1750"
    },
    {
      id: "24ca126f-f19d-4b11-bfba-93886754cbba",
      text: "Building 1 mCUP-7",
      type: 5,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 544,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995365"
    },
    {
      id: "bf709ce3-7004-4925-88e1-84537d179125",
      text: "B1 - 1A2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 8,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1600"
    },
    {
      id: "074353b9-a29e-47f2-952a-430dc77d3cad",
      text: "IBOS - Submittal Rvw/App'l  - PTX",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1120"
    },
    {
      id: "570cf87e-4ff7-4c3a-82bd-07a0434eaba6",
      text: "(CFCI) Div. 31 - Earthwork",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994859"
    },
    {
      id: "4c4a3ca6-3e76-4508-8266-9f92dc809775",
      text: "Tier 2, 3, 4 - B1-1-A",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994792"
    },
    {
      id: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 288,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995379"
    },
    {
      id: "7bcd4f85-350d-459c-be83-25b11deb2e87",
      text: "Install / Terminate FA Panels",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 40,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1080"
    },
    {
      id: "609fa5af-5d53-4887-bb08-1c350a49a172",
      text: "Product Review  Set Package",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-10-29T08:00:00",
      duration: 1736,
      parent: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      progress: 0.6,
      source_task_id: "7994729"
    },
    {
      id: "93267209-24ee-446c-bcec-37f8a12946cd",
      text: "IBOS Constuction Complete",
      type: 0,
      start_date: "2026-02-06T08:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1030"
    },
    {
      id: "d6dbed56-497d-443d-b8e0-8ff083d76c28",
      text: "Underground",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "41120383-8f38-4628-8077-188a15a1d1dd",
      progress: 0,
      source_task_id: "8444265"
    },
    {
      id: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2",
      text: "B1 - Network - Install Decking",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 40,
      parent: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      progress: 0,
      source_task_id: "B1.C.STR.1840"
    },
    {
      id: "6ef9db13-c668-4799-be88-de70a7cc6617",
      text: "B1 - DH-B - Lightning Protection",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1510"
    },
    {
      id: "f262686e-0fe1-4db4-82dc-d54c3b697c5f",
      text: "B1 - SSB - 1E1 - Common - Install Wall Devices BMS",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 48,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2320"
    },
    {
      id: "5480f647-2e98-4090-9ba5-6ad17a75b7b1",
      text: "(CFCI) Div. 05 - Structural Steel B2",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0,
      source_task_id: "7994924"
    },
    {
      id: "899d729a-67a9-4124-8d85-6a9c06d77fcb",
      text: "Campus - Submittal Review & Approval - Asphalt / Paving",
      type: 0,
      start_date: "2025-02-06T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 120,
      parent: "ecc051e0-d5dd-471f-94c9-13123cf5d74b",
      progress: 0,
      source_task_id: "B1.CFCI.5100"
    },
    {
      id: "55060ad7-412c-4bde-85c9-477d57ba3a95",
      text: "UPS - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 1,
      source_task_id: "B1.OFCI.1130"
    },
    {
      id: "57fd6970-b65c-419b-856a-83c5bdb6d4b1",
      text: "BLDG-1/2 - Fabricate / Deliver - Finished Carpentry (Millwork/Countertops)",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 240,
      parent: "450e7e94-6054-44b6-b556-c3c644e90ee4",
      progress: 0,
      source_task_id: "B1.CFCI.4960"
    },
    {
      id: "a7ca121a-2dd4-48fe-9417-0dc11fe4b967",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2440"
    },
    {
      id: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      text: "BLDG-1 SSB",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444257"
    },
    {
      id: "d8b87ed3-4282-4138-ab01-dad17637c355",
      text: "Corridor 1N1W",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 936,
      parent: "170d680a-3fe7-4c7b-84af-c46523784642",
      progress: 0,
      source_task_id: "7995335"
    },
    {
      id: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      text: "B1 - mCUP-3 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3040"
    },
    {
      id: "4c96e1c6-48ca-4370-9022-3687df559aee",
      text: "Roofing SA - Meta Review",
      type: 0,
      start_date: "2024-06-04T00:00:00",
      end_date: "2024-07-13T00:00:00",
      duration: 40,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 1,
      source_task_id: "PRE-PP-1240"
    },
    {
      id: "d4e90eb6-671b-4c28-bfb6-75806bbb4e37",
      text: "Factop Unit Online for Substation 1",
      type: 0,
      start_date: "2025-07-11T08:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2870"
    },
    {
      id: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 928,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "7995263"
    },
    {
      id: "cade9bfa-4cba-43dc-bd37-6c1b630e3559",
      text: "Site / UG BIM - Critical Early Release - Lift Station Design Change Delay (Post IFP) - Coordination / Sign Off",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2024-04-23T08:00:00",
      duration: 16,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1130"
    },
    {
      id: "df2d46ff-cec6-4c94-ab1c-f55d3dc7e3e9",
      text: "L4 - B2 DHC - Server Migration",
      type: 0,
      start_date: "2027-03-01T00:00:00",
      end_date: "2027-03-02T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHC.1010"
    },
    {
      id: "462ddc26-190b-413c-914d-f0b00888cacf",
      text: "Electrical SA - Meta Review",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-24T08:00:00",
      duration: 312,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1180"
    },
    {
      id: "136bfa09-240b-4afb-b99f-95a778f89769",
      text: "B1 - SSB - 1E2 - CMDF2 - Pour Pads Around Telecom Conduits (Carrier MDF2)",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 48,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1710"
    },
    {
      id: "1086d5ca-bfa3-4418-a6c0-3f4be628008c",
      text: "Paint Primary Steel",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1140"
    },
    {
      id: "1b938158-4ae6-49ce-b7ae-c299c79ad4ec",
      text: "PRS Issuance",
      type: 0,
      start_date: "2024-01-05T08:00:00",
      end_date: "2024-01-05T08:00:00",
      duration: 0,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "Design.PreC.2100"
    },
    {
      id: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      text: "Steel",
      type: 5,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 568,
      parent: "6f8a9cb3-e013-459d-bc9e-aadfcae5194d",
      progress: 0,
      source_task_id: "7995117"
    },
    {
      id: "362a02d2-774d-460a-8620-d052f83a8ab0",
      text: "Substation-2 Transformer A Work",
      type: 5,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 2000,
      parent: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      progress: 0,
      source_task_id: "7995219"
    },
    {
      id: "96758d24-41d4-4fa4-81b4-ec2b5400d4c2",
      text: "B1 - DH-B - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 40,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1430"
    },
    {
      id: "6c6659fb-813c-4555-aa02-76492f8e8ac8",
      text: "Substation-2 - MSG B - Install Batteries",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 40,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4400"
    },
    {
      id: "cbc26df0-bf40-45ac-bf64-e89b10534764",
      text: "Paint Top-Out",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1560"
    },
    {
      id: "ac533bcc-eaec-4005-932e-bf275afc408a",
      text: "Area B - OH Fire Alarm",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 80,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1042"
    },
    {
      id: "c0a0355b-ca4a-4ad9-9025-ecf639d7a568",
      text: "Frame Priority Walls",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-06-03T08:00:00",
      duration: 64,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.CON.1170"
    },
    {
      id: "1dd28142-ddc7-4088-a698-0827f8d5b870",
      text: "B2 - DH-D - Install Underground Controls",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 80,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1530"
    },
    {
      id: "ca74c3ad-3724-4ea5-8b7e-5523a5250ef9",
      text: "Campus - Install Campus Hardscape - Sequence 2",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 288,
      parent: "0fbbf7fa-904a-48e8-8721-806fbcb106b9",
      progress: 0,
      source_task_id: "C.SI.HS.1010"
    },
    {
      id: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      text: "L3 - B1 EY 1 NS/ B *On Temp Power*",
      type: 0,
      start_date: "2025-12-08T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 80,
      parent: "b4e5a005-102e-4fbf-949a-1ed89d200a5c",
      progress: 0,
      source_task_id: "CX3.B1.MSG.1020"
    },
    {
      id: "26ced265-6840-453a-9265-66ea6dffe757",
      text: "B1 - 1D2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 80,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2160"
    },
    {
      id: "d7c98bf0-15f2-4e60-9111-50290bda14d4",
      text: "B1 - DH-C - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 40,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1130"
    },
    {
      id: "d48eed1e-7f94-4fb5-97ad-32c0e2d79110",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Security",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1450"
    },
    {
      id: "b67b89c1-fee7-4663-91a4-e1613a1eb002",
      text: "B1 - DH-B - Install Decking",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 80,
      parent: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      progress: 0,
      source_task_id: "B1.C.STR.2060"
    },
    {
      id: "23c09456-b762-4334-ba03-41ef82534a45",
      text: "Substation-2 - TX A - NETA Testing",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 184,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4840"
    },
    {
      id: "f487bf81-6138-4387-9fa1-ff6e2e4171dc",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 8,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1610"
    },
    {
      id: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      text: "B2 - SSB - 2E1 - Common - Frame Walls (Top-out included)",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 96,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1000"
    },
    {
      id: "d0457db1-1321-4a69-8781-279d9fffd75f",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Porcelain Tiling",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-01-29T08:00:00",
      duration: 120,
      parent: "1199aed8-9a5c-4ba9-b5a4-fd27806e7d1d",
      progress: 0,
      source_task_id: "B1.CFCI.4930"
    },
    {
      id: "990a9e68-133e-417f-9881-f6c90d67f4be",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [5] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-05-12T08:00:00",
      duration: 2792,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.38,
      source_task_id: "B1.OFCI.3680"
    },
    {
      id: "4d1811b9-c839-49a4-ac38-aee0b2b3b21c",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1150"
    },
    {
      id: "6f95fff8-f1f8-4092-9a6e-10f6b1a2d946",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1710"
    },
    {
      id: "732a8b76-e31a-4493-a6e9-31c7d1d0008a",
      text: "B1 - DH-D - Hookup CDU's - Data Hall D",
      type: 0,
      start_date: "2026-02-24T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 144,
      parent: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      progress: 0,
      source_task_id: "B1.C.D.3115"
    },
    {
      id: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      text: "L4 - B1 MSG-A *On Temp Power*",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 40,
      parent: "9b65810f-93cc-453e-8de8-a75c5f4cb8b5",
      progress: 0,
      source_task_id: "CX4.B1.SS.1010"
    },
    {
      id: "b78830d7-dbe7-4fed-add3-f652a8bd3832",
      text: "L4 Finish DH D - DCB2",
      type: 0,
      start_date: "2027-03-17T08:00:00",
      end_date: "2027-03-17T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2113"
    },
    {
      id: "14c3d512-4930-4e8b-8006-fa1e89546196",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2580"
    },
    {
      id: "d18df9ed-00e2-4ba1-8a33-1deaaed8d03e",
      text: "B1 - 1C1W - 01C.08 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.2270"
    },
    {
      id: "16ab030a-f2e1-4942-9f80-3308fb3e455b",
      text: "Steel",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 464,
      parent: "94a1c3e5-7f04-47aa-9c64-e23c0509b3f5",
      progress: 1,
      source_task_id: "PRE1390"
    },
    {
      id: "5a76a616-ef35-416e-b75a-9c99fcdaff46",
      text: "B2 - DH-A - Inspect Above Ceiling - Data Hall A",
      type: 0,
      start_date: "2026-06-15T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 24,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2640"
    },
    {
      id: "d88e1970-06c1-4c02-a1bf-ce7897f49de8",
      text: "B2 - 2B1 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 80,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1770"
    },
    {
      id: "4f28e0d8-9a4f-46cc-b5aa-639e59bbe890",
      text: "B2 - SSB - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 40,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1000"
    },
    {
      id: "66ef179a-466c-4da5-ac89-7153c2c17faa",
      text: "FR 36 - Procure hand hole",
      type: 0,
      start_date: "2024-12-12T00:00:00",
      end_date: "2024-12-26T08:00:00",
      duration: 80,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 0,
      source_task_id: "FR.36.1030"
    },
    {
      id: "1f063521-b2a3-4b0d-838c-2b55c3f2085a",
      text: "Fragnet 39 - mCUP foundations",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 264,
      parent: null,
      progress: 0.64,
      source_task_id: "8816260"
    },
    {
      id: "877690eb-af7a-43bf-8337-0d864544dcc4",
      text: "Area B - Hang Top Out",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1180"
    },
    {
      id: "8add724b-b353-4269-86fb-29af286a4fdd",
      text: "B2 - DH-D - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 480,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "B2.C.EY.1500"
    },
    {
      id: "f6f51ffe-cd8a-44f6-8bf4-1bd591fc0413",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1390"
    },
    {
      id: "5e624115-3494-433d-9f92-5b99ac80c412",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (D)",
      type: 0,
      start_date: "2025-10-17T08:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1430"
    },
    {
      id: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98",
      text: "B1 - SSB - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-04-26T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 40,
      parent: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      progress: 0,
      source_task_id: "B1.C.STR.1860"
    },
    {
      id: "9918a6c8-1c36-4827-b385-53ff12fa7b8e",
      text: "B1 - Prep Area for Final Paving",
      type: 0,
      start_date: "2026-01-06T00:00:00",
      end_date: "2026-01-20T08:00:00",
      duration: 96,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1060"
    },
    {
      id: "382038a3-5959-4356-bdb8-9f0ccb256552",
      text: "B1 - SSB - 1E2 - Common - Install Rubber Base",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2440"
    },
    {
      id: "235aec86-ec4c-4cb0-8070-8efa49ad8434",
      text: "B1 - 1D1W - 01D.09 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2200"
    },
    {
      id: "827ea0dc-8cda-400a-8001-c1f65f5dcfc3",
      text: "B1 - Network Room 1/4  - Install Below Ceiling Signage and Devices",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2260"
    },
    {
      id: "9667b0ae-161a-4f45-b91a-9fc49e2519d4",
      text: "BLDG-1 - BIM - Tier 1 - Precast - Population-Coordination / Sign-off",
      type: 0,
      start_date: "2024-06-17T00:00:00",
      end_date: "2024-10-08T08:00:00",
      duration: 640,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0.06,
      source_task_id: "B1.VDC1.1210"
    },
    {
      id: "689b7118-7742-4c6d-959d-ef430cdbf7c4",
      text: "FR 23 - META review and Approve PCO#19",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 80,
      parent: "2be26207-dbca-4279-9a53-24684a97817a",
      progress: 0.4,
      source_task_id: "FR.23.1030"
    },
    {
      id: "4904011b-ade9-4838-bed6-0bd5330c5989",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2080"
    },
    {
      id: "fe4071fe-909e-4a85-aa83-ef00792d503f",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1320"
    },
    {
      id: "8d80126e-8321-432b-bc11-bbbc9e279276",
      text: "B2 - 2A1 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1230"
    },
    {
      id: "bc63b7e8-c261-4c29-801a-3ee0059780cd",
      text: "B2 - SSB - 2E2 - Common - Install Ceiling Grid",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 64,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1700"
    },
    {
      id: "4338b789-606e-4a01-9ac9-363419bb5417",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2100"
    },
    {
      id: "8f93b811-ce91-476f-8cc1-bc63894883d2",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Security",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1380"
    },
    {
      id: "31461867-6580-433d-94cd-33c955774fc0",
      text: "B1 - DH-A - Rough in HAC Lighting - Data Hall A",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2280"
    },
    {
      id: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      text: "UPS Room 02.01.E1.02",
      type: 5,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 480,
      parent: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      progress: 0,
      source_task_id: "7995056"
    },
    {
      id: "c72046e1-d3c7-4a2d-a2fb-68105d8ff5af",
      text: "[DCB1] DEC-C Ready: General Services [DAS TOWER #1 & GH]",
      type: 0,
      start_date: "2025-11-13T08:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3765"
    },
    {
      id: "80cf852a-b67e-4e92-9873-dbb6d23e3f09",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Electrical",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1030"
    },
    {
      id: "56ede0b1-255c-4479-a807-a615df7d22a5",
      text: "GS.MDF Module (Facnet)",
      type: 5,
      start_date: "2025-06-25T08:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 0,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994832"
    },
    {
      id: "612becec-5331-493e-8b2f-fecb210f4c1a",
      text: "DFSMA - DC2 - CUP 4- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-10-20T08:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1280"
    },
    {
      id: "cd5c1efe-569c-4b49-8fb6-db71c9e2e20b",
      text: "B1 - 1A2E - Corridor - Room Fit Out - Elecrical",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1870"
    },
    {
      id: "d759407a-4b29-4c26-bef9-8ce89bbf0990",
      text: "B1 - SSB - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 160,
      parent: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      progress: 0,
      source_task_id: "B1.C.STR.1420"
    },
    {
      id: "1cee4967-0a22-4e88-9c12-72d45544684a",
      text: "B2 - ISP Cabling - IDFB to DHB (GS tray)",
      type: 0,
      start_date: "2026-08-12T00:00:00",
      end_date: "2026-09-16T08:00:00",
      duration: 200,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1240"
    },
    {
      id: "fefac47e-ab7d-4989-973c-27002a407ce9",
      text: "B1 - Network Room 2/3 - Power Alley - Ductwork/EF Install",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1500"
    },
    {
      id: "e9c2c5a5-2959-4452-ba53-7ec873119de9",
      text: "Review site specific design to ensure adaptation of MOFE elements",
      type: 0,
      start_date: "2024-01-03T00:00:00",
      end_date: "2024-01-16T08:00:00",
      duration: 72,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1320"
    },
    {
      id: "a4c12ef8-c502-41c6-abf8-2941c777d83e",
      text: "B1 - Network Room 2/3 - Power Alley - OH Electrical Rough",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 96,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1280"
    },
    {
      id: "77dbc1da-f58d-4774-a6e9-1a7bf3fec7a6",
      text: "B2 - DH-C - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 160,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1760"
    },
    {
      id: "88e70f29-86af-4380-8c62-f8b99a4c5bfe",
      text: "B1 - DH-C - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 80,
      parent: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      progress: 0,
      source_task_id: "B1.C.C.3160"
    },
    {
      id: "9acce500-15d1-40e1-8695-be97fd7544ca",
      text: "B1 - 1C1W - 01C.08 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1830"
    },
    {
      id: "557f4a5b-506c-4d2f-8d73-ccdac0d09b83",
      text: "B1 - DH-B - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 240,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1280"
    },
    {
      id: "25c2bdc0-9feb-463e-a893-1dbf95d92b97",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [3] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-11-25T08:00:00",
      duration: 1616,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.64,
      source_task_id: "B1.OFCI.3580"
    },
    {
      id: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154",
      text: "Substation-1 - MSG B - Wire Pulls From Building - Sequence 2",
      type: 0,
      start_date: "2025-06-07T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 80,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6290"
    },
    {
      id: "d825dd3c-0eb8-4f39-8af8-e909889cfbcf",
      text: "B2 - DH-D - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1120"
    },
    {
      id: "8eff4dd1-d6ce-48b1-b262-9c04c2549570",
      text: "B1 - DH-A - Pull/Term BMS - Data Hall A",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2600"
    },
    {
      id: "10cad207-9465-4fed-b63a-c5ecad034bbc",
      text: "FR 23 - DPR Prepare and Submit PCO#19",
      type: 0,
      start_date: "2024-08-07T00:00:00",
      end_date: null,
      duration: 416,
      parent: "2be26207-dbca-4279-9a53-24684a97817a",
      progress: 1,
      source_task_id: "FR.23.1020"
    },
    {
      id: "14a93288-a9ec-4a1e-9927-b17a4c6587db",
      text: "B2 - DH-A - Install 800 Amp Busway - Data Hall A",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2260"
    },
    {
      id: "1529ec3a-c810-47d7-b75b-77e5a8096f16",
      text: "Fragnet 02 - Additional Civil & Building Permit Review Time",
      type: 0,
      start_date: "2024-05-06T00:00:00",
      end_date: null,
      duration: 688,
      parent: "9f4190f7-8b2b-4a33-a2d9-5b4aa76d947c",
      progress: 1,
      source_task_id: "8519868"
    },
    {
      id: "9dd203bd-63ed-4bf3-9539-c32d33cefaad",
      text: "BLDG-2 DH-B Level 2 Checkout",
      type: 5,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 200,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "7995134"
    },
    {
      id: "242b4cbb-1d82-45be-a5d3-1bbe349af6ac",
      text: "BLDG-1 - Area D - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.5010"
    },
    {
      id: "99bd6d34-dcc8-44a2-b361-21698415a6d6",
      text: "B1 - 1N2E - 01N3.06 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6520"
    },
    {
      id: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      text: "(OFCI) B1 UPS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2600,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.41,
      source_task_id: "7994977"
    },
    {
      id: "e292c999-4411-40bb-a7b2-a43578b53dad",
      text: "In-Wall Rough Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1090"
    },
    {
      id: "29aea85f-78e6-4f8f-aebd-6838c4522a88",
      text: "B1 - 1A2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1450"
    },
    {
      id: "5f2638a5-ed91-40d2-9403-c88672e15d2f",
      text: "B2 - DH-A - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 304,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1020"
    },
    {
      id: "7a764c24-46fa-433f-8538-20c230e46ca8",
      text: "B2 - 2A2 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 160,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1860"
    },
    {
      id: "4a213102-ecdd-4d3c-87e6-1eca8cf0725b",
      text: "B1 - DH-C - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1140"
    },
    {
      id: "f5524dd2-24a8-45da-ba1e-ecc6b0f0619b",
      text: "B1 - Network Room 1/4  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1150"
    },
    {
      id: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a",
      text: "BLDG-1 DH-D - L2 Checkout for Building",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 200,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1050"
    },
    {
      id: "22160751-fdd7-4e28-9bf6-e436206a6e25",
      text: "B2 - DH-C - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-17T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1400"
    },
    {
      id: "631493f5-651b-43a7-bc33-071f4850db8b",
      text: "B2 - 2C2 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 24,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1190"
    },
    {
      id: "754b29f6-4c15-42ae-b7a9-ed0999e6bccc",
      text: "B1 - DH-B - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 80,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1640"
    },
    {
      id: "fec47869-d978-4f49-9e4f-c5926b3f998c",
      text: "Area A - OH Mechanical (incl Ceiling Fans) - Open Areas",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 80,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1031"
    },
    {
      id: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      text: "Product Design Documentation (PDD)",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-10-23T00:00:00",
      duration: 0,
      parent: "a889b01a-9e63-4cf7-8e55-f28e9bb68b17",
      progress: 1,
      source_task_id: "PRE1020"
    },
    {
      id: "5ead4bd9-e05e-44f2-a601-bd7d84f9a97f",
      text: "B1 - 1N1E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1090"
    },
    {
      id: "87e69ded-b1a6-404f-a1b5-21a468f6dab7",
      text: "IBOS -  Review for Approval - PEMB Steel",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: null,
      duration: 472,
      parent: "bb4ccf8c-2430-46e8-8802-789fa95742f7",
      progress: 0,
      source_task_id: "B1.CFCI.6370"
    },
    {
      id: "6c0b3c4f-4c99-408f-a55d-1a154c725591",
      text: "B2 - 2D2 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1260"
    },
    {
      id: "169a7a22-09a7-4cd7-923e-29b697c8ad36",
      text: "Fab and Deliver - MVS-5WAY - Area D - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 2840,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.42,
      source_task_id: "B2.OFCI.2160"
    },
    {
      id: "3ba7914f-29c8-4baf-9d93-4b416557f236",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [6] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-05-19T08:00:00",
      duration: 2832,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.38,
      source_task_id: "B1.OFCI.3690"
    },
    {
      id: "460505ba-5b31-4e46-9b79-a5bcd8a855b1",
      text: "L3 Start DH B - DCB2",
      type: 0,
      start_date: "2026-10-07T00:00:00",
      end_date: "2026-10-07T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2003"
    },
    {
      id: "02527047-34bf-4eb5-8178-60681bbc6185",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 160,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1740"
    },
    {
      id: "95cfcc66-2158-4019-a073-c195691fb1bb",
      text: "B2 - DH-C - Install Perimeter Cable Tray - Data Hall C",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2640"
    },
    {
      id: "98b5eb75-fead-4a72-8e5f-b766647fd53b",
      text: "BLDG-1/2 - Prep / Submit for Review - Interior Expansion Joints (Spec 07 95 13.13)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-24T08:00:00",
      duration: 160,
      parent: "f068736c-3c4a-473c-8c98-6ef859973fe0",
      progress: 0,
      source_task_id: "B1.CFCI.4590"
    },
    {
      id: "57c60288-b67a-41a4-bf8a-826cec69bc3e",
      text: "B1 - mCUP-7 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7100"
    },
    {
      id: "b2f457b5-1e95-47e6-9ff6-9410bed9b93c",
      text: "B1 - 1D1W - 01D.08 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2380"
    },
    {
      id: "f510e8d1-168c-43c8-8886-0d322957a9b9",
      text: "DFSMA - DC1 - mCUP - GS.IDF Remote Module ROJ - MOFE (1X2)",
      type: 0,
      start_date: "2025-08-13T08:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 0,
      parent: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      progress: 0,
      source_task_id: "B1.DFSMA.1190"
    },
    {
      id: "d2d9b972-c72e-4341-8a57-68637848f221",
      text: "L4 - B1 DHD",
      type: 0,
      start_date: "2026-07-01T00:00:00",
      end_date: "2026-08-19T08:00:00",
      duration: 280,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHD.1000"
    },
    {
      id: "cf23d7e9-17e9-4c67-85a4-3fff3c14d1ca",
      text: "Area 4 - MV Electric Install - Remaining (EY into ER) - Concrete Scope",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 96,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A4.8090"
    },
    {
      id: "3ac7dba0-deef-4885-b7c1-f9cf9b2a669d",
      text: "B1 - Network Room 1/4 - Prime and 1st Coat",
      type: 0,
      start_date: "2025-07-17T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1370"
    },
    {
      id: "88bd03db-51de-4964-ac4a-30f792816ea4",
      text: "Cooling Towers - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-15T00:00:00",
      duration: 0,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 1,
      source_task_id: "B2.OFCI.1020"
    },
    {
      id: "23189029-db36-4e9f-823e-9b0709dd4b92",
      text: "B1 - Network Room 1/4 - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 192,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1870"
    },
    {
      id: "9acc1cfe-ea3f-45de-ae94-09b0286da607",
      text: "B1 - Network Room 1/4 - FCA Gallery - IMP Wall Install at FCA equipment",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 80,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1620"
    },
    {
      id: "ef9f749c-a8f7-46eb-89ec-cc4e30665005",
      text: "B1 - SSB - 1E2 - Common - Install Ceiling Grid",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 64,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1870"
    },
    {
      id: "01a216fb-b987-4bdb-82e2-a17937ef823b",
      text: "B1 - DH-A - Install Underground Security",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 80,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1450"
    },
    {
      id: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 16,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2180"
    },
    {
      id: "4aa341db-8696-49c1-b7ee-ce7550c9f986",
      text: "PRS Page Turn",
      type: 0,
      start_date: "2024-01-05T00:00:00",
      end_date: "2024-01-05T08:00:00",
      duration: 8,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "Design.PreC.2060"
    },
    {
      id: "864b363d-17b0-48a2-bceb-a8246043f798",
      text: "Fab and Deliver - ATS - Area D - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 0.39,
      source_task_id: "B2.OFCI.2580"
    },
    {
      id: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      text: "Building 1 mCUP-5",
      type: 5,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 480,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995368"
    },
    {
      id: "e8bb568c-a248-49de-8cab-1842f3f91dac",
      text: "DFSMA - DC2 - SUB 2 - GS.IDF Remote Module ROJ - MOFE",
      type: 0,
      start_date: "2025-11-26T08:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 0,
      parent: "d70530f6-b13d-4b0a-940b-9b1bf24a563d",
      progress: 0,
      source_task_id: "B2.DFSMA.1240"
    },
    {
      id: "ebb3c17e-bdaf-43ac-8996-e2d131b81404",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2040"
    },
    {
      id: "460ca71b-aa75-4358-a0fc-ea97f09ab8e9",
      text: "B2 - mCUP-1 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1260"
    },
    {
      id: "a12dbec5-e76a-40b1-b197-84dea2c5cac1",
      text: "B1 - Network - Install Underground Plumbing",
      type: 0,
      start_date: "2025-02-18T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 80,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1150"
    },
    {
      id: "4f44e098-6698-40c5-a1a8-fb6b89c70b5c",
      text: "Fab and Deliver - PLC Panels - DIO - mCUP (Integrator) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 2328,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.31,
      source_task_id: "B1.OFCI.2030"
    },
    {
      id: "6a3aaf47-1ab6-4956-afd7-b30ef3fb8615",
      text: "Start mCUP Unit Set-In-Place - Phase1",
      type: 0,
      start_date: "2025-07-07T08:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1182"
    },
    {
      id: "af73992b-f173-45bc-944e-dd449681c36e",
      text: "BLDG-2 DH-A  Electrical Pulls",
      type: 5,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 464,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "7995132"
    },
    {
      id: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      text: "BLDG-2 DH-B Electrical Pulls",
      type: 5,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 280,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "7995135"
    },
    {
      id: "709297a5-547d-446e-a726-780540dac865",
      text: "B2 - mCUP-3 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 80,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.8180"
    },
    {
      id: "919a03ff-ed70-45e4-96c4-bdc368998a4d",
      text: "B1 - DH-B - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 80,
      parent: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      progress: 0,
      source_task_id: "B1.C.STR.2210"
    },
    {
      id: "fc7d4283-3c27-4ee5-86cf-7b1e8a9643de",
      text: "B1 - DH-A - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 48,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2540"
    },
    {
      id: "06cc82f0-f677-410f-9e3f-f98cbe836508",
      text: "DCB2 EY2 Ready for Energization",
      type: 0,
      start_date: "2026-07-16T08:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1126"
    },
    {
      id: "869a25ab-7325-4b11-92ab-5d67cd19f1b4",
      text: "B2 - SSB - 2E2 - Common - Install Devices in Tile/OH Electrical",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1720"
    },
    {
      id: "f709d727-7225-4517-9ae4-5d8b8d232ee4",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (C)",
      type: 0,
      start_date: "2025-09-25T08:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1420"
    },
    {
      id: "76f1b205-6d2d-4956-8ca6-877a6aaee359",
      text: "Fragnet 29 - PCO # 27 CCD-049 Data Hall Elec CRAH Unit Floor Drains",
      type: 0,
      start_date: "2024-09-20T00:00:00",
      end_date: null,
      duration: 328,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717477"
    },
    {
      id: "1f68aa74-486e-48f9-ab59-57cf4e89a59d",
      text: "IBOS  - Fabricate / Deliver - Storage racks",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6440"
    },
    {
      id: "6cc41727-7ffe-4923-8540-840861a97785",
      text: "BLDG-1/2 - Prep / Submit for Review - Carpet",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-01-29T08:00:00",
      duration: 160,
      parent: "a186b242-b288-4250-b87d-d866ac28f219",
      progress: 0,
      source_task_id: "B1.CFCI.4830"
    },
    {
      id: "f9b5979d-3be3-4855-b1ba-cd7985f44884",
      text: "B1 - 1C1W - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1210"
    },
    {
      id: "35902e13-7819-4cc8-9f37-be61c40d5c55",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Plumbing",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1040"
    },
    {
      id: "e64544ae-3f43-4a46-aab5-680b38464edf",
      text: "B1 - DH-B - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-10-06T08:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 0,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2400"
    },
    {
      id: "ddfe9779-b4ac-47c1-8342-a17625b3bbc2",
      text: "B1 - SSB - Install Exterior Metal Panels & Louvers",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-21T08:00:00",
      duration: 80,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "B1.C.7020"
    },
    {
      id: "434e09f1-6149-420d-a10e-3a5f5a279eee",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1560"
    },
    {
      id: "59510490-4817-4444-81b7-b5a0365cbed2",
      text: "B2 - DH-C - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 40,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1240"
    },
    {
      id: "11487d54-9fa5-4cff-b4e1-c23d07f3d65b",
      text: "B1 - DH-B - Backfill",
      type: 0,
      start_date: "2025-04-09T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 40,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1690"
    },
    {
      id: "1c09917f-1195-490a-a74f-65cdbb4445f4",
      text: "BLDG-1/2 - Prep / Submit for Review - Vesda System",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 160,
      parent: "3e0c2709-f6dd-4154-90ac-684cc2b77033",
      progress: 0,
      source_task_id: "B1.CFCI.4710"
    },
    {
      id: "52d3af53-0515-442d-ae0a-d5ea0b3f489e",
      text: "BLDG-1 DH-D",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444262"
    },
    {
      id: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      text: "B1 - DH-A - Cure for SOG",
      type: 0,
      start_date: "2025-07-13T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 24,
      parent: "55203d15-6a05-4636-aac5-eb996029b878",
      progress: 0,
      source_task_id: "B1.C.STR.2300"
    },
    {
      id: "22b989cf-85fd-429a-9e42-130c8689b5f9",
      text: "Substructure - GH",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 240,
      parent: "960a3230-3d18-4a8d-9b60-7f435cfb3995",
      progress: 0,
      source_task_id: "GH.CON.1000"
    },
    {
      id: "597afc40-be93-4b84-9181-d324bcbe88b4",
      text: "Fab and Deliver - ATS - Area D - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.31,
      source_task_id: "B1.OFCI.3290"
    },
    {
      id: "510381a3-4332-49de-8527-36dc5f282b3c",
      text: "FR 03 - Telecom Redesign - UG BIM Coordination / Sign Off (Remaining Utilities) - Area 1",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-06-07T08:00:00",
      duration: 80,
      parent: "0497b6bf-f811-43f6-b6dc-b788f581380d",
      progress: 1,
      source_task_id: "FR.03.1020"
    },
    {
      id: "5c6758c7-10d1-4f01-820f-c716ff51fad0",
      text: "Area A - Seal Concrete Floors",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 80,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1261"
    },
    {
      id: "3c238586-ddab-405d-af44-e1ca2dac8412",
      text: "Set Equipment",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 320,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1080"
    },
    {
      id: "919dc4c3-0d09-481e-b3d6-24166f8e9a7b",
      text: "Campus - Submittal Rvw/App'l -  Storm Manholes and Inlets (Early Release)",
      type: 0,
      start_date: "2024-04-17T00:00:00",
      end_date: "2024-04-23T08:00:00",
      duration: 40,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.4070"
    },
    {
      id: "d981fa4d-70ed-4e80-b45c-4cecd0e62e10",
      text: "B2 - DH-B - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1080"
    },
    {
      id: "da781b9e-7e57-441e-a97a-70a3e6f14b81",
      text: "Fab and Deliver - PTX-CUP - Area CUP (9) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 2296,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.44,
      source_task_id: "B1.OFCI.2000"
    },
    {
      id: "acc27af2-8c46-4bb0-8d06-25e3ae0274bd",
      text: "B2 - 2E2E - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-23T08:00:00",
      duration: 160,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6210"
    },
    {
      id: "b703f064-2122-4c51-9118-8de2a8062aee",
      text: "B2 - mCUP-4 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 48,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4020"
    },
    {
      id: "07d5b9e0-ca27-4637-bf5c-8a50fdfa966f",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [3] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 2472,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.42,
      source_task_id: "B1.OFCI.3490"
    },
    {
      id: "1a496203-9663-4179-993b-50ba2f03a8ec",
      text: "OH Plumbing",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1400"
    },
    {
      id: "46821895-f91c-4fa1-a1d6-ba135d144d08",
      text: "Form/Rebar/Pour SOG - Area B - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1150"
    },
    {
      id: "65944138-288d-4e96-b35f-e182ababcce9",
      text: "HTF Walls / Ceilings / Install Plywood",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 56,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1010"
    },
    {
      id: "fc05ec65-4f10-4e7a-b57a-d2330a9fa422",
      text: "GMP Review and Final Submission",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-06-03T08:00:00",
      duration: 120,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1110"
    },
    {
      id: "1876afbe-b695-419a-93ac-8f1d188f35ce",
      text: "Campus - Fabricate / Deliver - Storm Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-05-20T00:00:00",
      end_date: "2024-06-10T08:00:00",
      duration: 120,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5910"
    },
    {
      id: "e3bc4aa7-96ec-4b8b-8e45-e26bf69c7e64",
      text: "Area 4a - UG RI - LateCommunications & Security-Campus",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 192,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1610.10"
    },
    {
      id: "dc869448-8240-4498-97b0-195eeebf7afc",
      text: "B2 - DH-A - Grout Column Baseplates",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      progress: 0,
      source_task_id: "B2.C.STR.1850"
    },
    {
      id: "42b85903-0569-451d-99c5-b076a5e46f01",
      text: "B1 - 1N2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 120,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6150"
    },
    {
      id: "95762aa0-d832-412b-b282-97cbe0ea5891",
      text: "B2 - DH-B - Pull/Term Lighting/Branch - Data Hall B",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2760"
    },
    {
      id: "08d2b405-6b71-4158-a88c-9cd0cc7b5fba",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [8] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 3064,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.35,
      source_task_id: "B2.OFCI.2790"
    },
    {
      id: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      text: "B2 - SSB - 2E2 - Common - Prime and 1st Coat Paint",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 80,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1610"
    },
    {
      id: "9e73801d-347f-4215-bf1e-92a10b0b5bd5",
      text: "Campus PH1 - Fabricate / Deliver - MV Vaults ((Early Release))",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: "2024-10-25T08:00:00",
      duration: 240,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0,
      source_task_id: "B1.CFCI.3340"
    },
    {
      id: "d943c7b5-acce-473a-8da4-beb04f88b517",
      text: "Substation-2 - MSG A - Wire Pulls From Building MSG-1A/C",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 128,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4770"
    },
    {
      id: "b2ba9f8e-75f7-4ee7-af8b-48bf32b59331",
      text: "B1 - mCUP-1-9 - Piping supports install (layout and vendor submittal confirmation) - Sequence 1",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-03-07T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1050"
    },
    {
      id: "dcd6b39b-125c-4c22-a3c5-a20fb33c64e4",
      text: "BLDG-1/2 - Fabricate / Deliver - FSC Rough Carpentry (In Wall Backing / Blocking)",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 80,
      parent: "5595ffef-e80b-48c5-a708-7cfa3f4a69f4",
      progress: 0,
      source_task_id: "B1.CFCI.4760"
    },
    {
      id: "7693ecd2-83d3-4c81-9b3a-aca0b9b38525",
      text: "B2 - DH-C - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 40,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1260"
    },
    {
      id: "6a044aad-9d8a-442e-821c-1b34590dad07",
      text: "Substation-1 - MSG A - MV Terms / NETA Testing / Torques (Finish 03/01/25) - Sequence 2",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 72,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6240"
    },
    {
      id: "aea5adf7-42b7-4797-8acb-11c265d10913",
      text: "Substation-2 - B Lineup - Install Controls / Conduit / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 136,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4270"
    },
    {
      id: "40cb507e-a232-4245-9c4f-b4e33c805a68",
      text: "Area 3 - UG RI -Network Infrastructure Vaults-Campus",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 328,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1410"
    },
    {
      id: "4070e4e5-f57a-4d04-a48e-a1ca3f85bbb6",
      text: "B1 - ISP Cabling - E1 to E4 (UG)",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 40,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1120"
    },
    {
      id: "4edb0608-f719-4afb-a93a-30fe1ccd5592",
      text: "B1 - Network Rooms - Room Complete activities (ceiling tiles, devices, doors) (Converted to LOE)",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 344,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1910"
    },
    {
      id: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d",
      text: "BLDG-2 - BIM - Tier 0 - Area 2-C - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 240,
      parent: "2937029d-cba7-4fda-9df6-f78e0ca56c95",
      progress: 0,
      source_task_id: "B2.VDC.3140"
    },
    {
      id: "3c68d965-1728-459a-b168-1eb7d69bbb38",
      text: "CX Milestones",
      type: 5,
      start_date: "2025-07-01T08:00:00",
      end_date: "2027-03-09T08:00:00",
      duration: 3384,
      parent: "f49c2121-73ed-4027-ae56-8e5ab2a49dd4",
      progress: 0,
      source_task_id: "7995423"
    },
    {
      id: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 24,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1060"
    },
    {
      id: "cddcd329-46df-49f7-b6da-46c5973181e7",
      text: "BLDG-1/2 - Fabricate / Deliver - HVAC Materials and Equipment",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 40,
      parent: "eaf2f66d-62ed-4333-9656-a42c1e2ecb58",
      progress: 0,
      source_task_id: "B1.CFCI.3900"
    },
    {
      id: "196bce59-4015-4263-b7e2-99d94b7c87fa",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [7] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-24T08:00:00",
      duration: 2552,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.53,
      source_task_id: "B2.OFCI.2850"
    },
    {
      id: "e7d07b71-af42-40fe-aa10-005bdd1435f1",
      text: "B1 - SSB - Grout Column Basepates",
      type: 0,
      start_date: "2025-04-11T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 48,
      parent: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      progress: 0,
      source_task_id: "B1.C.STR.1710"
    },
    {
      id: "87080549-5452-4337-b77f-166e9d8d47fb",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [6] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 2512,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.54,
      source_task_id: "B2.OFCI.2840"
    },
    {
      id: "f7b8e85d-3861-4bab-afd0-eaa17c4aba0b",
      text: "B1 - 1D2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1920"
    },
    {
      id: "cbdc39e5-4638-45c4-8286-99c48b54ed18",
      text: "FR 07 - META/ EOR Review/ Answer RFI#14.1",
      type: 0,
      start_date: "2024-07-02T00:00:00",
      end_date: null,
      duration: 0,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 1,
      source_task_id: "FR.07.1020"
    },
    {
      id: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      text: "Foundations",
      type: 5,
      start_date: "2025-05-06T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 440,
      parent: "90dd9ead-7191-4d9c-9a21-ffd37897bf30",
      progress: 0,
      source_task_id: "7995102"
    },
    {
      id: "3a531dc2-39de-4500-b3cb-b9c0d4a4197b",
      text: "B2 - DH-C - Term Bussways - Data Hall C",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2340"
    },
    {
      id: "7dbf3131-183b-44a3-8a35-870b34f5b604",
      text: "Fab and Deliver - Assembled Skids - Area C - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 3464,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 0.31,
      source_task_id: "B2.OFCI.2300"
    },
    {
      id: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25",
      text: "B1 - DH-A - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 160,
      parent: "5fc606c5-5219-4322-9c84-02b4379f499d",
      progress: 0,
      source_task_id: "B1.C.A.2920"
    },
    {
      id: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      text: "(OFCI) B2 MVS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 2840,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.42,
      source_task_id: "7994950"
    },
    {
      id: "f71baf9f-5d37-4b9d-b671-701063a4441b",
      text: "Site / UG BIM - Phase-1,2,3  - DPR/Trades - Rcve Updated - Model - Civil & Structural Foundations Permit Set",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-22T08:00:00",
      duration: 40,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC2.1500"
    },
    {
      id: "b11ba658-a13a-4876-82e2-093cd17bfa4b",
      text: "IBOS - Fabricate / Deliver - Electrical Panel",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-01-31T08:00:00",
      duration: 720,
      parent: "c95dcc31-539f-443e-987b-e84c0c944d47",
      progress: 0,
      source_task_id: "IBOS.PROC.1020"
    },
    {
      id: "e6085549-a03f-45d5-a865-2a6f25e2ad64",
      text: "B2 - DH-B - Pull/Term Fire Alarm - Data Hall B",
      type: 0,
      start_date: "2026-05-22T00:00:00",
      end_date: "2026-06-19T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2770"
    },
    {
      id: "0d5fb6e9-958e-4eaa-9041-6c576b94f1b8",
      text: "Phase 1 - Final Clean/Completion",
      type: 0,
      start_date: "2026-09-22T00:00:00",
      end_date: "2026-10-05T08:00:00",
      duration: 80,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1050"
    },
    {
      id: "a998cea3-96e2-4ace-9d12-8825c1c7e686",
      text: "FR 16 - META review and Approve PCO#12",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "ad81c4ff-51ed-406e-85d5-a07e20bb8eca",
      progress: 0,
      source_task_id: "FR.16.1030"
    },
    {
      id: "b1ea3f9d-c3f8-4fc4-a876-14c3a22dd34b",
      text: "Final Clean",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1500"
    },
    {
      id: "8f8550d5-adb1-4f94-9660-07c4011a5c9d",
      text: "B1 - 1N1W - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-06-28T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5380"
    },
    {
      id: "b8a99b16-97da-4f37-bd19-f46b14a28fee",
      text: "B2 - DH-A - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2026-05-07T08:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 0,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2580"
    },
    {
      id: "e92b7494-9783-4351-9180-0e06f962291a",
      text: "Substation-2 - MSG A - Set / Temp Dry In / Temp Power / Site Acceptance Inspection",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 120,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4680"
    },
    {
      id: "b4ff44bd-e4f7-40eb-bc45-c40a8d28bef1",
      text: "B2 - DH-A - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 80,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1330"
    },
    {
      id: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      text: "Power Alley DH-A",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-03-28T08:00:00",
      duration: 672,
      parent: "8c6f09f2-2af7-4585-afeb-4a4318520839",
      progress: 0,
      source_task_id: "7995092"
    },
    {
      id: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      text: "Storage Racks",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 520,
      parent: null,
      progress: 0,
      source_task_id: "8717100"
    },
    {
      id: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      text: "Structure & Skin",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 1096,
      parent: null,
      progress: 0,
      source_task_id: "8243670"
    },
    {
      id: "044ae072-44c6-4509-8a58-95183679d878",
      text: "B2 - DH-B - Install Decking",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 80,
      parent: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      progress: 0,
      source_task_id: "B2.C.STR.1820"
    },
    {
      id: "f6ef28b7-7dae-4f1c-b7b7-b2efce52a5e1",
      text: "BLDG-1/2 - Prep / Submit for Review - Roofing",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: "2024-11-14T08:00:00",
      duration: 160,
      parent: "1cd8272e-8d86-4a77-881d-f6e520bf9689",
      progress: 0,
      source_task_id: "B1.CFCI.3710"
    },
    {
      id: "1f7c6c3d-39d3-4685-8566-fa5c50da80dc",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Equipment Controls Hookup",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 80,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1150"
    },
    {
      id: "06f1955d-b8cc-4d52-8f8c-2b391d36aed4",
      text: "FR 08 - META review and Approve PCO#4 (Final)",
      type: 0,
      start_date: "2024-11-07T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "FR.08.1070"
    },
    {
      id: "86efc612-6e21-491b-98fc-5aba04020712",
      text: "Hot Aisle Containment",
      type: 5,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 584,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994835"
    },
    {
      id: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      text: "Tier 0 - B1 - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994802"
    },
    {
      id: "e4652728-c076-442a-b3eb-842b636b01aa",
      text: "L3 Start EY2 - DCB2",
      type: 0,
      start_date: "2025-12-08T00:00:00",
      end_date: "2025-12-08T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2260"
    },
    {
      id: "c09e0bff-c30c-4d52-bba5-373a6bc4c8e0",
      text: "Mass Timber",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: null,
      duration: 816,
      parent: null,
      progress: 0.09,
      source_task_id: "8365698"
    },
    {
      id: "1039d9e5-5a59-40d1-ae52-e112475d85ca",
      text: "Meta Reviews / Authorizations",
      type: 5,
      start_date: "2024-02-27T00:00:00",
      end_date: "2024-04-01T00:00:00",
      duration: 192,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "7994737"
    },
    {
      id: "b9701809-7e9c-4111-a294-557fc71f28f7",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Specialities",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-04-02T08:00:00",
      duration: 120,
      parent: "f9e927ae-bef4-4c2f-a9d1-169a3df666a0",
      progress: 0,
      source_task_id: "B1.CFCI.5070"
    },
    {
      id: "a2e3a003-1bcb-4562-8df8-2e7430ab3b1c",
      text: "B2 - DH-A - Install IMP Walls @ FCAs - Data Hall A",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1910"
    },
    {
      id: "32883ebe-f080-4bda-87d1-297f4db60fed",
      text: "Install Pipe Rails / Bollards",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1030"
    },
    {
      id: "f5d1cc2d-788c-412d-966c-6e3467dd077d",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Equipment Controls Hookup",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 40,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1140"
    },
    {
      id: "2568e592-9dc2-4779-80d2-6f241fb4b713",
      text: "Install Plam Lockers",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1220"
    },
    {
      id: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      text: "Building IFP Issuance",
      type: 0,
      start_date: "2024-03-29T08:00:00",
      end_date: "2024-03-29T08:00:00",
      duration: 0,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.2320"
    },
    {
      id: "103d453d-71c2-478d-8784-d16e4da7814f",
      text: "B1 - SSB - 1E1 - GSMDF1 - Terms for Lighting/Outlet/Racks",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 24,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1680"
    },
    {
      id: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb",
      text: "L4 - B2 SSB",
      type: 0,
      start_date: "2026-09-16T00:00:00",
      end_date: "2026-10-13T08:00:00",
      duration: 160,
      parent: "c43469b5-604f-43d2-a57c-6ea44c4b7184",
      progress: 0,
      source_task_id: "CX4.B2.SSB.1000"
    },
    {
      id: "748c5257-670d-4aaf-b781-e49f2afda907",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 24,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1820"
    },
    {
      id: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      text: "B1 - SSB - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1060"
    },
    {
      id: "eea96588-e7a0-4154-b8e1-8832accf4710",
      text: "L5 - B2 DHB",
      type: 0,
      start_date: "2027-01-07T00:00:00",
      end_date: "2027-01-08T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHB.1000"
    },
    {
      id: "2bb21ad4-1097-4a0f-bf4a-4232499840cc",
      text: "Data Hall A & B Electrical Yard",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "0277d7b3-e3a7-42c6-9996-54bcc49d9eab",
      progress: 0,
      source_task_id: "7995015"
    },
    {
      id: "2f354b34-527d-454d-af35-90a6bf49eb51",
      text: "Patch Back Drywall at Door Frames",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1540"
    },
    {
      id: "ca84b945-82b2-497a-981a-c7717da076e4",
      text: "Power Alley DH-C",
      type: 5,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 600,
      parent: "3750cb98-03f6-4090-9afc-515a595e07ff",
      progress: 0,
      source_task_id: "7995037"
    },
    {
      id: "b5042521-6d1c-4384-938b-98120cdd8b82",
      text: "B1 - mCUP-5 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 48,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5040"
    },
    {
      id: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      text: "Cx NS + SSB",
      type: 5,
      start_date: "2026-01-12T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 1000,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995009"
    },
    {
      id: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      text: "GS.IDF.2B1",
      type: 5,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 736,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "7995077"
    },
    {
      id: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      text: "Tier 1 - B1- Core / Shell",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994794"
    },
    {
      id: "24863dfe-d7ae-4f84-96f4-e673d296c1df",
      text: "Deep Underground - Plumbing",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 80,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1100"
    },
    {
      id: "26f725df-35d7-46e9-ad96-8ea50c860f96",
      text: "(OFCI) B2 Make Up Water Module",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0,
      source_task_id: "7994947"
    },
    {
      id: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 432,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995387"
    },
    {
      id: "d355d351-0f18-46b2-8ec1-7f3583a0d534",
      text: "Tier 1 - B1-1-E - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994796"
    },
    {
      id: "ac667a33-808a-4c93-9c98-e6d2b0673d1d",
      text: "Cx Fire Pump House",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995007"
    },
    {
      id: "49328ad0-f768-48ec-88af-3d47e88adfaf",
      text: "Tier 2, 3, 4 - B1-1-B",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994791"
    },
    {
      id: "0fbbf7fa-904a-48e8-8721-806fbcb106b9",
      text: "Hardscape",
      type: 5,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 864,
      parent: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      progress: 0,
      source_task_id: "7995204"
    },
    {
      id: "7c92f19c-97f6-4a6c-9a12-34151bbb5af1",
      text: "Non-Critical Power (NCP)",
      type: 5,
      start_date: "2025-02-26T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 104,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995187"
    },
    {
      id: "1f29b023-e838-4ea5-a260-5a334599acc4",
      text: "Area B - Resinous Floor Install + Cure",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 64,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1400"
    },
    {
      id: "de0fc433-7024-4b0f-9e68-6ca0cea5c6f4",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "52d3af53-0515-442d-ae0a-d5ea0b3f489e",
      progress: 0,
      source_task_id: "MECO-1140.60"
    },
    {
      id: "e81dfe27-6de2-426d-a9e9-d3d1748ffe89",
      text: "B1 - DH-B - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 120,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1060"
    },
    {
      id: "f453b346-22b9-4b8c-b610-24c5e4675f62",
      text: "L3 Start DH D - DCB1",
      type: 0,
      start_date: "2026-05-12T00:00:00",
      end_date: "2026-05-12T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2032"
    },
    {
      id: "5d3a19c5-d4e1-4a90-96f9-07c0680d96e0",
      text: "Submit Documentation for Civil & Foundations Permits",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-18T00:00:00",
      duration: 0,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 1,
      source_task_id: "ICM.PRE.1210"
    },
    {
      id: "667c27ca-08fb-4433-a08b-d330c1dbd5f4",
      text: "B1 - mCUP-1-9 - L2 Checkout of Pumps/Chillers and MSB Building 1",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 80,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1180"
    },
    {
      id: "08917008-e1c9-48c8-8227-78c765e3437b",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Struc. Conc. (SOG/SOMD/Pads Ready Mix)",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2024-10-31T08:00:00",
      duration: 80,
      parent: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      progress: 0,
      source_task_id: "B1.CFCI.1040"
    },
    {
      id: "7b0e93dc-5be2-422f-961a-7dd30d4fb697",
      text: "UG RI -Rack Bus-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 120,
      parent: "61eca0ba-60c7-4050-b050-569ff6de0dca",
      progress: 0,
      source_task_id: "MECO-1740.30"
    },
    {
      id: "7a11ce6d-def7-457d-91da-6bce021387f6",
      text: "Area 4 - UG RI -UPS system-DCB2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1760"
    },
    {
      id: "6e56d5bb-c252-430d-819c-d1df001df08c",
      text: "Corridor 2B1",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 976,
      parent: "7fe3a5d1-a6b7-41c5-83a0-318c9b9a3548",
      progress: 0,
      source_task_id: "7995076"
    },
    {
      id: "70094d4e-f7bd-413a-9caf-a73bb1031c7f",
      text: "B1 - DH-B - Install BMS Conduit -Data Hall B",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2690"
    },
    {
      id: "37ce2097-b79f-4202-888a-e2567ba22652",
      text: "B2 - SSB - 2E2 - Common - Install Porcelain Tile",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1780"
    },
    {
      id: "0a1468d6-af14-4368-bf7a-778b22713dd5",
      text: "B2 - mCUP-8 - L2 Inspections",
      type: 0,
      start_date: "2026-02-10T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 80,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8150"
    },
    {
      id: "e0306b80-1005-4076-8974-2fe1bf17eebd",
      text: "B2 - DH-B - L2 CDU Install Verification - Data Hall B",
      type: 0,
      start_date: "2026-05-06T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 144,
      parent: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      progress: 0,
      source_task_id: "B2.C.B.3240"
    },
    {
      id: "86890de1-e223-4c86-b288-11a6d50d3e9e",
      text: "B1 - mCUP-1-9 - Piping POC's, Devices, final dress out (Fill and Flush Building) (sequence 2)",
      type: 0,
      start_date: "2025-10-02T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1170"
    },
    {
      id: "9847c9f6-4b09-424c-bd7f-3e151fe084b9",
      text: "FR 05 - Issue - Substation design Coordination",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: null,
      duration: 72,
      parent: null,
      progress: 1,
      source_task_id: "FR.05.1015"
    },
    {
      id: "814fca88-0179-4f5a-bd8c-e1a9aed498f6",
      text: "B1 - DH-C - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 80,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1100"
    },
    {
      id: "4cb4ee67-ae43-423f-b23c-0b9fbec64286",
      text: "B1 - mCUP-4 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 48,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4000"
    },
    {
      id: "3af97ea3-28f6-4c3b-b276-d7c1b252861f",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2010"
    },
    {
      id: "d87c40c9-36ba-466e-9282-c17bb73cf6fe",
      text: "BLDG-2 SSB",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 200,
      parent: null,
      progress: 0,
      source_task_id: "8444266"
    },
    {
      id: "18d9b5c5-878c-4c27-a7b6-efbfefe56387",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 80,
      parent: "7ff8625a-dc89-41f6-8d33-dd61dacc1595",
      progress: 0,
      source_task_id: "MECO-1130.40"
    },
    {
      id: "e96a584d-ee96-4a5e-91f0-efee1a23481b",
      text: "B1 - DH-B - Install Underground Controls",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1550"
    },
    {
      id: "6555168b-5348-47cf-96a4-00868784ed13",
      text: "Delivery of DES Data Hall Electrical Room Skid (First Delivery) - DCB2",
      type: 0,
      start_date: "2026-01-21T08:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1840"
    },
    {
      id: "446db9ae-f692-47fb-ba0c-619dbb8c0ccf",
      text: "B2 - 2C1 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 80,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1550"
    },
    {
      id: "b3e8ea87-0f85-4041-be0f-7a2fe89a3c0a",
      text: "BLDG-1/2 - Fabricate / Deliver Joists",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 800,
      parent: "b4e5b7c9-5a36-4201-8305-5ac89568c3ba",
      progress: 0,
      source_task_id: "B1.CFCI.3960"
    },
    {
      id: "1d5435d0-cb94-4f72-81de-1960af236461",
      text: "BLDG-1 SSB",
      type: 5,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 216,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995402"
    },
    {
      id: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 312,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995378"
    },
    {
      id: "aa71d951-ed8c-41b4-9322-401064634cc6",
      text: "B1 - Network Room 2/3 - FCA Gallery - Facilty Water Install - [06.MTR-19-02,04,06,08] - [06.MTR-20-02,04,06,08]",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 96,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1340"
    },
    {
      id: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      text: "BLDG-1 Network",
      type: 5,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 936,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "7995255"
    },
    {
      id: "793df7df-1822-43b3-869a-eb19322f41ff",
      text: "B2 - DH-D - Prime and 1st Coat",
      type: 0,
      start_date: "2026-04-01T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 40,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1540"
    },
    {
      id: "92aa8a33-1e8a-4967-95ad-e4391a98b9cd",
      text: "BLDG-1 Network",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444258"
    },
    {
      id: "45fde9bd-5bbd-49bb-b65b-333d8afc29fd",
      text: "B2 - mCUP-1-8 - Piping supports install (layout and vendor submittal confirmation) (Sequence1)",
      type: 0,
      start_date: "2025-04-28T00:00:00",
      end_date: "2025-05-20T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1040"
    },
    {
      id: "63793101-e14b-4321-a459-422912adc441",
      text: "B2 - DH-C - Pull Feeders Bussways - Data Hall C",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2370"
    },
    {
      id: "f3e9743e-1bef-4a48-9485-6165fb6f4ea8",
      text: "B2 - DH-B - Lightning Protection",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B2.C.RF.1420"
    },
    {
      id: "aaf377c8-e087-4ad1-b7b3-39b23fec96e4",
      text: "IST Finish DH A - DCB1",
      type: 0,
      start_date: "2026-06-15T08:00:00",
      end_date: "2026-06-15T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2155"
    },
    {
      id: "9739d4da-62ba-46b1-9275-4f14829a2a03",
      text: "Admin - Fabricate / Deliver - Roofing",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: null,
      duration: 680,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1120"
    },
    {
      id: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      text: "Roofing",
      type: 5,
      start_date: "2025-10-13T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 936,
      parent: "6f8a9cb3-e013-459d-bc9e-aadfcae5194d",
      progress: 0,
      source_task_id: "7995111"
    },
    {
      id: "681ea9f6-786d-48c6-8192-720a90052a9a",
      text: "B1 - Network - Foundations",
      type: 0,
      start_date: "2025-01-24T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 80,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1020"
    },
    {
      id: "5ab088ec-b661-4d5b-8f6c-0aa2f20d01ba",
      text: "FR 40 - DPR Miller Prepare and Submit Submittal Tier-0 (underslb)",
      type: 0,
      start_date: "2024-12-06T00:00:00",
      end_date: null,
      duration: 80,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1050"
    },
    {
      id: "7cd6f5d5-ca06-491a-8148-996966549f81",
      text: "UPS Room 01N4.06",
      type: 5,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 480,
      parent: "e2a25521-eed0-4f3c-a501-f360cf914f24",
      progress: 0,
      source_task_id: "7995344"
    },
    {
      id: "e1392704-f364-4109-8976-104f9208353e",
      text: "OH Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1190"
    },
    {
      id: "450e7e94-6054-44b6-b556-c3c644e90ee4",
      text: "Finished Carpentry (Millwork/Tops)",
      type: 5,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 520,
      parent: "db0dda39-b5f6-4804-bd6f-fa2f5ef3ea3a",
      progress: 0,
      source_task_id: "7994892"
    },
    {
      id: "f99e57c9-ea00-4656-847e-0f3ca7bacc96",
      text: "B1 - 1C1W - 01C.07 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1790"
    },
    {
      id: "12a82b4e-cf6a-4cc8-b0da-a797f901af7c",
      text: "Sanitary Sewer force main ( Including ARV's)",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-03T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8180"
    },
    {
      id: "2e530ff9-2920-45b3-811c-203001222f49",
      text: "BLDG-1/2 - Fabricate / Deliver - Interior Expansion Joints (Spec 07 95 13.13)",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 480,
      parent: "f068736c-3c4a-473c-8c98-6ef859973fe0",
      progress: 0,
      source_task_id: "B1.CFCI.5130"
    },
    {
      id: "8abf03f9-5e78-404b-a8c3-388a1010400a",
      text: "B1 - mCUP-1 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1270"
    },
    {
      id: "6cbfcb39-0259-4bd9-b4ac-b08d35a87371",
      text: "B1 - DH-C - Install IMP Walls @ FCAs - Data Hall C",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2140"
    },
    {
      id: "b0c19626-3c01-4217-a9a3-046ef7fc1609",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 160,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6180"
    },
    {
      id: "7e745a24-1acd-4964-a8c4-be98686c3c6f",
      text: "B2 - SSB - Install Joists",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 80,
      parent: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      progress: 0,
      source_task_id: "B2.C.STR.1620"
    },
    {
      id: "82b868f8-d095-4060-813a-8059a48e1dc6",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2140"
    },
    {
      id: "83f1bd96-7269-4687-8cd4-2e2f38661a53",
      text: "B2 - 2B1 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1490"
    },
    {
      id: "99c03453-6452-4bb4-9fe6-6be008a5da2a",
      text: "B2 - DH-B - Install Celing Devices Security - Data Hall B",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2810"
    },
    {
      id: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe",
      text: "PHASE IBOS Substantial completion",
      type: 0,
      start_date: "2026-03-12T08:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.IB.1030"
    },
    {
      id: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      text: "B1 - DH-C - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 120,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1380"
    },
    {
      id: "3d951beb-f294-4941-98f2-8021c08f4840",
      text: "FR 31 - META review and respond to RFI #85",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "955aa671-6b4b-4034-bf88-d03902dbaf4e",
      progress: 1,
      source_task_id: "FR.31.1010"
    },
    {
      id: "2a878bec-7ca6-4fe7-a4c7-905c7ef582a2",
      text: "Paint Plywood",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 16,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1020"
    },
    {
      id: "2937029d-cba7-4fda-9df6-f78e0ca56c95",
      text: "Data Hall C (Area 2-C)",
      type: 5,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 760,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994784"
    },
    {
      id: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      text: "B1 - Network Room 2/3 - OH Rough In Inspections",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2030"
    },
    {
      id: "4bc91bad-f5b9-4da0-9eff-002f2ff6cedc",
      text: "CDU - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-03-13T08:00:00",
      duration: 144,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 1,
      source_task_id: "B2.OFCI.1270"
    },
    {
      id: "5937c2df-e534-4850-82fe-c3d7b9e59cef",
      text: "Weather Impacts (Critical)",
      type: 5,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-06T08:00:00",
      duration: 0,
      parent: "d4c3414c-f65e-4c55-8de4-d21b47508c37",
      progress: 0,
      source_task_id: "7995416"
    },
    {
      id: "1c543080-2ce6-46a7-b9a0-852ddc8a5be2",
      text: "Underground Utilities - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1050"
    },
    {
      id: "de12af0e-eb14-45e2-9d7e-1d3ef063f4a2",
      text: "B1 - mCUP-4 - Install FA  (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4110"
    },
    {
      id: "9c478c7b-64ca-4d18-8d48-2710b79dbb3e",
      text: "B1 - DH-D - Set HACs in Place - Data Hall D - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1140"
    },
    {
      id: "217c98f3-fb71-4a2e-bfaa-1acfcab44f02",
      text: "B2 - SSB - 2E2 - Common - Install Cable Tray",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1690"
    },
    {
      id: "0a34b3cf-89ab-43a2-816d-e2904a5a5352",
      text: "BLDG-1/2 - Fabricate / Deliver - Exterior Metal Panels",
      type: 0,
      start_date: "2024-12-18T00:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 480,
      parent: "e5d09a46-f2b1-4c5b-9af3-33b40223faef",
      progress: 0,
      source_task_id: "B1.CFCI.4100"
    },
    {
      id: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      text: "Area 1 - Storm Install",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: "2024-09-17T08:00:00",
      duration: 264,
      parent: "6b8898ee-f9e1-43c4-b521-2a4715747f84",
      progress: 0,
      source_task_id: "C.CSU.A1.3000"
    },
    {
      id: "5ea60c67-1b51-462d-a6ac-7b9c426e709b",
      text: "Exterior Canopy Gutter / Flashing",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 40,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1170"
    },
    {
      id: "bc20f290-9a5a-42e2-8714-d79834e4e626",
      text: "B2 - SSB - Install Underground Security",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1140"
    },
    {
      id: "196cfaca-bd4e-4480-9e78-6270b31337f0",
      text: "BLDG-1/2 - Prep / Submit for Review - Porcelain Tiling",
      type: 0,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 160,
      parent: "1199aed8-9a5c-4ba9-b5a4-fd27806e7d1d",
      progress: 0,
      source_task_id: "B1.CFCI.4660"
    },
    {
      id: "ae895390-9721-49b3-a0dc-a8fb8392ec80",
      text: "B2 - DH-D - Install Cable Tray - Data Hall D",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2190"
    },
    {
      id: "0e9931e1-320e-4766-9831-2835a4254660",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1530"
    },
    {
      id: "48c1bfa2-0931-4b2f-b187-1675bded97af",
      text: "FR 28 - META issue CSI #12",
      type: 0,
      start_date: "2024-08-25T00:00:00",
      end_date: null,
      duration: 0,
      parent: "1076d022-f279-458e-8e6f-47edee4227c2",
      progress: 1,
      source_task_id: "FR.28.1000"
    },
    {
      id: "734e9261-e49a-48e8-bbc9-f2b6165c342a",
      text: "B2 - 2E1E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 80,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5170"
    },
    {
      id: "56854466-7380-4fe7-aef0-c48550ba66ca",
      text: "B1 - 1D1W - 01D.08 - Lighting and Devices",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2580"
    },
    {
      id: "9b419884-ac6d-4c1f-9dda-375d0a487a3d",
      text: "B1 - DH-B - L2 CDU Install Verification - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 144,
      parent: "3d507b23-1be2-4905-a76c-b9aeff9a12e5",
      progress: 0,
      source_task_id: "B1.C.B.3240"
    },
    {
      id: "a1319814-a9bd-433f-a01e-23b0901c449b",
      text: "B2 - 2E1E - 02.01.E1.05 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5450"
    },
    {
      id: "f6715ee0-5b75-4ccd-823f-44d508bd40a1",
      text: "B1 - SSB - 1E2 - EF2 - Pull Wire for Lighting/Outlet/Racks (EF2)",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 24,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1890"
    },
    {
      id: "1da1079c-3fca-4aba-89b5-cd3b2301e2f7",
      text: "B2 - DH-D - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 40,
      parent: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      progress: 0,
      source_task_id: "B2.C.STR.2130"
    },
    {
      id: "4c488272-6226-418b-9d05-ea836ba039f3",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [3] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-05-19T08:00:00",
      duration: 2832,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.35,
      source_task_id: "B1.OFCI.3660"
    },
    {
      id: "7c78cffd-2045-43ec-9f45-0c3c78fa6768",
      text: "B1 - SSB - 1E2 - EF2 - Terms for Lighting/Outlet/Racks (EF2)",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 24,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1940"
    },
    {
      id: "e5cac6ba-7547-482d-92aa-035ba395db61",
      text: "B1 - mCUP-1 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1230"
    },
    {
      id: "d3947ced-e5aa-4d96-8db0-0a1574e24fac",
      text: "B1 - 1B2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1080"
    },
    {
      id: "2b0b473c-aa85-4f16-99eb-b072b2431167",
      text: "Area 2 - MV Electric Install - Remaining (EY into ER)",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 96,
      parent: "e9121d38-8b51-410e-9ddc-f5da5b002722",
      progress: 0,
      source_task_id: "C.CSU.A2.8050"
    },
    {
      id: "68e26ec3-52ca-47f6-b3d9-1bdf7676bafe",
      text: "Delivery of HAC - Hot Aisle Containment (First Delivery) - DCB2",
      type: 0,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1845"
    },
    {
      id: "96b9cfa7-1185-46b0-ae0d-669f51d859f9",
      text: "L3 Start Admin - DCB1",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-13T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2045"
    },
    {
      id: "5e04f777-0c94-4352-9071-a8117516bb4a",
      text: "DFSMA - DC2 DHB HAC ROJ - MOFE",
      type: 0,
      start_date: "2026-03-26T08:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 0,
      parent: "f0d9ef4f-191d-4d39-9779-5b0274a8fb64",
      progress: 0,
      source_task_id: "B2.DFSMA.1060"
    },
    {
      id: "a3dce638-39dc-481f-839b-b9cf22d8c39b",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [5] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 3176,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.37,
      source_task_id: "B2.OFCI.2900"
    },
    {
      id: "4e41781d-3b60-401b-807d-2741cb0cc5c5",
      text: "B2 - mCUP-1 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 48,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1200"
    },
    {
      id: "4a5ade5f-273d-4b6c-a146-c35f43d43515",
      text: "Area A - Install Doors / Hardware",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 16,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1311"
    },
    {
      id: "7399a800-e9a3-4edf-b0c7-4b2a0a775252",
      text: "B1 - DH-A - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 40,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1790"
    },
    {
      id: "030e073a-2b5b-4a22-ab03-3fdea7dce7da",
      text: "B1 - DH-B - Grout Column Baseplates",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 48,
      parent: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      progress: 0,
      source_task_id: "B1.C.STR.2110"
    },
    {
      id: "3e28be71-2de3-4166-9221-b89e63cb0544",
      text: "B1 - 1N1E - EF4 - Pull Wire for Lighting/Outlet/Racks (EF4)",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 24,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5830"
    },
    {
      id: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5",
      text: "B1 - SSB - 1E1 - GSMDF1 - Setting and hookup GS-MDF Skid - [11.MDF-01-00]",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-08T08:00:00",
      duration: 72,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "B1.C.SSB.1270"
    },
    {
      id: "c4501e92-11f3-4b76-b3e7-99462480111e",
      text: "Generators - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "eb3ea98a-2cf4-45ea-aad1-d7789c9747d1",
      progress: 1,
      source_task_id: "B1.OFCI.1510"
    },
    {
      id: "29feba74-9b96-4c8d-b52c-e77c234ed3ba",
      text: "B2 - DH-C - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2026-05-04T00:00:00",
      end_date: "2026-05-15T08:00:00",
      duration: 80,
      parent: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      progress: 0,
      source_task_id: "B2.C.EY.1610"
    },
    {
      id: "12a7a55e-3344-4ec1-9751-a922c8a2ba50",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2240"
    },
    {
      id: "082579cd-1314-4a33-a310-f58092660932",
      text: "B1 - 1N2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6140"
    },
    {
      id: "ce60ea35-b881-429a-b6ce-44412076bd61",
      text: "L4 Finish DH C - DCB1",
      type: 0,
      start_date: "2026-08-04T08:00:00",
      end_date: "2026-08-04T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2111"
    },
    {
      id: "daf3fc35-13f6-4999-9921-45e66e1700e8",
      text: "[DCB2] DEC-C Ready: General Services [Area D]",
      type: 0,
      start_date: "2026-08-07T08:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 0,
      parent: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      progress: 0,
      source_task_id: "ICM.B2.3755"
    },
    {
      id: "db2e9e89-180f-4675-9000-19af8c9e6c88",
      text: "B2 - mCUP-3 - Setting and Hookup of GS-IDF Hut (2X3)",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 80,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.C.EY.1810"
    },
    {
      id: "694dcc4a-f9d3-47e8-8338-7243718f087f",
      text: "BLDG-1/2 - Fabricate / Deliver - Fire Alarm",
      type: 0,
      start_date: "2025-02-18T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 320,
      parent: "aaa537e7-583e-4d33-ad14-d873dded0a6d",
      progress: 0,
      source_task_id: "B1.CFCI.5090"
    },
    {
      id: "d61c7d94-473f-4af5-8073-5e188677495f",
      text: "Electrical Preconstruction Services LNTP - Meta Review / Authorization",
      type: 0,
      start_date: "2024-02-27T00:00:00",
      end_date: "2024-03-11T08:00:00",
      duration: 80,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "PRE1380"
    },
    {
      id: "307c9bdc-11aa-430f-855c-ae0468bb9bd5",
      text: "B1 - 1N1E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 120,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6190"
    },
    {
      id: "8be16ed7-bd51-42b7-b2c7-40c5e80f3099",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area NW-2/3 (16) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 2344,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.43,
      source_task_id: "B1.OFCI.2200"
    },
    {
      id: "a42610ba-a51a-44e6-9991-c6c0975022bb",
      text: "B1 - mCUP-1 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1300"
    },
    {
      id: "c2b6cea0-6c62-423b-9336-3310c552a409",
      text: "Phase 1 Logistic Work",
      type: 5,
      start_date: "2025-04-16T08:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 0,
      parent: "fe99c54f-c538-4ad6-92f9-d75f5a4477c2",
      progress: 0,
      source_task_id: "7995200"
    },
    {
      id: "95c3937e-7cb7-4e72-afd0-9ddaa5348180",
      text: "Substantial Completion-No Weather - Bldg 1 - DH C",
      type: 0,
      start_date: "2026-09-01T08:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B1.MIL.1100"
    },
    {
      id: "e4d6202c-6833-48bb-8689-886f43de0dff",
      text: "DFSMA - DC1 - CUP 9- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-09-03T08:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1310"
    },
    {
      id: "b5935d97-c1ba-4de7-8191-fdf6e338c173",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Security",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1040"
    },
    {
      id: "05844c7d-896c-4a81-8914-4abaad03a157",
      text: "B2 - 2A1 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1190"
    },
    {
      id: "a25255f9-5a0e-484f-b4b1-bd95f214fa7f",
      text: "B2 - DH-A - Install Door/Hardware/ Wall Trim - Data Hall A",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2680"
    },
    {
      id: "145fb35d-9191-4ce2-bf5e-a0d5629bf5eb",
      text: "B1 - mCUP-3 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3110"
    },
    {
      id: "71457749-85f8-44fd-a3d0-0c22f531884b",
      text: "B1 - mCUP-3 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3120"
    },
    {
      id: "61e6b9a3-bc28-4d7c-bef3-e90de2d417c0",
      text: "Substation-1 - Pull and Term Substation to MSG Building 1 A/C (Pull to Vaults) - Sequence 2",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 160,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "B1.C.EY.1040"
    },
    {
      id: "6335258a-85e5-4d7a-a733-6de7b21846ec",
      text: "Precast Area A",
      type: 5,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "7995024"
    },
    {
      id: "10dbb8d9-5c42-4ec4-871a-d221c1819aa0",
      text: "B1 - 1N2W - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2260"
    },
    {
      id: "3168085d-bb13-4edb-98aa-a51da6c4ae70",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Finished Carpentry (FRP)",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 120,
      parent: "fadc8646-4b3d-42bf-ba2e-1d5f36c3c8bc",
      progress: 0,
      source_task_id: "B1.CFCI.4980"
    },
    {
      id: "9eadae9a-d784-4a8c-9fa4-4f858f2d7804",
      text: "ADMIN/ IBOS  - Submittal Rvw/App'l - Fire Suppression (AHJ)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6530"
    },
    {
      id: "12776a45-9909-4c8a-8258-6a75b852bdba",
      text: "B2 - mCUP-4 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.8190"
    },
    {
      id: "d5d6cbd4-6947-4f38-8090-5b0d7ac78bbe",
      text: "Area 4 - Mass Grading - Remainder Post Permit Delay",
      type: 0,
      start_date: "2024-12-19T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A4.8040"
    },
    {
      id: "a9ca1925-4d3f-468a-9607-35fe07b468fb",
      text: "B1 - 1N2E - 01N3.06 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6040"
    },
    {
      id: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      text: "GS.IDF.1D1",
      type: 5,
      start_date: "2025-10-08T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 736,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "7995321"
    },
    {
      id: "71d10656-f648-4453-bdd4-cdc3a3406072",
      text: "B2 - mCUP-1-8 - Piping Install (Header UG to Building)",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2025-01-03T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1080"
    },
    {
      id: "b39c9f8d-7751-4653-9c9e-10a67a62b0cb",
      text: "Area A - OH Plumbing - Open Areas",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1051"
    },
    {
      id: "b4cd0bf7-ef1f-4b1c-bb41-7bbf2236a0eb",
      text: "Issue Bid Package List with Subcontractors & Meta Approval",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2023-12-08T00:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1370"
    },
    {
      id: "9e1619a8-1257-4158-827c-4cd9510b5544",
      text: "Earthwork SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-03T08:00:00",
      duration: 104,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 1,
      source_task_id: "PRE1720"
    },
    {
      id: "2e32a68d-78f9-47ca-a027-d03fa9eeb7cb",
      text: "Tier 1 - B2-2-E - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994776"
    },
    {
      id: "32b33467-1611-40e9-bc96-46384d8c1eaa",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2030"
    },
    {
      id: "11d7d8f3-192b-48e0-a965-b2bc2099ba7e",
      text: "B1 - DH-D - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 40,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1570"
    },
    {
      id: "94b778f5-3fd0-4108-9900-4bc4bf597151",
      text: "B2 - DH-A - L2 CDU Pre-Eng Inspection - Data Hall A",
      type: 0,
      start_date: "2026-04-01T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 144,
      parent: "560c76d0-46ee-4116-9c68-58099187fdb2",
      progress: 0,
      source_task_id: "B2.C.A.3210"
    },
    {
      id: "4aef762f-166e-412d-b1d3-51be4aeddccf",
      text: "Substructure - Admin (LOE)",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-02-19T08:00:00",
      duration: 480,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1000"
    },
    {
      id: "ab0f24d8-ea95-4882-bd0e-dd47c6396a3f",
      text: "IST Start Network Core - DCB1",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-04-24T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2160"
    },
    {
      id: "7c9a664d-2bb9-40a6-aedd-590cf3098c75",
      text: "DCB1 EY1 Ready for Energization - DCB1",
      type: 0,
      start_date: "2026-01-08T08:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1116"
    },
    {
      id: "243331d7-08a6-44da-9d57-491ac509deba",
      text: "B1 - DH-C - Install Celing Devices Fire Protection - Data Hall C",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2590"
    },
    {
      id: "1998b076-f4b5-44a4-96c6-02088efd7891",
      text: "B2 - DH-B - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 80,
      parent: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      progress: 0,
      source_task_id: "B2.C.EY.1560"
    },
    {
      id: "94561b30-dd39-4260-ba38-3600e1e60cf7",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Equipment Elec Hookup",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 40,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1120"
    },
    {
      id: "1b878e85-d299-47c9-8c74-bb2866221890",
      text: "Meta Review & Comment - Baseline 1",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2023-12-18T08:00:00",
      duration: 88,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1200"
    },
    {
      id: "e1e3094f-a301-4f4f-a2c2-92a85aabecee",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2230"
    },
    {
      id: "8c5ec9b4-0ed6-4c34-83f2-4621a41da10c",
      text: "B1 - 1C2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 24,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1700"
    },
    {
      id: "0d1da365-82c9-4a4c-9a83-a68979c5a5c6",
      text: "DFSMA - DC2 - CUP 3- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-10-13T08:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1270"
    },
    {
      id: "c9289783-221d-4133-8480-d1af0a8f4606",
      text: "Plumbing Rough-In",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1030"
    },
    {
      id: "fadc8646-4b3d-42bf-ba2e-1d5f36c3c8bc",
      text: "FRP [Hallways]",
      type: 5,
      start_date: "2025-06-23T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 520,
      parent: "db0dda39-b5f6-4804-bd6f-fa2f5ef3ea3a",
      progress: 0,
      source_task_id: "7994890"
    },
    {
      id: "d517dea9-ead9-4174-b1ea-660298bde894",
      text: "L4 - B1 DHA - Server Migration",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-15T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHA.1010"
    },
    {
      id: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402",
      text: "B1 - OSP Cabling - EF to GSIDF 1X3",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "85391fcf-fbdc-4cfe-b101-e86ca0d8bff2",
      progress: 0,
      source_task_id: "B1.CONN.1030"
    },
    {
      id: "c16ea63a-b9ec-4525-ab5b-97b4e455f9c4",
      text: "B2 - DH-B - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 120,
      parent: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      progress: 0,
      source_task_id: "B2.C.STR.2160"
    },
    {
      id: "798e6053-4095-4d32-abe0-3e15913219d5",
      text: "B2 - 2E1E - 02.01.E1.01 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5380"
    },
    {
      id: "02e67765-effe-4ffe-b04e-8b33c670413e",
      text: "Local AHJ Review/Approval/Approval Letter - DHEC",
      type: 0,
      start_date: "2024-03-20T00:00:00",
      end_date: "2024-03-28T00:00:00",
      duration: 64,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "PRE-DD-1130"
    },
    {
      id: "17670139-3138-4fa5-a7cb-2096b7544123",
      text: "B2 - 2C2 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1260"
    },
    {
      id: "0b934af1-dcd1-4172-97ef-4396b6e6bd4c",
      text: "B1 - Network - Grout Column Baseplates",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 48,
      parent: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      progress: 0,
      source_task_id: "B1.C.STR.1900"
    },
    {
      id: "3d974720-d6b4-46dc-8833-6ace68fc4ff1",
      text: "B1 - SSB - Roofing (Converted to LOE) (8/20 - add lightning protection)",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 120,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1040"
    },
    {
      id: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d",
      text: "Substation-1 - A Lineup - MOAB Assembly / inspections",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 24,
      parent: "ad9bcc69-2423-47a9-879e-e48510c33ecb",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6220"
    },
    {
      id: "c49c78bb-12c0-469f-9703-150af487655a",
      text: "B1 - 1N1W - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 120,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5980"
    },
    {
      id: "28b639e4-8219-4846-9660-222d96e37b8e",
      text: "IST Finish DH C - DCB1",
      type: 0,
      start_date: "2026-08-10T08:00:00",
      end_date: "2026-08-10T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2175"
    },
    {
      id: "e9fca328-f40c-430e-84ec-e9bf11c50e4b",
      text: "Site - Earthwork/ Utilities SA - Meta Authorized",
      type: 0,
      start_date: "2024-04-09T08:00:00",
      end_date: "2024-04-09T08:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "ICM.PRE.1410"
    },
    {
      id: "8e4bd1c0-0282-4fa6-ad81-b95e28d56ae4",
      text: "Install U/G - Electrical",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1020"
    },
    {
      id: "51b50315-5c42-4877-9236-957ca2e7a361",
      text: "Fab and Deliver - MVS-5WAY - Area D (2) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 2448,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0,
      source_task_id: "B1.OFCI.2560"
    },
    {
      id: "313067ee-9a0b-46a8-9653-1002e5481ee9",
      text: "B2 - 2E1E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5090"
    },
    {
      id: "b00bb5cb-a037-487d-a554-e78fde91b896",
      text: "B2 - DH-D - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 200,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1620"
    },
    {
      id: "f7ff0818-aa27-46f3-b0d1-bfeff763e5c3",
      text: "B1 - DH-A - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 40,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1300"
    },
    {
      id: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      text: "BLDG-1 DH-C ElectricalTerms",
      type: 5,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 400,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "7995260"
    },
    {
      id: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      text: "L5 - B1 DHB",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHB.1000"
    },
    {
      id: "4c20d981-76ae-4733-a74f-d28eada76950",
      text: "B1 - RF-Tower-1 - Equipment Set-  Mast/Tower",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 120,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2220"
    },
    {
      id: "10155cf9-9391-4881-a0b2-bfae4089309e",
      text: "B1 - DH-B - El Equip Yd - Buildout MSG and Set-In Place Inspections",
      type: 0,
      start_date: "2025-06-28T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 80,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3020"
    },
    {
      id: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658",
      text: "B1 - DH-C - Install Decking",
      type: 0,
      start_date: "2025-06-14T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 80,
      parent: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      progress: 0,
      source_task_id: "B1.C.STR.2180"
    },
    {
      id: "1332df75-3750-4cb1-bb9a-f0ed61683248",
      text: "B1 - SSB - 1E2 - Common - Complete Interior Build-Out (DEC-C Ready)",
      type: 0,
      start_date: "2025-12-04T08:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 0,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2510"
    },
    {
      id: "bee61510-372a-42fa-a681-40702aefa9c9",
      text: "UPS Room 01C.08",
      type: 5,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 480,
      parent: "e38ed0fa-2663-4b0c-bf48-30907319fe5a",
      progress: 0,
      source_task_id: "7995276"
    },
    {
      id: "66f89bfc-e1f3-444d-ae26-1345719d1d60",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1520"
    },
    {
      id: "5ef13ffd-36c1-415b-b6b8-875944a8de5a",
      text: "[DCB1] FacNet Live [SITE BUILDINGS - CRITICAL]",
      type: 0,
      start_date: "2026-02-13T08:00:00",
      end_date: "2026-02-13T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3676"
    },
    {
      id: "0ec644a3-a831-47f0-8fa9-a5662a80b501",
      text: "B1 - Network Room 1/4  - Install Doors/Hardware",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2250"
    },
    {
      id: "595fb797-dd50-45a1-8c84-a268b1db9396",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 8,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2090"
    },
    {
      id: "4e89a163-490e-47ca-a560-ff9a639efb47",
      text: "B2 - West Entrance - Install rock mulch",
      type: 0,
      start_date: "2026-07-22T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1120"
    },
    {
      id: "45eb8282-a391-4188-92ae-13b6806efa35",
      text: "B1 - 1B2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1100"
    },
    {
      id: "9aadc098-1eab-461a-98e5-e41d805e610b",
      text: "(CFCI) Div. 26 - Site Utility Vaults (T-Comm)",
      type: 5,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-09-03T08:00:00",
      duration: 480,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0.16,
      source_task_id: "7994868"
    },
    {
      id: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6",
      text: "B2 - DH-A - WAP Provisioning",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 160,
      parent: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      progress: 0,
      source_task_id: "B2.CONN.1190"
    },
    {
      id: "d692450c-aea9-4c48-894e-a0870dec709c",
      text: "Admin Constuction Complete",
      type: 0,
      start_date: "2026-05-06T08:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1050"
    },
    {
      id: "89a9e7d3-f76f-4603-b23c-a559d7e414d9",
      text: "Install CLT Panels",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 160,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1200"
    },
    {
      id: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      text: "DH-C",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 1336,
      parent: "e7143409-9746-43ab-abe3-3a9fb88b3f47",
      progress: 0,
      source_task_id: "7995283"
    },
    {
      id: "074dcc52-1170-4a4b-86f6-d821db2d584f",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-01-05T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2410"
    },
    {
      id: "b49ba076-9f03-4f78-aade-b9cf0e9d026b",
      text: "FR 38 - IBOS-  Redesign of structural foundation",
      type: 0,
      start_date: "2024-11-26T00:00:00",
      end_date: null,
      duration: 40,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "B1.CFCI.6560"
    },
    {
      id: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 400,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995386"
    },
    {
      id: "53e40c9f-de3f-44a1-a898-3438d09ba387",
      text: "B2 - Rough Grading",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 80,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1090"
    },
    {
      id: "aab14c12-8591-45a4-baab-35b4654b25d6",
      text: "B1 - SSB - 1E1 - Common - E-cure /Seal Floors",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 64,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2450"
    },
    {
      id: "da68efed-c11c-46e6-a991-5f7744fdd0da",
      text: "B1 - 1D2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2130"
    },
    {
      id: "b1db0d86-7df4-4ff9-a0bf-317374f5488d",
      text: "(CFCI) Div. 26 - Substation (Auxiliary)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      progress: 0,
      source_task_id: "7994873"
    },
    {
      id: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 288,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995380"
    },
    {
      id: "58970856-58a0-405f-8e3d-1255df3bdd79",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 8,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1500"
    },
    {
      id: "e39bc1fd-688e-4691-869d-2615d2579be5",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 1312,
      parent: "9a439d8f-7507-4d44-a057-90cba25b759a",
      progress: 0,
      source_task_id: "7995027"
    },
    {
      id: "08062563-e86c-47a0-89e6-8f8201591b22",
      text: "Building 1 mCUP-4",
      type: 5,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 448,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995367"
    },
    {
      id: "6cf40f8a-86a1-42cd-a662-7171a72a3ad9",
      text: "Area B - Paint - Prime/First Coat Ceilings",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1330"
    },
    {
      id: "7fb33c35-1204-4516-b5fc-1de04cad777e",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 1384,
      parent: "9a439d8f-7507-4d44-a057-90cba25b759a",
      progress: 0,
      source_task_id: "7995070"
    },
    {
      id: "f8812fdc-6bb2-4375-8c46-7fe716f71918",
      text: "B2 - DH-D  - Power Alley - Final Paint",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-13T08:00:00",
      duration: 16,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.2300"
    },
    {
      id: "7d83864a-008e-469b-a278-10e305a4cc4f",
      text: "Precon Plan",
      type: 5,
      start_date: "2023-11-15T00:00:00",
      end_date: "2024-03-11T08:00:00",
      duration: 624,
      parent: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      progress: 1,
      source_task_id: "7994733"
    },
    {
      id: "64c1284c-d6e1-4add-b5b3-bc6e1e9a4b2b",
      text: "Fragnet 09 - PCO # 5 - Unsuitable Soils - DCB-2",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 408,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.48,
      source_task_id: "8519910"
    },
    {
      id: "e8d10710-ab8c-4ea3-aa8a-7094dd1c8c31",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1640"
    },
    {
      id: "b41cb521-532d-41d9-b985-74b4cfb32b13",
      text: "B1 - Network Room 2/3 - Install Lighting",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1950"
    },
    {
      id: "f8a54d36-e2e7-46fe-ac2f-b0ff914573f5",
      text: "L4 Finish mCUP  - DCB2",
      type: 0,
      start_date: "2026-09-11T08:00:00",
      end_date: "2026-09-11T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2133"
    },
    {
      id: "a2e8f15d-684a-40cf-836a-e18ddc2f9c9a",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 8,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1610"
    },
    {
      id: "8c6f09f2-2af7-4585-afeb-4a4318520839",
      text: "Data Hall",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-07-27T08:00:00",
      duration: 1344,
      parent: "8790b54e-02a0-492f-af1f-d61d0338ca55",
      progress: 0,
      source_task_id: "7995091"
    },
    {
      id: "a9965be8-1e27-47cb-b954-3f621652ade6",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (NW 2/3)",
      type: 0,
      start_date: "2025-07-14T08:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1380"
    },
    {
      id: "566ab706-2a55-4fb9-93c5-0746b8f140df",
      text: "B1 - mCUP-1 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 48,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1210"
    },
    {
      id: "212f2529-a5e9-4ead-a2d2-de0c4fd48e05",
      text: "Area 1 - UG RI -MVS to PTX-DCB1",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1110"
    },
    {
      id: "04535453-e825-4e39-946c-dda78f65eeb3",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2300"
    },
    {
      id: "5b0c7f62-d6b7-4c27-a219-7ab78c02b3ce",
      text: "Procurement and VDC",
      type: 5,
      start_date: "2023-09-08T08:00:00",
      end_date: "2026-05-05T08:00:00",
      duration: 5344,
      parent: "fde6fa74-71e9-4a70-857e-ca30387e7d0d",
      progress: 0.22,
      source_task_id: "7994747"
    },
    {
      id: "262a2fcd-0fb8-4171-b80f-fd5281528897",
      text: "IBOS - Prep / Submit for Review - Electrical Panel",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1090"
    },
    {
      id: "89f10edb-b109-4a99-92b4-c0fb31a58927",
      text: "B2 - DH-A - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 96,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2080"
    },
    {
      id: "7f611119-4e97-4289-b4a0-954de58da84b",
      text: "B1 - mCUP-1-6 - L2 Checkout of Pumps/Chillers and MSB for A/B/Network",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 120,
      parent: "2a30feef-09ac-419f-b924-97c80bbf1474",
      progress: 0,
      source_task_id: "B1.mCUP.9160"
    },
    {
      id: "613b7208-4628-4f41-be4d-244470010d71",
      text: "B1 - mCUP-1-6 - Seq. 1-Piping POC's, Devices, final dress out for Network and A/B Data Halls (Fill and Flush Building)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 160,
      parent: "2a30feef-09ac-419f-b924-97c80bbf1474",
      progress: 0,
      source_task_id: "B1.mCUP.9220"
    },
    {
      id: "0c7e5e14-dffa-4b51-8e9c-ff1680651120",
      text: "Architectural Precast SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-04-03T00:00:00",
      end_date: "2024-05-02T08:00:00",
      duration: 176,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 1,
      source_task_id: "PRE1630"
    },
    {
      id: "61547741-734d-4f19-a7ee-b90d9fe6d39e",
      text: "B1 - Network - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 160,
      parent: "e7525e1f-7352-4ede-9294-cffe817e578a",
      progress: 0,
      source_task_id: "B1.C.EY.1120"
    },
    {
      id: "777e8c6e-a142-4273-82ed-e0333182df28",
      text: "Corpnet Connectivity",
      type: 5,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-10-12T08:00:00",
      duration: 600,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995459"
    },
    {
      id: "33020e53-f9c6-4666-a0f2-58c34a4c6d4e",
      text: "Area 2 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-SSB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1360"
    },
    {
      id: "9ccc82da-b9ab-4782-8379-9d46f45ddc40",
      text: "Fab and Deliver - PTX-DHAux - Area B (2) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 3368,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.37,
      source_task_id: "B2.OFCI.1730"
    },
    {
      id: "6413bb2a-cb70-4f6c-879a-840667f54942",
      text: "PHASE 4 Substantial Completion",
      type: 0,
      start_date: "2027-05-14T08:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "CX.MIL.1050"
    },
    {
      id: "a7e191ac-ae65-47ee-8772-9b034e366c04",
      text: "L4 Finish DH C - DCB2",
      type: 0,
      start_date: "2027-02-26T08:00:00",
      end_date: "2027-02-26T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2111"
    },
    {
      id: "85ed5f66-b495-4c78-8526-5e496be64016",
      text: "B2 - mCUP-8 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8090"
    },
    {
      id: "5231452f-a8a5-481f-b2a2-e7602e53969d",
      text: "B2 - DH-A - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 80,
      parent: "af73992b-f173-45bc-944e-dd449681c36e",
      progress: 0,
      source_task_id: "B2.C.EY.1390"
    },
    {
      id: "7f585744-1012-4da5-b19a-bc3958544f66",
      text: "B1 - 1N1W - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 80,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5960"
    },
    {
      id: "09a24131-cfd0-48a6-a5b5-6b93e20a1538",
      text: "Admin - submittal Rvw/App'l - Doors, Frames and Hardware",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: "2024-10-11T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1140"
    },
    {
      id: "404d9b6c-ed39-425a-a908-93056a0b4636",
      text: "IBOS - Submittal Rvw/App'l  - Electrical Panel Procurement",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1100"
    },
    {
      id: "ee31fe2e-2f19-4690-baf4-71a3de84117d",
      text: "Substation-2 - TX B - Install Medium  And High Voltage Cable Including Terms",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-02-07T08:00:00",
      duration: 120,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6570"
    },
    {
      id: "a2964479-5c5e-4859-a1ca-27c718652a9d",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1530"
    },
    {
      id: "eb6b7324-2f65-43e9-81fb-e1ff7e6da51a",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 24,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1720"
    },
    {
      id: "4452f889-9581-4c2c-833a-cbb8d4422e1a",
      text: "B1 - DH-B - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1290"
    },
    {
      id: "a5af6e72-a5c1-4335-a495-64ee36264f2d",
      text: "B1 - 1N2E - EF3 - Pour Pads Around Telecom Conduits (EF3)",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 48,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5560"
    },
    {
      id: "23b83478-dc78-4be9-9125-02e1d278076d",
      text: "B1 - DH-C - Hookup FCAs Electrical- Data Hall C",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2340"
    },
    {
      id: "4b091fa4-3757-4696-9172-fd3de6023370",
      text: "BLDG-1/2 - Fabricate / Deliver - Building Controls",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 320,
      parent: "cb9ddad6-dc85-427d-a3ce-d7471522dab1",
      progress: 0,
      source_task_id: "B1.CFCI.4380"
    },
    {
      id: "8b063fd8-f4b7-446c-8f75-0d37bdf1593d",
      text: "Corridor 1D1W (UPS Room (2)/Light Inv/Control Panel",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 816,
      parent: "1d9e827f-f2c2-4707-950b-61d5bd31f6bc",
      progress: 0,
      source_task_id: "7995315"
    },
    {
      id: "387f4452-75b6-4e66-b65d-74f8b9eacaf4",
      text: "B2 - DH-A - Pull/Term Lighting/Branch - Data Hall A",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2540"
    },
    {
      id: "ad81c4ff-51ed-406e-85d5-a07e20bb8eca",
      text: "Fragnet 16 - PCO # 12 RFI-088 Cable Tray Over Hard Ceiling",
      type: 0,
      start_date: "2024-08-09T00:00:00",
      end_date: null,
      duration: 520,
      parent: null,
      progress: 0.5,
      source_task_id: "8690180"
    },
    {
      id: "18168e50-5827-45ee-b0e9-cafa6e41255d",
      text: "B1 - SSB - 1E1 - Common - Install Ceiling Grid",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 64,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1960"
    },
    {
      id: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      text: "Fragnet 08 - PCO # 4- Telecom",
      type: 0,
      start_date: "2024-07-23T00:00:00",
      end_date: null,
      duration: 1576,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.06,
      source_task_id: "8519851"
    },
    {
      id: "95688cc7-421b-4580-8842-888675a97d23",
      text: "B2 - OSP Cabling - EF to TWRIDF2",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 120,
      parent: "71be5c41-0454-4bac-8971-6b8f2d2021a0",
      progress: 0,
      source_task_id: "B2.CONN.1140"
    },
    {
      id: "bbc435a8-d8f2-4a9a-86ef-b28b7c718a20",
      text: "B1 - DH-D - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 40,
      parent: "62872b9b-6759-4561-825b-c00ed5bb886c",
      progress: 0,
      source_task_id: "B1.C.D.3140"
    },
    {
      id: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      text: "Gang Restrooms",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 672,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "8243677"
    },
    {
      id: "b968e3a9-a7db-47f1-a38e-71a6c4f452f3",
      text: "B1 - Network Room 2/3 - FCA Gallery - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.2120"
    },
    {
      id: "11775c5c-821e-449a-a1b5-959ed185f805",
      text: "B1 - Network Room 1/4  - Install Cable Tray for Perimeter",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2220"
    },
    {
      id: "2f31d1c8-d53e-4ea3-ac42-30a5eb52d821",
      text: "Fab and Deliver - Substation Circuit Breaker - Area SS-1 (2) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-21T08:00:00",
      duration: 2552,
      parent: "dce7c311-c42c-460b-bd76-db76204a1acf",
      progress: 0.22,
      source_task_id: "B1.OFCI.1950"
    },
    {
      id: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 24,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1140"
    },
    {
      id: "601b0653-e4c5-4d9a-86f4-2b326b9982bf",
      text: "Local AHJ Review and Comments of Mass Grading Permits",
      type: 0,
      start_date: "2023-11-20T00:00:00",
      end_date: "2024-01-26T08:00:00",
      duration: 544,
      parent: "68519373-5be8-4c94-895d-f8db4c1edde5",
      progress: 1,
      source_task_id: "PRE-DD-1100"
    },
    {
      id: "61eca0ba-60c7-4050-b050-569ff6de0dca",
      text: "BLDG-2 DH-B",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 200,
      parent: null,
      progress: 0,
      source_task_id: "8444269"
    },
    {
      id: "18b82ec0-070a-4054-87c3-069815864efe",
      text: "B2 - SSB - (equipment on roof) Roofing(Converted to LOE)",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 120,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1040"
    },
    {
      id: "5060a97b-9582-4317-a961-fd2d58fbe78f",
      text: "B2 - 2D1W - 02D.09 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-04-28T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1790"
    },
    {
      id: "3e60f626-2a1e-4750-9366-6b50c125d012",
      text: "Substantial Completion (DH A) - DCB2",
      type: 0,
      start_date: "2027-03-05T08:00:00",
      end_date: "2027-03-05T08:00:00",
      duration: 0,
      parent: "c02bb0d9-a0ba-46c8-8c9c-98131322446d",
      progress: 0,
      source_task_id: "ICM.B2.1080"
    },
    {
      id: "1835362b-1554-4d37-8466-b131150efb02",
      text: "Substation-2 - MSG A - terminations of MECO scope",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 72,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.6420.1"
    },
    {
      id: "db5214ff-8117-4566-a491-822577c55101",
      text: "B1 - DH-B - Install IMP Walls @ FCAs - Data Hall B",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2010"
    },
    {
      id: "468305bd-0501-4842-8fba-f6be486af515",
      text: "Substation-1 MSG A Buildout",
      type: 5,
      start_date: "2025-04-09T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 1448,
      parent: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      progress: 0,
      source_task_id: "7995241"
    },
    {
      id: "39fff964-da5a-47d3-a4a5-61f11e1b3e4a",
      text: "HAC - Div-5 - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5950"
    },
    {
      id: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      text: "Corridor 1N2E",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 920,
      parent: "19d232aa-0dc1-49f0-93d6-1893cfabaf59",
      progress: 0,
      source_task_id: "7995328"
    },
    {
      id: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      text: "B1 - mCUP-8 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8040"
    },
    {
      id: "8cca0891-37f8-4de7-94f5-094c0383e7ef",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-E / 1-F - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 240,
      parent: "aaa0fbd3-c982-483f-83c9-aa6fc59b7f97",
      progress: 0,
      source_task_id: "B1.VDC.1510"
    },
    {
      id: "18cb8c11-4a65-4833-a7a5-510fe0a0af1b",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Finished Carpentry (Millwork/Countertops)",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-01-29T08:00:00",
      duration: 120,
      parent: "450e7e94-6054-44b6-b556-c3c644e90ee4",
      progress: 0,
      source_task_id: "B1.CFCI.4730"
    },
    {
      id: "7d465d5f-cfb1-45b3-b61a-49ca1d259de2",
      text: "Substation HPT - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "4016a0a2-9bce-4112-a177-64ed092fdb94",
      progress: 1,
      source_task_id: "B1.OFCI.1160"
    },
    {
      id: "b79ea657-bc0e-4b1e-840b-32639bcd2c81",
      text: "B2 - DH-C - Rough in HAC Lighting - Data Hall C",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2060"
    },
    {
      id: "35f4f35d-3c63-4bfb-b18b-41d4cbd20f44",
      text: "DFSMA - SSB GS.MDF Module ROJ - MOFE (1 of 2)",
      type: 0,
      start_date: "2025-06-25T08:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 0,
      parent: "56ede0b1-255c-4479-a807-a615df7d22a5",
      progress: 0,
      source_task_id: "B1.DFSMA.1110"
    },
    {
      id: "fe27e2a2-de94-4473-977e-7c5c0b177be0",
      text: "FR 08 - Area 4 - Telecom Install - CAV3 to GH - Concrete Scope",
      type: 0,
      start_date: "2025-04-10T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 240,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A4.8070"
    },
    {
      id: "db8e4f83-e512-4808-ad1b-fe724b1af006",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1530"
    },
    {
      id: "61932347-a07c-4afd-b767-fdd5f24e3878",
      text: "B2 - 2E1E - 02.01.E1.05 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5310"
    },
    {
      id: "be1954a7-c219-474f-92c0-1eb06373ba27",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "52d3af53-0515-442d-ae0a-d5ea0b3f489e",
      progress: 0,
      source_task_id: "MECO-1260.60"
    },
    {
      id: "7581676d-2b94-4609-b168-7764e4136f48",
      text: "B1 - DH-C - DEC -C Turnover Walk - Data Hall C",
      type: 0,
      start_date: "2026-03-04T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 16,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2690"
    },
    {
      id: "44029bc0-1ab4-4bc7-a20b-41c34f469897",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 80,
      parent: "92aa8a33-1e8a-4967-95ad-e4391a98b9cd",
      progress: 0,
      source_task_id: "MECO-1260.20"
    },
    {
      id: "833743d9-0d1e-4f92-aeff-61f84c09f416",
      text: "B1 - DH-A - Hookup CDU's - Data Hall A",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 144,
      parent: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      progress: 0,
      source_task_id: "B1.C.A.2990"
    },
    {
      id: "e63b3f42-17bd-4cd7-b6f1-e2689d9887f9",
      text: "Substation-1 - TX B - NETA Testing Cables",
      type: 0,
      start_date: "2025-06-28T00:00:00",
      end_date: "2025-06-28T00:00:00",
      duration: 168,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3750"
    },
    {
      id: "d1e53723-a9e4-40c8-8c3f-a76ece4b98a5",
      text: "BLDG-2 DH-B - Equipment Final Clean",
      type: 0,
      start_date: "2026-09-16T00:00:00",
      end_date: "2026-10-06T08:00:00",
      duration: 120,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1070"
    },
    {
      id: "6524fe46-a43e-4c9f-8db0-a019124790f3",
      text: "Install Steel Perimeter Plate at CLT Edge",
      type: 0,
      start_date: "2025-05-15T00:00:00",
      end_date: "2025-05-21T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1270"
    },
    {
      id: "40117ff3-b57b-4747-baf5-bf1bc37475e2",
      text: "Install Tile",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 80,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1150"
    },
    {
      id: "14ecb330-e4dc-49b9-9ed9-1c5cd2b2429b",
      text: "B1 - SSB - 1E1 - EF1 - Pour Pads Around Telecom Conduits (EF1)",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 48,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1650"
    },
    {
      id: "20c03fc5-e794-4752-b507-21826bd31505",
      text: "BLDG-1/2 - Fabricate / Deliver - Specialities",
      type: 0,
      start_date: "2025-04-03T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 240,
      parent: "f9e927ae-bef4-4c2f-a9d1-169a3df666a0",
      progress: 0,
      source_task_id: "B1.CFCI.5260"
    },
    {
      id: "a77ef004-74a9-4cbe-a83a-896e2f07d751",
      text: "B2 - DH-D - Term Bussways - Data Hall D",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-31T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2460"
    },
    {
      id: "7a19d69f-582d-434a-9bcc-991b60df4cad",
      text: "Mechanical Contractor Alignment - Meta Decision to Engage Market",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 0,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "PRE1140"
    },
    {
      id: "7a0b2618-317a-46d4-8757-670464cb46bb",
      text: "B1 - Network - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 80,
      parent: "efec6b5a-5634-43a5-b571-748e500afd9a",
      progress: 0,
      source_task_id: "B1.C.EY.1100"
    },
    {
      id: "43902eda-cb7f-4e23-a5bc-75e4a5811ffc",
      text: "Fab and Deliver - Cooling Distribution Unit - Area D - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 3624,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 0.12,
      source_task_id: "B1.OFCI.3340"
    },
    {
      id: "c64d84d2-6539-4a46-8cae-51e196d00a94",
      text: "Fab and Deliver - MVS-6WAY - Area NW-2/3 (4) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 2088,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.06,
      source_task_id: "B1.OFCI.2180"
    },
    {
      id: "52278f4a-12b3-4bea-8257-b0cbcb0970f5",
      text: "B2 - 2E1E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 8,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5120"
    },
    {
      id: "3c1312b2-314b-42f4-b6af-ac036737d9ec",
      text: "BLDG-1/2 - Shopdrawings Rvw/App'l - Lighting",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6050"
    },
    {
      id: "e633c469-f45c-48e6-80b7-26a25ee90887",
      text: "Substation-2 - MSG B - Wire Pulls From Building MSG-1A/C",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 128,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4410"
    },
    {
      id: "d426c6ea-5246-425d-93d9-fc6d44805b6d",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Mechanical/Insulation",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1130"
    },
    {
      id: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 328,
      parent: "984b19cb-e113-48d8-94eb-b3babf498cee",
      progress: 0,
      source_task_id: "7995106"
    },
    {
      id: "a4cca5c4-bec2-4b39-8728-e316501776da",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-04-02T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2350"
    },
    {
      id: "c3c29311-adfa-438b-abce-b49ab0e86585",
      text: "Precast Leave Out at Electrical Skid",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 16,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1240"
    },
    {
      id: "9994c5c0-df16-4a8a-9cf8-1349b4dc3f48",
      text: "L3 Finish DH D - DCB2",
      type: 0,
      start_date: "2027-03-03T08:00:00",
      end_date: "2027-03-03T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2033"
    },
    {
      id: "68eac5c6-f18e-45f7-880e-8d00154eca77",
      text: "(CFCI) Div. 23 - Heating, Ventilation, Air Cond.",
      type: 5,
      start_date: "2024-01-09T00:00:00",
      end_date: "2025-03-19T08:00:00",
      duration: 760,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994901"
    },
    {
      id: "0afc9f69-eb7d-49f3-b5bd-cab03497529a",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2340"
    },
    {
      id: "c2c3ce2d-4dd9-4502-9124-4ac33d40a6bd",
      text: "Final Punch - NS+SSB",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 80,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX5.B1.NS.1020"
    },
    {
      id: "79cb3721-e11a-48e8-aa4f-c5e13406b815",
      text: "B1 - DH-B - Install Door/Hardware/ Wall Trim - Data Hall B",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2870"
    },
    {
      id: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce",
      text: "B2 - mCUP-8 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 48,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8040"
    },
    {
      id: "c8daf8ce-fd62-4394-b49d-f6aa118c90fc",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 8,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1360"
    },
    {
      id: "da2c75bf-4cca-437e-88ae-73f64841928e",
      text: "Substation-2 MSG A Buildout",
      type: 5,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 1064,
      parent: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      progress: 0,
      source_task_id: "7995218"
    },
    {
      id: "0980bff1-69fa-40a8-b3a2-57a05a73d265",
      text: "Area B - OH Electrical",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 120,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1200"
    },
    {
      id: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      text: "Building 1 mCUP-6",
      type: 5,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 512,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995369"
    },
    {
      id: "e822797a-5dbe-4e4b-8f94-1911d8e72630",
      text: "Substation-1 - MSG B - Wire Pulls From Building - Sequence 1",
      type: 0,
      start_date: "2025-05-09T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 184,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3630"
    },
    {
      id: "15bf5924-7210-4d33-8718-d532eb1a3391",
      text: "Bid Package List - Meta Review / Approval",
      type: 0,
      start_date: "2023-11-15T00:00:00",
      end_date: "2023-11-15T08:00:00",
      duration: 8,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "PRE1190"
    },
    {
      id: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e",
      text: "Substation-2 - Install Stone To Grade In Substation",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 120,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4290"
    },
    {
      id: "86d4db97-d3fe-481d-a291-1c0ed012a4e1",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2370"
    },
    {
      id: "f061cf85-98b1-4a41-8f55-df23ad164a6e",
      text: "B2 - 2C1 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1180"
    },
    {
      id: "080b832b-af7b-4e91-9c83-eab029357ee4",
      text: "Power Alley DH-D",
      type: 5,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 696,
      parent: "b1c751be-46df-40c6-9525-a10c4e362601",
      progress: 0,
      source_task_id: "7995312"
    },
    {
      id: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      text: "BLDG-1 Network",
      type: 5,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 208,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995381"
    },
    {
      id: "d46b67f4-d029-4ed7-8f9e-297f05cb6533",
      text: "Architectural/Security Fencing - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-19T08:00:00",
      duration: 120,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0,
      source_task_id: "Design.PreC.5070"
    },
    {
      id: "6ae80286-7bb3-4541-8340-5590923d551b",
      text: "B2 - DH-D - Install Underground Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 80,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1540"
    },
    {
      id: "5ae0c693-710f-4d74-9f48-d4ffe3563328",
      text: "Start Slab-On-Grade Concrete - DCB1",
      type: 0,
      start_date: "2025-04-28T00:00:00",
      end_date: "2025-04-28T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1500"
    },
    {
      id: "3f1b55f2-6946-41af-864d-721593cfe926",
      text: "B1 - DH-B - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 240,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1070"
    },
    {
      id: "2f98335f-473f-4e93-bfb4-27a152f494b8",
      text: "Site / UG BIM Coordination",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-06-25T08:00:00",
      duration: 568,
      parent: "1727f221-62ff-460d-93ab-9c07242dc0b2",
      progress: 0.93,
      source_task_id: "PRE-DD-1010"
    },
    {
      id: "37a83c6a-efbd-4c4b-ba78-64f281ea8c1b",
      text: "Finalize delivery schedule for MOFE elements to support Level 3 schedule development",
      type: 0,
      start_date: "2024-02-20T00:00:00",
      end_date: "2024-02-26T08:00:00",
      duration: 40,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1360"
    },
    {
      id: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      text: "GS.IDF.2A3",
      type: 5,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 736,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "7995090"
    },
    {
      id: "9c2ae6f0-7235-41f3-ae7f-54f99afa455c",
      text: "B2 - 2D1W - 02D.08 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-04-28T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1780"
    },
    {
      id: "ff2f7c02-5501-4940-8c2d-062ea542f15a",
      text: "BLDG-1/2 - Prep / Submit for Review - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-10-21T00:00:00",
      end_date: "2024-10-22T00:00:00",
      duration: 160,
      parent: "5ed9bec7-54c7-4156-b0c1-7ceb6eb0515a",
      progress: 0,
      source_task_id: "B1.CFCI.4610"
    },
    {
      id: "b37d9ee6-fd80-48a5-af58-6df4e380a676",
      text: "B1 - DH-D - Install HAC Lights - Data Hall D",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1200"
    },
    {
      id: "5791a32a-afaa-4585-a454-56bdd6f1d6b1",
      text: "Skin - Admin",
      type: 0,
      start_date: "2025-05-15T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 320,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1040"
    },
    {
      id: "a456564a-992b-4e6c-9164-49268d7f3239",
      text: "L3 Start DH C - DCB1",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-05-05T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2030"
    },
    {
      id: "d1127824-715e-4f69-a6f6-ec2be70f6e9f",
      text: "B2 - 2A2 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 160,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1870"
    },
    {
      id: "30b61d81-9fef-4f68-828a-de3a5c38171d",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Equipment Mech Hookup",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 80,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1110"
    },
    {
      id: "6c343024-3ee7-46e3-a040-d5959b762759",
      text: "Substation-1 - MSG A - Retesting on Perm Power",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 16,
      parent: "d9d2a2ca-55ab-40b7-b86c-22fa99be924a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.7030"
    },
    {
      id: "5918d1e3-7942-471c-a486-ca63b5fdd98a",
      text: "Area 4 - Fire Water Install",
      type: 0,
      start_date: "2024-12-19T00:00:00",
      end_date: "2025-01-15T08:00:00",
      duration: 160,
      parent: "f214a3c1-728d-4440-8681-2ec49a09b834",
      progress: 0,
      source_task_id: "C.CSU.A4.4000"
    },
    {
      id: "2801dea7-1f0e-41cd-9e7b-ced4907f83e5",
      text: "FR 04 - DPR submit RFI # 255",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 216,
      parent: null,
      progress: 1,
      source_task_id: "FR.04.1040"
    },
    {
      id: "c10179e0-c836-46db-b29d-7305c9e494c8",
      text: "B2 - 2D2 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-07-02T08:00:00",
      duration: 160,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2020"
    },
    {
      id: "c6f567a1-7265-49cc-ab1b-192c7d15c776",
      text: "B2 - 2D2 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1280"
    },
    {
      id: "3b1b10e1-806b-4964-b259-23cadd347822",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Structural Steel (Joists)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 72,
      parent: "b4e5b7c9-5a36-4201-8305-5ac89568c3ba",
      progress: 0,
      source_task_id: "B1.CFCI.3930"
    },
    {
      id: "c048762d-b888-4a2b-8b77-d0b842a67069",
      text: "B1 - ISP Cabling - MDF to N1, N2, N3, N4 (GS tray)",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 240,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1200"
    },
    {
      id: "206e0684-9d44-4a45-a5f7-788e46b0be63",
      text: "FR 30 - META review and Approve PCO#28",
      type: 0,
      start_date: "2024-11-13T00:00:00",
      end_date: "2024-11-27T08:00:00",
      duration: 80,
      parent: "4c402718-830a-4c9c-9cfa-044c255c93bf",
      progress: 0,
      source_task_id: "FR.30.1020"
    },
    {
      id: "c5c384b4-0791-4c05-aa57-fe32da4666d5",
      text: "B1 - Deep Telecom - EF4 - Concrete Scope",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B1.C.STR.2440"
    },
    {
      id: "15cb4329-7b1e-465e-a80b-bec578d26373",
      text: "Delivery of Substation MSG Alpha (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-04-08T08:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1805"
    },
    {
      id: "d3590b0a-3223-4217-be38-88869cfa4fd2",
      text: "B1 - SSB - 1E2 - Common - Clean",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 48,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2490"
    },
    {
      id: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751",
      text: "B1 - DH-D - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "B1.C.D.3010"
    },
    {
      id: "456497f5-6864-43df-bbd4-d63d16d4d467",
      text: "B1 - mCUP-7 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7090"
    },
    {
      id: "dee0d834-497a-4bf0-ab0d-d446c6853269",
      text: "Substation HPT - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "4016a0a2-9bce-4112-a177-64ed092fdb94",
      progress: 1,
      source_task_id: "B1.OFCI.1300"
    },
    {
      id: "9ab13b36-76ee-44b6-8b82-83c09a4b62d1",
      text: "Fab and Deliver - Busway Kits - Area B - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 4240,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 0.24,
      source_task_id: "B2.OFCI.2060"
    },
    {
      id: "6eaf241b-c837-4e4e-ae35-788d9d0b8347",
      text: "Commissioning - Admin - Level 3",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 200,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1100"
    },
    {
      id: "1c112190-5a48-483a-a023-f3c2bf5f2461",
      text: "Substation-2 - TX B - NETA Testing Cables",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 168,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4510"
    },
    {
      id: "583e5b91-cc52-43c5-830b-80b6233347b3",
      text: "Fireproofing (Intumescent) (Spec 07 81 23)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994845"
    },
    {
      id: "6d917d99-c6c5-4d8e-bcd2-3cc43ee37b8c",
      text: "B1 - mCUP-1-9 - Piping supports install (layout and vendor submittal confirmation) - Sequence 2",
      type: 0,
      start_date: "2025-03-08T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1060"
    },
    {
      id: "bdab29e5-307d-4e06-a3e2-ae6bd26fac08",
      text: "B1 - Network Rooms - FCA Setting/ Hookup (Converted to LOE)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 192,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1420"
    },
    {
      id: "061b8cd8-5099-4281-8bf5-8ec50b7a4267",
      text: "Interior fit-out Start DCB2 - Phase3",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-24T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1280"
    },
    {
      id: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2600"
    },
    {
      id: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      text: "(OFCI) B2 Distribution Panels HMD",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 3928,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.35,
      source_task_id: "7994954"
    },
    {
      id: "e4c2ae14-0c46-442a-8a4f-8bab00a534ec",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1140"
    },
    {
      id: "68c843ba-c453-447e-b630-0d80c7f9344a",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2570"
    },
    {
      id: "18d840dc-fbca-4944-bbc5-73c1783bea63",
      text: "Data Hall B (Area 2-B)",
      type: 5,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 760,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994783"
    },
    {
      id: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      text: "B1 - Network Room 1/4 - Frame Walls (ROJ Facnet Module)Pre-Fab keep",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 120,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1020"
    },
    {
      id: "48b18a85-7036-42d0-8dd2-fac74b55edc3",
      text: "B1 - mCUP-5 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 48,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5050"
    },
    {
      id: "0db73a88-707d-4f71-add5-96bcc57042dd",
      text: "B1 - OSP Cabling - EF to Admin",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "f25599a0-95e2-44be-82b5-e6c181abbae6",
      progress: 0,
      source_task_id: "B1.CONN.1440"
    },
    {
      id: "b4475927-ed7c-405a-857c-287484b833de",
      text: "FR 16 - DPR Prepare and Submit PCO#12",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 288,
      parent: "ad81c4ff-51ed-406e-85d5-a07e20bb8eca",
      progress: 1,
      source_task_id: "FR.16.1020"
    },
    {
      id: "604c8f5a-ede6-4444-b063-a73799ecf4d9",
      text: "OH Electrical",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1140"
    },
    {
      id: "5897d1e2-fe31-4d56-b344-c64086e9b0ca",
      text: "(CFCI) Div. 32 - Site Improvements",
      type: 5,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 960,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994912"
    },
    {
      id: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      text: "Issue Bid Package List with Subcontractors & Meta Approval",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2023-12-08T08:00:00",
      duration: 40,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "PRE-PP-1000"
    },
    {
      id: "08424bd0-4312-4bc4-bf95-fc8eeef4a1a3",
      text: "B2 - 2C1 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1430"
    },
    {
      id: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      text: "B2 - SSB - 2E1 - Common - Hang/Tape/Finish Drywall Ceiling",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1270"
    },
    {
      id: "395647e0-99d2-43e9-a284-bd0717c8f62e",
      text: "Admin -Submittal Rvw/App'l - Lighting",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1160"
    },
    {
      id: "ceada45c-fed4-43a1-9503-2998abb8c1f5",
      text: "B1 - Network - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 464,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1060"
    },
    {
      id: "ffdf9776-3a56-4b4c-9ba1-bc0c2dfd01a9",
      text: "B2 - 2C1W - 02C.08 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.1830"
    },
    {
      id: "364804f1-dd1b-4b3c-b6b5-7c7841f23ae6",
      text: "Substation-1 - B Lineup SF6 Breaker - Set Breaker",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-05-22T08:00:00",
      duration: 8,
      parent: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3790"
    },
    {
      id: "8b4938cb-a5b7-4660-b6e8-182433f3b671",
      text: "Substation-2 - MSG A - 3rd Party Inspections And Equipment Clean",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 152,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4750"
    },
    {
      id: "3cc250fd-7e22-4b4e-9df6-56142884eb6d",
      text: "B1 - DH-D - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 80,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1200"
    },
    {
      id: "dc10b468-dff7-43c9-9d8f-429a4d33d464",
      text: "B1 - DH-D - Install BMS Conduit -Data Hall D",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1270"
    },
    {
      id: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 160,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1800"
    },
    {
      id: "5a31b882-80c6-49fd-928e-34632a831486",
      text: "Substation-1 - MSG A - Install Temp Power / Permenant AC / Anchoring / Set In Place Inspection",
      type: 0,
      start_date: "2025-04-30T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 120,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3940"
    },
    {
      id: "6b1091f1-bc56-46af-b0a9-7f5086f9635a",
      text: "B1 - Network - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 40,
      parent: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      progress: 0,
      source_task_id: "B1.C.EY.1070"
    },
    {
      id: "5536764d-f897-48b7-97b3-1f2180c5753c",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1300"
    },
    {
      id: "43ffb775-89e0-48aa-9afc-2940cd091a80",
      text: "B2 - DH-A - Install Celing Devices Fire Protection - Data Hall A",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2610"
    },
    {
      id: "f3b2e4f9-4e28-47fa-9e5a-d1f3edc902bb",
      text: "Paint Plywood",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 16,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1020"
    },
    {
      id: "46c92b8b-9828-4940-82ad-4dc5ad449046",
      text: "FF GMP Development",
      type: 0,
      start_date: "2024-06-24T00:00:00",
      end_date: null,
      duration: 144,
      parent: null,
      progress: 1,
      source_task_id: "Design.PreC.5780"
    },
    {
      id: "e926dfce-7a79-4f02-b38f-9a917367ae4b",
      text: "Trade Partners Authorized to Start VDC Work",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-18T00:00:00",
      duration: 0,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC22.1060"
    },
    {
      id: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed",
      text: "B2 - 2C2 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-07-20T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 120,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2610"
    },
    {
      id: "33576614-e68d-4631-8481-9905100e2ef6",
      text: "Equipment Installation by Morgan",
      type: 0,
      start_date: "2025-02-15T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8150"
    },
    {
      id: "37ba63b9-445e-4c23-b2f0-55c7dd0198e6",
      text: "B1 - 1C1W - 01C.07 - Pull Wire to Equipment",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1880"
    },
    {
      id: "6e200373-b0d5-42b7-b368-efd5ab20e285",
      text: "Fab and Deliver - PTX-DHAux - Area B (2) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-02T08:00:00",
      duration: 2536,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.45,
      source_task_id: "B1.OFCI.2460"
    },
    {
      id: "b4e5b7c9-5a36-4201-8305-5ac89568c3ba",
      text: "(CFCI) Div. 05 - Structural Steel (Joists)",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 1096,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0.13,
      source_task_id: "7994925"
    },
    {
      id: "da7727f3-7935-47df-8cb9-6e5ff72654ac",
      text: "B1 - 1D1W - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1740"
    },
    {
      id: "8a748b1a-7e54-44d8-8a49-52cc3b117656",
      text: "B2 - 2B2 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-03-06T08:00:00",
      duration: 80,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1610"
    },
    {
      id: "5c2b6f42-df7a-474b-b875-c1e49e423264",
      text: "Set Cabinets & Millwork",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1250"
    },
    {
      id: "6da7e5b6-cf76-4f81-afdb-d45d765ec174",
      text: "B2 - DH-B - Install Tech Water - Data Hall B",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2540"
    },
    {
      id: "637f0fe1-a242-4e16-b1e0-807337669c04",
      text: "Area 5 - Sanitary Sewer Install (Pressure system)",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A5.8050"
    },
    {
      id: "6f8a9cb3-e013-459d-bc9e-aadfcae5194d",
      text: "Shell",
      type: 5,
      start_date: "2025-08-06T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 1304,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995104"
    },
    {
      id: "900c70c0-bb66-47df-812d-c9256f670df3",
      text: "FR 22 - DPR Prepare and Submit PCO#18 ( Zero $ CO)",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 344,
      parent: "6b393e4a-958e-4ac9-bb16-32b3eacbeb11",
      progress: 0.5,
      source_task_id: "FR.22.1010"
    },
    {
      id: "711361d7-7ffe-4250-ac6d-1ddc52dc54f3",
      text: "L3 Start EY2 - DCB1",
      type: 0,
      start_date: "2025-12-08T00:00:00",
      end_date: "2025-12-08T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2260"
    },
    {
      id: "99d743f0-19a5-450a-9923-5903819ebbee",
      text: "B1 - DH-C - Install Thermal Concrete",
      type: 0,
      start_date: "2025-03-31T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 120,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1590"
    },
    {
      id: "f36c53df-cfbe-48a6-b8b8-271d701046cd",
      text: "B1 - DH-A - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 160,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1920"
    },
    {
      id: "adb4861e-b395-4297-98a4-97a757b9a357",
      text: "B1 - 1C1W - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1060"
    },
    {
      id: "c5c2dcf7-42d9-45f7-9013-5a101d5931c8",
      text: "B2 - 2C2 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 160,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.5000"
    },
    {
      id: "08e587c5-6c00-4ed6-9d41-036e09563647",
      text: "Final Clean",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 24,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1110"
    },
    {
      id: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 24,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1230"
    },
    {
      id: "f47fcebd-ce11-4804-a0e4-6f2cb92f0ed3",
      text: "B1 - 1N2W - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1660"
    },
    {
      id: "414c2350-bebf-40c2-b2c0-1f263a0bc8ca",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1330"
    },
    {
      id: "9e08144e-63eb-4a7a-af34-eaa7b194218e",
      text: "B2 - SSB - 2E1 - Common - Install Wall Devices Electrical",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1310"
    },
    {
      id: "9519d4bf-014d-4593-997a-2437187fc868",
      text: "B1 - mCUP-1-9 - Foundations for Piping - Sequence 2",
      type: 0,
      start_date: "2024-12-21T00:00:00",
      end_date: "2025-01-17T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1010"
    },
    {
      id: "78e6e2d9-fc47-4f0a-a2ae-976706f06f5c",
      text: "B2 - DH-A - Install Underground Controls",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 80,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1270"
    },
    {
      id: "9b27af97-2fcb-4e8c-8c5c-c914e3cb7a7c",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2320"
    },
    {
      id: "d80f2375-2757-495a-bb7d-591996c35fcc",
      text: "BLDG-1/2 - Fabricate / Deliver - Security System",
      type: 0,
      start_date: "2025-01-24T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 320,
      parent: "d7b1b4ab-cbd4-4b4a-808b-511b0980ad59",
      progress: 0,
      source_task_id: "B1.CFCI.4920"
    },
    {
      id: "c222a7f2-1ef1-464a-9101-8a6b6dee3cea",
      text: "B2 - 2B2 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-03-11T08:00:00",
      duration: 24,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1800"
    },
    {
      id: "7e4d0455-701f-4f8d-9b1a-571e5c9a1fc5",
      text: "B2 - mCUP-6 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6050"
    },
    {
      id: "7e53c3fc-077a-469b-9bd3-28c013d7b1ae",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Fire Alarm",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1560"
    },
    {
      id: "0278e20e-1d9d-4cd2-b8ed-e0c44401b413",
      text: "B2 - 2A1 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 160,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1930"
    },
    {
      id: "ac1705ba-5c7a-4c3c-bfa1-a0bfa2e706a7",
      text: "B1 - SSB - 1E1 - Common - OH Rough In BMS",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1670"
    },
    {
      id: "95083085-3c7d-4cb9-9e03-25a54f77c6c9",
      text: "B1 - 1C1W - 01C.08 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.2360"
    },
    {
      id: "d3a2848f-d90d-4cf7-ad07-fea58ba4de43",
      text: "Area A - Install Door Frames",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 8,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1101"
    },
    {
      id: "5ffb2182-baa9-4dc7-a97d-027854ca168b",
      text: "BLDG-1/2 -  Fabricate / Deliver - SOG/SOMD/Pads Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 160,
      parent: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      progress: 0,
      source_task_id: "B1.CFCI.5660"
    },
    {
      id: "cf81abd6-5e91-4360-849d-fa9ececa96a1",
      text: "B1 - SSB - 1E2 - Common - Install Bathroom Accessories",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2260"
    },
    {
      id: "4982bc67-0975-4d17-ad40-e5601c7a3db7",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 80,
      parent: "82459529-b222-4604-bce3-f899e6205dbc",
      progress: 0,
      source_task_id: "MECO-1260.30"
    },
    {
      id: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      text: "FCA Gallery NW 2/3",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 576,
      parent: "f530bbb9-f449-4766-8257-53c5c9bcda64",
      progress: 0,
      source_task_id: "7995330"
    },
    {
      id: "3a1f2661-10c8-4f6c-99b3-2bb4ad934c0e",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 120,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2160"
    },
    {
      id: "ec0f34e5-946f-492c-a72e-105f868af682",
      text: "B2 - DH-B - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1100"
    },
    {
      id: "4bc3f1e6-fe3d-47d7-b115-a69c1ce2d288",
      text: "B1 - DH-C - Install Door/Hardware/ Wall Trim - Data Hall C",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2660"
    },
    {
      id: "a61a14d9-893d-4d6f-bd6c-6e40803b9ec9",
      text: "Fab and Deliver - Assembled Skids - Area D - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3232,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.21,
      source_task_id: "B1.OFCI.3230"
    },
    {
      id: "3de0d5dd-6df8-405d-9fb7-0b00ecead8b6",
      text: "B2 - DH-D - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area D",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-10T08:00:00",
      duration: 120,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "B2.C.EY.1290"
    },
    {
      id: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23",
      text: "B2 - 2C1 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-06-11T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 120,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2600"
    },
    {
      id: "53884058-3473-4eca-b10f-8002fe79b78a",
      text: "B2 - mCUP-1 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 48,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1210"
    },
    {
      id: "68a44023-5b0c-40f1-9ebc-de8169a80bba",
      text: "B2 - 2E1E - Corridor - Room Fit Out Activities - Set/Hook-Up Equipment",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 160,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5510"
    },
    {
      id: "bad44190-89b2-478f-8f04-a60acd514c39",
      text: "FR 08 - Area 2 - Telecom Install - DCI 3069 - Concrete Scope",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2024-12-12T08:00:00",
      duration: 40,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A2.8110"
    },
    {
      id: "04c38332-9bab-4f9e-ba02-cac3faefc964",
      text: "B2 - SSB - 2E2 - Common - OH Rough In BMS",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1660"
    },
    {
      id: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      text: "B1 - Network Room 1/4 - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-09-05T08:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 0,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1820"
    },
    {
      id: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      text: "Building 1 Paving",
      type: 5,
      start_date: "2025-01-14T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 2632,
      parent: "c673dffa-9349-4849-8685-f46d759d91be",
      progress: 0,
      source_task_id: "7995209"
    },
    {
      id: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      text: "Power Alley DH-B",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 680,
      parent: "70055513-b1cf-403a-b484-c8e2913ef6c0",
      progress: 0,
      source_task_id: "7995350"
    },
    {
      id: "e0fcef82-240d-47ff-9032-8c96d8374b78",
      text: "B2 - mCUP-8 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 48,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8080"
    },
    {
      id: "d888d97e-a902-4859-90aa-62bfc6839c88",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 24,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1810"
    },
    {
      id: "6ff70167-146a-4d1f-923e-828742b7551a",
      text: "B1 - Network Room 2/3 - Install Devices & Trim",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2100"
    },
    {
      id: "581a598c-7287-4fb8-9097-9ac1998a928c",
      text: "B1 - mCUP-1-9 - Equipment Set - (1)MVS, (1) Gen, (1)LB, (1)MGPC (ROJ CUP EL Equip)",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-02T08:00:00",
      duration: 80,
      parent: "0940dc8f-2121-4ca5-9917-93aa068b00ae",
      progress: 0,
      source_task_id: "B1.mCUP.9140"
    },
    {
      id: "e166fbbe-0127-454e-8ea8-1ce79e57dff8",
      text: "GSB - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "13271001-2e22-408b-be08-3d8849f2f6ba",
      progress: 1,
      source_task_id: "B2.OFCI.1350"
    },
    {
      id: "479b6606-d49b-4fe5-88c7-f4f4c95b0585",
      text: "B1 - OSP Cabling - CAV2 to IBOS (Temp) ((Starts after IBOS Shell Complete))",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 280,
      parent: "f25599a0-95e2-44be-82b5-e6c181abbae6",
      progress: 0,
      source_task_id: "B1.CONN.1260"
    },
    {
      id: "55f4d906-9c80-4f20-9f4b-b5e54b4e4999",
      text: "Painting - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5910"
    },
    {
      id: "3bccf6e3-3d99-4aae-8cf2-3bfb15ee06ef",
      text: "B2 - 2B2 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1160"
    },
    {
      id: "80fc92d8-19b9-4d59-a99f-fd12ecb81788",
      text: "B2 - 2E1E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5150"
    },
    {
      id: "48b2aa32-8dee-49d1-8676-0ed9ca62a1b8",
      text: "B1 - DH-D - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 40,
      parent: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      progress: 0,
      source_task_id: "B1.C.STR.2290"
    },
    {
      id: "a18e70a8-6c88-4a29-895f-a1271adb17a8",
      text: "Area B - Ceiling Rough-In MEPF",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1300"
    },
    {
      id: "d884d210-c31e-46e8-acf9-3a0714b9f8b7",
      text: "B1 - 1B2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 120,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2070"
    },
    {
      id: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      text: "Corridor 1C1W",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 816,
      parent: "e38ed0fa-2663-4b0c-bf48-30907319fe5a",
      progress: 0,
      source_task_id: "7995274"
    },
    {
      id: "c3d898a8-7b06-4e93-ad53-bf054d4e3567",
      text: "BLDG-2 - Building - Overall Duration - BG to CCO - (LOE)",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 6144,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0.06,
      source_task_id: "AUX.MILE.1490"
    },
    {
      id: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0",
      text: "B1 - DH-B - Set FCA's - Data Hall B",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1940"
    },
    {
      id: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe",
      text: "B1 - mCUP-2 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2070"
    },
    {
      id: "170e2595-2df7-4872-99b1-901f40cee5d8",
      text: "Area 2 - MV Electric Install - Priority for Foundations (Sub to MV Loop)",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-19T08:00:00",
      duration: 136,
      parent: "e9121d38-8b51-410e-9ddc-f5da5b002722",
      progress: 0,
      source_task_id: "C.CSU.A2.7000"
    },
    {
      id: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      text: "GS.IDF.2B3",
      type: 5,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 776,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "7995074"
    },
    {
      id: "ad0edfb7-03b7-4c07-9704-332acd6d612c",
      text: "B1 - SSB - 1E2 - Common - Install Door Frames",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1250"
    },
    {
      id: "a7837135-bdd2-4bfe-89ff-1893b6043c38",
      text: "Substation-1 - MSG B - Install Batteries",
      type: 0,
      start_date: "2025-06-14T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 40,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3620"
    },
    {
      id: "f8739406-778c-4e6c-84ff-82a093fb870d",
      text: "FR 07 - DPR Investigate & Identify Unsuitable Soil for bakfill @ Trailer City",
      type: 0,
      start_date: "2024-06-27T00:00:00",
      end_date: null,
      duration: 0,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 1,
      source_task_id: "FR.07.1000"
    },
    {
      id: "727beeb8-9c2e-415b-a8d1-70f5295d599c",
      text: "B1 - SSB - 1E1 - GSMDF1 - OH Rough In Sprinkler for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 40,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "B1.C.SSB.1230"
    },
    {
      id: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      text: "Corridor 1N1E (Spr Riser Rm/Control Rm/GS IDF (2)/ Flex Sp)",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 976,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995304"
    },
    {
      id: "5f2f5603-3a12-4e81-ac61-7f7035d70812",
      text: "FR 30 - Hurricane Helene - See weather events",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: null,
      duration: 32,
      parent: "4c402718-830a-4c9c-9cfa-044c255c93bf",
      progress: 1,
      source_task_id: "FR.30.1000"
    },
    {
      id: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      text: "(OFCI) B2 Electrical Skids",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 3496,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.3,
      source_task_id: "7994964"
    },
    {
      id: "f19d5158-9866-45eb-b654-7edfba9a5c6d",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2250"
    },
    {
      id: "b9151945-95b0-43a4-af2f-8451fe63034d",
      text: "Roofing",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 328,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 1,
      source_task_id: "PRE1460"
    },
    {
      id: "a5353429-464e-46c9-b140-7fdb60c1b19b",
      text: "FR 38 - IBOS-  Review and respond submittal",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: null,
      duration: 40,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "B1.CFCI.6590"
    },
    {
      id: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b",
      text: "L5 - NS+SSB",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 80,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX5.B1.NS.1010"
    },
    {
      id: "ec4b4b8f-a387-4529-a886-f917de362573",
      text: "B1 - Network Room 1/4 - Power Alley - Set MSB's (ROJ Skids)",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 40,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1690"
    },
    {
      id: "a1b545f6-4da5-4dba-835d-00872dffb2dd",
      text: "Busway - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-23T08:00:00",
      duration: 40,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 1,
      source_task_id: "B1.OFCI.1890"
    },
    {
      id: "5da618bd-dca9-404c-9bfa-3b7c3c5a0839",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Fire Sprinkler",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1470"
    },
    {
      id: "635fa1a3-4a0f-4e85-b7eb-69f8252fb9a7",
      text: "B1 - Network - Install Underground Security",
      type: 0,
      start_date: "2025-03-07T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 64,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1310"
    },
    {
      id: "9906626a-c957-4685-beaa-193160dab216",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2060"
    },
    {
      id: "699e4d53-5251-40a0-8fce-ab082119ae66",
      text: "Cx & Startup",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 432,
      parent: null,
      progress: 0,
      source_task_id: "8243678"
    },
    {
      id: "c1e92bd0-aeae-42bb-9459-8d0be7fc458c",
      text: "B1 - DH-C - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1160"
    },
    {
      id: "ea7b3771-f0f9-480b-bcff-1b4e6a8055b6",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2310"
    },
    {
      id: "31b5d869-779d-41ba-ac57-0632f9646f55",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-04-24T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1520"
    },
    {
      id: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f",
      text: "Substation-1 - Install Stone To Grade In Substation",
      type: 0,
      start_date: "2025-05-20T00:00:00",
      end_date: "2025-06-07T08:00:00",
      duration: 120,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3480"
    },
    {
      id: "57aac970-7973-491e-88bd-2da9e8d40785",
      text: "Area 3 - Storm Install (Mains)",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-10-04T08:00:00",
      duration: 184,
      parent: "2ef57594-c3a0-4778-9c25-a83690500ff9",
      progress: 0,
      source_task_id: "C.CSU.A3.3000"
    },
    {
      id: "228f20a5-2b33-492b-843c-2eabe2c8af8f",
      text: "Substation Circuit Breaker - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "dce7c311-c42c-460b-bd76-db76204a1acf",
      progress: 1,
      source_task_id: "B1.OFCI.1180"
    },
    {
      id: "e14086bf-aab1-4b81-b7b8-8508f0450ae1",
      text: "Area 3 - UG RI -Switchboard (SB)-DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1550"
    },
    {
      id: "80b4215f-4bf7-4208-a058-ee42428b0e2c",
      text: "Adverse Weather Event 18 - 11.11.2024",
      type: 0,
      start_date: "2024-11-11T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1018"
    },
    {
      id: "fe971848-aac2-4805-9abf-4ca6d613573c",
      text: "FR 39 - Review and Approve submittal for rebar",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 176,
      parent: "1f063521-b2a3-4b0d-838c-2b55c3f2085a",
      progress: 0,
      source_task_id: "FR.39.1010"
    },
    {
      id: "342f8138-4dc8-4da1-9348-431caf8de132",
      text: "B2 - DH-B - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 96,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2380"
    },
    {
      id: "00d8d983-10e1-40dc-a561-18003959c515",
      text: "B2 - 2E2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-12-26T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 8,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6110"
    },
    {
      id: "ed3c6361-1794-4939-becf-26ee70d23a50",
      text: "B2 - DH-B - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 40,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1310"
    },
    {
      id: "d96cd478-efd9-4133-9998-aaed95a88824",
      text: "B1 - 1N1E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1100"
    },
    {
      id: "faa908c4-84af-47f9-80d7-a6baf70394bd",
      text: "B1 - West Entrance - Install Main irrigation",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1030"
    },
    {
      id: "ffd4bc9f-42d8-4135-b878-f4d6139a1763",
      text: "Delivery of MVS - Medium Voltage Switches (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-03-10T08:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1825"
    },
    {
      id: "26bd51be-c0f5-4614-a707-3ab191556c9d",
      text: "DFSMA - DC1 EY-C Skids ROJ - MOFE",
      type: 0,
      start_date: "2025-09-17T08:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 0,
      parent: "993a33a9-ba19-4c70-87e9-c3247582ff68",
      progress: 0,
      source_task_id: "B1.DFSMA.1020"
    },
    {
      id: "adb3b71f-953f-4372-82df-5655ae3eba48",
      text: "B1 - DH-C - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 224,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1030"
    },
    {
      id: "9566e56d-838c-4033-8b4a-31aecb3b9dce",
      text: "FR 07 - DPR Prepare and Submit PCO#3",
      type: 0,
      start_date: "2024-07-03T00:00:00",
      end_date: null,
      duration: 488,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 0.5,
      source_task_id: "FR.07.1050"
    },
    {
      id: "d53ed77b-c3ef-4dbd-b6f6-d629c431ab2a",
      text: "B1 - mCUP-1-6 - Temp Power Hookup (Mobile Gen, 5 MW Temp Power to Equipment) for A/B/Network",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 40,
      parent: "2a30feef-09ac-419f-b924-97c80bbf1474",
      progress: 0,
      source_task_id: "B1.mCUP.9180"
    },
    {
      id: "22f7f124-57e8-4e8a-9a03-b51ea65b5a91",
      text: "Fragnet 35 - PCO # 36 CSI-046 V6 Site Signage Standards",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 544,
      parent: null,
      progress: 0.5,
      source_task_id: "8690695"
    },
    {
      id: "7004f583-46a7-40f1-8bfa-da5a4ea0707f",
      text: "B1 - 1D1W - 01D.09 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2220"
    },
    {
      id: "8855a153-2324-48fc-9f24-01a929f6553d",
      text: "SSB2 (Area 2-E and 2-F)",
      type: 5,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 720,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994781"
    },
    {
      id: "e147c76a-f21b-4eba-9050-9691792881f1",
      text: "B2 - SSB - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 40,
      parent: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      progress: 0,
      source_task_id: "B2.C.STR.2020"
    },
    {
      id: "fd4a671c-7efc-4d4e-bf32-7236ea165132",
      text: "B1 - mCUP-3 - L2 Inspections",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3130"
    },
    {
      id: "f06e8202-a6e3-4d75-841c-ebac8691367d",
      text: "B1 - SSB - 1E2 - EF2 - Build Wall Between MDF/Fiber Entry and Carrier (EF2)",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 48,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1400"
    },
    {
      id: "cc0ede26-d81e-497d-8e4b-e86693d37ff1",
      text: "Campus - Submittal Rvw/App'l -  Sanitary Manholes and Inlets (Early Release) - Area 4 & 5",
      type: 0,
      start_date: "2024-06-07T00:00:00",
      end_date: "2024-06-10T08:00:00",
      duration: 16,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.6020"
    },
    {
      id: "40afa46f-847a-4149-82c6-51d41091e614",
      text: "Substation-2 - B Lineup SF6 Breaker - NETA Testing (Control Cabling)",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 120,
      parent: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4570"
    },
    {
      id: "86b69653-a985-4a89-89b3-dea26bfa0490",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 16,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1290"
    },
    {
      id: "75b6388a-59b7-4d32-9f21-f50d2281bccf",
      text: "DEC-C Ready: OSP Pathways",
      type: 5,
      start_date: "2025-10-10T08:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 376,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995437"
    },
    {
      id: "141eb1c4-05d8-40d1-8f58-00736f1e4575",
      text: "B2 - DH-C - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 80,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1230"
    },
    {
      id: "2a22d0ce-4cea-4e73-81a6-13750bda9164",
      text: "Substation-2 - MSG A - Control Power And EPMS Dead Bus Checkout",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 80,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4800"
    },
    {
      id: "14d9c290-1711-4bef-9b8b-2bf6c1ec2076",
      text: "B1 - DH-A - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 264,
      parent: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      progress: 0,
      source_task_id: "B1.C.STR.1780"
    },
    {
      id: "ac98d0ce-e79b-4c47-8a7a-893379ff16c4",
      text: "OH Plumbing",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1150"
    },
    {
      id: "e78ba449-11b3-432e-87b3-d70f9eb5fc1b",
      text: "B2 - mCUP-1-8 - Piping POC's, Devices, final dress out (Fill and Flush Building) (sequence 2)",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1310"
    },
    {
      id: "e9f0975b-776e-4c34-965f-6c0916711e31",
      text: "Busway - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 1,
      source_task_id: "B1.OFCI.1880"
    },
    {
      id: "565e9aa9-3c11-473e-a494-f38925a3b1f9",
      text: "Substation-1 - MSG B - MV Terms / NETA Testing / Torques (Finish 03/01/25)  -Sequence 1",
      type: 0,
      start_date: "2025-06-07T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 120,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3640"
    },
    {
      id: "6cf1677c-66bc-43c1-a4c4-22794e9d686d",
      text: "B2 - DH-C - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1090"
    },
    {
      id: "68737a55-5604-4051-a3c2-9733d3720cc6",
      text: "UPS Room 02D.09",
      type: 5,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-07-22T08:00:00",
      duration: 520,
      parent: "dfc16b55-f1f0-4fea-b940-c09ea7840d80",
      progress: 0,
      source_task_id: "7995060"
    },
    {
      id: "5e97ad4e-c7d3-4531-b560-aaab3e9ab2dc",
      text: "Campus - Site Mobilize for Site Utilities",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-07-29T00:00:00",
      duration: 0,
      parent: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      progress: 0,
      source_task_id: "C.CSW.3070"
    },
    {
      id: "69357612-7698-4d38-a13b-fb7c4231a12b",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 80,
      parent: "7ff8625a-dc89-41f6-8d33-dd61dacc1595",
      progress: 0,
      source_task_id: "MECO-1260.40"
    },
    {
      id: "7cb0c710-fd70-44f4-9524-2948ee09818e",
      text: "B1 - 1N1W - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 160,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5600"
    },
    {
      id: "2ba2b7e0-2211-4698-8c1c-2b8867193aa1",
      text: "L4 - B2 DHD - Server Migration",
      type: 0,
      start_date: "2027-03-18T00:00:00",
      end_date: "2027-03-19T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHD.1010"
    },
    {
      id: "2785ff53-c134-47fa-975d-29f89716444e",
      text: "B2 - DH-B - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1110"
    },
    {
      id: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2025-11-01T00:00:00",
      end_date: "2026-01-17T08:00:00",
      duration: 400,
      parent: "984b19cb-e113-48d8-94eb-b3babf498cee",
      progress: 0,
      source_task_id: "7995110"
    },
    {
      id: "9b3fcf84-ebdc-44c5-8288-08c89b726dc7",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 8,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1470"
    },
    {
      id: "ea8107ab-5871-4674-8df5-cc5109519d9c",
      text: "Area B - Final Paint",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1420"
    },
    {
      id: "c479cdbf-674e-411b-bee8-0067bd583957",
      text: "B2 - 2B2 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 160,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2470"
    },
    {
      id: "19fc44d1-990d-4df1-9b0f-fec1d2c5ae56",
      text: "B2 - DH-B - Install  Balance of Grade Beams",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 80,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1300"
    },
    {
      id: "effd8d58-dc6c-49f8-badf-8daf3e609d1e",
      text: "B2 - DH-A - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for MCUP's",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 120,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1410"
    },
    {
      id: "939f2d2f-9c77-474d-b9a6-3e35e6465e46",
      text: "ADMIN/ IBOS - Fabricate / Deliver Speciality doors and dock levelers",
      type: 0,
      start_date: "2024-11-05T00:00:00",
      end_date: "2025-01-30T08:00:00",
      duration: 480,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6350"
    },
    {
      id: "8a69e383-0c26-404f-9dfa-f2a8f7ec976f",
      text: "B1 - DH-A - Install IMP Walls @ FCAs - Data Hall A",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1840"
    },
    {
      id: "5def9170-b350-4622-a43d-e617cf2bdb35",
      text: "B1 - DH-B - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1260"
    },
    {
      id: "21f942e1-8dbf-41ab-83c3-e410d4fa5303",
      text: "B2 - 2C1 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1160"
    },
    {
      id: "a3d7c350-e71f-4d12-ab22-6f97980e44a0",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Glass / Frames",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: "2024-11-27T08:00:00",
      duration: 120,
      parent: "d80cc1a6-c3ae-4d12-a355-ea20aea6ef84",
      progress: 0,
      source_task_id: "B1.CFCI.5700"
    },
    {
      id: "a461c134-264e-4357-8a77-152b8d6b18bc",
      text: "IBOS  - Submittal Rvw/App'l - Storage racks",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6430"
    },
    {
      id: "9aa3f311-7aea-4316-b271-f42583a49cac",
      text: "UPS Room 01N2.06",
      type: 5,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 480,
      parent: "fffebd98-3b92-4cb0-8da1-ac9af78bfdfe",
      progress: 0,
      source_task_id: "7995337"
    },
    {
      id: "a203770b-2c7b-4121-a8f4-84dd5e8b7563",
      text: "L3 Finish DH C - DCB2",
      type: 0,
      start_date: "2027-02-02T08:00:00",
      end_date: "2027-02-02T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2031"
    },
    {
      id: "249c258f-1cb8-4b3a-81d3-40dec86f5a74",
      text: "Substation-2 - MSG A - MV Terms / NETA Testing  (Finish 03/01/25)",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 160,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4780"
    },
    {
      id: "6191853a-f77e-4cdd-9990-30406c40f60e",
      text: "Install Windows",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1130"
    },
    {
      id: "83c41607-7a7e-4117-b19b-40dda9367b03",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2200"
    },
    {
      id: "fa68af35-930e-48ed-894d-e96babd97b0a",
      text: "BLDG-1/2 - Prep / Submit for Rvw - Structural Steel (Revision)",
      type: 0,
      start_date: "2024-09-27T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0.75,
      source_task_id: "B1.CFCI.6460"
    },
    {
      id: "1334ee80-382b-43bf-ac73-bccd0e86b5d0",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Exterior Louvers (w Ext Metal Panel Trade)",
      type: 0,
      start_date: "2025-02-06T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 120,
      parent: "7c2bce29-42fa-46b1-ad31-bfb1a0d53148",
      progress: 0,
      source_task_id: "B1.CFCI.3810"
    },
    {
      id: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55",
      text: "[DCB1] DEC-C Ready: OSP Pathways [ADMIN]",
      type: 0,
      start_date: "2025-09-05T08:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3695"
    },
    {
      id: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      text: "B1 - SSB - Precast",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 80,
      parent: "2ecb081b-e19d-4804-8346-6399c432d164",
      progress: 0,
      source_task_id: "B1.C.1550"
    },
    {
      id: "c3c6b00c-aba4-42a3-ab4d-ff382e606bf4",
      text: "B2 - mCUP-1-8 - Piping Install (Header Tie-in)",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 120,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1150"
    },
    {
      id: "838f5bd8-994a-4a5d-bae5-0954ba298079",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 24,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1930"
    },
    {
      id: "a22556d9-2392-4203-ae05-8629494d46e2",
      text: "B2 - DH-B - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 120,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1080"
    },
    {
      id: "ce1318c2-0edb-4778-a5be-445c057c5c34",
      text: "Substation-1 - TX B - Assemble Transformer",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-19T08:00:00",
      duration: 160,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6320"
    },
    {
      id: "5445f859-45b4-4d33-9dea-8152ccaff85d",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area C (16) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2576,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.46,
      source_task_id: "B1.OFCI.2590"
    },
    {
      id: "de6524fb-70fe-4f74-b325-71d879d3578a",
      text: "Building 1",
      type: 5,
      start_date: "2026-03-12T08:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 1448,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "7995420"
    },
    {
      id: "6081ef3c-ed0c-4d75-a06b-58a6d25aaa0c",
      text: "BLDG-1/2 - Submittal Rvw/App'l - HVAC Insulation",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 120,
      parent: "8901a989-4c49-4864-834a-2a9756542651",
      progress: 0,
      source_task_id: "B1.CFCI.3600"
    },
    {
      id: "ec71d562-c41f-41f7-8958-27cf0c3f9758",
      text: "B2 - SSB - 2E2 - Common - Final Paint",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 80,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1880"
    },
    {
      id: "95eb0fe7-ed5b-4955-8712-6580cda3dbbc",
      text: "B2 - 2D1W - 02D.08 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1820"
    },
    {
      id: "a74b62a7-d2ed-4f7b-8fab-77c511632bc3",
      text: "Fab and Deliver - HMD - Area C - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3408,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.35,
      source_task_id: "B1.OFCI.3200"
    },
    {
      id: "e246861c-bbe9-4cbe-8eba-3fc48c057f33",
      text: "B2 - DH-C - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 80,
      parent: "7e2c4263-df53-41a3-b764-1e6e272793de",
      progress: 0,
      source_task_id: "B2.C.EY.1470"
    },
    {
      id: "1059ad87-58a7-4254-961d-6b8c554600b4",
      text: "STC - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 1,
      source_task_id: "B2.OFCI.1390"
    },
    {
      id: "c80a95d0-5594-4d76-bf5d-7c39d721f499",
      text: "B1 - Network Room 2/3 - Power Alley - Hang/Finish Inside Electrical Room",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 96,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1170"
    },
    {
      id: "20f6d1cb-8203-4b13-852f-6380bf8c61c9",
      text: "PLC Panels - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-03-13T08:00:00",
      duration: 176,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 1,
      source_task_id: "B2.OFCI.1250"
    },
    {
      id: "a24f30ab-263c-48ad-959f-c303e52b0b1f",
      text: "Area B - In-Wall Rough-In Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1540"
    },
    {
      id: "a03f2772-5c32-4dfe-9f8e-b000e9f5edfe",
      text: "Overhead Mechanical, Install Equipment",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1030"
    },
    {
      id: "4700a17a-41de-4d09-932d-646af5bef852",
      text: "B1 - DH-A - Hookup FCAs Electrical- Data Hall A",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2130"
    },
    {
      id: "c01ca0f6-d7a1-4fdc-9d49-f9b9e368b240",
      text: "B1 - DH-B - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 192,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2420"
    },
    {
      id: "49440b47-47f9-40a5-b79a-ea55f1afb5f9",
      text: "Fab and Deliver - HMD - Area C - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 3688,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 0.35,
      source_task_id: "B2.OFCI.2610"
    },
    {
      id: "e8f16f4e-82dd-4998-918c-85a10065862f",
      text: "B2 - DH-C - Install Feeder Conduit -Data Hall C",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2270"
    },
    {
      id: "e07b437e-c887-4bac-85aa-e0c6b6ca5494",
      text: "B1 - DH-C - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1810"
    },
    {
      id: "55638641-d157-42f2-83ac-2827272165c1",
      text: "Fab and Deliver - Assembled Skids - Area C - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 3056,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.27,
      source_task_id: "B1.OFCI.3130"
    },
    {
      id: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      text: "Corridor 1D1W",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 816,
      parent: "8b063fd8-f4b7-446c-8f75-0d37bdf1593d",
      progress: 0,
      source_task_id: "7995316"
    },
    {
      id: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      text: "B1 - 1C2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 24,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1220"
    },
    {
      id: "156f3f89-7f51-4185-ab88-1801febc7c30",
      text: "FR 04 - META review and respond to RFI #255",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: null,
      duration: 64,
      parent: null,
      progress: 0.25,
      source_task_id: "FR.04.1050"
    },
    {
      id: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      text: "Substation-1 Transformer A Work",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 1064,
      parent: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      progress: 0,
      source_task_id: "7995242"
    },
    {
      id: "4a121ac5-3f0c-4f5d-a5e9-a4f821e0ee48",
      text: "Pad Ready for Substation (Substation 1)",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-09T00:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "ICM.G1.1052"
    },
    {
      id: "7df11e13-587a-460a-bcd6-cfdd73630988",
      text: "B2 - 2E2E - 02.01.E2.01 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6330"
    },
    {
      id: "3458751c-652e-4bca-a6eb-75a1f58feb41",
      text: "Data Hall D (Area 1-D)",
      type: 5,
      start_date: "2024-09-12T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 760,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994817"
    },
    {
      id: "dcd062f4-fb1c-4c80-aed9-5b61f82b637f",
      text: "B2 - DH-A - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1180"
    },
    {
      id: "10e6894b-4c13-4324-81c1-6839443e5099",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1530"
    },
    {
      id: "6b903073-2098-4b98-9550-1e7bdbdc6268",
      text: "Final Punch - B1 DHA & DHB",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 40,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHA.1010"
    },
    {
      id: "a2312a1a-59ba-4a5a-abcd-1caa5a1c9d79",
      text: "B2 - SSB - 2E1 - Common - Install Wall Devices BMS",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1330"
    },
    {
      id: "4c752bc7-d400-4200-90d3-25e9a3d0b97c",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1180"
    },
    {
      id: "b5a863b2-12c4-4e4d-9a64-73202f721fe9",
      text: "Campus - Construct Permanent Campus Roadways / Lighting - Sequence 3",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 288,
      parent: "26327ae0-6c90-4f36-b131-6ebdf49b7bd8",
      progress: 0,
      source_task_id: "C.SI.RW.1180"
    },
    {
      id: "f49c2121-73ed-4027-ae56-8e5ab2a49dd4",
      text: "Meta Project Milestones",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2027-03-09T08:00:00",
      duration: 5800,
      parent: "5f1ffaa6-2f9b-4373-bdf7-e99300bec629",
      progress: 0.06,
      source_task_id: "7995422"
    },
    {
      id: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      text: "Area 3 - Telecom Install - DCI 3069",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 40,
      parent: "dc323cfb-a17f-4b05-bebd-630fcd98848f",
      progress: 0,
      source_task_id: "C.CSU.A3.8020"
    },
    {
      id: "670f46f4-216e-4ce2-9f76-1b88030ef283",
      text: "DFSMA - DC1 DHB HAC ROJ - MOFE",
      type: 0,
      start_date: "2025-09-23T08:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 0,
      parent: "86efc612-6e21-491b-98fc-5aba04020712",
      progress: 0,
      source_task_id: "B1.DFSMA.1100"
    },
    {
      id: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830",
      text: "L3 Start DH A - DCB2",
      type: 0,
      start_date: "2026-09-09T00:00:00",
      end_date: "2026-09-09T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2000"
    },
    {
      id: "75e5eb31-9aa7-4c4f-a9ca-c1cc2b77ac85",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [8] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-21T08:00:00",
      duration: 2672,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.39,
      source_task_id: "B1.OFCI.3540"
    },
    {
      id: "ca21d338-b1a3-4b67-a07e-26057f0500ec",
      text: "B2 - SSB - 2E2 - Common - Install Security Devices",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 80,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1790"
    },
    {
      id: "29780aac-acd2-4b70-9cd5-95958495ea22",
      text: "FR 09 - META review and Approve PCO#5",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 80,
      parent: "64c1284c-d6e1-4add-b5b3-bc6e1e9a4b2b",
      progress: 0,
      source_task_id: "FR.09.1030"
    },
    {
      id: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39",
      text: "Substation-1 - MSG B - MSG A Neta Testing",
      type: 0,
      start_date: "2025-05-15T00:00:00",
      end_date: "2025-06-07T08:00:00",
      duration: 152,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3600"
    },
    {
      id: "695605b9-4f22-47f3-b7ea-fd59871d34cd",
      text: "B1 - mCUP-2 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2100"
    },
    {
      id: "334732a6-1994-490c-9503-c812c26050b9",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1950"
    },
    {
      id: "cca3496f-2fd3-4614-954b-6ae9bb9daaf7",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1350"
    },
    {
      id: "ce2feedb-ff89-43ca-8110-742692dd5e83",
      text: "Substation-1 - MSG A - Pre-energization MSG A and DC System / Battery Commissioning - Sequence 2",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 48,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6250"
    },
    {
      id: "6a94fee7-ba3b-43f6-aa22-37ca9bf2ad58",
      text: "B1 - DH-D - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1670"
    },
    {
      id: "c12fa46c-dd0b-4715-8b99-14c14ff991e9",
      text: "Fab and Deliver - Fan Coil Assembly - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-05-06T08:00:00",
      duration: 2640,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.43,
      source_task_id: "B1.OFCI.2680"
    },
    {
      id: "4af56416-33e5-4482-a9d7-8d52e2548a47",
      text: "Shell - IBOS (LOE)",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 480,
      parent: "597c58ac-895e-4e33-99f0-0adcfe2d7e72",
      progress: 0,
      source_task_id: "IBOS.CON.1020"
    },
    {
      id: "531958eb-590d-4be5-9f25-a31225006c24",
      text: "B1 - SSB - 1E2 - Common - Prime and 1st Coat Paint",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1360"
    },
    {
      id: "e02d6c98-f81c-4483-8a13-8fc9cd587557",
      text: "HTF Walls / Ceilings / Install Plywood",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 56,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1010"
    },
    {
      id: "d99e4cba-a6ef-4244-a0f1-5cb8ee810452",
      text: "Campus - Pre-Submittal Coordination - Fencing",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2024-12-20T08:00:00",
      duration: 8,
      parent: "2390c294-1245-4d73-85bc-b779088085b9",
      progress: 0,
      source_task_id: "B1.CFCI.3760"
    },
    {
      id: "66f9bb26-894e-45a5-aff0-4d0a73e0bb84",
      text: "B2 - DH-D - Install Celing Devices Security - Data Hall D",
      type: 0,
      start_date: "2026-08-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2580"
    },
    {
      id: "68ecaf80-c642-4843-bc39-d61797959061",
      text: "B1 - Network - El Equip Yd - Set Equipment (4)MVS, (16)PTX",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 80,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1020"
    },
    {
      id: "b3dab331-6be3-4bcf-b102-be811f56d448",
      text: "Design Team Address Comments & Re-Submit - Building Permits",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-10-17T00:00:00",
      duration: 80,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 0,
      source_task_id: "PRE-DD-1060"
    },
    {
      id: "73ecfbec-c9c6-4c5d-8356-d669e1b485e4",
      text: "B2 - 2C1 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1140"
    },
    {
      id: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      text: "UPS Room 01C.07",
      type: 5,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 480,
      parent: "e38ed0fa-2663-4b0c-bf48-30907319fe5a",
      progress: 0,
      source_task_id: "7995275"
    },
    {
      id: "1d314deb-145a-4291-845c-6265c36e459a",
      text: "[DCB2] DEC-C Ready: General Services [Area A]",
      type: 0,
      start_date: "2026-05-20T08:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 0,
      parent: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      progress: 0,
      source_task_id: "ICM.B2.3725"
    },
    {
      id: "a75f0222-f046-45cc-bfbb-a63b05868be4",
      text: "BLDG-1/2 - Prep / Submit for Review - Power Equipment and Material",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-07-22T08:00:00",
      duration: 312,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0,
      source_task_id: "B1.CFCI.3430"
    },
    {
      id: "11758442-99fc-4cb5-92f0-2e4875d8c296",
      text: "Install Metal Panels/Skin - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "A1020"
    },
    {
      id: "a3b051f5-2345-4b02-b5b9-adf72c69821d",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Electrical",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1150"
    },
    {
      id: "46a19152-5ebc-47d3-89d8-887c11a3eae2",
      text: "B2 - 2E1E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 160,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5250"
    },
    {
      id: "64d5abea-2873-4e85-a875-c54e7d27d9da",
      text: "B2 - DH-A - Connect Buss/Cable Tray Sections - Data Hall A",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2450"
    },
    {
      id: "4dadaa5f-d684-4b2f-aec6-3914fa7b00ed",
      text: "Admin - Fabricate / Deliver - Lighting",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 640,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1000"
    },
    {
      id: "7fcec3d5-a52c-46a2-afc9-d813553836a9",
      text: "B1 - DH-C - Pull/Term Fire Alarm - Data Hall C",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2540"
    },
    {
      id: "483eca18-28d5-4caf-9111-a35672f93c2d",
      text: "B2 - 2E1E - Corridor - OH Rough In Feeder",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5060"
    },
    {
      id: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      text: "BLDG-1 SSB 1E1 Common Area Buildout",
      type: 5,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1360,
      parent: "c6a66845-9cdf-419f-bc39-f7cbf2425030",
      progress: 0,
      source_task_id: "7995290"
    },
    {
      id: "179e7c68-1cbb-4287-97a9-aec294a036f2",
      text: "iGMP Submission to Meta",
      type: 0,
      start_date: "2024-06-10T08:00:00",
      end_date: "2024-06-10T08:00:00",
      duration: 0,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "ICM.PRE.1520"
    },
    {
      id: "cd03450e-e8ed-4b51-8939-8deb3f7b6575",
      text: "Substation-2 B Lineup Vertical Work",
      type: 5,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 320,
      parent: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      progress: 0,
      source_task_id: "7995223"
    },
    {
      id: "1d774fb8-f7a8-45be-bc31-db78a42907c8",
      text: "Fab and Deliver - Cooling Distribution Unit - Area C - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 4464,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 0.05,
      source_task_id: "B2.OFCI.1920"
    },
    {
      id: "c2937076-4e17-428c-9265-039cc7bc1a3a",
      text: "B2 - 2E2E - 02.01.E1.02 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 144,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6460"
    },
    {
      id: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      text: "B1 - mCUP-1 - Set/Assemble mCUP Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 48,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1190"
    },
    {
      id: "7b140ea3-c90d-45a4-b6db-bca1df5fafff",
      text: "Campus - Fabricate / Deliver - Asphalt / Paving",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 128,
      parent: "ecc051e0-d5dd-471f-94c9-13123cf5d74b",
      progress: 0,
      source_task_id: "B1.CFCI.5270"
    },
    {
      id: "f1623286-778b-4ba2-8a13-427cb953b423",
      text: "B2 - DH-B - Hookup FCAs Electrical- Data Hall B",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 192,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2550"
    },
    {
      id: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      text: "BLDG-2 - BIM - Tier 0 - Area 2-E / 2-F - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 240,
      parent: "8855a153-2324-48fc-9f24-01a929f6553d",
      progress: 0,
      source_task_id: "B2.VDC.1020"
    },
    {
      id: "7d49411b-461e-4953-a7b5-2016d23aba05",
      text: "B1 - mCUP-8 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8110"
    },
    {
      id: "c8a2d86c-c399-47b0-b74f-79311fc5e34b",
      text: "B1 - DH-C - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      progress: 0,
      source_task_id: "B1.C.C.3120"
    },
    {
      id: "74ee1cf2-98e1-40e1-8689-20385d55fcf0",
      text: "[DCB1] DEC-C Ready: Overhead cable tray complete [Area B]",
      type: 0,
      start_date: "2026-01-27T08:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3835"
    },
    {
      id: "78efea14-0b1b-4c66-88e4-582fdf00a3c9",
      text: "BLDG-2 DH-C - Equipment Final Clean",
      type: 0,
      start_date: "2026-10-14T00:00:00",
      end_date: "2026-11-03T08:00:00",
      duration: 120,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1080"
    },
    {
      id: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      text: "B1 - DH-D - Power Alley - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-10-31T08:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 0,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1620"
    },
    {
      id: "677df6e9-5929-42e4-b67e-3f5eae9ee718",
      text: "B2 - DH-A - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 192,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2100"
    },
    {
      id: "0dfba42c-1508-428c-9ce2-6df1c46ebea7",
      text: "B1 - DH-C - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 40,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1780"
    },
    {
      id: "dd597037-1f8d-46e0-b78b-c620a11d3f59",
      text: "[DCB1] DEC-C Ready: General Services [Area C]",
      type: 0,
      start_date: "2026-01-15T08:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3745"
    },
    {
      id: "bce9e531-f801-41ab-a447-17ec45e8b2b8",
      text: "B1 - 1D1W - 01D.09 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2310"
    },
    {
      id: "fadfcd2f-b166-497c-9caf-b6b2663459aa",
      text: "Load Bank - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "2c21e476-2412-4ed5-8c8a-27650481107d",
      progress: 1,
      source_task_id: "B1.OFCI.1640"
    },
    {
      id: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf",
      text: "BLDG-2 - BIM - Tier 0 - Area 2-B - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 240,
      parent: "18d840dc-fbca-4944-bbc5-73c1783bea63",
      progress: 0,
      source_task_id: "B2.VDC.3110"
    },
    {
      id: "12341272-656d-49a0-bde9-1c5644f96ab4",
      text: "Pad Prep / Deep Foundations - Admin",
      type: 0,
      start_date: "2024-11-26T00:00:00",
      end_date: "2024-12-04T08:00:00",
      duration: 40,
      parent: "56854237-ebdf-4446-8f94-9f575bfa1fbf",
      progress: 0,
      source_task_id: "C.CSU.A1.1020"
    },
    {
      id: "7f1ef01b-90b6-4b68-b020-7e6586ec3bf0",
      text: "B1 - DH-D - Install IMP Ceiling - Data Hall D",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1120"
    },
    {
      id: "af4069ae-940a-4275-a19a-93e19b691a7c",
      text: "B2 - mCUP-7 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 48,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7040"
    },
    {
      id: "2645519a-3380-412c-8fac-33e4f25a07b3",
      text: "B2 - 2C2 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 80,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2090"
    },
    {
      id: "9b392fd7-450f-4ead-a14e-cec5e6b13630",
      text: "[DCB1] DEC-C Ready: General Services [Area B]",
      type: 0,
      start_date: "2025-12-16T08:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3735"
    },
    {
      id: "4c2d79a0-af18-4343-9bc6-6ca945d19d60",
      text: "B2 - DH-C - Install BMS Conduit -Data Hall C",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2360"
    },
    {
      id: "3dc9e2db-503d-47a6-bb0d-9c66b3706040",
      text: "B1 - DH-A - Install Lighting/Branch Conduit -Data Hall A",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2430"
    },
    {
      id: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      text: "Cx DATA HALLS",
      type: 5,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 1320,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995010"
    },
    {
      id: "8d5fb61f-0ece-4bfc-b3ba-13b0a0019d93",
      text: "FR 35 - DPR prepare and Submit RFI #84",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "22f7f124-57e8-4e8a-9a03-b51ea65b5a91",
      progress: 1,
      source_task_id: "FR.35.1000"
    },
    {
      id: "6b5b20e6-eae6-4586-876c-268c1bed6382",
      text: "FR 34 - DPR Prepare and Submit PCO#35",
      type: 0,
      start_date: "2024-10-08T00:00:00",
      end_date: null,
      duration: 72,
      parent: "883427a6-7812-434c-b7bc-0738a53a7b23",
      progress: 1,
      source_task_id: "FR.34.1020"
    },
    {
      id: "33b65098-085e-400d-9d1a-636057e978d8",
      text: "Early Network Provisioning Release Achieved (Network/SSB Early turnover)",
      type: 0,
      start_date: "2026-07-06T08:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 0,
      parent: "343acf74-d115-412c-91e3-d35be32f0404",
      progress: 0,
      source_task_id: "CX.MIL.1060"
    },
    {
      id: "68109eb2-d4ef-4ebc-bda2-fe55a2411ebd",
      text: "Fab and Deliver - Cooling Distribution Unit - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2026-03-03T08:00:00",
      duration: 4112,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 0.08,
      source_task_id: "B2.OFCI.1910"
    },
    {
      id: "18034876-d990-48c1-a98b-f345b9729865",
      text: "B1 - 1N2E - 01N3.06 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 144,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6210"
    },
    {
      id: "3156c477-6cd0-4d4d-bf56-ec3ccf1e4eac",
      text: "BLDG-2 - BIM - Tier 1 - B2 - Precast -Coordination / Sign-off",
      type: 0,
      start_date: "2024-10-16T00:00:00",
      end_date: "2024-12-18T08:00:00",
      duration: 560,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "B2.VDC2.2290"
    },
    {
      id: "21ff1dd1-9520-42c0-b896-1be5ba21b0dd",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Interior Expansion Joints (Spec 07 95 13.13)",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-01-16T08:00:00",
      duration: 120,
      parent: "f068736c-3c4a-473c-8c98-6ef859973fe0",
      progress: 0,
      source_task_id: "B1.CFCI.4850"
    },
    {
      id: "ff9c50c7-6273-48ce-82d9-04a35f1eba15",
      text: "B2 - 2D2 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 80,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1570"
    },
    {
      id: "c5614c28-3f86-4810-9254-86e0fa00afde",
      text: "B2 - DH-C - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 40,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1540"
    },
    {
      id: "7b264714-6639-42fb-acf6-d10033c7e16b",
      text: "B1 - mCUP-9 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9110"
    },
    {
      id: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      text: "DH-A",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2026-01-12T08:00:00",
      duration: 1152,
      parent: "a8ee1bd4-65c3-4e10-beab-79fa57b9ff73",
      progress: 0,
      source_task_id: "7995301"
    },
    {
      id: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      text: "BLDG-1 SSB 1E2 Entrance Facility 2",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 296,
      parent: "317fedf3-4445-4d48-b19e-75107c7c0568",
      progress: 0,
      source_task_id: "7995295"
    },
    {
      id: "242ad192-a9a1-4973-bc98-024e62b03340",
      text: "Site / Civil",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 592,
      parent: "b36bc5ee-f112-4677-a654-d4337c07b419",
      progress: 0.92,
      source_task_id: "7994749"
    },
    {
      id: "797a59a1-c2e0-4669-96f6-3f1509ffd9d8",
      text: "B2 - 2E2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6020"
    },
    {
      id: "e6271eaf-ae4f-4e57-95e8-73e39245e53c",
      text: "B1 - DH-D - L2 CDU Install Verification - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-04-13T08:00:00",
      duration: 144,
      parent: "4e59b52c-1f38-413f-b50f-c638d57eaa94",
      progress: 0,
      source_task_id: "B1.C.D.3200"
    },
    {
      id: "14424aa9-97fa-4efb-94e1-46697b93c640",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1680"
    },
    {
      id: "aaa0fbd3-c982-483f-83c9-aa6fc59b7f97",
      text: "SSB1 (Area 1-E and 1-F)",
      type: 5,
      start_date: "2024-06-17T00:00:00",
      end_date: "2024-10-29T08:00:00",
      duration: 760,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0.05,
      source_task_id: "7994812"
    },
    {
      id: "09ab5321-6148-4313-a3a2-5c604a97f59a",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1310"
    },
    {
      id: "30e50962-fde1-4a10-8d76-ded8acad144f",
      text: "Area A - In Wall Rough Electrical",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1530"
    },
    {
      id: "1147ef4b-730a-4cf4-a6d8-00685d32e299",
      text: "B1 - SSB - 1E1 - GSMDF1 - OH Rough In for Ductwork, Elec, Vesda GS-MDF Skid",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 80,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "B1.C.SSB.1120"
    },
    {
      id: "ee41aa4a-6e7e-4641-bd29-b9c3facf6a2e",
      text: "B2 - 2E1E - EF3 - Pour Pads Around Telecom Conduits (EF3)",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 48,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5200"
    },
    {
      id: "0f5ed88f-713f-41ca-9c17-a38491a57787",
      text: "Weather/Construction Bank - Bldg 1 C & D S/C Fdn st (1) to L3 start + 5 days for Cx (Original 30 -5 = 25)",
      type: 0,
      start_date: "2026-09-02T00:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 240,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX1.DHD.WB.0020"
    },
    {
      id: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      text: "FCA Gallery DH-D",
      type: 5,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-09-22T08:00:00",
      duration: 728,
      parent: "4fa3accc-c8b6-477e-8cfb-161dd5586af2",
      progress: 0,
      source_task_id: "7995065"
    },
    {
      id: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62",
      text: "B1 - Network - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-05-14T00:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 80,
      parent: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      progress: 0,
      source_task_id: "B1.C.STR.1980"
    },
    {
      id: "3629411e-29c8-40a6-97e6-4f6f01e9cecb",
      text: "B2 - SSB - 2E1 - Common - Install Wall Devices Fire Alarm",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1320"
    },
    {
      id: "4d7f99a1-a653-43bf-b87f-5b8e20378bdb",
      text: "Construction Milestones",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2026-11-12T08:00:00",
      duration: 5184,
      parent: "f49c2121-73ed-4027-ae56-8e5ab2a49dd4",
      progress: 0.07,
      source_task_id: "7995426"
    },
    {
      id: "d0b37b78-eae0-4404-a1cc-de01eb4005d5",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1210"
    },
    {
      id: "e9ca5da5-9dc3-4322-abfb-99c988501781",
      text: "B1 - 1N1E - 01N4.07 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6550"
    },
    {
      id: "5fa2eed3-ac35-4b85-8c17-441acabf01db",
      text: "BLDG-1 - BIM - Coordination and Sign-off ((LOE))",
      type: 0,
      start_date: "2024-06-17T00:00:00",
      end_date: "2025-03-19T08:00:00",
      duration: 1520,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0.02,
      source_task_id: "B1.VDC1.1000"
    },
    {
      id: "c3c5a495-c4f7-4853-a2bf-87217331ba5d",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Plumbing",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1070"
    },
    {
      id: "678198d6-db6d-4102-bcf4-df71c55f4a46",
      text: "Campus - Submittals - Sanitary Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 80,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5920"
    },
    {
      id: "f1d60b85-f25a-4622-b20b-a26bb64413d3",
      text: "BLDG-2 - BIM - Tier 2-4 - Area 2-C - Coordination / Sign-off",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 280,
      parent: "2937029d-cba7-4fda-9df6-f78e0ca56c95",
      progress: 0,
      source_task_id: "B2.VDC.3160"
    },
    {
      id: "6eaf57cb-5d48-4c07-bb2c-cd926c775015",
      text: "Tape/Finish Drywall Walls",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.CON.1600"
    },
    {
      id: "7f9a52ce-9a4c-4dba-b918-4310c51d5848",
      text: "B2 - 2C1W - 02C.08 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.2510"
    },
    {
      id: "4dbf067a-566d-4c7e-a8ba-35ae562faaac",
      text: "Substation-2 - MSG A - MSG A Install Verification Inspection And Issue Resolution",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 152,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4730"
    },
    {
      id: "98966e8d-f224-4047-88b8-6a998869e94c",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Exterior Metal Panels",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 120,
      parent: "e5d09a46-f2b1-4c5b-9af3-33b40223faef",
      progress: 0,
      source_task_id: "B1.CFCI.3790"
    },
    {
      id: "71ce8baf-563c-4d08-a7bc-e5fc10a1f06a",
      text: "B1 - 1N1E - 01N4.06 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6320"
    },
    {
      id: "97846682-9174-4834-a904-9e98234abb5c",
      text: "B1 - Network Room 2/3 - Power Alley - Set MSB's (ROJ Skids)",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 40,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1660"
    },
    {
      id: "01c0d7ea-27bf-4f36-9ab7-149723ddc836",
      text: "[DCB1] DEC-C Ready: Production Cabling [Area D]",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-03-30T00:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3557"
    },
    {
      id: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5",
      text: "B1 - SSB - 1E2 - Common -  E-cure /Seal Floors",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 64,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2410"
    },
    {
      id: "95d88811-b5b1-4855-ba9f-966986df19bb",
      text: "B1 - SSB - 1E1 - EF1 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF1)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 8,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1930"
    },
    {
      id: "caad0da0-fa07-4084-b3b1-e6d556d697b8",
      text: "Storage Racks - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5940"
    },
    {
      id: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f",
      text: "B2 - DH-D - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-06-15T08:00:00",
      duration: 160,
      parent: "f63227a1-2d37-45bf-b6c4-986a8a6d50b9",
      progress: 0,
      source_task_id: "B2.C.EY.1650"
    },
    {
      id: "009d22ab-ab20-4945-89c3-10a7608e60e2",
      text: "L3 - B1 MSG-B *On Temp Power*",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 40,
      parent: "9b65810f-93cc-453e-8de8-a75c5f4cb8b5",
      progress: 0,
      source_task_id: "CX3.B1.SS.1020"
    },
    {
      id: "fc40cb84-1494-4112-8454-d1d04e8a4201",
      text: "B1 - DH-C - Pull/Term Lighting/Branch - Data Hall C",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2530"
    },
    {
      id: "a242b213-09ef-4805-be55-a7ad90f46970",
      text: "Install Duct Support Steel",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SI.1040"
    },
    {
      id: "d8d5bc1a-4c14-4246-a66d-42e171342cd4",
      text: "Utility Provider Substation Constuction Complete",
      type: 0,
      start_date: "2025-12-15T00:00:00",
      end_date: "2025-12-15T00:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1070"
    },
    {
      id: "5151eaab-2fa7-4780-b2ea-518c54011be4",
      text: "B2 - mCUP-1 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1280"
    },
    {
      id: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4",
      text: "B2 - DH-B - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 160,
      parent: "9dd203bd-63ed-4bf3-9539-c32d33cefaad",
      progress: 0,
      source_task_id: "B2.C.EY.1620"
    },
    {
      id: "b08dc945-e156-46ba-8571-1c59f1c88531",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1200"
    },
    {
      id: "4293a7a1-e84d-4c1e-b66e-304e829292cf",
      text: "B1 - mCUP-1-9 - Piping POC's, Devices, final dress out (Fill and Flush Building) (Sequence 1)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1160"
    },
    {
      id: "9cad802e-8833-469b-b2e3-756cb942706e",
      text: "Construction/Non-Critical Power Available",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-09-03T00:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "TPM.B1.2012"
    },
    {
      id: "6854c402-b599-4cd9-9d12-0520e4515eb4",
      text: "B1 - 1N1W - 01N1.07 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 144,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6090"
    },
    {
      id: "222d87ba-37a6-49cc-9fe0-90a7aa9fc2ca",
      text: "B2 - DH-A - El Equip Yd - Test/Terms for (2)HPT, (2)HPD, (1)GS-IDF Hut",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 80,
      parent: "ee7e7edf-af1b-4b93-83a7-d006dcd1c47a",
      progress: 0,
      source_task_id: "B2.C.EY.1480"
    },
    {
      id: "a565da4e-47a6-49f6-9a35-7baee475a452",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH A",
      type: 5,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 352,
      parent: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      progress: 0,
      source_task_id: "8106478"
    },
    {
      id: "1097b8f5-df62-41a9-820c-462b7138da45",
      text: "Building 2 mCUP-2",
      type: 5,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 384,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995147"
    },
    {
      id: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      text: "B1 - 1N1W - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 24,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5040"
    },
    {
      id: "59d90d4d-34c5-402c-ab7d-327de960ab5a",
      text: "B1 - DH-C - Install Perimeter Cable Tray - Data Hall C",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2640"
    },
    {
      id: "906ea534-9c2d-4898-8b72-bbc05f7a23c9",
      text: "B2 - mCUP-7 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 16,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7010"
    },
    {
      id: "a9f7bafc-e2ba-4b92-99ef-1fa9ffe7b59a",
      text: "B2 - DH-C - Install Celing Devices Fire Protection - Data Hall C",
      type: 0,
      start_date: "2026-06-15T00:00:00",
      end_date: "2026-07-13T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2560"
    },
    {
      id: "a2b51d4d-e450-460b-a464-b99164309cb2",
      text: "BLDG-2 - Prep / Submit for Rvw - Anchor Bolts",
      type: 0,
      start_date: "2024-10-23T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "B1.CFCI.6480"
    },
    {
      id: "281fc22a-effb-4183-9ee2-70338488abf0",
      text: "Fab and Deliver - Fan Coil Assembly - Area A - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 3160,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 0.46,
      source_task_id: "B2.OFCI.2700"
    },
    {
      id: "aab504bb-406c-46b6-8b3d-7b71e7a767b1",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 80,
      parent: "92aa8a33-1e8a-4967-95ad-e4391a98b9cd",
      progress: 0,
      source_task_id: "MECO-1130.20"
    },
    {
      id: "eb0df072-338a-4a4d-a048-74d54b57f126",
      text: "B2 - DH-D - Corpnet Provisioning",
      type: 0,
      start_date: "2026-09-22T00:00:00",
      end_date: "2026-10-12T08:00:00",
      duration: 120,
      parent: "777e8c6e-a142-4273-82ed-e0333182df28",
      progress: 0,
      source_task_id: "B2.CONN.1250"
    },
    {
      id: "173f1a48-63dc-4255-ac71-4753804f6d22",
      text: "B1 - DH-B - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1230"
    },
    {
      id: "a7053ddb-1ef8-4e60-9419-a62401a0ba45",
      text: "BLDG-1/2 - Fabricate / Deliver - Architectural Precast Conc.",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 400,
      parent: "07b55cfe-9e28-44c9-92c0-80e8fd883c9f",
      progress: 0,
      source_task_id: "B1.CFCI.4410"
    },
    {
      id: "85f26379-1771-49b5-b3f4-50e67ec11345",
      text: "B1 - DH-B - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1740"
    },
    {
      id: "82255e02-d597-4e98-aef0-4ad73e04d931",
      text: "B1 - 1C2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 120,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.2450"
    },
    {
      id: "11ef1af4-49c3-46f6-9fbf-7fb278e8dccf",
      text: "B1 - SSB - 1E1 - Common - Install Wall Devices Fire Alarm",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 48,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2310"
    },
    {
      id: "3bb3ab4c-cf4a-4ff4-b4c3-9cdebc03eebc",
      text: "B1 - SSB - Install lightning protection",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1480"
    },
    {
      id: "b8c7b7e1-5dff-4ec9-8c2d-cc3257e2a2b5",
      text: "Paint - Prime/First Coat Walls",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.CON.1610"
    },
    {
      id: "77f8951c-608c-4674-b9aa-5c7cdfb01f03",
      text: "B1 - SSB - 1E1 - EF1 - Pull Wire for Lighting/Outlet/Racks (EF1)",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1840"
    },
    {
      id: "5149dc2a-6118-4bc4-b8ed-2a232cd9fc0b",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2140"
    },
    {
      id: "887205f0-59bd-4e1c-a04c-800fa721c007",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2160"
    },
    {
      id: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4",
      text: "B1 - mCUP-6 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6070"
    },
    {
      id: "fb0292ad-1e76-47ee-bea0-e701e1b7991d",
      text: "Area B - Trim Out - All Devices",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1360"
    },
    {
      id: "2754e163-f563-4dbd-96b7-51f6783df49b",
      text: "B2 - DH-A - L2 CDU Install Verification - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-05T08:00:00",
      duration: 144,
      parent: "813899cd-a520-4613-8209-38f409169670",
      progress: 0,
      source_task_id: "B2.C.A.3240"
    },
    {
      id: "b795d137-86ae-487b-be8d-5f1696045771",
      text: "Substation-1 - MSG A - Energization MSG",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 40,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4050"
    },
    {
      id: "006347af-648b-4dcc-a410-6e226dbac75e",
      text: "Start Foundations - DCB1",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-01-17T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1060"
    },
    {
      id: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      text: "Substation-1 A Lineup Work",
      type: 5,
      start_date: "2024-11-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 2720,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "7995238"
    },
    {
      id: "f56ab0ae-e50b-4f1f-97b6-30d3049a1490",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1500"
    },
    {
      id: "ac8ecd6e-c713-4bdb-ab1c-3f8a26defce4",
      text: "FR 09 - META review and Approve PCO#29",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 80,
      parent: "402f3329-410a-4e55-9edb-1757470a7890",
      progress: 0,
      source_task_id: "FR.09.1780"
    },
    {
      id: "6e03fc84-0b85-4655-a3c9-a2ad5197d0a6",
      text: "B1 - DH-D - Power Alley - Power Alley- (Level of Effort)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 200,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1580"
    },
    {
      id: "5b921cb9-f591-48e4-8f52-ee08c0a79e03",
      text: "B1 - Deep Telecom - EF3 - Concrete Scope",
      type: 0,
      start_date: "2024-12-09T00:00:00",
      end_date: "2024-12-13T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B1.C.STR.2470"
    },
    {
      id: "f3bb6587-c43c-4ad2-b8b0-e68de35e4577",
      text: "B2 - DH-C - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 40,
      parent: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      progress: 0,
      source_task_id: "B2.C.STR.2090"
    },
    {
      id: "3c5a86a2-800a-4135-94db-14253d17693d",
      text: "L3 - B1 EY 1C *On Temp Power*",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 40,
      parent: "8d364ed6-8d95-4622-8f88-85275fa83049",
      progress: 0,
      source_task_id: "CX3.B1.MSG.1030"
    },
    {
      id: "9d63f511-01fd-48d5-a29a-dbfac03f8787",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [8] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 2632,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.46,
      source_task_id: "B1.OFCI.3700"
    },
    {
      id: "ff51a337-86b7-4b2b-93db-13cb220bba8f",
      text: "In-Wall Rough Electrical",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1040"
    },
    {
      id: "495599d2-0afc-40f8-bc50-b4aed093d3b3",
      text: "B2 - DH-D - Backfill",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 40,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1550"
    },
    {
      id: "7cb8621a-c516-48e9-8951-35e09b5803af",
      text: "B1 - Network - Corpnet Provisioning",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 160,
      parent: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      progress: 0,
      source_task_id: "B1.CONN.1080"
    },
    {
      id: "aa1ff7d6-d087-48dd-9265-36de0702a4b8",
      text: "Fragnet 27 - PCO # 25 CCD-007 Mechanical Specification Clarifications",
      type: 0,
      start_date: "2024-09-20T00:00:00",
      end_date: null,
      duration: 328,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717475"
    },
    {
      id: "bf6f2460-1cc3-468d-9158-fae614d9a8d6",
      text: "Water Cooler Chillers - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 1,
      source_task_id: "B1.OFCI.1700"
    },
    {
      id: "f648ff66-d798-4edd-a570-f8625c3e24c8",
      text: "B2 - DH-A - Install BMS Conduit -Data Hall A",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2510"
    },
    {
      id: "0a0d76fe-7c16-4314-89d2-6db30daf918d",
      text: "Mechanical Rough-In Hardlids",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1100"
    },
    {
      id: "8f38d3e4-419b-454c-a76c-d85621f6cccd",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2240"
    },
    {
      id: "a3fc6847-0c20-4b3b-a642-c54f7b39504e",
      text: "B1 - DH-C - Install Celing Devices Security - Data Hall C",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2580"
    },
    {
      id: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      text: "Corridor 2C1",
      type: 5,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 816,
      parent: "df4d1504-15cd-4330-b115-33d36d9863b8",
      progress: 0,
      source_task_id: "7995031"
    },
    {
      id: "60c968a0-95b9-47f0-b58e-3e8974073d1d",
      text: "L4 Finish IBOS",
      type: 0,
      start_date: "2026-01-13T08:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2902"
    },
    {
      id: "0d0af951-e907-4302-a30d-347bd603f2db",
      text: "B2 - mCUP-5 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 48,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5020"
    },
    {
      id: "b7e80775-db75-4aaf-b309-1a2626cd6965",
      text: "Cx mCUP",
      type: 5,
      start_date: "2026-07-02T00:00:00",
      end_date: "2026-09-11T08:00:00",
      duration: 400,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7995001"
    },
    {
      id: "eff587e0-9b20-4414-8570-445f04d4ed9e",
      text: "FR 01 - Sanitary Sewer Redesign - Prepare & Issue Hydraulic & CAD Model - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-04-29T00:00:00",
      end_date: "2024-05-08T08:00:00",
      duration: 64,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1020"
    },
    {
      id: "bedf80e5-7afa-473a-bcf5-6160777214cf",
      text: "B2 - DH-C - Install Underground Security",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 80,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1470"
    },
    {
      id: "9b278f25-343d-4fbd-acb1-ecc3b5c56234",
      text: "Campus PH1 - Review for Approval -T-Comm Vaults (Site)",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: "2024-08-02T08:00:00",
      duration: 40,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0,
      source_task_id: "B1.CFCI.5960"
    },
    {
      id: "693b2dbb-baab-4268-b094-03777820e3a7",
      text: "Kickoff Meeting - DHEC",
      type: 0,
      start_date: "2024-04-12T00:00:00",
      end_date: "2024-04-16T08:00:00",
      duration: 24,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "Design.PreC.5750"
    },
    {
      id: "1441fcff-90b8-44d7-91cc-2e2bd1c9a1d0",
      text: "B2 - mCUP-7 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7100"
    },
    {
      id: "4a394329-1f20-4ba6-ba96-af2c24a7f240",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2480"
    },
    {
      id: "08c08acf-f8a4-4bdf-af99-c9f30ed392a6",
      text: "Utility Provider Substation - Design / Permiting of utility Substation Civil",
      type: 0,
      start_date: "2024-03-19T00:00:00",
      end_date: null,
      duration: 776,
      parent: null,
      progress: 0.5,
      source_task_id: "CX0.USS.L2.0040"
    },
    {
      id: "f3d372b5-108e-423c-a7ac-e30f6c888ce2",
      text: "Fragnet 32 - PCO # 31 RFI-056 Duct Bank 121 to CAV02",
      type: 0,
      start_date: "2024-07-25T00:00:00",
      end_date: null,
      duration: 648,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717481"
    },
    {
      id: "64e564cc-af26-4fbe-a55c-86d565e76fde",
      text: "HMD - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 1,
      source_task_id: "B2.OFCI.1410"
    },
    {
      id: "0e8b1ece-ca3e-4263-9a21-a0a0a2a405bc",
      text: "B1 - Network - Install Insulation",
      type: 0,
      start_date: "2025-06-05T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 40,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1100"
    },
    {
      id: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      text: "Power Alley DH-B",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-04-18T08:00:00",
      duration: 672,
      parent: "8afd9616-202b-49c7-8b22-9f4de01ca6bd",
      progress: 0,
      source_task_id: "7995080"
    },
    {
      id: "1d9e827f-f2c2-4707-950b-61d5bd31f6bc",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 1688,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995310"
    },
    {
      id: "aee97459-2415-41ba-a558-125048895c07",
      text: "B2 - mCUP-1-8 - Set MVS's/Gens and Misc (ROJ)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 200,
      parent: "5d20944d-7918-46c2-83e5-08c69eb295d1",
      progress: 0,
      source_task_id: "B2.mCUP.8000"
    },
    {
      id: "27bca40a-ff50-49a1-958c-0b7972db37f7",
      text: "Substation-2 - MSG B - MV  Torques (Finish 03/01/25)",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 72,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6410"
    },
    {
      id: "20a05c16-c7e4-4249-a243-ab32370d297d",
      text: "B1 - ISP Cabling - IDFC to DHC (GS tray)",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-04-13T08:00:00",
      duration: 200,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1400"
    },
    {
      id: "2cb8e57b-5012-4408-9d7a-73b7cd7bf035",
      text: "DFSMA - DC1 - mCUP - GS.IDF Remote Module ROJ - MOFE (1X1)",
      type: 0,
      start_date: "2025-09-05T08:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 0,
      parent: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      progress: 0,
      source_task_id: "B1.DFSMA.1140"
    },
    {
      id: "00b49abf-3515-42f7-a8df-b1e9648e6b13",
      text: "Install HSS Headers for Windows",
      type: 0,
      start_date: "2025-04-10T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1250"
    },
    {
      id: "0d815e2a-7138-48ef-91d5-36b004cf7776",
      text: "B1 - DH-C - Install Ceiling Tiles - Data Hall C",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 48,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2630"
    },
    {
      id: "057c1122-f2f6-491e-b6c0-c280e39f66ad",
      text: "Electrical Connections",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8140"
    },
    {
      id: "fd1228a0-6f03-4c62-9674-1fbb992f3690",
      text: "B1 - DH-B - El Equip Yd - Set Equipment (12)MVS, (24)PTX",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3060"
    },
    {
      id: "d0901cd5-f443-437d-b16c-d7c69f6d27cd",
      text: "Substation-2 - TX A - NETA Testing Cables",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 168,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4870"
    },
    {
      id: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      text: "Campus Site Utilities",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2025-04-22T08:00:00",
      duration: 2024,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0.17,
      source_task_id: "7995153"
    },
    {
      id: "4dd354ce-4a4a-4fec-b3fe-164a91c94931",
      text: "B2 - SSB - 2E2 - Common - Install Rubber Base",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1910"
    },
    {
      id: "0372fb69-b3c6-488a-8a0a-4032aeb49725",
      text: "Substation-1 - A Lineup - Install Breaker and Misc Pad / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-02-14T00:00:00",
      end_date: "2025-03-11T08:00:00",
      duration: 168,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3880"
    },
    {
      id: "e61797c5-0e86-43b0-b567-9dc8484a534e",
      text: "Load Bank - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "2c21e476-2412-4ed5-8c8a-27650481107d",
      progress: 1,
      source_task_id: "B1.OFCI.1720"
    },
    {
      id: "b7f8f406-61ed-48a9-9b3c-46c6b8311c5b",
      text: "Specialties - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5880"
    },
    {
      id: "f25599a0-95e2-44be-82b5-e6c181abbae6",
      text: "OSP - B1 - Phase 0 (Auxiliary Buildings)",
      type: 5,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 680,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995456"
    },
    {
      id: "070e63e5-18d0-499a-945d-1549d583a09e",
      text: "Area A - In Wall Rough Mechanical",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1071"
    },
    {
      id: "f58e96f8-5113-4a4c-a813-96d5b11bae19",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [2] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-11-18T08:00:00",
      duration: 1576,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.66,
      source_task_id: "B1.OFCI.3570"
    },
    {
      id: "b0b12067-ab67-4ef6-b0f2-18d5d18768a0",
      text: "Area B - Install Storage Racks",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1490"
    },
    {
      id: "5e602f59-1eaf-46c1-97e8-ccef8095cb6b",
      text: "B1 - DH-B - Hookup FCAs Mechanical- Data Hall B",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2030"
    },
    {
      id: "d13373ef-6938-4ae5-a189-45a7468673f4",
      text: "B2 - SSB - 2E1 - Common - Install Door Frames",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1080"
    },
    {
      id: "25c5bdeb-186a-4e2d-ad2e-78c22078f356",
      text: "B2 - 2E1E - EF4 - Hang/Tape/Finish Drywall (EF4)",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 48,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5190"
    },
    {
      id: "09cd452c-ab01-4373-b097-54b4ad82432b",
      text: "Guardhouse - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 184,
      parent: null,
      progress: 0.76,
      source_task_id: "Design.PreC.5930"
    },
    {
      id: "48b3b449-97e1-4e8d-96ff-da2222ec41de",
      text: "OSP - B2 - Phase 4 (BEV to BEV and UG Priority)",
      type: 5,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 368,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995460"
    },
    {
      id: "0af04484-5114-40f9-855c-6978bac455d4",
      text: "L5 - B2 DHC",
      type: 0,
      start_date: "2027-03-03T00:00:00",
      end_date: "2027-03-04T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHC.1000"
    },
    {
      id: "53c6f03f-c973-4a5f-a30c-e194b04bb41a",
      text: "Area 3 - Mass Grading - Remainder Post Permit Delay",
      type: 0,
      start_date: "2024-10-28T00:00:00",
      end_date: "2024-11-27T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8030"
    },
    {
      id: "936814a6-8a12-4b5e-bd62-72980c21e965",
      text: "B2 - 2E2E - EF1 - Terms for Lighting/Outlet/Racks (EF1)",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 24,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6310"
    },
    {
      id: "2cea20c5-e3c2-4ea6-97b9-c8811e3bf86d",
      text: "Cx SS B2",
      type: 5,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 120,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7994999"
    },
    {
      id: "baa4c7cf-d15a-4544-8bae-0a0aabab6e43",
      text: "Campus - Site Prep (Level of Effort)",
      type: 0,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-07-17T08:00:00",
      duration: 608,
      parent: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      progress: 0.75,
      source_task_id: "C.CSW.1030"
    },
    {
      id: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc",
      text: "B1 - DH-A - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 120,
      parent: "55203d15-6a05-4636-aac5-eb996029b878",
      progress: 0,
      source_task_id: "B1.C.STR.2220"
    },
    {
      id: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      text: "Cx DATA HALLS",
      type: 5,
      start_date: "2026-09-09T00:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 1416,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7994998"
    },
    {
      id: "c6a66845-9cdf-419f-bc39-f7cbf2425030",
      text: "BLDG-1 SSB 1E1",
      type: 5,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1360,
      parent: "7a3b9846-48b7-40e8-a145-00e7fba0e1ee",
      progress: 0,
      source_task_id: "7995286"
    },
    {
      id: "5e68ca63-8752-43d3-9430-b8902d9a7cbb",
      text: "B2 - 2D1 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1430"
    },
    {
      id: "680e9b60-f75e-43fe-8142-3007a5446254",
      text: "B1 - DH-B - L2 CDU Pre-Eng Inspection - Data Hall B",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 144,
      parent: "b38b9d81-df08-4732-9a53-49eb573b0138",
      progress: 0,
      source_task_id: "B1.C.B.3055"
    },
    {
      id: "77a5c480-f706-4191-9710-f1fe0e652540",
      text: "Submit Documentation for Building Permits",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-04-01T00:00:00",
      duration: 0,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 1,
      source_task_id: "ICM.PRE.1580"
    },
    {
      id: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8",
      text: "B2 - DH-A - Corpnet Provisioning",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-17T08:00:00",
      duration: 120,
      parent: "777e8c6e-a142-4273-82ed-e0333182df28",
      progress: 0,
      source_task_id: "B2.CONN.1110"
    },
    {
      id: "8d78e3b8-9590-4a9c-ba66-69172899af35",
      text: "B2 - SSB - Install Underground Controls",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1130"
    },
    {
      id: "1402a3d2-66a0-41d0-861d-d7694cda6cb4",
      text: "B2 - 2E2E - 02.01.E1.02 - Lighting and Devices",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6510"
    },
    {
      id: "8df9fc94-e08a-42b8-a037-cceca9b56e43",
      text: "FR 14 - META review and Approve PCO#10",
      type: 0,
      start_date: "2024-10-28T00:00:00",
      end_date: null,
      duration: 80,
      parent: "abce5df4-8ee4-4f0a-85e7-22726c1c832f",
      progress: 0,
      source_task_id: "FR.14.1070"
    },
    {
      id: "5c627ef8-1f56-4f8c-840e-0b21ed447544",
      text: "B1 - Network Room 2/3 - Install Doors/Hardware",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2240"
    },
    {
      id: "7cf24f9c-0c7e-499c-8d04-f19c6648404e",
      text: "B1 - DH-A - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 120,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1770"
    },
    {
      id: "a95f34a8-a460-454f-b8dc-209c23d9d881",
      text: "B2 - DH-A - SOG",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 216,
      parent: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      progress: 0,
      source_task_id: "B2.C.STR.2060"
    },
    {
      id: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2025-11-19T00:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 1176,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "7995137"
    },
    {
      id: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6",
      text: "L4 - B2 MSG-A",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 40,
      parent: "2cea20c5-e3c2-4ea6-97b9-c8811e3bf86d",
      progress: 0,
      source_task_id: "CX4.B2.SS.1010"
    },
    {
      id: "ac9fbb09-e961-4d23-92f6-cf1cdaca8d55",
      text: "B1 - 1C2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 8,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1460"
    },
    {
      id: "cc325006-809f-4eb6-a2d3-e0ece604105b",
      text: "B1 - Specialties - Bike Rack",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1010"
    },
    {
      id: "58a47b31-b75f-4dff-94fd-099cef3e33fd",
      text: "Submittal Rvw/App'l - EPMS",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "2b010ade-1651-4af0-b7a2-c1fe1d12718c",
      progress: 0,
      source_task_id: "B1.CFCI.6190"
    },
    {
      id: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 280,
      parent: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      progress: 0,
      source_task_id: "7995100"
    },
    {
      id: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      text: "BLDG-2 DH-C",
      type: 5,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 288,
      parent: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      progress: 0,
      source_task_id: "7995119"
    },
    {
      id: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      text: "UPS Room 02.01.E1.05",
      type: 5,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 480,
      parent: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      progress: 0,
      source_task_id: "7995047"
    },
    {
      id: "f15bc28a-8da0-40d2-9a52-1bcc0bd07f25",
      text: "City Review Comments & Approve - Building Permits",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 40,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 0,
      source_task_id: "PRE-DD-1080"
    },
    {
      id: "46a201c1-27ca-4726-ae3b-537532fb4b64",
      text: "Substation-1 - A Lineup SF6 Breaker - Set Breaker",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-05-22T08:00:00",
      duration: 8,
      parent: "aa22521b-48bf-4060-93d0-7750855b683f",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4150"
    },
    {
      id: "ea83517a-dd48-4c21-9786-7bd3d6a2338c",
      text: "Manufacturing Strategy - Component Development",
      type: 5,
      start_date: "2025-05-30T08:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 1944,
      parent: "cee57e06-8220-46f4-bf48-e8124ce9e922",
      progress: 0,
      source_task_id: "7994819"
    },
    {
      id: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      text: "B2 - ISP Cabling - EF1/2/3/4 (GS tray) ((Facnet Live))",
      type: 0,
      start_date: "2026-05-12T00:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 80,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1060"
    },
    {
      id: "59d90de0-1f2e-4a8a-9f0c-37c611b3db76",
      text: "B1 - 1D1W - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1760"
    },
    {
      id: "069b2df1-e414-4c96-af60-fab5221313c3",
      text: "Precast Concrete SA - Meta Authorized",
      type: 0,
      start_date: "2024-05-02T08:00:00",
      end_date: "2024-05-02T08:00:00",
      duration: 0,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 1,
      source_task_id: "ICM.PRE.1440"
    },
    {
      id: "0a0c446c-9e50-4a02-977c-ffb216061fa7",
      text: "ADMIN - Prep / Submit for Review - Specialities",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6240"
    },
    {
      id: "e99ec20a-9083-45fb-a8d8-e5bf3ff34ed1",
      text: "Hook Up Fixed Kitchen Equipment",
      type: 0,
      start_date: "2025-12-08T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1270"
    },
    {
      id: "b51749df-6609-4c25-bdc6-b2f98fe27360",
      text: "Substation-1 - MSG A - Duration of Verification of Stable Power",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 40,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6980"
    },
    {
      id: "32c086ed-ec22-4ece-a778-4e5c254ab396",
      text: "B1 - mCUP-2 - Install FA  (Wire Pulls)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2080"
    },
    {
      id: "e8fae35f-22e3-450d-9520-4644aef89331",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      progress: 0,
      source_task_id: "MECO-1130.10"
    },
    {
      id: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49",
      text: "DCB2 EY1 Ready for Energization",
      type: 0,
      start_date: "2026-06-22T08:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1116"
    },
    {
      id: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      text: "Fire Pump Room",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 400,
      parent: null,
      progress: 0,
      source_task_id: "8243686"
    },
    {
      id: "8925c083-456e-42bc-a6ff-4579e41c4dc8",
      text: "Phase 2 - Remove Structures",
      type: 0,
      start_date: "2026-07-01T00:00:00",
      end_date: "2026-07-29T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1070"
    },
    {
      id: "559ddd23-e068-48bf-a1f0-eaec878bdede",
      text: "B1 - Network - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-05-08T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 144,
      parent: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      progress: 0,
      source_task_id: "B1.C.STR.1930"
    },
    {
      id: "5220153c-b126-4e34-a61c-047ed1f0b5b3",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2150"
    },
    {
      id: "ebaaea3d-b400-4fb6-9cd4-015044713fdd",
      text: "Hang/Tape/Finish Ceilings",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 48,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1130"
    },
    {
      id: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      text: "Start DCB1 EY1 MVS and PTX Equipment Pad Placement - DCB1",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-11T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1435"
    },
    {
      id: "d1564e53-0f63-48b4-ae6b-e7ec3580fd7a",
      text: "B2 - DH-B - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 80,
      parent: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      progress: 0,
      source_task_id: "B2.C.EY.1380"
    },
    {
      id: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      text: "B2 - 2E2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-12-15T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 24,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6010"
    },
    {
      id: "dd888cf3-c150-454d-a756-d731ae84c8be",
      text: "[DCB2] FacNet Live [Area A]",
      type: 0,
      start_date: "2026-08-18T08:00:00",
      end_date: "2026-08-18T08:00:00",
      duration: 0,
      parent: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      progress: 0,
      source_task_id: "ICM.B2.3627"
    },
    {
      id: "e1399b89-ab93-4919-8688-8310e829fe41",
      text: "B1 - 1N2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5260"
    },
    {
      id: "5001e7cf-5af8-4b18-be45-c03477429479",
      text: "B2 - 2E1E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 120,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5580"
    },
    {
      id: "96876223-bcd9-490c-bd78-0bf14b3f33f8",
      text: "B1 - 1N1E - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.2570"
    },
    {
      id: "5a3ae174-848a-4df3-afec-47b1de49f3b1",
      text: "FR 02 - Approval to cover utilties",
      type: 0,
      start_date: "2024-06-17T00:00:00",
      end_date: null,
      duration: 320,
      parent: null,
      progress: 1,
      source_task_id: "PRE-DD-1200"
    },
    {
      id: "64afed6b-a7a8-4420-a7e8-3f33826f45f9",
      text: "B1 - mCUP-2 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 16,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2010"
    },
    {
      id: "bb4ccf8c-2430-46e8-8802-789fa95742f7",
      text: "(CFCI) Div. 05 - PEMB Steel",
      type: 0,
      start_date: "2024-05-30T00:00:00",
      end_date: null,
      duration: 1600,
      parent: null,
      progress: 0.34,
      source_task_id: "8717099"
    },
    {
      id: "ab216bb8-d9f0-44c0-9630-49d870b2b368",
      text: "Area 2 - UG RI -RSB/MSB-SSB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1370"
    },
    {
      id: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      text: "Site / UG BIM - Area 3 - Critical Early Release - Coordination / Sign Off",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-08T08:00:00",
      duration: 128,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1040"
    },
    {
      id: "0df78865-60c8-4bad-aa6c-6afed85458a3",
      text: "B2 - mCUP-1-8 - Piping POC's, Devices, final dress out (Fill and Flush Building) (Sequence 1)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1300"
    },
    {
      id: "c1c51e1d-9c8c-45af-bef7-e8e22c3599a1",
      text: "Substation-2 - TX B - NETA Testing",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 184,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4480"
    },
    {
      id: "4f228d5a-0f87-449d-a336-4d2f781436d1",
      text: "B2 - 2E2E - EF1 - Build Wall Between MDF/Fiber Entry and Carrier (EF1)",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 48,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6080"
    },
    {
      id: "8c7aa885-082b-4a1b-b751-f6d39fe13836",
      text: "B1 - DH-A - El Equip Yd - Test/Terms for (2)HPT, (2)HPD, (1)GS-IDF Hut",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "bbb49ac4-d9a7-4848-87c0-a96e61e2e9d9",
      progress: 0,
      source_task_id: "B1.C.A.2900"
    },
    {
      id: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 160,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1760"
    },
    {
      id: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      text: "L4 - B1 EY 1 NS/ A *On Temp Power*",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 40,
      parent: "b4e5a005-102e-4fbf-949a-1ed89d200a5c",
      progress: 0,
      source_task_id: "CX4.B1.MSG.1020"
    },
    {
      id: "990e7047-18a5-4f35-8d46-972739abe902",
      text: "B1 - 1N2E - 01N3.05 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.5680"
    },
    {
      id: "e8554953-6a6f-4378-bfc5-cbe7872cda91",
      text: "B1 - DH-C - Install Underground Controls",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 80,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1650"
    },
    {
      id: "8356cb2e-551f-469a-9129-87aa622891bb",
      text: "B1 - 1N1E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1730"
    },
    {
      id: "83690d38-f66b-48b5-93b4-5a3f24aa9039",
      text: "B1 - DH-A - El Equip Yd - Pull Cable for (2)HPT, (2)HPD, (1)GS-IDF Hut",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 80,
      parent: "7ff8dfca-7821-49f8-b06e-76059e0f610b",
      progress: 0,
      source_task_id: "B1.C.A.2860"
    },
    {
      id: "a7d96cf0-a9a3-44c8-a993-44a452a9cab1",
      text: "FR 12 - Jack and bore tie in @ giant tire pawrkway",
      type: 0,
      start_date: "2024-12-09T00:00:00",
      end_date: "2024-12-13T08:00:00",
      duration: 16,
      parent: "0bab80ea-8808-4fcd-bcf8-5c2534153920",
      progress: 0,
      source_task_id: "FR.12.1020"
    },
    {
      id: "13fc09ba-4560-4a10-9eb9-d9ad6079915a",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [4] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 1640,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.63,
      source_task_id: "B1.OFCI.3590"
    },
    {
      id: "77528530-891c-4277-9023-56b69dc0c903",
      text: "Campus - Prep / Submit for Review - Landscaping / Irrigation",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 200,
      parent: "50f5196d-2758-41f7-896e-2e6190d0ed68",
      progress: 0,
      source_task_id: "B1.CFCI.4950"
    },
    {
      id: "9991e1e7-1782-42ec-a9ff-27d152c174f2",
      text: "BLDG-1/2 - Submittals - Exterior Metal Panels (CrownCorr)",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: "2024-11-14T08:00:00",
      duration: 160,
      parent: "e5d09a46-f2b1-4c5b-9af3-33b40223faef",
      progress: 0,
      source_task_id: "B1.CFCI.3630"
    },
    {
      id: "53d4bc53-71ab-465b-9b5c-2ffbe6d887aa",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2050"
    },
    {
      id: "d8dfd39a-369b-45cd-9ca6-3e4d96e7db83",
      text: "B2 - DH-B - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 192,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2400"
    },
    {
      id: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      text: "BLDG-1 SSB",
      type: 5,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 208,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995382"
    },
    {
      id: "d06c7db2-eb01-4d57-8d91-7b4cd07b4e6d",
      text: "B2 - DH-B - Install Ceiling Devices - Lighting - Data Hall B",
      type: 0,
      start_date: "2026-05-22T00:00:00",
      end_date: "2026-06-19T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2780"
    },
    {
      id: "dbb30b0c-e480-49b5-a376-f5e02d1487e9",
      text: "Substation 2 - Prep / Submit for Rvw - H-Frame MOAB",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 160,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5780"
    },
    {
      id: "5debe745-9862-414a-b073-b42917687ff4",
      text: "B1 - DH-D - L2 CDU Install Verification - Data Hall D",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 144,
      parent: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      progress: 0,
      source_task_id: "B1.C.D.3125"
    },
    {
      id: "43666a4e-1aee-436b-83c7-e5490a953421",
      text: "B2 - DH-C - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      progress: 0,
      source_task_id: "B2.C.STR.2150"
    },
    {
      id: "7bc2f2ad-bfa2-4706-9f4b-e8289791a672",
      text: "B1 - mCUP-8 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8100"
    },
    {
      id: "3ed65afc-abd6-4636-8e00-2b3e35d63785",
      text: "B2 - 2A1 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 160,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.2340"
    },
    {
      id: "659cbae2-73ce-4383-b984-b48bd1a8e3f8",
      text: "B1 - Network Room 2/3 - Power Alley - Prime Paint/First Coat Inside Electrical Room",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1250"
    },
    {
      id: "e7525d04-7af8-4d86-990c-665bb73e749c",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Signage",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6130"
    },
    {
      id: "fa16ae15-5182-435e-9db9-54f24b26a2c5",
      text: "L4 - B1 DHB - Server Migration",
      type: 0,
      start_date: "2026-06-10T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHB.1010"
    },
    {
      id: "060887f5-b149-4718-82cf-ace0a752a374",
      text: "Meta Authorizations",
      type: 5,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-07-29T08:00:00",
      duration: 680,
      parent: "56080308-2da4-4055-b9e7-474a80627d2c",
      progress: 0.75,
      source_task_id: "7994715"
    },
    {
      id: "ee8df115-d04f-4d4f-b0f0-1dc48af24fee",
      text: "B2 - DH-B - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1050"
    },
    {
      id: "2b010ade-1651-4af0-b7a2-c1fe1d12718c",
      text: "(CFCI) DIV. 25 - Integrated Automation",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 320,
      parent: null,
      progress: 0,
      source_task_id: "8717098"
    },
    {
      id: "b59787b1-4034-47f1-b469-52b087cc7b04",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH C",
      type: 5,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-07-30T08:00:00",
      duration: 504,
      parent: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      progress: 0,
      source_task_id: "8106484"
    },
    {
      id: "03114f37-cc78-4108-803d-c47e04c7e85f",
      text: "PTX & HPT - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2024-02-01T00:00:00",
      duration: 0,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 1,
      source_task_id: "B2.OFCI.1070"
    },
    {
      id: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0",
      text: "Substation-1 - TX A - Set Transformer",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 40,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4070"
    },
    {
      id: "70eaeb12-8cb8-45b9-a5bd-789b4aae88d8",
      text: "BLDG-1 SSB - Equipment Final Clean",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1070"
    },
    {
      id: "90321750-8d28-4a30-ab18-5f5e09e5a7a6",
      text: "Load Bank - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 0,
      parent: "5c788524-2553-452e-84b3-e22e7b7ba7ad",
      progress: 1,
      source_task_id: "B2.OFCI.1120"
    },
    {
      id: "cd92d0b6-4904-42c8-8228-d54b2be2dac5",
      text: "Roofing Bid & Develop SA Package",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 328,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 1,
      source_task_id: "PRE-PP-1140"
    },
    {
      id: "b10f89e5-6e11-47b4-a6ed-92e4cdb7d903",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2060"
    },
    {
      id: "120c5a87-9675-41d5-91c8-c4c60524fa89",
      text: "IST Start DH C - DCB2",
      type: 0,
      start_date: "2027-03-03T00:00:00",
      end_date: "2027-03-03T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2174"
    },
    {
      id: "c2ffb523-dd52-4ded-94c6-d8c4c3ac7f40",
      text: "B2 - 2D1W - 02D.09 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1680"
    },
    {
      id: "630fc7b8-dbbe-4d1f-909f-c543ba8860e8",
      text: "B1 - 1N1E - 01N4.07 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 144,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6270"
    },
    {
      id: "327537eb-46b3-4a85-9284-078d5e739c30",
      text: "Fab and Deliver - MVS-5WAY - Area A (3) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-24T08:00:00",
      duration: 2208,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0,
      source_task_id: "B1.OFCI.2410"
    },
    {
      id: "46e56e0c-0cde-489b-b6c3-385c7fad9390",
      text: "B2 - SSB - 2E1 - Common - Install Porcelain Tile",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1280"
    },
    {
      id: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      text: "(OFCI) B2 PLC Panels",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 3840,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.13,
      source_task_id: "7994946"
    },
    {
      id: "7465548e-3752-46b9-a9de-de74fa0cde36",
      text: "Substation-1 - MSG A - Wire Pulls From Building - Sequence 1",
      type: 0,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 160,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4010"
    },
    {
      id: "380b7bbd-4dcb-42ba-80d3-04fd92f36856",
      text: "Prime / 1st Coat Walls",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1200"
    },
    {
      id: "e6fe87b1-3b8d-45de-a55c-5c6ca62b95f8",
      text: "FR 09 - DPR Prepare and Submit PCO#29",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "402f3329-410a-4e55-9edb-1757470a7890",
      progress: 0.5,
      source_task_id: "FR.09.1770"
    },
    {
      id: "6244fe39-242c-4213-9ac1-2bc00708c95b",
      text: "B1 - DH-D - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area D",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 120,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "B1.C.D.3170"
    },
    {
      id: "bb4ba05f-e504-462c-a449-4229236823ac",
      text: "[DCB1] DEC-C Ready: Production Cabling [Network Suite & SSB]",
      type: 0,
      start_date: "2026-01-09T08:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3507"
    },
    {
      id: "c3dcad83-26ea-4f1f-897f-320c0768f4c2",
      text: "B2 - 2D1W - 02D.08 - Lighting and Devices",
      type: 0,
      start_date: "2026-06-17T00:00:00",
      end_date: "2026-06-23T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.2310"
    },
    {
      id: "93022ccb-a2c9-4c23-b9ab-ea662acbc674",
      text: "ADMIN - Submittal Rvw/App'l - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-26T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6280"
    },
    {
      id: "a3778628-c454-42d0-b0d6-a496585837ec",
      text: "B1 - mCUP-9 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9060"
    },
    {
      id: "e90dab19-a706-4830-8a9e-2cfd0b6e76bf",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [5] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 2944,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.37,
      source_task_id: "B2.OFCI.2760"
    },
    {
      id: "ecc3f1fc-bd90-49be-b50b-bcb760bf5fc6",
      text: "B1 - 1N1W - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 160,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5590"
    },
    {
      id: "1c495dd0-bf26-46d4-8a2a-83ff29fc0fcf",
      text: "BLDG-1/2 - Prep / Submit for Review - Signage",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6120"
    },
    {
      id: "1650ff1d-7719-42eb-8e5d-ec188361eabc",
      text: "Exterior Canopy Direct Applied EIFS",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 40,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1180"
    },
    {
      id: "b0f8b31b-828a-4f07-9994-a48c929bd17a",
      text: "Interior fit-out Start DCB1 - Phase1",
      type: 0,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-05-12T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1280"
    },
    {
      id: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09",
      text: "L3 - B2 MSG-A",
      type: 0,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-06-02T08:00:00",
      duration: 40,
      parent: "2cea20c5-e3c2-4ea6-97b9-c8811e3bf86d",
      progress: 0,
      source_task_id: "CX3.B2.SS.1000"
    },
    {
      id: "510fa674-ad10-4826-875e-0762c159f953",
      text: "In-Wall Rough Security",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1070"
    },
    {
      id: "767055b9-cb21-448e-8317-9d4632426ca8",
      text: "Mechanical SA - Meta Review",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-22T08:00:00",
      duration: 296,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1190"
    },
    {
      id: "a657002a-ede9-4c60-8a8b-8a0b0ada3247",
      text: "B2 - DH-A - Install Celing Devices Fire Alarm - Data Hall A",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2630"
    },
    {
      id: "25b2932a-9187-4591-88d1-d0b44210b49f",
      text: "B2 - DH-B - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1020"
    },
    {
      id: "cd9f3e87-af7b-46f9-a9a2-8d684a47ee5f",
      text: "L3 - B1 EY 1D *On Temp Power*",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 40,
      parent: "8d364ed6-8d95-4622-8f88-85275fa83049",
      progress: 0,
      source_task_id: "CX3.B1.MSG.1040"
    },
    {
      id: "abe1a98c-028c-44b8-8da7-9658d12e1819",
      text: "Construction",
      type: 5,
      start_date: "2024-03-19T00:00:00",
      end_date: "2026-12-11T08:00:00",
      duration: 5344,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0.07,
      source_task_id: "7995018"
    },
    {
      id: "5cc6b2a1-28e2-432c-9333-957d8867107a",
      text: "Weather/Construction Bank - Site - BG to Start of Foundations Bldg 1 (Original 12+5=17; Remaining 3)",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-16T08:00:00",
      duration: 96,
      parent: "268c5697-a68e-41ba-bbc5-d57da0b4f384",
      progress: 0,
      source_task_id: "WEATHER.1000"
    },
    {
      id: "32dd8d3d-362d-48b0-ba56-b735b6556b11",
      text: "B1 - DH-C - Hookup CDU's - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-02-23T08:00:00",
      duration: 144,
      parent: "dcac32fd-f134-4e86-b43f-bafd5526cedf",
      progress: 0,
      source_task_id: "B1.C.C.3190"
    },
    {
      id: "662f6f65-5382-49f8-ad7b-73485ade0333",
      text: "B2 - 2E1E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 80,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5420"
    },
    {
      id: "89dead84-e480-46f1-a83a-ca7709775511",
      text: "Corridor 1N1E",
      type: 5,
      start_date: "2025-06-16T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 920,
      parent: "e2a25521-eed0-4f3c-a501-f360cf914f24",
      progress: 0,
      source_task_id: "7995347"
    },
    {
      id: "a0ba5485-7b0b-42c9-925f-08fcc76612a7",
      text: "B2 - DH-C - Install Fire Alarm Conduit/Vesda -Data Hall C",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2350"
    },
    {
      id: "e0c445d5-4ec8-48e9-a52e-97b737412b93",
      text: "B1 - 1C1W - 01C.07 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1660"
    },
    {
      id: "98e0b973-3587-4037-8f6e-52f3e09b90d3",
      text: "Off Campus - Trade Partner Mobilization/Procurement",
      type: 0,
      start_date: "2024-04-19T00:00:00",
      end_date: "2024-05-11T08:00:00",
      duration: 160,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 1,
      source_task_id: "C.CSW.3050"
    },
    {
      id: "4be358d3-f79d-4aa4-8e87-3566a76e5e1d",
      text: "B2 - DH-C - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1070"
    },
    {
      id: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2400"
    },
    {
      id: "33d830eb-a5d3-47f0-acf5-74bab99d10e4",
      text: "B1 - SSB - 1E2 - Common - Install Ceiling Tiles",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2120"
    },
    {
      id: "44ace62e-e020-404b-92de-bd5a168f9c68",
      text: "L3 Finish EY1 - DCB1",
      type: 0,
      start_date: "2025-12-03T08:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2251"
    },
    {
      id: "7ffc7a7b-203e-4a01-a73d-89246481a5dc",
      text: "OH Mechanical Rough-In",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1230"
    },
    {
      id: "bc26256c-deb1-4c63-813d-3a9a4f47c500",
      text: "B1 - ISP Cabling - EF to IDFB (UG)",
      type: 0,
      start_date: "2026-01-12T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 80,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1280"
    },
    {
      id: "b90754e2-67af-4314-b785-5daf46d0b65a",
      text: "Install Doors / Hardware",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 16,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1120"
    },
    {
      id: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f",
      text: "B1 - Network - Install Joists",
      type: 0,
      start_date: "2025-04-11T00:00:00",
      end_date: "2025-04-22T08:00:00",
      duration: 80,
      parent: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      progress: 0,
      source_task_id: "B1.C.STR.1700"
    },
    {
      id: "1e24bee4-e9b7-4e93-b754-3e8ff99d386e",
      text: "B1 - DH-B - Install Underground Plumbing",
      type: 0,
      start_date: "2025-03-11T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 120,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1330"
    },
    {
      id: "e1279ce9-5049-4fae-bc19-b170eb75f399",
      text: "B1 - DH-C - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      progress: 0,
      source_task_id: "B1.C.C.3130"
    },
    {
      id: "98a17640-5a44-4c01-8f45-7e5c07194b8d",
      text: "B1 - 1D1W - 01D.09 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2610"
    },
    {
      id: "d2ca047b-2baf-42e0-9fbd-a368450f9f0c",
      text: "Deconstruct - rat slab",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.SUB.1140"
    },
    {
      id: "d24501a4-3025-48eb-a1ff-98862810740f",
      text: "B1 - DH-A - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 160,
      parent: "5fc606c5-5219-4322-9c84-02b4379f499d",
      progress: 0,
      source_task_id: "B1.C.A.2960"
    },
    {
      id: "26a78a0a-822a-4e57-935c-a60c3928b1d1",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Struc. Conc. (Fdn Ready Mix)",
      type: 0,
      start_date: "2024-10-09T00:00:00",
      end_date: "2024-10-28T08:00:00",
      duration: 40,
      parent: "f516d625-fc35-4562-b467-ea8f751e08e8",
      progress: 0,
      source_task_id: "B1.CFCI.1010"
    },
    {
      id: "c4bd9212-6008-43f2-848f-e4175161de6b",
      text: "B2 - DH-D - Install IMP Ceiling - Data Hall D",
      type: 0,
      start_date: "2026-05-06T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1850"
    },
    {
      id: "2fcfe7c1-2e91-4178-968b-b00d7a370595",
      text: "Substation-2 - MSG A - Wire Pulls From Building MSG-1B/D",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 128,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6390"
    },
    {
      id: "ac49182b-8b0b-4e9b-b3e0-ec892bd082ed",
      text: "Substation-2 - TX B - Set Transformer",
      type: 0,
      start_date: "2025-07-01T00:00:00",
      end_date: "2025-07-08T08:00:00",
      duration: 40,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4470"
    },
    {
      id: "ff53d551-6056-453b-b5d4-b4bc76bfcae3",
      text: "B2 - 2B1 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1500"
    },
    {
      id: "55e82dd7-8d81-48cc-a359-59bf9baf85ad",
      text: "B1 - DH-C - Install BMS Conduit -Data Hall C",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2500"
    },
    {
      id: "2d97a66c-7be9-4680-9090-107428a05ca6",
      text: "B1 - DH-B - Term Bussways - Data Hall B",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2670"
    },
    {
      id: "6e38b4b2-a555-4b02-8d54-8eee0c45ce03",
      text: "B1 - DH-A - Install 800 Amp Busway - Data Hall A",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2100"
    },
    {
      id: "cd81e48d-988c-4708-ba0f-1a8b696c93e7",
      text: "B1 - DH-A - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1290"
    },
    {
      id: "4df70c1c-5a26-4572-8ffd-d93daa9d8e91",
      text: "Fab and Deliver - MVS-5WAY - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 2608,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.46,
      source_task_id: "B2.OFCI.2130"
    },
    {
      id: "df3a87fb-ee6e-4f5c-8016-17e721e18e5f",
      text: "B1 - DH-A - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area A",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2950"
    },
    {
      id: "bad32c28-e0bc-4d75-b432-1f917c7b63c2",
      text: "B2 - DH-A - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 48,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2280"
    },
    {
      id: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Inspection AHJ",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 16,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1750"
    },
    {
      id: "081832f7-b3b1-4bd7-9370-24fb18b4c698",
      text: "B2 - mCUP-3 - Set in Place Inspections",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 8,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3030"
    },
    {
      id: "52bfaf6a-c0c2-4510-99d4-328fe102382e",
      text: "FR 12 - Procurement of material",
      type: 0,
      start_date: "2024-09-12T00:00:00",
      end_date: null,
      duration: 96,
      parent: "0bab80ea-8808-4fcd-bcf8-5c2534153920",
      progress: 0.5,
      source_task_id: "FR.12.1030"
    },
    {
      id: "dafcedc3-46c9-4d69-bb77-e2cd9c0e22b8",
      text: "B1 - 1N2E - 01N3.06 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6460"
    },
    {
      id: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      text: "(OFCI) B1 MVS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 2456,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.51,
      source_task_id: "7994980"
    },
    {
      id: "8432736e-acec-4682-8d2a-3ea945f9fe05",
      text: "B1 - DH-C - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 192,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2120"
    },
    {
      id: "57ec90db-0b26-4757-9b22-6003e84f3fbf",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-03-27T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1520"
    },
    {
      id: "b504bddc-d052-46c5-bb15-6309969e393a",
      text: "Substation-2 - B Lineup - Install Dead-End Structure Excavate / Form / Pour",
      type: 0,
      start_date: "2025-05-10T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 168,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4230"
    },
    {
      id: "1736fc13-a761-4ead-9995-4f12c77a69b1",
      text: "B2 - mCUP-4 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 48,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4000"
    },
    {
      id: "e7e419f2-3130-403a-a3db-89348cd9f4cd",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1340"
    },
    {
      id: "3d9f0349-2201-41b3-b818-15466b464b64",
      text: "B1 - Network Room 1/4 - Power Alley - OH Fire Alarm/Vesda",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 96,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1290"
    },
    {
      id: "21d20f92-fb5b-4e22-9fae-bf189cf51152",
      text: "Area A - In Wall Rough Plumbing",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 16,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1081"
    },
    {
      id: "a8994de6-2ebf-40c1-aa99-1895f171b275",
      text: "ADMIN/ IBOS - Prep / Submit for Review - Speciality doors and dock levelrs",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-07T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6330"
    },
    {
      id: "1534dcf7-aa7a-4956-8e00-a2ce1d980908",
      text: "Sanitary Sewer",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-10-08T08:00:00",
      duration: 136,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995155"
    },
    {
      id: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      text: "Site / UG BIM - Area 3 - Remaining Utilities - Coordination / Sign Off",
      type: 0,
      start_date: "2024-04-30T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 344,
      parent: "8331d266-0138-4b68-98a0-04c6efcc3613",
      progress: 0.66,
      source_task_id: "SITE.VDC.1090"
    },
    {
      id: "28b7bf91-ee9e-40ea-83bd-94ca2ca53097",
      text: "B2 - DH-A - Install Feeder Conduit -Data Hall A",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2460"
    },
    {
      id: "e7693bb5-22a2-45fb-91b3-07523ba6b3ce",
      text: "B2 - 2E2E - 02.01.E1.02 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6380"
    },
    {
      id: "e24f2ed0-e628-4b51-acfb-fbccdcd7a153",
      text: "Fab and Deliver - RSB - Area A - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 3224,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.43,
      source_task_id: "B2.OFCI.2350"
    },
    {
      id: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      text: "(CFCI) Div. 05 - Anchor Bolt Delivery B2",
      type: 5,
      start_date: "2024-10-23T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 400,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0,
      source_task_id: "7994927"
    },
    {
      id: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f",
      text: "B1 - Network - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-05-02T00:00:00",
      end_date: "2025-05-07T08:00:00",
      duration: 40,
      parent: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      progress: 0,
      source_task_id: "B1.C.STR.1910"
    },
    {
      id: "f7c17f7a-84f1-4d1e-8498-0280fba93e4c",
      text: "Substation-2 - MSG A - Duration of Verification of Stable Power",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 40,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.7010"
    },
    {
      id: "bdeffa65-18e5-4bfb-aec1-113fa5d5b78c",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Security",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1120"
    },
    {
      id: "3839bbe2-3dff-4bf4-a60e-7864a1ffced6",
      text: "B1 - DH-A - Grout Column Baseplates",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 48,
      parent: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      progress: 0,
      source_task_id: "B1.C.STR.2100"
    },
    {
      id: "4d45f32e-8c7f-4f53-b2a4-e1f2ecc7f611",
      text: "B1 - Network - Install Thermal Concrete",
      type: 0,
      start_date: "2025-03-01T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 80,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1230"
    },
    {
      id: "514b6680-a142-4962-b825-1ce3a0c38530",
      text: "B1 - Network Room 2/3 - Install Ceiling Grid",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1790"
    },
    {
      id: "4da5b7a6-7452-449d-85a8-aa82f2c3c9e6",
      text: "B1 - DH-B - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 632,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3090"
    },
    {
      id: "4154f35b-b33f-42f4-b0f4-5f1117171117",
      text: "Site & Utilities VDC Coordination",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 592,
      parent: "242ad192-a9a1-4973-bc98-024e62b03340",
      progress: 0.92,
      source_task_id: "7994758"
    },
    {
      id: "9f8d6d99-64b3-493a-a11f-6f2819d1197a",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Fire Sprinkler",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1170"
    },
    {
      id: "e4dc277f-f22d-49ff-863a-b65f22979638",
      text: "B1 - 1N1E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5340"
    },
    {
      id: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-31T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 24,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1210"
    },
    {
      id: "c23e83d4-a064-4972-9a5f-7ac9a210012b",
      text: "B1 - 1A2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2180"
    },
    {
      id: "706d2e52-0772-4280-b13b-93206452f57c",
      text: "Precon - Procurement Services",
      type: 5,
      start_date: "2023-12-04T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 1096,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 1,
      source_task_id: "7994721"
    },
    {
      id: "81ab71bd-6025-4df1-8730-74f01fab7d68",
      text: "PHASE 3 Substantial Completion",
      type: 0,
      start_date: "2027-03-05T08:00:00",
      end_date: "2027-03-05T08:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "CX.MIL.1040"
    },
    {
      id: "fec46aca-bbc5-4d5e-bead-8a3ddb964165",
      text: "FR 35 - META review and respond to RFI #84",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "22f7f124-57e8-4e8a-9a03-b51ea65b5a91",
      progress: 1,
      source_task_id: "FR.35.1010"
    },
    {
      id: "706b62e5-8002-44b8-9153-6007b53cd464",
      text: "Substantial Completion (DH B) - DCB2",
      type: 0,
      start_date: "2027-03-05T08:00:00",
      end_date: "2027-03-05T08:00:00",
      duration: 0,
      parent: "c02bb0d9-a0ba-46c8-8c9c-98131322446d",
      progress: 0,
      source_task_id: "ICM.B2.1070"
    },
    {
      id: "ac804cab-89ca-45c9-8eaa-71703f3576d8",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "d87c40c9-36ba-466e-9282-c17bb73cf6fe",
      progress: 0,
      source_task_id: "MECO-1700.10"
    },
    {
      id: "169464c2-4976-4da3-8162-fc3b0d8df6d0",
      text: "Final Punch - B2 DHA & DHB",
      type: 0,
      start_date: "2027-01-11T00:00:00",
      end_date: "2027-01-15T08:00:00",
      duration: 40,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHA.1010"
    },
    {
      id: "9ce46dcd-6136-4213-ba99-50c5d46bc9c3",
      text: "B2 - SSB - External Framing/Vapor Barrier to Finish Roof",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "B2.C.5000"
    },
    {
      id: "ef5419b9-206b-4af2-959b-dce5e4949e22",
      text: "Area B - In Wall Rough Security",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1090"
    },
    {
      id: "094937ee-f4f4-4be8-97e3-48dcb218cce9",
      text: "Frame Secondary Walls",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.CON.1011"
    },
    {
      id: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70",
      text: "Substation-1 - B Lineup - Dead End Structure Steel Erection And Branch Wiring",
      type: 0,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 104,
      parent: "40a947ea-b2c2-46a6-a512-b24f940e157e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3490"
    },
    {
      id: "590ed68d-51ec-44d7-aee0-4a1ac6510479",
      text: "Install Acoustical Wall Panels",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1320"
    },
    {
      id: "0c454575-0265-447b-87da-a02e8b1d144f",
      text: "DFSMA - DC2 - mCUP - GS.IDF Remote Module ROJ - MOFE (2x3)",
      type: 0,
      start_date: "2025-11-12T08:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 0,
      parent: "d70530f6-b13d-4b0a-940b-9b1bf24a563d",
      progress: 0,
      source_task_id: "B2.DFSMA.1110"
    },
    {
      id: "0c263f70-ba85-47c5-9d0b-f0b9076077af",
      text: "Substation-2 - TX A - Pull Control Wiring",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 40,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4850"
    },
    {
      id: "d6f813d9-79d2-44a8-9724-f3cc328d9b81",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2360"
    },
    {
      id: "edcf6a0a-db04-4020-9363-0d7b36f4189d",
      text: "B2 - DH-B - Corpnet Provisioning",
      type: 0,
      start_date: "2026-07-27T00:00:00",
      end_date: "2026-08-14T08:00:00",
      duration: 120,
      parent: "777e8c6e-a142-4273-82ed-e0333182df28",
      progress: 0,
      source_task_id: "B2.CONN.1150"
    },
    {
      id: "4aa562c1-943c-4953-8bff-7de72161feb4",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Doors, Frames and Hardware",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-04-02T08:00:00",
      duration: 120,
      parent: "e8e087a2-228d-4d9a-91a8-4636f0923181",
      progress: 0,
      source_task_id: "B1.CFCI.4550"
    },
    {
      id: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      text: "FCA Gallery DH-B",
      type: 5,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 576,
      parent: "8afd9616-202b-49c7-8b22-9f4de01ca6bd",
      progress: 0,
      source_task_id: "7995082"
    },
    {
      id: "e9a5d060-ceb9-4572-adfe-c037551cfead",
      text: "Equipment Start Up / Verification",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 120,
      parent: "699e4d53-5251-40a0-8fce-ab082119ae66",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1320"
    },
    {
      id: "7d4323cc-0b3f-43ba-9910-904cab280417",
      text: "B1 - 1N2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 160,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6120"
    },
    {
      id: "3edd199b-ca7b-4066-8faf-3bcaaf3cb119",
      text: "B1 - 1C1W - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1090"
    },
    {
      id: "6dee8a69-99ed-4008-89be-f46e1e2c9021",
      text: "B1 - mCUP-5 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 80,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.9290"
    },
    {
      id: "32bde680-1da0-44bb-912b-83bac3022da5",
      text: "Precon - MOFE",
      type: 5,
      start_date: "2023-12-04T00:00:00",
      end_date: "2024-02-26T08:00:00",
      duration: 456,
      parent: "706d2e52-0772-4280-b13b-93206452f57c",
      progress: 1,
      source_task_id: "7994722"
    },
    {
      id: "8fcbeb5f-6592-40f9-af4c-e632e01c1b54",
      text: "B2 - DH-C - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 80,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1040"
    },
    {
      id: "4acae406-bb7e-4a50-bc5e-58361dc1b779",
      text: "B2 - DH-A - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 80,
      parent: "ee7e7edf-af1b-4b93-83a7-d006dcd1c47a",
      progress: 0,
      source_task_id: "B2.C.EY.1420"
    },
    {
      id: "dd2c9185-b7ce-4449-9345-d1bd48e0c693",
      text: "Install Metal Panels/Skin - Area A - IBOS",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "A1040"
    },
    {
      id: "34cb53d4-3578-4690-9e18-bed8bf706fe5",
      text: "Substation-2 - Pull and Term Substation to MSG Building 1 B/D (Pull to Vaults) - Sequence 1",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 160,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1280"
    },
    {
      id: "3125c09c-538a-4eef-9f3f-213a2ca6ba6c",
      text: "[DCB1] DEC-C Ready: General Services [Area D]",
      type: 0,
      start_date: "2026-02-03T08:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3755"
    },
    {
      id: "b1b593a1-4940-40f6-a98b-d4f19f77e57d",
      text: "B2 - mCUP-1 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1160"
    },
    {
      id: "be3ed880-38fb-4e2c-bcbe-e436a37d5ac6",
      text: "BLDG-1 Network - Equipment Final Clean",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1060"
    },
    {
      id: "771cb3a0-c1e6-4ba2-a434-0169e82336f5",
      text: "B2 - 2E1E - EF4 - Pour Pads Around Telecom Conduits (EF4)",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 48,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5210"
    },
    {
      id: "3fdb2534-673f-49b9-a93b-c564b17a20ef",
      text: "B1 - DH-D - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 160,
      parent: "9f045ffe-87d3-4bb4-b99d-0eab0e0a129a",
      progress: 0,
      source_task_id: "B1.C.D.3090"
    },
    {
      id: "60bcbab5-c809-4195-9169-6b22033f2022",
      text: "B1 - 1D1W - 01D.09 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 144,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2370"
    },
    {
      id: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      text: "Network Room 1/4",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 1008,
      parent: "36beab78-fbfe-4a35-bcd4-46229816c1f9",
      progress: 0,
      source_task_id: "7995342"
    },
    {
      id: "145b3489-db25-4c57-b0a2-99219580d00a",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Gypsum System and Ceilings",
      type: 0,
      start_date: "2025-03-06T00:00:00",
      end_date: "2025-03-26T08:00:00",
      duration: 120,
      parent: "3821e008-bd7a-483f-8d1f-538e64dc2ec4",
      progress: 0,
      source_task_id: "B1.CFCI.4560"
    },
    {
      id: "0b4c3566-413f-4be5-8b2b-054a7faab7b5",
      text: "Install Window Shades",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1590"
    },
    {
      id: "1817c6e8-3d26-4b2d-9562-c650ce4d3977",
      text: "Fab and Deliver - Control Power UPS - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2600,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.36,
      source_task_id: "B1.OFCI.2840"
    },
    {
      id: "62ab5b87-cb5a-43d4-b6d1-f20c578ff042",
      text: "Install Grease Duct Insulation",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1060"
    },
    {
      id: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 288,
      parent: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      progress: 0,
      source_task_id: "7995118"
    },
    {
      id: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      text: "B1 - 1B2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1000"
    },
    {
      id: "72334aef-2df0-447d-9bfa-745351fa577c",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 8,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1410"
    },
    {
      id: "984d6f13-ec1e-4dea-b22d-2a2af28f5c80",
      text: "B2 - 2C1 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1170"
    },
    {
      id: "547e49e5-1db2-4c6c-973e-35a2b28a24bf",
      text: "Precast Complete DH A/C - DCB2",
      type: 0,
      start_date: "2025-10-28T08:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1375"
    },
    {
      id: "f75648e6-476e-4497-9e63-3a1b53a93c46",
      text: "B2 - SSB - 2E1 - Common - Install Ceiling Tiles",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 80,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1260"
    },
    {
      id: "3d1a7ee2-4e21-4f05-a01c-667753c39c4a",
      text: "BLDG-1/2 - Submittal Rvw/App'l - FSC Rough Carpentry (In Wall Backing / Blocking)",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-01-22T08:00:00",
      duration: 120,
      parent: "5595ffef-e80b-48c5-a708-7cfa3f4a69f4",
      progress: 0,
      source_task_id: "B1.CFCI.4540"
    },
    {
      id: "6fa69d15-5639-48e3-ad8b-97f09a014ca8",
      text: "B1 - 1D1W - 01D.09 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2330"
    },
    {
      id: "19d232aa-0dc1-49f0-93d6-1893cfabaf59",
      text: "Corridor 1N2E Enrtrance Facility 3/UPS (2)",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 920,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995324"
    },
    {
      id: "40259346-07ff-4beb-b825-abbaebacbeec",
      text: "Telecom",
      type: 5,
      start_date: "2024-10-17T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 328,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995171"
    },
    {
      id: "d3471800-12a4-4b40-bd54-482e98c2ef65",
      text: "B2 - DH-B - Install BMS Conduit -Data Hall B",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2730"
    },
    {
      id: "520b9b73-2cae-4c9d-aa69-11a16d57879d",
      text: "B2 - DH-A - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1070"
    },
    {
      id: "b3358cb7-9a51-4f12-a11c-43e133cd5f85",
      text: "FR 02 - Additional Civil Permit Review Time - Notification",
      type: 0,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-05-15T08:00:00",
      duration: 8,
      parent: "f5cede49-5629-40ad-881c-25df81197815",
      progress: 1,
      source_task_id: "FR.02.1000"
    },
    {
      id: "347092d5-4329-4c95-8ab1-8c8bd8464704",
      text: "B1 - 1N1E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5360"
    },
    {
      id: "1d26e942-c048-430a-b53e-1f752b423704",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [3] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 2392,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.58,
      source_task_id: "B2.OFCI.2810"
    },
    {
      id: "95fff06a-c765-49fa-9cd3-5e8597b61f18",
      text: "B1 - Network Room 1/4  - Install Ceiling Grid",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1800"
    },
    {
      id: "efcc0cb2-c398-4f5b-9920-0bdedf37cc64",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [2] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 2432,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.43,
      source_task_id: "B1.OFCI.3480"
    },
    {
      id: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      text: "L3 - NS *On Temp Power*",
      type: 0,
      start_date: "2026-01-12T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 440,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX3.B1.NS.1000"
    },
    {
      id: "c361004c-1309-4bfa-989d-0467cf7dc8ea",
      text: "B1 - mCUP-2 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2060"
    },
    {
      id: "729390bf-29c0-4fb1-b281-1f7a51e114ab",
      text: "B1 - 1N1W - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-10-02T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 120,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.6560"
    },
    {
      id: "f5757f89-af65-460b-9bf2-e52ead62156d",
      text: "BLDG-1/2 - Fabricate / Deliver - Signage",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6140"
    },
    {
      id: "38b7ba18-1c93-4014-8324-7fb66740c3bf",
      text: "Trade Partner (Civil) Organizes for VDC Kick Off Meeting",
      type: 0,
      start_date: "2024-03-19T00:00:00",
      end_date: "2024-03-19T00:00:00",
      duration: 0,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC2.1560"
    },
    {
      id: "b471c5d7-a21e-461b-ae37-199d2d5d3f84",
      text: "FR 10 - DPR Prepare and Submit RFI#37,38,39",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: null,
      duration: 0,
      parent: "207d8eec-4e49-43ad-8f43-1e6990c9645f",
      progress: 1,
      source_task_id: "FR.10.1010"
    },
    {
      id: "4b9350f6-eca7-4f51-93c2-67a0fa8f0b29",
      text: "B1 - DH-A - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1230"
    },
    {
      id: "ac485bab-b7a8-486c-a3ba-c48f7d21ed99",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 120,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2300"
    },
    {
      id: "7d1c764a-cf2f-49c0-8f04-deb020ed521c",
      text: "FR 26 - DPR Prepare and Submit PCO#24",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "24dee1b8-ef96-4c88-8860-44cdc0415f08",
      progress: 0.5,
      source_task_id: "FR.26.1010"
    },
    {
      id: "79ea0bfa-70c2-4ab3-886b-2654634c1dfb",
      text: "B2 - DH-A - Room QA/QC Pre DEC-C Turnover - Data Hall A",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2700"
    },
    {
      id: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      text: "(CFCI) Div. 26 - Substation (Permanent) MOAB",
      type: 5,
      start_date: "2024-10-18T00:00:00",
      end_date: "2025-03-24T08:00:00",
      duration: 880,
      parent: "bfc6e3fc-f68d-4c7b-aa41-55b6f0a76c8f",
      progress: 0,
      source_task_id: "7994871"
    },
    {
      id: "9a413c5e-c45b-40ce-a86f-b27382622d01",
      text: "B2 - 2C1 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 8,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1410"
    },
    {
      id: "9008fbb7-cbab-4d11-8fc7-a64a85f561c3",
      text: "BLDG-1/2 - Prep / Submit for Review - Storage racks",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6390"
    },
    {
      id: "0c7cef71-749b-479e-b852-0874ef4090ed",
      text: "B2 - mCUP-2 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2120"
    },
    {
      id: "65317120-a9f6-4f06-95cb-94e066f777b7",
      text: "Construction Complete Fire Pump House",
      type: 0,
      start_date: "2025-10-01T08:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1209"
    },
    {
      id: "04dd5b0f-a51e-4c8c-b26a-2077e88c91d9",
      text: "B1 - SSB - 1E1 - CMDF1 - Pull Wire for Lighting/Outlet/Racks (Carrier MDF1)",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1830"
    },
    {
      id: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a",
      text: "B2 - 2D1 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 8,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1410"
    },
    {
      id: "f9f97a49-1437-47e9-b2e5-da7ac58d0aef",
      text: "L4 Finish DH D - DCB1",
      type: 0,
      start_date: "2026-08-19T08:00:00",
      end_date: "2026-08-19T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2113"
    },
    {
      id: "64199729-94de-49c1-acba-051c12420764",
      text: "Fab and Deliver - PTX-DHAux - Area C (2) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2920,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.46,
      source_task_id: "B2.OFCI.1780"
    },
    {
      id: "a0781e82-3329-4853-81d9-8aef27ea089f",
      text: "B2 - DH-C - Pull/Term Fire Alarm - Data Hall C",
      type: 0,
      start_date: "2026-06-01T00:00:00",
      end_date: "2026-06-26T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2490"
    },
    {
      id: "e6649980-f177-481c-950e-d733e9a7c689",
      text: "B1 - DH-A - Hookup FCAs Mechanical- Data Hall A",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1860"
    },
    {
      id: "8e969182-8f7b-4315-a953-15e292ae012b",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 8,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1490"
    },
    {
      id: "eebe6f72-54c4-4abf-a17f-ac98afd31130",
      text: "IBOS - Prep / Submit for Review - PTX",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: "2024-09-16T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1110"
    },
    {
      id: "51fffb00-b3c5-4525-884a-61373d22b1fe",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 120,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2270"
    },
    {
      id: "2f3e4660-858d-4118-9009-800cc103b7e0",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2000"
    },
    {
      id: "24754848-1156-4161-a0b7-6c6b2331b915",
      text: "B2 - DH-D - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 160,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1660"
    },
    {
      id: "fbc6cd71-5a90-417c-8c22-e9957a99d91e",
      text: "B1 - DH-A - WAP Provisioning",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 160,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1340"
    },
    {
      id: "f102e27f-c1e5-4620-9935-2dec61b6deb8",
      text: "B2 - 2B1 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 120,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2750"
    },
    {
      id: "46f47d04-68c2-48e2-9b7f-622c57abcd4c",
      text: "MSB/RSB - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 344,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 1,
      source_task_id: "B1.OFCI.1090"
    },
    {
      id: "a6195c81-df9e-4adb-9255-efb1e48d1cf8",
      text: "B1 - OSP Cabling - GSIDF 1X3 to IW-IDF",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 40,
      parent: "85391fcf-fbdc-4cfe-b101-e86ca0d8bff2",
      progress: 0,
      source_task_id: "B1.CONN.1040"
    },
    {
      id: "712026df-e261-4bf5-83f6-fde03953e676",
      text: "B1 - OSP Cabling - EF to SUBIDF1",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 120,
      parent: "f9521e9a-0a5d-4806-969d-99217ffb5956",
      progress: 0,
      source_task_id: "B1.CONN.1050"
    },
    {
      id: "4ef1f5b4-ad92-432e-a00b-b5b855055c39",
      text: "B1 - DH-D - Install IMP Walls @ FCAs - Data Hall D",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1110"
    },
    {
      id: "8b805577-0811-4ad0-8814-78709fb07768",
      text: "Substation-2 B Lineup Ground work",
      type: 5,
      start_date: "2025-04-25T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 872,
      parent: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      progress: 0,
      source_task_id: "7995222"
    },
    {
      id: "d89e4703-8027-49ec-89d9-8c22ed9ed0bb",
      text: "B1 - 1N1E - 01N4.06 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6480"
    },
    {
      id: "e0cf13c9-4da5-4f95-b4db-626ddfca1c80",
      text: "Design Team Address Comments & Re-Submit - Mass Grading Permits",
      type: 0,
      start_date: "2024-01-29T00:00:00",
      end_date: "2024-03-04T08:00:00",
      duration: 200,
      parent: "68519373-5be8-4c94-895d-f8db4c1edde5",
      progress: 1,
      source_task_id: "PRE-DD-1110"
    },
    {
      id: "36539673-287c-4060-8b2c-170c56529f35",
      text: "Substation-2 A Lineup Ground work",
      type: 5,
      start_date: "2025-04-18T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 872,
      parent: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      progress: 0,
      source_task_id: "7995216"
    },
    {
      id: "317fedf3-4445-4d48-b19e-75107c7c0568",
      text: "BLDG-1 SSB 1E2",
      type: 5,
      start_date: "2025-05-27T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1272,
      parent: "7a3b9846-48b7-40e8-a145-00e7fba0e1ee",
      progress: 0,
      source_task_id: "7995292"
    },
    {
      id: "68703b00-9add-4022-9238-31381c41f1b5",
      text: "Area 2 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1270"
    },
    {
      id: "bdfe14a4-f314-4780-b892-2d253d9342b1",
      text: "B2 - SSB - 2E2 - Common - E-cure/Seal Floors",
      type: 0,
      start_date: "2026-05-06T00:00:00",
      end_date: "2026-05-15T08:00:00",
      duration: 64,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1890"
    },
    {
      id: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      text: "B2 - SSB - 2E2 - Common - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-12-15T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1600"
    },
    {
      id: "6dd38d3a-408d-4f08-be6b-fc28e0f9e1ed",
      text: "Campus PH1 - Prep / Submit for Review - T-Comm Vaults (Site) ((Early Release))",
      type: 0,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 120,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0.5,
      source_task_id: "B1.CFCI.3320"
    },
    {
      id: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      text: "Fragnet 36 - CAV -5 RFI # - resize",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: null,
      duration: 336,
      parent: "c9ca9ab5-7485-4d38-99c3-3c5fef4f879b",
      progress: 0.31,
      source_task_id: "8717460"
    },
    {
      id: "f75086e3-4fc5-4d53-9959-32599c157446",
      text: "B1 - DH-D - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 40,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1310"
    },
    {
      id: "70db9058-eab2-46cb-8fed-6849cceba762",
      text: "Substation 2 Constuction Complete",
      type: 0,
      start_date: "2026-04-23T08:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1090"
    },
    {
      id: "6265d63a-03f4-4699-a369-5fe6a59d94a5",
      text: "Building 1",
      type: 5,
      start_date: "2025-06-04T08:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 2112,
      parent: "0577b673-7309-47d7-974d-03b269939669",
      progress: 0,
      source_task_id: "7995441"
    },
    {
      id: "321aed74-6602-4bcf-9551-e88ad2a90aee",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 24,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1770"
    },
    {
      id: "c9a81071-196f-4344-9d39-aa8b296f2ad3",
      text: "B2 - DH-C - Install Celing Devices Fire Alarm - Data Hall C",
      type: 0,
      start_date: "2026-06-15T00:00:00",
      end_date: "2026-07-13T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2580"
    },
    {
      id: "ce7cbeee-1b3c-4618-a488-ab281e1755a4",
      text: "B1 - DH-B - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 96,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2430"
    },
    {
      id: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      text: "B1 - RF-Tower-1 - Electrical Equipment Pulls/Terms",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 80,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2200"
    },
    {
      id: "9478365f-6a8c-4157-b13b-f5a3a975e229",
      text: "B2 - mCUP-1 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 16,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1170"
    },
    {
      id: "90e8d5c9-7016-4e05-8700-b5a0fa75b0e2",
      text: "B1 - Network Room 2/3 - Install Grounding Loop",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2090"
    },
    {
      id: "2c4a6049-53c8-4785-b464-67fe218a6310",
      text: "IST Start DH C - DCB1",
      type: 0,
      start_date: "2026-08-07T00:00:00",
      end_date: "2026-08-07T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2174"
    },
    {
      id: "4ce3608d-1ea4-40c3-8781-148bfbee66aa",
      text: "B1 - DH-A - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 48,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2440"
    },
    {
      id: "495fa92e-2af1-4449-b96c-298a3e20e135",
      text: "B1 - Network Room 2/3 - Power Alley - OH Sprinkler Mains and Branch",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1380"
    },
    {
      id: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-07-27T08:00:00",
      duration: 248,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995393"
    },
    {
      id: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      text: "B1 - ISP Cabling - EF1/2 to Carrier1/2 to MDF1/2 (GS tray) ((Facnet Live))",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 80,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1160"
    },
    {
      id: "b1f5cd91-188c-4c2d-81fc-c55c197aa8ec",
      text: "Site BIM Coordination Package [Civil & Struct. Foundation IFP Set]",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-18T00:00:00",
      duration: 0,
      parent: "67d734a8-c39d-4ca8-b86e-5d5930a7692f",
      progress: 1,
      source_task_id: "PRE-DP-1001"
    },
    {
      id: "94b0bf4c-9fc1-4a65-b8de-3acaa4877836",
      text: "Area A - Hang Top Out",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1021"
    },
    {
      id: "0745b271-8802-45ec-8d9a-b0b6b88f83da",
      text: "B1 - 1D1W - 01D.08 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2650"
    },
    {
      id: "5ebd31d6-7801-416f-82db-096864c18f8c",
      text: "DH-D",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 1384,
      parent: "4fa3accc-c8b6-477e-8cfb-161dd5586af2",
      progress: 0,
      source_task_id: "7995064"
    },
    {
      id: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7",
      text: "B1 - DH-C - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 80,
      parent: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      progress: 0,
      source_task_id: "B1.C.C.3060"
    },
    {
      id: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      text: "Landscape",
      type: 5,
      start_date: "2025-08-16T00:00:00",
      end_date: "2026-09-16T08:00:00",
      duration: 2192,
      parent: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      progress: 0,
      source_task_id: "7995205"
    },
    {
      id: "963add96-1857-4130-80f5-cf03290831e1",
      text: "Start Owner Furniture, Fixtures, and Equipment (FF&E) - Admin",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-20T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1197"
    },
    {
      id: "301d69bb-9efa-4a33-a9bf-e6639a2723ed",
      text: "Start Foundations - Admin",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-14T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.SUB.1000"
    },
    {
      id: "f66200c5-a477-4687-85d7-7b0b6c427cf3",
      text: "B1 - DH-D - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 96,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1640"
    },
    {
      id: "0cb5964e-d5f3-448a-b858-099bfa9d31a4",
      text: "Area 3 - UG RI -MVS to PTX-DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1500"
    },
    {
      id: "7b14a916-deaa-4e4b-b674-03855ba5477c",
      text: "B1 - 1N2W - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2270"
    },
    {
      id: "ff7c9138-a070-4e40-b1e8-30f760d71e98",
      text: "Fire Protection SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-06-06T00:00:00",
      end_date: "2024-07-09T00:00:00",
      duration: 80,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 1,
      source_task_id: "PRE1600"
    },
    {
      id: "bf5b3812-aeb9-48bd-8e73-c3593e735648",
      text: "B1 - 1N2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5450"
    },
    {
      id: "be3d69fd-6db0-46c1-9934-f848f0067e34",
      text: "BLDG-2 - Area C - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 80,
      parent: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      progress: 0,
      source_task_id: "B1.CFCI.5120"
    },
    {
      id: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8",
      text: "B2 - DH-C - L2 CDU Install Verification - Data Hall C",
      type: 0,
      start_date: "2026-06-19T00:00:00",
      end_date: "2026-07-11T08:00:00",
      duration: 144,
      parent: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      progress: 0,
      source_task_id: "B2.C.C.3280"
    },
    {
      id: "0dd3e77e-b44c-4bb0-a73d-80904cc0b6e9",
      text: "Area A - Security Device Install",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1391"
    },
    {
      id: "1b45280a-8cad-405b-9173-15e4699cb7db",
      text: "Fab and Deliver - HMD - Area D - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 3688,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 0.35,
      source_task_id: "B2.OFCI.2620"
    },
    {
      id: "14311162-e5f2-4a9a-a047-a5f6a8e31db0",
      text: "B1 - DH-A - El Equip Yd - Set Equipment (2)MSG",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 80,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2790"
    },
    {
      id: "382647f4-58c8-42c3-ac82-7fc3285549bd",
      text: "FR 34 - META review and Approve PCO#35",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "883427a6-7812-434c-b7bc-0738a53a7b23",
      progress: 0,
      source_task_id: "FR.34.1030"
    },
    {
      id: "d7202a85-e01b-4fa0-a22d-b443d9c29d15",
      text: "B2 - mCUP-6 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6080"
    },
    {
      id: "5004e0d5-4281-4d3d-9228-d500697f5f44",
      text: "CRAH - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-01-09T00:00:00",
      end_date: "2024-01-16T08:00:00",
      duration: 40,
      parent: "cebac7a2-3c43-4d53-bc0b-02c1d6553116",
      progress: 1,
      source_task_id: "B1.OFCI.1580"
    },
    {
      id: "a63c40a5-c4c9-4674-bdbd-870ef5fa315c",
      text: "BLDG-1/2 - Prep / Submit for Review - Building Controls",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 160,
      parent: "cb9ddad6-dc85-427d-a3ce-d7471522dab1",
      progress: 0,
      source_task_id: "B1.CFCI.3830"
    },
    {
      id: "15ddbbb6-83af-485f-a6a1-3c45abb69cce",
      text: "Area 3 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1480"
    },
    {
      id: "8caa99bf-a3f0-49b4-819e-f79899f10d60",
      text: "B1 - Network Room 2/3 - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 16,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.2180"
    },
    {
      id: "862633a3-0830-40e4-b052-c3bfe6286a90",
      text: "B1 - DH-C - Raise HACs - Data Hall C",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2440"
    },
    {
      id: "b292f9f6-cc9d-4599-bef3-7964fab7e2cb",
      text: "B1 - DH-A - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2780"
    },
    {
      id: "dbeb179b-de7e-49b9-87ba-ce0148551672",
      text: "UG RI -Rack Bus-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "d87c40c9-36ba-466e-9282-c17bb73cf6fe",
      progress: 0,
      source_task_id: "MECO-1740.10"
    },
    {
      id: "56a3c0d5-3417-4023-8cb7-11411f07c760",
      text: "B1 - SSB - 1E1 - Common - Install Devices in Tile/OH Fire Alarm",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2150"
    },
    {
      id: "fd304b43-3efb-4e9b-8579-e7ec1cc17d3a",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1160"
    },
    {
      id: "7396df52-8be2-42b0-85c0-849a0964ef15",
      text: "Substation-2 A Lineup Vertical Work",
      type: 5,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 320,
      parent: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      progress: 0,
      source_task_id: "7995217"
    },
    {
      id: "d374f729-28ce-44ea-a8ee-84b337261347",
      text: "B1 - DH-C - L2 CDU Pre-Eng Inspection - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-02-17T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 144,
      parent: "dcac32fd-f134-4e86-b43f-bafd5526cedf",
      progress: 0,
      source_task_id: "B1.C.C.3210"
    },
    {
      id: "ddf2a130-7cb9-4046-8397-fb156a5859fc",
      text: "B2 - DH-C - Backfill",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 40,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1510"
    },
    {
      id: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      text: "Area 1 - Mass Grading",
      type: 0,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-07-02T08:00:00",
      duration: 160,
      parent: "56854237-ebdf-4446-8f94-9f575bfa1fbf",
      progress: 0.6,
      source_task_id: "C.CSU.A1.1000"
    },
    {
      id: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      text: "B2 - DH-B - Cure for SOG",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 24,
      parent: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      progress: 0,
      source_task_id: "B2.C.STR.2200"
    },
    {
      id: "2c166bbf-dfb5-4967-89e2-1b16c076b300",
      text: "B2 - DH-D  - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1090"
    },
    {
      id: "02b3d7c8-80d7-4f5a-966f-7131ef11254c",
      text: "Substation-1 - A Lineup SF6 Breaker - L3 Dead Bus Checkout and NETA Testing Energization",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 48,
      parent: "aa22521b-48bf-4060-93d0-7750855b683f",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4190"
    },
    {
      id: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315",
      text: "L5 - B1 DHD",
      type: 0,
      start_date: "2026-08-24T00:00:00",
      end_date: "2026-08-25T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHD.1010"
    },
    {
      id: "ffb3f31e-e683-406b-9039-fc25fe6e5c80",
      text: "Substation-1 - MSG B - Duration of Verification of Stable Power",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 40,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6990"
    },
    {
      id: "a312a493-b127-46dc-80ba-8f6ca5f888de",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1980"
    },
    {
      id: "aac5add6-2a20-4a39-959d-8173a564edc9",
      text: "B1 - 1B2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 80,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1590"
    },
    {
      id: "77401d30-e087-409c-926b-760a5e2afb49",
      text: "B2 - DH-D - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2026-05-04T00:00:00",
      end_date: "2026-05-15T08:00:00",
      duration: 80,
      parent: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      progress: 0,
      source_task_id: "B2.C.EY.1600"
    },
    {
      id: "6729170e-d170-4219-8523-1285e8217d18",
      text: "BLDG-2 SSB 2E1 Common Area Buildout",
      type: 5,
      start_date: "2025-10-24T00:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 1200,
      parent: "2190598a-f73d-49e3-90be-8cc832c8ba79",
      progress: 0,
      source_task_id: "7995042"
    },
    {
      id: "f9d86652-6a1c-40f5-a401-c4ba776bb6ef",
      text: "L4 Finish Network Core - DCB1",
      type: 0,
      start_date: "2026-04-21T08:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2056"
    },
    {
      id: "c787e886-a50d-480f-a52c-e7163b031f10",
      text: "Adverse Weather Event 7 - 08.29.2024",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 8,
      parent: null,
      progress: 1,
      source_task_id: "WX.1007"
    },
    {
      id: "9a014585-bce5-4d8e-bf63-bc24dafe0459",
      text: "B2 - DH-B - Set FCA's - Data Hall B",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2160"
    },
    {
      id: "d541cc42-11bf-453d-a0d0-ec548d55e95d",
      text: "FR 37 - DPR prepare and Submit RFI #219.1",
      type: 0,
      start_date: "2024-10-08T00:00:00",
      end_date: null,
      duration: 0,
      parent: "3379c616-a9bf-4246-981a-9eef20f2a943",
      progress: 1,
      source_task_id: "FR.36.1060"
    },
    {
      id: "27d933b4-bb78-4492-a7f9-8c053db73068",
      text: "(OFCI) B2 Water Cooled Chillers",
      type: 5,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 2592,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.52,
      source_task_id: "7994957"
    },
    {
      id: "06c1743d-99a6-4841-b51f-07237624fb2f",
      text: "Site / UG BIM - Area 1 - Critical Early Release - Coordination / Sign Off",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-08T00:00:00",
      duration: 120,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1020"
    },
    {
      id: "4cd10cc1-afc9-45de-9bfd-1dfa78f94014",
      text: "Fab and Deliver - HMD - Area A - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 0.35,
      source_task_id: "B2.OFCI.2600"
    },
    {
      id: "c337f453-3ddf-4941-897e-2c0840b1969a",
      text: "Substation-1 - TX A - Install Medium  And High Voltage Cable",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 80,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4100"
    },
    {
      id: "af9419ae-c23e-48e4-b592-87c16a8a04cd",
      text: "B2 - DH-C - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2026-05-04T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 40,
      parent: "7e2c4263-df53-41a3-b764-1e6e272793de",
      progress: 0,
      source_task_id: "B2.C.EY.1640"
    },
    {
      id: "cae42bc0-7268-498a-8ff1-bd54ce3c18bf",
      text: "Overhead Mechanical, Install Equipment",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 80,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1030"
    },
    {
      id: "78f1bbbc-e57c-4c48-bdad-0c9b1e95ecdf",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [6] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-12-16T08:00:00",
      duration: 1720,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.6,
      source_task_id: "B1.OFCI.3610"
    },
    {
      id: "ff622825-6d1e-4f1c-a095-0cac0495ccc3",
      text: "Substation-1 - B Lineup - Install Breaker and Misc Pad / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-02-14T00:00:00",
      end_date: "2025-03-11T08:00:00",
      duration: 168,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3390"
    },
    {
      id: "3ce5428a-e0ce-4ed4-b70f-a9dd03aacf17",
      text: "B1 - mCUP-9 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-08T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9120"
    },
    {
      id: "a6571f80-018d-4be0-938e-a6e7749692cc",
      text: "L4 Finish DH A - DCB1",
      type: 0,
      start_date: "2026-05-13T08:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2081"
    },
    {
      id: "e7525e1f-7352-4ede-9294-cffe817e578a",
      text: "BLDG-1 Network Level 2 Checkout",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 304,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "7995256"
    },
    {
      id: "878c4134-a00b-4a43-8636-78dd27899f13",
      text: "B1 - DH-B - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 160,
      parent: "6d080f13-3987-4a3c-b673-e8743952148f",
      progress: 0,
      source_task_id: "B1.C.B.3210"
    },
    {
      id: "88495794-a10c-4687-ae42-e93d34cae0b6",
      text: "Substation-1 - B Lineup - Install MSG Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-01-28T00:00:00",
      end_date: "2025-02-13T08:00:00",
      duration: 168,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3380"
    },
    {
      id: "bd2cd522-a21f-427a-9611-ec203d20cdc7",
      text: "BLDG-2 DH-A - Equipment Final Clean",
      type: 0,
      start_date: "2026-08-18T00:00:00",
      end_date: "2026-09-08T08:00:00",
      duration: 120,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1060"
    },
    {
      id: "df5b0f03-ca4f-43a8-af94-1c909c18d19e",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2010"
    },
    {
      id: "d3b505a3-d247-47de-833e-581cfb088f1d",
      text: "B1 - DH-D - Install Celing Devices Fire Alarm - Data Hall D",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1370"
    },
    {
      id: "e2265c6c-2019-4f34-9100-eeadcfcb56b1",
      text: "B2 - SSB - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 80,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1090"
    },
    {
      id: "0b85ca12-43d2-4c17-acd4-269a6497f9d6",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2120"
    },
    {
      id: "681ea83e-2207-4fd2-b708-4226a66e2574",
      text: "B2 - 2E2E - EF2 - Pull Wire for Lighting/Outlet/Racks (EF2)",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 24,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6290"
    },
    {
      id: "879cd5c6-a8f9-41d0-95d9-f6231708cd22",
      text: "B1 - 1N1E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-06-16T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 104,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5030"
    },
    {
      id: "0eb36f79-ca35-4824-959a-30cf91e12746",
      text: "B1 - DH-C - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 1032,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "B1.C.C.3000"
    },
    {
      id: "9943b970-1777-4ae7-8e66-ce20ddbd341b",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1320"
    },
    {
      id: "6e2a8468-9352-470f-a935-1a4f384833cb",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1340"
    },
    {
      id: "d505c511-6a65-486c-a760-3617f691c55c",
      text: "Underground",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "60a784f9-46e6-429a-aa4e-aa888c93bfcd",
      progress: 0,
      source_task_id: "8444256"
    },
    {
      id: "ce046f13-7690-47a8-b525-3d2dcb274d34",
      text: "B1 - 1N2W - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 160,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1030"
    },
    {
      id: "bd67df7a-75d1-4b28-8baf-8b3949ea42f1",
      text: "Electrical Preconstruction Services ? LNTP Development",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-26T08:00:00",
      duration: 80,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "PRE1180"
    },
    {
      id: "300f59b9-9631-4775-aec5-e4eeb9a08aad",
      text: "B2 - DH-B - El Equip Yd - Set Equipment (12)MVS, (24) PTX",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1180"
    },
    {
      id: "06a3be6c-b5de-4abc-94d0-4c2ce243f7e0",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2410"
    },
    {
      id: "632be35f-8f46-4b5c-bb52-d9b55c9ddad3",
      text: "(CFCI) Div. 28 - Elec. Safety & Security",
      type: 5,
      start_date: "2024-10-23T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 608,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994884"
    },
    {
      id: "7ab0d032-7181-45eb-90dc-eddef0a3efa2",
      text: "B2 - 2D1 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 80,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1990"
    },
    {
      id: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      text: "B1 - DH-B - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 120,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1290"
    },
    {
      id: "8bf7e77a-1de6-4ac3-a90e-b630f0eca710",
      text: "B1 - DH-B - Install Perimeter Cable Tray - Data Hall B",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2880"
    },
    {
      id: "8a07150f-e272-4881-891f-4897d14425ab",
      text: "B2 - DH-B - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 48,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2500"
    },
    {
      id: "27f9fd5a-b31c-4d1c-a3bb-cfa01b9aef75",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1310"
    },
    {
      id: "974d8c78-61e4-414b-9243-d66ed8d9f99a",
      text: "BMS Controls - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-06-18T00:00:00",
      end_date: "2024-09-16T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0,
      source_task_id: "Design.PreC.5680"
    },
    {
      id: "4016a0a2-9bce-4112-a177-64ed092fdb94",
      text: "(OFCI) Substation HPT",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2600,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0.17,
      source_task_id: "7994941"
    },
    {
      id: "fe53f24b-505a-4847-bb04-e50fa7e3eff4",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1510"
    },
    {
      id: "3419d4ab-22c8-42ac-a3d6-260a31398d10",
      text: "PRS Review Cycle",
      type: 0,
      start_date: "2024-01-08T00:00:00",
      end_date: "2024-01-22T08:00:00",
      duration: 80,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "Design.PreC.2160"
    },
    {
      id: "c95bf24f-1875-4cae-ad03-3cdaaef52eae",
      text: "B1 - mCUP-7 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7020"
    },
    {
      id: "9c39ad29-e2af-45a6-9371-8e5d24021b54",
      text: "B2 - DH-A - Backfill",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 40,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1380"
    },
    {
      id: "37bb25b9-8e38-43b3-9af7-767e4ef099d0",
      text: "B1 - 1C2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1740"
    },
    {
      id: "e06668a3-b613-4982-a7bf-8415dba63891",
      text: "B2 - 2D2 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 8,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1460"
    },
    {
      id: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2025-11-04T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 800,
      parent: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      progress: 0,
      source_task_id: "7995113"
    },
    {
      id: "20162ba7-1bc4-4672-bd33-91522a8f7102",
      text: "Fab and Deliver - Assembled Skids - Area NW-2 *NOT ON PROCLOG*",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 1656,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.42,
      source_task_id: "B1.OFCI.2660"
    },
    {
      id: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      text: "UPS Room 01D.08",
      type: 5,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 480,
      parent: "8b063fd8-f4b7-446c-8f75-0d37bdf1593d",
      progress: 0,
      source_task_id: "7995317"
    },
    {
      id: "c204c6e7-83b4-4f9f-bd4b-86f615a29e46",
      text: "B2 - DH-A - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1080"
    },
    {
      id: "77dd5370-9411-40b1-9bba-a426f4b98ac3",
      text: "Substation-1 - MSG B - Install Verification Inspection And Issue Resolution",
      type: 0,
      start_date: "2025-05-03T00:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 152,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3590"
    },
    {
      id: "1dd53faf-8264-4359-855e-4925cbdace3b",
      text: "(CFCI) Div. 05 - Metals",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2025-05-12T08:00:00",
      duration: 1664,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0.09,
      source_task_id: "7994920"
    },
    {
      id: "b8de3189-4705-434f-98fb-e69fad6858b4",
      text: "B1 - 1N1E - 01N4.06 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.5910"
    },
    {
      id: "b4cc41db-c251-43e2-af75-c1eb97081db4",
      text: "B1 - Network Room 1/4 - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.2110"
    },
    {
      id: "0bab80ea-8808-4fcd-bcf8-5c2534153920",
      text: "Fragnet 12 - Sanitary Sewer Tie In",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: null,
      duration: 432,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.17,
      source_task_id: "8519889"
    },
    {
      id: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      text: "B1 - mCUP-2 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2040"
    },
    {
      id: "33a147ac-f3bd-4827-8edc-e72977ca1c89",
      text: "L3 Start mCUP  - DCB1",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-11T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2070"
    },
    {
      id: "a2529087-acf2-4938-9a69-515967594528",
      text: "Off Campus - Extend Utility Provider Power service (16 miles)",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2025-03-18T08:00:00",
      duration: 2000,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 0.13,
      source_task_id: "C.CSW.3060"
    },
    {
      id: "6a134ced-0b47-4ff2-8ea9-23dc9d4bb641",
      text: "B1 - mCUP-4 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4060"
    },
    {
      id: "8a925966-ce5b-4931-a282-e3043b01a1ab",
      text: "Substantial Completion (DH D) - DCB2",
      type: 0,
      start_date: "2027-05-14T08:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 0,
      parent: "c02bb0d9-a0ba-46c8-8c9c-98131322446d",
      progress: 0,
      source_task_id: "ICM.B2.1110"
    },
    {
      id: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      text: "(OFCI) LLE - Building 1",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 4200,
      parent: "8820736c-410e-4efe-a06b-d0fc26d82040",
      progress: 0.26,
      source_task_id: "7994967"
    },
    {
      id: "2bba753e-4024-4a09-8b76-7988bfa3f392",
      text: "B1 - DH-D - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 24,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1540"
    },
    {
      id: "6798a730-f88a-498d-9d8c-74f13928280f",
      text: "B1 - Deep Telecom - EF1",
      type: 0,
      start_date: "2024-12-09T00:00:00",
      end_date: "2024-12-13T08:00:00",
      duration: 40,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2380"
    },
    {
      id: "c44a0923-e34d-491d-b45f-2e298a2641bb",
      text: "Substation-1 - MSG B - Assembly",
      type: 0,
      start_date: "2025-04-28T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 136,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3550"
    },
    {
      id: "6002bc3b-dca8-4815-b46b-fc9121f4990f",
      text: "Lighting Protection",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1280"
    },
    {
      id: "8e36182b-56a6-4925-a1a9-cd6d8fc09205",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2670"
    },
    {
      id: "c16f82c3-46d7-45ca-81f1-b909e7d6921f",
      text: "B1 - 1D1W - 01D.08 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2300"
    },
    {
      id: "3de266fe-517d-480a-97ed-db6e2d84b97d",
      text: "B1 - mCUP-5 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5090"
    },
    {
      id: "809f0131-9f7c-44f5-926b-2b24b1267cdd",
      text: "Area B - OH Security",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1161"
    },
    {
      id: "30a283fc-c369-456b-baba-f2fd8b116030",
      text: "Area 4 - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1650.10"
    },
    {
      id: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e",
      text: "B1 - DH-B - Set CDU's - Data Hall B (16 total; 4 per day)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 64,
      parent: "b38b9d81-df08-4732-9a53-49eb573b0138",
      progress: 0,
      source_task_id: "B1.C.B.3025"
    },
    {
      id: "ac2857fb-8394-454b-85a8-e18e77988f4b",
      text: "FR 27 - DPR Prepare and Submit PCO#25",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "aa1ff7d6-d087-48dd-9265-36de0702a4b8",
      progress: 0.5,
      source_task_id: "FR.27.1010"
    },
    {
      id: "61e00cf8-6338-4aa1-af3d-9ad8f71bda62",
      text: "FGMP Development",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-07T08:00:00",
      duration: 392,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2340"
    },
    {
      id: "c15df593-87de-45ec-8261-3f57af4f3c95",
      text: "B2 - 2E2E - 02.01.E1.02 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6450"
    },
    {
      id: "0c85d693-2cec-42fa-814f-5d26ed8dbb21",
      text: "B1 - DH-A - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1240"
    },
    {
      id: "659d02e6-e36e-4259-b69b-6eb7434d9601",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Below Grade Waterproofing (revise and resubmit)",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-04T00:00:00",
      duration: 120,
      parent: "7bb51d4c-8179-4d67-b199-7fb7f7af2db9",
      progress: 0,
      source_task_id: "B1.CFCI.4340"
    },
    {
      id: "2be7a4ad-05b3-4680-9025-f562fe5417cf",
      text: "Substantial Completion-No Weather - Bldg 1 - DH D",
      type: 0,
      start_date: "2026-09-01T08:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B1.MIL.1110"
    },
    {
      id: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      text: "DEC-C Ready: OSP Pathways",
      type: 5,
      start_date: "2025-06-04T08:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 1152,
      parent: "6265d63a-03f4-4699-a369-5fe6a59d94a5",
      progress: 0,
      source_task_id: "7995442"
    },
    {
      id: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      text: "B2 - ISP Cabling - IDFC to DHC (GS tray)",
      type: 0,
      start_date: "2026-09-10T00:00:00",
      end_date: "2026-10-14T08:00:00",
      duration: 200,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1270"
    },
    {
      id: "c15bba6e-fca1-48cd-9062-95de94b290f7",
      text: "B2 - 2E1E - 02.01.E1.05 - Lighting and Devices",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5520"
    },
    {
      id: "cfd3da95-4550-42a9-b5c7-a1c53c8da4cb",
      text: "Fragnet 33 - PCO # 32 CCD-024 Secur Cam View Clash w MTR Posts",
      type: 0,
      start_date: "2024-09-21T00:00:00",
      end_date: null,
      duration: 320,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717482"
    },
    {
      id: "a1712f69-196c-4cb1-b138-9f1b1913279d",
      text: "B2 - DH-C - L2 CDU Pre-Eng Inspection - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-07-20T00:00:00",
      end_date: "2026-08-08T08:00:00",
      duration: 144,
      parent: "b59787b1-4034-47f1-b469-52b087cc7b04",
      progress: 0,
      source_task_id: "B2.C.C.5050"
    },
    {
      id: "ed3ad6f3-bf27-4991-8291-fff7f6e012c1",
      text: "B1 - 1B2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2050"
    },
    {
      id: "bb3e3f73-bca9-458a-8dfe-7e6a8aec5b3c",
      text: "L4 Finish mCUP  - DCB1",
      type: 0,
      start_date: "2026-04-21T08:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2133"
    },
    {
      id: "919fde6b-6525-430d-974f-fc044576fa3a",
      text: "L4 Finish DH A - DCB2",
      type: 0,
      start_date: "2026-12-03T08:00:00",
      end_date: "2026-12-03T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2081"
    },
    {
      id: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      text: "(OFCI) B1 Electrical Skids",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3232,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.21,
      source_task_id: "7994987"
    },
    {
      id: "3bcbf178-3309-4cd5-a06b-9dd315f97658",
      text: "Fab and Deliver - Substation Circuit Breaker - Area SS-2 (2) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 2816,
      parent: "dce7c311-c42c-460b-bd76-db76204a1acf",
      progress: 0.25,
      source_task_id: "B2.OFCI.2110"
    },
    {
      id: "b68c4bfd-342f-4276-b864-c869ddf28b74",
      text: "B2 - DH-D - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-10T08:00:00",
      duration: 80,
      parent: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      progress: 0,
      source_task_id: "B2.C.EY.1770"
    },
    {
      id: "b8b83fee-8725-480a-9fd8-241f75488a4e",
      text: "B1 - DH-C - Roofing (Converted to LOE)",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 120,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1240"
    },
    {
      id: "ab6020ca-b7f2-4a90-a390-743c5968fa60",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2170"
    },
    {
      id: "8e2b70ce-f130-410b-a9ac-31a2e52d1148",
      text: "B1 - DH-D - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 536,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "B1.C.D.3040"
    },
    {
      id: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7",
      text: "B2 - DH-D - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2026-05-12T08:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 0,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1890"
    },
    {
      id: "a66f914c-9f61-4dd6-8a01-abc3ad94d3c7",
      text: "B2 - DH-D  - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 96,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1900"
    },
    {
      id: "7cbd4707-b5c4-49a0-824e-49ceb17978ef",
      text: "B2 - 2B2 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 160,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1850"
    },
    {
      id: "55203d15-6a05-4636-aac5-eb996029b878",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 216,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995396"
    },
    {
      id: "4eb20726-ed89-4a86-a5df-85ab23867b33",
      text: "Domestic Water",
      type: 5,
      start_date: "2024-10-15T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 40,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995158"
    },
    {
      id: "d3ccd2d0-9f36-4a67-a054-8012a25ce12d",
      text: "B2 - 2A2 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1450"
    },
    {
      id: "d847da25-e96a-49ad-818b-2b3297a9b3bc",
      text: "B2 - 2C2 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-07-02T08:00:00",
      duration: 160,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2430"
    },
    {
      id: "70103506-8711-41c1-b142-836e59671810",
      text: "Start Foundations - DCB2",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2025-05-06T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "ICM.B2.1060"
    },
    {
      id: "6e8dd9e7-9304-4294-a080-e8a803cfa7bd",
      text: "Substation-1 - Install Ground Grid / Excavate / Install / Inspections / Backfill - Sequence 1",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 120,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3470"
    },
    {
      id: "c12c184e-e11b-4568-9eb8-4a8f075ac119",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-D - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-12T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 240,
      parent: "3458751c-652e-4bca-a6eb-75a1f58feb41",
      progress: 0,
      source_task_id: "B1.VDC.1640"
    },
    {
      id: "a3503350-f84f-4646-b6ad-d730546875c3",
      text: "Admin -Shopdrawings Rvw/App'l - Lighting",
      type: 0,
      start_date: "2025-01-10T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1180"
    },
    {
      id: "f95da175-d0e0-45fb-b1df-565f047340cd",
      text: "Area A - In Wall Rough Electrical",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1061"
    },
    {
      id: "1cf666a1-1a39-47f8-b106-98e8bddf8846",
      text: "Fab and Deliver - MSB - Area SSB - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 3576,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.38,
      source_task_id: "B2.OFCI.2540"
    },
    {
      id: "d20dc6e1-38aa-462a-a1ff-9a4e936a3658",
      text: "B1 - DH-D - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 40,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1400"
    },
    {
      id: "941bb44b-8780-4ff6-a4bd-e63e335b7c70",
      text: "B1 - 1D1W - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 80,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1780"
    },
    {
      id: "1e3a1548-05c7-4aa5-82d3-607a0665054e",
      text: "Area 3 - Electrical Connections to water meter",
      type: 0,
      start_date: "2025-04-04T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8100"
    },
    {
      id: "5556f3d9-5f68-4d27-a631-3ea52a86e32c",
      text: "B2 - DH-B - Install Lighting/Branch Conduit -Data Hall B",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2700"
    },
    {
      id: "a3d8a10a-8e6b-4b46-b41b-13129526f875",
      text: "B2 - DH-A - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 40,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1580"
    },
    {
      id: "c8c0276e-dd57-43f8-9589-bc68dba22ad7",
      text: "Set Fire Pump/FDC",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 32,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1060"
    },
    {
      id: "262a0d87-2f90-4eb6-a570-bfbfe5a8b556",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1650"
    },
    {
      id: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0",
      text: "B1 - DH-D - Install Coping",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 80,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1460"
    },
    {
      id: "c4685307-7acd-4cc8-b09b-8ec3e8040c0b",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2090"
    },
    {
      id: "c8f191f4-88f6-4838-af1b-a1b8ef64b5ad",
      text: "Concrete - Meta Authorized",
      type: 0,
      start_date: "2024-06-12T00:00:00",
      end_date: "2024-06-12T00:00:00",
      duration: 0,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 1,
      source_task_id: "PRE-PP-1280"
    },
    {
      id: "7989b2b6-5240-47f3-adab-3b89fbe05185",
      text: "L3 Finish DH A - DCB1",
      type: 0,
      start_date: "2026-04-29T08:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2002"
    },
    {
      id: "4d03258e-82b0-490e-ad68-41d63b50d143",
      text: "B2 - DH-B - Inspect Above Ceiling - Data Hall B",
      type: 0,
      start_date: "2026-07-02T00:00:00",
      end_date: "2026-07-09T08:00:00",
      duration: 40,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2850"
    },
    {
      id: "855fe1a5-18dc-47fa-8635-6a2a570d237e",
      text: "Area 3 - Sanitary Sewer Install - Lift Station - Added Scope",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: "2024-10-10T08:00:00",
      duration: 80,
      parent: "622b64a1-3b44-4ab4-8dc6-e0062ed3f6a5",
      progress: 0,
      source_task_id: "C.CSU.A2.8030"
    },
    {
      id: "2e6fd349-9798-4d77-b947-f922686d4d0d",
      text: "B1 - 1N2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 8,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5410"
    },
    {
      id: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c",
      text: "Assembled Skids - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 1,
      source_task_id: "B2.OFCI.1140"
    },
    {
      id: "44ec1edf-2c44-44a5-9a05-1c5cc6147b1f",
      text: "B2 - DH-C - L2 CDU Pre-Eng Inspection - Data Hall C",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-18T08:00:00",
      duration: 144,
      parent: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      progress: 0,
      source_task_id: "B2.C.C.3290"
    },
    {
      id: "d9b4fdc0-184a-47df-8951-677628252698",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area SSB (1) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 3320,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.35,
      source_task_id: "B2.OFCI.1940"
    },
    {
      id: "ccd9eadc-eeca-45cc-ab9a-053bee02a5d1",
      text: "B2 - SSB - 2E2 - Common - Install Wall Devices Electrical",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1800"
    },
    {
      id: "f0884f83-24fa-4e1c-9f99-28b3bfdb0f94",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1330"
    },
    {
      id: "6a323fa0-d757-48fb-829b-699329196d39",
      text: "Area 3 - Water Utilites Install",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 192,
      parent: "358e43d2-5f04-4a0d-9914-2f2e84e613d3",
      progress: 0,
      source_task_id: "C.CSU.A3.5000"
    },
    {
      id: "0d9c599d-5c47-456f-a47b-edea9a6e0d8e",
      text: "B1 - DH-B - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 40,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1390"
    },
    {
      id: "123f8d50-d5a3-4c5a-925e-1f3afd393450",
      text: "B1 - Network - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 40,
      parent: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      progress: 0,
      source_task_id: "B1.C.EY.1110"
    },
    {
      id: "1b19049d-d282-4e0d-8ad1-c234eeb36c26",
      text: "B2 - DH-A - Term Bussways - Data Hall A",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2490"
    },
    {
      id: "a87f141f-b268-41d3-8916-348fe4d59bef",
      text: "iGMP Development",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-10T08:00:00",
      duration: 400,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1060"
    },
    {
      id: "3df91b93-dd42-43d9-a2b9-b556dfa5969a",
      text: "B2 - DH-C - Install HAC Lights - Data Hall C",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2070"
    },
    {
      id: "e768cad3-45de-4e6d-8577-f42b9df4b3ae",
      text: "B2 - mCUP-5 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5040"
    },
    {
      id: "9c54de4e-b35c-4127-9489-c910ca13b49a",
      text: "B1 - mCUP-1-9 - Foundations for Piping - Sequence 1",
      type: 0,
      start_date: "2024-12-10T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1000"
    },
    {
      id: "907c1351-c46b-48ce-8331-08f0ab5d822f",
      text: "B1 - DH-B - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2025-11-20T08:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 0,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2790"
    },
    {
      id: "d1a7d0fd-c60a-46d8-9f4d-1f0b06cd1daa",
      text: "FR 38 - DPR prepare and Submit PCO #XX",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: null,
      duration: 40,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "FR.38.1140"
    },
    {
      id: "245e9022-350f-4cad-bd3d-bffc722f5bee",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2250"
    },
    {
      id: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      text: "(CFCI) Div. 26 - Power Equip. & Material",
      type: 5,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 672,
      parent: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      progress: 0.22,
      source_task_id: "7994866"
    },
    {
      id: "2bf45bfe-4a88-42a7-b314-225149ae1236",
      text: "B2 - 2E2E - EF1 - Hang/Tape/Finish Drywall (EF1)",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6160"
    },
    {
      id: "0c48ba22-cee0-4e6a-b634-1a74458dcefc",
      text: "B1 - 1N2W - 01N2.06 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6450"
    },
    {
      id: "622b64a1-3b44-4ab4-8dc6-e0062ed3f6a5",
      text: "Sanitary Sewer",
      type: 5,
      start_date: "2024-09-30T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 392,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995183"
    },
    {
      id: "8538e936-563e-4ba2-9132-115ea06277e3",
      text: "Set PTX",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 40,
      parent: "621592be-cc33-40c4-89df-9cd0aa53b294",
      progress: 0,
      source_task_id: "ADMIN.SI.1040"
    },
    {
      id: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3",
      text: "BLDG-2 DH-B - L2 Checkout for Building",
      type: 0,
      start_date: "2026-08-25T00:00:00",
      end_date: "2026-09-29T08:00:00",
      duration: 200,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1020"
    },
    {
      id: "c76a3012-4d83-47ea-8e06-0b2f3c37cda2",
      text: "B1 - DH-C - Lightning Protection",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1520"
    },
    {
      id: "6909c563-590a-4a8d-b8d0-0a4b9e106a4c",
      text: "Fab and Deliver - Assembled Skids - Area B - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 3336,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 0.25,
      source_task_id: "B2.OFCI.2280"
    },
    {
      id: "c5351efd-8670-4e6f-a54c-3ba12a71331d",
      text: "BLDG-1/2 - Prep / Submit for Review Speciality doors and dock levelers",
      type: 0,
      start_date: "2024-10-08T00:00:00",
      end_date: "2024-10-21T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6300"
    },
    {
      id: "64874121-0ebf-4f71-8823-901722c12bf7",
      text: "B1 - DH-A - L2 CDU Pre-Eng Inspection - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 144,
      parent: "a565da4e-47a6-49f6-9a35-7baee475a452",
      progress: 0,
      source_task_id: "B1.C.A.3050"
    },
    {
      id: "721ef480-96ae-44c2-964b-2c5a39c0dae0",
      text: "FR 19 - DPR prepare and Submit RFI #121",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 0,
      parent: "9f9f89a7-c1ad-40cc-9316-7639d5b9a211",
      progress: 1,
      source_task_id: "FR.19.1000"
    },
    {
      id: "3ab74b3f-6194-4cad-bff4-3146b6a96ff1",
      text: "(CFCI) Div. 33 - Utilities (Smart Start - Typical Storm, San Swr, Dom Wtr)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994863"
    },
    {
      id: "5280518f-045d-4151-afe2-5e78566434ce",
      text: "Install Wood Wall Panels",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1340"
    },
    {
      id: "eb73a1f9-fda5-4fef-8296-6f8eeb63c600",
      text: "Substation-2 - Pull and Term Substation to MSG Building 1 A/C (Pull to Vaults) - Sequence 2",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 160,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "B2.C.EY.1150"
    },
    {
      id: "f6f3e632-d804-438e-9d65-ae73d274652c",
      text: "Area 2 - Mass Grading",
      type: 0,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-06-08T08:00:00",
      duration: 160,
      parent: "872df01c-b5af-4a82-b4f8-d4090a1571ca",
      progress: 1,
      source_task_id: "C.CSU.A2.1000"
    },
    {
      id: "0d2eb201-1fe4-414c-8927-81b1ca95ba24",
      text: "B1 - mCUP-5 - Setting and Hookup of GS-IDF Hut (1X2)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 80,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.C.EY.1210"
    },
    {
      id: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2",
      text: "B1 - SSB - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-03T08:00:00",
      duration: 40,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1000"
    },
    {
      id: "4ae65f9e-5e56-43c7-ba73-f6cf69798256",
      text: "Substation-1 - Pull and Term Substation to MSG Building 1 B/D (Pull to Vaults) - Sequence 2",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 160,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "B1.C.EY.1050"
    },
    {
      id: "cfaf7968-43c8-45b2-a897-d16a83eb5efb",
      text: "B2 - DH-B - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 40,
      parent: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      progress: 0,
      source_task_id: "B2.C.EY.1580"
    },
    {
      id: "be385840-ddf5-4459-b03d-3e46bb06e85a",
      text: "B2 - SSB - 2E2 - Common - Install Devices in Tile/OH Sprinkler",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1730"
    },
    {
      id: "44b62a35-b8e2-44e2-8e83-93708765c26d",
      text: "Electrical Rough-In Hardlids",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1090"
    },
    {
      id: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      text: "BLDG-2 DH-C ElectricalTerms",
      type: 5,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-06-08T08:00:00",
      duration: 280,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "7995139"
    },
    {
      id: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      text: "Area 3 - Mass Grading",
      type: 0,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-06-08T08:00:00",
      duration: 160,
      parent: "dc72aba6-4aeb-4210-b919-c8cf0233965f",
      progress: 1,
      source_task_id: "C.CSU.A3.1000"
    },
    {
      id: "27a53205-7fd2-4c3e-892d-b6146f651dba",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1690"
    },
    {
      id: "f0accd47-7da3-4e9d-b4f2-1255ec47066f",
      text: "B1 - Network Room 2/3 - Power Alley - Refrigerant Lines Install/Test/Insulate",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1570"
    },
    {
      id: "81080fa9-e859-4c60-b484-4c7f65b917e8",
      text: "B1 - SSB - Foundations Loading Dock Area",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 120,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1030"
    },
    {
      id: "a1861aa0-eade-4375-bea0-f5700fe520f3",
      text: "B2 - DH-B - El Equip Yd - Set Equipment (2)MSG",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1090"
    },
    {
      id: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      text: "Building 2 mCUP-8",
      type: 5,
      start_date: "2025-11-18T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 576,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995150"
    },
    {
      id: "2d121172-d21a-46c7-a745-2be0a048f750",
      text: "FRP Equipment Pads",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 64,
      parent: "621592be-cc33-40c4-89df-9cd0aa53b294",
      progress: 0,
      source_task_id: "ADMIN.SI.1010"
    },
    {
      id: "006f2b8e-65dd-4fb1-b43e-8e84a08db5c5",
      text: "(CFCI) Div. 03 - (Therm) Non-Struc Concrete",
      type: 5,
      start_date: "2024-06-03T00:00:00",
      end_date: "2024-07-08T08:00:00",
      duration: 200,
      parent: "104ad1d0-cc1d-442f-b628-bbf43f4a07d2",
      progress: 0,
      source_task_id: "7994856"
    },
    {
      id: "3c4a8f39-7983-4edb-a75a-931e19671b4e",
      text: "B1 - DH-C - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 240,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1370"
    },
    {
      id: "f4875174-c0e3-4caa-a104-28a17d1580aa",
      text: "B1 - DH-D - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1520"
    },
    {
      id: "4a89f8ac-daaa-40b8-8606-800b3004e660",
      text: "Tier 1 - B1-1-D - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994797"
    },
    {
      id: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364",
      text: "B1 - Network - El Equip Yd - Test/Terms from MSB to Generator",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 80,
      parent: "efec6b5a-5634-43a5-b571-748e500afd9a",
      progress: 0,
      source_task_id: "B1.C.EY.1160"
    },
    {
      id: "092dfe14-2916-495d-81e2-61c6c3a99c06",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1380"
    },
    {
      id: "0cdef6c4-0cd5-4b7f-9016-aac934ef4c4d",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Building Controls",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-26T08:00:00",
      duration: 120,
      parent: "cb9ddad6-dc85-427d-a3ce-d7471522dab1",
      progress: 0,
      source_task_id: "B1.CFCI.4130"
    },
    {
      id: "69118f10-3a96-4c06-bff2-077ce9c60175",
      text: "OSP - B1 - Phase 3 (CAV/MMV to BEV)",
      type: 5,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 680,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995453"
    },
    {
      id: "cf3055ff-4f2c-47a3-a4b7-d3567cce3760",
      text: "B1 - 1C1W - 01C.08 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 144,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1910"
    },
    {
      id: "cdac279d-1df3-4d0c-8b86-cf169b9aa7b1",
      text: "FR 32 - DPR Issue RFI #56",
      type: 0,
      start_date: "2024-07-25T00:00:00",
      end_date: null,
      duration: 0,
      parent: "f3d372b5-108e-423c-a7ac-e30f6c888ce2",
      progress: 1,
      source_task_id: "FR.32.1000"
    },
    {
      id: "1678f18e-fc5c-4ef4-bb50-297ff52db482",
      text: "Fab and Deliver - MSB - Area A - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 3056,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.41,
      source_task_id: "B1.OFCI.3360"
    },
    {
      id: "f9650ef1-74ec-45e3-a509-1010af288a54",
      text: "Area A - OH Fire Protection - Mains & Branches - Open Areas",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1141"
    },
    {
      id: "9245977a-af71-43c4-a39d-dae6bd706066",
      text: "Substation-2 - B Lineup SF6 Breaker - Assembly",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 120,
      parent: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4560"
    },
    {
      id: "f4715616-e024-422f-a1cc-3786392cfb07",
      text: "Fab and Deliver - MVS-4WAY - Area A (7) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 2168,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.01,
      source_task_id: "B1.OFCI.2370"
    },
    {
      id: "7ba68e98-91aa-4c6a-9158-f7d20bd00dd6",
      text: "B1 - SSB - Install Underground Controls",
      type: 0,
      start_date: "2025-02-20T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 64,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1170"
    },
    {
      id: "34024419-c329-450e-9a35-0eea8e810828",
      text: "B1 - DH-B - Install Underground Telecom",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1540"
    },
    {
      id: "214107b4-1a14-4e34-b575-03c9fe7c605a",
      text: "B2 - DH-A - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 80,
      parent: "ee7e7edf-af1b-4b93-83a7-d006dcd1c47a",
      progress: 0,
      source_task_id: "B2.C.EY.1300"
    },
    {
      id: "c7024785-c02e-4646-abe6-842adce73ae2",
      text: "B2 - SSB - 2E1 - Common - OH Rough In BMS",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1160"
    },
    {
      id: "18dc7d52-67db-4f7d-ab44-0580d04cd8ca",
      text: "B2 - 2D1 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-06-17T00:00:00",
      end_date: "2026-07-15T08:00:00",
      duration: 160,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.2330"
    },
    {
      id: "68c1b064-77f7-4bce-b15d-6cb1deec4b17",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1340"
    },
    {
      id: "f87dfe7d-589b-40bb-aa66-aec5c6c358e0",
      text: "B1 - DH-D - Backfill",
      type: 0,
      start_date: "2025-04-26T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 40,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1870"
    },
    {
      id: "a321561c-165e-49fa-b74e-53e640dc2f2b",
      text: "mCUP - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2023-12-29T08:00:00",
      duration: 40,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 1,
      source_task_id: "B1.OFCI.1840"
    },
    {
      id: "4680426c-75a9-4635-820b-b03d93dc9041",
      text: "Phase 1 - Complete Landscape/Hardscape/Misc. Work",
      type: 0,
      start_date: "2026-08-24T00:00:00",
      end_date: "2026-09-21T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1040"
    },
    {
      id: "d919a8af-a1c6-4060-98f3-7692faa4fe61",
      text: "B1 - Network Room 1/4 - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1230"
    },
    {
      id: "28902d1e-e06d-41b3-9c1e-3d926d951d36",
      text: "FR 38 - IBOS-  Prep and submit submittal",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: null,
      duration: 40,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "B1.CFCI.6580"
    },
    {
      id: "aca5987f-8831-4d4e-b5b7-29a94dc6bb73",
      text: "B2 - 2D2 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1250"
    },
    {
      id: "d302ebf8-480a-4480-98e8-95b57a21e0bb",
      text: "B2 - 2A2 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 120,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2550"
    },
    {
      id: "16f4a518-f541-4a11-aea4-d2236977b1a6",
      text: "Substation-2 - TX A - Set Transformer",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 40,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4830"
    },
    {
      id: "11af5222-36a9-44e5-be26-07ec3d02d40a",
      text: "B2 - DH-D - Set HACs in Place - Data Hall D - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2010"
    },
    {
      id: "955aa671-6b4b-4034-bf88-d03902dbaf4e",
      text: "Fragnet 31 - PCO # 30 RFI-085 TMH001 Upsize",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 584,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717480"
    },
    {
      id: "02c47d40-3206-445b-aece-2151225873d2",
      text: "B2 - DH-C - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 48,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.2250"
    },
    {
      id: "5aa45c8d-40f5-443e-8ef1-b4feaefb8cb3",
      text: "PRS Design Completion",
      type: 0,
      start_date: "2024-01-05T08:00:00",
      end_date: "2024-01-05T08:00:00",
      duration: 0,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "Design.PreC.2080"
    },
    {
      id: "8269f368-6921-403e-a18a-f9a2f424bb7a",
      text: "Weather/Construction Bank - Admin",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 192,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1130"
    },
    {
      id: "2b6ac8b0-5614-4bfb-a6cf-fdb1f42c6160",
      text: "(CFCI) Div. 05 - Slotted Channel Framing (Strut)",
      type: 5,
      start_date: "2025-02-13T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 440,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0,
      source_task_id: "7994933"
    },
    {
      id: "150fc470-4247-402f-8c28-d9b141485933",
      text: "Fragnet 15 - PCO # 11 RFI-086 Pond 4 Outfall Grading",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 584,
      parent: null,
      progress: 0.5,
      source_task_id: "8690175"
    },
    {
      id: "bbb88200-af8c-4c86-af49-c71faebcf7b9",
      text: "B2 - 2E2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-02-24T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6420"
    },
    {
      id: "ddd3b316-5da9-45c4-b13f-856d2f2c32f2",
      text: "B1 - DH-B - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 984,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3040"
    },
    {
      id: "4c7f2e1b-e8c8-45b6-8e24-c97b4fe86606",
      text: "Exterior Canopy Densdeck Install",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 80,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1150"
    },
    {
      id: "2b83d52c-6feb-4ca8-bc19-b50595aef73d",
      text: "B1 - DH-D - Install Celing Devices Fire Protection - Data Hall D",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1350"
    },
    {
      id: "b1cbd0db-4523-48cd-9716-0416282ebb61",
      text: "Area B - In Wall Rough Plumbing",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1230"
    },
    {
      id: "d920a9b2-4524-4a47-a52f-e89105d5119a",
      text: "Substation-2 - TX B - Install Medium  And High Voltage Cable Pulls",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 80,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4500"
    },
    {
      id: "471d1405-1daa-4156-863f-71099cb2bf78",
      text: "B2 - DH-A - Set HACs in Place - Data Hall A - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2210"
    },
    {
      id: "1eb6eec4-7ab1-4793-9a26-f5c0223841db",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1180"
    },
    {
      id: "d0287dc1-c65c-4022-ae75-c41f07d80eee",
      text: "B1 - DH-D - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 16,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1560"
    },
    {
      id: "4ac15812-9e9e-4259-8d4c-5fba895745fc",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1310"
    },
    {
      id: "b64659e1-a503-4bab-9060-d4f771358b60",
      text: "Site / UG BIM - Area 2 - Remaining Utilities - Coordination / Sign Off",
      type: 0,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-05-10T08:00:00",
      duration: 160,
      parent: "8331d266-0138-4b68-98a0-04c6efcc3613",
      progress: 1,
      source_task_id: "SITE.VDC.1080"
    },
    {
      id: "2ff871d6-c6b3-47c0-a53e-259b72b200a5",
      text: "Fragnet 24- PCO # 20 CCD-038 Post IFC Sec Page Turn",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: null,
      duration: 352,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8690698"
    },
    {
      id: "29990eb1-7fdc-4734-8925-643175b0e5bb",
      text: "Precast Concrete - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-05-02T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 96,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1330"
    },
    {
      id: "425a3675-d964-4bcd-981d-bc45ef37bf99",
      text: "(CFCI) Div. 22 - Plumbing",
      type: 5,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 320,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994857"
    },
    {
      id: "08154a95-18e6-4733-9939-55b52e88864c",
      text: "FR 36 - DPR/EIG Install pathway",
      type: 0,
      start_date: "2024-12-27T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 56,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 0,
      source_task_id: "FR.36.1050"
    },
    {
      id: "307e4193-b874-4d2f-a568-29c3a6952e9d",
      text: "L3 Start DH A - DCB1",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-02-19T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2000"
    },
    {
      id: "0f964bab-830e-4bb2-88c8-cdbecc261450",
      text: "B1 - Network Rooms - Facilty Water Install (ROJ Racks)(Converted to LOE)MOFE",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 96,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1330"
    },
    {
      id: "7c37b6b6-2b71-4bdf-882e-701d0bb49b4c",
      text: "B1 - 1D1W - 01D.08 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 144,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2350"
    },
    {
      id: "6bc47b33-9a30-4ab4-889d-25c5d9617ffd",
      text: "Local AHJ Review and Comments of Civil Permits",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-26T08:00:00",
      duration: 320,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 1,
      source_task_id: "PRE-DD-1030"
    },
    {
      id: "f741b8f2-6453-47de-895f-ab5c08bf6317",
      text: "B1 - mCUP-1 - Set in Place Inspections",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 8,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1220"
    },
    {
      id: "c76ec58f-3fda-4a25-b61e-4b9ef88864b5",
      text: "Fab and Deliver - PLC Panels - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-23T08:00:00",
      duration: 2568,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.36,
      source_task_id: "B1.OFCI.3400"
    },
    {
      id: "0940dc8f-2121-4ca5-9917-93aa068b00ae",
      text: "Equipment Set",
      type: 5,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 1176,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995362"
    },
    {
      id: "1fa04521-17ea-4a5d-a4ae-9ddd3814f2b0",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 120,
      parent: "61eca0ba-60c7-4050-b050-569ff6de0dca",
      progress: 0,
      source_task_id: "MECO-1700.30"
    },
    {
      id: "0e30c19f-2d41-468b-aad0-54a4e34d2ca4",
      text: "B2 - mCUP-6 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6100"
    },
    {
      id: "712d81d9-6ca6-4f52-84aa-ae332305f731",
      text: "B1 - mCUP-1 - Install Electrical /  Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1260"
    },
    {
      id: "dcbe82da-85d4-4af3-a3ac-19103779d8d7",
      text: "PTX/LB Pad Leave Out at Electrical Skid",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "621592be-cc33-40c4-89df-9cd0aa53b294",
      progress: 0,
      source_task_id: "ADMIN.SI.1020"
    },
    {
      id: "60a22111-cbcd-4144-9ce0-f117db9b9b49",
      text: "Install Mirrors",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 16,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1200"
    },
    {
      id: "8afd9616-202b-49c7-8b22-9f4de01ca6bd",
      text: "Data Hall B",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 1384,
      parent: "7fb33c35-1204-4516-b5fc-1de04cad777e",
      progress: 0,
      source_task_id: "7995079"
    },
    {
      id: "94a23c5d-d8e0-4463-a045-2fefe18288f7",
      text: "B1 - Network Room 1/4  - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1240"
    },
    {
      id: "f4b92e54-d674-407e-a509-d513b9d9c313",
      text: "B2 - DH-D - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 80,
      parent: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      progress: 0,
      source_task_id: "B2.C.EY.1750"
    },
    {
      id: "242cc820-b7c6-4fba-8be5-3256f5bbdc5e",
      text: "Frame Secondary Walls",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1020"
    },
    {
      id: "e749968c-781b-41e9-a121-7053c2d6d4d3",
      text: "B1 - Prep/Place Curbing",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-22T08:00:00",
      duration: 160,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1200"
    },
    {
      id: "697eda6e-fea2-466d-9c67-b44a4f47ecf1",
      text: "B1 - Network Room 1/4  - Install Technical Water",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1490"
    },
    {
      id: "3731537b-2ab3-42f0-a703-4419666bed41",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (NW 1/4)",
      type: 0,
      start_date: "2025-07-14T08:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1370"
    },
    {
      id: "49986074-60af-4a69-8655-a27f2870b244",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 24,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1050"
    },
    {
      id: "96112eca-427a-4b2a-b656-28897abb9779",
      text: "B2 - 2D1 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-05-19T00:00:00",
      end_date: "2026-06-16T08:00:00",
      duration: 160,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1980"
    },
    {
      id: "8ef8d50e-92d0-4d03-984b-806318da250c",
      text: "Substantial Completion-No Weather - Bldg 2 - DH A",
      type: 0,
      start_date: "2027-01-15T08:00:00",
      end_date: "2027-01-15T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B2.MIL.1080"
    },
    {
      id: "04625d21-10c3-4bbc-8fce-c40a18b4f846",
      text: "Substantial Completion-No Weather - Bldg 2 - DH D",
      type: 0,
      start_date: "2027-03-30T08:00:00",
      end_date: "2027-03-30T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B2.MIL.1110"
    },
    {
      id: "6e354b29-5a6a-4c70-b1fe-fbea803605ce",
      text: "B1 - 1N2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 80,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6130"
    },
    {
      id: "f2f64e05-c4f1-4e4f-ab46-24e24c2b3db6",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1270"
    },
    {
      id: "683d6cd3-e27b-48c0-8b4b-9c04bde957a8",
      text: "Corridor 1C2E (Sprinkler Riser/GSIDF (2)/Control Panel/Light Inv)",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 1056,
      parent: "dc0db725-f1c1-4687-8a98-61e9f8a18049",
      progress: 0,
      source_task_id: "7995277"
    },
    {
      id: "062f617e-f4cd-4dde-ae51-01bb700d93ad",
      text: "B1 - Network Room 2/3 - OH Rough In Branch",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1090"
    },
    {
      id: "56cf27dc-0790-45ef-9408-4bd9d3a7dfe7",
      text: "B1 - mCUP-9 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9080"
    },
    {
      id: "600eb0c0-be10-42dc-868c-fff6b4c2497f",
      text: "B2 - DH-D - Install Fire Alarm Conduit/Vesda -Data Hall D",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-31T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2470"
    },
    {
      id: "e04be7c1-e68b-4a64-95e4-fb9297a4f877",
      text: "Concrete - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.2280"
    },
    {
      id: "c9b2af01-e5db-4d67-8a04-0dd7ce2b5931",
      text: "Meta Deliver Preliminary ROH Heat Calcs.",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-13T00:00:00",
      duration: 0,
      parent: "67d734a8-c39d-4ca8-b86e-5d5930a7692f",
      progress: 1,
      source_task_id: "ICM.PRE.1231"
    },
    {
      id: "ea926f55-4871-463e-be6b-5020ac311c5f",
      text: "STC - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-15T00:00:00",
      duration: 0,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 1,
      source_task_id: "B1.OFCI.1030"
    },
    {
      id: "6e4407c3-c824-4548-be75-dce29413388f",
      text: "Delivery of NES Network Electrical Room Skid (First Delivery) - DCB2",
      type: 0,
      start_date: "2026-01-21T08:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1850"
    },
    {
      id: "adaa990b-7ce7-4dab-b72f-00794844510c",
      text: "Form/Rebar/Pour Foundations - Area B - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1140"
    },
    {
      id: "42ee2f33-8ce4-4200-8912-c84ca5afb80a",
      text: "B1 - DH-D - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 40,
      parent: "62872b9b-6759-4561-825b-c00ed5bb886c",
      progress: 0,
      source_task_id: "B1.C.D.3120"
    },
    {
      id: "5fb80f52-0f5b-43c0-861b-91af0a622d62",
      text: "B1 - mCUP-1 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1310"
    },
    {
      id: "72358187-39e2-4897-911b-ac88757bd142",
      text: "Corridor 2E1E",
      type: 5,
      start_date: "2025-11-25T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 816,
      parent: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      progress: 0,
      source_task_id: "7995045"
    },
    {
      id: "c6b1a3c1-a23d-4a01-bcb4-f035311ca280",
      text: "Fire Water",
      type: 5,
      start_date: "2024-11-22T00:00:00",
      end_date: "2024-12-18T08:00:00",
      duration: 80,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995185"
    },
    {
      id: "abce5df4-8ee4-4f0a-85e7-22726c1c832f",
      text: "Fragnet 14 - PCO # 10 RFI-041 LOD Extens for Fiber Op Utili Sect (FO-04)",
      type: 0,
      start_date: "2024-07-16T00:00:00",
      end_date: null,
      duration: 664,
      parent: null,
      progress: 0.5,
      source_task_id: "8690174"
    },
    {
      id: "e4ea102d-324f-4849-a9b5-b14e60f58f2d",
      text: "B1 - 1D1W - 01D.08 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2190"
    },
    {
      id: "2dce482f-d960-4054-b5d4-46e1a996ea3d",
      text: "Fab and Deliver - PLC Panels - IWM MNGR - mCUP (Integrator) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 2328,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.31,
      source_task_id: "B1.OFCI.2020"
    },
    {
      id: "c8f14d39-2814-497d-b207-521ed31fc9dd",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2500"
    },
    {
      id: "4ebe65dc-eb87-4b8c-8c39-477b23101e36",
      text: "B1 - 1D2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1930"
    },
    {
      id: "41413ac8-b638-4e92-8e73-e55d270c5161",
      text: "Area 5 - Water Utilites Install",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 56,
      parent: "f1cd5b7a-b7b4-44f8-8b2b-0bba0044e6c6",
      progress: 0,
      source_task_id: "C.CSU.A5.5000"
    },
    {
      id: "781af709-acd5-4c71-94b0-6d76e653cda3",
      text: "B1 - SSB - 1E2 - Common - Install Devices in Tile/OH Electrical",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2040"
    },
    {
      id: "5984a188-7751-440d-960b-768328f42abe",
      text: "FR 17 - META review and respond to RFI #88",
      type: 0,
      start_date: "2024-07-31T00:00:00",
      end_date: null,
      duration: 312,
      parent: "ff6b063e-140d-44b7-8199-0a0452134f17",
      progress: 1,
      source_task_id: "FR.17.1010"
    },
    {
      id: "813899cd-a520-4613-8209-38f409169670",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH A",
      type: 5,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 352,
      parent: "560c76d0-46ee-4116-9c68-58099187fdb2",
      progress: 0,
      source_task_id: "8106482"
    },
    {
      id: "9df1507b-8921-42e3-b144-cf7e9024176f",
      text: "FR 02 - Additional Building Permit Review Time - 45d after Civil Permit Approved",
      type: 0,
      start_date: "2024-09-06T00:00:00",
      end_date: "2024-09-27T08:00:00",
      duration: 360,
      parent: "f5cede49-5629-40ad-881c-25df81197815",
      progress: 0,
      source_task_id: "PRE-DD-1190"
    },
    {
      id: "0d19c91c-7976-49fc-8fed-f3c2a447f81f",
      text: "B1 - 1N1E - EF4 - Pour Pads Around Telecom Conduits (EF4)",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 48,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5570"
    },
    {
      id: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94",
      text: "B2 - DH-B - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 40,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1900"
    },
    {
      id: "855069c2-09d3-46f0-895c-34ac09b49a3d",
      text: "Telecom",
      type: 5,
      start_date: "2024-11-06T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 336,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995157"
    },
    {
      id: "3bb3643f-d947-49ba-83ab-b27416edc884",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2070"
    },
    {
      id: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548",
      text: "L4 Start DH C - DCB1",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-06-16T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2110"
    },
    {
      id: "16e91e00-cf59-47a4-98bb-1c0986a5d9b3",
      text: "B2 - 2D2 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 160,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1750"
    },
    {
      id: "edb8affa-da41-4faa-a111-9f4bdaed1eb5",
      text: "Area A - In-Wall Rough-In Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1110"
    },
    {
      id: "47d90987-1e11-4908-8485-1e5889c0d266",
      text: "B1 - mCUP-8 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8050"
    },
    {
      id: "9cbbdd64-199f-408c-8053-aa1307d7f655",
      text: "Area 5 - NCP Duct Bank & Equipment Install",
      type: 0,
      start_date: "2025-02-19T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 104,
      parent: "68713f45-bde5-47e7-8274-03e9250dc4fe",
      progress: 0,
      source_task_id: "C.CSU.A5.6000"
    },
    {
      id: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      text: "Campus",
      type: 5,
      start_date: "2024-04-15T00:00:00",
      end_date: "2026-12-07T08:00:00",
      duration: 5344,
      parent: "abe1a98c-028c-44b8-8da7-9658d12e1819",
      progress: 0.07,
      source_task_id: "7995151"
    },
    {
      id: "eeebdf7d-b0c8-4805-b83d-fa308a0f41be",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2230"
    },
    {
      id: "cc4b2444-15d5-4582-b6d0-d48dc3e4d02e",
      text: "B1 - DH-C - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 80,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1450"
    },
    {
      id: "3c5250df-8da3-44c8-b3b4-9be719ec7e52",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-B - Coordination / Sign-off",
      type: 0,
      start_date: "2024-08-28T00:00:00",
      end_date: "2024-09-11T08:00:00",
      duration: 240,
      parent: "7b800596-3c18-4eef-a601-dc65353e5660",
      progress: 0,
      source_task_id: "B1.VDC.1580"
    },
    {
      id: "be397963-3087-4bcd-acb7-3e346c64f7d0",
      text: "ADMIN - Prep / Submit for Review - Signage",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6150"
    },
    {
      id: "091f6228-5909-43ee-b5ef-6a877c88c923",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Fire Alarm",
      type: 0,
      start_date: "2025-01-27T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 120,
      parent: "aaa537e7-583e-4d33-ad14-d873dded0a6d",
      progress: 0,
      source_task_id: "B1.CFCI.4890"
    },
    {
      id: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      text: "B1 - 1N1E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-07-01T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 24,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5190"
    },
    {
      id: "9d01169b-98f2-4dd2-aafa-d09a0d22d779",
      text: "B1 - 1N1E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 8,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5430"
    },
    {
      id: "a1d2668d-517b-419d-ae83-f7e3aa88721a",
      text: "B2 - 2E1E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-01-02T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 24,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5220"
    },
    {
      id: "6aac9d75-7734-46a2-ad90-bae35ba34d51",
      text: "B1 - 1D2E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 160,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1880"
    },
    {
      id: "32eec1a6-6915-4c79-a7cd-c5cc8bfa57fd",
      text: "B1 - 1N2E - 01N3.05 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6220"
    },
    {
      id: "340322b8-8cb9-43d8-b4b9-513b36f312e3",
      text: "Int. Metal Panels & Associated Struc. Steel",
      type: 5,
      start_date: "2024-09-11T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 1504,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994840"
    },
    {
      id: "255e7e40-55ee-4e1a-84ef-521216aab2b2",
      text: "B2 - mCUP-2 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2090"
    },
    {
      id: "84ce3930-8fb0-4311-82a6-b2416384c17a",
      text: "B1 - DH-B - Install Fire Alarm Conduit/Vesda -Data Hall B",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2680"
    },
    {
      id: "cae540cf-45e1-4836-9f91-8223673a0a82",
      text: "B2 - Prep Area for Final Paving",
      type: 0,
      start_date: "2026-07-31T00:00:00",
      end_date: "2026-08-13T08:00:00",
      duration: 80,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1140"
    },
    {
      id: "56080308-2da4-4055-b9e7-474a80627d2c",
      text: "DPR Precon Activities",
      type: 5,
      start_date: "2024-03-08T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 1880,
      parent: "fde6fa74-71e9-4a70-857e-ca30387e7d0d",
      progress: 0.31,
      source_task_id: "7994714"
    },
    {
      id: "19fe44fb-a1b8-4acd-a5bb-caedd4b8a79b",
      text: "B2 - DH-D - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-03-04T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 80,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1030"
    },
    {
      id: "9db999bf-4c11-4577-bdcf-ff01e1425379",
      text: "Admin - Electrical Skid (By Others)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 1080,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1050"
    },
    {
      id: "ecf57043-4fc4-4c73-afa0-056b30ec5da7",
      text: "Delivery of Dry Cooling Towers (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-03-17T08:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1860"
    },
    {
      id: "4854c79e-fba1-46ab-a511-c2f507e4d857",
      text: "Site - Dry Utilities SA - Meta Review",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-09T08:00:00",
      duration: 224,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1120"
    },
    {
      id: "fb0a8132-3593-412e-9b2f-851eb1763a00",
      text: "Paint - Prime/First Coat Walls & Ceilings",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 24,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1280"
    },
    {
      id: "f6b36f48-cc99-4421-b0fe-655c9cc30b57",
      text: "Campus - Construct Permanent Campus Roadways / Lighting - Sequence 1",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 288,
      parent: "26327ae0-6c90-4f36-b131-6ebdf49b7bd8",
      progress: 0,
      source_task_id: "C.SI.RW.1000"
    },
    {
      id: "6fcddeec-044b-4148-951a-169122a17917",
      text: "Hood Smoke Containment Test",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1350"
    },
    {
      id: "ba989cfa-37e2-4e7f-9c77-a4f3125cdb8e",
      text: "Tier 0 - Site",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-26T08:00:00",
      duration: 240,
      parent: "242ad192-a9a1-4973-bc98-024e62b03340",
      progress: 1,
      source_task_id: "7994750"
    },
    {
      id: "3acf459e-58c2-463b-80e4-1ba4c76a7591",
      text: "Area 3 - Fire Water Install",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2024-12-18T08:00:00",
      duration: 80,
      parent: "c6b1a3c1-a23d-4a01-bcb4-f035311ca280",
      progress: 0,
      source_task_id: "C.CSU.A3.4000"
    },
    {
      id: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5",
      text: "B2 - DH-C - El Equip Yd - Set Equipment (10)MVS, (20)PTX",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 80,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "B2.C.EY.1210"
    },
    {
      id: "3bc55a1d-00e3-43a9-92de-6fc973b2deea",
      text: "HTF Walls & Ceilings (Rated)",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 64,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1040"
    },
    {
      id: "aa68c170-638a-411b-b550-eae6381f816d",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Blocking/Fire FEC",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1200"
    },
    {
      id: "ed7dd393-fd7e-464c-898a-edacf37d512b",
      text: "B2 - mCUP-4 - L2 Inspections",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 80,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4130"
    },
    {
      id: "0df4326a-90b6-4546-9714-42a348c699ef",
      text: "B1 - 1N1E - 01N4.06 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6060"
    },
    {
      id: "bd81e92b-5bc4-477f-8f19-0dcbd6b10454",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "a187e15c-5311-477e-8dcb-810084b7ae80",
      progress: 0,
      source_task_id: "MECO-1700.20"
    },
    {
      id: "c9ad3d23-754a-4671-ad56-20d0365599db",
      text: "B1 - 1C1W - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 160,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1600"
    },
    {
      id: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      text: "Cx Bldg 1 L2 Commissioning",
      type: 5,
      start_date: "2025-11-20T00:00:00",
      end_date: "2026-05-02T08:00:00",
      duration: 1120,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995011"
    },
    {
      id: "43e34b0b-c621-4f0a-a48a-916ec2d4ae87",
      text: "B1 - SSB - 1E1 - EF1 - Hang/Tape/Finish Drywall (EF1)",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 48,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1560"
    },
    {
      id: "706b87a2-dbac-4cf0-a069-f49413855482",
      text: "B1 - 1C2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1290"
    },
    {
      id: "b8bf1adb-9818-411c-99cd-e3af7577367d",
      text: "BLDG-2 SSB - L2 Checkout for Building",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 200,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1000"
    },
    {
      id: "61340a98-908f-43b0-a857-036cd0e3257e",
      text: "B1 - ISP Cabling - E2 to E3 (UG) ((Corpnet Live))",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 40,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1140"
    },
    {
      id: "1305292e-8afd-48f6-bdf3-55afaf898c1f",
      text: "Fab and Deliver - PLC Panels - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-23T08:00:00",
      duration: 2568,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.36,
      source_task_id: "B1.OFCI.3410"
    },
    {
      id: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3",
      text: "FCA - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-15T00:00:00",
      duration: 0,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 1,
      source_task_id: "B2.OFCI.1210"
    },
    {
      id: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      text: "FCA Gallery NW 1/4",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 576,
      parent: "36beab78-fbfe-4a35-bcd4-46229816c1f9",
      progress: 0,
      source_task_id: "7995341"
    },
    {
      id: "a8af12a2-deb2-4e1f-bf1d-3f2ad48fa7d6",
      text: "B1 - Network Room 2/3 - Install Device Tiles",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1940"
    },
    {
      id: "5f6d5485-bdbf-4c9e-9fdd-559daf1ed9a5",
      text: "BLDG-1/2 -  Review for Approval - Structural Steel (Revision)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6470"
    },
    {
      id: "a7847c6a-8535-4909-81d3-95239178755f",
      text: "B1 - 1C1W - 01C.08 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1800"
    },
    {
      id: "789fca8b-4469-4af9-b4cf-2aa490c3f084",
      text: "FR 05 - Issue Identification Notification -01 Substation design Coordination",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 24,
      parent: "a706f8e9-f5f3-400c-8585-d4fb3ff784b5",
      progress: 1,
      source_task_id: "FR.05.1010"
    },
    {
      id: "412a5e01-9a29-48d8-9544-d974c84e6443",
      text: "L4 Start DH B - DCB2",
      type: 0,
      start_date: "2026-11-11T00:00:00",
      end_date: "2026-11-11T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2082"
    },
    {
      id: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      text: "GS.IDF.1C2",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 776,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "7995280"
    },
    {
      id: "110e6ce1-858a-4287-ade9-76d223f05877",
      text: "B1 - 1C2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 80,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1560"
    },
    {
      id: "795a626b-0afc-4b18-9356-9a8fdb3cecf1",
      text: "B1 - mCUP-8 - L2 Inspections",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8130"
    },
    {
      id: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 160,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1760"
    },
    {
      id: "95a58614-dcbe-4292-9390-66c5d6745ea8",
      text: "Baseline 1 Issuance",
      type: 0,
      start_date: "2023-12-01T16:00:00",
      end_date: "2023-12-01T16:00:00",
      duration: 0,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2040"
    },
    {
      id: "98a5d32d-2029-4533-a0a7-ca859f808f68",
      text: "B1 - DH-D - Set CDU's - Data Hall D (16 total; 4 per day)",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 64,
      parent: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      progress: 0,
      source_task_id: "B1.C.D.3105"
    },
    {
      id: "ed8a657b-30c7-472b-b051-253d5386824f",
      text: "B1 - 1C2E - Corridor - Room Fit Out Activities - OH Rough Ins",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1730"
    },
    {
      id: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 16,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1090"
    },
    {
      id: "cb54386c-d258-42b2-a7e0-b0cbed7829b6",
      text: "B2 - 2E2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-02-24T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 80,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6410"
    },
    {
      id: "8f048949-df52-4b53-92a0-e73b017e4e13",
      text: "Area 2 - MV Electric Install - Priority for Foundations (Sub to MV Loop) - Concrete Scope",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-19T08:00:00",
      duration: 136,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A2.8120"
    },
    {
      id: "29bf1e57-797a-4668-8c02-fc9762cecb45",
      text: "Fab and Deliver - HMD - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2584,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.55,
      source_task_id: "B1.OFCI.2780"
    },
    {
      id: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8",
      text: "Utility Provider Substation-1 - Power Available to Meta Substation 1",
      type: 0,
      start_date: "2025-12-15T08:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 0,
      parent: "c99b52b5-cb9e-4df2-b38d-079c1e174658",
      progress: 0,
      source_task_id: "CX.1000"
    },
    {
      id: "8e6cd7c8-d32d-4eba-bb19-2df58436f161",
      text: "B1 - 1C1W - 01C.07 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1820"
    },
    {
      id: "bb9f00e5-e4ae-41ac-bce0-1b77b41d8a04",
      text: "Substation-2 - MSG B - Install Verification Inspection And Issue Resolution",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 152,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4370"
    },
    {
      id: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 8,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1430"
    },
    {
      id: "391e8559-de77-4b17-bd68-b4b620e973e3",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 1096,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "7995267"
    },
    {
      id: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d",
      text: "B1 - 1D2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 120,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2690"
    },
    {
      id: "38449171-2983-4540-b062-063db31f6ad1",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Electrical",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1530"
    },
    {
      id: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e",
      text: "B2 - DH-A - Install Structural Steel",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 120,
      parent: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      progress: 0,
      source_task_id: "B2.C.STR.1640"
    },
    {
      id: "4106b35c-0df3-4c56-8c2e-68d3d654f751",
      text: "B1 - DH-D - Install Cable Tray - Data Hall D",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1160"
    },
    {
      id: "da766588-484d-4c59-8c8a-6ead32da372c",
      text: "B2 - DH-A - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 1200,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1010"
    },
    {
      id: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      text: "B1 - DH-A - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 40,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1220"
    },
    {
      id: "45ec47db-5bae-4d80-a97e-2cafa2ffbd32",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1250"
    },
    {
      id: "dfead9a8-3eb3-4481-ae1a-58e1dcd1b3e9",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1190"
    },
    {
      id: "1d54acbf-3708-4fb7-828d-85592e14dc6e",
      text: "IBOS - Prep / Submit for Review -Cable Tray",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1070"
    },
    {
      id: "fba1e5b3-0909-4be5-9d24-93ae0e625d8e",
      text: "Install Storefronts & Windows",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1110"
    },
    {
      id: "f6a4ea17-0052-472a-99f8-6ce1d3124f93",
      text: "B2 - DH-B - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 80,
      parent: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      progress: 0,
      source_task_id: "B2.C.EY.1590"
    },
    {
      id: "d7a08e17-f8f6-4a72-9c29-3b3ec57cec52",
      text: "B1 - Network Room 2/3 - Rough In Lighting",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1930"
    },
    {
      id: "6769b16d-66d8-4b2b-afbc-63e2c90bf383",
      text: "B1 - Network Room 2/3 - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1040"
    },
    {
      id: "ba05e84b-6b5b-4033-9e02-abd6c098d6e9",
      text: "Fab and Deliver - PLC Panels - Area A - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 3584,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.2,
      source_task_id: "B2.OFCI.1840"
    },
    {
      id: "30516502-2e91-4a7b-bb80-a2e01f452038",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-03-11T08:00:00",
      duration: 160,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1810"
    },
    {
      id: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      text: "(CFCI) Div. 26 - Site Utility Vaults (MV)",
      type: 5,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-09-03T08:00:00",
      duration: 480,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0.16,
      source_task_id: "7994867"
    },
    {
      id: "de1c604e-259c-455b-aba8-b8672d8d9090",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In BMS",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1050"
    },
    {
      id: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      text: "GS.IDF.2D1",
      type: 5,
      start_date: "2026-03-31T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 736,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "7995068"
    },
    {
      id: "d625bd34-a380-46b1-81cf-0dde922c75f9",
      text: "BLDG-1/2 - Fabricate / Deliver - Cold Formed Metal Framing",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 120,
      parent: "cdab7e2f-666b-4468-a664-79d098844933",
      progress: 0,
      source_task_id: "B1.CFCI.4750"
    },
    {
      id: "fe83b577-f749-49c0-82b3-96c745c5fe93",
      text: "B1 - mCUP-3 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 16,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3010"
    },
    {
      id: "c3f2141d-53ce-417c-be17-0bfc1f598f9f",
      text: "BLDG-2 - BIM - Tier 1 - Area 2-B - Coordination / Sign-off",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-05-13T08:00:00",
      duration: 240,
      parent: "18d840dc-fbca-4944-bbc5-73c1783bea63",
      progress: 0,
      source_task_id: "B2.VDC.3120"
    },
    {
      id: "d487d45c-8f4c-436c-8bcb-12f3abe4a132",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-D - Coordination / Sign-off",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 280,
      parent: "3458751c-652e-4bca-a6eb-75a1f58feb41",
      progress: 0,
      source_task_id: "B1.VDC.1660"
    },
    {
      id: "a16999c0-7e60-4536-99f6-4c3959445c24",
      text: "Fab and Deliver - Assembled Skids - Area NW-1 *NOT ON PROCLOG*",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 1656,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.42,
      source_task_id: "B1.OFCI.2650"
    },
    {
      id: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      text: "B1 - DH-A - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 80,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1010"
    },
    {
      id: "1247a98d-945f-4abb-bb37-6fb4e0583f53",
      text: "FR 08 - Area 4 - Telecom Install - CAV2 to GH - Concrete Scope",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: "2024-11-06T08:00:00",
      duration: 240,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A4.8060"
    },
    {
      id: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9",
      text: "B2 - DH-A - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 80,
      parent: "ee7e7edf-af1b-4b93-83a7-d006dcd1c47a",
      progress: 0,
      source_task_id: "B2.C.EY.1330"
    },
    {
      id: "a94aec1e-7229-490b-b6ec-195d995d268a",
      text: "B1 - 1C1W - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 120,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1850"
    },
    {
      id: "b43dff38-96d8-477b-bc05-4d03eb53e781",
      text: "B2 - DH-B - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2026-03-19T08:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 0,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2330"
    },
    {
      id: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      text: "Building 2",
      type: 5,
      start_date: "2025-10-10T08:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 2272,
      parent: "0577b673-7309-47d7-974d-03b269939669",
      progress: 0,
      source_task_id: "7995431"
    },
    {
      id: "96928091-be5e-4d0b-905e-275d70cc308b",
      text: "B1 - mCUP-2 - Install FA  (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2050"
    },
    {
      id: "70d1ba73-1db0-4ad6-bced-2e9613c4fee0",
      text: "Substation-2 - MSG B - 3rd Party Inspections And Equipment Clean",
      type: 0,
      start_date: "2026-01-06T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 152,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4390"
    },
    {
      id: "83c745a8-447f-482f-bc0a-1140aa9dacb1",
      text: "IBOS - Submittal Rvw/App'l -Cable Tray",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: "2024-10-31T08:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1080"
    },
    {
      id: "0d359103-b31f-4090-855a-9d205ce6a5cf",
      text: "B2 - 2A1 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-11T08:00:00",
      duration: 80,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1940"
    },
    {
      id: "fde5ae59-4b28-4cc4-af3f-b303cadb53a5",
      text: "B1 - DH-D - Install Celing Devices Security - Data Hall D",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1340"
    },
    {
      id: "5adf12d4-a3e5-406f-b8dd-93e143105dbe",
      text: "FR 12 - AIken County Engineer response",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: null,
      duration: 0,
      parent: "0bab80ea-8808-4fcd-bcf8-5c2534153920",
      progress: 1,
      source_task_id: "FR.12.1010"
    },
    {
      id: "e9f90f8a-9ff9-43ba-a65b-734e663292fb",
      text: "Phase 1 - Demo Foundations and Infrastructure",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-24T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1020"
    },
    {
      id: "8cd60fb7-09ed-4de5-9f37-e5d320595df1",
      text: "FR 14 - DPR prepare and Submit RFI #41",
      type: 0,
      start_date: "2024-07-16T00:00:00",
      end_date: null,
      duration: 0,
      parent: "abce5df4-8ee4-4f0a-85e7-22726c1c832f",
      progress: 1,
      source_task_id: "FR.14.1000"
    },
    {
      id: "ec8bbfbd-62b0-4e1d-98c9-31dc156e3b76",
      text: "B2 - DH-A - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1040"
    },
    {
      id: "1fb7d762-4ed4-4c33-8469-781f92e92aeb",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-C - Coordination / Sign-off",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 280,
      parent: "04cae6b1-1ca2-4ca5-b054-a176ccf35389",
      progress: 0,
      source_task_id: "B1.VDC.1630"
    },
    {
      id: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      text: "B1 - DH-B - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1920"
    },
    {
      id: "bab4310e-57c3-4542-8777-f8dac058a2aa",
      text: "B1 - DH-B - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 80,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1430"
    },
    {
      id: "377993d1-5eed-4c64-bf35-1d51f4056477",
      text: "B2 - 2B1 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 120,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2220"
    },
    {
      id: "74e49900-e86e-4a0e-a542-d2f9f436cfce",
      text: "Substation-2 - MSG A - Energization MSG",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 24,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4810"
    },
    {
      id: "34cc8481-431d-4c29-b3da-c2ad6501b4d6",
      text: "B2 - DH-B - Hookup CDU's - Data Hall B",
      type: 0,
      start_date: "2026-04-29T00:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 144,
      parent: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      progress: 0,
      source_task_id: "B2.C.B.3230"
    },
    {
      id: "2c8d7f44-9755-44dd-ba6f-f721914766e3",
      text: "B2 - Deep Telecom - EF2",
      type: 0,
      start_date: "2025-03-07T00:00:00",
      end_date: "2025-03-13T08:00:00",
      duration: 40,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2260"
    },
    {
      id: "4eeb88dc-df2d-404a-a0eb-1c891eb234f6",
      text: "B1 - Network Room 1/4 - Power Alley - OH Electrical Rough",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 96,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1300"
    },
    {
      id: "8096e0cd-bd14-4252-a7a8-e98c58288837",
      text: "Install Stainless Steel Panels",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1240"
    },
    {
      id: "d985b530-22fa-4af0-8aa7-184af455bfa8",
      text: "B1 - SSB - 1E2 - CMDF2 - Hang/Tape/Finish Drywall (Carrier MDF2)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 48,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1620"
    },
    {
      id: "ef2d5f17-725b-4e16-92a5-dda27c8dba22",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 80,
      parent: "7ff8625a-dc89-41f6-8d33-dd61dacc1595",
      progress: 0,
      source_task_id: "MECO-1140.40"
    },
    {
      id: "29b3bc87-c2eb-48de-a236-07244017ee38",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 120,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2000"
    },
    {
      id: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed",
      text: "B1 - DH-A - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 40,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1910"
    },
    {
      id: "8d9201fa-93a1-4b66-8cfe-8313bf582b0e",
      text: "B1 - DH-C - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 16,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1640"
    },
    {
      id: "48fd4d4d-9360-4470-9510-527219ab1990",
      text: "Substation-2 - MSG B - Battery Commissioning",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 120,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6440"
    },
    {
      id: "acea461b-0492-401c-8342-d9709ca15201",
      text: "B2 - 2D2 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1270"
    },
    {
      id: "51370ae4-75d9-4cef-9ae2-da90bb8354b8",
      text: "B2 - SSB - Install Structural Steel",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 80,
      parent: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      progress: 0,
      source_task_id: "B2.C.STR.1610"
    },
    {
      id: "576d675f-a4e9-4756-9388-fd569fa1a6a4",
      text: "FR 32 - DPR Prepare and Submit PCO#31",
      type: 0,
      start_date: "2024-08-01T00:00:00",
      end_date: null,
      duration: 528,
      parent: "f3d372b5-108e-423c-a7ac-e30f6c888ce2",
      progress: 0.5,
      source_task_id: "FR.32.1020"
    },
    {
      id: "f76bb9ff-116d-4f70-8644-7b3d064ac299",
      text: "B1 - DH-B - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 80,
      parent: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      progress: 0,
      source_task_id: "B1.C.B.3180"
    },
    {
      id: "a3ecd9d2-7437-4303-b0e8-ab28653cb693",
      text: "Substation-2 - B Lineup - MOAB Assembly / Inspections",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 24,
      parent: "cd03450e-e8ed-4b51-8939-8deb3f7b6575",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6430"
    },
    {
      id: "8b101403-d69e-4cbf-89d2-d57dfe579918",
      text: "Substantial Completion-No Weather - Bldg 2 - DH B",
      type: 0,
      start_date: "2027-01-15T08:00:00",
      end_date: "2027-01-15T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B2.MIL.1070"
    },
    {
      id: "7b87499f-6094-4da2-9138-6f3e096589f1",
      text: "Shell",
      type: 5,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 1144,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995374"
    },
    {
      id: "a30805a1-908f-4f5c-9e23-30230e8de167",
      text: "B1 - 1N2E - EF3 - Pull Wire for Lighting/Outlet/Racks (EF3)",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 24,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5780"
    },
    {
      id: "937a5c15-24b8-429b-aaf6-a66460890d40",
      text: "(OFCI) B1 Generator Switchboard GSB",
      type: 5,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 2896,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.38,
      source_task_id: "7994973"
    },
    {
      id: "47b84e71-6d8b-4a4f-9c83-b37a773abb1e",
      text: "B1 - 1D1W - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1850"
    },
    {
      id: "bb05ed26-7a05-4994-b01c-c4ff95337fb1",
      text: "B1 - SSB - 1E1 - Common - Install Fire Extinguishers/FECs",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 32,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2380"
    },
    {
      id: "a1178e13-fe81-479c-9255-7718bb819472",
      text: "Substation-1 - TX B - Pull Control Wiring",
      type: 0,
      start_date: "2025-06-02T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 40,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3730"
    },
    {
      id: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      text: "GS.IDF.1B3",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 736,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "7995359"
    },
    {
      id: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      text: "Fragnet 06 - PCO # 2 Unsuitable Soils - NE - DCB-1",
      type: 0,
      start_date: "2024-07-18T00:00:00",
      end_date: null,
      duration: 328,
      parent: "cd435564-4024-4c0e-924c-74c687f38b15",
      progress: 1,
      source_task_id: "8519919"
    },
    {
      id: "943ea96e-9626-4052-9280-a99a82a65e2e",
      text: "Site / UG BIM - Area 4 - Critical Early Release - Coordination / Sign Off",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-05-03T08:00:00",
      duration: 160,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1050"
    },
    {
      id: "aa22521b-48bf-4060-93d0-7750855b683f",
      text: "Substation-1 A Lineup SF6 Breaker",
      type: 5,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 880,
      parent: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      progress: 0,
      source_task_id: "7995243"
    },
    {
      id: "4fb95960-4a97-4979-b16c-ddeb13b84af7",
      text: "B1 - 1A2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 8,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1590"
    },
    {
      id: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      text: "Building 1 mCUP-8",
      type: 5,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 576,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995371"
    },
    {
      id: "8dfba035-7dd7-4d9a-8815-dcbdab6d6ead",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1290"
    },
    {
      id: "3ef7bdbd-8183-43d4-aa00-fb8dbd5e7c34",
      text: "Utility Provider Substation - Mass Grading",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-11-01T08:00:00",
      duration: 320,
      parent: null,
      progress: 0,
      source_task_id: "CX0.USS.L2.0050"
    },
    {
      id: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      text: "Corridor 2B2",
      type: 5,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 1016,
      parent: "411d887d-c59d-46aa-9e66-aea427969932",
      progress: 0,
      source_task_id: "7995072"
    },
    {
      id: "698eddcb-208e-4585-b50a-02298ce39c26",
      text: "B1 - 1D1W - 01D.09 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2390"
    },
    {
      id: "d37a751b-6609-4c17-8407-79d882177c2d",
      text: "Substation-2 - MSG B - Install IDF Rack (SUBIDF2)",
      type: 0,
      start_date: "2025-12-01T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 40,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4460"
    },
    {
      id: "f5895a3e-d374-4a6c-b3fa-c30ecba87ba4",
      text: "B2 - 2E2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6030"
    },
    {
      id: "b48817fe-1eac-4caa-a97a-f669f829c86c",
      text: "B2 - DH-B - Install Feeder Conduit -Data Hall B",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2690"
    },
    {
      id: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf",
      text: "B1 - Network - Install Structural Steel",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 80,
      parent: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      progress: 0,
      source_task_id: "B1.C.STR.1600"
    },
    {
      id: "a2492a9b-cb43-4bd9-9a59-b0cc491ac51e",
      text: "Precast Area D",
      type: 5,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 48,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995413"
    },
    {
      id: "445fce04-ff5a-4101-8ebc-0a3c5f751d95",
      text: "Area 3 - MV Electric Install - Remaining (EY into ER) - Concrete Scope",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-26T08:00:00",
      duration: 96,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A3.8080"
    },
    {
      id: "59137c5e-a4c4-472d-9a7c-a8c5b53f55a4",
      text: "New Activity",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "A1030"
    },
    {
      id: "0bdaae5b-baa7-4974-a4c0-6219ba060fe7",
      text: "B1 - Network Room 1/4 - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.2020"
    },
    {
      id: "7ab0eccc-cce0-47fe-bda9-8dca285ccb6f",
      text: "B1 - Network Room 2/3 - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2025-08-26T08:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 0,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1770"
    },
    {
      id: "c5ee9381-912b-4187-b5a6-c4dcc7c931a1",
      text: "B1 - 1B2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1830"
    },
    {
      id: "781f5776-36c9-47be-9361-3dfc2c009a46",
      text: "B1 - 1B2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 160,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2040"
    },
    {
      id: "fb07f730-204b-44da-830f-310ff7231535",
      text: "B1 - SSB - 1E1 - GSMDF1 - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 48,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1540"
    },
    {
      id: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      text: "Corridor 2A1",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 1016,
      parent: "763c185c-82ee-4394-8b78-af68801f04d3",
      progress: 0,
      source_task_id: "7995085"
    },
    {
      id: "3212d75d-e709-4b9e-93ea-a8046f26bea6",
      text: "L3 Finish DH C - DCB1",
      type: 0,
      start_date: "2026-07-15T08:00:00",
      end_date: "2026-07-15T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2031"
    },
    {
      id: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      text: "B1 - DH-D - Install Structural Steel",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 120,
      parent: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      progress: 0,
      source_task_id: "B1.C.STR.2040"
    },
    {
      id: "f4b92410-173d-41f1-a4de-bb7ffb74a86d",
      text: "FR 08 - DPR Submit RFI #51",
      type: 0,
      start_date: "2024-07-23T00:00:00",
      end_date: null,
      duration: 0,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 1,
      source_task_id: "FR.08.1000"
    },
    {
      id: "5da95c87-a4ad-4133-a804-5ca9bce9400a",
      text: "Provide for delivery schedule for MOFE elements to support Level 2 schedule development",
      type: 0,
      start_date: "2024-01-29T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 120,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1350"
    },
    {
      id: "814ea38b-c0af-4e69-9a05-48b4d34fe4da",
      text: "B1 - DH-B - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area B",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3080"
    },
    {
      id: "bdfc8e43-0d5e-4804-a923-09335b93520b",
      text: "B2 - mCUP-4 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4120"
    },
    {
      id: "40a8037f-4f18-432a-aca8-a2338ac84ae5",
      text: "Earth Work - LOI Issed to Start Coordination",
      type: 0,
      start_date: "2024-03-21T00:00:00",
      end_date: "2024-04-03T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1210"
    },
    {
      id: "38abcee0-c149-4e62-84b9-fa5de943f21d",
      text: "Install Exterior Doors",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1110"
    },
    {
      id: "23870b29-3148-4b71-ab9b-0b185a5f87d2",
      text: "B1 - 1D1W - 01D.09 - Lighting and Devices",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2590"
    },
    {
      id: "c70718a1-8ea1-4a5e-9684-0fbedec14a57",
      text: "B1 - 1N1E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5320"
    },
    {
      id: "e4261644-2df6-4b39-97e9-fafd922a375d",
      text: "Area 3 - NCP Duct Bank & Equipment Install",
      type: 0,
      start_date: "2025-02-26T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 104,
      parent: "7c92f19c-97f6-4a6c-9a12-34151bbb5af1",
      progress: 0,
      source_task_id: "C.CSU.A3.6000"
    },
    {
      id: "85de7da8-34c4-4e4d-80d0-bce6ba58d896",
      text: "Campus PH1 - Prep / Submit for Review - MV Vaults (Site) ((Early Release))",
      type: 0,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 120,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0.5,
      source_task_id: "B1.CFCI.3240"
    },
    {
      id: "9af8ef62-2d58-418c-b64a-abf2480870bd",
      text: "Fab and Deliver - PTX-DHAux - Area A (2) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 3320,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.38,
      source_task_id: "B2.OFCI.1720"
    },
    {
      id: "423539f7-f776-4a4a-ba21-9f21e340c238",
      text: "Site / UG BIM - Area 5 - Critical Early Release - Coordination / Sign Off",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-05-03T08:00:00",
      duration: 160,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1060"
    },
    {
      id: "0009692d-af4c-47b0-99bd-88a49bb14da7",
      text: "B1 - Network - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 224,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1100"
    },
    {
      id: "83d86cb6-7192-4722-90b1-5243adc03ca6",
      text: "UG RI -Fire Alarm-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 80,
      parent: "61eca0ba-60c7-4050-b050-569ff6de0dca",
      progress: 0,
      source_task_id: "MECO-1680.30"
    },
    {
      id: "399c6478-9304-4e18-b7dc-7362df4ac7a7",
      text: "Sanitary Sewer",
      type: 5,
      start_date: "2024-08-12T00:00:00",
      end_date: "2024-08-30T08:00:00",
      duration: 136,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995192"
    },
    {
      id: "377b44b7-1e7a-4a2e-bfa6-6cb24b494197",
      text: "Substation-2 - MSG B - MV Terms / NETA Testing  (Finish 03/01/25)",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 160,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4420"
    },
    {
      id: "68d1dfde-3f4b-4389-8d3e-6feff58dc640",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2090"
    },
    {
      id: "415a7e3c-d7ef-4670-a303-95b1b2983458",
      text: "B2 - DH-A - Prime and 1st Coat",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1690"
    },
    {
      id: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      text: "BLDG-2 DH-B ElectricalTerms",
      type: 5,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-04-24T08:00:00",
      duration: 280,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "7995136"
    },
    {
      id: "bb7e01b6-6f50-43b1-b716-8c8007cb068b",
      text: "L3 - B2 DHB",
      type: 0,
      start_date: "2026-10-07T00:00:00",
      end_date: "2026-12-17T08:00:00",
      duration: 400,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX3.B2.DHB.1000"
    },
    {
      id: "59fb0607-d2d2-40f5-81ff-a8ad8254eadc",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1190"
    },
    {
      id: "aedfa6df-7cfe-4a90-ba8a-c62c561c0be8",
      text: "Placeholder - Successor- HRA Activities",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2024-12-31T00:00:00",
      duration: 0,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1130"
    },
    {
      id: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      text: "L5 - B2 DHA",
      type: 0,
      start_date: "2026-12-08T00:00:00",
      end_date: "2027-01-06T08:00:00",
      duration: 160,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHA.1000"
    },
    {
      id: "72852f06-5dba-43f7-a5f4-0b083b6f20d6",
      text: "B1 - DH-B - Raise HACs - Data Hall B",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2560"
    },
    {
      id: "6521a463-cfdf-4a35-ba39-b77c3b90aa72",
      text: "B2 - DH-C - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1110"
    },
    {
      id: "4e35947f-14d0-40e5-bb6d-17eccc689ee4",
      text: "Substation-1 - MSG B - Install Temp Power / Permenant AC / Anchoring / Set In Place Inspection",
      type: 0,
      start_date: "2025-05-01T00:00:00",
      end_date: "2025-05-17T08:00:00",
      duration: 120,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3560"
    },
    {
      id: "12635d9d-3a76-46a8-835c-ac67fdd25209",
      text: "B2 - mCUP-1 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1230"
    },
    {
      id: "a627fdb8-2e87-4669-bfc1-1db6d55acded",
      text: "B2 - DH-C - Set HACs in Place - Data Hall C - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-30T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1850"
    },
    {
      id: "808c8270-2317-4953-81e6-5d115b5a4142",
      text: "Substation-2 - A Lineup - MOAB Assembly / Inspections",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 24,
      parent: "7396df52-8be2-42b0-85c0-849a0964ef15",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6380"
    },
    {
      id: "7c5f9a71-0fb6-43a9-8af5-472f34d8949e",
      text: "B2 - 2E1E - EF3 - Fire Alarm Wire Pulls/Terms to devices (EF3)",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5230"
    },
    {
      id: "0274c778-28b8-475e-aa20-9cf38a7e9426",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Plumbing",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1170"
    },
    {
      id: "7c2bce29-42fa-46b1-ad31-bfb1a0d53148",
      text: "Fixed Louvers",
      type: 5,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-05-22T08:00:00",
      duration: 760,
      parent: "4fc673cb-0d55-4b7a-adb1-7bee9f658bfd",
      progress: 0,
      source_task_id: "7994897"
    },
    {
      id: "27e5365d-cfcc-4ec3-a644-9d8ca0eea1e7",
      text: "B2 - 2C1W - 02C.07 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-04-14T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1900"
    },
    {
      id: "3666d7c1-202c-4c17-81ce-cea597a7a6a1",
      text: "B2 - DH-C - Install 800 Amp Busway - Data Hall C",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1880"
    },
    {
      id: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      text: "B1 - SSB - 1E1 - Common - Prime and 1st Coat Paint",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-17T08:00:00",
      duration: 80,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1320"
    },
    {
      id: "924e57f3-3d32-432b-aaa2-a93728330198",
      text: "Data Hall A (Area 1-A)",
      type: 5,
      start_date: "2024-08-28T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 720,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994814"
    },
    {
      id: "27488122-4468-47dd-9cd1-2ec50bdd594f",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 8,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1350"
    },
    {
      id: "2c21e476-2412-4ed5-8c8a-27650481107d",
      text: "(OFCI) B1 Load Banks",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.29,
      source_task_id: "7994970"
    },
    {
      id: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      text: "B2 - DH-A - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 120,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1030"
    },
    {
      id: "3605f46f-1ad3-4c44-9a9c-4c587ed8e225",
      text: "IBOS - Pre/ Submit Shopdrawings - Lighting",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-19T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1150"
    },
    {
      id: "7c86e854-bbc3-45b8-ae6a-cc608532fb6b",
      text: "B1 - DH-A - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 496,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2930"
    },
    {
      id: "cf863b4c-b4b0-423f-92b0-cfd1e52a6f94",
      text: "BLDG-1/2 - Fabricate / Deliver - Roofing",
      type: 0,
      start_date: "2024-12-18T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 280,
      parent: "1cd8272e-8d86-4a77-881d-f6e520bf9689",
      progress: 0,
      source_task_id: "B1.CFCI.4300"
    },
    {
      id: "6a65cf2b-b775-4416-8901-d28117f830c2",
      text: "B2 - DH-B - Underground (Converted to LOE )",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 240,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1210"
    },
    {
      id: "feb3d06b-eb99-4200-b750-c47050c4ad91",
      text: "Cx - Lvl-3",
      type: 0,
      start_date: "2025-02-22T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8110"
    },
    {
      id: "fbdee150-1e65-4a43-8f20-ecd6cd36736b",
      text: "ATS - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 1,
      source_task_id: "B1.OFCI.1110"
    },
    {
      id: "5ebd7caf-1b83-4268-a22b-1309dea9dbe4",
      text: "Substation-1 - TX A - NETA Testing",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 184,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4080"
    },
    {
      id: "a18ac117-c0f1-48ed-b78c-c8916b3f901d",
      text: "Fab and Deliver - Load Bank 500kW - Area AN - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "2c21e476-2412-4ed5-8c8a-27650481107d",
      progress: 0.29,
      source_task_id: "B1.OFCI.2280"
    },
    {
      id: "e03ba4ef-728a-4129-a456-a8df9cd4d597",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2150"
    },
    {
      id: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84",
      text: "[DCB1] DEC-C Ready: OSP Pathways [SITE BUILDINGS]",
      type: 0,
      start_date: "2025-09-17T08:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3395"
    },
    {
      id: "57f1d59f-978e-4245-96e3-e9e27f131456",
      text: "B1 - Deep Telecom - EF4",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 40,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2410"
    },
    {
      id: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      text: "(CFCI) Div. 03 - (SOG/SOMD) Struc. Concrete",
      type: 5,
      start_date: "2024-10-03T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 200,
      parent: "d390b116-84b5-4ac4-9005-9d68157fdd1b",
      progress: 0,
      source_task_id: "7994852"
    },
    {
      id: "a404f8a5-6318-4723-be95-3ed9a74e748d",
      text: "Ansul System Fire Marshall Test",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1340"
    },
    {
      id: "5e180357-cd7c-41d1-8bdc-d2658386f64e",
      text: "Area 4 - Telecom Install - CAV3 to GH",
      type: 0,
      start_date: "2025-04-10T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 240,
      parent: "8609b6ff-9850-48d0-a7d4-8aefeb103cfe",
      progress: 0,
      source_task_id: "C.CSU.A4.8030"
    },
    {
      id: "1a1e33fa-df12-461b-8561-8dc7b80fc8b3",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1380"
    },
    {
      id: "bec6b574-14c8-4263-a9b5-6b36180ebd3d",
      text: "B2 - DH-A - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 16,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1570"
    },
    {
      id: "bc51e748-0d85-4aa9-85e1-4166676a204e",
      text: "FR 20 - META Issues CCD #18",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 0,
      parent: "a464ca61-32ce-4bd2-8aa4-8f60eccf8e8c",
      progress: 1,
      source_task_id: "FR.20.1000"
    },
    {
      id: "6b740a7f-f87a-46d1-a60f-bedfbce446aa",
      text: "B1 - DH-D - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 160,
      parent: "9f045ffe-87d3-4bb4-b99d-0eab0e0a129a",
      progress: 0,
      source_task_id: "B1.C.D.3160"
    },
    {
      id: "aef6a3f7-129c-4210-aa75-bc872403b87b",
      text: "Paint at Door Frames",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1550"
    },
    {
      id: "99d8d2ec-0f62-414b-bed1-909ecf4cd65d",
      text: "Fab and Deliver - Fan Coil Assembly - Area C - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 3024,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.4,
      source_task_id: "B1.OFCI.3330"
    },
    {
      id: "6df746c4-e7a6-469c-add3-701a0e2ae3ef",
      text: "B2 - DH-B - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1990"
    },
    {
      id: "c8d58817-4ce5-4106-aaf1-15ddaf4a62f4",
      text: "FR 06 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-07-25T00:00:00",
      end_date: null,
      duration: 0,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1010"
    },
    {
      id: "50abbfcc-c6d0-4c3b-8ea5-aa64950c1dbf",
      text: "Substation-1 - MSG A - MV Terms / NETA Testing / Torques (Finish 03/01/25) - Sequence 1",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 160,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4020"
    },
    {
      id: "6d72f4e9-8597-4231-8af2-cbf01f5eb892",
      text: "B1 - DH-D - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 80,
      parent: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      progress: 0,
      source_task_id: "B1.C.D.3110"
    },
    {
      id: "5317568f-1f66-44b8-919a-1d0ab5351796",
      text: "B1 - 1N2E - EF3 - Hang/Tape/Finish Drywall (EF3)",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 48,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5520"
    },
    {
      id: "cc4bd2cd-6e44-4582-9513-64948cad061f",
      text: "FR 24 - META review and Approve PCO#20",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "2ff871d6-c6b3-47c0-a53e-259b72b200a5",
      progress: 0,
      source_task_id: "FR.24.1020"
    },
    {
      id: "805559b8-977c-468b-9080-42c618feb295",
      text: "Install Roofing - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "A1010"
    },
    {
      id: "f8b0866b-c610-4290-9360-f129e2048d7b",
      text: "B1 - mCUP-4 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4120"
    },
    {
      id: "a912fc87-6bd8-4797-a8c6-befebf2dc5e3",
      text: "Fab and Deliver - MVS-5WAY - Area C - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 2768,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.44,
      source_task_id: "B2.OFCI.2150"
    },
    {
      id: "7046f8c6-bbe0-4936-8f84-a466deb40f32",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2520"
    },
    {
      id: "81efd804-3c57-4e17-8153-67a60dcc4815",
      text: "Area A - Paint - Prime/First Coat Walls",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1131"
    },
    {
      id: "67ba77d8-0f1c-4f23-a5ac-1ba681a510b3",
      text: "Substation-2 - A Lineup - Install Breaker and Misc Pad / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 168,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4640"
    },
    {
      id: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9",
      text: "B2 - 2D2 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 8,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1450"
    },
    {
      id: "f88884fa-3014-4a68-8ab9-51163c4a8f1c",
      text: "B1 - DH-A - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 80,
      parent: "7ff8dfca-7821-49f8-b06e-76059e0f610b",
      progress: 0,
      source_task_id: "B1.C.A.2820"
    },
    {
      id: "543fd443-71ab-4709-8f6f-7db7a8c373ea",
      text: "B1 - 1C1W - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 160,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1610"
    },
    {
      id: "2ed13a1a-4937-4a5a-8086-fa20f62e5db3",
      text: "B1 - 1B2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1750"
    },
    {
      id: "89cf7805-54c9-46b7-84b0-dc9faa83d01f",
      text: "Substation-2 - TX A - Energization",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 8,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4900"
    },
    {
      id: "8e996890-0198-459c-8ada-f462147097da",
      text: "B1 - 1D1W - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 120,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1870"
    },
    {
      id: "ca0407a9-b7c9-4931-886c-eddc4a9c1390",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1280"
    },
    {
      id: "e138ba5b-1232-40a9-8192-915af115e43e",
      text: "Open Ceiling MEPF Inspections & QAQC Walks (Area A)",
      type: 0,
      start_date: "2025-08-07T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1480"
    },
    {
      id: "fd008f3f-b652-4ac0-b370-f9edcf3edfc5",
      text: "B1 - 1A2E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1070"
    },
    {
      id: "7f831430-ce60-4cdb-8002-5ec846431633",
      text: "B2 - 2C1 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 120,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2010"
    },
    {
      id: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      text: "Interior Trades",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-10-01T08:00:00",
      duration: 1576,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 0.66,
      source_task_id: "7994730"
    },
    {
      id: "d175c038-a349-426b-a5b0-fea7057cda97",
      text: "B1 - 1N1E - EF4 - Fire Alarm Wire Pulls/Terms to devices (EF4)",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 48,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5730"
    },
    {
      id: "37dfb47a-9eea-4843-9e5a-d54c0928c451",
      text: "B2 - 2E1E - EF3 - In Wall Rough-In/ Inspections (EF3)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 48,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5140"
    },
    {
      id: "fee55743-0c4c-4395-8517-00d5e43c5a97",
      text: "IBOS - Submittal Rvw/App'l - Signage",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6100"
    },
    {
      id: "4666f4f7-c2b8-4663-9220-f4b53663ce77",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 80,
      parent: "92aa8a33-1e8a-4967-95ad-e4391a98b9cd",
      progress: 0,
      source_task_id: "MECO-1140.20"
    },
    {
      id: "5779f0e5-6208-443e-af37-c8a8c4e7342b",
      text: "FR 07 - DPR Review and Access the RFI and ground conditions",
      type: 0,
      start_date: "2024-07-03T00:00:00",
      end_date: null,
      duration: 144,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 1,
      source_task_id: "FR.07.1030"
    },
    {
      id: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      text: "Overall Durations Summary",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 6144,
      parent: "5f1ffaa6-2f9b-4373-bdf7-e99300bec629",
      progress: 0.06,
      source_task_id: "7995418"
    },
    {
      id: "aecc5220-6f2d-4824-821c-8e8a2a8853c5",
      text: "GMP Review Cycle",
      type: 0,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-08-19T08:00:00",
      duration: 400,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 0,
      source_task_id: "Design.PreC.2420"
    },
    {
      id: "825a348c-a090-445d-b2a3-bd4173d09cb6",
      text: "UG RI -Rack Bus-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "f4a0770e-db07-467c-95bd-9d401485c3b6",
      progress: 0,
      source_task_id: "MECO-1740.50"
    },
    {
      id: "48cf4798-012c-4fde-a8da-168cee42ccec",
      text: "(OFCI) B2 Generators",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 3728,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.19,
      source_task_id: "7994963"
    },
    {
      id: "62282871-afe9-4a4d-995a-7a4479435a38",
      text: "B1 - mCUP-9 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 48,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9000"
    },
    {
      id: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      text: "Substation-1 - MSG A - Set / Temp Dry In / Temp Power / Site Acceptance Inspection",
      type: 0,
      start_date: "2025-04-09T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 120,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3920"
    },
    {
      id: "13ea5675-19f8-49a3-9fb7-17b110890694",
      text: "B2 - DH-D - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-04-28T08:00:00",
      duration: 120,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1610"
    },
    {
      id: "4c131e97-35ff-42b2-aa1e-e082a239f55b",
      text: "Substation-2 - TX A - Install Inspection And 3rd Party Controls Cable Verification",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 136,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4880"
    },
    {
      id: "c0354f8e-a2ee-4268-a208-e0af86428c86",
      text: "B1 - 1D2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2410"
    },
    {
      id: "945df35f-ffbb-41c0-bdbd-712cd08e3b88",
      text: "B1 - DH-B - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 200,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1910"
    },
    {
      id: "3cde2b27-f251-484f-86c0-937857581088",
      text: "MVS & HPD - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 1,
      source_task_id: "B2.OFCI.1080"
    },
    {
      id: "ed7dbef1-2034-4840-b525-42186058830d",
      text: "B1 - 1C2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1260"
    },
    {
      id: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      text: "(OFCI) B2 Automatic Transfer Switch ATS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.39,
      source_task_id: "7994953"
    },
    {
      id: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859",
      text: "Baseline 2 Development",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-02-15T08:00:00",
      duration: 304,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2140"
    },
    {
      id: "87ac2321-1e81-4217-ac19-3cf69f69eff7",
      text: "FR 08 - Area 3 - Telecom Install - DCI 3069 - Concrete Scope",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 40,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A3.8060"
    },
    {
      id: "71710f75-81d5-4eaf-891b-683fe501afec",
      text: "Substation-1 - TX A - Install Medium  And High Voltage Terms",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 120,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6270"
    },
    {
      id: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      text: "GS.IDF.2A1",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 736,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "7995086"
    },
    {
      id: "6f44f4cc-51fc-4d7a-a5e0-034ae3a1b069",
      text: "Fab and Deliver - Busway Kits - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 2632,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.23,
      source_task_id: "B1.OFCI.2940"
    },
    {
      id: "417cebdf-db83-426a-a837-c66a1ce529a1",
      text: "B2 - DH-D - Hookup CDU's - Data Hall D",
      type: 0,
      start_date: "2026-07-27T00:00:00",
      end_date: "2026-08-15T08:00:00",
      duration: 144,
      parent: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      progress: 0,
      source_task_id: "B2.C.D.3310"
    },
    {
      id: "90b94368-430f-4f0f-a6e6-026bac123681",
      text: "B1 - 1N2E - 01N3.06 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6200"
    },
    {
      id: "7fbfbd37-d4ab-463c-9600-a3b51b35a517",
      text: "FR 18 - META review and respond to RFI #115",
      type: 0,
      start_date: "2024-08-30T00:00:00",
      end_date: null,
      duration: 144,
      parent: "ae1767c4-d36b-4241-8891-8fc1b5eca613",
      progress: 1,
      source_task_id: "FR.18.1010"
    },
    {
      id: "59ad89ed-a674-45c5-b3a4-11a1955c01c0",
      text: "Admin - Electrical Panel Procurement",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 720,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1020"
    },
    {
      id: "4bf86a0b-092f-43c4-aec6-00e45a71a21f",
      text: "Area 3 - Install Sanitary waste water flow meter",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8140"
    },
    {
      id: "eda016c9-3d34-48eb-8f61-afef736f7f35",
      text: "B2 - DH-B - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 200,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1890"
    },
    {
      id: "b26170cd-2d5a-4580-9a11-b2d308e596d8",
      text: "B2 - 2D1W - 02D.08 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-05-19T00:00:00",
      end_date: "2026-06-16T08:00:00",
      duration: 160,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1940"
    },
    {
      id: "a217ea65-7f40-4457-9273-2743836d8d79",
      text: "B1 - SSB - 1E2 - Common - Install Lighting Controls",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2080"
    },
    {
      id: "e32c8e33-ee0a-4c52-84c0-163264afcce6",
      text: "Fab and Deliver - ATS - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 2680,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.32,
      source_task_id: "B1.OFCI.2750"
    },
    {
      id: "0b14d54b-2e34-46ff-88a4-f143a6decae9",
      text: "BLDG-1/2 - Fabricate / Deliver - Pre-Fab Guardhouse",
      type: 0,
      start_date: "2025-01-03T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 640,
      parent: "54ea1ba9-ddf2-452c-881b-cedd12f21266",
      progress: 0,
      source_task_id: "B1.CFCI.5850"
    },
    {
      id: "143d583f-19d5-4146-b2ac-d9a8356ece24",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2090"
    },
    {
      id: "394d882e-1e6d-49d7-a8fb-6026f159fb2e",
      text: "B1 - Network Room 1/4  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1130"
    },
    {
      id: "ccd6d7e0-afd2-4579-a387-d7241f422e03",
      text: "Cx - Lvl-3",
      type: 0,
      start_date: "2025-02-15T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8230"
    },
    {
      id: "2cf00f3c-2e1b-4859-813d-9c33ecfc636e",
      text: "B2 - 2D1W - 02D.09 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-06-02T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1950"
    },
    {
      id: "cb74270e-a844-4a32-9461-b15618793e69",
      text: "B1 - mCUP-8 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 80,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.9320"
    },
    {
      id: "9fd77abc-8930-4cd7-ac6c-317a7f719ff9",
      text: "Cx - Lvl-2",
      type: 0,
      start_date: "2025-02-22T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 40,
      parent: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      progress: 0,
      source_task_id: "C.CSU.A5.8160"
    },
    {
      id: "9365705a-3a7e-4c12-954d-31f10a1aa8d7",
      text: "FR 19 - META review and respond to RFI #121",
      type: 0,
      start_date: "2024-08-30T00:00:00",
      end_date: null,
      duration: 64,
      parent: "9f9f89a7-c1ad-40cc-9316-7639d5b9a211",
      progress: 1,
      source_task_id: "FR.19.1010"
    },
    {
      id: "4d27fb88-a53c-4d20-8bcf-25e49b8bdbd5",
      text: "B1 - Network Room 1/4 - Power Alley - Refrigerant Lines Install/Test/Insulate",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1590"
    },
    {
      id: "a730483e-8e8e-4296-8460-9970b3854ecf",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2000"
    },
    {
      id: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      text: "Area 5 - Telecom Install",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-02-20T08:00:00",
      duration: 296,
      parent: "1b573127-21b9-4d1c-b69b-ddaf4855b3e8",
      progress: 0,
      source_task_id: "C.CSU.A5.8000"
    },
    {
      id: "bc93e67c-506a-4812-b130-fbe06295ed97",
      text: "B2 - 2E1E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5100"
    },
    {
      id: "37a64b19-679a-4612-9e9d-d9ee450fb456",
      text: "B2 - 2E1E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 120,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5410"
    },
    {
      id: "1ec9245e-0784-47ce-8ceb-83761eb5b47b",
      text: "Substation-2 - TX A - Install Medium  And High Voltage Cable Pulls",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 80,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4860"
    },
    {
      id: "a4f41d60-c40a-4f4b-90e0-ff5c21b42307",
      text: "L4 - B2 EY 1B/D",
      type: 0,
      start_date: "2026-09-09T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 40,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "CX4.B2.MSG.1030"
    },
    {
      id: "fb2c59b8-d9f4-4c8d-bc11-f0a7920e8ff5",
      text: "Area 2 - UG RI -Network Infrastructure Vaults-Campus",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-12-07T08:00:00",
      duration: 208,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1210"
    },
    {
      id: "4e671f2a-872a-49a2-af64-db432bc7d2e6",
      text: "Substation-2 -  Excavate / Install / Inspections / Backfill",
      type: 0,
      start_date: "2025-08-07T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 120,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4280"
    },
    {
      id: "8d985d3d-d7d5-4fec-aaa9-a17e966bc701",
      text: "B1 - 1C1W - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1870"
    },
    {
      id: "1e19bb82-0822-4d07-b931-89ab0239ba2d",
      text: "FR 36 - META review and respond to RFI #194, 252",
      type: 0,
      start_date: "2024-10-09T00:00:00",
      end_date: null,
      duration: 144,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 0.5,
      source_task_id: "FR.36.1010"
    },
    {
      id: "ac96fbb7-00b3-42e1-9f0e-0b38223bed62",
      text: "BLDG-1/2 - Fabricate / Deliver - Power Equipment and Material",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: "2024-09-30T08:00:00",
      duration: 240,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0,
      source_task_id: "B1.CFCI.4140"
    },
    {
      id: "48f4f1fa-d600-4534-9b2b-8c7139bf70d4",
      text: "B2 - DH-D - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 80,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1390"
    },
    {
      id: "10d43805-4d10-4d5f-9691-885af22ff632",
      text: "Substation-2 - Pull and Term Substation to MSG Building 1 B/D (Pull to Vaults) - Sequence 2",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 160,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "B2.C.EY.1320"
    },
    {
      id: "a127f3d4-ff0e-4154-baed-a5027afb4c78",
      text: "B2 - DH-C - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 96,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1950"
    },
    {
      id: "dfebc7b9-22bd-4180-950a-e0893c5c31a6",
      text: "B1 - SSB - Install Mullions and Glazing for Curtain Wall",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 120,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "B1.C.7010"
    },
    {
      id: "28bfbbc5-cffa-4c72-94f6-e54abcc5f55e",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - Set/Hook-Up Equipment",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 160,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6390"
    },
    {
      id: "240727d0-87c1-4e65-a6df-607f81f86df4",
      text: "B1 - DH-A - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1260"
    },
    {
      id: "b8332424-6c0c-4937-a992-180822cd6b7d",
      text: "GC Project Review Package Budget Estimate Agreed",
      type: 0,
      start_date: "2024-03-07T08:00:00",
      end_date: "2024-03-07T08:00:00",
      duration: 0,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "ICM.PRE.1560"
    },
    {
      id: "c6758e12-3fb2-44b2-a5bf-ef703df2ba9f",
      text: "B1 - Network Room 1/4 - Power Alley - Prime Paint/First Coat Inside Electrical Room",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1260"
    },
    {
      id: "fd20188e-aee7-4107-8957-b2b7ff9fedd7",
      text: "Area 1 - Storm Install (Early Work)",
      type: 0,
      start_date: "2024-07-20T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 1,
      source_task_id: "C.CSU.A1.8030"
    },
    {
      id: "b500bc0f-4651-4685-88a7-98c092da44d2",
      text: "FR 06 - Determine no longer schedule impact",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: null,
      duration: 280,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1020"
    },
    {
      id: "8331d266-0138-4b68-98a0-04c6efcc3613",
      text: "Remaining Utilities",
      type: 5,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 432,
      parent: "4154f35b-b33f-42f4-b0f4-5f1117171117",
      progress: 0.9,
      source_task_id: "7994760"
    },
    {
      id: "33af645e-c859-43d2-99ff-4bef45a62368",
      text: "B2 - DH-D  - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 192,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1920"
    },
    {
      id: "8b2e20c4-3d3d-407d-a99c-c99957870dba",
      text: "FF GMP Issuance",
      type: 0,
      start_date: "2024-07-22T00:00:00",
      end_date: null,
      duration: 8,
      parent: null,
      progress: 1,
      source_task_id: "Design.PreC.5760"
    },
    {
      id: "6b8d202d-741c-4df6-a1db-08aa839d2dec",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [8] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 1792,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.57,
      source_task_id: "B1.OFCI.3620"
    },
    {
      id: "17b6b45a-e94d-474a-ab36-b22735d1b304",
      text: "B1 - mCUP-6 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6110"
    },
    {
      id: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 160,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1860"
    },
    {
      id: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd",
      text: "B2 - mCUP-8 - Set in Place Inspections",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 8,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8050"
    },
    {
      id: "c832106d-03db-4ac2-81ea-f439c4d85963",
      text: "B2 - 2E2E - EF1 - Fire Alarm Wire Pulls/Terms to devices (EF1)",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6240"
    },
    {
      id: "711d8fd5-c3b2-45cd-9880-a000d9e4ac00",
      text: "B2 - 2C2 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 160,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1790"
    },
    {
      id: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      text: "B1 - DH-A - El Equip Yd - Pour Pads (Other Eqiuipment Pads)",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 120,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2880"
    },
    {
      id: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 16,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1590"
    },
    {
      id: "8609b6ff-9850-48d0-a7d4-8aefeb103cfe",
      text: "Telecom",
      type: 5,
      start_date: "2024-10-03T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 1512,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995180"
    },
    {
      id: "6f36d7bf-6fae-4a45-a26e-36e83757bb2e",
      text: "Fab and Deliver - MSB - Area AN - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-14T08:00:00",
      duration: 2504,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.56,
      source_task_id: "B1.OFCI.3750"
    },
    {
      id: "f8394416-7f37-4ba2-a3b2-9f1de04b491b",
      text: "In Wall Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 40,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1130"
    },
    {
      id: "1bc461ac-67a2-4da1-9214-c81596c667af",
      text: "B1 - 1D2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 8,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2080"
    },
    {
      id: "6f576b5f-da2a-46d4-a303-305280bc06fa",
      text: "B1 - mCUP-8 - Setting and Hookup of GS-IDF Hut (1X1)",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 80,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.C.EY.1220"
    },
    {
      id: "6fc5c784-ff76-492b-bf3d-d3489e899da0",
      text: "Millwork - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5850"
    },
    {
      id: "192687e0-64e7-4862-863a-1c828a9af852",
      text: "B1 - 1N1W - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 160,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5990"
    },
    {
      id: "14902242-0aa9-44e2-a0d4-0c8d86470433",
      text: "B2 - DH-B - Set HACs in Place - Data Hall B - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2420"
    },
    {
      id: "f7fb22f7-9a94-4ce8-a31e-bdeca3263a4e",
      text: "B1 - 1N1W - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5110"
    },
    {
      id: "3343dfa3-8d89-4dea-b9e4-bc6003a58e32",
      text: "B2 - mCUP-4 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 16,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4010"
    },
    {
      id: "cf490d6c-ecca-4326-b048-9799788b1079",
      text: "Area 2 - Storm Install (Branch @ Higher Elevation)",
      type: 0,
      start_date: "2024-09-14T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0.7,
      source_task_id: "C.CSU.A2.8090"
    },
    {
      id: "c565da9e-b058-48b9-b693-253cb1774d3b",
      text: "L3 Start Network Core - DCB1",
      type: 0,
      start_date: "2026-01-12T00:00:00",
      end_date: "2026-01-12T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2270"
    },
    {
      id: "d70530f6-b13d-4b0a-940b-9b1bf24a563d",
      text: "Remote GS.IDF",
      type: 5,
      start_date: "2025-10-08T08:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 552,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994826"
    },
    {
      id: "69665203-6cf0-42df-b0f5-54356551c93f",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1300"
    },
    {
      id: "6471d422-b6c6-4f70-b523-b50fee871ede",
      text: "B2 - 2D2 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 80,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2030"
    },
    {
      id: "8a4d7df9-fc67-4c5f-8ddc-be1b25f1dcca",
      text: "FR 08 - Area 1 - Telecom Install - Concrete Scope",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 336,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A1.8050"
    },
    {
      id: "22531de7-5fc4-47f3-a4d9-e2b243dd998e",
      text: "Electrical - LOI Issued to Start Coordination",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-04-19T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1090"
    },
    {
      id: "e777b038-b4ed-4f24-b3e1-75b3bc7303be",
      text: "B2 - DH-B - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 440,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1350"
    },
    {
      id: "e8bb7480-605d-40b8-bf0b-d4e05dd219f6",
      text: "B1 - DH-D - Hookup CDU's - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 144,
      parent: "4e59b52c-1f38-413f-b50f-c638d57eaa94",
      progress: 0,
      source_task_id: "B1.C.D.3190"
    },
    {
      id: "a2ad3ae9-a8d1-4abf-acb6-54dec595d278",
      text: "BLDG-1 - Area NWH - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.4510"
    },
    {
      id: "e2fa4b2a-9685-4bcb-8036-9dc03a08509e",
      text: "B1 - SSB - 1E2 - CMDF2 - Fire Alarm Wire Pulls/Terms to devices (Carrier MDF2)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 48,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.2010"
    },
    {
      id: "9d6cdbf6-cd98-41af-870d-a8ca2dbedeb7",
      text: "Drop Ceiling Tile",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 64,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1210"
    },
    {
      id: "460387f3-8d9e-4736-878f-1a9c8ae4ed44",
      text: "B2 - DH-C - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-05-11T00:00:00",
      end_date: "2026-05-15T08:00:00",
      duration: 40,
      parent: "7e2c4263-df53-41a3-b764-1e6e272793de",
      progress: 0,
      source_task_id: "B2.C.EY.1680"
    },
    {
      id: "68713f45-bde5-47e7-8274-03e9250dc4fe",
      text: "Non-Critical Power (NCP)",
      type: 5,
      start_date: "2025-02-19T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 104,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995196"
    },
    {
      id: "0f98c2dc-95cb-4c8f-9904-9ec20abb54b0",
      text: "Install Base",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1390"
    },
    {
      id: "6f7c798d-db7b-498b-8f2b-b7693ae46690",
      text: "B2 - mCUP-7 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 48,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7050"
    },
    {
      id: "269795b2-1cc4-4a15-a305-d34616207b2c",
      text: "OBSOLETE",
      type: 5,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 1,
      source_task_id: "7994712"
    },
    {
      id: "14b97f7a-27e8-43fd-8916-309064e52450",
      text: "FR 29 - META issue CSI #49",
      type: 0,
      start_date: "2024-09-20T00:00:00",
      end_date: null,
      duration: 0,
      parent: "76f1b205-6d2d-4956-8ca6-877a6aaee359",
      progress: 1,
      source_task_id: "FR.29.1000"
    },
    {
      id: "26a0ab21-8763-4753-97e3-a8223966b701",
      text: "OH AV Rough-In",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1240"
    },
    {
      id: "8b73533e-a37d-4356-a710-42a89f5aa2bf",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2330"
    },
    {
      id: "a78c948f-f3bd-4b71-a9b7-97fc7af1e375",
      text: "B2 - DH-A - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 40,
      parent: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      progress: 0,
      source_task_id: "B2.C.STR.2040"
    },
    {
      id: "f0230088-d1d8-4d15-b31c-31fd11261515",
      text: "Electrical Cennections to",
      type: 0,
      start_date: "2025-02-04T00:00:00",
      end_date: "2025-02-08T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8080"
    },
    {
      id: "4e12a895-47e2-4fea-9409-b26dbde1e9e5",
      text: "B2 - mCUP-3 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 48,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3050"
    },
    {
      id: "a1272486-f8a4-4ec5-89f7-bbd119858505",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [8] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 2592,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.52,
      source_task_id: "B2.OFCI.2860"
    },
    {
      id: "a7607f8c-afbf-4fe8-852f-eddfb333fda5",
      text: "B2 - 2C1W - 02C.08 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-04-01T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.1870"
    },
    {
      id: "1ce850f3-9e55-4e6b-912f-bcfe9c5a8eb6",
      text: "B1 - DH-D - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-17T08:00:00",
      duration: 40,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1170"
    },
    {
      id: "cf5b5417-f08b-4e80-a7fc-fbf247d6b620",
      text: "DFSMA - DC2 DHA HAC ROJ - MOFE",
      type: 0,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 0,
      parent: "f0d9ef4f-191d-4d39-9779-5b0274a8fb64",
      progress: 0,
      source_task_id: "B2.DFSMA.1070"
    },
    {
      id: "6e09fdd0-a78c-412b-a308-88e90ceb068c",
      text: "Substation-1 - MSG A - Control Power And EPMS Dead Bus Checkout",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 80,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4040"
    },
    {
      id: "72cbdee6-37c4-4a7b-99cd-23f275f0296d",
      text: "B1 - SSB - 1E1 - Common - Install Lighting Controls",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2160"
    },
    {
      id: "1ce30bc0-7d53-48be-9647-92258bdb2f95",
      text: "Site / UG BIM - Area 1 - Remaining Utilities - Coordination / Sign Off",
      type: 0,
      start_date: "2024-05-20T00:00:00",
      end_date: "2024-06-24T08:00:00",
      duration: 200,
      parent: "8331d266-0138-4b68-98a0-04c6efcc3613",
      progress: 0.96,
      source_task_id: "SITE.VDC.1070"
    },
    {
      id: "96a9e182-336d-409e-a84b-8d37d1898f5a",
      text: "GSB - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "13271001-2e22-408b-be08-3d8849f2f6ba",
      progress: 1,
      source_task_id: "B2.OFCI.1130"
    },
    {
      id: "37338ad1-344f-4f49-83db-8a381da2ea88",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area B (22) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-02T08:00:00",
      duration: 3000,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.31,
      source_task_id: "B1.OFCI.2440"
    },
    {
      id: "4899f493-60f8-48a4-aec6-46c0cf634580",
      text: "Substation-2 - MSG A - MSG A Neta Testing",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 152,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4740"
    },
    {
      id: "63f50e60-6bf4-43ef-afc9-b7259a6623a5",
      text: "Fab and Deliver - RSB - Area A - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2584,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.48,
      source_task_id: "B1.OFCI.2890"
    },
    {
      id: "5cd78464-3e9e-41ea-b05c-41fc308234bb",
      text: "Area 3 - MV Electric Install - Remaining (EY into ER)",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-26T08:00:00",
      duration: 96,
      parent: "927aef3e-b93e-46be-8eab-182fa2b5c711",
      progress: 0,
      source_task_id: "C.CSU.A3.8010"
    },
    {
      id: "b48019ec-f3dc-4e40-a6df-fcc7c53a9cdf",
      text: "Area 4a - UG RI -Panel Boards (PB)-Campus",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-21T08:00:00",
      duration: 192,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1640"
    },
    {
      id: "663a2db9-12db-4dd3-978d-f78acc7ceaf2",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1610"
    },
    {
      id: "0e638283-18ef-4adb-a7ce-064ebc7df6fd",
      text: "B2 - mCUP-5 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5060"
    },
    {
      id: "ce105bdf-9ed0-4179-b8be-e5801afd21c0",
      text: "Install Vapor Barrier",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 16,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1030"
    },
    {
      id: "6940e702-d644-4f22-b07b-cecadc0a3af9",
      text: "B1 - 1D2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1940"
    },
    {
      id: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      text: "Substation-2 B Lineup Work",
      type: 5,
      start_date: "2025-04-25T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 2440,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "7995221"
    },
    {
      id: "193ac790-6241-4c4d-8b9b-2d8dbeb9d2f7",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 24,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1850"
    },
    {
      id: "c2465daa-bbb5-4c1d-bab0-66078bd51345",
      text: "Fab and Deliver - ATS - Area B - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 2800,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.33,
      source_task_id: "B1.OFCI.3090"
    },
    {
      id: "9130718b-0c0b-47c8-9499-733194076ce7",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2040"
    },
    {
      id: "241e4023-04e5-4699-bbca-d33cd4f5e1cd",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1600"
    },
    {
      id: "165e2c1a-fc51-495d-818e-a376cd54b355",
      text: "B2 - DH-D - Install Ceiling Devices - Lighting - Data Hall D",
      type: 0,
      start_date: "2026-07-20T00:00:00",
      end_date: "2026-08-14T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2540"
    },
    {
      id: "40407a0a-3c8b-4b27-980d-516d0baf25c8",
      text: "Substation-1 - B Lineup - Install Transformer Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-01-27T08:00:00",
      duration: 128,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3370"
    },
    {
      id: "7e297290-43c7-404a-b379-6ce4cea826e0",
      text: "Precast Complete  - DCB1",
      type: 0,
      start_date: "2025-07-11T08:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1390"
    },
    {
      id: "595b507d-b492-416a-90ca-ccfdb2c3e142",
      text: "B1 - 1N1E - 01N4.07 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.5720"
    },
    {
      id: "f43b88cf-ccae-4010-bdee-8680c9453e22",
      text: "B2 - DH-C - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-02-10T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 40,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1220"
    },
    {
      id: "5b32e6b4-bde3-4733-bdaa-3b2445f9e1fd",
      text: "B1 - 1N1E - EF4 - In Wall Rough-In/ Inspections (EF4)",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-19T08:00:00",
      duration: 48,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5480"
    },
    {
      id: "5d98bb0f-1888-4338-9228-c4f17c29aba8",
      text: "B1 - DH-D - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 224,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1010"
    },
    {
      id: "5fadcab1-1647-4a91-9e20-0bbeb8331a28",
      text: "Commissioning - GH",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 80,
      parent: "960a3230-3d18-4a8d-9b60-7f435cfb3995",
      progress: 0,
      source_task_id: "GH.CON.1060"
    },
    {
      id: "eaf7c69a-484a-4ab0-a199-b4436346dec8",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2330"
    },
    {
      id: "24cc58c6-33d9-4791-9c1d-47ad6213dc39",
      text: "Set Electrical Skid (By Others)",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 16,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1170"
    },
    {
      id: "224699cc-9eda-43c1-93df-478ccee1d499",
      text: "ADMIN - Fabricate / Deliver - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6290"
    },
    {
      id: "e2ded763-0af7-44d2-bd42-ab2f0174d181",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2450"
    },
    {
      id: "cd4287b6-8d72-4989-970a-d3aaca99840d",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2440"
    },
    {
      id: "95889109-3260-43ba-893a-e3bdf76351dd",
      text: "B1 - 1N2E - 01N3.05 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.5800"
    },
    {
      id: "71b674fe-bce7-40b1-afb9-e2860457b441",
      text: "BLDG-1 DH-C Level 2 Checkout",
      type: 5,
      start_date: "2025-10-21T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 480,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "7995261"
    },
    {
      id: "5fc00194-0044-41dd-91c0-def3952f5bc9",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Mechanical",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1520"
    },
    {
      id: "6b110876-0968-44c0-b6b2-6a84e5254d0b",
      text: "(CFCI) NCB - Long Lead Elec (Transformers)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994916"
    },
    {
      id: "69275b9f-5368-48a2-a218-4419d4cfb762",
      text: "Campus - Fabricate / Deliver - Fencing",
      type: 0,
      start_date: "2025-02-13T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 320,
      parent: "2390c294-1245-4d73-85bc-b779088085b9",
      progress: 0,
      source_task_id: "B1.CFCI.4720"
    },
    {
      id: "514fd011-bf24-4893-b099-d913d65e9062",
      text: "[DCB2] DEC-C Ready: OSP Pathways [GS EXTERIOR]",
      type: 0,
      start_date: "2025-12-17T08:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 0,
      parent: "75b6388a-59b7-4d32-9f21-f50d2281bccf",
      progress: 0,
      source_task_id: "ICM.B2.3395"
    },
    {
      id: "e1005323-b570-4e7b-9372-bd513d48298d",
      text: "B2 - DH-B - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 120,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1220"
    },
    {
      id: "5ad6c77b-5a7c-48c5-b47c-25c950c95582",
      text: "B1 - mCUP-6 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6060"
    },
    {
      id: "49b3bada-c435-4f42-91ee-df8ea630ff7f",
      text: "UPS - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 1,
      source_task_id: "B2.OFCI.1380"
    },
    {
      id: "86dd4423-66ad-47a2-a560-82d0629aea42",
      text: "B2 - OSP Cabling - EF to GSIDF 2X2",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 40,
      parent: "71be5c41-0454-4bac-8971-6b8f2d2021a0",
      progress: 0,
      source_task_id: "B2.CONN.1050"
    },
    {
      id: "d6c0114c-ac51-4de5-974b-e8eccc5b4cda",
      text: "B1 - 1D1W - 01D.08 - Pull Wire to Equipment",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2340"
    },
    {
      id: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      text: "High Risk Activity Tracker",
      type: 0,
      start_date: "2024-08-26T00:00:00",
      end_date: null,
      duration: 408,
      parent: null,
      progress: 0.37,
      source_task_id: "8432693"
    },
    {
      id: "1351f692-8022-4e54-8888-a6468600c729",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1510"
    },
    {
      id: "9b3c6789-4852-4295-9750-2142140748b3",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2140"
    },
    {
      id: "10f43da3-9126-4ce3-982b-181f5f132b3e",
      text: "B1 - DH-D - Inspect Above Ceiling - Data Hall D",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 48,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1380"
    },
    {
      id: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      text: "(OFCI) B1 FCA Fan Coil Assembly",
      type: 5,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 3104,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.37,
      source_task_id: "7994988"
    },
    {
      id: "4f4606b3-f68d-44b0-945d-7d54e8b3b4f9",
      text: "B1 - 1A2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1440"
    },
    {
      id: "de662fe5-d473-4455-b6fb-ff1631479414",
      text: "Fab and Deliver - Substation XFMR - Area SS-1 (2) - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 2976,
      parent: "670bdb28-db62-4fc2-b89a-d1ad6f28ec8c",
      progress: 0.36,
      source_task_id: "B1.OFCI.1960"
    },
    {
      id: "11124115-e84b-48a2-b3b3-96ff6467f7a9",
      text: "B1 - DH-C - Install Celing Devices Fire Alarm - Data Hall C",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2610"
    },
    {
      id: "1a847011-646f-4791-8010-087565bcd660",
      text: "Trailer City  - Energize",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-12-12T08:00:00",
      duration: 136,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1140"
    },
    {
      id: "e677d5ef-4096-4d6a-85df-67e542e344ed",
      text: "B2 - SSB - Install Vapor Barrier",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 40,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1050"
    },
    {
      id: "1cd5d6e0-2628-4a52-b015-4495ca01939d",
      text: "B2 - 2E1E - 02.01.E1.05 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5490"
    },
    {
      id: "bd0b6c9e-2bda-4569-a2c3-e0488bf4ee6b",
      text: "B2 - Set Storm Inlets",
      type: 0,
      start_date: "2025-04-22T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 80,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1100"
    },
    {
      id: "86f89069-5a01-4f2c-bc24-321461d381a3",
      text: "Campus - Submittal Rvw/App'l -  Sanitary Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-06-03T08:00:00",
      duration: 40,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5930"
    },
    {
      id: "d9d2a2ca-55ab-40b7-b86c-22fa99be924a",
      text: "Temparary Commissioning Power",
      type: 5,
      start_date: "2025-12-16T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 40,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995248"
    },
    {
      id: "2e04d002-0e78-4fb9-8997-22ad664d0d84",
      text: "Substation-2 - TX B - Install Inspection And 3rd Party Controls Cable Verification",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 136,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4520"
    },
    {
      id: "7de64614-0d3e-46b0-a8e7-e7ab3e5851a7",
      text: "Deep Underground - Electrical",
      type: 0,
      start_date: "2024-12-13T00:00:00",
      end_date: "2024-12-24T08:00:00",
      duration: 64,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1090"
    },
    {
      id: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      text: "L5 - B1 DHA",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-06-15T08:00:00",
      duration: 160,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHA.1000"
    },
    {
      id: "e85e86a3-2e43-4831-8b75-c7f6616ff48e",
      text: "L3 - B1 DHA",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 400,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX3.B1.DHA.1000"
    },
    {
      id: "b47fd28a-fffa-4e5d-b59c-3bc12a8bfd0e",
      text: "FR 28 - META review and Approve PCO#26",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "1076d022-f279-458e-8e6f-47edee4227c2",
      progress: 0,
      source_task_id: "FR.28.1020"
    },
    {
      id: "4c58fab9-a2ff-4a2e-baf5-90e36cba5085",
      text: "B2 - DH-D - Install Grounding Loop - Data Hall D",
      type: 0,
      start_date: "2026-09-11T00:00:00",
      end_date: "2026-10-08T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2650"
    },
    {
      id: "1167f1b9-3593-4dae-828b-053796d82752",
      text: "B1 - DH-B - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 16,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2660"
    },
    {
      id: "cb3f6849-3dfc-4fb3-b936-97e725cca578",
      text: "Fab and Deliver - PTX-DHAux - Area C (2) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2576,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.47,
      source_task_id: "B1.OFCI.2610"
    },
    {
      id: "d2bafa63-41bc-4ea8-b5c0-3878b473b020",
      text: "B2 - mCUP-4 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4110"
    },
    {
      id: "1f419ff1-e532-4006-a0e9-07d0aad30a72",
      text: "Weather/Construction Bank - Site - BG to Start of Foundations Bldg 2 (Original 25+5=30; Remaining 16)",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 200,
      parent: "268c5697-a68e-41ba-bbc5-d57da0b4f384",
      progress: 0,
      source_task_id: "WEATHER.1090"
    },
    {
      id: "ebeccaa7-5cce-479e-adab-4ec5dea93232",
      text: "Owner Substation - 2 Ready for Energization",
      type: 0,
      start_date: "2026-07-01T08:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "TPM.B2.2016"
    },
    {
      id: "02c7fc48-581f-4a06-a836-9b1fdcb6b745",
      text: "BLDG-1/2 - Fabricate / Deliver - Storage racks",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6410"
    },
    {
      id: "8b1cfe3f-622a-4018-96c6-d9be6db603c2",
      text: "B2 - DH-C - Install Grounding Loop - Data Hall C",
      type: 0,
      start_date: "2026-07-22T00:00:00",
      end_date: "2026-08-18T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2650"
    },
    {
      id: "a706f8e9-f5f3-400c-8585-d4fb3ff784b5",
      text: "Fragnet 05 - Design Changes @ Substation",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 160,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.58,
      source_task_id: "8519850"
    },
    {
      id: "9f950378-b1a8-4c00-b309-841d44ffae07",
      text: "B1 - mCUP-1 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1290"
    },
    {
      id: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      text: "BLDG-1 SSB 1E2 Carrier MDF 2",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 344,
      parent: "317fedf3-4445-4d48-b19e-75107c7c0568",
      progress: 0,
      source_task_id: "7995297"
    },
    {
      id: "f93d234d-d4d6-40d7-82eb-2d9763730eec",
      text: "B2 - Fine Grading",
      type: 0,
      start_date: "2025-05-29T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 40,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1110"
    },
    {
      id: "11fdd4e2-de70-4a39-831b-622b2548281f",
      text: "B2 - DH-B - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 16,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1750"
    },
    {
      id: "8dbaca25-853f-4dd2-8d78-bbaaa785a357",
      text: "B2 - 2E2E - 02.01.E1.02 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6360"
    },
    {
      id: "9319a15f-aaa6-40df-a1dc-1a376df772dd",
      text: "Delivery of HAC - Hot Aisle Containment (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1845"
    },
    {
      id: "fe448f54-abe2-4800-a0f2-1f7d9c147801",
      text: "Install Visual Display Fabric",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1480"
    },
    {
      id: "09cd8070-041c-48f8-a4b1-faa0b7fe33b7",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area D (16) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 2616,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.45,
      source_task_id: "B1.OFCI.2600"
    },
    {
      id: "f9f209a6-05a3-491c-8a4f-9b1cd1d20320",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Security",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1010"
    },
    {
      id: "a255d6d3-9462-46d0-979d-8991a42c9e9b",
      text: "FR 40 - Miller and BMC coordinate and discuss",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: null,
      duration: 8,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1020"
    },
    {
      id: "d833d61a-29e5-405d-853f-b132b1771ed3",
      text: "B1 - DH-D - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1460"
    },
    {
      id: "6699faf0-2337-45f8-a024-f6ba073019ff",
      text: "B1 - RF-Tower-1 - Equipment Pads",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 40,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2180"
    },
    {
      id: "685a2a7b-06f7-496e-baa7-a599fba664dd",
      text: "B1 - DH-B - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 80,
      parent: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      progress: 0,
      source_task_id: "B1.C.B.3160"
    },
    {
      id: "b8c1abae-4087-464e-b7cf-c0f7c27aaf38",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-07-02T08:00:00",
      duration: 120,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2060"
    },
    {
      id: "d6770684-e93c-42d9-bf34-88a0c4e7b7c8",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [7] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 3024,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.36,
      source_task_id: "B2.OFCI.2780"
    },
    {
      id: "597c58ac-895e-4e33-99f0-0adcfe2d7e72",
      text: "Structure and Skin",
      type: 5,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 560,
      parent: "39855758-26c2-45c7-8a00-84dc36793e26",
      progress: 0,
      source_task_id: "8147635"
    },
    {
      id: "9e5d8da1-330b-4423-a31f-bf03e353e6e0",
      text: "B1 - DH-B - Hookup CDU's - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 144,
      parent: "3d507b23-1be2-4905-a76c-b9aeff9a12e5",
      progress: 0,
      source_task_id: "B1.C.B.3230"
    },
    {
      id: "7cf722b6-2bf1-47dc-be2b-b2f9c40eb113",
      text: "B2 - mCUP-7 - L2 Inspections",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7130"
    },
    {
      id: "6cb5740c-921b-4c90-9648-0e073cfc6e31",
      text: "B2 - mCUP-6 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6090"
    },
    {
      id: "8bda10f8-ad88-4d6d-8ac1-bee43326318e",
      text: "B1 - SSB - 1E2 - Common - Install Wall Devices BMS",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2210"
    },
    {
      id: "e79d2424-9f4b-489d-ab7e-be0866706ca4",
      text: "B1 - Network - Install Coping",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1260"
    },
    {
      id: "495690ef-6105-4dce-b7e9-ae4d163a37cb",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Plumbing (OH / In Wall)",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 120,
      parent: "425a3675-d964-4bcd-981d-bc45ef37bf99",
      progress: 0,
      source_task_id: "B1.CFCI.3580"
    },
    {
      id: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 560,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995388"
    },
    {
      id: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6",
      text: "B2 - DH-A - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 40,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1730"
    },
    {
      id: "4f060e97-4d69-46da-94e0-43573784cb47",
      text: "Area 3 - MV Electric Install - Priority for Foundations (Sub to MV Loop)",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 136,
      parent: "927aef3e-b93e-46be-8eab-182fa2b5c711",
      progress: 0,
      source_task_id: "C.CSU.A3.7000"
    },
    {
      id: "7c383a6f-d997-4822-8e5d-60fe7f1ffca1",
      text: "B2 - 2C1W - 02C.08 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-04-14T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.1910"
    },
    {
      id: "66b9cf2e-5a88-4308-ba1f-9dbe45a54af9",
      text: "FR 10 - META / EOR review and respond RFI#37,38,39",
      type: 0,
      start_date: "2024-07-16T00:00:00",
      end_date: null,
      duration: 32,
      parent: "207d8eec-4e49-43ad-8f43-1e6990c9645f",
      progress: 1,
      source_task_id: "FR.10.1020"
    },
    {
      id: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb",
      text: "B1 - DH-B - Precast",
      type: 0,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 48,
      parent: "4165939d-36ab-4f5b-a42d-afb4d272c96e",
      progress: 0,
      source_task_id: "B1.C.1790"
    },
    {
      id: "133e49c0-4321-4385-a537-e1d6fbe38160",
      text: "B1 - 1C1W - 01C.08 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1950"
    },
    {
      id: "d9a46c0c-dedf-4a19-bd8e-5069f5ad7df6",
      text: "B2 - DH-C - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1080"
    },
    {
      id: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      text: "B2 - DH-C - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 120,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "B2.C.EY.1140"
    },
    {
      id: "15d76d07-a923-4f36-a384-4b0e2af0f802",
      text: "Campus - Fabricate / Deliver - Sanitary Manholes and Inlets (Early Release) - Area 4 & 5",
      type: 0,
      start_date: "2024-06-11T00:00:00",
      end_date: "2024-07-09T08:00:00",
      duration: 160,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 0.45,
      source_task_id: "B1.CFCI.6030"
    },
    {
      id: "605cdf06-8d1e-41b4-b20f-86f6d7e4d916",
      text: "B1 - SSB - 1E2 - Common - Install Cable Tray",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1780"
    },
    {
      id: "593a80bc-3845-40e6-be8f-ddddcd2569c2",
      text: "Area 4 - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1650"
    },
    {
      id: "fb6b741c-8b01-40fc-beb9-d34d4c881166",
      text: "PWO Meta Legal Review",
      type: 0,
      start_date: "2023-10-19T00:00:00",
      end_date: "2023-11-03T00:00:00",
      duration: 88,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "PRE-EP-1040"
    },
    {
      id: "a791ae22-853b-4fa7-a2ee-cd8b54a001da",
      text: "B2 - DH-D  - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 96,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1910"
    },
    {
      id: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      text: "B2 - DH-D - Install Structural Steel",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 120,
      parent: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      progress: 0,
      source_task_id: "B2.C.STR.1790"
    },
    {
      id: "67b4216e-3f2b-49ad-afa6-09c28346ca7d",
      text: "Area 4 - UG RI -Substation Feeds-Campus",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1660"
    },
    {
      id: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d",
      text: "B1 - 1N1W - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-14T08:00:00",
      duration: 104,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5000"
    },
    {
      id: "c400db76-d6aa-4187-b34c-89cd23e11458",
      text: "B1 - DH-D - Set FCA's - Data Hall D",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1100"
    },
    {
      id: "f9b7b2d8-c045-4c6a-8a67-d66e8dca4696",
      text: "BLDG-1/2 - Submittals - Cold Formed Metal Framing",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-12T08:00:00",
      duration: 120,
      parent: "cdab7e2f-666b-4468-a664-79d098844933",
      progress: 0,
      source_task_id: "B1.CFCI.3650"
    },
    {
      id: "a247b351-bc53-43c6-9cce-4f9025d4fe1b",
      text: "B1 - 1D2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1950"
    },
    {
      id: "9f8e46ad-f77b-490f-8882-a45a7e58555b",
      text: "Glass & Metal Panel Bid & Develop SA Package",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-24T08:00:00",
      duration: 480,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 0.95,
      source_task_id: "PRE-PP-1130"
    },
    {
      id: "6fd82713-1b4a-4d61-8d34-8d8ed4dfd55d",
      text: "B1 - DH-D - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-11-11T08:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 0,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1090"
    },
    {
      id: "abac7b65-cccd-4286-a5b0-390254902430",
      text: "B2 - 2A2 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1470"
    },
    {
      id: "0cdae1e4-86b9-4398-b004-dc07e31ce270",
      text: "B1 - Network - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 80,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1370"
    },
    {
      id: "07df9232-df27-4805-8357-1453c9bc3e32",
      text: "OH Electrical",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1080"
    },
    {
      id: "b2c0c497-5e9a-4e33-9695-45fbf75f6135",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1190"
    },
    {
      id: "4c1c74f2-a484-4817-8438-123bd159c87b",
      text: "B1 - Install Striping and Signage",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 48,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1080"
    },
    {
      id: "800693c0-a45e-457e-bf71-b66ff94bdaf2",
      text: "FR 10 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "207d8eec-4e49-43ad-8f43-1e6990c9645f",
      progress: 1,
      source_task_id: "FR.10.1030"
    },
    {
      id: "2d33af29-1e4e-4310-ac3d-148b228c2e32",
      text: "FR 02 - Additional Civil Permit Review Time - City Review Response & Send Additional Comments",
      type: 0,
      start_date: "2024-05-06T00:00:00",
      end_date: "2024-06-05T08:00:00",
      duration: 176,
      parent: "f5cede49-5629-40ad-881c-25df81197815",
      progress: 1,
      source_task_id: "FR.02.1020"
    },
    {
      id: "3ef3a8ad-fe77-4692-b68b-99b20cbdddac",
      text: "Area 5 - UG RI -Low Voltage Electric Transmission (Branch)-SSB2",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1910"
    },
    {
      id: "4dbf8682-7b49-4bd8-875b-912c9a62186c",
      text: "B1 - DH-C - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-10-16T08:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 0,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2100"
    },
    {
      id: "7e52e785-c4af-4414-bc14-09a437907568",
      text: "(CFCI) Div. 09 - Epoxy  Flooring",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-12T08:00:00",
      duration: 400,
      parent: "88a16a24-d160-4e00-8516-9659424e2d90",
      progress: 0,
      source_task_id: "7994883"
    },
    {
      id: "0271206d-5a22-406a-a263-8c44b715c4b2",
      text: "B1 - SSB - Install Underground Security",
      type: 0,
      start_date: "2025-02-20T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 64,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1180"
    },
    {
      id: "38310a33-cfc7-4ad9-9a8b-2c1e522cc6fb",
      text: "IBOS - Fabricate / Deliver - Cable Tray",
      type: 0,
      start_date: "2024-11-07T00:00:00",
      end_date: "2025-01-02T08:00:00",
      duration: 640,
      parent: "c95dcc31-539f-443e-987b-e84c0c944d47",
      progress: 0,
      source_task_id: "IBOS.PROC.1010"
    },
    {
      id: "1b775b3f-8d0b-4287-aecf-b2ab308e9682",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1330"
    },
    {
      id: "1aa8e7a1-f494-4b81-b1bf-7015a66751ac",
      text: "B2 - DH-C - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 120,
      parent: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      progress: 0,
      source_task_id: "B2.C.STR.2190"
    },
    {
      id: "8f7731d7-1369-4c8b-a29f-5b018d12f8a1",
      text: "Fab and Deliver - RSB - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-23T08:00:00",
      duration: 2904,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.46,
      source_task_id: "B1.OFCI.2730"
    },
    {
      id: "c30f91bc-ed7f-4254-bee4-7401d4256a49",
      text: "Trade Partners (Electrical) Organize for VDC Kick-Off Meeting",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2024-04-26T08:00:00",
      duration: 40,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC22.1070"
    },
    {
      id: "e72f0194-c429-4f01-9356-19b7cc7a656b",
      text: "Substation-1 - Pull and Term Substation to MSG Building 1 A/C (Pull to Vaults) - Sequence 1",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 160,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2970"
    },
    {
      id: "1f73dc1e-53be-4d7a-aba4-9bca5bef8348",
      text: "B2 - SSB - 2E1 - Common - Point-Up Drywall",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 64,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1370"
    },
    {
      id: "427155f2-1f60-4004-9a69-be93e1f75748",
      text: "B1 - SSB - 1E2 - EF2 - Hang/Tape/Finish Drywall (EF2)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 48,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1610"
    },
    {
      id: "9c681767-7187-47cf-aac5-d8e72754cfae",
      text: "Substation-1 Transformer B Work",
      type: 5,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 928,
      parent: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      progress: 0,
      source_task_id: "7995237"
    },
    {
      id: "e6e62278-46d6-47d4-a4a2-12cd38e02a62",
      text: "Establish cost and schedule benchmarks for use of MOFE elements",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 416,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1310"
    },
    {
      id: "c2b1334a-5735-4fad-9236-ab5c0b28e4d3",
      text: "FR 22 - META review and Approve PCO#18",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "6b393e4a-958e-4ac9-bb16-32b3eacbeb11",
      progress: 0,
      source_task_id: "FR.22.1020"
    },
    {
      id: "6523acc1-0f9e-4214-8b2a-33f7210378a0",
      text: "Battery Monitoring & Diagnostic System - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2023-12-21T00:00:00",
      duration: 0,
      parent: "4bef5be0-b299-4faa-b366-fd0ba2a8ee98",
      progress: 1,
      source_task_id: "B1.OFCI.1380"
    },
    {
      id: "95945817-0690-41e2-8250-61def180102c",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1360"
    },
    {
      id: "e1237eb4-0de7-484d-85b8-9442d86a46b0",
      text: "Fab and Deliver - MVS-5WAY - Area C (2) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-04-21T08:00:00",
      duration: 2368,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0,
      source_task_id: "B1.OFCI.2550"
    },
    {
      id: "d3227ab1-a793-4b42-9587-e31ab9a6c991",
      text: "B1 - DH-D - Install Tech Water - Data Hall D",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1170"
    },
    {
      id: "d4cd48a2-e19f-4769-a609-b2c6dc1dd633",
      text: "B1 - DH-C - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 120,
      parent: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      progress: 0,
      source_task_id: "B1.C.STR.2310"
    },
    {
      id: "8dfdc9bd-40e1-45b4-b960-4270525057fd",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1500"
    },
    {
      id: "b2e53f57-6b31-4f4a-967e-b356ac799b79",
      text: "B1 - mCUP-7 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 16,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7010"
    },
    {
      id: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      text: "BLDG-1 DH-D ElectricalTerms",
      type: 5,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 376,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "7995264"
    },
    {
      id: "29c9ed05-47ea-40d5-9471-6283cc2ffeb1",
      text: "Tier 1 - B1-1-C - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994795"
    },
    {
      id: "abd622c8-97bd-48f6-a36d-9a080507f82d",
      text: "B1 - Network Room 1/4 - FCA Gallery - Facilty Water Install - [06.MTR-19-01,03,05,07] - [06.MTR-20-01,03,05,07]",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 96,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1360"
    },
    {
      id: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f",
      text: "Commissioning - Admin - Level 4 + 5",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 40,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1120"
    },
    {
      id: "b4b05e12-c2ba-4c52-8723-03cc3396236b",
      text: "B1 - SSB - 1E1 - Common - Install Devices in Tile/OH Electrical",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2130"
    },
    {
      id: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      text: "BLDG-1 DH-C Electrical Pulls",
      type: 5,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 400,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "7995262"
    },
    {
      id: "ec91474a-d4e9-4b87-b4a6-54f55adde5d3",
      text: "B1 - DH-D - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-04-09T00:00:00",
      end_date: "2025-04-19T08:00:00",
      duration: 80,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1680"
    },
    {
      id: "b0ef15aa-ea07-40e9-87b7-c72c0b2482af",
      text: "DFSMA - DC1 - CUP 5- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-08-04T08:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1270"
    },
    {
      id: "d7744250-088c-49da-926f-6abe9af37939",
      text: "Weather/Construction Bank - Bldg 2 C & D S/C Fdn st (2) to L3 start + 5 days for Cx (Original 38 - 5 = 33)",
      type: 0,
      start_date: "2027-03-31T00:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 304,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX2.DHD.WB.0020"
    },
    {
      id: "4b18be79-bf32-452c-a06b-f260d38ba0e4",
      text: "B2 - DH-D - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 80,
      parent: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      progress: 0,
      source_task_id: "B2.C.STR.2180"
    },
    {
      id: "3ab62672-558c-434f-94c4-12c6de5d0a35",
      text: "FR 08 - META/ EOR Review and answer RFI#51",
      type: 0,
      start_date: "2024-07-24T00:00:00",
      end_date: null,
      duration: 96,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 1,
      source_task_id: "FR.08.1020"
    },
    {
      id: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      text: "B1 - DH-C - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1020"
    },
    {
      id: "e396cca1-6af6-48f7-a664-99db5e2f9718",
      text: "Area 1 - Fire Water Install",
      type: 0,
      start_date: "2024-10-15T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 168,
      parent: "a893b11a-9b41-49b4-af57-f4810ebf888c",
      progress: 0,
      source_task_id: "C.CSU.A1.4000"
    },
    {
      id: "6d9a179c-138d-41ae-8419-5346393de16e",
      text: "B2 - DH-B - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 0,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2010"
    },
    {
      id: "80536356-cae6-49dc-990c-8963343d17d1",
      text: "Start DCB2  EY2 MVS and PTX Equipment Pad Placement",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-04T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1455"
    },
    {
      id: "b42b685a-9160-415a-8bd2-0f1009adfcc7",
      text: "B2 - mCUP-5 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5070"
    },
    {
      id: "c426d973-b4ff-44ee-998f-d05595eda66e",
      text: "Campus Site Utilities - Area 5",
      type: 5,
      start_date: "2024-07-29T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 1280,
      parent: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      progress: 0,
      source_task_id: "7995190"
    },
    {
      id: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec",
      text: "B1 - DH-D - L2 CDU Pre-Eng Inspection - Data Hall D",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 144,
      parent: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      progress: 0,
      source_task_id: "B1.C.D.3135"
    },
    {
      id: "0484875e-d4b7-4d26-87c0-4d809c9f0beb",
      text: "FR 20 - META review and Approve PCO#16",
      type: 0,
      start_date: "2024-11-20T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 80,
      parent: "a464ca61-32ce-4bd2-8aa4-8f60eccf8e8c",
      progress: 0,
      source_task_id: "FR.20.1030"
    },
    {
      id: "159ec191-4048-4d6b-8cba-2bc768d29399",
      text: "B1 - mCUP-1 - Set Electrical Equipment (MVS PTX MSB) + IWM PTX",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 16,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1200"
    },
    {
      id: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      text: "(OFCI) B2 PTX",
      type: 5,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 3040,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.43,
      source_task_id: "7994949"
    },
    {
      id: "60156f69-4668-4fde-837d-f44706e6da8d",
      text: "B1 - 1N2E - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 160,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5690"
    },
    {
      id: "6787b5a8-5d6c-421d-8ee5-f53996f7e8f3",
      text: "FR 31 - DPR Prepare and Submit PCO#30",
      type: 0,
      start_date: "2024-08-07T00:00:00",
      end_date: null,
      duration: 496,
      parent: "955aa671-6b4b-4034-bf88-d03902dbaf4e",
      progress: 0.5,
      source_task_id: "FR.31.1020"
    },
    {
      id: "fd64bc2b-7a87-4d34-9274-f7eb64ec7976",
      text: "B1 - 1N1E - 01N4.06 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.5810"
    },
    {
      id: "92890cee-b82f-47a3-8277-5ccaddb10542",
      text: "B1 - 1D2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 24,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2230"
    },
    {
      id: "9cb17e9b-51fa-45d2-9139-54242a98c283",
      text: "Substation 2 - Prep / Submit for Rvw - H-Frame Deadend",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-09-30T08:00:00",
      duration: 160,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5740"
    },
    {
      id: "e5763380-a411-4792-baed-3b3531818bac",
      text: "B2 - DH-C - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2026-04-02T08:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 0,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1840"
    },
    {
      id: "77c4844a-c255-45cd-9202-0a96fb3fd488",
      text: "Area B - OH Mechanical",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 80,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1190"
    },
    {
      id: "fa13b8e5-c32e-4214-a2d6-d4fc53ba0540",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1540"
    },
    {
      id: "e1b04186-76b7-44f4-bacd-4c5523139381",
      text: "B2 - 2E1E - 02.01.E1.05 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 144,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5460"
    },
    {
      id: "bbcf3199-391e-4ffa-8d07-35ec06c401bf",
      text: "BLDG-2 - BIM - Tier 1 - Area 2-C - Coordination / Sign-off",
      type: 0,
      start_date: "2025-05-13T00:00:00",
      end_date: "2025-06-03T08:00:00",
      duration: 240,
      parent: "2937029d-cba7-4fda-9df6-f78e0ca56c95",
      progress: 0,
      source_task_id: "B2.VDC.3150"
    },
    {
      id: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      text: "(CFCI) Div. 05 - Anchor Bolt Delivery B1",
      type: 5,
      start_date: "2024-10-24T00:00:00",
      end_date: "2025-01-22T08:00:00",
      duration: 1040,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0,
      source_task_id: "7994926"
    },
    {
      id: "08f864e1-e348-44d3-b572-20c9a0dcf496",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-11T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1990"
    },
    {
      id: "3c770400-513d-4113-ae9a-5b8161608f3f",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1490"
    },
    {
      id: "1265476e-f63d-4d25-a4c1-20b3aa6bb9d1",
      text: "B1 - 1D1W - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1730"
    },
    {
      id: "381800b6-6b73-4510-96a3-aadd9d35b418",
      text: "Delivery of m-CUP Skids (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-03-11T08:00:00",
      end_date: "2025-03-11T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1875"
    },
    {
      id: "dbfcb2a2-ca21-4281-882c-d69d430ba0d2",
      text: "B1 - 1D1W - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1770"
    },
    {
      id: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      text: "Electrical / IDF Room",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 760,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "8243673"
    },
    {
      id: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      text: "Area 3 - Telecom Install - Remaining (Includes CAV1 & CAV4)",
      type: 0,
      start_date: "2025-03-06T00:00:00",
      end_date: "2025-04-09T08:00:00",
      duration: 240,
      parent: "8609b6ff-9850-48d0-a7d4-8aefeb103cfe",
      progress: 0,
      source_task_id: "C.CSU.A4.8000"
    },
    {
      id: "7a49a70e-9086-46bc-9ccb-172317c9ab06",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2110"
    },
    {
      id: "27ffdbe0-f93d-4d92-b751-e132f812d54a",
      text: "IBOS - Submittal Rvw/App'l  - MSB Procurement",
      type: 0,
      start_date: "2024-08-30T00:00:00",
      end_date: "2024-09-06T00:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1140"
    },
    {
      id: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      text: "BLDG-1 DH-B ElectricalTerms",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 472,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "7995252"
    },
    {
      id: "c2c788be-70d3-4d6d-baf9-69443a81e769",
      text: "Assembled Skids - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 1,
      source_task_id: "B1.OFCI.1350"
    },
    {
      id: "778f5620-57d9-4756-a30b-6519f6c05951",
      text: "B2 - DH-A - Install Lighting/Branch Conduit -Data Hall A",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2470"
    },
    {
      id: "738956b2-7ec9-49dd-8b14-1ef1ad85636c",
      text: "Area A - Install Interior Signage",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1321"
    },
    {
      id: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      text: "BLDG-1 Network",
      type: 5,
      start_date: "2025-05-10T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 672,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995385"
    },
    {
      id: "99cb7f54-093d-46c0-892b-d5a3ef6857b2",
      text: "Fab and Deliver - MVS-3WAY - Area CUP (10) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 2416,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.1,
      source_task_id: "B1.OFCI.1990"
    },
    {
      id: "86aacc13-abda-4617-989d-90f786abb89d",
      text: "B1 - 1N2W - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1880"
    },
    {
      id: "3d7b1217-fbe3-4f4e-bcb4-2c5dfa1b29ec",
      text: "B2 - 2B2 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1170"
    },
    {
      id: "870f2979-608f-4349-94c0-af2a81850811",
      text: "B2 - mCUP-7 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 80,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.8220"
    },
    {
      id: "fbd37e7f-c1c0-43f1-b4cd-6bf1e400a5e6",
      text: "B2 - 2B2 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1190"
    },
    {
      id: "778cfbc4-154f-4404-9b73-054b2f2b9b33",
      text: "B1 - Network Room 2/3 - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 136,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1650"
    },
    {
      id: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1020"
    },
    {
      id: "5cfca804-e520-462a-a199-24132a727ac0",
      text: "Specialty Doors and Dock Levelers - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5920"
    },
    {
      id: "30f6b105-c0b5-4140-89e3-b84628231b02",
      text: "Building 2 mCUP-5",
      type: 5,
      start_date: "2025-10-28T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 480,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995143"
    },
    {
      id: "bee12360-17d8-4446-94ed-e7581796899b",
      text: "Fab and Deliver - Substation HPD - Area SS-2 (2) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-12-31T08:00:00",
      duration: 1768,
      parent: "862ebf7a-ac0e-4164-ba6f-7343140eb5ad",
      progress: 0.62,
      source_task_id: "B2.OFCI.2085"
    },
    {
      id: "86e9e056-534c-413b-ac1e-8ce36d596426",
      text: "Project Review Design Package (for Estimate Development) Delivered",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-10-23T00:00:00",
      duration: 0,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 1,
      source_task_id: "PRE-DP-1140"
    },
    {
      id: "708fe5f6-29a5-4972-b644-5e551f18e445",
      text: "B2 - SSB - 2E2 - Common - Install Carpet",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1900"
    },
    {
      id: "eaf9181d-9fa3-42c3-b52e-b917fc16c77f",
      text: "Area 3 - Install water meters",
      type: 0,
      start_date: "2025-04-10T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8110"
    },
    {
      id: "290eb132-b609-43c0-8c0f-432a084001e6",
      text: "B1 - 1D1W - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1690"
    },
    {
      id: "27154e49-b6fa-42a1-a75c-2c5f068ce6a8",
      text: "B1 - 1N1E - EF4 - Build Wall Between MDF/Fiber Entry and Carrier (EF4)",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 48,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5310"
    },
    {
      id: "0fdadd2b-5941-4ea5-91aa-d83048b8ea2d",
      text: "Final Clean",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 24,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1110"
    },
    {
      id: "2ee68109-f6ac-41c2-8f50-2158190daf83",
      text: "FR 18 - META review and Approve PCO#14",
      type: 0,
      start_date: "2024-11-20T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 80,
      parent: "ae1767c4-d36b-4241-8891-8fc1b5eca613",
      progress: 0,
      source_task_id: "FR.18.1030"
    },
    {
      id: "cbc278bf-e7b8-4a81-a55f-e07bc474745c",
      text: "B2 - 2D1W - 02D.09 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-07-16T00:00:00",
      end_date: "2026-07-22T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.2440"
    },
    {
      id: "099443ef-a38c-420e-995b-ae14080d002b",
      text: "FR 19 - DPR Prepare and Submit PCO#15",
      type: 0,
      start_date: "2024-09-13T00:00:00",
      end_date: null,
      duration: 216,
      parent: "9f9f89a7-c1ad-40cc-9316-7639d5b9a211",
      progress: 1,
      source_task_id: "FR.19.1020"
    },
    {
      id: "7a9612f2-5aa3-4f81-a5f5-5288bb093469",
      text: "Fab and Deliver - Load Bank - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "2c21e476-2412-4ed5-8c8a-27650481107d",
      progress: 0.29,
      source_task_id: "B1.OFCI.2270"
    },
    {
      id: "52ac4f47-3c08-4052-acad-659841dd549a",
      text: "B2 - 2E1E - EF3 - Terms for Lighting/Outlet/Racks (EF3)",
      type: 0,
      start_date: "2026-01-21T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 24,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5330"
    },
    {
      id: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      text: "L3 - B1 EY 1 NS/ A *On Temp Power*",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 80,
      parent: "b4e5a005-102e-4fbf-949a-1ed89d200a5c",
      progress: 0,
      source_task_id: "CX3.B1.MSG.1010"
    },
    {
      id: "89185f34-f941-4475-96ee-5f6094686dee",
      text: "Fab and Deliver - Control Power STC/SB - Area D - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 0.38,
      source_task_id: "B2.OFCI.2530"
    },
    {
      id: "95524127-d258-468f-bf0c-270ee743c7b2",
      text: "Critical Early Release Utilities",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-05-03T08:00:00",
      duration: 280,
      parent: "4154f35b-b33f-42f4-b0f4-5f1117171117",
      progress: 1,
      source_task_id: "7994759"
    },
    {
      id: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      text: "B1 - 1N2W - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1400"
    },
    {
      id: "81faa7d5-b271-463e-b720-973127863311",
      text: "B1 - DH-C - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 80,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1150"
    },
    {
      id: "184e59ce-654c-43a4-8af4-d60a90201b0e",
      text: "Adverse Weather Event 13 - 10.2.2024 (Hurricane Helene)",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1013"
    },
    {
      id: "2125dffd-eb96-4124-881d-893a6efb78d8",
      text: "B2 - 2E1E - 02.01.E1.01 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 144,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5480"
    },
    {
      id: "94c73420-8b4d-48ab-98c0-a37d2190ed38",
      text: "B1 - Network Room 1/4 - Power Alley - Install Light Fixtures/Exit Signs/GS Tray",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 96,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1860"
    },
    {
      id: "0f01a47d-dbfd-4190-876d-d5a6e6009d24",
      text: "FR 08 - Area 3 - Telecom Install - Concrete Scope",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 328,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A3.8050"
    },
    {
      id: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      text: "(OFCI) B2 Main Switchboards MSB/RSB",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3808,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.38,
      source_task_id: "7994959"
    },
    {
      id: "66a8db73-01b3-4dc0-a370-a4954cd2aff5",
      text: "B2 - SSB - 2E2 - Common - Install Fire Extinguishers/FECs",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 32,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1860"
    },
    {
      id: "c5380e45-419e-43ca-afde-66329fefc326",
      text: "BLDG-1/2 - Coordinate Scope and Submittal Req's - Vesda System",
      type: 0,
      start_date: "2024-10-23T00:00:00",
      end_date: "2024-10-23T00:00:00",
      duration: 8,
      parent: "3e0c2709-f6dd-4154-90ac-684cc2b77033",
      progress: 0,
      source_task_id: "B1.CFCI.3190"
    },
    {
      id: "df07a5bd-4110-44ee-9bec-2d86c528f2f5",
      text: "L4 Finish Guard House/Fire Pump House - DCB1",
      type: 0,
      start_date: "2025-12-02T08:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2037"
    },
    {
      id: "e345c5fa-0105-4db8-9bb0-8f97b19d1832",
      text: "FR 25 - DPR Prepare and Submit PCO#22",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: null,
      duration: 272,
      parent: "1ac29f4d-573b-42c4-b1bb-fe67a376ad74",
      progress: 0.5,
      source_task_id: "FR.25.1010"
    },
    {
      id: "cee57e06-8220-46f4-bf48-e8124ce9e922",
      text: "MOFE-OFCI-CFCI",
      type: 5,
      start_date: "2023-09-08T08:00:00",
      end_date: "2026-05-05T08:00:00",
      duration: 5344,
      parent: "5b0c7f62-d6b7-4c27-a219-7ab78c02b3ce",
      progress: 0.22,
      source_task_id: "7994818"
    },
    {
      id: "916f6428-167e-48fa-ad3d-b588500f6de3",
      text: "Substation-1 - B Lineup - MOAB Assembly / inspections",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-06T08:00:00",
      duration: 24,
      parent: "40a947ea-b2c2-46a6-a512-b24f940e157e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6280"
    },
    {
      id: "4f305649-165c-4d5b-9b13-7ce7d5ae2862",
      text: "B2 - DH-C - Install Celing Devices Security - Data Hall C",
      type: 0,
      start_date: "2026-06-15T00:00:00",
      end_date: "2026-07-13T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2590"
    },
    {
      id: "68a8d25d-3804-4628-8a6c-2155632ed6e1",
      text: "B2 - DH-C - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1600"
    },
    {
      id: "448fc2db-762d-4877-a80c-8067caceddb7",
      text: "FR 40 - Miller recoordinate feeds PTX to RSB and RSB to RB",
      type: 0,
      start_date: "2024-11-20T00:00:00",
      end_date: null,
      duration: 80,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1040"
    },
    {
      id: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa",
      text: "B1 - DH-A - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-02-24T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 120,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1190"
    },
    {
      id: "ddd25096-11f7-4bde-bdba-86892e987ce6",
      text: "B1 - DH-A - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 120,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1020"
    },
    {
      id: "ea84c061-1b01-4ab2-a0c0-3c77acd34fb5",
      text: "B1 - DH-A - Wall build/Rough In/ OH Rough (Converted to LOE) (8/20 - add - Elec OH Roughin)",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 240,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1030"
    },
    {
      id: "28756360-db55-43cc-b1d2-cb7f1ca84032",
      text: "B1 - mCUP-5 - Install Electrical /  Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5100"
    },
    {
      id: "f278a494-c8a8-47e0-bde3-877dc8157ea1",
      text: "B2 - 2A1 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 8,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1380"
    },
    {
      id: "8b06721e-38fc-4077-94f2-b279fd998184",
      text: "Fab and Deliver - Control Power STC/SB - Area A - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 0.35,
      source_task_id: "B2.OFCI.2510"
    },
    {
      id: "192ac6d3-7f7c-4716-b8f9-b58bd3a44b17",
      text: "B1 - mCUP-7-9 - Electrical Equipment Pulls/Terms for C/D Data Halls",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 80,
      parent: "0030099f-bbea-4b45-9ffb-9bcfe33c7559",
      progress: 0,
      source_task_id: "B1.mCUP.9190"
    },
    {
      id: "abb1ce78-a034-4016-b693-11a6ada2d524",
      text: "B2 - 2E1E - EF4 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF4)",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 8,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5360"
    },
    {
      id: "2565428a-6ee7-458e-908e-f44e5acdfea4",
      text: "Fab and Deliver - PLC Panels - Area C - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2832,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.34,
      source_task_id: "B1.OFCI.3170"
    },
    {
      id: "c3921b42-f753-4731-8f7b-a092cb5b752f",
      text: "B1 - DH-D - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 40,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1040"
    },
    {
      id: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      text: "Campus Site Utilities - Area 2",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-12-11T08:00:00",
      duration: 1368,
      parent: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      progress: 0.21,
      source_task_id: "7995163"
    },
    {
      id: "8be250bd-0710-4348-a24f-3f6f4b0b01c5",
      text: "B2 - DH-A - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 80,
      parent: "af73992b-f173-45bc-944e-dd449681c36e",
      progress: 0,
      source_task_id: "B2.C.EY.1310"
    },
    {
      id: "fcb8f6d0-2e92-47a0-b84b-c98e0d6f5255",
      text: "Fab and Deliver - MVS-4WAY - Area D (6) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 2448,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0,
      source_task_id: "B1.OFCI.2580"
    },
    {
      id: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      text: "MEP Procurement",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-04-01T00:00:00",
      duration: 272,
      parent: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      progress: 1,
      source_task_id: "7994736"
    },
    {
      id: "036e62a3-2215-42ac-ab9f-8126cfca2605",
      text: "Area 4 - Set Water Meter pads",
      type: 0,
      start_date: "2025-01-24T00:00:00",
      end_date: "2025-01-30T08:00:00",
      duration: 48,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A4.8100"
    },
    {
      id: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1",
      text: "[DCB1] DEC-C Ready: General Services [GS-CORE]",
      type: 0,
      start_date: "2025-08-26T08:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3707"
    },
    {
      id: "fbbb176d-f550-48ec-9980-38b65c1ebf17",
      text: "B2 - DH-A - Foundations",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 120,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1050"
    },
    {
      id: "e21651d2-5526-4800-b839-ade26384fabd",
      text: "BLDG-1/2 - (SPW - Div 07) Fabricate / Deliver - Below Grade Waterproofing",
      type: 0,
      start_date: "2024-11-20T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 80,
      parent: "7bb51d4c-8179-4d67-b199-7fb7f7af2db9",
      progress: 0,
      source_task_id: "B1.CFCI.4490"
    },
    {
      id: "48765d17-c558-484e-9b2c-d26c1754da21",
      text: "B1 - DH-A - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1570"
    },
    {
      id: "a3d46ce7-d3a0-4bc9-9451-b0d47dee01ad",
      text: "B2 - DH-A - Hookup FCAs Mechanical - Data Hall A",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2110"
    },
    {
      id: "f2aa2826-cd17-400e-a8c7-ff9b8f7719d2",
      text: "IBOS - Submittal Rvw/App'l - Lighting (Resubmittal)",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1060"
    },
    {
      id: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      text: "B1 - Network - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 40,
      parent: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      progress: 0,
      source_task_id: "B1.C.EY.1080"
    },
    {
      id: "6600c781-1202-481e-a52b-35cd0964ff47",
      text: "B1 - DH-B - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-17T08:00:00",
      duration: 40,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1160"
    },
    {
      id: "8add8f37-6016-4f1b-9c23-56d20d4278ab",
      text: "B1 - 1N1E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 40,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6170"
    },
    {
      id: "665be56c-ca32-41f1-b063-d66cc299b54d",
      text: "Substation-1 - MSG B - Set / Temp Dry In / Temp Power / Site Acceptance Inspection",
      type: 0,
      start_date: "2025-04-10T00:00:00",
      end_date: "2025-04-26T08:00:00",
      duration: 120,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3540"
    },
    {
      id: "7fe3a5d1-a6b7-41c5-83a0-318c9b9a3548",
      text: "Corridor 2B1 (Spr Riser Rm/Control Rm/GS IDF (2)",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 976,
      parent: "7fb33c35-1204-4516-b5fc-1de04cad777e",
      progress: 0,
      source_task_id: "7995075"
    },
    {
      id: "583c034a-1e6c-49c5-aad2-01bf4f1a4ef8",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1720"
    },
    {
      id: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      text: "PLC Panels - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 0,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 1,
      source_task_id: "B2.OFCI.1030"
    },
    {
      id: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1",
      text: "Substation-2 - Equipment Hookup's Utility Provider (Overhead from utitlity provider substation)",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 1280,
      parent: "164cb27d-1630-4aff-a06d-f1118a0a3eaf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.1280"
    },
    {
      id: "e39e0caa-4646-479c-addc-9d76559930d1",
      text: "Fab and Deliver - PLC Panels - Area D - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 3840,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.13,
      source_task_id: "B2.OFCI.1860"
    },
    {
      id: "922804f8-a04a-40b3-bfcd-4bf5e405444e",
      text: "B2 - 2E2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-02-24T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 120,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6400"
    },
    {
      id: "1c91e76e-71e6-4fc1-8749-69745656f328",
      text: "B2 - 2E2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-12-26T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 8,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6100"
    },
    {
      id: "fa98095d-1b81-4c23-ae9f-f333318f61bd",
      text: "B1 - DH-A - Install Grounding Loop - Data Hall A",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2720"
    },
    {
      id: "027986da-b91b-4966-b05d-799746e9d87e",
      text: "Fab and Deliver - Busway Kits - Area C - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2026-02-13T08:00:00",
      duration: 4360,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 0.21,
      source_task_id: "B2.OFCI.2080"
    },
    {
      id: "40893fd5-64b3-4680-b21f-bcca4f48556f",
      text: "B2 - SSB - 2E2 - Common - Install Bathroom Accessories",
      type: 0,
      start_date: "2026-03-31T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1840"
    },
    {
      id: "7b9f2e35-6250-4b0b-b5f3-9154f898ae59",
      text: "Install FRP",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1230"
    },
    {
      id: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      text: "B1 - mCUP-7 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7040"
    },
    {
      id: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      text: "B2 - 2C1 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 24,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1650"
    },
    {
      id: "07a429d0-1de6-448a-9879-487c9e533b55",
      text: "B1 - 1C1W - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 24,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1000"
    },
    {
      id: "f9ef39e8-35d8-4eab-b012-8a6bb80cb891",
      text: "OH Mechanical",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1130"
    },
    {
      id: "5ec5385f-7785-4fbb-82c6-06e1066ff1ed",
      text: "B1 - mCUP-7 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7050"
    },
    {
      id: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 360,
      parent: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      progress: 0,
      source_task_id: "7995098"
    },
    {
      id: "c14b6681-79e2-4d8f-8396-984000dfb685",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 120,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2110"
    },
    {
      id: "b00d2f59-7dc1-4917-adc6-a8c0bd5643c9",
      text: "B2 - Heavy Duty Course Paving",
      type: 0,
      start_date: "2025-06-05T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 40,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1120"
    },
    {
      id: "6e546e18-f5eb-43bc-9a15-f1c17a8bddc1",
      text: "FR 34 - META review and respond to RFI #212",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: null,
      duration: 0,
      parent: "883427a6-7812-434c-b7bc-0738a53a7b23",
      progress: 1,
      source_task_id: "FR.34.1010"
    },
    {
      id: "05726f27-0840-4b3c-be5a-5c1b8cb2930d",
      text: "Miller activities",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 880,
      parent: null,
      progress: 0,
      source_task_id: "8443468"
    },
    {
      id: "1d174025-b93d-437c-a8b7-faa7f7c2712e",
      text: "B2 - DH-A - Install Tech Water - Data Hall A",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2310"
    },
    {
      id: "720e9207-a7b5-48b5-bb85-5ab844c17046",
      text: "MV Electric",
      type: 5,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 232,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995160"
    },
    {
      id: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 160,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1870"
    },
    {
      id: "1f96de7a-a7a5-46cd-b42e-26be905753da",
      text: "B1 - 1C2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1980"
    },
    {
      id: "97578135-02af-4f93-93b3-0a084a6773f8",
      text: "Fab and Deliver - Busway Kits - Area A - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2824,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.21,
      source_task_id: "B1.OFCI.3370"
    },
    {
      id: "3061931f-5b71-4e5f-896e-e8449c7c7d65",
      text: "FR 20 - DPR / EOR review the Changes",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 304,
      parent: "a464ca61-32ce-4bd2-8aa4-8f60eccf8e8c",
      progress: 0,
      source_task_id: "FR.20.1010"
    },
    {
      id: "590f4ffc-b101-4f2f-8ce9-db8cb02679f7",
      text: "Busway - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 1,
      source_task_id: "B2.OFCI.1310"
    },
    {
      id: "bfdeab33-e791-4d9d-82c5-afe1292f3f19",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2590"
    },
    {
      id: "7720d7e1-a2ff-4456-87f4-fab63c5f2483",
      text: "B1 - DH-B - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 24,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1630"
    },
    {
      id: "0a9c04a2-f15b-4ebe-bae3-51a13b15b255",
      text: "Ansul System Pre-Test",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1330"
    },
    {
      id: "88a16a24-d160-4e00-8516-9659424e2d90",
      text: "(CFCI) Div. 09 - Finishes",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 1720,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994875"
    },
    {
      id: "44ea152d-6915-4b4a-848a-9f905fb08eb8",
      text: "B2 - DH-A - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 120,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1740"
    },
    {
      id: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2580"
    },
    {
      id: "75d436dd-74fe-4150-bb06-5bde0dff116c",
      text: "B2 - DH-D - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-05-27T08:00:00",
      duration: 40,
      parent: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      progress: 0,
      source_task_id: "B2.C.EY.1740"
    },
    {
      id: "bf25da74-e75e-41e4-a191-e5d5ece7a181",
      text: "Utility Water Available",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-05-28T00:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 1,
      source_task_id: "ICM.B1.4150"
    },
    {
      id: "ad9bcc69-2423-47a9-879e-e48510c33ecb",
      text: "Substation-1 A Lineup Vertical Work",
      type: 5,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 288,
      parent: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      progress: 0,
      source_task_id: "7995239"
    },
    {
      id: "f2690989-2ad5-4c11-9291-a12049f93277",
      text: "B2 - DH-C - Install Lighting/Branch Conduit -Data Hall C",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2280"
    },
    {
      id: "108fbfb6-c254-40d2-ba53-0f8e6b1feaf4",
      text: "PTX Pull & Term - Line side",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.SI.1050"
    },
    {
      id: "d36283d5-6b98-441f-9a29-0e88634ff546",
      text: "B2 - mCUP-6 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6110"
    },
    {
      id: "a18c735e-d5fc-4285-b70f-9bbd9fb3fe96",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1210"
    },
    {
      id: "da003499-08ce-4ed3-af01-8e22dae83772",
      text: "B2 - DH-D - Install Ceiling Tiles - Data Hall D",
      type: 0,
      start_date: "2026-09-01T00:00:00",
      end_date: "2026-09-08T08:00:00",
      duration: 40,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2630"
    },
    {
      id: "3bc94985-dfed-40e6-894a-2c8f749bc085",
      text: "Fab and Deliver - MVS-4WAY - Area D (10) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 2840,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.42,
      source_task_id: "B2.OFCI.2030"
    },
    {
      id: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec",
      text: "B2 - OSP Cabling - B1 EF1, EF2, EF3, EF4 to B2 BEV-5,6,7,8",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 120,
      parent: "48b3b449-97e1-4e8d-96ff-da2222ec41de",
      progress: 0,
      source_task_id: "B1.CONN.1330"
    },
    {
      id: "0837c3ef-b364-41b9-a488-3d5ffab577cc",
      text: "BLDG-1 - BIM - Tier 2-4 - iBOS - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-10-02T08:00:00",
      duration: 240,
      parent: "17f7bc24-cabe-4894-87dd-c247c97c43ef",
      progress: 0,
      source_task_id: "B1.VDC.1720"
    },
    {
      id: "57a8a90f-c088-460f-9f45-ee695c3faf7a",
      text: "B1 - SSB - 1E1 - Common - Complete Interior Build-Out (DEC-C Ready)",
      type: 0,
      start_date: "2025-12-04T08:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 0,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2500"
    },
    {
      id: "e62985ef-ff43-4812-b7c0-b9605c6775dd",
      text: "B2 - DH-A - Pull/Term Fire Alarm - Data Hall A",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2560"
    },
    {
      id: "c60c5278-1433-4174-9598-486d74d53204",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1330"
    },
    {
      id: "140b24cb-3cdd-4e30-a0ca-f8e9af1b9247",
      text: "BLDG-1/2 -  Fabricate / Deliver - Strut",
      type: 0,
      start_date: "2025-04-04T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 160,
      parent: "2b6ac8b0-5614-4bfb-a6cf-fdb1f42c6160",
      progress: 0,
      source_task_id: "B1.CFCI.5340"
    },
    {
      id: "3488d7eb-3de5-4bc5-aa74-827557aafac9",
      text: "B1 - 1N2E - 01N3.06 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.5790"
    },
    {
      id: "1c22d9c7-73fc-4807-9067-e87d5b9a8017",
      text: "BLDG-1 DH-A - L2 Checkout for Building",
      type: 0,
      start_date: "2026-01-13T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 200,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1020"
    },
    {
      id: "815f44ae-e840-404c-b464-7f2586ba6d74",
      text: "ISP - B1 - Phase 2 (OH)",
      type: 5,
      start_date: "2025-11-03T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 1032,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995452"
    },
    {
      id: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      text: "B2 - ISP Cabling - IDFA to DHA (GS tray)",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-08-18T08:00:00",
      duration: 200,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1200"
    },
    {
      id: "12190209-6d4f-4ad6-9e6d-256ab675ae3e",
      text: "BLDG-2 - Area Area SSB - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 80,
      parent: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      progress: 0,
      source_task_id: "B1.CFCI.5310"
    },
    {
      id: "27e0b6b6-6cfa-42e5-baef-e08293ffa233",
      text: "B2 - DH-D - Hookup FCAs Electrical- Data Hall D",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-07T08:00:00",
      duration: 192,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2270"
    },
    {
      id: "0999498e-5331-457d-ad44-a789bbca4339",
      text: "B2 - DH-D - Rough in HAC Lighting - Data Hall D",
      type: 0,
      start_date: "2026-06-11T00:00:00",
      end_date: "2026-07-09T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2280"
    },
    {
      id: "4bd7ed7d-ef6d-4239-beb1-62e0d0e3fd80",
      text: "B2 - DH-D - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 40,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1130"
    },
    {
      id: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      text: "ISP - B1 - Phase 1 (UG and Priority)",
      type: 5,
      start_date: "2025-09-22T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 984,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995451"
    },
    {
      id: "d8aa8460-29aa-4d9b-a12b-9dac6158488a",
      text: "L3 Finish DH B - DCB2",
      type: 0,
      start_date: "2026-12-17T08:00:00",
      end_date: "2026-12-17T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2004"
    },
    {
      id: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      text: "B2 - DH-D - Install Vapor Barrier",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 40,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1230"
    },
    {
      id: "207912f4-26eb-4930-8525-f8087ab8d1a4",
      text: "B2 - DH-B - Install Sprinkler Mains",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 40,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1440"
    },
    {
      id: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      text: "Permits",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-09-03T08:00:00",
      duration: 952,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 0.62,
      source_task_id: "7994746"
    },
    {
      id: "2c8b47e3-5872-46f5-8d95-7bd87fb59a37",
      text: "B2 - 2B1 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 24,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1920"
    },
    {
      id: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db",
      text: "L3 - B2 SSB",
      type: 0,
      start_date: "2026-09-01T00:00:00",
      end_date: "2026-09-29T08:00:00",
      duration: 160,
      parent: "c43469b5-604f-43d2-a57c-6ea44c4b7184",
      progress: 0,
      source_task_id: "CX3.B2.SSB.1000"
    },
    {
      id: "e711134d-8fc9-4c96-bd33-08148f81eb44",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [4] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 2904,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.33,
      source_task_id: "B1.OFCI.3670"
    },
    {
      id: "9de23734-57e7-4283-a531-2f57ac2525e9",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH D",
      type: 5,
      start_date: "2026-06-06T00:00:00",
      end_date: "2026-09-22T08:00:00",
      duration: 664,
      parent: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      progress: 0,
      source_task_id: "8106485"
    },
    {
      id: "9b36be92-3f02-4af5-909a-cd95fabc1d8c",
      text: "FR 25 - META review and Approve PCO#22",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "1ac29f4d-573b-42c4-b1bb-fe67a376ad74",
      progress: 0,
      source_task_id: "FR.25.1020"
    },
    {
      id: "669551d8-12a4-4f88-813b-aab27dcf4b63",
      text: "B2 - mCUP-7 - Set in Place Inspections",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 8,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7030"
    },
    {
      id: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      text: "MVS - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 1,
      source_task_id: "B1.OFCI.1360"
    },
    {
      id: "e075993e-e6fa-47a0-b0aa-4cc1dd5ba690",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In BMS",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1180"
    },
    {
      id: "38a275b8-5885-4a5a-917c-c853ccc68de5",
      text: "B1 - DH-C - Term Bussways - Data Hall C",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2520"
    },
    {
      id: "ac3576b3-6f4d-4c97-8b58-3fb7161d4453",
      text: "L4 Start DH A - DCB1",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-03-26T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2080"
    },
    {
      id: "2755c1fa-b5b6-4162-9aec-6620d9d55657",
      text: "BLDG-1/2 - Fabricate / Deliver -Epoxy Flooring (Spec 09 67 23)",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-02-12T08:00:00",
      duration: 120,
      parent: "7e52e785-c4af-4414-bc14-09a437907568",
      progress: 0,
      source_task_id: "B1.CFCI.5140"
    },
    {
      id: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      text: "(CFCI) Div. 26 - Substation (Permanent) H-Frame Deadend",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 880,
      parent: "bfc6e3fc-f68d-4c7b-aa41-55b6f0a76c8f",
      progress: 0,
      source_task_id: "7994872"
    },
    {
      id: "a3168fca-209e-4712-bab1-e0349ac881e8",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 24,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1770"
    },
    {
      id: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      text: "BLDG-2 SSB 2E2 Common Area Buildout",
      type: 5,
      start_date: "2025-11-11T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 1200,
      parent: "33388fbb-9d5a-4d59-bd4a-dbf183464b7b",
      progress: 0,
      source_task_id: "7995050"
    },
    {
      id: "ece97c27-0fb1-45a8-97a6-304f245f8322",
      text: "Area 4 - Sanitary Sewer Install",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-01-15T08:00:00",
      duration: 216,
      parent: "415ffe3d-5b86-4bfa-b4d2-a6bc07cd3efa",
      progress: 0,
      source_task_id: "C.CSU.A4.2000"
    },
    {
      id: "3a5be12b-d055-44f5-84b1-bc9c8a13ebdf",
      text: "UG RI -Fire Alarm-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 80,
      parent: "f4a0770e-db07-467c-95bd-9d401485c3b6",
      progress: 0,
      source_task_id: "MECO-1680.50"
    },
    {
      id: "8a5094f0-21ed-444e-8344-5cb358d522e0",
      text: "B2 - DH-B - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 40,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1250"
    },
    {
      id: "aa4329a6-5846-485a-92a9-bcc853bcb626",
      text: "OH Rough MEPF Inspections & QAQC Walks",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1270"
    },
    {
      id: "d16166cb-6e09-437a-8683-a631affd33e2",
      text: "Substation-2 - MSG B - Wire Pulls From Building MSG-1B/D",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 128,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6400"
    },
    {
      id: "586aee7e-b379-47ae-b173-bd726886c6ff",
      text: "Building 1",
      type: 5,
      start_date: "2024-06-17T00:00:00",
      end_date: "2025-03-19T08:00:00",
      duration: 1520,
      parent: "b36bc5ee-f112-4677-a654-d4337c07b419",
      progress: 0.02,
      source_task_id: "7994786"
    },
    {
      id: "d86958fa-3e33-46e0-8637-01724c1c77a4",
      text: "BLDG-1/2 - Prep / Submit for Review - Exterior Louvers (w Ext Metal Panel Trade)",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 160,
      parent: "7c2bce29-42fa-46b1-ad31-bfb1a0d53148",
      progress: 0,
      source_task_id: "B1.CFCI.3300"
    },
    {
      id: "c4fb5b42-29e6-4fc5-828d-99626e0bc5f4",
      text: "IBOS - Prep / Submit for Review - MSB Procurement",
      type: 0,
      start_date: "2024-08-01T00:00:00",
      end_date: "2024-08-30T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1130"
    },
    {
      id: "bf199754-1a16-4003-bd8b-7e4dbdbe1f7a",
      text: "B2 - DH-B - Install Underground Plumbing",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1260"
    },
    {
      id: "b4649b4d-c634-4e62-a712-26baaa6eefc3",
      text: "B1 - mCUP-6 - Set in Place Inspections",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 8,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6030"
    },
    {
      id: "6fedb5af-cbb1-4db1-b57a-5e9c3b742bdb",
      text: "FCA - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2024-01-23T08:00:00",
      duration: 40,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 1,
      source_task_id: "B1.OFCI.1690"
    },
    {
      id: "462e735c-7b86-4f89-9de6-d40632afbb2b",
      text: "Phase 1 - Remove Structures",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1010"
    },
    {
      id: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      text: "Area 2 - Sanitary Sewer Install",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-09-20T08:00:00",
      duration: 360,
      parent: "81163b8d-213a-47ce-8f82-68561568deaf",
      progress: 0,
      source_task_id: "C.CSU.A2.2000"
    },
    {
      id: "ea08ba20-7583-4401-9c98-3cb689629af6",
      text: "Hot Aisle Containment",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 712,
      parent: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      progress: 1,
      source_task_id: "PRE1540"
    },
    {
      id: "41901dd2-45be-40e3-a80a-95922259ddad",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1230"
    },
    {
      id: "d2a023dd-65be-4f84-a861-c764d89c75d4",
      text: "Non-Critical Power (NCP)",
      type: 5,
      start_date: "2024-12-28T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 96,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995162"
    },
    {
      id: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8",
      text: "L3 - B2 MSG-B",
      type: 0,
      start_date: "2026-06-03T00:00:00",
      end_date: "2026-06-09T08:00:00",
      duration: 40,
      parent: "2cea20c5-e3c2-4ea6-97b9-c8811e3bf86d",
      progress: 0,
      source_task_id: "CX3.B2.SS.1010"
    },
    {
      id: "100e1d20-7d31-4eec-a91f-fdf843704f31",
      text: "B2 - DH-C - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 80,
      parent: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      progress: 0,
      source_task_id: "B2.C.EY.1530"
    },
    {
      id: "5354ff5b-e6ce-4339-8b57-672492991239",
      text: "B1 - Network Room 1/4  - Install Cable Tray",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1560"
    },
    {
      id: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3",
      text: "B1 - Network Room 1/4  - Cable Pulls between EL Room and Busway",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1880"
    },
    {
      id: "df5a88d9-1079-4b84-aa75-de910209e6fb",
      text: "B2 - 2D1 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1180"
    },
    {
      id: "fb98b840-03c4-44e3-b2d7-2b27ca8f0a03",
      text: "B2 - DH-C - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 16,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.2380"
    },
    {
      id: "01d66e6e-b425-49a4-9846-0b249e4cbaa7",
      text: "B1 - SSB - 1E2 - EF2 - Pour Pads Around Telecom Conduits (EF2)",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 48,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1700"
    },
    {
      id: "d089e3ee-36ac-43c8-bd32-5691ac7c2909",
      text: "Area 3 - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-10-02T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 120,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1950"
    },
    {
      id: "4165939d-36ab-4f5b-a42d-afb4d272c96e",
      text: "Precast Area B",
      type: 5,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 48,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995411"
    },
    {
      id: "aebe8f53-4f40-46d5-bb10-9f8e0da59b1c",
      text: "B1 - SSB - 1E2 - GSMDF2 - Pull Wire for Lighting/Outlet/Racks",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 24,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1690"
    },
    {
      id: "baa4c000-a4d3-4505-b695-7df6a1e72fb1",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2210"
    },
    {
      id: "832147aa-7d1c-4966-a512-65bb2b32e74f",
      text: "Area B - In Wall Rough Mechanical",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1070"
    },
    {
      id: "3b1a539b-1a08-4b84-8de7-1878451261e1",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1520"
    },
    {
      id: "7f8b9512-6f23-4e42-a8af-e234219c044a",
      text: "B1 - mCUP-9 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 16,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9010"
    },
    {
      id: "0fea50f6-4ecb-4fa7-ae88-36e076effadc",
      text: "B1 - mCUP-6 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 48,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6020"
    },
    {
      id: "be07e4e7-6fbf-461c-a91d-c48bf99e3025",
      text: "IBOS - Fabricate / Deliver - Lighting",
      type: 0,
      start_date: "2024-11-07T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 640,
      parent: "c95dcc31-539f-443e-987b-e84c0c944d47",
      progress: 0,
      source_task_id: "IBOS.PROC.1000"
    },
    {
      id: "22639a6b-2088-4384-85cf-9f93aba02ac9",
      text: "Fab and Deliver - MSB - Area SSB - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 2864,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.45,
      source_task_id: "B1.OFCI.3760"
    },
    {
      id: "3e4e700b-1afa-4fc3-8db9-0e81b401c828",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [2] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 3064,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.38,
      source_task_id: "B2.OFCI.2870"
    },
    {
      id: "1ac29f4d-573b-42c4-b1bb-fe67a376ad74",
      text: "Fragnet 25 - PCO # 22 CCD-023 Removal of LPR Cameras",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 360,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8690699"
    },
    {
      id: "e37e76cb-bd5e-4c39-b82c-6e00476d1efa",
      text: "Fab and Deliver - MVS-4WAY - Area AN (1) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 2088,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.6,
      source_task_id: "B1.OFCI.2160"
    },
    {
      id: "86c7a2b4-8163-454c-b976-f9e64382081d",
      text: "FCA - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 1,
      source_task_id: "B2.OFCI.1430"
    },
    {
      id: "550bdc2c-d04a-4238-905d-dc2fef97e41d",
      text: "BLDG-1/2 - Prep / Submit for Review - Concrete (Thermal Ready Mix)",
      type: 0,
      start_date: "2024-06-03T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 160,
      parent: "006f2b8e-65dd-4fb1-b43e-8e84a08db5c5",
      progress: 0,
      source_task_id: "B1.CFCI.1060"
    },
    {
      id: "1f73876b-6cea-46ce-a835-91832bb5d293",
      text: "B1 - SSB - 1E1 - Common - Install Bathroom Accessories",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2350"
    },
    {
      id: "7f7e9cda-ee86-4bb5-a297-3cf9322c5ca7",
      text: "Fab and Deliver - Assembled Skids - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 3064,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 0.33,
      source_task_id: "B2.OFCI.2290"
    },
    {
      id: "667ce647-d071-42f8-b869-3323345b606d",
      text: "B2 - DH-C - Install Structural Steel",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 120,
      parent: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      progress: 0,
      source_task_id: "B2.C.STR.1760"
    },
    {
      id: "b72cea7b-83d1-4abf-81e1-76685eb79b35",
      text: "B2 - DH-D  - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1080"
    },
    {
      id: "27f0799a-7d99-4c4d-86b2-e78e471ba8aa",
      text: "B1 - mCUP-3 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3050"
    },
    {
      id: "c55bed7f-2bb1-41ae-9666-cfe9fe011630",
      text: "Flooring - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5860"
    },
    {
      id: "4f7055bf-142d-4b99-8e43-e8e1ce0a223e",
      text: "Steel Complete - DCB2",
      type: 0,
      start_date: "2025-10-22T08:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1320"
    },
    {
      id: "9b4c9a73-f00f-42aa-8c5c-01f50cb7c7c3",
      text: "Substation-1 - B Lineup SF6 Breaker - Assembly",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3800"
    },
    {
      id: "a829eec0-3e4f-49de-a8c3-3fdca7e9e157",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1250"
    },
    {
      id: "210ec9c6-92cd-47f2-b7d9-cd99153b0652",
      text: "In-Wall Rough Fire Alarm",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 64,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1100"
    },
    {
      id: "c3ce9ca1-8699-4b37-beeb-3b60498ef9f1",
      text: "B1 - DH-D - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 224,
      parent: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      progress: 0,
      source_task_id: "B1.C.STR.2320"
    },
    {
      id: "4c88b08d-2f91-40df-a03f-ebfda5ff1320",
      text: "B2 - 2B1 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1460"
    },
    {
      id: "e1434d18-0cf0-456c-88d6-6d6373063f18",
      text: "B1 - DH-C - Install 800 Amp Busway - Data Hall C",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-11-15T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2280"
    },
    {
      id: "9dd3115b-6f94-4c45-808f-22130b072a70",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1620"
    },
    {
      id: "f0223a95-84b7-4c39-bc82-4c9d39200cdc",
      text: "Building Permit Package - 100% IFP Development",
      type: 0,
      start_date: "2024-01-24T00:00:00",
      end_date: "2024-03-29T08:00:00",
      duration: 376,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "PRE-DP-1090"
    },
    {
      id: "0003d2bc-9969-4b0c-9a0d-9fd9005a85c5",
      text: "DFSMA - DC2 EY-A Skids ROJ - MOFE",
      type: 0,
      start_date: "2026-01-21T08:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 0,
      parent: "76b1ad37-499d-4ec3-8342-ec0ede70139c",
      progress: 0,
      source_task_id: "B2.DFSMA.1030"
    },
    {
      id: "fffd307a-99ff-41fb-a441-d9c6b8c85970",
      text: "Fab and Deliver - CRAH - Area NW-2 - DCB1 *DELETE?*",
      type: 0,
      start_date: "2024-01-09T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 1872,
      parent: "cebac7a2-3c43-4d53-bc0b-02c1d6553116",
      progress: 0.49,
      source_task_id: "B1.OFCI.2700"
    },
    {
      id: "64db0f31-937a-4a98-b914-fd22e0b42b09",
      text: "B2 - DH-A - Install IMP Ceiling - Data Hall A",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1920"
    },
    {
      id: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b",
      text: "B2 - DH-D - Inspect Above Ceiling - Data Hall D",
      type: 0,
      start_date: "2026-08-27T00:00:00",
      end_date: "2026-09-02T08:00:00",
      duration: 40,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2620"
    },
    {
      id: "52ce9133-2749-4c15-81ba-1a3af7588a34",
      text: "B1 - DH-B - Install Structural Steel",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 120,
      parent: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      progress: 0,
      source_task_id: "B1.C.STR.1820"
    },
    {
      id: "f98c7a25-073d-4872-8044-c3427b53c927",
      text: "Area A - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 120,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1121"
    },
    {
      id: "3a66d0d6-ea24-4400-803c-8305218bb78f",
      text: "B1 - DH-B - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-02T08:00:00",
      duration: 80,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1500"
    },
    {
      id: "18d36f01-43e0-43c0-a45e-b425272c2cc4",
      text: "Fab and Deliver - PTX-DHAux - Area D (2) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 3040,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.43,
      source_task_id: "B2.OFCI.1790"
    },
    {
      id: "efd1ac87-0f1e-467d-8235-6dcf813c30d7",
      text: "Balance of Trades",
      type: 0,
      start_date: "2024-06-04T00:00:00",
      end_date: "2024-08-13T08:00:00",
      duration: 400,
      parent: "34506e78-7808-45bd-a08a-14f00001a7a8",
      progress: 0.28,
      source_task_id: "PRE1700"
    },
    {
      id: "5c8bb63a-65b7-42ee-9190-4dbc117768fa",
      text: "BLDG-1/2 - Prep / Submit for Review - Interior Metal Panels",
      type: 0,
      start_date: "2024-09-11T00:00:00",
      end_date: "2024-11-14T08:00:00",
      duration: 160,
      parent: "340322b8-8cb9-43d8-b4b9-513b36f312e3",
      progress: 0,
      source_task_id: "B1.CFCI.3640"
    },
    {
      id: "79c8303e-3fc2-48ab-b1be-0413a74ca4a6",
      text: "Area 1 - UG RI -Substation Feeds-Campus",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1030"
    },
    {
      id: "8147b072-90c2-45e9-96e2-d067dedda4a1",
      text: "Fab and Deliver - Substation HPT - Area SS-2 (2) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 3072,
      parent: "4016a0a2-9bce-4112-a177-64ed092fdb94",
      progress: 0.13,
      source_task_id: "B2.OFCI.2095"
    },
    {
      id: "d6ebdbac-2949-427a-84c8-e05c772b1c47",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [5] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-12-09T08:00:00",
      duration: 1680,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.62,
      source_task_id: "B1.OFCI.3600"
    },
    {
      id: "cf9605a5-81bf-4fb5-918f-97ed4926b87b",
      text: "Tier 0 - B2-2-D - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      progress: 0,
      source_task_id: "7994767"
    },
    {
      id: "58e550b0-e44c-4727-bc94-a540cd987379",
      text: "Commencement Date",
      type: 0,
      start_date: "2023-10-16T00:00:00",
      end_date: "2023-10-16T00:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 1,
      source_task_id: "ICM.G.0001"
    },
    {
      id: "3892f785-2396-4be5-b68b-89b6399eaf36",
      text: "Substation-1 - A Lineup - Install Controls / Conduit / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-03-12T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 136,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3890"
    },
    {
      id: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea",
      text: "B1 - mCUP-6 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 48,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6000"
    },
    {
      id: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      text: "B2 - Deep Telecom - Interduct Between EF 1,2,3,4 to IDFs in DH A, B, C, D",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 120,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2290"
    },
    {
      id: "1f1d35a1-d39d-44d8-bdf7-f563ff5445ee",
      text: "Area 2 - Fire Water Install (remainder)",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: null,
      duration: 208,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A2.8150"
    },
    {
      id: "3864c229-9f86-445d-a9fe-f45d514e0da6",
      text: "City Review Comments & Approve - Mass Grading Permits",
      type: 0,
      start_date: "2024-03-05T00:00:00",
      end_date: "2024-04-05T08:00:00",
      duration: 192,
      parent: "68519373-5be8-4c94-895d-f8db4c1edde5",
      progress: 1,
      source_task_id: "PRE-DD-1120"
    },
    {
      id: "4889d387-b0c5-4853-971b-9debbabbb9db",
      text: "B2 - DH-A - Install Celing Devices Security - Data Hall A",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2600"
    },
    {
      id: "a5090960-932a-4336-89f0-e05dd288536f",
      text: "B2 - DH-C - Room QA/QC Pre DEC-C Turnover - Data Hall C",
      type: 0,
      start_date: "2026-08-14T00:00:00",
      end_date: "2026-09-11T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2680"
    },
    {
      id: "71b8d0d7-44f7-4f48-ae4f-7d551b498a27",
      text: "B1 - mCUP-1-9 - Piping Install (Header Mcup 1-9 tie in's)",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1140"
    },
    {
      id: "8144fc35-4877-49b3-a9c9-6b0660cf06f3",
      text: "L4 Finish DH B - DCB1",
      type: 0,
      start_date: "2026-06-09T08:00:00",
      end_date: "2026-06-09T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2083"
    },
    {
      id: "29adde29-7d38-4dd5-a276-c7d3c7eb7491",
      text: "B1 - mCUP-1 - L2 Inspections",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 80,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1320"
    },
    {
      id: "e3c7fbf0-37e7-4b1a-8032-53b253358dd1",
      text: "B1 - 1N1E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1120"
    },
    {
      id: "2ec3c8eb-cae4-4df2-9b54-b45fd03ce5a2",
      text: "B2 - DH-D - Install Feeder Conduit -Data Hall D",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2410"
    },
    {
      id: "dee905f6-a148-49a8-b010-2bacbe0f5516",
      text: "Fab and Deliver - Busway Kits - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 2632,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.23,
      source_task_id: "B1.OFCI.2930"
    },
    {
      id: "ec9c6b68-c507-4db6-9785-83922bf282b8",
      text: "FR 37 - META review and Approve PCO#XX (not required)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "3379c616-a9bf-4246-981a-9eef20f2a943",
      progress: 0,
      source_task_id: "FR.36.1110"
    },
    {
      id: "61b5b01b-b4e7-4f95-a490-b8a04ae023cd",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 8,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1680"
    },
    {
      id: "9bbd8dae-b3dd-490f-abaf-34673426dd19",
      text: "B2 - DH-B - Install Celing Devices BMS - Data Hall B",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2830"
    },
    {
      id: "92bc073d-eda8-4c1d-a80c-2fee99bcb7c2",
      text: "B1 - DH-C - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 160,
      parent: "71b674fe-bce7-40b1-afb9-e2860457b441",
      progress: 0,
      source_task_id: "B1.C.C.3080"
    },
    {
      id: "21b8d5e3-69db-4b29-9e38-135917df4beb",
      text: "Fab and Deliver - ATS - Area C - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 0.39,
      source_task_id: "B2.OFCI.2570"
    },
    {
      id: "310c278e-7f3e-4566-9963-c49005dfbb9a",
      text: "CSI BMS Controls SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-03-27T00:00:00",
      end_date: "2024-04-01T00:00:00",
      duration: 24,
      parent: "1039d9e5-5a59-40d1-ae52-e112475d85ca",
      progress: 1,
      source_task_id: "PRE1320"
    },
    {
      id: "aac6cca3-7a4b-4cfa-8f13-07e3998183dc",
      text: "Substation-2 - A Lineup SF6 Breaker - L3 Dead Bus Checkout and NETA Testing Energization",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4950"
    },
    {
      id: "801d90d3-308a-45d8-aa5a-84707a0f6168",
      text: "B1 - DH-C - Install Underground Telecom",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 80,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1640"
    },
    {
      id: "06e00a3b-2e24-4b3f-972b-0809cf2f0ec3",
      text: "B1 - mCUP-1-9 - Piping Install (Header Mcup 6-9)",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1120"
    },
    {
      id: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      text: "B2 - 2E1E - EF3 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF3)",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 8,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5350"
    },
    {
      id: "c452041a-3361-46b1-9ccb-b1a9d87eec29",
      text: "B2 - DH-B - Install Perimeter Cable Tray - Data Hall B",
      type: 0,
      start_date: "2026-07-08T00:00:00",
      end_date: "2026-08-04T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2870"
    },
    {
      id: "a60b1c60-082a-432c-8ac6-7d6487a44ad8",
      text: "Precast Complete DH B/D - DCB2",
      type: 0,
      start_date: "2025-11-03T08:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1385"
    },
    {
      id: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      text: "B1 - DH-D - Precast",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 48,
      parent: "a2492a9b-cb43-4bd9-9a59-b0cc491ac51e",
      progress: 0,
      source_task_id: "B1.C.1890"
    },
    {
      id: "307bde6e-fb6e-43f4-bfec-9d7463ebf6be",
      text: "B2 - Prep/Place Curbing",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2025-06-03T08:00:00",
      duration: 160,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1190"
    },
    {
      id: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      text: "B1 - Network - Cure for SOG",
      type: 0,
      start_date: "2025-05-28T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 24,
      parent: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      progress: 0,
      source_task_id: "B1.C.STR.2090"
    },
    {
      id: "9711a43b-3b28-4400-9177-e083abf0bfa8",
      text: "Install Exterior Lights/Security/Devices",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1120"
    },
    {
      id: "003a2f7a-24eb-473d-b1fc-47109d1de63b",
      text: "Fab and Deliver - Control Power STC/SB - Area C - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 0.38,
      source_task_id: "B2.OFCI.2520"
    },
    {
      id: "4104854d-8d0b-4d7a-af99-362ce12103fe",
      text: "UG RI -Rack Bus-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "a187e15c-5311-477e-8dcb-810084b7ae80",
      progress: 0,
      source_task_id: "MECO-1740.20"
    },
    {
      id: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      text: "Area 1 - MV Electric Install - Priority for Foundations (Sub to MV Loop)",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 136,
      parent: "720e9207-a7b5-48b5-bb85-5ab844c17046",
      progress: 0,
      source_task_id: "C.CSU.A1.7000"
    },
    {
      id: "547aff1c-6649-4ed1-8f66-c47d71d1a735",
      text: "B2 - DH-B - L2 CDU Pre-Eng Inspection - Data Hall B",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 144,
      parent: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      progress: 0,
      source_task_id: "B2.C.B.3250"
    },
    {
      id: "93ca7c08-9bc3-4fd6-ae13-21f66396c131",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 80,
      parent: "9cab297d-c579-43de-9c0f-90c459f05a0d",
      progress: 0,
      source_task_id: "MECO-1140.50"
    },
    {
      id: "01ccb8cc-3724-469e-a3a9-490263f5af1e",
      text: "B1 - SSB - Install Thermal Concrete",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-02-22T08:00:00",
      duration: 80,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1130"
    },
    {
      id: "07cfb042-bc3d-4e16-8126-bdb1ed5e81ab",
      text: "Substation-2 - Hookup of (GS IDF Hut) ((SUBIDF2))",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 80,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6200"
    },
    {
      id: "e72d1b4a-3fcc-49d2-8088-50aa18812065",
      text: "Substation-2 - A Lineup - Install Dead-End Structure Excavate / Form / Pour",
      type: 0,
      start_date: "2025-05-03T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 168,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4610"
    },
    {
      id: "555318ca-ffb4-45f8-9d6c-9183f6a579cf",
      text: "B1 - SSB - 1E2 - CMDF2 - In Wall Rough-In/ Inspections (Carrier MDF2)",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 48,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1530"
    },
    {
      id: "e31d381c-f706-42c3-84db-227ca55e8f11",
      text: "Building 1",
      type: 5,
      start_date: "2025-05-30T08:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 912,
      parent: "ea83517a-dd48-4c21-9786-7bd3d6a2338c",
      progress: 0,
      source_task_id: "7994829"
    },
    {
      id: "dda3e4ac-cb6f-4d12-98da-1e933192f6ea",
      text: "Substation-2 - A Lineup SF6 Breaker - Install High Voltage Cable / Install Verification / Pre-energization Checklist",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 128,
      parent: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4940"
    },
    {
      id: "94a34034-ed82-415e-a0b8-93bc455737e2",
      text: "Substation-2 - A Lineup - MOAB Assembly / Control Wiring / HV Conductors",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 192,
      parent: "7396df52-8be2-42b0-85c0-849a0964ef15",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4670"
    },
    {
      id: "1de65947-ffaf-40f2-b078-4b50f9e89520",
      text: "B1 - SSB - 1E2 - GSMDF2 - Tie in Skid to Ductwork",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 48,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1880"
    },
    {
      id: "927ad730-9778-4d08-85c6-fcb58e18862a",
      text: "B1 - Network Room 2/3 - Install Cable Tray",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1540"
    },
    {
      id: "c7df0e1d-3cea-45b8-9dd8-fbce5afd3d0e",
      text: "B1 - mCUP-4 - Install FA  (Wire Pulls)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4080"
    },
    {
      id: "43efc24e-a698-412c-84de-03f3c6ef69ea",
      text: "Area 5 - Mass Grading",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-08T08:00:00",
      duration: 80,
      parent: "e32d6279-98fb-47f4-9c62-0d77d69b6c47",
      progress: 0.2,
      source_task_id: "C.CSU.A5.1000"
    },
    {
      id: "48e3d33e-7768-4ea9-a4b4-4a491799e3fd",
      text: "Interior Curbs & Equipment Pads",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1130"
    },
    {
      id: "05396eb4-aea4-4f7e-8120-7e2d36a26000",
      text: "Substation-1 - MSG B - Medium Voltage Wire Pulls to HV/MV Transformer (Pulls and Terms)",
      type: 0,
      start_date: "2025-05-15T00:00:00",
      end_date: "2025-05-31T08:00:00",
      duration: 104,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3570"
    },
    {
      id: "9076309b-cd3b-4e72-a3fe-bfe6658b53a7",
      text: "Weather/Construction Bank - IBOS",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 136,
      parent: "b902ca4e-8c84-46aa-960c-fe4f123249ab",
      progress: 0,
      source_task_id: "IBOS.CON.1130"
    },
    {
      id: "04dc8626-687d-4e94-86c3-5bfc2e92baba",
      text: "B1 - mCUP-2 - L2 Inspections",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 80,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2130"
    },
    {
      id: "b5074734-b1e4-4798-bf15-6c846569d60a",
      text: "Building 1",
      type: 5,
      start_date: "2025-07-01T08:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 2240,
      parent: "3c68d965-1728-459a-b168-1eb7d69bbb38",
      progress: 0,
      source_task_id: "7995424"
    },
    {
      id: "1dfa4935-21ee-49ef-a8ab-561f799e9ffd",
      text: "B1 - mCUP-3 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3070"
    },
    {
      id: "cf73a802-a304-4c4f-90b5-b45e9a94b862",
      text: "B2 - DH-B - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-04-18T08:00:00",
      duration: 16,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2610"
    },
    {
      id: "7c486acd-5df0-4e23-b208-fcccfc7d0b14",
      text: "B2 - DH-B - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2026-02-23T00:00:00",
      end_date: "2026-03-06T08:00:00",
      duration: 80,
      parent: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      progress: 0,
      source_task_id: "B2.C.EY.1360"
    },
    {
      id: "f07e08a6-ffeb-499f-ae9a-822b799d247c",
      text: "B2 - DH-D - Install 800 Amp Busway - Data Hall D",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2180"
    },
    {
      id: "3f90229e-0233-4201-a962-f7b17d86b50f",
      text: "Fab and Deliver - MVS-4WAY - Area C (10) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 2768,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.44,
      source_task_id: "B2.OFCI.2020"
    },
    {
      id: "84633258-1f64-4ccd-b0be-ee203c3d667b",
      text: "Steel - Trade Partner Process Mill Order",
      type: 0,
      start_date: "2024-04-30T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 112,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1130"
    },
    {
      id: "6efc3154-837c-4250-8c9c-73b144dec055",
      text: "B2 - DH-D - Install Coping",
      type: 0,
      start_date: "2026-02-25T00:00:00",
      end_date: "2026-03-07T08:00:00",
      duration: 80,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1380"
    },
    {
      id: "d3f81527-a6b2-4aec-943f-eeddb43c3882",
      text: "Fab and Deliver - Control Power UPS - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2248,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 0.56,
      source_task_id: "B2.OFCI.2430"
    },
    {
      id: "26e0016b-a958-452c-ae1f-3184e0741bd9",
      text: "B2 - Install Striping and Signage",
      type: 0,
      start_date: "2026-08-28T00:00:00",
      end_date: "2026-09-03T08:00:00",
      duration: 40,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1160"
    },
    {
      id: "014c8355-07c5-4c4f-b07e-770c03345b1a",
      text: "B1 - DH-C - Install Fire Alarm Conduit/Vesda -Data Hall C",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2490"
    },
    {
      id: "7d4609c8-6296-4f67-8f00-7399939d7683",
      text: "B1 - DH-C - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 96,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2110"
    },
    {
      id: "f5178bab-9aee-43b4-9ec8-fded356154cf",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1380"
    },
    {
      id: "5cbf586e-86df-4015-b3af-689cf3836eb0",
      text: "FR 06 - DPR Investigate & Identify Unsuitable Soil @ DCB-1",
      type: 0,
      start_date: "2024-07-18T00:00:00",
      end_date: null,
      duration: 40,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1000"
    },
    {
      id: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      text: "PTX & HPT - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2024-02-01T00:00:00",
      duration: 0,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 1,
      source_task_id: "B1.OFCI.1390"
    },
    {
      id: "08a210dc-133f-4b25-8355-b4b2f3b8be40",
      text: "B2 - 2A1 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 160,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1780"
    },
    {
      id: "96e07be6-cc4d-47cd-893b-f60ca27681a9",
      text: "Steel Mill Order Package Release",
      type: 0,
      start_date: "2024-04-29T08:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1050"
    },
    {
      id: "5508a6c8-39d2-4155-b216-fb7cabcd7b28",
      text: "B2 - 2E2E - EF2 - In Wall Rough-In/ Inspections (EF2)",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 48,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6140"
    },
    {
      id: "086c42d9-8735-443d-a45d-99800fe3c59d",
      text: "Substation-2 - A Lineup SF6 Breaker - Set Breaker",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 8,
      parent: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4910"
    },
    {
      id: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a",
      text: "B1 - Network Room 1/4  - In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1070"
    },
    {
      id: "f949ff60-a25b-4a06-8058-76d06e9d36f4",
      text: "B1 - DH-D - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 48,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1660"
    },
    {
      id: "5df96130-1dbf-4579-9a0b-38a62985adb9",
      text: "Load Bank - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-08-30T08:00:00",
      duration: 1136,
      parent: "5c788524-2553-452e-84b3-e22e7b7ba7ad",
      progress: 0,
      source_task_id: "B2.OFCI.1340"
    },
    {
      id: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      text: "B1 - DH-B - Frame Walls (ROJ date for Prefab walls) Pre-Fab",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 80,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.1050"
    },
    {
      id: "c1a638e7-549d-4c75-aeb8-352bec505620",
      text: "BLDG-2 Connectivity",
      type: 5,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 1896,
      parent: "cb1dcb5c-8829-4b31-9b55-e2d7b49a06ad",
      progress: 0,
      source_task_id: "7995457"
    },
    {
      id: "829f9e87-e103-4200-a8ff-a6b0daa48b58",
      text: "B2 - DH-A - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 40,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1060"
    },
    {
      id: "47e6d2e4-246a-4d1f-91d0-7d43697af2ff",
      text: "Kitchen Equipment",
      type: 0,
      start_date: "2024-07-24T00:00:00",
      end_date: "2024-08-12T00:00:00",
      duration: 160,
      parent: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      progress: 0,
      source_task_id: "PRE1750"
    },
    {
      id: "edfc1cb5-e778-413e-9153-1e4983783445",
      text: "FR 15 - META review and respond to RFI #68.2",
      type: 0,
      start_date: "2024-07-31T00:00:00",
      end_date: null,
      duration: 312,
      parent: "150fc470-4247-402f-8c28-d9b141485933",
      progress: 1,
      source_task_id: "FR.15.1010"
    },
    {
      id: "8689b41d-425e-4a52-b831-cf49e2428c60",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Architectural Precast Conc.",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 104,
      parent: "07b55cfe-9e28-44c9-92c0-80e8fd883c9f",
      progress: 0,
      source_task_id: "B1.CFCI.4230"
    },
    {
      id: "2407cdb3-6209-4640-b6a2-62c19cb01969",
      text: "BLDG-1/2 - Fabricate / Deliver Speciality doors and dock levelers",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 480,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6320"
    },
    {
      id: "1843b881-fbde-490a-9867-6b8dbf7b7ea5",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [6] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-07T08:00:00",
      duration: 2592,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.4,
      source_task_id: "B1.OFCI.3520"
    },
    {
      id: "20dbfc4c-9da0-482b-ba72-9b378a1d8429",
      text: "B1 - SSB - 1E1 - CMDF1 - Terms for Lighting/Outlet/Racks (Carrier MDF1)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1850"
    },
    {
      id: "8bc1b444-1525-40b1-aae2-5a44fd44a41e",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1220"
    },
    {
      id: "a740fcc5-a56f-4367-8cff-c757f5c937d9",
      text: "B2 - DH-B - Connect Buss/Cable Tray Sections - Data Hall B",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2680"
    },
    {
      id: "58d7b1e7-47c2-48aa-9974-1f34d580d295",
      text: "B2 - mCUP-3 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 48,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3000"
    },
    {
      id: "4c61909e-e3ce-48e2-a4a6-53b5d7d40471",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1510"
    },
    {
      id: "848cfcd1-d03e-42dc-a51e-e91b26a9c40f",
      text: "Substation-2 - A Lineup - Install Transformer Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 128,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4620"
    },
    {
      id: "b8ebe236-9ba3-4511-bc85-922bff4333a8",
      text: "BLDG-1/2 - Prep / Submit for Rvw - Structural Steel",
      type: 0,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-07-05T08:00:00",
      duration: 224,
      parent: "b5ab113b-f512-4fc0-8bd5-aac4590010ea",
      progress: 0.55,
      source_task_id: "B1.CFCI.3020"
    },
    {
      id: "1199aed8-9a5c-4ba9-b5a4-fd27806e7d1d",
      text: "(CFCI) Div. 09 - Porcelain Tiling",
      type: 5,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 600,
      parent: "6f5d15b6-3801-4b83-9da3-89ba5b3dc781",
      progress: 0,
      source_task_id: "7994877"
    },
    {
      id: "75eecfcd-ec3a-4725-b3e7-075fe21cd99d",
      text: "Prepare and sumit for review",
      type: 0,
      start_date: "2024-08-23T00:00:00",
      end_date: null,
      duration: 56,
      parent: "dc78887d-8014-48b1-ad06-f9bf1be85152",
      progress: 0,
      source_task_id: "FR.04.1020"
    },
    {
      id: "c2d8030c-6263-4f73-9422-c55feddbea39",
      text: "Site & Utilities",
      type: 5,
      start_date: "2024-05-28T00:00:00",
      end_date: "2026-06-23T08:00:00",
      duration: 4184,
      parent: "4d7f99a1-a653-43bf-b87f-5b8e20378bdb",
      progress: 0.04,
      source_task_id: "7995429"
    },
    {
      id: "2c6a99ca-a112-46d0-9cc6-5732cebfa5ac",
      text: "Area 4 - MV Electric Install - Remaining (EY into ER)",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-30T08:00:00",
      duration: 96,
      parent: "cb84dcdb-d649-480a-8f41-a9ab04aae985",
      progress: 0,
      source_task_id: "C.CSU.A4.8010"
    },
    {
      id: "9ff4802e-8a35-4b9b-8540-c1222f41a74a",
      text: "BLDG-1/2 - Prep / Submit for Review - Gypsum System and Ceilings",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 120,
      parent: "3821e008-bd7a-483f-8d1f-538e64dc2ec4",
      progress: 0,
      source_task_id: "B1.CFCI.3730"
    },
    {
      id: "88648746-1f85-459a-9a2d-796bec4924e4",
      text: "Electrical R/I",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 120,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1000"
    },
    {
      id: "70e4f334-1eae-4a33-bf69-4e42ed00bbff",
      text: "Final Clean - Above Ceiling per Specs",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 8,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1140"
    },
    {
      id: "c875ef17-1edb-46fe-aca3-8692566e29d3",
      text: "B1 - 1N2W - 01N2.06 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6290"
    },
    {
      id: "d48fc8ee-18e6-4cee-8439-dc9f297b58cb",
      text: "B1 - mCUP-5 - Set in Place Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5030"
    },
    {
      id: "187633d5-4d41-408f-82e8-aaf4af8236c4",
      text: "B2 - SSB - Install Decking",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      progress: 0,
      source_task_id: "B2.C.STR.1680"
    },
    {
      id: "3edf62c5-ed13-4a70-8fc9-86bc47e82617",
      text: "L3 Start Substation - DCB2",
      type: 0,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-05-27T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2025"
    },
    {
      id: "6060f3e2-f7f3-4f5e-8a19-b27573204d71",
      text: "B1 - DH-A - Inspect Above Ceiling - Data Hall A",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 48,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2690"
    },
    {
      id: "5b5c0ea2-6570-4bc6-83b2-28c72bdd5be0",
      text: "Area 4a - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2024-11-23T00:00:00",
      end_date: "2024-12-27T08:00:00",
      duration: 200,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1790"
    },
    {
      id: "d21fa5c3-ab17-4c0a-a9cd-fd42cec2de2e",
      text: "Fab and Deliver - ATS - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2832,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 0.42,
      source_task_id: "B2.OFCI.2560"
    },
    {
      id: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      text: "RF Tower 1",
      type: 5,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 840,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995244"
    },
    {
      id: "1786ba2c-e011-4e1b-8712-52937aec48e9",
      text: "B1 - DH-A - L2 CDU Pre-Eng Inspection - Data Hall A",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 144,
      parent: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      progress: 0,
      source_task_id: "B1.C.A.3010"
    },
    {
      id: "84f1cb2d-4c9e-4d25-b395-c4d43195c72c",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2200"
    },
    {
      id: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176",
      text: "Weather/Construction Bank - Bldg 1 A & B S/C Fdn st (1) to L3 start + 5 days for Cx (Original = 30 -3 = 27)",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-08-03T08:00:00",
      duration: 240,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX1.DHB.WB.0020"
    },
    {
      id: "28ad431d-8ff4-4c97-aaff-75a7a5f61e17",
      text: "Fab and Deliver - HMD - Area A - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 3168,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.4,
      source_task_id: "B1.OFCI.2990"
    },
    {
      id: "27f63af4-0457-443c-b37b-be64f4a993e4",
      text: "Fab and Deliver - Cooling Distribution Unit - Area D - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 4464,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 0.05,
      source_task_id: "B2.OFCI.1930"
    },
    {
      id: "863e77f4-e6c7-4844-a3d2-f3f230182965",
      text: "B1 - OSP Cabling - CAV1/MMV to EF1, EF2, EF3, EF4 (Starts after Precast Network)",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 240,
      parent: "85391fcf-fbdc-4cfe-b101-e86ca0d8bff2",
      progress: 0,
      source_task_id: "B1.CONN.1000"
    },
    {
      id: "1ab67361-6d06-4b8e-b1fd-9818595a468e",
      text: "B2 - DH-B - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 40,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1760"
    },
    {
      id: "1c9276aa-3f44-453b-b647-ef177655cfd0",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1220"
    },
    {
      id: "70152441-2a85-45da-b325-6014f470680a",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2010"
    },
    {
      id: "3c41bf6e-836e-40f7-b092-84c97b0ff3cf",
      text: "Non-Critical Power (NCP)",
      type: 5,
      start_date: "2025-04-02T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 104,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995178"
    },
    {
      id: "405159c3-279f-4a22-ab08-21372783d94a",
      text: "FR 01 - Sanitary Sewer Redesign - Prepare & Issue Hydraulic & CAD Model - Area 4 & 5",
      type: 0,
      start_date: "2024-04-29T00:00:00",
      end_date: "2024-05-08T08:00:00",
      duration: 64,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1040"
    },
    {
      id: "c3841731-6ce1-42dd-b83f-cf49d4eddc41",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1550"
    },
    {
      id: "b80ee220-876c-4296-9a79-3377bac5baf8",
      text: "B2 - DH-A - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 40,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1170"
    },
    {
      id: "3425e907-188e-4aa2-a053-383ec1447e12",
      text: "Substation-1 - B Lineup - Deep Conduit Install",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-16T08:00:00",
      duration: 104,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3350"
    },
    {
      id: "84249298-053f-4bed-89cc-a4382c9f1fa6",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 120,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2050"
    },
    {
      id: "600d8f12-919f-42df-bb18-0526450a02aa",
      text: "Site Improvements",
      type: 5,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 320,
      parent: "39855758-26c2-45c7-8a00-84dc36793e26",
      progress: 0,
      source_task_id: "8147633"
    },
    {
      id: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      text: "Building 2 Paving",
      type: 5,
      start_date: "2025-04-17T00:00:00",
      end_date: "2026-09-03T08:00:00",
      duration: 2848,
      parent: "c673dffa-9349-4849-8685-f46d759d91be",
      progress: 0,
      source_task_id: "7995208"
    },
    {
      id: "ce08d940-d067-48cc-942b-0a6b0c1fc75b",
      text: "B1 - DH-D - Install Fire Alarm Conduit/Vesda -Data Hall D",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1260"
    },
    {
      id: "a7334d00-d180-4864-acad-043be0fce54a",
      text: "B1 - 1N2W - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1440"
    },
    {
      id: "59122aee-662d-45c0-b416-ae8b84c9d877",
      text: "Glass & Metal Panel SA - Meta Review",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-09T08:00:00",
      duration: 80,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 0,
      source_task_id: "PRE-PP-1230"
    },
    {
      id: "42b7422a-c88a-41d1-9960-0386ba772f36",
      text: "B2 - 2E2E - 02.01.E2.01 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 144,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6440"
    },
    {
      id: "66f7893c-8d52-49e2-9553-32185ed55567",
      text: "B2 - 2E2E - 02.01.E2.01 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6520"
    },
    {
      id: "c72003a7-f5c2-4bc0-8ae7-46a9a829afff",
      text: "In Wall Inspections & QAQC Walks",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-08T08:00:00",
      duration: 24,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1100"
    },
    {
      id: "832981e9-4ea4-4ad2-951e-0ab4460d32ad",
      text: "B1 - 1N1E - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1990"
    },
    {
      id: "2c680400-5591-4ad3-af30-0528b1f44615",
      text: "Substation-1 - TX B - Pre-energization / Control Power / Dead Bus Checkout",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 152,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3770"
    },
    {
      id: "cdab7e2f-666b-4468-a664-79d098844933",
      text: "(CFCI) Div. 05 - Cold Formed Metal Framing",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 320,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0,
      source_task_id: "7994921"
    },
    {
      id: "2b4b287d-9b48-4ac0-93b2-efcdc27ce262",
      text: "Fab and Deliver - 2.0MW Generator - Area A - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 3728,
      parent: "48cf4798-012c-4fde-a8da-168cee42ccec",
      progress: 0.19,
      source_task_id: "B2.OFCI.2190"
    },
    {
      id: "f8c890e4-88e7-4026-a2d1-dc17de52c4c0",
      text: "B1 - mCUP-6 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6120"
    },
    {
      id: "cd47765e-6b89-42bd-a873-eb60411a31b9",
      text: "Substation-1 - TX A - Pre-energization / Control Power / Dead Bus Checkout",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 152,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4130"
    },
    {
      id: "ac1292d8-552e-42fd-a671-f7d1df6a508b",
      text: "Substation-1 - A Lineup - MOAB Assembly / Control Wiring / HV Conductors",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 160,
      parent: "ad9bcc69-2423-47a9-879e-e48510c33ecb",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3910"
    },
    {
      id: "f69fc444-58e9-4c56-a680-e7aab3bc3b1f",
      text: "B1 - DH-D - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1510"
    },
    {
      id: "0b68c4dc-c508-4ba5-97ba-d56e39f6d625",
      text: "B2 - DH-A - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 200,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1720"
    },
    {
      id: "680102a5-98d3-4616-a73d-a7177e4a70d4",
      text: "B2 - DH-D - El Equip Yd - Set Equipment (10)MVS, (20)PTX",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-02T08:00:00",
      duration: 80,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "B2.C.EY.1240"
    },
    {
      id: "0cbb8d91-a163-4e44-a985-7c9923a50bd1",
      text: "B1 - 1N1W - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5090"
    },
    {
      id: "763c185c-82ee-4394-8b78-af68801f04d3",
      text: "Corridor 2A1 (Spr Riser Rm/Control Rm/GS IDF (2)",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 1016,
      parent: "8790b54e-02a0-492f-af1f-d61d0338ca55",
      progress: 0,
      source_task_id: "7995084"
    },
    {
      id: "26dfc994-8133-46f9-84cd-3b48426244e1",
      text: "B2 - 2E2E - EF1 - Pull Wire for Lighting/Outlet/Racks (EF1)",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 24,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6280"
    },
    {
      id: "490ee11b-5c8c-4e75-b103-dbc2869fea2d",
      text: "B2 - DH-C - Underground (Converted to LOE )",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 240,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1310"
    },
    {
      id: "c0fb9fcd-6590-4a48-9d11-d1f796ce6715",
      text: "B2 - DH-C - Install  Balance of Grade Beams",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 80,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1440"
    },
    {
      id: "0dd13668-e3a3-4dc1-9a64-c942c4ec6174",
      text: "B2 - DH-B - Raise HACs - Data Hall B",
      type: 0,
      start_date: "2026-04-24T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2640"
    },
    {
      id: "466a3e83-a6d6-45d1-8f0f-8e55055e8c12",
      text: "BLDG-2 - BIM - Tier 2-4 - Area 2-A - Coordination / Sign-off",
      type: 0,
      start_date: "2025-04-16T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 280,
      parent: "1e8886aa-f56f-4148-b16c-c79188f75884",
      progress: 0,
      source_task_id: "B2.VDC.3100"
    },
    {
      id: "f4c80d29-97ad-4b76-9746-0daaa2d75a51",
      text: "B2 - mCUP-1-8 - Foundations for Piping (Sequence 2)",
      type: 0,
      start_date: "2025-03-24T00:00:00",
      end_date: "2025-04-15T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1010"
    },
    {
      id: "87bcb177-d4dd-4ca4-b098-76e591a09685",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area NW-1/4 (16) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2336,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.44,
      source_task_id: "B1.OFCI.2190"
    },
    {
      id: "7c11424d-9f50-4f85-ac6d-e6717c1416f5",
      text: "L3 - B2 DHA",
      type: 0,
      start_date: "2026-09-09T00:00:00",
      end_date: "2026-11-17T08:00:00",
      duration: 400,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX3.B2.DHA.1000"
    },
    {
      id: "b6733cb5-8f44-407f-a43d-89d2abd97781",
      text: "Exterior Canopy MEPF Rough-In",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 80,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1140"
    },
    {
      id: "16772213-e8e7-4430-9271-e32d23148879",
      text: "B2 - DH-D - Precast",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 40,
      parent: "612ff8c3-6244-4794-a6d8-37d95a4390b7",
      progress: 0,
      source_task_id: "B2.C.1710"
    },
    {
      id: "1727f221-62ff-460d-93ab-9c07242dc0b2",
      text: "Precon- Critical Information / Decision Dates",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-07-12T08:00:00",
      duration: 1456,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 0.91,
      source_task_id: "7994720"
    },
    {
      id: "1e7b1d76-4462-4f25-8d2c-f5374fe49857",
      text: "Fab and Deliver - Busway Kits - Area D - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3064,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.2,
      source_task_id: "B1.OFCI.3470"
    },
    {
      id: "52b9c922-db25-4ac8-8655-ed1b944fb377",
      text: "B1 - Network - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 80,
      parent: "efec6b5a-5634-43a5-b571-748e500afd9a",
      progress: 0,
      source_task_id: "B1.C.EY.1140"
    },
    {
      id: "a743ba5d-b49f-4e1d-b106-26c85a6eb0fc",
      text: "B2 - 2E1E - 02.01.E1.05 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5270"
    },
    {
      id: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a",
      text: "B1 - Network Room 2/3 - FCA Gallery - FCA Setting/ Hookup",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 192,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1440"
    },
    {
      id: "8e02a0cc-de3f-4a70-87ed-929216ca8432",
      text: "B1 - Network - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 160,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1010"
    },
    {
      id: "5d20944d-7918-46c2-83e5-08c69eb295d1",
      text: "Equipment Set",
      type: 5,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 464,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995146"
    },
    {
      id: "b7276775-282b-41bf-b68f-4f43ce404d58",
      text: "B2 - DH-D - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 160,
      parent: "f63227a1-2d37-45bf-b6c4-986a8a6d50b9",
      progress: 0,
      source_task_id: "B2.C.EY.1790"
    },
    {
      id: "60fde966-b2db-4672-b592-2bdc8d06f1d2",
      text: "B2 - mCUP-6 - Set in Place Inspections",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 8,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6030"
    },
    {
      id: "17c332ed-9f70-42a7-b275-d77b682502c9",
      text: "Fab and Deliver - Control Power UPS - Area C - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2488,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 0.52,
      source_task_id: "B2.OFCI.2440"
    },
    {
      id: "09654b2c-e592-4a63-9486-ab8550d78b28",
      text: "Interior Construction - Admin",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 800,
      parent: "6390b5d5-9a22-42db-85db-444fbf74a661",
      progress: 0,
      source_task_id: "AD.CON.1060"
    },
    {
      id: "8cd3a88a-b943-4134-a113-4544add2b0c5",
      text: "B2 - 2C1 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2030"
    },
    {
      id: "40622e37-3df6-4e80-89d7-61c1c3cff41c",
      text: "B1 - 1C2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1960"
    },
    {
      id: "5ed9bec7-54c7-4156-b0c1-7ceb6eb0515a",
      text: "(CFCI) Div. 09 - Painting",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 440,
      parent: "88a16a24-d160-4e00-8516-9659424e2d90",
      progress: 0,
      source_task_id: "7994881"
    },
    {
      id: "bf0f2f61-4604-42f7-8a44-b75532890447",
      text: "[DCB1] DEC-C Ready: OSP Pathways [IBOS]",
      type: 0,
      start_date: "2025-06-19T08:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3365"
    },
    {
      id: "be9a3cae-a5bc-4239-9b4c-05ac5c53f89f",
      text: "[DCB1] DEC-C Ready: General Services [ADMIN]",
      type: 0,
      start_date: "2026-03-12T08:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3717"
    },
    {
      id: "eda52b05-1778-43c6-a48b-377e6928d9f4",
      text: "B2 - 2B1 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1470"
    },
    {
      id: "c6107663-54c4-4d6f-a472-cef71cfcb858",
      text: "B1 - DH-C - Install Tech Water - Data Hall C",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-22T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2370"
    },
    {
      id: "1d68be14-3b60-47a5-aa53-0d47031be75c",
      text: "B2 - SSB - Backfill",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 40,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1180"
    },
    {
      id: "ed1b30c6-5463-4d27-9156-650613258404",
      text: "Fab and Deliver - ATS - Area B - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 2792,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 0.43,
      source_task_id: "B2.OFCI.2550"
    },
    {
      id: "049ea951-1102-4aa0-941a-b0f8c6f69d1a",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2000"
    },
    {
      id: "bdef2b94-7931-4a69-b1f6-be9c4d6a9f55",
      text: "B1 - 1B2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1120"
    },
    {
      id: "ef413f2e-fe35-40d1-962f-a64afdf70526",
      text: "B2 - DH-B - Install Underground Security",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1350"
    },
    {
      id: "60c3171d-7b99-4a6b-b887-89a23e4c714e",
      text: "B1 - mCUP-6 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6090"
    },
    {
      id: "d7fa1c0a-6c6f-4e4e-b1db-bced10cff8c4",
      text: "FR 23 - META review and respond to RFI #84",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "2be26207-dbca-4279-9a53-24684a97817a",
      progress: 1,
      source_task_id: "FR.23.1010"
    },
    {
      id: "31e53564-18df-48b5-b5ac-676668893ae1",
      text: "MSB/RSB - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 1,
      source_task_id: "B2.OFCI.1150"
    },
    {
      id: "d19cc398-dc11-4acb-a221-8436a158ff3f",
      text: "B1 - 1D2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 40,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1960"
    },
    {
      id: "287494f9-4979-494e-b4f9-1766d55d66a5",
      text: "B1 - DH-B - Inspect Above Ceiling - Data Hall B",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 48,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2840"
    },
    {
      id: "b6fce1c3-c853-464b-9031-deaf389a90c0",
      text: "[DCB2] DEC-C Ready: OSP Pathways [DCB1 EF <> DCB2 EF]",
      type: 0,
      start_date: "2025-10-10T08:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 0,
      parent: "75b6388a-59b7-4d32-9f21-f50d2281bccf",
      progress: 0,
      source_task_id: "ICM.B2.3697"
    },
    {
      id: "95e10889-60a8-49e5-9c4a-0ba6317c90b7",
      text: "Area 4 - UG RI -Generator/LB/GSB -DCB2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1690"
    },
    {
      id: "b47fe8d5-c884-488a-ac51-bae777be354d",
      text: "B2 - DH-B - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-19T08:00:00",
      duration: 160,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2000"
    },
    {
      id: "8b8d9e67-9e52-4f01-8fe5-5de3ea4f7787",
      text: "B2 - SSB - 2E2 - Common - Install Device Tiles",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1710"
    },
    {
      id: "613dc94f-7422-4013-b010-66a8eb880cad",
      text: "Campus - Site Mobilize for Mass Grading",
      type: 0,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-04-18T08:00:00",
      duration: 32,
      parent: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      progress: 1,
      source_task_id: "C.CSW.1000"
    },
    {
      id: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      text: "Precon- Budget",
      type: 5,
      start_date: "2023-10-24T00:00:00",
      end_date: "2024-07-01T08:00:00",
      duration: 1384,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 0.95,
      source_task_id: "7994725"
    },
    {
      id: "cb1631e5-af5f-4223-a125-710ed0686609",
      text: "B1 - SSB - 1E1 - Common - Install Ceiling Tiles",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2240"
    },
    {
      id: "dfc16b55-f1f0-4fea-b940-c09ea7840d80",
      text: "Corridor 2D2 (Spr Riser Rm/Control Rm/GS IDF (2)/restroom/UPS Room (2)/ Light Inv/Control panel",
      type: 5,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 1016,
      parent: "6b113e4f-7c30-4f40-87bf-7db528dc210c",
      progress: 0,
      source_task_id: "7995066"
    },
    {
      id: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      text: "Area-4A",
      type: 0,
      start_date: "2024-11-23T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 2296,
      parent: null,
      progress: 0,
      source_task_id: "8444273"
    },
    {
      id: "a9437c85-41d4-4bc9-afc6-a8fe9a7e5359",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [4] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 2432,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.57,
      source_task_id: "B2.OFCI.2820"
    },
    {
      id: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce",
      text: "B1 - Network Room 1/4 - HAC Assembly Setting - [03.HAC-30-03,04]",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1480"
    },
    {
      id: "ecbbfa11-10ac-4fdc-851d-a73792f09398",
      text: "B2 - DH-B - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1070"
    },
    {
      id: "7ae66464-179d-4eda-a881-6d3b26d9f395",
      text: "B2 - 2C1W - 02C.07 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-04-22T00:00:00",
      end_date: "2026-04-28T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.2220"
    },
    {
      id: "97cd702a-7b4a-4e7a-a600-483bc208f74d",
      text: "B1 - DH-B - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 96,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2410"
    },
    {
      id: "d3c644e8-b911-4561-8a09-2ce148f4320b",
      text: "DCB1 EY2 Ready for Energization - DCB1",
      type: 0,
      start_date: "2025-12-15T08:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1126"
    },
    {
      id: "876f1f7f-6b1d-4eb9-83ab-0b91c84d32d8",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2090"
    },
    {
      id: "d390b116-84b5-4ac4-9005-9d68157fdd1b",
      text: "(CFCI) Div. 03 - Structural Concrete",
      type: 5,
      start_date: "2024-08-06T00:00:00",
      end_date: "2024-10-08T08:00:00",
      duration: 360,
      parent: "36b087b6-3ffb-4aea-873b-73cacb04dbd0",
      progress: 0,
      source_task_id: "7994850"
    },
    {
      id: "abc1e34d-7fd5-4e5a-97a3-f978003f5cc3",
      text: "BLDG-1 - Core - Overall Duration - FDN to SC A/B - (LOE)",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2026-08-03T08:00:00",
      duration: 3712,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0,
      source_task_id: "AUX.MILE.1540"
    },
    {
      id: "62f8196f-0ff5-491f-bb2b-95b6b33c77a5",
      text: "B1 - 1C1W - 01C.07 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1620"
    },
    {
      id: "ace0d89f-4e49-4bc6-9b86-f04eb1070053",
      text: "B2 - 2B1 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1480"
    },
    {
      id: "42ce33d6-85a8-43a4-9df8-1e057e94d91e",
      text: "L3 Start IBOS",
      type: 0,
      start_date: "2025-12-19T00:00:00",
      end_date: "2025-12-19T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2900"
    },
    {
      id: "28e7e979-7bf1-45d1-befc-dbee0d206497",
      text: "B1 - Network Room 1/4  - Install Device Tiles",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2000"
    },
    {
      id: "e352c68f-6c21-48a5-b8f6-74ae52259fd0",
      text: "Area B - Drop ACT Tile",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1410"
    },
    {
      id: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      text: "Utilities Package Issuance",
      type: 0,
      start_date: "2024-03-15T08:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 0,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.2380"
    },
    {
      id: "1af4f676-6072-41af-8ad8-43551eeca6e3",
      text: "B1 - 1A2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2190"
    },
    {
      id: "11fec43e-cfa4-4cde-be18-8b365ff358a7",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2360"
    },
    {
      id: "6a1235c3-ea70-4408-b57c-936a50c8b892",
      text: "Pad Prep / Deep Foundations - BLDG 1 mCup",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 40,
      parent: "872df01c-b5af-4a82-b4f8-d4090a1571ca",
      progress: 0,
      source_task_id: "C.CSU.A2.1010"
    },
    {
      id: "ec33f3ff-9607-4ee3-890e-0100e4de0b96",
      text: "IST Finish DH D - DCB1",
      type: 0,
      start_date: "2026-08-25T08:00:00",
      end_date: "2026-08-25T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2185"
    },
    {
      id: "b6353a66-bba0-4814-8480-84e8a9beda36",
      text: "B1 - DH-C - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1130"
    },
    {
      id: "ec41ab89-7900-47bd-ac5c-05f52ad5d233",
      text: "B2 - 2E1E - EF4 - In Wall Rough-In/ Inspections (EF4)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 48,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5160"
    },
    {
      id: "4e155fc3-8361-429e-9a8b-807103168d8b",
      text: "B2 - DH-A - Hookup CDU's - Data Hall A - DCI 3134",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-04-28T08:00:00",
      duration: 144,
      parent: "813899cd-a520-4613-8209-38f409169670",
      progress: 0,
      source_task_id: "B2.C.A.3230"
    },
    {
      id: "c396e79b-58bd-4153-b27c-14119d8e6cd0",
      text: "Area 5 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-SSB2",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1920"
    },
    {
      id: "b1c7f70e-5291-4b35-8fcd-f3a7dd24145e",
      text: "Delivery of DES - Data Hall Electrical Room Skid (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-08-01T08:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1840"
    },
    {
      id: "fc0932fe-3a0d-4101-b7dc-c7b486b7b6ca",
      text: "Fab and Deliver - ATS - Area AN - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-14T08:00:00",
      duration: 2168,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.49,
      source_task_id: "B1.OFCI.3390"
    },
    {
      id: "32a4a0d7-5912-4a82-adab-446b50869c46",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1700"
    },
    {
      id: "1177768d-69e3-4705-9ebf-4fe868ce700f",
      text: "B2 - 2C2 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-03-16T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1510"
    },
    {
      id: "2fa2c90a-4117-4eba-8dfc-3d2b15c3088b",
      text: "Start Electrical Room Skid Set-In-Place",
      type: 0,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1700"
    },
    {
      id: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      text: "AKN-1/2 - Construction Schedule DD 2024.06.23 - f-fGMP",
      type: 5,
      start_date: "2023-08-28T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 7448,
      parent: null,
      progress: 0.2,
      source_task_id: "7994711"
    },
    {
      id: "e65cf560-f777-4914-83f1-a1dddd577c7f",
      text: "B1 - SSB - 1E1 - Common - Install Door Frames",
      type: 0,
      start_date: "2025-06-14T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1210"
    },
    {
      id: "0418cc15-87a3-49a1-b5f4-3150930c84dc",
      text: "FR 08 - Area 5 - Telecom Install - Concrete Scope",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-02-20T08:00:00",
      duration: 296,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A5.8030"
    },
    {
      id: "ac14da03-e164-41ae-987f-f484869d6058",
      text: "DFSMA - DC1 - CUP 6- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-08-11T08:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1280"
    },
    {
      id: "5d255dab-ba76-4590-a7cf-f0db5c5ba939",
      text: "FR 24 - META issue CCD #38",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: null,
      duration: 0,
      parent: "2ff871d6-c6b3-47c0-a53e-259b72b200a5",
      progress: 1,
      source_task_id: "FR.24.1000"
    },
    {
      id: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      text: "BLDG-1 SSB 1E2 (GS-MDF Room Only)",
      type: 5,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 568,
      parent: "317fedf3-4445-4d48-b19e-75107c7c0568",
      progress: 0,
      source_task_id: "7995293"
    },
    {
      id: "7245901a-c8fb-4512-917e-31e360191e20",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2190"
    },
    {
      id: "8bd7f19e-3ccc-4b04-8087-e7a51f844c69",
      text: "B1 - 1D1W - 01D.09 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 48,
      parent: "39a3ae66-32ac-404b-abe4-060edea977f7",
      progress: 0,
      source_task_id: "B1.C.D.2360"
    },
    {
      id: "f8a5c63a-a641-45a1-80a4-ff46fa878512",
      text: "B2 - DH-D - Install Tech Water - Data Hall D",
      type: 0,
      start_date: "2026-06-04T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2210"
    },
    {
      id: "b7925a2b-1607-4009-9f05-517da87660fd",
      text: "B1 - 1N1W - 01N1.07 - Lighting and Devices",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6360"
    },
    {
      id: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      text: "B1 - 1N1E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 24,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1040"
    },
    {
      id: "095920e6-a996-4247-90f9-ea3b2164de0b",
      text: "B2 - DH-B - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 40,
      parent: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      progress: 0,
      source_task_id: "B2.C.STR.2080"
    },
    {
      id: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      text: "B2 - 2D1 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 24,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1640"
    },
    {
      id: "00ce9663-4d82-4cb0-9f19-1f07e53ab61d",
      text: "Fab and Deliver - Cooling Distribution Unit - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 3896,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 0,
      source_task_id: "B1.OFCI.3120"
    },
    {
      id: "c7e36ba0-1328-4932-b768-f0c1d7d5a392",
      text: "Additional Building Permits Review Time *Tentative* ( Duplicate- refer to PRE-DD-1190",
      type: 0,
      start_date: "2024-07-25T00:00:00",
      end_date: "2024-07-25T00:00:00",
      duration: 360,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 0,
      source_task_id: "PRE-DD-1180"
    },
    {
      id: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5",
      text: "B1 - 1B2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 120,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2710"
    },
    {
      id: "622bcced-a8a7-4dc5-97b8-24d38c62f6fa",
      text: "FR 04 - Review and decision for VE or not",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: "2024-09-26T08:00:00",
      duration: 64,
      parent: "dc78887d-8014-48b1-ad06-f9bf1be85152",
      progress: 0,
      source_task_id: "FR.04.1030"
    },
    {
      id: "0551c8a7-60d0-4fb6-a1a8-fa83eb9bc539",
      text: "Generators - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "48cf4798-012c-4fde-a8da-168cee42ccec",
      progress: 1,
      source_task_id: "B2.OFCI.1110"
    },
    {
      id: "3340475b-dab8-488a-a332-b61a475e63dd",
      text: "Fab and Deliver - Control Power UPS - Area B - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2248,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 0.56,
      source_task_id: "B2.OFCI.2420"
    },
    {
      id: "a4f79e44-64d8-4559-b616-c41d093a74bb",
      text: "B1 - DH-A - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1410"
    },
    {
      id: "8f84bfac-2d31-4436-8889-52d9ca3c3635",
      text: "Fab and Deliver - Cooling Distribution Unit - Area B - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2026-03-03T08:00:00",
      duration: 4112,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 0.09,
      source_task_id: "B2.OFCI.1900"
    },
    {
      id: "aed18f02-ad61-4e86-92cc-8a44725df702",
      text: "B1 - DH-B - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall B",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-31T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2890"
    },
    {
      id: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.1160"
    },
    {
      id: "41f23984-1504-46d5-b342-56ef67c1024b",
      text: "B1 - 1N2W - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1960"
    },
    {
      id: "14fe8d85-e744-4eb3-816d-a9b7a41f7f7a",
      text: "B1 - DH-A - BLDG-1 DH-A - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2025-11-03T08:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 0,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2620"
    },
    {
      id: "caad4353-1878-4ff3-a531-4c41e6c0519d",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [1] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 2392,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.44,
      source_task_id: "B1.OFCI.2050"
    },
    {
      id: "fe72916b-bb3d-4f46-b343-d4c1f4226bb4",
      text: "Area 5 - Mass Grading - Remainder Post Permit Delay",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: "2024-10-22T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A5.8020"
    },
    {
      id: "b5cad504-4c19-47d3-9504-84212010cfb7",
      text: "Fab and Deliver - Assembled Skids - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 2952,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.24,
      source_task_id: "B1.OFCI.2850"
    },
    {
      id: "ad416de4-3c9f-494d-88e0-4208e5a370fd",
      text: "B1 - 1N1W - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-07-17T08:00:00",
      duration: 80,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5460"
    },
    {
      id: "f2e17054-7851-4e08-bb8e-5043e5281c7d",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1580"
    },
    {
      id: "a340044a-a044-4363-a31b-a60c636f2ffb",
      text: "B2 - 2E2E - EF1 - Pour Pads Around Telecom Conduits (EF1)",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 48,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6180"
    },
    {
      id: "b57cc1f2-2e5e-4535-aff2-4d0bc5e98ad2",
      text: "Substation-1 - MSG A - MSG A Install Verification Inspection And Issue Resolution",
      type: 0,
      start_date: "2025-05-02T00:00:00",
      end_date: "2025-05-23T08:00:00",
      duration: 152,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3970"
    },
    {
      id: "68b39031-5d76-447e-adef-59107a454f6c",
      text: "ADMIN - Prep / Submit for Review - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-10-29T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6270"
    },
    {
      id: "631a9da3-4e12-4858-8213-16ceabad8397",
      text: "B2 - SSB - 2E1 - Common - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1100"
    },
    {
      id: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      text: "Start DCB1 EY2 MVS and PTX Equipment Pad Placement - DCB1",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-11T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1455"
    },
    {
      id: "302731fe-4cd0-44a3-8051-147a08a43a76",
      text: "Set Fixed Kitchen Equipment",
      type: 0,
      start_date: "2025-12-01T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1260"
    },
    {
      id: "d22e4cc3-dbd5-44e7-9680-7adb49857f16",
      text: "Final Clean - Above Ceiling per Specs",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 8,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1140"
    },
    {
      id: "7a320eae-aa57-425a-ae22-f8f43b8286f5",
      text: "B1 - DH-D - Hookup FCAs Mechanical- Data Hall D",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1130"
    },
    {
      id: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81",
      text: "B1 - DH-C - L2 CDU Install Verification - Data Hall C",
      type: 0,
      start_date: "2026-01-17T00:00:00",
      end_date: "2026-02-07T08:00:00",
      duration: 144,
      parent: "0346efe3-b63f-4628-9749-3c3592992deb",
      progress: 0,
      source_task_id: "B1.C.C.3085"
    },
    {
      id: "0bafdfde-72ea-4440-a561-3965b89a36bc",
      text: "B1 - SSB - 1E1 - CMDF1 - Pour Pads Around Telecom Conduits (Carrier MDF1)",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 48,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1640"
    },
    {
      id: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      text: "Placeholder - Predecessor",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-13T00:00:00",
      duration: 0,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "PRED"
    },
    {
      id: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5",
      text: "B2 - DH-C - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2026-05-26T00:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 160,
      parent: "51c00c83-bd57-417a-a005-a3275c0bb913",
      progress: 0,
      source_task_id: "B2.C.EY.1710"
    },
    {
      id: "7378c1dc-5884-4959-8d9b-fa6c59fbe29b",
      text: "Install CPT Tile",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1310"
    },
    {
      id: "bd6b2ce5-d103-40ab-92e5-def05736dae7",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1390"
    },
    {
      id: "b6bdf298-ffd9-47bf-91ec-b9960d916aa8",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area AN (1) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-04-18T08:00:00",
      duration: 2456,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.41,
      source_task_id: "B1.OFCI.2470"
    },
    {
      id: "22d64dfd-22a5-499b-9a9b-ed392e929ee5",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [4] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-03-24T08:00:00",
      duration: 2512,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.41,
      source_task_id: "B1.OFCI.3500"
    },
    {
      id: "37391e7e-c3d7-44f2-8045-e4dd1889d44d",
      text: "GSB - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2024-01-23T08:00:00",
      duration: 40,
      parent: "937a5c15-24b8-429b-aaf6-a66460890d40",
      progress: 1,
      source_task_id: "B1.OFCI.1080"
    },
    {
      id: "2862845a-7fac-4e26-9340-38d75a5894e8",
      text: "Finishes - Walls & Floors",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 24,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1050"
    },
    {
      id: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      text: "(OFCI) B1 PLC Panels",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2832,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.34,
      source_task_id: "7994971"
    },
    {
      id: "5b209e48-dd1f-4225-88bd-1502ae6551e6",
      text: "Area A - In Wall Rough Security",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1091"
    },
    {
      id: "7a92eae3-2638-416d-89b4-ab1f3f50dcb0",
      text: "B1 - Network Rooms - HAC Assembly Setting - NW1/4, NW2/3 (LOE)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1430"
    },
    {
      id: "244959fc-23c7-44b9-b0e6-c956bdd5945e",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Carpet",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-20T08:00:00",
      duration: 120,
      parent: "a186b242-b288-4250-b87d-d866ac28f219",
      progress: 0,
      source_task_id: "B1.CFCI.5110"
    },
    {
      id: "aa6a78f7-d6eb-4b90-896c-f58d01899073",
      text: "B2 - DH-B - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 80,
      parent: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      progress: 0,
      source_task_id: "B2.C.EY.1400"
    },
    {
      id: "6b1600de-c4dd-40df-8c6b-037320e91e8e",
      text: "B1 - DH-C - Install Lighting/Branch Conduit -Data Hall C",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2480"
    },
    {
      id: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      text: "DEC-C Ready: Production Cabling",
      type: 5,
      start_date: "2025-10-13T00:00:00",
      end_date: "2026-03-30T00:00:00",
      duration: 912,
      parent: "6265d63a-03f4-4699-a369-5fe6a59d94a5",
      progress: 0,
      source_task_id: "7995444"
    },
    {
      id: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      text: "B1 - DH-B - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 120,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3050"
    },
    {
      id: "0b2d4edc-0504-4883-ac3c-29318117328f",
      text: "B1 - DH-B - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 80,
      parent: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      progress: 0,
      source_task_id: "B1.C.B.3110"
    },
    {
      id: "771e9e6f-c882-4110-ad86-b3a340fc1f5b",
      text: "B1 - DH-B - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 80,
      parent: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      progress: 0,
      source_task_id: "B1.C.B.3130"
    },
    {
      id: "69a83544-4e6e-402f-be0d-e4b90e5b3ac3",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1720"
    },
    {
      id: "dbfeceab-f990-4193-8efd-0ef0cda93a8a",
      text: "B2 - DH-D - Connect Buss/Cable Tray Sections - Data Hall D",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2400"
    },
    {
      id: "c24bce5d-4c68-452d-925d-0be25fea015e",
      text: "Exterior Waterproofing",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1090"
    },
    {
      id: "7a5cd3b6-a925-43dd-9df1-20c410a102c6",
      text: "Substation-1 - A Lineup SF6 Breaker - Install High Voltage Cable / Install Verification / Pre-energization Checklist",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 128,
      parent: "aa22521b-48bf-4060-93d0-7750855b683f",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4180"
    },
    {
      id: "ca7ff64d-8bbf-4f5b-b35a-4e29f76db6f6",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Equipment Setting",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 80,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1090"
    },
    {
      id: "f35c623f-a74d-4e3e-ae38-c74d5b4f66aa",
      text: "B2 - DH-D - L2 CDU Pre-Eng Inspection - Data Hall D",
      type: 0,
      start_date: "2026-08-10T00:00:00",
      end_date: "2026-08-29T08:00:00",
      duration: 144,
      parent: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      progress: 0,
      source_task_id: "B2.C.D.3330"
    },
    {
      id: "7bc17825-c661-4bee-9b20-33801d49338b",
      text: "B1 - DH-A - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-02-24T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 120,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1210"
    },
    {
      id: "9710916a-6fea-462d-af55-06288c189947",
      text: "B1 - 1D1W - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1820"
    },
    {
      id: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4",
      text: "[DCB2] FacNet Live [Area C]",
      type: 0,
      start_date: "2026-10-14T08:00:00",
      end_date: "2026-10-14T08:00:00",
      duration: 0,
      parent: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      progress: 0,
      source_task_id: "ICM.B2.3647"
    },
    {
      id: "3dd3466e-0ee7-4d59-81d0-2319033b54df",
      text: "B1 - DH-D - Pull Feeders Bussways - Data Hall D",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1280"
    },
    {
      id: "8e199a5b-a211-4967-bc69-cb2cb0ac65de",
      text: "B1 - DH-C - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 48,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2250"
    },
    {
      id: "b1abd6b2-55fa-4947-9480-0769f73dcd30",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2460"
    },
    {
      id: "38b570aa-f1c1-4b79-9e11-bc6119e5d614",
      text: "B1 - mCUP-6 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6080"
    },
    {
      id: "07516109-843a-4834-b3b4-279a61ed5b1a",
      text: "Area 1 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-DCB1",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1090"
    },
    {
      id: "16ff0022-2c1e-4d62-84bc-4d25ed07c66e",
      text: "Area B - In Wall Rough Electrical",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1220"
    },
    {
      id: "55e03959-56ce-4429-881c-823715df79c8",
      text: "B2 - DH-B - L2 CDU Pre-Eng Inspection - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 144,
      parent: "d2bd53c0-cfe3-4110-8e81-f5665f925980",
      progress: 0,
      source_task_id: "B2.C.B.3290"
    },
    {
      id: "c9226b38-9346-4a61-922b-67e00a464dbd",
      text: "B1 - DH-A - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 192,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2310"
    },
    {
      id: "310f92cf-32c3-427c-8b32-c5f28ab15089",
      text: "B1 - 1C2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 120,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1990"
    },
    {
      id: "9482bac4-f768-4970-ad63-881ee69aeb7f",
      text: "B1 - Network Room 1/4 - Power Alley - Room Ready for Skids",
      type: 0,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1640"
    },
    {
      id: "c2712515-d233-47d4-ab35-a158eeac18dc",
      text: "IST Start DH D - DCB1",
      type: 0,
      start_date: "2026-08-24T00:00:00",
      end_date: "2026-08-24T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2184"
    },
    {
      id: "40a947ea-b2c2-46a6-a512-b24f940e157e",
      text: "Substation-1 B Lineup Vertical Work",
      type: 5,
      start_date: "2025-06-10T00:00:00",
      end_date: "2025-08-06T08:00:00",
      duration: 432,
      parent: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      progress: 0,
      source_task_id: "7995235"
    },
    {
      id: "39423d85-09da-4665-9168-25726a6a44fc",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 8,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1400"
    },
    {
      id: "5817ea83-22b4-4b0e-bdbf-50626227ada0",
      text: "Area 3 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-SSB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1570"
    },
    {
      id: "1ddcb752-9570-44b6-88c6-1d1b86dd0c7c",
      text: "Fab and Deliver - Control Power UPS - Area D - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2488,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 0.52,
      source_task_id: "B2.OFCI.2450"
    },
    {
      id: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85",
      text: "B2 - 2E2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 120,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6560"
    },
    {
      id: "217de0c3-abbe-46ce-87d6-37a30b52d505",
      text: "B2 - 2D1W - 02D.09 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-05-19T00:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1870"
    },
    {
      id: "4d632449-757e-42d0-af24-30435e124aef",
      text: "IST Start DH B - DCB2",
      type: 0,
      start_date: "2027-01-07T00:00:00",
      end_date: "2027-01-07T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2144"
    },
    {
      id: "1e68bea4-28a7-40f8-a493-aa3602dcec38",
      text: "B2 - DH-D - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 40,
      parent: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      progress: 0,
      source_task_id: "B2.C.EY.1760"
    },
    {
      id: "a95c75ca-c84d-45f7-855b-3467dc6edb17",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 80,
      parent: "9cab297d-c579-43de-9c0f-90c459f05a0d",
      progress: 0,
      source_task_id: "MECO-1260.50"
    },
    {
      id: "6f30688d-576a-4d35-b344-ba56257a494f",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "52d3af53-0515-442d-ae0a-d5ea0b3f489e",
      progress: 0,
      source_task_id: "MECO-1130.60"
    },
    {
      id: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      text: "CX Milestones",
      type: 5,
      start_date: "2026-06-24T08:00:00",
      end_date: "2027-03-30T08:00:00",
      duration: 1512,
      parent: "45fd1ece-f1fe-430f-97d2-91da4c830bb8",
      progress: 0,
      source_task_id: "7994995"
    },
    {
      id: "1d5bccf2-4375-4c8f-bfc0-cfd07432de0d",
      text: "B2 - mCUP-1-8 - Piping supports install (layout and vendor submittal confirmation) (Sequence 2)",
      type: 0,
      start_date: "2025-05-21T00:00:00",
      end_date: "2025-06-14T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1060"
    },
    {
      id: "1e1781f2-5393-47a7-bd2a-64c57adfd4b6",
      text: "B2 - DH-A - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2026-02-11T08:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 0,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1890"
    },
    {
      id: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      text: "B1 - SSB - 1E1 - GSMDF1 - Build Wall Between MDF/Fiber Entry and Carrier (Parent)",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 48,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1330"
    },
    {
      id: "99768851-4386-4804-890c-c18a20f078ff",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-E / 1-F - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-09-19T00:00:00",
      duration: 240,
      parent: "aaa0fbd3-c982-483f-83c9-aa6fc59b7f97",
      progress: 0,
      source_task_id: "B1.VDC.1500"
    },
    {
      id: "a4ea5949-5450-4bfb-88c8-41264315f483",
      text: "B2 - DH-B - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1880"
    },
    {
      id: "df547a39-5aeb-4ff3-a56c-02c56d13bec5",
      text: "FR 40 - DPR submitted LV Shop drawings (Tier-0 Underslab )",
      type: 0,
      start_date: "2024-11-08T00:00:00",
      end_date: null,
      duration: 0,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 1,
      source_task_id: "FR.40.1000"
    },
    {
      id: "b218df79-3f16-4f70-ae08-fa91e4e95874",
      text: "B1 - DH-A - Install Structural Steel",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 120,
      parent: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      progress: 0,
      source_task_id: "B1.C.STR.1790"
    },
    {
      id: "35f8862a-e544-42b7-a308-c23b212e7d90",
      text: "B1 - 1N2E - EF3 - Fire Alarm Wire Pulls/Terms to devices (EF3)",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 48,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5660"
    },
    {
      id: "3e05f150-c9a6-4d83-bbc4-250752106327",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2540"
    },
    {
      id: "a18cde12-ef8f-4633-ad31-4337e90ee1f2",
      text: "B1 - DH-B - Install Ceiling Devices - Lighting - Data Hall B",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2750"
    },
    {
      id: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      text: "(OFCI) B1 CDU Cooling Distribution Unit",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 3624,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.12,
      source_task_id: "7994979"
    },
    {
      id: "416e56f1-651a-42f2-b5e9-a5dc39061a55",
      text: "Substation-1 - Install Ground Grid / Excavate / Install / Inspections / Backfill - Sequence 2",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 120,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6210"
    },
    {
      id: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      text: "B2 - DH-C - Power Alley - Frame Walls",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.5010"
    },
    {
      id: "7c62768a-aa63-4990-a121-038315d2c3b0",
      text: "B1 - DH-C - Pull Feeders Bussways - Data Hall C",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2510"
    },
    {
      id: "5b52153d-4766-4358-8693-f95fc32925b5",
      text: "B1 - SSB - 1E1 - Common - Install Light Fixtures",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 80,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2060"
    },
    {
      id: "ff8762d0-f06d-4f2d-a558-754d08237efd",
      text: "B2 - DH-B - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 80,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1640"
    },
    {
      id: "71be5c41-0454-4bac-8971-6b8f2d2021a0",
      text: "OSP - B2 - Phase 5 (BEV to IDF Huts)",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 320,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995461"
    },
    {
      id: "504713b3-e1c8-415d-b748-c4372ff0382b",
      text: "B1 - DH-C - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 200,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1680"
    },
    {
      id: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      text: "Off Campus Utilty Work",
      type: 5,
      start_date: "2024-04-19T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 2864,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0.15,
      source_task_id: "7995152"
    },
    {
      id: "7e679c50-3ea1-4190-bbd1-fe56bf0e0097",
      text: "OSP",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995436"
    },
    {
      id: "94ad6811-c767-4392-a448-36a57456902a",
      text: "B2 - DH-A - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 240,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1100"
    },
    {
      id: "63a3c528-3960-46b2-82c2-76c8cc24f39f",
      text: "B1 - DH-D - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 96,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1650"
    },
    {
      id: "df62d19e-fb4e-443b-8a45-ddfaaf477694",
      text: "B1 - DH-D - Corpnet Provisioning",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 120,
      parent: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      progress: 0,
      source_task_id: "B1.CONN.1390"
    },
    {
      id: "b5ad5128-eebf-48f0-80cf-fab926f53225",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2460"
    },
    {
      id: "48ef2841-c4d6-4ab5-856d-56174516e12d",
      text: "B1 - Network Room 2/3 - In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1030"
    },
    {
      id: "ebe5993d-841c-4ccc-b2a6-6dc80951fe69",
      text: "Substantial Completion-No Weather - Bldg 1 - DH A",
      type: 0,
      start_date: "2026-06-24T08:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B1.MIL.1080"
    },
    {
      id: "30b30b3b-8ddd-48ec-a902-eb6df39052af",
      text: "B2 - DH-D - Pull/Term Fire Alarm - Data Hall D",
      type: 0,
      start_date: "2026-07-20T00:00:00",
      end_date: "2026-08-14T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2530"
    },
    {
      id: "7024a539-1e27-4d44-9394-cd0cb414b4f8",
      text: "B2 - mCUP-2 - Set in Place Inspections",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 8,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2030"
    },
    {
      id: "4f71cea6-1242-422e-b314-774cb4a09453",
      text: "Substation 1 Constuction Complete",
      type: 0,
      start_date: "2025-10-27T08:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1080"
    },
    {
      id: "9d0a37d9-829b-402b-b4fa-e91776d18818",
      text: "B1 - SSB - 1E1 - GSMDF1 - Hang/Tape/Finish Drywall for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-07T08:00:00",
      duration: 40,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "B1.C.SSB.1030"
    },
    {
      id: "f5687045-e840-4e35-a83a-988bd79c8da2",
      text: "B1 - 1C1W - 01C.08 - Lighting and Devices",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.2230"
    },
    {
      id: "59e7d533-0202-4d55-9b67-3defcf48ed34",
      text: "B2 - 2E1E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 160,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5440"
    },
    {
      id: "155b4250-7e35-4b94-a2be-2339d8ac64ef",
      text: "B1 - 1D1W - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1800"
    },
    {
      id: "ce31ca34-c9d8-4fda-8ec5-7c58e7dfe698",
      text: "DFSMA - DC1 - CUP 2- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-07-14T08:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1240"
    },
    {
      id: "4f33044f-a0d6-4ae1-b86b-473ded834021",
      text: "FR 07 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 1,
      source_task_id: "FR.07.1040"
    },
    {
      id: "ab40e558-979d-49bb-ac76-0d395322e733",
      text: "B2 - DH-D - Hookup FCAs Mechanical- Data Hall D",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-06-10T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1880"
    },
    {
      id: "628f8803-1627-4104-b2c6-c7487fb47dfc",
      text: "B1 - DH-A - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 80,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1140"
    },
    {
      id: "7468bb29-7277-4a01-9838-ea8fe978a6f1",
      text: "Area 4 - Electrical Connections to water meter",
      type: 0,
      start_date: "2025-04-04T00:00:00",
      end_date: null,
      duration: 48,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A4.8110"
    },
    {
      id: "38ebd75d-0cc7-4043-8a3e-58beeb90e070",
      text: "B1 - DH-D - Install Celing Devices BMS - Data Hall D",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1360"
    },
    {
      id: "50134eff-4018-4fb8-99f6-4ad4c56060be",
      text: "B1 - mCUP-8 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8060"
    },
    {
      id: "798899bb-65c9-4bd3-9511-f387cb56c42c",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Fire Suppression (AHJ)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-02T00:00:00",
      duration: 120,
      parent: "259cd2ff-2f2c-4882-8de7-0863b0131218",
      progress: 0,
      source_task_id: "B1.CFCI.3570"
    },
    {
      id: "e46a1b76-18a8-4bad-aa28-b45be9e9f2c2",
      text: "(CFCI) Div. 06 - Woods, Plastics & Composites",
      type: 5,
      start_date: "2024-08-12T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 1080,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994888"
    },
    {
      id: "23b10f07-b4fe-43f3-a565-d567bcaca24f",
      text: "[DCB1] DEC-C Ready: General Services [Area A]",
      type: 0,
      start_date: "2025-11-19T08:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3727"
    },
    {
      id: "43d6197c-7136-457b-9591-fd45d51df0cb",
      text: "B2 - 2A2 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1480"
    },
    {
      id: "45216dd4-2797-483a-9307-63633ec30356",
      text: "B1 - 1N2W - 01N2.06 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 144,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6110"
    },
    {
      id: "51d0027b-585e-4c3f-9f2f-0c3910e28559",
      text: "L5 - B2 DHD",
      type: 0,
      start_date: "2027-03-22T00:00:00",
      end_date: "2027-03-23T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX5.B2.DHD.1010"
    },
    {
      id: "3217259f-e02a-47f5-b0b4-01c6c0a67941",
      text: "B1 - DH-B - Steel (Hang Pre-Fab Racks- ROJ)(Converted to LOE)",
      type: 0,
      start_date: "2025-04-23T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 240,
      parent: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      progress: 0,
      source_task_id: "B1.C.STR.1810"
    },
    {
      id: "08bc72b3-5fac-44c0-a880-06a32319e9ad",
      text: "PTX & HPT - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 96,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 1,
      source_task_id: "B1.OFCI.1500"
    },
    {
      id: "bc36d2de-8620-4035-9890-1c2a9db20fb5",
      text: "Fab and Deliver - MVS-5WAY - Area B - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 2688,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.44,
      source_task_id: "B2.OFCI.2140"
    },
    {
      id: "bc4e71ca-2f27-47fb-8b3a-f6fe9d695d2c",
      text: "FR 08 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 1,
      source_task_id: "FR.08.1010"
    },
    {
      id: "94158ed9-67f1-4363-8e4e-738370d23654",
      text: "B1 - DH-C - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 560,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "B1.C.C.3050"
    },
    {
      id: "69fc4d02-ae4f-4d62-be16-c6a479ebd269",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2480"
    },
    {
      id: "1b2bff5a-55e7-41b1-98cd-623394979a5b",
      text: "B1 - Network Room 1/4  - Rough In Vesda",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1960"
    },
    {
      id: "7988ad95-6910-4038-8432-6e3a16f2aaef",
      text: "B1 - DH-A - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "55203d15-6a05-4636-aac5-eb996029b878",
      progress: 0,
      source_task_id: "B1.C.STR.2160"
    },
    {
      id: "d3d27037-5c6a-48a2-bc6f-4dc790721d91",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2180"
    },
    {
      id: "ebd73eea-8078-4c0b-b794-26a40ddde444",
      text: "B2 - DH-C - Corpnet Provisioning",
      type: 0,
      start_date: "2026-08-31T00:00:00",
      end_date: "2026-09-21T08:00:00",
      duration: 120,
      parent: "777e8c6e-a142-4273-82ed-e0333182df28",
      progress: 0,
      source_task_id: "B2.CONN.1210"
    },
    {
      id: "80358937-2b1a-41ae-aacb-c0cb4f862257",
      text: "B1 - DH-A - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 40,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1330"
    },
    {
      id: "630e51a9-595a-49bf-905c-cd4c1fd11f9b",
      text: "B1 - mCUP-7 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7060"
    },
    {
      id: "fcdc9db0-f28d-4d1f-abdb-f2d9ca1b45e7",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Electrical",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1060"
    },
    {
      id: "4e119cf9-d7f2-435a-b1c3-d2d11f8ab037",
      text: "B2 - DH-A - Install Grounding Loop - Data Hall A",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2670"
    },
    {
      id: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      text: "Campus Site Utilities - Area 3",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 1888,
      parent: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      progress: 0.27,
      source_task_id: "7995181"
    },
    {
      id: "3602a410-68ba-4154-8b20-3e149c2946bb",
      text: "B2 - ISP Cabling - EF to IDFD (UG)",
      type: 0,
      start_date: "2026-08-31T00:00:00",
      end_date: "2026-09-21T08:00:00",
      duration: 120,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1220"
    },
    {
      id: "a5d1bd50-5524-437e-ba9a-39a517e8a059",
      text: "Phase 1 - Cut/Fill and Establish Grade",
      type: 0,
      start_date: "2026-07-27T00:00:00",
      end_date: "2026-08-21T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1030"
    },
    {
      id: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      text: "Area 2 - Water Utilites Install",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-11-21T08:00:00",
      duration: 40,
      parent: "4799154d-3ba9-4bfd-a5a9-d8909449ccb7",
      progress: 0,
      source_task_id: "C.CSU.A2.5000"
    },
    {
      id: "b7c33fc5-0abe-4837-beb7-2a4c40a39f3d",
      text: "Underground Utilities - Area B - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1160"
    },
    {
      id: "d08b3fe3-cba3-47bc-b2ec-a561d0c417a2",
      text: "B2 - 2E2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6050"
    },
    {
      id: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      text: "B2 - SSB - 2E2 - Common - Hang/Tape/Finish Drywall Ceiling",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1770"
    },
    {
      id: "42a0929b-62e9-4588-849e-1a190a3d5d20",
      text: "B1 - mCUP-8 - Set in Place Inspections",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 8,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8030"
    },
    {
      id: "a7b59d79-4b62-41b0-9a7d-ec02e3d7694e",
      text: "Grout Baseplates",
      type: 0,
      start_date: "2025-03-20T00:00:00",
      end_date: "2025-03-26T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1030"
    },
    {
      id: "4b7f47b0-c8b9-41da-93d4-160f9939bca6",
      text: "B1 - Network Room 2/3 - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.2010"
    },
    {
      id: "c27b7e3d-e182-4a92-9928-9c5c4cc081d7",
      text: "NWS Electrical Yard Skids",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994822"
    },
    {
      id: "28038e7c-fa7e-49a7-aafe-f1daa8bef830",
      text: "Initial Procurement Plan Approved (update schedule with agreed upon dates)",
      type: 0,
      start_date: "2023-12-08T08:00:00",
      end_date: "2023-12-08T08:00:00",
      duration: 0,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "ICM.PRE.1400"
    },
    {
      id: "d29c0288-e508-426c-a0f9-b9eb1593a4ca",
      text: "Area 2 - UG RI -Switchboard (SB)-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1330"
    },
    {
      id: "4a7345b9-e113-4c51-9023-864b5f92c511",
      text: "B2 - DH-D - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 80,
      parent: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      progress: 0,
      source_task_id: "B2.C.EY.1520"
    },
    {
      id: "87d7627d-0383-44e9-9664-e7020c334452",
      text: "Place / Cure SOG",
      type: 0,
      start_date: "2025-07-01T00:00:00",
      end_date: "2025-07-08T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1050"
    },
    {
      id: "8e622819-a993-4900-a9f7-128ffbb661a4",
      text: "B2 - 2B1 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1720"
    },
    {
      id: "e1a50cf9-01c9-40e3-82ee-86c74229ea77",
      text: "B2 - mCUP-3 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 48,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3040"
    },
    {
      id: "fb7329ef-47ef-4557-85d3-161d3d7e5d03",
      text: "FGMP Issuance",
      type: 0,
      start_date: "2024-06-07T08:00:00",
      end_date: "2024-06-07T08:00:00",
      duration: 0,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2400"
    },
    {
      id: "2129f2fa-37a3-4fd0-b52d-3aa1a5c0bb6c",
      text: "MVS - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 1,
      source_task_id: "B1.OFCI.1470"
    },
    {
      id: "4574a98d-1bb7-4e8e-a726-f5294d913b8e",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2180"
    },
    {
      id: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea",
      text: "B1 - SSB - 1E2 - Common - Point-Up Drywall",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 64,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2360"
    },
    {
      id: "72311a6f-7112-488b-83e2-719c937c7f6c",
      text: "Start DCB2  EY1 MVS and PTX Equipment Pad Placement",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-10-29T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1435"
    },
    {
      id: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      text: "Substation-2 Transformer B Work",
      type: 5,
      start_date: "2025-07-01T00:00:00",
      end_date: "2026-04-11T08:00:00",
      duration: 2000,
      parent: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      progress: 0,
      source_task_id: "7995225"
    },
    {
      id: "2b210983-46a3-4c16-8a63-bf0c2ef06ffa",
      text: "B2 - mCUP-1-8 - Piping Install (Header Mcup 1-4)",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 120,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1100"
    },
    {
      id: "db47be10-b43b-4041-a357-38d06318db19",
      text: "Adverse Weather Event 11 - 09.30.2024  (Hurricane Helene)",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1011"
    },
    {
      id: "4e349ed9-c1eb-458b-b82d-0ea8510cd35e",
      text: "B1 - 1N1W - 01N1.07 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.5580"
    },
    {
      id: "99158f91-c77d-4c83-ae70-8126f7d2d04c",
      text: "BLDG-1/2 - Submittals - Finished Carpentry (Millwork/Countertops)",
      type: 0,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 160,
      parent: "450e7e94-6054-44b6-b556-c3c644e90ee4",
      progress: 0,
      source_task_id: "B1.CFCI.4450"
    },
    {
      id: "ae2bab53-e1d4-4395-8ca9-6c3a7a61cbc3",
      text: "B1 - DH-A - Install Feeder Conduit -Data Hall A",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2420"
    },
    {
      id: "5896d681-5ae2-4a70-ad65-2b2f88abdd23",
      text: "B1 - DH-C - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 80,
      parent: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      progress: 0,
      source_task_id: "B1.C.C.3090"
    },
    {
      id: "b557678c-5c21-4537-be28-fde8b1584424",
      text: "B2 - DH-C - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2026-05-26T00:00:00",
      end_date: "2026-06-08T08:00:00",
      duration: 80,
      parent: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      progress: 0,
      source_task_id: "B2.C.EY.1720"
    },
    {
      id: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb",
      text: "B1 - DH-A - Install Coping",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 80,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1380"
    },
    {
      id: "9fb307c9-6e4a-4b11-8b14-f67fa1e9a58e",
      text: "Security - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5820"
    },
    {
      id: "51ca251c-ab79-4e40-ad49-4330d374b341",
      text: "B2 - 2D1 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1160"
    },
    {
      id: "0e58febc-6d94-471f-a129-7e827930d4f5",
      text: "B1 - Network - Precast",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 80,
      parent: "4b2b452c-c32b-48b9-93c6-5bdc5902ce40",
      progress: 0,
      source_task_id: "B1.C.1670"
    },
    {
      id: "52247695-583d-420e-809e-ab1bacfff342",
      text: "B1 - SSB - 1E1 - Common - Frame Walls (Top-out included)",
      type: 0,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 96,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1000"
    },
    {
      id: "d0c4467c-6b1f-4e2b-b677-05a6d83ddbfe",
      text: "Adverse Weather Event 4 - 07.29.2024",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: null,
      duration: 8,
      parent: null,
      progress: 1,
      source_task_id: "WX.1004"
    },
    {
      id: "899e114e-67d1-4001-9bb4-8031ee08bd20",
      text: "B2 - DH-B - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 80,
      parent: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      progress: 0,
      source_task_id: "B2.C.EY.1370"
    },
    {
      id: "66ba46ef-2388-46b6-a81d-dc43fad79eb4",
      text: "FR 14 - DPR Prepare and Submit PCO#10",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 504,
      parent: "abce5df4-8ee4-4f0a-85e7-22726c1c832f",
      progress: 1,
      source_task_id: "FR.14.1190"
    },
    {
      id: "2a5fa159-fa84-4e4f-9f2c-d3b5cbbdb512",
      text: "IBOS - Prep / Submit for Review - Signage",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6090"
    },
    {
      id: "999a5b37-388c-4556-9e66-cefd7cb0cf85",
      text: "B2 - SSB - Install Coping",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-17T08:00:00",
      duration: 80,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1280"
    },
    {
      id: "14e14d87-a920-442a-ad0a-ba71d1b2dced",
      text: "Area A - Specialties",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 16,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1251"
    },
    {
      id: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      text: "Campus - Fabricate / Deliver - Sanitary Manholes and Inlets (Early Release) - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-06-03T00:00:00",
      end_date: "2024-07-15T08:00:00",
      duration: 240,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 0.5,
      source_task_id: "B1.CFCI.5880"
    },
    {
      id: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      text: "B1 - DH-D - Cure for SOG",
      type: 0,
      start_date: "2025-08-17T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      progress: 0,
      source_task_id: "B1.C.STR.2370"
    },
    {
      id: "2a45531e-2d53-4926-9c51-38cb8f4abf65",
      text: "B1 - DH-D - Install 800 Amp Busway - Data Hall D",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1150"
    },
    {
      id: "986de551-c44a-46a7-bf13-0aa72e9b9343",
      text: "B1 - DH-A - Foundations",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-20T08:00:00",
      duration: 144,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1040"
    },
    {
      id: "0b9d31c6-1031-4830-9028-c8fd13ab522d",
      text: "B1 - DH-B - Power Alley - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 48,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2550"
    },
    {
      id: "91dbf219-bc2a-4889-b5ad-11122a59714c",
      text: "B2 - DH-A - Install Underground Security",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 80,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1280"
    },
    {
      id: "33b66c03-5d4f-41d0-9e72-ad3eec5e406a",
      text: "B2 - 2E1E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5050"
    },
    {
      id: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 288,
      parent: "dc9d54b4-6bc7-43d7-a650-493ee562fdd5",
      progress: 0,
      source_task_id: "7995120"
    },
    {
      id: "2091ad73-f72d-4add-bcc0-88da115186f3",
      text: "B1 - DH-C - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area C",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 120,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "B1.C.C.3040"
    },
    {
      id: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3",
      text: "Balance of Trades SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-01T00:00:00",
      duration: 160,
      parent: "34506e78-7808-45bd-a08a-14f00001a7a8",
      progress: 0,
      source_task_id: "PRE1840"
    },
    {
      id: "eaf2f66d-62ed-4333-9656-a42c1e2ecb58",
      text: "(CFCI) Div. 23 - HVAC Materials and Equip.",
      type: 5,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 320,
      parent: "68eac5c6-f18e-45f7-880e-8d00154eca77",
      progress: 0,
      source_task_id: "7994902"
    },
    {
      id: "3bc7952a-d10c-47c9-ae3c-36045e2a7d93",
      text: "Substation-2 - MSG B - Control Power And EPMS Dead Bus Checkout",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-03-30T08:00:00",
      duration: 80,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4440"
    },
    {
      id: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 160,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1750"
    },
    {
      id: "b1aacda7-73fc-4e5f-854e-a3998d0b283f",
      text: "Area 2 - UG RI -Substation Feeds-Campus",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1230"
    },
    {
      id: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4",
      text: "B2 - DH-B - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 160,
      parent: "9dd203bd-63ed-4bf3-9539-c32d33cefaad",
      progress: 0,
      source_task_id: "B2.C.EY.1450"
    },
    {
      id: "7093ee6d-ed4a-49f7-a0d5-4a18d258d64e",
      text: "Admin - Mass Timber Procurement / Manufacturing",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 680,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1100"
    },
    {
      id: "edea1c7a-1f89-470d-8315-4b4954e2b629",
      text: "Roofing SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-06-06T00:00:00",
      end_date: "2024-07-12T08:00:00",
      duration: 160,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 0.95,
      source_task_id: "PRE1620"
    },
    {
      id: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456",
      text: "B1 - Network Room 1/4 - Power Alley - Set UPS's/STC's",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 40,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1750"
    },
    {
      id: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a",
      text: "B2 - SSB - Install Underground Telecom",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1150"
    },
    {
      id: "bf8bdde0-b2c0-4334-b770-2740dd083778",
      text: "B1 - Network - El Equip Yd - Pull Cable from MSB to Generator",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 40,
      parent: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      progress: 0,
      source_task_id: "B1.C.EY.1130"
    },
    {
      id: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf",
      text: "B1 - DH-D - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      progress: 0,
      source_task_id: "B1.C.STR.2330"
    },
    {
      id: "07597252-10db-4c9b-8c6a-3b80dfe714fb",
      text: "Substation-1 - TX B - Energization",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 8,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3780"
    },
    {
      id: "20b6c790-7b5f-416b-9f62-a1868cdd485f",
      text: "B1 - SSB - 1E1 - EF1 - In Wall Rough-In/ Inspections (EF1)",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 48,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1440"
    },
    {
      id: "d14a358f-2714-4b4f-b825-f2a228c80002",
      text: "(CFCI) Div. 05 - Structural Steel",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2025-05-12T08:00:00",
      duration: 1664,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0.09,
      source_task_id: "7994922"
    },
    {
      id: "dbf81c80-5ba4-4080-9975-73995bc6fe50",
      text: "B1 - SSB - 1E2 - EF2 - Fire Alarm Wire Pulls/Terms to devices (EF2)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 48,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1800"
    },
    {
      id: "8e85a57a-7801-4bf1-8705-771cb893951d",
      text: "CRAH - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-01-09T00:00:00",
      end_date: "2024-01-09T00:00:00",
      duration: 0,
      parent: "cebac7a2-3c43-4d53-bc0b-02c1d6553116",
      progress: 1,
      source_task_id: "B1.OFCI.1520"
    },
    {
      id: "b88b495a-90d4-4925-8e8b-857c4c293886",
      text: "Building 1",
      type: 5,
      start_date: "2024-11-18T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 3248,
      parent: "abe1a98c-028c-44b8-8da7-9658d12e1819",
      progress: 0,
      source_task_id: "7995249"
    },
    {
      id: "0b3995c7-15f1-4301-a795-2c3e168d2c6b",
      text: "B1 - Network Room 2/3 - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 24,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1310"
    },
    {
      id: "bb462a17-ba38-4cb3-b0cd-4caa8b84d7b7",
      text: "BLDG-1/2 - Fabricate / Deliver - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 160,
      parent: "5ed9bec7-54c7-4156-b0c1-7ceb6eb0515a",
      progress: 0,
      source_task_id: "B1.CFCI.5060"
    },
    {
      id: "1c91e947-3011-427b-a657-a2d71bd06bf1",
      text: "B2 - DH-D - Pull Feeders Bussways - Data Hall D",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-31T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2480"
    },
    {
      id: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9",
      text: "B2 - DH-D - Set CDU's - Data Hall D (16 total; 4 per day)",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 64,
      parent: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      progress: 0,
      source_task_id: "B2.C.D.3300"
    },
    {
      id: "1c1a1af7-4a0d-4d2d-aac1-1a3d6a0b0876",
      text: "Area 5 - UG RI -Panel Boards (PB)-SSB1",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1890"
    },
    {
      id: "4fb70027-0210-4b7b-bbed-e3fee42f9358",
      text: "B1 - Network Room 1/4 - FCA Gallery - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 0,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1410"
    },
    {
      id: "ea689582-9d51-496e-b534-36c3c65ac960",
      text: "B1 - mCUP-5 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 16,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5010"
    },
    {
      id: "4f4f527f-f123-4699-b4d2-dcb0fd0c1c6e",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2050"
    },
    {
      id: "cdb770a0-3e26-4554-9542-71296c77983c",
      text: "B1 - DH-A - Install Cable Tray - Data Hall A",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2110"
    },
    {
      id: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      text: "(OFCI) B2 mCUP",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 3304,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.35,
      source_task_id: "7994944"
    },
    {
      id: "071cf308-1ae1-457e-99c2-c6d91e0e1672",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1170"
    },
    {
      id: "36b087b6-3ffb-4aea-873b-73cacb04dbd0",
      text: "(CFCI) Div. 03 - Concrete",
      type: 5,
      start_date: "2024-06-03T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 1384,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994849"
    },
    {
      id: "51a8b01c-29fe-4065-a1d4-8ba3d6a4eeda",
      text: "Fab and Deliver - MSB - Area C - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 3288,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.37,
      source_task_id: "B1.OFCI.3730"
    },
    {
      id: "9f7deb23-ffb9-41d7-b3d2-ccf84544ca09",
      text: "Campus PH1 - Review for Approval - MV Vaults (SIte)",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-09-16T00:00:00",
      duration: 40,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0,
      source_task_id: "B1.CFCI.5990"
    },
    {
      id: "da79f507-1c3f-4ca4-ac94-7c99b6ec5c5c",
      text: "B2 - DH-B - Hookup CDU's - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 144,
      parent: "d2bd53c0-cfe3-4110-8e81-f5665f925980",
      progress: 0,
      source_task_id: "B2.C.B.3270"
    },
    {
      id: "84578b5c-1cdd-4361-8b5a-5000093df4c1",
      text: "[DCB2] DEC-C Ready: Overhead cable tray complete [Area C]",
      type: 0,
      start_date: "2026-08-11T08:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3845"
    },
    {
      id: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      text: "MSB/RSB - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 1,
      source_task_id: "B1.OFCI.1020"
    },
    {
      id: "fef30f96-a3fa-40f1-a987-e843a4234462",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-N - Coordination / Sign-off",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: "2024-09-17T08:00:00",
      duration: 240,
      parent: "025f7736-8841-42ad-887c-bb57088ea671",
      progress: 0,
      source_task_id: "B1.VDC.1520"
    },
    {
      id: "c24910e2-0e08-4555-90b6-fb591bcaa902",
      text: "B1 - DH-A - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 80,
      parent: "7ff8dfca-7821-49f8-b06e-76059e0f610b",
      progress: 0,
      source_task_id: "B1.C.A.2840"
    },
    {
      id: "794b4bc4-ebbd-4019-9768-e30e6b6da046",
      text: "B1 - 1A2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1460"
    },
    {
      id: "61807e5c-16ed-443c-81dd-a36d98ef965d",
      text: "FR 02 - Additional Civil Permit Review Time - City Review Comments & Approve",
      type: 0,
      start_date: "2024-06-17T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 80,
      parent: "f5cede49-5629-40ad-881c-25df81197815",
      progress: 0.66,
      source_task_id: "FR.02.1040"
    },
    {
      id: "82087812-361d-45ba-b343-21f3c945ca1d",
      text: "B2 - DH-C - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1330"
    },
    {
      id: "9717de69-6e06-4c10-806d-cce273f98818",
      text: "DFSMA - DC1 - CUP 8- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-08-25T08:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1300"
    },
    {
      id: "ecadcba1-0758-4b78-84c2-9467c790eaf2",
      text: "Area 1 - MV Electric Install - Priority for Foundations (Sub to MV Loop) - Concrete Scope",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 136,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A1.8060"
    },
    {
      id: "ea63c6a5-2919-486e-a1e3-78134aadb1d7",
      text: "BLDG-1/2 - (SPW-Div 10) Submittals - Finished Carpentry (FRP)",
      type: 0,
      start_date: "2025-06-23T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 160,
      parent: "fadc8646-4b3d-42bf-ba2e-1d5f36c3c8bc",
      progress: 0,
      source_task_id: "B1.CFCI.3690"
    },
    {
      id: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a",
      text: "B1 - 1C1W - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 120,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.2390"
    },
    {
      id: "a1f79bb1-c893-476b-8ab9-10ef5259f2ad",
      text: "B2 - DH-A - Install Ceiling Tiles - Data Hall A",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 40,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2650"
    },
    {
      id: "88e827a6-307b-4432-b687-23df5d182744",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 160,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2280"
    },
    {
      id: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      text: "B2 - DH-D - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 120,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1420"
    },
    {
      id: "aa4b40eb-3ac8-4136-abe1-fe2f5baa0710",
      text: "Drywall  Metal Studs SA - Meta Authorized",
      type: 0,
      start_date: "2024-06-20T00:00:00",
      end_date: "2024-06-20T00:00:00",
      duration: 0,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 0,
      source_task_id: "ICM.PRE.1455"
    },
    {
      id: "6d617624-6758-4414-b292-5cbc0249c40d",
      text: "B1 - 1N2E - 01N3.06 - Lighting and Devices",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6400"
    },
    {
      id: "939d4020-9def-41d4-b828-539db572d917",
      text: "B1 - 1N2W - 01N2.06 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.5950"
    },
    {
      id: "f4819789-6f1c-4aec-8732-6b7c68084d5b",
      text: "In Wall Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 40,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1130"
    },
    {
      id: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      text: "B1 - SSB - 1E1 - CMDF1 - Punchwalk and Handover Entrance Facility DEC-C Ready (Carrier MDF1)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 8,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.2020"
    },
    {
      id: "d5033bbc-0b77-4713-81b2-0015044edc5d",
      text: "BLDG-2 DH-C - L2 Checkout for Building",
      type: 0,
      start_date: "2026-09-23T00:00:00",
      end_date: "2026-10-27T08:00:00",
      duration: 200,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1030"
    },
    {
      id: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      text: "B2 - DH-A - Cure for SOG",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 24,
      parent: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      progress: 0,
      source_task_id: "B2.C.STR.2170"
    },
    {
      id: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd",
      text: "B2 - mCUP-7 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7020"
    },
    {
      id: "98c13818-11ac-4bb8-849c-5ab4193c0b0f",
      text: "Substation-1 - Pull and Term Substation to MSG Building 1 B/D (Pull to Vaults) - Sequence 1",
      type: 0,
      start_date: "2025-06-28T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 160,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3030"
    },
    {
      id: "c5f7dba8-1afc-4b33-ae74-a80395e92934",
      text: "DFSMA - DC1 DHD HAC ROJ - MOFE",
      type: 0,
      start_date: "2025-11-07T08:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 0,
      parent: "86efc612-6e21-491b-98fc-5aba04020712",
      progress: 0,
      source_task_id: "B1.DFSMA.1080"
    },
    {
      id: "6ae75282-cd52-4d4f-9747-727282508b0c",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-25T08:00:00",
      duration: 64,
      parent: "9cab297d-c579-43de-9c0f-90c459f05a0d",
      progress: 0,
      source_task_id: "MECO-1060.50"
    },
    {
      id: "96632964-43a4-401f-999e-37fdc318544b",
      text: "IBOS-  Fabricate / Deliver - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-11-26T00:00:00",
      end_date: "2024-12-04T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6080"
    },
    {
      id: "365dce18-115a-4607-bfa0-a56b4b4e74e1",
      text: "Area 5 - UG RI -Panel Boards (PB)-SSB2",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1930"
    },
    {
      id: "9e67a8f1-af87-4101-901d-98f7d1bcce62",
      text: "Campus - Submittal Review & Approval - Fencing",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-02-12T08:00:00",
      duration: 120,
      parent: "2390c294-1245-4d73-85bc-b779088085b9",
      progress: 0,
      source_task_id: "B1.CFCI.4480"
    },
    {
      id: "31c5aed9-cfd0-4672-979f-05ce60279037",
      text: "Fab and Deliver - PLC Panels - Area C - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 3760,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.15,
      source_task_id: "B2.OFCI.1850"
    },
    {
      id: "63761fea-9e85-4199-94d6-50b80f6eff1d",
      text: "BLDG-1 - BIM - Tier 1 - iBOS - Coordination / Sign-off",
      type: 0,
      start_date: "2024-08-14T00:00:00",
      end_date: "2024-08-28T08:00:00",
      duration: 240,
      parent: "17f7bc24-cabe-4894-87dd-c247c97c43ef",
      progress: 0,
      source_task_id: "B1.VDC.1710"
    },
    {
      id: "8174fd4d-f135-4ba3-9623-a7c312e6164a",
      text: "B1 - DH-A - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-07-10T08:00:00",
      duration: 40,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1120"
    },
    {
      id: "ea0de3c5-d25b-4e5d-93d9-a4baa884db3b",
      text: "Campus - Submittals - Sanitary Manholes and Inlets (Early Release) - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-05-16T00:00:00",
      end_date: "2024-05-30T08:00:00",
      duration: 80,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5860"
    },
    {
      id: "70a3e62d-12a1-4ab7-988f-fc5c250b2b1d",
      text: "B2 - DH-C - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-28T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 16,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1590"
    },
    {
      id: "cec8a63a-3153-445d-aeb7-cc2c33e5af85",
      text: "B2 - 2E1E - 02.01.E1.01 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5550"
    },
    {
      id: "8d31128e-9113-4bd3-aa9d-a336011a7b05",
      text: "B1 - DH-B - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 80,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1190"
    },
    {
      id: "7f296027-5418-4f4a-a3e6-c4004bcb7ec8",
      text: "Fire Supression - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-06-18T00:00:00",
      end_date: "2024-07-01T08:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0.4,
      source_task_id: "Design.PreC.5060"
    },
    {
      id: "eb8f6678-2b34-4925-92ac-2ba124fb9f12",
      text: "FR 22 - META Issues CCD #37",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 0,
      parent: "6b393e4a-958e-4ac9-bb16-32b3eacbeb11",
      progress: 1,
      source_task_id: "FR.22.1000"
    },
    {
      id: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f",
      text: "B1 - mCUP-4 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4070"
    },
    {
      id: "3084302a-c4fb-42bb-8ade-d9205702469e",
      text: "B2 - 2D1 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 8,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1400"
    },
    {
      id: "5cc7e252-0392-492b-8525-3cd43e06ffa9",
      text: "B1 - DH-A - Install Ceiling Devices - Lighting - Data Hall A",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2610"
    },
    {
      id: "6f9a426c-7f48-434e-ab76-ef844e171819",
      text: "B2 - DH-D - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 80,
      parent: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      progress: 0,
      source_task_id: "B2.C.EY.1510"
    },
    {
      id: "ab33c3e1-21fe-4e93-a1ee-9e43e843ebe5",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [7] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-12-23T08:00:00",
      duration: 1760,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.59,
      source_task_id: "B1.OFCI.2140"
    },
    {
      id: "3b9ab8ce-ac79-49e1-9b68-a00b573d4ce9",
      text: "B2 - DH-C - Foundations",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 120,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1170"
    },
    {
      id: "a897a98f-1542-4d71-8a7e-da8fc7597811",
      text: "Area 2 - Fire Water Install, Telecom offsets",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: "2024-11-01T08:00:00",
      duration: 96,
      parent: "f4555b14-34b1-40f7-b4ba-d44218efa144",
      progress: 0,
      source_task_id: "C.CSU.A2.4000"
    },
    {
      id: "d7dfc095-f783-4305-84e3-9e98d1ddb84b",
      text: "Deep Underground - Electrical",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 80,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1090"
    },
    {
      id: "ac7067c5-84d2-40b2-8dad-e4a29c924c6e",
      text: "B2 - mCUP-5 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5050"
    },
    {
      id: "4182d51a-8148-423b-bac4-1b9d91a8d69c",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 8,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1330"
    },
    {
      id: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1",
      text: "B2 - DH-A - Set CDU's - Data Hall A (16 total; 4 per day)",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-21T08:00:00",
      duration: 64,
      parent: "560c76d0-46ee-4116-9c68-58099187fdb2",
      progress: 0,
      source_task_id: "B2.C.A.3180"
    },
    {
      id: "7532238e-3647-45de-b131-f44f81d631d1",
      text: "B2 - DH-B - El Equip Yd - Pour Pads (MSG ONLY) Needs steel to go by",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 120,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1040"
    },
    {
      id: "c36183eb-2212-468d-8303-83d270b980f2",
      text: "FR 40 - DPR/ Miller Meet with VERTIV (OFCI Vendor)",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: null,
      duration: 8,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1030"
    },
    {
      id: "12f2bac7-8d1b-4970-b4e0-3aa5e3f714bd",
      text: "B1 - DH-A - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 80,
      parent: "bbb49ac4-d9a7-4848-87c0-a96e61e2e9d9",
      progress: 0,
      source_task_id: "B1.C.A.2870"
    },
    {
      id: "6a6ff9fa-7b66-47b2-87b5-2e069a950edb",
      text: "Substation-2 - B Lineup SF6 Breaker - Set Breaker",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 8,
      parent: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4550"
    },
    {
      id: "3991cbac-00d3-48a9-82eb-22134e507401",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1490"
    },
    {
      id: "7c667fef-461d-49e7-92f6-3ef47796ec0e",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Fire Sprinkler",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1670"
    },
    {
      id: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      text: "Interior Construction",
      type: 5,
      start_date: "2025-05-12T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 2008,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995271"
    },
    {
      id: "52fe1192-f057-4287-a06e-48b6e9cf0bb4",
      text: "B2 - 2B1 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 120,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1000"
    },
    {
      id: "0a84fa40-786a-4c7b-a359-5a951849a6bc",
      text: "B2 - DH-A - Set CDU's - Data Hall A (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 64,
      parent: "813899cd-a520-4613-8209-38f409169670",
      progress: 0,
      source_task_id: "B2.C.A.3220"
    },
    {
      id: "91934193-29f3-4677-9b89-832aaad7d820",
      text: "[DCB1] DEC-C Ready: Production Cabling [Area C]",
      type: 0,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3547"
    },
    {
      id: "cdda8015-5445-4e44-a65c-5da4459cc8df",
      text: "Set MSB & Panels",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 40,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1160"
    },
    {
      id: "eb274a3e-7052-45e0-8dc8-83f4c9b453f4",
      text: "Supports for Kitchen Hood",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1040"
    },
    {
      id: "5a5139c4-6996-4326-916f-82881d96e397",
      text: "BLDG-1/2 - Prep / Submit for Rvw - Structural Steel (Joists)",
      type: 0,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-08-01T08:00:00",
      duration: 224,
      parent: "b4e5b7c9-5a36-4201-8305-5ac89568c3ba",
      progress: 0.55,
      source_task_id: "B1.CFCI.3040"
    },
    {
      id: "5c788524-2553-452e-84b3-e22e7b7ba7ad",
      text: "(OFCI) B2 Load Bank",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 2792,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.45,
      source_task_id: "7994965"
    },
    {
      id: "8511dc97-c3c7-4750-8595-9ff466cf02c9",
      text: "B1 - mCUP-2 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 48,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2000"
    },
    {
      id: "5d1d3835-af93-4615-b481-7ed2c7075bf8",
      text: "B2 - mCUP-8 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8130"
    },
    {
      id: "75277f54-f829-477f-a3db-c76d591c2d79",
      text: "B2 - SSB - Lightning Protection",
      type: 0,
      start_date: "2026-01-20T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B2.C.RF.1400"
    },
    {
      id: "29ef6d5b-0fe1-4b38-a371-e70ef05d6544",
      text: "B1 - 1N1E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1110"
    },
    {
      id: "8034fd5c-7eb1-4d2a-90df-7467368b8dd5",
      text: "FR 11 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: null,
      duration: 0,
      parent: "2403d63f-04cd-4715-83a5-98a037fa1f56",
      progress: 1,
      source_task_id: "FR.11.1040"
    },
    {
      id: "6a8be261-5c5f-41a0-9142-f7d2d4155195",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1280"
    },
    {
      id: "e1448107-e106-40b0-bad3-e45d5fd95790",
      text: "B2 - West Entrance - Install Main irrigation",
      type: 0,
      start_date: "2026-05-11T00:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1090"
    },
    {
      id: "eeac0a3c-cfc1-4dd1-9201-0aa3a98b96e7",
      text: "Fab and Deliver - Control Power UPS - Area B - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2248,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.5,
      source_task_id: "B1.OFCI.3110"
    },
    {
      id: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad",
      text: "B2 - 2E1E - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 160,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5240"
    },
    {
      id: "efcd15ea-dcd3-47a4-a25e-f864b38838d9",
      text: "B2 - DH-A - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1100"
    },
    {
      id: "bf431cb9-c7ad-457d-989a-6f8a962d017c",
      text: "B1 - DH-C - Grout Column Basepletes",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 48,
      parent: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      progress: 0,
      source_task_id: "B1.C.STR.2230"
    },
    {
      id: "624ef655-c92e-43ec-b894-256bdbec4852",
      text: "B1 - DH-B - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 16,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1870"
    },
    {
      id: "ad3c4987-3244-4e4c-b67c-f324be13360c",
      text: "Final Paint",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1370"
    },
    {
      id: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      text: "Interior Construction",
      type: 5,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 480,
      parent: "39855758-26c2-45c7-8a00-84dc36793e26",
      progress: 0,
      source_task_id: "8147636"
    },
    {
      id: "44eb5560-a427-4685-a8d9-0903ab91829f",
      text: "B1 - Network Room 1/4 - Power Alley - Facility Water Rough in",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1600"
    },
    {
      id: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1",
      text: "Substantial Completion (DH A) - DCB1",
      type: 0,
      start_date: "2026-08-03T08:00:00",
      end_date: "2026-08-03T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.B1.1080"
    },
    {
      id: "1317a852-2a15-4509-a382-645cba63e528",
      text: "Install Doors & Hardware",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 64,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1360"
    },
    {
      id: "1a22ad96-5141-4656-b61b-78c924924007",
      text: "B1 - DH-D - DEC -C Turnover Walk - Data Hall D",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-03-28T08:00:00",
      duration: 16,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1450"
    },
    {
      id: "fa7c6ea4-d312-44f8-a93c-cf51af232331",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2440"
    },
    {
      id: "3c7e11fd-8e72-453d-9652-3239d4518993",
      text: "B1 - DH-D - Connect Buss/Cable Tray Sections - Data Hall D",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1220"
    },
    {
      id: "412d2c94-a09f-43ff-b373-c84f4d6ab8db",
      text: "CDU - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 1,
      source_task_id: "B1.OFCI.1600"
    },
    {
      id: "91520a4a-d795-4ef1-a8dd-bbca46f31c00",
      text: "B2 - mCUP-3 - L2 Inspections",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3130"
    },
    {
      id: "3dad5883-0038-409a-9d17-1854e369f85d",
      text: "B1 - 1C1W - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 8,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1200"
    },
    {
      id: "27abf7c4-7581-44b0-bb63-47380f9a65f1",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Roofing",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 120,
      parent: "1cd8272e-8d86-4a77-881d-f6e520bf9689",
      progress: 0,
      source_task_id: "B1.CFCI.4010"
    },
    {
      id: "fefe7594-ed27-420e-8c8f-fafdde3b6399",
      text: "B2 - ISP Cabling - EF to SSB (GS tray)",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 80,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1170"
    },
    {
      id: "e3a1cce3-1baf-4b6c-8bdd-43ccb92f94ef",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Building Dry -in",
      type: 0,
      start_date: "2025-03-08T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1070"
    },
    {
      id: "90640fcc-0e5f-4882-b01a-bf44d075c416",
      text: "BLDG-1/2 - Precast Tornado Schedule Fab and Deliver",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 40,
      parent: "07b55cfe-9e28-44c9-92c0-80e8fd883c9f",
      progress: 0,
      source_task_id: "B1.CFCI.4310"
    },
    {
      id: "15b467cf-8184-4054-92de-ef821903d781",
      text: "Completion of PDD Package and SDS Package",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-10-23T00:00:00",
      duration: 0,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 1,
      source_task_id: "PRE-DP-1120"
    },
    {
      id: "48e84d90-b240-4940-8943-ff56c16d17fb",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Blocking/Fire FEC",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1070"
    },
    {
      id: "7589d0bf-f286-4541-8d9d-437ff1f97ab9",
      text: "B2 - DH-C - El Equip Yd - Test/Terms for PTX (480V)",
      type: 0,
      start_date: "2026-05-11T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 80,
      parent: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      progress: 0,
      source_task_id: "B2.C.EY.1670"
    },
    {
      id: "1ed470ae-b4b6-4755-a2de-cf1fd845a9a4",
      text: "UG RI -Panel Boards (PB)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "d87c40c9-36ba-466e-9282-c17bb73cf6fe",
      progress: 0,
      source_task_id: "MECO-1640.10"
    },
    {
      id: "9a942442-912b-42ca-85c5-f9c30968403a",
      text: "Develop Project Review Design Package",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-10-23T00:00:00",
      duration: 0,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 1,
      source_task_id: "PRE-DP-1130"
    },
    {
      id: "bf9f4177-95ed-4cb0-b7ea-a3a9a194ee65",
      text: "B2 - 2A2 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 160,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2400"
    },
    {
      id: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365",
      text: "B2 - SSB - 2E2 - Common - Complete Interior Build-Out (DEC-C Ready)",
      type: 0,
      start_date: "2026-06-17T08:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 0,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1930"
    },
    {
      id: "f196a529-16ec-4cd0-a288-46ed813aaa72",
      text: "Area 1 - Mass Grading - Remainder Post Permit Delay",
      type: 0,
      start_date: "2024-09-13T00:00:00",
      end_date: "2024-09-28T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A1.8020"
    },
    {
      id: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7",
      text: "Area 4 - Storm Install",
      type: 0,
      start_date: "2024-11-21T00:00:00",
      end_date: "2024-12-26T08:00:00",
      duration: 208,
      parent: "360442f2-9561-479f-9a37-34f468217f2d",
      progress: 0,
      source_task_id: "C.CSU.A4.3000"
    },
    {
      id: "37decd77-16ae-4502-9315-7fb05660e29e",
      text: "B2 - 2E1E - EF3 - Hang/Tape/Finish Drywall (EF3)",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 48,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5180"
    },
    {
      id: "e744e458-1dee-4f3d-8774-0fdd9191e294",
      text: "B1 - mCUP-7 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7120"
    },
    {
      id: "e8549a00-d35b-4ed3-bd75-26bbe59f1808",
      text: "FRP - Foundations & Spread Footings",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 120,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1010"
    },
    {
      id: "3759b7dd-5340-438d-b150-36493d581509",
      text: "Slab Edge Waterproofing",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1080"
    },
    {
      id: "7b900639-849a-4d70-b451-8633dd3200d5",
      text: "BLDG-1/2 - Submittal Rvw/App'l Speciality doors and dock levelers",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-04T00:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6310"
    },
    {
      id: "241754d8-e88b-4572-ac3f-050ef6cf5411",
      text: "Area A - Cable Tray Install",
      type: 0,
      start_date: "2025-07-17T00:00:00",
      end_date: "2025-08-06T08:00:00",
      duration: 120,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1151"
    },
    {
      id: "49afa6bd-1404-4027-a9f6-b75a881b6c9d",
      text: "B1 - 1C1W - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 160,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.2170"
    },
    {
      id: "829e341a-f8e1-4ff9-9e2d-281c503ea784",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1520"
    },
    {
      id: "91142971-7ff8-402c-ad76-680fffb25ce0",
      text: "ATS - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 1,
      source_task_id: "B2.OFCI.1180"
    },
    {
      id: "54713288-8bfb-4bd0-b6ab-6748b6747919",
      text: "Phase 2 - De-energize Electrical Equipment",
      type: 0,
      start_date: "2026-06-03T00:00:00",
      end_date: "2026-06-30T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1060"
    },
    {
      id: "8fbc9a3d-a11a-481e-8dbb-83bff473de75",
      text: "Campus - Install Campus Specialties (LOE)",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 1688,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1000"
    },
    {
      id: "6f634469-8cf0-444f-9055-8ee00bcaa112",
      text: "B2 - 2C1W - 02C.07 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-05-28T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.2500"
    },
    {
      id: "57af004f-91ff-4c96-86c9-3aa68e1db3c0",
      text: "B2 - 2B2 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-06-19T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 120,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2670"
    },
    {
      id: "fd234342-f0d8-40a3-8318-20c783e1e6d0",
      text: "FR 01 - Sanitary Sewer Redesign - Site / UG BIM Coordination / Sign Off - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-05-16T00:00:00",
      end_date: "2024-05-22T08:00:00",
      duration: 40,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1060"
    },
    {
      id: "c673dffa-9349-4849-8685-f46d759d91be",
      text: "Roadways",
      type: 5,
      start_date: "2025-01-14T00:00:00",
      end_date: "2026-09-03T08:00:00",
      duration: 3376,
      parent: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      progress: 0,
      source_task_id: "7995207"
    },
    {
      id: "0232fc47-754a-4ece-856c-465c3f0da2b7",
      text: "B1 - mCUP-9 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9050"
    },
    {
      id: "6834fe2e-eabc-450c-9f15-e11bb2c0a456",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 120,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2020"
    },
    {
      id: "61f5fcd7-5f32-4bfe-9f35-40db96d584ef",
      text: "B1 - 1C1W - 01C.08 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1630"
    },
    {
      id: "5a5bcb62-e1a7-41ee-9487-414ac395de8b",
      text: "B1 - 1C1W - 01C.08 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1670"
    },
    {
      id: "7afae281-2c6a-4641-860a-2692ae80df78",
      text: "B1 - 1N1W - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5060"
    },
    {
      id: "ebaa5692-ddb2-48ba-b3d1-e12d6fe7b00c",
      text: "B1 - DH-A - Install Celing Devices Fire Alarm - Data Hall A",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2660"
    },
    {
      id: "7e2c4263-df53-41a3-b764-1e6e272793de",
      text: "BLDG-2 DH-C Electrical Pulls",
      type: 5,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 280,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "7995140"
    },
    {
      id: "c37f6611-3252-4a1e-8659-3064bc280094",
      text: "B2 - mCUP-2 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 48,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2000"
    },
    {
      id: "7b3732ac-c7bb-496f-bba4-9d92d4df0cbc",
      text: "B1 - Network Room 1/4 - FCA Gallery - IMP ceiling and Perf wall Install",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 120,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1720"
    },
    {
      id: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      text: "B1 - SSB - 1E2 - GSMDF2 - Punch walk and Handover Skid (DEC-C Ready)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 8,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1970"
    },
    {
      id: "bea65c75-25be-4476-afe3-d24e4e71b9f2",
      text: "Substation HPD - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "862ebf7a-ac0e-4164-ba6f-7343140eb5ad",
      progress: 1,
      source_task_id: "B1.OFCI.1290"
    },
    {
      id: "a183a617-56fe-4e7f-9618-2a6398e4dc53",
      text: "B2 - SSB - 2E2 - Common - Install Devices in Tile/OH Fire Alarm",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1740"
    },
    {
      id: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      text: "Project Review Design Package Review Cycle",
      type: 0,
      start_date: "2023-10-23T08:00:00",
      end_date: "2023-11-15T16:00:00",
      duration: 136,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 1,
      source_task_id: "PRE-DP-1160"
    },
    {
      id: "85391fcf-fbdc-4cfe-b101-e86ca0d8bff2",
      text: "OSP - B1 - Phase 1 (CAV/MMV to BEV and UG Priority)",
      type: 5,
      start_date: "2025-06-05T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 600,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995449"
    },
    {
      id: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      text: "B2 - 2D1 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 24,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1110"
    },
    {
      id: "9c368871-a61f-466d-86b1-18d21734512f",
      text: "B1 - Network Room 2/3 - FCA Gallery - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 96,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1890"
    },
    {
      id: "3e8d919a-1323-4e3d-b011-9634f8cdbaed",
      text: "B1 - DH-C - Install Underground Plumbing",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 120,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1460"
    },
    {
      id: "f148cead-a147-46c3-8132-31fe9374d8e3",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 8,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1370"
    },
    {
      id: "87605184-b8ea-4254-8e3a-7575764689ba",
      text: "BLDG-1/2 -  prep and submit Submittals - Strut",
      type: 0,
      start_date: "2025-02-13T00:00:00",
      end_date: "2025-03-13T08:00:00",
      duration: 160,
      parent: "2b6ac8b0-5614-4bfb-a6cf-fdb1f42c6160",
      progress: 0,
      source_task_id: "B1.CFCI.3660"
    },
    {
      id: "4c0f7fd4-b610-437f-93ea-ccf6086e1f21",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [1] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 2712,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.38,
      source_task_id: "B1.OFCI.3640"
    },
    {
      id: "d538b943-489c-4266-828e-8fb777bf9199",
      text: "B2 - SSB - 2E2 - Common - Install Wall Devices BMS",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1820"
    },
    {
      id: "8c3e4bbb-70ef-44f9-83ec-83fe7e8a1460",
      text: "B1 - SSB - Install Insulation",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 40,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1060"
    },
    {
      id: "48d0e46d-1139-4f51-b673-0c899c3465f3",
      text: "Substation 2 -  Review for Approval - H-Frame MOAB",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 72,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5800"
    },
    {
      id: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      text: "B2 - DH-D  - Power Alley - Frame Walls",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-10T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1010"
    },
    {
      id: "f6473398-71d2-4a90-9aa2-498a633dc3fa",
      text: "FR 08 - Area 3 - Telecom Install - Remaining (Includes CAV1 & CAV4) - Concrete Scope",
      type: 0,
      start_date: "2025-03-06T00:00:00",
      end_date: "2025-04-09T08:00:00",
      duration: 240,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A4.8050"
    },
    {
      id: "b140b2e3-e32c-48cc-b6d2-499861af3510",
      text: "META/ Design team to finalize",
      type: 0,
      start_date: "2024-08-22T00:00:00",
      end_date: null,
      duration: 8,
      parent: "dc78887d-8014-48b1-ad06-f9bf1be85152",
      progress: 1,
      source_task_id: "FR.04.1010"
    },
    {
      id: "a3dac3e9-421a-40e8-90e7-147055660c87",
      text: "Generators - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "eb3ea98a-2cf4-45ea-aad1-d7789c9747d1",
      progress: 1,
      source_task_id: "B1.OFCI.1570"
    },
    {
      id: "3d7ca0ff-8728-4549-a794-7df6b6f64831",
      text: "Steel SA - Meta Authorized",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-13T00:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "ICM.PRE.1405"
    },
    {
      id: "057d63bd-0a4d-434e-a7ca-5122ccde1b73",
      text: "B2 - 2A1 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1950"
    },
    {
      id: "96af88c9-9303-4517-8063-d5291d0ec79d",
      text: "PHASE 1 Substantial Completion",
      type: 0,
      start_date: "2026-08-03T08:00:00",
      end_date: "2026-08-03T08:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "CX.MIL.1020"
    },
    {
      id: "e9246acc-a785-4f70-b668-ae9bf580a79d",
      text: "UG Electrical",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-03T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8070"
    },
    {
      id: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      text: "Precon Packages",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-08-19T08:00:00",
      duration: 1664,
      parent: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      progress: 0.8,
      source_task_id: "7994740"
    },
    {
      id: "53f39f93-8e72-4118-a628-ab3ed637877d",
      text: "BLDG-2 - BIM - Tier 0 - Area 2-A - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 240,
      parent: "1e8886aa-f56f-4148-b16c-c79188f75884",
      progress: 0,
      source_task_id: "B2.VDC.3080"
    },
    {
      id: "68653b4e-705a-414d-8c18-7eb7442e2036",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1670"
    },
    {
      id: "48e10531-9d3f-4975-8179-05d3fe855eaf",
      text: "Admin - Fabricate / Deliver - Doors, Frames and Hardware",
      type: 0,
      start_date: "2024-10-16T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 1000,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1060"
    },
    {
      id: "6b113e4f-7c30-4f40-87bf-7db528dc210c",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 1384,
      parent: "9a439d8f-7507-4d44-a057-90cba25b759a",
      progress: 0,
      source_task_id: "7995057"
    },
    {
      id: "01fab29e-b00d-42cd-91af-352e5849e8ec",
      text: "Site / UG BIM - Area 4 - Remaining Utilities - Coordination / Sign Off",
      type: 0,
      start_date: "2024-05-14T00:00:00",
      end_date: "2024-06-21T00:00:00",
      duration: 216,
      parent: "8331d266-0138-4b68-98a0-04c6efcc3613",
      progress: 1,
      source_task_id: "SITE.VDC.1100"
    },
    {
      id: "705144c6-33d4-4989-8929-70d4546d8cbf",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [9] - DCB1",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 1824,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.56,
      source_task_id: "B1.OFCI.3630"
    },
    {
      id: "415d197c-8721-4070-b7d2-497fb58e0d02",
      text: "Weather/Construction Bank - Bldg 2 A & B & SSB S/C Fdn st (2) to L3 start + 5 days for Cx (Original 38 - 5 = 33)",
      type: 0,
      start_date: "2027-01-19T00:00:00",
      end_date: "2027-03-05T08:00:00",
      duration: 304,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX2.DHB.WB.0020"
    },
    {
      id: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      text: "BLDG-1 Entrance Facility 4",
      type: 5,
      start_date: "2025-07-07T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 296,
      parent: "e2a25521-eed0-4f3c-a501-f360cf914f24",
      progress: 0,
      source_task_id: "7995346"
    },
    {
      id: "923c2b3b-00ed-4e98-8732-fd637793ae9c",
      text: "B1 - DH-A - DEC -C Turnover Walk - Data Hall A",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-01-12T08:00:00",
      duration: 16,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2760"
    },
    {
      id: "6f16a3b0-5b7b-4356-ae2c-3aa6d94f835e",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1570"
    },
    {
      id: "47b72397-9ff6-4ddd-9a83-e9fce4799059",
      text: "B1 - 1N1E - EF4 - Hang/Tape/Finish Drywall (EF4)",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 48,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5530"
    },
    {
      id: "e8ae958b-366b-490f-9e68-81df6173416d",
      text: "B1 - RF-Tower-1 - Equipment Set - [12.IDF-01-00] (TWRIDF1)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 40,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2210"
    },
    {
      id: "c6ddd15c-a612-4027-9f17-f94ccc1571eb",
      text: "FR 36 - DPR Issue RFI #163",
      type: 0,
      start_date: "2024-09-18T00:00:00",
      end_date: null,
      duration: 0,
      parent: "402f3329-410a-4e55-9edb-1757470a7890",
      progress: 1,
      source_task_id: "FR.09.1920"
    },
    {
      id: "270aaa81-3717-43c5-81b9-37c53c87aaba",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 8,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1470"
    },
    {
      id: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      text: "UPS Room 01N3.05",
      type: 5,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 480,
      parent: "19d232aa-0dc1-49f0-93d6-1893cfabaf59",
      progress: 0,
      source_task_id: "7995327"
    },
    {
      id: "2e6b27dd-b9dc-424c-b1eb-75a996945f0b",
      text: "Mechanical In Wall Rough-In",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1010"
    },
    {
      id: "67dad360-3ab1-4ac5-9354-cac19d849941",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Mechanical/Insulation",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1570"
    },
    {
      id: "99edabb5-755f-41be-8083-81ca738bf3e5",
      text: "(OFCI) B2 UPS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2488,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.52,
      source_task_id: "7994951"
    },
    {
      id: "a5609441-0108-499b-9597-b43dbbe2a0da",
      text: "Admin - Mass Timber Submittals",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: "2024-09-18T08:00:00",
      duration: 272,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1080"
    },
    {
      id: "6ab96289-f544-47c7-acd5-c4e2650185bb",
      text: "Fab and Deliver - Fan Coil Assembly - Area B - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 2912,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.35,
      source_task_id: "B1.OFCI.3240"
    },
    {
      id: "fb628d61-e100-41e1-8151-615c8477897f",
      text: "B2 - DH-A - Install HAC Lights - Data Hall A",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2380"
    },
    {
      id: "7ab234d8-d8d1-4e94-ac48-9917f3b7bc51",
      text: "B2 - 2D2 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1290"
    },
    {
      id: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      text: "B2 - DH-A - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1110"
    },
    {
      id: "3b1e050a-924b-4d02-965f-35ae275adecc",
      text: "Substation-1 - B Lineup SF6 Breaker - Install High Voltage Cable / Install Verification / Pre-energization Checklist",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 128,
      parent: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3820"
    },
    {
      id: "43a46004-fef5-4e61-afef-6cb1eedb3dbc",
      text: "B2 - 2C1 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 40,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1150"
    },
    {
      id: "e5de2a0f-460d-40c0-84e3-84d2779ca56c",
      text: "B1 - DH-A - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-24T08:00:00",
      duration: 80,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1340"
    },
    {
      id: "dfbf37fe-ceca-479a-89bb-7cde37ffd70e",
      text: "FR 08 - Area 2 - Telecom Install - Concrete Scope",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 288,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A2.8100"
    },
    {
      id: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      text: "Area 2 - Telecom Install",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 288,
      parent: "40259346-07ff-4beb-b825-abbaebacbeec",
      progress: 0,
      source_task_id: "C.CSU.A2.8000"
    },
    {
      id: "9402dbca-c712-4e18-a48f-78760f20f09d",
      text: "Meta / DPR Baseline 2 Review",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-03-07T08:00:00",
      duration: 112,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.5710"
    },
    {
      id: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      text: "BLDG-1 SSB 1E2 Common Area Buildout",
      type: 5,
      start_date: "2025-05-27T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1272,
      parent: "317fedf3-4445-4d48-b19e-75107c7c0568",
      progress: 0,
      source_task_id: "7995296"
    },
    {
      id: "c5d0354a-cd51-4ade-84b1-6c2a13995d7b",
      text: "Adverse Weather Event 8 - 09.26.2024 (Hurricane Helene)",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1008"
    },
    {
      id: "ca7dcf5a-c382-434e-be4c-62f7790b15e8",
      text: "B2 - DH-D - L2 CDU Install Verification - Data Hall D",
      type: 0,
      start_date: "2026-08-03T00:00:00",
      end_date: "2026-08-22T08:00:00",
      duration: 144,
      parent: "ae93e0be-e24c-43c6-8f76-9c451318a34f",
      progress: 0,
      source_task_id: "B2.C.D.3320"
    },
    {
      id: "70d859ab-820c-4b3a-89f9-73567442d08b",
      text: "B2 - DH-D  - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1040"
    },
    {
      id: "cdfa70cf-e4b8-4ed2-9d90-b2a28fc73fc1",
      text: "Equipment Yard - Admin",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 320,
      parent: "621592be-cc33-40c4-89df-9cd0aa53b294",
      progress: 0,
      source_task_id: "AD.CON.1140"
    },
    {
      id: "1940ca64-fe19-41c0-84f5-9b20ebb157f0",
      text: "Substation-2 - MSG A - Terminations of MECO scope",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.4780.1"
    },
    {
      id: "6d2754c4-13ac-44a3-82f8-b9c4be704ae6",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Plumbing/Insulation",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1640"
    },
    {
      id: "2e1b9d82-98f1-4e0d-9689-fbb312083e2f",
      text: "Earthwork",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 464,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 1,
      source_task_id: "PRE1490"
    },
    {
      id: "925cae29-3bdc-44d3-9e8b-e3e88ca8ee7a",
      text: "B1 - 1C1W - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1070"
    },
    {
      id: "235e502b-fa1c-4257-baa2-57b00c9a2002",
      text: "B1 - DH-B - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 80,
      parent: "475fbabe-89c3-43ba-986e-c5e612752c64",
      progress: 0,
      source_task_id: "B1.C.B.3170"
    },
    {
      id: "8a2da932-59e8-421f-a211-bcec6fd788e4",
      text: "Plumbing In Wall Rough-In",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1020"
    },
    {
      id: "0836a228-0278-4103-9648-c0291d2dcd59",
      text: "B2 - 2A2 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1440"
    },
    {
      id: "19724f51-5141-4c60-b555-4054884085c7",
      text: "Fab and Deliver - RSB - Area C - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2824,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.42,
      source_task_id: "B1.OFCI.3160"
    },
    {
      id: "94a1c3e5-7f04-47aa-9c64-e23c0509b3f5",
      text: "Steel Bid Package",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 712,
      parent: "f09bc7e4-6a3a-4c03-8a80-89c610a18d70",
      progress: 1,
      source_task_id: "7994734"
    },
    {
      id: "780d972c-dc9b-4abb-a824-322441c2e5ca",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1290"
    },
    {
      id: "7a3b9846-48b7-40e8-a145-00e7fba0e1ee",
      text: "BLDG-1 SSB",
      type: 5,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1360,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995285"
    },
    {
      id: "ff7aa94c-a80a-43c5-b0e6-39eaed32358e",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1240"
    },
    {
      id: "65a77fba-67a9-4fef-8fec-7ec7c140bdc6",
      text: "B2 - DH-A - Install Coping",
      type: 0,
      start_date: "2026-01-20T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 80,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1320"
    },
    {
      id: "ea005c9d-750a-4ec9-be70-bf03d4052fc2",
      text: "Health Inspections",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-03-20T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1360"
    },
    {
      id: "bdc43c16-54bc-4ecd-86f0-1d5a58acf9e4",
      text: "B1 - DH-D - Install Ceiling Tiles - Data Hall D",
      type: 0,
      start_date: "2026-02-17T00:00:00",
      end_date: "2026-02-23T08:00:00",
      duration: 48,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1390"
    },
    {
      id: "667de3dc-f114-4221-952f-36890972a4c9",
      text: "B1 - DH-B - Install Feeder Conduit -Data Hall B",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2640"
    },
    {
      id: "77705ceb-71cf-4f20-9645-5a679e192572",
      text: "Mechanical Allocation SA Package",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2024-02-29T08:00:00",
      duration: 448,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1070"
    },
    {
      id: "2b7905ca-abf2-478a-9e87-57603cb49322",
      text: "Substation-1 - Set Equipment (GS IDF Hut) ((SUBIDF1))",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 80,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6160"
    },
    {
      id: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c",
      text: "B1 - mCUP-7 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7070"
    },
    {
      id: "59ca1a3b-b178-4647-8534-2aa7ee9887fb",
      text: "B1 - 1N2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 80,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5500"
    },
    {
      id: "42181f84-4685-4207-803b-0c0549cf83be",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1680"
    },
    {
      id: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      text: "B1 - DH-B - Cure for SOG",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-27T08:00:00",
      duration: 24,
      parent: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      progress: 0,
      source_task_id: "B1.C.STR.2340"
    },
    {
      id: "4b1d15f5-7710-4930-a02e-4ce90445eb71",
      text: "B2 - 2A2 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1460"
    },
    {
      id: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      text: "Power Alley NW 2/3",
      type: 5,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 728,
      parent: "f530bbb9-f449-4766-8257-53c5c9bcda64",
      progress: 0,
      source_task_id: "7995331"
    },
    {
      id: "1257fabf-bf3a-4507-bc44-20a3d13bfed9",
      text: "BLDG-1 - BIM - Tier 2-4 - Area 1-B - Coordination / Sign-off",
      type: 0,
      start_date: "2025-01-13T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 280,
      parent: "7b800596-3c18-4eef-a601-dc65353e5660",
      progress: 0,
      source_task_id: "B1.VDC.1600"
    },
    {
      id: "3dadaf33-c413-4bb6-ab2d-9b47a3458a3b",
      text: "B2 - DH-A - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1090"
    },
    {
      id: "60fc83b9-36e1-409f-ac80-3e8eac71c4e0",
      text: "B2 - DH-C - Pull/Term Lighting/Branch - Data Hall C",
      type: 0,
      start_date: "2026-05-22T00:00:00",
      end_date: "2026-06-19T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2420"
    },
    {
      id: "d824cb75-267f-4d3d-b909-ca3bdb71d0a1",
      text: 'FR 36 - DPR/META and AT&T feild walk and determine no CAV needed. instead 2 2"" conduits from trailer city to AT&T pedest',
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: null,
      duration: 96,
      parent: null,
      progress: 0,
      source_task_id: "FR.36.1150"
    },
    {
      id: "0da0d610-ed6c-4ef4-8518-8ba7e958c25c",
      text: "STC - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 1,
      source_task_id: "B1.OFCI.1100"
    },
    {
      id: "8f131f06-23b7-4eb0-8d9c-61ba0a2a9397",
      text: "B1 - 1D2E - Corridor - Room Fit Out Activities - Set/Hook up Equipment",
      type: 0,
      start_date: "2026-01-05T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 160,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2620"
    },
    {
      id: "698b4870-d177-4e2b-825b-a74ce2b5bbd6",
      text: "Fab and Deliver - RSB - Area C - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 3344,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.43,
      source_task_id: "B2.OFCI.2360"
    },
    {
      id: "52433c43-8fc6-4a60-a6eb-07ddf17e2ed6",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area D (22) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 2960,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.45,
      source_task_id: "B2.OFCI.1770"
    },
    {
      id: "1c607db6-60aa-4542-a2fd-2b76e1fe910c",
      text: "B1 - DH-D - Install Ceiling Devices - Lighting - Data Hall D",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-02-07T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1320"
    },
    {
      id: "a273e565-d29d-40a2-9ecc-002b654601ad",
      text: "Exterior Canopy Light Fixture Install / Device Trim",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 24,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1190"
    },
    {
      id: "76b9d5d4-49c8-452c-8dfa-2b51335af130",
      text: "BLDG-1 - BIM - Tier 0 - Admin - Coordination / Sign-off",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-09-09T08:00:00",
      duration: 240,
      parent: "0b068a4f-9be9-40d8-99dd-d9f5c60a2d1f",
      progress: 0,
      source_task_id: "B1.VDC.1670"
    },
    {
      id: "973f1515-8913-4dde-8810-139103574822",
      text: "B2 - SSB - 2E1 - Common - Install Plumbing Fixtures",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-30T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1290"
    },
    {
      id: "fde6fa74-71e9-4a70-857e-ca30387e7d0d",
      text: "Design and Precon",
      type: 5,
      start_date: "2023-08-28T00:00:00",
      end_date: "2026-05-05T08:00:00",
      duration: 5416,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0.26,
      source_task_id: "7994713"
    },
    {
      id: "cd93d015-8ec0-499a-b624-af24e2c68cd1",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1340"
    },
    {
      id: "bd2743ee-f5f7-4244-9acd-de51e09905e0",
      text: "B1 - DH-A - Raise HACs - Data Hall A",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2340"
    },
    {
      id: "5756c002-94ce-4682-b2df-0eedae69fed5",
      text: "B2 - 2E2E - 02.01.E2.01 - Lighting and Devices",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6500"
    },
    {
      id: "e48b49e3-e9d2-41d2-86e0-c5394edc9ee9",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Below Grade Waterproofing (revision)",
      type: 0,
      start_date: "2024-11-12T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0.8,
      source_task_id: "B1.CFCI.6510"
    },
    {
      id: "4da7a290-7f30-4d69-83c0-1451d3a41917",
      text: "L4 - B1 DHC - Server Migration",
      type: 0,
      start_date: "2026-08-05T00:00:00",
      end_date: "2026-08-06T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHC.1010"
    },
    {
      id: "5e3223c1-8707-427d-8e11-b2295a1bde3c",
      text: "DFSMA - DC1 - CUP 3- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-07-21T08:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1250"
    },
    {
      id: "bb082a23-35cc-41bc-9f32-f8e82ad80aa4",
      text: "Admin - Cable Tray Procurement",
      type: 0,
      start_date: "2024-11-07T00:00:00",
      end_date: "2025-02-24T08:00:00",
      duration: 640,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1010"
    },
    {
      id: "6af58e79-450a-4edc-84a8-c4ec77919c3a",
      text: "L4 - B1 DHC",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-08-04T08:00:00",
      duration: 280,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHC.1000"
    },
    {
      id: "56854237-ebdf-4446-8f94-9f575bfa1fbf",
      text: "Mass Grading",
      type: 5,
      start_date: "2024-06-10T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 1064,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0.07,
      source_task_id: "7995161"
    },
    {
      id: "ac5316b3-522b-43dd-b28e-194393746418",
      text: "Area 4 - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2024-10-05T00:00:00",
      end_date: "2024-11-06T08:00:00",
      duration: 200,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1620"
    },
    {
      id: "754035fd-b4b1-48c9-b32d-c27b2735124d",
      text: "B1 - SSB - 1E1 - Common - Install Doors and Hardware",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2370"
    },
    {
      id: "198b11a0-ccbe-4d1b-89f1-0f0ab0b4c1b1",
      text: "Fab and Deliver - MSB Accessories - Area A - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 3056,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.41,
      source_task_id: "B1.OFCI.2910"
    },
    {
      id: "6203ee0b-d544-4410-b314-8e5add762a00",
      text: "L4 - B1 MSG-B *On Temp Power*",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 40,
      parent: "9b65810f-93cc-453e-8de8-a75c5f4cb8b5",
      progress: 0,
      source_task_id: "CX4.B1.SS.1030"
    },
    {
      id: "fb67c078-673b-4328-9cd4-a78a08085d8c",
      text: "B1 - mCUP-8 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8120"
    },
    {
      id: "312dc114-8970-4872-9ae8-2dbd44f0ebb5",
      text: "B1 - SSB (Converted to LOE)",
      type: 0,
      start_date: "2025-05-12T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 1360,
      parent: "7a3b9846-48b7-40e8-a145-00e7fba0e1ee",
      progress: 0,
      source_task_id: "B2.C.C.1000"
    },
    {
      id: "3d2561bb-dde6-46f8-b7d6-703c822cf45c",
      text: "B1 - Network Room1/4 - FCA Gallery - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.2130"
    },
    {
      id: "8d364ed6-8d95-4622-8f88-85275fa83049",
      text: "Data Hall C & D Electrical Yard",
      type: 5,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 120,
      parent: "0277d7b3-e3a7-42c6-9996-54bcc49d9eab",
      progress: 0,
      source_task_id: "7995016"
    },
    {
      id: "bc981e7c-56c5-449c-8db4-4289f4a2d55c",
      text: "FR 28 - DPR Prepare and Submit PCO#26",
      type: 0,
      start_date: "2024-08-26T00:00:00",
      end_date: null,
      duration: 392,
      parent: "1076d022-f279-458e-8e6f-47edee4227c2",
      progress: 0.5,
      source_task_id: "FR.28.1010"
    },
    {
      id: "1cb75608-ea15-4d7d-a6f5-dc6bf4d3a50a",
      text: "Data Hall D (Area 2-D)",
      type: 5,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 760,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994785"
    },
    {
      id: "6aa2afa4-ef9a-49be-b9e3-7d04b7b5c79d",
      text: "Substation-1 - B Lineup - Install Controls / Conduit / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-03-12T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 136,
      parent: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3400"
    },
    {
      id: "81da4715-eb84-4efe-b98b-b1c4824b9111",
      text: "Hang Drywall Walls",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1120"
    },
    {
      id: "58e48c73-3f84-4822-83a6-f0ae02bb561a",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Inspection AHJ",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 16,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1250"
    },
    {
      id: "6a3d599f-a6cc-4e75-a631-840ed10185b1",
      text: "Area 2 - UG RI -UPS system-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1340"
    },
    {
      id: "31ddad05-7693-4918-890c-6785812b5182",
      text: "B2 - mCUP-6 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-13T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6120"
    },
    {
      id: "a73b3451-0cb3-4ccb-b96e-18f360181fcd",
      text: "B1 - mCUP-1-9 - Equipment set (Level of Effort)",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 560,
      parent: "0940dc8f-2121-4ca5-9917-93aa068b00ae",
      progress: 0,
      source_task_id: "B1.mCUP.9150"
    },
    {
      id: "30221775-1764-49fe-ac74-be7e57a187bc",
      text: "FR 36 - DPR Prepare and Submit PCO#XX",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: null,
      duration: 40,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 0,
      source_task_id: "FR.36.1020"
    },
    {
      id: "da8a68e8-4858-4e0b-8d41-8f803607d291",
      text: "Campus PH1 - Prep / Submit for Review - MV Vaults (Site)",
      type: 0,
      start_date: "2024-06-24T00:00:00",
      end_date: "2024-08-27T08:00:00",
      duration: 40,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0,
      source_task_id: "B1.CFCI.5980"
    },
    {
      id: "2606fcbb-bce4-483d-96c8-ebd6ad75f19a",
      text: "Install Downspouts / Gutters",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1070"
    },
    {
      id: "5c6b1ba1-dad4-4c3c-9d08-18f1056a3aef",
      text: "B2 - DH-A - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1060"
    },
    {
      id: "e0aca220-f8f7-43b5-bd2f-8ad1d45275d3",
      text: "B2 - 2C1W - 02C.07 - Lighting and Devices",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.2390"
    },
    {
      id: "d67b0569-6072-4d51-88e3-44e207941498",
      text: "B2 - DH-D - Install Decking",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 80,
      parent: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      progress: 0,
      source_task_id: "B2.C.STR.1900"
    },
    {
      id: "0286dced-cce8-4a53-ae18-56694d196d97",
      text: "Area 3 - Electrical Connections to Sanitary waste water flow meter",
      type: 0,
      start_date: "2024-12-13T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8130"
    },
    {
      id: "9c5df21e-df71-4a19-8fde-abd127bba955",
      text: "Caulk Precast",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 80,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1260"
    },
    {
      id: "2846edff-99e8-4751-8834-4f20df3d5c19",
      text: "B1 - 1B2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1110"
    },
    {
      id: "9e0f8ebb-e820-4b82-ba42-c1f0ef3710aa",
      text: "Install Roof curbs and Roofing",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 120,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1210"
    },
    {
      id: "8ca5f2cc-fc69-4ffe-9735-0c3ca41bda1f",
      text: "B1 - Heavy Duty Course Paving",
      type: 0,
      start_date: "2025-02-25T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 48,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1040"
    },
    {
      id: "52a45269-8285-4ce1-9c6d-e8fff1ad8c0d",
      text: "B1 - DH-D - Install Joists",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 120,
      parent: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      progress: 0,
      source_task_id: "B1.C.STR.2080"
    },
    {
      id: "e291665c-b8f5-44a2-a7c6-b9f4e0458651",
      text: "B2 - 2B1 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1670"
    },
    {
      id: "11976427-8105-41c2-936d-1812f73f06be",
      text: "Substation-2 - B Lineup - Deep Conduit Install",
      type: 0,
      start_date: "2025-04-25T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 104,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4220"
    },
    {
      id: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      text: "B2 - 2E2E - EF1 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF1)",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 8,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6340"
    },
    {
      id: "2152c31c-2857-45fb-8e11-1d672e926225",
      text: "Area 4 - Cx - Lvl-2, Lvl-3",
      type: 0,
      start_date: "2025-04-22T00:00:00",
      end_date: null,
      duration: 48,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A4.8130"
    },
    {
      id: "e572f8b6-cc02-40ed-b5da-85b282dcdbb8",
      text: "B1 - DH-C - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 80,
      parent: "6df5910d-fd29-4fec-b6b4-13bc03840f41",
      progress: 0,
      source_task_id: "B1.C.C.3150"
    },
    {
      id: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      text: "B1 - Deep Telecom - Interduct Between EF 1,2,3,4 to IDFs in DH A, B, C, D",
      type: 0,
      start_date: "2024-12-12T00:00:00",
      end_date: "2025-01-02T08:00:00",
      duration: 120,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2420"
    },
    {
      id: "64a5e86d-b411-4655-b538-9440a526b176",
      text: "B2 - 2A1 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 120,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1000"
    },
    {
      id: "319cad03-f286-4cf3-a0ca-2508bae43bd6",
      text: "B2 - DH-B - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 120,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1120"
    },
    {
      id: "ae3cc965-2d14-4059-84ab-eccd5d498d8e",
      text: "B1 - DH-A - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 16,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2560"
    },
    {
      id: "a47740c9-5cc0-48b9-82fd-69294a37101d",
      text: "B1 - DH-C - Install Coping",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 80,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1440"
    },
    {
      id: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      text: "Corridor 1B2E",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 1056,
      parent: "9c25f2dc-266e-49fd-9486-f02cd5642489",
      progress: 0,
      source_task_id: "7995354"
    },
    {
      id: "dcd35ac1-e25d-43a7-808d-439be1ef88c7",
      text: "FR 01 - Sanitary Sewer Redesign - Constructability Review + Redesign - Area 4 & 5",
      type: 0,
      start_date: "2024-05-09T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 56,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1110"
    },
    {
      id: "80e923b8-88ee-4958-a8eb-31858531ed07",
      text: "Fab and Deliver - MVS-4WAY - Area A (9) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 2576,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.47,
      source_task_id: "B2.OFCI.2000"
    },
    {
      id: "7f292b24-d30f-4525-b40e-96dce79c1a10",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (D)",
      type: 0,
      start_date: "2026-04-07T08:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 0,
      parent: "a9b0b7b3-691c-4bf3-b255-5085ef8b94aa",
      progress: 0,
      source_task_id: "B2.DFSMA.1440"
    },
    {
      id: "f702a418-b705-4108-95d7-f990a80150d2",
      text: "Break Ground",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2024-04-22T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 1,
      source_task_id: "ICM.B1.1010"
    },
    {
      id: "c02e40c4-107e-4b5a-92cd-87edcd5b033e",
      text: "B1 - DH-B - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 48,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.2620"
    },
    {
      id: "3691a4a5-2c48-476d-a402-7b0b32cf5858",
      text: "B1 - 1N2W - 01N2.06 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.5850"
    },
    {
      id: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      text: "B1 - SSB - 1E1 - Common - Hang/Tape/Finish Drywall Ceiling",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2250"
    },
    {
      id: "4169ba48-50aa-43c0-93f6-c64d4090cbb1",
      text: "L4 - B2 DHD",
      type: 0,
      start_date: "2027-01-27T00:00:00",
      end_date: "2027-03-17T08:00:00",
      duration: 280,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHD.1000"
    },
    {
      id: "1d3fea53-1097-4952-a38e-b27dcb99a6d4",
      text: "Install Metal Panels/Skin - Area A - IBOS",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "A1050"
    },
    {
      id: "f181a111-52cc-4662-bb49-ea19375faa96",
      text: "B1 - 1N2E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-14T08:00:00",
      duration: 104,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5020"
    },
    {
      id: "ead3e791-a451-4c3b-8bb6-f6fd268878bf",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1330"
    },
    {
      id: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      text: "Equipment Yard",
      type: 5,
      start_date: "2025-09-30T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 1584,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995124"
    },
    {
      id: "67777782-c5f2-4197-8228-5816389a65e2",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1490"
    },
    {
      id: "9a133269-2707-4959-a1ba-fd01eb52aa65",
      text: "B1 - 1C2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1510"
    },
    {
      id: "666d1c60-24a6-4d53-b322-e6d39e6ba01c",
      text: "Delivery of MTR - Multi Trade Rack (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-11-21T08:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1855"
    },
    {
      id: "eccf8c7d-f695-48cd-8781-1f4dfa09af12",
      text: "B2 - DH-D  - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1050"
    },
    {
      id: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 24,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1240"
    },
    {
      id: "ea3b19a9-5436-4edc-9f81-6a24cf5ca9d6",
      text: "Campus PH1 - Fabricate / Deliver - MV Vaults",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 320,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0,
      source_task_id: "B1.CFCI.6000"
    },
    {
      id: "f9e927ae-bef4-4c2f-a9d1-169a3df666a0",
      text: "(CFCI) Div. 10 - Specialities",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 520,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994860"
    },
    {
      id: "d8bce3a9-d15f-4720-9ebe-2cdfac20308c",
      text: "FR 18 - DPR prepare and Submit RFI #115",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 0,
      parent: "ae1767c4-d36b-4241-8891-8fc1b5eca613",
      progress: 1,
      source_task_id: "FR.18.1000"
    },
    {
      id: "f1f58f12-9c41-49d6-9222-aa02d7a11667",
      text: "B2 - 2C1W - 02C.08 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-04-22T00:00:00",
      end_date: "2026-04-28T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.2230"
    },
    {
      id: "209053fa-c921-4edb-969f-6bbfbf4119c6",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1400"
    },
    {
      id: "2a5d6958-bf7e-4f2e-a025-8e209baba994",
      text: "Area 4 - UG RI -RSB/MSB-DCB2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1750"
    },
    {
      id: "6d080f13-3987-4a3c-b673-e8743952148f",
      text: "BLDG-1 DH-B Level 2 Checkout",
      type: 5,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 472,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "7995253"
    },
    {
      id: "a62dc703-3cc4-4c31-8dc0-4c422ce3a681",
      text: "B2 - 2E2E - EF2 - Pour Pads Around Telecom Conduits (EF2)",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 48,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6190"
    },
    {
      id: "e5020467-4af6-4092-820c-446974548234",
      text: "B2 - DH-D - Install Door/Hardware/ Wall Trim - Data Hall D",
      type: 0,
      start_date: "2026-09-18T00:00:00",
      end_date: "2026-10-15T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2660"
    },
    {
      id: "c2d95d1c-7196-49d8-a17c-9af16837967d",
      text: "Fab and Deliver - Substation HPD - Area SS-1 (2) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 1904,
      parent: "862ebf7a-ac0e-4164-ba6f-7343140eb5ad",
      progress: 0.53,
      source_task_id: "B1.OFCI.1920"
    },
    {
      id: "6891621d-986f-45a6-b0b8-afbffc80b13c",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 8,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1480"
    },
    {
      id: "54e6c5f1-e313-4f5d-8be6-a5c24f8241b6",
      text: "B2 - 2C1 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-06-10T08:00:00",
      duration: 160,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2410"
    },
    {
      id: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      text: "(OFCI) B1 Water Cooled Chillers",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 1824,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.56,
      source_task_id: "7994969"
    },
    {
      id: "0d71bcdd-f418-4560-800b-2e3eb84b67e4",
      text: "Civil & Foundations Permit Package - 100% IFP Development",
      type: 0,
      start_date: "2024-01-24T00:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 296,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "PRE-DP-1150"
    },
    {
      id: "d7911e8e-6004-4aa8-9eb2-20a53e095d40",
      text: "Utility Provider Substation - Civil & Utility Install",
      type: 0,
      start_date: "2024-11-26T00:00:00",
      end_date: "2024-12-18T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "CX0.USS.L2.0060"
    },
    {
      id: "96d016f5-9a3c-47a8-9bfc-152eea730483",
      text: "B1 - DH-B - L2 CDU Install Verification - Data Hall B",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 144,
      parent: "b38b9d81-df08-4732-9a53-49eb573b0138",
      progress: 0,
      source_task_id: "B1.C.B.3045"
    },
    {
      id: "71350109-bdaf-4eef-a06e-00091dd9385c",
      text: "Campus - Fabricate / Deliver - Landscaping / Irrigation",
      type: 0,
      start_date: "2025-03-21T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 480,
      parent: "50f5196d-2758-41f7-896e-2e6190d0ed68",
      progress: 0,
      source_task_id: "B1.CFCI.5370"
    },
    {
      id: "04f774a3-5265-4330-9d5b-d31481486089",
      text: "B2 - mCUP-6 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 48,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6000"
    },
    {
      id: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      text: "B1 - mCUP-1-9 - Equipment Pads - Sequence 1",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-01-30T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1020"
    },
    {
      id: "a2e1f58b-9733-4810-af90-0a253d494902",
      text: "B1 - DH-D - Install Perimeter Cable Tray - Data Hall D",
      type: 0,
      start_date: "2026-02-21T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1400"
    },
    {
      id: "ef4dd395-ab3b-4897-962a-8738f00ccb65",
      text: "B2 - DH-D - Pull/Term BMS - Data Hall D",
      type: 0,
      start_date: "2026-07-27T00:00:00",
      end_date: "2026-08-21T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2570"
    },
    {
      id: "caf010dc-1b40-4837-b245-a6f47c37b5a1",
      text: "B1 - SSB - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-02-11T00:00:00",
      end_date: "2025-02-22T08:00:00",
      duration: 80,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1140"
    },
    {
      id: "7d626466-5bec-4d60-b113-2805b273f2be",
      text: "B1 - SSB - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-04-26T00:00:00",
      end_date: "2025-05-10T08:00:00",
      duration: 96,
      parent: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      progress: 0,
      source_task_id: "B1.C.STR.1850"
    },
    {
      id: "2bbca2bc-ce2a-4037-bb48-b173feb3744c",
      text: "B1 - 1N1W - 01N1.07 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.5840"
    },
    {
      id: "87c017a0-015b-47db-ac47-e1ec73a54e67",
      text: "B1 - Network - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 80,
      parent: "efec6b5a-5634-43a5-b571-748e500afd9a",
      progress: 0,
      source_task_id: "B1.C.EY.1090"
    },
    {
      id: "6328e14c-1810-407b-b9c8-5ded1d2580c5",
      text: "IST Start DH B - DCB1",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-06-16T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2144"
    },
    {
      id: "2ee97197-cf56-4325-b866-578348fbee31",
      text: "B1 - 1N1W - Corridor - Room Fit Out Activities - Set/Hook-Up Equipment",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 160,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.6340"
    },
    {
      id: "dc485882-bdb5-4fe1-bfb4-5bcb5be573c7",
      text: "OH Fire Alarm",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1170"
    },
    {
      id: "71320fed-794a-4dc5-a1a9-c09d8ed3b149",
      text: "B1 - mCUP-9 - Set in Place Inspections",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 8,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9030"
    },
    {
      id: "9f97c6d2-6032-4618-adc4-3abff952695d",
      text: "B1 - DH-D - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 40,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1070"
    },
    {
      id: "00e78dd0-bce3-47ca-8c9a-fa95fe35a73d",
      text: "B1 - 1C1W - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1050"
    },
    {
      id: "8b913b23-ed56-4f5f-aaad-64c3ff935a74",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Equipment Elec Hookup",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 80,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1130"
    },
    {
      id: "121f217b-0422-4d1e-931f-a0aba3b16769",
      text: "B2 - Deep Telecom - EF3",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-06T08:00:00",
      duration: 40,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2270"
    },
    {
      id: "7e6102d1-02d3-4e4f-bf97-7b12df6db4f1",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2020"
    },
    {
      id: "278b2471-3528-4a87-814a-fb976208c6df",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-07-27T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2490"
    },
    {
      id: "9c255142-2967-461e-9558-6fe607d0d11d",
      text: "B1 - DH-A - Roofing (Converted to LOE)",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 120,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1210"
    },
    {
      id: "dbecec67-0211-4957-baa4-5fbc0d029363",
      text: "B1 - Network Room 2/3 - Cable terms/testing between EL Room and Busway",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1980"
    },
    {
      id: "67d734a8-c39d-4ca8-b86e-5d5930a7692f",
      text: "Early Coordination",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-05-13T00:00:00",
      duration: 320,
      parent: "56080308-2da4-4055-b9e7-474a80627d2c",
      progress: 1,
      source_task_id: "7994717"
    },
    {
      id: "add75385-5534-43ed-8e50-b78ae61d909a",
      text: "B1 - Network Room 2/3 - Install Below Ceiling Signage and Devices",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2230"
    },
    {
      id: "e8abec90-5214-48f2-a94f-7e2c3e0b5c78",
      text: "B2 - DH-C - Hookup FCAs Electrical- Data Hall C",
      type: 0,
      start_date: "2026-04-22T00:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 192,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2050"
    },
    {
      id: "27d4ac2c-ec97-4544-b0dc-8d294f77b9f7",
      text: "Cx - Lvl-2 (delete)",
      type: 0,
      start_date: "2025-02-10T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8220"
    },
    {
      id: "077cbf67-e6b9-4ef9-a925-b08d253ac77b",
      text: "Precast Complete  - DCB2",
      type: 0,
      start_date: "2025-11-03T08:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1390"
    },
    {
      id: "4ded2a20-d790-45d3-9836-b7810095095b",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [5] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 2472,
      parent: "27d933b4-bb78-4492-a7f9-8c053db73068",
      progress: 0.56,
      source_task_id: "B2.OFCI.2830"
    },
    {
      id: "7061328a-235e-4531-b0cd-54cc3d67e8b6",
      text: "B2 - 2C1W - 02C.08 - Lighting and Devices",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.2400"
    },
    {
      id: "b4d139ca-770c-4809-9b30-0bbb0abd868c",
      text: "B1 - mCUP-1 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1250"
    },
    {
      id: "0235af60-0458-4363-b792-77a2466a45a7",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2240"
    },
    {
      id: "4699d3cb-d8a0-4c04-adce-21fa7c2cd641",
      text: "B1 - 1C2E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 160,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1010"
    },
    {
      id: "2093dae0-94e9-447c-8bb6-dbe0181060df",
      text: "FR 32 - META review and respond to RFI #56",
      type: 0,
      start_date: "2024-07-25T00:00:00",
      end_date: null,
      duration: 32,
      parent: "f3d372b5-108e-423c-a7ac-e30f6c888ce2",
      progress: 1,
      source_task_id: "FR.32.1010"
    },
    {
      id: "358e43d2-5f04-4a0d-9914-2f2e84e613d3",
      text: "Domestic Water",
      type: 5,
      start_date: "2024-12-07T00:00:00",
      end_date: "2025-04-21T08:00:00",
      duration: 192,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995186"
    },
    {
      id: "95aba7da-d379-46ce-879c-8c8f743a9f50",
      text: "B2 - mCUP-3 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3100"
    },
    {
      id: "527b9b01-fa31-4ffa-93cf-bb586a4058f5",
      text: "B1 - DH-A - Install Celing Devices BMS - Data Hall A",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2650"
    },
    {
      id: "345ddf84-e82b-4151-87fc-d4968370dae7",
      text: "Area 2 - Sanitary Sewer Install (Branch/ Catch basin install & Tie in - mCup)",
      type: 0,
      start_date: "2024-11-08T00:00:00",
      end_date: "2024-11-14T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A2.8160"
    },
    {
      id: "1aab4538-58f4-4246-8a27-60f4012d85d6",
      text: "B2 - DH-B - Install 800 Amp Busway - Data Hall B",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-30T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2510"
    },
    {
      id: "09032199-7075-40de-ae98-46ff5554253a",
      text: "BLDG-1/2 - Pre/ Submit Shopdrawings - Lighting",
      type: 0,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6040"
    },
    {
      id: "c7c097b0-8c16-46db-8f88-984cdc40cf75",
      text: "BLDG-1/2 - Prep / Submit for Review - HVAC Materials and Equipment",
      type: 0,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 160,
      parent: "eaf2f66d-62ed-4333-9656-a42c1e2ecb58",
      progress: 0,
      source_task_id: "B1.CFCI.3380"
    },
    {
      id: "68feb5e5-43c6-4bf7-b20f-305fa178afd8",
      text: "B1 - DH-D - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 16,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1680"
    },
    {
      id: "440e743f-1820-4bb8-aeea-47951aac8f25",
      text: "Building 1 mCUP-2",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 384,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995366"
    },
    {
      id: "90156d41-b228-420a-a841-712f9e6855c8",
      text: "Frame Hardlids",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1080"
    },
    {
      id: "d96c812f-f447-46a1-b0dc-d6eeeead6d58",
      text: "Turnkey Concrete SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-04-12T08:00:00",
      duration: 320,
      parent: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      progress: 1,
      source_task_id: "PRE1660"
    },
    {
      id: "b481cb3f-09d7-48c7-b500-ed168d828fd3",
      text: "B1 - DH-B - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1620"
    },
    {
      id: "df15e95a-c41b-4d4a-9a26-aee0a0d2240f",
      text: "B1 - Network Room 2/3 - Prime and 1st Coat",
      type: 0,
      start_date: "2025-07-17T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1350"
    },
    {
      id: "e5b1d906-589c-41b8-bf27-953076bed5eb",
      text: "B1 - mCUP-8 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8020"
    },
    {
      id: "bc691861-ddda-49cc-b3b2-8465bc2cda65",
      text: "Design Team Address Comments & Re-Submit - Civil Permits",
      type: 0,
      start_date: "2024-04-29T00:00:00",
      end_date: "2024-05-03T08:00:00",
      duration: 40,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 1,
      source_task_id: "PRE-DD-1070"
    },
    {
      id: "45284d72-12f6-467b-8c15-cd1f91072d86",
      text: "B1 - SSB - 1E2 - GSMDF2 - Terms for Lighting/Outlet/Racks",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 24,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1770"
    },
    {
      id: "7a5a83ba-32d0-4a9f-a1ce-03b4a67fa5ee",
      text: "Mechanical R/I",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 40,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1070"
    },
    {
      id: "89edab3b-a5e8-421a-aa96-5171a069eaee",
      text: "B2 - DH-D  - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1420"
    },
    {
      id: "542a85e9-eedf-4125-9b9c-19831993743b",
      text: "B1 - SSB - 1E1 - Common - Install Security Devices",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2340"
    },
    {
      id: "b069564a-eddd-4292-aad6-f27eeb880557",
      text: "B1 - DH-A - Install Underground Controls",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 80,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1440"
    },
    {
      id: "94ecbbac-8ec5-46f3-885d-1f25be5a2ce7",
      text: "B1 - SSB - 1E2 - Common - Install Wall Devices Electrical",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2190"
    },
    {
      id: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86",
      text: "B2 - DH-D - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2026-06-04T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 80,
      parent: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      progress: 0,
      source_task_id: "B2.C.EY.1780"
    },
    {
      id: "310a05d1-1d8b-4d1e-883c-fe00c8e228ce",
      text: "B2 - SSB - Install Precast Storm Shelter (Early Mobilization for Precast)",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 80,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1010"
    },
    {
      id: "38252a54-135c-4c3e-83e6-74241779b223",
      text: "B1 - SSB - 1E2 - GSMDF2 - Hang/Tape/Finish Drywall for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 40,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "B1.C.SSB.1130"
    },
    {
      id: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 280,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995404"
    },
    {
      id: "d2222065-d580-47e5-a083-8658010b613d",
      text: "B1 - SSB - 1E2 - GSMDF2 - OH Rough In Sprinkler for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 40,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "B1.C.SSB.1280"
    },
    {
      id: "ebbeb88c-3fc4-4ff4-bbb0-88342eee3836",
      text: "B1 - DH-C - Install Cable Tray - Data Hall C",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-11-15T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2290"
    },
    {
      id: "99cbbd15-4939-4671-988d-7a8f895f9753",
      text: "B2 - SSB - 2E1 - Common - Install Device Tiles",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1210"
    },
    {
      id: "5eb03678-14dc-4243-a1cd-00a97485235d",
      text: "B2 - 2E1E - 02.01.E1.01 - Lighting and Devices",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5530"
    },
    {
      id: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      text: "(CFCI) Div. 26 - Electrical",
      type: 5,
      start_date: "2024-05-28T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 1648,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0.09,
      source_task_id: "7994864"
    },
    {
      id: "cf077eae-d31d-4cba-a666-eb3849bbc805",
      text: "B1 - 1D2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 160,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2430"
    },
    {
      id: "e162a6ef-1db8-4670-97bd-d87330bc1dda",
      text: "Set HSS Steel Columns",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1010"
    },
    {
      id: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      text: "Weather/Construction Bank - Bldg 1 SSB/Network S/C Fdn st (1) to L3 start + 5 days for Cx",
      type: 0,
      start_date: "2026-05-22T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 240,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX1.B1.NS.0030"
    },
    {
      id: "07306f8a-c20c-4135-a710-c8366e60895f",
      text: "B1 - mCUP-3 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3080"
    },
    {
      id: "17f7bc24-cabe-4894-87dd-c247c97c43ef",
      text: "IBOS VDC",
      type: 5,
      start_date: "2024-06-21T00:00:00",
      end_date: "2024-10-28T08:00:00",
      duration: 720,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994811"
    },
    {
      id: "cd26e6bc-f395-4680-9b52-b7f7a84376b2",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 24,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1740"
    },
    {
      id: "bacc9779-e175-435d-8b8a-abbbf13f7902",
      text: "[DCB2] DEC-C Ready: General Services [Area C]",
      type: 0,
      start_date: "2026-07-17T08:00:00",
      end_date: "2026-07-17T08:00:00",
      duration: 0,
      parent: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      progress: 0,
      source_task_id: "ICM.B2.3745"
    },
    {
      id: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      text: "BLDG-1/2 - Prep / Submit for Review - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: "2024-08-26T08:00:00",
      duration: 120,
      parent: "f516d625-fc35-4562-b467-ea8f751e08e8",
      progress: 0,
      source_task_id: "B1.CFCI.5460"
    },
    {
      id: "04e876f5-e2e9-4116-af41-aff9550ebc46",
      text: "B1 - ISP Cabling - EF to IDFC (UG)",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-02-25T08:00:00",
      duration: 120,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1300"
    },
    {
      id: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa",
      text: "B1 - Network - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 80,
      parent: "efec6b5a-5634-43a5-b571-748e500afd9a",
      progress: 0,
      source_task_id: "B1.C.EY.1170"
    },
    {
      id: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      text: "mCUP - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 1,
      source_task_id: "B2.OFCI.1000"
    },
    {
      id: "d00d12b2-df1a-411b-a437-661925afea4f",
      text: "B1 - 1N1W - 01N1.07 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.5760"
    },
    {
      id: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618",
      text: "B2 - 2A2 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1590"
    },
    {
      id: "6d409fe2-21b4-426c-93ff-53f73e763098",
      text: "Area A - In Wall Rough Fire Alarm",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1063"
    },
    {
      id: "93687a79-dfee-49b4-b1d4-b8335cfebe1e",
      text: "[DCB1] DEC-C Ready: General Services [SITE BUILDINGS - CRITICAL]",
      type: 0,
      start_date: "2025-12-23T08:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3775"
    },
    {
      id: "eb0944e3-30aa-4c55-8fed-47804a3cc212",
      text: "Area 3 - Set Water Meter pads",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-01-14T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8090"
    },
    {
      id: "0bf2bcd8-b382-499b-bf41-1128480a235c",
      text: "B1 - 1N1E - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.2350"
    },
    {
      id: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Mechanical/Insulation",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1490"
    },
    {
      id: "6f59f610-a665-434a-8add-a64caa1434c8",
      text: "Substation-2 - MSG B - Set / Temp Dry In / Temp Power / Site Acceptance Inspection",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 120,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4320"
    },
    {
      id: "30c2d9aa-2b2a-49b2-95e0-75b95b845202",
      text: "B1 - SSB - 1E2 - GSMDF2 - Fire Alarm Wire Pulls/Terms to devices",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 48,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1790"
    },
    {
      id: "dce7c311-c42c-460b-bd76-db76204a1acf",
      text: "(OFCI) Substation Circuit Breaker",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-09T08:00:00",
      duration: 2816,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0.25,
      source_task_id: "7994938"
    },
    {
      id: "fe6ed863-f98f-4dec-9f27-15c250e7170c",
      text: "B2 - mCUP-5 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5090"
    },
    {
      id: "245368be-1a45-40d2-9e35-92b4cfc72553",
      text: "B1 - SSB - 1E2 - EF2 - In Wall Rough-In/ Inspections (EF2)",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 48,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1520"
    },
    {
      id: "9bee263f-4d07-40c5-8829-554635a69f9c",
      text: "B2 - 2D1W - 02D.09 - Lighting and Devices",
      type: 0,
      start_date: "2026-07-01T00:00:00",
      end_date: "2026-07-08T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.2320"
    },
    {
      id: "c5a738df-69ea-44bf-9a4d-b9e0047fd9b8",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Security",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1140"
    },
    {
      id: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2",
      text: "L3 - SSB *On Temp Power*",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-13T08:00:00",
      duration: 160,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX3.B1.NS.1010"
    },
    {
      id: "63e8deeb-23c1-40fa-a7f4-66137ea87b7c",
      text: "Frame Hardlids",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1200"
    },
    {
      id: "6510dce4-5698-42e6-8034-b18fc48d5d92",
      text: "Fab and Deliver - PTX-DHAux - Area D (2) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 2616,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.46,
      source_task_id: "B1.OFCI.2620"
    },
    {
      id: "5a87ebd8-615f-4259-a1a3-f0ac70e94174",
      text: "[DCB2] DEC-C Ready: Overhead cable tray complete [Area A]",
      type: 0,
      start_date: "2026-07-14T08:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3825"
    },
    {
      id: "55f72cea-55f0-4c12-acb6-e37e273b4c68",
      text: "B1 - DH-B - Pull Feeders Bussways - Data Hall B",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2700"
    },
    {
      id: "8cabc6da-da99-4039-a04b-184fb2f29b40",
      text: "Admin -Pre/ Submit Shopdrawings - Lighting",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-01-09T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1170"
    },
    {
      id: "cb41f056-4be4-42db-980a-4c50319cf390",
      text: "B1 - Network Room 1/4 - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 16,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.2190"
    },
    {
      id: "a986bbd8-925e-4eb8-9cdc-f55be8038ef4",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1260"
    },
    {
      id: "2054a24c-df62-464a-ab5a-a0762c98e1de",
      text: "B1 - OSP Cabling - EF to GSIDF 1X2",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 80,
      parent: "f9521e9a-0a5d-4806-969d-99217ffb5956",
      progress: 0,
      source_task_id: "B1.CONN.1090"
    },
    {
      id: "63e0e025-62ab-4435-a2aa-6cd5c04c377f",
      text: "Fab and Deliver - CRAH - Area NW-1 - DCB1 *DELETE?*",
      type: 0,
      start_date: "2024-01-09T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 1872,
      parent: "cebac7a2-3c43-4d53-bc0b-02c1d6553116",
      progress: 0.49,
      source_task_id: "B1.OFCI.2690"
    },
    {
      id: "1c3c98ea-7f40-4806-be6e-1793f944696e",
      text: "Fire Protection",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-06-03T08:00:00",
      duration: 904,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 1,
      source_task_id: "PRE1440"
    },
    {
      id: "3fe2faa5-3259-4b61-94f6-4dea7db724d6",
      text: "B2 - 2E1E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5070"
    },
    {
      id: "41cf20f6-36f1-4fb3-a0e3-a139f90fd0aa",
      text: "FR 11 - DPR further investigate and deterimie that it is dense clay but not rock",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 136,
      parent: "2403d63f-04cd-4715-83a5-98a037fa1f56",
      progress: 1,
      source_task_id: "FR.11.1010"
    },
    {
      id: "035e22cc-18b7-4458-b571-7d0325364652",
      text: "B1 - DH-A - Set HACs in Place - Data Hall A - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1930"
    },
    {
      id: "df4d1504-15cd-4330-b115-33d36d9863b8",
      text: "Corridor 2C2 (Sprinkler Riser/GSIDF (2)/Control Panel/Light Inv/Ups Room(2)/Spoke Tech)",
      type: 5,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 1056,
      parent: "e39bc1fd-688e-4691-869d-2615d2579be5",
      progress: 0,
      source_task_id: "7995032"
    },
    {
      id: "a25541c6-ceca-4623-bc06-44d1b4b6ae3b",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Mechanical/Insulation",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1630"
    },
    {
      id: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      text: "B1 - SSB - 1E2 - EF2 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF2)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 8,
      parent: "3194a95d-01d0-4e58-a8af-a7ad35a34912",
      progress: 0,
      source_task_id: "B1.C.SSB.1980"
    },
    {
      id: "2bcb6e37-6b98-47ec-87c6-9add06004006",
      text: "BLDG-1/2 - Fabricate / Deliver - Food Service",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6230"
    },
    {
      id: "4e8b7a7d-ec08-4858-95c9-a9ee08df8e6b",
      text: "B2 - DH-B - Install Thermal Concrete",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1290"
    },
    {
      id: "789686a6-9ac2-4442-bc55-8cd32ff335d8",
      text: "Area 2 - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1960.10"
    },
    {
      id: "cb3dd730-ec2f-44fe-9102-b7eb06e50111",
      text: "B1 - 1C1W - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 8,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1190"
    },
    {
      id: "e77c32f4-8784-45a7-b68b-1000bbf8bf68",
      text: "B1 - 1D1W - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1860"
    },
    {
      id: "e9121d38-8b51-410e-9ddc-f5da5b002722",
      text: "MV Electric",
      type: 5,
      start_date: "2024-11-27T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 232,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995170"
    },
    {
      id: "e96928d1-30b8-4f17-af14-164b20aee7c4",
      text: "B1 - 1A2E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 24,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1800"
    },
    {
      id: "74981eb1-fb0b-4ade-9ca7-fe619bbe96d0",
      text: "Fab and Deliver - Cooling Distribution Unit - Area B - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 3896,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 0,
      source_task_id: "B1.OFCI.3220"
    },
    {
      id: "4f15fc11-4302-46f9-bf8c-5915bf7b710e",
      text: "B2 - mCUP-2 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 48,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2040"
    },
    {
      id: "908f3ddd-a033-46d0-afe5-7a49335c6963",
      text: "Substation-1 - MSG B - MV Terms / NETA Testing / Torques (Finish 03/01/25) - Sequence 2",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 112,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6300"
    },
    {
      id: "d315ec78-23a1-4c80-9607-c035351d49bd",
      text: "Campus Site Utilities - Area 1",
      type: 5,
      start_date: "2024-06-10T00:00:00",
      end_date: "2025-01-04T08:00:00",
      duration: 1152,
      parent: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      progress: 0.06,
      source_task_id: "7995154"
    },
    {
      id: "3ab78e21-d10c-4068-96fd-77bff928aa24",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 40,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2440"
    },
    {
      id: "d9cb8451-406d-462d-bdc3-9144490a4baa",
      text: "L4 Start DH B - DCB1",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-04-21T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2082"
    },
    {
      id: "76dbb63f-e2b5-4ff9-98af-f566475f94da",
      text: "B1 - DH-B - Install Celing Devices Fire Protection - Data Hall B",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2800"
    },
    {
      id: "77070421-e838-41b8-ad2a-109fd4b9fc92",
      text: "B1 - mCUP-2 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2020"
    },
    {
      id: "41282a1c-37f1-444a-a339-bae8480964d4",
      text: "B2 - DH-A - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 704,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1260"
    },
    {
      id: "00ef6860-f91b-40fb-b664-4fe169ed8a61",
      text: "B2 - Deep Telecom - EF1",
      type: 0,
      start_date: "2025-03-10T00:00:00",
      end_date: "2025-03-14T08:00:00",
      duration: 40,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2250"
    },
    {
      id: "9d1297dc-36c4-4e5d-bad9-500d5a4a3a79",
      text: "FR 15 - DPR prepare and Submit RFI #68.2",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "150fc470-4247-402f-8c28-d9b141485933",
      progress: 1,
      source_task_id: "FR.15.1000"
    },
    {
      id: "f903e28c-4906-4080-bf57-47788d7d475a",
      text: "B1 - 1C1W - 01C.07 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.2260"
    },
    {
      id: "f9694fe6-22e6-41c1-a548-8d45e738a205",
      text: "B1 - DH-A - Room QA/QC Pre DEC-C Turnover - Data Hall A",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2750"
    },
    {
      id: "411d887d-c59d-46aa-9e66-aea427969932",
      text: "Corridor 2B2 (Restroom/GS IDF (2)",
      type: 5,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 1016,
      parent: "7fb33c35-1204-4516-b5fc-1de04cad777e",
      progress: 0,
      source_task_id: "7995071"
    },
    {
      id: "f40f4c36-844f-40d8-8db1-2eb41533108d",
      text: "B1 - DH-B - El Equip Yd - Set Equipment (2)MSG",
      type: 0,
      start_date: "2025-06-17T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 80,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3010"
    },
    {
      id: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      text: "BLDG-1 SSB 1E1 Carrier MDF 1",
      type: 5,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 344,
      parent: "c6a66845-9cdf-419f-bc39-f7cbf2425030",
      progress: 0,
      source_task_id: "7995289"
    },
    {
      id: "42c5b619-60d6-4fd7-ad05-1e4f760a2b09",
      text: "Utilities Design Package",
      type: 0,
      start_date: "2024-01-24T00:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 296,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.2220"
    },
    {
      id: "efec6b5a-5634-43a5-b571-748e500afd9a",
      text: "BLDG-1 Network ElectricalTerms",
      type: 5,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 264,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "7995258"
    },
    {
      id: "c297997b-e1e0-4d4b-9303-acc1424681ad",
      text: "Area B - Install Door Frames",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1240"
    },
    {
      id: "cebac7a2-3c43-4d53-bc0b-02c1d6553116",
      text: "(OFCI) B1 CRAH Units *DELETE?? CFCI?*",
      type: 5,
      start_date: "2024-01-09T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 1872,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.49,
      source_task_id: "7994991"
    },
    {
      id: "61d8a848-a111-42d4-80f2-e97260d63199",
      text: "Substation-1 - MSG A - Pre-energization MSG A and DC System / Battery Commissioning - Sequence 1",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 160,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4030"
    },
    {
      id: "2be26207-dbca-4279-9a53-24684a97817a",
      text: "Fragnet 23 - PCO # 19 RFI-084 Tele Man Hole 017 Removal",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 512,
      parent: null,
      progress: 0.62,
      source_task_id: "8690693"
    },
    {
      id: "dbb0c3fc-db8d-4417-9a83-7fd31a39070c",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1320"
    },
    {
      id: "56a47bbc-86ba-4f6d-bdcb-ced25f42be1f",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 120,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2020"
    },
    {
      id: "72880b0e-8d3c-4b84-b336-4427b77512d2",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [9] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 2712,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.38,
      source_task_id: "B1.OFCI.3550"
    },
    {
      id: "52111880-f074-41b4-8a0d-a4e2c5db4490",
      text: "B2 - DH-A - Power Alley  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-12-15T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 40,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1130"
    },
    {
      id: "5cd05ebf-e3f6-418a-b4a4-5e2b32f12b30",
      text: "B2 - 2E1E - EF4 - Build Wall Between MDF/Fiber Entry and Carrier (EF4)",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5110"
    },
    {
      id: "dca8ffda-be52-413d-9368-db56579d09e5",
      text: "B2 - DH-C - Power Alley - Power Alley - Install GS Cable Tray",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 96,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1940"
    },
    {
      id: "38a7e1b1-d0ea-4658-a6c9-ebadcab872da",
      text: "B1 - 1N2W - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1450"
    },
    {
      id: "c6f5ffe3-80a2-4dff-b052-c9b140a040e5",
      text: "Final Paint",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1210"
    },
    {
      id: "de1c52c6-581c-4cec-91ad-df6cc6647ae4",
      text: "Mass Timber - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 128,
      parent: null,
      progress: 1,
      source_task_id: "Design.PreC.5890"
    },
    {
      id: "45a96d99-1a2d-478c-b52e-f86d47bb1d4b",
      text: "Equipment Installation by Morgan",
      type: 0,
      start_date: "2025-02-04T00:00:00",
      end_date: "2025-02-08T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8210"
    },
    {
      id: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6",
      text: "B1 - DH-A - El Equip Yd - Buildout MSG and Set-In Place inspections",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 80,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2800"
    },
    {
      id: "7fcc67fd-c50c-44ab-97a1-a7f81b14a909",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1130"
    },
    {
      id: "4afc810d-85af-4009-ad12-51462618da45",
      text: "mCUP - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 1,
      source_task_id: "B1.OFCI.1810"
    },
    {
      id: "0577b673-7309-47d7-974d-03b269939669",
      text: "Connectivity [ETO]",
      type: 5,
      start_date: "2025-06-04T08:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 3232,
      parent: "4d7f99a1-a653-43bf-b87f-5b8e20378bdb",
      progress: 0,
      source_task_id: "7995430"
    },
    {
      id: "1615638a-a40f-4417-8464-768dddb76836",
      text: "L5 - B1 DHC",
      type: 0,
      start_date: "2026-08-07T00:00:00",
      end_date: "2026-08-10T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHC.1000"
    },
    {
      id: "22b094e2-d114-4611-93cf-8d54204c0657",
      text: "B1 - DH-B - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1270"
    },
    {
      id: "f24708ae-3472-4332-a5d3-8daad7ccff0b",
      text: "B2 - mCUP-5 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 16,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5010"
    },
    {
      id: "77d4c7c9-7763-459c-96c7-e26d063ec128",
      text: "B1 - 1D1W - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1720"
    },
    {
      id: "45274fc4-697c-4dc2-ba51-e4b7e583ed48",
      text: "B1 - DH-D - Install Insulation",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 40,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1360"
    },
    {
      id: "13dfb0cc-ff57-49a7-9900-0e7eb3455ef2",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2150"
    },
    {
      id: "0c2766ed-67b4-49fc-9d5e-6eb9e57b9f63",
      text: "Fab and Deliver - Battery Monitoring & Diagnostic System - Area D - DCB1",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 3528,
      parent: "4bef5be0-b299-4faa-b366-fd0ba2a8ee98",
      progress: 0.27,
      source_task_id: "B1.OFCI.2800"
    },
    {
      id: "c7ccfef2-7405-4c1b-b335-d12d308d8549",
      text: "B1 - mCUP-1-9 - Piping Install (Header) UG to Building",
      type: 0,
      start_date: "2024-10-14T00:00:00",
      end_date: "2024-11-05T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1080"
    },
    {
      id: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a",
      text: "B1 - DH-B - Set HACs in Place - Data Hall B - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2180"
    },
    {
      id: "2050da74-3800-4e4d-8d44-81a7e62d3473",
      text: "B1 - OSP Cabling - EF to TWRIDF1",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 40,
      parent: "f9521e9a-0a5d-4806-969d-99217ffb5956",
      progress: 0,
      source_task_id: "B1.CONN.1190"
    },
    {
      id: "c4f4e164-3919-47d5-be4e-be3938783854",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area A (22) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-04-18T08:00:00",
      duration: 2456,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.43,
      source_task_id: "B1.OFCI.2430"
    },
    {
      id: "2afb7d0f-1e67-4513-8a45-1eac89fe7f03",
      text: "B2 - 2C1W - 02C.08 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-05-27T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.2470"
    },
    {
      id: "c843df31-38a5-4705-819d-f3c428d72755",
      text: "FR 01 - Sanitary Sewer Redesign - Added Scope",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "FR.01.1100"
    },
    {
      id: "0838401f-ca7a-4b90-a871-63675f860af4",
      text: "(CFCI) Div. 33 - Utilities  Storm / Sanitary Manholes and Inlets",
      type: 5,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-07-15T08:00:00",
      duration: 552,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0.76,
      source_task_id: "7994894"
    },
    {
      id: "009342b9-d9d4-41b9-85b8-9ff8339a0d2e",
      text: "BLDG-1/2 - Prep / Submit for Review - Joint Sealants",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 160,
      parent: "0dd0f158-898f-4192-8581-e48c7623784f",
      progress: 0,
      source_task_id: "B1.CFCI.4580"
    },
    {
      id: "0134279a-2dc0-4bf4-b8a6-b8d457d7336d",
      text: "B1 - mCUP-6 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 80,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.9300"
    },
    {
      id: "7bffd7ca-56a1-4658-9c5a-9a85a570f179",
      text: "B1 - DH-B - Install IMP Ceiling - Data Hall B",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2020"
    },
    {
      id: "6e0d2a71-1c69-4b0d-9ef9-3946c4c90d9f",
      text: "B2 - 2E2E - EF2 - Hang/Tape/Finish Drywall (EF2)",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6170"
    },
    {
      id: "882d5be6-1cd9-40b8-aa35-2c5f93eab8c9",
      text: "Substation-1 - Install Fencing",
      type: 0,
      start_date: "2025-04-15T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 144,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.7060"
    },
    {
      id: "3ebf2ec1-0742-4fd5-b1f4-42239dfd77c1",
      text: "B1 - DH-A - Set CDU's - Data Hall A (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 64,
      parent: "a565da4e-47a6-49f6-9a35-7baee475a452",
      progress: 0,
      source_task_id: "B1.C.A.3020"
    },
    {
      id: "e24710c8-84f0-4739-8ad1-5ad18f9d3dda",
      text: "B2 - 2E2E - 02.01.E2.01 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6470"
    },
    {
      id: "2af75056-6a2d-4ee1-a19d-b97049236c3b",
      text: "Substantial Completion (DH B) - DCB1",
      type: 0,
      start_date: "2026-08-03T08:00:00",
      end_date: "2026-08-03T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.B1.1070"
    },
    {
      id: "8b311f7c-6070-4db4-8e0d-186b9dc5ac49",
      text: "B2 - 2A2 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2140"
    },
    {
      id: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8",
      text: "Civil IFP Issuance",
      type: 0,
      start_date: "2024-03-15T08:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 0,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.3000"
    },
    {
      id: "6ce8af76-476c-4f0d-85af-ff1a76906202",
      text: "B2 - DH-C - Install Underground Plumbing",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 120,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1370"
    },
    {
      id: "ce0c0a53-8d74-44bd-91bb-7c9ce77ad646",
      text: "Precon- Design Precon",
      type: 5,
      start_date: "2023-10-16T00:00:00",
      end_date: "2024-08-19T08:00:00",
      duration: 1704,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 0.8,
      source_task_id: "7994738"
    },
    {
      id: "8c42d50e-c3f1-4e8c-94e0-e8a626ae18bb",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2340"
    },
    {
      id: "09b79ccd-8edf-4589-baec-fc3da020e460",
      text: "B2 - DH-C - Hookup CDU's - Data Hall C",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-07-02T08:00:00",
      duration: 144,
      parent: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      progress: 0,
      source_task_id: "B2.C.C.3270"
    },
    {
      id: "820d6ce5-7d14-47b1-ba0b-3ed260d2f495",
      text: "B2 - DH-A - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 120,
      parent: "1aabe25a-9110-4d14-bd63-29d9dfc2e3c1",
      progress: 0,
      source_task_id: "B2.C.STR.2100"
    },
    {
      id: "9a6cce23-901c-4384-8f62-9bd0d3eda8a2",
      text: "B2 - DH-A - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-03-28T08:00:00",
      duration: 16,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2390"
    },
    {
      id: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c",
      text: "Area 1 - Water Utilites Install",
      type: 0,
      start_date: "2024-10-15T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 40,
      parent: "4eb20726-ed89-4a86-a5df-85ab23867b33",
      progress: 0,
      source_task_id: "C.CSU.A1.5000"
    },
    {
      id: "3a9b1564-f121-497c-8782-824ffa45a30e",
      text: "B1 - 1A2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1630"
    },
    {
      id: "fc995a77-06a1-4ddc-a685-38eaee1cf2cf",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2190"
    },
    {
      id: "0760e5c1-96bd-4d19-827b-383962e60963",
      text: "FR 17 - DPR Prepare and Submit PCO#13",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: null,
      duration: 216,
      parent: "ff6b063e-140d-44b7-8199-0a0452134f17",
      progress: 0.5,
      source_task_id: "FR.17.1020"
    },
    {
      id: "ea0d5659-0623-45c4-b3bf-862dc5be26d4",
      text: "Pad Prep / Deep Foundations - BLDG 2 mCup",
      type: 0,
      start_date: "2025-03-06T00:00:00",
      end_date: "2025-03-11T08:00:00",
      duration: 40,
      parent: "dc72aba6-4aeb-4210-b919-c8cf0233965f",
      progress: 0,
      source_task_id: "C.CSU.A3.1010"
    },
    {
      id: "066282e1-a68b-4886-be1a-028c94e2d058",
      text: "Area 3 - UG RI -Generator/LB/GSB -DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1460"
    },
    {
      id: "9e562eca-9bd2-4cc5-821c-9f0a6cb0ba03",
      text: "BLDG-1 - Building - Overall Duration - BG to CCO - (LOE)",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 7240,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0.06,
      source_task_id: "AUX.MILE.1550"
    },
    {
      id: "b974a2f5-ce56-4cc5-aa3a-748b588b9bd6",
      text: "UG RI -Panel Boards (PB)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "a187e15c-5311-477e-8dcb-810084b7ae80",
      progress: 0,
      source_task_id: "MECO-1640.20"
    },
    {
      id: "0a56b3da-eaeb-41af-8802-22dc9e70e73d",
      text: "B1 - DH-C - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 216,
      parent: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      progress: 0,
      source_task_id: "B1.C.STR.2260"
    },
    {
      id: "58979e2c-d924-45a6-af73-baa12f1084e1",
      text: "B1 - 1N2W - 01N2.06 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.5770"
    },
    {
      id: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      text: "(OFCI) B2 Busway Kits",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2026-03-06T08:00:00",
      duration: 4712,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.19,
      source_task_id: "7994956"
    },
    {
      id: "bb214aea-e7e6-4f1c-ada4-9396abe8bbcd",
      text: "B1 - 1N2E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5240"
    },
    {
      id: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 256,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995394"
    },
    {
      id: "21d08f23-b8b3-41f1-a04b-e7691b7446c3",
      text: "B1 - DH-C - Install Joists",
      type: 0,
      start_date: "2025-05-28T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 120,
      parent: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      progress: 0,
      source_task_id: "B1.C.STR.2070"
    },
    {
      id: "0643a591-df62-4540-b40c-b55e8255b67c",
      text: "DFSMA - DC1 - TWR 1 - GS.IDF Remote Module ROJ - MOFE",
      type: 0,
      start_date: "2025-09-10T08:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 0,
      parent: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      progress: 0,
      source_task_id: "B1.DFSMA.1230"
    },
    {
      id: "c3171f33-313a-4a8a-98c3-7c1164e3704c",
      text: "BLDG-1/2 - Fabricate / Deliver - Lighting",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 360,
      parent: "35f922d0-d8cc-464c-8795-760c9606b1a3",
      progress: 0,
      source_task_id: "B1.CFCI.4320"
    },
    {
      id: "0ee4e98b-820a-4428-9a8e-701184cde28c",
      text: "B2 - DH-D - L2 CDU Install Verification - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-08-24T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 144,
      parent: "9de23734-57e7-4283-a531-2f57ac2525e9",
      progress: 0,
      source_task_id: "B2.C.D.3360"
    },
    {
      id: "7a64b4b8-e869-4511-ac8a-c43f3fad733d",
      text: "FR 07 - DPR Prepare and Submit RFI# 14.1",
      type: 0,
      start_date: "2024-06-28T00:00:00",
      end_date: null,
      duration: 16,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 1,
      source_task_id: "FR.07.1010"
    },
    {
      id: "41f5963d-df09-4d07-8566-b2244ab87b6c",
      text: "Fab and Deliver - Substation XFMR - Area SS-2 (2) - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 3112,
      parent: "670bdb28-db62-4fc2-b89a-d1ad6f28ec8c",
      progress: 0.36,
      source_task_id: "B2.OFCI.2120"
    },
    {
      id: "1e2b9f11-da25-404b-bddc-3da71ecd9912",
      text: "B1 - DH-D - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1530"
    },
    {
      id: "a359f2e6-2c6b-41eb-8fb1-79ed9f89b547",
      text: "B1 - DH-A - Pull Feeders Bussways - Data Hall A",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2520"
    },
    {
      id: "5fb26a39-2e42-4fd4-baad-a8b7c927c408",
      text: "B1 - 1N1W - Corridor - OH Rough In Feeder",
      type: 0,
      start_date: "2025-06-21T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5070"
    },
    {
      id: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      text: "Substation-2 B Lineup SF6 Breaker",
      type: 5,
      start_date: "2025-08-01T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 1616,
      parent: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      progress: 0,
      source_task_id: "7995226"
    },
    {
      id: "4d05b14e-8092-4263-a869-e1aa9684708b",
      text: "B2 - SSB - 2E1 - Common - Install Rubber Base",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1400"
    },
    {
      id: "73533502-6f43-4338-a644-e96d364dbd5f",
      text: "B1 - DH-C - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 40,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1230"
    },
    {
      id: "e9ea4763-c9bb-42cf-a721-eed0a5f66f67",
      text: "B1 - Mill Course Base Paving",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 96,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1050"
    },
    {
      id: "650e7b6f-3850-41c2-a99e-75d41ac99385",
      text: "FR 27 - META issue CCD #07",
      type: 0,
      start_date: "2024-09-20T00:00:00",
      end_date: null,
      duration: 0,
      parent: "aa1ff7d6-d087-48dd-9265-36de0702a4b8",
      progress: 1,
      source_task_id: "FR.27.1000"
    },
    {
      id: "d1758336-6ece-48e5-b7a7-3c154d0e13a4",
      text: "Waterproofing / Caulking / Expansion Joints",
      type: 0,
      start_date: "2024-04-05T00:00:00",
      end_date: "2024-06-20T00:00:00",
      duration: 160,
      parent: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      progress: 0.75,
      source_task_id: "PRE1740"
    },
    {
      id: "1936d72e-ef34-4399-afb7-4dfdc1e082fa",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "f4a0770e-db07-467c-95bd-9d401485c3b6",
      progress: 0,
      source_task_id: "MECO-1700.50"
    },
    {
      id: "31847245-1765-42f0-b786-1c126c3849bd",
      text: "B2 - DH-C - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-06-15T08:00:00",
      duration: 160,
      parent: "51c00c83-bd57-417a-a005-a3275c0bb913",
      progress: 0,
      source_task_id: "B2.C.EY.1660"
    },
    {
      id: "a0e52b8b-692d-430b-b316-a56abd7c8e6f",
      text: "B1 - DH-B - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 80,
      parent: "84b1da4e-2cd9-4bc4-82d7-8a532378dfeb",
      progress: 0,
      source_task_id: "B1.C.B.3200"
    },
    {
      id: "ee7f244a-80cc-4705-bc08-2d1ae5d0b6ce",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1510"
    },
    {
      id: "0d76a41d-c2c5-49e2-abb5-619ead8f0c7c",
      text: "B2 - 2B2 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 160,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2020"
    },
    {
      id: "bc79c9f5-d1f2-4bac-8183-c8172cc424b0",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [6] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 2984,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.36,
      source_task_id: "B2.OFCI.2770"
    },
    {
      id: "66cbfc93-d5a4-4bad-9333-abfa5afcf154",
      text: "B2 - DH-A - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 160,
      parent: "ff40e3a6-bbbc-4a6d-a305-083ef7670a8d",
      progress: 0,
      source_task_id: "B2.C.EY.1340"
    },
    {
      id: "68519373-5be8-4c94-895d-f8db4c1edde5",
      text: "Mass Grading Package",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-04-05T08:00:00",
      duration: 912,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "7994745"
    },
    {
      id: "0ec11c16-6c17-4576-bd17-9ee8666f2d17",
      text: "BLDG-1 DH-B - L2 Checkout for Building",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-03-07T08:00:00",
      duration: 200,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1030"
    },
    {
      id: "571ac984-f404-434d-91ca-a3894e570ddf",
      text: "BLDG-2 DH-D",
      type: 5,
      start_date: "2025-11-25T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 1264,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "7995125"
    },
    {
      id: "dd2d09af-f119-45dc-a7a4-77a29c8615b9",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-14T00:00:00",
      end_date: "2026-01-21T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1520"
    },
    {
      id: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f",
      text: "B2 - DH-C - Pull/Term BMS - Data Hall C",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2530"
    },
    {
      id: "8da1abf2-5377-408f-8b11-977b16068494",
      text: "Area B - Cable Tray Install",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 120,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1280"
    },
    {
      id: "48541c8a-033a-4715-9f63-6fa88aa4fa61",
      text: "Fab and Deliver - Water Cooler Chillers - Area mCUP Dry [1] - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-11-11T08:00:00",
      duration: 1504,
      parent: "26f3e6ba-5d43-4ac1-82e8-829e31f2b2b5",
      progress: 0.66,
      source_task_id: "B1.OFCI.3560"
    },
    {
      id: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6",
      text: "Permanent Utility Power (Grid Power) Available - Substation 1",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-22T00:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "TPM.B1.2015"
    },
    {
      id: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      text: "[DCB2] DEC-C Ready: General Services [GS EXTERIOR - CRITICAL]",
      type: 0,
      start_date: "2026-02-11T08:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 0,
      parent: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      progress: 0,
      source_task_id: "ICM.B2.3775"
    },
    {
      id: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      text: "BLDG-2 Entrance Facility 1",
      type: 5,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 296,
      parent: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      progress: 0,
      source_task_id: "7995054"
    },
    {
      id: "cd9c105c-a1fa-49e3-80ce-7fa725d223d0",
      text: "Campus - Prep / Submit for Review - Fencing",
      type: 0,
      start_date: "2024-12-23T00:00:00",
      end_date: "2025-01-22T08:00:00",
      duration: 160,
      parent: "2390c294-1245-4d73-85bc-b779088085b9",
      progress: 0,
      source_task_id: "B1.CFCI.4220"
    },
    {
      id: "bfa698a9-58a1-407b-aeb6-db5a052eb567",
      text: "Substation-1 - TX A - Install Inspection And 3rd Party Controls Cable Verification",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 136,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4120"
    },
    {
      id: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      text: "B1 - DH-C - Cure for SOG",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 24,
      parent: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      progress: 0,
      source_task_id: "B1.C.STR.2360"
    },
    {
      id: "85bb9e2e-92a2-41be-9d2e-f360cd5c9f59",
      text: "FR 35 - META review and Approve PCO#36",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "22f7f124-57e8-4e8a-9a03-b51ea65b5a91",
      progress: 0,
      source_task_id: "FR.35.1030"
    },
    {
      id: "e32d6279-98fb-47f4-9c62-0d77d69b6c47",
      text: "Mass Grading",
      type: 5,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-10-22T08:00:00",
      duration: 80,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0.2,
      source_task_id: "7995191"
    },
    {
      id: "58811e8f-3145-4987-af51-84d80286bcbd",
      text: "Phase 2 - Demo Foundations and Infrastructure",
      type: 0,
      start_date: "2026-07-30T00:00:00",
      end_date: "2026-08-26T08:00:00",
      duration: 160,
      parent: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      progress: 0,
      source_task_id: "C.DEMOB.1080"
    },
    {
      id: "da68dcfd-799f-4659-8a7d-1bcf9db99802",
      text: "Substation-1 - TX B - Install Medium  And High Voltage Cable -Terms",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 104,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3740"
    },
    {
      id: "2c33a1d0-1a0c-4453-a8a2-dc6c797b3022",
      text: "Area 2 - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 184,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1960"
    },
    {
      id: "e00c7895-8ce4-4189-aa94-ead11b56e278",
      text: "B1 - Network Room 1/4  - Install 800 Amp Busway",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1550"
    },
    {
      id: "d02e14e0-b3b2-4499-afea-b4a6b376a21c",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1210"
    },
    {
      id: "824a85a2-b289-4507-b314-eb4bc62c0cf5",
      text: "B2 - SSB - 2E1 - Common - Install Devices in Tile/OH Sprinkler",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1230"
    },
    {
      id: "98a2c595-43fb-4a3d-94e0-39f5e289d6fa",
      text: "B2 - 2E1E - 02.01.E1.05 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5560"
    },
    {
      id: "c1f6a7ac-1c93-432b-b5fe-30be07168a44",
      text: "Fragnet 21 - PCO # 17 CCD-015 TW Loop Fill-Flush Requirements",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 472,
      parent: null,
      progress: 0.33,
      source_task_id: "8690691"
    },
    {
      id: "231a1018-61f1-44f4-b872-bf390102cbda",
      text: "B1 - 1C2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1970"
    },
    {
      id: "f2289e13-4de9-4943-a514-3cdc8ca11c70",
      text: "BLDG-1/2 - (SPW - Div 07) Submittals - Below Grade Waterproofing",
      type: 0,
      start_date: "2024-08-27T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 160,
      parent: "7bb51d4c-8179-4d67-b199-7fb7f7af2db9",
      progress: 0,
      source_task_id: "B1.CFCI.3700"
    },
    {
      id: "f08ac2cb-0850-4511-a49e-5965b6c300d9",
      text: "DFSMA - DC2 - CUP 1- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-09-29T08:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1130"
    },
    {
      id: "233dfe43-74e4-43b1-a244-be069e5d322d",
      text: "B1 - 1N1E - 01N4.06 - Lighting and Devices",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6420"
    },
    {
      id: "441058b9-6a3d-4c16-83ad-3cee55811a0d",
      text: "Admin - Prep / Submit for Review - Roofing",
      type: 0,
      start_date: "2024-08-02T00:00:00",
      end_date: "2024-08-30T00:00:00",
      duration: 1000,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1070"
    },
    {
      id: "e3949285-7508-46b2-988c-b4be2deba2d2",
      text: "Reconciled iGMP Submission Submitted to Meta Legal",
      type: 0,
      start_date: "2024-05-10T08:00:00",
      end_date: "2024-05-10T08:00:00",
      duration: 0,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "ICM.PRE.1530"
    },
    {
      id: "bc4d521c-1316-4309-b8ce-31f2d56b230b",
      text: "B2 - mCUP-8 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 48,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8070"
    },
    {
      id: "2dc13c4f-af7b-4930-8ac3-e0e2da6d455c",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Mechanical",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1050"
    },
    {
      id: "87fa564b-e670-471c-b54c-bd752209f121",
      text: "B1 - SSB - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1250"
    },
    {
      id: "2dca3b84-b0cd-4c91-b6b0-2923cc09696f",
      text: "Area A - Final Paint",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1291"
    },
    {
      id: "ee2d3707-daf6-4648-b2e6-de4d670e2f04",
      text: "B1 - DH-C - Power Alley  - OH Rough In Branch",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1150"
    },
    {
      id: "beea18e1-8273-4cf3-95b7-a29fb923c74a",
      text: "Area B - Install Doors / Hardware",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1440"
    },
    {
      id: "25c1d062-01ae-4563-a707-ee47fabafd4e",
      text: "B1 - West Entrance - install irrigation branch and heads",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1060"
    },
    {
      id: "0277d7b3-e3a7-42c6-9996-54bcc49d9eab",
      text: "Cx Electrical Yards B1",
      type: 5,
      start_date: "2025-11-18T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 200,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995013"
    },
    {
      id: "3722bcc6-e411-4ccb-870c-4c921d9a5b51",
      text: "B1 - ISP Cabling - MDF1 to MDF2 (UG)",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 40,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1060"
    },
    {
      id: "aaf32da7-0596-429b-bad9-bdb69ff5c73c",
      text: "Area B - Pull Wire",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 80,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1510"
    },
    {
      id: "6ff49cc4-e9dc-4841-aef6-4685104df5f6",
      text: "Finishes - Ceilings & Floors",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 24,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1060"
    },
    {
      id: "e49c3a7d-4a9a-4b57-b6f9-066e45d695ee",
      text: "FR 01 - Sanitary Sewer Redesign - Sanitary Civil Permit Revision City Review & Send Comments",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "FR.01.1130"
    },
    {
      id: "c95dcc31-539f-443e-987b-e84c0c944d47",
      text: "IBOS Procurement",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: null,
      duration: 1040,
      parent: null,
      progress: 0,
      source_task_id: "8243680"
    },
    {
      id: "5b295964-9c52-42b3-ab5a-00183b6e9718",
      text: "Site - Dry Utilities SA - Meta Authorized",
      type: 0,
      start_date: "2024-04-09T08:00:00",
      end_date: "2024-04-09T08:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "ICM.PRE.1415"
    },
    {
      id: "28d413d4-625a-49c1-8fa7-781f9878b8db",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1160"
    },
    {
      id: "44660d2f-4a5f-4b5a-94bb-e18a8ccd3d78",
      text: "B1 - DH-D - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 40,
      parent: "62872b9b-6759-4561-825b-c00ed5bb886c",
      progress: 0,
      source_task_id: "B1.C.D.3100"
    },
    {
      id: "326c3858-5e96-4793-bf7c-765e317b18fc",
      text: "Building 1 mCUP-9",
      type: 5,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 608,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995373"
    },
    {
      id: "00158869-5cc2-47a8-83bc-c60af231dc88",
      text: "B2 - 2E2E - EF2 - Fire Alarm Wire Pulls/Terms to devices (EF2)",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6250"
    },
    {
      id: "68a55c82-27f3-4e7e-9f63-dcc080f54ec9",
      text: "Substation-2 - MSG B - Medium Voltage Wire Pulls to HV/MV Transformer (Pulls and Terms)",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 104,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4350"
    },
    {
      id: "d168862b-bafd-49cd-9ca9-0f88bf9ae139",
      text: "B1 - mCUP-9 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9090"
    },
    {
      id: "aff69d35-3ccf-4f09-96e3-c01e2717eacd",
      text: "B2 - SSB - 2E1 - Common - Final Paint",
      type: 0,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 80,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1380"
    },
    {
      id: "2c824a29-b625-4f37-a78f-907d6feaa77a",
      text: "[DCB1] FacNet Live [IBOS]",
      type: 0,
      start_date: "2025-12-18T08:00:00",
      end_date: "2025-12-18T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3697"
    },
    {
      id: "e836e317-00e8-4486-8dc1-35dcfca1db61",
      text: "B2 - mCUP-4 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 48,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4040"
    },
    {
      id: "ff68b3dd-a4a4-4715-a799-2aa656cf93c2",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2060"
    },
    {
      id: "de0d906a-bcf9-439e-9ac9-a34dab232569",
      text: "Fab and Deliver - MVS-4WAY - Area B (9) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 2248,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.06,
      source_task_id: "B1.OFCI.2380"
    },
    {
      id: "3cd7186c-518e-40a3-a348-69fa6a639817",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 160,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1970"
    },
    {
      id: "1f0b601a-65c2-4e21-9ddf-a98ffccb9e82",
      text: "B1 - 1N1E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1310"
    },
    {
      id: "3cbf9162-237a-4029-b85f-3070f07014f9",
      text: "Waterproofing / Caulking / Expansion Joints",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 520,
      parent: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      progress: 0.83,
      source_task_id: "PRE1510"
    },
    {
      id: "22b95600-70be-452b-bf64-73d094807f16",
      text: "Substation-2 - MSG A - Install Batteries",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 40,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4760"
    },
    {
      id: "a4902310-fe36-4f67-81dc-c6698d7f9917",
      text: "B1 - OSP Cabling - CAV-4 to EF1, EF2, EF3, EF4",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 280,
      parent: "69118f10-3a96-4c06-bff2-077ce9c60175",
      progress: 0,
      source_task_id: "B1.CONN.1180"
    },
    {
      id: "c431b625-4de7-4992-a6e8-a34e8ec3078f",
      text: "Fab and Deliver - Busway Kits - Area A - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2026-01-02T08:00:00",
      duration: 4128,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 0.27,
      source_task_id: "B2.OFCI.2070"
    },
    {
      id: "fcfe5293-993f-4ee5-b66b-796af915b6e8",
      text: "B2 - DH-D - Grout column Baseplates",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 48,
      parent: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      progress: 0,
      source_task_id: "B2.C.STR.1920"
    },
    {
      id: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      text: "Fragnet 40 - Swtich board alignment",
      type: 0,
      start_date: "2024-11-08T00:00:00",
      end_date: null,
      duration: 304,
      parent: null,
      progress: 0.43,
      source_task_id: "8816261"
    },
    {
      id: "d952212a-7c20-4301-88c2-d4ea58766e1a",
      text: "Steel Complete - DCB1",
      type: 0,
      start_date: "2025-06-25T08:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1320"
    },
    {
      id: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      text: "B2 - DH-A - Install Underground Telecom",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 80,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1250"
    },
    {
      id: "e9eae808-a58b-4101-b24c-f2e4860ee49b",
      text: "B2 - SSB - 2E2 - Common - Install Wall Devices Fire Alarm",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 48,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1810"
    },
    {
      id: "ea8227d1-d3f7-4e5e-9219-667a8bb5d41b",
      text: "B2 - 2C2 - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1250"
    },
    {
      id: "a530a7df-8470-4ebe-9bce-c0482f5a1f32",
      text: "B2 - ISP Cabling - EF to IDFA (UG)",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 80,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1090"
    },
    {
      id: "d3864721-50a6-458e-9757-22d81dafb9fe",
      text: "B2 - DH-B - Install Insulation",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 40,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1200"
    },
    {
      id: "27b3b15d-60ef-4b92-aaf5-1f7bdcf883d7",
      text: "Overhead Electrical",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 80,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1040"
    },
    {
      id: "824c45aa-79aa-44c1-9452-028364ab53b0",
      text: "Substation-1 - B Lineup - MOAB Assembly / Control Wiring / HV Conductors",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 192,
      parent: "40a947ea-b2c2-46a6-a512-b24f940e157e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3500"
    },
    {
      id: "aed2600b-a779-42e5-9e21-c05ae757a964",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1130"
    },
    {
      id: "418bcefe-41e2-4340-8bfb-124265abfc01",
      text: "DFSMA - DC1 EY-A Skids ROJ - MOFE (Presuming these skids are actually for EL rooms and not PTX/MVS in yard)",
      type: 0,
      start_date: "2025-08-27T08:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 0,
      parent: "993a33a9-ba19-4c70-87e9-c3247582ff68",
      progress: 0,
      source_task_id: "B1.DFSMA.1000"
    },
    {
      id: "f03d9a78-35b0-4045-b2cd-72d4c5310c83",
      text: "IBOS - Fabricate / Deliver - Signage",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6110"
    },
    {
      id: "06c14998-67a6-473c-a15f-e13fff4f61a9",
      text: "B1 - SSB - 1E1 - EF1 - Build Wall Between MDF/Fiber Entry and Carrier (EF1)",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 48,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1350"
    },
    {
      id: "99e93dae-1c76-4e08-af5e-da8861563bf2",
      text: "Final MEPF Trim Outs",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1300"
    },
    {
      id: "19ed5841-5a0f-468b-ad94-546da0261ac0",
      text: "B1 - mCUP-9 - Install Electrical /  Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-13T08:00:00",
      duration: 24,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9100"
    },
    {
      id: "687d955b-cb62-4346-ab68-01dea9268a9f",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Security System",
      type: 0,
      start_date: "2025-01-02T00:00:00",
      end_date: "2025-01-23T08:00:00",
      duration: 120,
      parent: "d7b1b4ab-cbd4-4b4a-808b-511b0980ad59",
      progress: 0,
      source_task_id: "B1.CFCI.4700"
    },
    {
      id: "126a4134-1ae8-4cd2-b194-7885aac03c52",
      text: "B2 - DH-A - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 80,
      parent: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      progress: 0,
      source_task_id: "B2.C.RF.1110"
    },
    {
      id: "69836149-930c-48b4-b739-14f0a3f58793",
      text: "B1 - DH-C - Foundations",
      type: 0,
      start_date: "2025-03-03T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 96,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1260"
    },
    {
      id: "3d507b23-1be2-4905-a76c-b9aeff9a12e5",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH B",
      type: 5,
      start_date: "2025-10-31T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 512,
      parent: "b38b9d81-df08-4732-9a53-49eb573b0138",
      progress: 0,
      source_task_id: "8106479"
    },
    {
      id: "c11a929a-c36b-4337-8bf0-47d168838f02",
      text: "FR 21 - DPR / EOR review the Changes",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 304,
      parent: "c1f6a7ac-1c93-432b-b5fe-30be07168a44",
      progress: 0,
      source_task_id: "FR.21.1010"
    },
    {
      id: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      text: "BLDG-1 SSB 1E1 (GS-MDF Room Only)",
      type: 5,
      start_date: "2025-05-28T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 568,
      parent: "c6a66845-9cdf-419f-bc39-f7cbf2425030",
      progress: 0,
      source_task_id: "7995287"
    },
    {
      id: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      text: "Area 1 - Sanitary Sewer Install",
      type: 0,
      start_date: "2024-10-11T00:00:00",
      end_date: "2024-10-23T08:00:00",
      duration: 88,
      parent: "1534dcf7-aa7a-4956-8e00-a2ce1d980908",
      progress: 0,
      source_task_id: "C.CSU.A1.2000"
    },
    {
      id: "0702b875-ef25-41d8-bc54-5bf0600a31b7",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 120,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2120"
    },
    {
      id: "e3b89732-2b5e-478b-97f8-70e6a445677d",
      text: "Fab and Deliver - Control Power STC/SB - Area B - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 3456,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 0.37,
      source_task_id: "B2.OFCI.2500"
    },
    {
      id: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74",
      text: "[DCB2] DEC-C Ready: Overhead cable tray complete [Area D]",
      type: 0,
      start_date: "2026-10-01T08:00:00",
      end_date: "2026-10-01T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3855"
    },
    {
      id: "78831163-e0bf-4198-958f-4c944a079b14",
      text: "Area B - Install Light Fixtures - Hard Ceilings / ACT",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1340"
    },
    {
      id: "b99e24ae-e3de-4d45-9094-bb837f13fb4b",
      text: "B2 - SSB - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 120,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1040"
    },
    {
      id: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-05-20T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 288,
      parent: "07794b93-17a5-4377-baf1-cbf10c8551fd",
      progress: 0,
      source_task_id: "7995377"
    },
    {
      id: "1a307ad1-9b1d-40cb-b332-5059f338ba19",
      text: "B2 - mCUP-8 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8110"
    },
    {
      id: "bdb7d0fd-44a2-41c4-9393-b59abad9987e",
      text: "Substation-2 - MSG A - Battery Commissioning",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 80,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6530"
    },
    {
      id: "50696560-c491-4e00-b32b-5eac345df713",
      text: "Off Campus - Meta Releases Off Campus Work",
      type: 0,
      start_date: "2024-04-19T00:00:00",
      end_date: "2024-04-19T00:00:00",
      duration: 0,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 1,
      source_task_id: "C.CSW.3040"
    },
    {
      id: "1e8886aa-f56f-4148-b16c-c79188f75884",
      text: "Data Hall A (Area 2-A)",
      type: 5,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 760,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994782"
    },
    {
      id: "272b3138-7764-4cb4-aff5-56b42d9cbc32",
      text: "UG RI -Network Infrastructure-DCB2-Area 3",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 304,
      parent: "afd03ae4-558e-496d-a3a8-0c7b4e1e9e37",
      progress: 0,
      source_task_id: "MECO-1510"
    },
    {
      id: "5bad728e-eb0f-48d5-8b43-6fe06d949d38",
      text: "B2 - 2E2E - 02.01.E1.02 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6550"
    },
    {
      id: "bb55f43a-1d38-40f3-9a85-1bba690dcb2e",
      text: "Area 4a - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 120,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1810.10"
    },
    {
      id: "7656289d-d833-42b4-8e7a-8be485a94508",
      text: "FR 15 - DPR Prepare and Submit PCO#11",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: null,
      duration: 136,
      parent: "150fc470-4247-402f-8c28-d9b141485933",
      progress: 1,
      source_task_id: "FR.15.1020"
    },
    {
      id: "2b3e640a-0ddf-4df8-b656-3100b2422ab8",
      text: "B2 - mCUP-4 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4090"
    },
    {
      id: "eac066a0-891a-4d9e-b0a4-469228a55362",
      text: "B1 - mCUP-8 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 48,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8000"
    },
    {
      id: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      text: "Precon- Trade Procurement",
      type: 5,
      start_date: "2023-11-15T00:00:00",
      end_date: "2024-11-26T08:00:00",
      duration: 2088,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 0.56,
      source_task_id: "7994727"
    },
    {
      id: "bf5e2723-2ea6-46df-9d93-cbbcb2f86406",
      text: "BLDG-1/2 - Fabricate / Deliver - HVAC Insulation",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 40,
      parent: "8901a989-4c49-4864-834a-2a9756542651",
      progress: 0,
      source_task_id: "B1.CFCI.3910"
    },
    {
      id: "38dfa9ba-a89e-42bf-a519-ae07b2f7ccac",
      text: "Start HAC set in place - DCB2",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-03T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1725"
    },
    {
      id: "1bed9582-60b9-4fad-9cbd-a514f1d8a6a4",
      text: "Fab and Deliver - MVS-4WAY - Area C (6) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-04-21T08:00:00",
      duration: 2368,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0,
      source_task_id: "B1.OFCI.2570"
    },
    {
      id: "b63f0cab-f66d-4e95-8cf6-9f8db83d674b",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area A (22) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 3272,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.36,
      source_task_id: "B2.OFCI.1700"
    },
    {
      id: "289b41e3-13fb-417a-a60d-faa2eb8a1ea7",
      text: "Area 4a - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2024-12-28T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 192,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1810"
    },
    {
      id: "f500a6d2-8d94-4b8b-a387-3da7d39c03a0",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1220"
    },
    {
      id: "26ffae8b-688d-40b0-b9f0-30ed56867102",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1300"
    },
    {
      id: "b342a75c-3a4f-4f75-8bdd-acfd08a4e619",
      text: "B1 - mCUP-8 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8090"
    },
    {
      id: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Fire Sprinkler",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1750"
    },
    {
      id: "a13d4291-b872-4f47-83f1-68e56f0c81b9",
      text: "B1 - SSB - 1E1 - Common - Install Device Tiles",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2100"
    },
    {
      id: "8fadbf6e-28ba-4684-b008-4bc9de5026ff",
      text: "Area 3 - Storm Install (remainders)",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8040"
    },
    {
      id: "2d50ccf5-cdc7-4321-95fa-8eb9bcdceb98",
      text: "L3 Start Guard House/Fire Pump House - DCB1",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-11-24T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2035"
    },
    {
      id: "c07e2644-5412-4257-b98b-5dc97e8dd793",
      text: "FR 24 - DPR Prepare and Submit PCO#20",
      type: 0,
      start_date: "2024-09-18T00:00:00",
      end_date: null,
      duration: 264,
      parent: "2ff871d6-c6b3-47c0-a53e-259b72b200a5",
      progress: 0.5,
      source_task_id: "FR.24.1010"
    },
    {
      id: "e80d78df-783b-4386-bfa2-5ae701de5845",
      text: "Area 4 - MV Electric Install - Priority for Foundations (Sub to MV Loop) - Concrete Scope",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 136,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A4.8080"
    },
    {
      id: "a5fdd629-393b-464f-9268-8fe65e84b184",
      text: "Fragnet 04 - BMcD VE Lighting Efforts",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: null,
      duration: 224,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.86,
      source_task_id: "8519853"
    },
    {
      id: "d04c4b2b-8c64-4841-855b-eca9f99ff44d",
      text: "B2 - 2E2E - EF2 - Build Wall Between MDF/Fiber Entry and Carrier (EF2)",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 48,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6090"
    },
    {
      id: "e301e0be-f7f8-46c4-8204-68b86cb3e42a",
      text: "FR 03 - Telecom Redesign - Issue Identification and Notification",
      type: 0,
      start_date: "2024-05-10T00:00:00",
      end_date: "2024-05-10T08:00:00",
      duration: 8,
      parent: "0497b6bf-f811-43f6-b6dc-b788f581380d",
      progress: 1,
      source_task_id: "FR.03.1000"
    },
    {
      id: "19345dfd-a119-4249-8e05-a47a6e5952a2",
      text: "Area 2 - Mass Grading - Remainder Post Permit Delay",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-09-13T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A2.8070"
    },
    {
      id: "b13b2083-0b59-41eb-bba0-f29dd1ee78ed",
      text: "FR 01 - Sanitary Sewer Redesign - Issue Identification and Notification",
      type: 0,
      start_date: "2024-04-26T00:00:00",
      end_date: "2024-04-26T08:00:00",
      duration: 8,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1000"
    },
    {
      id: "ad04b24f-7db0-4091-9161-ac126727e117",
      text: "Install ACT Grid",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1210"
    },
    {
      id: "bd66cb46-a83b-4343-a7d4-12d68b9d29cf",
      text: "B2 - DH-B - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 304,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1030"
    },
    {
      id: "b8c36790-8481-4ac1-a6fe-9977f01fa53d",
      text: "Area 1 - Sanitary Sewer Install - Lift Station - Added Scope",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-09-30T08:00:00",
      duration: 80,
      parent: "1534dcf7-aa7a-4956-8e00-a2ce1d980908",
      progress: 0,
      source_task_id: "C.CSU.A2.8020"
    },
    {
      id: "ce7cb5f0-235d-4c03-92b0-77a564aac29b",
      text: "B2 - SSB - 2E1 - Common - Install Ceiling Grid",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 64,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1190"
    },
    {
      id: "a2de943d-9ec6-4578-a401-3bd550906b78",
      text: "B1 - mCUP-6 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 24,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6100"
    },
    {
      id: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      text: "(OFCI) B1 Busway Kits",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3648,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.25,
      source_task_id: "7994981"
    },
    {
      id: "b895aa3a-37d1-45c9-b2ba-5160fc999de8",
      text: "B1 - DH-B - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 120,
      parent: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      progress: 0,
      source_task_id: "B1.C.STR.2280"
    },
    {
      id: "d9158d21-9e6a-4bbb-bcc2-91c56b3ffc6a",
      text: "B2 - DH-D  - Power Alley - OH Rough In Security",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1100"
    },
    {
      id: "a4d4f525-9806-4cc5-bb76-69b28522293c",
      text: "B1 - 1N1E - 01N4.06 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 144,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6250"
    },
    {
      id: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      text: "Area-4",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: "2025-04-19T08:00:00",
      duration: 1304,
      parent: null,
      progress: 0,
      source_task_id: "8444253"
    },
    {
      id: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      text: "Building 2 mCUP-7",
      type: 5,
      start_date: "2025-11-11T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 544,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995145"
    },
    {
      id: "826defa0-bab9-41a4-9328-11c1e8e045e2",
      text: "B2 - DH-A - L2 CDU Install Verification - Data Hall A",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-04-14T08:00:00",
      duration: 144,
      parent: "560c76d0-46ee-4116-9c68-58099187fdb2",
      progress: 0,
      source_task_id: "B2.C.A.3200"
    },
    {
      id: "33063251-efce-455a-a250-cab7d9a84c1a",
      text: "B1 - Network Room 1/4  - OH Rough In Inspections",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2060"
    },
    {
      id: "ecef52da-83fc-44d1-ba1f-56501ee5e577",
      text: "BLDG-2 - Core - Construction Duration - FDN to DEC-C - (LOE)",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 2248,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0,
      source_task_id: "AUX.MILE.1350"
    },
    {
      id: "70b0f6d6-b056-4124-9764-958c18d93ef9",
      text: "ATS - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "e82c00c0-46a2-49c1-b8f5-86862524d82e",
      progress: 1,
      source_task_id: "B2.OFCI.1400"
    },
    {
      id: "971a2961-8489-47aa-b6eb-58d54e716b86",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2720"
    },
    {
      id: "89fc80ab-e240-4ccd-b7af-e5cfebb0fb20",
      text: "Electrical GCs and Fee - Develop SA Package",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-26T08:00:00",
      duration: 80,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "PRE1200"
    },
    {
      id: "9f34293e-7961-4abe-b736-9bcb89c09c60",
      text: "B2 - 2A1 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 8,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1390"
    },
    {
      id: "612ff8c3-6244-4794-a6d8-37d95a4390b7",
      text: "Precast Area D",
      type: 5,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 40,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "7995021"
    },
    {
      id: "cc67d785-73b4-4612-847b-0c3e2759ac1b",
      text: "B1 - DH-B - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 120,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1270"
    },
    {
      id: "44c04805-901b-4212-95e8-8143f388131c",
      text: "B1 - mCUP-7 - Install FA  (Wire Pulls)",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 24,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7080"
    },
    {
      id: "5f50c853-b639-4545-8a89-996935d18d66",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.2130"
    },
    {
      id: "802be593-d644-4540-aac9-a98b564c0317",
      text: "Delivery of PTX - Pad Mounted Transformers (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-06-06T08:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1830"
    },
    {
      id: "7dd68318-744f-43a7-9787-9563dcffdf5f",
      text: "BLDG-1/2 - Fabricate / Deliver - Vesda System",
      type: 0,
      start_date: "2024-12-18T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 320,
      parent: "3e0c2709-f6dd-4154-90ac-684cc2b77033",
      progress: 0,
      source_task_id: "B1.CFCI.5190"
    },
    {
      id: "5d53e708-d117-4cf3-8998-040429394f2a",
      text: "B2 - DH-D - Install IMP Walls @ FCAs - Data Hall D",
      type: 0,
      start_date: "2026-05-06T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1840"
    },
    {
      id: "c24201dc-823c-44b6-82cc-3f9b8200e716",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 24,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1890"
    },
    {
      id: "72b88ae1-8587-42b2-b7eb-8f932042fbe1",
      text: "B2 - 2A2 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 80,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1700"
    },
    {
      id: "35697f12-0557-4de0-9cd6-a3ebbc175e3e",
      text: "Fab and Deliver - RSB - Area B - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2584,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.48,
      source_task_id: "B1.OFCI.3050"
    },
    {
      id: "b5de7f76-7175-497d-8627-a55c129b76fe",
      text: "B1 - DH-D - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 80,
      parent: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      progress: 0,
      source_task_id: "B1.C.D.3060"
    },
    {
      id: "cec4a492-53a7-45e4-8318-0444a2ea10bd",
      text: "B1 - 1N1E - EF4 - Terms for Lighting/Outlet/Racks (EF4)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 24,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5870"
    },
    {
      id: "560c76d0-46ee-4116-9c68-58099187fdb2",
      text: "FCA Gallery DH-A",
      type: 5,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 416,
      parent: "8c6f09f2-2af7-4585-afeb-4a4318520839",
      progress: 0,
      source_task_id: "7995094"
    },
    {
      id: "7d23d5da-b4d3-4825-b653-c67882cf9119",
      text: "B1 - DH-A - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1650"
    },
    {
      id: "7b616c69-001d-443a-b32c-4288a474e3ca",
      text: "B1 - DH-D - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 80,
      parent: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      progress: 0,
      source_task_id: "B1.C.D.3130"
    },
    {
      id: "f443b980-3700-420e-b9fd-97b1edb2dd7c",
      text: "B1 - DH-C - Inspect Above Ceiling - Data Hall C",
      type: 0,
      start_date: "2026-01-20T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 48,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2620"
    },
    {
      id: "b2835994-c51c-4a7f-aee1-aa18a70f9331",
      text: "B1 - DH-D - Room QA/QC Pre DEC-C Turnover - Data Hall D",
      type: 0,
      start_date: "2026-03-04T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1440"
    },
    {
      id: "d522b072-7ff5-4e06-8643-ba650a58b672",
      text: "FR 09 - DPR Investigate & Identify organic matter @ DCB-2",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "64c1284c-d6e1-4add-b5b3-bc6e1e9a4b2b",
      progress: 1,
      source_task_id: "FR.09.1000"
    },
    {
      id: "c7fa11d0-7ecb-4293-a2c9-67183646fda2",
      text: "FR 11 - DPR Encounter Rock during excavation @utility substation",
      type: 0,
      start_date: "2024-08-05T00:00:00",
      end_date: null,
      duration: 0,
      parent: "2403d63f-04cd-4715-83a5-98a037fa1f56",
      progress: 1,
      source_task_id: "FR.11.1000"
    },
    {
      id: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 24,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1420"
    },
    {
      id: "ad9b77cc-4b44-4de1-8c07-7cbdb2a25444",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 40,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1550"
    },
    {
      id: "eeb27339-fb79-41c1-bec2-a7a79b829d2d",
      text: "Final Punch - B1 DHC & DHD",
      type: 0,
      start_date: "2026-08-26T00:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 40,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX5.B1.DHC.1010"
    },
    {
      id: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d",
      text: "B1 - mCUP-7-9 - Piping POC's, Devices, final dress out C/D Data Halls (Fill and Flush Building)",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 160,
      parent: "0030099f-bbea-4b45-9ffb-9bcfe33c7559",
      progress: 0,
      source_task_id: "B1.mCUP.9240"
    },
    {
      id: "bac9ce1a-54a9-49d8-9c9f-b001aa4bc673",
      text: "IBOS -  Fabricate / Deliver - PEMB Steel",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 680,
      parent: "bb4ccf8c-2430-46e8-8802-789fa95742f7",
      progress: 0,
      source_task_id: "B1.CFCI.6380"
    },
    {
      id: "3e16f800-ce34-4ca3-baa0-34213b8cae96",
      text: "B2 - DH-C - Install Ceiling Devices - Lighting - Data Hall C",
      type: 0,
      start_date: "2026-06-01T00:00:00",
      end_date: "2026-06-26T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2480"
    },
    {
      id: "17c03a9b-5fea-494f-b09a-23ad23096edd",
      text: "FR 06 - META/ EOR Review/ Answer / ISSUE CCD# XX",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 0,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1030"
    },
    {
      id: "158779dd-5ff0-4812-8888-27e4c39a2909",
      text: "FR 14 - META review and respond to RFI #41",
      type: 0,
      start_date: "2024-07-17T00:00:00",
      end_date: null,
      duration: 64,
      parent: "abce5df4-8ee4-4f0a-85e7-22726c1c832f",
      progress: 1,
      source_task_id: "FR.14.1180"
    },
    {
      id: "115d14d1-96a9-4453-b70d-27986bcbc4ca",
      text: "B1 - 1N1E - 01N4.07 - Lighting and Devices",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-30T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6430"
    },
    {
      id: "07b674e1-dc2f-4493-bbab-2dba2ae7acc1",
      text: "PWO Signed",
      type: 0,
      start_date: "2023-11-15T00:00:00",
      end_date: "2023-11-15T00:00:00",
      duration: 0,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "ICM.PRE.1020"
    },
    {
      id: "89a1abd8-4572-4cd6-9e2a-57a4c59d1444",
      text: "B1 - 1N2W - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 80,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1780"
    },
    {
      id: "6085fb25-50fd-4b16-bef7-eb44c01cba07",
      text: "B2 - DH-B - L2 CDU Install Verification - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 144,
      parent: "d2bd53c0-cfe3-4110-8e81-f5665f925980",
      progress: 0,
      source_task_id: "B2.C.B.3280"
    },
    {
      id: "d0037e20-5d27-46bf-922a-1c9b9e992101",
      text: "B1 - DH-D - Rough in HAC Lighting - Data Hall D",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1190"
    },
    {
      id: "66af152a-a06e-4f23-b0bf-67d83d82786a",
      text: "B1 - mCUP-2 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.9260"
    },
    {
      id: "35da25ca-6f7a-4029-80ca-d3567c9c5330",
      text: "B2 - DH-B - Install Door/Hardware/ Wall Trim - Data Hall B",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2890"
    },
    {
      id: "01dda793-bff4-4724-8346-c0997fef1457",
      text: "B2 - DH-D - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 240,
      parent: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      progress: 0,
      source_task_id: "B2.C.STR.1810"
    },
    {
      id: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      text: "UPS Room 02C.07",
      type: 5,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 440,
      parent: "df4d1504-15cd-4330-b115-33d36d9863b8",
      progress: 0,
      source_task_id: "7995029"
    },
    {
      id: "4e59b52c-1f38-413f-b50f-c638d57eaa94",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH D",
      type: 5,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 744,
      parent: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      progress: 0,
      source_task_id: "8106481"
    },
    {
      id: "abd0cea0-a044-4524-9874-930065f141fd",
      text: "B1 - 1N1E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 80,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1530"
    },
    {
      id: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      text: "GS.IDF.1C1",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 736,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "7995279"
    },
    {
      id: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd",
      text: "B2 - ISP Cabling - E2 to E3 (UG) ((Corpnet Live))",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1040"
    },
    {
      id: "a80dddbe-a709-4f29-ac5d-d3cbe5d97f2e",
      text: "B2 - DH-D  - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 16,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1600"
    },
    {
      id: "081cf95d-1a9b-4486-a2d5-a24d02b883b3",
      text: "B2 - DH-D - DEC -C Turnover Walk - Data Hall D",
      type: 0,
      start_date: "2026-10-29T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 16,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2690"
    },
    {
      id: "c8e33e25-2772-4bc2-b198-030af753ecb3",
      text: "Substation-1 - MSG B - Battery Commissioning",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 48,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3650"
    },
    {
      id: "40625718-f733-4d7d-b680-1e6049d28304",
      text: "B1 - SSB - 1E2 - CMDF2 - Build Wall Between MDF/Fiber Entry and Carrier (Carrier MDF2)",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 48,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1410"
    },
    {
      id: "1c0ddb56-864a-4ae2-807a-27ceb9f2f576",
      text: "B1 - mCUP-7 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 80,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.9310"
    },
    {
      id: "2c966fd6-cd00-4769-8599-fe294edc2937",
      text: "FR 08 - META review and Approve PCO#4 (ROM)",
      type: 0,
      start_date: "2024-08-23T00:00:00",
      end_date: null,
      duration: 200,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "FR.08.1050"
    },
    {
      id: "025f7736-8841-42ad-887c-bb57088ea671",
      text: "NW (Area I-N)",
      type: 5,
      start_date: "2024-08-06T00:00:00",
      end_date: "2024-12-12T08:00:00",
      duration: 720,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994813"
    },
    {
      id: "799927a3-4e60-4c91-b624-8e9b57176a79",
      text: "B2 - DH-D - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2026-04-08T00:00:00",
      end_date: "2026-04-14T08:00:00",
      duration: 40,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1630"
    },
    {
      id: "bc3997a9-2390-4cd0-868b-06e57a62a91f",
      text: "[DCB1] DEC-C Ready: OSP Primary Pathways [GS Core]",
      type: 0,
      start_date: "2025-06-04T08:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3300"
    },
    {
      id: "be78994f-33b0-46f0-9c36-8f392580b686",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2220"
    },
    {
      id: "8d13ff6b-0d1a-434c-93e9-e19b1d5421ec",
      text: "FR 02 - Additional Civil Permit Review Time - Design Team Address Second Comments & Re-Submit",
      type: 0,
      start_date: "2024-06-06T00:00:00",
      end_date: "2024-06-14T08:00:00",
      duration: 56,
      parent: "f5cede49-5629-40ad-881c-25df81197815",
      progress: 1,
      source_task_id: "FR.02.1030"
    },
    {
      id: "7fe894b4-f8b7-40a4-ab6f-abb8346ee14e",
      text: "B1 - 1A2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2200"
    },
    {
      id: "a17835af-b4e9-486c-af75-f0c698a39e95",
      text: "BLDG-1/2 - FAB - Steel Mill Order - Released",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: "2024-07-29T00:00:00",
      duration: 232,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0,
      source_task_id: "B1.CFCI.3010"
    },
    {
      id: "3aad9742-ba4d-49a0-9ba5-b1a12c8dcd8c",
      text: "FR 02 - DPR Prepare and Submit PCO #1 alond with TIA#1",
      type: 0,
      start_date: "2024-09-12T00:00:00",
      end_date: null,
      duration: 224,
      parent: null,
      progress: 1,
      source_task_id: "FR.02.1070"
    },
    {
      id: "f3ee259b-7c96-4d20-84d4-29c7c9fa866c",
      text: "FR 26 - META issue CSI #16",
      type: 0,
      start_date: "2024-09-21T00:00:00",
      end_date: null,
      duration: 0,
      parent: "24dee1b8-ef96-4c88-8860-44cdc0415f08",
      progress: 1,
      source_task_id: "FR.26.1000"
    },
    {
      id: "95ca3871-1f26-4053-9a42-b39ea8935a20",
      text: "B1 - mCUP-2 - Setting and Hookup of GS-IDF Hut (1X3)",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 80,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.C.EY.1030"
    },
    {
      id: "cb4f66b6-5fd3-4bb8-9062-f89db19b4771",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2300"
    },
    {
      id: "7202ea17-3b80-4fcd-8035-d8cd0c789b71",
      text: "B1 - DH-C - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 160,
      parent: "71b674fe-bce7-40b1-afb9-e2860457b441",
      progress: 0,
      source_task_id: "B1.C.C.3170"
    },
    {
      id: "cef65ab2-1eb1-4d88-93c8-e5579b8d4c75",
      text: "B1 - 1C1W - 01C.07 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.2350"
    },
    {
      id: "881cdbd2-ea67-413b-81e0-5200f2773df9",
      text: "B2 - mCUP-5 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-11-04T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 80,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.8200"
    },
    {
      id: "80e77f40-76c0-4a7a-ae17-09e0655312dd",
      text: "B2 - mCUP-6 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6060"
    },
    {
      id: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      text: "Campus - Prepare Building Pad for BLDG-1 (Cut/Fill/Lime/Compact/Stone/Wells)",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: "2024-12-09T08:00:00",
      duration: 40,
      parent: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      progress: 0,
      source_task_id: "C.CSW.1120"
    },
    {
      id: "b6c3de34-0c10-4283-9111-530216ad6292",
      text: "B2 - DH-C - Install Door/Hardware/ Wall Trim - Data Hall C",
      type: 0,
      start_date: "2026-07-29T00:00:00",
      end_date: "2026-08-25T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2660"
    },
    {
      id: "28d753d8-98b7-4126-a3d9-b7ff29d38403",
      text: "BLDG-1/2 - Prep / Submit for Review - Specialities",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 160,
      parent: "f9e927ae-bef4-4c2f-a9d1-169a3df666a0",
      progress: 0,
      source_task_id: "B1.CFCI.4810"
    },
    {
      id: "0b0da2a3-31d0-4e50-979a-074686b2fc60",
      text: "B2 - 2E2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6040"
    },
    {
      id: "972c4f41-09b7-4b18-89cd-89f2984b7637",
      text: "B2 - mCUP-5 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-05T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5080"
    },
    {
      id: "dcfca05d-8864-4acd-934e-c4730a3c620b",
      text: "B1 - Network - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for M-Cups (7-9)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 120,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1200"
    },
    {
      id: "60e4c849-ff18-41e8-924d-91a859d865d3",
      text: "Substation-1 - MSG B - Energization MSG",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 24,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3680"
    },
    {
      id: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      text: "Network Room 2/3",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 984,
      parent: "f530bbb9-f449-4766-8257-53c5c9bcda64",
      progress: 0,
      source_task_id: "7995332"
    },
    {
      id: "fd22fbef-ea49-4357-97bd-8c3c51ee3194",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 120,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2080"
    },
    {
      id: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e",
      text: "Site Logistics Create and Approval for BL 2",
      type: 0,
      start_date: "2024-03-08T00:00:00",
      end_date: "2024-03-08T00:00:00",
      duration: 0,
      parent: "5f97e78e-4198-45c7-9f9f-34e2a66e7e12",
      progress: 1,
      source_task_id: "PRE-DD-1050"
    },
    {
      id: "2f39c398-464f-4f08-a802-85da1f9e7afd",
      text: "B1 - RF-Tower-1 - UG Utilities",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 80,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2160"
    },
    {
      id: "9d8f341a-3a96-42a1-8638-64d8e87ff245",
      text: "B2 - DH-D - Install Underground Plumbing",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 120,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1450"
    },
    {
      id: "5a613ad5-0b86-4630-a161-3b57398dfb55",
      text: "B2 - 2C1W - 02C.08 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.1990"
    },
    {
      id: "e679dffd-23f0-4679-9bde-06d466c544eb",
      text: "Substation-1 - A Lineup - Install Dead-End Structure Excavate / Form / Pour",
      type: 0,
      start_date: "2024-12-10T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 168,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3850"
    },
    {
      id: "9d5de1c4-4afe-4486-a125-5b0704cc1b98",
      text: "Battery Monitoring & Diagnostic System - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-01-08T08:00:00",
      duration: 88,
      parent: "4bef5be0-b299-4faa-b366-fd0ba2a8ee98",
      progress: 1,
      source_task_id: "B1.OFCI.1490"
    },
    {
      id: "6a90ebf2-8f87-404e-8afe-0b81d587a812",
      text: "B2 - mCUP-2 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 48,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2020"
    },
    {
      id: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      text: "B2 - SSB - Precast",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 80,
      parent: "4dd7c528-9ce8-4b6b-9c59-af769c63915e",
      progress: 0,
      source_task_id: "B2.C.1440"
    },
    {
      id: "eeb33de8-acc0-4d9a-9b90-25d1bb685059",
      text: "B1 - SSB Set AHU/ Elec Skid (ROJ date for Elec skid, AHU/ PTX)",
      type: 0,
      start_date: "2025-06-05T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 80,
      parent: "7a3b9846-48b7-40e8-a145-00e7fba0e1ee",
      progress: 0,
      source_task_id: "B2.C.C.1010"
    },
    {
      id: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5",
      text: "B2 - DH-A - Raise HACs - Data Hall A",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-30T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2420"
    },
    {
      id: "ca5a6b8a-d930-41f3-82c7-3c75c509fe0b",
      text: "Adverse Weather Event 6 - 08.06.2024",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 8,
      parent: null,
      progress: 1,
      source_task_id: "WX.1006"
    },
    {
      id: "cc25be2e-f6bf-4e5a-ba18-f5d4b52eb915",
      text: "Site - Earthwork/Utilities SA - Meta Review",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-09T08:00:00",
      duration: 224,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1110"
    },
    {
      id: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      text: "BLDG-2 Entrance Facility 2",
      type: 5,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 296,
      parent: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      progress: 0,
      source_task_id: "7995055"
    },
    {
      id: "b5bd4fcc-7fcb-4def-8c59-61197e71cadb",
      text: "B2 - DH-A - Install Perimeter Cable Tray - Data Hall A",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2660"
    },
    {
      id: "8eac0aac-5165-40b0-a14b-3955a864beb4",
      text: "Install Ceramic Tile",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1430"
    },
    {
      id: "110ae5f5-17a4-4936-893a-12dd48117817",
      text: "B2 - Mill Course Base Paving",
      type: 0,
      start_date: "2026-07-17T00:00:00",
      end_date: "2026-07-30T08:00:00",
      duration: 80,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1130"
    },
    {
      id: "275b0c1d-dd26-4250-a4ae-6ee6cfb4b140",
      text: "Area 4 - UG RI -Network Infrastructure Vaults-Campus",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: "2024-10-31T08:00:00",
      duration: 200,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1630"
    },
    {
      id: "991689bf-d739-41ef-ad32-ef94be5a605c",
      text: "FR 17 - DPR prepare and Submit RFI #88",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "ff6b063e-140d-44b7-8199-0a0452134f17",
      progress: 1,
      source_task_id: "FR.17.1000"
    },
    {
      id: "7505477b-8430-4fb0-ba49-79fe375fdb8e",
      text: "Finalize Heat Calcs",
      type: 0,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-07-12T08:00:00",
      duration: 504,
      parent: "1727f221-62ff-460d-93ab-9c07242dc0b2",
      progress: 0.72,
      source_task_id: "PRE-DD-1020"
    },
    {
      id: "2f177ddd-db3f-4deb-bfaa-13eba28aca44",
      text: "B1 - DH-D - L2 CDU Pre-Eng Inspection - Data Hall D - DCI 3134",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 144,
      parent: "4e59b52c-1f38-413f-b50f-c638d57eaa94",
      progress: 0,
      source_task_id: "B1.C.D.3210"
    },
    {
      id: "05088bd3-8d75-42e2-9b8f-69d88fc77b4a",
      text: "Install Ansul Raceways/Connect to Hood",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1110"
    },
    {
      id: "ae7b7671-80cb-4765-9b9e-f2414a0102d4",
      text: "(CFCI) NCB - Long Lead Mech (AHU's)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994862"
    },
    {
      id: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      text: "B2 - 2E1E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 24,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.6000"
    },
    {
      id: "f1af65f9-3654-4afc-b2f7-5da348865ff4",
      text: "B2 - SSB - Install Glazing for Curtain Wall",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 120,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "B2.C.5020"
    },
    {
      id: "06f3c8e9-3016-46d0-945f-a50315a94b24",
      text: "BLDG-1 DH-B - Equipment Final Clean",
      type: 0,
      start_date: "2026-02-25T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1090"
    },
    {
      id: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      text: "Corpnet Connectivity",
      type: 5,
      start_date: "2025-09-29T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 1064,
      parent: "61d80750-bf18-446c-be45-d3d5a13e2e6f",
      progress: 0,
      source_task_id: "7995455"
    },
    {
      id: "c7da7e10-345f-4491-8a28-72d9ccefb82a",
      text: "B1 - 1N2W - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1650"
    },
    {
      id: "5534f605-e779-4607-8940-2bd768ce169f",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2130"
    },
    {
      id: "96a6f9b6-1324-4f8c-aaed-2927b3258c43",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [1] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 3024,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.39,
      source_task_id: "B2.OFCI.1820"
    },
    {
      id: "3853d88d-339f-4ae8-908a-4179da4bf774",
      text: "B2 - mCUP-4 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4070"
    },
    {
      id: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      text: "(OFCI) B1 Automatic Transfer Switch ATS",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.31,
      source_task_id: "7994975"
    },
    {
      id: "2dce8b57-10b4-4bd4-86f0-33c584798f34",
      text: "B2 - DH-C - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 16,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1620"
    },
    {
      id: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c",
      text: "B1 - DH-C - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 120,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1360"
    },
    {
      id: "f819cfb3-4a72-4cb5-97d6-d23eb9b3b289",
      text: "B1 - DH-D - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 80,
      parent: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      progress: 0,
      source_task_id: "B1.C.D.3150"
    },
    {
      id: "3970afe7-ead9-431c-b05c-aaea2e42c6a1",
      text: "Area B - Security Device Install",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1381"
    },
    {
      id: "bfed2800-deca-4e25-90e9-11fe61e97f4d",
      text: "B1 - 1N2E - 01N3.05 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6530"
    },
    {
      id: "4bef5be0-b299-4faa-b366-fd0ba2a8ee98",
      text: "(OFCI) B1 BMDS Battery Monitoring & Diagnostic System",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 3528,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.27,
      source_task_id: "7994983"
    },
    {
      id: "c99b52b5-cb9e-4df2-b38d-079c1e174658",
      text: "Utility Provider Substation",
      type: 5,
      start_date: "2024-03-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 3416,
      parent: "70bdaf4f-8ceb-47b4-9049-d77f20ba3361",
      progress: 0,
      source_task_id: "7995229"
    },
    {
      id: "8638001b-82c2-4817-8236-55342481c5a7",
      text: "B2 - mCUP-8 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8140"
    },
    {
      id: "70bdaf4f-8ceb-47b4-9049-d77f20ba3361",
      text: "Utility Provider Substation & Power",
      type: 5,
      start_date: "2024-03-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 3416,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995228"
    },
    {
      id: "67e015d2-aab6-41d1-8e03-ad8605412648",
      text: "B2 - DH-C - SOG",
      type: 0,
      start_date: "2025-11-13T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 264,
      parent: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      progress: 0,
      source_task_id: "B2.C.STR.2140"
    },
    {
      id: "e0299bc3-ac94-4026-a3e5-0572b8cd2e65",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2400"
    },
    {
      id: "a12439fe-69d1-4b09-9604-c1833b23dacb",
      text: "BLDG-1/2 - Fabricate / Deliver - Fire Suppression",
      type: 0,
      start_date: "2024-12-16T00:00:00",
      end_date: "2025-05-08T08:00:00",
      duration: 160,
      parent: "259cd2ff-2f2c-4882-8de7-0863b0131218",
      progress: 0,
      source_task_id: "B1.CFCI.4190"
    },
    {
      id: "3ec8b8b3-4277-47ed-803a-60817f06b87b",
      text: "B2 - 2E1E - 02.01.E1.05 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5540"
    },
    {
      id: "8a272e27-336f-4bd6-b8c6-f35d29fcc3e7",
      text: "FR 18 - DPR Prepare and Submit PCO#14 (Zero $ Change)",
      type: 0,
      start_date: "2024-09-27T00:00:00",
      end_date: null,
      duration: 208,
      parent: "ae1767c4-d36b-4241-8891-8fc1b5eca613",
      progress: 0.5,
      source_task_id: "FR.18.1020"
    },
    {
      id: "5202900d-c960-45e8-b3df-ff1d78cab980",
      text: "FR 05 - Civil, Aldrige, DPR team discuss and resolve the path forward",
      type: 0,
      start_date: "2024-10-21T00:00:00",
      end_date: null,
      duration: 72,
      parent: null,
      progress: 1,
      source_task_id: "FR.05.1030"
    },
    {
      id: "52ffef0b-d4e6-4196-8083-acfffc8e4b75",
      text: "B1 - 1A2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2670"
    },
    {
      id: "e90cdcbe-e185-46c0-b35d-3e4b46b93bb8",
      text: "Corridor 2A2 (GS IDF/Spoke Parts Area)",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 976,
      parent: "8790b54e-02a0-492f-af1f-d61d0338ca55",
      progress: 0,
      source_task_id: "7995088"
    },
    {
      id: "6b556992-b16c-4624-933a-047555c3af4f",
      text: "B2 - DH-B - Install Structural Steel",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 120,
      parent: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      progress: 0,
      source_task_id: "B2.C.STR.1660"
    },
    {
      id: "eb6016d6-f269-465c-89d8-b0e62c2452fe",
      text: "Substation 1 -  Review for Approval - H-Frame Deadend",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-11T08:00:00",
      duration: 72,
      parent: "31ddf586-695a-43cd-8824-5097b5c4df9f",
      progress: 0,
      source_task_id: "B1.CFCI.5720"
    },
    {
      id: "4b681102-efac-4828-8781-db44d2d71816",
      text: "B1 - SSB - 1E1 - CMDF1 -  Install Split System/Refrigerant Piping/Test/Insulate (Carrier MDF1)",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 96,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1730"
    },
    {
      id: "5595ffef-e80b-48c5-a708-7cfa3f4a69f4",
      text: "Rough Carpentry - FSC Wood",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 360,
      parent: "e46a1b76-18a8-4bad-aa28-b45be9e9f2c2",
      progress: 0,
      source_task_id: "7994893"
    },
    {
      id: "0c9e523b-158a-4369-9521-45d4209777a3",
      text: "Delivery of MTR - Multi Trade Rack (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-05-30T08:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1855"
    },
    {
      id: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-04-23T00:00:00",
      end_date: "2026-05-20T08:00:00",
      duration: 160,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1810"
    },
    {
      id: "77ce9181-4a70-45b7-8927-e620b83303e1",
      text: "CSI BMS Contractor Alignment - Meta Decision to Engage Market",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-03-11T08:00:00",
      duration: 160,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "PRE-PP-1080"
    },
    {
      id: "485cd59e-91fe-4ef9-81de-43347ec44cda",
      text: "B1 - Network Room 1/4 - FCA Gallery - Final Paint",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 16,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.2210"
    },
    {
      id: "fb688aa4-c0b6-4a08-a692-19a070e75ead",
      text: "B2 - 2E2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6070"
    },
    {
      id: "7265e2c8-8ef3-4c20-9bbf-20d252a68851",
      text: "B2 - 2C1 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-04-14T08:00:00",
      duration: 160,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1700"
    },
    {
      id: "8cd3fc62-29df-45e6-9efe-39efd384699e",
      text: "Electrical Contractor Alignment - Meta Decision to Engage Market",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 0,
      parent: "7d83864a-008e-469b-a278-10e305a4cc4f",
      progress: 1,
      source_task_id: "PRE1170"
    },
    {
      id: "f7e1bd07-940b-477b-9339-ab138c1eb4b1",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "06bd3404-1a5f-4d2c-b5cb-bad1e0f64a0d",
      progress: 0,
      source_task_id: "MECO-1700.40"
    },
    {
      id: "aaa537e7-583e-4d33-ad14-d873dded0a6d",
      text: "(CFCI) Div. 26 - Fire Alarm",
      type: 5,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 600,
      parent: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      progress: 0,
      source_task_id: "7994865"
    },
    {
      id: "7db0ee12-4437-4c14-8fd2-f69485405b43",
      text: "B2 - DH-B - Pull Feeders Bussways - Data Hall B",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2740"
    },
    {
      id: "11fec865-82fd-4d55-9837-1d0b01e9ed09",
      text: "B2 - SSB (Converted to LOE)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 1200,
      parent: "bf6187b5-e96d-44aa-afd3-3c0e407eb0e8",
      progress: 0,
      source_task_id: "B2.C.1720"
    },
    {
      id: "79643575-6f44-470c-adda-4678da8d9606",
      text: "QA/QC - Procure Services, Establish Delivery Dates, Establish RACI & Scope of Work",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 720,
      parent: "ed959986-b462-46b9-a631-e3987866c0c0",
      progress: 1,
      source_task_id: "PRE-PP-1260"
    },
    {
      id: "2d4d1a7f-96fe-4a31-85ca-634b28f3acfb",
      text: "Substantial Completion (DH D) - DCB1",
      type: 0,
      start_date: "2026-10-07T08:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.B1.1110"
    },
    {
      id: "bf911267-61f9-4a45-932f-27b42afeee34",
      text: "B2 - 2E1E - 02.01.E1.01 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5280"
    },
    {
      id: "eaacb991-d9c9-4574-a070-2714b8e61d93",
      text: "B1 - Network - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "6212fd9c-9c53-442b-87fa-e28ef70f8990",
      progress: 0,
      source_task_id: "B1.C.EY.1150"
    },
    {
      id: "5848f7a4-c9ff-42b8-88d5-cd6198ffb112",
      text: "B2 - 2B1 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 160,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2190"
    },
    {
      id: "e0e4c9da-e0b6-41ec-b9e5-c1178d84cf78",
      text: "B1 - Network - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 160,
      parent: "b7e4d2b4-a0c6-498e-ab29-bf6403612b7e",
      progress: 0,
      source_task_id: "B1.C.STR.1610"
    },
    {
      id: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      text: "B2 - 2C1 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 24,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1120"
    },
    {
      id: "e8cd07ec-6d8b-4f97-b855-17feef46ba8f",
      text: "Substation-2 - MSG A - MSG A Install Control Cabling",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 88,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4720"
    },
    {
      id: "096c3891-e186-43e6-b2b3-86d1183a6f63",
      text: "DFSMA - DC2 - CUP 2- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-10-06T08:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1260"
    },
    {
      id: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048",
      text: "Identify MOFE Elements to Site Specific Design",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2024-01-16T08:00:00",
      duration: 232,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1290"
    },
    {
      id: "b75524e3-9b9a-4c73-bbd0-d2f3c8df13db",
      text: "B2 - 2C1W - 02C.08 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.1690"
    },
    {
      id: "a0833bca-df6a-49f0-b1e5-7db407efd172",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 16,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2090"
    },
    {
      id: "310e6906-c51e-4130-b236-f0a9265afeae",
      text: "B2 - DH-D - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 40,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1300"
    },
    {
      id: "46fb9d54-811f-4de6-b326-8dc8f76fd371",
      text: "Cooling Towers - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 1,
      source_task_id: "B2.OFCI.1240"
    },
    {
      id: "dce54a98-e783-4194-9265-cf169f3f7a3a",
      text: "ADMIN  - Submittal Rvw/App'l - Signage",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6160"
    },
    {
      id: "e37eb8d7-d4fc-4411-b080-1c574da378ce",
      text: "DFSMA - DC2 - CUP 5- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-10-27T08:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1290"
    },
    {
      id: "d36cff8d-f735-453c-8c93-201c22bc9784",
      text: "Substation-1 A Lineup Ground work",
      type: 5,
      start_date: "2024-11-21T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 872,
      parent: "1e42c2bf-63b3-489b-8f7b-a28640a79e8d",
      progress: 0,
      source_task_id: "7995240"
    },
    {
      id: "162dd7ea-4592-492c-a0e3-91e8bc0df67f",
      text: "B1 - Network Room 2/3 - FCA Gallery - IMP ceiling and Perf wall Install",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 120,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1710"
    },
    {
      id: "ce0557bc-a3c0-4b61-8182-6c8634289b86",
      text: "B2 - DH-B - Room QA/QC Pre DEC-C Turnover - Data Hall B",
      type: 0,
      start_date: "2026-07-24T00:00:00",
      end_date: "2026-08-20T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2910"
    },
    {
      id: "d0922209-7513-4b64-b7d0-b99ee12ec293",
      text: "B2 - 2D2 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-08-10T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 120,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2550"
    },
    {
      id: "b0fab1bf-bd43-4295-b95d-f890aef0ab33",
      text: "B1 - DH-B - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1280"
    },
    {
      id: "465afcde-3dcc-4b35-bae7-843bfd3b95f3",
      text: "B1 - DH-C - L2 CDU Pre-Eng Inspection - Data Hall C",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-14T08:00:00",
      duration: 144,
      parent: "0346efe3-b63f-4628-9749-3c3592992deb",
      progress: 0,
      source_task_id: "B1.C.C.3095"
    },
    {
      id: "c3a6e053-f967-4154-b4e5-d774402e8960",
      text: "UPS Room 02.01.E1.01",
      type: 5,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 480,
      parent: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      progress: 0,
      source_task_id: "7995048"
    },
    {
      id: "9c038cdb-4660-4baa-b7e6-d16babdbfd92",
      text: "Area B - In Wall Rough Fire Alarm",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1062"
    },
    {
      id: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      text: "(OFCI) B1 Static Transfer Cabinets STC",
      type: 5,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3408,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.33,
      source_task_id: "7994974"
    },
    {
      id: "8c3f7f50-fa5d-4354-8890-58b977f64113",
      text: "B1 - Network Room 2/3 - E-cure/Seal Floors/QA/QC/Wall Base/Final Paint",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.2270"
    },
    {
      id: "84b140a9-05cb-4b5d-9cb9-975a0a778979",
      text: "Civil IFP Design Completion",
      type: 0,
      start_date: "2024-03-15T08:00:00",
      end_date: "2024-03-15T08:00:00",
      duration: 0,
      parent: "1bf0e276-e316-4b6c-91cb-5ec9f945f300",
      progress: 1,
      source_task_id: "Design.PreC.2260"
    },
    {
      id: "386b551f-4b83-41b0-9d6a-30378a005646",
      text: "Stormwater Management Design Package - DHEC",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-11-18T08:00:00",
      duration: 160,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "Design.PreC.5720"
    },
    {
      id: "580b75ff-8420-4c95-99bd-7c9dba8183ca",
      text: "B1 - 1N1W - 01N1.07 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.5940"
    },
    {
      id: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0",
      text: "B1 - Network Room 1/4 - FCA Gallery - FCA Setting/ Hookup",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 192,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1470"
    },
    {
      id: "5d181cbf-c802-4ba2-95c7-642599af24b6",
      text: "B1 - DH-D - WAP Provisioning",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 160,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1430"
    },
    {
      id: "c5c554d9-ed3b-4a4b-b372-b2111f8cab35",
      text: "FR 36 - DPR prepare and Submit RFI #194, 252",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "9ce92136-13d4-4f59-af50-af5acfb13f34",
      progress: 1,
      source_task_id: "FR.36.1000"
    },
    {
      id: "26e8617e-7c73-4a22-8dce-c8a81f5672da",
      text: "B1 - DH-A - BLDG-1 DH-A - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-09-08T08:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 0,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1940"
    },
    {
      id: "22d218cf-dd8d-46ce-99bd-4367f1e20f91",
      text: "BLDG-1/2 - Submittals - FSC -Rough Carpentry (In Wall Backing / Blocking)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 160,
      parent: "5595ffef-e80b-48c5-a708-7cfa3f4a69f4",
      progress: 0,
      source_task_id: "B1.CFCI.3680"
    },
    {
      id: "6dece376-433a-4568-b6c1-03a7e5fc4605",
      text: "BLDG-1/2 - Fabricate / Deliver - Carpet Tile",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 320,
      parent: "a186b242-b288-4250-b87d-d866ac28f219",
      progress: 0,
      source_task_id: "B1.CFCI.5290"
    },
    {
      id: "7ad97858-dc54-4cbb-99e6-44c414ed78c3",
      text: "(CFCI) Div. 13 - Special Const.",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994861"
    },
    {
      id: "0baaf4d0-808b-43e7-8c3c-4c3885424656",
      text: "IST Finish DH C - DCB2",
      type: 0,
      start_date: "2027-03-04T08:00:00",
      end_date: "2027-03-04T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2175"
    },
    {
      id: "70b95beb-de03-4f99-b648-a03ebeddc017",
      text: "B2 - DH-A - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall A",
      type: 0,
      start_date: "2026-06-16T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2690"
    },
    {
      id: "b36d3e4e-d14d-4d7c-bd06-37af8e07a714",
      text: "B1 - Network Room 2/3 - HAC Assembly Setting - [03.HAC-30-03,04]",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1460"
    },
    {
      id: "d1665901-e7bf-4d10-8801-2e410b367359",
      text: "FR 02 - DPR Prepare and Submit Draft TIA#1",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: null,
      duration: 168,
      parent: null,
      progress: 1,
      source_task_id: "FR.02.1050"
    },
    {
      id: "d77ae7a6-348a-4b29-b1eb-5fc2b4bfee99",
      text: "Fab and Deliver - RSB - Area B - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 3224,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.43,
      source_task_id: "B2.OFCI.2340"
    },
    {
      id: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      text: "BLDG-1 Entrance Facility 3",
      type: 5,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 296,
      parent: "19d232aa-0dc1-49f0-93d6-1893cfabaf59",
      progress: 0,
      source_task_id: "7995325"
    },
    {
      id: "5dea1993-57a9-444f-8a18-074e225e4f66",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 160,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1970"
    },
    {
      id: "6d26cd39-c180-4ab0-af56-f39a58493ef9",
      text: "B1 - mCUP-3 - Set in Place Inspections",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 8,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3030"
    },
    {
      id: "c7699246-bbba-4ca3-8a23-77c106b18bfa",
      text: "[DCB1] FacNet Live [Area A]",
      type: 0,
      start_date: "2026-02-13T08:00:00",
      end_date: "2026-02-13T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3627"
    },
    {
      id: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      text: "B2 - DH-D - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 120,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "B2.C.EY.1170"
    },
    {
      id: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f",
      text: "B2 - mCUP-8 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 48,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8020"
    },
    {
      id: "a6c67193-33ce-4eb7-89a3-b5ce9e6e688a",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 80,
      parent: "82459529-b222-4604-bce3-f899e6205dbc",
      progress: 0,
      source_task_id: "MECO-1140.30"
    },
    {
      id: "bd1ef6c2-eb94-4237-be7e-008089d82669",
      text: "B2 - DH-D - Install Celing Devices BMS - Data Hall D",
      type: 0,
      start_date: "2026-08-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2600"
    },
    {
      id: "f1f821c9-5081-4d88-a35a-0e806c78a819",
      text: "Substation-1 - MSG B - Control Power And EPMS Dead Bus Checkout",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 80,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3660"
    },
    {
      id: "31d5c2f3-2b41-4def-9286-727a73af9d42",
      text: "B1 - SSB - 1E2 - Common - Install Fire Extinguishers/FECs",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 32,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2290"
    },
    {
      id: "6b170940-c128-4242-b84e-22ccd116608b",
      text: "BLDG-1/2 - (SPW-Div 10) Fabricate / Deliver - Finished Carpentry (FRP)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 240,
      parent: "fadc8646-4b3d-42bf-ba2e-1d5f36c3c8bc",
      progress: 0,
      source_task_id: "B1.CFCI.5180"
    },
    {
      id: "9b87906a-098d-47d8-b85c-3c3e56e14433",
      text: "B1 - Network - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-03-01T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 80,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1220"
    },
    {
      id: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016",
      text: "B1 - DH-C - Corpnet Provisioning",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 120,
      parent: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      progress: 0,
      source_task_id: "B1.CONN.1360"
    },
    {
      id: "b33a3880-3a89-4b11-a0c8-595baef8251d",
      text: "B2 - 2D2 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1510"
    },
    {
      id: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      text: "B1 - mCUP-1 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 80,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.9250"
    },
    {
      id: "be9cecea-8dfc-446f-b163-72434a897bd2",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2026-01-12T08:00:00",
      duration: 1152,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995298"
    },
    {
      id: "24eb50c0-55a3-4768-8779-dea9f8632bf3",
      text: "Set Carrier",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1000"
    },
    {
      id: "7c92018d-4ef4-44d4-b45d-f78f6e1f432b",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Mechanical",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1020"
    },
    {
      id: "372a560b-f6ec-4c81-9898-20f81d137742",
      text: "Form / Rebar & Pour SOG",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 64,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1040"
    },
    {
      id: "2bec7536-f935-437c-b342-175720fbc961",
      text: "B1 - Network - Install lightning protection",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1490"
    },
    {
      id: "78379811-55be-4062-a0ae-3a83ee9504dd",
      text: "B2 - 2E1E - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5080"
    },
    {
      id: "979d5de6-426b-4112-8ce3-93b6b5a4939b",
      text: "Fab and Deliver - MSB - Area B - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 3056,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.41,
      source_task_id: "B1.OFCI.3720"
    },
    {
      id: "f530bbb9-f449-4766-8257-53c5c9bcda64",
      text: "NW2/3",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-25T08:00:00",
      duration: 984,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995329"
    },
    {
      id: "7e41d9e5-cd3e-4fd5-bc94-72ab245bf83e",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [3] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-19T08:00:00",
      duration: 2872,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.38,
      source_task_id: "B2.OFCI.2740"
    },
    {
      id: "bcc46726-ab89-4826-95bc-2795611434f2",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 24,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1730"
    },
    {
      id: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1",
      text: "B2 - mCUP-6 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 48,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6020"
    },
    {
      id: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      text: "Electrical SA - Meta Authorized",
      type: 0,
      start_date: "2024-04-24T08:00:00",
      end_date: "2024-04-24T08:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1210"
    },
    {
      id: "1a888afe-aa20-4b68-8759-09312e214b3a",
      text: "B2 - DH-A - Rough in HAC Lighting - Data Hall A",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2370"
    },
    {
      id: "1d3c9c1c-46dc-4436-aa1b-74aea5b37c3a",
      text: "FR 34 - DPR prepare and Submit RFI #212",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: null,
      duration: 0,
      parent: "883427a6-7812-434c-b7bc-0738a53a7b23",
      progress: 1,
      source_task_id: "FR.34.1000"
    },
    {
      id: "17105612-fb32-4856-a8a8-2cb9f6426325",
      text: "Tier 0 - B1-1-A - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994804"
    },
    {
      id: "54ea1ba9-ddf2-452c-881b-cedd12f21266",
      text: "(CFCI) Guardhouse - Prefabricated Building",
      type: 5,
      start_date: "2024-11-04T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 960,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994887"
    },
    {
      id: "d4b326a1-cd90-402d-8d70-45aeeaacd14a",
      text: "UPS - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "99edabb5-755f-41be-8083-81ca738bf3e5",
      progress: 1,
      source_task_id: "B2.OFCI.1160"
    },
    {
      id: "3e6924ef-4acc-45a0-8bb1-fd95a13e6e9e",
      text: "B2 - DH-D - Install Celing Devices Fire Alarm - Data Hall D",
      type: 0,
      start_date: "2026-08-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2610"
    },
    {
      id: "b6e12dfe-824f-4df1-b66d-45b53a11ede2",
      text: "Fragnet 01 - Sanitary Sewer Redesign",
      type: 0,
      start_date: "2024-04-26T00:00:00",
      end_date: null,
      duration: 168,
      parent: "cd435564-4024-4c0e-924c-74c687f38b15",
      progress: 1,
      source_task_id: "8519862"
    },
    {
      id: "c4c1ab2a-40d8-4938-bdbb-8ba4bc0ee069",
      text: "OH Electrical Rough-In",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1220"
    },
    {
      id: "a363e32d-4f06-4226-8a08-a68fd1d346b0",
      text: "Security Terminations at Door Frames",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-07T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1530"
    },
    {
      id: "32f232aa-e01a-43cf-a211-68622fb84146",
      text: "B2 - Specialties - Benchs",
      type: 0,
      start_date: "2026-07-29T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1060"
    },
    {
      id: "f3b17f9e-53fd-4d16-8368-5ad9f2d0972b",
      text: "B1 - DH-D - Install Underground Plumbing",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 120,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1530"
    },
    {
      id: "0d4e1ec3-301d-438a-830a-df078e8ea34c",
      text: "B1 - DH-A - Install Underground Telecom",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 80,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1430"
    },
    {
      id: "7b5ca09d-c5ae-42c2-ae95-b99448c62504",
      text: "Non-Critical Power (NCP)",
      type: 5,
      start_date: "2024-12-05T00:00:00",
      end_date: "2024-12-19T08:00:00",
      duration: 104,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995169"
    },
    {
      id: "fe99c54f-c538-4ad6-92f9-d75f5a4477c2",
      text: "Campus Logistics",
      type: 5,
      start_date: "2025-04-16T08:00:00",
      end_date: "2026-11-05T08:00:00",
      duration: 3440,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0,
      source_task_id: "7995199"
    },
    {
      id: "1b114571-da28-4aad-b71a-2e28dc2837d5",
      text: "BLDG-1/2 - Fabricate / Deliver - Porcelain Tiling",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 320,
      parent: "1199aed8-9a5c-4ba9-b5a4-fd27806e7d1d",
      progress: 0,
      source_task_id: "B1.CFCI.5150"
    },
    {
      id: "d98f84ae-d8b7-413e-aa7b-a199bf4cf796",
      text: "Campus PH1 - Prep / Submit for Review - T-Comm Vaults (Site)",
      type: 0,
      start_date: "2024-06-24T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 40,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0,
      source_task_id: "B1.CFCI.5950"
    },
    {
      id: "9734eb9a-fd01-4b43-b058-ea660800e142",
      text: "B2 - West Entrance - Rough Grade behind Curb",
      type: 0,
      start_date: "2026-04-27T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 80,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1080"
    },
    {
      id: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1010"
    },
    {
      id: "2d44d520-a537-4ad7-8497-b8a3633f9a96",
      text: "B2 - DH-B - Set CDU's - Data Hall B (16 total; 4 per day)",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-11T08:00:00",
      duration: 64,
      parent: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      progress: 0,
      source_task_id: "B2.C.B.3220"
    },
    {
      id: "da9806b4-2d71-4501-8c5c-b4e6b9537279",
      text: "FR 01 - Sanitary Sewer Redesign - City Review Comments and Issue Sanitary Civil Permit Approval",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "FR.01.1150"
    },
    {
      id: "3dbc66ea-37e3-4b3b-826c-4d0b6f613181",
      text: "Utility Provider Substation - Final Grading",
      type: 0,
      start_date: "2024-12-12T00:00:00",
      end_date: "2024-12-26T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "CX0.USS.L2.0070"
    },
    {
      id: "d7e326ee-8e9b-4892-b354-aabf20099af6",
      text: "B2 - 2C1W - 02C.07 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1820"
    },
    {
      id: "805d895d-6c03-4368-a180-bc3c2af923df",
      text: "ADMIN/ IBOS - Prep / Submit for Review - Fire Suppression",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 360,
      parent: null,
      progress: 0.75,
      source_task_id: "B1.CFCI.6520"
    },
    {
      id: "97a0cbdc-8ad9-4673-9660-96ac28a83626",
      text: "B2 - DH-B - Set CDU's - Data Hall B (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 64,
      parent: "d2bd53c0-cfe3-4110-8e81-f5665f925980",
      progress: 0,
      source_task_id: "B2.C.B.3260"
    },
    {
      id: "77382489-0386-4657-9939-e0d917fd8b8a",
      text: "Fab and Deliver - Control Power STC/SB - Area D - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3408,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.33,
      source_task_id: "B1.OFCI.3280"
    },
    {
      id: "23a36a6d-79d5-474e-9a9f-3f95a1a79939",
      text: "Substation-2 - A Lineup - Dead End Structure Steel Erection And Branch Wiring",
      type: 0,
      start_date: "2025-09-20T00:00:00",
      end_date: "2025-10-04T08:00:00",
      duration: 104,
      parent: "7396df52-8be2-42b0-85c0-849a0964ef15",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4660"
    },
    {
      id: "b112c781-3156-4964-9719-87821cfaf32c",
      text: "Roof - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-07-13T00:00:00",
      end_date: "2024-07-29T00:00:00",
      duration: 80,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1360"
    },
    {
      id: "6dcec0e1-aa7d-498b-8072-1b3648d75c64",
      text: "Drywall / Ceilings",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 520,
      parent: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      progress: 0.83,
      source_task_id: "PRE1500"
    },
    {
      id: "0152f816-00ed-4e1f-b34b-83afe9b985f9",
      text: "B2 - DH-A - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 160,
      parent: "ff40e3a6-bbbc-4a6d-a305-083ef7670a8d",
      progress: 0,
      source_task_id: "B2.C.EY.1570"
    },
    {
      id: "81ef8cbb-9c53-4d9b-a99d-84219f2cf80e",
      text: "B2 - DH-D - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2026-07-23T08:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 0,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2560"
    },
    {
      id: "233c3273-0eeb-4b30-93dd-9cbc3030522d",
      text: "Development of PRS",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-01-05T08:00:00",
      duration: 408,
      parent: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      progress: 1,
      source_task_id: "PRED1030"
    },
    {
      id: "996a4ddf-b5a2-40c4-81fa-ab07714e3030",
      text: "B2 - 2D1W - 02D.09 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-07-09T00:00:00",
      end_date: "2026-07-15T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.2390"
    },
    {
      id: "599bc1f3-73df-470a-af9b-2ccd6bd099fc",
      text: "B1 - mCUP-1 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1240"
    },
    {
      id: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 24,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1210"
    },
    {
      id: "b63c12e5-6455-40a0-bbbe-d4fa8ed7f996",
      text: "B2 - DH-C - Install IMP Ceiling - Data Hall C",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1670"
    },
    {
      id: "3b024ade-c602-4559-80a6-5a52c11fba37",
      text: "Campus - Submittal Rvw/App'l -  Storm Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 40,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5900"
    },
    {
      id: "cd435564-4024-4c0e-924c-74c687f38b15",
      text: "Closed",
      type: 0,
      start_date: "2024-04-26T00:00:00",
      end_date: null,
      duration: 784,
      parent: null,
      progress: 1,
      source_task_id: "8519828"
    },
    {
      id: "df49c55f-4894-4058-bc3a-6284334abbce",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [6] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 3216,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.37,
      source_task_id: "B2.OFCI.2910"
    },
    {
      id: "5b8e6dfe-1fa4-460e-b6d8-920b332477ed",
      text: "FR 01 - Sanitary Sewer Redesign - Constructability Review + Redesign - Area 1, 2 & 3",
      type: 0,
      start_date: "2024-05-09T00:00:00",
      end_date: "2024-05-15T08:00:00",
      duration: 40,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1090"
    },
    {
      id: "0d5f5bc7-bee5-4b93-b5ff-00f8e1fd515f",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Electrical",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1660"
    },
    {
      id: "6a37e962-604b-4ed4-b199-a5772544e137",
      text: "Area B - Tile",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1350"
    },
    {
      id: "028754d6-3f7b-47e1-9695-9692b0fa6940",
      text: "Tier 1 - B2-2-C - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994777"
    },
    {
      id: "79309bae-62de-40f7-9acc-ee584074d979",
      text: "Area 5 - UG RI -Network Infrastructure Vaults-Campus-",
      type: 0,
      start_date: "2025-01-13T00:00:00",
      end_date: "2025-02-26T08:00:00",
      duration: 296,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1850"
    },
    {
      id: "8664c72e-35ac-4eb1-8948-e96b5ab4a80b",
      text: "L3 Finish DH A - DCB2",
      type: 0,
      start_date: "2026-11-17T08:00:00",
      end_date: "2026-11-17T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2002"
    },
    {
      id: "2b64ef56-ac34-4a46-8d6c-c262e0698cdc",
      text: "B2 - 2E2E - 02.01.E1.02 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6300"
    },
    {
      id: "24944f47-e305-4007-86d1-b6d165f8d2d0",
      text: "BLDG-1/2 - Fabricate / Deliver - Exterior Louvers",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-05-22T08:00:00",
      duration: 480,
      parent: "7c2bce29-42fa-46b1-ad31-bfb1a0d53148",
      progress: 0,
      source_task_id: "B1.CFCI.4120"
    },
    {
      id: "acb78903-07c0-4dda-ad65-37ccc29818e7",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2240"
    },
    {
      id: "e5b8fd80-16cd-40b2-a357-daaa22ae6b7e",
      text: "B1 - 1N1W - 01N1.07 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6280"
    },
    {
      id: "4403f6dd-1701-4c20-8acf-13f5a649f033",
      text: "B2 - DH-A - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1050"
    },
    {
      id: "18cedcb7-b697-423f-9ec6-c1c364cb8d5c",
      text: "B1 - 1N1E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1980"
    },
    {
      id: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3",
      text: "L4 Start mCUP  - DCB1",
      type: 0,
      start_date: "2026-02-18T00:00:00",
      end_date: "2026-02-18T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2132"
    },
    {
      id: "292add02-6549-410d-a4fc-736e4a87e40b",
      text: "B1 - 1N1E - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 160,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.2360"
    },
    {
      id: "415ffe3d-5b86-4bfa-b4d2-a6bc07cd3efa",
      text: "Sanitary Sewer",
      type: 5,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-01-15T08:00:00",
      duration: 264,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995174"
    },
    {
      id: "1546480d-27e7-4770-b1a8-3f314926d94e",
      text: "B2 - 2B2 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 120,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2050"
    },
    {
      id: "450dc1a3-5efe-4cb7-a597-6adc60877d25",
      text: "B1 - Network Room 1/4  - Raise HAC's/ Connect Busway/Cable Tray",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1700"
    },
    {
      id: "60f148c4-542d-4240-b597-482ec3840025",
      text: "B1 - SSB - 1E2 - GSMDF2 - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 48,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1600"
    },
    {
      id: "209e315a-9bed-43eb-8125-f463ac7a17bd",
      text: "B1 - mCUP-8 -Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 16,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8010"
    },
    {
      id: "a2dbfb4b-863f-4819-96d1-61a37c3fc03b",
      text: "Frame Ceiling",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 8,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1030"
    },
    {
      id: "a9674e15-12bf-4446-90ed-08d24d420f70",
      text: "B2 - 2B1 - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 160,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1960"
    },
    {
      id: "c147d70b-133b-48d0-ac94-9a2dea317ff0",
      text: "B2 - 2A1 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 120,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1960"
    },
    {
      id: "841df35d-6f24-4908-8c1e-3bcc4a3c2516",
      text: "Substation-1 - TX A - Assemble Transformer",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 160,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6260"
    },
    {
      id: "153adec9-99a1-4d84-b4d4-7d9869263d78",
      text: "B1 - SSB - 1E1 - EF1 - Fire Alarm Wire Pulls/Terms to devices (EF1)",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 48,
      parent: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      progress: 0,
      source_task_id: "B1.C.SSB.1760"
    },
    {
      id: "df34f571-ba8d-42f2-b6d9-ab2aee8d22f2",
      text: "BLDG-1/2 -  Fabricate / Deliver - Structural Steel",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 648,
      parent: "b5ab113b-f512-4fc0-8bd5-aac4590010ea",
      progress: 0,
      source_task_id: "B1.CFCI.3560"
    },
    {
      id: "ee7e7edf-af1b-4b93-83a7-d006dcd1c47a",
      text: "BLDG-2 DH-A ElectricalTerms",
      type: 5,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 464,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "7995130"
    },
    {
      id: "f516d625-fc35-4562-b467-ea8f751e08e8",
      text: "(CFCI) Div. 03 - (Foundation) Struc. Concrete",
      type: 5,
      start_date: "2024-08-06T00:00:00",
      end_date: "2024-10-08T08:00:00",
      duration: 360,
      parent: "d390b116-84b5-4ac4-9005-9d68157fdd1b",
      progress: 0,
      source_task_id: "7994851"
    },
    {
      id: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      text: "Cooling Towers - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2023-12-22T00:00:00",
      duration: 0,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 1,
      source_task_id: "B1.OFCI.1820"
    },
    {
      id: "14dd7026-97aa-4a4a-8661-bd96e3898dda",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 40,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2040"
    },
    {
      id: "b4e884ef-dc2a-4069-87e5-ae276981d9ed",
      text: "Security Device Install",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1460"
    },
    {
      id: "834a2c87-fdd3-4526-ae51-271999f71498",
      text: "B2 - DH-A - Hookup FCAs Electrical- Data Hall A",
      type: 0,
      start_date: "2026-03-25T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 192,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2330"
    },
    {
      id: "51a9bef8-4a73-40f6-ab68-af531420db2c",
      text: "Area 4 - UG RI -Deep Communications & Security-Campus",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1610"
    },
    {
      id: "10f5dfec-bbce-491b-a5ae-ef46a8aabbd2",
      text: "B2 - DH-B - Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 80,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1070"
    },
    {
      id: "bbfb506e-b03c-443e-8ffe-68413a54cb78",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (B)",
      type: 0,
      start_date: "2025-09-08T08:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1410"
    },
    {
      id: "10e73e0b-3323-4daf-81c1-f5ae99a301d8",
      text: "Fab and Deliver - Control Power UPS - Area C - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2488,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.44,
      source_task_id: "B1.OFCI.3210"
    },
    {
      id: "335e140f-6b2d-404a-aaf5-dfffc86af201",
      text: "Doors / Frames / Hardware",
      type: 0,
      start_date: "2024-04-04T00:00:00",
      end_date: "2024-06-20T00:00:00",
      duration: 160,
      parent: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      progress: 0,
      source_task_id: "PRE1780"
    },
    {
      id: "f75fdba4-3527-4f6a-b273-f020b5f776ca",
      text: "B2 - SSB - 2E2 - Common - Install Door Frames",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1580"
    },
    {
      id: "32168247-a37b-4401-b5f9-f0c29e51031a",
      text: "Skin - IBOS (LOE)",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 240,
      parent: "597c58ac-895e-4e33-99f0-0adcfe2d7e72",
      progress: 0,
      source_task_id: "IBOS.CON.1040"
    },
    {
      id: "4e389728-e415-4a59-8423-e0e2916efc56",
      text: "B2 - 2A2 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-02-18T08:00:00",
      duration: 24,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1840"
    },
    {
      id: "166375c4-7218-45b8-be5f-391e14d883af",
      text: "(CFCI) NCB - (Deferred Submittal) Fire Alarm Design",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994918"
    },
    {
      id: "419938e9-34dd-47a9-a828-6717d88d10bb",
      text: "Electrical R/I",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 80,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1000"
    },
    {
      id: "36bb7204-7677-404e-930f-1b403d0ccc46",
      text: "Punchlist / Zero Defects",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.CON.1470"
    },
    {
      id: "2696e742-cd10-4b95-8a41-277ca3b0f51c",
      text: "Demobilization",
      type: 5,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-11-05T08:00:00",
      duration: 1288,
      parent: "fe99c54f-c538-4ad6-92f9-d75f5a4477c2",
      progress: 0,
      source_task_id: "7995201"
    },
    {
      id: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      text: "Substation-1 MSG B Buildout",
      type: 5,
      start_date: "2025-04-10T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 1048,
      parent: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      progress: 0,
      source_task_id: "7995236"
    },
    {
      id: "7a3cdc68-7b33-4766-8474-e785e7943d34",
      text: "B2 - DH-A - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 80,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1360"
    },
    {
      id: "19f7a566-a38a-45b0-a4fb-a7bf357a0602",
      text: "Final Clean - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5800"
    },
    {
      id: "104ad1d0-cc1d-442f-b628-bbf43f4a07d2",
      text: "(CFCI) Div. 03 - Non- Structural Concrete",
      type: 5,
      start_date: "2024-06-03T00:00:00",
      end_date: "2024-07-08T08:00:00",
      duration: 200,
      parent: "36b087b6-3ffb-4aea-873b-73cacb04dbd0",
      progress: 0,
      source_task_id: "7994854"
    },
    {
      id: "ca726eb6-39fd-49d2-ad5a-1b5f3e4fbb64",
      text: "BLDG-1 DH-C - Equipment Final Clean",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 120,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1100"
    },
    {
      id: "d209a79f-e610-4e56-ae59-10cfa26208d2",
      text: "B2 - mCUP-8 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8120"
    },
    {
      id: "9cab297d-c579-43de-9c0f-90c459f05a0d",
      text: "BLDG-1 DH-C",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444261"
    },
    {
      id: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      text: "Building 2",
      type: 5,
      start_date: "2025-09-29T08:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 1272,
      parent: "ea83517a-dd48-4c21-9786-7bd3d6a2338c",
      progress: 0,
      source_task_id: "7994820"
    },
    {
      id: "bf83dc35-3c91-4905-b1db-959f7b465647",
      text: "B1 - 1C1W - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 80,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1410"
    },
    {
      id: "aa484bd1-228b-4d55-8c12-92a1cdff3942",
      text: "B1 - 1C1W - 01C.08 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 48,
      parent: "bee61510-372a-42fa-a681-40702aefa9c9",
      progress: 0,
      source_task_id: "B1.C.C.1900"
    },
    {
      id: "6e30d7ee-e219-422d-9d85-b8a1c26f6d9e",
      text: "Area B - OH Plumbing",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1210"
    },
    {
      id: "ee0ce781-26bc-41c7-9651-662383cbc198",
      text: "B2 - DH-A - Install Underground Plumbing",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 120,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1160"
    },
    {
      id: "0938d647-afcd-4b27-9e4b-c9c1a7dad1b1",
      text: "Trim Out - All Devices",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1440"
    },
    {
      id: "f9b17f31-7854-479b-b017-fee40ec70f8d",
      text: "B2 - SSB - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 40,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1130"
    },
    {
      id: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557",
      text: "Substation-2 - MSG B - Energization MSG",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 24,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4450"
    },
    {
      id: "7106e614-e14a-4029-bf17-8ea4bd60029d",
      text: "FacNet Live - DCB2",
      type: 0,
      start_date: "2026-07-01T08:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2880"
    },
    {
      id: "874ea700-71ea-4030-8bc9-592481826f26",
      text: "B2 - DH-A - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 120,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1110"
    },
    {
      id: "ade2e6b0-bd80-4e10-9ebd-c0e0f8a169de",
      text: "Fab and Deliver - Busway Kits - Area C - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3064,
      parent: "7daf4adf-ced1-4cf6-8970-25b7702a310f",
      progress: 0.2,
      source_task_id: "B1.OFCI.3450"
    },
    {
      id: "d97fca9f-fb52-4158-93c7-1764891aeef8",
      text: "Delivery of FCA - Fan Coil Assembly (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-05-20T08:00:00",
      end_date: "2025-05-20T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1835"
    },
    {
      id: "fe7d7efc-c1f4-43cd-8d2d-b2e69d15aabc",
      text: "B1 - 1N2W - 01N2.06 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.5610"
    },
    {
      id: "1b487435-c4ee-4b4e-969f-cc9c858302f6",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Equipment Mech Hookup",
      type: 0,
      start_date: "2025-04-24T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1110"
    },
    {
      id: "2fd0f3a7-8faa-4a12-a56a-2f4872e729fb",
      text: "FR 05 - Model Coordination and resolve",
      type: 0,
      start_date: "2024-10-21T00:00:00",
      end_date: "2024-11-04T08:00:00",
      duration: 48,
      parent: "a706f8e9-f5f3-400c-8585-d4fb3ff784b5",
      progress: 0,
      source_task_id: "FR.05.1000"
    },
    {
      id: "4f6868f3-0d9d-45a5-9d7c-eb4cc9efc93b",
      text: "B2 - 2E1E - 02.01.E1.05 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-02-03T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5390"
    },
    {
      id: "90dd9ead-7191-4d9c-9a21-ffd37897bf30",
      text: "Sub Structure",
      type: 5,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 1160,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995095"
    },
    {
      id: "b55dedcb-17c7-4a05-b140-4ffc11f41345",
      text: "Substation-2 - TX B - Pull Control Wiring",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 40,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4490"
    },
    {
      id: "93ede041-6583-401b-9f50-9d52e252d55c",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Lighting",
      type: 0,
      start_date: "2024-11-20T00:00:00",
      end_date: "2024-12-05T08:00:00",
      duration: 120,
      parent: "35f922d0-d8cc-464c-8795-760c9606b1a3",
      progress: 0,
      source_task_id: "B1.CFCI.4040"
    },
    {
      id: "35e2108f-8537-4bb3-af72-7147126da563",
      text: "B2 - DH-D - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2026-05-13T00:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 40,
      parent: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      progress: 0,
      source_task_id: "B2.C.EY.1730"
    },
    {
      id: "4d92b7ff-dc9e-48f6-803c-ba0858ed4d38",
      text: "Substation 1 -  Review for Approval - H-Frame MOAB",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-03T08:00:00",
      duration: 72,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5790"
    },
    {
      id: "146c3a66-4e1a-4778-80c1-ce94beca75c3",
      text: "B1 - DH-D - Install Decking",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-21T08:00:00",
      duration: 80,
      parent: "2a43c059-bb4c-4407-9973-5e670181d3f2",
      progress: 0,
      source_task_id: "B1.C.STR.2190"
    },
    {
      id: "431c4952-3318-4958-8110-7b5dfede44b6",
      text: "B1 - Network Room 2/3 - Install Technical Water",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1450"
    },
    {
      id: "99479f13-36a4-409f-b44c-024ee2b03f53",
      text: "B1 - SSB - 1E1 - CMDF1 - Build Wall Between MDF/Fiber Entry and Carrier (Carrier MDF1)",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 48,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1340"
    },
    {
      id: "99c76171-a13d-45b6-b825-38f4d5bea816",
      text: "Interior Construction - IBOS (LOE)",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 480,
      parent: "079ba0f0-2fdb-4e7a-866a-6e6316dc9e1f",
      progress: 0,
      source_task_id: "IBOS.CON.1060"
    },
    {
      id: "3819532e-4a9a-486b-a57b-3a690a88dbe8",
      text: "Off Campus - Install Non-Critical Power System (service to transformer)",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-06-29T08:00:00",
      duration: 320,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 0.85,
      source_task_id: "C.CSW.3000"
    },
    {
      id: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9",
      text: "B2 - DH-B - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1060"
    },
    {
      id: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      text: "B1 - DH-D - Frame Walls (ROJ date for Prefab walls)Pre-fab",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1000"
    },
    {
      id: "ebf78c9f-a46e-499f-9f05-08916b6c329b",
      text: "Adverse Weather Event 5 - 08.05.2024",
      type: 0,
      start_date: "2024-08-05T00:00:00",
      end_date: null,
      duration: 8,
      parent: null,
      progress: 1,
      source_task_id: "WX.1005"
    },
    {
      id: "09c06ca8-564f-4081-bffc-b19c58f69913",
      text: "B2 - DH-C - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 40,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1030"
    },
    {
      id: "aff9859a-2ae3-46bd-b1b6-30283ba1645d",
      text: "FR 29 - META review and Approve PCO#27",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 80,
      parent: "76f1b205-6d2d-4956-8ca6-877a6aaee359",
      progress: 0,
      source_task_id: "FR.29.1020"
    },
    {
      id: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      text: "Tier 0 - Site - Phase 1",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-26T08:00:00",
      duration: 240,
      parent: "ba989cfa-37e2-4e7f-9c77-a4f3125cdb8e",
      progress: 1,
      source_task_id: "7994751"
    },
    {
      id: "72e94fbf-c40f-4ce4-aeed-5ce24d9af1bb",
      text: "B2 - DH-D - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 104,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1120"
    },
    {
      id: "468e93cd-8b59-4de0-9ca3-a7768313bb9d",
      text: "Fragnet 03 - Telecom Redesign",
      type: 0,
      start_date: "2024-05-10T00:00:00",
      end_date: null,
      duration: 184,
      parent: "cd435564-4024-4c0e-924c-74c687f38b15",
      progress: 1,
      source_task_id: "8519883"
    },
    {
      id: "a464ca61-32ce-4bd2-8aa4-8f60eccf8e8c",
      text: "Fragnet 20 - PCO # 16 CCD-018 Heat Trace Sensor Location",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 472,
      parent: null,
      progress: 0.33,
      source_task_id: "8690690"
    },
    {
      id: "3e40dffb-4d62-4ffe-b5a9-0f8465e90024",
      text: "B1 - Deep Telecom - EF1 - Concrete Scope",
      type: 0,
      start_date: "2024-11-23T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B1.C.STR.2450"
    },
    {
      id: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      text: "BLDG-2 Entrance Facility 3",
      type: 5,
      start_date: "2025-12-02T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 296,
      parent: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      progress: 0,
      source_task_id: "7995044"
    },
    {
      id: "1123851f-8062-4ec1-8099-548b04aca54a",
      text: "Room Ready for GS.MDF Module Placement - DCB1",
      type: 0,
      start_date: "2025-06-25T08:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1750"
    },
    {
      id: "e8f9c7d3-11e6-4ca9-be0f-e5958e45c929",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2600"
    },
    {
      id: "16885e34-aafb-4bd9-8f26-e99d5ef56a21",
      text: "MEPF Ceiling / Wall Rough-In",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 80,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1020"
    },
    {
      id: "d9211a90-3325-4503-946c-da72e8ca4e4d",
      text: "Delay to Power Available from Power Grid",
      type: 0,
      start_date: "2023-12-01T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 4112,
      parent: "e5b9549d-9194-435b-9ea4-2d31c95d3bc4",
      progress: 0,
      source_task_id: "D.PD.1000"
    },
    {
      id: "e4b8cd12-941c-4b48-8c09-0bbc18e187ef",
      text: "B2 - DH-A - Install Thermal Concrete",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 120,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1190"
    },
    {
      id: "cf4003fe-f163-41cf-9bd3-59d7784829fd",
      text: "B1 - 1D2E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2400"
    },
    {
      id: "d878e5ad-598a-4bf6-8b48-6ad6087f03f3",
      text: "B1 - Network - WAP Provisioning",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 192,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1210"
    },
    {
      id: "fffebd98-3b92-4cb0-8da1-ac9af78bfdfe",
      text: "Corridor 1N2W (UPS Room/Restroom/Janitor/Control Panel)",
      type: 5,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 400,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995336"
    },
    {
      id: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      text: "Contractor Furnished Equip. (CFCI)",
      type: 5,
      start_date: "2024-01-09T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 2672,
      parent: "cee57e06-8220-46f4-bf48-e8124ce9e922",
      progress: 0.14,
      source_task_id: "7994837"
    },
    {
      id: "4dd2b68e-e2be-49c7-8d76-4ecea429f753",
      text: "B1 - SSB - 1E1 - GSMDF1 - Punch walk and Handover Skid (DEC-C Ready)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 8,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1910"
    },
    {
      id: "3523fe14-da7a-489d-8e7d-8da4c3423537",
      text: "B1 - 1N1W - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 24,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5540"
    },
    {
      id: "1685c1f9-40f0-48e7-a581-5cc660945576",
      text: "Substation-2 - MSG B - MSG A Neta Testing",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 152,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4380"
    },
    {
      id: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59",
      text: "B1 - 1N1E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 120,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.6590"
    },
    {
      id: "36613527-b84c-499c-a9a1-695a5bc84d19",
      text: "L4 - B1 DHD - Server Migration",
      type: 0,
      start_date: "2026-08-20T00:00:00",
      end_date: "2026-08-21T08:00:00",
      duration: 16,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHD.1010"
    },
    {
      id: "9f4ff250-f8fd-4bae-aa2b-8e6b4d536313",
      text: "Pressure testing - Saniitary Sewer",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 40,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1110"
    },
    {
      id: "758147f6-cdd0-4f5b-b882-ebc2374e4b40",
      text: "B1 - 1N2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-06-25T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 8,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5400"
    },
    {
      id: "6901006a-88f8-47d2-a665-e7c120f803c5",
      text: "B1 - DH-C - Install Balance of Grade Beams",
      type: 0,
      start_date: "2025-03-31T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 80,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1580"
    },
    {
      id: "70257f37-f3fc-43c0-a48c-d7174bfaf3a0",
      text: "B2 - 2E2E - 02.01.E2.01 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6370"
    },
    {
      id: "8abd18ce-bd05-413d-b05a-577ba7be0653",
      text: "BLDG-1/2 - Submittal Rvw/App'l -Epoxy Flooring (Spec 09 67 23)",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: "2025-01-22T08:00:00",
      duration: 120,
      parent: "7e52e785-c4af-4414-bc14-09a437907568",
      progress: 0,
      source_task_id: "B1.CFCI.4880"
    },
    {
      id: "c00b4971-b0e2-49cb-adec-4c05cbe9e25a",
      text: "Mechanical GCs and Fee - Develop SA Package",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-02-26T08:00:00",
      duration: 80,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "PRE1160"
    },
    {
      id: "5879d744-df34-4e9d-9087-5b631f1b38bd",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2030"
    },
    {
      id: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      text: "Area 2 - Sanitary Sewer Install - Lift Station (Early Work)",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: "2024-07-26T00:00:00",
      duration: 80,
      parent: "81163b8d-213a-47ce-8f82-68561568deaf",
      progress: 0,
      source_task_id: "C.CSU.A2.8010"
    },
    {
      id: "c3804e97-b239-4885-a723-fce3b1ec160e",
      text: "DFSMA - DC1 - CUP 4- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1260"
    },
    {
      id: "5f56be1c-c476-403f-a5dd-4a3329f06fd6",
      text: "B1 - DH-A - Install Fire Alarm Conduit/Vesda -Data Hall A",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2500"
    },
    {
      id: "2d4e0451-9b9a-4336-9df3-08aedb856e2c",
      text: "B2 - SSB - 2E1 - Common - Install Devices in Tile/OH Fire Alarm",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1240"
    },
    {
      id: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 160,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1750"
    },
    {
      id: "6a20c832-3531-4522-8322-a05e770741b6",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1370"
    },
    {
      id: "926c19d3-ae03-46ba-a506-346d424fde19",
      text: "Substation-2 - A Lineup - Install MSG Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 168,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4630"
    },
    {
      id: "3e1a6b22-298d-4d8c-bd96-96c144226a7a",
      text: "Substation-1 - TX B - NETA Testing",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 184,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3720"
    },
    {
      id: "04a6aee4-d714-4cf9-8b79-5811683473d6",
      text: "Erect Canopy Steel",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 40,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1120"
    },
    {
      id: "8af65a37-dd4c-4361-bc42-10142c179b20",
      text: "B1 - DH-D - El Equip Yd - Set Equipment (10)MVS, (20)PTX",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "B1.C.D.3020"
    },
    {
      id: "689af013-a550-48af-af52-783a8539b04b",
      text: "B1 - DH-A - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 16,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1760"
    },
    {
      id: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10",
      text: "B1 - SSB - Install Underground Telecom",
      type: 0,
      start_date: "2025-02-20T00:00:00",
      end_date: "2025-02-28T08:00:00",
      duration: 64,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1160"
    },
    {
      id: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      text: "Area 5 - Telecom Install - DCI 3069",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-02-26T08:00:00",
      duration: 40,
      parent: "1b573127-21b9-4d1c-b69b-ddaf4855b3e8",
      progress: 0,
      source_task_id: "C.CSU.A5.8010"
    },
    {
      id: "a14cdfc7-32e6-4af5-b4d2-362c933730a6",
      text: "B1 - DH-A - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 40,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1830"
    },
    {
      id: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      text: "B2 - DH-C - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "752f580e-1b15-4e9d-b156-a9d2d9ab02b5",
      progress: 0,
      source_task_id: "B2.C.STR.1320"
    },
    {
      id: "14662752-c8c0-46e0-8c14-bd33dd0e07bb",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 8,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1480"
    },
    {
      id: "21ca2baa-4a72-4279-b666-bf7a44c49fe5",
      text: "DFSMA - NWS South EY Skids ROJ - MOFE",
      type: 0,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "7085aaf1-4a32-4af6-aab6-cc21a3c34f7b",
      progress: 0,
      source_task_id: "B1.DFSMA.1050"
    },
    {
      id: "333050a7-0437-4c26-911f-75f4e2bba31f",
      text: "UG RI -Fire Alarm-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "06bd3404-1a5f-4d2c-b5cb-bad1e0f64a0d",
      progress: 0,
      source_task_id: "MECO-1680.40"
    },
    {
      id: "3750cb98-03f6-4090-9afc-515a595e07ff",
      text: "Data Hall C",
      type: 5,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 1312,
      parent: "e39bc1fd-688e-4691-869d-2615d2579be5",
      progress: 0,
      source_task_id: "7995036"
    },
    {
      id: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      text: "B1 - 1N2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-06-16T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 24,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5180"
    },
    {
      id: "667b7ead-af20-473f-aa1f-8adb63c37981",
      text: "Sanitary Sewer force main ( Including ARV's)",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8120"
    },
    {
      id: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd",
      text: "B2 - OSP Cabling - GSIDF 2X1 to IW-IDF",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-26T08:00:00",
      duration: 40,
      parent: "48b3b449-97e1-4e8d-96ff-da2222ec41de",
      progress: 0,
      source_task_id: "B2.CONN.1010"
    },
    {
      id: "3c869558-a455-4d67-bfbe-acc66c78082a",
      text: "Area A - Install Base",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 24,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1301"
    },
    {
      id: "f42d64c8-b2bd-4d87-8aa7-597c3e68303b",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Electrical",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1590"
    },
    {
      id: "29b867ba-3259-4b2f-b3af-9e62932d8146",
      text: "B1 - DH-A - Install Door/Hardware/ Wall Trim - Data Hall A",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2730"
    },
    {
      id: "6df4257d-bbdb-4628-beb1-3a30c578be60",
      text: "BLDG-1/2 - Prep / Submit for Review - Fire Alarm",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-01-24T08:00:00",
      duration: 160,
      parent: "aaa537e7-583e-4d33-ad14-d873dded0a6d",
      progress: 0,
      source_task_id: "B1.CFCI.4630"
    },
    {
      id: "08b76e55-41a7-4738-a5d9-999cd803be80",
      text: "B2 - DH-C - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1050"
    },
    {
      id: "84b2c487-8d68-483b-b6f2-2a89b54fccb9",
      text: "B1 - mCUP-7 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 48,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7000"
    },
    {
      id: "b097b758-ff0e-4f5c-8e6a-6f1a9ee5c820",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [3] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 3104,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.38,
      source_task_id: "B2.OFCI.2880"
    },
    {
      id: "99a7ae21-d468-400a-b563-50c15bf4ea85",
      text: "Substation HPD - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "862ebf7a-ac0e-4164-ba6f-7343140eb5ad",
      progress: 1,
      source_task_id: "B1.OFCI.1150"
    },
    {
      id: "b69200e1-2621-439d-beea-baaf20ef03f1",
      text: "B2 - 2A2 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 80,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2130"
    },
    {
      id: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      text: "B1 - SSB - 1E1 - Common - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-06-23T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1260"
    },
    {
      id: "a4c93897-d541-498e-9716-43ad43115085",
      text: "Area B - Plumbing Restroom Trim Out",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1500"
    },
    {
      id: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      text: "DEC-C Ready: General Services",
      type: 5,
      start_date: "2026-02-11T08:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 984,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995438"
    },
    {
      id: "f8187294-0b5f-474e-ac87-700645a38479",
      text: "Fab and Deliver - HMD - Area D - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3408,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.35,
      source_task_id: "B1.OFCI.3300"
    },
    {
      id: "7d4adfc5-bd88-454b-a4ce-cb80a6a12d91",
      text: "B2 - Deep Telecom - Backfill",
      type: 0,
      start_date: "2025-04-07T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 40,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2440"
    },
    {
      id: "3450f3ae-4523-482a-bd62-921a761ee582",
      text: "L4 Start DH A - DCB2",
      type: 0,
      start_date: "2026-10-14T00:00:00",
      end_date: "2026-10-14T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2080"
    },
    {
      id: "10863bda-8e83-4746-b50e-13c00d34b238",
      text: "B2 - 2D1W - 02D.08 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-06-24T00:00:00",
      end_date: "2026-06-30T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.2380"
    },
    {
      id: "f068736c-3c4a-473c-8c98-6ef859973fe0",
      text: "Building Expansion Joints (Spec 07 95 13.13)",
      type: 5,
      start_date: "2024-11-25T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 760,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994847"
    },
    {
      id: "375e41f1-0a7b-4bee-9fc1-fe48ac5e5c08",
      text: "B1 - Network Room 1/4 - Power Alley - Equipment Hookup  (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 96,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1760"
    },
    {
      id: "8d7917b6-d2c7-40c1-abb9-362057f3a7ed",
      text: "B1 - Network Room 2/3 - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1220"
    },
    {
      id: "c286ea02-1b1b-4331-8456-6f924e582e78",
      text: "B1 - Network Room 2/3 - Power Alley - Room Ready for Skids",
      type: 0,
      start_date: "2025-08-14T08:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 0,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1630"
    },
    {
      id: "67f67df1-5b8f-468d-bd41-e9987e90a528",
      text: "Interior fit-out Start DCB2 - Phase 4",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-23T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1290"
    },
    {
      id: "cf9227b7-4c03-4a45-a94f-4b075f8246cd",
      text: "B2 - 2C1W - 02C.08 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 160,
      parent: "4800ea84-30c1-4ed3-ba18-07b3fa1ef484",
      progress: 0,
      source_task_id: "B2.C.C.2000"
    },
    {
      id: "520abc93-f6c9-4ba9-a853-d8ff2143e26d",
      text: "Substation-2 - TX B - Energization",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 8,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4540"
    },
    {
      id: "ff40e3a6-bbbc-4a6d-a305-083ef7670a8d",
      text: "BLDG-2 DH-A Level 2 Checkout",
      type: 5,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 464,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "7995131"
    },
    {
      id: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      text: "B2 - SSB - 2E1 - Common - Prime and 1st Coat Paint",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 80,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1110"
    },
    {
      id: "04eea52a-164c-469e-87b0-71ae63bdd8bc",
      text: "B2 - DH-C - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-05-18T00:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 80,
      parent: "9d327b1d-02b1-4eab-85c0-d1381fd1b75a",
      progress: 0,
      source_task_id: "B2.C.EY.1690"
    },
    {
      id: "587a14b0-c535-417d-9dc3-25f34dbe27a3",
      text: "L3 - B2 EY 1B/D",
      type: 0,
      start_date: "2026-08-25T00:00:00",
      end_date: "2026-09-08T08:00:00",
      duration: 80,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "CX3.B2.MSG.1020"
    },
    {
      id: "8b1c55d4-111f-48db-b134-efc649b1f14b",
      text: "B1 - DH-B - Pull/Term Lighting/Branch - Data Hall B",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2740"
    },
    {
      id: "beec48dd-423f-4c51-b7b9-a66ca4e524ab",
      text: "B1 - DH-B - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1240"
    },
    {
      id: "9591fb7e-3354-423a-8514-0b7d93053a0e",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 120,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2470"
    },
    {
      id: "06737829-e188-48c8-90e1-05746ef0b9f8",
      text: "B1 - mCUP-1-9 - Piping Install (Header Mcup 1-5)",
      type: 0,
      start_date: "2025-04-24T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1090"
    },
    {
      id: "d6c6b1be-83c9-420a-bc49-4915bbc465ca",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Equipment Setting",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1100"
    },
    {
      id: "670bdb28-db62-4fc2-b89a-d1ad6f28ec8c",
      text: "(OFCI) Substation Power Transformer",
      type: 5,
      start_date: "2023-09-08T08:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 3648,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0.36,
      source_task_id: "7994939"
    },
    {
      id: "b4e5a005-102e-4fbf-949a-1ed89d200a5c",
      text: "Network Electrical Yard",
      type: 5,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 200,
      parent: "0277d7b3-e3a7-42c6-9996-54bcc49d9eab",
      progress: 0,
      source_task_id: "7995014"
    },
    {
      id: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      text: "WAP",
      type: 5,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-11-19T08:00:00",
      duration: 864,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995458"
    },
    {
      id: "13229818-d9b7-4b8b-abcc-581bd7429801",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Interior Painting (Spec 09 91 23)",
      type: 0,
      start_date: "2024-10-23T00:00:00",
      end_date: "2024-11-19T08:00:00",
      duration: 120,
      parent: "5ed9bec7-54c7-4156-b0c1-7ceb6eb0515a",
      progress: 0,
      source_task_id: "B1.CFCI.4870"
    },
    {
      id: "e33e334f-e67a-462b-8f59-cf344c722a84",
      text: "(CFCI) Div. 07 - Thermal & Moisture Protection",
      type: 5,
      start_date: "2024-08-02T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 1512,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994838"
    },
    {
      id: "49470c76-b61b-4f12-b702-7222ca7c2aa5",
      text: "BLDG-1/2 -  Review for Approval - Structural Steel",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: "2024-09-06T08:00:00",
      duration: 72,
      parent: "b5ab113b-f512-4fc0-8bd5-aac4590010ea",
      progress: 0,
      source_task_id: "B1.CFCI.3420"
    },
    {
      id: "55a0fd5c-45ee-419c-9e39-4c1865299c37",
      text: "Substation-1 - A Lineup SF6 Breaker - Assembly",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "aa22521b-48bf-4060-93d0-7750855b683f",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4160"
    },
    {
      id: "904ae244-f22d-4b22-8fe1-ee87d6f3fab8",
      text: "B1 - DH-D - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 80,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1020"
    },
    {
      id: "1d27fe08-66ca-4f61-919a-bad62b8d0cc8",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1500"
    },
    {
      id: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      text: "B1 - mCUP-4 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4040"
    },
    {
      id: "b902ca4e-8c84-46aa-960c-fe4f123249ab",
      text: "Cx & Startup",
      type: 5,
      start_date: "2025-11-17T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 376,
      parent: "39855758-26c2-45c7-8a00-84dc36793e26",
      progress: 0,
      source_task_id: "8147637"
    },
    {
      id: "e5d09a46-f2b1-4c5b-9af3-33b40223faef",
      text: "Exterior Metal Panels",
      type: 5,
      start_date: "2024-09-11T00:00:00",
      end_date: "2025-03-07T08:00:00",
      duration: 760,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994843"
    },
    {
      id: "212dda32-6ec5-467d-b017-b72859d32a5f",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2160"
    },
    {
      id: "b0a0be6f-c27b-4f12-bd96-5e75d61c6b30",
      text: "B2 - mCUP-3 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 16,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3010"
    },
    {
      id: "c6952a30-ea67-499d-b6d2-ee0c753f26df",
      text: "OH Cable Tray Install",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1180"
    },
    {
      id: "6578e9d9-ca51-45cc-8726-cf66b2a066ee",
      text: "B2 - DH-B - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 120,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1910"
    },
    {
      id: "182eb0a8-c8a3-4365-a0ae-96426cdba0d2",
      text: "B2 - mCUP-2 - L2 Inspections",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2130"
    },
    {
      id: "262de4d5-857d-44f1-9c96-1dcfa716764b",
      text: "B1 - DH-C - Set CDU's - Data Hall C (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2025-12-20T08:00:00",
      duration: 64,
      parent: "dcac32fd-f134-4e86-b43f-bafd5526cedf",
      progress: 0,
      source_task_id: "B1.C.C.3180"
    },
    {
      id: "15326198-a4f4-4581-b541-5a50d9d098f8",
      text: "B2 - 2E2E - Corridor - OH Rough In Feeder",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2025-12-24T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6060"
    },
    {
      id: "6e83ade3-3f4d-45a0-84f4-8619aac4be17",
      text: "FR 37 - META review and respond to RFI #219.1",
      type: 0,
      start_date: "2024-10-09T00:00:00",
      end_date: null,
      duration: 64,
      parent: "3379c616-a9bf-4246-981a-9eef20f2a943",
      progress: 1,
      source_task_id: "FR.36.1070"
    },
    {
      id: "a9e6da2e-d346-4bdc-902e-a515ca7eb37f",
      text: "BLDG-2 SSB - Equipment Final Clean",
      type: 0,
      start_date: "2026-07-10T00:00:00",
      end_date: "2026-07-30T08:00:00",
      duration: 120,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1050"
    },
    {
      id: "30e5ab3a-14d7-4ce7-8163-0e3510247c71",
      text: "FR 37 - Install CAV -2 (MECO)",
      type: 0,
      start_date: "2024-12-30T00:00:00",
      end_date: "2024-12-31T08:00:00",
      duration: 56,
      parent: "3379c616-a9bf-4246-981a-9eef20f2a943",
      progress: 0,
      source_task_id: "FR.36.1100"
    },
    {
      id: "8804404b-bdd4-4bc3-8942-e458aa99c89f",
      text: "B2 - 2E2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-23T08:00:00",
      duration: 160,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6220"
    },
    {
      id: "a1e50c0f-32aa-4860-b4ff-e27de2cbd78d",
      text: "B2 - 2E1E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5430"
    },
    {
      id: "43d42ebe-27bd-4d84-bb35-170cf20f2b46",
      text: "B2 - mCUP-6 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 16,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6010"
    },
    {
      id: "6b393e4a-958e-4ac9-bb16-32b3eacbeb11",
      text: "Fragnet 22 - PCO # 18 CCD-037 TW Loop, Non-Zinc Values",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: null,
      duration: 432,
      parent: null,
      progress: 0.4,
      source_task_id: "8690692"
    },
    {
      id: "f60a73cf-32c4-4c13-bfaf-61c6d9ca9123",
      text: "Delivery of MVS - Medium Voltage Switches (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-05-27T08:00:00",
      end_date: "2025-05-27T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1825"
    },
    {
      id: "92382b5d-09f4-4be1-b2f5-b1899eed6f80",
      text: "[DCB1] FacNet Live [DAS TOWER #1 & GH]",
      type: 0,
      start_date: "2025-11-21T08:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3667"
    },
    {
      id: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      text: "Building 2",
      type: 5,
      start_date: "2025-03-11T08:00:00",
      end_date: "2026-07-09T08:00:00",
      duration: 2560,
      parent: "4d7f99a1-a653-43bf-b87f-5b8e20378bdb",
      progress: 0,
      source_task_id: "7995427"
    },
    {
      id: "5c6f3038-7ae8-40d1-808f-5b07864c7aa4",
      text: "Substation-1 - MSG B - Install IDF Rack (SUBIDF1) for MSG B",
      type: 0,
      start_date: "2025-04-28T00:00:00",
      end_date: "2025-05-02T08:00:00",
      duration: 40,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3700"
    },
    {
      id: "e0e42120-2ca4-41f2-bd91-655f59c20f7e",
      text: "B1 - 1B2E - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2060"
    },
    {
      id: "bff7cb41-a76c-46f3-9db8-e2014bf430a1",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1360"
    },
    {
      id: "563acf81-2601-48a9-8475-3b199c4ad204",
      text: "B2 - mCUP-3 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3080"
    },
    {
      id: "bc79d762-9494-4e90-adc4-400081a65a92",
      text: "B2 - mCUP-7 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7070"
    },
    {
      id: "f581bf1d-3ccd-4413-9d92-d725119f4ccf",
      text: "B1 - SSB - 1E1 - Common - Clean",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 48,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2480"
    },
    {
      id: "9934ee9b-957d-4d28-af13-b16c42d00a52",
      text: "B2 - mCUP-1 - Setting and Hookup of GS-IDF Hut (2X1)",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 80,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.C.EY.1100"
    },
    {
      id: "28d12d42-a49d-43fc-b1d9-424f6b835c20",
      text: "B2 - DH-D - Install Insulation",
      type: 0,
      start_date: "2025-12-04T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 40,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1270"
    },
    {
      id: "c2ba5953-47b1-495e-9759-8f696fa33150",
      text: "Substation-2 - A Lineup - Deep Conduit Install",
      type: 0,
      start_date: "2025-04-18T00:00:00",
      end_date: "2025-05-02T08:00:00",
      duration: 104,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4600"
    },
    {
      id: "b18d0f25-0e11-4cf1-9603-2511f8a95b2e",
      text: "B1 - SSB - 1E2 - Common - Install Security Devices",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2230"
    },
    {
      id: "f0d62a9f-d597-45a7-90b4-44ab761c820b",
      text: "B1 - Network Room 2/3 - Raise HAC's/ Connect Busway/Cable Tray",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1670"
    },
    {
      id: "4d719932-f0c2-4ea5-903c-c125369ea801",
      text: "IST Finish DH A - DCB2",
      type: 0,
      start_date: "2027-01-06T08:00:00",
      end_date: "2027-01-06T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2155"
    },
    {
      id: "da2cf7ac-eaba-4747-aafb-64968211492e",
      text: "(CFCI) Div. 05 - Deco. Metals (Target Plates / Diamond Plates)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0,
      source_task_id: "7994934"
    },
    {
      id: "95d760eb-ceb2-4cef-8874-73a10fb573be",
      text: "State Review and Approval - DHEC",
      type: 0,
      start_date: "2024-04-10T00:00:00",
      end_date: "2024-04-11T00:00:00",
      duration: 8,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "PRE-DD-1140"
    },
    {
      id: "77eba6c6-3172-4003-8d6d-2dd18ca98b81",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Blocking/Fire FEC",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1100"
    },
    {
      id: "fcb414f2-390a-4870-a33e-898663fa8e82",
      text: "B1 - 1A2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 24,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1410"
    },
    {
      id: "edb74c16-cc04-43f5-99a4-e42d4d4c2874",
      text: "B2 - SSB - 2E1 - Common - Install Security Devices",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 80,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1300"
    },
    {
      id: "817a1850-5c9f-4ca9-a283-aedc0bebbb02",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [4] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 3136,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.38,
      source_task_id: "B2.OFCI.2890"
    },
    {
      id: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d",
      text: "B1 - Network Room 2/3 - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1200"
    },
    {
      id: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      text: "Deep Telecom",
      type: 5,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 320,
      parent: "d3088fee-6e35-4c31-ad29-0f9024527c65",
      progress: 0,
      source_task_id: "7995406"
    },
    {
      id: "7e94a2e0-495e-49dc-a503-d9e4acd075da",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2450"
    },
    {
      id: "c79a70af-d9ce-4920-b3c9-f8eac61a2ed3",
      text: "Substation-1 - MSG A - Disconnect Temporary Power & Hookup Perm Power",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2025-12-18T08:00:00",
      duration: 24,
      parent: "d9d2a2ca-55ab-40b7-b86c-22fa99be924a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.7020"
    },
    {
      id: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      text: "BLDG-2 DH-D Electrical Pulls",
      type: 5,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-06-03T08:00:00",
      duration: 320,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "7995126"
    },
    {
      id: "e8e23443-7726-4526-988a-cd71ecf4cba2",
      text: "Meta Reviews / Authorization",
      type: 5,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-10-29T08:00:00",
      duration: 1736,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 0.58,
      source_task_id: "7994731"
    },
    {
      id: "b3bbc402-500c-40f6-85fe-05ed4354691e",
      text: "BLDG-1/2 -  Prep / Submit for Review - Struc. Conc. (SOG/SOMD Ready Mix)",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: "2024-10-17T00:00:00",
      duration: 80,
      parent: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      progress: 0,
      source_task_id: "B1.CFCI.1030"
    },
    {
      id: "e20126e8-8f6a-4ec8-9149-317f70a98a77",
      text: "B1 - mCUP-4 - L2 Inspections",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4130"
    },
    {
      id: "c0ce5d1b-0fbc-4bef-a7ae-eb1586c5f9c2",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 24,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2240"
    },
    {
      id: "a4af63fc-0dc7-4649-b7fb-75f508c5aa24",
      text: "BLDG-1/2 - Fabricate / Deliver - Plumbing (OH Piping) (Prefab)",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 40,
      parent: "425a3675-d964-4bcd-981d-bc45ef37bf99",
      progress: 0,
      source_task_id: "B1.CFCI.3890"
    },
    {
      id: "04513e29-27d2-4ed7-b372-c6fb0b1e5004",
      text: "FR 08 - Area 5 - Telecom Install - DCI 3069 - Concrete Scope",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-02-26T08:00:00",
      duration: 40,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 0,
      source_task_id: "C.CSU.A5.8040"
    },
    {
      id: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      text: "Area 3 - Sanitary Sewer Install",
      type: 0,
      start_date: "2024-10-11T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 344,
      parent: "622b64a1-3b44-4ab4-8dc6-e0062ed3f6a5",
      progress: 0,
      source_task_id: "C.CSU.A3.2000"
    },
    {
      id: "992febb7-4f25-43fa-a90f-fe56ed7dff43",
      text: "Substation-1 - TX A - Pull Control Wiring",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 40,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4090"
    },
    {
      id: "e8be9ff4-f33b-49de-9fda-cb65d7032498",
      text: "B1 - DH-D - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall D",
      type: 0,
      start_date: "2026-02-28T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1430"
    },
    {
      id: "70d280e2-b447-483b-988f-efe191c41286",
      text: "DFSMA - DC2 - CUP 6- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-11-03T08:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1300"
    },
    {
      id: "2e0b08be-32e4-4542-8567-e52e463197a1",
      text: "L4 - B1 EY 1D *On Temp Power*",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 40,
      parent: "8d364ed6-8d95-4622-8f88-85275fa83049",
      progress: 0,
      source_task_id: "CX4.B1.MSG.1050"
    },
    {
      id: "f3285826-75e2-4eee-a5de-2d5fcafb0dda",
      text: "B2 - SSB - Underground (Converted to LOE )",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 240,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1020"
    },
    {
      id: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      text: "B1 - SSB - 1E1 - GSMDF1 - In Wall Rough In for GS-MDF Skid",
      type: 0,
      start_date: "2025-05-28T00:00:00",
      end_date: "2025-06-02T08:00:00",
      duration: 40,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "B1.C.SSB.1020"
    },
    {
      id: "ef078086-45cd-4944-9dac-55511cd2cdc0",
      text: "B1 - Network Room 1/4  - Install Grounding Loop",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2150"
    },
    {
      id: "439475e7-fd6f-4100-91a8-ac58abcdbdcb",
      text: "B1 - Network - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-05-10T00:00:00",
      end_date: "2025-05-15T08:00:00",
      duration: 40,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1020"
    },
    {
      id: "bddc1376-21cc-4b85-a77f-3e45b164b74a",
      text: "B1 - DH-D - Install Underground Security",
      type: 0,
      start_date: "2025-04-15T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 80,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1740"
    },
    {
      id: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      text: "DEC-C Ready: General Services",
      type: 5,
      start_date: "2025-08-26T08:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 1192,
      parent: "6265d63a-03f4-4699-a369-5fe6a59d94a5",
      progress: 0,
      source_task_id: "7995443"
    },
    {
      id: "2de29078-c64e-4e5d-88c9-4421b0fe933d",
      text: "B1 - 1N1W - 01N1.07 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-08-19T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6080"
    },
    {
      id: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      text: "UPS Room 01N1.07",
      type: 5,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 480,
      parent: "170d680a-3fe7-4c7b-84af-c46523784642",
      progress: 0,
      source_task_id: "7995334"
    },
    {
      id: "14796376-b4a8-47d0-a072-4d7d7b938edb",
      text: "DFSMA - DC1 - SUB 1 - GS.IDF Remote Module ROJ - MOFE",
      type: 0,
      start_date: "2025-06-19T08:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 0,
      parent: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      progress: 0,
      source_task_id: "B1.DFSMA.1220"
    },
    {
      id: "028cb7c0-7617-4664-8fcd-d6d41251d127",
      text: "Form/Rebar/Pour SOG - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1030"
    },
    {
      id: "be052ef5-e1f1-489b-9ff3-d0d14d4e0dc7",
      text: "Pressure testing - Water",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 40,
      parent: "e1a68307-fdef-4d79-9ca4-7d73fe61b112",
      progress: 0,
      source_task_id: "HRA.1100"
    },
    {
      id: "2281590d-a3bf-4061-aa84-8705ca6382b0",
      text: "FR 38 - DPR prepare and Submit RFI #315",
      type: 0,
      start_date: "2024-11-14T00:00:00",
      end_date: null,
      duration: 0,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 1,
      source_task_id: "FR.38.1120"
    },
    {
      id: "2d1fd528-15ba-4b0a-b9fe-6db5c2cf7dc6",
      text: "B2 - mCUP-3 - Setting and Hookup of GS-IDF Hut (2X2)",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 80,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.C.EY.1800"
    },
    {
      id: "82459529-b222-4604-bce3-f899e6205dbc",
      text: "BLDG-1 DH-A",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "8444259"
    },
    {
      id: "da465e61-4cdb-4785-b437-baa0976357e9",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (C)",
      type: 0,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 0,
      parent: "a9b0b7b3-691c-4bf3-b255-5085ef8b94aa",
      progress: 0,
      source_task_id: "B2.DFSMA.1400"
    },
    {
      id: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd",
      text: "[DCB1] FacNet Live [AREA C]",
      type: 0,
      start_date: "2026-04-13T08:00:00",
      end_date: "2026-04-13T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3645"
    },
    {
      id: "f143f7e2-9bdc-4e7e-864a-fe05a3a3f04b",
      text: "MVS & HPD - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 1,
      source_task_id: "B2.OFCI.1300"
    },
    {
      id: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      text: "Campus Site Utilities - Area 4",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2025-04-22T08:00:00",
      duration: 2384,
      parent: "f9042377-f148-4804-85c5-aa57a2b4a7b3",
      progress: 0.37,
      source_task_id: "7995172"
    },
    {
      id: "99c0b2a1-2431-459e-a8b5-189b4bbb6a94",
      text: "Substation-1 - Ready for Overhead hookups from Santee cooper",
      type: 0,
      start_date: "2025-08-07T00:00:00",
      end_date: "2025-08-07T00:00:00",
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "CAMPUS.AUX.7040"
    },
    {
      id: "3379c616-a9bf-4246-981a-9eef20f2a943",
      text: "Fragnet 37 - Area - 4a telecom - CAV 2 relocation RFI #",
      type: 0,
      start_date: "2024-10-08T00:00:00",
      end_date: null,
      duration: 368,
      parent: "c9ca9ab5-7485-4d38-99c3-3c5fef4f879b",
      progress: 0.23,
      source_task_id: "8718819"
    },
    {
      id: "935732bb-b4cb-451c-a52d-b5c5ba6f10fc",
      text: "ADMIN/ IBOS - Submittal Rvw/App'l - Speciality doors and dock levelrs",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-11-04T00:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6340"
    },
    {
      id: "cb48e525-d5a6-45cb-809f-1165d090a3af",
      text: "B2 - 2E2E - 02.01.E1.02 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-03-17T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6480"
    },
    {
      id: "2a3cc48f-e381-4998-8027-fdc83d31d99d",
      text: "DFSMA - DC2 - CUP 7- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-11-10T08:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1310"
    },
    {
      id: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      text: "B1 - 1D2E - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 24,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.1890"
    },
    {
      id: "51b3abdf-b191-44cd-a08b-dbab9f96f0ce",
      text: "Substation-2 - Set Equipment (GS IDF Hut) ((SUBIDF2))",
      type: 0,
      start_date: "2025-12-01T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 80,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6190"
    },
    {
      id: "b6ff84de-9def-408f-9921-7d5b15bb56e0",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1360"
    },
    {
      id: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      text: "MDF Room Buildout Post Skid Setting",
      type: 5,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 296,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "7995294"
    },
    {
      id: "36510829-6102-4b2d-a7ec-96548beac333",
      text: "FR 06 - DPR Prepare and Submit PCO#2 (ROM)",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 0,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1040"
    },
    {
      id: "9fc02960-0011-4b76-bed9-0f7cd12efb69",
      text: "B2 - mCUP-1-8 - Foundations for Piping (Sequence 1)",
      type: 0,
      start_date: "2025-03-12T00:00:00",
      end_date: "2025-04-03T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1000"
    },
    {
      id: "9ce890e4-44fe-4479-a2e2-9e77b6d3940d",
      text: "Grease Duct Inspection",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 16,
      parent: "c53e0f48-3f8a-4332-8591-b02897d0fd9e",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1310"
    },
    {
      id: "772ef034-da98-4dd3-bbff-ae983f99d0e5",
      text: "B2 - 2E2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-06T00:00:00",
      end_date: "2026-01-20T08:00:00",
      duration: 80,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6150"
    },
    {
      id: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      text: "B2 - 2A1 - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1140"
    },
    {
      id: "f496dec9-10cd-4871-a202-a0843dd883f8",
      text: "B1 - Network Room 1/4  - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1210"
    },
    {
      id: "e3cfcd7e-c5d5-47c7-8cbc-4ec50d0e8a51",
      text: "B1 - 1A2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1890"
    },
    {
      id: "64812c01-ba38-4c2f-a0b1-611253ddf598",
      text: "BLDG-1/2 -  Submittals - Glass / Frames",
      type: 0,
      start_date: "2024-10-10T00:00:00",
      end_date: "2024-11-01T00:00:00",
      duration: 160,
      parent: "d80cc1a6-c3ae-4d12-a355-ea20aea6ef84",
      progress: 0,
      source_task_id: "B1.CFCI.5680"
    },
    {
      id: "ef487ed0-e0ea-4897-a739-b0eccec45793",
      text: "L4 - B2 EY 1A/C",
      type: 0,
      start_date: "2026-08-25T00:00:00",
      end_date: "2026-08-31T08:00:00",
      duration: 40,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "CX4.B2.MSG.1020"
    },
    {
      id: "baa6a889-2ce3-4592-86ab-18dab8a9ec91",
      text: "Substation-2 - B Lineup SF6 Breaker - Install High Voltage Cable / Install Verification / Pre-energization Checklist",
      type: 0,
      start_date: "2026-03-17T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 128,
      parent: "16ff5042-0ab3-4c60-92e5-16eed69a2518",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4580"
    },
    {
      id: "8f1f3143-5066-4f9b-85a3-016657f7ac94",
      text: "Frame Priority Walls",
      type: 0,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1010"
    },
    {
      id: "04afbee0-0115-475b-b183-6bab11cb7a66",
      text: "Fab and Deliver - PLC Panels - Area B - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 2720,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.36,
      source_task_id: "B1.OFCI.3070"
    },
    {
      id: "59ab9f2a-e795-4791-aaee-5242b1540274",
      text: "B2 - mCUP-4 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4100"
    },
    {
      id: "2a005706-7073-4042-b585-28e14aee4b53",
      text: "Precon - Connectivity Scope",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 720,
      parent: "706d2e52-0772-4280-b13b-93206452f57c",
      progress: 1,
      source_task_id: "7994724"
    },
    {
      id: "dd986823-19df-4887-8874-e07a81769ca1",
      text: "B1 - DH-A - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 40,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1400"
    },
    {
      id: "48e7de91-7fdc-41a7-8391-949673c1794d",
      text: "Campus - Prep / Submit for Review - Asphalt / Paving",
      type: 0,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 160,
      parent: "ecc051e0-d5dd-471f-94c9-13123cf5d74b",
      progress: 0,
      source_task_id: "B1.CFCI.4820"
    },
    {
      id: "afb52c0f-ded1-4d02-87df-7d1e15b940db",
      text: "B2 - SSB - 2E2 - Common - Clean and Field Walks",
      type: 0,
      start_date: "2026-06-02T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 96,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1920"
    },
    {
      id: "073a2bc0-01c0-4c57-a9b9-8bfb23adf20e",
      text: "Fab and Deliver - Control Power UPS - Area D - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 2488,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.44,
      source_task_id: "B1.OFCI.3310"
    },
    {
      id: "3c3cabfc-0a08-455c-b5f2-540f9a0812e8",
      text: "B2 - 2E2E - 02.01.E2.01 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6430"
    },
    {
      id: "e7245af7-b992-4b25-b541-0115b5a9676c",
      text: "Area 2 - UG RI -RSB/MSB-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1320"
    },
    {
      id: "475fbabe-89c3-43ba-986e-c5e612752c64",
      text: "BLDG-1 DH-B Electrical Pulls",
      type: 5,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 472,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "7995254"
    },
    {
      id: "708065cf-9a16-4b84-b7a7-e9d77054c890",
      text: "B1 - DH-A - Backfill",
      type: 0,
      start_date: "2025-03-31T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 40,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1570"
    },
    {
      id: "bb9ae4cf-13f0-487d-b3fa-850677bf2e90",
      text: "B2 - 2B2 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1200"
    },
    {
      id: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      text: "(OFCI) B2 Cooling Towers",
      type: 5,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 3296,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.36,
      source_task_id: "7994945"
    },
    {
      id: "a5794235-9496-4110-bc2a-2645b05e22c1",
      text: "B1 - DH-A - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1000"
    },
    {
      id: "92c2b146-eba7-411a-bbaa-1f913c1b2dc8",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In BMS",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1550"
    },
    {
      id: "c9609c4d-19d8-4300-ae1e-02cc7bb08b16",
      text: "B1 - 1C1W - 01C.07 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 144,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1890"
    },
    {
      id: "7df0e8c4-7604-4772-9141-2617f08a1fb4",
      text: "Fab and Deliver - Substation HPT - Area SS-1 (2) - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 2208,
      parent: "4016a0a2-9bce-4112-a177-64ed092fdb94",
      progress: 0.34,
      source_task_id: "B1.OFCI.1930"
    },
    {
      id: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6",
      text: "[DCB1] DEC-C Ready: Overhead cable tray complete [Area C]",
      type: 0,
      start_date: "2026-02-20T08:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3845"
    },
    {
      id: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      text: "Area 2 - Telecom Install - DCI 3069",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2024-12-12T08:00:00",
      duration: 40,
      parent: "40259346-07ff-4beb-b825-abbaebacbeec",
      progress: 0,
      source_task_id: "C.CSU.A2.8060"
    },
    {
      id: "6b0eab76-2efa-4856-94fd-8f9875c33373",
      text: "B1 - DH-B - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution) MV Side",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 160,
      parent: "6d080f13-3987-4a3c-b673-e8743952148f",
      progress: 0,
      source_task_id: "B1.C.B.3140"
    },
    {
      id: "29507403-1346-424f-881f-30f2eefcfb73",
      text: "Start Fill & Flush of Chilled Water System - Phase1",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-09T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1212"
    },
    {
      id: "9d425924-b566-40c4-9c9c-4f22b673c9ce",
      text: "Campus - Submittal Rvw/App'l - Landscaping / Irrigation",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 120,
      parent: "50f5196d-2758-41f7-896e-2e6190d0ed68",
      progress: 0,
      source_task_id: "B1.CFCI.5280"
    },
    {
      id: "31336d61-1270-4455-8fb0-c95cc6c3238a",
      text: "Doors / Frames / Hardware",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-06-28T08:00:00",
      duration: 520,
      parent: "891e0fdd-6ec7-494a-96b3-d52fa1874653",
      progress: 0.83,
      source_task_id: "PRE1550"
    },
    {
      id: "5e34ad05-c342-4bd4-aff5-851dbe89c7f9",
      text: "FCA Gallery DH-D",
      type: 5,
      start_date: "2025-12-22T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 808,
      parent: "b1c751be-46df-40c6-9525-a10c4e362601",
      progress: 0,
      source_task_id: "7995314"
    },
    {
      id: "afd03ae4-558e-496d-a3a8-0c7b4e1e9e37",
      text: "Deep Telecom",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 304,
      parent: "41120383-8f38-4628-8077-188a15a1d1dd",
      progress: 0,
      source_task_id: "8444264"
    },
    {
      id: "53a0ef0d-3f93-41fb-9d6c-bcf8ea0907f2",
      text: "BLDG-1 Network",
      type: 5,
      start_date: "2025-05-02T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 160,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995392"
    },
    {
      id: "6da0772f-bc9d-4678-a56b-1ee395993af4",
      text: "L4 Finish DH B - DCB2",
      type: 0,
      start_date: "2027-01-04T08:00:00",
      end_date: "2027-01-04T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2083"
    },
    {
      id: "daf6c419-f65a-4559-8fd1-b239240801bd",
      text: "B1 - SSB - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-05-05T00:00:00",
      end_date: "2025-05-15T08:00:00",
      duration: 80,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1010"
    },
    {
      id: "c2a2b756-e3e1-4cdd-81fd-d1606bba7c95",
      text: "B2 - mCUP-7 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 48,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7060"
    },
    {
      id: "170d680a-3fe7-4c7b-84af-c46523784642",
      text: "Corridor 1N1W (UPS Room/Control Panel Room/Restroom)",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 936,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995333"
    },
    {
      id: "42d29dcf-7b03-45af-9da0-b05b3304154a",
      text: "B2 - Specialties - Flag Pole",
      type: 0,
      start_date: "2026-08-12T00:00:00",
      end_date: "2026-08-25T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1080"
    },
    {
      id: "ac66801f-b705-448b-8b15-b3b22af3edc9",
      text: "B1 - 1A2E - Corridor - Room Fit Out Activities - Set/Hook Up Equipment",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2470"
    },
    {
      id: "39973f16-682e-428c-8ae1-2fc29da0b7e7",
      text: "Substation 2 -  Fabricate / Deliver - H-Frame MOAB",
      type: 0,
      start_date: "2024-12-04T00:00:00",
      end_date: "2025-04-01T08:00:00",
      duration: 648,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5820"
    },
    {
      id: "518a90e8-ed2b-4f72-a141-a3c13a9a3642",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2490"
    },
    {
      id: "fd12e491-8635-4a1a-8d1b-a327e36d6c10",
      text: "HMD - Baseline/Site Specific Submittals Approved-Revit Model Provided Approved - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-21T08:00:00",
      duration: 40,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 1,
      source_task_id: "B1.OFCI.1120"
    },
    {
      id: "8ed1a712-75d7-4b2d-8ca6-1c60cafd45f4",
      text: "Substation-1 - MSG A - Install IDF Rack (SUBIDF1) for MSG A",
      type: 0,
      start_date: "2025-04-26T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 40,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4060"
    },
    {
      id: "d16ce363-0361-4faa-92e8-5bb92bbee8e3",
      text: "Finalize GC/GRs for BL 2",
      type: 0,
      start_date: "2024-03-08T00:00:00",
      end_date: "2024-03-08T00:00:00",
      duration: 0,
      parent: "5f97e78e-4198-45c7-9f9f-34e2a66e7e12",
      progress: 1,
      source_task_id: "ICM.PRE.1510"
    },
    {
      id: "e64353a9-6760-4f62-b561-80f07c1c457e",
      text: "B1 - DH-D - Install Grounding Loop - Data Hall D",
      type: 0,
      start_date: "2026-02-21T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1410"
    },
    {
      id: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      text: "B2 - DH-C - Cure for SOG",
      type: 0,
      start_date: "2025-12-21T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 24,
      parent: "c989b9ac-c3fc-4efc-90ac-cc3e537fc7e1",
      progress: 0,
      source_task_id: "B2.C.STR.2220"
    },
    {
      id: "9f045ffe-87d3-4bb4-b99d-0eab0e0a129a",
      text: "BLDG-1 DH-D Level 2 Checkout",
      type: 5,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 376,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "7995266"
    },
    {
      id: "960a3230-3d18-4a8d-9b60-7f435cfb3995",
      text: "GUARD HOUSE",
      type: 5,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 1240,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995247"
    },
    {
      id: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      text: "Equipment Yard",
      type: 5,
      start_date: "2025-05-30T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 1424,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995250"
    },
    {
      id: "f307079e-8b8b-4529-8188-b7c9d47386b0",
      text: "Adverse Weather Event 19 - 11.14.2024",
      type: 0,
      start_date: "2024-11-14T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1019"
    },
    {
      id: "56df9d12-a20d-40b8-9f2e-462f4fab565a",
      text: "B2 - 2E1E - 02.01.E1.01 - Install Lighting Rough In",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5320"
    },
    {
      id: "5029b4a2-cd99-4b01-a2f3-bf847879ed24",
      text: "B2 - 2B1 - Corridor - Room Fit Out Activities - OH Rough In",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 160,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1950"
    },
    {
      id: "a5322cc4-5d2c-445e-95eb-a2ec0ee92b63",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1550"
    },
    {
      id: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7",
      text: "B1 - OSP Cabling - CAV-3 to EF1, EF2, EF3, EF4",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 400,
      parent: "69118f10-3a96-4c06-bff2-077ce9c60175",
      progress: 0,
      source_task_id: "B1.CONN.1020"
    },
    {
      id: "bff24eab-c927-418e-bf14-170c666ca558",
      text: "Substation-1 - MSG B - Pre-energization MSG A and DC System",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 208,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6310"
    },
    {
      id: "e073eccc-3f5f-4f21-a744-78c3b4a2a9e4",
      text: "B2 - DH-C - Grout Column Baseplates",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 48,
      parent: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      progress: 0,
      source_task_id: "B2.C.STR.1910"
    },
    {
      id: "7ff8dfca-7821-49f8-b06e-76059e0f610b",
      text: "BLDG-1 DH-A  Electrical Pulls",
      type: 5,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 336,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "7995268"
    },
    {
      id: "0c918be6-c278-46c0-ba98-f2ba1737f428",
      text: "Area 1 - UG RI -UPS system-DCB1",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1170"
    },
    {
      id: "c6ed857f-a909-4e2f-bec3-47bc88bdb882",
      text: "Fab and Deliver - Fan Coil Assembly - Area D - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 3104,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.37,
      source_task_id: "B1.OFCI.3350"
    },
    {
      id: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      text: "Substructure",
      type: 0,
      start_date: "2024-12-26T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 1232,
      parent: null,
      progress: 0,
      source_task_id: "8243669"
    },
    {
      id: "fc7dfce5-42d9-4890-bf56-262110277b21",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Pre-Fab Guardhouse",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: "2025-01-02T08:00:00",
      duration: 120,
      parent: "54ea1ba9-ddf2-452c-881b-cedd12f21266",
      progress: 0,
      source_task_id: "B1.CFCI.5840"
    },
    {
      id: "844d619f-03b4-44dc-b4f9-172eb2f534f6",
      text: "B1 - DH-C - El Equip Yd - Set Equipment (10)MVS, (20)PTX",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "B1.C.C.3020"
    },
    {
      id: "5596366c-b3a7-49ce-a349-65eaf0150524",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1360"
    },
    {
      id: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4",
      text: "Substation-1 - Pad Prep",
      type: 0,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-09-20T00:00:00",
      duration: 80,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.1010"
    },
    {
      id: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      text: "B1 - SSB - Foundations",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-01-29T08:00:00",
      duration: 80,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1000"
    },
    {
      id: "3f911c1e-9fc2-4c0e-82af-a72d6f0c82ab",
      text: "B1 - DH-B - L2 CDU Pre-Eng Inspection - Data Hall B - DCI 3134",
      type: 0,
      start_date: "2025-12-31T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 144,
      parent: "3d507b23-1be2-4905-a76c-b9aeff9a12e5",
      progress: 0,
      source_task_id: "B1.C.B.3250"
    },
    {
      id: "f8eb7462-7197-46ab-adbe-b3b4e8d7c9c2",
      text: "Substation-1 - TX B - Install Medium  And High Voltage Cable",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 96,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6330"
    },
    {
      id: "1f0a0bc9-0d28-4733-9311-09d01d4a19b1",
      text: "B2 - West Entrance - install SOD",
      type: 0,
      start_date: "2026-09-02T00:00:00",
      end_date: "2026-09-16T08:00:00",
      duration: 80,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1140"
    },
    {
      id: "51012d70-b7e2-4e92-81d8-1d0b5562fdda",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-10-29T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 632,
      parent: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      progress: 0,
      source_task_id: "7995115"
    },
    {
      id: "2390c294-1245-4d73-85bc-b779088085b9",
      text: "(CFCI) Div. 32 - Fencing",
      type: 5,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 608,
      parent: "5897d1e2-fe31-4d56-b344-c64086e9b0ca",
      progress: 0,
      source_task_id: "7994913"
    },
    {
      id: "dcac32fd-f134-4e86-b43f-bafd5526cedf",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH C",
      type: 5,
      start_date: "2025-12-12T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 536,
      parent: "0346efe3-b63f-4628-9749-3c3592992deb",
      progress: 0,
      source_task_id: "8106480"
    },
    {
      id: "a9b7a1af-02e1-4e89-9c04-d6c45066b5e8",
      text: "B2 - 2D1 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-04-02T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 80,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1550"
    },
    {
      id: "e7143409-9746-43ab-abe3-3a9fb88b3f47",
      text: "Data Hall C",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 1440,
      parent: "dc0db725-f1c1-4687-8a98-61e9f8a18049",
      progress: 0,
      source_task_id: "7995281"
    },
    {
      id: "419d248e-e8a0-4e09-9d26-8851b166490b",
      text: "B1 - Specialties - Flag Pole",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 40,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1040"
    },
    {
      id: "139facf2-362a-4710-971b-85a5725804a7",
      text: "B2 - DH-A - Install Ceiling Devices - Lighting - Data Hall A",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2570"
    },
    {
      id: "d2bd53c0-cfe3-4110-8e81-f5665f925980",
      text: "DCI 3134 - Added CDUs (16 to 32) - DH B",
      type: 5,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 512,
      parent: "c30ba2be-57ad-4e60-9cab-4d71b157148a",
      progress: 0,
      source_task_id: "8106483"
    },
    {
      id: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      text: "Building 2 mCUP-6",
      type: 5,
      start_date: "2025-11-04T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 456,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995144"
    },
    {
      id: "807cd144-2a32-4e5b-b0b2-cf022821a4f8",
      text: "UG RI -Panel Boards (PB)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 120,
      parent: "61eca0ba-60c7-4050-b050-569ff6de0dca",
      progress: 0,
      source_task_id: "MECO-1640.30"
    },
    {
      id: "25ddedc6-7844-4679-b81a-75bf926477df",
      text: "Corridor 1D2E GS IDF Rm (2)/Restroom/Spr Riser/Control Panel",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 1016,
      parent: "1d9e827f-f2c2-4707-950b-61d5bd31f6bc",
      progress: 0,
      source_task_id: "7995319"
    },
    {
      id: "2ad9aa9a-2894-4453-b919-9aff0f442d6f",
      text: "B1 - DH-D - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 40,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1030"
    },
    {
      id: "fac76ff8-62ed-4afe-a533-083fa8afa7b8",
      text: "Area 3 - UG RI -Substation Feeds-Campus",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1430"
    },
    {
      id: "70c248b3-7c26-480e-8a9c-fe4c54aeac5c",
      text: "Start DCB2 MTR Installation - Phase 3",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1655"
    },
    {
      id: "2e9c83d2-1a23-48ee-95ac-651f569992ca",
      text: "Fab and Deliver - MVS-6WAY - Area NW-1/4 (4) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-03-10T08:00:00",
      duration: 2128,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.04,
      source_task_id: "B1.OFCI.2170"
    },
    {
      id: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      text: "DHEC",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-04-16T08:00:00",
      duration: 968,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "7994744"
    },
    {
      id: "59d957cd-c9b3-47f5-9c8f-a704a603e32c",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1680"
    },
    {
      id: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      text: "B2 - DH-C - Install Vapor Barrier",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 40,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1160"
    },
    {
      id: "414841dc-7c73-4921-aa99-ce721fc76f94",
      text: "B1 - mCUP-4 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4090"
    },
    {
      id: "ac49455c-7179-4c7d-95ba-045d3be2c497",
      text: "B2 - ISP Cabling - EF to IDFC (UG)",
      type: 0,
      start_date: "2026-08-10T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 120,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1180"
    },
    {
      id: "b24c2f80-a3c7-4af5-b0f5-006fc4c42cf8",
      text: "B1 - 1N1E - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 80,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1970"
    },
    {
      id: "2bd3c2d0-d6c0-40c1-a7ce-fbb3b3a7c75f",
      text: "Submit County DHEC Approval Letter to State - DHEC",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-04-09T08:00:00",
      duration: 16,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "PRE-DD-1160"
    },
    {
      id: "eded72c6-97b9-4111-961e-23e2e5a9d02f",
      text: "B1 - Network Room 2/3 - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1100"
    },
    {
      id: "3b958be2-8fae-4c83-a7f3-621ec4b5cfcf",
      text: "B1 - 1D1W - 01D.08 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2320"
    },
    {
      id: "3ce3502c-ccdd-4010-83e8-d248a4631e44",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 8,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1620"
    },
    {
      id: "4bf9a9ea-19b1-4e3f-a5e2-6fa22e066902",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2490"
    },
    {
      id: "752a06ac-1047-4ff9-8aad-d9d55f7adfc8",
      text: "Prime and First Coat Paint - Restrooms",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1140"
    },
    {
      id: "81123ef1-f56a-48b6-b091-fc65ba386b38",
      text: "B1 - Network Room 1/4 - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 24,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1320"
    },
    {
      id: "88ed6019-6a5e-4cce-9a63-1f4a15a6ea23",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 40,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.1350"
    },
    {
      id: "7cb59f9d-8f86-496c-b1fd-66c61618c5ba",
      text: "Steel - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-04-30T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 112,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1170"
    },
    {
      id: "1076d022-f279-458e-8e6f-47edee4227c2",
      text: "Fragnet 28 - PCO # 26 CCD-012 Decple Final Utilit Loss L4 & L5 Cx.",
      type: 0,
      start_date: "2024-08-25T00:00:00",
      end_date: null,
      duration: 472,
      parent: "ca305c79-746d-4cb9-8af7-bfada980efde",
      progress: 0.4,
      source_task_id: "8717476"
    },
    {
      id: "66f20d17-585b-4af9-aedb-e01009b9a088",
      text: "B1 - Network Room 1/4 - Power Alley - Hang/Finish Inside Electrical Room",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 96,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1180"
    },
    {
      id: "3db3cf40-c0d6-4e97-827d-e7dc5bf46075",
      text: "Substation-2 - MSG A - MV  Torques (Finish 03/01/25)",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 72,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6420"
    },
    {
      id: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      text: "Start Site BIM / Initiate Heat Calcs",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-03-18T00:00:00",
      duration: 0,
      parent: "1727f221-62ff-460d-93ab-9c07242dc0b2",
      progress: 1,
      source_task_id: "ICM.PRE.1200"
    },
    {
      id: "d60e5d74-84ee-43dc-8ae9-114b9e9d043b",
      text: "B2 - DH-B - Install IMP Ceiling - Data Hall B",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2180"
    },
    {
      id: "73d74f88-0190-42dc-ab09-f92e5dd28894",
      text: "B2 - 2C2 - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1290"
    },
    {
      id: "4521e9ff-16bc-4e4b-babf-85154075a147",
      text: "B2 - DH-A - Hookup CDU's - Data Hall A",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 144,
      parent: "560c76d0-46ee-4116-9c68-58099187fdb2",
      progress: 0,
      source_task_id: "B2.C.A.3190"
    },
    {
      id: "04d62129-263a-4ab0-9fc1-c2c428956bdb",
      text: "B1 - mCUP-7 - L2 Inspections",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7130"
    },
    {
      id: "1046e761-6a4c-449b-9f2a-5e388d17c672",
      text: "Area 4a - UG RI -Network Infrastructure Vaults-Campus",
      type: 0,
      start_date: "2024-12-03T00:00:00",
      end_date: "2025-01-04T08:00:00",
      duration: 200,
      parent: "28b5955e-c0e8-484e-a729-b4248ca2a974",
      progress: 0,
      source_task_id: "MECO-1800"
    },
    {
      id: "334cbf16-efb3-4308-90ac-8d37399c784b",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1170"
    },
    {
      id: "2b124624-e63c-4a6a-8f49-8a3a5f2eb35d",
      text: "B2 - Install Final Paving",
      type: 0,
      start_date: "2026-08-14T00:00:00",
      end_date: "2026-08-27T08:00:00",
      duration: 80,
      parent: "603fe6ee-c2aa-461c-b67e-f472f4ab50f5",
      progress: 0,
      source_task_id: "C.SI.RW.1150"
    },
    {
      id: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c",
      text: "B1 - 1N1E - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 24,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5650"
    },
    {
      id: "695ee57c-988e-4f3c-98ce-cffafd905cad",
      text: "B2 - mCUP-4 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-11-22T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 24,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4080"
    },
    {
      id: "f614e5dc-bf45-4ce0-8d65-918cf4f7efbb",
      text: "B1 - 1N2E - 01N3.06 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.5890"
    },
    {
      id: "19fdb366-9d8b-4b64-8bbb-eca8ba62f361",
      text: "B1 - DH-B - El Equip Yd - Pulls Cable to PTX (480V)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 80,
      parent: "475fbabe-89c3-43ba-986e-c5e612752c64",
      progress: 0,
      source_task_id: "B1.C.B.3150"
    },
    {
      id: "0062596b-8279-44a2-b159-821545ec9d11",
      text: "B2 - DH-B - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 1104,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1030"
    },
    {
      id: "def39e4e-f750-4fdc-bd38-039a1def91e6",
      text: "B1 - Network Room 1/4  - OH Rough In Security",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1160"
    },
    {
      id: "ed8267b4-1dbe-4aa9-b686-8d350b37184e",
      text: "Area 4 - Install water meters",
      type: 0,
      start_date: "2025-04-11T00:00:00",
      end_date: null,
      duration: 48,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A4.8120"
    },
    {
      id: "8f318940-dbf9-442e-8428-ff962a67e014",
      text: "Building 1",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2025-12-22T00:00:00",
      duration: 3368,
      parent: "4d7f99a1-a653-43bf-b87f-5b8e20378bdb",
      progress: 0.38,
      source_task_id: "7995428"
    },
    {
      id: "dd7f8cac-5b60-4a7f-9e8d-d68bc32d4e87",
      text: "B2 - 2B1 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 80,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2200"
    },
    {
      id: "5c52bd43-335d-443d-8a4e-f9a8b9da33c7",
      text: "B2 - SSB - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 40,
      parent: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      progress: 0,
      source_task_id: "B2.C.STR.2000"
    },
    {
      id: "b3045a71-cc67-46fe-8b41-5077137d1d69",
      text: "Auxillary Buildings Constuction Complete",
      type: 0,
      start_date: "2026-05-06T08:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1040"
    },
    {
      id: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      text: "Area A",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 680,
      parent: null,
      progress: 0,
      source_task_id: "8258375"
    },
    {
      id: "a227880f-59ea-42d0-9b8d-f43ef4b21fb7",
      text: "B2 - mCUP-7 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7120"
    },
    {
      id: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 160,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.1880"
    },
    {
      id: "e5f99c74-a50e-4048-985f-b4cff8bf79f7",
      text: "Tier 1 - B2-2-D - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994778"
    },
    {
      id: "fe426be2-0e9f-4710-8fb3-13f55f18c43f",
      text: "(CFCI) Div. 11 - Equipment",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-03-06T08:00:00",
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994905"
    },
    {
      id: "621592be-cc33-40c4-89df-9cd0aa53b294",
      text: "Site Improvements",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 672,
      parent: null,
      progress: 0,
      source_task_id: "8243668"
    },
    {
      id: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      text: "Corridor 2E2E",
      type: 5,
      start_date: "2025-12-15T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 816,
      parent: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      progress: 0,
      source_task_id: "7995052"
    },
    {
      id: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      text: "Precon",
      type: 5,
      start_date: "2023-08-28T00:00:00",
      end_date: "2024-11-26T08:00:00",
      duration: 2536,
      parent: "fde6fa74-71e9-4a70-857e-ca30387e7d0d",
      progress: 0.6,
      source_task_id: "7994719"
    },
    {
      id: "2de259e3-e324-4b76-9388-0b6628f10f62",
      text: "UPS Room 02D.08",
      type: 5,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-07-08T08:00:00",
      duration: 440,
      parent: "dfc16b55-f1f0-4fea-b940-c09ea7840d80",
      progress: 0,
      source_task_id: "7995059"
    },
    {
      id: "b5c5f4e6-7ed6-4631-a437-dda89bf7a383",
      text: "Delivery of m-CUP Skids (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-03-17T08:00:00",
      end_date: "2025-03-17T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1875"
    },
    {
      id: "3c733d7a-dc8b-414c-8d68-e65562d5bebc",
      text: "Equipment Yard - IBOS (LOE)",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 320,
      parent: "600d8f12-919f-42df-bb18-0526450a02aa",
      progress: 0,
      source_task_id: "IBOS.CON.1080"
    },
    {
      id: "e05a1537-3e7b-47aa-9a22-cc9f8bcc8329",
      text: "Area A - Final Clean / Demob",
      type: 0,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1331"
    },
    {
      id: "4799154d-3ba9-4bfd-a5a9-d8909449ccb7",
      text: "Domestic Water",
      type: 5,
      start_date: "2024-10-07T00:00:00",
      end_date: "2024-11-21T08:00:00",
      duration: 40,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995168"
    },
    {
      id: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      text: "B1 - DH-B - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-07T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1040"
    },
    {
      id: "a9b0b7b3-691c-4bf3-b255-5085ef8b94aa",
      text: "Multi-Trade/Pipe Racks",
      type: 5,
      start_date: "2025-11-21T08:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 728,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994827"
    },
    {
      id: "83316e03-c554-4a9a-a25d-b00017f31279",
      text: "B1 - mCUP-7-9 - Temp Power Hookup (Mobile Gen, 5 MW Temp Power to Equipment) for C/D",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 40,
      parent: "0030099f-bbea-4b45-9ffb-9bcfe33c7559",
      progress: 0,
      source_task_id: "B1.mCUP.9210"
    },
    {
      id: "0fd5f596-cff5-41cb-8455-a352db88370a",
      text: "Precast Area B",
      type: 5,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "7995022"
    },
    {
      id: "7e449c27-d141-490d-8c59-9ffeb2a1b855",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2390"
    },
    {
      id: "b984189e-966b-4dde-bb44-3dc7ce7c198b",
      text: "B2 - mCUP-8 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 80,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8230"
    },
    {
      id: "be41b8d4-c507-48e7-9772-7bcb4cbffe70",
      text: "FR 01 - Sanitary Sewer Redesign - Site / UG BIM Coordination / Sign Off - Area 4 & 5",
      type: 0,
      start_date: "2024-05-20T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 40,
      parent: "8d123bf9-49ce-4abe-9406-a0ca497a3831",
      progress: 1,
      source_task_id: "FR.01.1080"
    },
    {
      id: "5107ffe2-9507-400d-a111-5a80b49ae5a8",
      text: "Substation 1 - Prep / Submit for Rvw - H-Frame MOAB",
      type: 0,
      start_date: "2024-10-18T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 160,
      parent: "65ff3918-66a0-45c9-ab32-4c9cf0bf3a67",
      progress: 0,
      source_task_id: "B1.CFCI.5770"
    },
    {
      id: "02f823b3-e125-441c-a1f9-f8a631647efc",
      text: "Corridor 1D2E",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 1016,
      parent: "25ddedc6-7844-4679-b81a-75bf926477df",
      progress: 0,
      source_task_id: "7995320"
    },
    {
      id: "6e0c1a11-fcd9-4d4a-980c-53f4f353c662",
      text: "(CFCI) Div. 05 - Misc. Steel (Grating / Handrails)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0,
      source_task_id: "7994932"
    },
    {
      id: "49c2db29-f8b7-4697-9ee9-50894cfe766d",
      text: "Interior fit-out Start DCB1 - Phase 2",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-11T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1290"
    },
    {
      id: "bdca0691-b87f-41d9-bf0a-c2873d26438e",
      text: "Tier 2, 3, 4 - B1-1-N",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994788"
    },
    {
      id: "5d0e7750-f0eb-405c-9b6a-3f3ae0f65b47",
      text: "B2 - DH-D  - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1070"
    },
    {
      id: "a8200659-a901-4147-b422-d34fb3df3a14",
      text: "B1 - 1C2E - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 160,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.2310"
    },
    {
      id: "9f80106d-1a79-43bd-b73d-788391d3c4f7",
      text: "Fire Pump Room",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "8243674"
    },
    {
      id: "1450b882-7a9c-49ed-94b5-2e53182107c6",
      text: "B1 - Network Room 2/3 - FCA Gallery - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.2040"
    },
    {
      id: "c1cd519c-0717-437a-b53a-57050cfab4df",
      text: "B1 - SSB - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-04T08:00:00",
      duration: 40,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1070"
    },
    {
      id: "74243b29-1644-445c-90c0-2ae0722c2640",
      text: "B2 - SSB - Install Insulation",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 40,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1100"
    },
    {
      id: "df430232-7133-410a-b684-e5db7772d8ac",
      text: "Fab and Deliver - 500KW Generator - Area AN - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "eb3ea98a-2cf4-45ea-aad1-d7789c9747d1",
      progress: 0.29,
      source_task_id: "B1.OFCI.2250"
    },
    {
      id: "c9b08464-6aee-4765-b328-6cb191062769",
      text: "Tier 2, 3, 4 - B1 - Overhead/In-Wall",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994787"
    },
    {
      id: "d7fdba8e-9ef8-4acb-b234-9be9e2f28f4a",
      text: "Area 1 - Storm Install ( Branch)",
      type: 0,
      start_date: "2024-10-10T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A1.8040"
    },
    {
      id: "0d77f9cf-1119-431b-840c-f4ed8725aaa7",
      text: "B2 - 2E2E - EF2 - Terms for Lighting/Outlet/Racks (EF2)",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-10T08:00:00",
      duration: 24,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6320"
    },
    {
      id: "78e523a2-47f5-41ab-a7b6-e146dba91b0d",
      text: "Area A - Trim Out - All Devices",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 40,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1231"
    },
    {
      id: "95ab1f1c-0ae5-44af-adb9-8225b7058cef",
      text: "B1 - 1N2E - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5250"
    },
    {
      id: "d8f54db8-db77-4c07-b00d-65ff8fb8f1a5",
      text: "FR 31 - META review and Approve PCO#30",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 80,
      parent: "955aa671-6b4b-4034-bf88-d03902dbaf4e",
      progress: 0,
      source_task_id: "FR.31.1030"
    },
    {
      id: "2ed99712-5bfd-474f-8a23-ffbecb59328c",
      text: "B2 - DH-D - Install Lighting/Branch Conduit -Data Hall D",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-07-23T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2420"
    },
    {
      id: "d1fcfedd-54b1-435f-a501-f62f385650b5",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2480"
    },
    {
      id: "00aaa7c4-794a-4e82-a873-65136740c443",
      text: "B2 - DH-D - Lightning Protection",
      type: 0,
      start_date: "2026-03-09T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B2.C.RF.1440"
    },
    {
      id: "0e59e38a-19ab-4f52-af91-91ccd88a3cc4",
      text: "Fab and Deliver - 3.0MW Generator - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 2440,
      parent: "eb3ea98a-2cf4-45ea-aad1-d7789c9747d1",
      progress: 0.29,
      source_task_id: "B1.OFCI.2240"
    },
    {
      id: "1c999f46-1e6c-4bf4-b009-23cddd1a13f6",
      text: "Permanent Utility Power (Grid Power) Available - Substation 2",
      type: 0,
      start_date: "2026-01-08T08:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "TPM.B2.2015"
    },
    {
      id: "fc5c9373-6029-4721-92a4-d6fb97961175",
      text: "BLDG-1/2 -  Fabricate / Deliver - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-11T00:00:00",
      duration: 160,
      parent: "f516d625-fc35-4562-b467-ea8f751e08e8",
      progress: 0,
      source_task_id: "B1.CFCI.5480"
    },
    {
      id: "187da2f9-2d65-4b95-9f0c-74b9fdbfc170",
      text: "B1 - RF-Tower-1 - Equipment Hookup's - Seq. 1",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 160,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2190"
    },
    {
      id: "f6044b69-2e06-4d52-911a-41bb2e4b683b",
      text: "B2 - DH-D - Install Underground Telecom",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 80,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1520"
    },
    {
      id: "a5697831-1f0f-4681-b9fd-200481e23a16",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-N - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-10-22T08:00:00",
      duration: 240,
      parent: "025f7736-8841-42ad-887c-bb57088ea671",
      progress: 0,
      source_task_id: "B1.VDC.1530"
    },
    {
      id: "f6089950-d5ed-48a5-a295-699129837b6c",
      text: "FCA - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2024-01-17T00:00:00",
      duration: 0,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 1,
      source_task_id: "B1.OFCI.1610"
    },
    {
      id: "e0c7e5cb-1620-46db-83f5-45870ee0c38d",
      text: "DFSMA - DC1 EY-D Skids ROJ - MOFE",
      type: 0,
      start_date: "2025-10-02T08:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 0,
      parent: "993a33a9-ba19-4c70-87e9-c3247582ff68",
      progress: 0,
      source_task_id: "B1.DFSMA.1010"
    },
    {
      id: "550f3cdc-e2f8-46fb-a9c2-41cdd1e0e939",
      text: "B2 - 2D1W - 02D.09 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-06-03T00:00:00",
      end_date: "2026-06-09T08:00:00",
      duration: 40,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.2170"
    },
    {
      id: "3f17bfa7-37ba-4dc3-aa24-a7910ffb1bf1",
      text: "B2 - DH-D - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2026-04-28T08:00:00",
      end_date: "2026-04-28T08:00:00",
      duration: 0,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1800"
    },
    {
      id: "99e60647-ebc4-4f10-a959-28095d9a25a7",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-04-03T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1300"
    },
    {
      id: "39855758-26c2-45c7-8a00-84dc36793e26",
      text: "IBOS",
      type: 5,
      start_date: "2024-12-13T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 2256,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995246"
    },
    {
      id: "0b0a8df9-746a-4831-914b-36c5e976f13c",
      text: "B2 - DH-C - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall C",
      type: 0,
      start_date: "2026-08-05T00:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2670"
    },
    {
      id: "863ec9b0-5c25-44ff-bbac-443b9756159e",
      text: "Area 5 - UG RI - Late Site Lighting-Campus",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 120,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1860.10"
    },
    {
      id: "6390b5d5-9a22-42db-85db-444fbf74a661",
      text: "ADMIN",
      type: 5,
      start_date: "2024-12-26T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 2328,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995245"
    },
    {
      id: "1dea4851-b02a-419c-ae58-ee0461e2cc77",
      text: "Delivery of MDF - GS.MDF Module (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-06-25T08:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1865"
    },
    {
      id: "09600123-3f39-4b83-a26c-faa59281f5b4",
      text: "OH Fire Protection Rough-In",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1160"
    },
    {
      id: "9c3b2836-225a-4e71-ad6d-304f86a5ab4a",
      text: "B2 - DH-D - WAP Provisioning",
      type: 0,
      start_date: "2026-10-23T00:00:00",
      end_date: "2026-11-19T08:00:00",
      duration: 160,
      parent: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      progress: 0,
      source_task_id: "B2.CONN.1280"
    },
    {
      id: "e75d2218-3531-449f-8bca-6447a6303425",
      text: "Fab and Deliver - MVS-4WAY - Area B (9) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 2648,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.45,
      source_task_id: "B2.OFCI.2010"
    },
    {
      id: "7a7e68ff-9098-4858-b959-70c8cad34beb",
      text: "DFSMA - DC1 - CUP 7- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-08-18T08:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1290"
    },
    {
      id: "8ed1802e-75ea-4963-8ba0-cf9c15f0419d",
      text: "B1 - DH-C - Power Alley - Equipment Hookup (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 160,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1770"
    },
    {
      id: "7b6d8dd9-daa7-43d0-9d77-c72eb917d112",
      text: "Factop Unit Online for Substation 2",
      type: 0,
      start_date: "2025-09-26T08:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2870"
    },
    {
      id: "a6db81bd-7c57-4e77-9f6c-7bb86bc07980",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2210"
    },
    {
      id: "44b8754d-eb21-48b0-8364-8e0ef42e38ab",
      text: "B1 - Network Room 2/3 - Power Alley - Install Light Fixtures/Exit Signs/GS Tray",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 96,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1830"
    },
    {
      id: "066375d5-aab5-42ce-b66a-30c6bf08e337",
      text: "B1 - DH-C - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 80,
      parent: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      progress: 0,
      source_task_id: "B1.C.C.3100"
    },
    {
      id: "6375921a-2180-480e-b9f5-dcad87dd87bf",
      text: "B1 - DH-C - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 80,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1420"
    },
    {
      id: "e743d157-d4bf-4e79-ba02-788774267bfc",
      text: "L3 Start EY1  - DCB1",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-18T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2250"
    },
    {
      id: "a25a8c05-003f-43f2-b2ca-a10cd02324dd",
      text: "B2 - West Entrance - Form / Pour Side walks",
      type: 0,
      start_date: "2026-06-02T00:00:00",
      end_date: "2026-06-29T08:00:00",
      duration: 160,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1100"
    },
    {
      id: "57a30ae1-48d2-4fa9-a0b3-45a9285d5609",
      text: "B2 - DH-B - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 80,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.1450"
    },
    {
      id: "94e42a73-c094-42b9-bf96-cc2358fbeb81",
      text: "B1 - Network Room 2/3 - Power Alley - Set UPS's/STC's",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 40,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1730"
    },
    {
      id: "6c24a029-8a6f-4e33-bcdc-811590af8cff",
      text: "B1 - Network Room 2/3 - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-09-05T08:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 0,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1810"
    },
    {
      id: "e6aec84b-a721-4bdc-83cc-eb58ca8010e1",
      text: "Fab and Deliver - Fan Coil Assembly - Area D - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 3264,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 0.46,
      source_task_id: "B2.OFCI.2720"
    },
    {
      id: "b2388eb1-2513-4edc-986a-dda628936e34",
      text: "Cx Type F 1.2 Template Rev 1",
      type: 5,
      start_date: "2025-01-17T00:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 4720,
      parent: "45fd1ece-f1fe-430f-97d2-91da4c830bb8",
      progress: 0,
      source_task_id: "7994996"
    },
    {
      id: "86c28459-00b7-4c4a-bd27-3f85528e0fa5",
      text: "FRP Curb Leave Out at Electrical Skid",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1060"
    },
    {
      id: "5f97e78e-4198-45c7-9f9f-34e2a66e7e12",
      text: "Budget Deliverables",
      type: 5,
      start_date: "2024-03-08T00:00:00",
      end_date: "2024-03-08T00:00:00",
      duration: 0,
      parent: "56080308-2da4-4055-b9e7-474a80627d2c",
      progress: 0,
      source_task_id: "7994716"
    },
    {
      id: "3797272a-1177-4c26-a854-6f774510b8ef",
      text: "BLDG-1/2 - Submittal Rvw/App'l - HVAC Materials and Equipment",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-01-28T08:00:00",
      duration: 120,
      parent: "eaf2f66d-62ed-4333-9656-a42c1e2ecb58",
      progress: 0,
      source_task_id: "B1.CFCI.3590"
    },
    {
      id: "03bfed0e-f197-4cdf-878d-46664e57ea65",
      text: "L3 Finish EY1 - DCB2",
      type: 0,
      start_date: "2025-12-03T08:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2251"
    },
    {
      id: "7604e032-0a91-4e56-aef5-66c7d5b377ac",
      text: "Area 5 - Fire Water Install",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-11T08:00:00",
      duration: 72,
      parent: "f81b9767-093c-4d6e-a4a6-507ec2ac8d97",
      progress: 0,
      source_task_id: "C.CSU.A5.4000"
    },
    {
      id: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      text: "B2 - SSB - 2E2 - Common - Frame Walls (Top-out included)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 96,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1500"
    },
    {
      id: "9d39ff96-e7cf-4a00-bb33-71eb46010f0c",
      text: "B1 - DH-D - Install Underground Controls",
      type: 0,
      start_date: "2025-04-15T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 80,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1730"
    },
    {
      id: "352249f5-fd75-4f7c-afa1-7a3f7e0c0cbf",
      text: "Substation-2 A Lineup Work",
      type: 5,
      start_date: "2025-04-18T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 2440,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "7995215"
    },
    {
      id: "304302ca-1b65-44d6-b642-0ee01206a910",
      text: "B1 - DH-C - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1120"
    },
    {
      id: "96ef314c-095a-46b0-9995-2e6cc32320f5",
      text: "Baseline 1 Development",
      type: 0,
      start_date: "2023-10-24T08:00:00",
      end_date: "2023-12-01T16:00:00",
      duration: 208,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2020"
    },
    {
      id: "81cb96a8-6ea8-406e-bb0c-0e9cf4c2eac2",
      text: "B2 - DH-A - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 24,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1680"
    },
    {
      id: "9d0d146a-3778-457c-b05e-28988fa2922d",
      text: "Placeholder - Successor",
      type: 0,
      start_date: "2023-11-14T00:00:00",
      end_date: "2023-11-14T00:00:00",
      duration: 0,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "SUCC"
    },
    {
      id: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f",
      text: "B1 - Network Room 2/3 - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1050"
    },
    {
      id: "bd992907-f5c4-4168-bbe9-ccb2db5a56ca",
      text: "Substation-1 - A Lineup - Install MSG Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-01-28T00:00:00",
      end_date: "2025-02-13T08:00:00",
      duration: 168,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3870"
    },
    {
      id: "43a7fcf4-0b26-4e24-a817-3f6a3fccc8d6",
      text: "B2 - 2A2 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 160,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2120"
    },
    {
      id: "061c3d7a-01a7-4e3a-b039-ff534b392178",
      text: "B2 - 2A1 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1200"
    },
    {
      id: "7ddc007c-99de-40b8-9d93-70a323f96302",
      text: "B2 - 2B2 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 24,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1130"
    },
    {
      id: "722fbeb9-fe8f-4e06-8333-c6655669e837",
      text: "B2 - 2B2 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2030"
    },
    {
      id: "0f78e4b4-76e4-4499-96b9-9b8f62208a47",
      text: "B2 - DH-D - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 80,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1190"
    },
    {
      id: "277320d1-edab-425c-8778-3ae78f667ca1",
      text: "Fragnet 13 - Building Permit",
      type: 0,
      start_date: "2024-09-06T00:00:00",
      end_date: null,
      duration: 128,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.81,
      source_task_id: "8539524"
    },
    {
      id: "8178d928-7a8a-4139-a44b-c580ede45952",
      text: "B2 - 2D2 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-05-04T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 24,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1710"
    },
    {
      id: "557162ae-f57f-46d5-b338-f37e8aea54e5",
      text: "IST Finish Network Core - DCB1",
      type: 0,
      start_date: "2026-05-07T08:00:00",
      end_date: "2026-05-07T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2161"
    },
    {
      id: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      text: "B1 - DH-D - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 40,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1590"
    },
    {
      id: "ac899d05-1cea-4c66-ac62-acae0311db54",
      text: "B1 - OSP Cabling - EF to GSIDF 1X1",
      type: 0,
      start_date: "2025-10-27T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 120,
      parent: "f9521e9a-0a5d-4806-969d-99217ffb5956",
      progress: 0,
      source_task_id: "B1.CONN.1110"
    },
    {
      id: "2c94f5ba-83f2-467a-a290-6024e28133eb",
      text: "B1 - SSB - Install Decking",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-10T08:00:00",
      duration: 40,
      parent: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      progress: 0,
      source_task_id: "B1.C.STR.1630"
    },
    {
      id: "00929af5-44cf-4d8e-8ab5-6e0c69870a54",
      text: "B1 - DH-C - Install Grounding Loop - Data Hall C",
      type: 0,
      start_date: "2026-01-28T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2650"
    },
    {
      id: "b916b544-f22a-4548-824e-57b2a8ccb9b4",
      text: "B1 - DH-B - BLDG-1 DH-B - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-09-25T08:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 0,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2190"
    },
    {
      id: "e5b8b86e-3fbf-4924-8029-6639ba1f52d1",
      text: "GSB - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2024-01-17T00:00:00",
      duration: 0,
      parent: "937a5c15-24b8-429b-aaf6-a66460890d40",
      progress: 1,
      source_task_id: "B1.OFCI.1010"
    },
    {
      id: "6ebad0a7-f96c-4980-ba51-78607a494e83",
      text: "B2 - 2C2 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-28T08:00:00",
      duration: 120,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2110"
    },
    {
      id: "3705cf28-7d96-4266-839c-9e97e07bf2d0",
      text: "Area B - Install Base",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 16,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1430"
    },
    {
      id: "f5dde7a0-97f9-4300-812c-a05c2e9ab261",
      text: "B1 - DH-B - Set CDU's - Data Hall B (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-08T08:00:00",
      duration: 64,
      parent: "3d507b23-1be2-4905-a76c-b9aeff9a12e5",
      progress: 0,
      source_task_id: "B1.C.B.3220"
    },
    {
      id: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      text: "Specialties",
      type: 5,
      start_date: "2025-10-10T00:00:00",
      end_date: "2026-08-25T08:00:00",
      duration: 1768,
      parent: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      progress: 0,
      source_task_id: "7995206"
    },
    {
      id: "1908f518-40d5-4356-96a5-fe7b60604aaf",
      text: "Substation-2 - B Lineup - Install Transformer Pad Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 128,
      parent: "8b805577-0811-4ad0-8814-78709fb07768",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4240"
    },
    {
      id: "ef397edc-462c-4006-acc9-d03515ffeae3",
      text: "L3 Finish DH D - DCB1",
      type: 0,
      start_date: "2026-08-05T08:00:00",
      end_date: "2026-08-05T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2033"
    },
    {
      id: "da20ac2d-283e-4a76-b8f0-fb083084a68c",
      text: "B1 - DH-C - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1590"
    },
    {
      id: "e63031a6-8107-4789-8e77-f22bd14756d2",
      text: "B1 - 1N1W - 01N1.07 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6500"
    },
    {
      id: "55eed6f0-7247-4461-8cfd-1f3fd9df3d4c",
      text: "B2 - DH-D  - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 48,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.2220"
    },
    {
      id: "7504975d-20e2-4237-83ff-6ccbebaf7eaa",
      text: "DFSMA - DC2 EY-B Skids ROJ - MOFE",
      type: 0,
      start_date: "2026-02-11T08:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 0,
      parent: "76b1ad37-499d-4ec3-8342-ec0ede70139c",
      progress: 0,
      source_task_id: "B2.DFSMA.1020"
    },
    {
      id: "38bb5abc-4a24-42e2-abfe-472449237910",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1390"
    },
    {
      id: "1e3995d9-25be-4a16-ac68-39d4044b8042",
      text: "B1 - DH-C - Power Alley - Paint 1st Coat",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 16,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1650"
    },
    {
      id: "a6da9106-294e-4829-8bfd-ced11942708e",
      text: "OH Fire Protection Rough-In",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1260"
    },
    {
      id: "f34ec909-44e0-43c6-b838-519286a54799",
      text: "B1 - OSP Cabling - CAV2/MMV to EF1, EF2, EF3, EF4 (Starts after Precast Network)",
      type: 0,
      start_date: "2025-06-05T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 280,
      parent: "85391fcf-fbdc-4cfe-b101-e86ca0d8bff2",
      progress: 0,
      source_task_id: "B1.CONN.1010"
    },
    {
      id: "94a589a4-3f06-48fb-ace8-894ccfe9e065",
      text: "IFC Package - Design Completion",
      type: 0,
      start_date: "2024-06-14T08:00:00",
      end_date: "2024-06-14T08:00:00",
      duration: 0,
      parent: "c884f3e1-0476-48f8-860b-e5f48adfe961",
      progress: 1,
      source_task_id: "Design.PreC.2460"
    },
    {
      id: "0cec6626-41db-4afb-883e-5bb2221ba79f",
      text: "B1 - DH-B - Install HAC Lights - Data Hall B",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2470"
    },
    {
      id: "de63d88b-d875-4799-affc-e40d06712eb0",
      text: "B2 - mCUP-1-8 - L2 Checkout of Pumps/Chillers and MSB Building 2",
      type: 0,
      start_date: "2026-02-10T00:00:00",
      end_date: "2026-02-21T08:00:00",
      duration: 80,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1320"
    },
    {
      id: "921f6ec7-e1b3-49d0-abd7-8ef1995db419",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Blocking/Fire FEC",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1570"
    },
    {
      id: "d22ec166-8389-4a47-b802-6340e6461c6b",
      text: "B2 - mCUP-6 - L2 Inspections",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 80,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6130"
    },
    {
      id: "0a5e5b9c-7544-42f3-9c25-33035a54a93e",
      text: "B2 - 2E2E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 40,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6120"
    },
    {
      id: "6ea7b8d2-4d66-40d9-bdb9-cae113bfef94",
      text: "B2 - 2E2E - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-02-24T00:00:00",
      end_date: "2026-03-23T08:00:00",
      duration: 160,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6390"
    },
    {
      id: "9c1b5dd9-f405-4ac4-b975-1e3b584533fb",
      text: "L3 Start Substation - DCB1",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-10-28T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2025"
    },
    {
      id: "115373ba-c948-4106-807f-766f2afd1633",
      text: "BLDG-2 DH-A - L2 Checkout for Building",
      type: 0,
      start_date: "2026-07-28T00:00:00",
      end_date: "2026-08-31T08:00:00",
      duration: 200,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1010"
    },
    {
      id: "98fa6290-6073-4f98-9e46-1aa91271fad3",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Strut",
      type: 0,
      start_date: "2025-03-14T00:00:00",
      end_date: "2025-04-03T08:00:00",
      duration: 120,
      parent: "2b6ac8b0-5614-4bfb-a6cf-fdb1f42c6160",
      progress: 0,
      source_task_id: "B1.CFCI.5210"
    },
    {
      id: "ff6b063e-140d-44b7-8199-0a0452134f17",
      text: "Fragnet 17 - PCO # 13 RFI-086 Elec Skid Coor CFCI to MOFE",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 624,
      parent: null,
      progress: 0.4,
      source_task_id: "8690179"
    },
    {
      id: "9be563d1-ed63-4665-abc2-c201e0459dff",
      text: "Substation-1 - TX B - Install Inspection And 3rd Party Controls Cable Verification",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 136,
      parent: "9c681767-7187-47cf-aac5-d8e72754cfae",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3760"
    },
    {
      id: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      text: "Approval of Building Permits",
      type: 0,
      start_date: "2024-11-22T08:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 0,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 0,
      source_task_id: "ICM.PRE.1590"
    },
    {
      id: "25ae1d52-5d50-4b4f-b961-139eaa0b4756",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1640"
    },
    {
      id: "ac8b443a-eb69-4f9d-a3d5-d9de834aa168",
      text: "Substation-2 - MSG B - Duration of Verification of Stable Power",
      type: 0,
      start_date: "2026-04-18T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 40,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.7000"
    },
    {
      id: "b8a5144b-9969-420f-9d75-238d9fa89e22",
      text: "B2 - DH-D - Foundations",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 120,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1240"
    },
    {
      id: "2a30feef-09ac-419f-b924-97c80bbf1474",
      text: "Eq Hookups Network and Data Halls A/B",
      type: 5,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 376,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995363"
    },
    {
      id: "9ff69100-bc9a-4cc4-b9bd-1092e5aec233",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [9] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 2944,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.36,
      source_task_id: "B1.OFCI.3710"
    },
    {
      id: "ea975beb-4b7f-4abd-9806-05c67f243e68",
      text: "B1 - DH-B - Install Insulation",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 40,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1350"
    },
    {
      id: "fcf05b59-8770-41a5-a617-2e38d2a481fa",
      text: "Area 2 - UG RI -MVS to MVS-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1280"
    },
    {
      id: "86b01ff3-2b17-4ccd-9114-93c883a3e941",
      text: "B1 - mCUP-3 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3060"
    },
    {
      id: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03",
      text: "B2 - 2B2 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 8,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1320"
    },
    {
      id: "d8755f57-1ef0-4f93-8ae4-e717b9f2d8c3",
      text: "B2 - 2D1W - 02D.08 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-07-01T00:00:00",
      end_date: "2026-07-08T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.2430"
    },
    {
      id: "20d293bf-3f90-4a0c-aa77-b62a3e884271",
      text: "B1 - Network Room 2/3 - FCA Gallery - Final Paint",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 16,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.2200"
    },
    {
      id: "e6e4fa59-ce01-40f5-9800-b28ea0f9911b",
      text: "B1 - DH-A - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-02-24T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 240,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1200"
    },
    {
      id: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb",
      text: "B1 - ISP Cabling - EF to SSB (GS tray)",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-18T08:00:00",
      duration: 80,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1240"
    },
    {
      id: "68402a73-d6c7-4711-a9c9-650e09911176",
      text: "FR 16 - META review and respond to RFI #88",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: null,
      duration: 96,
      parent: "ad81c4ff-51ed-406e-85d5-a07e20bb8eca",
      progress: 1,
      source_task_id: "FR.16.1010"
    },
    {
      id: "8300723c-7ec3-4ec1-a798-b6dade312f79",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 8,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1500"
    },
    {
      id: "8642d3c8-0933-4ac9-913c-84ef97748037",
      text: "Install Countertop",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-18T08:00:00",
      duration: 16,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1170"
    },
    {
      id: "354050cf-901f-4ed1-9211-6bfb8f0873bb",
      text: "B1 - DH-B - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2025-09-13T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 40,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1990"
    },
    {
      id: "b5dc3de5-a127-42cd-a0db-425a496fcea3",
      text: "B1 - West Entrance - Install Trees",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1010"
    },
    {
      id: "e3d654ff-aef9-4ac4-93e6-9552e6f83576",
      text: "B2 - SSB - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 80,
      parent: "96dc4c2c-8feb-4072-acfd-89d98a21ac3d",
      progress: 0,
      source_task_id: "B2.C.RF.1010"
    },
    {
      id: "9dc6a190-f454-4ba5-9482-63856a582222",
      text: "Stone & Fine Grade",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-12T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1120"
    },
    {
      id: "788d1f62-507e-4025-aab2-a46f59549cb0",
      text: "Deep Telecom",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-01-10T08:00:00",
      duration: 320,
      parent: "60a784f9-46e6-429a-aa4e-aa888c93bfcd",
      progress: 0,
      source_task_id: "8444255"
    },
    {
      id: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177",
      text: "[DCB1] DEC-C Ready: Production Cabling [Area A]",
      type: 0,
      start_date: "2026-01-12T08:00:00",
      end_date: "2026-01-12T08:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3527"
    },
    {
      id: "480dc9b0-680e-4a83-890b-4635b31b6983",
      text: "L4 - B2 DHB - Server Migration",
      type: 0,
      start_date: "2027-01-05T00:00:00",
      end_date: "2027-01-06T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHB.1010"
    },
    {
      id: "f721a444-80b9-452d-a51e-2d4a9feafc31",
      text: "Set RTU/MUA",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 24,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1220"
    },
    {
      id: "238bc62d-17cb-4c7e-9fc3-cede3e56f9a5",
      text: "Campus PH1 - Fabricate / Deliver - T-Comm Vaults (Site)",
      type: 0,
      start_date: "2024-08-09T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 320,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0,
      source_task_id: "B1.CFCI.5970"
    },
    {
      id: "a3e968c8-943d-4297-8a1a-53f1e27e760d",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-05-11T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 24,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1720"
    },
    {
      id: "7208600e-0e2d-4fa7-8e6b-d04276389976",
      text: "B1 - SSB - 1E1 - GSMDF1 - Tie in Skid to Ductwork",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 48,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1820"
    },
    {
      id: "92da57d4-9d3b-409b-a4bd-0a5513a6562a",
      text: "Campus - Logistic Work Complete - Phase 1",
      type: 0,
      start_date: "2025-04-16T08:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 0,
      parent: "c2b6cea0-6c62-423b-9336-3310c552a409",
      progress: 0,
      source_task_id: "C.CL.PH1.1000"
    },
    {
      id: "7a9f66be-0898-443f-b03b-42fc721ac117",
      text: "Finishes - Ceilings & Floors",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 24,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1060"
    },
    {
      id: "b3192a13-b4b1-42f8-8c2f-a05a330c5488",
      text: "B1 - DH-D - Install Door/Hardware/ Wall Trim - Data Hall D",
      type: 0,
      start_date: "2026-02-21T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1420"
    },
    {
      id: "9e62986e-7034-42c2-b641-601586fdac94",
      text: "Backfill",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 40,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1070"
    },
    {
      id: "39e5fca2-53a7-4367-866e-de694f3a679b",
      text: "B2 - DH-C - Hookup FCAs Mechanical - Data Hall C",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1770"
    },
    {
      id: "3cd8ec1f-1e3e-4087-b12a-e5518bb90884",
      text: "B1 - mCUP-9 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9020"
    },
    {
      id: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      text: "GS.IDF.1A3",
      type: 5,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 696,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "7995309"
    },
    {
      id: "ba74f83b-512b-4cbc-b83c-3f67902a5573",
      text: "B1 - DH-D - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 40,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1600"
    },
    {
      id: "95f2726c-8591-472b-b721-22bac3f44659",
      text: "Connectivity - Procure Services, Establish Delivery Dates, Establish RACI & Scope of Work",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 720,
      parent: "2a005706-7073-4042-b585-28e14aee4b53",
      progress: 1,
      source_task_id: "PRE-PP-1270"
    },
    {
      id: "ac82282b-b699-43c5-83f4-32d5b0f63861",
      text: "B1 - mCUP-4 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-05T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 24,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4100"
    },
    {
      id: "a5385589-db36-465b-a883-be62a45ce509",
      text: "(OFCI) B1 Main Switchboards MSB/RSB",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 3528,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.37,
      source_task_id: "7994990"
    },
    {
      id: "7f103629-f681-4cdd-9abb-9474c656c554",
      text: "B1 - 1N1E - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1370"
    },
    {
      id: "52739a62-3ec3-4d82-a355-74615201eff7",
      text: "Substation-1 - MSG A - Install Batteries",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 40,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4000"
    },
    {
      id: "be534141-357d-4c9f-8353-19591a73ef83",
      text: "Substation-2 - MSG B - Install Control Cabling",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 88,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4360"
    },
    {
      id: "5a6df0c1-ee29-49d6-b859-51ab2131e1f1",
      text: "Storm Sewer",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-10-09T08:00:00",
      duration: 144,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995193"
    },
    {
      id: "e0400250-d276-4e1f-a64d-9281daddabfa",
      text: "B2 - DH-C - Power Alley - Set MSB/RSB's (ROJ for DH Skids)",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-11T08:00:00",
      duration: 40,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1640"
    },
    {
      id: "4f7f364d-e265-46e7-8a2a-1d99cdaf4f20",
      text: "Substation-1 - MSG A - 3rd Party Inspections And Equipment Clean",
      type: 0,
      start_date: "2025-05-28T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 152,
      parent: "468305bd-0501-4842-8fba-f6be486af515",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3990"
    },
    {
      id: "6e1c97e4-389e-491f-93f9-57de37f6c03f",
      text: "B1 - DH-C - Install Ceiling Devices - Lighting - Data Hall C",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2560"
    },
    {
      id: "114b4b4f-2ba0-46fc-9a53-bb8e0be21112",
      text: "Install U/G - Plumbing",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-19T08:00:00",
      duration: 80,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1110"
    },
    {
      id: "a4df9c68-0fd1-46c0-960c-4b00b6e2808a",
      text: "B1 - DH-D - Pull/Term Lighting/Branch - Data Hall D",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-31T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1290"
    },
    {
      id: "3752613e-dad4-47f9-a762-24f963e18990",
      text: "OH Fire Alarm Rough-In",
      type: 0,
      start_date: "2025-11-17T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1250"
    },
    {
      id: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4",
      text: "B1 - DH-C - Install Structural Steel",
      type: 0,
      start_date: "2025-05-20T00:00:00",
      end_date: "2025-06-07T08:00:00",
      duration: 120,
      parent: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      progress: 0,
      source_task_id: "B1.C.STR.2000"
    },
    {
      id: "c2097344-8d59-4832-b32d-5e1bb2b8ec2d",
      text: "B1 - Network Room 2/3 - Power Alley - Facility Water Rough in",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1580"
    },
    {
      id: "3e0c2709-f6dd-4154-90ac-684cc2b77033",
      text: "(CFCI) Div. 28 - VESDA System",
      type: 5,
      start_date: "2024-10-23T00:00:00",
      end_date: "2025-02-14T08:00:00",
      duration: 608,
      parent: "632be35f-8f46-4b5c-bb52-d9b55c9ddad3",
      progress: 0,
      source_task_id: "7994885"
    },
    {
      id: "6f343f6b-7d09-4c93-b93c-239b6210e956",
      text: "Fab and Deliver - Substation MSG-Alpha - Area SS-2 (2) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 2304,
      parent: "26e5948f-129c-48df-8881-cfc73de88da4",
      progress: 0.47,
      source_task_id: "B2.OFCI.2100"
    },
    {
      id: "d97a88a1-8975-43c9-8f6a-404cc691b45a",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2550"
    },
    {
      id: "ce501ad6-8819-4631-8e22-62a6c06635fd",
      text: "Site / UG BIM - Phase-1 - DPR Receive Site MOFE/OFCI Submittals and Models",
      type: 0,
      start_date: "2024-04-15T00:00:00",
      end_date: "2024-04-19T08:00:00",
      duration: 40,
      parent: "c5c22553-885d-47f9-89bf-c50d3453b6ae",
      progress: 1,
      source_task_id: "SITE.VDC2.1040"
    },
    {
      id: "6ca14f1a-0790-424e-8917-ef78671e14e1",
      text: "B1 - 1N2W - 01N2.06 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6510"
    },
    {
      id: "46d1dfef-3c3f-4b1d-9637-a20b18a1a139",
      text: "B2 - mCUP-5 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5110"
    },
    {
      id: "6169310a-5601-438a-a428-f5979d5895a1",
      text: "BLDG-1/2 - Prep / Submit for Review - HVAC Insulation",
      type: 0,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-01-06T08:00:00",
      duration: 160,
      parent: "8901a989-4c49-4864-834a-2a9756542651",
      progress: 0,
      source_task_id: "B1.CFCI.3390"
    },
    {
      id: "c780465c-342b-4c65-930a-5e676c2857df",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2080"
    },
    {
      id: "a00a3642-05ac-49ff-bf1f-832c418fa0b6",
      text: "B1 - SSB - 1E2 - Common - Install Wall Devices Fire Alarm",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 48,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2200"
    },
    {
      id: "4a8c31db-194a-4f51-a869-7d3ca3982a01",
      text: "B1 - DH-A - Power Alley - Power Alley - Install GS Tray",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 96,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2320"
    },
    {
      id: "b0aa3d04-3297-468f-8b3f-e498740133e6",
      text: "Site - Earthwork Utilities Bid & Develop SA Package",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2024-02-29T08:00:00",
      duration: 448,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1020"
    },
    {
      id: "5025f16f-2531-4540-8c28-3d63ae3e84dc",
      text: "Area 3 - UG RI -RSB/MSB-DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1540"
    },
    {
      id: "c5d5e20a-4789-425d-b6f2-f39accd58867",
      text: "B1 - SSB - 1E2 - CMDF2 - Terms for Lighting/Outlet/Racks (Carrier MDF2)",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 24,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1950"
    },
    {
      id: "09c4286b-b6ce-454f-94cf-ab9f37922100",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Plumbing/Insulation",
      type: 0,
      start_date: "2025-07-24T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1580"
    },
    {
      id: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c",
      text: "B1 - 1N1E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.2680"
    },
    {
      id: "edc6bbd2-58cb-4892-a4b0-b8a7558c1314",
      text: "L4 Start Network Core - DCB1",
      type: 0,
      start_date: "2026-03-11T00:00:00",
      end_date: "2026-03-11T00:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2055"
    },
    {
      id: "a541a224-bc86-42a2-82a7-4415b24374e1",
      text: "B1 - 1N2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5230"
    },
    {
      id: "d0bed54c-5231-4917-855f-27c41cceb369",
      text: "Underground",
      type: 5,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 624,
      parent: "d3088fee-6e35-4c31-ad29-0f9024527c65",
      progress: 0,
      source_task_id: "7995399"
    },
    {
      id: "0bab6e61-79ea-41a3-971b-b69468c1ae87",
      text: "Set Gluelam Beams",
      type: 0,
      start_date: "2025-03-20T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 160,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1050"
    },
    {
      id: "bf635749-bc6b-4afb-8af8-a7269d980d69",
      text: "BLDG-2 - Area B - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 80,
      parent: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      progress: 0,
      source_task_id: "B1.CFCI.5380"
    },
    {
      id: "a4817a0a-6c14-4fcd-a3e8-933fc0591d13",
      text: "B2 - 2A1 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-27T08:00:00",
      duration: 24,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1750"
    },
    {
      id: "c62cd328-48ae-4f63-a1b5-b25c61207db6",
      text: "B1 - Network Room 1/4  - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2025-08-26T08:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 0,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1780"
    },
    {
      id: "aecd4a73-d0fd-4b23-8472-d5a3f3bd4788",
      text: "Set Panels",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 40,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1160"
    },
    {
      id: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3",
      text: "B2 - mCUP-6 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-12T08:00:00",
      duration: 24,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6070"
    },
    {
      id: "99342262-539e-4a89-9db5-728c05c3d3cb",
      text: "B2 - mCUP-2 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 80,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.8170"
    },
    {
      id: "3de03668-1ef1-48cb-b798-b17a3933219a",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 40,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.1320"
    },
    {
      id: "2ef57594-c3a0-4778-9c25-a83690500ff9",
      text: "Storm Sewer",
      type: 5,
      start_date: "2024-09-09T00:00:00",
      end_date: "2024-10-22T08:00:00",
      duration: 184,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995184"
    },
    {
      id: "8e87066e-a35b-440f-bca6-9cc7a28fd82b",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [7] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 3256,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.36,
      source_task_id: "B2.OFCI.2920"
    },
    {
      id: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      text: "Canopy",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 320,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "8243671"
    },
    {
      id: "57a27c76-2b94-401d-9035-4955837b0296",
      text: "B1 - DH-B - Install Underground Security",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 80,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1560"
    },
    {
      id: "f4fffe37-0e28-475b-8a02-ceaea1b08640",
      text: "B2 - mCUP-8 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2025-12-30T08:00:00",
      duration: 24,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8100"
    },
    {
      id: "d594f419-340d-4d3f-a0f0-a32fe022f14d",
      text: "B1 - West Entrance - Install rock mulch",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1070"
    },
    {
      id: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 24,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1420"
    },
    {
      id: "b6cf968e-4332-4bdb-b154-82c4d2b1f9b9",
      text: "B2 - 2B2 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-02-13T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1380"
    },
    {
      id: "26598ba9-76b5-452c-b1be-4c7c04919258",
      text: "B1 - DH-B - Install Cable Tray - Data Hall B",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2210"
    },
    {
      id: "422f3369-7a66-4767-a016-70debbe7099e",
      text: "FR 21 - DPR Prepare and Submit PCO#17",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "c1f6a7ac-1c93-432b-b5fe-30be07168a44",
      progress: 0,
      source_task_id: "FR.21.1020"
    },
    {
      id: "efd3ae41-8445-4f9a-b9d6-9519bc8b1eaf",
      text: "In Wall Inspection & QAQC Walks",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1060"
    },
    {
      id: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      text: "B1 - SSB - 1E2 - CMDF2 - Punchwalk and Handover Entrance Facility DEC-C Ready (Carrier MDF2)",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 8,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.2070"
    },
    {
      id: "b04611ed-47c0-4d18-b647-7a707ee436bb",
      text: "B2 - 2C1W - 02C.07 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2026-05-20T00:00:00",
      end_date: "2026-05-27T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.2460"
    },
    {
      id: "3d7692ee-e39e-4203-8386-e67ef0a74a9d",
      text: "[DCB1] FacNet Live (GS CORE)",
      type: 0,
      start_date: "2025-11-14T08:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3355"
    },
    {
      id: "8f57bb19-30c4-4859-8ddd-6c8c7fdf0bcc",
      text: "Approved DHEC Permit - DHEC",
      type: 0,
      start_date: "2024-04-11T00:00:00",
      end_date: "2024-04-11T00:00:00",
      duration: 0,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "Design.PreC.5730"
    },
    {
      id: "cbdf6d9e-42d9-42a5-b259-714b7957bcee",
      text: "FR 35 - DPR Prepare and Submit PCO#36",
      type: 0,
      start_date: "2024-08-07T00:00:00",
      end_date: null,
      duration: 416,
      parent: "22f7f124-57e8-4e8a-9a03-b51ea65b5a91",
      progress: 1,
      source_task_id: "FR.35.1020"
    },
    {
      id: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4",
      text: "B1 - DH-A - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-13T08:00:00",
      duration: 80,
      parent: "7ff8dfca-7821-49f8-b06e-76059e0f610b",
      progress: 0,
      source_task_id: "B1.C.A.2810"
    },
    {
      id: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      text: "AUX. Buildings",
      type: 5,
      start_date: "2024-03-19T00:00:00",
      end_date: "2026-06-29T08:00:00",
      duration: 3928,
      parent: "abe1a98c-028c-44b8-8da7-9658d12e1819",
      progress: 0,
      source_task_id: "7995212"
    },
    {
      id: "085297a6-891e-42b9-abd5-3a092733cf40",
      text: "B1 - DH-A - Precast",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 48,
      parent: "60c49587-0ac1-4fea-a483-61af60db4cec",
      progress: 0,
      source_task_id: "B1.C.1780"
    },
    {
      id: "5ee0f40d-9a19-457b-973b-139d01aaf830",
      text: "Area 3 - Sanitary Sewer Install - Lift Station-2",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-09T08:00:00",
      duration: 80,
      parent: "415ffe3d-5b86-4bfa-b4d2-a6bc07cd3efa",
      progress: 0,
      source_task_id: "C.CSU.A2.8040"
    },
    {
      id: "37304d8d-d453-4d1d-ad01-4a7fc9af3ea2",
      text: "B2 - DH-B - El Equip Yd - Pull Cable from MSB/RSB to Generator",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 40,
      parent: "bbd509f9-953a-4d97-8e24-89ae51fd8c92",
      progress: 0,
      source_task_id: "B2.C.EY.1550"
    },
    {
      id: "ea89a066-19b9-4806-869e-61a32c739b4a",
      text: "UG RI -Rack Bus-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      progress: 0,
      source_task_id: "MECO-1140.10"
    },
    {
      id: "73d065ec-b2a2-4b51-b830-f548cf113290",
      text: "B1 - SSB - 1E2 - GSMDF2 - Setting and hookup GS-MDF Skid (ROJ date for GS-MDF skid)",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-14T08:00:00",
      duration: 72,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "B1.C.SSB.1310"
    },
    {
      id: "7e611ff2-7796-4006-91c3-15c5fd46e223",
      text: "B2 - Specialties - Bike Rack",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-07-28T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1050"
    },
    {
      id: "74be69cd-47de-49a4-b624-a3bf56d9cdcf",
      text: "B1 - 1D1W - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 120,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1840"
    },
    {
      id: "61a94882-51e1-48ae-85f6-01cb65eba7eb",
      text: "Install Interior Signage",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1410"
    },
    {
      id: "7a27052a-152c-48a0-8eaf-98c9ad1e94e8",
      text: "B2 - DH-A - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-03-26T08:00:00",
      duration: 48,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2320"
    },
    {
      id: "e5715b5c-ca0f-4650-bcb3-9f82f2b94ae6",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-05-21T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 120,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2170"
    },
    {
      id: "9babbde7-21a0-417a-8a39-3490e28568ed",
      text: "B2 - mCUP-4 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 48,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4060"
    },
    {
      id: "8ded4bd8-2c0c-4387-a55d-8803472860c0",
      text: "Area 2 - MV Electric Install - Remaining (EY into ER) - Concrete Scope",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-07T08:00:00",
      duration: 96,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "C.CSU.A2.8130"
    },
    {
      id: "30a13332-1047-4c9f-ad09-b526b962ef76",
      text: "B1 - DH-B - Hookup FCAs Electrical- Data Hall B",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2440"
    },
    {
      id: "4c402718-830a-4c9c-9cfa-044c255c93bf",
      text: "Fragnet 30 - PCO # 28 Hurricane Helene",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: null,
      duration: 296,
      parent: "c9ca9ab5-7485-4d38-99c3-3c5fef4f879b",
      progress: 0.4,
      source_task_id: "8717478"
    },
    {
      id: "b9c8dc6d-d22c-45d8-87dd-0d87a21eee95",
      text: "FRP Equipment Pads",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-10T08:00:00",
      duration: 40,
      parent: "b5f8dda0-821a-4473-9e78-8e8ef4d0c906",
      progress: 0,
      source_task_id: "IBOS.FP.1000"
    },
    {
      id: "52e6e47e-5b3e-4672-a8f3-0c4290d05425",
      text: "L3 - B2 DHD",
      type: 0,
      start_date: "2026-12-18T00:00:00",
      end_date: "2027-03-03T08:00:00",
      duration: 400,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX3.B2.DHD.1000"
    },
    {
      id: "9cb56bfc-bb07-4e70-bb70-587e22b2a6ba",
      text: "B1 - Network - Install Underground Controls",
      type: 0,
      start_date: "2025-03-07T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 64,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1300"
    },
    {
      id: "f981f9aa-e670-49b2-b5c6-b18b956ee853",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2140"
    },
    {
      id: "b6b8e811-87f7-4b4e-9453-2be7d2a77ff7",
      text: "Area 5 - UG RI -Low Voltage Electric Transmission (Branch)-SSB1",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1880"
    },
    {
      id: "95e6e290-9351-45cb-a9b6-158d608044a0",
      text: "B1 - DH-C - Rough in HAC Lighting - Data Hall C",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2420"
    },
    {
      id: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      text: "B1 - SSB - 1E2 - Common - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-06-28T00:00:00",
      end_date: "2025-07-17T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1300"
    },
    {
      id: "ae393f7a-b536-4e92-93ab-c70d1e17f566",
      text: "B2 - 2C2 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 8,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1450"
    },
    {
      id: "52cdb49b-fa91-43cc-a713-e781a47f993c",
      text: "Substation-1 - Pad Prep for IDF Hut",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 80,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6150"
    },
    {
      id: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      text: "Release RFP's / Meta Issue PO's",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2024-02-15T08:00:00",
      duration: 336,
      parent: "8820736c-410e-4efe-a06b-d0fc26d82040",
      progress: 1,
      source_task_id: "B1.OFCI.1140"
    },
    {
      id: "2f436069-737b-4d27-be8a-72db4ab8e581",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2630"
    },
    {
      id: "e0712f0e-84fc-49ce-bbd6-5bfecd1588f1",
      text: "Install Vapor Barrier",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1030"
    },
    {
      id: "36349a08-6432-4c85-8914-3fa3e4bb79b2",
      text: "IBOS - Submittal Rvw/App'l - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-09-17T00:00:00",
      end_date: "2024-10-02T08:00:00",
      duration: 80,
      parent: "f516d625-fc35-4562-b467-ea8f751e08e8",
      progress: 0,
      source_task_id: "B1.CFCI.5470"
    },
    {
      id: "dda8fe38-85aa-4236-91bf-c9acbecf8cce",
      text: "Fab and Deliver - PLC Panels - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 2720,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 0.34,
      source_task_id: "B1.OFCI.2960"
    },
    {
      id: "54fa6b99-2ac8-4823-8b12-d16a43354a24",
      text: "IST Finish DH B - DCB2",
      type: 0,
      start_date: "2027-01-08T08:00:00",
      end_date: "2027-01-08T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2145"
    },
    {
      id: "181a2426-2c84-426b-aeee-ed70881aefe0",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [8] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 3296,
      parent: "0e05785d-a39c-4e8c-85e8-dee680ce8ddd",
      progress: 0.36,
      source_task_id: "B2.OFCI.2930"
    },
    {
      id: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56",
      text: "B1 - DH-D - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 120,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1490"
    },
    {
      id: "d88da9af-de9a-4f0b-a64b-948a878500ec",
      text: "Delivery of Dry Cooling Towers (First Delivery) - DCB2",
      type: 0,
      start_date: "2025-06-16T08:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1860"
    },
    {
      id: "5d05cf3f-7941-408f-bb13-3aeb3de631e2",
      text: "UG RI -Low Voltage Electric Transmission (Branch)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      progress: 0,
      source_task_id: "MECO-1260.10"
    },
    {
      id: "36b79854-9774-4973-bd6b-578b4b168918",
      text: "B1 - DH-A - Install Underslab Branch Conduit (includes EPMS)",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 40,
      parent: "55203d15-6a05-4636-aac5-eb996029b878",
      progress: 0,
      source_task_id: "B1.C.STR.2120"
    },
    {
      id: "cddbc8c3-6848-4da0-aa6e-16306ae9cadf",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1150"
    },
    {
      id: "0a44da7c-f803-4818-bd5b-8e8169df7615",
      text: "[DCB2] DEC-C Ready: General Services [Area B]",
      type: 0,
      start_date: "2026-06-18T08:00:00",
      end_date: "2026-06-18T08:00:00",
      duration: 0,
      parent: "4c471f47-09d9-4b92-aa85-0a1537bffb4e",
      progress: 0,
      source_task_id: "ICM.B2.3735"
    },
    {
      id: "66532f16-45fc-4ca5-ba91-f451d7280803",
      text: "B1 - mCUP-4 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4050"
    },
    {
      id: "f66d0a54-fc2e-421b-8a9c-5536072633b2",
      text: "B2 - OSP Cabling - EF to GSIDF 2X3",
      type: 0,
      start_date: "2026-03-20T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 80,
      parent: "71be5c41-0454-4bac-8971-6b8f2d2021a0",
      progress: 0,
      source_task_id: "B2.CONN.1100"
    },
    {
      id: "f6510654-c5de-446e-825d-0d22eaa68e4d",
      text: "Glass / Glazing - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-07-22T00:00:00",
      end_date: "2024-08-30T08:00:00",
      duration: 120,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0,
      source_task_id: "Design.PreC.1340"
    },
    {
      id: "633cffbb-b1cf-46f5-8f02-1e8b28275ab4",
      text: "Drop ACT Tile",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1380"
    },
    {
      id: "28f8337d-b553-43c2-9031-1716482638ac",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 120,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2130"
    },
    {
      id: "89c212c7-7009-4a28-a52e-66e8a829414f",
      text: "Adverse Weather Event 10 - 09.28.2024  (Hurricane Helene)",
      type: 0,
      start_date: "2024-09-28T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1010"
    },
    {
      id: "b24f4699-923a-404a-88fc-9f097768e13f",
      text: "B2 - 2A1  (GS.IDF.2A2) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 80,
      parent: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      progress: 0,
      source_task_id: "B2.C.A.2030"
    },
    {
      id: "8ef542cf-c45d-4953-90b7-97d7cfad9871",
      text: "B1 - ISP Cabling - IDFB to DHB (GS tray)",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 200,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1370"
    },
    {
      id: "2760ba52-4164-4cf9-a0be-2996d16f4183",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [2] - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-12T08:00:00",
      duration: 2832,
      parent: "c14f9d03-3cec-4c11-850a-1168f7d567b0",
      progress: 0.38,
      source_task_id: "B2.OFCI.2730"
    },
    {
      id: "abb34534-4301-4812-9794-66b861e59015",
      text: "IST Finish DH B - DCB1",
      type: 0,
      start_date: "2026-06-17T08:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2145"
    },
    {
      id: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7",
      text: "B1 - 1C1W - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 24,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1550"
    },
    {
      id: "be3e6dec-4b64-42bb-bbf4-24280a6b60fd",
      text: "Generators - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-05-28T00:00:00",
      duration: 560,
      parent: "48cf4798-012c-4fde-a8da-168cee42ccec",
      progress: 1,
      source_task_id: "B2.OFCI.1330"
    },
    {
      id: "f0d9ef4f-191d-4d39-9779-5b0274a8fb64",
      text: "Hot Aisle Containment",
      type: 5,
      start_date: "2026-03-05T08:00:00",
      end_date: "2026-05-19T08:00:00",
      duration: 424,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994821"
    },
    {
      id: "18a248ee-4bc3-40e6-a028-66f4afbf49fb",
      text: "B2 - DH-C - Inspect Above Ceiling - Data Hall C",
      type: 0,
      start_date: "2026-07-10T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 40,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2620"
    },
    {
      id: "26d5a9eb-551e-420d-8b46-2ae818c18137",
      text: "B1 - 1B2E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1310"
    },
    {
      id: "2251a03b-5b2c-4cb2-8dba-edc09b7bddc9",
      text: "B1 - DH-C - Install Insulation",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 40,
      parent: "38fd3d37-8290-43b8-9c72-86a815a9caee",
      progress: 0,
      source_task_id: "B1.C.RF.1280"
    },
    {
      id: "af297041-818e-4976-a727-2c0aabaa7148",
      text: "BLDG-2 - BIM - Tier 0 - Area 2-D - Coordination / Sign-off",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 240,
      parent: "1cb75608-ea15-4d7d-a6f5-dc6bf4d3a50a",
      progress: 0,
      source_task_id: "B2.VDC.3170"
    },
    {
      id: "f6b53c79-f0d7-4ea6-8f97-5281e73cd801",
      text: "Provide site specific design to interface requirements of MOFE elements",
      type: 0,
      start_date: "2023-12-26T00:00:00",
      end_date: "2024-01-02T08:00:00",
      duration: 40,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1330"
    },
    {
      id: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      text: "Substation-2 MSG B Buildout",
      type: 5,
      start_date: "2025-11-10T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 1064,
      parent: "b8e45de6-42ff-47bd-abb4-b79f68000588",
      progress: 0,
      source_task_id: "7995224"
    },
    {
      id: "98101063-399f-45c8-bbc8-fb801425baeb",
      text: "B1 - DH-D - Pull/Term BMS - Data Hall D",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-02-07T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1310"
    },
    {
      id: "f2c14ded-4438-4665-973b-0774f27d4c7b",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2160"
    },
    {
      id: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      text: "DPR Trade Awards",
      type: 5,
      start_date: "2024-03-21T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 1808,
      parent: "56080308-2da4-4055-b9e7-474a80627d2c",
      progress: 0.23,
      source_task_id: "7994718"
    },
    {
      id: "d0881ff2-384f-44c8-8d68-f9f849b81b06",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2570"
    },
    {
      id: "bfe8aabb-e24b-4d77-b26b-00151c892335",
      text: "Install Wall IMP System",
      type: 0,
      start_date: "2025-05-22T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1060"
    },
    {
      id: "442bfdfa-b2cf-4f68-a9b7-4ea41c6296a6",
      text: "B1 - mCUP-7-9 - L2 Checkout of Pumps/Chillers and MSB for C/D",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 80,
      parent: "0030099f-bbea-4b45-9ffb-9bcfe33c7559",
      progress: 0,
      source_task_id: "B1.mCUP.9200"
    },
    {
      id: "608e9583-5403-4e20-8d84-2702bbb5742e",
      text: "Campus - Submittals - Storm Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-05-03T08:00:00",
      duration: 160,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.5890"
    },
    {
      id: "6b06752b-87c7-4910-b4e1-d57317f50ce3",
      text: "B2 - DH-C - Install Decking",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 80,
      parent: "e5e2deef-8606-4ab5-91fe-d633b81bf315",
      progress: 0,
      source_task_id: "B2.C.STR.1890"
    },
    {
      id: "4e35fcfa-0392-428a-96ae-f2acb0a1cb46",
      text: "B2 - DH-B - Install Grounding Loop - Data Hall B",
      type: 0,
      start_date: "2026-07-08T00:00:00",
      end_date: "2026-08-04T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2880"
    },
    {
      id: "6462ce83-0e17-48d2-a4e0-418df7976a21",
      text: "Establish Baseline 1",
      type: 0,
      start_date: "2023-12-01T08:00:00",
      end_date: "2023-12-01T08:00:00",
      duration: 0,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "ICM.PRE.1610"
    },
    {
      id: "55a7801c-a46b-4031-b203-4429c2a14fff",
      text: "B2 - 2D2 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 40,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2040"
    },
    {
      id: "b5a3662a-0fc0-4952-97ba-79a71bd71f50",
      text: "Area 2 - UG RI -MVS to PTX-DCB1",
      type: 0,
      start_date: "2024-11-27T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 192,
      parent: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      progress: 0,
      source_task_id: "MECO-1290"
    },
    {
      id: "d35d841b-61b4-47a6-bfce-efcc34d1e4aa",
      text: "B1 - 1N2E - 01N3.05 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6050"
    },
    {
      id: "0256923c-cf68-4d03-b14b-d50d74261f0c",
      text: "B1 - 1N2E - 01N3.05 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6310"
    },
    {
      id: "8d958915-fa46-4250-9bcc-068e2b28965d",
      text: "B1 - Deep Telecom - EF2 - Concrete Scope",
      type: 0,
      start_date: "2024-12-03T00:00:00",
      end_date: "2024-12-07T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B1.C.STR.2460"
    },
    {
      id: "439f0c0c-31ba-4794-bc29-3919a21d4eb9",
      text: "B2 - SSB - Grout Column Baseplates",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 40,
      parent: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      progress: 0,
      source_task_id: "B2.C.STR.1720"
    },
    {
      id: "6701a342-d859-40c6-a27d-7bf4bb1c4b54",
      text: "Substation MSG - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "26e5948f-129c-48df-8881-cfc73de88da4",
      progress: 1,
      source_task_id: "B1.OFCI.1310"
    },
    {
      id: "cdb48eb9-dba5-4f76-84a3-d26098ea5e0e",
      text: "Foundation keyway water stop",
      type: 0,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1080"
    },
    {
      id: "e610cbe7-010f-49d6-bfeb-8278bcfe59b0",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 120,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2060"
    },
    {
      id: "53d3b873-e557-402e-9667-2069e633678d",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2090"
    },
    {
      id: "6a3e5d79-5f67-4376-b76c-b49c7cfc1ca5",
      text: "Fab and Deliver - PTX-CUP - Area CUP (9) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-06T08:00:00",
      duration: 3224,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.27,
      source_task_id: "B2.OFCI.1950"
    },
    {
      id: "4615220c-de4a-44f0-85e6-bb0d52ee1741",
      text: "B2 - DH-B - Install Celing Devices Fire Alarm - Data Hall B",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2840"
    },
    {
      id: "aad2ee27-75d9-4b82-a5af-932ef4a31fad",
      text: "Foundation Start",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-01-17T00:00:00",
      duration: 0,
      parent: "343acf74-d115-412c-91e3-d35be32f0404",
      progress: 0,
      source_task_id: "CX.MIL.1000"
    },
    {
      id: "1a475c0b-ae36-404a-809b-3520552e883a",
      text: "B1 - DH-D - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 80,
      parent: "62872b9b-6759-4561-825b-c00ed5bb886c",
      progress: 0,
      source_task_id: "B1.C.D.3070"
    },
    {
      id: "0d13d1ef-4a25-43f0-a2d3-04d201b94a7d",
      text: "B1 - Network Rooms - Electrical Pulls/Terms/Cable Tray (Converted to LOE)",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 336,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "B1.C.NR.1520"
    },
    {
      id: "d9a5b98e-cd43-4907-beec-d9636b0efc25",
      text: "Fab and Deliver - Fan Coil Assembly - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-05-06T08:00:00",
      duration: 2640,
      parent: "449712cf-b0e6-4351-9fed-f8b5dccd621f",
      progress: 0.43,
      source_task_id: "B1.OFCI.2670"
    },
    {
      id: "17e8ecb5-9de9-44c9-bc08-591d3fa9a372",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Food Service",
      type: 0,
      start_date: "2024-12-31T00:00:00",
      end_date: null,
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6220"
    },
    {
      id: "ef41caf1-070f-490d-8af6-fb3afc981237",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Mechanical",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1150"
    },
    {
      id: "8867c60e-a98b-47a7-8cff-14f96a885d9c",
      text: "B2 - DH-B - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area B",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 120,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1200"
    },
    {
      id: "8661730a-9304-4470-b80c-38b6f2423696",
      text: "Install Braced Frames",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-02-19T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1060"
    },
    {
      id: "a2c0d744-0668-4a8c-aff9-53d075297491",
      text: "Fab and Deliver - Assembled Skids - Area B - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 3000,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 0.26,
      source_task_id: "B1.OFCI.3010"
    },
    {
      id: "132f642a-4b74-4169-a1d1-13b9d87a0cb2",
      text: "B1 - 1N1E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 160,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5750"
    },
    {
      id: "83ffac24-2ea4-4829-b741-541365942fb8",
      text: "B1 - DH-A - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1250"
    },
    {
      id: "d73e1f73-7c1a-47b6-aa65-8c0d0751f983",
      text: "B1 - DH-D - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1470"
    },
    {
      id: "eab7eac6-5d7a-4ffb-baeb-37325bee6282",
      text: "Execution of GMP",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-01T00:00:00",
      duration: 0,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 0,
      source_task_id: "Design.PreC.2440"
    },
    {
      id: "520f5e0f-9ae8-49a8-aae9-8bc4dd12fe8a",
      text: "B2 - mCUP-1-8 - Equipment set (Level of Effort)",
      type: 0,
      start_date: "2025-10-07T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 464,
      parent: "5d20944d-7918-46c2-83e5-08c69eb295d1",
      progress: 0,
      source_task_id: "B2.mCUP.8010"
    },
    {
      id: "ac5a4c71-9f99-410d-a424-c603a76381b0",
      text: "UG RI -Panel Boards (PB)-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "06bd3404-1a5f-4d2c-b5cb-bad1e0f64a0d",
      progress: 0,
      source_task_id: "MECO-1640.40"
    },
    {
      id: "b2097b31-3e16-4aa0-808c-8f8209d7bf50",
      text: "PRS",
      type: 5,
      start_date: "2023-10-23T00:00:00",
      end_date: "2024-01-22T08:00:00",
      duration: 488,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "7994741"
    },
    {
      id: "d92df994-826b-451d-9959-0988bb8829ad",
      text: "Start Slab-On-Grade Concrete - DCB2",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-09T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1500"
    },
    {
      id: "189ccc66-a3ae-42bc-888b-b1b808f4bca6",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-02-06T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.1780"
    },
    {
      id: "3ef449ea-d160-48e6-9c6c-1f5fbedf706d",
      text: "Start HAC set in place - DCB1",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-24T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1725"
    },
    {
      id: "0c912ad6-7054-429f-b427-26fabfdfaea7",
      text: "L4 - mCUP 1-9 *On Temp Power*",
      type: 0,
      start_date: "2026-02-18T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 360,
      parent: "9b27290c-13f7-443c-bc67-befdf49822ba",
      progress: 0,
      source_task_id: "CX4.B1.MCUP.1000"
    },
    {
      id: "e860efb6-be26-4d2d-aef3-6af76ce6a187",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-11-03T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 80,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2250"
    },
    {
      id: "ea0e8a31-0808-4cc4-bb46-cdbd5a64a029",
      text: "B1 - 1B2E - Corridor - Room Fit Out Activities - Set/Hook up Equipment",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.2480"
    },
    {
      id: "3a6975cb-05be-484e-ad90-774be5bbff35",
      text: "B1 - 1N2E - 01N3.05 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 144,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6230"
    },
    {
      id: "d6d06ab3-0803-4a9c-9558-89ebef6f2ab2",
      text: "Install Canopies",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1080"
    },
    {
      id: "2067e93a-473a-4c84-bffe-b102a2be0c70",
      text: "B1 - DH-B - Power Alley - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-04T08:00:00",
      duration: 16,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1860"
    },
    {
      id: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      text: "Building 2 mCUP-3",
      type: 5,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 352,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995142"
    },
    {
      id: "5c1c5bf9-70c3-48d3-962f-31f06bda80fe",
      text: "B1 - 1C1W - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 160,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1840"
    },
    {
      id: "eb4403f2-df57-43c9-a25b-261c7f96903b",
      text: "B2 - 2C2 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 160,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1780"
    },
    {
      id: "b506e9a8-aa7b-4b85-b1c5-9583ed7c8603",
      text: "B2 - DH-A - DEC -C Turnover Walk - Data Hall A",
      type: 0,
      start_date: "2026-07-24T00:00:00",
      end_date: "2026-07-27T08:00:00",
      duration: 16,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2710"
    },
    {
      id: "c622157b-ff05-4490-95fa-270ab9f08454",
      text: "DFSMA - DC1 - CUP 1- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-07-07T08:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 0,
      parent: "aa35404c-261a-4bb5-8fd1-43cd65e1c5b0",
      progress: 0,
      source_task_id: "B1.DFSMA.1210"
    },
    {
      id: "4e4ecf78-df25-44e3-b7e0-d880d601b742",
      text: "[DCB1] DEC-C Ready: Overhead cable tray complete [Area A]",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-10-13T00:00:00",
      duration: 0,
      parent: "59d33bfb-664d-4cca-baa5-842df0f73a55",
      progress: 0,
      source_task_id: "ICM.B1.3825"
    },
    {
      id: "45f9325e-cbba-47d5-8f66-00c081e6aa73",
      text: "Form/Rebar/Pour Foundations - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "IBOS.CON.1010"
    },
    {
      id: "14a2565f-aff6-4bd0-a6e9-811ada0de272",
      text: "Fab and Deliver - RSB - Area D - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 3344,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.43,
      source_task_id: "B2.OFCI.2370"
    },
    {
      id: "b927c50c-d897-4864-888c-d8f6122c9703",
      text: "B1 - RF-Tower-1 - Equipment Hookup's - Seq. 2",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 160,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6590"
    },
    {
      id: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 160,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1800"
    },
    {
      id: "7455a196-cadf-4149-b1c4-7385cbc91ff9",
      text: "FR 16 - DPR prepare and Submit RFI #88",
      type: 0,
      start_date: "2024-08-09T00:00:00",
      end_date: null,
      duration: 0,
      parent: "ad81c4ff-51ed-406e-85d5-a07e20bb8eca",
      progress: 1,
      source_task_id: "FR.16.1000"
    },
    {
      id: "9b9ca51f-3732-42a7-9ec8-81140732591d",
      text: "FR 03 - Telecom Redesign - Awaiting Telecom Design Modifications",
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-05-24T08:00:00",
      duration: 88,
      parent: "0497b6bf-f811-43f6-b6dc-b788f581380d",
      progress: 1,
      source_task_id: "FR.03.1010"
    },
    {
      id: "a6159eb0-62ed-4251-853c-a798dec3d0a8",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2350"
    },
    {
      id: "5527aa8e-25d2-4a3e-989e-6421a5276a08",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-20T08:00:00",
      duration: 8,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1340"
    },
    {
      id: "d23ed867-e0e0-4374-bd68-b89c9582e2f9",
      text: "FR 32 - META review and Approve PCO#31",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 80,
      parent: "f3d372b5-108e-423c-a7ac-e30f6c888ce2",
      progress: 0,
      source_task_id: "FR.32.1030"
    },
    {
      id: "cc19acbe-a89b-4ff4-bc45-da41efc17936",
      text: "B2 - DH-D  - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-16T08:00:00",
      duration: 80,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1060"
    },
    {
      id: "23e5880b-5068-4d04-a976-1f3e3bd3c149",
      text: "B2 - 2D1W - 02D.08 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-05-27T00:00:00",
      end_date: "2026-06-02T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.2160"
    },
    {
      id: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0",
      text: "B1 - DH-C - WAP Provisioning",
      type: 0,
      start_date: "2026-03-10T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 160,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1410"
    },
    {
      id: "c7b21fff-59b1-4351-ae73-34e1aa35e758",
      text: "Precast Start - DCB2",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-09-30T00:00:00",
      duration: 0,
      parent: "afbb7442-851f-4c66-9cde-ce07cdd76ba2",
      progress: 0,
      source_task_id: "ICM.B2.1380"
    },
    {
      id: "b9d8df39-d15a-4838-9afd-6c53841fe141",
      text: "B2 - mCUP-8 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 48,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8060"
    },
    {
      id: "83348ea3-d1b8-4a15-b644-dd79511e108d",
      text: "B2 - Deep Telecom - EF4 - Concrete Scope",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B2.C.STR.2450"
    },
    {
      id: "448c6c82-74c5-49dd-b8de-5ceef5fa8940",
      text: "B2 - 2D1 - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-07-23T00:00:00",
      end_date: "2026-08-12T08:00:00",
      duration: 120,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.2520"
    },
    {
      id: "d5f5c6a1-35d4-4708-9b06-316e2067e5c0",
      text: "BLDG-2 - Area A - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 80,
      parent: "7b3cfc8f-4609-488f-a2e1-1542cfc0c883",
      progress: 0,
      source_task_id: "B1.CFCI.5430"
    },
    {
      id: "3ffd9e4e-0fff-4929-a6cb-266e57a48ceb",
      text: "Admin - Mass Timber Review/Approval",
      type: 0,
      start_date: "2024-10-25T00:00:00",
      end_date: "2024-11-11T08:00:00",
      duration: 40,
      parent: "548e63b0-33fb-40de-89f7-df1bfa59596a",
      progress: 0,
      source_task_id: "ADMIN.PROC.1090"
    },
    {
      id: "728b0680-5a9d-42ed-9bab-c06a6ac71d41",
      text: "B2 - mCUP-5 - Set in Place Inspections",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 8,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5030"
    },
    {
      id: "195b01c7-ca3f-4020-81af-4c8389420740",
      text: "B1 - DH-A - Term Bussways - Data Hall A",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2530"
    },
    {
      id: "3b798bb2-0d45-402b-aace-562d29adc534",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-01-30T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 24,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1760"
    },
    {
      id: "a8760b19-5f81-452d-ae2b-122605927840",
      text: "Campus - Submittals - Storm Manholes and Inlets (Early Release)",
      type: 0,
      start_date: "2024-04-08T00:00:00",
      end_date: "2024-04-16T08:00:00",
      duration: 56,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.3940"
    },
    {
      id: "b059a712-db60-4a41-929a-dfa1e031e852",
      text: "Area 1 - MV Electric Install - Remaining (EY into ER)",
      type: 0,
      start_date: "2024-12-28T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 96,
      parent: "720e9207-a7b5-48b5-bb85-5ab844c17046",
      progress: 0,
      source_task_id: "C.CSU.A1.8010"
    },
    {
      id: "81653fb2-2628-422e-9882-31ff7c58e09f",
      text: "B1 - 1C1W - 01C.07 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.1940"
    },
    {
      id: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70",
      text: "B1 - 1D1W - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 8,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1750"
    },
    {
      id: "a11e806f-81d9-4ea7-87c5-8b8e133a820e",
      text: "Punchlist / Zero Defects",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1510"
    },
    {
      id: "7e34e0dc-45d3-4d99-9ec4-3b022ebcd600",
      text: 'Off Campus - Install 12"" Sanitary Sewer (3400\' LF)',
      type: 0,
      start_date: "2024-05-13T00:00:00",
      end_date: "2024-07-31T08:00:00",
      duration: 512,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 0.4,
      source_task_id: "C.CSW.3030"
    },
    {
      id: "c39ef87d-806e-489f-8e37-34382dc62059",
      text: "B1 - SSB - 1E2 - GSMDF2 - Build Wall Between MDF/Fiber Entry and Carrier (Parent)",
      type: 0,
      start_date: "2025-07-15T00:00:00",
      end_date: "2025-07-21T08:00:00",
      duration: 48,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1390"
    },
    {
      id: "b0915ac9-c21c-4a06-89fd-3ce504b45794",
      text: "Fab and Deliver - ATS - Area C - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3072,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.31,
      source_task_id: "B1.OFCI.3190"
    },
    {
      id: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4",
      text: "IFC Package - Development",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-14T08:00:00",
      duration: 432,
      parent: "c884f3e1-0476-48f8-860b-e5f48adfe961",
      progress: 1,
      source_task_id: "Design.PreC.2360"
    },
    {
      id: "85daca7c-faff-48a2-bbbd-5cd315f37ba3",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 8,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.1670"
    },
    {
      id: "46ff247c-d266-4338-913a-2fb41fede75a",
      text: "BLDG-1/2 - Prep / Submit for Review - Lighting",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: "2024-11-19T08:00:00",
      duration: 160,
      parent: "35f922d0-d8cc-464c-8795-760c9606b1a3",
      progress: 0,
      source_task_id: "B1.CFCI.3840"
    },
    {
      id: "9880ddc5-41c3-4ec8-b8df-9785c9e1f1ff",
      text: "B1 - mCUP-2 - Install FA  (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2110"
    },
    {
      id: "7ea3ceb9-347c-4806-8aff-0fc1ed4f79e3",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [7] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-04-14T08:00:00",
      duration: 2632,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.4,
      source_task_id: "B1.OFCI.3530"
    },
    {
      id: "552d5874-7e69-4a6d-a8b1-dde31aa2fc51",
      text: "B1 - DH-D - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2026-01-16T08:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 0,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1330"
    },
    {
      id: "5125e72f-5be1-4d42-bf16-dbda07ff65d2",
      text: "B1 - DH-A - Install Joists",
      type: 0,
      start_date: "2025-05-02T00:00:00",
      end_date: "2025-05-19T08:00:00",
      duration: 120,
      parent: "b68b9bd8-795b-47f0-93c7-d910dad72a06",
      progress: 0,
      source_task_id: "B1.C.STR.1880"
    },
    {
      id: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      text: "DH-B",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 1384,
      parent: "8afd9616-202b-49c7-8b22-9f4de01ca6bd",
      progress: 0,
      source_task_id: "7995081"
    },
    {
      id: "f0fb3a25-e2d6-483f-a95e-ba5d9e7f7ecc",
      text: "Fab and Deliver - ATS - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 2832,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.3,
      source_task_id: "B1.OFCI.2980"
    },
    {
      id: "2cadaf95-ba94-40ec-a86e-0e94b5efd460",
      text: "Fab and Deliver - PLC Panels - Area B - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-12-01T08:00:00",
      duration: 3648,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.18,
      source_task_id: "B2.OFCI.1830"
    },
    {
      id: "5d72a611-530f-409f-b90f-1d4f9773e85a",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.2370"
    },
    {
      id: "b50abb1f-cbfe-4da5-bfc2-6c03e7a32b2b",
      text: "Area 3 - Cx - Lvl-2, Lvl-3",
      type: 0,
      start_date: "2024-12-19T00:00:00",
      end_date: null,
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8150"
    },
    {
      id: "2914d626-e82d-4b3d-be7e-523764ac4ce2",
      text: "B2 - mCUP-2 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-10-14T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 16,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2010"
    },
    {
      id: "947205c5-5a11-4986-983a-ac9b8fd49e14",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-03-02T00:00:00",
      end_date: "2026-03-06T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1400"
    },
    {
      id: "dbc30aa6-5af1-409d-8fc1-76346f414b5a",
      text: "Substation-2 - Install Ground Grid",
      type: 0,
      start_date: "2025-08-07T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 120,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6370"
    },
    {
      id: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0",
      text: "Campus - Prepare Building Pad for BLDG-2  (Cut/Fill/Lime/Compact/Stone/Wells)",
      type: 0,
      start_date: "2024-12-10T00:00:00",
      end_date: "2024-12-14T08:00:00",
      duration: 40,
      parent: "4e014c7b-b6b9-4a1d-a98a-183e322561d1",
      progress: 0,
      source_task_id: "C.CSW.1130"
    },
    {
      id: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75",
      text: "B1 - DH-C - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-07T08:00:00",
      duration: 40,
      parent: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      progress: 0,
      source_task_id: "B1.C.STR.2250"
    },
    {
      id: "4c4f953b-ed7e-4a3f-ae81-412817bd8c66",
      text: "B1 - SSB - 1E1 - Common - Install Porcelain Tile",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2270"
    },
    {
      id: "3b4909fc-685a-4acb-8c64-cdb640f6e236",
      text: "B1 - 1N2E - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-16T08:00:00",
      duration: 120,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.6580"
    },
    {
      id: "3747081e-04b5-4630-ad5f-3905662ade2b",
      text: "B1 - mCUP-7 - Set in Place Inspections",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 8,
      parent: "24ca126f-f19d-4b11-bfba-93886754cbba",
      progress: 0,
      source_task_id: "B1.mCUP.7030"
    },
    {
      id: "951e7f90-d5c3-4bf4-852f-4bce5c0dd488",
      text: "L3 Start mCUP  - DCB2",
      type: 0,
      start_date: "2026-07-02T00:00:00",
      end_date: "2026-07-02T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2070"
    },
    {
      id: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      text: "GS.IDF.A1",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 696,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "7995305"
    },
    {
      id: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      text: "B1 - DH-C - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 80,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1040"
    },
    {
      id: "55ae2949-c2d8-484c-8216-2698a056d696",
      text: "B1 - DH-D - Set CDU's - Data Hall D (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 64,
      parent: "4e59b52c-1f38-413f-b50f-c638d57eaa94",
      progress: 0,
      source_task_id: "B1.C.D.3180"
    },
    {
      id: "8203e406-f0f6-4aaf-859d-d66383b5d901",
      text: "B2 - SSB - 2E1 - Common - OH Rough In Plumbing/Insulation",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1140"
    },
    {
      id: "9115becb-df28-4b8f-bc6b-f76537418602",
      text: "RF Tower 1 Constuction Complete",
      type: 0,
      start_date: "2025-11-13T08:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 0,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "AKN.MS.1100"
    },
    {
      id: "47e37ed7-7148-4a37-a0c8-9fda1acc74af",
      text: "Area B - OH Fire Protection - Mains & Branches",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1270"
    },
    {
      id: "87d8a24d-4db1-428d-a912-75b952f29814",
      text: "UG RI -DAS System-DCB1-Area 1",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 64,
      parent: "277b6712-1d98-47ef-bcb9-e914db88fe8a",
      progress: 0,
      source_task_id: "MECO-1050"
    },
    {
      id: "4b824c59-f5cd-4171-b76f-776a5a37398e",
      text: "B1 - Network Room 2/3 - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 48,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.2070"
    },
    {
      id: "d5f395af-487c-4217-9d5f-219617efce48",
      text: "B2 - 2D2 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-30T08:00:00",
      duration: 160,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.1000"
    },
    {
      id: "3cd8c2ae-1020-4a4b-afe4-81cf3e011402",
      text: "Delivery of NES - Network Electrical Room Skid (First Delivery) - DCB1",
      type: 0,
      start_date: "2024-12-10T08:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1850"
    },
    {
      id: "2091270a-1d07-4366-8ed9-66b537e2de76",
      text: "B1 - Network Room 1/4 - Power Alley - OH Sprinkler Mains and Branch",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-31T08:00:00",
      duration: 48,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1390"
    },
    {
      id: "943b1642-e7aa-48cf-80ce-f71213c95094",
      text: "Fab and Deliver - GSB - Area A - DCB1",
      type: 0,
      start_date: "2024-01-17T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 2896,
      parent: "937a5c15-24b8-429b-aaf6-a66460890d40",
      progress: 0.38,
      source_task_id: "B1.OFCI.2300"
    },
    {
      id: "47514918-2b02-4579-a20b-6c15c940201c",
      text: "B1 - DH-C - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 40,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1180"
    },
    {
      id: "bb52d052-3765-4394-84d1-a4c52f532881",
      text: "B2 - DH-C - Roofing(Converted to LOE)",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1170"
    },
    {
      id: "de1641a4-aa53-4d6b-a15e-d708ac6d1f3e",
      text: "BLDG-1- SSB - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.4520"
    },
    {
      id: "0fe2ef5c-f13d-4358-8b45-bb6e458d345f",
      text: "B1 - DH-D - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 240,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1470"
    },
    {
      id: "c1bb9d42-1eae-46fb-96a5-d1289654ecd4",
      text: "B1 - SSB - 1E1 - GSMDF1 - Pull Wire for Lighting/Outlet/Racks",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 24,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1630"
    },
    {
      id: "75983700-34ca-4bef-a5b8-95b3d5be2fe0",
      text: "BLDG-1 Network - L2 Checkout for Building",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 240,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1000"
    },
    {
      id: "5faffcb1-e61e-430f-8afa-296ee2caa19f",
      text: "Finalize Site Logistics",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-12-05T08:00:00",
      duration: 240,
      parent: "1727f221-62ff-460d-93ab-9c07242dc0b2",
      progress: 1,
      source_task_id: "PRE-DD-1000"
    },
    {
      id: "bd5ebfbb-03fb-44fe-9969-ddea623fd20b",
      text: "Local AHJ Review/Approval/Approval Letter - DHEC - Revision from IFP",
      type: 0,
      start_date: "2024-03-29T00:00:00",
      end_date: "2024-04-05T08:00:00",
      duration: 64,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "PRE-DD-1170"
    },
    {
      id: "cfc5354b-ec39-4c10-80c0-476fdce6b389",
      text: "B1 - DH-C - Power Alley  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1110"
    },
    {
      id: "4aa84633-4921-4d35-a8f7-0a725766ecf5",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-05T08:00:00",
      duration: 64,
      parent: "52d3af53-0515-442d-ae0a-d5ea0b3f489e",
      progress: 0,
      source_task_id: "MECO-1060.60"
    },
    {
      id: "34c8624c-7f37-4a45-9ae3-129542ad11fa",
      text: "B1 - DH-A - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 80,
      parent: "bbb49ac4-d9a7-4848-87c0-a96e61e2e9d9",
      progress: 0,
      source_task_id: "B1.C.A.2830"
    },
    {
      id: "0c4ad431-16f2-44fb-ab08-bd5d3dae8022",
      text: "B1 - DH-B - El Equip Yd - Pulls Cable to LB and MGPC (480V)",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 80,
      parent: "475fbabe-89c3-43ba-986e-c5e612752c64",
      progress: 0,
      source_task_id: "B1.C.B.3190"
    },
    {
      id: "137bf508-26c7-4bb5-a9d1-c9e000dd5ed7",
      text: "Architectural Precast",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 712,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 1,
      source_task_id: "PRE1470"
    },
    {
      id: "43e34f46-cb5c-482c-b889-f5b2e80cdb94",
      text: "B2 - 2D1 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-05-18T08:00:00",
      duration: 160,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1690"
    },
    {
      id: "7fba55dc-c5cc-414d-810b-b8e69060b0ef",
      text: "B1 - DH-A - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 200,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1820"
    },
    {
      id: "98a55e82-65bf-4b88-a3bb-b32c5ff3a1e0",
      text: "B2 - 2C1W - 02C.07 - Pull Wire to Euipment",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1970"
    },
    {
      id: "c91e1060-c3b3-4b0e-9566-f61c6f10d319",
      text: "IBOS  - Submittal Rvw/App'l - Fire Pump",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: null,
      duration: 72,
      parent: null,
      progress: 1,
      source_task_id: "B1.CFCI.6550"
    },
    {
      id: "50336325-26fe-40fb-ad49-08be680ced7c",
      text: "CSI BMS GCs and Fee - Develop SA Package",
      type: 0,
      start_date: "2024-03-12T00:00:00",
      end_date: "2024-03-26T00:00:00",
      duration: 80,
      parent: "d6360f93-e83f-40c0-aad2-ed0cd6c48029",
      progress: 1,
      source_task_id: "PRE1210"
    },
    {
      id: "fce56697-81f2-47bd-9e13-816fdcce0392",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area SSB (1) - DCB1",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 2376,
      parent: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      progress: 0.44,
      source_task_id: "B1.OFCI.2230"
    },
    {
      id: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 160,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1900"
    },
    {
      id: "3437cc2b-aff8-43b6-8f66-cd47ff78ff5f",
      text: "IST Finish DH D - DCB2",
      type: 0,
      start_date: "2027-03-23T08:00:00",
      end_date: "2027-03-23T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2185"
    },
    {
      id: "5001069c-b464-4458-8ac3-b61918fa2091",
      text: "Fab and Deliver - Control Power STC/SB - Area B - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 3168,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.38,
      source_task_id: "B1.OFCI.3080"
    },
    {
      id: "d1b22d64-752d-4406-9e8f-df57e2edb64d",
      text: "HMD - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "820d97d3-64ee-4b2f-bfa8-db8f13b33f4b",
      progress: 1,
      source_task_id: "B2.OFCI.1190"
    },
    {
      id: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 256,
      parent: "984b19cb-e113-48d8-94eb-b3babf498cee",
      progress: 0,
      source_task_id: "7995109"
    },
    {
      id: "b4963bea-6188-4b59-a80a-d9b78bd15943",
      text: "Fab and Deliver - Assembled Skids - Area D - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 3496,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 0.3,
      source_task_id: "B2.OFCI.2310"
    },
    {
      id: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-C - Coordination / Sign-off",
      type: 0,
      start_date: "2024-09-12T00:00:00",
      end_date: "2024-09-24T08:00:00",
      duration: 240,
      parent: "04cae6b1-1ca2-4ca5-b054-a176ccf35389",
      progress: 0,
      source_task_id: "B1.VDC.1610"
    },
    {
      id: "77060a70-8e8e-4639-962a-c35a4dc18f4d",
      text: "B1 - Network Room 2/3 - Cable Pulls between EL Room and Busway (PRED IN POWER ALLEY)",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1850"
    },
    {
      id: "7d22006d-9ae6-4099-bf6f-653b392a7059",
      text: "B2 - DH-D - Install BMS Conduit -Data Hall D",
      type: 0,
      start_date: "2026-07-02T00:00:00",
      end_date: "2026-07-30T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2450"
    },
    {
      id: "ad26aff8-ebc1-4079-b5f2-0ba8509da261",
      text: "B2 - mCUP-2 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-12T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 24,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2110"
    },
    {
      id: "3031ed11-c18a-4953-8b25-94f6d881c2c9",
      text: "B2 - DH-C - Raise HACs - Data Hall C",
      type: 0,
      start_date: "2026-05-01T00:00:00",
      end_date: "2026-05-29T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2240"
    },
    {
      id: "ae43484f-bbad-4916-9ae4-5630dee3996c",
      text: "IST Start DH D - DCB2",
      type: 0,
      start_date: "2027-03-22T00:00:00",
      end_date: "2027-03-22T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2184"
    },
    {
      id: "0e1b37a9-5332-4bc8-a007-68efbc15a930",
      text: "DFSMA - DC1 EY-B Skids ROJ - MOFE",
      type: 0,
      start_date: "2025-09-05T08:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 0,
      parent: "993a33a9-ba19-4c70-87e9-c3247582ff68",
      progress: 0,
      source_task_id: "B1.DFSMA.1030"
    },
    {
      id: "69322edc-df55-4f4a-b4f7-7c64478ebc35",
      text: "B2 - mCUP-1 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-05T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1270"
    },
    {
      id: "164cb27d-1630-4aff-a06d-f1118a0a3eaf",
      text: "Substation-2",
      type: 5,
      start_date: "2025-04-01T00:00:00",
      end_date: "2026-04-23T08:00:00",
      duration: 2728,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995213"
    },
    {
      id: "50fdd7f5-b49f-4823-928d-578670dc488b",
      text: "B2 - 2C2 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 160,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2080"
    },
    {
      id: "47e725ae-8386-41be-905c-197027a8d882",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 24,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1200"
    },
    {
      id: "42953626-3107-4257-9ab2-a37eafbe51d3",
      text: "(OFCI) B2 Static Transfer Cabinets STC",
      type: 5,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3568,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.38,
      source_task_id: "7994952"
    },
    {
      id: "23d6de3b-478c-4ff7-89f0-182b38e2e90d",
      text: "B1 - ISP Cabling - Carrier1 to MDF2 (UG)",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 40,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1070"
    },
    {
      id: "78579165-b42e-41d8-91ca-af5ec85ac8e8",
      text: "FR 09 - DPR Submit Notice of Change (Potential Cost and Schedule Impact)",
      type: 0,
      start_date: "2024-07-30T00:00:00",
      end_date: null,
      duration: 0,
      parent: "64c1284c-d6e1-4add-b5b3-bc6e1e9a4b2b",
      progress: 1,
      source_task_id: "FR.09.1010"
    },
    {
      id: "56d2e782-08b3-4159-bc1b-c4b6af629223",
      text: "B1 - mCUP-5 - Install FA  (Wire Pulls)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5080"
    },
    {
      id: "9a0af33b-f2fb-4888-9d90-267300162d89",
      text: "B2 - SSB - Install Underground Plumbing",
      type: 0,
      start_date: "2025-05-23T00:00:00",
      end_date: "2025-06-11T08:00:00",
      duration: 120,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1060"
    },
    {
      id: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f",
      text: "B2 - DH-C - Set CDU's - Data Hall C (16 total; 4 per day)",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 64,
      parent: "baee997a-04c2-4ca2-a666-b2a0788c070e",
      progress: 0,
      source_task_id: "B2.C.C.3260"
    },
    {
      id: "3258e949-ae84-4533-9bb6-a755bda58d9c",
      text: "Campus PH1 - Review for Approval - MV Vaults (SIte) ((Early Release))",
      type: 0,
      start_date: "2024-09-03T00:00:00",
      end_date: "2024-09-16T00:00:00",
      duration: 40,
      parent: "5c35e4c0-ad45-46bb-a08b-d80c5f62a9c5",
      progress: 0,
      source_task_id: "B1.CFCI.3310"
    },
    {
      id: "691913a7-5763-4234-9842-ee608ee73d01",
      text: "B1 - 1N1W - 01N1.07 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 48,
      parent: "e0c375f0-11bb-49a8-a69f-9253c12a540b",
      progress: 0,
      source_task_id: "B1.C.6440"
    },
    {
      id: "b426f8b7-5e94-4a14-9d9c-0f35f9996105",
      text: "B1 - DH-A - Pull/Term Lighting/Branch - Data Hall A",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2550"
    },
    {
      id: "4cf177df-cecb-427d-a866-dc61a330e4f6",
      text: "B1 - DH-A - Install Underground Plumbing",
      type: 0,
      start_date: "2025-03-01T00:00:00",
      end_date: "2025-03-18T08:00:00",
      duration: 120,
      parent: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      progress: 0,
      source_task_id: "B1.C.STR.1250"
    },
    {
      id: "2b321b6a-3033-4d36-818d-1894068ccc36",
      text: "BLDG-2 - Core - Overall Duration - FDN to SC A/B - (LOE)",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2027-03-05T08:00:00",
      duration: 3712,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0,
      source_task_id: "AUX.MILE.1360"
    },
    {
      id: "6f08a868-e0dd-4986-abc5-38b9e51263cd",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2100"
    },
    {
      id: "f46ca132-06e7-4cc2-89b2-466e7173b185",
      text: "B1 - DH-D - Raise HACs - Data Hall D",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1210"
    },
    {
      id: "a1343d2f-d312-4ef1-8d19-7ba869df2c32",
      text: "BLDG-1/2 - Prep / Submit for Review - Pre-Fab Guardhouse",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 200,
      parent: "54ea1ba9-ddf2-452c-881b-cedd12f21266",
      progress: 0,
      source_task_id: "B1.CFCI.5830"
    },
    {
      id: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      text: "B2 - DH-C - Precast",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 40,
      parent: "03b1cd35-79d5-48f0-a78d-368c4e4a2d8b",
      progress: 0,
      source_task_id: "B2.C.1700"
    },
    {
      id: "16062421-2efe-49ff-8f60-1166653c5e5a",
      text: "B2 - SSB - 2E2 - Common - In Wall Rough In Security",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1510"
    },
    {
      id: "b8ea20d5-b98b-42f7-aee5-fed060a753ae",
      text: "B1 - 1N1E - 01N4.06 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6240"
    },
    {
      id: "190f6a18-d05a-4953-94d5-86ec3362ab5a",
      text: "B1 - mCUP-1 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-12T08:00:00",
      duration: 24,
      parent: "b394bc5d-6c5a-433d-9980-024a535cda33",
      progress: 0,
      source_task_id: "B1.mCUP.1280"
    },
    {
      id: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      text: "Cx Bldg 2 L2 Commissioning",
      type: 5,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-12-17T08:00:00",
      duration: 1008,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7995002"
    },
    {
      id: "754fc69d-b798-452e-a865-47a7a190ce80",
      text: "B2 - DH-B - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 24,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1830"
    },
    {
      id: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      text: "B1 - SSB - 1E2 - Common - Frame Walls (Top-out included)",
      type: 0,
      start_date: "2025-05-27T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 96,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1010"
    },
    {
      id: "980d4c30-4282-42f0-97c1-7e787e90a56e",
      text: "B2 - Specialties - Lighting/Pulls/Terms",
      type: 0,
      start_date: "2026-06-30T00:00:00",
      end_date: "2026-07-14T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1070"
    },
    {
      id: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      text: "ISP - B2 - Phase 4 (OH)",
      type: 5,
      start_date: "2026-05-12T00:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 1112,
      parent: "c1a638e7-549d-4c75-aeb8-352bec505620",
      progress: 0,
      source_task_id: "7995463"
    },
    {
      id: "1295b4b6-67b6-40a3-842f-3dee76459aa2",
      text: "B1 - DH-D - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 80,
      parent: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      progress: 0,
      source_task_id: "B1.C.RF.1470"
    },
    {
      id: "259cd2ff-2f2c-4882-8de7-0863b0131218",
      text: "(CFCI) Div. 21 - Fire Suppression",
      type: 5,
      start_date: "2024-09-23T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 440,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994911"
    },
    {
      id: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a",
      text: "PHASE 2 Substantial Completion",
      type: 0,
      start_date: "2026-10-07T08:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 0,
      parent: "881c9656-cd55-4fd5-ab3e-dc15c87fd08a",
      progress: 0,
      source_task_id: "CX.MIL.1030"
    },
    {
      id: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9",
      text: "B1 - mCUP-9 - L2 Inspections",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 80,
      parent: "326c3858-5e96-4793-bf7c-765e317b18fc",
      progress: 0,
      source_task_id: "B1.mCUP.9130"
    },
    {
      id: "57124ac6-576b-4cfa-a44f-7992a1a97af9",
      text: "Site / UG BIM - Area 5 - Remaining Utilities - Coordination / Sign Off",
      type: 0,
      start_date: "2024-05-20T00:00:00",
      end_date: "2024-06-25T08:00:00",
      duration: 208,
      parent: "8331d266-0138-4b68-98a0-04c6efcc3613",
      progress: 0.92,
      source_task_id: "SITE.VDC.1110"
    },
    {
      id: "2bacf041-bef2-4329-968a-ec11643eafe5",
      text: "FR 33 - DPR Prepare and Submit PCO#32",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "cfd3da95-4550-42a9-b5c7-a1c53c8da4cb",
      progress: 0.5,
      source_task_id: "FR.33.1010"
    },
    {
      id: "3821e008-bd7a-483f-8d1f-538e64dc2ec4",
      text: "(CFCI) Div. 09 - Gypsum System & Ceilings",
      type: 5,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 400,
      parent: "88a16a24-d160-4e00-8516-9659424e2d90",
      progress: 0,
      source_task_id: "7994882"
    },
    {
      id: "663029a7-4ced-4347-bfaa-aec34f42efb3",
      text: "B2 - DH-A - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "dee2ab9c-14a9-4fbb-b398-3e7db451b921",
      progress: 0,
      source_task_id: "B2.C.STR.1120"
    },
    {
      id: "cc46a90d-fbfe-431a-953c-76d8483e2429",
      text: "B2 - DH-B - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 240,
      parent: "e97bec09-09e1-450b-9a9a-cf80f3f062a1",
      progress: 0,
      source_task_id: "B2.C.STR.1670"
    },
    {
      id: "03896984-e578-4d81-8e6f-b4daa727a03e",
      text: "B2 - DH-B - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 120,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1230"
    },
    {
      id: "3b8af22f-0d45-435a-a57f-d5df4c41d061",
      text: "BLDG-1/2 - Prep / Submit for Review - Struc. Conc. (Fdn Ready Mix)",
      type: 0,
      start_date: "2024-09-26T00:00:00",
      end_date: "2024-10-04T08:00:00",
      duration: 56,
      parent: "f516d625-fc35-4562-b467-ea8f751e08e8",
      progress: 0,
      source_task_id: "B1.CFCI.1000"
    },
    {
      id: "32c3858b-fe37-4788-870d-c77b2888f113",
      text: "Glass & Metal Panel SA - Meta Authorized",
      type: 0,
      start_date: "2024-08-09T08:00:00",
      end_date: "2024-08-09T08:00:00",
      duration: 0,
      parent: "060887f5-b149-4718-82cf-ace0a752a374",
      progress: 0,
      source_task_id: "ICM.PRE.1450"
    },
    {
      id: "c3ca8ee2-0a61-489f-b8c6-fe806ddaa3e2",
      text: "B1 - 1N2E - 01N3.05 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6470"
    },
    {
      id: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      text: "(OFCI) B2 CDU Cooling Distribution Unit",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 4464,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0.05,
      source_task_id: "7994948"
    },
    {
      id: "242b840f-4286-4024-ad0c-d23559852167",
      text: "B2 - 2E1E - EF4 - Fire Alarm Wire Pulls/Terms to devices (EF4)",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 48,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5260"
    },
    {
      id: "759cfae2-a02b-4c92-9c18-78e7d5693907",
      text: "B1 - SSB - 1E1 - CMDF1 - In Wall Rough-In/ Inspections (Carrier MDF1)",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 48,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1430"
    },
    {
      id: "2c0e4f36-6ad9-4cd5-87d2-b7f5516432ca",
      text: "BLDG-1 DH-A",
      type: 5,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-04-04T08:00:00",
      duration: 280,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995403"
    },
    {
      id: "c35abc49-152c-4331-98d8-5370416ca04b",
      text: "B2 - DH-B - External Framing/Blocking/Sheathing (Roof Edge /Expansion Joints)",
      type: 0,
      start_date: "2025-10-23T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 40,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1020"
    },
    {
      id: "5fc606c5-5219-4322-9c84-02b4379f499d",
      text: "BLDG-1 DH-A Level 2 Checkout",
      type: 5,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 336,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "7995270"
    },
    {
      id: "9b59ba30-4f53-474d-91f2-380d4431197d",
      text: "B1 - mCUP-3 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-08-09T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 48,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3020"
    },
    {
      id: "95b15abc-0f1f-4d1c-b937-9f48d0736ba0",
      text: "Fab and Deliver - MVS-3WAY - Area CUP (8) - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-19T08:00:00",
      duration: 2536,
      parent: "734c27e2-288a-4853-bd7b-995c52cdc6f6",
      progress: 0.37,
      source_task_id: "B2.OFCI.2050"
    },
    {
      id: "96b6355b-571c-4374-9b17-0936c10f67f1",
      text: "B1 - SSB - 1E1 - Common - Point-Up Drywall",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 64,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2400"
    },
    {
      id: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b",
      text: "B1 - DH-A - Power Alley - Skid Integration Complete including Inspections",
      type: 0,
      start_date: "2025-09-27T08:00:00",
      end_date: "2025-09-27T08:00:00",
      duration: 0,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.2300"
    },
    {
      id: "b19dd44a-b6f2-418c-a220-b7b75a1753f9",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area B (22) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-20T08:00:00",
      duration: 2808,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.45,
      source_task_id: "B2.OFCI.1710"
    },
    {
      id: "ac7f1e44-9b71-4772-9acc-b8127cb064e0",
      text: "CDU - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-04-10T08:00:00",
      duration: 304,
      parent: "9cbbb9ac-ff5b-42c3-9e71-bd424094da70",
      progress: 1,
      source_task_id: "B1.OFCI.1680"
    },
    {
      id: "5f2daa78-32dc-49a6-9769-7506968e9153",
      text: "BLDG-1 - BIM - Tier 0 - Area 1-E / 1-F - Coordination / Sign-off",
      type: 0,
      start_date: "2024-06-17T00:00:00",
      end_date: "2024-08-05T08:00:00",
      duration: 280,
      parent: "aaa0fbd3-c982-483f-83c9-aa6fc59b7f97",
      progress: 0.14,
      source_task_id: "B1.VDC.1020"
    },
    {
      id: "7f7651ef-2b96-41db-b783-a6aeaeab96b0",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-17T08:00:00",
      duration: 80,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.2550"
    },
    {
      id: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      text: "B2 - 2E2E - EF2 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF2)",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 8,
      parent: "fc625a2c-f7cb-492b-b9f0-0a9f65328da2",
      progress: 0,
      source_task_id: "B2.C.6350"
    },
    {
      id: "12303049-4506-470d-a35f-e5a38e13b3ab",
      text: "B1 - West Entrance - Form / Pour Side walks",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 160,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1020"
    },
    {
      id: "58e94545-4197-4edd-89ef-707997c1586e",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1270"
    },
    {
      id: "e09962c2-1280-44e4-b721-8c9cefb6d762",
      text: "B1 - 1N1W - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 8,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5270"
    },
    {
      id: "91160375-ff37-4074-b7a4-e2bceca5e402",
      text: "B1 - DH-C - Hookup FCAs Mechanical - Data Hall C",
      type: 0,
      start_date: "2025-10-10T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2160"
    },
    {
      id: "5103ab08-e938-4718-8559-b5089f2da12f",
      text: "B1 - DH-D - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 928,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "B1.C.D.3000"
    },
    {
      id: "07cbd25c-ad24-48c9-9d7c-1b8bbd4825de",
      text: "Area 5 - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-02-20T08:00:00",
      duration: 296,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1840"
    },
    {
      id: "33d2ca25-798d-44f0-8d98-16b1136565d9",
      text: "Fab and Deliver - MSB - Area D - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3808,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.38,
      source_task_id: "B2.OFCI.2490"
    },
    {
      id: "652f2110-2640-43d1-a516-940cd51ee8e6",
      text: "B2 - mCUP-3 - Install BMS Controls (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-14T08:00:00",
      duration: 48,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3060"
    },
    {
      id: "2ebc6d16-4aed-4085-9462-fbd38edacb2b",
      text: "L3 Finish mCUP  - DCB2",
      type: 0,
      start_date: "2026-08-27T08:00:00",
      end_date: "2026-08-27T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2071"
    },
    {
      id: "4f477a94-9215-46cb-9ded-d5fc9fba33cc",
      text: "B2 - DH-A - Install Celing Devices BMS - Data Hall A",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-06-12T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2620"
    },
    {
      id: "511e123e-5566-4e5b-beec-35254b02ad1c",
      text: "BLDG-1/2 - Prep / Submit for Review - Foundation Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-09-30T00:00:00",
      end_date: "2024-10-11T00:00:00",
      duration: 56,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6060"
    },
    {
      id: "d185c091-680c-4cc0-9628-0a768f0df849",
      text: "B1 - DH-C - El Equip Yd - Test/Terms from MSB/RSB to Generator",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 80,
      parent: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      progress: 0,
      source_task_id: "B1.C.C.3140"
    },
    {
      id: "6892a1d6-5f3d-47a1-8a24-d85b217130c8",
      text: "B2 - 2D2 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-06-05T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 120,
      parent: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      progress: 0,
      source_task_id: "B2.C.D.2050"
    },
    {
      id: "96b1ef9d-9d2a-4044-8b3f-cfb3d7dffcf2",
      text: "BLDG-1 - BIM - Tier 1 - Admin - Coordination / Sign-off",
      type: 0,
      start_date: "2024-08-14T00:00:00",
      end_date: "2024-09-12T08:00:00",
      duration: 240,
      parent: "0b068a4f-9be9-40d8-99dd-d9f5c60a2d1f",
      progress: 0,
      source_task_id: "B1.VDC.1680"
    },
    {
      id: "b73b7110-66c4-4442-8045-dba93d833e09",
      text: "B2 - DH-C - Wall build/Rough In/ OH Rough (Converted to LOE)",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-03-04T08:00:00",
      duration: 224,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1020"
    },
    {
      id: "3d2430cc-754c-4f4f-bddb-86c58f6b5409",
      text: "B2 - DH-C - Install Tech Water - Data Hall C",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1920"
    },
    {
      id: "23727721-3eda-48aa-8572-be386fbd9fee",
      text: "Campus - Install Campus Landscape (LOE)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2026-09-01T08:00:00",
      duration: 2480,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1000"
    },
    {
      id: "57a608c3-7a40-477c-b4df-c255bb6c8650",
      text: "Area B - Install Interior Signage",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1450"
    },
    {
      id: "792f0d54-506f-4726-b996-5b44afaba48f",
      text: "FRP Equipment Pads",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "ADMIN.SI.1000"
    },
    {
      id: "6b8a5918-9218-40e6-9c5d-1ceb484db936",
      text: "B2 - DH-B - El Equip Yd - Buildout MSG and Set-In Place inspections",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      progress: 0,
      source_task_id: "B2.C.EY.1120"
    },
    {
      id: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      text: "(OFCI) B1 Cooling Towers",
      type: 5,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 2944,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.36,
      source_task_id: "7994968"
    },
    {
      id: "4efd5231-7150-4744-96e0-273c2f8e1536",
      text: "B1 - DH-B - Install Lighting/Branch Conduit -Data Hall B",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2650"
    },
    {
      id: "48d1d251-23e1-4a82-a01d-599d571d4767",
      text: "B2 - 2E1E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-12-09T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 8,
      parent: "72358187-39e2-4897-911b-ac88757bd142",
      progress: 0,
      source_task_id: "B2.C.5130"
    },
    {
      id: "21ca4579-a34a-49a5-9281-c916d9780229",
      text: "B2 - 2E2E - 02.01.E1.02 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "e127f3db-21a8-432c-b1ce-ebb244c86f20",
      progress: 0,
      source_task_id: "B2.C.6260"
    },
    {
      id: "9383a3ca-5027-45ac-8498-7424f91cf7fe",
      text: "B1 - mCUP-4 - Set in Place Inspections",
      type: 0,
      start_date: "2025-08-22T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 8,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4030"
    },
    {
      id: "a3f38060-4ee9-44a8-82d3-0ae1d8d78e12",
      text: "B1 - 1N1E - 01N4.07 - Install Humidifiers and CRAC Units",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6070"
    },
    {
      id: "6f5d15b6-3801-4b83-9da3-89ba5b3dc781",
      text: "(CFCI) Div. 09 - Ceramic Tile, Carpet",
      type: 5,
      start_date: "2024-12-09T00:00:00",
      end_date: "2025-04-17T08:00:00",
      duration: 720,
      parent: "88a16a24-d160-4e00-8516-9659424e2d90",
      progress: 0,
      source_task_id: "7994876"
    },
    {
      id: "dc1caeca-a28e-4188-95c4-d27f56f7646b",
      text: "Install Toilet Accessories",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2025-12-26T08:00:00",
      duration: 80,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1190"
    },
    {
      id: "2366d88c-3d82-4bce-9d32-324a70288556",
      text: "BLDG-1/2 - (SPW - Div 07) Submittals - Below Grade Waterproofing (revision)",
      type: 0,
      start_date: "2024-11-05T00:00:00",
      end_date: null,
      duration: 32,
      parent: null,
      progress: 1,
      source_task_id: "B1.CFCI.6500"
    },
    {
      id: "ed94b3f4-6b7b-4db3-b961-3f0c9d2cafbe",
      text: "IBOS  - Fabricate / Deliver - Fire pump",
      type: 0,
      start_date: "2024-10-21T00:00:00",
      end_date: null,
      duration: 752,
      parent: null,
      progress: 0.07,
      source_task_id: "B1.CFCI.6540"
    },
    {
      id: "60c49587-0ac1-4fea-a483-61af60db4cec",
      text: "Precast Area A",
      type: 5,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 48,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995408"
    },
    {
      id: "df0c4b83-465b-4731-882f-998d372421dc",
      text: "Area 3 - Fire Water Install Offsets for mCUP piping",
      type: 0,
      start_date: "2024-11-22T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A3.8160"
    },
    {
      id: "bffb2894-d9a1-4574-a38a-990de512a65d",
      text: "B1 - SSB - 1E2 - Common - Install Device Tiles",
      type: 0,
      start_date: "2025-08-26T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2000"
    },
    {
      id: "862ebf7a-ac0e-4164-ba6f-7343140eb5ad",
      text: "(OFCI) Substation HPD",
      type: 5,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-12-31T08:00:00",
      duration: 1768,
      parent: "9da5f81b-8614-46c6-991f-45da12733b0a",
      progress: 0.62,
      source_task_id: "7994942"
    },
    {
      id: "805fb94f-c3e9-415d-add6-3d55bd24feb6",
      text: "Trailer city- under trailer- Elect / Mech Connections",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "HRA.1150"
    },
    {
      id: "72d87cd3-c14b-4c54-90ab-fe759c12b65b",
      text: "Campus PH1 - Review for Approval -T-Comm Vaults (Site) ((Early Release))",
      type: 0,
      start_date: "2024-07-26T00:00:00",
      end_date: "2024-08-02T08:00:00",
      duration: 40,
      parent: "9aadc098-1eab-461a-98e5-e41d805e610b",
      progress: 0,
      source_task_id: "B1.CFCI.3330"
    },
    {
      id: "57926fa2-fcec-4df4-ab67-93e924fca539",
      text: "Area 4 - UG RI -Mechanical Distribution Panel (HMD) (FCA/CDU/MCUP)-DCB2",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-24T08:00:00",
      duration: 192,
      parent: "c914a4f7-21d4-4bd9-9b44-4ed486947fe0",
      progress: 0,
      source_task_id: "MECO-1710"
    },
    {
      id: "dc7d2dd6-d734-4372-a0f8-36c27e8a318f",
      text: "B1 - 1B2E - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1090"
    },
    {
      id: "f39ece41-5135-4375-8bd0-5d408dafc6f8",
      text: "FR 08 - META/ EOR Incorporate and issue CCD#39",
      type: 0,
      start_date: "2024-08-12T00:00:00",
      end_date: null,
      duration: 208,
      parent: "5a900ad8-3a89-45d8-acc0-7fde216019c3",
      progress: 1,
      source_task_id: "FR.08.1040"
    },
    {
      id: "f26e75a4-1291-458f-9ded-95a48f58db64",
      text: "B2 - DH-B - Backfill",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 40,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1390"
    },
    {
      id: "b799e883-fef0-453b-a1de-e82ebda8573b",
      text: "UPS - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 1,
      source_task_id: "B1.OFCI.1060"
    },
    {
      id: "428d9872-6a5e-4a1f-8a6f-e5fcde83c629",
      text: "Fab and Deliver - RSB - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-05-23T08:00:00",
      duration: 2904,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.46,
      source_task_id: "B1.OFCI.2740"
    },
    {
      id: "869c0fd1-d268-4947-bc05-382d13ad03db",
      text: "Precon- Early Precon",
      type: 5,
      start_date: "2023-08-28T00:00:00",
      end_date: "2023-11-15T00:00:00",
      duration: 448,
      parent: "aed8067e-954d-446f-ada1-f2aa2b5bd235",
      progress: 1,
      source_task_id: "7994726"
    },
    {
      id: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734",
      text: "Campus - Fabricate / Deliver - Sanitary Manholes and Inlets (Remaining)",
      type: 0,
      start_date: "2024-06-04T00:00:00",
      end_date: "2024-07-15T08:00:00",
      duration: 232,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 0.5,
      source_task_id: "B1.CFCI.5940"
    },
    {
      id: "6c1113ac-e550-4f9e-b04c-6bb17c7656e3",
      text: "B2 - Deep Telecom - EF3 - Concrete Scope",
      type: 0,
      start_date: "2025-02-28T00:00:00",
      end_date: "2025-03-06T08:00:00",
      duration: 40,
      parent: "27942519-4b3d-4062-aac5-6d9381642a1d",
      progress: 0,
      source_task_id: "B2.C.STR.2460"
    },
    {
      id: "84647bb3-9204-4384-a921-15a7c2271182",
      text: "PLC Panels - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "a93f034a-dbcd-43ee-8892-ca30d2c20676",
      progress: 1,
      source_task_id: "B1.OFCI.1630"
    },
    {
      id: "49d64f15-0d08-416d-abbe-7b5951402325",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (B)",
      type: 0,
      start_date: "2026-02-11T08:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 0,
      parent: "a9b0b7b3-691c-4bf3-b255-5085ef8b94aa",
      progress: 0,
      source_task_id: "B2.DFSMA.1390"
    },
    {
      id: "0bf114cf-77c0-4475-9c6b-2d91c4adead9",
      text: "B2 - mCUP-1-8 - Make Up Water Building - Building Dry in",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-26T08:00:00",
      duration: 160,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1070"
    },
    {
      id: "448b4847-644e-4690-8d9e-4b40fa0e33b2",
      text: "BLDG-2 DH-D - Equipment Final Clean",
      type: 0,
      start_date: "2026-11-25T00:00:00",
      end_date: "2026-12-17T08:00:00",
      duration: 120,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1090"
    },
    {
      id: "0a5e58fa-7f9e-4c4b-bd60-3ed13109e19e",
      text: "BLDG-1/2 - Fabricate / Deliver - Joint Sealants",
      type: 0,
      start_date: "2024-12-18T00:00:00",
      end_date: "2025-01-02T08:00:00",
      duration: 80,
      parent: "0dd0f158-898f-4192-8581-e48c7623784f",
      progress: 0,
      source_task_id: "B1.CFCI.5040"
    },
    {
      id: "478f4b22-0e5d-4360-a1a8-fb79d4a93143",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Security",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1620"
    },
    {
      id: "3d72c927-328e-4896-a719-ac1d8a442e91",
      text: "B2 - mCUP-8 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-11-26T08:00:00",
      duration: 16,
      parent: "f0b84fa5-1993-40c9-bef7-d97c80890f5e",
      progress: 0,
      source_task_id: "B2.mCUP.8030"
    },
    {
      id: "c52d5305-7797-41b8-9bc2-3ddfeb3aa3ee",
      text: "Area B - HTF Ceilings",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1320"
    },
    {
      id: "62700687-f8dd-48aa-af04-5cf93229b85c",
      text: "Specialities",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: null,
      duration: 520,
      parent: null,
      progress: 0,
      source_task_id: "8717096"
    },
    {
      id: "ae06decc-04aa-4c15-96ae-b8c5b99a2668",
      text: "OH Fire Alarm",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1420"
    },
    {
      id: "aa2bf968-f58d-46f1-8f5b-4d8dbdd16798",
      text: "Apply Fire Retardant @ Gluelam Plenum Spaces",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1570"
    },
    {
      id: "731caeb4-e25e-4854-96ca-86afa311f0b1",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Fire Alarm",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1090"
    },
    {
      id: "8cfc3b80-1927-4703-ad34-75cee8c3478a",
      text: "Precon Kick Off (Target Value, Risk, Schedule)",
      type: 0,
      start_date: "2023-11-14T00:00:00",
      end_date: "2023-11-14T00:00:00",
      duration: 0,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "ICM.PRE.1000"
    },
    {
      id: "7ba011a2-9dca-4252-ae6f-67961d89d001",
      text: "B2 - 2B1  (GS.IDF.2A1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "f04fa6a4-5935-4098-b876-0aed01bb39d8",
      progress: 0,
      source_task_id: "B2.C.B.2430"
    },
    {
      id: "a2df2132-9675-48fd-bc61-2395e26eb1e6",
      text: "BLDG-1/2 - Submittal Rvw/App'l - SOG/SOMD/Pads Struc. Conc. (Rebar)",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "c05e8848-04b6-4f2c-87be-747ae48e68bc",
      progress: 0,
      source_task_id: "B1.CFCI.5670"
    },
    {
      id: "9580999a-4c4c-4988-83ac-4c63b205e54c",
      text: "B2 - 2E2E - 02.01.E2.01 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      progress: 0,
      source_task_id: "B2.C.6230"
    },
    {
      id: "578e4efb-394e-4710-b082-79db1ce54fe1",
      text: "B1 - 1C1W - 01C.07 - Lighting and Devices",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-06T08:00:00",
      duration: 48,
      parent: "d13f9b9c-80c5-452e-9e3b-eff6886453a4",
      progress: 0,
      source_task_id: "B1.C.C.2220"
    },
    {
      id: "fe266e05-3e6d-4628-8f3c-5ba5c530d17a",
      text: "DFSMA - DC2 DHC HAC ROJ - MOFE",
      type: 0,
      start_date: "2026-04-02T08:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 0,
      parent: "f0d9ef4f-191d-4d39-9779-5b0274a8fb64",
      progress: 0,
      source_task_id: "B2.DFSMA.1050"
    },
    {
      id: "5ecb607e-775d-43de-9e28-e84b3e84f988",
      text: "B1 - DH-D - Install Feeder Conduit -Data Hall D",
      type: 0,
      start_date: "2025-12-18T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1230"
    },
    {
      id: "9ab030f3-750a-4f16-a272-3f9edd13b884",
      text: "B1 - SSB - 1E2 - Common - In Wall Rough In Electrical",
      type: 0,
      start_date: "2025-06-09T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1160"
    },
    {
      id: "43744881-6f63-4765-ac73-c4430f424f77",
      text: "B2 - 2A1 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-01-08T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 80,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1630"
    },
    {
      id: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      text: "B1 - DH-A - Corpnet Provisioning",
      type: 0,
      start_date: "2025-12-26T00:00:00",
      end_date: "2026-01-16T08:00:00",
      duration: 120,
      parent: "be84be3c-8fff-4c8f-b6d7-8c41896ac51b",
      progress: 0,
      source_task_id: "B1.CONN.1290"
    },
    {
      id: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      text: "GS.IDF.2B2",
      type: 5,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 736,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "7995073"
    },
    {
      id: "c77e0f92-3b07-449c-96fa-d2b6bf76effd",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2170"
    },
    {
      id: "9fbd5493-3b5b-4129-a0a7-d6250e97ba6d",
      text: "B2 - DH-D - Install Joists",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 120,
      parent: "574dfca6-2f1f-451e-9f16-1b2c8f2c9cd0",
      progress: 0,
      source_task_id: "B2.C.STR.1840"
    },
    {
      id: "9072c387-f08c-4cc9-8452-286f8800234f",
      text: "Building 2 mCUP-4",
      type: 5,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 448,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "7995149"
    },
    {
      id: "f764d1ed-77ec-4afb-a627-a67975c11e76",
      text: "[DCB1] DEC-C Ready: OSP Non-Primary Pathways",
      type: 0,
      start_date: "2025-09-17T08:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 0,
      parent: "9891a12b-317f-4e75-b19d-839bbb100ad1",
      progress: 0,
      source_task_id: "ICM.B1.3393"
    },
    {
      id: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b",
      text: "B1 - DH-D - Install Underground Telecom",
      type: 0,
      start_date: "2025-04-15T00:00:00",
      end_date: "2025-04-25T08:00:00",
      duration: 80,
      parent: "bded9958-5e3f-4ab3-8ea2-528829a3939b",
      progress: 0,
      source_task_id: "B1.C.STR.1720"
    },
    {
      id: "7fdbb9cd-57b1-4d68-b277-70b803118d05",
      text: "Construction Complete DAS Tower - Phase1",
      type: 0,
      start_date: "2025-11-13T08:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1188"
    },
    {
      id: "9d77e203-2558-4082-95d5-8a88999f2e4e",
      text: "B1 - ISP Cabling - IDFD to DHD (GS tray)",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 200,
      parent: "815f44ae-e840-404c-b464-7f2586ba6d74",
      progress: 0,
      source_task_id: "B1.CONN.1420"
    },
    {
      id: "75bced8e-c5ec-47be-bc53-70499005906b",
      text: "B1 - DH-A - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 848,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "B1.C.A.2890"
    },
    {
      id: "bcbbbc9b-24ca-4668-b095-cd234241f82e",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-13T08:00:00",
      duration: 64,
      parent: "92aa8a33-1e8a-4967-95ad-e4391a98b9cd",
      progress: 0,
      source_task_id: "MECO-1060.20"
    },
    {
      id: "f214a3c1-728d-4440-8681-2ec49a09b834",
      text: "Fire Water",
      type: 5,
      start_date: "2024-12-19T00:00:00",
      end_date: "2025-01-15T08:00:00",
      duration: 160,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995176"
    },
    {
      id: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3",
      text: "Substation-2 - MSG B - Assembly",
      type: 0,
      start_date: "2025-12-01T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 136,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4330"
    },
    {
      id: "22ea2ca3-9993-4776-856e-8cb96dc795bc",
      text: "In-Wall Blocking",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1580"
    },
    {
      id: "82de2168-e717-48cd-85cc-c0d71269d36c",
      text: "Substation-2 - Pad Prep (Includes IDF Hut)",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 80,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4200"
    },
    {
      id: "dc4f7c12-f003-4b56-b9ad-9c47268fa8ca",
      text: "Utility Provider Substation-1 - ready of Cx (DELETE)",
      type: 0,
      start_date: "2024-07-26T08:00:00",
      end_date: "2024-07-26T08:00:00",
      duration: 0,
      parent: "c99b52b5-cb9e-4df2-b38d-079c1e174658",
      progress: 0,
      source_task_id: "CX0.USS.L2.0030"
    },
    {
      id: "32197d4f-991d-4a60-a244-d393e14fa540",
      text: "B1 - 1N2W - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 120,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2290"
    },
    {
      id: "4dd7c528-9ce8-4b6b-9c59-af769c63915e",
      text: "Precast SSB",
      type: 5,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-10T08:00:00",
      duration: 80,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "7995025"
    },
    {
      id: "a8cb18bb-f8c6-43c0-abd5-e4f3202dc7ea",
      text: "B2 - DH-D - Room QA/QC Pre DEC-C Turnover - Data Hall D",
      type: 0,
      start_date: "2026-10-01T00:00:00",
      end_date: "2026-10-28T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2680"
    },
    {
      id: "df988812-a62c-4468-8839-b1ffff168ac2",
      text: "B1 - Network Room 2/3 - Install 800 Amp Busway",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1530"
    },
    {
      id: "d6015d46-abf0-42b7-a87e-0d68d7c85fb9",
      text: "B1 - 1C2E - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1300"
    },
    {
      id: "a22cfa0d-3463-4508-b367-286054b932df",
      text: "GMP Review by Legal",
      type: 0,
      start_date: "2024-06-04T00:00:00",
      end_date: "2024-07-01T08:00:00",
      duration: 160,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 0.7,
      source_task_id: "PRE-ES-1130"
    },
    {
      id: "1408ad3b-7be3-48a2-beeb-930ec7f724ab",
      text: "B2 - 2E2E - Corridor - Room Fit Out Activities - Set/Hook-Up Equipment",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 160,
      parent: "5febf4c4-aa14-49f0-aa66-7dc1af6da8d5",
      progress: 0,
      source_task_id: "B2.C.6490"
    },
    {
      id: "be8b8449-acd6-4ab9-b1c9-58dc97dc206a",
      text: "IBOS - Shopdrawings Rvw/App'l - Lighting",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: "2024-11-06T00:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.PROC.1160"
    },
    {
      id: "796c370d-3581-49f3-8a97-a1459bd2664e",
      text: "B1 - 1N1W - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "d8b87ed3-4282-4138-ab01-dad17637c355",
      progress: 0,
      source_task_id: "B1.C.5970"
    },
    {
      id: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce",
      text: "B2 - ISP Cabling - EF to IDFB (UG)",
      type: 0,
      start_date: "2026-07-13T00:00:00",
      end_date: "2026-07-24T08:00:00",
      duration: 80,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1130"
    },
    {
      id: "b51a00f8-c294-4f79-8a59-46f0176024a8",
      text: "B2 - mCUP-6 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-11-11T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 80,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.8210"
    },
    {
      id: "25c6555c-ad06-479c-88a6-9affe166e870",
      text: "Assembled Skids - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "b2c6b2e2-798c-4496-80b4-5fe336fd7237",
      progress: 1,
      source_task_id: "B2.OFCI.1360"
    },
    {
      id: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc",
      text: "B1 - DH-A - Set FCA's - Data Hall A",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1780"
    },
    {
      id: "432f8af0-1e02-4aca-a6ac-03ecb4f29211",
      text: "B1 - DH-D - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1480"
    },
    {
      id: "6eb707fe-64b7-4766-bce1-e198dea069d3",
      text: "B1 - DH-D - Power Alley  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1500"
    },
    {
      id: "cc1d02ba-1984-4145-b198-531dd6c14d25",
      text: "B2 - mCUP-3 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3120"
    },
    {
      id: "b89c1637-41cf-4e4b-8dce-47ec3a07d263",
      text: "BLDG-2 - BIM - Tier 1 - Area 2-A - Coordination / Sign-off",
      type: 0,
      start_date: "2025-03-27T00:00:00",
      end_date: "2025-04-15T08:00:00",
      duration: 240,
      parent: "1e8886aa-f56f-4148-b16c-c79188f75884",
      progress: 0,
      source_task_id: "B2.VDC.3090"
    },
    {
      id: "68506006-d589-4d8a-a629-cea2657e4216",
      text: "B2 - DH-A - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 80,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1370"
    },
    {
      id: "edfd9ebd-60f8-4018-b381-03b2cfe02afb",
      text: "FR 33 - META review and Approve PCO#32",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 80,
      parent: "cfd3da95-4550-42a9-b5c7-a1c53c8da4cb",
      progress: 0,
      source_task_id: "FR.33.1020"
    },
    {
      id: "a8070082-6987-4f1a-ad1e-e918ac33e006",
      text: "B1 - DH-D - Hookup FCAs Electrical- Data Hall D",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1180"
    },
    {
      id: "7aaeb0b1-c391-42ed-9ef0-9a64db1a74a2",
      text: "Install OH Doors & Loading Dock Equipment",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1100"
    },
    {
      id: "0cb8d2d6-9f62-452e-8872-7a2a92cdb29f",
      text: "B2 - DH-B - Install Celing Devices Fire Protection - Data Hall B",
      type: 0,
      start_date: "2026-06-08T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2820"
    },
    {
      id: "119f7be2-71ec-4be5-81c8-eca228889ad6",
      text: "Substation-1 - B Lineup SF6 Breaker - L3 Dead Bus Checkout and NETA Testing",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "ea4a89de-c4b3-4e7f-b183-ad6e0d66f6b1",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3830"
    },
    {
      id: "8fd5e04f-22cb-4bce-aa4f-3e48975b0c35",
      text: "Mechanical SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-03-12T00:00:00",
      end_date: "2024-03-19T00:00:00",
      duration: 40,
      parent: "1039d9e5-5a59-40d1-ae52-e112475d85ca",
      progress: 1,
      source_task_id: "PRE1310"
    },
    {
      id: "518e8f16-eed9-4ae6-bc01-b215655bde57",
      text: "B1 - 1A2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 120,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2220"
    },
    {
      id: "10f00308-3d04-4a4b-b312-9d2d62948488",
      text: "Complete U/G Sweeps",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 40,
      parent: "621592be-cc33-40c4-89df-9cd0aa53b294",
      progress: 0,
      source_task_id: "ADMIN.SI.1030"
    },
    {
      id: "ae7ea8da-f3ad-4e6a-ab19-8fa1df47665a",
      text: "BLDG-2 - BIM - Tier 1 - Area 2-D - Coordination / Sign-off",
      type: 0,
      start_date: "2025-06-04T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 240,
      parent: "1cb75608-ea15-4d7d-a6f5-dc6bf4d3a50a",
      progress: 0,
      source_task_id: "B2.VDC.3180"
    },
    {
      id: "e17bbfbd-e978-4085-a0cf-46e9a690e99a",
      text: "B1 - DH-C - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-13T08:00:00",
      duration: 48,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2300"
    },
    {
      id: "8142724a-3f36-4387-856c-5932970c5e44",
      text: "Electrical GCs and Fee SA - Meta Review / Authorization",
      type: 0,
      start_date: "2024-02-27T00:00:00",
      end_date: "2024-03-04T08:00:00",
      duration: 40,
      parent: "1039d9e5-5a59-40d1-ae52-e112475d85ca",
      progress: 1,
      source_task_id: "PRE1300"
    },
    {
      id: "18a14275-6a54-4ab1-a1cb-afdfceea337c",
      text: "L4 - SSB *On Temp Power*",
      type: 0,
      start_date: "2026-02-02T00:00:00",
      end_date: "2026-03-02T08:00:00",
      duration: 160,
      parent: "4369f389-9fe8-4df0-bc21-bd2bf19e070e",
      progress: 0,
      source_task_id: "CX4.B1.NS.1010"
    },
    {
      id: "3c2016a7-5cee-448c-9844-c1e76ead6713",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1380"
    },
    {
      id: "357928b4-594c-4b0e-a88b-371966429ca8",
      text: "B2 - 2B2 - Corridor -Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-15T08:00:00",
      duration: 40,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.2040"
    },
    {
      id: "b72687f8-5862-451e-afde-3cf80999acfb",
      text: "B2 - DH-B - Install HAC Lights - Data Hall B",
      type: 0,
      start_date: "2026-04-17T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2630"
    },
    {
      id: "410bdc8c-729a-4ecd-99de-d83ed4b9c47f",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-06-12T00:00:00",
      end_date: "2026-06-25T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2070"
    },
    {
      id: "c656b628-342f-44cf-9db2-d204c99097f4",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-11-20T00:00:00",
      end_date: "2025-11-25T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.2070"
    },
    {
      id: "268c5697-a68e-41ba-bbc5-d57da0b4f384",
      text: "Campus Weather Allowance before Foundations",
      type: 5,
      start_date: "2025-01-14T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 824,
      parent: "a246aa51-899a-4f30-9cd8-88a1ca47cbe4",
      progress: 0,
      source_task_id: "7995211"
    },
    {
      id: "27ba588a-aede-4bd1-90ae-bb5cd908b15b",
      text: "Area 3 - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1950.10"
    },
    {
      id: "bcf1cb30-ac46-4353-be20-536b09b7e94a",
      text: "B2 - DH-D - Install HAC Lights - Data Hall D",
      type: 0,
      start_date: "2026-06-11T00:00:00",
      end_date: "2026-07-09T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2290"
    },
    {
      id: "a00ded8b-ecc9-4d53-985f-34c25dcf76ac",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.2070"
    },
    {
      id: "9d4397d9-9c8f-4e49-9c4f-9a45d31633a3",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2190"
    },
    {
      id: "1b8f56af-e805-4fda-9407-164053e74315",
      text: "B1 - 1D1W - 01D.08 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2600"
    },
    {
      id: "361414dd-f1b6-4928-8acb-b8fd11b0e41c",
      text: "B1 - Network - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for M-Cups (1-6)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 120,
      parent: "48b374c2-62a0-4af6-9a03-4b6d6337b136",
      progress: 0,
      source_task_id: "B1.C.EY.1180"
    },
    {
      id: "b5f31122-188e-4bd1-905b-97f887dd899a",
      text: "Finalize Site Specific Scope and RACI with GC; Finalize GR/GC needs",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 416,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1300"
    },
    {
      id: "e1842088-2ad3-4b25-852d-e7ceec6ddd8b",
      text: "B2 - 2C1 - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-31T08:00:00",
      duration: 80,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2020"
    },
    {
      id: "23e66f15-d8a9-44eb-8047-0a79afa820e0",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 80,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.2100"
    },
    {
      id: "ff4ce29a-fe13-4f4b-9c21-da7e4d5fd554",
      text: "B2 - DH-A - Power Alley - Power Alley - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 96,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.2090"
    },
    {
      id: "184797a9-40f5-44ea-82a4-eb38a79b9c00",
      text: "B1 - 1N1E - 01N4.06 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2025-10-08T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.6540"
    },
    {
      id: "3be01b15-6f84-4259-b42d-9a31ecef8f03",
      text: "B1 - DH-B - Room QA/QC Pre DEC-C Turnover - Data Hall B",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2900"
    },
    {
      id: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      text: "Area 4 - Mass Grading",
      type: 0,
      start_date: "2024-04-22T00:00:00",
      end_date: "2024-05-14T08:00:00",
      duration: 160,
      parent: "07966cba-d319-4601-87e2-3084c54fdb7d",
      progress: 1,
      source_task_id: "C.CSU.A4.1000"
    },
    {
      id: "b883c317-a92b-4f9a-94cb-8d48623a4072",
      text: "Fab and Deliver - Control Power UPS - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2600,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.36,
      source_task_id: "B1.OFCI.2830"
    },
    {
      id: "01615c95-a9a0-4728-9877-6ca9d72bb5c5",
      text: "B1 - DH-C - Connect Buss/Cable Tray Sections - Data Hall C",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2460"
    },
    {
      id: "27de967f-a8df-4d9d-aed6-afcb74c687e3",
      text: "Tier 1 - B1-1-N - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994799"
    },
    {
      id: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0",
      text: "B2 - DH-D - Set FCA's - Data Hall D",
      type: 0,
      start_date: "2026-04-29T00:00:00",
      end_date: "2026-05-27T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.1810"
    },
    {
      id: "2403d63f-04cd-4715-83a5-98a037fa1f56",
      text: "Fragnet 11 - PCO # 7 Rock encounter @ Utility Substation",
      type: 0,
      start_date: "2024-08-05T00:00:00",
      end_date: null,
      duration: 144,
      parent: "cd435564-4024-4c0e-924c-74c687f38b15",
      progress: 1,
      source_task_id: "8519891"
    },
    {
      id: "0ac1d778-7cb2-463e-9cce-fd72d14c288f",
      text: "B2 - SSB - Steel (Converted to LOE)",
      type: 0,
      start_date: "2025-08-06T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 160,
      parent: "d5a6c342-75e3-4c08-8ec7-dcad77b15e06",
      progress: 0,
      source_task_id: "B2.C.STR.1600"
    },
    {
      id: "8790b54e-02a0-492f-af1f-d61d0338ca55",
      text: "BLDG-2 DH-A",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-07-27T08:00:00",
      duration: 1344,
      parent: "9a439d8f-7507-4d44-a057-90cba25b759a",
      progress: 0,
      source_task_id: "7995083"
    },
    {
      id: "ad393807-f0aa-44dd-8bbd-05a4e7a3efdc",
      text: "B1 - 1N2W - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1710"
    },
    {
      id: "1e8ca4ca-9590-47b3-b350-99b32ea57e32",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 80,
      parent: "9cab297d-c579-43de-9c0f-90c459f05a0d",
      progress: 0,
      source_task_id: "MECO-1130.50"
    },
    {
      id: "10d6132e-af3e-4946-a1ac-d3f8723691e0",
      text: "B2 - mCUP-3 - Install Electrical / Lighting (Wire Pulls)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3070"
    },
    {
      id: "7ddfe567-675a-45e2-89f7-b8b15c5075e9",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 40,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.2150"
    },
    {
      id: "665d38bf-4370-4cc4-a231-4348a32236da",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 40,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2320"
    },
    {
      id: "a25a44c9-1575-43cf-995d-19c517844198",
      text: "Substation-2 - A Lineup SF6 Breaker - Assembly",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 120,
      parent: "ea42833e-92be-4313-b667-6ebb6de2be6c",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4920"
    },
    {
      id: "4d2a0e22-c5a7-4200-aa31-12b022fa86c0",
      text: "B1 - 1A2E - Corridor - Room Fit Out -  Architectural",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 160,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.2480"
    },
    {
      id: "f4fd83ad-859b-4b50-b160-2f551ba8e129",
      text: "B1 - Network Room 1/4 - Power Alley - (Level of Effort)",
      type: 0,
      start_date: "2025-08-15T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 136,
      parent: "d2608689-c286-449e-9760-9f41fc47b9c8",
      progress: 0,
      source_task_id: "B1.C.NR.1680"
    },
    {
      id: "5d4387c3-45cd-4fda-8b4e-9428400cf2e8",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [7] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-06-09T08:00:00",
      duration: 2944,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.35,
      source_task_id: "B1.OFCI.2150"
    },
    {
      id: "4984fa1c-2dfc-4802-a4b5-4c5a9c0fb8b8",
      text: "B1 - 1N2W - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.1460"
    },
    {
      id: "b9c10788-605a-42ef-b511-980d064c65b9",
      text: "B2 - 2D1W - 02D.08 - Pull Wire to Equipment",
      type: 0,
      start_date: "2026-05-19T00:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 40,
      parent: "2de259e3-e324-4b76-9388-0b6628f10f62",
      progress: 0,
      source_task_id: "B2.C.D.1930"
    },
    {
      id: "3d3765ed-346a-41cd-a399-766723355166",
      text: "Initial Procurement Plan Approved",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2023-12-04T00:00:00",
      duration: 0,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "ICM.PRE.1640"
    },
    {
      id: "6bdb7124-d7ea-448e-8756-317e8382021f",
      text: "Assembled Skids - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "76719f05-54bf-4474-8919-c0cffed7bfe9",
      progress: 1,
      source_task_id: "B1.OFCI.1210"
    },
    {
      id: "5dd1b4cb-a534-4471-9e4b-207b625c9e72",
      text: "B1 - Network - Install Scuppers and Temp Downspouts",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-05-29T08:00:00",
      duration: 80,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1050"
    },
    {
      id: "d80cc1a6-c3ae-4d12-a355-ea20aea6ef84",
      text: "Glass & Glazing (Alum. Entrances & Curtainwall)",
      type: 5,
      start_date: "2024-10-10T00:00:00",
      end_date: "2025-02-05T08:00:00",
      duration: 640,
      parent: "4fc673cb-0d55-4b7a-adb1-7bee9f658bfd",
      progress: 0,
      source_task_id: "7994899"
    },
    {
      id: "9b6feec4-4b16-496a-aed7-a5762459a085",
      text: "Area A - OH Electrical (incl Light Fixtures) - Open Areas",
      type: 0,
      start_date: "2025-07-10T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 120,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1041"
    },
    {
      id: "1037813e-cf0e-4b3b-a3ab-8618cb9d780c",
      text: "B2 - DH-C - El Equip Yd - Cabling- Copper Pulls/Terms to Establish Facnet for Area C",
      type: 0,
      start_date: "2025-12-12T00:00:00",
      end_date: "2026-01-05T08:00:00",
      duration: 120,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "B2.C.EY.1230"
    },
    {
      id: "4a722dfa-a7bb-4096-8c50-630793b2965a",
      text: "B1 - 1C2E  (GS.IDF.1C2) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-09-18T00:00:00",
      end_date: "2025-09-23T08:00:00",
      duration: 40,
      parent: "14e98806-f4a3-4699-95ac-e7908e1ab4a9",
      progress: 0,
      source_task_id: "B1.C.C.1390"
    },
    {
      id: "1b2897ec-bdb6-4b9b-8b6d-12512ccbcb8f",
      text: "Fab and Deliver - mCUP - Area mCUP Dry [5] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 2552,
      parent: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      progress: 0.41,
      source_task_id: "B1.OFCI.3510"
    },
    {
      id: "117c33d0-9a54-42ef-a268-d1554953ee74",
      text: "DFSMA - DC1 - mCUP - GS.IDF Remote Module ROJ - MOFE (1x3)",
      type: 0,
      start_date: "2025-07-23T08:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 0,
      parent: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      progress: 0,
      source_task_id: "B1.DFSMA.1180"
    },
    {
      id: "ce2a1ce2-f17e-473f-b202-b5e4093a77c6",
      text: "B1 - DH-C - Power Alley - Power Alley - Final Paint",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-15T08:00:00",
      duration: 16,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.2380"
    },
    {
      id: "a8df5053-478a-4e75-913c-62ee1afcb093",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-30T00:00:00",
      end_date: "2026-04-10T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.1570"
    },
    {
      id: "2555ee99-362a-44d6-970e-0613bbddec3b",
      text: "Install U/G - Electrical",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-19T08:00:00",
      duration: 80,
      parent: "6a0cd1fc-ee81-4b6b-98d1-80d82ce6812c",
      progress: 0,
      source_task_id: "ADMIN.SUB.1020"
    },
    {
      id: "af9dc6c6-873c-4f3a-bae7-29917b860a05",
      text: "B1 - DH-C - Steel (Hang Pre-Fab Racks- ROJ)(Converted to LOE)",
      type: 0,
      start_date: "2025-05-20T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 240,
      parent: "12b2f794-1081-48b7-bc59-245c3ffa07ce",
      progress: 0,
      source_task_id: "B1.C.STR.1990"
    },
    {
      id: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      text: "Non-Critical Trade Buyout Lvl-2",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 400,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 0,
      source_task_id: "Design.PreC.1590"
    },
    {
      id: "c4758960-1dea-44d4-9ccb-dc85579a17d5",
      text: "Electrical Allocation SA Package",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2024-02-29T08:00:00",
      duration: 448,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1060"
    },
    {
      id: "2463cca4-535e-4c29-aac9-446f2a06f8f3",
      text: "Fab and Deliver - GSB - Area A - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 3456,
      parent: "13271001-2e22-408b-be08-3d8849f2f6ba",
      progress: 0.37,
      source_task_id: "B2.OFCI.2250"
    },
    {
      id: "65b2b2b9-f871-418e-a7b5-e09f901833b3",
      text: "Fab and Deliver - PTX-DH/NW/NWAux/SSB - Area C (22) - DCB2",
      type: 0,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 2848,
      parent: "01fb85d2-d556-4c70-90dc-951c30f3ff59",
      progress: 0.47,
      source_task_id: "B2.OFCI.1760"
    },
    {
      id: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      text: "B2 - 2A2 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 24,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1340"
    },
    {
      id: "cc36ae56-fade-4d41-8b71-86a48085d358",
      text: "B1 - DH-C - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 40,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1250"
    },
    {
      id: "ecc051e0-d5dd-471f-94c9-13123cf5d74b",
      text: "(CFCI) Div. 32 - Asphalt/ Conc. Paving",
      type: 5,
      start_date: "2025-01-08T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 408,
      parent: "5897d1e2-fe31-4d56-b344-c64086e9b0ca",
      progress: 0,
      source_task_id: "7994915"
    },
    {
      id: "278d83f2-fd8d-4ff7-821d-aba3447b99a0",
      text: "B1 - 1A2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1430"
    },
    {
      id: "2190598a-f73d-49e3-90be-8cc832c8ba79",
      text: "BLDG-2 SSB 2E1",
      type: 5,
      start_date: "2025-10-24T00:00:00",
      end_date: "2026-06-01T08:00:00",
      duration: 1200,
      parent: "bf6187b5-e96d-44aa-afd3-3c0e407eb0e8",
      progress: 0,
      source_task_id: "7995041"
    },
    {
      id: "da85c0fc-26fe-489b-93bf-4d990e4138b1",
      text: "B1 - Network - Install Underground Telecom",
      type: 0,
      start_date: "2025-03-07T00:00:00",
      end_date: "2025-03-15T08:00:00",
      duration: 64,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1320"
    },
    {
      id: "9753b40c-3365-4ec6-8f11-1301b172d698",
      text: "B2 - SSB - Cure for SOG",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 24,
      parent: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      progress: 0,
      source_task_id: "B2.C.STR.2050"
    },
    {
      id: "edbea56f-5ebb-4239-975d-69bce2944188",
      text: "Fab and Deliver - MVS-5WAY - Area B (2) - DCB1",
      type: 0,
      start_date: "2024-02-19T00:00:00",
      end_date: "2025-04-07T08:00:00",
      duration: 2288,
      parent: "71a3cdb2-9201-4b08-95c3-112735b5ffc9",
      progress: 0.43,
      source_task_id: "B1.OFCI.2420"
    },
    {
      id: "2f5a0a67-3f19-4a87-a681-72a97dd49a86",
      text: "B1 - DH-C - Set HACs in Place - Data Hall C - [03.HAC-30-01,02]",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-11-08T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2240"
    },
    {
      id: "b2962ef2-0566-42e3-8162-4525f07eded8",
      text: "Fab and Deliver - MSB - Area B - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 3696,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.37,
      source_task_id: "B2.OFCI.2470"
    },
    {
      id: "e9e23379-a129-4ebb-b80c-e8552edee979",
      text: "Permanent Power to Substation 1",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-22T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "CAMPUS.9999"
    },
    {
      id: "8f687476-a96f-460f-b9e0-6896008bb4a5",
      text: "B2 - 2C1 - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-05-12T08:00:00",
      duration: 160,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.2040"
    },
    {
      id: "e40f51ed-d3a3-47c9-a1a6-fa38bcf32d1e",
      text: "BLDG-1/2 - Fabricate / Deliver - Interior Metal Panels",
      type: 0,
      start_date: "2024-12-18T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 1224,
      parent: "340322b8-8cb9-43d8-b4b9-513b36f312e3",
      progress: 0,
      source_task_id: "B1.CFCI.4110"
    },
    {
      id: "5472af19-77cd-4bcd-b2d9-7a1026442ee4",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-10-30T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2170"
    },
    {
      id: "7f955768-32f4-4aca-b134-ffece6db0c66",
      text: "Lav Supports",
      type: 0,
      start_date: "2025-09-25T00:00:00",
      end_date: "2025-10-01T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1040"
    },
    {
      id: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      text: "Approval of Civil Permits",
      type: 0,
      start_date: "2024-09-05T08:00:00",
      end_date: "2024-09-05T08:00:00",
      duration: 0,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 0,
      source_task_id: "ICM.PRE.1220"
    },
    {
      id: "d1d5ac4f-7495-4f56-8adc-355bfe546819",
      text: "B1 - Specialties - Benchs",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 80,
      parent: "77a24039-ebfc-49cb-b78b-b18d8f6c7c6d",
      progress: 0,
      source_task_id: "C.SI.SP.1020"
    },
    {
      id: "5dc8a286-1a9f-44d1-84d2-5ce8474144c5",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-10-21T00:00:00",
      end_date: "2026-05-08T08:00:00",
      duration: 1104,
      parent: "a7802f9a-c2fe-42f2-93c8-39143cadcbc2",
      progress: 0,
      source_task_id: "7995133"
    },
    {
      id: "b976b124-dea5-4d7e-bf5a-bb842e781a6b",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Corridor/Room Construction DEC-C Ready",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-04-29T08:00:00",
      duration: 80,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.2430"
    },
    {
      id: "268d91c1-9d30-46e0-9562-67ba2b463daa",
      text: "B2 - DH-D - Roofing(Converted to LOE)",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 120,
      parent: "96d1ae36-7562-40f8-b090-e86bd86e1de3",
      progress: 0,
      source_task_id: "B2.C.RF.1220"
    },
    {
      id: "caa908cc-3f97-4741-bd96-442cba3a118e",
      text: "B2 - DH-D - Install  Balance of Grade Beams",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 80,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1490"
    },
    {
      id: "23bd365d-7ac8-4f92-857a-5bb69ba9531f",
      text: "BLDG-2 DH-D ElectricalTerms",
      type: 5,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-06-17T08:00:00",
      duration: 320,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "7995127"
    },
    {
      id: "2bf0857a-e200-41b7-b339-1135d4ca569f",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Room Fit Out Activities - Set and Hook Up Equipment",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.2230"
    },
    {
      id: "1791c987-9cb3-4776-b27f-b2c0b4d29471",
      text: "BLDG-1/2 -  Fabricate / Deliver - Gypsum System and Ceilings",
      type: 0,
      start_date: "2025-03-27T00:00:00",
      end_date: "2025-04-23T08:00:00",
      duration: 160,
      parent: "3821e008-bd7a-483f-8d1f-538e64dc2ec4",
      progress: 0,
      source_task_id: "B1.CFCI.4780"
    },
    {
      id: "7b2b2b49-e469-44e0-97c1-fd532e029aef",
      text: "B1 - Network Room 1/4  - Install Devices & Trim",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2160"
    },
    {
      id: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24",
      text: "BLDG-1 SSB - L2 Checkout for Building",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 200,
      parent: "02f8ded1-4c38-44cd-9328-f537c699e8b9",
      progress: 0,
      source_task_id: "CX2.B1.1010"
    },
    {
      id: "d4ee83e1-7770-4986-af5c-46b6379689f5",
      text: "B1 - 1D2E - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 120,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2420"
    },
    {
      id: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6",
      text: "B2 - DH-C - Power Alley  - OH Rough In Feeder",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1060"
    },
    {
      id: "651ab799-cc77-4309-a031-9040d3552726",
      text: "B1 - mCUP-4 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 48,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4020"
    },
    {
      id: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 8,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2100"
    },
    {
      id: "26327ae0-6c90-4f36-b131-6ebdf49b7bd8",
      text: "Lighting",
      type: 5,
      start_date: "2025-07-03T00:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 864,
      parent: "c5f4a009-3c2d-45e5-acc4-95f6a07cc96b",
      progress: 0,
      source_task_id: "7995210"
    },
    {
      id: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      text: "B1 - 1N1E - EF4 - Punchwalk and Handover Entrance Facility DEC-C Ready (EF4)",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 8,
      parent: "6f5553bf-73ab-4668-8e43-216cc5af3bda",
      progress: 0,
      source_task_id: "B1.C.5930"
    },
    {
      id: "9e721a43-3b64-45cb-8a42-42cf9eefd556",
      text: "Area C & D",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995432"
    },
    {
      id: "040c162c-8537-4b40-9366-3d4389551add",
      text: "BLDG-1/2 - Delegated design- Fire Alarm",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: null,
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "B1.CFCI.6600"
    },
    {
      id: "92abe9a3-bbac-4a93-8043-b18fe712e36b",
      text: "Site Buildings",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995435"
    },
    {
      id: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb",
      text: "B1 - Network Room 2/3 - Power Alley - Equipment Hookup  (Skid Integration &SIP Inspections)",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 96,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1740"
    },
    {
      id: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      text: "Tier 0 - B2 - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "7994762"
    },
    {
      id: "d733b440-09c3-44d0-9543-b08cc608da33",
      text: "Fab and Deliver - ATS - Area NW-2/3 - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-06-13T08:00:00",
      duration: 2680,
      parent: "7e15574a-63a1-48ea-8cdc-83852661aca6",
      progress: 0.32,
      source_task_id: "B1.OFCI.2760"
    },
    {
      id: "81b937c3-75df-4386-a79f-3240af9a410a",
      text: "B1 - SSB - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-05-02T00:00:00",
      end_date: "2025-05-07T08:00:00",
      duration: 40,
      parent: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      progress: 0,
      source_task_id: "B1.C.STR.1920"
    },
    {
      id: "8172d914-a2ad-4f90-bdd5-199c1b7dc925",
      text: "IBOS - Prep / Submit for Rvw - PEMB Steel",
      type: 0,
      start_date: "2024-05-30T00:00:00",
      end_date: null,
      duration: 872,
      parent: "bb4ccf8c-2430-46e8-8802-789fa95742f7",
      progress: 0.8,
      source_task_id: "B1.CFCI.6360"
    },
    {
      id: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c",
      text: "B2 - DH-B - E-cure/Seal Floors/Final Paint/Rubber Base - Data Hall B",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-08-11T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2900"
    },
    {
      id: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Frame Walls",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1150"
    },
    {
      id: "656acec0-9b65-4159-be15-d0607975a7e1",
      text: "B1 - DH-B - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-08-02T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 80,
      parent: "65e2ac9d-26ce-4eb3-a7b1-8ea3f6994fe5",
      progress: 0,
      source_task_id: "B1.C.B.1250"
    },
    {
      id: "9f434faf-cb19-4c93-93b3-94fdda8a437e",
      text: "Fabricate / Deliver - EPMS",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 40,
      parent: "2b010ade-1651-4af0-b7a2-c1fe1d12718c",
      progress: 0,
      source_task_id: "B1.CFCI.6200"
    },
    {
      id: "f5bed361-ca99-4fb0-ac8e-3af5ea0abeeb",
      text: "DFSMA - ROJ - MOFE - Multi-Trade/ Pipe Racks (A)",
      type: 0,
      start_date: "2025-08-19T08:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1390"
    },
    {
      id: "1b8ab6ca-eb09-458a-a337-cdf4e4c1a5e5",
      text: "Fab and Deliver - HMD - Area B - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 3168,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.4,
      source_task_id: "B1.OFCI.3100"
    },
    {
      id: "553a0088-5d9a-45ef-b5ba-d9e79d2a9183",
      text: "Area 1 - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1970.10"
    },
    {
      id: "207d8eec-4e49-43ad-8f43-1e6990c9645f",
      text: "Fragnet 10 - PCO # 6 Added Power requirements @ MDF - DCB-1; DCB-2 (MOFE)",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: null,
      duration: 88,
      parent: "cd435564-4024-4c0e-924c-74c687f38b15",
      progress: 1,
      source_task_id: "8519904"
    },
    {
      id: "cb304893-e83f-4245-922c-9af363599820",
      text: "Set Kitchen Exhaust Fans",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-03T08:00:00",
      duration: 40,
      parent: "3ef181c5-60e0-4541-9cfa-14adb1217a17",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1230"
    },
    {
      id: "87aec155-33ca-41f4-80fc-22a787f4edc9",
      text: "B2 - DH-C - El Equip Yd - Pull Cable to PTX (MV)",
      type: 0,
      start_date: "2026-04-20T00:00:00",
      end_date: "2026-05-01T08:00:00",
      duration: 80,
      parent: "7e2c4263-df53-41a3-b764-1e6e272793de",
      progress: 0,
      source_task_id: "B2.C.EY.1540"
    },
    {
      id: "bc594957-c3be-421b-99ef-5eec3af850f9",
      text: "MDF Room Buildout Post Skid Setting",
      type: 5,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 296,
      parent: "4018d9e4-1af5-4b3e-a383-d6cb95eb6c54",
      progress: 0,
      source_task_id: "7995288"
    },
    {
      id: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      text: "B1 - SSB - 1E2 - Common - Hang/Tape/Finish Drywall Ceiling",
      type: 0,
      start_date: "2025-09-11T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2110"
    },
    {
      id: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-03-13T00:00:00",
      end_date: "2025-04-22T08:00:00",
      duration: 280,
      parent: "d0bed54c-5231-4917-855f-27c41cceb369",
      progress: 0,
      source_task_id: "7995405"
    },
    {
      id: "874b638d-a34b-446f-b6f5-a02e31a00edc",
      text: "BLDG-1 DH-B",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 1056,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995348"
    },
    {
      id: "b5ab113b-f512-4fc0-8bd5-aac4590010ea",
      text: "(CFCI) Div. 05 - Structural Steel",
      type: 5,
      start_date: "2024-05-28T00:00:00",
      end_date: "2024-11-11T08:00:00",
      duration: 944,
      parent: "d14a358f-2714-4b4f-b825-f2a228c80002",
      progress: 0.16,
      source_task_id: "7994923"
    },
    {
      id: "f8a6cf98-8c2e-41d8-808e-f36acbfcb0ea",
      text: "B2 - mCUP-1-8 - Piping Install (Header Mcup 5-8)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "f4c45d27-1849-46b8-a44c-96df1cc5b291",
      progress: 0,
      source_task_id: "B2.mCUP.1130"
    },
    {
      id: "ca3a70ce-ebd7-4ff4-a028-60e0ee019e90",
      text: "B2 - 2D1 - Corridor - OH Rough In Security",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      progress: 0,
      source_task_id: "B2.C.D.1150"
    },
    {
      id: "5c6464d9-140b-448e-92b5-bfce0e613174",
      text: "Camera Install",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1450"
    },
    {
      id: "b0598ceb-6fee-4932-a96e-9a7372d12748",
      text: "B2 - 2B1 - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2026-04-16T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 160,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2560"
    },
    {
      id: "00243349-58fe-44d5-baf0-3429b86b9264",
      text: "Hot Aisle Containment",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 992,
      parent: "5694af39-a9b3-47e6-8268-ac75dc1e0739",
      progress: 1,
      source_task_id: "PRE1770"
    },
    {
      id: "7cfbb4fe-239c-4c61-80bb-2ec84a13534e",
      text: "UG RI -Fire Alarm-DCB1-Area 1",
      type: 0,
      start_date: "2025-03-05T00:00:00",
      end_date: "2025-03-13T08:00:00",
      duration: 64,
      parent: "7ff8625a-dc89-41f6-8d33-dd61dacc1595",
      progress: 0,
      source_task_id: "MECO-1060.40"
    },
    {
      id: "6cf34255-dbe6-417c-bccb-3cce11f6660b",
      text: "Install Doors / Hardware",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 16,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1120"
    },
    {
      id: "2fa140d4-6e65-4b79-a55f-189dcae41a1f",
      text: "Substation-1 - A Lineup - Deep Conduit Install",
      type: 0,
      start_date: "2024-11-21T00:00:00",
      end_date: "2024-12-09T08:00:00",
      duration: 104,
      parent: "d36cff8d-f735-453c-8c93-201c22bc9784",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3840"
    },
    {
      id: "98e73b44-a413-40e1-b62a-a45425218193",
      text: "B1 - DH-B - SOG (Converted to LOE)",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-07-26T08:00:00",
      duration: 216,
      parent: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      progress: 0,
      source_task_id: "B1.C.STR.2200"
    },
    {
      id: "8392942d-42bd-4f26-ba93-f77096494997",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out - Electrical",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2260"
    },
    {
      id: "c662b4ef-8ce9-4062-afd3-76e0f22e8157",
      text: "B1 - 1N2E - 01N3.06 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.5670"
    },
    {
      id: "5cba7266-2724-483c-adf5-63d041ec2d40",
      text: "B1 - DH-B - Install Joists",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-15T08:00:00",
      duration: 120,
      parent: "b7d9d9de-e35e-4ff9-b6aa-4e9db3332b31",
      progress: 0,
      source_task_id: "B1.C.STR.1890"
    },
    {
      id: "32649675-5f9a-4c00-91f6-aa2ef8b70d4f",
      text: "[DCB1] DEC-C Ready: General Services [IBOS]",
      type: 0,
      start_date: "2025-10-02T08:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 0,
      parent: "2f681c37-a441-4fc2-8d7c-88d6653808f9",
      progress: 0,
      source_task_id: "ICM.B1.3795"
    },
    {
      id: "fb31be48-0bda-4d93-8554-03d677f27bef",
      text: "Area 5 - UG RI -Deep Site Lighting-Campus",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 192,
      parent: "55c2f835-cb78-493d-9337-1340798ed26b",
      progress: 0,
      source_task_id: "MECO-1860"
    },
    {
      id: "4a9bf09a-f345-4ef4-8f38-92b7d1937843",
      text: "B1 - mCUP-1-6 - Electrical Equipment Pulls/Terms for Network and A/B Data Halls",
      type: 0,
      start_date: "2025-09-16T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 160,
      parent: "2a30feef-09ac-419f-b924-97c80bbf1474",
      progress: 0,
      source_task_id: "B1.mCUP.9170"
    },
    {
      id: "6eb39590-fcae-422e-9779-77b82d79d4c5",
      text: "B1 - DH-B - Install Coping",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "3a15a1ac-23d0-45ad-a1af-c4ccfe77469d",
      progress: 0,
      source_task_id: "B1.C.RF.1420"
    },
    {
      id: "69a8544d-a2a4-4a01-b2fb-7b991fdfef9b",
      text: "Install Grease Duct",
      type: 0,
      start_date: "2025-07-30T00:00:00",
      end_date: "2025-08-05T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1050"
    },
    {
      id: "408f68d7-09f0-4ee6-8b78-bd6b6a420cbb",
      text: "Substation-2 - MSG B - Pre-energization MSG A and DC System",
      type: 0,
      start_date: "2026-02-11T00:00:00",
      end_date: "2026-02-28T08:00:00",
      duration: 120,
      parent: "b24bbbab-ffa9-4d00-bec1-e17b7710be08",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4430"
    },
    {
      id: "43c532d0-be4c-496e-86c4-0eea88b87e23",
      text: "Local AHJ Review and Comments of Building Permits - Original Activity",
      type: 0,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-08-13T00:00:00",
      duration: 664,
      parent: "13aa0ca6-4e32-4d9a-a7ab-9fd7a35513d1",
      progress: 1,
      source_task_id: "PRE-DD-1040"
    },
    {
      id: "fd7ad9b7-75f3-44f4-87c8-08db9a776bbf",
      text: "Area B - Frame Ceilings (Drywall & ACT)",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1290"
    },
    {
      id: "e7d26732-3faf-4110-bea8-4a8367261afc",
      text: "B1 - mCUP-2 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 24,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2090"
    },
    {
      id: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      text: "B1 - SSB - 1E2 - GSMDF2 - In Wall Rough In for GS-MDF Skid",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-07T08:00:00",
      duration: 40,
      parent: "3e507fd4-dcd7-4452-9766-aeca640b2a14",
      progress: 0,
      source_task_id: "B1.C.SSB.1110"
    },
    {
      id: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      text: "Foundations",
      type: 5,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 464,
      parent: "d3088fee-6e35-4c31-ad29-0f9024527c65",
      progress: 0,
      source_task_id: "7995398"
    },
    {
      id: "9c115577-5d2c-4c3d-a78a-ab7216e00c80",
      text: "Craft Parking -Construction Power energize",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: null,
      duration: 184,
      parent: null,
      progress: 0,
      source_task_id: "HRA.1160"
    },
    {
      id: "93c419fe-0544-4237-bb14-1541d7a0dc82",
      text: "B1 - Deep Telecom - Backfill",
      type: 0,
      start_date: "2025-01-03T00:00:00",
      end_date: "2025-01-08T08:00:00",
      duration: 40,
      parent: "f187d573-e29d-4f64-93ee-38df15ce2ea0",
      progress: 0,
      source_task_id: "B1.C.STR.2430"
    },
    {
      id: "80304145-e678-41e7-930f-619c16d31757",
      text: "Substation-2 - TX B - Assemble",
      type: 0,
      start_date: "2025-07-26T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 160,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6550"
    },
    {
      id: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776",
      text: "L4 - B2 DHB",
      type: 0,
      start_date: "2026-11-11T00:00:00",
      end_date: "2027-01-04T08:00:00",
      duration: 280,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHB.1000"
    },
    {
      id: "7b800596-3c18-4eef-a601-dc65353e5660",
      text: "Data Hall B (Area 1-B)",
      type: 5,
      start_date: "2024-08-28T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 760,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994815"
    },
    {
      id: "185d36a7-9d16-4e51-8ae2-99b2c950ef0f",
      text: "Prep / Submit for Review - EPMS",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "2b010ade-1651-4af0-b7a2-c1fe1d12718c",
      progress: 0,
      source_task_id: "B1.CFCI.6180"
    },
    {
      id: "551481c3-db0c-41f8-97db-292669d8e66b",
      text: "Fiber Cement Panels (Swisspearl)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994842"
    },
    {
      id: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 216,
      parent: "feb8fe8f-79d7-4be4-a607-d8e4ca0c127e",
      progress: 0,
      source_task_id: "7995391"
    },
    {
      id: "7c039159-3e86-44fc-89e3-bfb944477f3f",
      text: "FR 23 - DPR prepare and Submit RFI #84",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "2be26207-dbca-4279-9a53-24684a97817a",
      progress: 1,
      source_task_id: "FR.23.1000"
    },
    {
      id: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      text: "BLDG-2 Entrance Facility 4",
      type: 5,
      start_date: "2025-12-02T00:00:00",
      end_date: "2026-01-26T08:00:00",
      duration: 296,
      parent: "14818e58-af4b-40a0-9f06-bdd07731f03d",
      progress: 0,
      source_task_id: "7995046"
    },
    {
      id: "5080eddb-27ca-4a28-82ec-053e5a6d88db",
      text: "L3 - mCUP 1-8",
      type: 0,
      start_date: "2026-07-02T00:00:00",
      end_date: "2026-08-27T08:00:00",
      duration: 320,
      parent: "b7e80775-db75-4aaf-b309-1a2626cd6965",
      progress: 0,
      source_task_id: "CX3.B2.MCUP.1000"
    },
    {
      id: "6ac2baac-eb0a-40af-87f9-caca9fe3c708",
      text: "B2 - DH-C - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2026-04-30T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 48,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.2330"
    },
    {
      id: "6e150188-3a6c-4212-b3b0-2e8e61e40220",
      text: "BLDG-1 SSB 1E1 Entrance Facility 1",
      type: 5,
      start_date: "2025-07-09T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 296,
      parent: "c6a66845-9cdf-419f-bc39-f7cbf2425030",
      progress: 0,
      source_task_id: "7995291"
    },
    {
      id: "33f9d545-3835-4e65-b5b9-12a6700fb9a7",
      text: "B2 - DH-C - Set CDU's - Data Hall C (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2026-05-14T00:00:00",
      end_date: "2026-05-22T08:00:00",
      duration: 64,
      parent: "b59787b1-4034-47f1-b469-52b087cc7b04",
      progress: 0,
      source_task_id: "B2.C.C.5020"
    },
    {
      id: "3405b6d8-58ed-488c-9932-f54373a803ce",
      text: "B1 - 1CDE  (GS.IDF.1D1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2025-12-23T00:00:00",
      end_date: "2026-01-09T08:00:00",
      duration: 80,
      parent: "ab853810-63f8-45f7-8b5a-8e33e3c48c0c",
      progress: 0,
      source_task_id: "B1.C.D.2540"
    },
    {
      id: "b5199bb8-6208-4ff6-ab7a-fd5a5b9e6888",
      text: "Substation-2 - TX B - Pre-energization / Control Power / Dead Bus Checkout",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 152,
      parent: "5f9ce28a-9b3f-47fb-866c-7e40ad8f4071",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4530"
    },
    {
      id: "506550df-142c-4fd3-8582-5ddaba041ccc",
      text: "B2 - DH-A -  Lightning Protection",
      type: 0,
      start_date: "2026-01-31T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B2.C.RF.1410"
    },
    {
      id: "8ceeaeca-1fd8-4b1e-ad1a-72a329ec4c4c",
      text: "OH Fire Alarm Rough-In",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1170"
    },
    {
      id: "d9f4f61f-4751-482d-b6a0-93faea768610",
      text: "(CFCI) NCB - (Deferred Submittal) Fire Protection Design",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994917"
    },
    {
      id: "b7efe29d-7592-4d70-9a1e-c3d350e9ee96",
      text: "Hang/Tape/Finish Drywall Ceilings",
      type: 0,
      start_date: "2025-12-10T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1290"
    },
    {
      id: "b7aaa84c-ad46-4363-8344-8cf94f254ed9",
      text: "Pad Ready - DCB1",
      type: 0,
      start_date: "2024-12-16T00:00:00",
      end_date: "2024-12-16T00:00:00",
      duration: 0,
      parent: "c2d8030c-6263-4f73-9422-c55feddbea39",
      progress: 0,
      source_task_id: "ICM.G1.1056"
    },
    {
      id: "a2594620-9624-4d19-8ff0-a8c17275c6fc",
      text: "Area 2 - Storm Install (Early work)",
      type: 0,
      start_date: "2024-07-15T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 1,
      source_task_id: "C.CSU.A2.8080"
    },
    {
      id: "84aed80d-5d62-46cf-9215-528b7bc0eec9",
      text: "In-Wall Rough Mechanical",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-17T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1050"
    },
    {
      id: "567614ba-0249-4af4-9377-ebf35bea90df",
      text: "B1 - DH-C - Install HAC Lights - Data Hall C",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2430"
    },
    {
      id: "848e3428-513c-49fa-a48a-7c59a78ed2a7",
      text: "Mass Grading Design Package",
      type: 0,
      start_date: "2023-10-23T00:00:00",
      end_date: "2023-11-18T08:00:00",
      duration: 160,
      parent: "68519373-5be8-4c94-895d-f8db4c1edde5",
      progress: 1,
      source_task_id: "Design.PreC.5700"
    },
    {
      id: "c3d4c4e0-8467-4107-9240-e0ff32914a97",
      text: "FR 07 - META review and Approve PCO#3",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: "2024-11-08T08:00:00",
      duration: 80,
      parent: "7565b988-5073-4059-925b-84b84bce1b11",
      progress: 0,
      source_task_id: "FR.07.1070"
    },
    {
      id: "b95d4d42-2a69-45ef-bea0-2f690b98fe5b",
      text: "Provide for GMP dev - site specific specs, QA/QC, Installation RACI, Vendor support commitments for MOFE elements",
      type: 0,
      start_date: "2023-12-04T00:00:00",
      end_date: "2023-12-08T08:00:00",
      duration: 40,
      parent: "32bde680-1da0-44bb-912b-83bac3022da5",
      progress: 1,
      source_task_id: "PRE-PP-1340"
    },
    {
      id: "dc0db725-f1c1-4687-8a98-61e9f8a18049",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-08-09T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 1440,
      parent: "9e46eb04-9bcc-4118-b67d-5276c41d5d9f",
      progress: 0,
      source_task_id: "7995272"
    },
    {
      id: "af3d37a4-80ef-4595-be29-ccdceed37961",
      text: "B2 - mCUP-1 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 24,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1250"
    },
    {
      id: "872df01c-b5af-4a82-b4f8-d4090a1571ca",
      text: "Mass Grading",
      type: 5,
      start_date: "2024-05-15T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 1264,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0.96,
      source_task_id: "7995165"
    },
    {
      id: "bd85483f-7137-4be2-b76d-979e82b83376",
      text: "Fab and Deliver - Battery Monitoring & Diagnostic System - Area B- DCB1",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 3296,
      parent: "4bef5be0-b299-4faa-b366-fd0ba2a8ee98",
      progress: 0.32,
      source_task_id: "B1.OFCI.2790"
    },
    {
      id: "e183f4ef-b3e1-4262-9416-1236c0f36441",
      text: "B1 - SSB - Backfill",
      type: 0,
      start_date: "2025-03-01T00:00:00",
      end_date: "2025-03-03T08:00:00",
      duration: 16,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1240"
    },
    {
      id: "aad612cb-5df2-49ab-8f2e-e80272da8a25",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2200"
    },
    {
      id: "919b0a08-9434-4457-9dce-c51833c5cf8c",
      text: "Substation-1 B Lineup Ground work",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-03-31T08:00:00",
      duration: 872,
      parent: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      progress: 0,
      source_task_id: "7995234"
    },
    {
      id: "5682fe95-70e0-4a0e-a209-96fd4d6be09a",
      text: "B1 - 1N1E - 01N4.07 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.5820"
    },
    {
      id: "24b28ae6-80d0-4f83-83f5-84a3255480da",
      text: "B2 - DH-B - Install IMP Walls @ FCAs - Data Hall B",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2170"
    },
    {
      id: "05efc6ef-2bc7-45cb-b38d-ff7101f6e21e",
      text: "Mechanical R/I",
      type: 0,
      start_date: "2025-06-18T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "f37a81c7-69b0-459e-bb44-9e6a8c8699a6",
      progress: 0,
      source_task_id: "IBOS.IDF.1070"
    },
    {
      id: "3b92f394-9e27-4e2a-b808-55aa3b1ee1cd",
      text: "Corridor 2D1",
      type: 5,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-08-12T08:00:00",
      duration: 856,
      parent: "dfc16b55-f1f0-4fea-b940-c09ea7840d80",
      progress: 0,
      source_task_id: "7995061"
    },
    {
      id: "9ee725fd-e35d-4991-8cae-cb37d821d273",
      text: "B2 - ISP Cabling - E1 to E4 (UG)",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-05T08:00:00",
      duration: 40,
      parent: "82aa04f8-84e7-4ba1-aa79-7f3251ef26a5",
      progress: 0,
      source_task_id: "B2.CONN.1030"
    },
    {
      id: "6202754d-a562-45a4-a8cb-67659e25e0ae",
      text: "Lift station 1",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 240,
      parent: null,
      progress: 0,
      source_task_id: "8725181"
    },
    {
      id: "9ff85359-b0f7-4746-b268-944ada2f5382",
      text: "B1 - Telecom Enabling Foundations",
      type: 0,
      start_date: "2024-11-23T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 96,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.STR.2480"
    },
    {
      id: "dc8f2f4d-f011-4843-a84a-315b7fafccee",
      text: "Install Lights",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1520"
    },
    {
      id: "8dee6ef6-7b88-4d32-aea4-46f6b20209bd",
      text: "B1 - DH-D - Power Alley- In Wall Rough Ins/Inspections - Fire Alarm",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 80,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1490"
    },
    {
      id: "c3c2d0b7-ae61-4275-9e98-023a7fce1faa",
      text: "Tier 0 - B1-1-C - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994806"
    },
    {
      id: "f51f4912-276d-4dea-a028-c1af55c3f334",
      text: "DFSMA - DC1 DHA HAC ROJ - MOFE",
      type: 0,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 0,
      parent: "86efc612-6e21-491b-98fc-5aba04020712",
      progress: 0,
      source_task_id: "B1.DFSMA.1070"
    },
    {
      id: "f43f88a7-4c00-44ed-8477-2da17c93d0a0",
      text: "IBOS-  Fabricate / Deliver - Foundation Struc. Conc. (Rebar) Supplimental Rebar",
      type: 0,
      start_date: "2024-12-11T00:00:00",
      end_date: null,
      duration: 112,
      parent: "4829c004-900e-4663-bf29-7a9d04c5e4a3",
      progress: 0,
      source_task_id: "B1.CFCI.6570"
    },
    {
      id: "0b068a4f-9be9-40d8-99dd-d9f5c60a2d1f",
      text: "Admin VDC",
      type: 5,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-12-04T08:00:00",
      duration: 720,
      parent: "586aee7e-b379-47ae-b173-bd726886c6ff",
      progress: 0,
      source_task_id: "7994810"
    },
    {
      id: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      text: "HMD - Meta PO Issued - DCB1",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 1,
      source_task_id: "B1.OFCI.1050"
    },
    {
      id: "3541fb3f-7ff2-4335-8a2d-2fb84f4471cb",
      text: "B2 - DH-B - Power Alley - Power Alley - Terminate Electrical @ Light Fixtures/Devices/Outlets",
      type: 0,
      start_date: "2026-04-10T00:00:00",
      end_date: "2026-04-16T08:00:00",
      duration: 48,
      parent: "c9f09357-738b-4bf9-9e4b-7907ae380ca6",
      progress: 0,
      source_task_id: "B2.C.B.2530"
    },
    {
      id: "5166c0bb-8ac7-44c5-ba9b-861c1aad271e",
      text: "Fab and Deliver - MSB - Area CUP - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-03-18T08:00:00",
      duration: 2760,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.34,
      source_task_id: "B2.OFCI.2400"
    },
    {
      id: "11d2bf3f-bb63-4882-ae84-c4b2c07a10a2",
      text: "Stormwater Management Design Package - Redesign - DHEC",
      type: 0,
      start_date: "2023-11-20T00:00:00",
      end_date: "2024-03-19T08:00:00",
      duration: 648,
      parent: "82fa88fb-5ef6-46b5-8ab3-73a29384c3ea",
      progress: 1,
      source_task_id: "Design.PreC.5740"
    },
    {
      id: "438b74e9-e317-416c-a103-d3a7d96c879b",
      text: "Substation-2 - B Lineup - MOAB Assembly / Control Wiring / HV Conductors",
      type: 0,
      start_date: "2025-10-13T00:00:00",
      end_date: "2025-11-08T08:00:00",
      duration: 192,
      parent: "cd03450e-e8ed-4b51-8939-8deb3f7b6575",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4310"
    },
    {
      id: "590c6b80-78b8-413f-9298-b28a850c095c",
      text: "B1 - DH-C - Hookup CDU's - Data Hall C",
      type: 0,
      start_date: "2026-01-10T00:00:00",
      end_date: "2026-01-31T08:00:00",
      duration: 144,
      parent: "0346efe3-b63f-4628-9749-3c3592992deb",
      progress: 0,
      source_task_id: "B1.C.C.3075"
    },
    {
      id: "1141d702-60d3-444c-ab72-02e21ea12211",
      text: "B1 - DH-D - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 120,
      parent: "b2024e36-73dd-48c2-87f3-c28d0d4373d8",
      progress: 0,
      source_task_id: "B1.C.STR.2350"
    },
    {
      id: "40535452-533a-4cc6-b446-2c85cc034c55",
      text: "B2 - DH-D - Install Celing Devices Fire Protection - Data Hall D",
      type: 0,
      start_date: "2026-08-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2590"
    },
    {
      id: "db86ff6b-468b-465e-b41d-914e0b2dafcf",
      text: "B2 - DH-D - Underground (Converted to LOE)",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 240,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1410"
    },
    {
      id: "c58d12bf-614f-4c63-b273-87839b55d090",
      text: "Substation-1",
      type: 5,
      start_date: "2024-09-09T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 3216,
      parent: "92fdfff6-1c52-460d-a713-e626aa2716d6",
      progress: 0,
      source_task_id: "7995230"
    },
    {
      id: "6081c9d9-8ad1-4bf1-a52c-71d03c66a501",
      text: "B1 - Network Room 2/3 - Power Alley - OH Fire Alarm/Vesda",
      type: 0,
      start_date: "2025-07-11T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 96,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1270"
    },
    {
      id: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef",
      text: "Substation-2 - MSG A - Assembly",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-08-13T08:00:00",
      duration: 136,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4690"
    },
    {
      id: "c3de4e0f-44fc-4e79-9c69-24841968c6fd",
      text: "(OFCI) B1 Hot Aisle Containment *DELETE*",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0,
      source_task_id: "7994972"
    },
    {
      id: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      text: "B2 - DH-C - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 80,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.1030"
    },
    {
      id: "0427c27e-859f-4d49-b964-564a3381fba0",
      text: "Cure SOG",
      type: 0,
      start_date: "2025-02-15T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 56,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1120"
    },
    {
      id: "9b7849e7-4127-4091-8d27-e9bb17383514",
      text: "B2 - mCUP-1 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-10-18T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 48,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1180"
    },
    {
      id: "36beab78-fbfe-4a35-bcd4-46229816c1f9",
      text: "NW1/4",
      type: 5,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-10-29T08:00:00",
      duration: 1008,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995339"
    },
    {
      id: "18334722-94ca-454d-a407-c2ebe037779e",
      text: "B1 - SSB - Install Structural Steel",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-03-29T08:00:00",
      duration: 80,
      parent: "8706ae17-e73d-469c-8b7e-f2473608e8df",
      progress: 0,
      source_task_id: "B1.C.STR.1410"
    },
    {
      id: "ea73fbf5-4752-469c-a68f-24fd27e7f1cf",
      text: "B2 - DH-D - Install Thermal Concrete",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-09-05T08:00:00",
      duration: 120,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1500"
    },
    {
      id: "c9601c7a-8441-44a2-b189-201ef066c2d9",
      text: "B1 - SSB - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-01-30T00:00:00",
      end_date: "2025-02-10T08:00:00",
      duration: 80,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1070"
    },
    {
      id: "73c096d4-b053-4103-9c77-97b889e80fa5",
      text: "Grout Baseplates - Structural Steel",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1020"
    },
    {
      id: "ae0178eb-f4ce-400c-acb0-067206489a5c",
      text: "B1 - Network - Install Single Ply White Cap",
      type: 0,
      start_date: "2025-06-11T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 40,
      parent: "02b743c2-814f-4e6d-a14f-9940e4d2b185",
      progress: 0,
      source_task_id: "B1.C.RF.1110"
    },
    {
      id: "0a7b8101-358f-4e05-92f5-c2cc06e8a959",
      text: "Precast Start - DCB1",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-17T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1380"
    },
    {
      id: "8530504b-e7ad-48e3-a890-1ac6d5d3a8b4",
      text: "Substation-2 - A Lineup - Install Controls / Conduit / Excavate / Conduit / Form / Pour",
      type: 0,
      start_date: "2025-08-01T00:00:00",
      end_date: "2025-08-20T08:00:00",
      duration: 136,
      parent: "36539673-287c-4060-8b2c-170c56529f35",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4650"
    },
    {
      id: "bc7a7685-6066-460e-93a4-8e5f3ef8763d",
      text: "FR 31 - DPR Issue RFI #85",
      type: 0,
      start_date: "2024-08-06T00:00:00",
      end_date: null,
      duration: 0,
      parent: "955aa671-6b4b-4034-bf88-d03902dbaf4e",
      progress: 1,
      source_task_id: "FR.31.1000"
    },
    {
      id: "17a792bc-8b6c-4f60-acfc-43a939ecba81",
      text: "L3 Finish Substation - DCB2",
      type: 0,
      start_date: "2026-06-09T08:00:00",
      end_date: "2026-06-09T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2026"
    },
    {
      id: "d39027c5-3342-4100-9261-ff860958971f",
      text: "B1 - 1N2W - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 40,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2280"
    },
    {
      id: "8df302e0-ce4b-4751-92fb-c7a6aabd4cf7",
      text: "B2 - mCUP-2 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-07T08:00:00",
      duration: 48,
      parent: "1097b8f5-df62-41a9-820c-462b7138da45",
      progress: 0,
      source_task_id: "B2.mCUP.2050"
    },
    {
      id: "27bca850-e0a0-4a4e-a0fb-0ee1e0e6e37c",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Room Fit Out Activities - Finishes",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2270"
    },
    {
      id: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      text: "GS.IDF.1B2",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 776,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "7995355"
    },
    {
      id: "78085b11-0144-408f-90e5-d30c70a38d19",
      text: "B1 - DH-C - Prepare Subgrade/Install Vapor Barrier SOG",
      type: 0,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 80,
      parent: "323b2c31-b115-4d2d-b0aa-d07e0a49e28f",
      progress: 0,
      source_task_id: "B1.C.STR.2270"
    },
    {
      id: "676d4296-3019-4da1-b2d5-55159fe95012",
      text: "Tier 0 - B1-1-E - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994808"
    },
    {
      id: "2e6b32d5-383a-4f8f-9a89-a29c542e3246",
      text: "B2 - OSP Cabling - EF to SUBIDF1",
      type: 0,
      start_date: "2026-02-27T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 80,
      parent: "71be5c41-0454-4bac-8971-6b8f2d2021a0",
      progress: 0,
      source_task_id: "B2.CONN.1020"
    },
    {
      id: "3d31ee60-67fa-496f-b2a2-aed4c3875db0",
      text: "(New WBS)",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: null,
      progress: 0,
      source_task_id: "8297156"
    },
    {
      id: "a36fe2cc-ddb6-48eb-a257-0587beb40e6f",
      text: "Adverse Weather Event 12 - 10.1.2024  (Hurricane Helene)",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "WX.1012"
    },
    {
      id: "60503f88-9515-47db-8208-1a65c6e247a4",
      text: "UG RI -Network Infrastructure-DCB1-Area 1",
      type: 0,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-01-10T08:00:00",
      duration: 320,
      parent: "788d1f62-507e-4025-aab2-a46f59549cb0",
      progress: 0,
      source_task_id: "MECO-1120"
    },
    {
      id: "31bf0bfd-e249-4ea9-8c9b-ef0b9f34730d",
      text: "L3 Finish Substation - DCB1",
      type: 0,
      start_date: "2025-11-10T08:00:00",
      end_date: "2025-11-10T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2026"
    },
    {
      id: "5574c361-0300-4741-ac4a-d7b9dbf385fe",
      text: "B2 - 2C2 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-05-07T00:00:00",
      end_date: "2026-05-13T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.2100"
    },
    {
      id: "04a48e72-b603-4918-8e25-7505979a5b77",
      text: "Install Door Frames",
      type: 0,
      start_date: "2025-12-30T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1080"
    },
    {
      id: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      text: "B2 - DH-B - Install Vapor Barrier",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 40,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1150"
    },
    {
      id: "1c07ecc8-327e-426b-8911-b50d65c80ab2",
      text: "B1 - DH-C - Pull/Term BMS - Data Hall C",
      type: 0,
      start_date: "2025-12-16T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2550"
    },
    {
      id: "fb85b6a3-c5a8-47b2-9ea7-8ffc1fc2d357",
      text: "Substation-1 - A Lineup SF6 Breaker - NETA Testing (Control Cabling)",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 120,
      parent: "aa22521b-48bf-4060-93d0-7750855b683f",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4170"
    },
    {
      id: "fcf7f38e-4a8b-41fd-a396-2af83c242463",
      text: "B2 - 2C2 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1270"
    },
    {
      id: "03b59b82-39f9-4ef1-af1d-07d28a88ab7d",
      text: "B1 - SSB - 1E1 - Common - Install Plumbing Fixtures",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-09T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2330"
    },
    {
      id: "c82c9c65-32dc-44f6-8a2e-b9675e3cc1a3",
      text: "B1 - Install Final Paving",
      type: 0,
      start_date: "2026-01-21T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 96,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1070"
    },
    {
      id: "5f1ffaa6-2f9b-4373-bdf7-e99300bec629",
      text: "Milestones",
      type: 5,
      start_date: "2023-10-16T00:00:00",
      end_date: "2027-05-07T08:00:00",
      duration: 7176,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0.16,
      source_task_id: "7995417"
    },
    {
      id: "80e23ce1-ed4b-4104-9452-6078f30f51c2",
      text: "B1 - mCUP-3 - mCUP Interconnects (Owner/Vendor)",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 80,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.9270"
    },
    {
      id: "e8d8fbc0-2457-40b0-b8a5-44cfd05180a5",
      text: "B2 - 2D2  (GS.IDF.2D1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-06-26T00:00:00",
      end_date: "2026-07-10T08:00:00",
      duration: 80,
      parent: "01a9b0ef-1406-4d7a-9db6-a4bf029b3bf0",
      progress: 0,
      source_task_id: "B2.C.D.2230"
    },
    {
      id: "cf35acea-f4a0-48b2-99a5-186d8c018df7",
      text: "B1 - mCUP-5 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5120"
    },
    {
      id: "4f122a2f-7d4b-4940-abba-f9b0cba600d7",
      text: "Fab and Deliver - MSB - Area A - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-02T08:00:00",
      duration: 3696,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.37,
      source_task_id: "B2.OFCI.2460"
    },
    {
      id: "b36bc5ee-f112-4677-a654-d4337c07b419",
      text: "VDC Coordination",
      type: 5,
      start_date: "2024-03-18T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 2792,
      parent: "5b0c7f62-d6b7-4c27-a219-7ab78c02b3ce",
      progress: 0.19,
      source_task_id: "7994748"
    },
    {
      id: "2edce70b-fdf4-4bdd-a96c-47f91331becc",
      text: "B1 - mCUP-4 - Set Electrical Equipment (MVS PTX MSB)",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-06T08:00:00",
      duration: 16,
      parent: "08062563-e86c-47a0-89e6-8f8201591b22",
      progress: 0,
      source_task_id: "B1.mCUP.4010"
    },
    {
      id: "d8358450-9d1c-4ceb-9c90-8d882c4480f7",
      text: "B2 - 2B2  (GS.IDF.2B3) - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 8,
      parent: "501837d1-020d-44cf-8a48-7bb2537b8e83",
      progress: 0,
      source_task_id: "B2.C.B.1350"
    },
    {
      id: "cc4d6d2f-68b7-4a58-bc02-9533d8e7f4a4",
      text: "Electrical Cennections to",
      type: 0,
      start_date: "2025-01-29T00:00:00",
      end_date: "2025-02-03T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8200"
    },
    {
      id: "306e399b-90ee-437d-8279-8e05faadfc37",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - OH Rough In Electrical Branch",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-28T08:00:00",
      duration: 40,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1140"
    },
    {
      id: "16bd69c7-82fb-4a43-ad8c-ae161f901385",
      text: "B1 - DH-C - Power Alley - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-02T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 80,
      parent: "a684ba1e-a62f-4426-a990-cf14abf15739",
      progress: 0,
      source_task_id: "B1.C.C.1540"
    },
    {
      id: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52",
      text: "B1 - DH-A - Set CDU's - Data Hall A (16 total; 4 per day)",
      type: 0,
      start_date: "2025-10-03T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 64,
      parent: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      progress: 0,
      source_task_id: "B1.C.A.2980"
    },
    {
      id: "2940ae46-ce59-4161-b8b2-d53ca7bfc4c7",
      text: "B2 - mCUP-7 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7080"
    },
    {
      id: "f2d08268-17a3-4a53-828e-f39d2e9d23db",
      text: "B1 - DH-B - Install 800 Amp Busway - Data Hall B",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-23T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2200"
    },
    {
      id: "8d300db3-9727-4323-be25-8c4fe5f951b0",
      text: "Area 3 - UG RI -Network Infrastructure-Campus",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 328,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1400"
    },
    {
      id: "a137ac83-2cbd-4bd8-9b04-91addce14575",
      text: "Install Turnstiles",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1490"
    },
    {
      id: "ac0da6ca-5aa4-444e-a1fa-017465c576c3",
      text: "B1 - mCUP-6 - L2 Inspections",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 80,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6130"
    },
    {
      id: "19f12c43-2633-4673-99ab-4081cac795ba",
      text: "B1 - DH-D - Power Alley - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 192,
      parent: "080b832b-af7b-4e91-9c83-eab029357ee4",
      progress: 0,
      source_task_id: "B1.C.D.1630"
    },
    {
      id: "dcd42ad9-9357-4feb-aeb7-4d877913e6db",
      text: "Admin - Submittal Rvw/App'l - Roofing",
      type: 0,
      start_date: "2024-08-30T00:00:00",
      end_date: "2024-09-10T00:00:00",
      duration: 120,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1110"
    },
    {
      id: "993a33a9-ba19-4c70-87e9-c3247582ff68",
      text: "DH Electrical Yard Skids",
      type: 5,
      start_date: "2025-08-27T08:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 200,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994834"
    },
    {
      id: "ad008ffc-1727-49e4-903a-71d4841a8211",
      text: "UPS Room 01N4.07",
      type: 5,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-10-14T08:00:00",
      duration: 480,
      parent: "e2a25521-eed0-4f3c-a501-f360cf914f24",
      progress: 0,
      source_task_id: "7995345"
    },
    {
      id: "5b1579e2-572a-4454-b067-6883bf03177b",
      text: "B2 - mCUP-6 - Install Electrical / Lighting (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-12-03T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "0da90fef-d50b-4b20-bfae-c07d689f0182",
      progress: 0,
      source_task_id: "B2.mCUP.6040"
    },
    {
      id: "50b67990-912a-4528-969d-ecb49f0307ee",
      text: "Erect Structural Steel - Area A - IBOS",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "A1000"
    },
    {
      id: "10ed9297-3fb3-46a9-8fc0-d26bd6f8467f",
      text: "B1 - 1N2W  (GS.IDF.1B3) - Corridor - Install Lighting (In Corridors)",
      type: 0,
      start_date: "2025-10-22T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 80,
      parent: "4ea20dea-42e9-481c-94a4-26785afe6b41",
      progress: 0,
      source_task_id: "B1.C.B.2310"
    },
    {
      id: "d72ed235-71e8-4748-ba35-530b4c3e04f0",
      text: "BLDG-1 - Core - Construction Duration - FDN to DEC-C - (LOE)",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 1912,
      parent: "85caf046-1383-4789-9fcd-ca4282fe03f9",
      progress: 0,
      source_task_id: "AUX.MILE.1520"
    },
    {
      id: "09014fb4-21e2-4efe-a928-a4c300ef547c",
      text: "Sanitary Sewer force main ( Including ARV's)",
      type: 0,
      start_date: "2025-01-16T00:00:00",
      end_date: "2025-01-22T08:00:00",
      duration: 40,
      parent: "8eae7895-3d16-4011-9e4b-a40632fd5b1b",
      progress: 0,
      source_task_id: "C.CSU.A5.8240"
    },
    {
      id: "2dd17f0b-6599-4106-bfb9-f19dee480171",
      text: "B2 - mCUP-7 - Install FA (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-20T00:00:00",
      end_date: "2025-12-23T08:00:00",
      duration: 24,
      parent: "68c51d81-fb52-4e7d-9cc0-a0e20e27e3d6",
      progress: 0,
      source_task_id: "B2.mCUP.7110"
    },
    {
      id: "20c628d9-ebd7-4465-8f4e-d5910b018fe0",
      text: "(OFCI) B1 mCUP",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 2992,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.38,
      source_task_id: "7994989"
    },
    {
      id: "223ba065-6c21-4807-b711-f005d438d0c7",
      text: "B2 - mCUP-5 - Set/Assemble mCUp Modules/Mechanical/Dry Cooler Modules - [06.MTR-15-01,02,03]",
      type: 0,
      start_date: "2025-10-28T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 48,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5000"
    },
    {
      id: "485c9ae3-1503-474c-a626-391e5d2b494e",
      text: "B2 - mCUP-5 - L2 Inspections",
      type: 0,
      start_date: "2026-01-05T00:00:00",
      end_date: "2026-01-15T08:00:00",
      duration: 80,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5130"
    },
    {
      id: "74b9f7af-f680-4479-b726-9a2a1645e578",
      text: "Area B - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1250"
    },
    {
      id: "84cb7700-2de2-4187-b3b5-e007f51750d8",
      text: "OH Electrical Rough-In",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1140"
    },
    {
      id: "09120bbb-754e-4650-886a-31f195fccd31",
      text: "Electrical In Wall Rough-In",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1000"
    },
    {
      id: "b9ac7be6-87ce-4b04-83df-1350afa67db8",
      text: "(OFCI) B1 PTX",
      type: 5,
      start_date: "2024-02-01T00:00:00",
      end_date: "2025-05-16T08:00:00",
      duration: 2616,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0.46,
      source_task_id: "7994985"
    },
    {
      id: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      text: "BLDG-2 SSB",
      type: 5,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 280,
      parent: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      progress: 0,
      source_task_id: "7995097"
    },
    {
      id: "3c142183-d997-400f-9a7d-43cc08f164da",
      text: "B1 - SSB - External Framing/Vapor Barrier to Finish Roof",
      type: 0,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-21T08:00:00",
      duration: 160,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "B1.C.7000"
    },
    {
      id: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8",
      text: "B2 - ISP Cabling - IDFD to DHD (GS tray)",
      type: 0,
      start_date: "2026-10-23T00:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 200,
      parent: "8a5c0cce-e50e-401f-a7b5-45659824a0c9",
      progress: 0,
      source_task_id: "B2.CONN.1290"
    },
    {
      id: "dbbcc54a-ba5b-4afe-99cf-a5f47c1494bc",
      text: "Electrical Rough-In",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1010"
    },
    {
      id: "f69b96e0-ef80-41cb-aff2-025ad95a1fdd",
      text: "BLDG-1/2 - Coordinate Scope and Submittal Req's - Security System (Prod Dat)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-02T08:00:00",
      duration: 8,
      parent: "d7b1b4ab-cbd4-4b4a-808b-511b0980ad59",
      progress: 0,
      source_task_id: "B1.CFCI.3180"
    },
    {
      id: "69e798ea-3a81-40ed-a5e8-230876e74e8d",
      text: "B2 - DH-D - Trenching for Deep Electric",
      type: 0,
      start_date: "2025-07-31T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 120,
      parent: "93e3b1d4-f52c-43b4-a225-1c6c27a55c2c",
      progress: 0,
      source_task_id: "B2.C.STR.1400"
    },
    {
      id: "aa209eb0-d113-4c31-95a3-4d93162c7a48",
      text: "B1 - SSB - 1E2 - Common - Final Paint",
      type: 0,
      start_date: "2025-10-25T00:00:00",
      end_date: "2025-11-05T08:00:00",
      duration: 80,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2390"
    },
    {
      id: "39f62e9e-9f41-468d-a3a5-7c788feaece2",
      text: "(CFCI) Div. 11 - OH Monorail Fall Protection",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "fe426be2-0e9f-4710-8fb3-13f55f18c43f",
      progress: 0,
      source_task_id: "7994909"
    },
    {
      id: "6adae03f-5c9c-48b4-8f46-f5c29ada199e",
      text: "B2 - SSB - 2E1 - Common - Install Bathroom Accessories",
      type: 0,
      start_date: "2026-03-31T00:00:00",
      end_date: "2026-04-06T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1340"
    },
    {
      id: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      text: "B2 - DH-B - Precast",
      type: 0,
      start_date: "2025-10-17T00:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 40,
      parent: "0fd5f596-cff5-41cb-8455-a352db88370a",
      progress: 0,
      source_task_id: "B2.C.1550"
    },
    {
      id: "5900e46e-c1ed-4291-9024-e958fb77329a",
      text: "Area 1 - UG RI -RSB/MSB-DCB1",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1150"
    },
    {
      id: "828e2b04-6e5a-4259-94a4-828c11f3f999",
      text: "Owner Substation - 1 Ready for Energization",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-22T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "TPM.B1.2016"
    },
    {
      id: "b1180801-66be-4b3c-8312-7b72561ddb83",
      text: "B2 - SSB - 2E1 - Common - Install Doors and Hardware",
      type: 0,
      start_date: "2026-04-07T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1360"
    },
    {
      id: "532d2c6e-2c95-4dcc-8b28-853d48f9f8c7",
      text: "B2 - SSB - Install Exterior Metal Panels & Louvers",
      type: 0,
      start_date: "2025-12-24T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 160,
      parent: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      progress: 0,
      source_task_id: "B2.C.5030"
    },
    {
      id: "14aea842-8ba1-4827-9295-2495d96c3d79",
      text: "L4 - B2 MSG-B",
      type: 0,
      start_date: "2026-06-25T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 40,
      parent: "2cea20c5-e3c2-4ea6-97b9-c8811e3bf86d",
      progress: 0,
      source_task_id: "CX4.B2.SS.1020"
    },
    {
      id: "171c0117-c074-4b63-bbec-700ef043fb6a",
      text: "B1 - DH-B - Pull/Term Fire Alarm - Data Hall B",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2760"
    },
    {
      id: "83c6985e-fea6-443f-94e2-60f9ed8b43bf",
      text: "B1 - DH-B - Install Celing Devices Fire Alarm - Data Hall B",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 160,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2820"
    },
    {
      id: "cab70635-26b8-48cf-ac52-2980f163bc90",
      text: "BLDG-1/2 - Prep / Submit for Review -Epoxy Flooring (Spec 09 67 23)",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 160,
      parent: "7e52e785-c4af-4414-bc14-09a437907568",
      progress: 0,
      source_task_id: "B1.CFCI.4620"
    },
    {
      id: "4508e8bd-a515-4fe4-836e-a8d2434e7a95",
      text: "Area A - OH Fire Alarm",
      type: 0,
      start_date: "2025-07-02T00:00:00",
      end_date: "2025-07-16T08:00:00",
      duration: 80,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1043"
    },
    {
      id: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      text: "Area 4 - Telecom Install - CAV2 to GH",
      type: 0,
      start_date: "2024-10-03T00:00:00",
      end_date: "2024-11-06T08:00:00",
      duration: 240,
      parent: "8609b6ff-9850-48d0-a7d4-8aefeb103cfe",
      progress: 0,
      source_task_id: "C.CSU.A4.8020"
    },
    {
      id: "d7b1b4ab-cbd4-4b4a-808b-511b0980ad59",
      text: "(CFCI) Div. 28 - Security Syst.",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 608,
      parent: "632be35f-8f46-4b5c-bb52-d9b55c9ddad3",
      progress: 0,
      source_task_id: "7994886"
    },
    {
      id: "a43b526a-fc14-4c28-ab85-db98d74d496c",
      text: "B1 - DH-D - Term Bussways - Data Hall D",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-24T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1250"
    },
    {
      id: "d9411721-bf5d-4996-a5c7-df15dd61391c",
      text: "B2 - DH-A - Install Cable Tray - Data Hall A",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-04-09T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2270"
    },
    {
      id: "883427a6-7812-434c-b7bc-0738a53a7b23",
      text: "Fragnet 34 - PCO # 35 RFI-123 Substa 1 & 2 Teleco Misalgn",
      type: 0,
      start_date: "2024-10-07T00:00:00",
      end_date: null,
      duration: 200,
      parent: null,
      progress: 0.5,
      source_task_id: "8690694"
    },
    {
      id: "bdf79de1-4d90-4d0a-a474-3bde0e6f2115",
      text: "B1 - SSB - 1E1 - Common - Install Cable Tray",
      type: 0,
      start_date: "2025-08-05T00:00:00",
      end_date: "2025-08-21T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1740"
    },
    {
      id: "31669510-e59d-4be6-b5cc-c39c01546c06",
      text: "B1 - SSB - 1E1 - Common - Install Devices in Tile/OH Sprinkler",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-19T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2140"
    },
    {
      id: "6d6fce69-8759-4441-9d3a-c5e9942272cb",
      text: "B2 - 2C2  (GS.IDF.2C2) - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-03-27T00:00:00",
      end_date: "2026-03-27T08:00:00",
      duration: 8,
      parent: "0ad5fd02-3ce7-4f63-92ba-b2c80fcac48f",
      progress: 0,
      source_task_id: "B2.C.C.1490"
    },
    {
      id: "1d9febe4-3b3c-4fee-b924-6d98635b05a6",
      text: "B2 - DH-C - DEC -C Turnover Walk - Data Hall C",
      type: 0,
      start_date: "2026-09-14T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 16,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2690"
    },
    {
      id: "01735b44-2928-416e-8263-a57a4f22304f",
      text: "Area 4 - Water Utilites Install",
      type: 0,
      start_date: "2025-01-16T00:00:00",
      end_date: "2025-01-23T08:00:00",
      duration: 48,
      parent: "5cfc9fca-b165-4c0a-b17d-687aeb42332b",
      progress: 0,
      source_task_id: "C.CSU.A4.5000"
    },
    {
      id: "f71698b8-627c-496f-97f1-8206e201204c",
      text: "Central Plant Piping Racks",
      type: 5,
      start_date: "2025-09-29T08:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 280,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994828"
    },
    {
      id: "f6e10691-1afe-4c2e-b60a-a31bcd1612c4",
      text: "FR 27 - META review and Approve PCO#25",
      type: 0,
      start_date: "2024-10-30T00:00:00",
      end_date: "2024-11-22T08:00:00",
      duration: 80,
      parent: "aa1ff7d6-d087-48dd-9265-36de0702a4b8",
      progress: 0,
      source_task_id: "FR.27.1020"
    },
    {
      id: "eef8ced1-edc5-410d-9fd7-d16105b984aa",
      text: "Site / UG BIM - Area 2 - Critical Early Release - Coordination / Sign Off",
      type: 0,
      start_date: "2024-03-18T00:00:00",
      end_date: "2024-04-08T00:00:00",
      duration: 120,
      parent: "95524127-d258-468f-bf0c-270ee743c7b2",
      progress: 1,
      source_task_id: "SITE.VDC.1030"
    },
    {
      id: "d34d7cb0-44dc-45d6-a43e-4cf75688b937",
      text: "L3 - B2 EY 1A/C",
      type: 0,
      start_date: "2026-08-11T00:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 80,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "CX3.B2.MSG.1010"
    },
    {
      id: "f715f119-44b4-4cf3-a3b8-4fcfa534a19f",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-04-09T00:00:00",
      end_date: "2026-04-22T08:00:00",
      duration: 80,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2290"
    },
    {
      id: "e68c0bc3-ab1f-4f9e-b626-bd13757fab96",
      text: "Remote GS.IDF",
      type: 5,
      start_date: "2025-06-19T08:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 352,
      parent: "e31d381c-f706-42c3-84db-227ca55e8f11",
      progress: 0,
      source_task_id: "7994836"
    },
    {
      id: "62872b9b-6759-4561-825b-c00ed5bb886c",
      text: "BLDG-1 DH-D Electrical Pulls",
      type: 5,
      start_date: "2025-09-26T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 376,
      parent: "be331373-f4a8-4cdd-a0c8-d2e188c92f04",
      progress: 0,
      source_task_id: "7995265"
    },
    {
      id: "c5448f94-aac6-4083-902d-84b19be1cc0f",
      text: "B1 - 1B2E - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2025-09-23T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 160,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.1820"
    },
    {
      id: "e55b463d-aa5d-494c-a126-242c52dc6736",
      text: "B1 - mCUP-1-9 - Equipment Pads - Sequence 2",
      type: 0,
      start_date: "2025-01-18T00:00:00",
      end_date: "2025-02-11T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1030"
    },
    {
      id: "c7cc0d73-9cfd-4561-813e-c597573cb5d7",
      text: "B2 - DH-D - Set CDU's - Data Hall D (16 total; 4 per day) - DCI 3134",
      type: 0,
      start_date: "2026-06-06T00:00:00",
      end_date: "2026-06-15T08:00:00",
      duration: 64,
      parent: "9de23734-57e7-4283-a531-2f57ac2525e9",
      progress: 0,
      source_task_id: "B2.C.D.3340"
    },
    {
      id: "c86e5224-8fd7-4379-a344-a4f1d0950fe2",
      text: "Campus - Install Campus Hardscape - Sequence 1",
      type: 0,
      start_date: "2025-08-16T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 288,
      parent: "0fbbf7fa-904a-48e8-8721-806fbcb106b9",
      progress: 0,
      source_task_id: "C.SI.HS.1000"
    },
    {
      id: "0f9ea7ed-922f-49c6-a51c-4fce48117730",
      text: "B2 - DH-C - El Equip Yd - Pulls Terms to Equipment (Converted to LOE)",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-06-22T08:00:00",
      duration: 440,
      parent: "ac95068d-11da-4a2f-a631-5499e7e594cc",
      progress: 0,
      source_task_id: "B2.C.EY.1460"
    },
    {
      id: "fd0da505-7ac6-4f33-b243-fa60110dacc1",
      text: "Weather tight SSB and Network Core",
      type: 0,
      start_date: "2025-06-23T00:00:00",
      end_date: "2025-06-23T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1020"
    },
    {
      id: "1165ec92-fbbf-425e-abc5-3aed33f40cc6",
      text: "DFSMA - First ROJ - MOFE - Multi-Trade/ Pipe Racks (NW Corridor)",
      type: 0,
      start_date: "2025-05-30T08:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 0,
      parent: "26a34def-3ec1-4af6-b6d7-47efc2050f0e",
      progress: 0,
      source_task_id: "B1.DFSMA.1200"
    },
    {
      id: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      text: "B1 - SSB - Install Vapor Barrier",
      type: 0,
      start_date: "2025-05-16T00:00:00",
      end_date: "2025-05-21T08:00:00",
      duration: 40,
      parent: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      progress: 0,
      source_task_id: "B1.C.RF.1030"
    },
    {
      id: "080ee61e-f797-4a93-863e-ccc85e94d622",
      text: "UG RI -Fire Alarm-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-12T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 80,
      parent: "d87c40c9-36ba-466e-9282-c17bb73cf6fe",
      progress: 0,
      source_task_id: "MECO-1680.10"
    },
    {
      id: "0b91b206-4834-49db-8c68-87228c7823a7",
      text: "B2 - 2E1E - 02.01.E1.01 - Term Electrical and NETA Testing",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-02T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5570"
    },
    {
      id: "dba96e5c-8d5f-480a-97c3-c5c7e50450d1",
      text: "DFSMA - DC2 - CUP 8- Pipe Racks ROJ - MOFE",
      type: 0,
      start_date: "2025-11-17T08:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 0,
      parent: "f71698b8-627c-496f-97f1-8206e201204c",
      progress: 0,
      source_task_id: "B2.DFSMA.1320"
    },
    {
      id: "d3c255df-7097-4f6a-96de-1316214ccd67",
      text: "Final Paint",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-04T08:00:00",
      duration: 40,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1370"
    },
    {
      id: "7359fe81-7390-40a2-b51c-77967c923179",
      text: "B1 - Network Room 2/3 - Rough In Vesda",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 80,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1920"
    },
    {
      id: "0121be95-59af-4e15-92d6-9c96714070dd",
      text: "B1 - Network - Backfill",
      type: 0,
      start_date: "2025-03-17T00:00:00",
      end_date: "2025-03-18T08:00:00",
      duration: 16,
      parent: "f3cce9c8-d6b4-4532-9f77-a3f20c7ae814",
      progress: 0,
      source_task_id: "B1.C.STR.1400"
    },
    {
      id: "c75eae43-a879-4112-95b5-3aa7ce69c216",
      text: "B1 - 1D2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2270"
    },
    {
      id: "b7ca906c-6386-415f-9637-8fae1d1c0499",
      text: "B1 - DH-D - Foundations",
      type: 0,
      start_date: "2025-03-14T00:00:00",
      end_date: "2025-03-27T08:00:00",
      duration: 96,
      parent: "ad71e5c7-bee8-452a-9b25-1f9b72f9c985",
      progress: 0,
      source_task_id: "B1.C.STR.1390"
    },
    {
      id: "c9ca9ab5-7485-4d38-99c3-3c5fef4f879b",
      text: "Critical / Near Critical",
      type: 0,
      start_date: "2023-12-01T00:00:00",
      end_date: null,
      duration: 4112,
      parent: null,
      progress: 0.21,
      source_task_id: "8690696"
    },
    {
      id: "1524a761-f8a6-4d36-80db-aea7d3a6b097",
      text: "B2 - 2B2 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-02-12T08:00:00",
      duration: 8,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1330"
    },
    {
      id: "b394bc5d-6c5a-433d-9980-024a535cda33",
      text: "Building 1 mCUP-1",
      type: 5,
      start_date: "2025-07-08T00:00:00",
      end_date: "2025-08-27T08:00:00",
      duration: 352,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "7995372"
    },
    {
      id: "b7b25fc2-f423-4294-905f-82c550d8e451",
      text: "B1 - 1N1E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5510"
    },
    {
      id: "8a82eeb3-f27f-4093-832a-ce09ce437500",
      text: "Tier 2, 3, 4 - B2-2-C",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      progress: 0,
      source_task_id: "7994772"
    },
    {
      id: "b689c116-9865-4106-b790-0f9b9203295e",
      text: "B1 - DH-C - Backfill",
      type: 0,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-22T08:00:00",
      duration: 40,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1760"
    },
    {
      id: "35c982bf-8751-44ae-897b-9f7999cf2d24",
      text: "Meta Review & Comment - Baseline 2 Estimate Reconciliation",
      type: 0,
      start_date: "2024-02-20T00:00:00",
      end_date: "2024-03-07T08:00:00",
      duration: 104,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1160"
    },
    {
      id: "abb99ed0-8a95-466e-99dd-475492996a6a",
      text: "Utility Provider Substation - Pad ready for Utility Contractor",
      type: 0,
      start_date: "2024-12-27T00:00:00",
      end_date: "2024-12-27T00:00:00",
      duration: 80,
      parent: "c99b52b5-cb9e-4df2-b38d-079c1e174658",
      progress: 0,
      source_task_id: "CX0.USS.L2.0010"
    },
    {
      id: "01146062-a3b3-4b1c-a6f6-82cd7891b826",
      text: "Substation-1 - Install Stone Base",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2025-05-28T08:00:00",
      duration: 192,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3340"
    },
    {
      id: "f81b9767-093c-4d6e-a4a6-507ec2ac8d97",
      text: "Fire Water",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2024-12-11T08:00:00",
      duration: 72,
      parent: "c426d973-b4ff-44ee-998f-d05595eda66e",
      progress: 0,
      source_task_id: "7995194"
    },
    {
      id: "17550e9f-710a-4082-aeeb-c0832f387333",
      text: "B1 - mCUP-1-9 - Make Up Water Building - Erect Building",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-03-07T08:00:00",
      duration: 160,
      parent: "6c0c7402-6e89-483a-ac8e-42af3c344dfc",
      progress: 0,
      source_task_id: "B1.mCUP.1040"
    },
    {
      id: "283ccf29-de5d-439d-b58f-c58db84dee49",
      text: "Utility Provider Substation - Santee Cooper Buildout of UtilityS ubstation (META)",
      type: 0,
      start_date: "2025-01-02T00:00:00",
      end_date: "2025-12-13T08:00:00",
      duration: 2032,
      parent: "c99b52b5-cb9e-4df2-b38d-079c1e174658",
      progress: 0,
      source_task_id: "CX0.USS.L2.0020"
    },
    {
      id: "94809bf2-cd90-4603-a7c0-8e4ab5a90173",
      text: "B2 - 2C2  (GS.IDF.2C1) - Corridor - Room Fit Out - Mechanical",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-11T08:00:00",
      duration: 80,
      parent: "daebe31d-2394-4f3c-9b7c-cd745a7d73e2",
      progress: 0,
      source_task_id: "B2.C.C.2290"
    },
    {
      id: "46219bb1-f994-4392-acd5-8ba98fac6098",
      text: "Area 1 - Telecom Install",
      type: 0,
      start_date: "2024-11-06T00:00:00",
      end_date: "2024-12-30T08:00:00",
      duration: 336,
      parent: "855069c2-09d3-46f0-895c-34ac09b49a3d",
      progress: 0,
      source_task_id: "C.CSU.A1.8000"
    },
    {
      id: "fa6a550e-706e-4869-bf75-8850a0b4d54c",
      text: "ADMIN- Fabricate / Deliver - Signage",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: null,
      duration: 240,
      parent: "c93c1b8b-4755-40fe-96da-362f2de1edc2",
      progress: 0,
      source_task_id: "B1.CFCI.6170"
    },
    {
      id: "ca2b1a16-aa3c-42b6-b354-62ed7289f230",
      text: "Area A - Pull Wire",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 80,
      parent: "a98f4462-68bb-4978-b7d1-e4ab38878a0f",
      progress: 0,
      source_task_id: "IBOS.CON.1520"
    },
    {
      id: "62b2f374-ec58-4866-bd65-9da99cd2503d",
      text: "FR 39 - Rebar procurement",
      type: 0,
      start_date: "2024-11-21T00:00:00",
      end_date: null,
      duration: 88,
      parent: "1f063521-b2a3-4b0d-838c-2b55c3f2085a",
      progress: 0,
      source_task_id: "FR.39.1020"
    },
    {
      id: "007e9ce2-35ab-48f7-b076-9a6bf08a756b",
      text: "B2 - mCUP-5 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5100"
    },
    {
      id: "01268485-98d9-4d10-b71b-2f6542753210",
      text: "Fab and Deliver - PLC Panels - DIO - mCUP (Integrator) - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-05-30T08:00:00",
      duration: 2632,
      parent: "750bef5c-bf18-4074-a4e2-33064e6262a0",
      progress: 0.35,
      source_task_id: "B2.OFCI.1870"
    },
    {
      id: "e96128c0-cee5-4dd2-9304-c284387627bb",
      text: "B2 - SSB - 2E1 - Common - Install Carpet",
      type: 0,
      start_date: "2026-05-15T00:00:00",
      end_date: "2026-05-21T08:00:00",
      duration: 40,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1410"
    },
    {
      id: "1f4de4a8-3d03-4c1b-ad5e-dde7dcf62caf",
      text: "DFSMA - DC2 EY-D Skids ROJ - MOFE",
      type: 0,
      start_date: "2026-04-07T08:00:00",
      end_date: "2026-04-07T08:00:00",
      duration: 0,
      parent: "76b1ad37-499d-4ec3-8342-ec0ede70139c",
      progress: 0,
      source_task_id: "B2.DFSMA.1000"
    },
    {
      id: "61bdc405-056a-4272-8171-8143f5faa4f4",
      text: "B1 - SSB - 1E2 - Common - Install Porcelain Tile",
      type: 0,
      start_date: "2025-09-17T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2170"
    },
    {
      id: "801c45de-c08d-43b2-85ae-c95b2af0143b",
      text: "B2 - DH-B - WAP Provisioning",
      type: 0,
      start_date: "2026-08-12T00:00:00",
      end_date: "2026-09-09T08:00:00",
      duration: 160,
      parent: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      progress: 0,
      source_task_id: "B2.CONN.1230"
    },
    {
      id: "a6f6f4c4-075a-42f0-96f1-691c91e026d3",
      text: "B2 - 2E1E - EF4 - Terms for Lighting/Outlet/Racks (EF4)",
      type: 0,
      start_date: "2026-01-21T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 24,
      parent: "bb7991d1-caa2-4d04-9218-4faad3a51533",
      progress: 0,
      source_task_id: "B2.C.5340"
    },
    {
      id: "8eae24f6-ae67-4923-a5a7-c591b983d970",
      text: "BLDG-1 - Area B - Deliver - Anchor Bolts",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-06T08:00:00",
      duration: 80,
      parent: "c982e1b0-571f-4b01-881f-32acfcdbc31a",
      progress: 0,
      source_task_id: "B1.CFCI.4640"
    },
    {
      id: "fbe66827-31ea-4a2d-b5cc-a00140f8c47f",
      text: "B1 - 1N1E (GS.IDF.A1) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 24,
      parent: "2ffd6ed9-96d1-453f-b8a7-79772a20b779",
      progress: 0,
      source_task_id: "B1.C.A.1670"
    },
    {
      id: "87d31044-91f0-4602-ad3f-fb2e6f10955c",
      text: "Substation-1 - A Lineup - Dead End Structure Steel Erection And Branch Wiring",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 104,
      parent: "ad9bcc69-2423-47a9-879e-e48510c33ecb",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3900"
    },
    {
      id: "727c2ac2-cf76-45d9-996e-41d67311c83d",
      text: "B1 - DH-A - Install IMP Ceiling - Data Hall A",
      type: 0,
      start_date: "2025-08-28T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1850"
    },
    {
      id: "1875a1d7-f07f-45da-8bb1-42ce581297a7",
      text: "B1 - SSB - Install Underground Plumbing",
      type: 0,
      start_date: "2025-02-05T00:00:00",
      end_date: "2025-02-15T08:00:00",
      duration: 80,
      parent: "1d5435d0-cb94-4f72-81de-1960af236461",
      progress: 0,
      source_task_id: "B1.C.STR.1080"
    },
    {
      id: "7bb51d4c-8179-4d67-b199-7fb7f7af2db9",
      text: "Waterproofing",
      type: 5,
      start_date: "2024-08-27T00:00:00",
      end_date: "2024-10-29T08:00:00",
      duration: 360,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994846"
    },
    {
      id: "03b46ffc-4f12-4c97-bddf-5b0faf01aaca",
      text: "ENS Room Ready Network Core Suites - DCB1",
      type: 0,
      start_date: "2026-07-06T08:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2150"
    },
    {
      id: "ab624b77-dba0-418f-a141-0b47ceaf4741",
      text: "Food Service - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5900"
    },
    {
      id: "71a3d173-ebfb-4922-9117-d061cce6217b",
      text: "B1 - 1N2E - Corridor - OH Rough In Feeder",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5220"
    },
    {
      id: "6a90a127-28fd-4775-a98d-e17c6c84f2cf",
      text: "B1 - 1C1W - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-08-13T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 40,
      parent: "7aa2cb2b-a28e-41e2-aaae-fff16656008c",
      progress: 0,
      source_task_id: "B1.C.C.1080"
    },
    {
      id: "c7e805d0-a92b-4e82-89e5-fa872a7609dc",
      text: "B1 - Network Room 2/3 - Power Alley - Equipment Hookup / Tie-in Feeder Conduit (Electrical Contractor)",
      type: 0,
      start_date: "2025-09-06T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 192,
      parent: "dcce1ad0-53d9-4abf-be2d-ee08fc9a4229",
      progress: 0,
      source_task_id: "B1.C.NR.1840"
    },
    {
      id: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      text: "(OFCI) LLE - Building 2",
      type: 5,
      start_date: "2023-11-01T00:00:00",
      end_date: "2026-05-04T08:00:00",
      duration: 5040,
      parent: "8820736c-410e-4efe-a06b-d0fc26d82040",
      progress: 0.13,
      source_task_id: "7994943"
    },
    {
      id: "d680b996-bb03-458a-b0a7-d8ecafdcb524",
      text: "Pad Prep / Deep Foundations - IBOS",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2024-11-25T08:00:00",
      duration: 40,
      parent: "56854237-ebdf-4446-8f94-9f575bfa1fbf",
      progress: 0,
      source_task_id: "C.CSU.A1.1010"
    },
    {
      id: "2848bb95-d1c2-4518-9d78-d325f4e2c6d1",
      text: "Delivery of PTX - Pad Mounted Transformers (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-03-21T08:00:00",
      end_date: "2025-03-21T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1830"
    },
    {
      id: "eade8e07-2e96-4243-a8fa-1d6f6255814c",
      text: "Punchlist / Zero Defects",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 120,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1380"
    },
    {
      id: "54e84b4f-6e70-489b-bf06-4ee2ba15d7e0",
      text: "B1 - 1D1W - 01D.08 - Install Lighting Rough In",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 48,
      parent: "d8e63b8f-ddd1-4349-8f44-f4e428b827a0",
      progress: 0,
      source_task_id: "B1.C.D.2210"
    },
    {
      id: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11",
      text: "Area 4 - NCP Duct Bank & Equipment Install",
      type: 0,
      start_date: "2025-04-02T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 104,
      parent: "3c41bf6e-836e-40f7-b092-84c97b0ff3cf",
      progress: 0,
      source_task_id: "C.CSU.A4.6000"
    },
    {
      id: "1a7383df-d935-43a5-a4a3-e0061fd8cf96",
      text: "Off Campus - Install Temporary Cx Power",
      type: 0,
      start_date: "2024-04-19T00:00:00",
      end_date: "2025-07-01T08:00:00",
      duration: 2864,
      parent: "d0fa8e9c-c691-43f9-a332-5b54fd839d54",
      progress: 0.15,
      source_task_id: "C.CSW.3080"
    },
    {
      id: "4a130107-010b-4615-9c6e-fe49ed9d70c8",
      text: "B1 - Network Room 1/4  - In Wall Rough Ins/Inspections - Electrical",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1060"
    },
    {
      id: "ad67dbc7-f76d-40bd-b506-435bcbce4b21",
      text: "B2 - SSB - Install Thermal Concrete",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1080"
    },
    {
      id: "04bde596-890b-43b4-bee2-7ec958349cb7",
      text: "B1 - SSB - 1E1 - CMDF1 - Hang/Tape/Finish Drywall (Carrier MDF1)",
      type: 0,
      start_date: "2025-07-23T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 48,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1550"
    },
    {
      id: "c6bde09b-8153-44fd-a653-a7dffa1f104a",
      text: "[DCB2] FacNet Live [Area D]",
      type: 0,
      start_date: "2026-11-30T08:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 0,
      parent: "f4d19297-ba11-4388-b91c-b797e3b6a71a",
      progress: 0,
      source_task_id: "ICM.B2.3687"
    },
    {
      id: "1461d24b-e7bf-4a67-8146-e10bf70e8d5c",
      text: "FR 06 - META review and Approve PCO#2 (ROM)",
      type: 0,
      start_date: "2024-09-16T00:00:00",
      end_date: null,
      duration: 0,
      parent: "663db2bb-cbcf-49f5-971b-3d987523b12f",
      progress: 1,
      source_task_id: "FR.06.1050"
    },
    {
      id: "83ca5c4c-ea2d-4317-b93f-4ae7ffc47fde",
      text: "B1 - 1N1E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1080"
    },
    {
      id: "279c4ab6-97fa-41f3-8300-c0825ad9a7bf",
      text: "Fab and Deliver - MSB - Area C - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 3808,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 0.38,
      source_task_id: "B2.OFCI.2480"
    },
    {
      id: "f0e9db08-4cbb-458d-8b7c-f71051caadd9",
      text: "B1 - DH-C - Install Feeder Conduit -Data Hall C",
      type: 0,
      start_date: "2025-11-21T00:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2470"
    },
    {
      id: "d063a395-07dc-4681-9a7d-b35e9319f202",
      text: "B1 - SSB - 1E1 - Common - Install Rubber Base",
      type: 0,
      start_date: "2025-11-19T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 40,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2470"
    },
    {
      id: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      text: "B2 - DH-A - Power Alley - Frame Walls",
      type: 0,
      start_date: "2025-11-24T00:00:00",
      end_date: "2025-12-08T08:00:00",
      duration: 80,
      parent: "c5d99f62-9213-42a7-8c15-25124d8fbd5d",
      progress: 0,
      source_task_id: "B2.C.A.1010"
    },
    {
      id: "38c5e814-1788-44d4-9fdf-05ab8e7f4071",
      text: "Initial PWO Document Creation (GC)",
      type: 0,
      start_date: "2023-10-19T00:00:00",
      end_date: "2023-11-03T00:00:00",
      duration: 88,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "PRE-EP-1020"
    },
    {
      id: "350341a1-6bc1-4188-890f-4189a5bb0d5e",
      text: "Admin - Prep / Submit for Review - Lighting",
      type: 0,
      start_date: "2024-11-04T00:00:00",
      end_date: "2024-11-19T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.PROC.1150"
    },
    {
      id: "4b2b452c-c32b-48b9-93c6-5bdc5902ce40",
      text: "Precast Network",
      type: 5,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-05-09T08:00:00",
      duration: 80,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995410"
    },
    {
      id: "4ba9e176-dcd7-4687-ac34-49af0db8707b",
      text: "Fab and Deliver - Control Power UPS - Area A - DCB1",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2248,
      parent: "f9b82cd1-5094-4590-8c47-e2a30a824f3e",
      progress: 0.49,
      source_task_id: "B1.OFCI.3000"
    },
    {
      id: "57b5fb21-93fa-4461-8e38-401fa92838e3",
      text: "Area 3 - UG RI -MVS to MVS-DCB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1490"
    },
    {
      id: "09557f2b-1f59-473a-be64-f201ed83efda",
      text: "Fab and Deliver - Fan Coil Assembly - Area C - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-07-15T08:00:00",
      duration: 3184,
      parent: "be989221-1474-4327-b00b-6970f7e48d22",
      progress: 0.48,
      source_task_id: "B2.OFCI.2710"
    },
    {
      id: "379311ae-7a7f-4ac2-8a18-7ea1aedbe955",
      text: "Substantial Completion (DH C) - DCB1",
      type: 0,
      start_date: "2026-10-07T08:00:00",
      end_date: "2026-10-07T08:00:00",
      duration: 0,
      parent: "de6524fb-70fe-4f74-b325-71d879d3578a",
      progress: 0,
      source_task_id: "ICM.B1.1100"
    },
    {
      id: "ce03bc86-151b-4d7e-945c-3450639eef73",
      text: "BLDG-1/2 - Fabricate / Deliver - Doors, Frames and Hardware",
      type: 0,
      start_date: "2025-04-03T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 360,
      parent: "e8e087a2-228d-4d9a-91a8-4636f0923181",
      progress: 0,
      source_task_id: "B1.CFCI.4770"
    },
    {
      id: "685fdb1a-e473-450e-9752-37190bb60713",
      text: "IBOS - Prep / Submit for Review - Storage racks",
      type: 0,
      start_date: "2024-12-02T00:00:00",
      end_date: null,
      duration: 160,
      parent: "62518f68-8afa-4d56-ac54-3dfa598c2eba",
      progress: 0,
      source_task_id: "B1.CFCI.6420"
    },
    {
      id: "60b22ed4-5b6b-483e-a342-4ae86e519f13",
      text: "Substation-2 - MSG A - Install Temp Power / Permenant AC / Anchoring / Set In Place Inspection",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "da2c75bf-4cca-437e-88ae-73f64841928e",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4700"
    },
    {
      id: "78328bd2-0c8c-4c95-a304-3ad7bc0381ca",
      text: "B1 - 1D1W - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2025-10-16T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 40,
      parent: "4928e351-95f4-4e48-9189-4f9661a74a7f",
      progress: 0,
      source_task_id: "B1.C.D.1830"
    },
    {
      id: "4c878dc4-d252-4cfd-a46c-08269c37c510",
      text: "B1 - Network Room 1/4  - Install Ceiling Tiles",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-06T08:00:00",
      duration: 40,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.2140"
    },
    {
      id: "d21d165e-9c90-44f5-b79e-b355adbed776",
      text: "B1 - SSB - 1E1 - GSMDF1 - In Wall Rough-In/ Inspections",
      type: 0,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-07-22T08:00:00",
      duration: 48,
      parent: "bc594957-c3be-421b-99ef-5eec3af850f9",
      progress: 0,
      source_task_id: "B1.C.SSB.1420"
    },
    {
      id: "ae6106a3-55f9-4620-ba25-fb37b62aa6e8",
      text: "B2 - 2B2 - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-30T08:00:00",
      duration: 120,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1010"
    },
    {
      id: "3c87948c-85dd-4896-bd9c-585d039a57e0",
      text: "Substation-2 - Pull and Term Substation to MSG Building 1 A/C (Pull to Vaults) - Sequence 1",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-12-03T08:00:00",
      duration: 160,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1070"
    },
    {
      id: "0d011268-7774-4b6a-b9a8-9169aac4cae9",
      text: "Steel Bid & Develop SA Package",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2024-02-29T08:00:00",
      duration: 448,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1010"
    },
    {
      id: "920c3f23-c495-404b-874e-11586810c7da",
      text: "B2 - DH-D - El Equip Yd - (Level of Effort)",
      type: 0,
      start_date: "2025-11-25T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 1264,
      parent: "571ac984-f404-434d-91ca-a3894e570ddf",
      progress: 0,
      source_task_id: "B2.C.EY.1160"
    },
    {
      id: "f8471d33-1151-45dc-be3d-f2301bda8d0f",
      text: "IFC Package - Issuance",
      type: 0,
      start_date: "2024-06-14T08:00:00",
      end_date: "2024-06-14T08:00:00",
      duration: 0,
      parent: "c884f3e1-0476-48f8-860b-e5f48adfe961",
      progress: 1,
      source_task_id: "Design.PreC.2480"
    },
    {
      id: "81f4daa4-bcf2-48e8-993b-b2185d7a4e2b",
      text: "FR 09 - DPR Prepare and Submit PCO#5",
      type: 0,
      start_date: "2024-07-31T00:00:00",
      end_date: null,
      duration: 320,
      parent: "64c1284c-d6e1-4add-b5b3-bc6e1e9a4b2b",
      progress: 0.7,
      source_task_id: "FR.09.1020"
    },
    {
      id: "50ece6a7-a3be-472a-af0b-302205a22925",
      text: "B1 - SSB - 1E2 - Common - Install Carpet",
      type: 0,
      start_date: "2025-11-07T00:00:00",
      end_date: "2025-11-12T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2430"
    },
    {
      id: "45735b5d-f763-4159-9283-12a672462f7c",
      text: "B2 - DH-B - Install Fire Alarm Conduit/Vesda -Data Hall B",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2720"
    },
    {
      id: "863cba8d-56cd-42b4-8e65-2ee4696e69fa",
      text: "B1 - Network Room 1/4  - Rough In Lighting",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-20T08:00:00",
      duration: 80,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1970"
    },
    {
      id: "3eb7a46b-4380-444b-8d03-fdc6c8e59204",
      text: "B1 - DH-D - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-18T08:00:00",
      duration: 80,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1050"
    },
    {
      id: "cb6057e9-2782-44be-9789-1244393164b9",
      text: "FR 05 - Model Coordination and resolve",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "A1150"
    },
    {
      id: "7a8579ed-8300-4b9e-bc59-c69e933b305d",
      text: "Campus - Fabricate / Deliver - Storm Manholes and Inlets (Early Release)",
      type: 0,
      start_date: "2024-05-20T00:00:00",
      end_date: "2024-06-03T08:00:00",
      duration: 80,
      parent: "0838401f-ca7a-4b90-a871-63675f860af4",
      progress: 1,
      source_task_id: "B1.CFCI.4210"
    },
    {
      id: "bbd610ef-d3e9-4a85-adcb-8f7a3b171d48",
      text: "B1 - mCUP-5 - Install Mechanical / Header Tie In Connections",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5020"
    },
    {
      id: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      text: "B2 - 2B1 - Corridor - Frame Walls",
      type: 0,
      start_date: "2026-01-09T00:00:00",
      end_date: "2026-01-13T08:00:00",
      duration: 24,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.1410"
    },
    {
      id: "8bc22fdb-792a-44dd-8cb1-f81136adcddf",
      text: "B2 - 2C1W - 02C.07 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2026-03-18T00:00:00",
      end_date: "2026-03-24T08:00:00",
      duration: 40,
      parent: "3fc8249c-f75e-43d1-80cb-c7dce921b390",
      progress: 0,
      source_task_id: "B2.C.C.1680"
    },
    {
      id: "621c2bbd-da9f-46a2-a233-976e158012a5",
      text: "Building 2",
      type: 5,
      start_date: "2025-02-27T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 3888,
      parent: "abe1a98c-028c-44b8-8da7-9658d12e1819",
      progress: 0,
      source_task_id: "7995019"
    },
    {
      id: "8901a989-4c49-4864-834a-2a9756542651",
      text: "(CFCI) Div. 23 - HVAC Insulation",
      type: 5,
      start_date: "2024-12-06T00:00:00",
      end_date: "2025-02-04T08:00:00",
      duration: 320,
      parent: "68eac5c6-f18e-45f7-880e-8d00154eca77",
      progress: 0,
      source_task_id: "7994903"
    },
    {
      id: "3b263764-6686-4c56-b856-b5de86aae709",
      text: "BLDG-1 - BIM - Tier 1 - Area 1-C - Coordination / Sign-off",
      type: 0,
      start_date: "2025-01-13T00:00:00",
      end_date: "2025-02-07T08:00:00",
      duration: 240,
      parent: "04cae6b1-1ca2-4ca5-b054-a176ccf35389",
      progress: 0,
      source_task_id: "B1.VDC.1620"
    },
    {
      id: "12b9d796-8640-4dc0-8f20-2033aed26fc5",
      text: "B2 - 2C2 - Corridor - OH Rough In Branch",
      type: 0,
      start_date: "2026-03-06T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 40,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1280"
    },
    {
      id: "fd68c53c-2f7a-4a32-9e46-e555713f2672",
      text: "BLDG-1/2 - Submittals - Doors, Frames and Hardware",
      type: 0,
      start_date: "2025-02-12T00:00:00",
      end_date: "2025-03-12T08:00:00",
      duration: 160,
      parent: "e8e087a2-228d-4d9a-91a8-4636f0923181",
      progress: 0,
      source_task_id: "B1.CFCI.3720"
    },
    {
      id: "cef9533d-10dc-42cf-97c8-faaec8f8ec18",
      text: "B1 - 1C2E  (GS.IDF.1C1) - Corridor - Room Fit Out - Architectural",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2025-12-22T08:00:00",
      duration: 80,
      parent: "4f6e3b0e-b0d2-461b-98b5-9e283c683727",
      progress: 0,
      source_task_id: "B1.C.C.2320"
    },
    {
      id: "226dba93-ba7b-4d64-91b0-417be5816107",
      text: "B2 - SSB - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-10-20T08:00:00",
      duration: 40,
      parent: "b59504df-f668-4315-b3d6-b9e0da7302b3",
      progress: 0,
      source_task_id: "B2.C.STR.2030"
    },
    {
      id: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2",
      text: "Area 1 - NCP Duct Bank & Equipment Install",
      type: 0,
      start_date: "2024-12-28T00:00:00",
      end_date: "2025-01-13T08:00:00",
      duration: 96,
      parent: "d2a023dd-65be-4f84-a861-c764d89c75d4",
      progress: 0,
      source_task_id: "C.CSU.A1.6000"
    },
    {
      id: "b221284c-7100-4bfe-8546-fe95302ef837",
      text: "B2 - 2B1 - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 40,
      parent: "6e56d5bb-c252-430d-819c-d1df001df08c",
      progress: 0,
      source_task_id: "B2.C.B.2210"
    },
    {
      id: "d5f1fd08-9d3a-4138-807f-02a53d7f872f",
      text: "UG RI -Panel Boards (PB)-DCB1-Area 1/2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-04T08:00:00",
      duration: 80,
      parent: "82459529-b222-4604-bce3-f899e6205dbc",
      progress: 0,
      source_task_id: "MECO-1130.30"
    },
    {
      id: "df125867-a6eb-444d-a4f8-ee5c816596a2",
      text: "B1 - 1N2E - EF3 - Build Wall Between MDF/Fiber Entry and Carrier (EF3)",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-25T08:00:00",
      duration: 48,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5200"
    },
    {
      id: "918dd7b1-d031-4c21-b771-1664d4c0fd81",
      text: "B1 - 1N2E - EF3 - In Wall Rough-In/ Inspections (EF3)",
      type: 0,
      start_date: "2025-06-26T00:00:00",
      end_date: "2025-07-02T08:00:00",
      duration: 48,
      parent: "ff995a6a-6d61-4cfc-bd3d-d269ef282356",
      progress: 0,
      source_task_id: "B1.C.5440"
    },
    {
      id: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed",
      text: "B2 - 2C1 - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2026-02-19T00:00:00",
      end_date: "2026-02-19T08:00:00",
      duration: 8,
      parent: "3865de87-5b57-44d0-8923-31b3eeb77dc7",
      progress: 0,
      source_task_id: "B2.C.C.1420"
    },
    {
      id: "1feb1c4a-7edd-4368-ba99-a6aced1de914",
      text: "Fab and Deliver - Control Power STC/SB - Area C - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-22T08:00:00",
      duration: 3408,
      parent: "ca82f77d-c6ca-4455-9954-2a8b78311781",
      progress: 0.33,
      source_task_id: "B1.OFCI.3180"
    },
    {
      id: "bb87195f-b1ce-4278-98af-ad6e1a725c18",
      text: "B2 - DH-B - SOG",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-12-06T08:00:00",
      duration: 224,
      parent: "158e7a8c-2eb3-477d-ab65-b0e327409a81",
      progress: 0,
      source_task_id: "B2.C.STR.2110"
    },
    {
      id: "1d192237-419b-45d3-a879-286866c93bec",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1180"
    },
    {
      id: "6094bc01-b3a8-4162-8143-7fb7f7001adc",
      text: "B2 - DH-D - Raise HACs - Data Hall D",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-07-16T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2340"
    },
    {
      id: "336bb83c-4838-41ea-8c5f-6b9ff0d6aadb",
      text: "B1 - 1N1E - 01N4.06 - UPS Room Pour Equipment Pads",
      type: 0,
      start_date: "2025-08-04T00:00:00",
      end_date: "2025-08-09T08:00:00",
      duration: 48,
      parent: "7cd6f5d5-ca06-491a-8148-996966549f81",
      progress: 0,
      source_task_id: "B1.C.5710"
    },
    {
      id: "76a91481-8334-4348-b0b0-4083aa3038b3",
      text: "Substation-2 - TX A - Install Medium  And High Voltage Cable Including Terms",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-29T08:00:00",
      duration: 120,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6560"
    },
    {
      id: "9a548f49-0376-44cc-a0a2-f30c07480762",
      text: "B2 - 2A2 - Corridor - Install Vapor Barrier",
      type: 0,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-01-29T08:00:00",
      duration: 40,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1660"
    },
    {
      id: "8a594828-e48a-40c0-95f9-dd97a6adc7fd",
      text: "B2 - DH-D - Power Alley - Set ATS's/Misc Panels",
      type: 0,
      start_date: "2026-04-15T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 40,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.1650"
    },
    {
      id: "ca560bd7-d327-488a-b332-09f46c329883",
      text: "Fab and Deliver - MSB - Area D - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 3288,
      parent: "a5385589-db36-465b-a883-be62a45ce509",
      progress: 0.37,
      source_task_id: "B1.OFCI.3740"
    },
    {
      id: "d4c3414c-f65e-4c55-8de4-d21b47508c37",
      text: "Weather Impacts",
      type: 5,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-06T08:00:00",
      duration: 0,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0,
      source_task_id: "7995414"
    },
    {
      id: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      text: "B2 - DH-A - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-10-29T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 120,
      parent: "7a612763-86ea-4351-9df5-89b71caf4155",
      progress: 0,
      source_task_id: "B2.C.EY.1060"
    },
    {
      id: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd",
      text: "STC - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2023-12-15T00:00:00",
      duration: 0,
      parent: "42953626-3107-4257-9ab2-a37eafbe51d3",
      progress: 1,
      source_task_id: "B2.OFCI.1170"
    },
    {
      id: "76312c2d-4ed0-46f0-857e-60fa51cb3cbc",
      text: "BLDG-1 SSB",
      type: 5,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 672,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995384"
    },
    {
      id: "818f4e88-4c42-4633-8646-3b56eaceb364",
      text: "Power Alley DH-A",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 704,
      parent: "a8ee1bd4-65c3-4e10-beab-79fa57b9ff73",
      progress: 0,
      source_task_id: "7995300"
    },
    {
      id: "ed8ae6ee-b607-4e99-bb7f-d7a2b34d46b7",
      text: "B2 - DH-B - Roofing(Converted to LOE)",
      type: 0,
      start_date: "2025-11-14T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 120,
      parent: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      progress: 0,
      source_task_id: "B2.C.RF.1140"
    },
    {
      id: "fb0ab18a-1103-414c-b826-aed4493e6901",
      text: "B1 - 1N1E (GS.IDF.A2) - Corridor - OH Rough In Sprinkler Branch",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-24T08:00:00",
      duration: 40,
      parent: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      progress: 0,
      source_task_id: "B1.C.A.1200"
    },
    {
      id: "7dc87caa-654d-427b-971f-54d347b25bf1",
      text: "B2 - SSB - 2E2 - Common - OH Rough In Electrical",
      type: 0,
      start_date: "2026-01-16T00:00:00",
      end_date: "2026-02-06T08:00:00",
      duration: 120,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1650"
    },
    {
      id: "5e23355f-0b9f-4bd3-9347-bc985bca315d",
      text: "B2 - SSB - 2E2 - Common - Install Plumbing Fixtures",
      type: 0,
      start_date: "2026-03-24T00:00:00",
      end_date: "2026-03-30T08:00:00",
      duration: 40,
      parent: "3346e2a8-9e2f-4386-9a64-93fba2e4d5c0",
      progress: 0,
      source_task_id: "B2.C.SSB.1830"
    },
    {
      id: "1f8684f7-a981-49d6-8a09-5640ea4d3b7a",
      text: "B2 - 2A1  (GS.IDF.2A1) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-05T00:00:00",
      end_date: "2026-03-25T08:00:00",
      duration: 120,
      parent: "da6e8116-b0d2-4cfe-90dd-d501a5fb03e3",
      progress: 0,
      source_task_id: "B2.C.A.1970"
    },
    {
      id: "793cf237-fce7-47f2-b3ee-00cd5892d60b",
      text: "B1 - mCUP-6 - Install FA  (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "6faefe2c-6dd8-4f07-a13e-b77f1c6ff4d2",
      progress: 0,
      source_task_id: "B1.mCUP.6050"
    },
    {
      id: "e3c1d2d5-aa63-400f-a922-7a19c07f0148",
      text: "B2 - 2E2E - EF1 - In Wall Rough-In/ Inspections (EF1)",
      type: 0,
      start_date: "2025-12-29T00:00:00",
      end_date: "2026-01-06T08:00:00",
      duration: 48,
      parent: "6bedb37f-8bd0-4eaa-b738-266861ed584e",
      progress: 0,
      source_task_id: "B2.C.6130"
    },
    {
      id: "439adca3-2d5f-48f1-902e-af195e35a295",
      text: "B1 - 1N1E - 01N4.07 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-09-10T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6330"
    },
    {
      id: "9c7b9c45-e1f7-48cb-9367-6b9667c318a9",
      text: "B2 - DH-D  - Power Alley - Pull to Light Fixtures/ Devices/Outlets",
      type: 0,
      start_date: "2026-05-29T00:00:00",
      end_date: "2026-06-04T08:00:00",
      duration: 48,
      parent: "e798c49e-5bac-4b32-ac4a-fadaac33ed17",
      progress: 0,
      source_task_id: "B2.C.D.2200"
    },
    {
      id: "07feb5ed-73dc-4cda-9a3c-332e80ec5e3f",
      text: "B2 - Deep Telecom - EF4",
      type: 0,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-03-05T08:00:00",
      duration: 40,
      parent: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      progress: 0,
      source_task_id: "B2.C.STR.2280"
    },
    {
      id: "f4ea056a-3a49-49aa-9006-79a794faea91",
      text: "Busway - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2023-11-01T00:00:00",
      duration: 0,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 1,
      source_task_id: "B2.OFCI.1090"
    },
    {
      id: "4c932962-c37e-44fa-870e-9ddeb79e2aae",
      text: "BLDG-1/2 - Prep / Submit for Review - Security System (Prod Dat)",
      type: 0,
      start_date: "2024-12-03T00:00:00",
      end_date: "2024-12-31T08:00:00",
      duration: 160,
      parent: "d7b1b4ab-cbd4-4b4a-808b-511b0980ad59",
      progress: 0,
      source_task_id: "B1.CFCI.4690"
    },
    {
      id: "528b422d-a2bd-445d-822c-1da4eed8156b",
      text: "FR 19 - META review and Approve PCO#15",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "9f9f89a7-c1ad-40cc-9316-7639d5b9a211",
      progress: 0,
      source_task_id: "FR.19.1030"
    },
    {
      id: "9649d7f7-b59f-4800-b945-443ed4c486a6",
      text: "B2 - DH-D - Pull/Term Lighting/Branch - Data Hall D",
      type: 0,
      start_date: "2026-07-13T00:00:00",
      end_date: "2026-08-07T08:00:00",
      duration: 160,
      parent: "5ebd31d6-7801-416f-82db-096864c18f8c",
      progress: 0,
      source_task_id: "B2.C.D.2510"
    },
    {
      id: "fb25c2a2-9c6d-4a00-9063-ea65a4829d8d",
      text: "B1 - Set Storm Inlets",
      type: 0,
      start_date: "2025-01-17T00:00:00",
      end_date: "2025-01-29T08:00:00",
      duration: 80,
      parent: "31923a9c-8b67-4e51-b2cf-ca1c9a71a5e5",
      progress: 0,
      source_task_id: "C.SI.RW.1020"
    },
    {
      id: "8340ab17-ef95-48dc-93ed-058f0a2709bd",
      text: "Landscaping - Issue Subcontract",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: null,
      duration: 328,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5870"
    },
    {
      id: "5530e123-637d-4ca1-abdc-554d85775ec3",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 120,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.2230"
    },
    {
      id: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      text: "Corridor 1N2W (Restroom /GS IDF (2))",
      type: 5,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-12-31T08:00:00",
      duration: 1016,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995358"
    },
    {
      id: "0dd0f158-898f-4192-8581-e48c7623784f",
      text: "Joint Sealants",
      type: 5,
      start_date: "2024-11-04T00:00:00",
      end_date: "2025-01-02T08:00:00",
      duration: 360,
      parent: "e33e334f-e67a-462b-8f59-cf344c722a84",
      progress: 0,
      source_task_id: "7994839"
    },
    {
      id: "ba107032-7cc6-4140-8d80-66eac9c10862",
      text: "Substantial Completion (DH C) - DCB2",
      type: 0,
      start_date: "2027-05-14T08:00:00",
      end_date: "2027-05-14T08:00:00",
      duration: 0,
      parent: "c02bb0d9-a0ba-46c8-8c9c-98131322446d",
      progress: 0,
      source_task_id: "ICM.B2.1100"
    },
    {
      id: "927aef3e-b93e-46be-8eab-182fa2b5c711",
      text: "MV Electric",
      type: 5,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-26T08:00:00",
      duration: 232,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995188"
    },
    {
      id: "e1af700f-5133-487d-ae52-5385cd8e35d5",
      text: "Skin",
      type: 5,
      start_date: "2025-09-30T00:00:00",
      end_date: "2026-01-23T08:00:00",
      duration: 624,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995020"
    },
    {
      id: "80402b65-4269-4a8f-803a-3a0418c0fcbe",
      text: "B1 - SSB - 1E2 - Common - Install Devices in Tile/OH Fire Alarm",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-08T08:00:00",
      duration: 40,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.2030"
    },
    {
      id: "1a85a95d-368a-46a8-8339-2ce02d0feb9d",
      text: "B1 - SSB - 1E1 - Common - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-29T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1370"
    },
    {
      id: "4be2b649-4fcc-4b45-ac23-4164f85486e6",
      text: "BLDG-2 DH-D - L2 Checkout for Building",
      type: 0,
      start_date: "2026-11-02T00:00:00",
      end_date: "2026-12-08T08:00:00",
      duration: 200,
      parent: "e4980abc-24d7-4fe9-8579-5eb9c435fdfe",
      progress: 0,
      source_task_id: "CX2.B2.1040"
    },
    {
      id: "f4a0770e-db07-467c-95bd-9d401485c3b6",
      text: "BLDG-2 DH-D",
      type: 0,
      start_date: "2025-07-14T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 200,
      parent: null,
      progress: 0,
      source_task_id: "8444271"
    },
    {
      id: "2d7810a9-51bb-4800-933f-6d4c89f7268f",
      text: "B1 - 1N2E - 01N3.05 - Lighting and Devices",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 48,
      parent: "0a027d6e-b982-45ab-a3b7-f5f6dbfeca97",
      progress: 0,
      source_task_id: "B1.C.6410"
    },
    {
      id: "e2a25521-eed0-4f3c-a501-f360cf914f24",
      text: "Corridor 1N1E Entrance Facility 4/UPS (2)",
      type: 5,
      start_date: "2025-06-16T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 920,
      parent: "d1524871-d7e7-4852-a620-43b1d6bcee8c",
      progress: 0,
      source_task_id: "7995343"
    },
    {
      id: "f2499b34-2d10-4ce7-a03d-7d78778b5c67",
      text: "(OFCI) B2 MRPP Mobile Row Power Panel",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0,
      source_task_id: "7994962"
    },
    {
      id: "a6a85663-c215-407f-a1bd-f784e5af0796",
      text: "B1 - mCUP-5 - L2 Inspections",
      type: 0,
      start_date: "2025-10-04T00:00:00",
      end_date: "2025-10-15T08:00:00",
      duration: 80,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5130"
    },
    {
      id: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      text: "B2 - DH-D - Cure for SOG",
      type: 0,
      start_date: "2026-01-15T00:00:00",
      end_date: "2026-01-17T08:00:00",
      duration: 24,
      parent: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      progress: 0,
      source_task_id: "B2.C.STR.2240"
    },
    {
      id: "d72b52e5-65dc-48c2-9360-9f331e8de4a8",
      text: "Mechanical Rough-In",
      type: 0,
      start_date: "2025-09-04T00:00:00",
      end_date: "2025-09-10T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1020"
    },
    {
      id: "f06b8d6a-49a8-4648-9cd6-56338ac04e84",
      text: "L4 - B1 DHB",
      type: 0,
      start_date: "2026-04-21T00:00:00",
      end_date: "2026-06-09T08:00:00",
      duration: 280,
      parent: "0fd749f0-fb0e-4723-86b4-de1ef096a4be",
      progress: 0,
      source_task_id: "CX4.B1.DHB.1000"
    },
    {
      id: "ca305c79-746d-4cb9-8af7-bfada980efde",
      text: "Non Critical",
      type: 0,
      start_date: "2024-06-27T00:00:00",
      end_date: null,
      duration: 840,
      parent: null,
      progress: 0.8,
      source_task_id: "8690697"
    },
    {
      id: "5010ddb6-9b7d-446f-b669-502a6ac6eebc",
      text: "Data Hall C & D Electrical Yard",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      progress: 0,
      source_task_id: "7995005"
    },
    {
      id: "135ebf1d-b7c3-449f-9042-cd328d7bc93d",
      text: "(CFCI) Div. 26 - MGPC - Bldg 01",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0,
      source_task_id: "7994869"
    },
    {
      id: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      text: "DH-A",
      type: 5,
      start_date: "2025-11-24T00:00:00",
      end_date: "2026-07-27T08:00:00",
      duration: 1344,
      parent: "8c6f09f2-2af7-4585-afeb-4a4318520839",
      progress: 0,
      source_task_id: "7995093"
    },
    {
      id: "309e7b74-931f-4535-8c88-0fed68f18be0",
      text: "BLDG-2 Network",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d6dbed56-497d-443d-b8e0-8ff083d76c28",
      progress: 0,
      source_task_id: "8444267"
    },
    {
      id: "3d773bed-6608-45df-840f-bf38db676f7a",
      text: "B1 - 1N2E - Corridor - Connect MTR Rack Systems",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-08-11T08:00:00",
      duration: 160,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5700"
    },
    {
      id: "036a771d-b745-4a4d-a7d2-c05416f36262",
      text: "Building 2",
      type: 5,
      start_date: "2025-09-26T08:00:00",
      end_date: "2027-03-23T08:00:00",
      duration: 2512,
      parent: "3c68d965-1728-459a-b168-1eb7d69bbb38",
      progress: 0,
      source_task_id: "7995425"
    },
    {
      id: "3d9019a0-4fc7-4b60-90e5-c2e0bec774f3",
      text: "mCup",
      type: 0,
      start_date: "2024-12-07T00:00:00",
      end_date: "2025-01-03T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "8487778"
    },
    {
      id: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      text: "BLDG-1 DH-C",
      type: 5,
      start_date: "2025-07-29T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 1032,
      parent: "d8b12c4e-e357-4374-b596-f7df4255e9d2",
      progress: 0,
      source_task_id: "7995259"
    },
    {
      id: "e525785a-854d-441a-b4d0-cc20a0fd9dec",
      text: "B1 - ISP Cabling - EF to IDFD (UG)",
      type: 0,
      start_date: "2026-02-26T00:00:00",
      end_date: "2026-03-18T08:00:00",
      duration: 120,
      parent: "da363b35-67f6-4765-8579-53d3cefc3ca4",
      progress: 0,
      source_task_id: "B1.CONN.1350"
    },
    {
      id: "770fc0bd-3ef4-4dc1-baf3-ba46b4c4f6d6",
      text: "B2 - DH-B - Term Bussways - Data Hall B",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2710"
    },
    {
      id: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      text: "Corridor 1C2E",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2026-02-03T08:00:00",
      duration: 1056,
      parent: "683d6cd3-e27b-48c0-8b4b-9c04bde957a8",
      progress: 0,
      source_task_id: "7995278"
    },
    {
      id: "e0fdaa51-4cb1-4b83-a09d-a447f638353c",
      text: "B1 - 1N1E - 01N4.07 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2025-08-18T00:00:00",
      end_date: "2025-08-23T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.5920"
    },
    {
      id: "343acf74-d115-412c-91e3-d35be32f0404",
      text: "CX Milestones",
      type: 5,
      start_date: "2025-01-17T00:00:00",
      end_date: "2026-07-06T08:00:00",
      duration: 3000,
      parent: "b2388eb1-2513-4edc-986a-dda628936e34",
      progress: 0,
      source_task_id: "7995017"
    },
    {
      id: "a072cf4e-9c3d-489d-94c1-4c49e91a4115",
      text: "B1 - SSB - 1E2 - Common - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1480"
    },
    {
      id: "1b5db001-67cd-4097-8a61-68359e05f8d0",
      text: "B2 - DH-C - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2026-01-29T00:00:00",
      end_date: "2026-02-09T08:00:00",
      duration: 80,
      parent: "ca84b945-82b2-497a-981a-c7717da076e4",
      progress: 0,
      source_task_id: "B2.C.C.1100"
    },
    {
      id: "35f922d0-d8cc-464c-8795-760c9606b1a3",
      text: "(CFCI) Div. 26 - Lighting",
      type: 5,
      start_date: "2024-09-19T00:00:00",
      end_date: "2025-06-30T08:00:00",
      duration: 640,
      parent: "11bc9435-7a51-4b35-995b-64d5f3ebf01b",
      progress: 0,
      source_task_id: "7994874"
    },
    {
      id: "9de991ae-24d3-47ac-a668-a61e204b073d",
      text: "Earth Work/Utilities -  Award and Issue Subcontract",
      type: 0,
      start_date: "2024-03-21T00:00:00",
      end_date: "2024-03-21T08:00:00",
      duration: 8,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1200"
    },
    {
      id: "f9b731a8-7d05-448d-abf2-39906f411592",
      text: "Area B - Paint - Prime/First Coat Walls",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1260"
    },
    {
      id: "9d2aee1f-d938-47b4-affa-9741c4ecca01",
      text: "Substation-2 - Install Fencing",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 192,
      parent: "5b7d0df4-8d15-4b5c-9fc3-ba8f580c19cf",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4210"
    },
    {
      id: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca",
      text: "B2 - DH-A - Set FCA's - Data Hall A",
      type: 0,
      start_date: "2026-02-12T00:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.1900"
    },
    {
      id: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      text: "FacNet Live",
      type: 5,
      start_date: "2025-11-14T08:00:00",
      end_date: "2026-05-11T08:00:00",
      duration: 952,
      parent: "6265d63a-03f4-4699-a369-5fe6a59d94a5",
      progress: 0,
      source_task_id: "7995445"
    },
    {
      id: "e46c2b3c-5f81-464d-9e0c-91be0f87b50b",
      text: "B2 - 2D1W - 02D.09 - Piping/Testing and Insulation for CRAC Units",
      type: 0,
      start_date: "2026-06-03T00:00:00",
      end_date: "2026-06-30T08:00:00",
      duration: 160,
      parent: "68737a55-5604-4051-a3c2-9733d3720cc6",
      progress: 0,
      source_task_id: "B2.C.D.1960"
    },
    {
      id: "20c6c9b6-0917-47f5-8047-84a817f48a47",
      text: "B2 - DH-C - Install Final Downspouts and Connections",
      type: 0,
      start_date: "2026-02-25T00:00:00",
      end_date: "2026-03-07T08:00:00",
      duration: 80,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1370"
    },
    {
      id: "c051fe49-5a30-45ed-9c5a-af987fe624d2",
      text: "Substation-2 - TX A  Assemble",
      type: 0,
      start_date: "2025-07-01T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 160,
      parent: "362a02d2-774d-460a-8620-d052f83a8ab0",
      progress: 0,
      source_task_id: "CAMPUS.AUX.6540"
    },
    {
      id: "214d9bc1-c7b2-444e-b7fc-58d6a30984c6",
      text: "B1 - DH-A - Lightning Protection",
      type: 0,
      start_date: "2025-08-21T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "B1.C.RF.1500"
    },
    {
      id: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      text: "Identify Program Directives, Initiatives, and Expectations - Precon/Estimating",
      type: 0,
      start_date: "2023-08-28T00:00:00",
      end_date: "2023-09-29T00:00:00",
      duration: 184,
      parent: "869c0fd1-d268-4947-bc05-382d13ad03db",
      progress: 1,
      source_task_id: "PRE-EP-1010"
    },
    {
      id: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      text: "Lift station 2",
      type: 0,
      start_date: "2025-01-23T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 240,
      parent: null,
      progress: 0,
      source_task_id: "8718820"
    },
    {
      id: "78fd65a9-3a93-488f-ba0f-d51fc0470fe0",
      text: "In-Wall Rough Plumbing",
      type: 0,
      start_date: "2025-09-22T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 80,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1060"
    },
    {
      id: "f6f996da-39a7-46ab-af62-c26c74ce326e",
      text: "[DCB2] DEC-C Ready: Production Cabling [Area B]",
      type: 0,
      start_date: "2026-08-24T08:00:00",
      end_date: "2026-08-24T08:00:00",
      duration: 0,
      parent: "0feb2333-6999-456c-9d2f-ced9dea90da6",
      progress: 0,
      source_task_id: "ICM.B2.3537"
    },
    {
      id: "ae901ade-6f94-4ae2-99ae-f1a7a3601f1d",
      text: "Non-Critical Trade Buyout Lvl-1",
      type: 0,
      start_date: "2024-10-02T00:00:00",
      end_date: "2024-11-27T08:00:00",
      duration: 424,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5790"
    },
    {
      id: "3c1a1b4c-abc9-4754-9251-85dd255f658e",
      text: "Delivery of Substation MSG Alpha (First Delivery) - DCB1",
      type: 0,
      start_date: "2025-04-08T08:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1805"
    },
    {
      id: "95d9fd3b-7233-41a7-ac06-e4e1783bc252",
      text: "B1 - Network Room 2/3 - FCA Gallery - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-07-28T08:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 0,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1400"
    },
    {
      id: "5d8125e2-2fbe-4fb1-9270-cc81e28cf92e",
      text: "Campus Site Utilities",
      type: 0,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "05726f27-0840-4b3c-be5a-5c1b8cb2930d",
      progress: 0,
      source_task_id: "8444249"
    },
    {
      id: "8b0a7d86-a298-46fb-bb8e-764858725660",
      text: "(OFCI) B1 MSG - *DELETE*",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "e02fd83f-9bb4-4f3b-b1d8-cd780eec6f54",
      progress: 0,
      source_task_id: "7994984"
    },
    {
      id: "7377255d-fb3b-46d2-b9bd-6221ef68a014",
      text: "FR 05 - Awaiting new OFCI equipment information",
      type: 0,
      start_date: "2024-09-08T00:00:00",
      end_date: null,
      duration: 88,
      parent: "a706f8e9-f5f3-400c-8585-d4fb3ff784b5",
      progress: 0.9,
      source_task_id: "FR.05.1020"
    },
    {
      id: "df0ba7a8-032c-4c60-96d3-b6927883d18a",
      text: "Fab and Deliver - Load Bank - Area A - DCB2",
      type: 0,
      start_date: "2024-02-12T00:00:00",
      end_date: "2025-06-27T08:00:00",
      duration: 2792,
      parent: "5c788524-2553-452e-84b3-e22e7b7ba7ad",
      progress: 0.45,
      source_task_id: "B2.OFCI.2220"
    },
    {
      id: "dd8192df-620e-45ac-b2df-0fb594c7f8f6",
      text: "B2 - 2A1 - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2025-12-29T08:00:00",
      duration: 40,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "B2.C.A.1210"
    },
    {
      id: "b08dd572-23be-434c-9ec8-6cc63dde1aac",
      text: "Area 2 - Sanitary Sewer Install (Branch)",
      type: 0,
      start_date: "2024-10-10T00:00:00",
      end_date: null,
      duration: 344,
      parent: null,
      progress: 0,
      source_task_id: "C.CSU.A2.8140"
    },
    {
      id: "e0d10e3c-18b7-4dbc-a003-9dfca534f4de",
      text: "B1 - SSB - 1E2 - GSMDF2 - In Wall Rough-In/ Inspections",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-07-28T08:00:00",
      duration: 48,
      parent: "7617a7a4-b09a-46aa-9c5b-becaed49ee83",
      progress: 0,
      source_task_id: "B1.C.SSB.1510"
    },
    {
      id: "2de9f875-30d6-4317-8de6-1e340e38c348",
      text: "B1 - DH-B - Install Thermal Concrete",
      type: 0,
      start_date: "2025-03-22T00:00:00",
      end_date: "2025-04-08T08:00:00",
      duration: 120,
      parent: "1bf3d276-d316-453d-80e9-ff645085fd4b",
      progress: 0,
      source_task_id: "B1.C.STR.1510"
    },
    {
      id: "eed9c4c6-0bd1-4a9b-88e3-f11ce163b390",
      text: "L4 - B2 DHA - Server Migration",
      type: 0,
      start_date: "2026-12-04T00:00:00",
      end_date: "2026-12-07T08:00:00",
      duration: 16,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHA.1010"
    },
    {
      id: "ca8ceee2-897c-41b3-95e7-b3f458db5b3a",
      text: "Cx - Lvl-2",
      type: 0,
      start_date: "2025-02-15T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 40,
      parent: "80f02156-f5ca-4f2c-91eb-718f1f724893",
      progress: 0,
      source_task_id: "C.CSU.A5.8100"
    },
    {
      id: "27774246-5e3a-4ebc-b3a5-eff91665cdc0",
      text: "B2 - mCUP-5 - Install BMS Controls (Terminations / Devices)",
      type: 0,
      start_date: "2025-12-06T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 24,
      parent: "30f6b105-c0b5-4140-89e3-b84628231b02",
      progress: 0,
      source_task_id: "B2.mCUP.5120"
    },
    {
      id: "1bab0fd2-f4c4-4a68-9156-34785e1c3198",
      text: "Substation-1 - MSG B - 3rd Party Inspections And Equipment Clean",
      type: 0,
      start_date: "2025-05-29T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 152,
      parent: "b547d3b8-ead9-4e3b-bd6d-67f3c21b081b",
      progress: 0,
      source_task_id: "CAMPUS.AUX.3610"
    },
    {
      id: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      text: "Area 4 - MV Electric Install - Priority for Foundations (Sub to MV Loop)",
      type: 0,
      start_date: "2025-03-28T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 136,
      parent: "cb84dcdb-d649-480a-8f41-a9ab04aae985",
      progress: 0,
      source_task_id: "C.CSU.A4.7000"
    },
    {
      id: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      text: "B2 - SSB - Foundations",
      type: 0,
      start_date: "2025-05-06T00:00:00",
      end_date: "2025-05-22T08:00:00",
      duration: 120,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1000"
    },
    {
      id: "6544e8f4-b2b5-4b62-92ea-5c71df5d28d9",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Power Equipment and Material",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-16T08:00:00",
      duration: 120,
      parent: "f2449ac3-9148-4727-a863-d0333a3a0ff8",
      progress: 0,
      source_task_id: "B1.CFCI.4030"
    },
    {
      id: "645ae26c-84d4-4ad7-a339-7856ac7b5fd1",
      text: "Area 1 - UG RI -System Transfer Cabinet (STC)-DCB1-",
      type: 0,
      start_date: "2024-12-20T00:00:00",
      end_date: "2025-01-21T08:00:00",
      duration: 184,
      parent: "750eb9f5-4c8f-4c91-bc48-9f950724d379",
      progress: 0,
      source_task_id: "MECO-1160"
    },
    {
      id: "3f315edb-3a69-451c-8b43-955290d9ea95",
      text: "B1 - 1N1E - 01N4.07 - Pull Wire to Lighting and Devices",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-07T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6490"
    },
    {
      id: "e87be40b-b70f-4d9e-9cbd-0ddfc0b1b651",
      text: "Substation-1 B Lineup Work",
      type: 5,
      start_date: "2024-12-02T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 2672,
      parent: "71f29387-b98a-444d-9be2-cbd28264f81a",
      progress: 0,
      source_task_id: "7995232"
    },
    {
      id: "de64d598-5090-4ed8-9101-2943b87ddf60",
      text: "B1 - SSB - Cure for SOG",
      type: 0,
      start_date: "2025-05-08T00:00:00",
      end_date: "2025-05-10T08:00:00",
      duration: 24,
      parent: "3845be00-8d67-41fa-b995-0a3ddd618d25",
      progress: 0,
      source_task_id: "B1.C.STR.1950"
    },
    {
      id: "9f9f89a7-c1ad-40cc-9316-7639d5b9a211",
      text: "Fragnet 19 - PCO # 15 RFI-121 Ftgs and Tele Duct Banks Conflict",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 408,
      parent: null,
      progress: 0.5,
      source_task_id: "8690177"
    },
    {
      id: "9e71e842-0dd8-4fdd-bf57-c970443541ec",
      text: "B2 - 2A2  (GS.IDF.2A3) - Corridor - Install Devices (In Corridors)",
      type: 0,
      start_date: "2026-03-26T00:00:00",
      end_date: "2026-04-01T08:00:00",
      duration: 40,
      parent: "ecad26e0-2dbd-4af9-ba14-bb916ed993b3",
      progress: 0,
      source_task_id: "B2.C.A.2180"
    },
    {
      id: "9f4190f7-8b2b-4a33-a2d9-5b4aa76d947c",
      text: "TIA's",
      type: 0,
      start_date: "2024-05-06T00:00:00",
      end_date: null,
      duration: 688,
      parent: null,
      progress: 1,
      source_task_id: "8519840"
    },
    {
      id: "015154f2-cb25-462f-8497-1e3d1adfe3c4",
      text: "B1 - DH-A - Power Alley  - OH Rough In Fire Alarm",
      type: 0,
      start_date: "2025-07-22T00:00:00",
      end_date: "2025-08-01T08:00:00",
      duration: 80,
      parent: "818f4e88-4c42-4633-8646-3b56eaceb364",
      progress: 0,
      source_task_id: "B1.C.A.1280"
    },
    {
      id: "bc65dcc0-03df-4b00-b4d5-a340c982b43b",
      text: "Tier 0 - B1-mCUP-1- Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994809"
    },
    {
      id: "522edb03-75a2-4166-8d66-50f140352491",
      text: "B2 - DH-A - Pull/Term BMS - Data Hall A",
      type: 0,
      start_date: "2026-05-08T00:00:00",
      end_date: "2026-06-05T08:00:00",
      duration: 160,
      parent: "53c8632e-57de-4948-9490-64eb1dbe73e1",
      progress: 0,
      source_task_id: "B2.C.A.2590"
    },
    {
      id: "06bd3404-1a5f-4d2c-b5cb-bad1e0f64a0d",
      text: "BLDG-2 DH-C",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 200,
      parent: null,
      progress: 0,
      source_task_id: "8444270"
    },
    {
      id: "4b475fd7-db58-45e4-90cd-9e9e9fb2a75a",
      text: "Steel Erection Start - DCB1",
      type: 0,
      start_date: "2025-03-19T00:00:00",
      end_date: "2025-03-19T00:00:00",
      duration: 0,
      parent: "8f318940-dbf9-442e-8428-ff962a67e014",
      progress: 0,
      source_task_id: "ICM.B1.1360"
    },
    {
      id: "f99a7478-9f2c-42a9-b8d9-e8dbed7f07d9",
      text: "B2 - DH-D - Form/Rebar/Pour SOG",
      type: 0,
      start_date: "2025-12-22T00:00:00",
      end_date: "2026-01-14T08:00:00",
      duration: 120,
      parent: "95e918ae-8492-4579-9a83-ef5e00faf1ee",
      progress: 0,
      source_task_id: "B2.C.STR.2230"
    },
    {
      id: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c",
      text: "B2 - DH-A - Install Joists",
      type: 0,
      start_date: "2025-08-29T00:00:00",
      end_date: "2025-09-17T08:00:00",
      duration: 120,
      parent: "6201941a-b129-4e9a-b6d9-310c75a9c893",
      progress: 0,
      source_task_id: "B2.C.STR.1690"
    },
    {
      id: "3369bd3a-4a9c-4256-99ba-9a4fd892669a",
      text: "B2 - DH-B - Pull/Term BMS - Data Hall B",
      type: 0,
      start_date: "2026-06-01T00:00:00",
      end_date: "2026-06-26T08:00:00",
      duration: 160,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.2800"
    },
    {
      id: "bc49cdda-185a-4f8f-9d26-b967b66003d1",
      text: "B1 - 1B2E (GS.IDF.1B2) - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2025-10-01T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 24,
      parent: "787832d9-6434-4a22-bc1a-7208a0bff4bd",
      progress: 0,
      source_task_id: "B1.C.B.1760"
    },
    {
      id: "8039b75e-0c84-4c81-a494-5dc5eb889ce3",
      text: "CDU - Meta PO Issued - DCB2",
      type: 0,
      start_date: "2024-02-16T00:00:00",
      end_date: "2024-02-16T00:00:00",
      duration: 0,
      parent: "08df99e0-67cd-4305-a713-c28ccf38dc88",
      progress: 1,
      source_task_id: "B2.OFCI.1050"
    },
    {
      id: "31793537-1478-4cb1-b6e8-0780d6de1c44",
      text: "B1 - SSB - 1E1 - CMDF1 - Fire Alarm Wire Pulls/Terms to devices (Carrier MDF1)",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-08-26T08:00:00",
      duration: 48,
      parent: "3aa2efc5-4631-4585-9e4b-17f17a3bc158",
      progress: 0,
      source_task_id: "B1.C.SSB.1920"
    },
    {
      id: "392df1ce-4a4a-420c-a02b-c7cc50f88edc",
      text: "B2 - DH-D - El Equip Yd - Pull Cable from MVS to MSG",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-17T08:00:00",
      duration: 80,
      parent: "59d266a3-2730-4d26-beb5-ad6aff5d6682",
      progress: 0,
      source_task_id: "B2.C.EY.1440"
    },
    {
      id: "ae1767c4-d36b-4241-8891-8fc1b5eca613",
      text: "Fragnet 18 - PCO # 14 RFI-115 Ext Grade Beam and Ele Conduit Conflict",
      type: 0,
      start_date: "2024-08-29T00:00:00",
      end_date: null,
      duration: 448,
      parent: null,
      progress: 0.4,
      source_task_id: "8690178"
    },
    {
      id: "c884f3e1-0476-48f8-860b-e5f48adfe961",
      text: "IFC",
      type: 5,
      start_date: "2024-04-01T00:00:00",
      end_date: "2024-06-14T08:00:00",
      duration: 432,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "7994743"
    },
    {
      id: "9afaeea2-2bf3-4cea-bf21-85e7728d6234",
      text: "L4 - B2 DHC",
      type: 0,
      start_date: "2027-01-07T00:00:00",
      end_date: "2027-02-26T08:00:00",
      duration: 280,
      parent: "4a9aee9f-0f1a-4200-960a-4791ea8539d4",
      progress: 0,
      source_task_id: "CX4.B2.DHC.1000"
    },
    {
      id: "6c5115da-258d-42c7-aaeb-764762e8bf7d",
      text: "B2 - SSB - 2E1 - Common - In Wall Rough In Fire Alarm",
      type: 0,
      start_date: "2025-10-31T00:00:00",
      end_date: "2025-11-20T08:00:00",
      duration: 120,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1060"
    },
    {
      id: "89b51122-ef2a-45e3-b198-e03287a439ec",
      text: "B1 - mCUP-3 - Install Electrical / Lighting (Terminations / Devices)",
      type: 0,
      start_date: "2025-08-27T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 24,
      parent: "f9f99681-267b-44e3-bd2e-175b57e64b81",
      progress: 0,
      source_task_id: "B1.mCUP.3100"
    },
    {
      id: "a3f4952d-d626-4cf3-b9e8-36212610c179",
      text: "Cooling Towers - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2023-12-29T08:00:00",
      duration: 40,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 1,
      source_task_id: "B1.OFCI.1850"
    },
    {
      id: "70f4f801-9915-40aa-91dd-350a6969896a",
      text: "Steel SA - Meta Review",
      type: 0,
      start_date: "2024-03-01T00:00:00",
      end_date: "2024-04-29T08:00:00",
      duration: 336,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1040"
    },
    {
      id: "91a6aa4b-b69b-4592-9dd4-f873407e8dae",
      text: "B2 - SSB - WAP Provisioning",
      type: 0,
      start_date: "2026-06-18T00:00:00",
      end_date: "2026-07-01T08:00:00",
      duration: 80,
      parent: "0803ae81-dc04-4696-a91c-1bd43b6cc640",
      progress: 0,
      source_task_id: "B2.CONN.1160"
    },
    {
      id: "61cd90fd-6bc0-4f4b-872c-8fca6ba938db",
      text: "Slab Edge water proofing and backfill",
      type: 0,
      start_date: "2025-02-19T00:00:00",
      end_date: "2025-02-21T08:00:00",
      duration: 24,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1130"
    },
    {
      id: "2e3c3a5f-c10e-4f9e-8ea9-66f71ebcca3c",
      text: "Substation-1 - TX A - Energization",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 8,
      parent: "a4b0d8da-3386-4228-b16c-5ba01df1f298",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4140"
    },
    {
      id: "360442f2-9561-479f-9a37-34f468217f2d",
      text: "Storm Sewer",
      type: 5,
      start_date: "2024-11-21T00:00:00",
      end_date: "2024-12-26T08:00:00",
      duration: 208,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995175"
    },
    {
      id: "fdb580cd-aa8a-4e67-96ec-ad95b1730d18",
      text: "Seal Concrete Floors",
      type: 0,
      start_date: "2026-01-07T00:00:00",
      end_date: "2026-01-28T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1300"
    },
    {
      id: "cb1dcb5c-8829-4b31-9b55-e2d7b49a06ad",
      text: "Connectivity",
      type: 5,
      start_date: "2025-06-05T00:00:00",
      end_date: "2026-11-30T08:00:00",
      duration: 3232,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0,
      source_task_id: "7995447"
    },
    {
      id: "4dafec49-c879-4bdd-9cd3-5b27d9e38fa4",
      text: "BLDG-1/2 - Submittal Rvw/App'l - Joint Sealants",
      type: 0,
      start_date: "2024-11-25T00:00:00",
      end_date: "2024-12-17T08:00:00",
      duration: 120,
      parent: "0dd0f158-898f-4192-8581-e48c7623784f",
      progress: 0,
      source_task_id: "B1.CFCI.4840"
    },
    {
      id: "d8f90d79-7005-4b5f-8785-c133d4725c88",
      text: "B2 - mCUP-1 - Set in Place Inspections",
      type: 0,
      start_date: "2025-10-24T00:00:00",
      end_date: "2025-10-24T08:00:00",
      duration: 8,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1190"
    },
    {
      id: "784e3f39-3786-45d6-a4ba-3ca93a358713",
      text: "B1 - Network Room 1/4  - In Wall Rough Ins/Inspections - Security",
      type: 0,
      start_date: "2025-06-06T00:00:00",
      end_date: "2025-06-23T08:00:00",
      duration: 120,
      parent: "5be07111-dcd0-4cf0-9c5c-623d1fd32e0c",
      progress: 0,
      source_task_id: "B1.C.NR.1080"
    },
    {
      id: "d160a1b3-d6be-4739-b254-2df997a1dfa2",
      text: "B2 - 2E1E - EF3 - Build Wall Between MDF/Fiber Entry and Carrier (EF3)",
      type: 0,
      start_date: "2025-12-02T00:00:00",
      end_date: "2025-12-09T08:00:00",
      duration: 48,
      parent: "84bf3f19-0ce5-4ef7-8bd5-dae8bdc7ccb5",
      progress: 0,
      source_task_id: "B2.C.5040"
    },
    {
      id: "cec926f1-5e70-4454-ab31-860802bff000",
      text: "B1 - DH-A - Install Ceiling Tiles - Data Hall A",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-11T08:00:00",
      duration: 48,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2700"
    },
    {
      id: "cd1295e0-1c90-4bd4-af92-f3500ca14548",
      text: "B2 - 2A2 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-01-22T00:00:00",
      end_date: "2026-01-22T08:00:00",
      duration: 8,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.1600"
    },
    {
      id: "b63ef7b2-6a31-41e7-926f-9c5afbe2f2c9",
      text: "B1 - mCUP-5 - Install FA  (Terminations / Devices)",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-15T08:00:00",
      duration: 24,
      parent: "3d1fcbeb-c8ac-4e86-a25c-e36b7807baf5",
      progress: 0,
      source_task_id: "B1.mCUP.5110"
    },
    {
      id: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83",
      text: "B1 - DH-B - Install Underslab Branch Conduit",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-18T08:00:00",
      duration: 40,
      parent: "1fe25b5c-2a40-4311-81c9-4d0c84e5cca4",
      progress: 0,
      source_task_id: "B1.C.STR.2170"
    },
    {
      id: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      text: "B1 - 1B2E (GS.IDF.1B1) - Corridor - Room Fit Out Activities - OH Rough",
      type: 0,
      start_date: "2025-09-29T00:00:00",
      end_date: "2025-10-21T08:00:00",
      duration: 160,
      parent: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      progress: 0,
      source_task_id: "B1.C.B.1850"
    },
    {
      id: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632",
      text: "B2 - DH-B - Install Underground Telecom",
      type: 0,
      start_date: "2025-07-19T00:00:00",
      end_date: "2025-07-30T08:00:00",
      duration: 80,
      parent: "9bcba143-e1d7-4c6d-9550-c8692423cf1a",
      progress: 0,
      source_task_id: "B2.C.STR.1360"
    },
    {
      id: "8737aec1-769f-4997-b052-9786f6ca3288",
      text: "Fab and Deliver - HMD - Area NW-1/4 - DCB1",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2025-03-28T08:00:00",
      duration: 2584,
      parent: "9ccfb300-2e18-4d8a-9c65-bc7efcd3dbf0",
      progress: 0.55,
      source_task_id: "B1.OFCI.2770"
    },
    {
      id: "a7f53700-1c36-42cf-a0e0-117ba3d6d805",
      text: "B1 - 1D2E - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "02f823b3-e125-441c-a1f9-f8a631647efc",
      progress: 0,
      source_task_id: "B1.C.D.2260"
    },
    {
      id: "37b2ef8c-0d12-48ec-ac0f-d5e30fc8bf97",
      text: "B2 - DH-C - Hookup CDU's - Data Hall C - DCI 3134",
      type: 0,
      start_date: "2026-07-06T00:00:00",
      end_date: "2026-07-25T08:00:00",
      duration: 144,
      parent: "b59787b1-4034-47f1-b469-52b087cc7b04",
      progress: 0,
      source_task_id: "B2.C.C.5030"
    },
    {
      id: "07966cba-d319-4601-87e2-3084c54fdb7d",
      text: "Mass Grading",
      type: 5,
      start_date: "2024-04-22T00:00:00",
      end_date: "2024-05-14T08:00:00",
      duration: 160,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 1,
      source_task_id: "7995173"
    },
    {
      id: "0c4e2242-92cb-47ee-9f3a-1332cb5c28ce",
      text: "B2 - 2E1E - 02.01.E1.01 - Term Wire to Equipment",
      type: 0,
      start_date: "2026-02-20T00:00:00",
      end_date: "2026-02-27T08:00:00",
      duration: 48,
      parent: "c3a6e053-f967-4154-b4e5-d774402e8960",
      progress: 0,
      source_task_id: "B2.C.5500"
    },
    {
      id: "07874df0-2f96-4435-8bcc-77b2ceb832a9",
      text: "B1 - DH-A - Install Insulation",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-02T08:00:00",
      duration: 40,
      parent: "eb7d2136-e3a5-43d9-85b8-badfb1257cb8",
      progress: 0,
      source_task_id: "B1.C.RF.1270"
    },
    {
      id: "2081ef8d-21c8-486b-ae6e-9fbc7d0c54e9",
      text: "B1 - DH-C - El Equip Yd - Test/Terms from MVS to MSG",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 80,
      parent: "73da657d-8cde-4d11-9b12-ec230a7b894e",
      progress: 0,
      source_task_id: "B1.C.C.3070"
    },
    {
      id: "5cfc9fca-b165-4c0a-b17d-687aeb42332b",
      text: "Domestic Water",
      type: 5,
      start_date: "2025-01-16T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 48,
      parent: "9b38e62a-275d-45fc-ba0d-d755b754e64b",
      progress: 0,
      source_task_id: "7995177"
    },
    {
      id: "c94c1aad-abfd-4f70-bfe3-72a79bf124a4",
      text: "BLDG-2 DH-B",
      type: 5,
      start_date: "2025-10-23T00:00:00",
      end_date: "2026-02-24T08:00:00",
      duration: 728,
      parent: "2e69ab4f-9277-48b7-bf2a-f075ff5a5af8",
      progress: 0,
      source_task_id: "7995116"
    },
    {
      id: "5033d1a2-682d-4f32-ab30-1a5b71b51f26",
      text: "FR 02 - META review and Approve TIA#1",
      type: 0,
      start_date: "2024-10-23T00:00:00",
      end_date: null,
      duration: 80,
      parent: null,
      progress: 0.53,
      source_task_id: "FR.02.1080"
    },
    {
      id: "f1c8b869-f598-4fab-bec9-738168c61de7",
      text: "B2 - 2B2  (GS.IDF.2B4) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2026-02-05T00:00:00",
      end_date: "2026-02-11T08:00:00",
      duration: 40,
      parent: "29e6b06c-4790-4afd-90e4-f2d41197ee8b",
      progress: 0,
      source_task_id: "B2.C.B.1260"
    },
    {
      id: "bb9db6df-9deb-4d46-814b-403852c714cf",
      text: "Area 5 - Storm Install",
      type: 0,
      start_date: "2024-09-19T00:00:00",
      end_date: "2024-10-09T08:00:00",
      duration: 144,
      parent: "5a6df0c1-ee29-49d6-b859-51ab2131e1f1",
      progress: 0,
      source_task_id: "C.CSU.A5.3000"
    },
    {
      id: "17f5d39b-423b-44de-a420-1da1db27ec2e",
      text: "MSB/RSB - Baseline/Site Specific Submittals Approved-Revit Model Provided - DCB2",
      type: 0,
      start_date: "2023-11-01T00:00:00",
      end_date: "2024-02-12T00:00:00",
      duration: 544,
      parent: "97a3baf8-e3f9-4b33-be40-0c5342e5fab7",
      progress: 1,
      source_task_id: "B2.OFCI.1370"
    },
    {
      id: "bbf90f72-3ab6-468e-999b-b67688429762",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In BMS",
      type: 0,
      start_date: "2025-06-03T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 120,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1080"
    },
    {
      id: "0cfb3289-d790-46cb-b98b-8cbeecba32bf",
      text: "FR 39 - DPR Submit delay notice",
      type: 0,
      start_date: "2024-11-14T00:00:00",
      end_date: null,
      duration: 0,
      parent: "1f063521-b2a3-4b0d-838c-2b55c3f2085a",
      progress: 1,
      source_task_id: "FR.39.1000"
    },
    {
      id: "2a3d5c36-0d80-4d90-a31d-ac3e9487c14a",
      text: "BLDG-1/2 - Prep / Submit for Review - Fire Suppression",
      type: 0,
      start_date: "2024-09-23T00:00:00",
      end_date: "2024-11-27T08:00:00",
      duration: 160,
      parent: "259cd2ff-2f2c-4882-8de7-0863b0131218",
      progress: 0,
      source_task_id: "B1.CFCI.3360"
    },
    {
      id: "9a439d8f-7507-4d44-a057-90cba25b759a",
      text: "Interior Construction",
      type: 5,
      start_date: "2025-10-24T00:00:00",
      end_date: "2026-10-30T08:00:00",
      duration: 2048,
      parent: "621c2bbd-da9f-46a2-a233-976e158012a5",
      progress: 0,
      source_task_id: "7995026"
    },
    {
      id: "5c6c8b45-eac0-4ebc-9f59-6cf17bde19fc",
      text: "Install Secondary Steel - Canopies, OH Doors, etc.",
      type: 0,
      start_date: "2025-05-08T00:00:00",
      end_date: "2025-05-14T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1050"
    },
    {
      id: "ad355aea-c3eb-4d10-a36e-0951e66d23c6",
      text: "Substantial Completion-No Weather - Bldg 2 - DH C",
      type: 0,
      start_date: "2027-03-30T08:00:00",
      end_date: "2027-03-30T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B2.MIL.1100"
    },
    {
      id: "17d0af7f-a628-4bbe-9f47-098668f0fb7d",
      text: "B1 - SSB - 1E1 - Common - In Wall Rough In Inspection AHJ",
      type: 0,
      start_date: "2025-06-20T00:00:00",
      end_date: "2025-06-21T08:00:00",
      duration: 16,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.1240"
    },
    {
      id: "73c76572-c3a4-4ef2-87e2-4ee5cd180b2f",
      text: "In-Wall Blocking",
      type: 0,
      start_date: "2025-10-02T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 40,
      parent: "edb30dfc-80fc-4422-a6f7-a76b21776e9f",
      progress: 0,
      source_task_id: "ADMIN.REST.1050"
    },
    {
      id: "7c6a153e-430f-42d8-87af-6431c1b0c4b6",
      text: "B1 - DH-C - Install Underground Security",
      type: 0,
      start_date: "2025-04-05T00:00:00",
      end_date: "2025-04-16T08:00:00",
      duration: 80,
      parent: "9633aeee-9665-4e54-a92e-e8ebff2a1a9d",
      progress: 0,
      source_task_id: "B1.C.STR.1660"
    },
    {
      id: "d4472b8a-39ec-4821-9924-8dff6f4fcd51",
      text: "B1 - 1N1E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-07-25T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 8,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "B1.C.A.1320"
    },
    {
      id: "90048737-b66d-45c4-aaf8-f6ed96c52b65",
      text: "Set Prefabricated Guardhouse - GH",
      type: 0,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-09-03T08:00:00",
      duration: 80,
      parent: "960a3230-3d18-4a8d-9b60-7f435cfb3995",
      progress: 0,
      source_task_id: "GH.CON.1020"
    },
    {
      id: "5da6c4f0-606f-4c55-8cd5-61bd95f19baf",
      text: "B1 - DH-C - Room QA/QC Pre DEC-C Turnover - Data Hall C",
      type: 0,
      start_date: "2026-02-07T00:00:00",
      end_date: "2026-03-03T08:00:00",
      duration: 160,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2680"
    },
    {
      id: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      text: "B1 - Network - El Equip Yd - Level 2 Check Out (Inspections and Issue Resolution)",
      type: 0,
      start_date: "2025-10-06T00:00:00",
      end_date: "2025-10-28T08:00:00",
      duration: 160,
      parent: "e7525e1f-7352-4ede-9294-cffe817e578a",
      progress: 0,
      source_task_id: "B1.C.EY.1190"
    },
    {
      id: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      text: "Area 3 - Telecom Install",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 328,
      parent: "dc323cfb-a17f-4b05-bebd-630fcd98848f",
      progress: 0,
      source_task_id: "C.CSU.A3.8000"
    },
    {
      id: "6083e472-b9b9-4ec9-90de-2a721818dc61",
      text: "Project Impacts (Fragnets)",
      type: 5,
      start_date: "2023-12-01T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 4112,
      parent: "ff357444-a6b6-4ef1-8f39-53aaba89919c",
      progress: 0,
      source_task_id: "7994992"
    },
    {
      id: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d",
      text: "B1 - DH-B - DEC -C Turnover Walk - Data Hall B",
      type: 0,
      start_date: "2026-02-04T00:00:00",
      end_date: "2026-02-05T08:00:00",
      duration: 16,
      parent: "a1adecb3-3f48-40ff-bea5-9df03426c04b",
      progress: 0,
      source_task_id: "B1.C.B.2910"
    },
    {
      id: "8729c704-5316-40c9-a098-222574688c6a",
      text: "B2 - 2C2 - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2026-03-23T00:00:00",
      end_date: "2026-04-03T08:00:00",
      duration: 80,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1560"
    },
    {
      id: "c2c1f8ff-37e0-428a-b88e-16f2b8644ac3",
      text: "BLDG-1/2 - Submittals - Architectural Precast Conc.",
      type: 0,
      start_date: "2024-10-24T00:00:00",
      end_date: "2024-12-10T08:00:00",
      duration: 160,
      parent: "07b55cfe-9e28-44c9-92c0-80e8fd883c9f",
      progress: 0,
      source_task_id: "B1.CFCI.3490"
    },
    {
      id: "0a248c1d-062c-4597-ad94-5ac5d0d85c27",
      text: "B1 - DH-C - Facilty Water Rack Install CompleteMOFE",
      type: 0,
      start_date: "2025-10-18T08:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 0,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.1920"
    },
    {
      id: "1ae91f04-7bd0-4120-a9ec-abf196c0be1d",
      text: "B1 - 1N2E - 01N3.06 - Term Wire to Equipment",
      type: 0,
      start_date: "2025-08-23T00:00:00",
      end_date: "2025-08-29T08:00:00",
      duration: 48,
      parent: "c9a0e42b-1321-4700-a0d3-18f58552b7cf",
      progress: 0,
      source_task_id: "B1.C.6300"
    },
    {
      id: "9103a25b-da63-4e4e-9e3f-75c3ab4059df",
      text: "Area B - Final Clean / Demob",
      type: 0,
      start_date: "2025-09-19T00:00:00",
      end_date: "2025-09-25T08:00:00",
      duration: 40,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1460"
    },
    {
      id: "37b73365-da5f-44bf-a3a9-4cc2c41642fa",
      text: "B1 - DH-A - Prime and 1st Coat",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 40,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.1710"
    },
    {
      id: "d891792d-cfac-4918-8676-d7f4b4e620cb",
      text: "B2 - 2A2 - Corridor - Install Cable Tray (In Corridors)",
      type: 0,
      start_date: "2026-03-19T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 120,
      parent: "0d77c4d3-19c1-493b-a44e-b64023fe4d9a",
      progress: 0,
      source_task_id: "B2.C.A.2150"
    },
    {
      id: "f1f60748-baed-4a2d-bc7a-2dd1c8f29486",
      text: "B2 - 2C2 - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2026-03-13T00:00:00",
      end_date: "2026-03-13T08:00:00",
      duration: 8,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1460"
    },
    {
      id: "2ecb081b-e19d-4804-8346-6399c432d164",
      text: "Precast SSB",
      type: 5,
      start_date: "2025-04-17T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 80,
      parent: "b5572f8d-48ba-4dd5-ab04-b24dc83874a9",
      progress: 0,
      source_task_id: "7995409"
    },
    {
      id: "533e7156-a315-4056-8900-2579f62f2ca0",
      text: "B1 - DH-A - Pull/Term Fire Alarm - Data Hall A",
      type: 0,
      start_date: "2025-11-01T00:00:00",
      end_date: "2025-11-24T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2590"
    },
    {
      id: "2867df5e-a08b-4239-bba0-5b860f308f68",
      text: "B1 - 1N1E - Corridor - OH Sprinkler Testing",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-12T08:00:00",
      duration: 8,
      parent: "89dead84-e480-46f1-a83a-ca7709775511",
      progress: 0,
      source_task_id: "B1.C.5420"
    },
    {
      id: "eecabc0b-b15b-44a3-b7b3-0b433a9fe17c",
      text: "Substantial Completion-No Weather - Bldg 1 - DH B",
      type: 0,
      start_date: "2026-06-24T08:00:00",
      end_date: "2026-06-24T08:00:00",
      duration: 0,
      parent: "94ee409e-2030-4cc1-bb1f-b6d1f72e8eee",
      progress: 0,
      source_task_id: "B1.MIL.1070"
    },
    {
      id: "36942aef-cbe4-4d9e-a92b-23e741e20fd9",
      text: "B1 - 1N2W - Corridor - Room Fit Out Activities - Set/Hookup Equipment",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 160,
      parent: "f9da5495-3dc4-48ce-9a3b-db91156070aa",
      progress: 0,
      source_task_id: "B1.C.B.2590"
    },
    {
      id: "9118bb40-c891-4d1f-a75f-fca9d9980911",
      text: "Area B - Camera Install",
      type: 0,
      start_date: "2025-09-12T00:00:00",
      end_date: "2025-09-16T08:00:00",
      duration: 24,
      parent: "cf3ac39b-cd1c-4932-8c02-d9615fb3548e",
      progress: 0,
      source_task_id: "IBOS.CON.1411"
    },
    {
      id: "bbb49ac4-d9a7-4848-87c0-a96e61e2e9d9",
      text: "BLDG-1 DH-A ElectricalTerms",
      type: 5,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-11-01T08:00:00",
      duration: 336,
      parent: "391e8559-de77-4b17-bd68-b4b620e973e3",
      progress: 0,
      source_task_id: "7995269"
    },
    {
      id: "f2a0d8b9-1579-4690-8938-afe90d88a452",
      text: "Tier 2, 3, 4 - B1-1-E",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "c9b08464-6aee-4765-b328-6cb191062769",
      progress: 0,
      source_task_id: "7994790"
    },
    {
      id: "df40bd6b-351f-433f-8a79-17b222e06f0f",
      text: "L3 Start EY1 - DCB2",
      type: 0,
      start_date: "2025-11-18T00:00:00",
      end_date: "2025-11-18T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2250"
    },
    {
      id: "e244cb5b-85f4-496d-b363-4d80ef240aef",
      text: "B1 - SSB - WAP Provisioning",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-18T08:00:00",
      duration: 80,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1250"
    },
    {
      id: "46fe0d8f-7503-49b1-b967-ad3b2f85c203",
      text: "VE meeting with Meta",
      type: 0,
      start_date: "2024-08-19T00:00:00",
      end_date: null,
      duration: 0,
      parent: "dc78887d-8014-48b1-ad06-f9bf1be85152",
      progress: 1,
      source_task_id: "FR.04.1000"
    },
    {
      id: "630aa7bf-92c2-498c-bb8b-83bd815e0475",
      text: "[DCB1] FacNet Live [ADMIN]",
      type: 0,
      start_date: "2026-03-12T08:00:00",
      end_date: "2026-03-12T08:00:00",
      duration: 0,
      parent: "518f7596-9fb6-4c5e-8772-8c80b843b7df",
      progress: 0,
      source_task_id: "ICM.B1.3615"
    },
    {
      id: "26c07bd1-b025-4581-867c-4a8a71802aba",
      text: "Area 3 - UG RI -RSB/MSB-SSB2",
      type: 0,
      start_date: "2025-02-21T00:00:00",
      end_date: "2025-03-20T08:00:00",
      duration: 192,
      parent: "60e3c674-bdc4-4557-9445-d5f61146f870",
      progress: 0,
      source_task_id: "MECO-1580"
    },
    {
      id: "c54c5c76-7e07-40be-894d-e018b0b7d423",
      text: "Tier 0 - B2-2-C - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      progress: 0,
      source_task_id: "7994766"
    },
    {
      id: "ed959986-b462-46b9-a631-e3987866c0c0",
      text: "Precon - QA/QC Buyout",
      type: 5,
      start_date: "2024-02-12T00:00:00",
      end_date: "2024-06-18T08:00:00",
      duration: 720,
      parent: "706d2e52-0772-4280-b13b-93206452f57c",
      progress: 1,
      source_task_id: "7994723"
    },
    {
      id: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      text: "Area 2 - Storm Install",
      type: 0,
      start_date: "2024-08-14T00:00:00",
      end_date: "2024-09-06T08:00:00",
      duration: 216,
      parent: "e592906c-716a-4f3a-a11b-d68444d468ee",
      progress: 0,
      source_task_id: "C.CSU.A2.3000"
    },
    {
      id: "386cffa9-a238-403a-a0dc-007f3e7c0848",
      text: "B2 - DH-C - Install Insulation",
      type: 0,
      start_date: "2025-11-26T00:00:00",
      end_date: "2025-12-04T08:00:00",
      duration: 40,
      parent: "9f5ebb69-d0f0-43ff-a939-ace389cea6e6",
      progress: 0,
      source_task_id: "B2.C.RF.1210"
    },
    {
      id: "036d4d2d-d8a8-45f9-b214-bc61ddb33ea0",
      text: "FF GMP Review Cycle",
      type: 0,
      start_date: "2024-07-22T00:00:00",
      end_date: null,
      duration: 168,
      parent: null,
      progress: 0,
      source_task_id: "Design.PreC.5770"
    },
    {
      id: "393e7de8-7297-4526-a043-795c3f04b087",
      text: "B1 - 1A2E (GS.IDF.A3) - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-16T08:00:00",
      duration: 40,
      parent: "e6fd19cd-fc12-4dcd-94b1-5b919f57b2c6",
      progress: 0,
      source_task_id: "B1.C.A.1480"
    },
    {
      id: "fa21be49-cc31-4bea-acb3-232657c3d5f0",
      text: "NEW MILESTONES",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f49c2121-73ed-4027-ae56-8e5ab2a49dd4",
      progress: 0,
      source_task_id: "7995446"
    },
    {
      id: "2a2d2ad9-ff36-4bea-adf0-7edd107bd5dc",
      text: "Cx Electrical Yards B2",
      type: 5,
      start_date: "2026-08-11T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 200,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7995003"
    },
    {
      id: "06356746-ce95-4fc7-820c-cac1a3ae84f3",
      text: "L3 Finish EY2 - DCB2",
      type: 0,
      start_date: "2025-12-19T08:00:00",
      end_date: "2025-12-19T08:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2261"
    },
    {
      id: "be05b14d-480d-4a9e-b8a0-ce33e7db5ffb",
      text: "(CFCI) Div. 05 - Misc Steel (Interior Stairs)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "34ca79b6-dd19-4968-869d-fe70e871b4ad",
      progress: 0,
      source_task_id: "7994929"
    },
    {
      id: "d3088fee-6e35-4c31-ad29-0f9024527c65",
      text: "Sub-Structure",
      type: 5,
      start_date: "2024-11-18T00:00:00",
      end_date: "2025-05-01T08:00:00",
      duration: 1256,
      parent: "b88b495a-90d4-4925-8e8b-857c4c293886",
      progress: 0,
      source_task_id: "7995397"
    },
    {
      id: "1b7a8875-7898-4966-9d78-419b6df6578f",
      text: "Hang/Tape/Finish Walls",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-09-26T08:00:00",
      duration: 80,
      parent: "abd3ac85-ab88-48ac-9a29-340c0c0d221b",
      progress: 0,
      source_task_id: "ADMIN.KITCH.1100"
    },
    {
      id: "c36e022b-9510-4fc6-b827-69a4f4d89760",
      text: "(CFCI) NCB - Long Lead Doors/Frames/Hardware",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "5835c8c4-440f-41e7-a652-4ed2177e09ac",
      progress: 0,
      source_task_id: "7994895"
    },
    {
      id: "22141bd9-5118-4e5e-8e51-b8899985c4cd",
      text: "B1 - DH-D - Install MTR Facility Water (CDU & FCA Header Piping)",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-11-11T08:00:00",
      duration: 160,
      parent: "223856b2-e50a-4bef-9561-17d9c641c077",
      progress: 0,
      source_task_id: "B1.C.D.1080"
    },
    {
      id: "c5a9dcf1-db4a-46b5-8b9b-f8f6051f6011",
      text: "B2 - DH-C - Install Ceiling Tiles - Data Hall C",
      type: 0,
      start_date: "2026-07-15T00:00:00",
      end_date: "2026-07-21T08:00:00",
      duration: 40,
      parent: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      progress: 0,
      source_task_id: "B2.C.C.2630"
    },
    {
      id: "d58cc4e8-f3b2-4fb2-8f96-5b29c346ec4b",
      text: "B2 - 2C2 - Corridor - Prime and 1st Coat",
      type: 0,
      start_date: "2026-04-06T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 24,
      parent: "208c2b85-813b-4a31-bcf3-f6c34e08bd22",
      progress: 0,
      source_task_id: "B2.C.C.1720"
    },
    {
      id: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      text: "GMP Approved by Meta Legal - CUR",
      type: 0,
      start_date: "2024-10-01T00:00:00",
      end_date: "2024-10-01T00:00:00",
      duration: 0,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 0,
      source_task_id: "ICM.PRE.1540"
    },
    {
      id: "a900c3e3-4d6d-4583-a9f6-1e02cb862f19",
      text: "B1 - Network Room 2/3 - FCA Gallery - IMP Wall Install at FCA equipment",
      type: 0,
      start_date: "2025-08-14T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 80,
      parent: "08e2fe72-da97-4655-ad63-ae4e6381a897",
      progress: 0,
      source_task_id: "B1.C.NR.1610"
    },
    {
      id: "ef4bc87a-5f7d-44da-907b-d4c2745214b8",
      text: "B2 - mCUP-1 - L2 Inspections",
      type: 0,
      start_date: "2025-11-08T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 80,
      parent: "40c28c28-89aa-4424-b526-6fa909ea3458",
      progress: 0,
      source_task_id: "B2.mCUP.1290"
    },
    {
      id: "7565b988-5073-4059-925b-84b84bce1b11",
      text: "Fragnet 07 - PCO # 3 Unsuitable Soils - Trailer City",
      type: 0,
      start_date: "2024-06-27T00:00:00",
      end_date: null,
      duration: 600,
      parent: "2662e4cb-9bbe-4b29-aa84-bdccf4e89ab7",
      progress: 0.78,
      source_task_id: "8519916"
    },
    {
      id: "0a2e5bd5-4b77-4d77-b500-e2c18a2368ed",
      text: "DH-C",
      type: 5,
      start_date: "2026-01-23T00:00:00",
      end_date: "2026-09-15T08:00:00",
      duration: 1312,
      parent: "3750cb98-03f6-4090-9afc-515a595e07ff",
      progress: 0,
      source_task_id: "7995038"
    },
    {
      id: "e24747f5-816d-4bf2-9173-eb8c929bf49a",
      text: "B2 - mCUP-3 - Install BMS Controls (Wire Pulls)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-18T08:00:00",
      duration: 24,
      parent: "44cc353f-f8e5-4e56-bdaa-89c52ec87f20",
      progress: 0,
      source_task_id: "B2.mCUP.3090"
    },
    {
      id: "e4cff625-4671-4e31-909d-c91f23b1d76a",
      text: "B1 - 1A2E - Corridor - Hang/Tape/Finish Drywall",
      type: 0,
      start_date: "2025-08-25T00:00:00",
      end_date: "2025-09-06T08:00:00",
      duration: 80,
      parent: "87859527-d91a-4551-a9d6-17ce9cc2ad55",
      progress: 0,
      source_task_id: "B1.C.A.1690"
    },
    {
      id: "4951abd8-85ad-4287-8980-ae5abe73325e",
      text: "B1 - DH-D - El Equip Yd - Test/Terms for PTX (MV)",
      type: 0,
      start_date: "2025-10-20T00:00:00",
      end_date: "2025-10-30T08:00:00",
      duration: 80,
      parent: "0446cac3-0a3f-47f8-abb1-e2202034f3af",
      progress: 0,
      source_task_id: "B1.C.D.3080"
    },
    {
      id: "ff4b586d-725c-4f81-a0cc-24910d8529df",
      text: "B1 - DH-C - FSHAC Install CompleteMOFE",
      type: 0,
      start_date: "2025-12-17T08:00:00",
      end_date: "2025-12-17T08:00:00",
      duration: 0,
      parent: "4988ba64-ab08-4d23-ae37-bfd6a4c8f939",
      progress: 0,
      source_task_id: "B1.C.C.2570"
    },
    {
      id: "3d493c5a-a2fa-4047-ab7a-3ecda09d5464",
      text: "B2 - mCUP-4 - Install FA (Overhead Conduit and Tie-In Connections)",
      type: 0,
      start_date: "2025-11-15T00:00:00",
      end_date: "2025-11-21T08:00:00",
      duration: 48,
      parent: "9072c387-f08c-4cc9-8452-286f8800234f",
      progress: 0,
      source_task_id: "B2.mCUP.4050"
    },
    {
      id: "cc2bb161-d241-4f1f-9d40-970fc362dfe6",
      text: "Baseline 2 Issuance",
      type: 0,
      start_date: "2024-02-15T08:00:00",
      end_date: "2024-02-15T08:00:00",
      duration: 0,
      parent: "15e2f1ba-8bc1-4d46-9fbc-9a34ed256caa",
      progress: 1,
      source_task_id: "Design.PreC.2240"
    },
    {
      id: "06761436-6b4e-4081-98d5-7cb993e535b3",
      text: "FR 40 - BMC review and respond (via email)",
      type: 0,
      start_date: "2024-11-11T00:00:00",
      end_date: null,
      duration: 48,
      parent: "e2ac24e1-807f-411e-aab2-a4a6b0fe41d7",
      progress: 0,
      source_task_id: "FR.40.1010"
    },
    {
      id: "488facb6-6e40-4b50-96a6-d899882d3b19",
      text: "B1 - 1N1E - 01N4.07 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-09-03T00:00:00",
      end_date: "2025-09-09T08:00:00",
      duration: 48,
      parent: "ad008ffc-1727-49e4-903a-71d4841a8211",
      progress: 0,
      source_task_id: "B1.C.6260"
    },
    {
      id: "706b3d4a-9a33-4935-aa91-9319b20ca574",
      text: "Turnkey Concrete (Foundations Only)",
      type: 0,
      start_date: "2023-12-21T00:00:00",
      end_date: "2024-04-12T08:00:00",
      duration: 624,
      parent: "609fa5af-5d53-4887-bb08-1c350a49a172",
      progress: 1,
      source_task_id: "PRE1480"
    },
    {
      id: "9b27290c-13f7-443c-bc67-befdf49822ba",
      text: "Cx mCUP",
      type: 5,
      start_date: "2025-12-11T00:00:00",
      end_date: "2026-04-21T08:00:00",
      duration: 720,
      parent: "c89ebc31-b6eb-4f68-bc45-f3966e634423",
      progress: 0,
      source_task_id: "7995012"
    },
    {
      id: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2",
      text: "B1 - Network Room 2/3 - Install Sprinkler Mains",
      type: 0,
      start_date: "2025-06-24T00:00:00",
      end_date: "2025-06-28T08:00:00",
      duration: 40,
      parent: "dfb476f9-919e-46d7-8443-fbf3fd6e4bbb",
      progress: 0,
      source_task_id: "B1.C.NR.1190"
    },
    {
      id: "3fa1f9ef-57da-4ae7-9e83-af50927366b5",
      text: "FR 17 - META review and Approve PCO#13",
      type: 0,
      start_date: "2024-11-13T00:00:00",
      end_date: "2024-12-04T08:00:00",
      duration: 80,
      parent: "ff6b063e-140d-44b7-8199-0a0452134f17",
      progress: 0,
      source_task_id: "FR.17.1030"
    },
    {
      id: "97fa2136-85a6-46f2-b6ff-31c8316c4807",
      text: "Fab and Deliver - Cooling Towers - Area mCUP Dry [2] - DCB1",
      type: 0,
      start_date: "2023-12-22T00:00:00",
      end_date: "2025-05-05T08:00:00",
      duration: 2752,
      parent: "315c976a-264d-4fb9-a3f7-142eb85d5fd3",
      progress: 0.37,
      source_task_id: "B1.OFCI.3650"
    },
    {
      id: "17c5a102-3a79-4569-872e-ad1c465bbbff",
      text: "B1 - RF-Tower-1 - Pad Prep",
      type: 0,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-07-23T08:00:00",
      duration: 80,
      parent: "f329c8d4-f73d-42ab-b526-aa9ffe25cfa4",
      progress: 0,
      source_task_id: "CAMPUS.AUX.2150"
    },
    {
      id: "d00a0a38-b927-41af-8b4a-4a500416a835",
      text: "B2 - DH-B - El Equip Yd - Test/Terms for LB and MGPC (480V)",
      type: 0,
      start_date: "2026-04-13T00:00:00",
      end_date: "2026-04-24T08:00:00",
      duration: 80,
      parent: "2f3a17e0-d4ae-4c9c-98f9-8e0b4cad7450",
      progress: 0,
      source_task_id: "B2.C.EY.1630"
    },
    {
      id: "55c2f835-cb78-493d-9337-1340798ed26b",
      text: "Area-5",
      type: 0,
      start_date: "2025-01-07T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 2040,
      parent: null,
      progress: 0,
      source_task_id: "8444272"
    },
    {
      id: "51d604b9-f5df-40e9-aaeb-48c0025ccc98",
      text: "B1 - 1C2E - Corridor - OH Rough In Inspections",
      type: 0,
      start_date: "2025-09-24T00:00:00",
      end_date: "2025-09-24T08:00:00",
      duration: 8,
      parent: "aa27c45b-f272-4d53-9bfd-efc2b57cd5b8",
      progress: 0,
      source_task_id: "B1.C.C.1450"
    },
    {
      id: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      text: "B1 - DH-C - El Equip Yd - Pour Pads",
      type: 0,
      start_date: "2025-07-29T00:00:00",
      end_date: "2025-08-14T08:00:00",
      duration: 120,
      parent: "ccd0e25a-0332-4eca-bb1e-7139f7cf770f",
      progress: 0,
      source_task_id: "B1.C.C.3010"
    },
    {
      id: "73d45fb1-cf70-4062-be84-9a0187710d0f",
      text: "B2 - 2E1E - 02.01.E1.05 - Set UPS Cabinet and Misc Electric Equipment",
      type: 0,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-02-02T08:00:00",
      duration: 48,
      parent: "9b41d378-ba1b-443c-9cf2-5ab9c7c1971e",
      progress: 0,
      source_task_id: "B2.C.5370"
    },
    {
      id: "966c0045-20bf-45d2-a8e1-f21d6d1907e8",
      text: "B1 - SSB - 1E1 - Common - Final Paint",
      type: 0,
      start_date: "2025-11-06T00:00:00",
      end_date: "2025-11-17T08:00:00",
      duration: 80,
      parent: "9020c3f9-3073-4be2-9a11-b7b0d55a1d94",
      progress: 0,
      source_task_id: "B1.C.SSB.2420"
    },
    {
      id: "26528eee-edb3-46ca-bb02-9f443da418f1",
      text: "B1 - West Entrance - install SOD",
      type: 0,
      start_date: "2025-12-05T00:00:00",
      end_date: "2025-12-16T08:00:00",
      duration: 80,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1050"
    },
    {
      id: "84369fb7-0e77-47e1-83d3-1fdb1c943076",
      text: "FR 15 - META review and Approve PCO#11",
      type: 0,
      start_date: "2024-10-22T00:00:00",
      end_date: null,
      duration: 112,
      parent: "150fc470-4247-402f-8c28-d9b141485933",
      progress: 0,
      source_task_id: "FR.15.1030"
    },
    {
      id: "7e339dde-5396-473b-a03d-cf293a6fc6ab",
      text: "Overhead Electrical",
      type: 0,
      start_date: "2025-11-10T00:00:00",
      end_date: "2025-12-02T08:00:00",
      duration: 120,
      parent: "80aaeea9-b67b-4162-a5fd-a18a1e1dd476",
      progress: 0,
      source_task_id: "ADMIN.IDF.1040"
    },
    {
      id: "e5ba1fc4-e696-4cfe-9e3f-07e4a88c51be",
      text: "OH Mechanical",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1130"
    },
    {
      id: "4d5b7a80-9212-4771-8660-99571d152bfd",
      text: "Exterior Canopy Framing",
      type: 0,
      start_date: "2025-06-13T00:00:00",
      end_date: "2025-06-19T08:00:00",
      duration: 40,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1130"
    },
    {
      id: "254cb044-a477-48de-91c7-78a3ef690b74",
      text: "Roofing",
      type: 5,
      start_date: "2025-04-29T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 1072,
      parent: "7b87499f-6094-4da2-9138-6f3e096589f1",
      progress: 0,
      source_task_id: "7995383"
    },
    {
      id: "60e3c674-bdc4-4557-9445-d5f61146f870",
      text: "Area-3",
      type: 0,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 1920,
      parent: null,
      progress: 0,
      source_task_id: "8444252"
    },
    {
      id: "e592906c-716a-4f3a-a11b-d68444d468ee",
      text: "Storm Sewer",
      type: 5,
      start_date: "2024-07-15T00:00:00",
      end_date: "2024-08-19T08:00:00",
      duration: 216,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995167"
    },
    {
      id: "62da7c81-f2c5-4332-9024-f2763b07aca5",
      text: "B1 - DH-A - Connect Buss/Cable Tray Sections - Data Hall A",
      type: 0,
      start_date: "2025-10-11T00:00:00",
      end_date: "2025-11-03T08:00:00",
      duration: 160,
      parent: "935a05c3-a0be-4887-a2ac-c6dedcc3c345",
      progress: 0,
      source_task_id: "B1.C.A.2410"
    },
    {
      id: "a3baddd8-0bc6-42e1-acca-417d240e2566",
      text: "Site - Dry Utilities Bid & Develop SA Package",
      type: 0,
      start_date: "2023-12-08T00:00:00",
      end_date: "2024-02-29T08:00:00",
      duration: 448,
      parent: "28bb1d2b-46fe-4f0e-b4ed-6290ea7eaf9c",
      progress: 1,
      source_task_id: "PRE-PP-1030"
    },
    {
      id: "0e40acaf-07af-44ca-a847-e81a185ef23b",
      text: "FRP Ramp / Walls",
      type: 0,
      start_date: "2025-06-27T00:00:00",
      end_date: "2025-07-11T08:00:00",
      duration: 80,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.SUB.1060"
    },
    {
      id: "ea11542b-587f-4351-9d55-0a27d0fac9aa",
      text: "Substation-2 - B Lineup - Dead End Structure Steel Erection And Branch Wiring",
      type: 0,
      start_date: "2025-09-27T00:00:00",
      end_date: "2025-10-11T08:00:00",
      duration: 104,
      parent: "cd03450e-e8ed-4b51-8939-8deb3f7b6575",
      progress: 0,
      source_task_id: "CAMPUS.AUX.4300"
    },
    {
      id: "524e098f-79f8-44dc-9074-a6a20c6527b1",
      text: "B1 - Network Room 1/4 - FCA Gallery - Install Light Fixtures/Exit Signs",
      type: 0,
      start_date: "2025-09-09T00:00:00",
      end_date: "2025-09-22T08:00:00",
      duration: 96,
      parent: "bbee4110-eb9a-4d53-b458-d4fbf0f18b19",
      progress: 0,
      source_task_id: "B1.C.NR.1900"
    },
    {
      id: "27244c2c-db31-4305-acd1-d3e36aa75518",
      text: "Tier 2, 3, 4 - B2-2-A",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7c7d8e74-6276-4a5c-b01f-136553300e92",
      progress: 0,
      source_task_id: "7994771"
    },
    {
      id: "bba1d552-5c49-489f-b82e-5bc0942098bc",
      text: "B1 - SSB - 1E2 - Common - OH Rough In BMS",
      type: 0,
      start_date: "2025-07-18T00:00:00",
      end_date: "2025-08-04T08:00:00",
      duration: 120,
      parent: "11dea330-3068-4fd1-9e5c-1cb22360bb55",
      progress: 0,
      source_task_id: "B1.C.SSB.1460"
    },
    {
      id: "822ca292-96ad-416e-a792-1a1be5c4aec2",
      text: "BLDG-1 DH-D",
      type: 5,
      start_date: "2025-07-12T00:00:00",
      end_date: "2025-10-08T08:00:00",
      duration: 592,
      parent: "254cb044-a477-48de-91c7-78a3ef690b74",
      progress: 0,
      source_task_id: "7995389"
    },
    {
      id: "f358bc82-0fcc-4b78-88c6-ee3bc4381404",
      text: "B1 - DH-B - WAP Provisioning",
      type: 0,
      start_date: "2026-02-09T00:00:00",
      end_date: "2026-03-09T08:00:00",
      duration: 160,
      parent: "30e648c7-9873-4311-8ca1-0e102e215bbf",
      progress: 0,
      source_task_id: "B1.CONN.1380"
    },
    {
      id: "205b80c6-b398-4930-8845-3912668e20f2",
      text: "Develop Project Review Set - Baseline 2 Estimate",
      type: 0,
      start_date: "2024-01-08T00:00:00",
      end_date: "2024-02-16T08:00:00",
      duration: 232,
      parent: "09b89ac9-8d41-4d42-ba3c-76bc1cecbb63",
      progress: 1,
      source_task_id: "PRE-ES-1150"
    },
    {
      id: "34ca79b6-dd19-4968-869d-fe70e871b4ad",
      text: "(CFCI) Div. 05 - Misc. Steel (Stairs)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "1dd53faf-8264-4359-855e-4925cbdace3b",
      progress: 0,
      source_task_id: "7994928"
    },
    {
      id: "2eb3f253-1d00-4d3d-8d37-57d4a45c0db5",
      text: "FR 05 - Issue Identification Notification -01 Substation design Coordination",
      type: 0,
      start_date: "2024-09-04T00:00:00",
      end_date: null,
      duration: 0,
      parent: null,
      progress: 1,
      source_task_id: "A1140"
    },
    {
      id: "98dc0b17-09c2-49df-9ff7-aa04e55420b2",
      text: "B1 - DH-A - L2 CDU Install Verification - Data Hall A",
      type: 0,
      start_date: "2025-10-15T00:00:00",
      end_date: "2025-11-04T08:00:00",
      duration: 144,
      parent: "fffdfe01-5301-4bf8-bbc4-5467000c0f2f",
      progress: 0,
      source_task_id: "B1.C.A.3000"
    },
    {
      id: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      text: "B1 - mCUP-1-6 - Seq.2Piping POC's, Devices, final dress out for Network and A/B Data Halls (Fill and Flush Building)",
      type: 0,
      start_date: "2025-10-09T00:00:00",
      end_date: "2025-10-31T08:00:00",
      duration: 160,
      parent: "2a30feef-09ac-419f-b924-97c80bbf1474",
      progress: 0,
      source_task_id: "B1.mCUP.9230"
    },
    {
      id: "e9d2b8d9-edb9-40f3-884b-c7d0d7742c53",
      text: "FR 01 - Sanitary Sewer Redesign - Submit Sanitary Civil Permit Revision (After Civil Permits Approved)",
      type: 0,
      start_date: "2023-11-13T00:00:00",
      end_date: "2023-11-14T08:00:00",
      duration: 16,
      parent: "269795b2-1cc4-4a15-a305-d34616207b2c",
      progress: 1,
      source_task_id: "FR.01.1120"
    },
    {
      id: "6a0acef7-9d4f-42f5-bbac-77322e0ffb74",
      text: "BLDG-1/2 - Review for Approval - Concrete (Thermal Ready Mix)",
      type: 0,
      start_date: "2024-07-29T00:00:00",
      end_date: "2024-08-02T08:00:00",
      duration: 40,
      parent: "006f2b8e-65dd-4fb1-b43e-8e84a08db5c5",
      progress: 0,
      source_task_id: "B1.CFCI.1070"
    },
    {
      id: "6b0c7f71-2077-4149-b4ff-e196eb914b19",
      text: "Exterior Canopy Roofing",
      type: 0,
      start_date: "2025-07-21T00:00:00",
      end_date: "2025-07-25T08:00:00",
      duration: 40,
      parent: "9b583aef-8b6b-4165-bfbe-be62c836cdf2",
      progress: 0,
      source_task_id: "ADMIN.STRUCT.1160"
    },
    {
      id: "df73ed77-88af-4b60-a65c-a81e276bd966",
      text: "(CFCI) Div.05 - Misc. Steel (Gen. Yard Stairs)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "34ca79b6-dd19-4968-869d-fe70e871b4ad",
      progress: 0,
      source_task_id: "7994930"
    },
    {
      id: "224c29f3-50e4-422c-bd57-6a816887eef6",
      text: "L3 Finish DH B - DCB1",
      type: 0,
      start_date: "2026-05-26T08:00:00",
      end_date: "2026-05-26T08:00:00",
      duration: 0,
      parent: "b5074734-b1e4-4798-bf15-6c846569d60a",
      progress: 0,
      source_task_id: "ICM.B1.2004"
    },
    {
      id: "ba49dc6d-1ba5-4905-a8fd-0cce32088ffc",
      text: "B2 - SSB - 2E1 - Common - E-cure/Seal Floors",
      type: 0,
      start_date: "2026-05-05T00:00:00",
      end_date: "2026-05-14T08:00:00",
      duration: 64,
      parent: "6729170e-d170-4219-8523-1285e8217d18",
      progress: 0,
      source_task_id: "B2.C.SSB.1390"
    },
    {
      id: "87f70d3b-6a0e-45a7-a28f-6ac6ec9619c8",
      text: "BLDG-2 - BIM - Coordination and Sign-off ((LOE))",
      type: 0,
      start_date: "2024-11-19T00:00:00",
      end_date: "2025-08-18T08:00:00",
      duration: 1280,
      parent: "09c8e623-a7a2-4892-9b99-ccf31f0980f1",
      progress: 0,
      source_task_id: "B2.VDC22.1000"
    },
    {
      id: "22e2ef48-896b-472d-9ffb-c764f79206fd",
      text: "B1 - mCUP-8 - Install FA (Wire Pulls)",
      type: 0,
      start_date: "2025-09-30T00:00:00",
      end_date: "2025-10-02T08:00:00",
      duration: 24,
      parent: "3a0bcba3-0f0c-47e9-8904-672bc6be705d",
      progress: 0,
      source_task_id: "B1.mCUP.8080"
    },
    {
      id: "3b4a4ecc-e5c6-4f03-98fb-ec4afc6885de",
      text: "IST Start DH A - DCB2",
      type: 0,
      start_date: "2026-12-08T00:00:00",
      end_date: "2026-12-08T00:00:00",
      duration: 0,
      parent: "036a771d-b745-4a4d-a7d2-c05416f36262",
      progress: 0,
      source_task_id: "ICM.B2.2154"
    },
    {
      id: "9e064a13-9dbb-4239-96a1-2ed3dcc162d1",
      text: "Area-2",
      type: 0,
      start_date: "2024-10-17T00:00:00",
      end_date: null,
      duration: 2280,
      parent: null,
      progress: 0,
      source_task_id: "8444251"
    },
    {
      id: "f7d2e4ca-fca3-4698-a92d-e7c59e40c80a",
      text: "B1 - SSB - 1E2 - CMDF2 -  Install Split System/Refrigerant Piping/Test/Insulate (Carrier MDF2)",
      type: 0,
      start_date: "2025-08-12T00:00:00",
      end_date: "2025-08-25T08:00:00",
      duration: 96,
      parent: "b20c22e9-d4e5-4ad3-9d92-fdac9c7bc541",
      progress: 0,
      source_task_id: "B1.C.SSB.1810"
    },
    {
      id: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      text: "B2 - DH-B - Frame Walls (ROJ date for Prefab walls)Pre-Fab",
      type: 0,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-01-08T08:00:00",
      duration: 120,
      parent: "72d8ec94-eb2a-471d-a709-9c00efe4077c",
      progress: 0,
      source_task_id: "B2.C.B.1040"
    },
    {
      id: "7f3ef5e8-9081-48b4-af55-10930869a8bc",
      text: "B1 - mCUP-2 - Set in Place Inspections",
      type: 0,
      start_date: "2025-08-08T00:00:00",
      end_date: "2025-08-08T08:00:00",
      duration: 8,
      parent: "440e743f-1820-4bb8-aeea-47951aac8f25",
      progress: 0,
      source_task_id: "B1.mCUP.2030"
    },
    {
      id: "37249a52-1b56-400d-8473-8f0267fc2e09",
      text: "DFSMA - DC2 - mCUP - GS.IDF Remote Module ROJ - MOFE (2x2)",
      type: 0,
      start_date: "2025-10-22T08:00:00",
      end_date: "2025-10-22T08:00:00",
      duration: 0,
      parent: "d70530f6-b13d-4b0a-940b-9b1bf24a563d",
      progress: 0,
      source_task_id: "B2.DFSMA.1100"
    },
    {
      id: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      text: "L3 - mCUP 1-9 *On Temp Power*",
      type: 0,
      start_date: "2025-12-11T00:00:00",
      end_date: "2026-02-17T08:00:00",
      duration: 360,
      parent: "9b27290c-13f7-443c-bc67-befdf49822ba",
      progress: 0,
      source_task_id: "CX3.B1.MCUP.1000"
    },
    {
      id: "e08f5205-30bf-473e-a063-adec8e0acd9a",
      text: "B2 - DH-B - Foundations",
      type: 0,
      start_date: "2025-05-31T00:00:00",
      end_date: "2025-06-17T08:00:00",
      duration: 120,
      parent: "3a124c3c-a9f9-4594-96b8-c2da7f157eb4",
      progress: 0,
      source_task_id: "B2.C.STR.1070"
    },
    {
      id: "1108f3ef-bfd0-41e9-9bba-fc2d52c8d878",
      text: "In-Wall Rough AV",
      type: 0,
      start_date: "2025-09-15T00:00:00",
      end_date: "2025-10-03T08:00:00",
      duration: 120,
      parent: "5fe388c7-12a6-47bc-be1f-259cf8781d71",
      progress: 0,
      source_task_id: "ADMIN.CON.1110"
    },
    {
      id: "7fa75463-f1bc-4ef6-a050-0b3817ef9ca3",
      text: "Set Primary Steel",
      type: 0,
      start_date: "2025-04-01T00:00:00",
      end_date: "2025-04-28T08:00:00",
      duration: 160,
      parent: null,
      progress: 0,
      source_task_id: "IBOS.STRUCT.1010"
    },
    {
      id: "a059912c-c8ae-42cc-8fa9-ae913d76e607",
      text: "Underground",
      type: 5,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-09-11T08:00:00",
      duration: 760,
      parent: "90dd9ead-7191-4d9c-9a21-ffd37897bf30",
      progress: 0,
      source_task_id: "7995096"
    },
    {
      id: "8edcc91f-b98f-458e-ae88-c7697c251245",
      text: "B2 - 2B2 - Corridor - Room Fit Out Activities - OH Rough in",
      type: 0,
      start_date: "2026-03-12T00:00:00",
      end_date: "2026-04-08T08:00:00",
      duration: 160,
      parent: "79c28c33-f493-4750-9acd-7b10cd67f80a",
      progress: 0,
      source_task_id: "B2.C.B.1840"
    },
    {
      id: "f7db4e21-dcef-428b-85cd-07788bc619e4",
      text: "B1 - DH-B - El Equip Yd - Pour Pads (MSG Only) needs steel to go by",
      type: 0,
      start_date: "2025-05-30T00:00:00",
      end_date: "2025-06-16T08:00:00",
      duration: 120,
      parent: "4d88cbfc-dc77-43fd-ad5a-4d0f6f677ab2",
      progress: 0,
      source_task_id: "B1.C.B.3000"
    },
    {
      id: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      text: "Electrical - Award and Issue Subcontract",
      type: 0,
      start_date: "2024-04-24T00:00:00",
      end_date: "2024-05-17T08:00:00",
      duration: 144,
      parent: "f1ec2178-6f0b-42d4-bea9-b0c1148eac4d",
      progress: 1,
      source_task_id: "Design.PreC.1080"
    },
    {
      id: "980633c9-3fcd-4932-b20f-2d50122837b7",
      text: "B1 - 1N2E - Corridor - In Wall Rough Ins/Inspections",
      type: 0,
      start_date: "2025-06-19T00:00:00",
      end_date: "2025-06-24T08:00:00",
      duration: 40,
      parent: "e9e406a4-c0c6-4da9-b993-ed3b37614c94",
      progress: 0,
      source_task_id: "B1.C.5210"
    },
    {
      id: "dac38423-a5d6-4353-b29e-1e935ffc5386",
      text: "Deep Telecom",
      type: 5,
      start_date: "2025-02-27T00:00:00",
      end_date: "2025-04-11T08:00:00",
      duration: 256,
      parent: "90dd9ead-7191-4d9c-9a21-ffd37897bf30",
      progress: 0,
      source_task_id: "7995103"
    },
    {
      id: "81112da9-0bc1-415d-b3ce-9552a2a4e8ff",
      text: "Fab and Deliver - Busway Kits - Area D - DCB2",
      type: 0,
      start_date: "2023-12-15T00:00:00",
      end_date: "2026-03-06T08:00:00",
      duration: 4472,
      parent: "20424f38-1c32-4b54-b51c-fab9f0a49fd9",
      progress: 0.19,
      source_task_id: "B2.OFCI.2090"
    },
    {
      id: "55f0dddc-12a3-4405-91ef-f7d31dcee15e",
      text: "UG RI -Rack Bus-DCB2-Area 3/4",
      type: 0,
      start_date: "2025-06-30T00:00:00",
      end_date: "2025-07-18T08:00:00",
      duration: 120,
      parent: "06bd3404-1a5f-4d2c-b5cb-bad1e0f64a0d",
      progress: 0,
      source_task_id: "MECO-1740.40"
    },
    {
      id: "3b014aa5-c8cf-4762-9e05-d0a452c22035",
      text: "B1 - 1B2E - Corridor - Install MTR Racks",
      type: 0,
      start_date: "2025-07-28T00:00:00",
      end_date: "2025-08-19T08:00:00",
      duration: 160,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "B1.C.B.3260"
    },
    {
      id: "e0bd96cc-3363-4ede-a223-0fc4b792552e",
      text: "B2 - West Entrance - Install Trees",
      type: 0,
      start_date: "2026-06-30T00:00:00",
      end_date: "2026-07-21T08:00:00",
      duration: 120,
      parent: "d0ea22eb-73a2-4670-86d8-3129490b53e0",
      progress: 0,
      source_task_id: "C.SI.LS.1110"
    },
    {
      id: "82150e10-0ee4-44ad-b04f-c8e7979d7bd7",
      text: "B1 - 1N2W - 01N2.06 - Pull Wire to Euipment",
      type: 0,
      start_date: "2025-10-21T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 48,
      parent: "9aa3f311-7aea-4316-b271-f42583a49cac",
      progress: 0,
      source_task_id: "B1.C.6100"
    },
    {
      id: "0fb8d7bf-9464-4c9e-a1e4-84f33a8e6747",
      text: "GS.IDF.1A2",
      type: 5,
      start_date: "2025-07-16T00:00:00",
      end_date: "2025-10-27T08:00:00",
      duration: 696,
      parent: "d0b420a5-fa11-48e7-8dea-f270fc3968fe",
      progress: 0,
      source_task_id: "7995306"
    },
    {
      id: "71f29387-b98a-444d-9be2-cbd28264f81a",
      text: "Substation-1 Yard",
      type: 5,
      start_date: "2024-09-09T00:00:00",
      end_date: "2025-11-19T08:00:00",
      duration: 3216,
      parent: "c58d12bf-614f-4c63-b273-87839b55d090",
      progress: 0,
      source_task_id: "7995231"
    },
    {
      id: "b1c751be-46df-40c6-9525-a10c4e362601",
      text: "Data Hall D",
      type: 5,
      start_date: "2025-08-21T00:00:00",
      end_date: "2026-04-27T08:00:00",
      duration: 1688,
      parent: "1d9e827f-f2c2-4707-950b-61d5bd31f6bc",
      progress: 0,
      source_task_id: "7995311"
    },
    {
      id: "c8cb9f0b-e62a-4b93-8190-3d707b626e88",
      text: "Weather Impacts (Residual Impacts)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d4c3414c-f65e-4c55-8de4-d21b47508c37",
      progress: 0,
      source_task_id: "7995415"
    },
    {
      id: "c43469b5-604f-43d2-a57c-6ea44c4b7184",
      text: "Cx SSB",
      type: 5,
      start_date: "2026-09-01T00:00:00",
      end_date: "2026-10-13T08:00:00",
      duration: 360,
      parent: "3e9ed4c0-0f29-44b7-82a8-71fed2baf759",
      progress: 0,
      source_task_id: "7995000"
    },
    {
      id: "a5858497-8ae4-4101-8f0c-f54d9a419e59",
      text: "PTX Pull & Term - Load side",
      type: 0,
      start_date: "2025-09-08T00:00:00",
      end_date: "2025-09-12T08:00:00",
      duration: 40,
      parent: null,
      progress: 0,
      source_task_id: "ADMIN.SI.1060"
    },
    {
      id: "609843eb-b77c-4998-a2e9-e531f6409c2c",
      text: "(OFCI) B2 MSG *DELETE*",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0,
      source_task_id: "7994955"
    },
    {
      id: "03821032-ad64-410c-83d4-9611dbdb73d2",
      text: "SSB",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995433"
    },
    {
      id: "ef14dc6c-fecb-470a-8a47-509f4b717c82",
      text: "GS.IDF.1B1",
      type: 5,
      start_date: "2025-08-20T00:00:00",
      end_date: "2025-12-10T08:00:00",
      duration: 736,
      parent: "bdf0c936-1496-4297-ae33-ce676dad4e87",
      progress: 0,
      source_task_id: "7995356"
    },
    {
      id: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      text: "B2 - SSB - Install Deep Electric (Inside building foot print only)",
      type: 0,
      start_date: "2025-05-17T00:00:00",
      end_date: "2025-06-05T08:00:00",
      duration: 120,
      parent: "ecf7c7e7-9d1a-491e-889e-14e41d440015",
      progress: 0,
      source_task_id: "B2.C.STR.1030"
    },
    {
      id: "8baf8aa6-de03-40c5-b789-393f90891135",
      text: "B1 - OSP Cabling - EF to IBOS (Perm)",
      type: 0,
      start_date: "2025-08-11T00:00:00",
      end_date: "2025-08-15T08:00:00",
      duration: 40,
      parent: "f25599a0-95e2-44be-82b5-e6c181abbae6",
      progress: 0,
      source_task_id: "B1.CONN.1450"
    },
    {
      id: "6b8898ee-f9e1-43c4-b521-2a4715747f84",
      text: "Storm Sewer",
      type: 5,
      start_date: "2024-07-20T00:00:00",
      end_date: "2024-09-25T08:00:00",
      duration: 264,
      parent: "d315ec78-23a1-4c80-9607-c035351d49bd",
      progress: 0,
      source_task_id: "7995156"
    },
    {
      id: "99d22bd4-5cdf-4e17-8845-59c30640c69d",
      text: "(OFCI) B2 Hot Aisle Containment",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "377bd7f0-b7a3-4ed8-81c6-102fd7376759",
      progress: 0,
      source_task_id: "7994960"
    },
    {
      id: "49da005d-edff-4335-ad16-144eb2051d52",
      text: "Slab on Metal Deck",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "7b87499f-6094-4da2-9138-6f3e096589f1",
      progress: 0,
      source_task_id: "7995375"
    },
    {
      id: "863f9098-4de6-407d-af06-0318de30cf55",
      text: "Area A",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "597c58ac-895e-4e33-99f0-0adcfe2d7e72",
      progress: 0,
      source_task_id: "8148738"
    },
    {
      id: "483072c8-023c-4f10-bc9f-182e7a00b0bd",
      text: "GS.IDF.2A2",
      type: 5,
      start_date: "2025-12-17T00:00:00",
      end_date: "2026-05-06T08:00:00",
      duration: 776,
      parent: "fdd29649-bbb2-48b5-a690-dcaeb8653b6e",
      progress: 0,
      source_task_id: "7995087"
    },
    {
      id: "df830e9d-ca14-4458-900e-ac944b9cb3d2",
      text: "Tier 0 - B2-2-A - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "b2fa88db-0373-410f-8cd1-6ad493b5bda2",
      progress: 0,
      source_task_id: "7994764"
    },
    {
      id: "9df67091-5008-494e-a59b-61011bb4c73d",
      text: "Tier 1 - B2 - Precast",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994779"
    },
    {
      id: "767a75d4-91d0-482f-9684-40fbafe574a0",
      text: "Slab on Metal Deck",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f8a9cb3-e013-459d-bc9e-aadfcae5194d",
      progress: 0,
      source_task_id: "7995123"
    },
    {
      id: "5c68131e-813e-4fab-869e-e1489cbfd17f",
      text: "Corridor 1N2W",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "fffebd98-3b92-4cb0-8da1-ac9af78bfdfe",
      progress: 0,
      source_task_id: "7995338"
    },
    {
      id: "0ff803b9-2b4e-4863-b06e-ad8d0467eca7",
      text: "Security Panels",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "db0dda39-b5f6-4804-bd6f-fa2f5ef3ea3a",
      progress: 0,
      source_task_id: "7994891"
    },
    {
      id: "f8d9785b-3cc8-4350-a7a0-63593fe09a16",
      text: "GS.MDF Module (Facnet)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "0a823beb-d53c-46cc-a951-42cad5e5a3d6",
      progress: 0,
      source_task_id: "7994825"
    },
    {
      id: "5132dd90-6a94-45bf-b739-1d6be4432df5",
      text: "OH Coiling Doors",
      type: 5,
      start_date: "2024-10-01T00:00:00",
      end_date: "2025-02-27T08:00:00",
      duration: 0,
      parent: "4fc673cb-0d55-4b7a-adb1-7bee9f658bfd",
      progress: 0,
      source_task_id: "7994900"
    },
    {
      id: "ef22316f-7d40-4b1f-be38-81d5508e37fb",
      text: "(CFCI) Div. 11 - Facility Waste Compactor",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "fe426be2-0e9f-4710-8fb3-13f55f18c43f",
      progress: 0,
      source_task_id: "7994907"
    },
    {
      id: "f62a7e88-a561-4b91-8c24-7ee51da36a9d",
      text: "Area A & B",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "d89fa483-94e0-4376-95d1-3a3ea79586b7",
      progress: 0,
      source_task_id: "7995434"
    },
    {
      id: "0ec68ead-46b0-4fd6-9fb6-51efa56ec9c1",
      text: "(CFCI) Div. 09 - Glass Mosaic Tiling",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f5d15b6-3801-4b83-9da3-89ba5b3dc781",
      progress: 0,
      source_task_id: "7994879"
    },
    {
      id: "d622e998-8403-4d5a-b9a2-2b1a29e18816",
      text: "Tier 1 - B1 - Precast",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "6f71df42-798a-4f2a-a5ee-6bfda5a2a664",
      progress: 0,
      source_task_id: "7994801"
    },
    {
      id: "993685ef-1582-464f-9b03-77cfb583d5fc",
      text: "Tier 1 - B2-2-A, - Core / Shell (Deck Edge/Openings/MEPF Envel)",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "f9e387f9-2c34-4b71-aed4-2599b1c19b7a",
      progress: 0,
      source_task_id: "7994780"
    },
    {
      id: "bf6f1c21-a642-4ee6-ac9d-90e44095dec8",
      text: "Tier 0 - B1 -1-N - Underground",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "3ef20cfd-585f-4597-9bfa-e7f8c0f82a04",
      progress: 0,
      source_task_id: "7994803"
    },
    {
      id: "267b47cd-f1d0-49e4-ac94-68aec0df19d1",
      text: "Area B",
      type: 5,
      start_date: null,
      end_date: null,
      duration: 0,
      parent: "597c58ac-895e-4e33-99f0-0adcfe2d7e72",
      progress: 0,
      source_task_id: "8148739"
    },
    {
      id: "dc323cfb-a17f-4b05-bebd-630fcd98848f",
      text: "Telecom",
      type: 5,
      start_date: "2025-01-09T00:00:00",
      end_date: "2025-10-18T08:00:00",
      duration: 368,
      parent: "3ec32f80-eb92-40d1-bc04-dc0f14d242ce",
      progress: 0,
      source_task_id: "7995189"
    },
    {
      id: "81163b8d-213a-47ce-8f82-68561568deaf",
      text: "Sanitary Sewer",
      type: 5,
      start_date: "2024-07-15T00:00:00",
      end_date: "2024-09-20T08:00:00",
      duration: 408,
      parent: "9f31dd44-d7f7-4802-ae31-0ab5ed2a11c4",
      progress: 0,
      source_task_id: "7995166"
    },
    {
      id: "7d21c5b3-5fe8-4c59-a546-3b666f32b377",
      text: "UPS Room 02.01.E2.01",
      type: 5,
      start_date: "2026-01-26T00:00:00",
      end_date: "2026-04-20T08:00:00",
      duration: 480,
      parent: "526f6a7f-b9c0-49e8-97db-340bf873b655",
      progress: 0,
      source_task_id: "7995053"
    },
    {
      id: "7e6eb9cc-c620-4795-ad4f-a763ab4751c9",
      text: "Corridor 2D2",
      type: 5,
      start_date: "2026-03-03T00:00:00",
      end_date: "2026-08-28T08:00:00",
      duration: 1016,
      parent: "dfc16b55-f1f0-4fea-b940-c09ea7840d80",
      progress: 0,
      source_task_id: "7995067"
    },
    {
      id: "984b19cb-e113-48d8-94eb-b3babf498cee",
      text: "Slab on Grade",
      type: 5,
      start_date: "2025-10-03T00:00:00",
      end_date: "2026-01-17T08:00:00",
      duration: 568,
      parent: "6f8a9cb3-e013-459d-bc9e-aadfcae5194d",
      progress: 0,
      source_task_id: "7995105"
    },
    {
      id: "e5b9549d-9194-435b-9ea4-2d31c95d3bc4",
      text: "Power Delay - Delayed Start",
      type: 5,
      start_date: "2023-12-01T00:00:00",
      end_date: "2025-12-15T08:00:00",
      duration: 4112,
      parent: "6083e472-b9b9-4ec9-90de-2a721818dc61",
      progress: 0,
      source_task_id: "7994993"
    }
  ],
  links: [
    {
      id: "51cf4837-8038-413c-a2fe-365603a683b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecef52da-83fc-44d1-ba1f-56501ee5e577",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "cc3c9608-37b6-40de-93c0-0827489e5374",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2b321b6a-3033-4d36-818d-1894068ccc36",
      target: "706b62e5-8002-44b8-9153-6007b53cd464"
    },
    {
      id: "eb0526a9-975e-4c97-b03f-4335a61ad57a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2b321b6a-3033-4d36-818d-1894068ccc36",
      target: "3e60f626-2a1e-4750-9366-6b50c125d012"
    },
    {
      id: "784070c0-f9c6-4faf-aff1-9487f02500a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3d898a8-7b06-4e93-ad53-bf054d4e3567",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "69ea0605-5a2b-488c-b354-35f7517bca65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d72ed235-71e8-4748-ba35-530b4c3e04f0",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "36024e31-ee19-4dcf-bca2-1d321043046b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "abc1e34d-7fd5-4e5a-97a3-f978003f5cc3",
      target: "2af75056-6a2d-4ee1-a19d-b97049236c3b"
    },
    {
      id: "7414eeef-20f0-464c-98ff-4bb8d23e554b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "abc1e34d-7fd5-4e5a-97a3-f978003f5cc3",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "61478926-1628-4163-9507-b2a4a5d18095",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9e562eca-9bd2-4cc5-821c-9f0a6cb0ba03",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "f195d6d6-d7af-416e-9108-948beec4bcb4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96af88c9-9303-4517-8063-d5291d0ec79d",
      target: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a"
    },
    {
      id: "99b4858f-c241-4ea0-ae0d-34f3423fa990",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96af88c9-9303-4517-8063-d5291d0ec79d",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "98aa845a-7afb-4c6e-9a85-360fbabed2db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "ebd5e4a8-6efc-47fd-9515-a6e9cc01d674",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "b8c4eff1-033a-4259-8563-75fcfce623e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81ab71bd-6025-4df1-8730-74f01fab7d68",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "f96b7d30-bbae-470c-a585-58d33f911d33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81ab71bd-6025-4df1-8730-74f01fab7d68",
      target: "6413bb2a-cb70-4f6c-879a-840667f54942"
    },
    {
      id: "67358ea7-9bc3-47df-bc64-f87c269270d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6413bb2a-cb70-4f6c-879a-840667f54942",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "21e88f3b-31d5-4f51-be46-ce7b4012a019",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58e550b0-e44c-4727-bc94-a540cd987379",
      target: "9de991ae-24d3-47ac-a668-a61e204b073d"
    },
    {
      id: "38f1fa9d-03c2-4d50-81d0-de2a24ff6a49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2af75056-6a2d-4ee1-a19d-b97049236c3b",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "1b805b13-5c64-4317-9437-061b8f3b9ff0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "cacd0daf-01f3-4bde-a8b6-981084376053",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "379311ae-7a7f-4ac2-8a18-7ea1aedbe955",
      target: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a"
    },
    {
      id: "c1ec2bfc-8c72-443c-8fd1-3680e170a5c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d4d1a7f-96fe-4a31-85ca-634b28f3acfb",
      target: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a"
    },
    {
      id: "9c7e2f1e-d23a-4665-a389-954d51cada4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "026e3909-8c5e-443b-830c-4d8cfc419135",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "3283e4b9-a997-45fe-bbad-5d8cafe9012e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "cdbb99f4-d61e-43cb-94a4-6e7cab5b173e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "706b62e5-8002-44b8-9153-6007b53cd464",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "ba6e0bdb-44f9-4d38-bfcb-ac419a102cc9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e60f626-2a1e-4750-9366-6b50c125d012",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "decb732a-992e-4e7a-b446-ddd61e95e74b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba107032-7cc6-4140-8d80-66eac9c10862",
      target: "6413bb2a-cb70-4f6c-879a-840667f54942"
    },
    {
      id: "3a37894e-d1c3-4420-971c-f1e81cd4360f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a925966-ce5b-4931-a282-e3043b01a1ab",
      target: "6413bb2a-cb70-4f6c-879a-840667f54942"
    },
    {
      id: "5034aa40-cfee-41db-9882-fe2838b797e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9e23379-a129-4ebb-b80c-e8552edee979",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "d34382b6-7cae-4b19-bf49-3a3d1609d9c5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f702a418-b705-4108-95d7-f990a80150d2",
      target: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d"
    },
    {
      id: "64119342-8af2-4c89-8664-437118ecec30",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f702a418-b705-4108-95d7-f990a80150d2",
      target: "c3d898a8-7b06-4e93-ad53-bf054d4e3567"
    },
    {
      id: "e445efe3-dfb0-441d-9cdd-0c15c47446ce",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f702a418-b705-4108-95d7-f990a80150d2",
      target: "9e562eca-9bd2-4cc5-821c-9f0a6cb0ba03"
    },
    {
      id: "0de34e4c-9ab0-44fe-b39e-4ef33986efd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f702a418-b705-4108-95d7-f990a80150d2",
      target: "5e97ad4e-c7d3-4531-b560-aaab3e9ab2dc"
    },
    {
      id: "64965345-d218-44f4-bcd6-8e4c2319f5ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0da505-7ac6-4f33-b243-fa60110dacc1",
      target: "d919a8af-a1c6-4060-98f3-7692faa4fe61"
    },
    {
      id: "1d122d74-dca9-4eb3-b7b8-23c1e508310e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0da505-7ac6-4f33-b243-fa60110dacc1",
      target: "0c64ec9d-59dd-4c73-899d-d202963f14d8"
    },
    {
      id: "b8a69517-6955-40af-808d-bb8ad0ae3d1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "006347af-648b-4dcc-a410-6e226dbac75e",
      target: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426"
    },
    {
      id: "26ecf759-10a5-476c-b800-b98e166e0fde",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7c9a664d-2bb9-40a6-aedd-590cf3098c75",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "1aa1f5fd-a919-4758-a163-154f4703a4bb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d3c644e8-b911-4561-8a09-2ce148f4320b",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "38227819-c8cb-4d1a-abeb-9850d61e9313",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a3aaf47-1ab6-4956-afd7-b30ef3fb8615",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "6c468086-dd70-4e97-a3a1-032fb02a8f1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7fdbb9cd-57b1-4d68-b277-70b803118d05",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "aad86823-9e67-4c0e-92db-9672bc81f32e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "963add96-1857-4130-80f5-cf03290831e1",
      target: "026e3909-8c5e-443b-830c-4d8cfc419135"
    },
    {
      id: "b57b1702-1aa4-4d2c-b3dc-cde4ada00e9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65317120-a9f6-4f06-95cb-94e066f777b7",
      target: "2d50ccf5-cdc7-4321-95fa-8eb9bcdceb98"
    },
    {
      id: "0620efeb-b353-4e9f-9506-53b5f281061b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29507403-1346-424f-881f-30f2eefcfb73",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "552a8932-2595-4224-b277-addd1692af47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29507403-1346-424f-881f-30f2eefcfb73",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "5d41c0f8-1aba-48de-bebe-750bd5b32930",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29507403-1346-424f-881f-30f2eefcfb73",
      target: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3"
    },
    {
      id: "9a56e852-fed0-4be1-9152-c14137d9e654",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0f8b31b-828a-4f07-9994-a48c929bd17a",
      target: "b5935d97-c1ba-4de7-8191-fdf6e338c173"
    },
    {
      id: "2d69f5bf-9b7f-4f29-80e8-cc0b85d70372",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49c2db29-f8b7-4697-9ee9-50894cfe766d",
      target: "6375921a-2180-480e-b9f5-dcad87dd87bf"
    },
    {
      id: "238285f8-4159-4746-b46a-3d8ad786f612",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d952212a-7c20-4301-88c2-d4ea58766e1a",
      target: "51370ae4-75d9-4cef-9ae2-da90bb8354b8"
    },
    {
      id: "f044088f-7d7e-4662-9b2b-5385a65fef05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b475fd7-db58-45e4-90cd-9e9e9fb2a75a",
      target: "e268c818-d3e5-4b88-8a92-e9fe836f88aa"
    },
    {
      id: "c557c614-3765-4603-bc34-7a3b7c02559e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a7b8101-358f-4e05-92f5-c2cc06e8a959",
      target: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2"
    },
    {
      id: "151458f3-674f-4b45-aaa3-dcc15c49aa03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a7b8101-358f-4e05-92f5-c2cc06e8a959",
      target: "3c142183-d997-400f-9a7d-43cc08f164da"
    },
    {
      id: "b66c0019-9bc2-4d86-b036-58e39a982e90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e297290-43c7-404a-b379-6ce4cea826e0",
      target: "6600c781-1202-481e-a52b-35cd0964ff47"
    },
    {
      id: "a7612c85-ba0c-4656-9d67-9ff71925615d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e297290-43c7-404a-b379-6ce4cea826e0",
      target: "1ce850f3-9e55-4e6b-912f-bcfe9c5a8eb6"
    },
    {
      id: "4ebef327-52d4-4bd8-9d7b-7b9465ecc2a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "1d3cd42c-c28f-4c85-b465-159ed590a99d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "77c99e68-c4e7-495f-8a35-fa9918eec106",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "d24501a4-3025-48eb-a1ff-98862810740f"
    },
    {
      id: "80e34070-0d1d-460a-8b8f-d06698538dbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "4c368340-33b6-4819-9ab5-0f14b3d5b7f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "dcfca05d-8864-4acd-934e-c4730a3c620b"
    },
    {
      id: "1535c1cc-e30f-4304-9d33-9c844d83e7b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb",
      target: "df3a87fb-ee6e-4f5c-8016-17e721e18e5f"
    },
    {
      id: "ab2f20b5-eac6-4fd7-8589-d1a4fc3d6349",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "6a707474-58d0-4d03-b952-7adf58dbb4cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      target: "814ea38b-c0af-4e69-9a05-48b4d34fe4da"
    },
    {
      id: "ca1ea785-4d72-456c-8c5f-e8431b51fa47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      target: "6b0eab76-2efa-4856-94fd-8f9875c33373"
    },
    {
      id: "a4e2233c-d7cf-4bc6-ae44-0f33c5b91865",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "510e9d5f-dd31-4150-97a8-6fb08f74800e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "3483e282-91bf-4372-82be-57142a0d08f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ae0c693-710f-4d74-9f48-d4ffe3563328",
      target: "81b937c3-75df-4386-a79f-3240af9a410a"
    },
    {
      id: "9498aaae-5918-4448-95a7-76bdf69d264c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e83af6fb-81e2-4758-aa2f-90b56e081c3f",
      target: "879cd5c6-a8f9-41d0-95d9-f6231708cd22"
    },
    {
      id: "499b50af-3a5d-417e-8c95-5247c3db5284",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fa2c90a-4117-4eba-8dfc-3d2b15c3088b",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "cfe45ccb-08cd-4a56-9e8f-662d8e90fbc1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fa2c90a-4117-4eba-8dfc-3d2b15c3088b",
      target: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb"
    },
    {
      id: "1fdeed32-267e-4d30-b761-47a0df0a7b94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ef449ea-d160-48e6-9c6c-1f5fbedf706d",
      target: "bd2743ee-f5f7-4244-9acd-de51e09905e0"
    },
    {
      id: "9308a3b5-cd6f-4536-b2ff-9f9dca6c1604",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1123851f-8062-4ec1-8099-548b04aca54a",
      target: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5"
    },
    {
      id: "e4a0c3fc-8cf8-4223-9f61-4572ccce040d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c1a1b4c-abc9-4754-9251-85dd255f658e",
      target: "ae7d5631-0e66-4aa4-a199-d819775a27d0"
    },
    {
      id: "598c6c26-f9fc-40f9-bcec-205d2bc1484f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ffd4bc9f-42d8-4135-b878-f4d6139a1763",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "2026c0b7-2e00-49f1-b438-4974593ef6a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2848bb95-d1c2-4518-9d78-d325f4e2c6d1",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "48023189-6888-4148-b042-664c15a2746e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa74099b-0c1f-464d-ba37-712d8efd9636",
      target: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc"
    },
    {
      id: "8c6dea9b-56d1-404c-be2e-c23cc2b7b357",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c7f70e-5291-4b35-8fcd-f3a7dd24145e",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "59d48dc5-6cf2-453d-99a4-7ca1248c73b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9319a15f-aaa6-40df-a1dc-1a376df772dd",
      target: "b36d3e4e-d14d-4d7c-bd06-37af8e07a714"
    },
    {
      id: "2cface85-fa2b-430f-8bd2-925bc11b9cbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd8c2ae-1020-4a4b-afe4-81cf3e011402",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "86b563e0-d8c1-46d6-8212-fb41e9edaee2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c9e523b-158a-4369-9521-45d4209777a3",
      target: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d"
    },
    {
      id: "a9ff29e2-0f23-4a44-b422-cc8da5ad3c38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecf57043-4fc4-4c73-afa0-056b30ec5da7",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "ef4b6d90-8b80-4df8-abc2-d736e6a4bb9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1dea4851-b02a-419c-ae58-ee0461e2cc77",
      target: "73d065ec-b2a2-4b51-b830-f548cf113290"
    },
    {
      id: "a78a9c3c-e849-49fd-85ec-c0a844dc29b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1dea4851-b02a-419c-ae58-ee0461e2cc77",
      target: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5"
    },
    {
      id: "2c3527f2-de01-49fc-98be-37805b57d220",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5c5f4e6-7ed6-4631-a437-dda89bf7a383",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "8e2da915-dd37-465c-b6da-32284b116ed5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "828e2b04-6e5a-4259-94a4-828c11f3f999",
      target: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6"
    },
    {
      id: "4c45536e-5fac-449b-8d94-b174c6aa1d5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "828e2b04-6e5a-4259-94a4-828c11f3f999",
      target: "d0fe2a47-291c-4527-8865-41785c38f7e5"
    },
    {
      id: "8b2efe16-2ad2-4665-8b23-cec9c769a5e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "5f6b99ac-9ebf-4878-8d8a-210248e97d7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06cc82f0-f677-410f-9e3f-f98cbe836508",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "6d8c00aa-99d9-478c-8a79-ec7e522dbadc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c0dc662c-8200-4f0e-90a0-2d410ebc3806",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "9fa7fc43-a3cb-47cc-91d6-dbde53915d60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "061b8cd8-5099-4281-8bf5-8ec50b7a4267",
      target: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8"
    },
    {
      id: "fc5d8170-9b6f-4c74-82dd-24a39600fa84",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67f67df1-5b8f-468d-bd41-e9987e90a528",
      target: "141eb1c4-05d8-40d1-8f58-00736f1e4575"
    },
    {
      id: "65e785f2-37a7-4374-b556-d2858811675e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7055bf-142d-4b99-8e43-e8e1ce0a223e",
      target: "16772213-e8e7-4430-9271-e32d23148879"
    },
    {
      id: "16d6d576-b373-44cc-9e74-e837761fb222",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "79b21e2b-9e78-4e8f-957a-3654e2fdea61",
      target: "7e745a24-1acd-4964-a8c4-be98686c3c6f"
    },
    {
      id: "12f3e432-63e1-4305-982c-b4cf97d2d490",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "547e49e5-1db2-4c6c-973e-35a2b28a24bf",
      target: "09c06ca8-564f-4081-bffc-b19c58f69913"
    },
    {
      id: "12a6f5bb-28ee-4725-9722-97b4b98a700d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "547e49e5-1db2-4c6c-973e-35a2b28a24bf",
      target: "829f9e87-e103-4200-a8ff-a6b0daa48b58"
    },
    {
      id: "034c3b30-10f0-45bc-b7f9-1af624340a4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7b21fff-59b1-4351-ae73-34e1aa35e758",
      target: "4b763aab-f0f5-492d-b7d2-832fcfac94f0"
    },
    {
      id: "84b6bf49-5b44-4733-bbd7-eca8bed9c15d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a60b1c60-082a-432c-8ac6-7d6487a44ad8",
      target: "4b763aab-f0f5-492d-b7d2-832fcfac94f0"
    },
    {
      id: "86dcbd11-4c30-4937-86c3-bcaa5b3cbb2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "077cbf67-e6b9-4ef9-a925-b08d253ac77b",
      target: "4b763aab-f0f5-492d-b7d2-832fcfac94f0"
    },
    {
      id: "28158eae-8740-4f60-b925-1b60a6ba807a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72311a6f-7112-488b-83e2-719c937c7f6c",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "00ffb596-65c7-499c-9586-e50d3908d882",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80536356-cae6-49dc-990c-8963343d17d1",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "047720c0-5aa6-4423-817d-f1b70354f2d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d92df994-826b-451d-9959-0988bb8829ad",
      target: "226dba93-ba7b-4d64-91b0-417be5816107"
    },
    {
      id: "852ebe7e-e580-4a8d-a0e3-afb6a6c3a648",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70c248b3-7c26-480e-8a9c-fe4c54aeac5c",
      target: "6578e9d9-ca51-45cc-8726-cf66b2a066ee"
    },
    {
      id: "0b4cdb7b-f7c3-4fab-b7f0-94df52197340",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38dfa9ba-a89e-42bf-a519-ae07b2f7ccac",
      target: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5"
    },
    {
      id: "b02f3631-ffe0-4800-a58a-632ad49af29f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15cb4329-7b1e-465e-a80b-bec578d26373",
      target: "60b22ed4-5b6b-483e-a342-4ae86e519f13"
    },
    {
      id: "5be1ecd5-8951-47d4-b6b9-103291098fa0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f60a73cf-32c4-4c13-bfaf-61c6d9ca9123",
      target: "e5862044-0aeb-40d6-b111-9bb0dad28651"
    },
    {
      id: "af3f4327-8192-402d-946e-b382632b24b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "802be593-d644-4540-aac9-a98b564c0317",
      target: "e5862044-0aeb-40d6-b111-9bb0dad28651"
    },
    {
      id: "b467f36b-0d4a-491e-ad9b-0b7fa251628d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d97fca9f-fb52-4158-93c7-1764891aeef8",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "8c75fb12-50d6-42b9-a0f6-212fd91cfcb0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6555168b-5348-47cf-96a4-00868784ed13",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "b18d5f4a-90e9-478f-9e77-d492280c757c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68e26ec3-52ca-47f6-b3d9-1bdf7676bafe",
      target: "471d1405-1daa-4156-863f-71099cb2bf78"
    },
    {
      id: "2c6e4747-e22c-498f-b4e4-a2d856067d51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e4407c3-c824-4548-be75-dce29413388f",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "24d66309-482e-4a8d-9c33-eda21ace5bad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "666d1c60-24a6-4d53-b322-e6d39e6ba01c",
      target: "64a5e86d-b411-4655-b538-9440a526b176"
    },
    {
      id: "e43611dc-e5c8-4414-be0b-500e475b0ec0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d88da9af-de9a-4f0b-a64b-948a878500ec",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "a9c9117e-f058-4909-b3ff-23ffadc53a82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "381800b6-6b73-4510-96a3-aadd9d35b418",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "95b481ae-393a-4a0c-9300-9b06fc32b797",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebeccaa7-5cce-479e-adab-4ec5dea93232",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "26dfa93f-5a04-420f-9d58-30d357e13d5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb45b960-09a6-4197-b4e2-b2c45e54f7e3",
      target: "613b7208-4628-4f41-be4d-244470010d71"
    },
    {
      id: "8bd5d11d-12be-4286-9ae3-24e40709db04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf25da74-e75e-41e4-a191-e5d5ece7a181",
      target: "613b7208-4628-4f41-be4d-244470010d71"
    },
    {
      id: "019071e6-b00f-49ec-be60-a739020a8bb5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a121ac5-3f0c-4f5d-a5e9-a4f821e0ee48",
      target: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70"
    },
    {
      id: "99cdc579-5fe2-4633-a4d8-1242e9cd2754",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7aaa84c-ad46-4363-8344-8cf94f254ed9",
      target: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426"
    },
    {
      id: "c54673a8-1b34-4106-b932-4e2e0465f37d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cad802e-8833-469b-b2e3-756cb942706e",
      target: "006347af-648b-4dcc-a410-6e226dbac75e"
    },
    {
      id: "55a97da0-2980-44da-a123-374678007759",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "504b13f4-e85a-4642-b582-011bb9d3c11d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "8b41464d-2627-48f8-af7c-f000886a0f42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "4d3b0541-218d-4afc-b082-be2871c668b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "b6b4a619-1641-4c88-b742-d31b64cea3a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c999f46-1e6c-4bf4-b009-23cddd1a13f6",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "f91758c4-6ca4-46e4-8da4-27db0c566c2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c999f46-1e6c-4bf4-b009-23cddd1a13f6",
      target: "96c4da44-9951-472e-8a46-30de0eeb2781"
    },
    {
      id: "81a5f781-0b17-49e1-ad2b-c70d14e344e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c999f46-1e6c-4bf4-b009-23cddd1a13f6",
      target: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09"
    },
    {
      id: "b639afe5-0405-4f6e-8bcd-3eaa7a45b9eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc3997a9-2390-4cd0-868b-06e57a62a91f",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "cc181bae-4b96-4d22-90f8-899d8884cc16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc3997a9-2390-4cd0-868b-06e57a62a91f",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "7e85c1cd-1aec-43eb-a664-6451728aec24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc3997a9-2390-4cd0-868b-06e57a62a91f",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "1dd6c5ff-03af-4e8d-844e-e0c85a71f0ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf0f2f61-4604-42f7-8a44-b75532890447",
      target: "a4902310-fe36-4f67-81dc-c6698d7f9917"
    },
    {
      id: "9bb4a57a-2eb5-4a31-92fd-a1ebfbb1ccb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf0f2f61-4604-42f7-8a44-b75532890447",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "bf0698ad-fa4f-411f-b91a-8d7cd501705d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf0f2f61-4604-42f7-8a44-b75532890447",
      target: "479b6606-d49b-4fe5-88c7-f4f4c95b0585"
    },
    {
      id: "085d68e0-66d3-4d72-bcf7-230b4084f71c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f764d1ed-77ec-4afb-a627-a67975c11e76",
      target: "5ef13ffd-36c1-415b-b6b8-875944a8de5a"
    },
    {
      id: "a55bcfd2-4ebb-4c34-a8a6-a50f8a794a1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84",
      target: "f764d1ed-77ec-4afb-a627-a67975c11e76"
    },
    {
      id: "fd594381-1b83-41f1-86c1-40568f742130",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84",
      target: "5ef13ffd-36c1-415b-b6b8-875944a8de5a"
    },
    {
      id: "225c3620-ae37-44bb-a1a9-050c2b47ae8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "670aec9a-e1eb-4076-9b88-4d9eb7984678",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "cb88c99e-2f14-4e3f-97dc-19a3dbdeaf92",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55",
      target: "630aa7bf-92c2-498c-bb8b-83bd815e0475"
    },
    {
      id: "55f5615f-e77e-42ba-a7a3-63c19227b001",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55",
      target: "0db73a88-707d-4f71-add5-96bcc57042dd"
    },
    {
      id: "670f74f0-1a2b-4729-9aca-f15dfed8f121",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "4f69652d-bbb3-4a7c-9567-a9ac5767fbb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be9a3cae-a5bc-4239-9b4c-05ac5c53f89f",
      target: "630aa7bf-92c2-498c-bb8b-83bd815e0475"
    },
    {
      id: "ca2317b8-6978-4f8e-aaa4-3ff15797aaf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23b10f07-b4fe-43f3-a565-d567bcaca24f",
      target: "c7699246-bbba-4ca3-8a23-77c106b18bfa"
    },
    {
      id: "e73e5e13-c1c8-425f-9259-f1a17b77ab83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b392fd7-450f-4ead-a14e-cec5e6b13630",
      target: "556f6761-f13c-4fd4-b607-ba5bc889528f"
    },
    {
      id: "9cc9c117-6528-43af-9627-9478725a6e7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd597037-1f8d-46e0-b78b-c620a11d3f59",
      target: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd"
    },
    {
      id: "c0e694f2-6aca-49ab-bda8-afea4b5b1924",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3125c09c-538a-4eef-9f3f-213a2ca6ba6c",
      target: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e"
    },
    {
      id: "b6eadbeb-bca7-4f4f-95af-b5ae3304db71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c72046e1-d3c7-4a2d-a2fb-68105d8ff5af",
      target: "92382b5d-09f4-4be1-b2f5-b1899eed6f80"
    },
    {
      id: "9c85ec29-97cc-41f0-ab38-33ebd02a7ce6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "93687a79-dfee-49b4-b1d4-b8335cfebe1e",
      target: "5ef13ffd-36c1-415b-b6b8-875944a8de5a"
    },
    {
      id: "8ebf7582-cd89-4820-bc1a-4760130dffaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32649675-5f9a-4c00-91f6-aa2ef8b70d4f",
      target: "2c824a29-b625-4f37-a78f-907d6feaa77a"
    },
    {
      id: "1376b146-305b-472d-99c8-94aa7de78371",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb4ba05f-e504-462c-a449-4229236823ac",
      target: "edc6bbd2-58cb-4892-a4b0-b8a7558c1314"
    },
    {
      id: "2324f550-2c52-463b-acbd-0aedbc29860d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "6eb8d1de-2358-4cd9-bd84-cf8fe8a28b79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "f030cd3f-ff04-4efb-8434-5a98726dca2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "647c6a43-beb6-4657-9f02-65549581d252",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "27172ac6-5a0f-4b72-a46c-27493560a96d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "647c6a43-beb6-4657-9f02-65549581d252",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "6ccb3238-e0aa-4c44-b670-5afb2ce153b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91934193-29f3-4677-9b89-832aaad7d820",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "098b0031-7509-43a2-ad0a-d3a0aec3c7ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91934193-29f3-4677-9b89-832aaad7d820",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "04a5e2fc-d021-49eb-a2a2-e7ccdd2ab714",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01c0d7ea-27bf-4f36-9ab7-149723ddc836",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "e4a77799-ea75-45bf-ab0e-79af8ba26cd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01c0d7ea-27bf-4f36-9ab7-149723ddc836",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "00be261a-c5c5-4acc-9316-da0d2c976dd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e4ecf78-df25-44e3-b7e0-d880d601b742",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "ea9ac91f-5c04-45ba-a7ef-992c638b5a1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74ee1cf2-98e1-40e1-8689-20385d55fcf0",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "3b2d491e-9293-417a-ad94-5628ab78fd4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "aeff3abb-6176-4f02-aff3-2b919a946335",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "35b20efe-8607-4062-ad8e-def5ac6c21b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2122c78-55fe-482c-88c1-30ff5b193643",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "9a1cb3be-07f6-4f22-9d8d-1aaf4de166a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2122c78-55fe-482c-88c1-30ff5b193643",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "e7228ed3-86d8-40be-81fa-ba8764083306",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d7692ee-e39e-4203-8386-e67ef0a74a9d",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "970a64cb-6516-4065-a671-f03e21873f09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "630aa7bf-92c2-498c-bb8b-83bd815e0475",
      target: "96b9cfa7-1185-46b0-ae0d-669f51d859f9"
    },
    {
      id: "c14a1ef3-5aa4-466c-8266-fd3e7e5a22cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7699246-bbba-4ca3-8a23-77c106b18bfa",
      target: "7989b2b6-5240-47f3-adab-3b89fbe05185"
    },
    {
      id: "e61339f4-8a8a-4821-9171-54dfec251e4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "556f6761-f13c-4fd4-b607-ba5bc889528f",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "d9b9c2ac-7f23-4798-83cc-b84ad80b4bec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "20d820a7-a1e3-4986-a80f-f8727784ce75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "49e58442-f781-4cb6-8af3-96a611efa93c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92382b5d-09f4-4be1-b2f5-b1899eed6f80",
      target: "2d50ccf5-cdc7-4321-95fa-8eb9bcdceb98"
    },
    {
      id: "bae85afb-0b5d-4ede-9154-366aa8915fe2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ef13ffd-36c1-415b-b6b8-875944a8de5a",
      target: "ab0f24d8-ea95-4882-bd0e-dd47c6396a3f"
    },
    {
      id: "6dab62a3-77cf-4624-96a2-09cbcaf86066",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "9c4f4bb6-695b-4cc0-8e5c-6fe670eff4ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "85587e26-01d1-4c7d-a0c0-a987d3c4bdf2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c824a29-b625-4f37-a78f-907d6feaa77a",
      target: "42ce33d6-85a8-43a4-9df8-1e057e94d91e"
    },
    {
      id: "aaccff37-16f3-4b95-8b4d-0134699f42ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "514fd011-bf24-4893-b099-d913d65e9062",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "97cd4309-c093-4456-a8b9-f9d6e4f30e90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "514fd011-bf24-4893-b099-d913d65e9062",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "99382844-5b96-44f8-a455-6ccf82ffd42a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6fce1c3-c853-464b-9031-deaf389a90c0",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "11c5e416-754a-4fbb-85a5-67c166c6f63b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6fce1c3-c853-464b-9031-deaf389a90c0",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "202ac2b7-ed47-4d8c-be40-69af329991da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6fce1c3-c853-464b-9031-deaf389a90c0",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "4fe5a9cc-9922-4062-aa40-ee001849d7f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6fce1c3-c853-464b-9031-deaf389a90c0",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "dd85ebed-f3c0-4eaf-987b-b10c54ffe1fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d314deb-145a-4291-845c-6265c36e459a",
      target: "dd888cf3-c150-454d-a756-d731ae84c8be"
    },
    {
      id: "3dc41e3c-6ec2-4a14-937f-399160d3b223",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a44da7c-f803-4818-bd5b-8e8169df7615",
      target: "0b1b385e-5b7e-4978-859b-4f7f47a21776"
    },
    {
      id: "ec4cbc74-d596-4796-a03c-80c98d48fd25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bacc9779-e175-435d-8b8a-abbbf13f7902",
      target: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4"
    },
    {
      id: "f55f45d0-a36b-4a52-b5b4-ad0e695d75d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "daf3fc35-13f6-4999-9921-45e66e1700e8",
      target: "c6bde09b-8153-44fd-a653-a7dffa1f104a"
    },
    {
      id: "5d74110c-a5c4-4594-b982-deef7b61ad65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "7d42f996-04d9-4694-b075-de33ad444174"
    },
    {
      id: "d5abc39c-1cec-4a20-8826-9c8e5d19c9d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "ac0cfdb5-aa27-4c58-9a64-abe07a592e24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "375fb1bb-57ed-443d-9a26-40b13cc7ce78",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "7bf87f59-99b0-4b87-94c9-ebe25279c1f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "ca802a1b-8629-4ef1-8705-851d06d69817",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "d2b1bd47-c65c-4390-8f32-0ee63457bbe1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "53551a0e-9999-4051-bd2a-9817a2e677b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "dcb7c310-38d3-4a6d-b619-73677b94cf8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f996da-39a7-46ab-af62-c26c74ce326e",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "3e9041bd-7bb5-469b-a2be-4a2d863a3078",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f996da-39a7-46ab-af62-c26c74ce326e",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "cc737bc0-6c4f-4aa3-afe4-b67da8edb41d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "7e430a6e-6ba0-4d38-aa41-41be06876e4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "9e291848-2505-4ff6-a39b-b88350d47992",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "f52bc7f6-909d-4db6-80ca-769610ca48a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "721b9e84-f5fd-4c2c-b778-8868d88a4f58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a87ebd8-615f-4259-a1a3-f0ac70e94174",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "7b0a7065-94a7-495e-b392-6ecfccd9f2d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a87ebd8-615f-4259-a1a3-f0ac70e94174",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "b805951c-11dc-45ba-b07e-50067f688c09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "538fc6c9-bb4f-4f2c-bd27-f7c727136670",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "9cba66ec-9750-4e39-9ba1-73eda8369843",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "538fc6c9-bb4f-4f2c-bd27-f7c727136670",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "a73f8851-e682-4b53-ad9d-d35bc2487d19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84578b5c-1cdd-4361-8b5a-5000093df4c1",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "8199d2a9-06a3-4051-9ff2-2c1234f00d2a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84578b5c-1cdd-4361-8b5a-5000093df4c1",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "f284698f-6420-4023-a88e-826999642bf2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "58d9180a-b96d-4e7a-a6c6-4f2de432cead",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "4caefbcd-fe72-4126-b002-eed48a6d6432",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd888cf3-c150-454d-a756-d731ae84c8be",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "a39e8eb6-6470-4f77-ad70-58f454e4f684",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd888cf3-c150-454d-a756-d731ae84c8be",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "fca2167a-8d30-48f9-b15b-77a725896646",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b1b385e-5b7e-4978-859b-4f7f47a21776",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "9bf51380-7c2f-47e7-9be7-57ce3f8e4bbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b1b385e-5b7e-4978-859b-4f7f47a21776",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "3b244b6d-4c0f-41f4-b699-d3659920f428",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "6c9fe0a5-b880-4a0e-aa57-2b6c1edb2430",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "e0b38d6a-f244-4e70-90b5-8cbf30531046",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d42f996-04d9-4694-b075-de33ad444174",
      target: "7106e614-e14a-4029-bf17-8ea4bd60029d"
    },
    {
      id: "0fceb029-14a1-49dc-9c64-5df04a84736b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6bde09b-8153-44fd-a653-a7dffa1f104a",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "e4e47f08-361f-4b11-9219-8d6afb735755",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6bde09b-8153-44fd-a653-a7dffa1f104a",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "a285c569-b05d-43e9-a34c-cf294915d64b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "307e4193-b874-4d2f-a568-29c3a6952e9d",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "573af710-e455-4894-b5b1-d0a97ddef861",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73113448-b7bf-4cd2-871a-20a72e48c232",
      target: "61d8a848-a111-42d4-80f2-e97260d63199"
    },
    {
      id: "bbd3c3ef-6130-4b8c-9083-bc3c15e29751",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7989b2b6-5240-47f3-adab-3b89fbe05185",
      target: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6"
    },
    {
      id: "9c744840-8d4b-4166-a8f9-9876ade283ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b230b21-0d2b-4d57-a8d8-67226d0d800c",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "b186477f-3c18-47f3-871e-703fff5ab545",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "224c29f3-50e4-422c-bd57-6a816887eef6",
      target: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09"
    },
    {
      id: "30ea978b-dcbf-4791-b676-7811e4beb7b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c1b5dd9-f405-4ac4-b975-1e3b584533fb",
      target: "0e38b366-0370-44f3-98bc-11d1f59d7bcd"
    },
    {
      id: "38790626-229f-4e8b-9b1b-fb146ee34672",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31bf0bfd-e249-4ea9-8c9b-ef0b9f34730d",
      target: "6203ee0b-d544-4410-b314-8e5add762a00"
    },
    {
      id: "aafb97d2-8d66-4e3c-9141-d4d366165c9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a456564a-992b-4e6c-9164-49268d7f3239",
      target: "3212d75d-e709-4b9e-93ea-a8046f26bea6"
    },
    {
      id: "f6b9e187-6641-456b-ab13-cb87eb27151c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3212d75d-e709-4b9e-93ea-a8046f26bea6",
      target: "6af58e79-450a-4edc-84a8-c4ec77919c3a"
    },
    {
      id: "192f92aa-79dd-458d-b030-7a346623ee61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f453b346-22b9-4b8c-b610-24c5e4675f62",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "3ff7c221-9b94-462b-bd9f-c173a2d7ef9b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ef397edc-462c-4006-acc9-d03515ffeae3",
      target: "d2d9b972-c72e-4341-8a57-68637848f221"
    },
    {
      id: "0c3ec04a-cb32-43c6-976b-71b6b73931fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d50ccf5-cdc7-4321-95fa-8eb9bcdceb98",
      target: "a8404001-50fe-4ad5-9496-6ac0bb33cfd8"
    },
    {
      id: "1434cd7c-ca04-4334-a500-b1542b660e29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df07a5bd-4110-44ee-9bec-2d86c528f2f5",
      target: "a8404001-50fe-4ad5-9496-6ac0bb33cfd8"
    },
    {
      id: "5d26f013-a405-4019-9b00-bd9ffc0afc56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96b9cfa7-1185-46b0-ae0d-669f51d859f9",
      target: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f"
    },
    {
      id: "6439eb7f-beff-4657-9f05-de0ca9314aea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aecb3155-a072-400f-ac87-21c55b5bc4be",
      target: "026e3909-8c5e-443b-830c-4d8cfc419135"
    },
    {
      id: "c6d775f4-509f-4447-ba47-6f8b4e1a18dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aecb3155-a072-400f-ac87-21c55b5bc4be",
      target: "d692450c-aea9-4c48-894e-a0870dec709c"
    },
    {
      id: "1382e1c2-46ce-42e2-bfd7-3998cbb2184c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edc6bbd2-58cb-4892-a4b0-b8a7558c1314",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "af53cc40-58cb-40c2-8fc5-14f7d080f21c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9d86652-6a1c-40f5-a401-c4ba776bb6ef",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "d39d48b6-f3d3-4f8d-a02b-2c4a2d419e31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33a147ac-f3bd-4827-8edc-e72977ca1c89",
      target: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3"
    },
    {
      id: "97a62165-9295-47cd-b896-fae7352323ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9194dc8f-640b-4d87-958e-4b6998f0d0cd",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "d4a7460b-1d68-4d85-88b9-74b9680387ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9194dc8f-640b-4d87-958e-4b6998f0d0cd",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "f0c2b545-acd7-4ee8-8a0c-204c6dfbf84d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac3576b3-6f4d-4c97-8b58-3fb7161d4453",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "1e0a5b1a-8ddd-43d4-8707-382a8331c2d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6571f80-018d-4be0-938e-a6e7749692cc",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "2523f826-86ef-4319-b8ca-4b9267a0cdf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9cb8451-406d-462d-bdc3-9144490a4baa",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "5a72799a-f479-4145-8c34-4dfeeb290fc8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8144fc35-4877-49b3-a9c9-6b0660cf06f3",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "7fbcc6d6-4dda-46f8-bc25-6731db238292",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548",
      target: "1615638a-a40f-4417-8464-768dddb76836"
    },
    {
      id: "ecdf9b22-ab0e-4ca4-9719-da9266291451",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce60ea35-b881-429a-b6ce-44412076bd61",
      target: "1615638a-a40f-4417-8464-768dddb76836"
    },
    {
      id: "487de32c-5955-4296-95ec-77ad93e3feef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663380fc-5e84-44c8-9084-4e7d770f64a0",
      target: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315"
    },
    {
      id: "dda83abb-f939-4f15-a58d-f55f0ca4a658",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9f97a49-1437-47e9-b2e5-da7ac58d0aef",
      target: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315"
    },
    {
      id: "aa23a960-e074-4610-b490-35c89b284362",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3",
      target: "0c912ad6-7054-429f-b427-26fabfdfaea7"
    },
    {
      id: "7e876161-ced7-4819-8abe-caa5e14df73c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb3e3f73-bca9-458a-8dfe-7e6a8aec5b3c",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "31959ec7-c4e2-4346-a330-c2bd3b86be30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6328e14c-1810-407b-b9c8-5ded1d2580c5",
      target: "6b903073-2098-4b98-9550-1e7bdbdc6268"
    },
    {
      id: "a20cabbc-4b3b-4ed6-989d-187f4b1240b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6328e14c-1810-407b-b9c8-5ded1d2580c5",
      target: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6"
    },
    {
      id: "19b2a7f6-ec88-40a6-9b88-dba98dfe53e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb34534-4301-4812-9794-66b861e59015",
      target: "6b903073-2098-4b98-9550-1e7bdbdc6268"
    },
    {
      id: "f5ac77cf-fe5b-4d41-bf1b-ce53be6584db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb34534-4301-4812-9794-66b861e59015",
      target: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6"
    },
    {
      id: "6085d3e5-f8ab-4d31-9444-f5b4a4b1d153",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03b46ffc-4f12-4c97-bddf-5b0faf01aaca",
      target: "33b65098-085e-400d-9d1a-636057e978d8"
    },
    {
      id: "a4b807ad-50e0-418d-b63e-91046dadf46c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28c6b98f-7a79-46c0-872d-87d148c820c6",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "4ae6816b-ad52-4ef2-b117-98d33c7ccc6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28c6b98f-7a79-46c0-872d-87d148c820c6",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "d7edfa28-d57a-4c5a-9205-e091cdede681",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aaf377c8-e087-4ad1-b7b3-39b23fec96e4",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "c30993c2-b1d3-4e58-857a-a0bc25c8be28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aaf377c8-e087-4ad1-b7b3-39b23fec96e4",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "fd93cf2d-c35e-45c4-b41c-2f119921b32f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ab0f24d8-ea95-4882-bd0e-dd47c6396a3f",
      target: "c2c3ce2d-4dd9-4502-9124-4ac33d40a6bd"
    },
    {
      id: "71a01ecc-5deb-4665-8f64-826e18b4cd74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "557162ae-f57f-46d5-b338-f37e8aea54e5",
      target: "c2c3ce2d-4dd9-4502-9124-4ac33d40a6bd"
    },
    {
      id: "941dcc4f-ebb6-4695-91df-13e8dc541c55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c4a6049-53c8-4785-b464-67fe218a6310",
      target: "e747de92-3612-4383-a084-d397869ed83b"
    },
    {
      id: "6312ca09-50d6-40f5-a586-f31ce3c18939",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c4a6049-53c8-4785-b464-67fe218a6310",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "0d016545-848c-4490-badf-3b94776d1b5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28b639e4-8219-4846-9660-222d96e37b8e",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "f052aee8-b525-4cdf-b1fc-538e4abbf81d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28b639e4-8219-4846-9660-222d96e37b8e",
      target: "e747de92-3612-4383-a084-d397869ed83b"
    },
    {
      id: "1f913fe5-0696-45be-afb3-90ddfb848cdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2712515-d233-47d4-ab35-a158eeac18dc",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "940343de-ac3e-4ebe-91cd-0c3068852f17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec33f3ff-9607-4ee3-890e-0100e4de0b96",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "6934b450-b559-4919-9c6e-51d287066e93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e743d157-d4bf-4e79-ba02-788774267bfc",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "82de4a68-ac48-4af8-8c8f-d0e4d480f9e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44ace62e-e020-404b-92de-bd5a168f9c68",
      target: "711361d7-7ffe-4250-ac6d-1ddc52dc54f3"
    },
    {
      id: "23080382-5229-4060-943e-b235d1998e3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "711361d7-7ffe-4250-ac6d-1ddc52dc54f3",
      target: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5"
    },
    {
      id: "cf7f418a-e6b3-4102-b869-b1fa57df1bb7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "fa3140f3-f594-460d-b7b8-888e23c2a7fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5",
      target: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3"
    },
    {
      id: "72e9f8fe-5c83-4edf-8163-04491dedd8d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "2be6311c-16c8-419a-aa24-4d137fca9bbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "252a5476-81e5-44d9-96de-ecef9b00b1ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c565da9e-b058-48b9-b693-253cb1774d3b",
      target: "d757e4ea-7f64-459f-9d06-b480a681de4c"
    },
    {
      id: "9a7a8804-eff7-4845-9b72-95b5f2a35a09",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "89cb16bb-25b2-4e5f-bb8c-a9ab72eb9905",
      target: "764226b4-1845-478e-acbb-28aa60f66f32"
    },
    {
      id: "09e96684-5f96-424c-9f7c-83df9344ff40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4e90eb6-671b-4c28-bfb6-75806bbb4e37",
      target: "61d8a848-a111-42d4-80f2-e97260d63199"
    },
    {
      id: "7802a2f6-9677-4313-b083-e4f8521ae645",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42ce33d6-85a8-43a4-9df8-1e057e94d91e",
      target: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe"
    },
    {
      id: "af4f463b-f61d-4e32-880c-4c0def82a73a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60c968a0-95b9-47f0-b58e-3e8974073d1d",
      target: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe"
    },
    {
      id: "9f8baa09-9728-4a06-9786-c964fef754b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60c968a0-95b9-47f0-b58e-3e8974073d1d",
      target: "93267209-24ee-446c-bcec-37f8a12946cd"
    },
    {
      id: "21870773-5e88-4bd3-aeb7-79213b468629",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "e7b33149-5700-4e62-8cfe-5519d7501f3a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8664c72e-35ac-4eb1-8948-e96b5ab4a80b",
      target: "64b9fffe-cd95-4ebe-9d96-44888cb955ad"
    },
    {
      id: "b795385e-7a44-43a8-947d-4850781c5056",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "460505ba-5b31-4e46-9b79-a5bcd8a855b1",
      target: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776"
    },
    {
      id: "d32b429b-0ab3-4313-bafb-e9c163dceed2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8aa8460-29aa-4d9b-a12b-9dac6158488a",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "030b2300-1451-4b35-91e3-5f8faa9373a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3edf62c5-ed13-4a70-8fc9-86bc47e82617",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "e0953f81-9e1c-46c7-a689-630e3767d499",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17a792bc-8b6c-4f60-acfc-43a939ecba81",
      target: "14aea842-8ba1-4827-9295-2495d96c3d79"
    },
    {
      id: "7912bad7-8f7c-454a-aa0f-85eb637ef0d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "8d4ff656-978c-4d1e-a80a-f6ffc86d3b22",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a203770b-2c7b-4121-a8f4-84dd5e8b7563",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "232ff3a4-c245-482e-8f1f-25cb24b92577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a245aa08-11aa-4809-ad44-52e2c2572582",
      target: "4169ba48-50aa-43c0-93f6-c64d4090cbb1"
    },
    {
      id: "6ea31627-6153-49cb-a603-db8e69341ad7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9994c5c0-df16-4a8a-9cf8-1349b4dc3f48",
      target: "4169ba48-50aa-43c0-93f6-c64d4090cbb1"
    },
    {
      id: "9576bc8b-3dac-4558-8c20-b189a6d540b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "951e7f90-d5c3-4bf4-852f-4bce5c0dd488",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "ee6b3a7e-39aa-4568-ac77-614ffab7017e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ebc6d16-4aed-4085-9462-fbd38edacb2b",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "ed01b3e8-9111-404c-8015-6c8b908e1cba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3450f3ae-4523-482a-bd62-921a761ee582",
      target: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864"
    },
    {
      id: "edf4a565-38e7-4163-82e0-e8f722b431cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "919fde6b-6525-430d-974f-fc044576fa3a",
      target: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864"
    },
    {
      id: "512eabdb-775c-4278-ba48-95532b825a49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "412a5e01-9a29-48d8-9544-d974c84e6443",
      target: "eea96588-e7a0-4154-b8e1-8832accf4710"
    },
    {
      id: "c3c66fc7-8ee8-42c3-9d5b-fc6eab7419e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6da0772f-bc9d-4678-a56b-1ee395993af4",
      target: "eea96588-e7a0-4154-b8e1-8832accf4710"
    },
    {
      id: "df8c79cb-1d7b-4d26-b765-be713f770045",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4504c57c-90c8-40fe-bd78-a8ef31b054bf",
      target: "0af04484-5114-40f9-855c-6978bac455d4"
    },
    {
      id: "c3a1cf91-c669-4ae4-8734-87b40ddedce2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7e191ac-ae65-47ee-8772-9b034e366c04",
      target: "0af04484-5114-40f9-855c-6978bac455d4"
    },
    {
      id: "7fe906ec-2865-4713-bd79-215630698549",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66d5fb70-4127-4bd5-acfc-d7e8b903a2f0",
      target: "51d0027b-585e-4c3f-9f2f-0c3910e28559"
    },
    {
      id: "f2a1d53a-1066-4fa1-bcc1-616648d6ba5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b78830d7-dbe7-4fed-add3-f652a8bd3832",
      target: "51d0027b-585e-4c3f-9f2f-0c3910e28559"
    },
    {
      id: "4bf4b81f-a04d-499a-b7f1-455a81a3666f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1455a002-7d07-41c4-85f5-43fec32823fd",
      target: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db"
    },
    {
      id: "94f679e5-130e-497a-acd2-c803b31636b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8a54d36-e2e7-46fe-ac2f-b0ff914573f5",
      target: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb"
    },
    {
      id: "7b6ae1fb-9de8-4c32-a0da-f1b31314d802",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d632449-757e-42d0-af24-30435e124aef",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "08b4437b-c804-4d9e-a915-238a577d2d26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54fa6b99-2ac8-4823-8b12-d16a43354a24",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "d9327627-8c80-4dea-a674-1323ca98c067",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4a4ecc-e5c6-4f03-98fb-ec4afc6885de",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "539892b4-c80f-4dd4-8d59-198316f4eab6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4a4ecc-e5c6-4f03-98fb-ec4afc6885de",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "04c0b20c-18b2-4f70-917b-8fcd9d5e48d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d719932-f0c2-4ea5-903c-c125369ea801",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "24912159-0f8a-491a-bc65-f3504891badc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d719932-f0c2-4ea5-903c-c125369ea801",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "deb52904-e804-46da-9113-d96f6b138ec7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "120c5a87-9675-41d5-91c8-c4c60524fa89",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "eaf416ef-4ce2-4fe6-82d7-55ffa86986a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0baaf4d0-808b-43e7-8c3c-4c3885424656",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "76b6727f-30de-4712-90d8-3a9dcf999726",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae43484f-bbad-4916-9ae4-5630dee3996c",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "a4bbd866-bc79-4c3a-864d-424c9e062350",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3437cc2b-aff8-43b6-8f66-cd47ff78ff5f",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "18a52bea-3e3f-4eaf-b02f-32f90bbb3f73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df40bd6b-351f-433f-8a79-17b222e06f0f",
      target: "03bfed0e-f197-4cdf-878d-46664e57ea65"
    },
    {
      id: "8bb4547d-2b95-4bd5-9720-185d18ebacba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df40bd6b-351f-433f-8a79-17b222e06f0f",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "d9147bda-4d61-442f-b075-0481c74cb909",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03bfed0e-f197-4cdf-878d-46664e57ea65",
      target: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a"
    },
    {
      id: "92857b6b-ee50-4e0c-845c-1128a4625df0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4652728-c076-442a-b3eb-842b636b01aa",
      target: "06356746-ce95-4fc7-820c-cac1a3ae84f3"
    },
    {
      id: "6dc25130-d497-4769-88ee-0b73f99eebba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06356746-ce95-4fc7-820c-cac1a3ae84f3",
      target: "cc151cd6-c099-4849-ad83-f4b5e8927bd7"
    },
    {
      id: "112fd643-e572-471d-93d6-43a6e7d780e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b6d8dd9-daa7-43d0-9d77-c72eb917d112",
      target: "3e847e73-ae72-4d8b-8537-75b619b72bae"
    },
    {
      id: "14bc1604-8f05-4108-839f-bdc19a089267",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7106e614-e14a-4029-bf17-8ea4bd60029d",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "634d13ed-cb13-4788-8450-3352bd616daa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cfc3b80-1927-4703-ad34-75cee8c3478a",
      target: "38c5e814-1788-44d4-9fdf-05ab8e7f4071"
    },
    {
      id: "686a257a-7ea6-4290-b322-8d8e739353be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34e8a7cf-289a-4ab0-8e83-86f5b07f43bf",
      target: "fb6b741c-8b01-40fc-beb9-d34d4c881166"
    },
    {
      id: "dfdd1e5b-e5d0-4295-bc26-2b05d9206b6b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07b674e1-dc2f-4493-bbab-2dba2ae7acc1",
      target: "613dc94f-7422-4013-b010-66a8eb880cad"
    },
    {
      id: "4b462e0e-8f13-4bc6-9b09-6d2ea7581924",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07b674e1-dc2f-4493-bbab-2dba2ae7acc1",
      target: "cf5ac519-aa75-4199-8008-f19b4bda4858"
    },
    {
      id: "8412df01-daa5-4463-92d1-562d7ca4f666",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07b674e1-dc2f-4493-bbab-2dba2ae7acc1",
      target: "5e97ad4e-c7d3-4531-b560-aaab3e9ab2dc"
    },
    {
      id: "f47611f7-db69-4ad6-8e14-6c3c0b830294",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "8cfc3b80-1927-4703-ad34-75cee8c3478a"
    },
    {
      id: "58c32bdb-a0c6-4fb4-9acf-e6a85f2d292b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "34e8a7cf-289a-4ab0-8e83-86f5b07f43bf"
    },
    {
      id: "50f0922a-ed8f-4e37-ba75-502d91c83693",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "15b467cf-8184-4054-92de-ef821903d781"
    },
    {
      id: "f719796f-df58-4634-864f-1018b1c883c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "b6282542-918a-4c3f-a27e-693fef05f4f7"
    },
    {
      id: "10a91415-0e35-48f7-b321-71e9e2193b47",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "663a6bf2-7c97-446f-a6b3-b1ef67612d09"
    },
    {
      id: "91f6a770-a8b4-41b9-b16f-8f1001ef090a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "38c5e814-1788-44d4-9fdf-05ab8e7f4071"
    },
    {
      id: "523d6a73-d655-4e20-804a-0a1dc79daefa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "b13b2083-0b59-41eb-bba0-f29dd1ee78ed"
    },
    {
      id: "a795cc62-edd0-47b7-86b4-7c94254eb01b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d98828-69a0-41c4-8290-b0d122fe4c89",
      target: "e301e0be-f7f8-46c4-8204-68b86cb3e42a"
    },
    {
      id: "f837bb32-3d10-4404-9199-c3081f84fcaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38c5e814-1788-44d4-9fdf-05ab8e7f4071",
      target: "af5a2f2d-8aa9-4766-b06d-2d0e22224763"
    },
    {
      id: "db102fed-da4a-43f3-8a4a-ec7b868fc67e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38c5e814-1788-44d4-9fdf-05ab8e7f4071",
      target: "34e8a7cf-289a-4ab0-8e83-86f5b07f43bf"
    },
    {
      id: "3ea2a899-2a76-427a-ad6d-aad503c07300",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38c5e814-1788-44d4-9fdf-05ab8e7f4071",
      target: "58e550b0-e44c-4727-bc94-a540cd987379"
    },
    {
      id: "7ccbf70f-c366-490e-96a3-4037486ea997",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "38c5e814-1788-44d4-9fdf-05ab8e7f4071",
      target: "34e8a7cf-289a-4ab0-8e83-86f5b07f43bf"
    },
    {
      id: "362874b8-c344-4210-909c-0df412168389",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb6b741c-8b01-40fc-beb9-d34d4c881166",
      target: "07b674e1-dc2f-4493-bbab-2dba2ae7acc1"
    },
    {
      id: "2df2f037-830e-43cf-81fe-21c73417c49d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      target: "9a942442-912b-42ca-85c5-f9c30968403a"
    },
    {
      id: "7ffcec37-88f5-46f1-bc77-12540b5c10fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      target: "af5a2f2d-8aa9-4766-b06d-2d0e22224763"
    },
    {
      id: "55368aab-f262-41cc-9417-aa438e7d1776",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      target: "cd40b2e4-b36e-4d50-98c1-f35461c8e487"
    },
    {
      id: "7be7d16c-f3c9-484d-b7f4-c822e0b2b11b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      target: "386b551f-4b83-41b0-9d6a-30378a005646"
    },
    {
      id: "888ad548-14fa-492b-bd85-94bbf53ca002",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d42932a6-5d03-47f7-93ba-635b6cd09443",
      target: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048"
    },
    {
      id: "4f4de525-d2ec-4067-a0be-5fb07e86a1da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15b467cf-8184-4054-92de-ef821903d781",
      target: "d42932a6-5d03-47f7-93ba-635b6cd09443"
    },
    {
      id: "d73f7cbf-dbe0-4615-92d8-46c8d0465491",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "5faffcb1-e61e-430f-8afa-296ee2caa19f"
    },
    {
      id: "82feae9e-9d7e-4e73-9ce8-d69bd1568f74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "cd40b2e4-b36e-4d50-98c1-f35461c8e487"
    },
    {
      id: "25fd6adf-77e0-4c33-8b97-c6355dbdcf24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "e4cde759-dea4-4e81-9d49-17ef7167c8ed",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "86e9e056-534c-413b-ac1e-8ce36d596426"
    },
    {
      id: "e7601a3c-1c32-4828-8d9a-000fc1d0c71c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4"
    },
    {
      id: "dff3f487-3209-4a16-b387-2c37f0ad2e88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a942442-912b-42ca-85c5-f9c30968403a",
      target: "c9b2af01-e5db-4d67-8a04-0dd7ce2b5931"
    },
    {
      id: "6630cb29-578f-4629-aaf0-8e2e08f75f83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86e9e056-534c-413b-ac1e-8ce36d596426",
      target: "f8af2cb3-ca70-48cd-877f-9742798a870c"
    },
    {
      id: "166b59e4-aeee-48ae-a32d-e2f443e68a13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86e9e056-534c-413b-ac1e-8ce36d596426",
      target: "205b80c6-b398-4930-8845-3912668e20f2"
    },
    {
      id: "3217f325-f539-41de-b385-a69f68a887d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      target: "f0223a95-84b7-4c39-bc82-4c9d39200cdc"
    },
    {
      id: "556316cd-11da-4115-8002-e77ccd497e89",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      target: "b0aa3d04-3297-468f-8b3f-e498740133e6"
    },
    {
      id: "149f3a0e-1a1d-4421-9b09-657b363782e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      target: "cf5ac519-aa75-4199-8008-f19b4bda4858"
    },
    {
      id: "f536b660-a13e-46d0-b234-c28c504514a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      target: "0d71bcdd-f418-4560-800b-2e3eb84b67e4"
    },
    {
      id: "667efa20-cadf-4280-b3a1-09fd6421a34a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd40b2e4-b36e-4d50-98c1-f35461c8e487",
      target: "a3baddd8-0bc6-42e1-acca-417d240e2566"
    },
    {
      id: "f3598972-e72a-490e-8c8c-906129fce077",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      target: "3d3765ed-346a-41cd-a399-766723355166"
    },
    {
      id: "11359d28-fe2b-4a6c-859b-38f858f95b23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      target: "19e016a4-7f92-4635-b54e-fc056c6005c0"
    },
    {
      id: "cc6a9d0d-6657-4f00-9c97-ace4c490a294",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      target: "233c3273-0eeb-4b30-93dd-9cbc3030522d"
    },
    {
      id: "92910619-2fa5-496e-9405-d424881ce16c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      target: "96ef314c-095a-46b0-9995-2e6cc32320f5"
    },
    {
      id: "9863edf9-4249-460f-9a81-8b5dfa27766e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a6bf2-7c97-446f-a6b3-b1ef67612d09",
      target: "848e3428-513c-49fa-a48a-7c59a78ed2a7"
    },
    {
      id: "45ab096f-b52f-48c2-af05-403490abe30d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96ef314c-095a-46b0-9995-2e6cc32320f5",
      target: "95a58614-dcbe-4292-9390-66c5d6745ea8"
    },
    {
      id: "69bdcf32-d534-4a64-98e5-92a36ea9b64f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95a58614-dcbe-4292-9390-66c5d6745ea8",
      target: "d9211a90-3325-4503-946c-da72e8ca4e4d"
    },
    {
      id: "4136a2ef-6a78-429f-8bf2-ade2b6dbdc3a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859",
      target: "f0223a95-84b7-4c39-bc82-4c9d39200cdc"
    },
    {
      id: "6b7c7f08-773a-433e-9469-384eea3f8949",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859",
      target: "cc2bb161-d241-4f1f-9d40-970fc362dfe6"
    },
    {
      id: "522ac36a-435e-4bbd-a9d1-1480e59e8af1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859",
      target: "0d71bcdd-f418-4560-800b-2e3eb84b67e4"
    },
    {
      id: "9649aacd-c695-4ffc-8e73-b4e323c3eff7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859",
      target: "42c5b619-60d6-4fd7-ad05-1e4f760a2b09"
    },
    {
      id: "87c95871-bb23-497a-8729-10d25f5dd478",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc2bb161-d241-4f1f-9d40-970fc362dfe6",
      target: "9402dbca-c712-4e18-a48f-78760f20f09d"
    },
    {
      id: "d4610860-3a55-463a-92ef-db54490136f4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cc2bb161-d241-4f1f-9d40-970fc362dfe6",
      target: "61e00cf8-6338-4aa1-af3d-9ad8f71bda62"
    },
    {
      id: "8465fad3-09cc-4264-a94f-771f5d029349",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61e00cf8-6338-4aa1-af3d-9ad8f71bda62",
      target: "fb7329ef-47ef-4557-85d3-161d3d7e5d03"
    },
    {
      id: "06c3083b-f79d-4068-b099-ed3e802ce748",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb7329ef-47ef-4557-85d3-161d3d7e5d03",
      target: "aecc5220-6f2d-4824-821c-8e8a2a8853c5"
    },
    {
      id: "296852a7-da59-4697-ae40-a384265d2499",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aecc5220-6f2d-4824-821c-8e8a2a8853c5",
      target: "eab7eac6-5d7a-4ffb-baeb-37325bee6282"
    },
    {
      id: "5fe2bb33-5315-435e-915b-91f4259ca4b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab7eac6-5d7a-4ffb-baeb-37325bee6282",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "dab8ddf8-24b6-4c16-b54f-300099106b94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab7eac6-5d7a-4ffb-baeb-37325bee6282",
      target: "50c5be2e-449e-457d-9b68-640fd14e85e6"
    },
    {
      id: "ab7bc6dc-e871-4988-ab42-7d9053a809ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab7eac6-5d7a-4ffb-baeb-37325bee6282",
      target: "f6ef28b7-7dae-4f1c-b7b7-b2efce52a5e1"
    },
    {
      id: "1a627123-270c-47cd-a311-a486f7c55298",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9402dbca-c712-4e18-a48f-78760f20f09d",
      target: "61e00cf8-6338-4aa1-af3d-9ad8f71bda62"
    },
    {
      id: "df6776a5-eea5-4e27-a7d6-531b0e2cc823",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "386b551f-4b83-41b0-9d6a-30378a005646",
      target: "11d2bf3f-bb63-4882-ae84-c4b2c07a10a2"
    },
    {
      id: "e4456d92-9872-48de-ab82-f21b3575b71e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f57bb19-30c4-4859-8ddd-6c8c7fdf0bcc",
      target: "693b2dbb-baab-4268-b094-03777820e3a7"
    },
    {
      id: "db8d0359-9c0d-4114-99be-9c92f99b9b82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f57bb19-30c4-4859-8ddd-6c8c7fdf0bcc",
      target: "f702a418-b705-4108-95d7-f990a80150d2"
    },
    {
      id: "ba7ce21a-9294-43e5-a579-6f32225e8f07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11d2bf3f-bb63-4882-ae84-c4b2c07a10a2",
      target: "02e67765-effe-4ffe-b04e-8b33c670413e"
    },
    {
      id: "b734bdc5-de1f-4694-8c56-d2af514cb2c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "693b2dbb-baab-4268-b094-03777820e3a7",
      target: "f702a418-b705-4108-95d7-f990a80150d2"
    },
    {
      id: "9131cee6-1d8e-4a4e-b71d-7811f91e39d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "693b2dbb-baab-4268-b094-03777820e3a7",
      target: "613dc94f-7422-4013-b010-66a8eb880cad"
    },
    {
      id: "7913f6a4-f955-4175-95fd-7ca362ad8f9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02e67765-effe-4ffe-b04e-8b33c670413e",
      target: "bd5ebfbb-03fb-44fe-9969-ddea623fd20b"
    },
    {
      id: "57013195-532e-4857-a798-981e612d56fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d760eb-ceb2-4cef-8874-73a10fb573be",
      target: "8f57bb19-30c4-4859-8ddd-6c8c7fdf0bcc"
    },
    {
      id: "1c55e8f2-c5ae-4ac5-8ac6-c4551eaacaae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bd3c2d0-d6c0-40c1-a7ce-fbb3b3a7c75f",
      target: "95d760eb-ceb2-4cef-8874-73a10fb573be"
    },
    {
      id: "cb7bccad-cdf8-4e98-b4e4-41ea669757be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd5ebfbb-03fb-44fe-9969-ddea623fd20b",
      target: "2bd3c2d0-d6c0-40c1-a7ce-fbb3b3a7c75f"
    },
    {
      id: "974db7c1-5e87-4459-9981-3603a352f13d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "f702a418-b705-4108-95d7-f990a80150d2"
    },
    {
      id: "2de4ff9d-8bbe-4653-9d62-018c4a6b25b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "f6f3e632-d804-438e-9d65-ae73d274652c"
    },
    {
      id: "ca17d7a8-2803-41d1-9294-3f633577dbe6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d"
    },
    {
      id: "6997e59d-0190-40cf-a4cf-860b4166a4cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "8ebc3021-6377-45a7-ab30-490e7479fc33"
    },
    {
      id: "81f317c6-5ca3-4c33-b001-f1a4548df506",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb"
    },
    {
      id: "84d497b4-cbc6-4c9a-9173-ea1c80e0de8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19e016a4-7f92-4635-b54e-fc056c6005c0",
      target: "43efc24e-a698-412c-84de-03f3c6ef69ea"
    },
    {
      id: "c46366d0-ea10-48b5-93af-36f530baf16c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "848e3428-513c-49fa-a48a-7c59a78ed2a7",
      target: "19e016a4-7f92-4635-b54e-fc056c6005c0"
    },
    {
      id: "663fd252-5131-44a2-b763-153ca097caa4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "848e3428-513c-49fa-a48a-7c59a78ed2a7",
      target: "601b0653-e4c5-4d9a-86f4-2b326b9982bf"
    },
    {
      id: "76897e6d-d2ca-4198-861c-19dc1d1ca13e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "601b0653-e4c5-4d9a-86f4-2b326b9982bf",
      target: "e0cf13c9-4da5-4f95-b4db-626ddfca1c80"
    },
    {
      id: "63eead8d-6a59-446b-a4e3-ca8ff516bd64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0cf13c9-4da5-4f95-b4db-626ddfca1c80",
      target: "3864c229-9f86-445d-a9fe-f45d514e0da6"
    },
    {
      id: "ae691542-a3b1-421c-b65a-7e9345fd633d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3864c229-9f86-445d-a9fe-f45d514e0da6",
      target: "19e016a4-7f92-4635-b54e-fc056c6005c0"
    },
    {
      id: "01c46254-4bdc-4f46-977f-4cb9f559f3cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4aa341db-8696-49c1-b7ee-ce7550c9f986",
      target: "3419d4ab-22c8-42ac-a3d6-260a31398d10"
    },
    {
      id: "4ef9f351-adf0-45bf-90ce-d11a024efa23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aa45c8d-40f5-443e-8ef1-b4feaefb8cb3",
      target: "1b938158-4ae6-49ce-b7ae-c299c79ad4ec"
    },
    {
      id: "0fe9bfe2-c273-4fa7-abc5-4e94becff61e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aa45c8d-40f5-443e-8ef1-b4feaefb8cb3",
      target: "aecc5220-6f2d-4824-821c-8e8a2a8853c5"
    },
    {
      id: "e9254f72-b3c6-4ee4-bdf0-d17ca0e889f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b938158-4ae6-49ce-b7ae-c299c79ad4ec",
      target: "3419d4ab-22c8-42ac-a3d6-260a31398d10"
    },
    {
      id: "25bdef63-200f-4143-a32f-039c0815f4c7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "6c6c12ce-ae44-4684-b8b7-57de04d36237",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "706b3d4a-9a33-4935-aa91-9319b20ca574"
    },
    {
      id: "fb5d6f0a-d3b7-4ac2-abb1-b8750350279c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "16ab030a-f2e1-4942-9f80-3308fb3e455b"
    },
    {
      id: "0dfc6cf9-21f6-4ebd-9f23-8eddd92399b6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "ea08ba20-7583-4401-9c98-3cb689629af6"
    },
    {
      id: "a75f1b0a-a832-4a94-80aa-efc796838140",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "50c5be2e-449e-457d-9b68-640fd14e85e6"
    },
    {
      id: "fde3c7d9-5efe-4aaa-87b1-c3608af16a16",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "6dcec0e1-aa7d-498b-8072-1b3648d75c64"
    },
    {
      id: "a1c777dd-6b80-4eaa-a6c8-f7fab0c821df",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "3cbf9162-237a-4029-b85f-3070f07014f9"
    },
    {
      id: "7711d9da-0e8e-4323-bae2-335274542de3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "b9151945-95b0-43a4-af2f-8451fe63034d"
    },
    {
      id: "220a51c3-00b0-45bd-8807-ff1224ec1a98",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "2e1b9d82-98f1-4e0d-9689-fbb312083e2f"
    },
    {
      id: "e45c4386-acc9-43e2-bb9b-c63c1ac440d5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "31336d61-1270-4455-8fb0-c95cc6c3238a"
    },
    {
      id: "bc99c78c-b99a-4317-b686-4301e7996439",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "137bf508-26c7-4bb5-a9d1-c9e000dd5ed7"
    },
    {
      id: "0eb64a89-e8c3-42b8-bb4d-cb484e352906",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "1c3c98ea-7f40-4806-be6e-1793f944696e"
    },
    {
      id: "fcc05ab2-916c-41fc-be35-29b3cbc6dc33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "039940a4-6a28-4ad4-ba53-495178b98448",
      target: "f0eb30c1-3a09-41e7-a21e-bb9eb2f56859"
    },
    {
      id: "1fa0253a-095e-47e7-893b-b6e82b76b7d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3419d4ab-22c8-42ac-a3d6-260a31398d10",
      target: "f8471d33-1151-45dc-be3d-f2301bda8d0f"
    },
    {
      id: "ccd70ea4-a4a4-4605-9927-e5add9bba453",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "233c3273-0eeb-4b30-93dd-9cbc3030522d",
      target: "039940a4-6a28-4ad4-ba53-495178b98448"
    },
    {
      id: "92275e1e-cf0f-4c53-8340-d8057ffc4e84",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "233c3273-0eeb-4b30-93dd-9cbc3030522d",
      target: "5aa45c8d-40f5-443e-8ef1-b4feaefb8cb3"
    },
    {
      id: "4f56bc69-c086-4524-b0d6-47b62c465f1b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "233c3273-0eeb-4b30-93dd-9cbc3030522d",
      target: "4aa341db-8696-49c1-b7ee-ce7550c9f986"
    },
    {
      id: "49cefed7-c48c-4939-9283-7dfde582d19c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42c5b619-60d6-4fd7-ad05-1e4f760a2b09",
      target: "a03b939d-b372-4e01-abaf-31037c0d6a72"
    },
    {
      id: "de09c616-0648-4397-8d9d-604c8a7ab01e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84b140a9-05cb-4b5d-9cb9-975a0a778979",
      target: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8"
    },
    {
      id: "320e3833-3d93-4110-b5bf-4c26ce5898e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "541ef03e-36b9-412a-b477-6af807fe2299",
      target: "7497b13b-a664-4d1b-9410-4b33f82b39be"
    },
    {
      id: "c7822a5c-59c3-4940-8b4e-79b4ec68e4e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "541ef03e-36b9-412a-b477-6af807fe2299",
      target: "6dcec0e1-aa7d-498b-8072-1b3648d75c64"
    },
    {
      id: "71c27849-9dd6-4abe-a09e-c341c49724c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "541ef03e-36b9-412a-b477-6af807fe2299",
      target: "9f8e46ad-f77b-490f-8882-a45a7e58555b"
    },
    {
      id: "791228b4-afed-4ce1-ac89-32a0195474f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "b218df79-3f16-4f70-ae08-fa91e4e95874"
    },
    {
      id: "1b3f2efe-78e6-4be3-9fd5-e0e78a8e3f59",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "77a5c480-f706-4191-9710-f1fe0e652540"
    },
    {
      id: "c46e891c-9893-4e0d-be6c-7cddc70e05a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "9af2c01d-798a-4b2d-a917-ec1f9981ce73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "61e00cf8-6338-4aa1-af3d-9ad8f71bda62"
    },
    {
      id: "991c895e-a09e-4abc-96e5-6c7b369cd728",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "86f6ad65-38f0-4598-a223-a655c7f555fc"
    },
    {
      id: "08bed9b3-9e90-43fe-b3b7-2903c55447cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "4af56416-33e5-4482-a9d7-8d52e2548a47"
    },
    {
      id: "39ade66d-f321-401c-827e-132b4b787f88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf"
    },
    {
      id: "cc6a58e2-34f1-4e85-9df9-5beaf96f7b34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "18334722-94ca-454d-a407-c2ebe037779e"
    },
    {
      id: "3e44b420-0004-4b54-818c-457c78cdc38b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "4b475fd7-db58-45e4-90cd-9e9e9fb2a75a"
    },
    {
      id: "375d3dc4-4362-4120-8f58-d4511a5cf8f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "b9151945-95b0-43a4-af2f-8451fe63034d"
    },
    {
      id: "d33d1d2b-ca3e-4510-829e-c2407c0ce5f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "6dcec0e1-aa7d-498b-8072-1b3648d75c64"
    },
    {
      id: "99f2d7d2-8a11-49e1-b709-2535c343a559",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "3cbf9162-237a-4029-b85f-3070f07014f9"
    },
    {
      id: "004a0ab4-b72a-4c47-bea3-3c72f474514e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7497b13b-a664-4d1b-9410-4b33f82b39be",
      target: "31336d61-1270-4455-8fb0-c95cc6c3238a"
    },
    {
      id: "dcff1f72-1d2a-4c8d-8ec7-e66bf54ad48e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "e4731137-8d9a-407a-8f4c-9ae38c1b7e5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "19e9a1ee-745d-4bf5-8343-20c6e308ef3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "3acf459e-58c2-463b-80e4-1ba4c76a7591"
    },
    {
      id: "091dfb8a-b3a8-4f45-b34f-2f7e75711180",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "12a69c6a-1b2d-434b-9fb0-ba989e246f2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "1852ba6d-19ab-4ffc-a68f-4f421829900a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "e4261644-2df6-4b39-97e9-fafd922a375d"
    },
    {
      id: "4fbc4bdd-9727-468e-9ede-d262409969d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "5918d1e3-7942-471c-a486-ca63b5fdd98a"
    },
    {
      id: "7b0e498d-fba7-4b3b-932f-0a668302868a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "e396cca1-6af6-48f7-a664-99db5e2f9718"
    },
    {
      id: "3198a45e-f46f-48fb-9a75-63d665bf4f50",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "262557e6-ff10-4ff4-910a-b99f52076f96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "7030df7c-c10e-4202-858a-b46446dbbf55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c"
    },
    {
      id: "d064384c-5d0e-4104-9227-4a6630500836",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "15068838-80cb-4f83-9709-2cc4f7d0d69d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "a897a98f-1542-4d71-8a7e-da8fc7597811"
    },
    {
      id: "e9f5b853-f906-4f55-bd70-c2e85bc8cea4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "0a0d8d0c-9ad6-4ed0-b201-b653e3a2eed3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "bd69ba1a-c240-48ac-b34f-50139c878276",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "1d808105-7e1b-44fe-b4f5-5c739585bf2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3"
    },
    {
      id: "c6fd0307-d874-406e-937b-d67e8af0d7bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "7e6431c5-49e6-41e2-ae80-7d4354152212",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "b4729c30-8a19-4a28-9e85-8e2d24cb36b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "7604e032-0a91-4e56-aef5-66c7d5b377ac"
    },
    {
      id: "27ab5e7d-0fbb-4f65-b705-9ce810739964",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "46219bb1-f994-4392-acd5-8ba98fac6098"
    },
    {
      id: "a7c81135-ca98-46d3-bfd5-d19fa3464740",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "65a406fa-3b1d-4063-ae0b-56a8371486ef"
    },
    {
      id: "53e53328-7e73-40ab-9f57-5b41f33d940d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "360a0f64-3731-4234-a5bd-e0042395de9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "39216312-bbd2-4a27-9719-a23e5e5964e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "a78594e5-a9b5-4c17-bf06-68dc576a595f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "6a323fa0-d757-48fb-829b-699329196d39"
    },
    {
      id: "79a7ed04-be32-4511-a516-562c2b15a791",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "01735b44-2928-416e-8263-a57a4f22304f"
    },
    {
      id: "d599a308-e570-478a-b852-c0e8f71d73a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11"
    },
    {
      id: "743a9677-a19e-464a-934d-10cc38baf240",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "41413ac8-b638-4e92-8e73-e55d270c5161"
    },
    {
      id: "9e665c2f-4f5f-4185-877c-a54e56d9c3f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "9cbbdd64-199f-408c-8053-aa1307d7f655"
    },
    {
      id: "8f4cd41a-13a5-4615-87c4-d085dd889639",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4"
    },
    {
      id: "ac7026c5-8d3f-4b8f-8517-22c3015b47c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2"
    },
    {
      id: "97dcd596-9690-4070-9a55-c846057df76f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "b9555331-371b-44e0-bd83-5a20d9d960f3"
    },
    {
      id: "8f9dc358-9a61-42a4-a336-c5e6f70b16ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "92e7f5e9-dbed-491a-b3c7-90de3e5a52ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "26b1e916-4e42-4b02-91a1-f68c2e4b0a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "e5e846b7-98af-4b33-8188-39970fb0ea03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "e270725a-5572-4448-a9a0-0f676909db3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a03b939d-b372-4e01-abaf-31037c0d6a72",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "fb5fa20e-58fa-474a-8487-12e2054b11a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8",
      target: "b1f5cd91-188c-4c2d-81fc-c55c197aa8ec"
    },
    {
      id: "a9263f0b-bcce-4dec-877c-cc91052689ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8",
      target: "5d3a19c5-d4e1-4a90-96f9-07c0680d96e0"
    },
    {
      id: "1d4d89e8-6505-4199-85bb-a815a1a7a3f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8",
      target: "94fc3b3d-b329-4304-a4c1-8e25349cc515"
    },
    {
      id: "e6348ce8-dda4-4997-8702-ebef5a62c2b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c22f724c-b7e0-48ca-8c2e-aa84ae2085e8",
      target: "c9b2af01-e5db-4d67-8a04-0dd7ce2b5931"
    },
    {
      id: "76a515dc-2e55-4006-8d2c-b4dd9c14d62e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0223a95-84b7-4c39-bc82-4c9d39200cdc",
      target: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4"
    },
    {
      id: "f243985a-1cd9-4188-9dba-60e198d1932c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0223a95-84b7-4c39-bc82-4c9d39200cdc",
      target: "541ef03e-36b9-412a-b477-6af807fe2299"
    },
    {
      id: "ee40a80e-af3d-46e1-9fd6-f6e4e9583ea8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0d71bcdd-f418-4560-800b-2e3eb84b67e4",
      target: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4"
    },
    {
      id: "3879c781-ee91-481e-8323-3811a5f44fc4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0d71bcdd-f418-4560-800b-2e3eb84b67e4",
      target: "42c5b619-60d6-4fd7-ad05-1e4f760a2b09"
    },
    {
      id: "78a4ec0c-e3f9-40d2-9d95-04114a92ed3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d71bcdd-f418-4560-800b-2e3eb84b67e4",
      target: "94fc3b3d-b329-4304-a4c1-8e25349cc515"
    },
    {
      id: "48303d47-8c99-42d4-9e53-a31ac09669d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d71bcdd-f418-4560-800b-2e3eb84b67e4",
      target: "84b140a9-05cb-4b5d-9cb9-975a0a778979"
    },
    {
      id: "a27f48b4-8e1f-4efc-98b9-ce6a0ec7ecab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4",
      target: "f8471d33-1151-45dc-be3d-f2301bda8d0f"
    },
    {
      id: "b4df139f-73e1-4b15-b08f-8ba3619a7d75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74cb3fbe-9f24-4ec6-81ae-99beb75afad4",
      target: "94a589a4-3f06-48fb-ace8-894ccfe9e065"
    },
    {
      id: "38fae07c-8bda-417c-9f25-8cdd82a44c12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94a589a4-3f06-48fb-ace8-894ccfe9e065",
      target: "f8471d33-1151-45dc-be3d-f2301bda8d0f"
    },
    {
      id: "0b3590c9-2e93-4aa4-a846-74d09b4b2ff0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8471d33-1151-45dc-be3d-f2301bda8d0f",
      target: "9667b0ae-161a-4f45-b91a-9fc49e2519d4"
    },
    {
      id: "5cc2c5a8-3ada-4ab9-a2c9-f06e2b60624b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8471d33-1151-45dc-be3d-f2301bda8d0f",
      target: "5f2daa78-32dc-49a6-9769-7506968e9153"
    },
    {
      id: "b8114f52-7296-4c1a-bf51-ab0d426f014a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8471d33-1151-45dc-be3d-f2301bda8d0f",
      target: "50c5be2e-449e-457d-9b68-640fd14e85e6"
    },
    {
      id: "bf1bc1eb-4d24-4248-a65f-24af37b59364",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      target: "ce501ad6-8819-4631-8e22-62a6c06635fd"
    },
    {
      id: "ee8fe5ca-3997-4679-a216-0fc616fa8eb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      target: "85be915e-6c45-4a63-abd8-3b7e221ece7e"
    },
    {
      id: "7b9d47f6-52ff-4ae6-a2d4-dcf8d5b944c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      target: "7505477b-8430-4fb0-ba49-79fe375fdb8e"
    },
    {
      id: "783a0a2a-758f-4cf6-8d85-cc0ea006d4e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      target: "eef8ced1-edc5-410d-9fd7-d16105b984aa"
    },
    {
      id: "51cdea82-3278-410e-8e5e-0438cb4477a8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "94fc3b3d-b329-4304-a4c1-8e25349cc515",
      target: "85be915e-6c45-4a63-abd8-3b7e221ece7e"
    },
    {
      id: "f36d80aa-26ee-464b-8c4b-a4ed963ec56b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5faffcb1-e61e-430f-8afa-296ee2caa19f",
      target: "94fc3b3d-b329-4304-a4c1-8e25349cc515"
    },
    {
      id: "5630ae6f-378c-431f-a068-8f459eb8091c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f98335f-473f-4e93-bfb4-27a152f494b8",
      target: "57124ac6-576b-4cfa-a44f-7992a1a97af9"
    },
    {
      id: "35648d97-2709-4292-aa3e-c03821ed84e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7505477b-8430-4fb0-ba49-79fe375fdb8e",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "83a01728-df30-4c1c-91ca-91adc0a7a816",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7505477b-8430-4fb0-ba49-79fe375fdb8e",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "1d9c294b-ee2f-43fd-b1aa-3d4467e01109",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7505477b-8430-4fb0-ba49-79fe375fdb8e",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "6bad1fa5-9d37-4d86-a17d-a18e9e91c11a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7505477b-8430-4fb0-ba49-79fe375fdb8e",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "341d8312-6ead-4724-a118-1d7cdf6e9c25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d3a19c5-d4e1-4a90-96f9-07c0680d96e0",
      target: "43c532d0-be4c-496e-86c4-0eea88b87e23"
    },
    {
      id: "b452690b-b74e-48f0-b0a6-1c2b535fac73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d3a19c5-d4e1-4a90-96f9-07c0680d96e0",
      target: "77a5c480-f706-4191-9710-f1fe0e652540"
    },
    {
      id: "b3261256-b6b4-4f59-9d47-e2582910388c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d3a19c5-d4e1-4a90-96f9-07c0680d96e0",
      target: "6bc47b33-9a30-4ab4-889d-25c5d9617ffd"
    },
    {
      id: "9148a718-6f73-453a-a936-72fa76464b35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "dbc30aa6-5af1-409d-8fc1-76346f414b5a"
    },
    {
      id: "3bd30815-b067-41ed-bb23-d138ae6ffd28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "5e97ad4e-c7d3-4531-b560-aaab3e9ab2dc"
    },
    {
      id: "42345082-2c52-46a2-9432-851aea1525ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "513bc86e-3cea-4a8d-bc8f-f44ae9c64a3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "2d6d9e7d-7442-49ba-983b-be39be3955c1"
    },
    {
      id: "d5770959-7fed-4830-af03-e55652a37ace",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "6e8dd9e7-9304-4294-a080-e8a803cfa7bd"
    },
    {
      id: "2069b9aa-4cd7-4e59-be61-08a5641ebfeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "c92f31db-1e6f-407d-996a-6222d2c1ca07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "e203349b-5694-4987-aeee-c66b31fdc95b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "e43430bc-b825-46be-abac-c6e6f8aca722",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "33ca806d-5fe3-45c6-b210-6d3ad097bbba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3"
    },
    {
      id: "ce104459-60a1-4245-932a-481e4a284c60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "e9d6c09c-f088-4661-bfc9-4bef458989b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "30b73bf2-89f6-4146-8baf-0c9e184eb3f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "2f39c398-464f-4f08-a802-85da1f9e7afd"
    },
    {
      id: "79674f01-fe0c-4936-8718-0f9dfe038060",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "f507d4d6-99a0-4e15-81d1-9623b1359a44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "22b989cf-85fd-429a-9e42-130c8689b5f9"
    },
    {
      id: "52d8d777-30c9-402b-bde1-1d759a16808b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "8c25b97c-ec26-4977-8561-318e0761793f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "b6994582-2a69-4167-ac19-bc1202ca6da0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "e5100ca6-99f0-4040-94c6-02d6fb3d3062",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "c7e36ba0-1328-4932-b768-f0c1d7d5a392"
    },
    {
      id: "efa208e7-0535-484f-816a-0cf14f60f494",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "9df1507b-8921-42e3-b144-cf7e9024176f"
    },
    {
      id: "1532860c-15fa-42e1-919a-009ee086d629",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e"
    },
    {
      id: "640247e0-c2c1-4900-ae40-c1fb393dbeb5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "569a4d4a-80ed-41d4-8604-6b4f10568023",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "dea85ad2-5bd3-4cbb-bb8f-9dd5da0308b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "e92f0065-7283-4b6c-bc02-41bff1b1e7fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ecca2ad-412b-4657-a1ea-a21befefd009",
      target: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e"
    },
    {
      id: "82466481-03e9-4b27-9528-9cf6d20db515",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77a5c480-f706-4191-9710-f1fe0e652540",
      target: "43c532d0-be4c-496e-86c4-0eea88b87e23"
    },
    {
      id: "b65a5dc9-ad88-4a65-9cdc-ec48e083f9c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "9c54de4e-b35c-4127-9489-c910ca13b49a"
    },
    {
      id: "e2cfa1af-bf61-4c1a-8568-9db6b6c3443d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "2d6d9e7d-7442-49ba-983b-be39be3955c1"
    },
    {
      id: "d3c4624a-51d1-43aa-9e9f-27ddd80cbb57",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "4af56416-33e5-4482-a9d7-8d52e2548a47"
    },
    {
      id: "6907f2a2-89f6-46cb-87a2-478acb8820ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "037af818-1879-4797-b5b4-af214e6447f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "416e56f1-651a-42f2-b5e9-a5dc39061a55"
    },
    {
      id: "daa388f1-ae41-4d7e-8670-3440a5857341",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "0209fb85-ff98-4f79-a21f-06f63eeaee9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28dc52fb-1a39-4cc2-91bc-f365281cd27d",
      target: "22b989cf-85fd-429a-9e42-130c8689b5f9"
    },
    {
      id: "225f689d-2dfd-42db-8e54-57d1252fb92a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bc47b33-9a30-4ab4-889d-25c5d9617ffd",
      target: "1ecca2ad-412b-4657-a1ea-a21befefd009"
    },
    {
      id: "e31bdb9b-a81a-4cbe-9105-1c75c7571388",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bc47b33-9a30-4ab4-889d-25c5d9617ffd",
      target: "bc691861-ddda-49cc-b3b2-8465bc2cda65"
    },
    {
      id: "b57f69cb-fa36-4fa3-a6de-188549d1a7fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43c532d0-be4c-496e-86c4-0eea88b87e23",
      target: "28dc52fb-1a39-4cc2-91bc-f365281cd27d"
    },
    {
      id: "f1e63a4d-6038-48cd-913c-31d6eb5f5f41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43c532d0-be4c-496e-86c4-0eea88b87e23",
      target: "b3dab331-6be3-4bcf-b102-be811f56d448"
    },
    {
      id: "2ce9726c-c53f-4426-a02f-fe5a0d6c8b4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3dab331-6be3-4bcf-b102-be811f56d448",
      target: "f15bc28a-8da0-40d2-9a52-1bcc0bd07f25"
    },
    {
      id: "21abf9c7-f92c-4c29-bee4-1ed61d6bf7ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3dab331-6be3-4bcf-b102-be811f56d448",
      target: "28dc52fb-1a39-4cc2-91bc-f365281cd27d"
    },
    {
      id: "e608248c-e686-4a23-8be2-6f5e1f2f8a01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc691861-ddda-49cc-b3b2-8465bc2cda65",
      target: "61807e5c-16ed-443c-81dd-a36d98ef965d"
    },
    {
      id: "9da8ba2f-d986-4282-8617-70de00b6fe38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc691861-ddda-49cc-b3b2-8465bc2cda65",
      target: "2d33af29-1e4e-4310-ac3d-148b228c2e32"
    },
    {
      id: "e8968651-d64c-4980-8d94-60a3075f60ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f15bc28a-8da0-40d2-9a52-1bcc0bd07f25",
      target: "28dc52fb-1a39-4cc2-91bc-f365281cd27d"
    },
    {
      id: "4131586f-6117-4bc7-90ba-a3ad5199c87d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7e36ba0-1328-4932-b768-f0c1d7d5a392",
      target: "28dc52fb-1a39-4cc2-91bc-f365281cd27d"
    },
    {
      id: "1394bcfa-6a62-440f-9442-edb6ec01add6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d7ca0ff-8728-4549-a794-7df6b6f64831",
      target: "96e07be6-cc4d-47cd-893b-f60ca27681a9"
    },
    {
      id: "b75d91f6-5f5a-4cb4-b787-77f44a991c86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d7ca0ff-8728-4549-a794-7df6b6f64831",
      target: "7cb59f9d-8f86-496c-b1fd-66c61618c5ba"
    },
    {
      id: "6533b778-6f4e-42a9-ac61-2284e93663da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d7ca0ff-8728-4549-a794-7df6b6f64831",
      target: "84633258-1f64-4ccd-b0be-ee203c3d667b"
    },
    {
      id: "873bde4f-6d9a-41db-934c-8d1b99603d0c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9fca328-f40c-430e-84ec-e9bf11c50e4b",
      target: "9de991ae-24d3-47ac-a668-a61e204b073d"
    },
    {
      id: "940c9c95-6603-4a4e-9368-5580e27f9677",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9fca328-f40c-430e-84ec-e9bf11c50e4b",
      target: "dbe8d274-563a-4d1d-9983-5627f06750f1"
    },
    {
      id: "af9a11ac-eb26-43ae-9440-d1807b7004ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b295964-9c52-42b3-ab5a-00183b6e9718",
      target: "dbe8d274-563a-4d1d-9983-5627f06750f1"
    },
    {
      id: "33d0c7ac-47ad-44ba-8cd6-49ba6314de26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae84b1f4-1253-4a87-a5d7-dc7ee0651f5d",
      target: "44f5801c-e795-4119-bc54-671db47310a9"
    },
    {
      id: "b632943a-47d6-4e1a-822d-745a9ff11d43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d3765ed-346a-41cd-a399-766723355166",
      target: "b4cd0bf7-ef1f-4b1c-bb41-7bbf2236a0eb"
    },
    {
      id: "bb7bdb5d-c4d7-4c25-a21f-4d06e4112f40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d3765ed-346a-41cd-a399-766723355166",
      target: "15bf5924-7210-4d33-8718-d532eb1a3391"
    },
    {
      id: "c87af23b-7812-49da-89c7-4ad6b5b2898a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d011268-7774-4b6a-b9a8-9169aac4cae9",
      target: "70f4f801-9915-40aa-91dd-350a6969896a"
    },
    {
      id: "4b9dcf07-cdcd-4ee8-a597-e7f8ffa2ce7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0aa3d04-3297-468f-8b3f-e498740133e6",
      target: "cc25be2e-f6bf-4e5a-ba18-f5d4b52eb915"
    },
    {
      id: "9c4e320b-233e-410d-918e-6f136dc4c876",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3baddd8-0bc6-42e1-acca-417d240e2566",
      target: "4854c79e-fba1-46ab-a511-c2f507e4d857"
    },
    {
      id: "edfae5fc-8003-4cfd-9d76-20c33004ca00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70f4f801-9915-40aa-91dd-350a6969896a",
      target: "3d7ca0ff-8728-4549-a794-7df6b6f64831"
    },
    {
      id: "87c09501-b7ca-4ad1-9b09-1430f0379570",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96e07be6-cc4d-47cd-893b-f60ca27681a9",
      target: "a17835af-b4e9-486c-af75-f0c698a39e95"
    },
    {
      id: "ba0c18fe-d0b2-4f77-a82e-94a75b585afe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4758960-1dea-44d4-9ccb-dc85579a17d5",
      target: "462ddc26-190b-413c-914d-f0b00888cacf"
    },
    {
      id: "571036d7-68e3-4bb1-a6e2-4974695197be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77705ceb-71cf-4f20-9645-5a679e192572",
      target: "767055b9-cb21-448e-8317-9d4632426ca8"
    },
    {
      id: "bac54054-6bc8-4d7b-8e52-ab209d98e867",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "77705ceb-71cf-4f20-9645-5a679e192572",
      target: "c4758960-1dea-44d4-9ccb-dc85579a17d5"
    },
    {
      id: "6a570741-a4bb-4da4-ae8d-c928f366e285",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc25be2e-f6bf-4e5a-ba18-f5d4b52eb915",
      target: "e9fca328-f40c-430e-84ec-e9bf11c50e4b"
    },
    {
      id: "54505836-0681-4ee1-a321-006e6e63ee30",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cc25be2e-f6bf-4e5a-ba18-f5d4b52eb915",
      target: "06c1743d-99a6-4841-b51f-07237624fb2f"
    },
    {
      id: "16dfd1d1-3694-490a-8c0a-240c7fffc4b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4854c79e-fba1-46ab-a511-c2f507e4d857",
      target: "5b295964-9c52-42b3-ab5a-00183b6e9718"
    },
    {
      id: "f8853d2e-5a18-4e0a-8008-7bf4a1f251a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "462ddc26-190b-413c-914d-f0b00888cacf",
      target: "e90f6b94-ae46-46e1-8c31-defcb429d86c"
    },
    {
      id: "76672ca5-cb1f-4580-bdf2-28a090f18708",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "767055b9-cb21-448e-8317-9d4632426ca8",
      target: "ae84b1f4-1253-4a87-a5d7-dc7ee0651f5d"
    },
    {
      id: "3390f74d-b6ad-4b3c-b6cb-8dee4b4e1a6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      target: "c30f91bc-ed7f-4254-bee4-7401d4256a49"
    },
    {
      id: "b0a739d8-0a23-42ab-b505-bb2bae97aba6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      target: "b64659e1-a503-4bab-9060-d4f771358b60"
    },
    {
      id: "d13733ff-310f-4ac0-8895-e63192f3b942",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      target: "57124ac6-576b-4cfa-a44f-7992a1a97af9"
    },
    {
      id: "0ac5a1ab-e044-4362-aa62-53071b1c3db3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      target: "18d2bd45-b771-4e21-b7d8-c277fd1f9140"
    },
    {
      id: "05ad0ddc-be41-40c2-ab40-6ba6ab851911",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90f6b94-ae46-46e1-8c31-defcb429d86c",
      target: "1ce30bc0-7d53-48be-9647-92258bdb2f95"
    },
    {
      id: "46aa5a5d-9771-4089-a237-3969e53ea3d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4cd0bf7-ef1f-4b1c-bb41-7bbf2236a0eb",
      target: "28038e7c-fa7e-49a7-aafe-f1daa8bef830"
    },
    {
      id: "58caddae-e9a4-4533-babb-f1c86a999ac6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28038e7c-fa7e-49a7-aafe-f1daa8bef830",
      target: "0d011268-7774-4b6a-b9a8-9169aac4cae9"
    },
    {
      id: "f19a2457-b545-4e1d-8df8-6223b6fc1762",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28038e7c-fa7e-49a7-aafe-f1daa8bef830",
      target: "77705ceb-71cf-4f20-9645-5a679e192572"
    },
    {
      id: "ff2d6df4-20c2-4025-8b3e-4165696449c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28038e7c-fa7e-49a7-aafe-f1daa8bef830",
      target: "b0aa3d04-3297-468f-8b3f-e498740133e6"
    },
    {
      id: "17bbc713-7ffe-4958-a583-c1f7a5aa2f44",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28038e7c-fa7e-49a7-aafe-f1daa8bef830",
      target: "a3baddd8-0bc6-42e1-acca-417d240e2566"
    },
    {
      id: "8071a18a-fcb5-4483-83c6-ebfcfeb0a33f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "77705ceb-71cf-4f20-9645-5a679e192572"
    },
    {
      id: "2821a726-923f-4050-bdb1-fdd7e8dd004e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "28038e7c-fa7e-49a7-aafe-f1daa8bef830"
    },
    {
      id: "674288a1-70ea-4fe3-9663-b96626e8a9d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "a3baddd8-0bc6-42e1-acca-417d240e2566"
    },
    {
      id: "a0f94c83-fa16-44c5-ab95-995cb7711b7b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "b0aa3d04-3297-468f-8b3f-e498740133e6"
    },
    {
      id: "46958490-fccd-41f6-af52-73c1b7cb4496",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "0d011268-7774-4b6a-b9a8-9169aac4cae9"
    },
    {
      id: "d944f715-bcf1-4496-bd5a-b9d49dc69bce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af5a2f2d-8aa9-4766-b06d-2d0e22224763",
      target: "77ce9181-4a70-45b7-8927-e620b83303e1"
    },
    {
      id: "3d4c4c1e-c989-4521-90be-5170ddeac9ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77ce9181-4a70-45b7-8927-e620b83303e1",
      target: "50336325-26fe-40fb-ad49-08be680ced7c"
    },
    {
      id: "49f694c4-146a-46ef-b32d-8f2d4eeae9a7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "77ce9181-4a70-45b7-8927-e620b83303e1",
      target: "7a19d69f-582d-434a-9bcc-991b60df4cad"
    },
    {
      id: "cea2929e-40b1-4510-a0e4-fceb823c1c66",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7a19d69f-582d-434a-9bcc-991b60df4cad",
      target: "8cd3fc62-29df-45e6-9efe-39efd384699e"
    },
    {
      id: "3dfa28b2-50a8-4494-89e6-ae03ea26b969",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a19d69f-582d-434a-9bcc-991b60df4cad",
      target: "c00b4971-b0e2-49cb-adec-4c05cbe9e25a"
    },
    {
      id: "32342860-2732-4c8c-8879-9a08f9715e16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cd3fc62-29df-45e6-9efe-39efd384699e",
      target: "50336325-26fe-40fb-ad49-08be680ced7c"
    },
    {
      id: "f85bbcce-a426-4c8d-947b-885c0e2cad0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cd3fc62-29df-45e6-9efe-39efd384699e",
      target: "bd67df7a-75d1-4b28-8baf-8b3949ea42f1"
    },
    {
      id: "88145c54-3c73-40c0-b3d5-3dd616eb2806",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cd3fc62-29df-45e6-9efe-39efd384699e",
      target: "89fc80ab-e240-4ccd-b7af-e5cfebb0fb20"
    },
    {
      id: "97fb0a9f-1de7-41b5-869c-9120692bc5b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15bf5924-7210-4d33-8718-d532eb1a3391",
      target: "28038e7c-fa7e-49a7-aafe-f1daa8bef830"
    },
    {
      id: "8cd17ba3-7343-43ec-b765-0724b276c80a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c00b4971-b0e2-49cb-adec-4c05cbe9e25a",
      target: "8fd5e04f-22cb-4bce-aa4f-3e48975b0c35"
    },
    {
      id: "99922f3b-41cd-4caf-b7ef-ce56a09cabff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd67df7a-75d1-4b28-8baf-8b3949ea42f1",
      target: "d61c7d94-473f-4af5-8073-5e188677495f"
    },
    {
      id: "c9d621d4-b757-48ff-9898-5233005563e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89fc80ab-e240-4ccd-b7af-e5cfebb0fb20",
      target: "8142724a-3f36-4387-856c-5932970c5e44"
    },
    {
      id: "fe14ac96-3e83-4385-bfbe-53b97a7130ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50336325-26fe-40fb-ad49-08be680ced7c",
      target: "310c278e-7f3e-4566-9963-c49005dfbb9a"
    },
    {
      id: "a0dcb9a7-df2c-41f0-8cee-deb6899f7e8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d61c7d94-473f-4af5-8073-5e188677495f",
      target: "8fd5e04f-22cb-4bce-aa4f-3e48975b0c35"
    },
    {
      id: "66314100-6164-4638-b838-073fb4cd5a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8142724a-3f36-4387-856c-5932970c5e44",
      target: "22531de7-5fc4-47f3-a4d9-e2b243dd998e"
    },
    {
      id: "f761f8e9-1ee7-4ae5-b73d-af7ca87e3f82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fd5e04f-22cb-4bce-aa4f-3e48975b0c35",
      target: "ae84b1f4-1253-4a87-a5d7-dc7ee0651f5d"
    },
    {
      id: "2344a1ba-3b83-43aa-bd05-9e293d6f3a1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310c278e-7f3e-4566-9963-c49005dfbb9a",
      target: "974d8c78-61e4-414b-9243-d66ed8d9f99a"
    },
    {
      id: "9808347f-0005-4cb4-9269-80245120d49c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "16ab030a-f2e1-4942-9f80-3308fb3e455b",
      target: "b686b55d-fde0-4841-b50f-cd89274c44d0"
    },
    {
      id: "35cf7766-0a83-420f-9959-31fb7409e5f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b686b55d-fde0-4841-b50f-cd89274c44d0",
      target: "3d7ca0ff-8728-4549-a794-7df6b6f64831"
    },
    {
      id: "63fc052c-caa7-49c0-a484-187503f9d776",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c3c98ea-7f40-4806-be6e-1793f944696e",
      target: "ff7c9138-a070-4e40-b1e8-30f760d71e98"
    },
    {
      id: "f183d7e0-4727-422d-9bb7-c60ae4cfa7de",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b9151945-95b0-43a4-af2f-8451fe63034d",
      target: "cd92d0b6-4904-42c8-8228-d54b2be2dac5"
    },
    {
      id: "bc2e107d-a758-4be7-a5fa-ab91e02a708a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9151945-95b0-43a4-af2f-8451fe63034d",
      target: "edea1c7a-1f89-470d-8315-4b4954e2b629"
    },
    {
      id: "e9b4b41a-4e93-41a2-819d-c8dde3c454f7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "137bf508-26c7-4bb5-a9d1-c9e000dd5ed7",
      target: "0c7e5e14-dffa-4b51-8e9c-ff1680651120"
    },
    {
      id: "d3a4c3f2-7823-47f3-a468-f16fb56e494b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "137bf508-26c7-4bb5-a9d1-c9e000dd5ed7",
      target: "069b2df1-e414-4c96-af60-fab5221313c3"
    },
    {
      id: "b1ee8659-e9f0-4c26-bde7-517caf57476c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "706b3d4a-9a33-4935-aa91-9319b20ca574",
      target: "d96c812f-f447-46a1-b0dc-d6eeeead6d58"
    },
    {
      id: "a7978276-7cc2-44bd-8c89-fee884584ce8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e1b9d82-98f1-4e0d-9689-fbb312083e2f",
      target: "9e1619a8-1257-4158-827c-4cd9510b5544"
    },
    {
      id: "d8b92fd5-3c49-4a1c-b729-300098b3e601",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6dcec0e1-aa7d-498b-8072-1b3648d75c64",
      target: "1523c30c-a070-48b9-8d6a-445fb0af575f"
    },
    {
      id: "cbff118c-db23-4f37-8fab-86d56326ab5e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3cbf9162-237a-4029-b85f-3070f07014f9",
      target: "d1758336-6ece-48e5-b7a7-3c154d0e13a4"
    },
    {
      id: "9777c1e6-41a2-46bc-9408-bf894ce117df",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3cbf9162-237a-4029-b85f-3070f07014f9",
      target: "d1758336-6ece-48e5-b7a7-3c154d0e13a4"
    },
    {
      id: "274b3b3c-e1b5-48cc-a083-c976bc7968c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50c5be2e-449e-457d-9b68-640fd14e85e6",
      target: "47e6d2e4-246a-4d1f-91d0-7d43697af2ff"
    },
    {
      id: "110f584c-4abf-4788-9b0c-aacaddf966a8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ea08ba20-7583-4401-9c98-3cb689629af6",
      target: "00243349-58fe-44d5-baf0-3429b86b9264"
    },
    {
      id: "38d05dac-3d45-4d74-8081-5c45570f1e38",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ea08ba20-7583-4401-9c98-3cb689629af6",
      target: "00243349-58fe-44d5-baf0-3429b86b9264"
    },
    {
      id: "0c7e3507-35c9-4f0a-82bd-09f52b2b16ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31336d61-1270-4455-8fb0-c95cc6c3238a",
      target: "335e140f-6b2d-404a-aaf5-dfffc86af201"
    },
    {
      id: "a18f92a9-fe2e-4876-8f7e-193831677691",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff7c9138-a070-4e40-b1e8-30f760d71e98",
      target: "7f296027-5418-4f4a-a3e6-c4004bcb7ec8"
    },
    {
      id: "d6147648-2e22-4a05-aca8-0ae314422522",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff7c9138-a070-4e40-b1e8-30f760d71e98",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "052eea4d-a009-4ff3-9428-fd2e52ba94bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edea1c7a-1f89-470d-8315-4b4954e2b629",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "c8b1b3e5-7d37-4686-9c2f-4f9c35f5c386",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c7e5e14-dffa-4b51-8e9c-ff1680651120",
      target: "069b2df1-e414-4c96-af60-fab5221313c3"
    },
    {
      id: "3f6a1294-93e9-4ae1-86fd-b0d0da862a23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c7e5e14-dffa-4b51-8e9c-ff1680651120",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "df39c2e0-6521-4ff9-812c-f4f063e7b2e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d96c812f-f447-46a1-b0dc-d6eeeead6d58",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "c96fbe92-1fc5-46a9-8445-884981cc937a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d96c812f-f447-46a1-b0dc-d6eeeead6d58",
      target: "c8f191f4-88f6-4838-af1b-a1b8ef64b5ad"
    },
    {
      id: "7011fe9e-8595-4378-b3f4-98304976c5b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e1619a8-1257-4158-827c-4cd9510b5544",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "74a4a19b-ce4f-424a-93d7-33339e2aa04d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1523c30c-a070-48b9-8d6a-445fb0af575f",
      target: "aa4b40eb-3ac8-4136-abe1-fe2f5baa0710"
    },
    {
      id: "a437febf-48e0-4e22-b190-05695f9a2020",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1758336-6ece-48e5-b7a7-3c154d0e13a4",
      target: "009342b9-d9d4-41b9-85b8-9ff8339a0d2e"
    },
    {
      id: "be9c035d-5a6b-4bd7-87e7-e8abcf95f18d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1758336-6ece-48e5-b7a7-3c154d0e13a4",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "cacc8232-33fe-47d0-86e2-1c096d96e2a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e6d2e4-246a-4d1f-91d0-7d43697af2ff",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "bd680a65-aaa8-4f01-adb8-d05ff8278a1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00243349-58fe-44d5-baf0-3429b86b9264",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "96611209-ffec-4557-9a70-f8d51955eee5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "335e140f-6b2d-404a-aaf5-dfffc86af201",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "a7209d0d-bad6-450e-ac59-639fc5e3983d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "335e140f-6b2d-404a-aaf5-dfffc86af201",
      target: "fd68c53c-2f7a-4a32-9e46-e555713f2672"
    },
    {
      id: "87ad9ec3-4eb6-4c05-b98f-8124d5104196",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "efd1ac87-0f1e-467d-8235-6dcf813c30d7",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "7e656f95-fba6-41e7-9411-448be4512f1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3",
      target: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3"
    },
    {
      id: "adc84017-5c8a-4352-bd9e-56a97560f2a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3",
      target: "d46b67f4-d029-4ed7-8f9e-297f05cb6533"
    },
    {
      id: "15853f87-ed1c-4f4c-b45d-3b25ec590dab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "79643575-6f44-470c-adda-4678da8d9606",
      target: "a49a7bd7-344d-4160-87e5-3a9484f1a11f"
    },
    {
      id: "6fd3f271-341c-4577-b3ff-a93a3f08e62c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95f2726c-8591-472b-b721-22bac3f44659",
      target: "a49a7bd7-344d-4160-87e5-3a9484f1a11f"
    },
    {
      id: "8f2535d8-72d6-4cf1-a3d8-928e038eb302",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048",
      target: "f6b53c79-f0d7-4ea6-8f97-5281e73cd801"
    },
    {
      id: "50c4ccdc-dfbe-48da-8daa-46b542354d02",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048",
      target: "b95d4d42-2a69-45ef-bea0-2f690b98fe5b"
    },
    {
      id: "b1cf1251-bd7a-464c-b238-d720e1a001b4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048",
      target: "e6e62278-46d6-47d4-a4a2-12cd38e02a62"
    },
    {
      id: "504cc0a0-4b01-4833-bc18-6f33acced965",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "47c7b2a6-2fa6-46fd-ab48-4a9b4c102048",
      target: "f6b53c79-f0d7-4ea6-8f97-5281e73cd801"
    },
    {
      id: "11106bda-fca1-4582-a381-a14630de9fb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5f31122-188e-4bd1-905b-97f887dd899a",
      target: "37a83c6a-efbd-4c4b-ba78-64f281ea8c1b"
    },
    {
      id: "38d28a62-37f5-46d3-86c9-a0560794f9eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e6e62278-46d6-47d4-a4a2-12cd38e02a62",
      target: "37a83c6a-efbd-4c4b-ba78-64f281ea8c1b"
    },
    {
      id: "04521c0c-3f1d-432c-8941-c6e4f07ab8c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9c2c5a5-2959-4452-ba53-7ec873119de9",
      target: "5da95c87-a4ad-4133-a804-5ca9bce9400a"
    },
    {
      id: "5c878daa-c46d-4a4b-b952-62ce4128d4e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9c2c5a5-2959-4452-ba53-7ec873119de9",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "be2856ce-4e7e-4e72-b9e3-024b97fbeb49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6b53c79-f0d7-4ea6-8f97-5281e73cd801",
      target: "e9c2c5a5-2959-4452-ba53-7ec873119de9"
    },
    {
      id: "7b920510-9bbf-4e14-a4a7-7b72ef27290a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b95d4d42-2a69-45ef-bea0-2f690b98fe5b",
      target: "b5f31122-188e-4bd1-905b-97f887dd899a"
    },
    {
      id: "9b45f3c1-7e02-430f-bc71-f75c8d7b985c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b95d4d42-2a69-45ef-bea0-2f690b98fe5b",
      target: "b5f31122-188e-4bd1-905b-97f887dd899a"
    },
    {
      id: "cc829c4b-779a-4a1c-85cb-68ded289ce2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5da95c87-a4ad-4133-a804-5ca9bce9400a",
      target: "37a83c6a-efbd-4c4b-ba78-64f281ea8c1b"
    },
    {
      id: "c52f3fec-d80c-4e40-a012-297adc52546f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37a83c6a-efbd-4c4b-ba78-64f281ea8c1b",
      target: "a49a7bd7-344d-4160-87e5-3a9484f1a11f"
    },
    {
      id: "03109fa3-c562-42bb-a884-4d485b27a982",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "179e7c68-1cbb-4287-97a9-aec294a036f2",
      target: "82b14cbd-9d0a-4e5f-96ce-e64568b513d3"
    },
    {
      id: "6e4f711a-abb7-46a6-9699-cb481142f6c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3949285-7508-46b2-988c-b4be2deba2d2",
      target: "fc05ec65-4f10-4e7a-b57a-d2330a9fa422"
    },
    {
      id: "9f683cd3-a5d3-4411-9995-aa374d6bee43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "a1343d2f-d312-4ef1-8d19-7ba869df2c32"
    },
    {
      id: "3eff1dad-201d-40c1-9f9b-e326e8b6bd00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "dbb30b0c-e480-49b5-a376-f5e02d1487e9"
    },
    {
      id: "38b3f536-d49f-47f2-9a7f-b1e4d57b0e75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "9cb17e9b-51fa-45d2-9139-54242a98c283"
    },
    {
      id: "9dbd2b22-f3f1-4b1c-9564-084682d5864a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "b7ca906c-6386-415f-9637-8fae1d1c0499"
    },
    {
      id: "73e30aa2-b740-4ff9-afd4-5aa2bbff7c64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "d86958fa-3e33-46e0-8637-01724c1c77a4"
    },
    {
      id: "9a743022-655f-4513-9f4e-4087608cb5f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "5c8bb63a-65b7-42ee-9190-4dbc117768fa"
    },
    {
      id: "7c1c9dd3-2758-4860-98c8-4e3c9d245683",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c"
    },
    {
      id: "a4070942-8a1c-4666-a329-fc431457cb80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "af515cab-25ca-4f40-abbe-b7f3236d4cb4"
    },
    {
      id: "ef144986-e5e8-48a7-9c88-9c0e4f49bbb7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a49a7bd7-344d-4160-87e5-3a9484f1a11f",
      target: "5107ffe2-9507-400d-a111-5a80b49ae5a8"
    },
    {
      id: "99610d1d-e302-4023-93c9-eb389ee5147d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8332424-6c0c-4937-a992-180822cd6b7d",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "09ea9a53-a87a-4e34-a0aa-d810f8fbad20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6462ce83-0e17-48d2-a4e0-418df7976a21",
      target: "205b80c6-b398-4930-8845-3912668e20f2"
    },
    {
      id: "0fcd16c4-cae5-450e-a696-1ab9f24bf4c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a87f141f-b268-41d3-8916-348fe4d59bef",
      target: "179e7c68-1cbb-4287-97a9-aec294a036f2"
    },
    {
      id: "85dbb197-55cf-484e-be8c-b1fc705c7c99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbe8d274-563a-4d1d-9983-5627f06750f1",
      target: "e3949285-7508-46b2-988c-b4be2deba2d2"
    },
    {
      id: "d92dd063-8673-44dc-9de5-36beb6afad00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc05ec65-4f10-4e7a-b57a-d2330a9fa422",
      target: "50c5be2e-449e-457d-9b68-640fd14e85e6"
    },
    {
      id: "f8eaeed8-dfb3-4d85-be9f-07102f0e9ffa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc05ec65-4f10-4e7a-b57a-d2330a9fa422",
      target: "efd1ac87-0f1e-467d-8235-6dcf813c30d7"
    },
    {
      id: "d83307a0-c68d-4b94-947e-72a00ef20354",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc05ec65-4f10-4e7a-b57a-d2330a9fa422",
      target: "a22cfa0d-3463-4508-b367-286054b932df"
    },
    {
      id: "a6166d73-b175-4cb1-b5d1-0c6af4d638b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22cfa0d-3463-4508-b367-286054b932df",
      target: "a49a7bd7-344d-4160-87e5-3a9484f1a11f"
    },
    {
      id: "45929e7b-8555-46e9-be73-4eda8dfd546e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "205b80c6-b398-4930-8845-3912668e20f2",
      target: "35c982bf-8751-44ae-897b-9f7999cf2d24"
    },
    {
      id: "2931750e-daa9-4d84-8072-38e076b5ac07",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "205b80c6-b398-4930-8845-3912668e20f2",
      target: "95f2726c-8591-472b-b721-22bac3f44659"
    },
    {
      id: "511742ce-0dd8-40d9-8788-c57de51f4510",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "205b80c6-b398-4930-8845-3912668e20f2",
      target: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e"
    },
    {
      id: "f3e22c13-6768-4221-8c8f-324cacef4a1e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "205b80c6-b398-4930-8845-3912668e20f2",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "6bfeb23b-1dd2-4724-9abd-aac514cec8a6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "205b80c6-b398-4930-8845-3912668e20f2",
      target: "79643575-6f44-470c-adda-4678da8d9606"
    },
    {
      id: "e3d007d6-a692-4ae3-81fe-9f3b0db288dc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35c982bf-8751-44ae-897b-9f7999cf2d24",
      target: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e"
    },
    {
      id: "de8b7ecb-a6f3-43c4-b987-ee9bc7f01c2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35c982bf-8751-44ae-897b-9f7999cf2d24",
      target: "b8332424-6c0c-4937-a992-180822cd6b7d"
    },
    {
      id: "664b8a15-3c50-4118-b81a-1164ff0562d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8af2cb3-ca70-48cd-877f-9742798a870c",
      target: "1b878e85-d299-47c9-8c74-bb2866221890"
    },
    {
      id: "b37ad666-f7ea-4d3d-a0a8-358f4b99f2f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f8af2cb3-ca70-48cd-877f-9742798a870c",
      target: "6462ce83-0e17-48d2-a4e0-418df7976a21"
    },
    {
      id: "497574eb-da38-46bf-b07e-290055e99044",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b878e85-d299-47c9-8c74-bb2866221890",
      target: "205b80c6-b398-4930-8845-3912668e20f2"
    },
    {
      id: "2e6c764f-74f4-4bd3-9603-717e065d10cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b878e85-d299-47c9-8c74-bb2866221890",
      target: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e"
    },
    {
      id: "c0c81eae-c79c-4845-affd-97aa3ab606a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9b2af01-e5db-4d67-8a04-0dd7ce2b5931",
      target: "01fab29e-b00d-42cd-91af-352e5849e8ec"
    },
    {
      id: "f2376713-a435-42c7-b914-3b3acf3d2385",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1f5cd91-188c-4c2d-81fc-c55c197aa8ec",
      target: "f71baf9f-5d37-4b9d-b671-701063a4441b"
    },
    {
      id: "0573c525-adcf-4ef7-bd9a-af21269b8bb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d16ce363-0361-4faa-92e8-5bb92bbee8e3",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "acb20dc6-03ab-4bbf-bdab-12ad9372088c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e",
      target: "d16ce363-0361-4faa-92e8-5bb92bbee8e3"
    },
    {
      id: "37154bb5-3d3b-4612-8db0-956b723fd702",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e",
      target: "a87f141f-b268-41d3-8916-348fe4d59bef"
    },
    {
      id: "eac3e84e-7733-4b1c-a6f4-047ad67dd721",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f3c80de-3aef-4259-a6f8-74d3dcd7ba6e",
      target: "f702a418-b705-4108-95d7-f990a80150d2"
    },
    {
      id: "abaac13a-96c6-4eed-bd3a-51b2feaf120c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bed6b06-2271-4990-b73d-14b7dba7e392",
      target: "b112c781-3156-4964-9719-87821cfaf32c"
    },
    {
      id: "d9bc7860-3b06-45e3-a1e0-2e46a3730260",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "069b2df1-e414-4c96-af60-fab5221313c3",
      target: "29990eb1-7fdc-4734-8925-643175b0e5bb"
    },
    {
      id: "f0a1132c-71d0-4d18-816e-8f97ae9fd000",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c3858b-fe37-4788-870d-c77b2888f113",
      target: "f6510654-c5de-446e-825d-0d22eaa68e4d"
    },
    {
      id: "f98f2f7c-4534-4993-ab0a-97ee18357d0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa4b40eb-3ac8-4136-abe1-fe2f5baa0710",
      target: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e"
    },
    {
      id: "baf12467-01e0-42b4-94e9-2d6648d72d5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f8e46ad-f77b-490f-8882-a45a7e58555b",
      target: "59122aee-662d-45c0-b416-ae8b84c9d877"
    },
    {
      id: "3c9c7a79-d400-4a4c-8659-5aa94121126b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd92d0b6-4904-42c8-8228-d54b2be2dac5",
      target: "4c96e1c6-48ca-4370-9022-3687df559aee"
    },
    {
      id: "6ef4f156-a3c3-4a16-ab0e-0039f5046d3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59122aee-662d-45c0-b416-ae8b84c9d877",
      target: "32c3858b-fe37-4788-870d-c77b2888f113"
    },
    {
      id: "56f4eaaf-5f9d-4cc1-8bdc-380f32de1b68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c96e1c6-48ca-4370-9022-3687df559aee",
      target: "0bed6b06-2271-4990-b73d-14b7dba7e392"
    },
    {
      id: "b979620b-c4ad-4426-babc-4b9cfbb49b1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f191f4-88f6-4838-af1b-a1b8ef64b5ad",
      target: "e04be7c1-e68b-4a64-95e4-fb9297a4f877"
    },
    {
      id: "d6d20a20-182d-4345-ad6c-0805e711cd5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "af515cab-25ca-4f40-abbe-b7f3236d4cb4"
    },
    {
      id: "c512648c-e589-4293-b9c5-6f52ea2c5565",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "550bdc2c-d04a-4238-905d-dc2fef97e41d"
    },
    {
      id: "d1894dd5-4c25-4462-a8dd-5e2205707877",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "c5380e45-419e-43ca-afde-66329fefc326"
    },
    {
      id: "4683e4b0-e44a-4f73-8f74-d8fd318937da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "9cb17e9b-51fa-45d2-9139-54242a98c283"
    },
    {
      id: "e02b74e4-aec6-4e97-a8a9-434900be6ef4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "85de7da8-34c4-4e4d-80d0-bce6ba58d896"
    },
    {
      id: "b6c70b72-48d5-43c7-8cc8-a0a450b0ce92",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "dbb30b0c-e480-49b5-a376-f5e02d1487e9"
    },
    {
      id: "c08c38a1-d96a-4c6a-b528-186ed8893d53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "5107ffe2-9507-400d-a111-5a80b49ae5a8"
    },
    {
      id: "5712d006-b745-4bd5-8c9f-b4c640d0f3a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "f69b96e0-ef80-41cb-aff2-025ad95a1fdd"
    },
    {
      id: "15377753-5a04-459d-b401-ce64342af515",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d2bd45-b771-4e21-b7d8-c277fd1f9140",
      target: "a75f0222-f046-45cc-bfbb-a63b05868be4"
    },
    {
      id: "33fcea6b-b21a-472c-9c18-e5f89a02eaf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22531de7-5fc4-47f3-a4d9-e2b243dd998e",
      target: "6dd38d3a-408d-4f08-be6b-fc28e0f9e1ed"
    },
    {
      id: "0400e272-a6e7-4c42-9b03-2021316626cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22531de7-5fc4-47f3-a4d9-e2b243dd998e",
      target: "85de7da8-34c4-4e4d-80d0-bce6ba58d896"
    },
    {
      id: "9af9cadd-f9a1-4d46-8d21-c5db21247662",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84633258-1f64-4ccd-b0be-ee203c3d667b",
      target: "1f7905d5-8d35-4ccb-bdac-e4372f7f0b36"
    },
    {
      id: "9fe90b96-d964-4a5f-bffa-f3b21079b473",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb59f9d-8f86-496c-b1fd-66c61618c5ba",
      target: "5a5139c4-6996-4326-916f-82881d96e397"
    },
    {
      id: "581f5e88-b3f5-45b6-ac7c-fe9a27d62245",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7cb59f9d-8f86-496c-b1fd-66c61618c5ba",
      target: "84633258-1f64-4ccd-b0be-ee203c3d667b"
    },
    {
      id: "2c64cab2-3e4e-4d38-a870-d56c1c824e1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb59f9d-8f86-496c-b1fd-66c61618c5ba",
      target: "b8ebe236-9ba3-4511-bc85-922bff4333a8"
    },
    {
      id: "5c5a6ca3-4379-47b5-8aca-168d8ac101cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9de991ae-24d3-47ac-a668-a61e204b073d",
      target: "40a8037f-4f18-432a-aca8-a2338ac84ae5"
    },
    {
      id: "ddb2da57-4bdb-4aaa-9d46-fe5fb501646d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "40a8037f-4f18-432a-aca8-a2338ac84ae5",
      target: "22531de7-5fc4-47f3-a4d9-e2b243dd998e"
    },
    {
      id: "946d697e-5c4b-4020-a04d-62db3f626ae0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44f5801c-e795-4119-bc54-671db47310a9",
      target: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c"
    },
    {
      id: "327a0111-5f52-4d83-9c8b-4b9e971afaf0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44f5801c-e795-4119-bc54-671db47310a9",
      target: "5c8bb63a-65b7-42ee-9190-4dbc117768fa"
    },
    {
      id: "013153e0-dc83-473d-9186-3d2c0452a144",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44f5801c-e795-4119-bc54-671db47310a9",
      target: "d86958fa-3e33-46e0-8637-01724c1c77a4"
    },
    {
      id: "a3816ec7-6aeb-441c-80b4-ef3e075b9f16",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "29990eb1-7fdc-4734-8925-643175b0e5bb",
      target: "9667b0ae-161a-4f45-b91a-9fc49e2519d4"
    },
    {
      id: "f12bb720-584c-4336-82d9-23bfd8668dfe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "29990eb1-7fdc-4734-8925-643175b0e5bb",
      target: "c2c1f8ff-37e0-428a-b88e-16f2b8644ac3"
    },
    {
      id: "ee436bfa-1d6f-455c-87f4-0931f7301361",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "29990eb1-7fdc-4734-8925-643175b0e5bb",
      target: "c2c1f8ff-37e0-428a-b88e-16f2b8644ac3"
    },
    {
      id: "468a0e3f-1d43-4712-b8f9-4a078e963a13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6510654-c5de-446e-825d-0d22eaa68e4d",
      target: "64812c01-ba38-4c2f-a0b1-611253ddf598"
    },
    {
      id: "d879d7e4-b373-4a2f-be0b-47f0fa7aeb8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e",
      target: "22d218cf-dd8d-46ce-99bd-4367f1e20f91"
    },
    {
      id: "51e74977-5632-4f4a-a426-ce1596a334cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e",
      target: "9ff4802e-8a35-4b9b-8540-c1222f41a74a"
    },
    {
      id: "80129975-9ab9-4c65-bd4d-5ee444ced23d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e",
      target: "fd68c53c-2f7a-4a32-9e46-e555713f2672"
    },
    {
      id: "2e329d5e-c845-4aff-9722-4dfe9df91c44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc1da4fe-3bfd-4e81-bc21-fe9f7643194e",
      target: "f9b7b2d8-c045-4c6a-8a67-d66e8dca4696"
    },
    {
      id: "58f9ef88-fc8c-4d0f-9362-42906cfcfc13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b112c781-3156-4964-9719-87821cfaf32c",
      target: "f6ef28b7-7dae-4f1c-b7b7-b2efce52a5e1"
    },
    {
      id: "28b1764d-aafa-4264-9a22-0834e0e34218",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b112c781-3156-4964-9719-87821cfaf32c",
      target: "c670e2d6-6ddc-4069-96cd-5b0f1558589d"
    },
    {
      id: "951d9b9d-f2ed-4e24-85be-e56474ccc3c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "a1343d2f-d312-4ef1-8d19-7ba869df2c32"
    },
    {
      id: "da90e608-8da1-4d82-8355-954bc0aa2c2b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "48e7de91-7fdc-41a7-8391-949673c1794d"
    },
    {
      id: "0719640b-2d74-4d31-bb35-e3e208b073f3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "6df4257d-bbdb-4628-beb1-3a30c578be60"
    },
    {
      id: "0f1b8b56-fdbd-4aec-bfc5-f3ed984e11ec",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "77528530-891c-4277-9023-56b69dc0c903"
    },
    {
      id: "619a8eac-8981-473c-9133-f2ccaf5eda95",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "99158f91-c77d-4c83-ae70-8126f7d2d04c"
    },
    {
      id: "a8d4809f-3e62-44bd-8aa1-1866f4f35d77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fec9e2e1-c2c1-4d64-94b3-2ee4af7fe3b3",
      target: "ff2f7c02-5501-4940-8c2d-062ea542f15a"
    },
    {
      id: "7cd6f98e-2d87-4d64-af45-4691469bc566",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e04be7c1-e68b-4a64-95e4-fb9297a4f877",
      target: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a"
    },
    {
      id: "ad1b0028-1f32-4540-aa61-f81f5beb30fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c670e2d6-6ddc-4069-96cd-5b0f1558589d",
      target: "9991e1e7-1782-42ec-a9ff-27d152c174f2"
    },
    {
      id: "d8b0b9de-d90a-4648-91c3-ad35717d3f89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f296027-5418-4f4a-a3e6-c4004bcb7ec8",
      target: "974d8c78-61e4-414b-9243-d66ed8d9f99a"
    },
    {
      id: "06c3ae2a-06b3-440c-b1e8-b0a8fc841953",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f296027-5418-4f4a-a3e6-c4004bcb7ec8",
      target: "2a3d5c36-0d80-4d90-a31d-ac3e9487c14a"
    },
    {
      id: "e28830bf-de24-4803-ac4d-13f93252030a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d46b67f4-d029-4ed7-8f9e-297f05cb6533",
      target: "d99e4cba-a6ef-4244-a0f1-5cb8ee810452"
    },
    {
      id: "53234296-3409-4b37-856c-40901ea66342",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "974d8c78-61e4-414b-9243-d66ed8d9f99a",
      target: "6df4257d-bbdb-4628-beb1-3a30c578be60"
    },
    {
      id: "b6300e24-0628-4178-848f-7c8cbfb96282",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "974d8c78-61e4-414b-9243-d66ed8d9f99a",
      target: "f69b96e0-ef80-41cb-aff2-025ad95a1fdd"
    },
    {
      id: "a8c84ab3-5ee0-4347-ad9f-7aa0bcfdd470",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "974d8c78-61e4-414b-9243-d66ed8d9f99a",
      target: "a63c40a5-c4c9-4674-bdbd-870ef5fa315c"
    },
    {
      id: "35b41ecf-d4ec-4851-9c26-d82a177e92f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "974d8c78-61e4-414b-9243-d66ed8d9f99a",
      target: "c5380e45-419e-43ca-afde-66329fefc326"
    },
    {
      id: "d96e94eb-03d6-4c29-b7e9-edec4b5cfa8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f7905d5-8d35-4ccb-bdac-e4372f7f0b36",
      target: "a17835af-b4e9-486c-af75-f0c698a39e95"
    },
    {
      id: "e847f70a-8063-4baa-8636-23d390a62902",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cb8e57b-5012-4408-9d7a-73b7cd7bf035",
      target: "6f576b5f-da2a-46d4-a303-305280bc06fa"
    },
    {
      id: "3319922a-44ae-41cb-9ac0-eefdfaa2ed0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "117c33d0-9a54-42ef-a268-d1554953ee74",
      target: "95ca3871-1f26-4053-9a42-b39ea8935a20"
    },
    {
      id: "3477e96f-d005-44fb-89f4-4a99a4505169",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f510e8d1-168c-43c8-8886-0d322957a9b9",
      target: "0d2eb201-1fe4-414c-8927-81b1ca95ba24"
    },
    {
      id: "501b89e2-d377-4231-97f4-5937f99b68bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14796376-b4a8-47d0-a072-4d7d7b938edb",
      target: "2b7905ca-abf2-478a-9e87-57603cb49322"
    },
    {
      id: "c83b08db-f247-424d-9fa9-4ac33bcb3973",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14796376-b4a8-47d0-a072-4d7d7b938edb",
      target: "0643a591-df62-4540-b40c-b55e8255b67c"
    },
    {
      id: "b96ebc8b-5e54-431a-add1-108378294442",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0643a591-df62-4540-b40c-b55e8255b67c",
      target: "e8ae958b-366b-490f-9e68-81df6173416d"
    },
    {
      id: "fff68a94-ea00-4989-9776-1f6c99aca6f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35f4f35d-3c63-4bfb-b18b-41d4cbd20f44",
      target: "1dea4851-b02a-419c-ae58-ee0461e2cc77"
    },
    {
      id: "0d18591d-5015-492b-844e-8b358d4090dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21ca2baa-4a72-4279-b666-bf7a44c49fe5",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "7a0184d1-c03f-47d4-8620-aab492d58844",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94338bcd-7706-43b1-8a41-2c70a99d957b",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "598dca71-77b2-4abb-9e2f-61193615effc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "418bcefe-41e2-4340-8bfb-124265abfc01",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "e6aadddf-cc8f-4d97-a738-6b34b9b64727",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0c7e5cb-1620-46db-83f5-45870ee0c38d",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "6778eef1-c3d7-412e-8da4-7854671b9b75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26bd51be-c0f5-4614-a707-3ab191556c9d",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "1eafd4eb-6ab8-4b98-bf7d-2821688f3881",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e1b37a9-5332-4bc8-a007-68efbc15a930",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "a6717a9e-8c2b-45ad-ad9b-b5e4aa017138",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1165ec92-fbbf-425e-abc5-3aed33f40cc6",
      target: "0c9e523b-158a-4369-9521-45d4209777a3"
    },
    {
      id: "7729576f-41d4-4c7e-a849-c90746c13141",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1165ec92-fbbf-425e-abc5-3aed33f40cc6",
      target: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d"
    },
    {
      id: "874fe621-5551-4300-ae69-0e293310178c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3731537b-2ab3-42f0-a703-4419666bed41",
      target: "abd622c8-97bd-48f6-a36d-9a080507f82d"
    },
    {
      id: "436144c2-aed9-41f5-bf63-c8ac9a27444b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9965be8-1e27-47cb-b954-3f621652ade6",
      target: "aa71d951-ed8c-41b4-9322-401064634cc6"
    },
    {
      id: "33c6b682-9841-4e9d-ac23-8d2054b73cca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5bed361-ca99-4fb0-ac8e-3af5ea0abeeb",
      target: "7cf24f9c-0c7e-499c-8d04-f19c6648404e"
    },
    {
      id: "7290a18d-0550-4add-aca8-993f0a8ef8af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbfb506e-b03c-443e-8ffe-68413a54cb78",
      target: "c249ab2c-cfe1-452a-9c38-a2a761b1553c"
    },
    {
      id: "a8f81714-a010-4123-b66f-d787ab2d6830",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f709d727-7225-4517-9ae4-5d8b8d232ee4",
      target: "e07b437e-c887-4bac-85aa-e0c6b6ca5494"
    },
    {
      id: "bdcfe231-b26e-4666-938b-34830d0c1504",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e624115-3494-433d-9f92-5b99ac80c412",
      target: "22141bd9-5118-4e5e-8e51-b8899985c4cd"
    },
    {
      id: "3942a013-d4af-453e-9356-72a271399ab6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c622157b-ff05-4490-95fa-270ab9f08454",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "e64499be-f270-4275-a525-0e2131d15ab5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce31ca34-c9d8-4fda-8ec5-7c58e7dfe698",
      target: "8511dc97-c3c7-4750-8595-9ff466cf02c9"
    },
    {
      id: "6a9b7399-57d4-44c4-88d3-b7152929544d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e3223c1-8707-427d-8e11-b2295a1bde3c",
      target: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b"
    },
    {
      id: "603d5ede-7d87-47dd-9ca1-1633b3a0d1fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3804e97-b239-4885-a723-fce3b1ec160e",
      target: "4cb4ee67-ae43-423f-b23c-0b9fbec64286"
    },
    {
      id: "72e622fe-fe41-41b3-b93d-debdf888c135",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0ef15aa-ea07-40e9-87b7-c72c0b2482af",
      target: "29d8126e-d41e-44c0-ac74-b21977de94af"
    },
    {
      id: "07d5eb65-04df-4ba0-9c94-d1b20a642c41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac14da03-e164-41ae-987f-f484869d6058",
      target: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea"
    },
    {
      id: "08247a74-691c-41b3-9674-41ab429c7085",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a7e68ff-9098-4858-b959-70c8cad34beb",
      target: "84b2c487-8d68-483b-b6f2-2a89b54fccb9"
    },
    {
      id: "1f82b8d2-1197-4f44-8125-24a02b2a0e4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9717de69-6e06-4c10-806d-cce273f98818",
      target: "eac066a0-891a-4d9e-b0a4-469228a55362"
    },
    {
      id: "d8d656a3-e952-4949-ba32-15badfaea562",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4d6202c-6833-48bb-8689-886f43de0dff",
      target: "62282871-afe9-4a4d-995a-7a4479435a38"
    },
    {
      id: "1b382efe-5164-44b3-a634-4165dfb2f74a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f51f4912-276d-4dea-a028-c1af55c3f334",
      target: "035e22cc-18b7-4458-b571-7d0325364652"
    },
    {
      id: "aad28004-3551-4ff2-954f-3b9de63d2490",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f51f4912-276d-4dea-a028-c1af55c3f334",
      target: "9319a15f-aaa6-40df-a1dc-1a376df772dd"
    },
    {
      id: "b2e8b316-5e4c-4dfb-80b1-32a730225e5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5f7dba8-1afc-4b33-ae74-a80395e92934",
      target: "9c478c7b-64ca-4d18-8d48-2710b79dbb3e"
    },
    {
      id: "5e55cfc9-dbee-44fc-a38e-85ab2f7c00e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84b96093-028f-4acd-842d-9d74b72628c2",
      target: "2f5a0a67-3f19-4a87-a681-72a97dd49a86"
    },
    {
      id: "c9580e32-3283-4bd8-b2c9-5dc540dace69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "670f46f4-216e-4ce2-9f76-1b88030ef283",
      target: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a"
    },
    {
      id: "a9416a6c-6455-4564-b0ce-bde40cb3b9ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d22ff3ef-1527-4921-9134-ea2f12a4daba",
      target: "9934ee9b-957d-4d28-af13-b16c42d00a52"
    },
    {
      id: "4c85d56a-a3b6-4199-89e2-77885baf5fe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37249a52-1b56-400d-8473-8f0267fc2e09",
      target: "2d1fd528-15ba-4b0a-b9fe-6db5c2cf7dc6"
    },
    {
      id: "257f0c44-d2db-48fc-b6cd-af16832901da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c454575-0265-447b-87da-a02e8b1d144f",
      target: "db2e9e89-180f-4675-9000-19af8c9e6c88"
    },
    {
      id: "408b1429-a8db-483d-8706-dd576356e326",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8bb568c-a248-49de-8cab-1842f3f91dac",
      target: "51b3abdf-b191-44cd-a08b-dbab9f96f0ce"
    },
    {
      id: "f8f08822-422e-405e-902d-cd0033ec7843",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f4de4a8-3d03-4c1b-ad5e-dde7dcf62caf",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "fc43b560-9e3c-41ca-b716-4d8977703b3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04c8fdc7-c659-4485-a013-3e2a70e908dc",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "ca8e6322-c6f2-4788-8ffc-3699a9944dcc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7504975d-20e2-4237-83ff-6ccbebaf7eaa",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "fcdc5117-53ca-4286-a28d-c582fe0e6d21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0003d2bc-9969-4b0c-9a0d-9fd9005a85c5",
      target: "6e4407c3-c824-4548-be75-dce29413388f"
    },
    {
      id: "4f9e905c-6f0d-4e42-ad1e-da1d50c21289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0003d2bc-9969-4b0c-9a0d-9fd9005a85c5",
      target: "6555168b-5348-47cf-96a4-00868784ed13"
    },
    {
      id: "4c29d261-8cb2-45c4-ba02-babdb4930c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59e34313-e3f6-4b49-9775-a1cd083a8451",
      target: "64a5e86d-b411-4655-b538-9440a526b176"
    },
    {
      id: "50650653-f729-4d2f-87cb-2e26a5489199",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59e34313-e3f6-4b49-9775-a1cd083a8451",
      target: "666d1c60-24a6-4d53-b322-e6d39e6ba01c"
    },
    {
      id: "3e5abf41-b08d-4e81-98ee-3a3407a2089c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49d64f15-0d08-416d-abbe-7b5951402325",
      target: "6578e9d9-ca51-45cc-8726-cf66b2a066ee"
    },
    {
      id: "0ee1fc2d-9c36-4edc-a00a-65e1fd02a62a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da465e61-4cdb-4785-b437-baa0976357e9",
      target: "68a8d25d-3804-4628-8a6c-2155632ed6e1"
    },
    {
      id: "148ac03c-fb23-41cf-870b-35a99758f14c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f292b24-d30f-4525-b40e-96dce79c1a10",
      target: "13ea5675-19f8-49a3-9fb7-17b110890694"
    },
    {
      id: "329ad6f7-d3c9-4cb7-8b62-a7dbd45c1a1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f08ac2cb-0850-4511-a49e-5965b6c300d9",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "88846e3c-7556-43c1-a57a-2185614b6f55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "096c3891-e186-43e6-b2b3-86d1183a6f63",
      target: "c37f6611-3252-4a1e-8659-3064bc280094"
    },
    {
      id: "072cb110-9185-4401-a6a2-053cbe7b468d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d1da365-82c9-4a4c-9a83-a68979c5a5c6",
      target: "58d7b1e7-47c2-48aa-9974-1f34d580d295"
    },
    {
      id: "0d16cc22-1d37-4503-9eee-50c49097f9ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "612becec-5331-493e-8b2f-fecb210f4c1a",
      target: "1736fc13-a761-4ead-9995-4f12c77a69b1"
    },
    {
      id: "5ec5c95b-9dc2-4a47-9ddf-7991a088bf58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e37eb8d7-d4fc-4411-b080-1c574da378ce",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "2003ee76-7cfb-45d4-a7ce-0cbcfc43f73c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70d280e2-b447-483b-988f-efe191c41286",
      target: "04f774a3-5265-4330-9d5b-d31481486089"
    },
    {
      id: "04851952-7940-4201-9884-3f3a0248050f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a3cc48f-e381-4998-8027-fdc83d31d99d",
      target: "c44f2f8c-314c-4a74-ade0-0ffc414d3176"
    },
    {
      id: "218a1403-799b-4c22-ac24-ec53805e7ec8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dba96e5c-8d5f-480a-97c3-c5c7e50450d1",
      target: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f"
    },
    {
      id: "22894e94-7f9b-48da-bc60-e85cdd72dd80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c99b40c-006f-432f-9db7-7a9c413cb800",
      target: "11af5222-36a9-44e5-be26-07ec3d02d40a"
    },
    {
      id: "f8ac49f1-8d3e-469f-9411-6bc59aeb6154",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe266e05-3e6d-4628-8f3c-5ba5c530d17a",
      target: "a627fdb8-2e87-4669-bfc1-1db6d55acded"
    },
    {
      id: "137438c0-307a-4f5b-8cb1-ce8aa97837b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e04f777-0c94-4352-9071-a8117516bb4a",
      target: "14902242-0aa9-44e2-a0d4-0c8d86470433"
    },
    {
      id: "98b4e6f2-beec-4a18-8c52-8babb8bb5804",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5b5417-f08b-4e80-a7fc-fbf247d6b620",
      target: "68e26ec3-52ca-47f6-b3d9-1bdf7676bafe"
    },
    {
      id: "c05804c8-a80d-4aa3-8195-357b4560fa94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f08ac2cb-0850-4511-a49e-5965b6c300d9"
    },
    {
      id: "a22875ac-e305-42e7-8ff6-526bc35b6467",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3"
    },
    {
      id: "e3f5e077-f57c-4339-b973-aa4c4cfbbb4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "5e624115-3494-433d-9f92-5b99ac80c412"
    },
    {
      id: "05655bb8-fed4-42ab-adce-8cb29806a3b2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "03114f37-cc78-4108-803d-c47e04c7e85f"
    },
    {
      id: "8d78a012-8067-45cc-b584-3de538d8f58b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "3731537b-2ab3-42f0-a703-4419666bed41"
    },
    {
      id: "f49370fd-6b31-425b-ad6f-f0c251f573ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "a9965be8-1e27-47cb-b954-3f621652ade6"
    },
    {
      id: "02e0be9d-54bd-4858-a9d3-d7723178fed2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18"
    },
    {
      id: "92d7c2dc-ea7e-4fa7-95e0-722d789861cb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "ea926f55-4871-463e-be6b-5020ac311c5f"
    },
    {
      id: "44a68b75-29a5-4cfb-b503-2cf12b4ba896",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f51f4912-276d-4dea-a028-c1af55c3f334"
    },
    {
      id: "18b4ff2d-3edc-4a9e-9e6c-0de6f65e5781",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "26bd51be-c0f5-4614-a707-3ab191556c9d"
    },
    {
      id: "57fcede1-e0ac-4049-9bfa-562c6fa37cfb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd"
    },
    {
      id: "5dc16ef3-641e-4373-a528-e7517ee4eeed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "9c99b40c-006f-432f-9db7-7a9c413cb800"
    },
    {
      id: "c117a1ec-6e16-4a2c-989c-02c0c4ef6b8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c"
    },
    {
      id: "af064035-129f-4cf1-ab5b-c76856329fa4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "49d64f15-0d08-416d-abbe-7b5951402325"
    },
    {
      id: "af85d006-0c48-4782-8e2d-ae055d7cf284",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f510e8d1-168c-43c8-8886-0d322957a9b9"
    },
    {
      id: "af2171ed-a6c0-4b8b-a29a-bbb86dc3247f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e5b8b86e-3fbf-4924-8029-6639ba1f52d1"
    },
    {
      id: "dc8c7ac1-0759-4432-86cc-9b526f4035be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "8098d509-112a-47e7-9d6b-5eb780bd7e95"
    },
    {
      id: "2898221e-9c34-4239-84aa-8f52bcc3956f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "22a98aa1-9258-445a-88c8-ec8fc61b3775"
    },
    {
      id: "59bd8554-68f0-4c1e-9a63-111c671c6c79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f5bed361-ca99-4fb0-ac8e-3af5ea0abeeb"
    },
    {
      id: "585a4d8f-9796-41ea-a4c6-07b0bfb39e9b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f4ea056a-3a49-49aa-9006-79a794faea91"
    },
    {
      id: "2bd4534f-aa1e-42d9-ac96-6fc5bab7312b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "0d1da365-82c9-4a4c-9a83-a68979c5a5c6"
    },
    {
      id: "9b3b899a-8367-45f2-9d61-0e87fe9f8685",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "d22ff3ef-1527-4921-9134-ea2f12a4daba"
    },
    {
      id: "30eae2d7-16e9-4c0e-980c-b73a71414217",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "096c3891-e186-43e6-b2b3-86d1183a6f63"
    },
    {
      id: "c7751ba6-a39f-4433-8f2c-277b0d0c0426",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "1aca1855-4070-4470-9d81-e3461d849d96"
    },
    {
      id: "4e5de424-d620-4e0b-aa09-5de6d4e9e286",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96"
    },
    {
      id: "e9f8d18f-5b8a-438a-b807-ac5644e76d61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "84b96093-028f-4acd-842d-9d74b72628c2"
    },
    {
      id: "3609b6a3-e0b4-4323-9579-3acd735afc1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f709d727-7225-4517-9ae4-5d8b8d232ee4"
    },
    {
      id: "70e48ff7-5803-4891-99d1-5d009cdce88a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "cf5b5417-f08b-4e80-a7fc-fbf247d6b620"
    },
    {
      id: "9b1b2af8-9d53-4991-a788-5d0f03331cd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "b0ef15aa-ea07-40e9-87b7-c72c0b2482af"
    },
    {
      id: "e73b7a9d-cf3e-42b0-b162-c5fea814ed5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "0003d2bc-9969-4b0c-9a0d-9fd9005a85c5"
    },
    {
      id: "d4ed8573-bc2a-4aca-b4ed-b92157852f12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "94338bcd-7706-43b1-8a41-2c70a99d957b"
    },
    {
      id: "877facba-1042-4e10-9482-505416abc5f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "0e1b37a9-5332-4bc8-a007-68efbc15a930"
    },
    {
      id: "c91cc417-f573-4210-97e0-1e1edf4f87f1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "4f7c5831-d6a3-4abf-a251-5147b68351f2"
    },
    {
      id: "348a30e5-6d76-4223-8c21-90c5b6fae88c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "90321750-8d28-4a30-ab18-5f5e09e5a7a6"
    },
    {
      id: "5299c5d5-4d13-431b-b0fa-0531f78fded4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "2cb8e57b-5012-4408-9d7a-73b7cd7bf035"
    },
    {
      id: "a3d7b9c8-d0bb-4a31-9f10-7283128446b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "fe266e05-3e6d-4628-8f3c-5ba5c530d17a"
    },
    {
      id: "287c6294-ca46-48c7-a32a-1e436cc0a287",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e9f0975b-776e-4c34-965f-6c0916711e31"
    },
    {
      id: "6cd51937-6d8f-4265-a339-024406fd3559",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "5e3223c1-8707-427d-8e11-b2295a1bde3c"
    },
    {
      id: "3a9f1561-1df8-4678-8dad-9fb79ff1e127",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "412d2c94-a09f-43ff-b373-c84f4d6ab8db"
    },
    {
      id: "448f8127-9941-4455-ae14-da8632d22e10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "99a7ae21-d468-400a-b563-50c15bf4ea85"
    },
    {
      id: "60159d64-fbd7-4779-a51b-d2327ba389e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e8bb568c-a248-49de-8cab-1842f3f91dac"
    },
    {
      id: "a17e500d-8e9c-40a9-a0bc-33e635036875",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "6523acc1-0f9e-4214-8b2a-33f7210378a0"
    },
    {
      id: "8e25eae7-96bb-4681-9e2b-ef4052c7659f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "0551c8a7-60d0-4fb6-a1a8-fa83eb9bc539"
    },
    {
      id: "b3100787-0637-4d74-8fe5-67d4499c2ff3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "670f46f4-216e-4ce2-9f76-1b88030ef283"
    },
    {
      id: "213ba331-2236-4d96-98a6-0fdc700d8f3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "bf6f2460-1cc3-468d-9158-fae614d9a8d6"
    },
    {
      id: "53dee07d-681f-4d78-8f73-6fb9f4500ff8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "a1b545f6-4da5-4dba-835d-00872dffb2dd"
    },
    {
      id: "4693e75f-375f-4de3-b9d7-876c041c677c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "bbfb506e-b03c-443e-8ffe-68413a54cb78"
    },
    {
      id: "bc3ae818-920d-4679-bcba-36706ca5f15b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "21ca2baa-4a72-4279-b666-bf7a44c49fe5"
    },
    {
      id: "84f18e28-1f91-446b-96af-b8a1237756ab",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "d1b22d64-752d-4406-9e8f-df57e2edb64d"
    },
    {
      id: "3831c750-b8ae-4af5-b6b3-f396c5fc3fef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "0c454575-0265-447b-87da-a02e8b1d144f"
    },
    {
      id: "db9b6295-c49c-4c84-ab10-1a0d4d142fd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "3cde2b27-f251-484f-86c0-937857581088"
    },
    {
      id: "b2c96e90-8312-4816-806d-1ea97f656812",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "9717de69-6e06-4c10-806d-cce273f98818"
    },
    {
      id: "0a5b79ef-088d-46ed-abef-4f17cf399d30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "35f4f35d-3c63-4bfb-b18b-41d4cbd20f44"
    },
    {
      id: "30675b77-2d4f-492a-a2f5-0e42324e8d8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "14796376-b4a8-47d0-a072-4d7d7b938edb"
    },
    {
      id: "1893c344-334d-4840-b9cb-7d399b7834ae",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "06baf101-a970-49f2-ae60-6b4a30de5e1d"
    },
    {
      id: "8385bb2c-7bfd-4531-8f00-ef6903263d2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "fadfcd2f-b166-497c-9caf-b6b2663459aa"
    },
    {
      id: "f5273c6d-ca20-45e7-89e0-0736021035d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "37249a52-1b56-400d-8473-8f0267fc2e09"
    },
    {
      id: "ecdad2b8-b139-44af-9237-1ff9967ccdf2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "f6089950-d5ed-48a5-a295-699129837b6c"
    },
    {
      id: "7bca3fce-f25d-400c-b239-c05cc8743027",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "da465e61-4cdb-4785-b437-baa0976357e9"
    },
    {
      id: "c6483713-35a7-479a-ae60-edce64764904",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "1165ec92-fbbf-425e-abc5-3aed33f40cc6"
    },
    {
      id: "23485213-f2b3-46b1-b6f3-81b1b456c7b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "d4b326a1-cd90-402d-8d70-45aeeaacd14a"
    },
    {
      id: "f588fce2-cf27-4358-bb03-49e7f2e6406d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "59e34313-e3f6-4b49-9775-a1cd083a8451"
    },
    {
      id: "b64dd45a-339f-47f6-bc01-93840384d39a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "c5f7dba8-1afc-4b33-ae74-a80395e92934"
    },
    {
      id: "c5564777-7375-4bdf-b4a5-87b883a47521",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "7d465d5f-cfb1-45b3-b61a-49ca1d259de2"
    },
    {
      id: "88893166-cb3f-46a7-877d-35393915d7d2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "96a9e182-336d-409e-a84b-8d37d1898f5a"
    },
    {
      id: "c6232010-a80b-4ea7-b9a2-7c4c23a31fcb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "8e85a57a-7801-4bf1-8705-771cb893951d"
    },
    {
      id: "5de489d7-8e18-4012-91d4-2576676b81b2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "4afc810d-85af-4009-ad12-51462618da45"
    },
    {
      id: "ba53279a-c344-4dfe-af03-48fffc3e8bb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "6bdb7124-d7ea-448e-8756-317e8382021f"
    },
    {
      id: "0006a373-5f5c-425e-872d-46913a9e7f94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "c3804e97-b239-4885-a723-fce3b1ec160e"
    },
    {
      id: "3f52a543-f370-4213-9589-e93506eb43e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "7a7e68ff-9098-4858-b959-70c8cad34beb"
    },
    {
      id: "60037fac-7045-48da-b12d-cfaaf269bc25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "8039b75e-0c84-4c81-a494-5dc5eb889ce3"
    },
    {
      id: "c550c28b-bb36-4f04-ba1a-09ea71ce8887",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "1f4de4a8-3d03-4c1b-ad5e-dde7dcf62caf"
    },
    {
      id: "79bd8c96-bd13-474d-a558-fd6fb46617ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "117c33d0-9a54-42ef-a268-d1554953ee74"
    },
    {
      id: "e8cccc05-060b-40f4-97fa-a952aa9bbd5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "c622157b-ff05-4490-95fa-270ab9f08454"
    },
    {
      id: "30c17e93-50db-47c8-a30d-7a901471ae55",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "88bd03db-51de-4964-ac4a-30f792816ea4"
    },
    {
      id: "9e099de7-54cf-4dd5-9bdd-e4e766178358",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "7504975d-20e2-4237-83ff-6ccbebaf7eaa"
    },
    {
      id: "6f29dabe-cfac-419a-b1a5-49f7880c653a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "612becec-5331-493e-8b2f-fecb210f4c1a"
    },
    {
      id: "2be574b7-a374-41d5-bc7a-2dd2e4b41a37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "7f292b24-d30f-4525-b40e-96dce79c1a10"
    },
    {
      id: "d158faa0-cf40-4b5a-8d82-97992ef7efbe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74"
    },
    {
      id: "dcaeb4ee-2ccb-47c7-ae0f-9c534c8baa0c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "84647bb3-9204-4384-a921-15a7c2271182"
    },
    {
      id: "67b84265-41d7-4d9a-8c46-e4338541504e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "ac14da03-e164-41ae-987f-f484869d6058"
    },
    {
      id: "728e21cf-e5c3-44f8-a890-f165e0a7b3b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e0c7e5cb-1620-46db-83f5-45870ee0c38d"
    },
    {
      id: "73b255b1-5b68-49f9-a836-d377229c0140",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "91142971-7ff8-402c-ad76-680fffb25ce0"
    },
    {
      id: "c990972d-18e5-4a63-ad0e-e873514d80e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "70d280e2-b447-483b-988f-efe191c41286"
    },
    {
      id: "bb55f245-87f2-4be6-9706-e4790f1356e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e4d6202c-6833-48bb-8689-886f43de0dff"
    },
    {
      id: "c4e8a6aa-2ab5-4913-8800-941aaf398e43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "c4501e92-11f3-4b76-b3e7-99462480111e"
    },
    {
      id: "7e5c5d68-9015-4b70-95ff-ff0dec0c3cc8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "418bcefe-41e2-4340-8bfb-124265abfc01"
    },
    {
      id: "57718302-1429-49d4-9b31-f06051c04ee3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "31e53564-18df-48b5-b5ac-676668893ae1"
    },
    {
      id: "d6150267-805e-4c23-aab7-35eb32abee65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "ce31ca34-c9d8-4fda-8ec5-7c58e7dfe698"
    },
    {
      id: "ce29b8ae-535f-4ccc-a449-8efe5cca25b3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "7d30f906-edaf-42a2-84e6-d89980169b4f"
    },
    {
      id: "bb2d2a1b-2a58-4ac3-af2b-febe7ca210f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "e37eb8d7-d4fc-4411-b080-1c574da378ce"
    },
    {
      id: "0351dae9-d1f7-4cb8-9eea-40bae69160fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "5e04f777-0c94-4352-9071-a8117516bb4a"
    },
    {
      id: "5e0b7beb-abff-425a-a912-0e87c779c9f7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "85b691fb-8041-4ba5-904d-a0e67c43af88"
    },
    {
      id: "b0ab5524-bea9-4aa2-8890-88ee0e902ef7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "dba96e5c-8d5f-480a-97c3-c5c7e50450d1"
    },
    {
      id: "c664a3d6-2dbd-4d7d-9bc9-ea44b11cbbce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "2a3cc48f-e381-4998-8027-fdc83d31d99d"
    },
    {
      id: "4e484c6a-3c67-402f-b31b-de91092509f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "228f20a5-2b33-492b-843c-2eabe2c8af8f"
    },
    {
      id: "10397a54-aa70-4ea0-a685-38a8ffcfde13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "b799e883-fef0-453b-a1de-e82ebda8573b"
    },
    {
      id: "e00a4c34-e21c-4052-8f55-1fb6e36b30ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf5ac519-aa75-4199-8008-f19b4bda4858",
      target: "04c8fdc7-c659-4485-a013-3e2a70e908dc"
    },
    {
      id: "12cb6655-0f4f-4820-a6b4-b38dacf58d56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22a98aa1-9258-445a-88c8-ec8fc61b3775",
      target: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae"
    },
    {
      id: "d3788042-8e7e-4d65-86d9-e984d1fd511f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae",
      target: "de662fe5-d473-4455-b6fb-ff1631479414"
    },
    {
      id: "de5a1ced-6b36-4301-8282-9a4b9de934ef",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae",
      target: "de662fe5-d473-4455-b6fb-ff1631479414"
    },
    {
      id: "b7460f14-4306-45df-9d52-30f7b4042b37",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae",
      target: "41f5963d-df09-4d07-8566-b2244ab87b6c"
    },
    {
      id: "e5375d02-82b9-41f8-9ae0-b235987d9402",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "54f4b66d-7f1e-44c4-9e13-14260f5e47ae",
      target: "41f5963d-df09-4d07-8566-b2244ab87b6c"
    },
    {
      id: "df5358b4-cb99-4259-9835-ce1460f4a88b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de662fe5-d473-4455-b6fb-ff1631479414",
      target: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5"
    },
    {
      id: "60d212e5-c7e6-4a99-b3ec-50f851d5b401",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de662fe5-d473-4455-b6fb-ff1631479414",
      target: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0"
    },
    {
      id: "c23c2c61-ef7f-4aa4-a6b3-3fc78ba72ac7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41f5963d-df09-4d07-8566-b2244ab87b6c",
      target: "16f4a518-f541-4a11-aea4-d2236977b1a6"
    },
    {
      id: "652097a6-2f89-4e51-b90a-ce484eb070c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41f5963d-df09-4d07-8566-b2244ab87b6c",
      target: "ac49182b-8b0b-4e9b-b3e0-ec892bd082ed"
    },
    {
      id: "c3a973c0-9265-49e1-ae74-391b21fe8b43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8098d509-112a-47e7-9d6b-5eb780bd7e95",
      target: "6701a342-d859-40c6-a27d-7bf4bb1c4b54"
    },
    {
      id: "e5041cfb-b5c9-44ff-8206-c2a61748603e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6701a342-d859-40c6-a27d-7bf4bb1c4b54",
      target: "6f343f6b-7d09-4c93-b93c-239b6210e956"
    },
    {
      id: "65054871-d295-4b7c-ba07-ffb85efc9b2b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6701a342-d859-40c6-a27d-7bf4bb1c4b54",
      target: "6f343f6b-7d09-4c93-b93c-239b6210e956"
    },
    {
      id: "8404f579-6692-4786-b3da-903191ce9005",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6701a342-d859-40c6-a27d-7bf4bb1c4b54",
      target: "ff0a3b6f-673a-4683-b7d6-3632c9704274"
    },
    {
      id: "3ff1d7b0-6ccb-465f-98ce-c61c1b2d9625",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6701a342-d859-40c6-a27d-7bf4bb1c4b54",
      target: "ff0a3b6f-673a-4683-b7d6-3632c9704274"
    },
    {
      id: "38000258-2b91-4fce-9707-0ebca00d82db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff0a3b6f-673a-4683-b7d6-3632c9704274",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "7e6c0415-b31e-425f-90ea-9cc23a32884a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff0a3b6f-673a-4683-b7d6-3632c9704274",
      target: "3c1a1b4c-abc9-4754-9251-85dd255f658e"
    },
    {
      id: "f429c2aa-7910-4d67-ba71-3421c49b1b33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff0a3b6f-673a-4683-b7d6-3632c9704274",
      target: "ae7d5631-0e66-4aa4-a199-d819775a27d0"
    },
    {
      id: "e86072e6-ee06-4a41-bd78-8e0b279ccc87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f343f6b-7d09-4c93-b93c-239b6210e956",
      target: "e92b7494-9783-4351-9180-0e06f962291a"
    },
    {
      id: "46233e1b-1867-4116-a6f3-a6bc95452f56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f343f6b-7d09-4c93-b93c-239b6210e956",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "1acac6ab-aa27-480c-8314-e9b353b4a425",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f343f6b-7d09-4c93-b93c-239b6210e956",
      target: "15cb4329-7b1e-465e-a80b-bec578d26373"
    },
    {
      id: "99a78e3b-2d6f-420c-bf73-feae94697c3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "228f20a5-2b33-492b-843c-2eabe2c8af8f",
      target: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be"
    },
    {
      id: "0b9f6138-513c-4c76-9e65-cfc31ee66f00",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be",
      target: "3bcbf178-3309-4cd5-a06b-9dd315f97658"
    },
    {
      id: "107b25e7-0e2c-492e-a0f7-f5b665e64135",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be",
      target: "2f31d1c8-d53e-4ea3-ac42-30a5eb52d821"
    },
    {
      id: "2e1ab417-d25f-4b32-b415-9f447bb1a39d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be",
      target: "2f31d1c8-d53e-4ea3-ac42-30a5eb52d821"
    },
    {
      id: "6f35f5a5-b6fa-46af-85f5-367bf9b82641",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fa984784-5c8f-4f38-96ad-1bfe89d0f7be",
      target: "3bcbf178-3309-4cd5-a06b-9dd315f97658"
    },
    {
      id: "1e6df771-1323-4d5d-9ffd-a19eaef20b59",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f31d1c8-d53e-4ea3-ac42-30a5eb52d821",
      target: "364804f1-dd1b-4b3c-b6b5-7c7841f23ae6"
    },
    {
      id: "a9c68a40-d4ae-4cec-a2fc-e241d225073d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f31d1c8-d53e-4ea3-ac42-30a5eb52d821",
      target: "46a201c1-27ca-4726-ae3b-537532fb4b64"
    },
    {
      id: "994a21cf-7d4f-4b47-b8aa-f723fba793e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bcbf178-3309-4cd5-a06b-9dd315f97658",
      target: "6a6ff9fa-7b66-47b2-87b5-2e069a950edb"
    },
    {
      id: "c7061a3a-0562-4db6-acf4-781ab2175794",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bcbf178-3309-4cd5-a06b-9dd315f97658",
      target: "086c42d9-8735-443d-a45d-99800fe3c59d"
    },
    {
      id: "5dfe1404-0568-4380-b02d-ba2ceced47f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99a7ae21-d468-400a-b563-50c15bf4ea85",
      target: "bea65c75-25be-4476-afe3-d24e4e71b9f2"
    },
    {
      id: "c1635029-b081-48a7-b720-60f42c3a93b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bea65c75-25be-4476-afe3-d24e4e71b9f2",
      target: "bee12360-17d8-4446-94ed-e7581796899b"
    },
    {
      id: "def36544-a4f8-49b8-82d0-1257e36422d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bea65c75-25be-4476-afe3-d24e4e71b9f2",
      target: "c2d95d1c-7196-49d8-a17c-9af16837967d"
    },
    {
      id: "bf722a84-734e-4121-b86c-d7c855517566",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bea65c75-25be-4476-afe3-d24e4e71b9f2",
      target: "bee12360-17d8-4446-94ed-e7581796899b"
    },
    {
      id: "ea659bed-cc9f-4f8b-ad83-c3de96ce75f6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bea65c75-25be-4476-afe3-d24e4e71b9f2",
      target: "c2d95d1c-7196-49d8-a17c-9af16837967d"
    },
    {
      id: "20e4a9b3-c776-4070-98e1-46dd14419db6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2d95d1c-7196-49d8-a17c-9af16837967d",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "9afa8a55-24fe-47cc-af7e-d6f21de28beb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2d95d1c-7196-49d8-a17c-9af16837967d",
      target: "ae7d5631-0e66-4aa4-a199-d819775a27d0"
    },
    {
      id: "a8a65552-0475-440e-9ca5-5df26d5877d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bee12360-17d8-4446-94ed-e7581796899b",
      target: "e92b7494-9783-4351-9180-0e06f962291a"
    },
    {
      id: "cdbb7046-a2f8-42c7-9933-fbce9954ed17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bee12360-17d8-4446-94ed-e7581796899b",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "ff3306f3-df2d-44ee-8130-ba37031bbaf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d465d5f-cfb1-45b3-b61a-49ca1d259de2",
      target: "dee0d834-497a-4bf0-ab0d-d446c6853269"
    },
    {
      id: "96bbd1e5-39dc-4763-a9a3-724259ca0796",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dee0d834-497a-4bf0-ab0d-d446c6853269",
      target: "8147b072-90c2-45e9-96e2-d067dedda4a1"
    },
    {
      id: "316e8825-7b9c-4672-9a19-34cad187480e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dee0d834-497a-4bf0-ab0d-d446c6853269",
      target: "7df0e8c4-7604-4772-9141-2617f08a1fb4"
    },
    {
      id: "41ee03bb-4283-454e-b1d5-12b739bbe23b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "dee0d834-497a-4bf0-ab0d-d446c6853269",
      target: "7df0e8c4-7604-4772-9141-2617f08a1fb4"
    },
    {
      id: "adbd692f-5978-4d03-93e7-45583bd92df5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "dee0d834-497a-4bf0-ab0d-d446c6853269",
      target: "8147b072-90c2-45e9-96e2-d067dedda4a1"
    },
    {
      id: "4ed82cb7-b1f8-4451-bb25-165b4c329cda",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7df0e8c4-7604-4772-9141-2617f08a1fb4",
      target: "ae7d5631-0e66-4aa4-a199-d819775a27d0"
    },
    {
      id: "ceb36519-4f19-4cc4-9e35-b20f0b5852d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7df0e8c4-7604-4772-9141-2617f08a1fb4",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "d2c63de9-96b0-4a51-8e2c-b1c06468711c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8147b072-90c2-45e9-96e2-d067dedda4a1",
      target: "e92b7494-9783-4351-9180-0e06f962291a"
    },
    {
      id: "f4f61de8-2099-4ae1-bdb3-24209819d8b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8147b072-90c2-45e9-96e2-d067dedda4a1",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "9045ad5b-0e99-4802-ba0e-e7b10c600207",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "8be16ed7-bd51-42b7-b2c7-40c5e80f3099"
    },
    {
      id: "daeb403c-7216-420d-a514-ff380c44cf27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "6510dce4-5698-42e6-8034-b18fc48d5d92"
    },
    {
      id: "aae83740-1c5c-44d9-859c-6854e8d37fee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "cb3f6849-3dfc-4fb3-b936-97e725cca578"
    },
    {
      id: "2180264a-375d-4c76-b23f-234768a7eacf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "fce56697-81f2-47bd-9e13-816fdcce0392"
    },
    {
      id: "82d32dcf-dbfe-4f94-95f8-8c71f94236a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "09cd8070-041c-48f8-a4b1-faa0b7fe33b7"
    },
    {
      id: "0702249a-2022-45b4-baf8-7e7209ae7123",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "5445f859-45b4-4d33-9dea-8152ccaff85d"
    },
    {
      id: "d5b9fa80-dac9-414a-ac74-5dbe37413665",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "da781b9e-7e57-441e-a97a-70a3e6f14b81"
    },
    {
      id: "51ad9114-c6ac-4549-a801-2e69cf5c9644",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "c4f4e164-3919-47d5-be4e-be3938783854"
    },
    {
      id: "53a04e98-34c5-4e4f-bc2f-a0584c6a75ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "08bc72b3-5fac-44c0-a880-06a32319e9ad"
    },
    {
      id: "7bc21059-74a9-47b5-a331-1f17a8648789",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "26c0cf0e-5c92-41c5-bafa-3e5a7e31dffa"
    },
    {
      id: "6b54c33a-5702-40ed-8934-bcb109b2013d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "b6bdf298-ffd9-47bf-91ec-b9960d916aa8"
    },
    {
      id: "cdc84504-61f2-4d55-adb0-7735ca87a2a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "6e200373-b0d5-42b7-b368-efd5ab20e285"
    },
    {
      id: "a773627e-2b8a-4d90-89c1-3d87ea3a3300",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b8aea7b-ff32-4a24-a9bd-b6da17928a74",
      target: "37338ad1-344f-4f49-83db-8a381da2ea88"
    },
    {
      id: "b550beb2-44ca-40e9-9440-eddb09a66d0e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "08bc72b3-5fac-44c0-a880-06a32319e9ad",
      target: "87bcb177-d4dd-4ca4-b098-76e591a09685"
    },
    {
      id: "819bff8e-5ce9-40e0-9ec0-d6a97b1df18c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "08bc72b3-5fac-44c0-a880-06a32319e9ad",
      target: "87bcb177-d4dd-4ca4-b098-76e591a09685"
    },
    {
      id: "ec396fa7-e422-45ed-addb-c65949eb45e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da781b9e-7e57-441e-a97a-70a3e6f14b81",
      target: "581a598c-7287-4fb8-9097-9ac1998a928c"
    },
    {
      id: "a16ef71c-b934-43cb-b0ca-28c60be3a9c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87bcb177-d4dd-4ca4-b098-76e591a09685",
      target: "2848bb95-d1c2-4518-9d78-d325f4e2c6d1"
    },
    {
      id: "c07c8fa2-5471-4017-94f3-63ad1c141540",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87bcb177-d4dd-4ca4-b098-76e591a09685",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "b2bf425c-2ca0-486c-b8fc-4306985b8c11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8be16ed7-bd51-42b7-b2c7-40c5e80f3099",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "7e63f1c9-b34d-4e16-9fff-18e0bda92ac5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fce56697-81f2-47bd-9e13-816fdcce0392",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "c6ed3e5b-0093-4df5-81a9-ade2f197e5cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4f4e164-3919-47d5-be4e-be3938783854",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "f6ada0e2-a93d-4dc7-92b3-29231becde8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37338ad1-344f-4f49-83db-8a381da2ea88",
      target: "fd1228a0-6f03-4c62-9674-1fbb992f3690"
    },
    {
      id: "195cc7e9-da49-43c2-98eb-65856d493b2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26c0cf0e-5c92-41c5-bafa-3e5a7e31dffa",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "921f642d-6d36-4c4e-8905-68c7814791ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e200373-b0d5-42b7-b368-efd5ab20e285",
      target: "fd1228a0-6f03-4c62-9674-1fbb992f3690"
    },
    {
      id: "da57f4ef-012a-49d6-a4dc-7dfb6bd21a19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6bdf298-ffd9-47bf-91ec-b9960d916aa8",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "5320857f-ad47-4253-8a2b-bc7cacc83e0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5445f859-45b4-4d33-9dea-8152ccaff85d",
      target: "844d619f-03b4-44dc-b4f9-172eb2f534f6"
    },
    {
      id: "58e7b510-7369-4b3e-8c74-edd7b04fc008",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09cd8070-041c-48f8-a4b1-faa0b7fe33b7",
      target: "8af65a37-dd4c-4361-bc42-10142c179b20"
    },
    {
      id: "61656962-14e1-46cc-a6d8-ad7b2558aade",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb3f6849-3dfc-4fb3-b936-97e725cca578",
      target: "844d619f-03b4-44dc-b4f9-172eb2f534f6"
    },
    {
      id: "fce64901-2a63-4958-ab60-e6eb67c35134",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6510dce4-5698-42e6-8034-b18fc48d5d92",
      target: "8af65a37-dd4c-4361-bc42-10142c179b20"
    },
    {
      id: "b27af77b-06b4-4699-8083-05fcd3352982",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "51b50315-5c42-4877-9236-957ca2e7a361"
    },
    {
      id: "ad2f907c-66ef-4f38-8b67-139a6f2acce8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "2129f2fa-37a3-4fd0-b52d-3aa1a5c0bb6c"
    },
    {
      id: "929615a5-24db-4e96-b600-8fb393873545",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "327537eb-46b3-4a85-9284-078d5e739c30"
    },
    {
      id: "d265ea56-5533-4d7a-9ad9-9b80508c6d42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "c64d84d2-6539-4a46-8cae-51e196d00a94"
    },
    {
      id: "c9379a2c-6a52-4b09-8585-863a3707cc2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "fcb8f6d0-2e92-47a0-b84b-c98e0d6f5255"
    },
    {
      id: "fc38ab4b-dcf4-4519-ab28-7827512a5128",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "e1237eb4-0de7-484d-85b8-9442d86a46b0"
    },
    {
      id: "413b779c-2e0f-4db4-be10-ca8cc8bd8012",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "1bed9582-60b9-4fad-9cbd-a514f1d8a6a4"
    },
    {
      id: "d8d3bf38-e47d-4699-a1e0-321f25a01b54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "2e9c83d2-1a23-48ee-95ac-651f569992ca"
    },
    {
      id: "a1e1b6ae-8403-4e19-8de2-ff59719a3043",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "edbea56f-5ebb-4239-975d-69bce2944188"
    },
    {
      id: "d8e02966-8cd8-40f2-b290-89408e3fc94b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "e37e76cb-bd5e-4c39-b82c-6e00476d1efa"
    },
    {
      id: "f95e0a92-8162-4911-8142-f8ca82968c9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "f4715616-e024-422f-a1cc-3786392cfb07"
    },
    {
      id: "8bd732c9-ff5d-4b96-8ab2-712198f81995",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9956d507-b2c4-4f0e-a0ea-067bf4c71f96",
      target: "de0d906a-bcf9-439e-9ac9-a34dab232569"
    },
    {
      id: "496c384d-9069-402b-aac5-ec75186b5a68",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2129f2fa-37a3-4fd0-b52d-3aa1a5c0bb6c",
      target: "99cb7f54-093d-46c0-892b-d5a3ef6857b2"
    },
    {
      id: "12830778-98de-485c-a21e-25792bd83e94",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2129f2fa-37a3-4fd0-b52d-3aa1a5c0bb6c",
      target: "99cb7f54-093d-46c0-892b-d5a3ef6857b2"
    },
    {
      id: "57f35a1f-b83b-41b7-9524-da496b1a1650",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99cb7f54-093d-46c0-892b-d5a3ef6857b2",
      target: "581a598c-7287-4fb8-9097-9ac1998a928c"
    },
    {
      id: "5657ed78-c321-4a1f-a8df-7df327a91837",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99cb7f54-093d-46c0-892b-d5a3ef6857b2",
      target: "ffd4bc9f-42d8-4135-b878-f4d6139a1763"
    },
    {
      id: "3c2e22c9-2e7e-4e66-ac32-a101c3f9306b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e37e76cb-bd5e-4c39-b82c-6e00476d1efa",
      target: "3c238586-ddab-405d-af44-e1ca2dac8412"
    },
    {
      id: "65608317-c167-40f5-aa66-4c06a0667c19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e9c83d2-1a23-48ee-95ac-651f569992ca",
      target: "ffd4bc9f-42d8-4135-b878-f4d6139a1763"
    },
    {
      id: "e34acc3c-4b86-4d8e-a505-b85aaa50ffef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e9c83d2-1a23-48ee-95ac-651f569992ca",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "de7169ed-bed5-40e0-8a4d-97968f70f6ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c64d84d2-6539-4a46-8cae-51e196d00a94",
      target: "ffd4bc9f-42d8-4135-b878-f4d6139a1763"
    },
    {
      id: "4ba690a1-3365-4102-8b74-a6249730f027",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c64d84d2-6539-4a46-8cae-51e196d00a94",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "c9163004-a679-447b-8d6c-202abbeca9b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4715616-e024-422f-a1cc-3786392cfb07",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "bbafbfc0-a6c7-4068-b451-43751b709623",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de0d906a-bcf9-439e-9ac9-a34dab232569",
      target: "fd1228a0-6f03-4c62-9674-1fbb992f3690"
    },
    {
      id: "da127934-6bbf-448a-8d21-da8c8d93ea0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "327537eb-46b3-4a85-9284-078d5e739c30",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "510ebed5-db20-4371-bd18-0847a175d686",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edbea56f-5ebb-4239-975d-69bce2944188",
      target: "fd1228a0-6f03-4c62-9674-1fbb992f3690"
    },
    {
      id: "eb5b54ed-5c8c-41a8-840d-6b4c8a6824f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1237eb4-0de7-484d-85b8-9442d86a46b0",
      target: "844d619f-03b4-44dc-b4f9-172eb2f534f6"
    },
    {
      id: "463ed3fe-1398-46a7-ab2e-5abaf1321ebd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51b50315-5c42-4877-9236-957ca2e7a361",
      target: "8af65a37-dd4c-4361-bc42-10142c179b20"
    },
    {
      id: "70cbdea1-11d4-49dd-85c1-af381a33c9c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1bed9582-60b9-4fad-9cbd-a514f1d8a6a4",
      target: "844d619f-03b4-44dc-b4f9-172eb2f534f6"
    },
    {
      id: "26d43362-5e92-45a7-b9ce-9af70b5644c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb8f6d0-2e92-47a0-b84b-c98e0d6f5255",
      target: "8af65a37-dd4c-4361-bc42-10142c179b20"
    },
    {
      id: "0ca1002c-8bad-4d13-a114-0d6b9968a780",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "a1b545f6-4da5-4dba-835d-00872dffb2dd"
    },
    {
      id: "17738c37-83fc-4984-8c27-eae573fb9900",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "97578135-02af-4f93-93b3-0a084a6773f8"
    },
    {
      id: "62096971-8e3d-444c-b4ce-f04e1f06b638",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "6f44f4cc-51fc-4d7a-a5e0-034ae3a1b069"
    },
    {
      id: "b6ad4e0a-a6e8-4f6a-ad6c-6853fee376dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "ade2e6b0-bd80-4e10-9ebd-c0e0f8a169de"
    },
    {
      id: "0eedb77b-dc13-4e96-a001-3b765b015df8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "5b4e3422-8569-4f25-b569-4001bfb1cde6"
    },
    {
      id: "154d58e6-5bde-4980-b5be-2a8784ce4795",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f0975b-776e-4c34-965f-6c0916711e31",
      target: "1e7b1d76-4462-4f25-8d2c-f5374fe49857"
    },
    {
      id: "c2d4f5a1-0d26-4a81-ada1-3ef441248a59",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a1b545f6-4da5-4dba-835d-00872dffb2dd",
      target: "dee905f6-a148-49a8-b010-2bacbe0f5516"
    },
    {
      id: "b79cf224-849e-4d34-8598-ec1fd670c0f5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a1b545f6-4da5-4dba-835d-00872dffb2dd",
      target: "dee905f6-a148-49a8-b010-2bacbe0f5516"
    },
    {
      id: "2d0fc699-61c6-4ebc-a241-cae1f02a7b53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dee905f6-a148-49a8-b010-2bacbe0f5516",
      target: "e00c7895-8ce4-4189-aa94-ead11b56e278"
    },
    {
      id: "27bcb061-0a11-4acd-b600-c4c90062cfda",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f44f4cc-51fc-4d7a-a5e0-034ae3a1b069",
      target: "df988812-a62c-4468-8839-b1ffff168ac2"
    },
    {
      id: "8e6164ec-dc8f-447c-ad45-c5c46891ee2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97578135-02af-4f93-93b3-0a084a6773f8",
      target: "6e38b4b2-a555-4b02-8d54-8eee0c45ce03"
    },
    {
      id: "14d7ae68-4754-4e44-9640-c62d29e79869",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b4e3422-8569-4f25-b569-4001bfb1cde6",
      target: "f2d08268-17a3-4a53-828e-f39d2e9d23db"
    },
    {
      id: "91614171-485c-4780-890f-2196aa71a043",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ade2e6b0-bd80-4e10-9ebd-c0e0f8a169de",
      target: "e1434d18-0cf0-456c-88d6-6d6373063f18"
    },
    {
      id: "05b6ca32-5930-4608-a245-e6cb2e5adc96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e7b1d76-4462-4f25-8d2c-f5374fe49857",
      target: "2a45531e-2d53-4926-9c51-38cb8f4abf65"
    },
    {
      id: "8c76fd57-a101-4014-b807-bc1fd4e48f6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6523acc1-0f9e-4214-8b2a-33f7210378a0",
      target: "9d5de1c4-4afe-4486-a125-5b0704cc1b98"
    },
    {
      id: "5c2a462f-5672-429f-9ed1-1888a782fe34",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d5de1c4-4afe-4486-a125-5b0704cc1b98",
      target: "bd85483f-7137-4be2-b76d-979e82b83376"
    },
    {
      id: "fb0edbcc-14ef-474c-a8fb-24613535f48d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d5de1c4-4afe-4486-a125-5b0704cc1b98",
      target: "bd85483f-7137-4be2-b76d-979e82b83376"
    },
    {
      id: "c79ccc60-c180-4a53-9871-cd206a4f5e74",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d5de1c4-4afe-4486-a125-5b0704cc1b98",
      target: "0c2766ed-67b4-49fc-9d5e-6eb9e57b9f63"
    },
    {
      id: "a3a7603d-abf9-4bf1-b646-d0fcb4c58594",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d5de1c4-4afe-4486-a125-5b0704cc1b98",
      target: "0c2766ed-67b4-49fc-9d5e-6eb9e57b9f63"
    },
    {
      id: "22e63a81-6f4f-4046-90fa-c16a9bd6442d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd85483f-7137-4be2-b76d-979e82b83376",
      target: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456"
    },
    {
      id: "9337ced4-24ea-434e-bb31-260825d496b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c2766ed-67b4-49fc-9d5e-6eb9e57b9f63",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "78967221-4f40-4f45-9520-920480a42162",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4501e92-11f3-4b76-b3e7-99462480111e",
      target: "a3dac3e9-421a-40e8-90e7-147055660c87"
    },
    {
      id: "3bb86d41-d714-4430-bc91-47682c3f5373",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4501e92-11f3-4b76-b3e7-99462480111e",
      target: "df430232-7133-410a-b684-e5db7772d8ac"
    },
    {
      id: "9b456e4d-a96a-40c3-ad5d-96092ef5e7d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4501e92-11f3-4b76-b3e7-99462480111e",
      target: "0e59e38a-19ab-4f52-af91-91ccd88a3cc4"
    },
    {
      id: "7162cfd7-a907-4d1f-91d5-ed072ea40499",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3dac3e9-421a-40e8-90e7-147055660c87",
      target: "0e59e38a-19ab-4f52-af91-91ccd88a3cc4"
    },
    {
      id: "cf845599-0f8f-4d72-9d89-43e8837bff8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e59e38a-19ab-4f52-af91-91ccd88a3cc4",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "38cebafe-b5cc-43a0-9f2b-977fcfb1c961",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e59e38a-19ab-4f52-af91-91ccd88a3cc4",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "3f0d71b6-ac5f-4eab-8e7f-8486bb1192b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df430232-7133-410a-b684-e5db7772d8ac",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "20302d00-ae58-4772-952b-700c354cd74a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fadfcd2f-b166-497c-9caf-b6b2663459aa",
      target: "7a9612f2-5aa3-4f81-a5f5-5288bb093469"
    },
    {
      id: "23964a62-bae5-48a8-a45d-dc425025c287",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fadfcd2f-b166-497c-9caf-b6b2663459aa",
      target: "e61797c5-0e86-43b0-b567-9dc8484a534e"
    },
    {
      id: "559b66f7-5297-4940-94f1-9ac8a7653f72",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fadfcd2f-b166-497c-9caf-b6b2663459aa",
      target: "a18ac117-c0f1-48ed-b78c-c8916b3f901d"
    },
    {
      id: "c07b893d-2461-407c-a84b-3be50747e646",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e61797c5-0e86-43b0-b567-9dc8484a534e",
      target: "7a9612f2-5aa3-4f81-a5f5-5288bb093469"
    },
    {
      id: "9f247e14-425d-4cd1-b8d0-1e77563a6b87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a9612f2-5aa3-4f81-a5f5-5288bb093469",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "4064e8e8-f1fa-4416-942c-8ac88458e647",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a18ac117-c0f1-48ed-b78c-c8916b3f901d",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "3e96db17-94ce-4c2a-92cd-f402fc95b542",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5b8b86e-3fbf-4924-8029-6639ba1f52d1",
      target: "943b1642-e7aa-48cf-80ce-f71213c95094"
    },
    {
      id: "6da1d8c0-1083-4752-8f1a-70fcb5b95563",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5b8b86e-3fbf-4924-8029-6639ba1f52d1",
      target: "37391e7e-c3d7-44f2-8045-e4dd1889d44d"
    },
    {
      id: "1236b30c-6e0b-4886-b51d-adf3a3bc4f91",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "37391e7e-c3d7-44f2-8045-e4dd1889d44d",
      target: "943b1642-e7aa-48cf-80ce-f71213c95094"
    },
    {
      id: "d915c2a6-e855-4bc7-adb1-485b7847cf88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943b1642-e7aa-48cf-80ce-f71213c95094",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "0091421b-6f61-457f-b46a-d723233fa82a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "a61a14d9-893d-4d6f-bd6c-6e40803b9ec9"
    },
    {
      id: "02ad0b96-4535-4def-a81b-59f95bac6783",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "20162ba7-1bc4-4672-bd33-91522a8f7102"
    },
    {
      id: "429d2e46-c4b0-4040-a00c-0ee9ea05dfac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "55638641-d157-42f2-83ac-2827272165c1"
    },
    {
      id: "9a45d3b7-6c54-445b-89e3-fe025fea8484",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "a2c0d744-0668-4a8c-aff9-53d075297491"
    },
    {
      id: "feee55bc-9cc0-4c85-8647-d1266952359a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "c2c788be-70d3-4d6d-baf9-69443a81e769"
    },
    {
      id: "1f52b478-2518-47b5-b368-f7749fc17ed0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bdb7124-d7ea-448e-8756-317e8382021f",
      target: "b5cad504-4c19-47d3-9504-84212010cfb7"
    },
    {
      id: "abf40bc3-72f7-422a-8228-1b5df8193823",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c2c788be-70d3-4d6d-baf9-69443a81e769",
      target: "a16999c0-7e60-4536-99f6-4c3959445c24"
    },
    {
      id: "f2bb4b20-a7a6-4a05-9d95-50bf3ec76e4b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c2c788be-70d3-4d6d-baf9-69443a81e769",
      target: "a16999c0-7e60-4536-99f6-4c3959445c24"
    },
    {
      id: "a776024a-aec8-45ba-8736-ce08e8dfef29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a16999c0-7e60-4536-99f6-4c3959445c24",
      target: "3cd8c2ae-1020-4a4b-afe4-81cf3e011402"
    },
    {
      id: "642000db-1ba6-4f3a-bbd5-10683ab8dfa3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20162ba7-1bc4-4672-bd33-91522a8f7102",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "e6a4cce8-cc8e-4c9b-abf9-1f474ed09204",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5cad504-4c19-47d3-9504-84212010cfb7",
      target: "b1c7f70e-5291-4b35-8fcd-f3a7dd24145e"
    },
    {
      id: "04b994a2-0dab-4f65-81ae-bad5b473d07b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5cad504-4c19-47d3-9504-84212010cfb7",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "618b4066-1b2d-49fa-a53a-84b2e5d9372e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2c0d744-0668-4a8c-aff9-53d075297491",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "c73226a0-185c-40e0-9dd5-88f0256acd63",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55638641-d157-42f2-83ac-2827272165c1",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "bb7aadc0-bd08-4b08-a9dd-a4f8be772d13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a61a14d9-893d-4d6f-bd6c-6e40803b9ec9",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "5d724abb-da56-4a67-99f1-ec7b1bfe7225",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "22639a6b-2088-4384-85cf-9f93aba02ac9"
    },
    {
      id: "21c331a9-5f5b-425b-b869-b863916cb01e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "63f50e60-6bf4-43ef-afc9-b7259a6623a5"
    },
    {
      id: "696013cd-9921-4a3d-9e78-01c5385017df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "19724f51-5141-4c60-b555-4054884085c7"
    },
    {
      id: "411137be-39b5-47af-acda-eca26a3d5fd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "51a8b01c-29fe-4065-a1d4-8ba3d6a4eeda"
    },
    {
      id: "b5da2dac-66db-40bb-8ca6-92d3fdecdb3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "7a91b721-ec5e-45ec-beb7-3df106555700"
    },
    {
      id: "26203afd-1c8e-4404-82e3-029212fec49d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "46f47d04-68c2-48e2-9b7f-622c57abcd4c"
    },
    {
      id: "4ef2fdd1-a663-47c3-a515-a4e5f8b8ca21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "6f36d7bf-6fae-4a45-a26e-36e83757bb2e"
    },
    {
      id: "e1eaabf2-bfa5-4a45-b24f-03d6b124cf67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "428d9872-6a5e-4a1f-8a6f-e5fcde83c629"
    },
    {
      id: "f17eacf6-4329-4e95-9a18-c7e93eb37f81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "ca560bd7-d327-488a-b332-09f46c329883"
    },
    {
      id: "7293cd3e-7713-4e0e-9a58-c12858fce8b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "9da0335d-c875-4f71-b1f7-b24826145553"
    },
    {
      id: "0c64b279-41b7-4522-a6c2-88588dd1dede",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "35697f12-0557-4de0-9cd6-a3ebbc175e3e"
    },
    {
      id: "59f1f4c7-64de-4e4e-9c02-683b443ca525",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "979d5de6-426b-4112-8ce3-93b6b5a4939b"
    },
    {
      id: "966b8093-2e62-43f7-9349-61f7f940b4fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "1678f18e-fc5c-4ef4-bb50-297ff52db482"
    },
    {
      id: "033e43c7-cc61-44e9-851a-257e266acfe4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b691fb-8041-4ba5-904d-a0e67c43af88",
      target: "198b11a0-ccbe-4d1b-89f1-0f0ab0b4c1b1"
    },
    {
      id: "cf10be97-2353-4ebc-ae33-289edec9b5f4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46f47d04-68c2-48e2-9b7f-622c57abcd4c",
      target: "8f7731d7-1369-4c8b-a29f-5b018d12f8a1"
    },
    {
      id: "9d701e42-ea90-4bca-b89f-38f389c07437",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46f47d04-68c2-48e2-9b7f-622c57abcd4c",
      target: "8f7731d7-1369-4c8b-a29f-5b018d12f8a1"
    },
    {
      id: "a9b1564e-c409-4a47-97f1-0c5810ecf4cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9da0335d-c875-4f71-b1f7-b24826145553",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "4c24abe6-c89c-4036-8995-e22ab339f9f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f7731d7-1369-4c8b-a29f-5b018d12f8a1",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "5abf2f91-d768-48ed-aa87-2217b10ffdb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "428d9872-6a5e-4a1f-8a6f-e5fcde83c629",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "f5037262-274b-4ee0-98fa-d2a0cb189fcc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63f50e60-6bf4-43ef-afc9-b7259a6623a5",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "3d5d4e8d-6a03-4e1d-8cc6-1ec2d64ae416",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "198b11a0-ccbe-4d1b-89f1-0f0ab0b4c1b1",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "e1ba2b56-d631-4de1-8696-bedaf94ac309",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35697f12-0557-4de0-9cd6-a3ebbc175e3e",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "19f41962-31a1-4d04-8e08-3a38b023316a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19724f51-5141-4c60-b555-4054884085c7",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "a9afe5f8-1825-4d1c-b008-b99610c8867e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a91b721-ec5e-45ec-beb7-3df106555700",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "93d13551-9ea2-41ee-a202-f7ac06bfddac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1678f18e-fc5c-4ef4-bb50-297ff52db482",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "c340131a-3220-4b6b-9e56-4c3367c9493a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "979d5de6-426b-4112-8ce3-93b6b5a4939b",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "ca2758f5-4ec2-4ed6-adb6-8fedefd1467b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51a8b01c-29fe-4065-a1d4-8ba3d6a4eeda",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "81f0c162-91fe-4ba3-9edb-6f3180694a48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca560bd7-d327-488a-b332-09f46c329883",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "1b76ea3a-635c-4d41-926d-fa4171e0ef0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f36d7bf-6fae-4a45-a26e-36e83757bb2e",
      target: "3c238586-ddab-405d-af44-e1ca2dac8412"
    },
    {
      id: "7886f8f5-2f7c-4292-8b7c-8717243bb47d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22639a6b-2088-4384-85cf-9f93aba02ac9",
      target: "2bbca2bc-ce2a-4037-bb48-b173feb3744c"
    },
    {
      id: "46ba8228-810c-4152-baac-99ac41dcc12a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "55060ad7-412c-4bde-85c9-477d57ba3a95"
    },
    {
      id: "af6044dc-b16a-4f8a-b342-b2389eef0359",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "eeac0a3c-cfc1-4dd1-9201-0aa3a98b96e7"
    },
    {
      id: "352b5624-d8d1-413e-8dc2-674dcefc0958",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "073a2bc0-01c0-4c57-a9b9-8bfb23adf20e"
    },
    {
      id: "bc59f746-df93-4ff5-ad2e-e1010af32a06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "1817c6e8-3d26-4b2d-9562-c650ce4d3977"
    },
    {
      id: "e736e29e-b3c8-427e-b5a5-295a8229ce80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "4ba9e176-dcd7-4687-ac34-49af0db8707b"
    },
    {
      id: "a9c3dcd8-89f8-402c-976e-636b99743add",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b799e883-fef0-453b-a1de-e82ebda8573b",
      target: "10e73e0b-3323-4daf-81c1-f5ae99a301d8"
    },
    {
      id: "4f011a9f-0cd8-44d3-b2ff-8c5bc0450b2e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "55060ad7-412c-4bde-85c9-477d57ba3a95",
      target: "b883c317-a92b-4f9a-94cb-8d48623a4072"
    },
    {
      id: "b8856e26-da36-4d82-b6ff-a93ac3d8e730",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "55060ad7-412c-4bde-85c9-477d57ba3a95",
      target: "b883c317-a92b-4f9a-94cb-8d48623a4072"
    },
    {
      id: "38727725-c0a9-4014-95a4-495296f03db1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b883c317-a92b-4f9a-94cb-8d48623a4072",
      target: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456"
    },
    {
      id: "c69222f5-9475-4e41-8190-faecb63ed377",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1817c6e8-3d26-4b2d-9562-c650ce4d3977",
      target: "94e42a73-c094-42b9-bf96-cc2358fbeb81"
    },
    {
      id: "3fceb497-7a9d-427c-8e55-fb24377df31b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ba9e176-dcd7-4687-ac34-49af0db8707b",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "0585aa52-111b-4b9c-a3f3-3abee58fc53c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeac0a3c-cfc1-4dd1-9201-0aa3a98b96e7",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "e96b8922-1c2a-4008-a858-93b00c8dcbf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10e73e0b-3323-4daf-81c1-f5ae99a301d8",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "f9b0057b-fcf2-4b0f-bf44-a3ce3cedefed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "073a2bc0-01c0-4c57-a9b9-8bfb23adf20e",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "aaef444b-62df-4d55-92bf-c798478904fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "1feb1c4a-7edd-4368-ba99-a6aced1de914"
    },
    {
      id: "918e84c4-6183-410b-b650-55c056673a23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "54ffb185-2a3c-45de-8a3a-fb9a2d5d0f15"
    },
    {
      id: "1effc880-9221-4594-a90b-838ea84b7895",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "77382489-0386-4657-9939-e0d917fd8b8a"
    },
    {
      id: "7833ebb1-9717-4ad9-a519-5a9a9d6a8a3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "5001069c-b464-4458-8ac3-b61918fa2091"
    },
    {
      id: "9e3a2db7-4ec3-43db-8dac-3423d02867b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "6aca4f91-66bc-4158-b0fd-2177a79f139e"
    },
    {
      id: "1cdc49b9-f30c-4d1a-896e-a5e540d58ce2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea926f55-4871-463e-be6b-5020ac311c5f",
      target: "0da0d610-ed6c-4ef4-8518-8ba7e958c25c"
    },
    {
      id: "ffa27948-cba8-45a1-b327-61a191e6d238",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0da0d610-ed6c-4ef4-8518-8ba7e958c25c",
      target: "1124313a-6f29-41cd-9c87-5ed39b5cc6a9"
    },
    {
      id: "8e73936e-a357-4909-8870-6fb09d89357b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0da0d610-ed6c-4ef4-8518-8ba7e958c25c",
      target: "1124313a-6f29-41cd-9c87-5ed39b5cc6a9"
    },
    {
      id: "b9b6ae15-9fee-4b2a-8a94-bf5414aa7579",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1124313a-6f29-41cd-9c87-5ed39b5cc6a9",
      target: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456"
    },
    {
      id: "7774c36b-2b3e-4190-9a7e-2a0b2794e67f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54ffb185-2a3c-45de-8a3a-fb9a2d5d0f15",
      target: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456"
    },
    {
      id: "cdb85e0b-2102-4aca-967f-1a46d7a35fad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6aca4f91-66bc-4158-b0fd-2177a79f139e",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "b8e8d43e-dfc5-494c-8c92-417e2f3827bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5001069c-b464-4458-8ac3-b61918fa2091",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "f869230f-15e1-4244-b9ed-04bbeae952e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1feb1c4a-7edd-4368-ba99-a6aced1de914",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "ae6745ae-10d9-4ec0-9570-02774ee4af02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77382489-0386-4657-9939-e0d917fd8b8a",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "6b95e317-02a2-4975-bb64-52bde4dfc2a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "f0fb3a25-e2d6-483f-a95e-ba5d9e7f7ecc"
    },
    {
      id: "8112f007-1cdf-467b-965a-421cf49a6950",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "fbdee150-1e65-4a43-8f20-ecd6cd36736b"
    },
    {
      id: "56a7bce9-c616-4f1f-81b6-4cb580448140",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "fc0932fe-3a0d-4101-b7dc-c7b486b7b6ca"
    },
    {
      id: "0fcd516a-2901-4f3b-bfac-a032edca8031",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "c2465daa-bbb5-4c1d-bab0-66078bd51345"
    },
    {
      id: "f6cc164c-0c96-42f4-be3f-4ba3bd3f0723",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "b0915ac9-c21c-4a06-89fd-3ce504b45794"
    },
    {
      id: "04df9bea-10ef-437a-8c34-4cf9ae16417a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "d733b440-09c3-44d0-9543-b08cc608da33"
    },
    {
      id: "c32e78cb-d36f-4dfc-aa39-2de8d70d9f99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aca1855-4070-4470-9d81-e3461d849d96",
      target: "597afc40-be93-4b84-9181-d324bcbe88b4"
    },
    {
      id: "b5d20e24-e10f-4422-aa10-e22801e288f2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fbdee150-1e65-4a43-8f20-ecd6cd36736b",
      target: "e32c8e33-ee0a-4c52-84c0-163264afcce6"
    },
    {
      id: "98521d94-dc09-4739-8050-b553e54e8919",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fbdee150-1e65-4a43-8f20-ecd6cd36736b",
      target: "e32c8e33-ee0a-4c52-84c0-163264afcce6"
    },
    {
      id: "1935b43b-165b-4b29-ad21-e52078d47719",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e32c8e33-ee0a-4c52-84c0-163264afcce6",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "684ad7bf-96f9-46e9-9e84-9806f53f2772",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d733b440-09c3-44d0-9543-b08cc608da33",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "159a033f-1dbe-489f-a738-c43dcd0318e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0fb3a25-e2d6-483f-a95e-ba5d9e7f7ecc",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "628c9536-c52f-4559-93a7-0b34dc6ad9ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2465daa-bbb5-4c1d-bab0-66078bd51345",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "132781d7-a3ea-438d-8994-efacb609c957",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0915ac9-c21c-4a06-89fd-3ce504b45794",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "14774fd4-ee05-410b-ac9f-f1eb89201819",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "597afc40-be93-4b84-9181-d324bcbe88b4",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "933f95da-f369-44d1-ada8-4bbbb8ecfed9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc0932fe-3a0d-4101-b7dc-c7b486b7b6ca",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "407bbd0c-08f5-4d6e-8708-0f07ede120dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "f8187294-0b5f-474e-ac87-700645a38479"
    },
    {
      id: "226fccf9-fc65-44b3-9782-cb3a6d1c5dc0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "29bf1e57-797a-4668-8c02-fc9762cecb45"
    },
    {
      id: "50e9a145-1514-4342-b668-572ea796f5e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "a74b62a7-d2ed-4f7b-8fab-77c511632bc3"
    },
    {
      id: "949816c4-d797-4f86-a8c4-8a132c2518d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "28ad431d-8ff4-4c97-aaff-75a7a5f61e17"
    },
    {
      id: "f074d018-396f-43ac-8fa4-c27b0718eec0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "1b8ab6ca-eb09-458a-a337-cdf4e4c1a5e5"
    },
    {
      id: "07a3c8b4-8e7b-41fd-8507-207ba26963e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4f53932-751d-4cbd-8bdf-2a93d9cb4e18",
      target: "fd12e491-8635-4a1a-8d1b-a327e36d6c10"
    },
    {
      id: "14accdc1-92f6-4184-9dd9-96cbaab9458c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fd12e491-8635-4a1a-8d1b-a327e36d6c10",
      target: "8737aec1-769f-4997-b052-9786f6ca3288"
    },
    {
      id: "8b177817-19b1-45c8-a951-2e22067aff1f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fd12e491-8635-4a1a-8d1b-a327e36d6c10",
      target: "8737aec1-769f-4997-b052-9786f6ca3288"
    },
    {
      id: "e9cf3f18-6914-4256-94c8-48af3c2dcca9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8737aec1-769f-4997-b052-9786f6ca3288",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "4e061538-eabe-4933-a4bf-9fca29de1da6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29bf1e57-797a-4668-8c02-fc9762cecb45",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "c7a859da-8156-48b4-b09c-92859e586dbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28ad431d-8ff4-4c97-aaff-75a7a5f61e17",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "95711afc-4374-4020-9324-6140c31aa6a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b8ab6ca-eb09-458a-a337-cdf4e4c1a5e5",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "6ecfc734-1e06-48d6-bdb4-947d641092dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a74b62a7-d2ed-4f7b-8fab-77c511632bc3",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "2f17877a-8fb7-4bd1-bb15-67eaf5f80f0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8187294-0b5f-474e-ac87-700645a38479",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "a989deb4-b750-49eb-8d63-12f0cd758a38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "6ab96289-f544-47c7-acd5-c4e2650185bb"
    },
    {
      id: "3786df4c-8e6c-49d3-b110-15ad01fc8e0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "99d8d2ec-0f62-414b-bed1-909ecf4cd65d"
    },
    {
      id: "85484ea7-329b-4966-bf29-53893eca75a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "6fedb5af-cbb1-4db1-b57a-5e9c3b742bdb"
    },
    {
      id: "20901c8b-1fcb-4743-b21c-b9143de6735c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "d9da5ebd-01e2-4c37-bd1f-888c5ec86252"
    },
    {
      id: "3998979e-84ab-4c4d-aa59-65b41aaa5c97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "c6ed857f-a909-4e2f-bec3-47bc88bdb882"
    },
    {
      id: "1fc0d18a-fb53-4671-a328-18e1f1cfbd65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6089950-d5ed-48a5-a295-699129837b6c",
      target: "c12fa46c-dd0b-4715-8b99-14c14ff991e9"
    },
    {
      id: "279efefd-ab32-467a-a804-6fdfeb963f0c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6fedb5af-cbb1-4db1-b57a-5e9c3b742bdb",
      target: "d9a5b98e-cd43-4907-beec-d9636b0efc25"
    },
    {
      id: "980d313f-30a2-4dcd-a30e-ba4b459e8238",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6fedb5af-cbb1-4db1-b57a-5e9c3b742bdb",
      target: "d9a5b98e-cd43-4907-beec-d9636b0efc25"
    },
    {
      id: "ac4c11a0-671a-49c2-a10a-1976b768b54a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9a5b98e-cd43-4907-beec-d9636b0efc25",
      target: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0"
    },
    {
      id: "2125b3d0-1dd0-4978-bd20-518ce0e478cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c12fa46c-dd0b-4715-8b99-14c14ff991e9",
      target: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a"
    },
    {
      id: "cb93a453-f09f-4ef3-a8fe-ac2fc8929a2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9da5ebd-01e2-4c37-bd1f-888c5ec86252",
      target: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc"
    },
    {
      id: "c0b6e106-6d43-4e11-a3fe-280c216beff5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9da5ebd-01e2-4c37-bd1f-888c5ec86252",
      target: "aa74099b-0c1f-464d-ba37-712d8efd9636"
    },
    {
      id: "b9fa6a8f-c10a-4131-ae6f-87b9d0ce45e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ab96289-f544-47c7-acd5-c4e2650185bb",
      target: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0"
    },
    {
      id: "9ba9a5c0-a2ad-4732-abaa-06c6a592245c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99d8d2ec-0f62-414b-bed1-909ecf4cd65d",
      target: "357c010b-aa25-4aeb-860c-f7b7b050e152"
    },
    {
      id: "452ebc74-903b-4f3d-a59d-c29087fcc759",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6ed857f-a909-4e2f-bec3-47bc88bdb882",
      target: "c400db76-d6aa-4187-b34c-89cd23e11458"
    },
    {
      id: "b7e38d3a-7299-4f73-9739-c19d458ae44d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e85a57a-7801-4bf1-8705-771cb893951d",
      target: "5004e0d5-4281-4d3d-9228-d500697f5f44"
    },
    {
      id: "629b505c-ae82-41c2-af23-e807f2f6c1d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e85a57a-7801-4bf1-8705-771cb893951d",
      target: "fffd307a-99ff-41fb-a441-d9c6b8c85970"
    },
    {
      id: "df7b6941-52a7-4a78-808f-b2249d758d7f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5004e0d5-4281-4d3d-9228-d500697f5f44",
      target: "63e0e025-62ab-4435-a2aa-6cd5c04c377f"
    },
    {
      id: "16e15984-1c0e-464f-81f1-3c9ff3a4bcce",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5004e0d5-4281-4d3d-9228-d500697f5f44",
      target: "63e0e025-62ab-4435-a2aa-6cd5c04c377f"
    },
    {
      id: "17d2b9d6-c5db-4c51-8d3b-bf2383d59af2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63e0e025-62ab-4435-a2aa-6cd5c04c377f",
      target: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0"
    },
    {
      id: "be76eb8b-d6e0-41b4-802b-5e94ac699ce4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fffd307a-99ff-41fb-a441-d9c6b8c85970",
      target: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a"
    },
    {
      id: "799b41ba-7d9c-4c01-adda-0de84e649832",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "412d2c94-a09f-43ff-b373-c84f4d6ab8db",
      target: "5454c703-49ce-4aa8-ae74-dd2b1e50f616"
    },
    {
      id: "2deb6c73-fea3-4026-98f6-0bfc66c9d38a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "412d2c94-a09f-43ff-b373-c84f4d6ab8db",
      target: "74981eb1-fb0b-4ade-9ca7-fe619bbe96d0"
    },
    {
      id: "a2b3d823-0ffc-48b4-be6b-42d49e282801",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "412d2c94-a09f-43ff-b373-c84f4d6ab8db",
      target: "43902eda-cb7f-4e23-a5bc-75e4a5811ffc"
    },
    {
      id: "1c2426e2-2d2b-4ce4-8b3a-564583f86a60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "412d2c94-a09f-43ff-b373-c84f4d6ab8db",
      target: "ac7f1e44-9b71-4772-9acc-b8127cb064e0"
    },
    {
      id: "a04a78d0-d827-4516-bd9f-b3d642185c81",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ac7f1e44-9b71-4772-9acc-b8127cb064e0",
      target: "00ce9663-4d82-4cb0-9f19-1f07e53ab61d"
    },
    {
      id: "6df02f6b-3537-479a-8fde-42ae70ffb837",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ac7f1e44-9b71-4772-9acc-b8127cb064e0",
      target: "00ce9663-4d82-4cb0-9f19-1f07e53ab61d"
    },
    {
      id: "78145b53-10ee-42a2-9cc0-2c11c0acacf0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00ce9663-4d82-4cb0-9f19-1f07e53ab61d",
      target: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52"
    },
    {
      id: "7268cb16-d435-4418-86de-2d7046a018f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74981eb1-fb0b-4ade-9ca7-fe619bbe96d0",
      target: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e"
    },
    {
      id: "d7874456-b6e0-4fbf-8ff0-266819ebdce8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5454c703-49ce-4aa8-ae74-dd2b1e50f616",
      target: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61"
    },
    {
      id: "6a99ecbf-7d28-4da2-8d15-2afcbc81c178",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43902eda-cb7f-4e23-a5bc-75e4a5811ffc",
      target: "98a5d32d-2029-4533-a0a7-ca859f808f68"
    },
    {
      id: "6236fe20-ef37-4ffb-b876-42cfde936fbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "f58e96f8-5113-4a4c-a813-96d5b11bae19"
    },
    {
      id: "c0b5e724-ccf4-4bdc-b20f-f9462b66e262",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "a321561c-165e-49fa-b74e-53e640dc2f2b"
    },
    {
      id: "65761c26-49a1-4e05-a093-53b2918d945c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "22d64dfd-22a5-499b-9a9b-ed392e929ee5"
    },
    {
      id: "5cc7e561-251b-4888-a849-e887c6019d8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "13fc09ba-4560-4a10-9eb9-d9ad6079915a"
    },
    {
      id: "1b7ac47e-0828-4626-94c4-9d92d3ba234b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "75e5eb31-9aa7-4c4f-a9ca-c1cc2b77ac85"
    },
    {
      id: "185c1c53-60d0-4c96-988f-758f811f7ce9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "d6ebdbac-2949-427a-84c8-e05c772b1c47"
    },
    {
      id: "b32123ef-52c9-4ad8-bab8-55d8d655e5fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "25c2bdc0-9feb-463e-a893-1dbf95d92b97"
    },
    {
      id: "c2775e54-8137-4b32-9f70-6c1660fd2d2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "1b2897ec-bdb6-4b9b-8b6d-12512ccbcb8f"
    },
    {
      id: "ff053120-6d9c-4d7b-b496-1eb6ef7e1a40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "78f1bbbc-e57c-4c48-bdad-0c9b1e95ecdf"
    },
    {
      id: "b7023437-2975-4b81-a427-7e7f2dcf0aac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "6b8d202d-741c-4df6-a1db-08aa839d2dec"
    },
    {
      id: "f99a5277-6fa1-49f8-8b3b-798ba0b81037",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "07d5b9e0-ca27-4637-bf5c-8a50fdfa966f"
    },
    {
      id: "f3a8eceb-ab9b-40ed-b008-a064e1e34318",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "7ea3ceb9-347c-4806-8aff-0fc1ed4f79e3"
    },
    {
      id: "d4184eed-dcea-45e1-8ca7-83f329f436a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "1843b881-fbde-490a-9867-6b8dbf7b7ea5"
    },
    {
      id: "e491a919-cb94-403c-aeab-e89005b642f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "efcc0cb2-c398-4f5b-9920-0bdedf37cc64"
    },
    {
      id: "6c211b12-48ca-4dba-bb24-0481cd70cb9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "72880b0e-8d3c-4b84-b336-4427b77512d2"
    },
    {
      id: "4bcd3f4c-2d13-4528-8e37-fc748413475d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "705144c6-33d4-4989-8929-70d4546d8cbf"
    },
    {
      id: "9e14ff4d-19e6-4317-86b6-b27735e9b8f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "bf6f2460-1cc3-468d-9158-fae614d9a8d6"
    },
    {
      id: "d0fa2267-fd49-4f13-9841-3b405167a159",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4afc810d-85af-4009-ad12-51462618da45",
      target: "ab33c3e1-21fe-4e93-a1ee-9e43e843ebe5"
    },
    {
      id: "71bb7921-4358-4b54-9e0e-03ff2fc6d675",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a321561c-165e-49fa-b74e-53e640dc2f2b",
      target: "caad4353-1878-4ff3-a531-4c41e6c0519d"
    },
    {
      id: "a8939121-4158-4151-aaeb-ed646bcc9ce9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a321561c-165e-49fa-b74e-53e640dc2f2b",
      target: "caad4353-1878-4ff3-a531-4c41e6c0519d"
    },
    {
      id: "6504e2e2-bfd9-474c-a379-301ce3abe480",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "caad4353-1878-4ff3-a531-4c41e6c0519d",
      target: "ecf57043-4fc4-4c73-afa0-056b30ec5da7"
    },
    {
      id: "be222930-45d4-4b34-912c-720223b61198",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "caad4353-1878-4ff3-a531-4c41e6c0519d",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "f0e75a6f-b1d9-4d54-9a7e-5273bc757bab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "caad4353-1878-4ff3-a531-4c41e6c0519d",
      target: "b5c5f4e6-7ed6-4631-a437-dda89bf7a383"
    },
    {
      id: "ff3ae3f3-a976-4718-beba-54203a9ac3a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "efcc0cb2-c398-4f5b-9920-0bdedf37cc64",
      target: "8511dc97-c3c7-4750-8595-9ff466cf02c9"
    },
    {
      id: "fbd62ff3-0851-45df-a284-4618bda3dbf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07d5b9e0-ca27-4637-bf5c-8a50fdfa966f",
      target: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b"
    },
    {
      id: "ffbbcc3b-e33f-4ca8-98cf-944bcae36cf8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22d64dfd-22a5-499b-9a9b-ed392e929ee5",
      target: "4cb4ee67-ae43-423f-b23c-0b9fbec64286"
    },
    {
      id: "8f279cdb-08a5-41a9-bf51-2c603a68d959",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b2897ec-bdb6-4b9b-8b6d-12512ccbcb8f",
      target: "29d8126e-d41e-44c0-ac74-b21977de94af"
    },
    {
      id: "9b2d4c16-e18a-4b85-b032-c5182443d6ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1843b881-fbde-490a-9867-6b8dbf7b7ea5",
      target: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea"
    },
    {
      id: "014a90b6-af00-4f31-8d88-d6d903527db7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ea3ceb9-347c-4806-8aff-0fc1ed4f79e3",
      target: "84b2c487-8d68-483b-b6f2-2a89b54fccb9"
    },
    {
      id: "7cfd9b18-c144-46c5-966c-fb9ceea90c31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75e5eb31-9aa7-4c4f-a9ca-c1cc2b77ac85",
      target: "eac066a0-891a-4d9e-b0a4-469228a55362"
    },
    {
      id: "5741e93f-bfc4-4a15-bd08-515a97b04e4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72880b0e-8d3c-4b84-b336-4427b77512d2",
      target: "62282871-afe9-4a4d-995a-7a4479435a38"
    },
    {
      id: "c387459a-5a25-49e5-a9b8-cbaa719aca48",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bf6f2460-1cc3-468d-9158-fae614d9a8d6",
      target: "48541c8a-033a-4715-9f63-6fa88aa4fa61"
    },
    {
      id: "f17cc829-26d8-443e-93be-92cea84c7bdb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bf6f2460-1cc3-468d-9158-fae614d9a8d6",
      target: "48541c8a-033a-4715-9f63-6fa88aa4fa61"
    },
    {
      id: "b0c1fa4e-1b04-42cc-9310-92b0347dec58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ab33c3e1-21fe-4e93-a1ee-9e43e843ebe5",
      target: "84b2c487-8d68-483b-b6f2-2a89b54fccb9"
    },
    {
      id: "cc1826a5-7b69-4191-b291-eba19e66b037",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48541c8a-033a-4715-9f63-6fa88aa4fa61",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "bfa07e35-8315-4efc-a91e-ea0911be8da0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58e96f8-5113-4a4c-a813-96d5b11bae19",
      target: "8511dc97-c3c7-4750-8595-9ff466cf02c9"
    },
    {
      id: "09354565-6153-4b34-9cf0-8b22ac1a7420",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "25c2bdc0-9feb-463e-a893-1dbf95d92b97",
      target: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b"
    },
    {
      id: "a86b338f-8fc1-4406-9944-aed1fb3bea93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "13fc09ba-4560-4a10-9eb9-d9ad6079915a",
      target: "4cb4ee67-ae43-423f-b23c-0b9fbec64286"
    },
    {
      id: "24e7df01-5300-4d45-87bb-67a0a8229dd9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6ebdbac-2949-427a-84c8-e05c772b1c47",
      target: "29d8126e-d41e-44c0-ac74-b21977de94af"
    },
    {
      id: "f89db806-0071-420f-8fbc-fba33571baa1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78f1bbbc-e57c-4c48-bdad-0c9b1e95ecdf",
      target: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea"
    },
    {
      id: "1f82811b-0c25-439f-8057-78a2a8f4c6ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b8d202d-741c-4df6-a1db-08aa839d2dec",
      target: "eac066a0-891a-4d9e-b0a4-469228a55362"
    },
    {
      id: "ebdc7688-886e-4d78-b13c-626ad544851b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "705144c6-33d4-4989-8929-70d4546d8cbf",
      target: "62282871-afe9-4a4d-995a-7a4479435a38"
    },
    {
      id: "f4d5d0da-2713-4a9a-a4bc-c22281c0cc97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "97fa2136-85a6-46f2-b6ff-31c8316c4807"
    },
    {
      id: "0d8f30f6-5b88-4aa0-a16c-58002bceabee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "a3f4952d-d626-4cf3-b9e8-36212610c179"
    },
    {
      id: "15a09b4e-899b-4ff9-b5de-812ffa2a9d7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "4c488272-6226-418b-9d05-ea836ba039f3"
    },
    {
      id: "ceabbeba-e06c-4ca8-ae89-5b76b5b6313b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "9d63f511-01fd-48d5-a29a-dbfac03f8787"
    },
    {
      id: "296b05de-85fd-4f03-a78d-834d5a05c630",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "e711134d-8fc9-4c96-bd33-08148f81eb44"
    },
    {
      id: "ee5ffed7-2f56-42b2-a812-e46a2678dcf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "5d4387c3-45cd-4fda-8b4e-9428400cf2e8"
    },
    {
      id: "72f9c26e-0c6e-404a-83a1-2e6657b9be79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "990a9e68-133e-417f-9881-f6c90d67f4be"
    },
    {
      id: "50a0fec8-4a30-4818-860a-9654d63695e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "9ff69100-bc9a-4cc4-b9bd-1092e5aec233"
    },
    {
      id: "dede8fe9-1910-4ced-bd7b-b13b3f2b1a22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f7c5831-d6a3-4abf-a251-5147b68351f2",
      target: "3ba7914f-29c8-4baf-9d93-4b416557f236"
    },
    {
      id: "a3576d50-746d-48cf-80dc-3399bde98f77",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a3f4952d-d626-4cf3-b9e8-36212610c179",
      target: "4c0f7fd4-b610-437f-93ea-ccf6086e1f21"
    },
    {
      id: "3f04e85d-69df-448a-9701-e13a7bc37459",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3f4952d-d626-4cf3-b9e8-36212610c179",
      target: "4c0f7fd4-b610-437f-93ea-ccf6086e1f21"
    },
    {
      id: "3e119d4a-3383-4026-bc99-d725e366aef7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d4387c3-45cd-4fda-8b4e-9428400cf2e8",
      target: "84b2c487-8d68-483b-b6f2-2a89b54fccb9"
    },
    {
      id: "4298c8b8-7517-4397-b8c1-c10db3010288",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c0f7fd4-b610-437f-93ea-ccf6086e1f21",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "1552f690-95d4-4d1e-9a01-190401d7c731",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97fa2136-85a6-46f2-b6ff-31c8316c4807",
      target: "8511dc97-c3c7-4750-8595-9ff466cf02c9"
    },
    {
      id: "1802899d-f3f4-433c-8e3a-6b53b42b1e20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c488272-6226-418b-9d05-ea836ba039f3",
      target: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b"
    },
    {
      id: "782299cc-3907-4f6e-8a5e-c5e307b27ff2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e711134d-8fc9-4c96-bd33-08148f81eb44",
      target: "4cb4ee67-ae43-423f-b23c-0b9fbec64286"
    },
    {
      id: "c968c890-fa94-4f07-8081-432bb16bdd2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "990a9e68-133e-417f-9881-f6c90d67f4be",
      target: "29d8126e-d41e-44c0-ac74-b21977de94af"
    },
    {
      id: "bb381939-cf71-4b82-95d9-2e5288388db2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ba7914f-29c8-4baf-9d93-4b416557f236",
      target: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea"
    },
    {
      id: "86440344-d665-4966-aeea-2793ebae0806",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d63f511-01fd-48d5-a29a-dbfac03f8787",
      target: "eac066a0-891a-4d9e-b0a4-469228a55362"
    },
    {
      id: "983a2bc6-a8f9-4716-b648-6fef5b78210f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ff69100-bc9a-4cc4-b9bd-1092e5aec233",
      target: "62282871-afe9-4a4d-995a-7a4479435a38"
    },
    {
      id: "9f92d936-7af9-441e-ab43-26e0652808f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "4f44e098-6698-40c5-a1a8-fb6b89c70b5c"
    },
    {
      id: "8a0095bf-7afc-45c3-abcb-75a2f03f94c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "c76ec58f-3fda-4a25-b61e-4b9ef88864b5"
    },
    {
      id: "f136df97-b45b-4334-894d-e5ecbafce86b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "04afbee0-0115-475b-b183-6bab11cb7a66"
    },
    {
      id: "23af7311-6aec-41e8-9130-9cefc67a3713",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "535a341a-1726-44cf-9562-21479d30ef59"
    },
    {
      id: "ac96a2ef-47de-4b37-b9fe-9b74204e926e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "2dce482f-d960-4054-b5d4-46e1a996ea3d"
    },
    {
      id: "2a9e4812-6f0b-4a9d-b2ee-f3a48fa430c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "cd6b3a75-0cca-40a8-9389-38ccefdeb5d8"
    },
    {
      id: "dd27b80e-3c4f-4d4b-aebe-42506a7c51d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "1305292e-8afd-48f6-bdf3-55afaf898c1f"
    },
    {
      id: "bf3c2892-cb4f-4aae-b1c3-156c73b3512a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84647bb3-9204-4384-a921-15a7c2271182",
      target: "2565428a-6ee7-458e-908e-f44e5acdfea4"
    },
    {
      id: "c72f3c2b-c219-4901-b996-200468bdcbba",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cd6b3a75-0cca-40a8-9389-38ccefdeb5d8",
      target: "dda8fe38-85aa-4236-91bf-c9acbecf8cce"
    },
    {
      id: "391c3fc6-8f26-4e7a-86ba-4e0ee3030a44",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cd6b3a75-0cca-40a8-9389-38ccefdeb5d8",
      target: "dda8fe38-85aa-4236-91bf-c9acbecf8cce"
    },
    {
      id: "ca4a6eb3-06a8-40e7-bccd-12ff87656cdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dce482f-d960-4054-b5d4-46e1a996ea3d",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "e7d58d52-6de1-44ab-a071-676ba2ab7789",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f44e098-6698-40c5-a1a8-fb6b89c70b5c",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "3ad8966d-9e8f-4aa0-a880-46489572df75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dda8fe38-85aa-4236-91bf-c9acbecf8cce",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "00bfadc6-5687-442c-b0a4-74720670aa8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04afbee0-0115-475b-b183-6bab11cb7a66",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "a0a85137-32e5-4c29-b228-fd3aa3415a80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2565428a-6ee7-458e-908e-f44e5acdfea4",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "115fc84c-94d6-4058-815f-750467067585",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "535a341a-1726-44cf-9562-21479d30ef59",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "fcd3ac56-e8bb-4e46-af55-d8e3eaeaf0b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c76ec58f-3fda-4a25-b61e-4b9ef88864b5",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "1a1a6bda-2047-4f15-bce9-cfe797cdbafe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1305292e-8afd-48f6-bdf3-55afaf898c1f",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "fab551ac-98a2-4065-8c0e-d77c86d17d7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "18d36f01-43e0-43c0-a45e-b425272c2cc4"
    },
    {
      id: "d2aff168-78a9-4fc7-b1fb-7b1a387afa38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "52433c43-8fc6-4a60-a6eb-07ddf17e2ed6"
    },
    {
      id: "131722ca-8695-4521-bca0-c36ddb0cd98e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "b63f0cab-f66d-4e95-8cf6-9f8db83d674b"
    },
    {
      id: "dbe3e87b-8167-485d-bcb8-f32b01ade328",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "9ccc82da-b9ab-4782-8379-9d46f45ddc40"
    },
    {
      id: "d8991766-ac78-4ee1-866b-44307229913e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "b19dd44a-b6f2-418c-a220-b7b75a1753f9"
    },
    {
      id: "34e6b7a1-ee1f-4b53-b47c-f88bc79789da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "64199729-94de-49c1-acba-051c12420764"
    },
    {
      id: "73dd1d7f-8191-4698-89b6-c029334d6d42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "9af8ef62-2d58-418c-b64a-abf2480870bd"
    },
    {
      id: "ad7214c3-8457-4b8e-ab85-a328664c3ad3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "65b2b2b9-f871-418e-a7b5-e09f901833b3"
    },
    {
      id: "5fd7fe49-1a04-4532-948f-a057f5002814",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "6a3e5d79-5f67-4376-b76c-b49c7cfc1ca5"
    },
    {
      id: "a2734e58-bfcf-41bb-9c5f-03c22d7898d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03114f37-cc78-4108-803d-c47e04c7e85f",
      target: "67b83c41-6c23-46c7-9e0f-ccfffe4510d0"
    },
    {
      id: "3a0a946e-590c-4ec3-ba8e-07265cc1d55c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "67b83c41-6c23-46c7-9e0f-ccfffe4510d0",
      target: "d9b4fdc0-184a-47df-8951-677628252698"
    },
    {
      id: "780b2697-ecb0-4c72-aed0-d82efe07473f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "67b83c41-6c23-46c7-9e0f-ccfffe4510d0",
      target: "d9b4fdc0-184a-47df-8951-677628252698"
    },
    {
      id: "23217f52-127f-4601-8b30-63aa9245080a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b63f0cab-f66d-4e95-8cf6-9f8db83d674b",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "e5f85ff4-b1e1-4cb7-bdb2-dbbbe3c05f34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b63f0cab-f66d-4e95-8cf6-9f8db83d674b",
      target: "802be593-d644-4540-aac9-a98b564c0317"
    },
    {
      id: "65767e36-5d05-4ee9-9cdc-68fcf6e35d10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b19dd44a-b6f2-418c-a220-b7b75a1753f9",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "cd281189-a2b7-4564-9680-d214bdd8075e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9af8ef62-2d58-418c-b64a-abf2480870bd",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "36378fe7-4414-418e-aab8-ea2d0e2ab93f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ccc82da-b9ab-4782-8379-9d46f45ddc40",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "36f31474-8476-459d-b2ae-57de5a8c8a2a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65b2b2b9-f871-418e-a7b5-e09f901833b3",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "42216ecc-d4be-46c0-adcb-aa2588d45c61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52433c43-8fc6-4a60-a6eb-07ddf17e2ed6",
      target: "680102a5-98d3-4616-a73d-a7177e4a70d4"
    },
    {
      id: "f8b5984b-b1bf-48b3-91ac-807c4d5cb8a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64199729-94de-49c1-acba-051c12420764",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "629676a4-7423-42d4-a4df-19b123747edb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18d36f01-43e0-43c0-a45e-b425272c2cc4",
      target: "680102a5-98d3-4616-a73d-a7177e4a70d4"
    },
    {
      id: "5d296965-388f-4aad-95c9-e3ff3faadd81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9b4fdc0-184a-47df-8951-677628252698",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "de787543-44d3-488f-879d-d56ba59e98a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a3e5d79-5f67-4376-b76c-b49c7cfc1ca5",
      target: "aee97459-2415-41ba-a558-125048895c07"
    },
    {
      id: "4bd07595-5976-4cbf-92ef-8968c79641a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a3e5d79-5f67-4376-b76c-b49c7cfc1ca5",
      target: "9478365f-6a8c-4157-b13b-f5a3a975e229"
    },
    {
      id: "caf0b9e0-33f5-4758-865e-24c234619ffd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "e75d2218-3531-449f-8bca-6447a6303425"
    },
    {
      id: "3214195f-23f5-4cda-950b-23057c4a5ac9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "f143f7e2-9bdc-4e7e-864a-fe05a3a3f04b"
    },
    {
      id: "375c55eb-c673-4c26-9ad9-a77cfb06b3a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "3f90229e-0233-4201-a962-f7b17d86b50f"
    },
    {
      id: "aee1f963-3625-4745-b239-98efe80abbdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "95b15abc-0f1f-4d1c-b937-9f48d0736ba0"
    },
    {
      id: "1ef13dee-066e-46c6-8a2e-0ace4db8e033",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "a912fc87-6bd8-4797-a8c6-befebf2dc5e3"
    },
    {
      id: "a8b08803-f11e-4bb8-a0d7-abf93b6bfd1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "4df70c1c-5a26-4572-8ffd-d93daa9d8e91"
    },
    {
      id: "37de722a-0115-44bc-92f0-15a92aee3fcd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "3bc94985-dfed-40e6-894a-2c8f749bc085"
    },
    {
      id: "5e25a6ca-7602-4cb6-b0a2-fb048e2ca1fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "80e923b8-88ee-4958-a8eb-31858531ed07"
    },
    {
      id: "331c8624-3657-4cc0-a99f-5bd433e03f3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "bc36d2de-8620-4035-9890-1c2a9db20fb5"
    },
    {
      id: "bc4d00b6-ea9e-4f82-ae0f-24a573d3f366",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cde2b27-f251-484f-86c0-937857581088",
      target: "169a7a22-09a7-4cd7-923e-29b697c8ad36"
    },
    {
      id: "b8478206-80c7-451c-9eda-a912cce4c770",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f143f7e2-9bdc-4e7e-864a-fe05a3a3f04b",
      target: "3f90229e-0233-4201-a962-f7b17d86b50f"
    },
    {
      id: "e60ce5b4-461d-4fea-8b87-df30060c434e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80e923b8-88ee-4958-a8eb-31858531ed07",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "bdd3297f-6686-4a24-aeca-7bbcc2211821",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80e923b8-88ee-4958-a8eb-31858531ed07",
      target: "f60a73cf-32c4-4c13-bfaf-61c6d9ca9123"
    },
    {
      id: "f564da3a-bdd2-4fbd-bb94-345674b8fcd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e75d2218-3531-449f-8bca-6447a6303425",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "b08edb66-6d90-4675-b87a-fe7d22084987",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3f90229e-0233-4201-a962-f7b17d86b50f",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "2b0f94fd-7619-484d-9a0f-27d0af6cd754",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bc94985-dfed-40e6-894a-2c8f749bc085",
      target: "680102a5-98d3-4616-a73d-a7177e4a70d4"
    },
    {
      id: "572fa94c-e4b5-4644-a9b1-9492ecf386a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95b15abc-0f1f-4d1c-b937-9f48d0736ba0",
      target: "aee97459-2415-41ba-a558-125048895c07"
    },
    {
      id: "551b3092-7881-4712-bcee-49c2fbfff614",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4df70c1c-5a26-4572-8ffd-d93daa9d8e91",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "46b5d8a3-8dc8-4bc2-b2fe-8026b9c21d5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc36d2de-8620-4035-9890-1c2a9db20fb5",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "713ffc93-1aed-4a7c-8570-bbcd059acab7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a912fc87-6bd8-4797-a8c6-befebf2dc5e3",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "cd325a56-7eb5-4639-a18d-70bf4a2ea62b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "169a7a22-09a7-4cd7-923e-29b697c8ad36",
      target: "680102a5-98d3-4616-a73d-a7177e4a70d4"
    },
    {
      id: "fcd91f15-8a94-40f0-abb3-389b46eee292",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4ea056a-3a49-49aa-9006-79a794faea91",
      target: "81112da9-0bc1-415d-b3ce-9552a2a4e8ff"
    },
    {
      id: "8c5671f9-7e4d-43b2-bd06-2e423a2bac36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4ea056a-3a49-49aa-9006-79a794faea91",
      target: "590f4ffc-b101-4f2f-8ce9-db8cb02679f7"
    },
    {
      id: "17c8c053-62b2-49a4-aa31-426eb0af13bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4ea056a-3a49-49aa-9006-79a794faea91",
      target: "9ab13b36-76ee-44b6-8b82-83c09a4b62d1"
    },
    {
      id: "d0a7ac28-36a8-4c61-b649-a952610ef70b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4ea056a-3a49-49aa-9006-79a794faea91",
      target: "027986da-b91b-4966-b05d-799746e9d87e"
    },
    {
      id: "12f741a4-1e91-4e19-9cba-b0b94150c2b0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "590f4ffc-b101-4f2f-8ce9-db8cb02679f7",
      target: "c431b625-4de7-4992-a6e8-a34e8ec3078f"
    },
    {
      id: "047a98de-972e-41f1-b901-81f7d44bff41",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "590f4ffc-b101-4f2f-8ce9-db8cb02679f7",
      target: "c431b625-4de7-4992-a6e8-a34e8ec3078f"
    },
    {
      id: "3eb9777b-81b1-45d2-b79e-d628d0fd896c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ab13b36-76ee-44b6-8b82-83c09a4b62d1",
      target: "1aab4538-58f4-4246-8a27-60f4012d85d6"
    },
    {
      id: "d579506f-a79a-43bb-b4cc-6b4da2c38fd4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c431b625-4de7-4992-a6e8-a34e8ec3078f",
      target: "14a93288-a9ec-4a1e-9927-b17a4c6587db"
    },
    {
      id: "1a9279ba-7f7d-4ef1-9c24-dfa1110ca8b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "027986da-b91b-4966-b05d-799746e9d87e",
      target: "3666d7c1-202c-4c17-81ce-cea597a7a6a1"
    },
    {
      id: "7d38f6b2-a88b-46eb-bd45-d89d52c54732",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81112da9-0bc1-415d-b3ce-9552a2a4e8ff",
      target: "f07e08a6-ffeb-499f-ae9a-822b799d247c"
    },
    {
      id: "56a9ee7a-d123-4829-a7ad-ea9479d93734",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0551c8a7-60d0-4fb6-a1a8-fa83eb9bc539",
      target: "be3e6dec-4b64-42bb-bbf4-24280a6b60fd"
    },
    {
      id: "2a6bd870-f18a-4312-956d-1b19cda6b73c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "be3e6dec-4b64-42bb-bbf4-24280a6b60fd",
      target: "2b4b287d-9b48-4ac0-93b2-efcdc27ce262"
    },
    {
      id: "cfedcc76-72d8-423e-8cb1-f8a7eea78bfe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "be3e6dec-4b64-42bb-bbf4-24280a6b60fd",
      target: "2b4b287d-9b48-4ac0-93b2-efcdc27ce262"
    },
    {
      id: "fc8b6448-79c1-45f6-bdbd-03a20ffd3430",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b4b287d-9b48-4ac0-93b2-efcdc27ce262",
      target: "e246861c-bbe9-4cbe-8eba-3fc48c057f33"
    },
    {
      id: "4791c163-fd2e-4a98-a0b8-c190f1e09fe9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b4b287d-9b48-4ac0-93b2-efcdc27ce262",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "073073a7-d168-45aa-8ea5-b9757666fe70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90321750-8d28-4a30-ab18-5f5e09e5a7a6",
      target: "5df96130-1dbf-4579-9a0b-38a62985adb9"
    },
    {
      id: "172e01dc-2b59-46e0-8f86-ad0991e5cbbc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5df96130-1dbf-4579-9a0b-38a62985adb9",
      target: "df0ba7a8-032c-4c60-96d3-b6927883d18a"
    },
    {
      id: "6928501e-74d1-4dae-bb8e-2fd997e01e2c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5df96130-1dbf-4579-9a0b-38a62985adb9",
      target: "df0ba7a8-032c-4c60-96d3-b6927883d18a"
    },
    {
      id: "412932d6-d92e-42f2-9239-75f8ff45d269",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df0ba7a8-032c-4c60-96d3-b6927883d18a",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "68212115-c9c2-4ed5-9920-71605e8367fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96a9e182-336d-409e-a84b-8d37d1898f5a",
      target: "e166fbbe-0127-454e-8ea8-1ce79e57dff8"
    },
    {
      id: "4d4aebb8-56e9-4d5d-9969-6a46c4ab02d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e166fbbe-0127-454e-8ea8-1ce79e57dff8",
      target: "2463cca4-535e-4c29-aac9-446f2a06f8f3"
    },
    {
      id: "25381dc4-a08b-4824-9e76-8d40660fa0d2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e166fbbe-0127-454e-8ea8-1ce79e57dff8",
      target: "2463cca4-535e-4c29-aac9-446f2a06f8f3"
    },
    {
      id: "8642908d-9e97-4edb-b5f2-8d340caf6f9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2463cca4-535e-4c29-aac9-446f2a06f8f3",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "a3f958b9-fa5c-45ca-8f0a-560336f58702",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c",
      target: "25c6555c-ad06-479c-88a6-9affe166e870"
    },
    {
      id: "07d204e6-e74a-4c56-b7db-b813985f4910",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c",
      target: "b4963bea-6188-4b59-a80a-d9b78bd15943"
    },
    {
      id: "8eeb59e4-a9ae-4ca2-8a96-28ee92f335fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c",
      target: "6909c563-590a-4a8d-b8d0-0a4b9e106a4c"
    },
    {
      id: "1db1c561-f612-4dc3-939d-68f4bc5b8997",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1d4bd76-f215-4ba1-ae0b-69553fe1426c",
      target: "7dbf3131-183b-44a3-8a35-870b34f5b604"
    },
    {
      id: "e3d1747a-aa73-4099-bd0c-c717ac894378",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "25c6555c-ad06-479c-88a6-9affe166e870",
      target: "7f7e9cda-ee86-4bb5-a297-3cf9322c5ca7"
    },
    {
      id: "362f6db2-9324-4196-bd8b-46438047aed7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "25c6555c-ad06-479c-88a6-9affe166e870",
      target: "7f7e9cda-ee86-4bb5-a297-3cf9322c5ca7"
    },
    {
      id: "740bd905-f86b-480b-a7e4-0bca11fe9e16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6909c563-590a-4a8d-b8d0-0a4b9e106a4c",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "dfae5e9d-c4b1-4586-a3d8-0e1e59d2ff26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f7e9cda-ee86-4bb5-a297-3cf9322c5ca7",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "a9cd5d20-182a-400a-99b8-130a7c4355c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7dbf3131-183b-44a3-8a35-870b34f5b604",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "413b8769-59a5-4b13-80ec-323d87c5d96d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4963bea-6188-4b59-a80a-d9b78bd15943",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "18852019-990b-489b-a5d2-1ebbbedfce84",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "14a2565f-aff6-4bd0-a6e9-811ada0de272"
    },
    {
      id: "b75f4847-322c-454d-8332-a33fe44ff3ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "698b4870-d177-4e2b-825b-a74ce2b5bbd6"
    },
    {
      id: "9cf18598-6b46-484c-afaa-10557d11fab2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "b2962ef2-0566-42e3-8162-4525f07eded8"
    },
    {
      id: "086af9d3-d020-4e79-84d5-5e567bbf8cdc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "8d4fc066-79be-40ac-8740-db2e45be0cca"
    },
    {
      id: "4896e4e7-e935-4e72-abc2-3d6e0efff614",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "33d2ca25-798d-44f0-8d98-16b1136565d9"
    },
    {
      id: "0a10ccf6-3ea2-416f-81cb-03d76d7a452f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "17f5d39b-423b-44de-a420-1da1db27ec2e"
    },
    {
      id: "4668ea07-f6ae-4d9b-a792-ea1b7643da22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "d77ae7a6-348a-4b29-b1eb-5fc2b4bfee99"
    },
    {
      id: "098ba659-ac49-42bd-bd22-33f1742f25fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "279c4ab6-97fa-41f3-8300-c0825ad9a7bf"
    },
    {
      id: "3a8ef548-6117-42fc-9acf-70349f091468",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "1cf666a1-1a39-47f8-b106-98e8bddf8846"
    },
    {
      id: "6c622307-3974-4441-8bdc-358fe9a340ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "5166c0bb-8ac7-44c5-ba9b-861c1aad271e"
    },
    {
      id: "42ba35a5-2495-4166-b018-35c7a4ffbccf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e53564-18df-48b5-b5ac-676668893ae1",
      target: "4f122a2f-7d4b-4940-abba-f9b0cba600d7"
    },
    {
      id: "d6248134-27ff-4adc-bfeb-d1ee1ceac88c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "17f5d39b-423b-44de-a420-1da1db27ec2e",
      target: "e24f2ed0-e628-4b51-acfb-fbccdcd7a153"
    },
    {
      id: "f713e9fe-80c4-4f07-a5b4-bdd5931d0788",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "17f5d39b-423b-44de-a420-1da1db27ec2e",
      target: "e24f2ed0-e628-4b51-acfb-fbccdcd7a153"
    },
    {
      id: "e67d8f37-24ef-4721-825a-f208f9009236",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d77ae7a6-348a-4b29-b1eb-5fc2b4bfee99",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "cee47c1a-7c30-4107-88f7-4bfa1ab0b799",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e24f2ed0-e628-4b51-acfb-fbccdcd7a153",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "82accbc6-7f36-44c0-8833-123b3ae96147",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "698b4870-d177-4e2b-825b-a74ce2b5bbd6",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "f4397d41-e364-4af9-a93d-8014b03e29df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14a2565f-aff6-4bd0-a6e9-811ada0de272",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "f6e41a2a-8185-4a8e-b6b0-3e3edc9e9466",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5166c0bb-8ac7-44c5-ba9b-861c1aad271e",
      target: "aee97459-2415-41ba-a558-125048895c07"
    },
    {
      id: "6c5e82da-2462-43e7-84cd-0c355806de8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d4fc066-79be-40ac-8740-db2e45be0cca",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "7e256bc8-4c1f-4de6-a0f1-7c1aa1d78f7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f122a2f-7d4b-4940-abba-f9b0cba600d7",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "e1917d83-6953-4b96-9d7d-6d51311a5557",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2962ef2-0566-42e3-8162-4525f07eded8",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "5ef8155e-54d7-4dc2-9592-22944e9364f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "279c4ab6-97fa-41f3-8300-c0825ad9a7bf",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "c2fa2c8a-228f-4c48-9fda-f260e836dd23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33d2ca25-798d-44f0-8d98-16b1136565d9",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "b84cd0eb-9fa7-4331-91f5-583013d2aa71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cf666a1-1a39-47f8-b106-98e8bddf8846",
      target: "798e6053-4095-4d32-abe0-3e15913219d5"
    },
    {
      id: "7121b005-2ba1-446f-b0e4-83cf12eae730",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4b326a1-cd90-402d-8d70-45aeeaacd14a",
      target: "49b3bada-c435-4f42-91ee-df8ea630ff7f"
    },
    {
      id: "b248324b-da82-4bde-b772-0693ea83d8a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4b326a1-cd90-402d-8d70-45aeeaacd14a",
      target: "17c332ed-9f70-42a7-b275-d77b682502c9"
    },
    {
      id: "5d46620e-451f-4fa4-aef4-5e19aeaafa39",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4b326a1-cd90-402d-8d70-45aeeaacd14a",
      target: "3340475b-dab8-488a-a332-b61a475e63dd"
    },
    {
      id: "160d5fe2-95d7-4796-910a-0db6cf603974",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4b326a1-cd90-402d-8d70-45aeeaacd14a",
      target: "1ddcb752-9570-44b6-88c6-1d1b86dd0c7c"
    },
    {
      id: "797f5076-92be-4bb8-999d-1a981459cd56",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "49b3bada-c435-4f42-91ee-df8ea630ff7f",
      target: "d3f81527-a6b2-4aec-943f-eeddb43c3882"
    },
    {
      id: "ea10116d-772e-40e2-9c61-93fcfc933e0c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "49b3bada-c435-4f42-91ee-df8ea630ff7f",
      target: "d3f81527-a6b2-4aec-943f-eeddb43c3882"
    },
    {
      id: "01780569-88b4-44d7-8416-286107558bff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3340475b-dab8-488a-a332-b61a475e63dd",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "dd363332-1637-4284-9313-f3a926893c6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3f81527-a6b2-4aec-943f-eeddb43c3882",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "5f176cd9-b41f-477a-8577-3a0c000b57ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17c332ed-9f70-42a7-b275-d77b682502c9",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "cafd411c-9d2c-467c-8a7d-cf2951f0bf32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ddcb752-9570-44b6-88c6-1d1b86dd0c7c",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "a2769f8c-ee55-4928-b42e-c880fa0200d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd",
      target: "1059ad87-58a7-4254-961d-6b8c554600b4"
    },
    {
      id: "efca779a-25df-4d54-a8a3-f2d360dffdd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd",
      target: "003a2f7a-24eb-473d-b1fc-47109d1de63b"
    },
    {
      id: "1c2e03ea-558b-4d51-b766-cc9cb2e453f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd",
      target: "e3b89732-2b5e-478b-97f8-70e6a445677d"
    },
    {
      id: "b92e9e8a-fd0a-4a30-9949-840248a12d2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c1bd0e3-1c73-4b54-95c4-d9da488aa9bd",
      target: "89185f34-f941-4475-96ee-5f6094686dee"
    },
    {
      id: "96e9c369-615d-4d04-b7a5-737ba7a8d8df",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1059ad87-58a7-4254-961d-6b8c554600b4",
      target: "8b06721e-38fc-4077-94f2-b279fd998184"
    },
    {
      id: "3f391f38-f0c0-466a-8d8e-f2581c789ce8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1059ad87-58a7-4254-961d-6b8c554600b4",
      target: "8b06721e-38fc-4077-94f2-b279fd998184"
    },
    {
      id: "5646e621-ae66-4d37-b366-503f1321b3d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3b89732-2b5e-478b-97f8-70e6a445677d",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "041617a8-5116-4d5b-bc24-db2d72ae8950",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b06721e-38fc-4077-94f2-b279fd998184",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "3df94ceb-6eb3-4c51-a2de-16cbe50c0f91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "003a2f7a-24eb-473d-b1fc-47109d1de63b",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "5d8432dd-3861-4820-9a14-66752d037c37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89185f34-f941-4475-96ee-5f6094686dee",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "ee0976e2-3e08-440e-943f-a054fb5f6765",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91142971-7ff8-402c-ad76-680fffb25ce0",
      target: "ed1b30c6-5463-4d27-9156-650613258404"
    },
    {
      id: "ed565231-067e-4677-8ca7-0ee1196c09a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91142971-7ff8-402c-ad76-680fffb25ce0",
      target: "864b363d-17b0-48a2-bceb-a8246043f798"
    },
    {
      id: "ff410dd4-bc21-4e58-89ea-f317ea582dd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91142971-7ff8-402c-ad76-680fffb25ce0",
      target: "21b8d5e3-69db-4b29-9e38-135917df4beb"
    },
    {
      id: "8248741f-541a-4d78-8d1a-0d91d7ecdd78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91142971-7ff8-402c-ad76-680fffb25ce0",
      target: "70b0f6d6-b056-4124-9764-958c18d93ef9"
    },
    {
      id: "73c2af5b-570e-473c-99cc-5817acc69b94",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70b0f6d6-b056-4124-9764-958c18d93ef9",
      target: "d21fa5c3-ab17-4c0a-a9cd-fd42cec2de2e"
    },
    {
      id: "18bbae05-b877-42c9-8b4c-7981fa502466",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70b0f6d6-b056-4124-9764-958c18d93ef9",
      target: "d21fa5c3-ab17-4c0a-a9cd-fd42cec2de2e"
    },
    {
      id: "cfaa9551-5a27-4b53-80fd-df5fba7c4db5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed1b30c6-5463-4d27-9156-650613258404",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "ae88b9e8-dd86-4b71-81b9-0090d4ad2b73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d21fa5c3-ab17-4c0a-a9cd-fd42cec2de2e",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "b90695b3-7387-494a-b836-ec6e15030481",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21b8d5e3-69db-4b29-9e38-135917df4beb",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "a71b59f7-5482-4bcd-895b-8d83014db8f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "864b363d-17b0-48a2-bceb-a8246043f798",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "1a1d5aa0-a43f-42c0-ae50-5da377efd508",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1b22d64-752d-4406-9e8f-df57e2edb64d",
      target: "64e564cc-af26-4fbe-a55c-86d565e76fde"
    },
    {
      id: "f4d283c9-8025-4244-9bf5-5fcfad7e813e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1b22d64-752d-4406-9e8f-df57e2edb64d",
      target: "1b45280a-8cad-405b-9173-15e4699cb7db"
    },
    {
      id: "a50e946d-ea98-47bb-9c4b-4063c794c51c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1b22d64-752d-4406-9e8f-df57e2edb64d",
      target: "f6076341-e1f4-4fe3-be97-589ae5c1d403"
    },
    {
      id: "05eacbb0-329d-40fb-8d49-28af8420602f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1b22d64-752d-4406-9e8f-df57e2edb64d",
      target: "49440b47-47f9-40a5-b79a-ea55f1afb5f9"
    },
    {
      id: "63fb34a7-4005-4fe0-8f04-8949879183bb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64e564cc-af26-4fbe-a55c-86d565e76fde",
      target: "4cd10cc1-afc9-45de-9bfd-1dfa78f94014"
    },
    {
      id: "b7d7a2e6-0b05-40d1-bc5b-7818d408292d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "64e564cc-af26-4fbe-a55c-86d565e76fde",
      target: "4cd10cc1-afc9-45de-9bfd-1dfa78f94014"
    },
    {
      id: "16912b5c-799d-42cb-b69b-5f7dc8902904",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6076341-e1f4-4fe3-be97-589ae5c1d403",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "0d5211c0-4256-40f8-847f-a791cd5f843f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cd10cc1-afc9-45de-9bfd-1dfa78f94014",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "317684f7-76aa-42df-83a7-69cdc3007db7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49440b47-47f9-40a5-b79a-ea55f1afb5f9",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "e590b64d-d08d-403f-8cf5-b0bab132e180",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b45280a-8cad-405b-9173-15e4699cb7db",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "c06be157-e937-49a6-8fa4-b0d9f24b34e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3",
      target: "09557f2b-1f59-473a-be64-f201ed83efda"
    },
    {
      id: "69ec3a89-621a-402a-be11-ddde444d2417",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3",
      target: "3671e562-2962-48c3-9017-e93a291df0ac"
    },
    {
      id: "e4183eef-d23d-42e2-a6cc-f4635c00ac7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3",
      target: "86c7a2b4-8163-454c-b976-f9e64382081d"
    },
    {
      id: "052b1bab-87a9-4303-8619-fa6f0739135c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0be411a-d7c6-4dd7-90a5-fc918daa46e3",
      target: "e6aec84b-a721-4bdc-83cc-eb58ca8010e1"
    },
    {
      id: "da7d5836-4399-408b-8fed-734b966a3323",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "86c7a2b4-8163-454c-b976-f9e64382081d",
      target: "281fc22a-effb-4183-9ee2-70338488abf0"
    },
    {
      id: "de351e9c-94f9-41d5-b460-235704d76ebd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "86c7a2b4-8163-454c-b976-f9e64382081d",
      target: "281fc22a-effb-4183-9ee2-70338488abf0"
    },
    {
      id: "403b4ba3-33e1-4780-9490-7cee2237129d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3671e562-2962-48c3-9017-e93a291df0ac",
      target: "9a014585-bce5-4d8e-bf63-bc24dafe0459"
    },
    {
      id: "b9f91e53-cec7-4ebb-bc47-31864490b079",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3671e562-2962-48c3-9017-e93a291df0ac",
      target: "d97fca9f-fb52-4158-93c7-1764891aeef8"
    },
    {
      id: "b3c164d8-bc41-4323-9941-c6bb92ffda67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "281fc22a-effb-4183-9ee2-70338488abf0",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "0f058e55-9d49-4603-a8b2-b5a6b1817076",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09557f2b-1f59-473a-be64-f201ed83efda",
      target: "119cc502-8ae5-49f3-a97c-5258d4f4a413"
    },
    {
      id: "4a066d76-519e-4370-b6ac-7c42d742368c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e6aec84b-a721-4bdc-83cc-eb58ca8010e1",
      target: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0"
    },
    {
      id: "0c43ebdf-fd08-4a1c-a8e8-7e5d64a7aca4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8039b75e-0c84-4c81-a494-5dc5eb889ce3",
      target: "1d774fb8-f7a8-45be-bc31-db78a42907c8"
    },
    {
      id: "ea39507d-83c2-44c4-ab62-c1eadcb0bfcd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8039b75e-0c84-4c81-a494-5dc5eb889ce3",
      target: "4bc91bad-f5b9-4da0-9eff-002f2ff6cedc"
    },
    {
      id: "63bd158f-2a2c-4dd4-932d-6023dd7a0fb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8039b75e-0c84-4c81-a494-5dc5eb889ce3",
      target: "27f63af4-0457-443c-b37b-be64f4a993e4"
    },
    {
      id: "f618881b-eae2-4be7-a107-2e48c176b7d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8039b75e-0c84-4c81-a494-5dc5eb889ce3",
      target: "8f84bfac-2d31-4436-8889-52d9ca3c3635"
    },
    {
      id: "e4854214-7d9d-47cc-b976-3d5db2c0602e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4bc91bad-f5b9-4da0-9eff-002f2ff6cedc",
      target: "68109eb2-d4ef-4ebc-bda2-fe55a2411ebd"
    },
    {
      id: "e22675ac-ef15-4ccc-ad24-4f7d79f5c43a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4bc91bad-f5b9-4da0-9eff-002f2ff6cedc",
      target: "68109eb2-d4ef-4ebc-bda2-fe55a2411ebd"
    },
    {
      id: "461bd17c-fdfa-4df8-b9e9-02610f8ca208",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f84bfac-2d31-4436-8889-52d9ca3c3635",
      target: "2d44d520-a537-4ad7-8497-b8a3633f9a96"
    },
    {
      id: "08e69202-b754-4870-9758-c8d4cb6d2d46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68109eb2-d4ef-4ebc-bda2-fe55a2411ebd",
      target: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1"
    },
    {
      id: "6dc99aad-9d7d-44bb-8bdc-4565dbfd33c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d774fb8-f7a8-45be-bc31-db78a42907c8",
      target: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f"
    },
    {
      id: "6998a549-3c68-4f34-8200-573efbfe1c2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27f63af4-0457-443c-b37b-be64f4a993e4",
      target: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9"
    },
    {
      id: "0fbb442e-b252-4e39-b14b-1cfe3b4cd9e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "4ded2a20-d790-45d3-9836-b7810095095b"
    },
    {
      id: "a904e626-16b7-4bb3-a386-a63a29ec496d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "a1272486-f8a4-4ec5-89f7-bbd119858505"
    },
    {
      id: "6eccd780-eef2-469a-ba04-d26ff14cf74b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "f5622644-5fae-4de5-b073-5e130ffd3c9c"
    },
    {
      id: "4b95fb7e-f856-4dd4-ae4f-f69628633be8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "196bce59-4015-4263-b7e2-99d94b7c87fa"
    },
    {
      id: "3e2f2294-1aea-47e1-bac3-ffd4d0416fcb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "7d79a0be-ac68-475c-90e5-83ff2979f057"
    },
    {
      id: "e627c45b-a6a0-48a7-b276-3b1542d9a6e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "1d26e942-c048-430a-b53e-1f752b423704"
    },
    {
      id: "4602c1dc-6d95-437b-8345-095aebd24e46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "2760ba52-4164-4cf9-a0be-2996d16f4183"
    },
    {
      id: "e30ce563-a576-40a1-9c85-1bcc88e14e9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "e90dab19-a706-4830-8a9e-2cfd0b6e76bf"
    },
    {
      id: "5c87f818-90f3-4726-8be5-8427b665c979",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "a9437c85-41d4-4bc9-afc6-a8fe9a7e5359"
    },
    {
      id: "74790294-c4dd-4ddd-89f3-56ca6ee976bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "7e41d9e5-cd3e-4fd5-bc94-72ab245bf83e"
    },
    {
      id: "4d956470-6bee-44d0-9355-a52419625f0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "bc79c9f5-d1f2-4bac-8183-c8172cc424b0"
    },
    {
      id: "8b0e096b-45ac-4061-bc10-c83dddc027dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "08d2b405-6b71-4158-a88c-9cd0cc7b5fba"
    },
    {
      id: "e6fc84d5-fa63-423a-b7a6-4b548a97c4ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "87080549-5452-4337-b77f-166e9d8d47fb"
    },
    {
      id: "039792ad-d761-4c41-ba7f-79ef50ba4729",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "e96d272f-5153-4181-9fdc-b3c332b99bdc"
    },
    {
      id: "22486d4b-513b-4346-a839-e0d8f70181ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "82f421e6-a86f-470c-bee8-e90fa20b7eaf"
    },
    {
      id: "28e929e4-6654-4617-a339-3a2be9cf33e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06baf101-a970-49f2-ae60-6b4a30de5e1d",
      target: "d6770684-e93c-42d9-bf34-88a0c4e7b7c8"
    },
    {
      id: "83bf2d0f-ac80-4b59-85d8-6d97e373ec68",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "82f421e6-a86f-470c-bee8-e90fa20b7eaf",
      target: "b3bd6c8a-9e7c-4f71-bd78-2c40deb5bae0"
    },
    {
      id: "5db35c87-70f9-4c6d-852a-195bd9b9bc6d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "82f421e6-a86f-470c-bee8-e90fa20b7eaf",
      target: "b3bd6c8a-9e7c-4f71-bd78-2c40deb5bae0"
    },
    {
      id: "98adf27c-aab0-48c2-ae3c-23ce427a3b00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3bd6c8a-9e7c-4f71-bd78-2c40deb5bae0",
      target: "381800b6-6b73-4510-96a3-aadd9d35b418"
    },
    {
      id: "293fa024-5ea3-49df-8f3c-20f0fce63e5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3bd6c8a-9e7c-4f71-bd78-2c40deb5bae0",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "9f980be2-fc4a-456a-9558-b12e9e0aafe3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2760ba52-4164-4cf9-a0be-2996d16f4183",
      target: "c37f6611-3252-4a1e-8659-3064bc280094"
    },
    {
      id: "ff8ec100-0e76-4687-9565-e223f75819cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e41d9e5-cd3e-4fd5-bc94-72ab245bf83e",
      target: "58d7b1e7-47c2-48aa-9974-1f34d580d295"
    },
    {
      id: "27a4a8d2-2ffd-4c5e-b562-bf2d8daa2e5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d79a0be-ac68-475c-90e5-83ff2979f057",
      target: "1736fc13-a761-4ead-9995-4f12c77a69b1"
    },
    {
      id: "ffdeff4f-fb65-4835-8274-5562efda04b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e90dab19-a706-4830-8a9e-2cfd0b6e76bf",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "cfdd21e3-f131-439e-8ffa-ccd927e683fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc79c9f5-d1f2-4bac-8183-c8172cc424b0",
      target: "04f774a3-5265-4330-9d5b-d31481486089"
    },
    {
      id: "556a5b0e-2985-4524-9a55-53782511752e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6770684-e93c-42d9-bf34-88a0c4e7b7c8",
      target: "c44f2f8c-314c-4a74-ade0-0ffc414d3176"
    },
    {
      id: "9b631e77-3a0b-44a5-aa14-5486dfcdfdd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "08d2b405-6b71-4158-a88c-9cd0cc7b5fba",
      target: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f"
    },
    {
      id: "0b4b2f37-e263-4b7f-a924-d792e5366440",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5622644-5fae-4de5-b073-5e130ffd3c9c",
      target: "838408f9-1bdf-4241-b195-b2f3e3568f42"
    },
    {
      id: "00d002b5-2174-4401-82b4-d31a85dcb059",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f5622644-5fae-4de5-b073-5e130ffd3c9c",
      target: "838408f9-1bdf-4241-b195-b2f3e3568f42"
    },
    {
      id: "1b0ee518-9464-4ba8-a7c4-5957c185da47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "838408f9-1bdf-4241-b195-b2f3e3568f42",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "21f0b944-096d-4197-b1ad-45277f162ef2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e96d272f-5153-4181-9fdc-b3c332b99bdc",
      target: "c37f6611-3252-4a1e-8659-3064bc280094"
    },
    {
      id: "0b2db20d-0875-47bc-9b49-b8eca97c03ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d26e942-c048-430a-b53e-1f752b423704",
      target: "58d7b1e7-47c2-48aa-9974-1f34d580d295"
    },
    {
      id: "0eaaa731-0551-4285-bb5d-4b8228105273",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9437c85-41d4-4bc9-afc6-a8fe9a7e5359",
      target: "1736fc13-a761-4ead-9995-4f12c77a69b1"
    },
    {
      id: "03008151-6167-45fd-9c4e-4c7dc7acb2d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ded2a20-d790-45d3-9836-b7810095095b",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "824db4a5-4367-45d3-8ce5-6f60004984f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87080549-5452-4337-b77f-166e9d8d47fb",
      target: "04f774a3-5265-4330-9d5b-d31481486089"
    },
    {
      id: "a37580ae-309e-4be8-bc6f-043f0d681510",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "196bce59-4015-4263-b7e2-99d94b7c87fa",
      target: "c44f2f8c-314c-4a74-ade0-0ffc414d3176"
    },
    {
      id: "8a2a3112-8b5f-4161-a0f9-4917ec8e64e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1272486-f8a4-4ec5-89f7-bbd119858505",
      target: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f"
    },
    {
      id: "36127586-8a48-4ba4-af17-61e63d81b4b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "817a1850-5c9f-4ca9-a283-aedc0bebbb02"
    },
    {
      id: "a4548729-7d65-4e3d-a01b-40aab7d080e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "46fb9d54-811f-4de6-b326-8dc8f76fd371"
    },
    {
      id: "3bd33b35-bc81-4f55-9878-3a8c0fe97420",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "3e4e700b-1afa-4fc3-8db9-0e81b401c828"
    },
    {
      id: "73983960-ac9f-46ed-bf32-95118965bc8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "8e87066e-a35b-440f-bca6-9cc7a28fd82b"
    },
    {
      id: "65262c13-617d-45cc-ad5b-8f6b4e84d4f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "181a2426-2c84-426b-aeee-ed70881aefe0"
    },
    {
      id: "7adb7340-cc60-4f84-a456-688fd0f9440c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "a3dce638-39dc-481f-839b-b9cf22d8c39b"
    },
    {
      id: "62fe1db7-3ef8-450f-b951-4867067bc30d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "b097b758-ff0e-4f5c-8e6a-6f1a9ee5c820"
    },
    {
      id: "cb043e49-b595-46b9-b404-887587f40b2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88bd03db-51de-4964-ac4a-30f792816ea4",
      target: "df49c55f-4894-4058-bc3a-6284334abbce"
    },
    {
      id: "b4000dd2-c981-422b-8a6a-0e9e3ece985e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46fb9d54-811f-4de6-b326-8dc8f76fd371",
      target: "96a6f9b6-1324-4f8c-aaed-2927b3258c43"
    },
    {
      id: "dc394004-7cfa-4b45-a650-ae071fe2e3cb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46fb9d54-811f-4de6-b326-8dc8f76fd371",
      target: "96a6f9b6-1324-4f8c-aaed-2927b3258c43"
    },
    {
      id: "e6eab224-ec8b-42db-b29c-049b7f0538fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96a6f9b6-1324-4f8c-aaed-2927b3258c43",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "a8a73301-ab6a-4225-a5a8-5d424b6f794c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96a6f9b6-1324-4f8c-aaed-2927b3258c43",
      target: "d88da9af-de9a-4f0b-a64b-948a878500ec"
    },
    {
      id: "c363bb7c-efad-4dde-8aa9-d5664abc9292",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e4e700b-1afa-4fc3-8db9-0e81b401c828",
      target: "c37f6611-3252-4a1e-8659-3064bc280094"
    },
    {
      id: "e671d579-6be3-4a6c-822d-c2ec6dccc8f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b097b758-ff0e-4f5c-8e6a-6f1a9ee5c820",
      target: "58d7b1e7-47c2-48aa-9974-1f34d580d295"
    },
    {
      id: "200d16a5-6608-49b1-a80f-450da2c14803",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "817a1850-5c9f-4ca9-a283-aedc0bebbb02",
      target: "1736fc13-a761-4ead-9995-4f12c77a69b1"
    },
    {
      id: "aac79926-06ab-4abe-a967-b614e64d1cb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3dce638-39dc-481f-839b-b9cf22d8c39b",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "8cd1944d-b908-4440-b296-331ad25b2a41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df49c55f-4894-4058-bc3a-6284334abbce",
      target: "04f774a3-5265-4330-9d5b-d31481486089"
    },
    {
      id: "e0f90e15-7650-4b0b-b67b-3c1ac3798eb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e87066e-a35b-440f-bca6-9cc7a28fd82b",
      target: "c44f2f8c-314c-4a74-ade0-0ffc414d3176"
    },
    {
      id: "a2833488-b49f-429a-80d4-96d0ca20d467",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "181a2426-2c84-426b-aeee-ed70881aefe0",
      target: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f"
    },
    {
      id: "579a9174-6821-4691-92c7-581a3a2fb089",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "01268485-98d9-4d10-b71b-2f6542753210"
    },
    {
      id: "51a1c3fe-ab99-4e72-b828-dfd0985dcd42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "2cadaf95-ba94-40ec-a86e-0e94b5efd460"
    },
    {
      id: "f072fe64-a0c5-4c77-ba3e-74a1a652ce29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "20f6d1cb-8203-4b13-852f-6380bf8c61c9"
    },
    {
      id: "34c64e68-6e44-4af5-9688-7f4088873733",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "31c5aed9-cfd0-4672-979f-05ce60279037"
    },
    {
      id: "b7a053c2-7c98-4b0f-b9c8-384e0b077de2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "e39e0caa-4646-479c-addc-9d76559930d1"
    },
    {
      id: "bedf60ef-c58f-4b1a-a882-5bf82e519601",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "4dd96660-d407-4d4d-bcbf-009e684bdc85"
    },
    {
      id: "11d46256-43ff-4633-a92c-29636aed728b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d30f906-edaf-42a2-84e6-d89980169b4f",
      target: "ba05e84b-6b5b-4033-9e02-abd6c098d6e9"
    },
    {
      id: "df1503f5-6860-46ff-b1a6-492abfa30f37",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "20f6d1cb-8203-4b13-852f-6380bf8c61c9",
      target: "ba05e84b-6b5b-4033-9e02-abd6c098d6e9"
    },
    {
      id: "656012e0-2212-47bb-8b91-f45c151996e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cadaf95-ba94-40ec-a86e-0e94b5efd460",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "15d21d09-18da-4ea8-8306-0f72d40b2e04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba05e84b-6b5b-4033-9e02-abd6c098d6e9",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "224fbdab-d21c-4f20-8515-eebd564cbd66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31c5aed9-cfd0-4672-979f-05ce60279037",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "05724cc8-d039-440c-a25d-1bdcc9cca85a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e39e0caa-4646-479c-addc-9d76559930d1",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "41bc7acb-8cdd-4b78-a4ca-02771fff3314",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01268485-98d9-4d10-b71b-2f6542753210",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "c367bedc-48bf-4a84-a275-100aff37393c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dd96660-d407-4d4d-bcbf-009e684bdc85",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "a9fca98c-2ca4-41be-bfa1-f3ebbcffd8cc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3b8af22f-0d45-435a-a57f-d5df4c41d061",
      target: "2a3d5c36-0d80-4d90-a31d-ac3e9487c14a"
    },
    {
      id: "5fd9b2a4-8122-4f7b-9803-61f5ced2d288",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b8af22f-0d45-435a-a57f-d5df4c41d061",
      target: "26a78a0a-822a-4e57-935c-a60c3928b1d1"
    },
    {
      id: "0148339e-cf50-493a-90b2-d97738ba32f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26a78a0a-822a-4e57-935c-a60c3928b1d1",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "4c645559-3432-4bee-b56b-3eed4582c24a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      target: "3b8af22f-0d45-435a-a57f-d5df4c41d061"
    },
    {
      id: "6c7f22e4-4abd-40df-8a14-384a9e4e30f2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      target: "3b8af22f-0d45-435a-a57f-d5df4c41d061"
    },
    {
      id: "64bdef14-691e-4b8b-a452-0b114cf7128d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      target: "36349a08-6432-4c85-8914-3fa3e4bb79b2"
    },
    {
      id: "9343ffe0-87f2-4a00-a2a2-df3c378858b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      target: "a9c8e62f-f8aa-4a97-b987-8c643db8c643"
    },
    {
      id: "b568a4d8-59cc-4a57-a7a8-682410dd539c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a",
      target: "f2289e13-4de9-4943-a514-3cdc8ca11c70"
    },
    {
      id: "45f12983-62e2-4bb0-b2df-02adb64acff0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36349a08-6432-4c85-8914-3fa3e4bb79b2",
      target: "fc5c9373-6029-4721-92a4-d6fb97961175"
    },
    {
      id: "fd870626-d834-4ad7-b493-8c7f6e19efc9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc5c9373-6029-4721-92a4-d6fb97961175",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "4a9ed91e-ac18-498e-9f3d-b3c8de3a7f1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc5c9373-6029-4721-92a4-d6fb97961175",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "6fdf1ab9-c355-455d-aeea-b505799dc6d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc5c9373-6029-4721-92a4-d6fb97961175",
      target: "2d6d9e7d-7442-49ba-983b-be39be3955c1"
    },
    {
      id: "b64c6987-81e5-4329-8c7a-20c915f936d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3bbc402-500c-40f6-85fe-05ed4354691e",
      target: "08917008-e1c9-48c8-8227-78c765e3437b"
    },
    {
      id: "6d9050d2-6c50-4475-ac98-d0e4d41c4ca5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "08917008-e1c9-48c8-8227-78c765e3437b",
      target: "81b937c3-75df-4386-a79f-3240af9a410a"
    },
    {
      id: "9c80b2b9-7c4f-4225-a720-9af706139249",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8e62f-f8aa-4a97-b987-8c643db8c643",
      target: "a2df2132-9675-48fd-bc61-2395e26eb1e6"
    },
    {
      id: "ea92ce36-328c-41db-996e-d8e4c5b20738",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a9c8e62f-f8aa-4a97-b987-8c643db8c643",
      target: "b3bbc402-500c-40f6-85fe-05ed4354691e"
    },
    {
      id: "d2630b5b-5ac5-474e-9e54-ec9adf6c16e9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a9c8e62f-f8aa-4a97-b987-8c643db8c643",
      target: "b3bbc402-500c-40f6-85fe-05ed4354691e"
    },
    {
      id: "8dd4ede9-0dde-4ac6-bb41-b9767dbbfa6e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ffb2182-baa9-4dc7-a97d-027854ca168b",
      target: "81b937c3-75df-4386-a79f-3240af9a410a"
    },
    {
      id: "50c4fbec-d517-44f0-ab00-a43540d53a57",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a2df2132-9675-48fd-bc61-2395e26eb1e6",
      target: "5ffb2182-baa9-4dc7-a97d-027854ca168b"
    },
    {
      id: "a6599f97-0e0d-4162-9e9d-9899a860f3d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "550bdc2c-d04a-4238-905d-dc2fef97e41d",
      target: "6a0acef7-9d4f-42f5-bbac-77322e0ffb74"
    },
    {
      id: "167c9bfd-f1b1-4975-ab86-cc7db371f2ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a0acef7-9d4f-42f5-bbac-77322e0ffb74",
      target: "46219bb1-f994-4392-acd5-8ba98fac6098"
    },
    {
      id: "f84262bc-5f61-4e2a-9813-ce35b2bf6143",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2c1f8ff-37e0-428a-b88e-16f2b8644ac3",
      target: "8689b41d-425e-4a52-b831-cf49e2428c60"
    },
    {
      id: "80adb9cd-fdf2-4d5b-8a75-fdc1773e89a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8689b41d-425e-4a52-b831-cf49e2428c60",
      target: "a7053ddb-1ef8-4e60-9419-a62401a0ba45"
    },
    {
      id: "388470f6-755a-4e6a-9395-29056789641f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8689b41d-425e-4a52-b831-cf49e2428c60",
      target: "90640fcc-0e5f-4882-b01a-bf44d075c416"
    },
    {
      id: "118bbbc2-3fd7-46b8-bd6a-70ad3bc26cd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90640fcc-0e5f-4882-b01a-bf44d075c416",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "240db825-fc61-4d31-9b93-54d60429069e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7053ddb-1ef8-4e60-9419-a62401a0ba45",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "39e875f5-3801-445e-b6bd-304632db9669",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a17835af-b4e9-486c-af75-f0c698a39e95",
      target: "df34f571-ba8d-42f2-b6d9-ab2aee8d22f2"
    },
    {
      id: "d75d3835-0c2a-403f-b0db-9e007e582a71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8ebe236-9ba3-4511-bc85-922bff4333a8",
      target: "49470c76-b61b-4f12-b702-7222ca7c2aa5"
    },
    {
      id: "33df7108-e688-43d7-8bb2-7d562074860c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8ebe236-9ba3-4511-bc85-922bff4333a8",
      target: "de1641a4-aa53-4d6b-a15e-d708ac6d1f3e"
    },
    {
      id: "42e2d61a-d908-400b-9786-9c8c9da1d83d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49470c76-b61b-4f12-b702-7222ca7c2aa5",
      target: "df34f571-ba8d-42f2-b6d9-ab2aee8d22f2"
    },
    {
      id: "aa044efb-3c7c-4a7a-ade1-77598c1dcffa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "df34f571-ba8d-42f2-b6d9-ab2aee8d22f2",
      target: "cb54a186-4490-474c-84c1-b33eba367999"
    },
    {
      id: "5efa09e0-74ed-4f4a-ad64-0c6816588bdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df34f571-ba8d-42f2-b6d9-ab2aee8d22f2",
      target: "e867ac94-6bee-479f-b924-c25290e08341"
    },
    {
      id: "c3bef27b-bc12-4b57-a0bc-46ef6d752cd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a5139c4-6996-4326-916f-82881d96e397",
      target: "3b1b10e1-806b-4964-b259-23cadd347822"
    },
    {
      id: "381c17cb-e428-4cdf-b020-746a92f3a27b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b1b10e1-806b-4964-b259-23cadd347822",
      target: "b3e8ea87-0f85-4041-be0f-7a2fe89a3c0a"
    },
    {
      id: "72eacbbc-ba7f-4f4f-aa93-afbf502a53b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3e8ea87-0f85-4041-be0f-7a2fe89a3c0a",
      target: "e268c818-d3e5-4b88-8a92-e9fe836f88aa"
    },
    {
      id: "d364a19e-26fa-4a9c-a762-ececf0429644",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb54a186-4490-474c-84c1-b33eba367999",
      target: "242b4cbb-1d82-45be-a5d3-1bbe349af6ac"
    },
    {
      id: "528020e9-ba25-4ac9-89c1-6559781fad06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb54a186-4490-474c-84c1-b33eba367999",
      target: "69836149-930c-48b4-b739-14f0a3f58793"
    },
    {
      id: "0aa3310b-5053-4b03-84bc-781d009eac6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2ad3ae9-a8d1-4abf-acb6-54dec595d278",
      target: "e867ac94-6bee-479f-b924-c25290e08341"
    },
    {
      id: "1c421925-33ef-4873-b902-ca9605955355",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2ad3ae9-a8d1-4abf-acb6-54dec595d278",
      target: "681ea9f6-786d-48c6-8192-720a90052a9a"
    },
    {
      id: "15e0ca13-41a8-42af-a864-006028b8f9b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de1641a4-aa53-4d6b-a15e-d708ac6d1f3e",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "995c28a5-c4a7-4958-9db4-d7b77a588116",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de1641a4-aa53-4d6b-a15e-d708ac6d1f3e",
      target: "a2ad3ae9-a8d1-4abf-acb6-54dec595d278"
    },
    {
      id: "9188c8d1-b30d-4222-a8d8-3e10a65c1635",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8eae24f6-ae67-4923-a5a7-c591b983d970",
      target: "cb54a186-4490-474c-84c1-b33eba367999"
    },
    {
      id: "54e0fa84-23a3-4fd6-b66e-d1f1aa3353c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8eae24f6-ae67-4923-a5a7-c591b983d970",
      target: "7f963270-d436-447c-bb7f-0dfa4164c6b5"
    },
    {
      id: "3f735ea5-35f6-42ea-98bd-030bdb6fce9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e867ac94-6bee-479f-b924-c25290e08341",
      target: "8eae24f6-ae67-4923-a5a7-c591b983d970"
    },
    {
      id: "94f8f57e-404a-4bd8-a0ab-4b42527d531b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e867ac94-6bee-479f-b924-c25290e08341",
      target: "986de551-c44a-46a7-bf13-0aa72e9b9343"
    },
    {
      id: "fc5ec869-f9cc-41e2-87c7-556e2c378f9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "242b4cbb-1d82-45be-a5d3-1bbe349af6ac",
      target: "b7ca906c-6386-415f-9637-8fae1d1c0499"
    },
    {
      id: "d6b4a60a-9e18-44cb-aecc-6ff0eecb0562",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "242b4cbb-1d82-45be-a5d3-1bbe349af6ac",
      target: "12190209-6d4f-4ad6-9e6d-256ab675ae3e"
    },
    {
      id: "84e44232-af5e-4d0d-9ebf-fd10a2897f54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be3d69fd-6db0-46c1-9934-f848f0067e34",
      target: "18f4fed5-d104-4471-b11a-99098c0d1900"
    },
    {
      id: "4cb6e5a8-be95-4567-b7b3-74fc1eb0c40b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be3d69fd-6db0-46c1-9934-f848f0067e34",
      target: "3b9ab8ce-ac79-49e1-9b68-a00b573d4ce9"
    },
    {
      id: "7fd6e631-03c4-4bf3-a484-1019bd1e3372",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12190209-6d4f-4ad6-9e6d-256ab675ae3e",
      target: "d5f5c6a1-35d4-4708-9b06-316e2067e5c0"
    },
    {
      id: "1496b287-f3a0-4074-8796-78b8019d94e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12190209-6d4f-4ad6-9e6d-256ab675ae3e",
      target: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5"
    },
    {
      id: "ffd3ed24-11db-4230-a21c-da9f6a9257bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf635749-bc6b-4afb-8af8-a7269d980d69",
      target: "be3d69fd-6db0-46c1-9934-f848f0067e34"
    },
    {
      id: "aecc381e-3b2a-4c37-b65b-176962b3c588",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf635749-bc6b-4afb-8af8-a7269d980d69",
      target: "e08f5205-30bf-473e-a063-adec8e0acd9a"
    },
    {
      id: "646f6831-4a50-45e8-94ab-a69ba9fe6231",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d5f5c6a1-35d4-4708-9b06-316e2067e5c0",
      target: "fbbb176d-f550-48ec-9980-38b65c1ebf17"
    },
    {
      id: "347ba37e-6d8f-4a98-bb02-12cbb33f2262",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d5f5c6a1-35d4-4708-9b06-316e2067e5c0",
      target: "bf635749-bc6b-4afb-8af8-a7269d980d69"
    },
    {
      id: "d0281304-65df-448f-a495-d9a600774299",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18f4fed5-d104-4471-b11a-99098c0d1900",
      target: "b8a5144b-9969-420f-9d75-238d9fa89e22"
    },
    {
      id: "12c008ba-7cc2-4fb6-a109-0bf833b6c94b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f9b7b2d8-c045-4c6a-8a67-d66e8dca4696",
      target: "87605184-b8ea-4254-8e3a-7575764689ba"
    },
    {
      id: "11acdf4a-0e4b-4df9-a708-0a89241b65df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9b7b2d8-c045-4c6a-8a67-d66e8dca4696",
      target: "3348f161-0c63-4379-ad02-7d64020e73be"
    },
    {
      id: "4df95abd-11f0-4904-9084-79ce7baa477b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3348f161-0c63-4379-ad02-7d64020e73be",
      target: "d625bd34-a380-46b1-81cf-0dde922c75f9"
    },
    {
      id: "2919703c-e6c0-4570-a1e6-2e14f8ea3a73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d625bd34-a380-46b1-81cf-0dde922c75f9",
      target: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2"
    },
    {
      id: "dd661d65-11cc-4d0a-b4ff-69ee11a2ecab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d625bd34-a380-46b1-81cf-0dde922c75f9",
      target: "52247695-583d-420e-809e-ab1bacfff342"
    },
    {
      id: "dc414f01-ba64-470e-ac57-1e6b57679414",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87605184-b8ea-4254-8e3a-7575764689ba",
      target: "98fa6290-6073-4f98-9e46-1aa91271fad3"
    },
    {
      id: "014750fe-2326-45ed-82ce-7ae2e8024ed7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98fa6290-6073-4f98-9e46-1aa91271fad3",
      target: "140b24cb-3cdd-4e30-a0ca-f8e9af1b9247"
    },
    {
      id: "4cb30f48-bfa0-4acf-a214-079363c42bc0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "140b24cb-3cdd-4e30-a0ca-f8e9af1b9247",
      target: "95fff06a-c765-49fa-9cd3-5e8597b61f18"
    },
    {
      id: "7a4aa66a-380d-4ea2-806b-6f57147164db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22d218cf-dd8d-46ce-99bd-4367f1e20f91",
      target: "3d1a7ee2-4e21-4f05-a01c-667753c39c4a"
    },
    {
      id: "a80abc8d-58fe-4e90-9085-069cc8c6b237",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "22d218cf-dd8d-46ce-99bd-4367f1e20f91",
      target: "ea63c6a5-2919-486e-a1e3-78134aadb1d7"
    },
    {
      id: "02804550-84d3-4583-99fd-b6f5f8b5a0e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d1a7ee2-4e21-4f05-a01c-667753c39c4a",
      target: "dcd6b39b-125c-4c22-a3c5-a20fb33c64e4"
    },
    {
      id: "05d6f9fc-93fd-4c78-9e32-8e99df9adf27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcd6b39b-125c-4c22-a3c5-a20fb33c64e4",
      target: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2"
    },
    {
      id: "63f1ee90-f44f-453a-95b6-f13f59cbd47c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcd6b39b-125c-4c22-a3c5-a20fb33c64e4",
      target: "52247695-583d-420e-809e-ab1bacfff342"
    },
    {
      id: "d83f0bb0-876b-4936-837f-7fcecb155e44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea63c6a5-2919-486e-a1e3-78134aadb1d7",
      target: "3168085d-bb13-4edb-98aa-a51da6c4ae70"
    },
    {
      id: "337fe6e5-38c8-4b2e-a5ad-e079aef5a95e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3168085d-bb13-4edb-98aa-a51da6c4ae70",
      target: "6b170940-c128-4242-b84e-22ccd116608b"
    },
    {
      id: "88ff833b-1fcf-4f3e-997a-42d901a80b7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b170940-c128-4242-b84e-22ccd116608b",
      target: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea"
    },
    {
      id: "f59cf7ab-797a-4b5b-a098-2a05dfad8a26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99158f91-c77d-4c83-ae70-8126f7d2d04c",
      target: "18cb8c11-4a65-4833-a7a5-510fe0a0af1b"
    },
    {
      id: "b1cb70e5-3f3c-4d6a-b64e-269325401045",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18cb8c11-4a65-4833-a7a5-510fe0a0af1b",
      target: "57fd6970-b65c-419b-856a-83c5bdb6d4b1"
    },
    {
      id: "c0fa225b-a102-4581-bc5c-4f6682faee62",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57fd6970-b65c-419b-856a-83c5bdb6d4b1",
      target: "03b59b82-39f9-4ef1-af1d-07d28a88ab7d"
    },
    {
      id: "e2a697da-9072-46f9-b67a-f609b6619c23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f2289e13-4de9-4943-a514-3cdc8ca11c70",
      target: "659d02e6-e36e-4259-b69b-6eb7434d9601"
    },
    {
      id: "b52218b1-61c3-4cdf-8e6a-dd2e7b86deac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "659d02e6-e36e-4259-b69b-6eb7434d9601",
      target: "e21651d2-5526-4800-b839-ade26384fabd"
    },
    {
      id: "0bfd5db8-9744-4a52-ba87-505653198954",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e21651d2-5526-4800-b839-ade26384fabd",
      target: "681ea9f6-786d-48c6-8192-720a90052a9a"
    },
    {
      id: "d9f6b139-0973-44cc-801f-21474be294b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9991e1e7-1782-42ec-a9ff-27d152c174f2",
      target: "98966e8d-f224-4047-88b8-6a998869e94c"
    },
    {
      id: "9f012426-98f0-404f-85dd-ed32333b6173",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98966e8d-f224-4047-88b8-6a998869e94c",
      target: "0a34b3cf-89ab-43a2-816d-e2904a5a5352"
    },
    {
      id: "c5dc17ea-9087-4c5f-a43d-f325438f09ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a34b3cf-89ab-43a2-816d-e2904a5a5352",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "ccfa6d2f-1091-4d32-a878-bb50253aaf02",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5c8bb63a-65b7-42ee-9190-4dbc117768fa",
      target: "fd68c53c-2f7a-4a32-9e46-e555713f2672"
    },
    {
      id: "a6a00c3f-d466-4ca0-a5d9-f95acce7d8b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c8bb63a-65b7-42ee-9190-4dbc117768fa",
      target: "3259bfff-3b82-4026-ba38-67b655d69e5d"
    },
    {
      id: "cc3f19ae-14e1-4109-aaf5-4ff275e7cd58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3259bfff-3b82-4026-ba38-67b655d69e5d",
      target: "e40f51ed-d3a3-47c9-a1a6-fa38bcf32d1e"
    },
    {
      id: "14dfffa4-7035-4493-8c53-e37d8c34106c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e40f51ed-d3a3-47c9-a1a6-fa38bcf32d1e",
      target: "9acc1cfe-ea3f-45de-ae94-09b0286da607"
    },
    {
      id: "e97941d1-54df-49c3-98cd-57ec8b8af1e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6ef28b7-7dae-4f1c-b7b7-b2efce52a5e1",
      target: "27abf7c4-7581-44b0-bb63-47380f9a65f1"
    },
    {
      id: "54e093cc-6877-4e64-8d3e-6af39edca963",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6ef28b7-7dae-4f1c-b7b7-b2efce52a5e1",
      target: "28d753d8-98b7-4126-a3d9-b7ff29d38403"
    },
    {
      id: "561f7599-6045-4bcb-89b3-74816074822f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27abf7c4-7581-44b0-bb63-47380f9a65f1",
      target: "cf863b4c-b4b0-423f-92b0-cfd1e52a6f94"
    },
    {
      id: "2fbbdcd9-07aa-4c30-aab3-1f67cfc61fd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf863b4c-b4b0-423f-92b0-cfd1e52a6f94",
      target: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979"
    },
    {
      id: "334221ba-22cd-428e-8e89-f03924215f10",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "009342b9-d9d4-41b9-85b8-9ff8339a0d2e",
      target: "98b5eb75-fead-4a72-8e5f-b766647fd53b"
    },
    {
      id: "84f22ba1-5a95-4bb7-aaa5-a6430f71fe0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "009342b9-d9d4-41b9-85b8-9ff8339a0d2e",
      target: "4dafec49-c879-4bdd-9cd3-5b27d9e38fa4"
    },
    {
      id: "2639a5c6-3d71-4348-b095-174fa3b651ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dafec49-c879-4bdd-9cd3-5b27d9e38fa4",
      target: "0a5e58fa-7f9e-4c4b-bd60-3ed13109e19e"
    },
    {
      id: "78b76e29-f635-4dea-bfe0-e1e8b1f6895b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0a5e58fa-7f9e-4c4b-bd60-3ed13109e19e",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "c0b17872-64ad-430c-b36d-516374a78241",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0a5e58fa-7f9e-4c4b-bd60-3ed13109e19e",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "c92ba3bb-a98a-4f40-8bd2-b1af0f486319",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b5eb75-fead-4a72-8e5f-b766647fd53b",
      target: "21ff1dd1-9520-42c0-b896-1be5ba21b0dd"
    },
    {
      id: "845520e5-3ead-4be2-8a44-db0f96d6ccae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21ff1dd1-9520-42c0-b896-1be5ba21b0dd",
      target: "2e530ff9-2920-45b3-811c-203001222f49"
    },
    {
      id: "1c31429e-7c57-45d7-be9c-214615e62e24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e530ff9-2920-45b3-811c-203001222f49",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "58bb384d-b02e-42bf-afc2-3d6d17890114",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd68c53c-2f7a-4a32-9e46-e555713f2672",
      target: "4aa562c1-943c-4953-8bff-7de72161feb4"
    },
    {
      id: "bb672009-b139-43bf-9d3e-6a941c109716",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4aa562c1-943c-4953-8bff-7de72161feb4",
      target: "ce03bc86-151b-4d7e-945c-3450639eef73"
    },
    {
      id: "94ec9da9-849b-4d31-b116-6771f5d8bce2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce03bc86-151b-4d7e-945c-3450639eef73",
      target: "e65cf560-f777-4914-83f1-a1dddd577c7f"
    },
    {
      id: "b4d7984c-0c92-4d74-999d-79efa1350ad2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64812c01-ba38-4c2f-a0b1-611253ddf598",
      target: "a3d7c350-e71f-4d12-ab22-6f97980e44a0"
    },
    {
      id: "f734d3b1-0413-4e83-9c71-d732705e6886",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af4317c5-b524-43ef-9861-100cf6dee12e",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "b6d69f3f-d6c3-47fc-bcaf-31cc923ea613",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7c350-e71f-4d12-ab22-6f97980e44a0",
      target: "af4317c5-b524-43ef-9861-100cf6dee12e"
    },
    {
      id: "0146fcc7-d424-4b0f-a3a4-1d635b2fc5be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d86958fa-3e33-46e0-8637-01724c1c77a4",
      target: "1334ee80-382b-43bf-ac73-bccd0e86b5d0"
    },
    {
      id: "cea01713-56de-410b-ac62-ec6fe598ca05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1334ee80-382b-43bf-ac73-bccd0e86b5d0",
      target: "24944f47-e305-4007-86d1-b6d165f8d2d0"
    },
    {
      id: "9db41edc-e3dd-4b3c-a48c-ff7e62cc2dca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "24944f47-e305-4007-86d1-b6d165f8d2d0",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "3512d955-8619-4008-b3c4-bdf6e546bc28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ff4802e-8a35-4b9b-8540-c1222f41a74a",
      target: "145b3489-db25-4c57-b0a2-99219580d00a"
    },
    {
      id: "5532ae1e-c164-461b-888a-d82b5165e7b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "145b3489-db25-4c57-b0a2-99219580d00a",
      target: "1791c987-9cb3-4776-b27f-b2c0b4d29471"
    },
    {
      id: "efbcc31f-9e76-4311-a805-4a311d234dcd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1791c987-9cb3-4776-b27f-b2c0b4d29471",
      target: "0c64ec9d-59dd-4c73-899d-d202963f14d8"
    },
    {
      id: "e4494d43-dcf7-4c5d-8b28-116be1b30058",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff2f7c02-5501-4940-8c2d-062ea542f15a",
      target: "13229818-d9b7-4b8b-abcc-581bd7429801"
    },
    {
      id: "7db1573b-c391-4411-8b6f-3a3ef28ad727",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ff2f7c02-5501-4940-8c2d-062ea542f15a",
      target: "cab70635-26b8-48cf-ac52-2980f163bc90"
    },
    {
      id: "5b17f38b-9d55-4a0a-9cb3-42590a6319e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "13229818-d9b7-4b8b-abcc-581bd7429801",
      target: "bb462a17-ba38-4cb3-b0cd-4caa8b84d7b7"
    },
    {
      id: "a9d2f910-5d99-4a3b-8838-2a8f89927ddd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb462a17-ba38-4cb3-b0cd-4caa8b84d7b7",
      target: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012"
    },
    {
      id: "a43df283-bbab-4fc8-8f13-eb6f2290d80a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cab70635-26b8-48cf-ac52-2980f163bc90",
      target: "196cfaca-bd4e-4480-9e78-6270b31337f0"
    },
    {
      id: "455441c1-f4bc-48d6-8bff-a96bb8630844",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cab70635-26b8-48cf-ac52-2980f163bc90",
      target: "8abd18ce-bd05-413d-b05a-577ba7be0653"
    },
    {
      id: "b5d16e51-8114-4f6a-b5cd-a441ec26c1b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cab70635-26b8-48cf-ac52-2980f163bc90",
      target: "6cc41727-7ffe-4923-8540-840861a97785"
    },
    {
      id: "d91a0717-e209-4089-a65b-bced71479b23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8abd18ce-bd05-413d-b05a-577ba7be0653",
      target: "2755c1fa-b5b6-4162-9aec-6620d9d55657"
    },
    {
      id: "bdfb88f0-7086-46ac-a23e-2f006642ed2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2755c1fa-b5b6-4162-9aec-6620d9d55657",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "064a600c-606c-4975-91dc-2ba35150ca21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2755c1fa-b5b6-4162-9aec-6620d9d55657",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "7394f8d2-b2b1-40e8-a05e-1b180300cb2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "196cfaca-bd4e-4480-9e78-6270b31337f0",
      target: "d0457db1-1321-4a69-8781-279d9fffd75f"
    },
    {
      id: "f2e8e5e5-8b7f-4ec7-a07b-ce1e05dd15c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0457db1-1321-4a69-8781-279d9fffd75f",
      target: "1b114571-da28-4aad-b71a-2e28dc2837d5"
    },
    {
      id: "60f4a9e4-fad8-4b00-9722-847878dcd751",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b114571-da28-4aad-b71a-2e28dc2837d5",
      target: "4c4f953b-ed7e-4a3f-ae81-412817bd8c66"
    },
    {
      id: "e065c0b2-da18-4ce0-b937-fdeb802d46d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6cc41727-7ffe-4923-8540-840861a97785",
      target: "244959fc-23c7-44b9-b0e6-c956bdd5945e"
    },
    {
      id: "ea62af15-dc3b-423e-a9ee-8643427fb51e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "244959fc-23c7-44b9-b0e6-c956bdd5945e",
      target: "6dece376-433a-4568-b6c1-03a7e5fc4605"
    },
    {
      id: "bdeb1d42-fc52-4ba2-b9f6-6204e580b6b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6dece376-433a-4568-b6c1-03a7e5fc4605",
      target: "5c9ae33e-5f69-4888-bdde-75af599f05ca"
    },
    {
      id: "86a8c11b-9070-450f-b1fd-cef9411345f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28d753d8-98b7-4126-a3d9-b7ff29d38403",
      target: "b9701809-7e9c-4111-a294-557fc71f28f7"
    },
    {
      id: "9d1d9e2a-0448-4f59-8f6b-d039f371c041",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9701809-7e9c-4111-a294-557fc71f28f7",
      target: "20c03fc5-e794-4752-b507-21826bd31505"
    },
    {
      id: "be5b3e24-5007-4cd4-9a45-9f1f504b1295",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20c03fc5-e794-4752-b507-21826bd31505",
      target: "754035fd-b4b1-48c9-b32d-c27b2735124d"
    },
    {
      id: "f228b5da-f911-4c5d-8587-23d823d073f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a3d5c36-0d80-4d90-a31d-ac3e9487c14a",
      target: "798899bb-65c9-4bd3-9511-f387cb56c42c"
    },
    {
      id: "bd4402d0-7c3e-4452-9ef3-bc46e6de8904",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "798899bb-65c9-4bd3-9511-f387cb56c42c",
      target: "a12439fe-69d1-4b09-9604-c1833b23dacb"
    },
    {
      id: "094fa1fa-0579-4495-a0cf-65f57c9412e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a12439fe-69d1-4b09-9604-c1833b23dacb",
      target: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770"
    },
    {
      id: "bb12aff2-be8e-455d-acad-21f0cfe23473",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c",
      target: "c7c097b0-8c16-46db-8f88-984cdc40cf75"
    },
    {
      id: "c71997e8-6e68-4945-9aca-278eed962485",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c",
      target: "495690ef-6105-4dce-b7e9-ae4d163a37cb"
    },
    {
      id: "fc0147ee-fdb9-4084-9152-cc1931780e48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "495690ef-6105-4dce-b7e9-ae4d163a37cb",
      target: "a4af63fc-0dc7-4649-b7fb-75f508c5aa24"
    },
    {
      id: "bf8a5667-a077-4068-94d8-8e615760dfba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4af63fc-0dc7-4649-b7fb-75f508c5aa24",
      target: "c3c5a495-c4f7-4853-a2bf-87217331ba5d"
    },
    {
      id: "dc90cc77-c81f-4efb-a961-1652ade66630",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c7c097b0-8c16-46db-8f88-984cdc40cf75",
      target: "6169310a-5601-438a-a428-f5979d5895a1"
    },
    {
      id: "b1b10c9a-f1fb-4f49-94a9-01df71fcaf34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7c097b0-8c16-46db-8f88-984cdc40cf75",
      target: "3797272a-1177-4c26-a854-6f774510b8ef"
    },
    {
      id: "75a4d1a6-2ad2-4355-8593-0a0f50c23b8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3797272a-1177-4c26-a854-6f774510b8ef",
      target: "cddcd329-46df-49f7-b6da-46c5973181e7"
    },
    {
      id: "92b12ddb-59f8-40fd-acbc-93ac471c7398",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cddcd329-46df-49f7-b6da-46c5973181e7",
      target: "2dc13c4f-af7b-4930-8ac3-e0e2da6d455c"
    },
    {
      id: "8cfd3c8d-489e-4494-b99f-d3dc36840e0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6169310a-5601-438a-a428-f5979d5895a1",
      target: "a63c40a5-c4c9-4674-bdbd-870ef5fa315c"
    },
    {
      id: "d06a48fa-802d-4418-8787-df9dd4b16189",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6169310a-5601-438a-a428-f5979d5895a1",
      target: "6081ef3c-ed0c-4d75-a06b-58a6d25aaa0c"
    },
    {
      id: "37f66cbe-a44a-471c-9df8-c2be20818289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6081ef3c-ed0c-4d75-a06b-58a6d25aaa0c",
      target: "bf5e2723-2ea6-46df-9d93-cbbcb2f86406"
    },
    {
      id: "b90c1a46-1e29-4958-b0a4-e4c7ff8448b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf5e2723-2ea6-46df-9d93-cbbcb2f86406",
      target: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2"
    },
    {
      id: "e85fe2df-f3dc-4b8b-a4b3-ddf44268363c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a63c40a5-c4c9-4674-bdbd-870ef5fa315c",
      target: "0cdef6c4-0cd5-4b7f-9016-aac934ef4c4d"
    },
    {
      id: "b5978609-4111-4e13-8e8e-c480f74280f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cdef6c4-0cd5-4b7f-9016-aac934ef4c4d",
      target: "4b091fa4-3757-4696-9172-fd3de6023370"
    },
    {
      id: "cbfa3ba0-e73f-4f32-9a14-0a8dc88c10ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b091fa4-3757-4696-9172-fd3de6023370",
      target: "bbf90f72-3ab6-468e-999b-b67688429762"
    },
    {
      id: "2182a702-8c38-4539-873a-9d43a155d66d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af515cab-25ca-4f40-abbe-b7f3236d4cb4",
      target: "eb6016d6-f269-465c-89d8-b0e62c2452fe"
    },
    {
      id: "96ad5b3c-eda7-457a-bb93-ec4e32cfdb64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb6016d6-f269-465c-89d8-b0e62c2452fe",
      target: "438f412b-6494-40f3-b116-bec3886fb730"
    },
    {
      id: "0b15b881-3472-4000-a8bf-a352105feb6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "438f412b-6494-40f3-b116-bec3886fb730",
      target: "87d31044-91f0-4602-ad3f-fb2e6f10955c"
    },
    {
      id: "84443e53-2768-413d-afb7-f54c20b4fad4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cb17e9b-51fa-45d2-9139-54242a98c283",
      target: "4c830df3-5263-4d67-bb71-607442c832de"
    },
    {
      id: "6198dc4b-b30f-46f1-ab76-50f69d5d46d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c830df3-5263-4d67-bb71-607442c832de",
      target: "204f59f9-2335-4a2e-95bc-43e92c038cb3"
    },
    {
      id: "38a688ac-bd3a-4920-b3b0-6f75f25834dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "204f59f9-2335-4a2e-95bc-43e92c038cb3",
      target: "23a36a6d-79d5-474e-9a9f-3f95a1a79939"
    },
    {
      id: "edfdd188-3878-4376-95e9-4fa29b66c414",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5107ffe2-9507-400d-a111-5a80b49ae5a8",
      target: "4d92b7ff-dc9e-48f6-803c-ba0858ed4d38"
    },
    {
      id: "45afff2a-b9fb-42ed-9870-06df82c7816c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbb30b0c-e480-49b5-a376-f5e02d1487e9",
      target: "48d0e46d-1139-4f51-b673-0c899c3465f3"
    },
    {
      id: "8db3450a-18d8-488f-bc60-7c96f54d1169",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d92b7ff-dc9e-48f6-803c-ba0858ed4d38",
      target: "cb855200-15a5-4ab3-a9f1-53f8d05284a9"
    },
    {
      id: "796f147a-9c8b-4e56-b760-fa60782d122a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48d0e46d-1139-4f51-b673-0c899c3465f3",
      target: "39973f16-682e-428c-8ae1-2fc29da0b7e7"
    },
    {
      id: "cbee0ce4-2696-49ab-9602-b2d60726d184",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb855200-15a5-4ab3-a9f1-53f8d05284a9",
      target: "824c45aa-79aa-44c1-9452-028364ab53b0"
    },
    {
      id: "8bbf01de-7209-4ca9-aac0-d4f95d12c5a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "39973f16-682e-428c-8ae1-2fc29da0b7e7",
      target: "438b74e9-e317-416c-a103-d3a7d96c879b"
    },
    {
      id: "b8a8a04d-c065-48eb-86f4-e0ecafc37992",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a75f0222-f046-45cc-bfbb-a63b05868be4",
      target: "6544e8f4-b2b5-4b62-92ea-5c71df5d28d9"
    },
    {
      id: "2d9d4210-ce2d-455d-bb3a-5ce76a17a7d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a75f0222-f046-45cc-bfbb-a63b05868be4",
      target: "46ff247c-d266-4338-913a-2fb41fede75a"
    },
    {
      id: "1408c3d2-cc8a-478b-b9c0-e13767fb71e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6544e8f4-b2b5-4b62-92ea-5c71df5d28d9",
      target: "ac96fbb7-00b3-42e1-9f0e-0b38223bed62"
    },
    {
      id: "46e6dc45-6444-4fdd-8902-52dbb9c69460",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac96fbb7-00b3-42e1-9f0e-0b38223bed62",
      target: "fcdc9db0-f28d-4d1f-abdb-f2d9ca1b45e7"
    },
    {
      id: "99e33748-12f1-4f2d-8e56-9b86252b84e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac96fbb7-00b3-42e1-9f0e-0b38223bed62",
      target: "2fa140d4-6e65-4b79-a55f-189dcae41a1f"
    },
    {
      id: "70739e89-9bde-42d2-bdaa-9ab51e5cae55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85de7da8-34c4-4e4d-80d0-bce6ba58d896",
      target: "3258e949-ae84-4533-9bb6-a755bda58d9c"
    },
    {
      id: "e4369147-3e00-4171-87ad-538112a80d88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3258e949-ae84-4533-9bb6-a755bda58d9c",
      target: "9e73801d-347f-4215-bf1e-92a10b0b5bd5"
    },
    {
      id: "49c141e7-6722-4b2f-bffe-6e9f58d50edb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e73801d-347f-4215-bf1e-92a10b0b5bd5",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "976fae96-eb70-4969-9490-f14af1633d43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e73801d-347f-4215-bf1e-92a10b0b5bd5",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "06632efc-7d0c-4124-ac87-0678506fcf2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e73801d-347f-4215-bf1e-92a10b0b5bd5",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "88a043ce-0bf3-4be4-8664-1b6ec9e9f5a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da8a68e8-4858-4e0b-8d41-8f803607d291",
      target: "9f7deb23-ffb9-41d7-b3d2-ccf84544ca09"
    },
    {
      id: "8893297f-32be-4ae8-9537-f5c211d61efd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f7deb23-ffb9-41d7-b3d2-ccf84544ca09",
      target: "ea3b19a9-5436-4edc-9f81-6a24cf5ca9d6"
    },
    {
      id: "a934ba28-2d25-4af6-be49-6744d7919d12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea3b19a9-5436-4edc-9f81-6a24cf5ca9d6",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "fd366c2e-c455-42a3-bc03-cd3db4011b70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea3b19a9-5436-4edc-9f81-6a24cf5ca9d6",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "6d3c73c9-62cd-4a2c-836c-5207c0f0768c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6dd38d3a-408d-4f08-be6b-fc28e0f9e1ed",
      target: "72d87cd3-c14b-4c54-90ab-fe759c12b65b"
    },
    {
      id: "52c5c8fc-c106-4b9c-808c-1e47a8331d22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d87cd3-c14b-4c54-90ab-fe759c12b65b",
      target: "100fd2b2-44bd-4a77-aa12-962d54fb58fc"
    },
    {
      id: "f4780685-2622-430f-9cbe-f39e7b24e64f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72d87cd3-c14b-4c54-90ab-fe759c12b65b",
      target: "46ff247c-d266-4338-913a-2fb41fede75a"
    },
    {
      id: "edcb2de5-b5f8-4905-8990-b40113498893",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "100fd2b2-44bd-4a77-aa12-962d54fb58fc",
      target: "46219bb1-f994-4392-acd5-8ba98fac6098"
    },
    {
      id: "b381da7b-b82b-4eea-b871-9b8d50defb4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "100fd2b2-44bd-4a77-aa12-962d54fb58fc",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "ea3a9192-9e9c-4f4c-a589-b5a2f5326fbe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "100fd2b2-44bd-4a77-aa12-962d54fb58fc",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "eac2d5a1-a7a0-4925-b746-87f22a4da6ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d98f84ae-d8b7-413e-aa7b-a199bf4cf796",
      target: "9b278f25-343d-4fbd-acb1-ecc3b5c56234"
    },
    {
      id: "ff73104e-6fbe-4eae-aa0f-145972e196f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b278f25-343d-4fbd-acb1-ecc3b5c56234",
      target: "238bc62d-17cb-4c7e-9fc3-cede3e56f9a5"
    },
    {
      id: "ebd0562a-481f-41d0-b97c-848125681045",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "238bc62d-17cb-4c7e-9fc3-cede3e56f9a5",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "1d19a64a-24aa-4f63-ac36-890e4d983666",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "238bc62d-17cb-4c7e-9fc3-cede3e56f9a5",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "b3c28d94-0010-4911-a36d-735ba2d591c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "238bc62d-17cb-4c7e-9fc3-cede3e56f9a5",
      target: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e"
    },
    {
      id: "328a0627-27e2-49b5-9626-bbef5509a59c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46ff247c-d266-4338-913a-2fb41fede75a",
      target: "93ede041-6583-401b-9f50-9d52e252d55c"
    },
    {
      id: "127fcc89-fde2-470f-8316-23c217b72241",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46ff247c-d266-4338-913a-2fb41fede75a",
      target: "6df4257d-bbdb-4628-beb1-3a30c578be60"
    },
    {
      id: "9aa28e46-5112-4ce6-b699-5a7e8bad5dbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "93ede041-6583-401b-9f50-9d52e252d55c",
      target: "c3171f33-313a-4a8a-98c3-7c1164e3704c"
    },
    {
      id: "9ad153cd-5680-4d0d-ab0b-f588c643dc3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3171f33-313a-4a8a-98c3-7c1164e3704c",
      target: "b4b05e12-c2ba-4c52-8723-03cc3396236b"
    },
    {
      id: "83a965c0-f0e4-4050-bdf9-8f6114b67f05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6df4257d-bbdb-4628-beb1-3a30c578be60",
      target: "091f6228-5909-43ee-b5ef-6a877c88c923"
    },
    {
      id: "704ad094-c271-41c4-be11-35961110dcd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "091f6228-5909-43ee-b5ef-6a877c88c923",
      target: "694dcc4a-f9d3-47e8-8338-7243718f087f"
    },
    {
      id: "e7c8f68c-6421-450f-b96c-68e92d8425f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "694dcc4a-f9d3-47e8-8338-7243718f087f",
      target: "11ef1af4-49c3-46f6-9fbf-7fb278e8dccf"
    },
    {
      id: "710390cf-cdc5-424c-99da-f1dc1938b473",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f69b96e0-ef80-41cb-aff2-025ad95a1fdd",
      target: "4c932962-c37e-44fa-870e-9ddeb79e2aae"
    },
    {
      id: "fb1f8f98-c685-4168-85b8-e051256edda6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c932962-c37e-44fa-870e-9ddeb79e2aae",
      target: "687d955b-cb62-4346-ab68-01dea9268a9f"
    },
    {
      id: "e25bfeba-5e66-42ec-8c10-3733fc645148",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "687d955b-cb62-4346-ab68-01dea9268a9f",
      target: "d80f2375-2757-495a-bb7d-591996c35fcc"
    },
    {
      id: "19ba34fe-d0cf-468f-8e5e-2da2825c95f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d80f2375-2757-495a-bb7d-591996c35fcc",
      target: "b5935d97-c1ba-4de7-8191-fdf6e338c173"
    },
    {
      id: "85b553d2-12c7-492a-9c8e-6f151c458d4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5380e45-419e-43ca-afde-66329fefc326",
      target: "1c09917f-1195-490a-a74f-65cdbb4445f4"
    },
    {
      id: "b5225875-084a-46ab-82aa-49f26809f8b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c09917f-1195-490a-a74f-65cdbb4445f4",
      target: "ed4dfcd2-381d-42cc-ae72-a7f2a9395619"
    },
    {
      id: "7b86dc6b-3812-4c28-bb83-109f9234a4e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed4dfcd2-381d-42cc-ae72-a7f2a9395619",
      target: "7dd68318-744f-43a7-9787-9563dcffdf5f"
    },
    {
      id: "cc22f9ac-bb97-4221-a5c4-1e92b17c95ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7dd68318-744f-43a7-9787-9563dcffdf5f",
      target: "731caeb4-e25e-4854-96ca-86afa311f0b1"
    },
    {
      id: "cd956172-1f1e-4fd0-9029-a3adf65d1226",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48e7de91-7fdc-41a7-8391-949673c1794d",
      target: "899d729a-67a9-4124-8d85-6a9c06d77fcb"
    },
    {
      id: "633d5679-675f-48d3-8b0a-b67955f99b7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "899d729a-67a9-4124-8d85-6a9c06d77fcb",
      target: "7b140ea3-c90d-45a4-b6db-bca1df5fafff"
    },
    {
      id: "46732186-ec26-40d6-ab17-3f6e603670e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b140ea3-c90d-45a4-b6db-bca1df5fafff",
      target: "f6b36f48-cc99-4421-b0fe-655c9cc30b57"
    },
    {
      id: "c7ec5f48-f4ce-4f07-8032-82d27ba16fd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d99e4cba-a6ef-4244-a0f1-5cb8ee810452",
      target: "cd9c105c-a1fa-49e3-80ce-7fa725d223d0"
    },
    {
      id: "292814ce-71df-49c8-b7e2-9cad23371939",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd9c105c-a1fa-49e3-80ce-7fa725d223d0",
      target: "9e67a8f1-af87-4101-901d-98f7d1bcce62"
    },
    {
      id: "b1642e6b-5978-48a2-bea9-ccfbace1fc96",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cd9c105c-a1fa-49e3-80ce-7fa725d223d0",
      target: "77528530-891c-4277-9023-56b69dc0c903"
    },
    {
      id: "8d322146-092f-49c6-b6c2-fb06aa7434ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e67a8f1-af87-4101-901d-98f7d1bcce62",
      target: "69275b9f-5368-48a2-a218-4419d4cfb762"
    },
    {
      id: "bc2a85de-d575-42c3-bf18-6386cf4d8838",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69275b9f-5368-48a2-a218-4419d4cfb762",
      target: "c86e5224-8fd7-4379-a344-a4f1d0950fe2"
    },
    {
      id: "455b03e7-dc23-49a1-8670-28aaa9db2943",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77528530-891c-4277-9023-56b69dc0c903",
      target: "9d425924-b566-40c4-9c9c-4f22b673c9ce"
    },
    {
      id: "0dc25437-690d-4b02-8fe0-060d8de62eba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d425924-b566-40c4-9c9c-4f22b673c9ce",
      target: "71350109-bdaf-4eef-a06e-00091dd9385c"
    },
    {
      id: "37bf6e1e-ed53-44d8-8486-03c745f2fe40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71350109-bdaf-4eef-a06e-00091dd9385c",
      target: "faa908c4-84af-47f9-80d7-a6baf70394bd"
    },
    {
      id: "07fbd32b-0b52-4f06-9d4e-31a835947e08",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8760b19-5f81-452d-ae2b-122605927840",
      target: "919dc4c3-0d09-481e-b3d6-24166f8e9a7b"
    },
    {
      id: "605e6521-afb5-414b-9e23-3f4db222611e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "919dc4c3-0d09-481e-b3d6-24166f8e9a7b",
      target: "7a8579ed-8300-4b9e-bc59-c69e933b305d"
    },
    {
      id: "4644e4ce-7db9-4892-9d5d-1b99dac15b6e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a8579ed-8300-4b9e-bc59-c69e933b305d",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "cdc9a2ff-35a6-4825-b20b-bce302be8f68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a8579ed-8300-4b9e-bc59-c69e933b305d",
      target: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3"
    },
    {
      id: "b0eea648-62c8-443e-88ef-7a01736a3863",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a8579ed-8300-4b9e-bc59-c69e933b305d",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "6d713069-87a6-470c-91cc-712e504473a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea0de3c5-d25b-4e5d-93d9-a4baa884db3b",
      target: "78af96cc-0132-489e-86ac-a457790848a0"
    },
    {
      id: "ba07ac40-c9d8-481d-a3be-f5abd383ec8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78af96cc-0132-489e-86ac-a457790848a0",
      target: "41ed3436-5df8-40a7-8776-c4f214dfa777"
    },
    {
      id: "5b1b914d-a64d-4890-9a5e-c5b073ee2af3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "67ad000e-097d-4816-aa28-e87c3f4e6c73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "2405a678-dd83-4de3-9eaa-b1f7c27bce78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e"
    },
    {
      id: "df8962dc-a83b-42ea-9111-1f9a2193476b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "7b88e29b-46a1-47f6-9428-b3f1acbe7c9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "63fe0031-e5a5-48f8-968d-92a394633781",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41ed3436-5df8-40a7-8776-c4f214dfa777",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "e44c1fce-1f4b-4ed8-9a1e-295baaff6010",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "608e9583-5403-4e20-8d84-2702bbb5742e",
      target: "3b024ade-c602-4559-80a6-5a52c11fba37"
    },
    {
      id: "8927ec0a-cf61-407c-8554-f8cf049313c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b024ade-c602-4559-80a6-5a52c11fba37",
      target: "1876afbe-b695-419a-93ac-8f1d188f35ce"
    },
    {
      id: "ab8d7b36-634a-4263-b08e-12eaf7fe71d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1876afbe-b695-419a-93ac-8f1d188f35ce",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "7cc4b39b-f6a7-4153-99c1-6202d94c2dd7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1876afbe-b695-419a-93ac-8f1d188f35ce",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "c67a6611-3051-44ea-a533-ed924beeae31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "678198d6-db6d-4102-bcf4-df71c55f4a46",
      target: "86f89069-5a01-4f2c-bc24-321461d381a3"
    },
    {
      id: "0cdf7a8b-cd27-4391-9f8a-b44c55472788",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86f89069-5a01-4f2c-bc24-321461d381a3",
      target: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734"
    },
    {
      id: "7aa4da92-8169-4fb9-8e00-d945d9b4d824",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "39c1d26e-4bb0-4723-93b5-046bdff8e622",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "2acc011a-35f3-427c-9ebf-eed98d78166d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "a6d1429e-c414-4271-ab5e-d9a2eb3eba91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "1bf6aa35-6c69-4657-9192-571d8c5696fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5565e178-4b72-4587-bdca-3728e274025f",
      target: "cc0ede26-d81e-497d-8e4b-e86693d37ff1"
    },
    {
      id: "101da820-5798-41b6-8043-ba9763e1d6e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc0ede26-d81e-497d-8e4b-e86693d37ff1",
      target: "15d76d07-a923-4f36-a384-4b0e2af0f802"
    },
    {
      id: "c5ecef77-cc23-43ab-b955-29e0d2308677",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15d76d07-a923-4f36-a384-4b0e2af0f802",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "1821abc5-03e2-46f5-bc65-3951b2f2cd4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15d76d07-a923-4f36-a384-4b0e2af0f802",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "bc4c1e27-5555-4668-85be-1c6eb61d7ee2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15d76d07-a923-4f36-a384-4b0e2af0f802",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "5f2c2619-239f-41b3-8323-0709729f1a96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1343d2f-d312-4ef1-8d19-7ba869df2c32",
      target: "fc7dfce5-42d9-4890-bf56-262110277b21"
    },
    {
      id: "92fbb79e-b0ab-4791-977d-fa96cb23facc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc7dfce5-42d9-4890-bf56-262110277b21",
      target: "0b14d54b-2e34-46ff-88a4-f143a6decae9"
    },
    {
      id: "f878efb3-8ec1-4924-b1cb-9b38000221af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b14d54b-2e34-46ff-88a4-f143a6decae9",
      target: "90048737-b66d-45c4-aaf8-f6ed96c52b65"
    },
    {
      id: "100a436e-cf22-4ff5-9906-333a2e5b7b41",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ce501ad6-8819-4631-8e22-62a6c06635fd",
      target: "9667b0ae-161a-4f45-b91a-9fc49e2519d4"
    },
    {
      id: "82607aad-f8a9-47c7-b0a6-bebc28d2e041",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f71baf9f-5d37-4b9d-b671-701063a4441b",
      target: "e926dfce-7a79-4f02-b38f-9a917367ae4b"
    },
    {
      id: "f164e13e-a45f-4c25-b3d0-9bdd652ea31a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38b7ba18-1c93-4014-8324-7fb66740c3bf",
      target: "c30f91bc-ed7f-4254-bee4-7401d4256a49"
    },
    {
      id: "b9c11217-e17d-4bd4-9a8c-2c7703eb6838",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e926dfce-7a79-4f02-b38f-9a917367ae4b",
      target: "9471bbea-2b52-43c3-a5ce-da8d6a215ec9"
    },
    {
      id: "e8c89693-a769-484d-b198-c030b2945209",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e926dfce-7a79-4f02-b38f-9a917367ae4b",
      target: "c30f91bc-ed7f-4254-bee4-7401d4256a49"
    },
    {
      id: "485d9fee-d5cb-4f78-a4ca-99924734cfa8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c30f91bc-ed7f-4254-bee4-7401d4256a49",
      target: "b64659e1-a503-4bab-9060-d4f771358b60"
    },
    {
      id: "99dee8ab-5bbf-4330-a1a3-6588411ec803",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9471bbea-2b52-43c3-a5ce-da8d6a215ec9",
      target: "38b7ba18-1c93-4014-8324-7fb66740c3bf"
    },
    {
      id: "798ae989-93bc-49d7-87d2-14b43d9b2436",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06c1743d-99a6-4841-b51f-07237624fb2f",
      target: "81b4eafb-1d38-447e-81d2-2fb02f964330"
    },
    {
      id: "483c4caf-fca5-4bdb-8a8e-cd979651489a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "06c1743d-99a6-4841-b51f-07237624fb2f",
      target: "2f98335f-473f-4e93-bfb4-27a152f494b8"
    },
    {
      id: "2777eecd-4ae2-4b30-aadc-c84465184209",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06c1743d-99a6-4841-b51f-07237624fb2f",
      target: "a8760b19-5f81-452d-ae2b-122605927840"
    },
    {
      id: "24589d75-fd98-4d5d-ac65-3be2a1a7570f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06c1743d-99a6-4841-b51f-07237624fb2f",
      target: "1ce30bc0-7d53-48be-9647-92258bdb2f95"
    },
    {
      id: "05c2f911-116e-468f-b2d0-ad5e1f75eb31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eef8ced1-edc5-410d-9fd7-d16105b984aa",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "152c92cf-ec82-41ef-b240-737a42523896",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eef8ced1-edc5-410d-9fd7-d16105b984aa",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "fb135662-ab36-4c98-951e-de799ebeb8e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eef8ced1-edc5-410d-9fd7-d16105b984aa",
      target: "81b4eafb-1d38-447e-81d2-2fb02f964330"
    },
    {
      id: "e4760f77-886f-406b-8758-02ae6699aac7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "746a2059-ca2e-4e45-9a2e-1b31896e2c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "7519bb42-967e-4a5d-bd8f-0fda606e123c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "943ea96e-9626-4052-9280-a99a82a65e2e"
    },
    {
      id: "e2e82608-e15b-430c-b7e8-5ed621582f6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "423539f7-f776-4a4a-ba21-9f21e340c238"
    },
    {
      id: "3a046567-c9bc-4634-869d-45dd8db282c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "81b4eafb-1d38-447e-81d2-2fb02f964330"
    },
    {
      id: "edcb322b-a783-4eeb-aada-02f14c0183fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85be915e-6c45-4a63-abd8-3b7e221ece7e",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "1ca78ff3-c5f7-413b-b0a1-bc4a40262aaf",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "608e9583-5403-4e20-8d84-2702bbb5742e"
    },
    {
      id: "f5a9f98e-33d2-4a53-a211-300b28c5119c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "678198d6-db6d-4102-bcf4-df71c55f4a46"
    },
    {
      id: "84e3f2a3-a6aa-4802-8343-959326470636",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "2739f522-8134-4a41-b7d0-c9f4ac4234e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "13b224e4-c05f-4ebe-9e25-50cc08709631",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "98500e83-855d-43d5-9276-494a9c3c6c23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "50846b02-2922-41b0-bc59-619ba2ca97ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "943ea96e-9626-4052-9280-a99a82a65e2e",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "f43a3a2c-5ec1-46cb-86fe-4cf6f691c59c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "423539f7-f776-4a4a-ba21-9f21e340c238",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "95b06981-dc96-4ee7-949e-944edb9a84f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "423539f7-f776-4a4a-ba21-9f21e340c238",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "301958d2-5050-4835-a5d6-70d14b17377e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "423539f7-f776-4a4a-ba21-9f21e340c238",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "21b095fc-eac3-43bf-8ec8-487fedc535c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "423539f7-f776-4a4a-ba21-9f21e340c238",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "0c1c6752-2c27-4461-9623-7115e50680ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81b4eafb-1d38-447e-81d2-2fb02f964330",
      target: "ea0de3c5-d25b-4e5d-93d9-a4baa884db3b"
    },
    {
      id: "17c6ffaa-cbaa-41c3-b557-d8992940548a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81b4eafb-1d38-447e-81d2-2fb02f964330",
      target: "cade9bfa-4cba-43dc-bd37-6c1b630e3559"
    },
    {
      id: "caab7004-92b4-46cc-a54e-8b505931cceb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cade9bfa-4cba-43dc-bd37-6c1b630e3559",
      target: "ea0de3c5-d25b-4e5d-93d9-a4baa884db3b"
    },
    {
      id: "9e5e7bea-fd5b-41a6-bd6e-67180bac71aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cade9bfa-4cba-43dc-bd37-6c1b630e3559",
      target: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e"
    },
    {
      id: "ddf95754-9dcd-4984-9506-e46742e32fe4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cade9bfa-4cba-43dc-bd37-6c1b630e3559",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "633cfc6a-684a-434b-a84e-8fbb7f011c53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cade9bfa-4cba-43dc-bd37-6c1b630e3559",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "bea04de9-63f2-48c1-b261-68d34123db99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ce30bc0-7d53-48be-9647-92258bdb2f95",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "f9a94c71-18e9-4193-a45a-25caff8a5cfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ce30bc0-7d53-48be-9647-92258bdb2f95",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "40847f3a-c93d-4207-85db-69860af744f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b64659e1-a503-4bab-9060-d4f771358b60",
      target: "85de7da8-34c4-4e4d-80d0-bce6ba58d896"
    },
    {
      id: "da1e20f7-1209-4afd-9585-7e88f2b4fdb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b64659e1-a503-4bab-9060-d4f771358b60",
      target: "6dd38d3a-408d-4f08-be6b-fc28e0f9e1ed"
    },
    {
      id: "dd1e3bce-6ee0-4d13-a4b1-ec22445669b3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b64659e1-a503-4bab-9060-d4f771358b60",
      target: "a1f49bec-c97d-49f6-9fec-96d8136336ed"
    },
    {
      id: "37a5cfeb-de48-46e3-bb20-b2bf1769c3d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "01fab29e-b00d-42cd-91af-352e5849e8ec"
    },
    {
      id: "63f1e6b8-c487-4fd0-9f2c-831d7a52d4e7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "57124ac6-576b-4cfa-a44f-7992a1a97af9"
    },
    {
      id: "8fd8b29a-8777-483f-9905-3f03128a833f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "1ce30bc0-7d53-48be-9647-92258bdb2f95"
    },
    {
      id: "4824a39d-ba56-4a48-8667-2a8c93467c89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "3acf459e-58c2-463b-80e4-1ba4c76a7591"
    },
    {
      id: "ef3d3ed5-1479-41c5-bdf9-ffa555b0b8a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "6a323fa0-d757-48fb-829b-699329196d39"
    },
    {
      id: "7803d756-f817-455f-98ac-ef81cac68cab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "e4261644-2df6-4b39-97e9-fafd922a375d"
    },
    {
      id: "54549fae-a749-47ad-88f3-e653f02a5a05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "517d023c-8169-48dc-ab48-8bcc58367d8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "5cd78464-3e9e-41ea-b05c-41fc308234bb"
    },
    {
      id: "b7d27786-6405-4fe1-8112-310fa68a979f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "f67169a4-99cb-4781-9a83-58610c9f2767",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1f49bec-c97d-49f6-9fec-96d8136336ed",
      target: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e"
    },
    {
      id: "5819abce-afcc-483a-b828-9d86f9d918df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01fab29e-b00d-42cd-91af-352e5849e8ec",
      target: "da8a68e8-4858-4e0b-8d41-8f803607d291"
    },
    {
      id: "70e6bd21-eed1-4c97-ac55-322fde326b83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01fab29e-b00d-42cd-91af-352e5849e8ec",
      target: "d98f84ae-d8b7-413e-aa7b-a199bf4cf796"
    },
    {
      id: "85c81e88-48d3-4839-9e51-429e58f8f967",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57124ac6-576b-4cfa-a44f-7992a1a97af9",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "6e38a544-52de-4518-84db-2464179b9f7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57124ac6-576b-4cfa-a44f-7992a1a97af9",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "3ff11101-e608-47e8-8033-77278bf9ab2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5fa2eed3-ac35-4b85-8c17-441acabf01db",
      target: "d487d45c-8f4c-436c-8bcb-12f3abe4a132"
    },
    {
      id: "a231a2b9-5060-43bf-b000-1c4d064a5849",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9667b0ae-161a-4f45-b91a-9fc49e2519d4",
      target: "c2c1f8ff-37e0-428a-b88e-16f2b8644ac3"
    },
    {
      id: "412b8854-2359-48c0-a74a-c4f8a27b4257",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "3a0eb3dd-0c1e-434e-bdf0-f435f515b84a"
    },
    {
      id: "91bbf2a2-3ea7-4efc-9c28-d626c3e0fd9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "fef30f96-a3fa-40f1-a987-e843a4234462"
    },
    {
      id: "6e23cb2f-718e-47dd-94b4-52e14ac8931d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8"
    },
    {
      id: "61fa70b5-5baa-4110-bbef-dbc86fe7e0fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "99768851-4386-4804-890c-c18a20f078ff"
    },
    {
      id: "a56b7c33-c957-46ee-ad47-18867e53609c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "5fa2eed3-ac35-4b85-8c17-441acabf01db"
    },
    {
      id: "c6fa0bbf-ea7e-4f91-a38d-e99c0529eb92",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "76b9d5d4-49c8-452c-8dfa-2b51335af130"
    },
    {
      id: "14d30a35-af88-42b6-9d68-e68058269032",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f2daa78-32dc-49a6-9769-7506968e9153",
      target: "05162f5f-6979-48fc-b69f-7d33a5c9783c"
    },
    {
      id: "6707793f-42bf-48bf-bdb1-ba8b2abc85d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99768851-4386-4804-890c-c18a20f078ff",
      target: "8cca0891-37f8-4de7-94f5-094c0383e7ef"
    },
    {
      id: "cc51dc83-f8b6-498b-ae88-bc0dfa654750",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99768851-4386-4804-890c-c18a20f078ff",
      target: "18334722-94ca-454d-a407-c2ebe037779e"
    },
    {
      id: "81be2e9c-16fc-4477-afd5-bfd1a9633044",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cca0891-37f8-4de7-94f5-094c0383e7ef",
      target: "52247695-583d-420e-809e-ab1bacfff342"
    },
    {
      id: "7a383ae4-a460-4514-a07c-f1cc83c5a0f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cca0891-37f8-4de7-94f5-094c0383e7ef",
      target: "814cbbf6-08de-4ae6-b4da-5b8aadf0e35c"
    },
    {
      id: "3e48dea0-cb02-4d95-a643-9fae25c3eea7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cca0891-37f8-4de7-94f5-094c0383e7ef",
      target: "c7c097b0-8c16-46db-8f88-984cdc40cf75"
    },
    {
      id: "82003258-3c43-4eb8-bc88-39456af28ee0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fef30f96-a3fa-40f1-a987-e843a4234462",
      target: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9"
    },
    {
      id: "820da45a-b6bd-42b3-bc39-5a4a8c246011",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fef30f96-a3fa-40f1-a987-e843a4234462",
      target: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f"
    },
    {
      id: "12254557-a373-4f02-8b65-0265266930f7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fef30f96-a3fa-40f1-a987-e843a4234462",
      target: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f"
    },
    {
      id: "6e5c72bb-8d30-41b9-87b5-028f2bd384fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fef30f96-a3fa-40f1-a987-e843a4234462",
      target: "a5697831-1f0f-4681-b9fd-200481e23a16"
    },
    {
      id: "034132a2-855a-48f5-81a8-3dd5e408eecc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5697831-1f0f-4681-b9fd-200481e23a16",
      target: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf"
    },
    {
      id: "b8282de7-3279-4fce-8107-4e10bd7e8a83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5697831-1f0f-4681-b9fd-200481e23a16",
      target: "e25e0c73-df43-45d3-87ce-6609c9d860ba"
    },
    {
      id: "c366c570-7cbe-4e72-ad15-dd334b1f9a45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e25e0c73-df43-45d3-87ce-6609c9d860ba",
      target: "7b9c4468-eb61-43fb-9126-d6bdc80e6065"
    },
    {
      id: "22fa9764-0043-48be-af08-01f4829576f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f",
      target: "7bc17825-c661-4bee-9b20-33801d49338b"
    },
    {
      id: "d99fa347-cfe0-4d15-9ec6-769a91712b68",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f",
      target: "3c5250df-8da3-44c8-b3b4-9be719ec7e52"
    },
    {
      id: "f1f125f3-202a-4e37-a0e5-66466ec02476",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f",
      target: "3c5250df-8da3-44c8-b3b4-9be719ec7e52"
    },
    {
      id: "0afd9d8e-4bb6-4e88-a811-04de5105b81b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c3cdbeb-6dcb-4438-bb71-ff2191415b4f",
      target: "7a2e01a8-6d3e-495c-a300-790d3ddea24b"
    },
    {
      id: "16fd8044-a9e8-46bc-bc07-3c6a2b177a8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a2e01a8-6d3e-495c-a300-790d3ddea24b",
      target: "053bca37-c49d-4ae8-b392-2bfa1d70169c"
    },
    {
      id: "1020a8d1-da52-48cd-ba70-848648fcd087",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a2e01a8-6d3e-495c-a300-790d3ddea24b",
      target: "b218df79-3f16-4f70-ae08-fa91e4e95874"
    },
    {
      id: "f221d6d1-7351-460b-8600-15d9f8a22c0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "053bca37-c49d-4ae8-b392-2bfa1d70169c",
      target: "87f14436-2fcc-45cc-9e01-d0dabe0fe228"
    },
    {
      id: "c6ebf17d-9118-4852-8487-807eff7f468e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c5250df-8da3-44c8-b3b4-9be719ec7e52",
      target: "cb891f47-ae1b-4b60-bc54-add7c2a5d451"
    },
    {
      id: "06fea2a5-cd17-438e-98e3-d0f4adffeb52",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3c5250df-8da3-44c8-b3b4-9be719ec7e52",
      target: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac"
    },
    {
      id: "9a7d0ba5-7293-4755-a742-edeb5b6c66aa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3c5250df-8da3-44c8-b3b4-9be719ec7e52",
      target: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac"
    },
    {
      id: "9e680fa2-9c92-4d72-a857-7b624e50aa0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c5250df-8da3-44c8-b3b4-9be719ec7e52",
      target: "c3216b00-ae0a-46b8-8e12-c68d628dfea1"
    },
    {
      id: "e04c5b6a-b2f7-44ca-8aca-00752846089b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb891f47-ae1b-4b60-bc54-add7c2a5d451",
      target: "52ce9133-2749-4c15-81ba-1a3af7588a34"
    },
    {
      id: "bf36fd41-41bf-47cd-9c7a-6d8394503925",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb891f47-ae1b-4b60-bc54-add7c2a5d451",
      target: "1257fabf-bf3a-4507-bc44-20a3d13bfed9"
    },
    {
      id: "92f7cbc3-be7b-49b0-a8be-61a4af4c3883",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1257fabf-bf3a-4507-bc44-20a3d13bfed9",
      target: "da4a993b-47fc-4eb2-adfe-a06962929a74"
    },
    {
      id: "bbdbcb48-af11-4566-8c63-7823cbd88d3f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac",
      target: "c12c184e-e11b-4568-9eb8-4a8f075ac119"
    },
    {
      id: "6df3993b-4824-4f53-97ae-5b10dfe624e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac",
      target: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5"
    },
    {
      id: "ec797c2e-4525-4bbd-87fa-8029f738039a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac",
      target: "c12c184e-e11b-4568-9eb8-4a8f075ac119"
    },
    {
      id: "0b6acd6f-45ce-4978-a73e-09b795e0c642",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85c53c37-60db-4a56-b18d-aaab9dc2d0ac",
      target: "3b263764-6686-4c56-b856-b5de86aae709"
    },
    {
      id: "a4d3688f-15d2-4a8d-9340-e8687dbeb0b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b263764-6686-4c56-b856-b5de86aae709",
      target: "1fb7d762-4ed4-4c33-8469-781f92e92aeb"
    },
    {
      id: "8b419db6-392f-47b2-86c4-27a35a1f55d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b263764-6686-4c56-b856-b5de86aae709",
      target: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4"
    },
    {
      id: "933a2279-2fa1-4253-b9df-ab5e3cc031d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fb7d762-4ed4-4c33-8469-781f92e92aeb",
      target: "def49e23-f658-4b58-83fd-d348d1d0a0fa"
    },
    {
      id: "bbc21b21-9493-4fcd-bd91-ad1eb868a98b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c12c184e-e11b-4568-9eb8-4a8f075ac119",
      target: "b0576fda-8791-4b71-9c9a-050246414d26"
    },
    {
      id: "fbf744b1-085e-42eb-97d8-62fe6d188583",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c12c184e-e11b-4568-9eb8-4a8f075ac119",
      target: "70cf0573-8154-4084-b0bf-802a9c57b72c"
    },
    {
      id: "af2344ae-d2da-4449-859c-047192eaaf57",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c12c184e-e11b-4568-9eb8-4a8f075ac119",
      target: "3156c477-6cd0-4d4d-bf56-ec3ccf1e4eac"
    },
    {
      id: "1d76bc79-8bdf-4629-97c1-7762e4f6de8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c12c184e-e11b-4568-9eb8-4a8f075ac119",
      target: "f5c0c82c-b783-4456-8607-fe7f19c53ea9"
    },
    {
      id: "fe5ad9ca-d5d9-4db2-91e5-8598fd0caa86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0576fda-8791-4b71-9c9a-050246414d26",
      target: "ec977ce1-cb6b-468b-8406-d82c32cee200"
    },
    {
      id: "f43fb7a8-dc90-4869-b856-57a8750fea25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0576fda-8791-4b71-9c9a-050246414d26",
      target: "d487d45c-8f4c-436c-8bcb-12f3abe4a132"
    },
    {
      id: "6be2db6a-923c-47c3-ad5c-eef27c4d9cab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d487d45c-8f4c-436c-8bcb-12f3abe4a132",
      target: "2e72af4c-7d12-4ae6-ac85-8f96fc525515"
    },
    {
      id: "884798a0-ba4b-4c48-85c0-6e40e53bce8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "76b9d5d4-49c8-452c-8dfa-2b51335af130",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "3f3fff89-9309-4110-8d87-370b974fda26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "76b9d5d4-49c8-452c-8dfa-2b51335af130",
      target: "96b1ef9d-9d2a-4044-8b3f-cfb3d7dffcf2"
    },
    {
      id: "28251114-7734-40c7-ba87-773aa2f7c957",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96b1ef9d-9d2a-4044-8b3f-cfb3d7dffcf2",
      target: "6107621f-b871-4996-91bb-531496b31376"
    },
    {
      id: "7542de67-e071-4381-b597-243392ad99b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96b1ef9d-9d2a-4044-8b3f-cfb3d7dffcf2",
      target: "86f6ad65-38f0-4598-a223-a655c7f555fc"
    },
    {
      id: "b3ee9b32-b5aa-48ae-9967-b91e0ff65eca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6107621f-b871-4996-91bb-531496b31376",
      target: "09654b2c-e592-4a63-9486-ab8550d78b28"
    },
    {
      id: "7598c953-5aba-4c47-a6a4-73db2115cc2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "05162f5f-6979-48fc-b69f-7d33a5c9783c",
      target: "63761fea-9e85-4199-94d6-50b80f6eff1d"
    },
    {
      id: "5f0f816d-f990-4e3e-ae79-7819f22bb046",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "05162f5f-6979-48fc-b69f-7d33a5c9783c",
      target: "2d6d9e7d-7442-49ba-983b-be39be3955c1"
    },
    {
      id: "e448a927-bdd9-4fc3-8dca-f1de6c4b7f70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63761fea-9e85-4199-94d6-50b80f6eff1d",
      target: "4af56416-33e5-4482-a9d7-8d52e2548a47"
    },
    {
      id: "132d916f-870d-42f1-bb00-29628aaa105f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63761fea-9e85-4199-94d6-50b80f6eff1d",
      target: "0837c3ef-b364-41b9-a488-3d5ffab577cc"
    },
    {
      id: "e15370ab-3df5-46b9-b905-3f723849eaef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0837c3ef-b364-41b9-a488-3d5ffab577cc",
      target: "99c76171-a13d-45b6-b825-38f4d5bea816"
    },
    {
      id: "7108bfe7-34e4-4278-984c-4a2107c17bbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3156c477-6cd0-4d4d-bf56-ec3ccf1e4eac",
      target: "8aeeda65-56ca-4ed2-b228-14a9238ade1f"
    },
    {
      id: "527d86ad-5a06-4e4e-803e-641abbc8c5a9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87f70d3b-6a0e-45a7-a28f-6ac6ec9619c8",
      target: "bb3858f7-e8b9-464a-8425-37009e0bb88a"
    },
    {
      id: "5afc7481-3057-498e-bd10-942003fc9917",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      target: "53f39f93-8e72-4118-a628-ab3ed637877d"
    },
    {
      id: "024baab1-c565-4697-a1f6-15507160bb1d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      target: "53f39f93-8e72-4118-a628-ab3ed637877d"
    },
    {
      id: "dfc6f666-cf3b-4ac6-881d-696fcd1c1a0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      target: "e1993bc2-04a0-4898-b288-71b058cd68ac"
    },
    {
      id: "201c703d-a988-481e-b249-716cfcea2f3f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      target: "87f70d3b-6a0e-45a7-a28f-6ac6ec9619c8"
    },
    {
      id: "253ed197-0d90-4531-98f1-ac831c557cfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70cf0573-8154-4084-b0bf-802a9c57b72c",
      target: "5c6ac608-03d9-441f-8e7d-10a7ca30bc8c"
    },
    {
      id: "edcd2795-2b0b-485a-99bd-acb6caacbd6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c6ac608-03d9-441f-8e7d-10a7ca30bc8c",
      target: "51370ae4-75d9-4cef-9ae2-da90bb8354b8"
    },
    {
      id: "4eed8b1f-72b9-4e7f-b119-6bb09b9d4832",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c6ac608-03d9-441f-8e7d-10a7ca30bc8c",
      target: "7ed2ac77-5edd-495a-b6f0-baa018720a86"
    },
    {
      id: "dc869841-f83b-4533-938c-4f73e167d2e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ed2ac77-5edd-495a-b6f0-baa018720a86",
      target: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8"
    },
    {
      id: "ebaf989d-fbd2-441c-81d1-c8d15e1d672f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53f39f93-8e72-4118-a628-ab3ed637877d",
      target: "2d75a1d9-401e-411c-9627-acf88f9e4735"
    },
    {
      id: "b6eac0da-d988-41d1-a564-60aeb2b515d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53f39f93-8e72-4118-a628-ab3ed637877d",
      target: "b89c1637-41cf-4e4b-8dce-47ec3a07d263"
    },
    {
      id: "b4b66529-96cf-4c38-a850-2069305f6ad4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "53f39f93-8e72-4118-a628-ab3ed637877d",
      target: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf"
    },
    {
      id: "fea0dc8b-6b49-4421-8bf8-05f0c5d323d0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "53f39f93-8e72-4118-a628-ab3ed637877d",
      target: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf"
    },
    {
      id: "784cd645-f96a-4489-bf4e-c1fd1500c492",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b89c1637-41cf-4e4b-8dce-47ec3a07d263",
      target: "466a3e83-a6d6-45d1-8f0f-8e55055e8c12"
    },
    {
      id: "bf0418dc-13dd-4a1e-85e9-ad33ad3055ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b89c1637-41cf-4e4b-8dce-47ec3a07d263",
      target: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e"
    },
    {
      id: "58b064f9-b7c7-4322-ac01-215738d3c0b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "466a3e83-a6d6-45d1-8f0f-8e55055e8c12",
      target: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8"
    },
    {
      id: "1a3d88fd-32bd-43dd-aa49-6ac763dab86e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf",
      target: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d"
    },
    {
      id: "0d62e3f6-3d6d-4832-ab7e-ec15065fbfc7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf",
      target: "c3f2141d-53ce-417c-be17-0bfc1f598f9f"
    },
    {
      id: "ec2f00d0-6b72-43a1-8cec-7c686e3f851b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf",
      target: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d"
    },
    {
      id: "494f87ec-4643-4ed4-8121-013a087ca1d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af5bba0b-b7e6-497c-bbb5-215ed2d304bf",
      target: "e1005323-b570-4e7b-9372-bd513d48298d"
    },
    {
      id: "269a77b7-590d-434a-b5eb-bc9cb210a68a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3f2141d-53ce-417c-be17-0bfc1f598f9f",
      target: "9fd8dfe3-3f66-4128-b716-d49e13192ef0"
    },
    {
      id: "de2eb0c4-8f61-4c27-9b16-a0ae1afad688",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3f2141d-53ce-417c-be17-0bfc1f598f9f",
      target: "6b556992-b16c-4624-933a-047555c3af4f"
    },
    {
      id: "6efe4900-9478-4a14-8ac1-478d134b3699",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9fd8dfe3-3f66-4128-b716-d49e13192ef0",
      target: "7607e97b-3881-43c4-8b6a-06f0087f28ff"
    },
    {
      id: "df633c53-0021-418a-bcd0-0027858c94c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d",
      target: "d143a46d-fb23-4aab-9a9d-ab5437094a76"
    },
    {
      id: "be86239b-d729-4b16-b786-2aedb973bc7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d",
      target: "bbcf3199-391e-4ffa-8d07-35ec06c401bf"
    },
    {
      id: "d97b467f-d9bd-445e-877a-466f21bd9586",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d",
      target: "af297041-818e-4976-a727-2c0aabaa7148"
    },
    {
      id: "73e540ad-63f6-40a9-91fd-25a9e1097cbb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "35d4f4fd-0b4e-43ba-b0f7-2f6b89c3310d",
      target: "af297041-818e-4976-a727-2c0aabaa7148"
    },
    {
      id: "7fcbddac-be69-43cc-a995-b7f037ca7dcd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbcf3199-391e-4ffa-8d07-35ec06c401bf",
      target: "f1d60b85-f25a-4622-b20b-a26bb64413d3"
    },
    {
      id: "d399d13b-8be5-4fae-9b1c-7527419639e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbcf3199-391e-4ffa-8d07-35ec06c401bf",
      target: "667ce647-d071-42f8-b869-3323345b606d"
    },
    {
      id: "8cab87cc-fc59-437c-a60b-1f1cb3f5f027",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1d60b85-f25a-4622-b20b-a26bb64413d3",
      target: "bc6b0566-84da-4421-adbb-c29bb4256d70"
    },
    {
      id: "8c86c1eb-a708-4a04-8307-ca1721a8efab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af297041-818e-4976-a727-2c0aabaa7148",
      target: "ae7ea8da-f3ad-4e6a-ab19-8fa1df47665a"
    },
    {
      id: "f07251b5-5886-4d89-9ca4-ee73ad7ffcb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af297041-818e-4976-a727-2c0aabaa7148",
      target: "6fbf2eb3-8f19-4627-89a7-aec878173fff"
    },
    {
      id: "1d5a30ae-f0ff-4d39-8864-4f843cde2c37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae7ea8da-f3ad-4e6a-ab19-8fa1df47665a",
      target: "bb3858f7-e8b9-464a-8425-37009e0bb88a"
    },
    {
      id: "196d4a42-584a-4095-8a9f-45c366c2a34b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae7ea8da-f3ad-4e6a-ab19-8fa1df47665a",
      target: "95f06f01-4228-4104-a9ad-daffdae87ce6"
    },
    {
      id: "aa27fe5a-20a9-47de-b0cc-b24d8f82558b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb3858f7-e8b9-464a-8425-37009e0bb88a",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "d29bc994-0272-48ed-bb5c-34828b1591e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3819532e-4a9a-486b-a57b-3a690a88dbe8",
      target: "9cad802e-8833-469b-b2e3-756cb942706e"
    },
    {
      id: "a5068043-cdfe-4ebf-a030-ad1f3d9136c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e34e0dc-45d3-4d99-9ec4-3b022ebcd600",
      target: "fb45b960-09a6-4197-b4e2-b2c45e54f7e3"
    },
    {
      id: "81fd7493-80e7-42d2-8ed3-a3343c6b5188",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50696560-c491-4e00-b32b-5eac345df713",
      target: "1a7383df-d935-43a5-a4a3-e0061fd8cf96"
    },
    {
      id: "4f19f778-86e6-46b9-b691-098dd4ca69d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50696560-c491-4e00-b32b-5eac345df713",
      target: "98e0b973-3587-4037-8f6e-52f3e09b90d3"
    },
    {
      id: "c86aebfc-6e13-44c1-a4c8-446b39735d8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98e0b973-3587-4037-8f6e-52f3e09b90d3",
      target: "3819532e-4a9a-486b-a57b-3a690a88dbe8"
    },
    {
      id: "9503e473-3a12-4405-ad82-a533750811c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98e0b973-3587-4037-8f6e-52f3e09b90d3",
      target: "7e34e0dc-45d3-4d99-9ec4-3b022ebcd600"
    },
    {
      id: "e1603b65-45f7-40ee-8bf1-a9b9085b34a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98e0b973-3587-4037-8f6e-52f3e09b90d3",
      target: "a2529087-acf2-4938-9a69-515967594528"
    },
    {
      id: "3855644f-c6f2-403b-bbab-a052767eb6e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98e0b973-3587-4037-8f6e-52f3e09b90d3",
      target: "bf25da74-e75e-41e4-a191-e5d5ece7a181"
    },
    {
      id: "e3915fde-98ee-49f5-9594-ec083b5b5966",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2529087-acf2-4938-9a69-515967594528",
      target: "dc4f7c12-f003-4b56-b9ad-9c47268fa8ca"
    },
    {
      id: "471e2197-09f0-4f2b-92cf-4d77482e3ac6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a7383df-d935-43a5-a4a3-e0061fd8cf96",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "ce5ba84d-548c-4569-ab80-468804a3ccaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92da57d4-9d3b-409b-a4bd-0a5513a6562a",
      target: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a"
    },
    {
      id: "e4376e6c-8247-44df-b080-061fe6390cfc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "76044c4a-8691-42d0-8c22-77d05c84bf4e",
      target: "462e735c-7b86-4f89-9de6-d40632afbb2b"
    },
    {
      id: "103c6421-401e-49ff-90bd-6f64cf411310",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "462e735c-7b86-4f89-9de6-d40632afbb2b",
      target: "e9f90f8a-9ff9-43ba-a65b-734e663292fb"
    },
    {
      id: "99a6df05-b1b4-459a-8053-591dcec70f51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9f90f8a-9ff9-43ba-a65b-734e663292fb",
      target: "a5d1bd50-5524-437e-ba9a-39a517e8a059"
    },
    {
      id: "d3aa40f6-0777-4934-91ac-6743227b4ac9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5d1bd50-5524-437e-ba9a-39a517e8a059",
      target: "4680426c-75a9-4635-820b-b03d93dc9041"
    },
    {
      id: "7fdd08ad-aef3-400c-84a4-10bee6ec549b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4680426c-75a9-4635-820b-b03d93dc9041",
      target: "0d5fb6e9-958e-4eaa-9041-6c576b94f1b8"
    },
    {
      id: "a8302176-75a9-466e-962d-18323e146f33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d5fb6e9-958e-4eaa-9041-6c576b94f1b8",
      target: "2d4d1a7f-96fe-4a31-85ca-634b28f3acfb"
    },
    {
      id: "6fe64062-3b52-4a3c-ac0c-0ca65756c876",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54713288-8bfb-4bd0-b6ab-6748b6747919",
      target: "8925c083-456e-42bc-a6ff-4579e41c4dc8"
    },
    {
      id: "52d9d591-1ba1-4556-bc28-8ee1500674a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8925c083-456e-42bc-a6ff-4579e41c4dc8",
      target: "58811e8f-3145-4987-af51-84d80286bcbd"
    },
    {
      id: "a6e6b206-76e3-463f-87e6-a56c93e8adc4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58811e8f-3145-4987-af51-84d80286bcbd",
      target: "2d8de93f-1b26-44ab-866b-6b03baf2b090"
    },
    {
      id: "069eb910-0691-4b32-9b75-49c3ebbf7f3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d8de93f-1b26-44ab-866b-6b03baf2b090",
      target: "0a167a2b-48b1-43c2-9f20-61d0ad03eb25"
    },
    {
      id: "89ebc08c-3902-4f54-89f2-e97ee5f918fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a167a2b-48b1-43c2-9f20-61d0ad03eb25",
      target: "7161ff52-e6c7-4e5d-8072-2b8e3832367b"
    },
    {
      id: "b22a690c-6f4b-4a28-a7da-138115db35e7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7161ff52-e6c7-4e5d-8072-2b8e3832367b",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "f7affd10-72f0-4953-a227-d24a096ffddb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "50696560-c491-4e00-b32b-5eac345df713"
    },
    {
      id: "047e2760-8d29-405c-a85b-07d07bee4b86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "f702a418-b705-4108-95d7-f990a80150d2"
    },
    {
      id: "ea223248-6273-43a0-9847-98d8da269ad9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0"
    },
    {
      id: "25a14c35-6404-43f6-94f9-02eaa961819a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d"
    },
    {
      id: "9400168b-7d1e-4fe5-af29-1fd13fc868e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3"
    },
    {
      id: "c763080a-6027-44f0-8709-f39467c48fb7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "613dc94f-7422-4013-b010-66a8eb880cad",
      target: "baa4c7cf-d15a-4544-8bae-0a0aabab6e43"
    },
    {
      id: "62ec7546-f10e-4e1b-baa1-2c298dde5922",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "baa4c7cf-d15a-4544-8bae-0a0aabab6e43",
      target: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0"
    },
    {
      id: "78727fb7-df29-468f-b641-e6fc359aaf49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "5cc6b2a1-28e2-432c-9333-957d8867107a"
    },
    {
      id: "1cccfd3b-8d96-4edc-b9d4-65b0d790e038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "abb99ed0-8a95-466e-99dd-475492996a6a"
    },
    {
      id: "3b97737c-12a9-4ec1-95fb-aeb38b4bd4d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4"
    },
    {
      id: "4d435a36-a219-4543-be2c-ad4ac6f6302b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "b44bc2ec-059f-4a0e-8cc5-2304702a1aea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0"
    },
    {
      id: "8efd4539-b5bb-43e3-81fd-14ab54e15abc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3",
      target: "b7aaa84c-ad46-4363-8344-8cf94f254ed9"
    },
    {
      id: "d190a278-2d97-4c72-a822-a219beee3201",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0",
      target: "fbbb176d-f550-48ec-9980-38b65c1ebf17"
    },
    {
      id: "635e06b1-3f27-41f4-8270-679f819cc771",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0",
      target: "1f419ff1-e532-4006-a0e9-07d0aad30a72"
    },
    {
      id: "11a6d681-7149-4c2f-a0f9-795bdf7d38f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0",
      target: "b7aaa84c-ad46-4363-8344-8cf94f254ed9"
    },
    {
      id: "cbdb6d2e-10f8-4c41-b805-cd70312b931e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "84c9ec32-c476-4551-a8a8-96d54063964d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e97ad4e-c7d3-4531-b560-aaab3e9ab2dc",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "54577cbd-6a42-494f-be89-a82cf639fda1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      target: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3"
    },
    {
      id: "07996e99-cd57-4788-81dc-163b4e301d94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      target: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4"
    },
    {
      id: "12364af0-f4ed-49dd-b28b-2d7534fe1a3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "bc6a1ad8-c466-4f36-ab65-28db1fec096f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      target: "2fa140d4-6e65-4b79-a55f-189dcae41a1f"
    },
    {
      id: "817e1357-0816-4d7c-b299-672fb6661a08",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8ebc3021-6377-45a7-ab30-490e7479fc33",
      target: "43efc24e-a698-412c-84de-03f3c6ef69ea"
    },
    {
      id: "fdc45951-18c4-47d4-a82b-fd76a5848a49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d680b996-bb03-458a-b0a7-d8ecafdcb524",
      target: "2d6d9e7d-7442-49ba-983b-be39be3955c1"
    },
    {
      id: "2b0776e8-1db9-4c8b-8405-63f2d0c6e5dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12341272-656d-49a0-bde9-1c5644f96ab4",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "d10b6e15-d0b9-4452-928a-32ba2d554d6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "d2659117-4f9c-47f4-8d07-92b8511c8467",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "77156c16-d34a-467d-be97-d5f6c7563e85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "7f2c8d9a-9f2e-4322-a5d7-42fabd647461",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "457b752c-87da-4e0c-9a8c-862002e29252",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "28417da3-1430-46f2-a529-29b6830c1d8b"
    },
    {
      id: "53a1567f-04e2-488a-8978-039f1041c172",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "a0d6780c-41c4-4f06-af1c-7623af524cdd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b8c36790-8481-4ac1-a6fe-9977f01fa53d",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "2678fe16-8dd1-4a95-b4d9-52f80d9979bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8c36790-8481-4ac1-a6fe-9977f01fa53d",
      target: "28417da3-1430-46f2-a529-29b6830c1d8b"
    },
    {
      id: "061ccaf2-dc47-4ec3-b1af-ea83476042c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "6451fdd7-f7d4-4327-878a-25d7b2b74929",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "45d1cb9e-bf52-412a-b873-37b1f3e74b0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "85ee6f22-4df1-46d1-a37a-bbc5eb4863c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "b9c6ea50-9bbb-4b58-a661-1e4ead8769a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c"
    },
    {
      id: "2077fce9-c9fb-4e18-b176-6018087c2676",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "aa228e48-4b6e-430b-8363-51a7a3f20477",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3",
      target: "28417da3-1430-46f2-a529-29b6830c1d8b"
    },
    {
      id: "277af8f2-0204-426c-abc1-16e31fe66ef6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e396cca1-6af6-48f7-a664-99db5e2f9718",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "babc9dd9-7695-48ec-aa53-3fa14234d426",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e396cca1-6af6-48f7-a664-99db5e2f9718",
      target: "46219bb1-f994-4392-acd5-8ba98fac6098"
    },
    {
      id: "6078dc98-db18-47ad-b63b-f7e291ed1daf",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c",
      target: "e396cca1-6af6-48f7-a664-99db5e2f9718"
    },
    {
      id: "9b2a0705-2fb8-4970-8bf8-df252b8bec01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "b3b97687-4afc-4625-8006-b7d19acdcb03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "9b07842f-67cd-4d93-b2a0-925791154ae5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "c6e0f4af-76f5-46b1-991c-3e0be562e103",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "9606c1ea-7151-416c-bc35-aabadc970313",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2",
      target: "9cbbdd64-199f-408c-8053-aa1307d7f655"
    },
    {
      id: "524b8162-2f8b-489f-af37-da8bd7651fa5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "913938d4-bcbd-4254-974e-943224cea531",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      target: "d4d4f77a-6856-4cde-9316-deca7201edb9"
    },
    {
      id: "a492f885-0abf-4cbf-a40c-8c6a87fb7840",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      target: "5cc6b2a1-28e2-432c-9333-957d8867107a"
    },
    {
      id: "1847ee63-92ef-4183-af15-ca02eeda211c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      target: "b059a712-db60-4a41-929a-dfa1e031e852"
    },
    {
      id: "a437e015-4a75-47ce-9337-a143ece815e8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d",
      target: "b059a712-db60-4a41-929a-dfa1e031e852"
    },
    {
      id: "c5840544-0e71-449c-8e1b-dfbd661a7e54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b059a712-db60-4a41-929a-dfa1e031e852",
      target: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8"
    },
    {
      id: "10f472d4-304e-4401-8982-4af796a4113f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55"
    },
    {
      id: "4e73c675-f7d3-48c5-b6ea-47a1e3eea93b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "183d945e-5caa-4f24-95f1-485502f145b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "f4c778f2-f7da-40b2-9bc8-dba60c49c3f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "fa6bb76b-f0b1-42f0-8d55-8ec75f0b12fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "479b6606-d49b-4fe5-88c7-f4f4c95b0585"
    },
    {
      id: "ed52e1a9-a3f6-4ca9-bda5-38cd7c4e4903",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "4ecd2988-49b5-4eb3-af96-e361cd573fe2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "225b80a0-2e40-4dcf-a4f3-d65ff5d3346c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "bf0f2f61-4604-42f7-8a44-b75532890447"
    },
    {
      id: "3b21a383-28f1-4d79-9f84-f4431fdbc9af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "d680b996-bb03-458a-b0a7-d8ecafdcb524"
    },
    {
      id: "d73534fb-393b-41cc-abc7-1c425bbe61c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "12341272-656d-49a0-bde9-1c5644f96ab4"
    },
    {
      id: "239864ae-0662-4afd-ac10-86d7f6f19ec9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2"
    },
    {
      id: "aa681c73-5af2-43bb-b773-bbbfa5b59472",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "838e3bcd-1590-4519-8d5a-0064f3ca775f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46219bb1-f994-4392-acd5-8ba98fac6098",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "7498f83c-bc7d-4924-95b4-57ad8390091b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "8ebc3021-6377-45a7-ab30-490e7479fc33"
    },
    {
      id: "f6513439-5207-42e9-94fb-6e5e48b47a7d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "b3c0c34b-37e4-4dd9-a149-95895185f5d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4"
    },
    {
      id: "5685fb9f-e056-41c0-817e-9d92cf5d0269",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e"
    },
    {
      id: "b9c8ac7a-f3dd-4f87-bfaf-05dc8ef99beb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "5745bfac-b66c-40b5-9397-4c82316c9c56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "2fa140d4-6e65-4b79-a55f-189dcae41a1f"
    },
    {
      id: "bbd7cab7-179c-4f64-a506-76ea52c4375b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6f3e632-d804-438e-9d65-ae73d274652c",
      target: "366184e3-b8bf-4741-88a0-0ba7685ce00e"
    },
    {
      id: "733b271e-1d02-44e6-86a4-3883026218e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a1235c3-ea70-4408-b57c-936a50c8b892",
      target: "9c54de4e-b35c-4127-9489-c910ca13b49a"
    },
    {
      id: "370573cc-fc72-41a3-bf95-9c770270fab3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a1235c3-ea70-4408-b57c-936a50c8b892",
      target: "9519d4bf-014d-4593-997a-2437187fc868"
    },
    {
      id: "3b027b14-cece-4502-885a-90a585014a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "05b9e595-907d-459a-b275-9560862e1f44",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "8ef3a2bd-70f8-455c-b5da-81760c25ff86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "ad50441b-a00e-4090-89c5-614756334aeb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "46a05ca0-da16-44cd-aa16-908f54807a77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "52efda2e-1613-4f39-896f-78243d19fb5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "57f1d59f-978e-4245-96e3-e9e27f131456"
    },
    {
      id: "75b0a872-ce1e-4278-bcee-defac44c1b16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "c7ccfef2-7405-4c1b-b335-d12d308d8549"
    },
    {
      id: "d1e5584a-e992-4d03-86d9-5b64ecf8c704",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "a897a98f-1542-4d71-8a7e-da8fc7597811"
    },
    {
      id: "b4dabe16-22e1-4c5c-a1f7-9d418dadcf2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90f13398-adbc-4be2-adfb-88ebcba1f7a0",
      target: "b9555331-371b-44e0-bd83-5a20d9d960f3"
    },
    {
      id: "a243f4f7-4def-4365-8991-24ee9464fce8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "1fd5030c-184c-4d6c-baf6-583a391db8b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "c2d5ca63-2b04-4745-8285-7ed9c8058544",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "1a65dd9d-c46f-4da0-b277-995e12d3bde6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "9e84e1a1-f585-4b1f-b487-b31b66b8d9f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db9bc8e9-1f07-4ffb-b562-2d185ef6151e",
      target: "57f1d59f-978e-4245-96e3-e9e27f131456"
    },
    {
      id: "fd5feb73-4907-4fb4-a028-bf45008b477c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "e83aa809-c1de-42a8-8a73-d64615e7992d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "b9555331-371b-44e0-bd83-5a20d9d960f3"
    },
    {
      id: "f30997f3-59e6-491b-acfb-da26399ce48b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "8279aa3e-92c9-4608-8bc0-6eb2219e0fa3"
    },
    {
      id: "dd215e21-0abc-4703-8bf6-ed25f40ee3dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "ac83d456-b1ba-4274-a311-e4d018217be3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "62c99c0a-8916-4af1-b75f-0481e20451ab",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "90f13398-adbc-4be2-adfb-88ebcba1f7a0"
    },
    {
      id: "a86a3e06-29a6-449a-9216-30c506a35395",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "366184e3-b8bf-4741-88a0-0ba7685ce00e",
      target: "57f1d59f-978e-4245-96e3-e9e27f131456"
    },
    {
      id: "d9fb7e0f-79f4-4f94-b124-f1af7847e78d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a897a98f-1542-4d71-8a7e-da8fc7597811",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "21191f31-94ea-44fd-9360-d86eb40c6b20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a897a98f-1542-4d71-8a7e-da8fc7597811",
      target: "e396cca1-6af6-48f7-a664-99db5e2f9718"
    },
    {
      id: "9874817f-efa0-46fd-a2fc-0638bbe0046e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a897a98f-1542-4d71-8a7e-da8fc7597811",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "344fa760-b340-4019-9ed1-b5794f9c9111",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a897a98f-1542-4d71-8a7e-da8fc7597811",
      target: "7604e032-0a91-4e56-aef5-66c7d5b377ac"
    },
    {
      id: "c547c3f1-2d24-4dc6-b900-f0cbe915032a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "2e385877-6674-45d9-bbc0-3043ad7910f7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      target: "a897a98f-1542-4d71-8a7e-da8fc7597811"
    },
    {
      id: "1bacbd83-113d-4dcb-b0f2-5630bc18facb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "48e6b413-4560-4065-8612-81dab2d31578",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      target: "a019ca0f-55f3-4db8-87e4-069fb8b71e7c"
    },
    {
      id: "518f97d7-bee2-4519-83cc-6447f501059f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9555331-371b-44e0-bd83-5a20d9d960f3",
      target: "41413ac8-b638-4e92-8e73-e55d270c5161"
    },
    {
      id: "cfe21584-10e5-43ff-8b15-06cfbcd6e63b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "65a406fa-3b1d-4063-ae0b-56a8371486ef",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "8868d014-6d2d-47a8-b376-86bec4ae6bc0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65a406fa-3b1d-4063-ae0b-56a8371486ef",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "71188463-99f7-4f0f-b261-70f2f77398cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65a406fa-3b1d-4063-ae0b-56a8371486ef",
      target: "5bf8dbec-0a18-4cc5-b116-0c1eadc523d2"
    },
    {
      id: "e2da475f-165a-451c-b5a5-003516c90bc6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65a406fa-3b1d-4063-ae0b-56a8371486ef",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "08f99354-fb57-4a24-97f6-6533133a1c36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "170e2595-2df7-4872-99b1-901f40cee5d8",
      target: "d4d4f77a-6856-4cde-9316-deca7201edb9"
    },
    {
      id: "7821bc31-5f02-4d2c-8720-f0822277d9fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "170e2595-2df7-4872-99b1-901f40cee5d8",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "25073fe6-df96-49cc-a736-03f1f09bcabb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "170e2595-2df7-4872-99b1-901f40cee5d8",
      target: "5cc6b2a1-28e2-432c-9333-957d8867107a"
    },
    {
      id: "3aeeeeb2-731e-43d0-8462-94519f16391c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "170e2595-2df7-4872-99b1-901f40cee5d8",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "3f01f11f-44ba-46b8-b16f-d953b55c3242",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "170e2595-2df7-4872-99b1-901f40cee5d8",
      target: "2b0b473c-aa85-4f16-99eb-b072b2431167"
    },
    {
      id: "4604119f-3d84-43cd-b0fe-eced44a49eaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b0b473c-aa85-4f16-99eb-b072b2431167",
      target: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8"
    },
    {
      id: "e0072445-2680-4f18-8de8-ebf02863aa05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "1805c813-2263-4d19-8b26-281a8d5e346b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "ac899d05-1cea-4c66-ac62-acae0311db54"
    },
    {
      id: "d7efb0c8-079d-4628-ae24-a66163da6e01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "42fbf4fc-a7bf-42bc-8475-572feaa6c631",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "938ab4cc-dd0d-4984-b613-67f2253715de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "fe3c1d25-c30f-448f-90fb-8dd98c0a3019",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "e8f3a250-9135-4b3f-9541-dc1b154264b1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "65a406fa-3b1d-4063-ae0b-56a8371486ef"
    },
    {
      id: "e394e9a9-1ae4-4143-8e25-0181fda7b4aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "cdd7d5bf-ebef-46bd-9000-85c7beac1bfc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "6a1235c3-ea70-4408-b57c-936a50c8b892"
    },
    {
      id: "7cd24fc9-2fb8-4274-812b-f92e9844ac5b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "dbcfb1a8-2e31-447d-959a-b30d1f742362",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "7b8f9d0e-3f23-40b8-82b5-0b116f4920c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "a6195c81-df9e-4adb-9255-efb1e48d1cf8"
    },
    {
      id: "f68bc2a9-1645-446e-9510-8c05af4fd464",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128",
      target: "9c19a252-b649-4bb2-9dbf-665c0cf3b789"
    },
    {
      id: "65eb71f9-b94a-4301-a9e0-ce6573303883",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "65a406fa-3b1d-4063-ae0b-56a8371486ef"
    },
    {
      id: "ab9824cf-050c-4697-aea3-d47f0becc12a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "1a2c5f9d-f7d4-4eee-9e3a-ac2878d2ac4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "968be79f-80ab-4377-93d7-38e79ac7f4f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "6a1235c3-ea70-4408-b57c-936a50c8b892"
    },
    {
      id: "9f9fb752-038f-429f-a2ab-b3eeae91ab99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "3efeb2c0-c565-4eb0-9222-48bd09e8043a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "a6195c81-df9e-4adb-9255-efb1e48d1cf8"
    },
    {
      id: "ed208d66-a812-430d-96f5-3040a2d629b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "921a7ba3-b313-4e49-844b-74b8250d67f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "72abb045-c87e-40c5-8396-24b7fc350289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "09891d90-4c94-4f22-bbc4-5fb29b7976b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "45ab17f3-5a40-4cb2-885e-7eee9f3f4257",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "e352730d-e97e-41eb-9be3-49c232a41d96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c19a252-b649-4bb2-9dbf-665c0cf3b789",
      target: "ac899d05-1cea-4c66-ac62-acae0311db54"
    },
    {
      id: "ae6d90c7-31fb-40b2-b67f-4ea7b784336a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "32aa4050-3ff8-4f7c-8209-bc2aa813c62b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "b2ea2d7d-1fd5-4c7f-91f7-9c74567a2eee",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "0cb88efb-a209-46bc-a7ca-8e3f1db48bdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      target: "57aac970-7973-491e-88bd-2da9e8d40785"
    },
    {
      id: "ad3331a6-3642-4373-b9f1-02323f1c7973",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb",
      target: "855fe1a5-18dc-47fa-8635-6a2a570d237e"
    },
    {
      id: "01d66db4-dc68-4521-bc25-9d0acf4434f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea0d5659-0623-45c4-b3bf-862dc5be26d4",
      target: "9fc02960-0011-4b76-bed9-0f7cd12efb69"
    },
    {
      id: "7a620772-ed99-432b-afa2-cdeb5ec18eae",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "855fe1a5-18dc-47fa-8635-6a2a570d237e",
      target: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5"
    },
    {
      id: "264619fe-ad79-4ce1-a471-88f80ebe138f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "855fe1a5-18dc-47fa-8635-6a2a570d237e",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "0c46f2fc-efa9-45ab-b05b-94cdda19198d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "f0efcd39-1a3b-4811-950d-80a9b4440a14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "c0f03c11-f035-4e5f-a648-25899192a7cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "1ead6268-1a8c-49da-8375-7bb2f4580d87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "71d10656-f648-4453-bdd4-cdc3a3406072"
    },
    {
      id: "3c2eed03-093b-42c2-99b3-2d7736f3775d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "3acf459e-58c2-463b-80e4-1ba4c76a7591"
    },
    {
      id: "2d1d5f61-a888-4456-9d9d-d20fc2df792a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3617b0c1-0e24-4917-b5c2-1f7c6cd3f8b5",
      target: "6a323fa0-d757-48fb-829b-699329196d39"
    },
    {
      id: "9ebca86e-c11d-45a3-aeb6-b61a751c1f81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57aac970-7973-491e-88bd-2da9e8d40785",
      target: "6a323fa0-d757-48fb-829b-699329196d39"
    },
    {
      id: "884ada25-c312-4a78-bc10-72b452958a2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57aac970-7973-491e-88bd-2da9e8d40785",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "1f26df69-e21d-476e-b48e-17e4daf16b86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3acf459e-58c2-463b-80e4-1ba4c76a7591",
      target: "5918d1e3-7942-471c-a486-ca63b5fdd98a"
    },
    {
      id: "81625020-1624-42c2-8661-ad24a6051587",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3acf459e-58c2-463b-80e4-1ba4c76a7591",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "a65621cf-cecf-411f-b90d-54f1c70e2968",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3acf459e-58c2-463b-80e4-1ba4c76a7591",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "af7e0677-b4de-4bea-a7f6-dfb2d0238bcf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a323fa0-d757-48fb-829b-699329196d39",
      target: "01735b44-2928-416e-8263-a57a4f22304f"
    },
    {
      id: "0f58aa42-0c89-4039-8d0f-8861bfef14fe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6a323fa0-d757-48fb-829b-699329196d39",
      target: "3acf459e-58c2-463b-80e4-1ba4c76a7591"
    },
    {
      id: "3c94a3cb-335a-410f-b1ca-43f39419a3e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a323fa0-d757-48fb-829b-699329196d39",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "9e013fee-6e1c-45f6-addf-252cd8ab076a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a323fa0-d757-48fb-829b-699329196d39",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "cb6b2b9f-8f7e-47d2-879a-64106fa08b34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4261644-2df6-4b39-97e9-fafd922a375d",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "7ba78112-2728-43b8-b2b6-7bfd2e999694",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4261644-2df6-4b39-97e9-fafd922a375d",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "a46a5915-8364-49f2-a9c6-6801c23af7b3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e4261644-2df6-4b39-97e9-fafd922a375d",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "aeb051c5-a8c2-4de8-bc2f-45b8205898fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4261644-2df6-4b39-97e9-fafd922a375d",
      target: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11"
    },
    {
      id: "621ebb36-1cf0-4052-8e61-af652ec440ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "c2ba5953-47b1-495e-9759-8f696fa33150"
    },
    {
      id: "c70126cd-9b50-46dd-a67b-f86e467d6653",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "d32c32d9-9eb4-4bca-9c77-08dc79cc157d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "1f419ff1-e532-4006-a0e9-07d0aad30a72"
    },
    {
      id: "561815e8-be11-45f7-ad99-1670df06aa43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "53e40c9f-de3f-44a1-a898-3438d09ba387"
    },
    {
      id: "8fd36931-8f04-45b9-8a12-eec4fbbecad8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "f694eb10-1a01-44a6-a88c-875b875dd6cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "fbbb176d-f550-48ec-9980-38b65c1ebf17"
    },
    {
      id: "a1a19485-c1f8-45b9-85b9-5451a00fbab1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f060e97-4d69-46da-94e0-43573784cb47",
      target: "5cd78464-3e9e-41ea-b05c-41fc308234bb"
    },
    {
      id: "f392ff4b-36ed-461f-bb8d-bd440ec69d80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cd78464-3e9e-41ea-b05c-41fc308234bb",
      target: "e1993bc2-04a0-4898-b288-71b058cd68ac"
    },
    {
      id: "f7427a3d-864e-49f9-ae0b-343424064bf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "faab9665-0594-4ca1-991e-994671a4121e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "99196f2f-c631-401f-b965-a8b306e188aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "bfa2f518-00f6-4dbd-a75f-27affda7a8e5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "ea0d5659-0623-45c4-b3bf-862dc5be26d4"
    },
    {
      id: "5e1cde73-86c8-4584-a4d6-4570a2525b3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "2f7f83ee-03d5-4f47-bb8b-9f4d2ffc69bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "26e9cd4b-4cec-4bc7-965b-1208ef49e971",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "b57b0315-eaee-44c3-9203-231312fe6b2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "e4261644-2df6-4b39-97e9-fafd922a375d"
    },
    {
      id: "f41a9fcc-e7a9-4943-9930-26ef33900d7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "1659b18c-1f19-4abd-95c3-5db0a7375e95",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd"
    },
    {
      id: "0c6e70c9-3f84-45a4-8fda-cf23edde7d9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "1957ee64-1ca8-4c10-82fc-1ebc1521a38a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "b0dd6012-351c-4a6d-9a38-dc5f4ca847dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff",
      target: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e"
    },
    {
      id: "ea0bfb47-35df-4ecb-8986-79ae3470f1ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "7c4aa2fe-f570-4566-99d7-a82d45d06da7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "ea0d5659-0623-45c4-b3bf-862dc5be26d4"
    },
    {
      id: "6d79e134-9d68-4830-b9ef-c9386b187da1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "e4261644-2df6-4b39-97e9-fafd922a375d"
    },
    {
      id: "80388046-7705-40bc-b8fd-8f69a6a9342b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "6eeab8e1-8a7a-40b2-9375-edf86f12acbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "f35de821-0a98-42dd-bb5e-c551e50f294d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd"
    },
    {
      id: "e8ba92f1-4e1a-4e92-8b77-622a38dda148",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "a0ba475b-ee22-408c-a6c6-7164a19a9fe2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "467c60d6-5dc9-43f4-a5b5-c128d9c0a2bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "1bdd1431-bd23-4429-a1af-64eac65ba2f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "5a198608-3fd1-4d6e-b092-a03ef261a431",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "ccdb299d-db7e-4fb4-b01c-3ce97a8a0000",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7cbdb4f-4e8d-4693-b715-bb6e66a5f89e",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "590bdc70-1182-4619-80cf-6efae16e6373",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "5fafb20b-7eb1-489d-86af-d62e95dfbb4f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "cbbba3e5-d4c0-46ed-b281-94c3cda59526",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "77e68404-8d85-4200-b129-f015cc16f93f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "c47dbf3d-b336-42e8-ba8f-3f7131a2d0fb"
    },
    {
      id: "00ac6457-200b-4b4c-93d5-40b423030d27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "abb99ed0-8a95-466e-99dd-475492996a6a"
    },
    {
      id: "7d1a6141-afbe-4489-abca-d8ecd2c83119",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "8e2f88be-a1ff-4675-a1ca-dcd627bf3fb0"
    },
    {
      id: "a10ea04c-bd0b-4481-a4a4-82fb64b40641",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "f6f3e632-d804-438e-9d65-ae73d274652c"
    },
    {
      id: "77d74e55-4cfd-47d2-9cde-410cfa392b37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e"
    },
    {
      id: "cef0956c-f22a-4d16-afa1-1d2df6120ffa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3bf92fe-34c6-4fa7-9a13-1a05b21b161d",
      target: "5ee0f40d-9a19-457b-973b-139d01aaf830"
    },
    {
      id: "b3e741b6-a375-4e8a-9ce7-2481fef252d5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5ee0f40d-9a19-457b-973b-139d01aaf830",
      target: "ece97c27-0fb1-45a8-97a6-304f245f8322"
    },
    {
      id: "a9ffeda0-f7bf-4724-9360-55c78d983bd1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ee0f40d-9a19-457b-973b-139d01aaf830",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "78acfdd2-40fc-4f57-91d7-c4c3c820f207",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ee0f40d-9a19-457b-973b-139d01aaf830",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "d106e5f0-4401-43b9-a736-1f2475a74655",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ece97c27-0fb1-45a8-97a6-304f245f8322",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "9cb1be1e-8f6e-461b-9af3-34e4b1124d9a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ece97c27-0fb1-45a8-97a6-304f245f8322",
      target: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7"
    },
    {
      id: "3e1a9ed3-f555-4e82-897c-17bbb3ccacb7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ece97c27-0fb1-45a8-97a6-304f245f8322",
      target: "5918d1e3-7942-471c-a486-ca63b5fdd98a"
    },
    {
      id: "4373a982-e5ca-42a1-b62e-a7924f90a89b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ece97c27-0fb1-45a8-97a6-304f245f8322",
      target: "01735b44-2928-416e-8263-a57a4f22304f"
    },
    {
      id: "6467fbfe-e5f0-4a31-b83f-8a24c1d21d62",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7",
      target: "01735b44-2928-416e-8263-a57a4f22304f"
    },
    {
      id: "2a53d1c3-3dc3-4210-a48c-4fbc8d0255ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7",
      target: "5918d1e3-7942-471c-a486-ca63b5fdd98a"
    },
    {
      id: "3900105b-548c-4a14-bad8-b3b1b886f910",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9135f5ac-f834-4fc5-9d13-3b97adaa5bb7",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "a5fa87cd-fe6b-4905-b2db-658b9a6fb2cb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5918d1e3-7942-471c-a486-ca63b5fdd98a",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "c0a4809e-e2f0-479c-8e41-54fdb937cccd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5918d1e3-7942-471c-a486-ca63b5fdd98a",
      target: "01735b44-2928-416e-8263-a57a4f22304f"
    },
    {
      id: "5bc42999-779c-43da-9cc0-26c505a5d053",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5918d1e3-7942-471c-a486-ca63b5fdd98a",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "e27bdcd3-0a5c-43ae-91fe-495546728d6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01735b44-2928-416e-8263-a57a4f22304f",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "7dd37568-39e6-4745-acef-3f63d61aa038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01735b44-2928-416e-8263-a57a4f22304f",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "2508a228-a881-45e0-bf71-d7143d79ee38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "e6b8cf57-0842-46ca-8400-ba9d0813b3d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "f84a041d-b7fc-4060-83ed-1346cb81e046",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "1cbc0153-0349-4c74-b527-deb5115a6474",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "53e40c9f-de3f-44a1-a898-3438d09ba387"
    },
    {
      id: "6c7e0950-fb5e-4de3-b336-d9582eec68a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "1f419ff1-e532-4006-a0e9-07d0aad30a72"
    },
    {
      id: "bdd71700-3398-49da-bb0e-a9eaa10c1d35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "c2ba5953-47b1-495e-9759-8f696fa33150"
    },
    {
      id: "c88abe6f-c29a-46a3-b92b-e60ec2f69e6f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "9afc135d-50a4-4d58-a26a-e10a25f51f27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "fbbb176d-f550-48ec-9980-38b65c1ebf17"
    },
    {
      id: "f309a2e4-83db-40a2-8307-de26b1a08721",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db6f20bf-d504-4ec9-820c-6857799cf29f",
      target: "2c6a99ca-a112-46d0-9cc6-5732cebfa5ac"
    },
    {
      id: "829e558a-5b18-4222-9e3f-edefdf22ecd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c6a99ca-a112-46d0-9cc6-5732cebfa5ac",
      target: "e1993bc2-04a0-4898-b288-71b058cd68ac"
    },
    {
      id: "1e43cb8f-4cf5-48a1-8c84-1208b85729ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "bf0f2f61-4604-42f7-8a44-b75532890447"
    },
    {
      id: "35b00f78-76eb-4262-9335-731aa2633ac2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "39a8d804-ad11-4219-b8f4-2d3f67c084d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55"
    },
    {
      id: "14dc7409-a310-43b4-9491-924e1ef2f89b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "ca762878-8551-4c84-a166-ba2ab981d9a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "5e180357-cd7c-41d1-8bdc-d2658386f64e"
    },
    {
      id: "7b67fd3d-1d9b-447b-bf5a-9a2f65daf76a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "e5120bc2-de07-41a5-bd93-cbd701abe15f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "27dbc2cf-f1a0-498f-8979-bbc5ec543a11"
    },
    {
      id: "4085816b-e4e9-4f65-a4e9-5b9c31cd2e5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "670aec9a-e1eb-4076-9b88-4d9eb7984678"
    },
    {
      id: "d6348f94-9f5c-4de6-a704-b061cb222f58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "479b6606-d49b-4fe5-88c7-f4f4c95b0585"
    },
    {
      id: "8289e7b0-ab0e-4a7c-99bd-863ed4ae10c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "3683b102-2ebf-4b38-b739-db57f35de71f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "ee848793-a604-44b3-ab75-fba76e81ade1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "62d38f1d-0575-4bbd-bf03-ec0159c97053",
      target: "db6f20bf-d504-4ec9-820c-6857799cf29f"
    },
    {
      id: "924ee7b6-91db-4944-b756-0b62788309ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "bde2bb24-c9e5-46ad-821c-c6dc5d0124ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "f0f9a928-c7b3-4851-aca3-d285628b88d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "9418f7f9-4101-4a55-a054-644e11a67945",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "5654e96f-020c-44ab-b67d-a1caf38add80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "479b6606-d49b-4fe5-88c7-f4f4c95b0585"
    },
    {
      id: "01cf0426-0f6b-4a08-873a-d2c7ca5eed87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "670aec9a-e1eb-4076-9b88-4d9eb7984678"
    },
    {
      id: "41591cdc-0f48-48f7-a698-18987627ba5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55"
    },
    {
      id: "ddc69923-265b-430f-9964-cc904ec36e59",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "62d38f1d-0575-4bbd-bf03-ec0159c97053"
    },
    {
      id: "b39ab962-11ed-4c89-86d3-6d29768ed869",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c052cbca-1d75-4532-8def-5a4bbbe5dd1e",
      target: "bf0f2f61-4604-42f7-8a44-b75532890447"
    },
    {
      id: "191dca11-cad5-474f-b179-067a3b0b9324",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e180357-cd7c-41d1-8bdc-d2658386f64e",
      target: "670aec9a-e1eb-4076-9b88-4d9eb7984678"
    },
    {
      id: "876a447f-52ba-49f4-935c-f38ac331761d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e180357-cd7c-41d1-8bdc-d2658386f64e",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "e5eb9348-37fa-4ba9-9dfb-45c1ebf13166",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43efc24e-a698-412c-84de-03f3c6ef69ea",
      target: "fd254f27-1c93-49b2-a5e8-fa34cbb725d3"
    },
    {
      id: "eb924403-6d5d-4aaf-a0f5-152e935f0abf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43efc24e-a698-412c-84de-03f3c6ef69ea",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "502f8597-e49c-4a8c-bd00-9a385302e418",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43efc24e-a698-412c-84de-03f3c6ef69ea",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "ddda5a35-19f8-4cce-93f6-de09955a963b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43efc24e-a698-412c-84de-03f3c6ef69ea",
      target: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2"
    },
    {
      id: "d75e16e7-37a9-408d-a659-96232a90c0cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "41413ac8-b638-4e92-8e73-e55d270c5161"
    },
    {
      id: "38150764-caa7-4ec4-830a-627eb26fbf25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "5129b10a-b148-4b29-aae7-9cca2bb33ba1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "bb9db6df-9deb-4d46-814b-403852c714cf"
    },
    {
      id: "95794ac7-22b0-43bc-b358-681549e5be25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "3713e6ba-d89a-4ac3-8446-1e1212a2f5d7"
    },
    {
      id: "c55d65f4-78ce-4b6c-926b-40328c37ec97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "7604e032-0a91-4e56-aef5-66c7d5b377ac"
    },
    {
      id: "794ef9f2-fa1b-49ca-91ec-d8118af41e17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "b8c36790-8481-4ac1-a6fe-9977f01fa53d"
    },
    {
      id: "c8c6dddf-2259-49ec-8437-897be28fe678",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "6798a730-f88a-498d-9d8c-74f13928280f"
    },
    {
      id: "7d266fea-9f0b-45bd-9b56-6942684e277f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1c2af4d-e1b2-4e30-a436-6b48892c3ba2",
      target: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9"
    },
    {
      id: "61769730-01af-4582-bb42-f2607b4d6a4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb9db6df-9deb-4d46-814b-403852c714cf",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "3a20dcf2-cbc6-4d47-b2f5-21491aff1f41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb9db6df-9deb-4d46-814b-403852c714cf",
      target: "6798a730-f88a-498d-9d8c-74f13928280f"
    },
    {
      id: "f4e08071-21ce-4c77-a4dd-6ffcad144b08",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb9db6df-9deb-4d46-814b-403852c714cf",
      target: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9"
    },
    {
      id: "481fcab2-29f6-40bf-a192-ebba37c46299",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7604e032-0a91-4e56-aef5-66c7d5b377ac",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "fc221c5b-6108-4bd6-8ad7-091fc35f20c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7604e032-0a91-4e56-aef5-66c7d5b377ac",
      target: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e"
    },
    {
      id: "8a6df4ab-a384-4118-84c3-4c2d4e371331",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7604e032-0a91-4e56-aef5-66c7d5b377ac",
      target: "3acf459e-58c2-463b-80e4-1ba4c76a7591"
    },
    {
      id: "9482436a-c5bc-4b66-b650-bde22372b482",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41413ac8-b638-4e92-8e73-e55d270c5161",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "a15d1a37-2ca8-4a43-8c60-9af235ce76fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41413ac8-b638-4e92-8e73-e55d270c5161",
      target: "7604e032-0a91-4e56-aef5-66c7d5b377ac"
    },
    {
      id: "bb3e55a3-d05d-40ee-9a2b-8d1f9479e386",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41413ac8-b638-4e92-8e73-e55d270c5161",
      target: "6a323fa0-d757-48fb-829b-699329196d39"
    },
    {
      id: "9e220edd-f6db-4c58-94b3-fcceb4cdee07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cbbdd64-199f-408c-8053-aa1307d7f655",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "d9b83be4-b157-463e-bc3e-a5fd18586e51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cbbdd64-199f-408c-8053-aa1307d7f655",
      target: "73113448-b7bf-4cd2-871a-20a72e48c232"
    },
    {
      id: "85e39ab8-005c-43a4-b56e-af41ee68fa10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cbbdd64-199f-408c-8053-aa1307d7f655",
      target: "1f419ff1-e532-4006-a0e9-07d0aad30a72"
    },
    {
      id: "d938985d-5e4e-49ec-8da4-d63434a4f7ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "23bf0efe-23cb-4ac6-bddf-8884ea6f72b7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "9cbbdd64-199f-408c-8053-aa1307d7f655"
    },
    {
      id: "6f438cd0-965a-4372-808d-220a7e16e322",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "ccfdde6c-722e-4a95-bd50-b1368f059bed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "514fd011-bf24-4893-b099-d913d65e9062"
    },
    {
      id: "07f4b279-2cd7-44b2-a423-d4b4c20e3905",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "e0beb11e-c494-4b90-a814-6d9fd41a6414",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "07feb5ed-73dc-4cda-9a3c-332e80ec5e3f"
    },
    {
      id: "19c6fb19-53b2-46c2-9299-46828c2411e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "0ae79b5e-bc10-417e-b8a1-8126e9913efa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "4c8ff9c8-bb5d-4d9f-8f9e-0969fc03d120",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "92750d00-894f-4a33-a8c1-4806b12e741e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "7bb5ed1c-834b-410e-b063-c6b63cd35924",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "c4f25363-be4a-4cbd-94ef-0cf533f0492d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "b6fce1c3-c853-464b-9031-deaf389a90c0"
    },
    {
      id: "783b568c-1d61-4e11-b2a7-6e636f0a363a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83dd400a-bb4f-4b6b-9dbd-22af1d280f3e",
      target: "9c376a68-3f3a-4591-b439-a52bcedf3ddf"
    },
    {
      id: "1c515749-0e57-4e0e-9aaf-986ce8652779",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "9cbbdd64-199f-408c-8053-aa1307d7f655"
    },
    {
      id: "14398573-5047-4543-a215-86e6994b8f51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "92da57d4-9d3b-409b-a4bd-0a5513a6562a"
    },
    {
      id: "54c3dde5-94f5-45f8-91d3-41ad36e76d03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "07feb5ed-73dc-4cda-9a3c-332e80ec5e3f"
    },
    {
      id: "b248df1c-f2f2-4e43-8bab-0f9271c26ea1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "f759122c-3337-4e7e-8082-b1a5a5703956",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "2fcdddc5-03ff-4a63-b4f0-9001b83c8b26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "514fd011-bf24-4893-b099-d913d65e9062"
    },
    {
      id: "f38a950a-c5e4-40b7-b53a-07ce941ea929",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "b6fce1c3-c853-464b-9031-deaf389a90c0"
    },
    {
      id: "04c758ef-0bbf-4173-986f-386ad95b999d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "ea075411-5274-4f7d-9aca-3a735e3fe1cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "9b340258-9773-453a-9f7c-f380e2264db9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "cd72ab25-e36e-42db-8b01-de95303d7b28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "deadeb11-4fed-43b9-a40a-0954e806805d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c376a68-3f3a-4591-b439-a52bcedf3ddf",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "144ddd9c-5469-4552-a252-a5e95dfc03b1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d4d4f77a-6856-4cde-9316-deca7201edb9",
      target: "fb25c2a2-9c6d-4a00-9063-ea65a4829d8d"
    },
    {
      id: "96648b97-68eb-4cb8-85b6-1edc8e5eeb72",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d4d4f77a-6856-4cde-9316-deca7201edb9",
      target: "fb25c2a2-9c6d-4a00-9063-ea65a4829d8d"
    },
    {
      id: "596dac36-ccba-4038-8796-3904f1fb3948",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb25c2a2-9c6d-4a00-9063-ea65a4829d8d",
      target: "e749968c-781b-41e9-a121-7053c2d6d4d3"
    },
    {
      id: "3db3a012-b332-4e5f-b753-180518ae0e08",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fb25c2a2-9c6d-4a00-9063-ea65a4829d8d",
      target: "f7a97eec-bc4f-4438-8800-d09c11771317"
    },
    {
      id: "477262ec-4ca3-4f86-adfc-a2b98d1e36bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7a97eec-bc4f-4438-8800-d09c11771317",
      target: "8ca5f2cc-fc69-4ffe-9735-0c3ca41bda1f"
    },
    {
      id: "8211d877-ccab-44c4-bf5a-38f36d220bc4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ca5f2cc-fc69-4ffe-9735-0c3ca41bda1f",
      target: "e9ea4763-c9bb-42cf-a721-eed0a5f66f67"
    },
    {
      id: "419d3551-8be5-400f-9b3d-377e597a5c9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ca5f2cc-fc69-4ffe-9735-0c3ca41bda1f",
      target: "0643a591-df62-4540-b40c-b55e8255b67c"
    },
    {
      id: "8e53dc91-9554-42d6-a262-b27f3f399641",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9ea4763-c9bb-42cf-a721-eed0a5f66f67",
      target: "9918a6c8-1c36-4827-b385-53ff12fa7b8e"
    },
    {
      id: "9735a01e-ef9e-4ff5-89c1-f6fcf390c7cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9918a6c8-1c36-4827-b385-53ff12fa7b8e",
      target: "c82c9c65-32dc-44f6-8a2e-b9675e3cc1a3"
    },
    {
      id: "8907db6b-cd11-493d-85be-282033141152",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c82c9c65-32dc-44f6-8a2e-b9675e3cc1a3",
      target: "4c1c74f2-a484-4817-8438-123bd159c87b"
    },
    {
      id: "f7a3dad3-3e17-4f98-aa86-619dc031745d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c1c74f2-a484-4817-8438-123bd159c87b",
      target: "6b903073-2098-4b98-9550-1e7bdbdc6268"
    },
    {
      id: "3c7d663b-4ed5-4d4e-9732-c5b0be5713ba",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e749968c-781b-41e9-a121-7053c2d6d4d3",
      target: "f7a97eec-bc4f-4438-8800-d09c11771317"
    },
    {
      id: "c652f5a1-3ddf-4693-9e3c-59fe72b8cbdd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "53e40c9f-de3f-44a1-a898-3438d09ba387",
      target: "bd0b6c9e-2bda-4569-a2c3-e0488bf4ee6b"
    },
    {
      id: "e9449fdd-beca-4e1b-847c-a14ff4718e27",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "53e40c9f-de3f-44a1-a898-3438d09ba387",
      target: "bd0b6c9e-2bda-4569-a2c3-e0488bf4ee6b"
    },
    {
      id: "7d4e99c8-9089-44e9-a4ac-6c47ae168f87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd0b6c9e-2bda-4569-a2c3-e0488bf4ee6b",
      target: "307bde6e-fb6e-43f4-bfec-9d7463ebf6be"
    },
    {
      id: "9132619c-97fc-406a-8190-6daa25ef6a7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f93d234d-d4d6-40d7-82eb-2d9763730eec",
      target: "b00d2f59-7dc1-4917-adc6-a8c0bd5643c9"
    },
    {
      id: "a4499bf1-ea4f-4204-8345-73594e3d4b77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b00d2f59-7dc1-4917-adc6-a8c0bd5643c9",
      target: "110ae5f5-17a4-4936-893a-12dd48117817"
    },
    {
      id: "845b619c-f9d7-4cc9-9e24-43485aad8a26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "110ae5f5-17a4-4936-893a-12dd48117817",
      target: "cae540cf-45e1-4836-9f91-8223673a0a82"
    },
    {
      id: "eb1cb256-48dd-465a-8e9e-f51bfc3caeb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cae540cf-45e1-4836-9f91-8223673a0a82",
      target: "2b124624-e63c-4a6a-8f49-8a3a5f2eb35d"
    },
    {
      id: "8d893bda-0c64-4ea1-94c3-9483503db205",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b124624-e63c-4a6a-8f49-8a3a5f2eb35d",
      target: "26e0016b-a958-452c-ae1f-3184e0741bd9"
    },
    {
      id: "8713aa41-c99b-438e-8130-d10f9adc8650",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26e0016b-a958-452c-ae1f-3184e0741bd9",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "ddd3b251-2f5e-4bcb-af1c-0920f7712495",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "307bde6e-fb6e-43f4-bfec-9d7463ebf6be",
      target: "f93d234d-d4d6-40d7-82eb-2d9763730eec"
    },
    {
      id: "4c7c19f3-0d18-4852-b00c-67caab220ace",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6b36f48-cc99-4421-b0fe-655c9cc30b57",
      target: "510bc2d0-baa0-4dae-92aa-8a3ee8bd7ff3"
    },
    {
      id: "e310a29c-196e-48b7-afea-da33efce6b53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6b36f48-cc99-4421-b0fe-655c9cc30b57",
      target: "c86e5224-8fd7-4379-a344-a4f1d0950fe2"
    },
    {
      id: "2d5d2a65-9a38-42a9-8c28-1b2d9e0f25b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "510bc2d0-baa0-4dae-92aa-8a3ee8bd7ff3",
      target: "b5a863b2-12c4-4e4d-9a64-73202f721fe9"
    },
    {
      id: "39047101-cac8-4977-bce8-5d898fe89e5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "510bc2d0-baa0-4dae-92aa-8a3ee8bd7ff3",
      target: "ca74c3ad-3724-4ea5-8b7e-5523a5250ef9"
    },
    {
      id: "26801a2c-4ff4-48d8-9c47-a850ea0ad038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5a863b2-12c4-4e4d-9a64-73202f721fe9",
      target: "84e77a30-74d9-4f42-82be-12329d0e59fa"
    },
    {
      id: "766183de-0674-4bef-899e-fca364b78e36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c86e5224-8fd7-4379-a344-a4f1d0950fe2",
      target: "ca74c3ad-3724-4ea5-8b7e-5523a5250ef9"
    },
    {
      id: "532891c0-a6c8-4b05-9fa2-8c8bb65a7cf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca74c3ad-3724-4ea5-8b7e-5523a5250ef9",
      target: "84e77a30-74d9-4f42-82be-12329d0e59fa"
    },
    {
      id: "38ea9e2f-0eee-46c5-8839-68feed696e6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84e77a30-74d9-4f42-82be-12329d0e59fa",
      target: "42d29dcf-7b03-45af-9da0-b05b3304154a"
    },
    {
      id: "2845d99f-2ca7-47ed-aaca-33b690b4eeb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23727721-3eda-48aa-8572-be386fbd9fee",
      target: "1f0a0bc9-0d28-4733-9311-09d01d4a19b1"
    },
    {
      id: "76f1c425-e1f3-4c7d-87a4-0338c44b9566",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5dc3de5-a127-42cd-a0db-425a496fcea3",
      target: "d594f419-340d-4d3f-a0f0-a32fe022f14d"
    },
    {
      id: "eb68f7f8-5057-44e1-b1f9-caf95c80d661",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5dc3de5-a127-42cd-a0db-425a496fcea3",
      target: "d594f419-340d-4d3f-a0f0-a32fe022f14d"
    },
    {
      id: "2b4fc136-1947-44cb-b196-5b0103ff04c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12303049-4506-470d-a35f-e5a38e13b3ab",
      target: "f5fd7581-bc99-48e6-9c5f-e9c3ee6de080"
    },
    {
      id: "4e6a462d-793b-4dd0-964d-bb26022e4ec8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12303049-4506-470d-a35f-e5a38e13b3ab",
      target: "b5dc3de5-a127-42cd-a0db-425a496fcea3"
    },
    {
      id: "f40969e7-14a0-4832-85b6-36ef5162ca3f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "12303049-4506-470d-a35f-e5a38e13b3ab",
      target: "b5dc3de5-a127-42cd-a0db-425a496fcea3"
    },
    {
      id: "d85bade1-e8cb-4315-ba8b-11d87f7d6a59",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "faa908c4-84af-47f9-80d7-a6baf70394bd",
      target: "12303049-4506-470d-a35f-e5a38e13b3ab"
    },
    {
      id: "7432b6cf-94e6-40f9-9746-b8b08b41f8fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "faa908c4-84af-47f9-80d7-a6baf70394bd",
      target: "12303049-4506-470d-a35f-e5a38e13b3ab"
    },
    {
      id: "d2bf912b-b487-47de-a3c1-04b84eac9371",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f167a6a8-f349-4333-9ee9-4eec52bf4647",
      target: "23727721-3eda-48aa-8572-be386fbd9fee"
    },
    {
      id: "e0667e64-4724-4d62-b1b3-f4f2cfe453e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f167a6a8-f349-4333-9ee9-4eec52bf4647",
      target: "faa908c4-84af-47f9-80d7-a6baf70394bd"
    },
    {
      id: "d9681427-98e3-48ef-89f6-d267511a63b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26528eee-edb3-46ca-bb02-9f443da418f1",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "a91af685-c684-43eb-abb7-380310aef435",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "25c1d062-01ae-4563-a707-ee47fabafd4e",
      target: "26528eee-edb3-46ca-bb02-9f443da418f1"
    },
    {
      id: "93f3fa73-14a8-475f-b635-2db1fa00f89c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "25c1d062-01ae-4563-a707-ee47fabafd4e",
      target: "26528eee-edb3-46ca-bb02-9f443da418f1"
    },
    {
      id: "cd4343dd-fc7f-489e-91ff-223d73621b18",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d594f419-340d-4d3f-a0f0-a32fe022f14d",
      target: "25c1d062-01ae-4563-a707-ee47fabafd4e"
    },
    {
      id: "e99aaffb-59af-49ce-a450-33da94d03dd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d594f419-340d-4d3f-a0f0-a32fe022f14d",
      target: "25c1d062-01ae-4563-a707-ee47fabafd4e"
    },
    {
      id: "413904cf-38b7-424f-9cc0-e07686d96a2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9734eb9a-fd01-4b43-b058-ea660800e142",
      target: "e1448107-e106-40b0-bad3-e45d5fd95790"
    },
    {
      id: "59e848a9-e2fb-455c-a7a0-e58dd9c6dfa5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1448107-e106-40b0-bad3-e45d5fd95790",
      target: "a25a8c05-003f-43f2-b2ca-a10cd02324dd"
    },
    {
      id: "4cd11e62-b67c-4a14-8974-f13741bd87bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a25a8c05-003f-43f2-b2ca-a10cd02324dd",
      target: "980d4c30-4282-42f0-97c1-7e787e90a56e"
    },
    {
      id: "7956613b-e757-480a-9037-84a3bf990f5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a25a8c05-003f-43f2-b2ca-a10cd02324dd",
      target: "e0bd96cc-3363-4ede-a223-0fc4b792552e"
    },
    {
      id: "ff096635-127b-4eaf-9890-815a187c33e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0bd96cc-3363-4ede-a223-0fc4b792552e",
      target: "4e89a163-490e-47ca-a560-ff9a639efb47"
    },
    {
      id: "2f6b3c55-2a79-4982-9fe4-14409c7aa89a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e89a163-490e-47ca-a560-ff9a639efb47",
      target: "7f23957a-6912-4549-a52f-01b1e24686d7"
    },
    {
      id: "af6546ec-7ee5-47bd-83be-235e6922e70e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f23957a-6912-4549-a52f-01b1e24686d7",
      target: "1f0a0bc9-0d28-4733-9311-09d01d4a19b1"
    },
    {
      id: "7f673fc9-3a21-4a71-a940-0c8fa4cc27d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f0a0bc9-0d28-4733-9311-09d01d4a19b1",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "9c31d614-d100-48f9-9ee3-1aece5e8e29c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fbc9a3d-a11a-481e-8dbb-83bff473de75",
      target: "42d29dcf-7b03-45af-9da0-b05b3304154a"
    },
    {
      id: "5376aa46-9f87-4ef8-a559-fd64e1625a13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc325006-809f-4eb6-a2d3-e0ece604105b",
      target: "d1d5ac4f-7495-4f56-8adc-355bfe546819"
    },
    {
      id: "b6d19484-199b-4dfc-8035-e0c7d68ef511",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1d5ac4f-7495-4f56-8adc-355bfe546819",
      target: "419d248e-e8a0-4e09-9d26-8851b166490b"
    },
    {
      id: "58b4fc75-b88c-4179-8be5-b51ddec42fbe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5fd7581-bc99-48e6-9c5f-e9c3ee6de080",
      target: "cc325006-809f-4eb6-a2d3-e0ece604105b"
    },
    {
      id: "4b4b116d-64ef-42a3-9a72-e9356c717947",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5fd7581-bc99-48e6-9c5f-e9c3ee6de080",
      target: "8fbc9a3d-a11a-481e-8dbb-83bff473de75"
    },
    {
      id: "2998c160-ff2b-47d2-abc4-d0425504de31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "419d248e-e8a0-4e09-9d26-8851b166490b",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "308f9629-2307-45e0-afa9-2ca05c7e55ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e611ff2-7796-4006-91c3-15c5fd46e223",
      target: "32f232aa-e01a-43cf-a211-68622fb84146"
    },
    {
      id: "d4566bc9-2bae-4562-8ad6-85497389a978",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32f232aa-e01a-43cf-a211-68622fb84146",
      target: "42d29dcf-7b03-45af-9da0-b05b3304154a"
    },
    {
      id: "1fa8336a-a19c-4f9e-ab16-a12cd7ce34ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "980d4c30-4282-42f0-97c1-7e787e90a56e",
      target: "7e611ff2-7796-4006-91c3-15c5fd46e223"
    },
    {
      id: "37ee6e45-9475-454e-9526-3aeb05b5ced9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42d29dcf-7b03-45af-9da0-b05b3304154a",
      target: "415d197c-8721-4070-b7d2-497fb58e0d02"
    },
    {
      id: "1dafa85e-ca94-4f64-ba0a-e7ab991df672",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cc6b2a1-28e2-432c-9333-957d8867107a",
      target: "aad2ee27-75d9-4b82-a5af-932ef4a31fad"
    },
    {
      id: "318a5f54-b860-4754-b12c-721ed11649ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cc6b2a1-28e2-432c-9333-957d8867107a",
      target: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8"
    },
    {
      id: "1cbc8869-5e00-45c1-8141-2a671f378d83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f419ff1-e532-4006-a0e9-07d0aad30a72",
      target: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5"
    },
    {
      id: "02d88655-6bfd-4854-9b47-8b5a105265f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "93267209-24ee-446c-bcec-37f8a12946cd",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "e619bcb5-d85e-408f-9a90-981a38985868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3045a71-cc67-46fe-8b41-5077137d1d69",
      target: "d7744250-088c-49da-926f-6abe9af37939"
    },
    {
      id: "c052b7d4-d30c-4b78-80d4-a65ba9d54383",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d692450c-aea9-4c48-894e-a0870dec709c",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "9a032819-6e3b-445e-ab8a-6699192a54a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8404001-50fe-4ad5-9496-6ac0bb33cfd8",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "66cfd0db-7376-4c49-8007-b89caadb58c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8d5bc1a-4c14-4246-a66d-42e171342cd4",
      target: "f9d86652-6a1c-40f5-a401-c4ba776bb6ef"
    },
    {
      id: "b5065dd5-3448-499d-b3e4-d79c8036b3d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f71cea6-1242-422e-b314-774cb4a09453",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "ffef42c1-0dec-402a-a77e-27f17ade37b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70db9058-eab2-46cb-8fed-6849cceba762",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "e7b6e43d-1b3c-46ff-ac50-68735350656d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9115becb-df28-4b8f-bc6b-f76537418602",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "cce61eef-aaab-4ce8-90a5-9e515d3b65a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c733d7a-dc8b-414c-8d68-e65562d5bebc",
      target: "c326228f-8c65-44f9-bab9-b8f64730433f"
    },
    {
      id: "fce02997-e290-403e-b7cf-082852eac494",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d6d9e7d-7442-49ba-983b-be39be3955c1",
      target: "4af56416-33e5-4482-a9d7-8d52e2548a47"
    },
    {
      id: "67787814-a25d-45a6-aedd-84055662a6c8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d6d9e7d-7442-49ba-983b-be39be3955c1",
      target: "4aef762f-166e-412d-b1d3-51be4aeddccf"
    },
    {
      id: "090e3fb3-48a6-454a-863e-5b27040946f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d6d9e7d-7442-49ba-983b-be39be3955c1",
      target: "32168247-a37b-4401-b5f9-f0c29e51031a"
    },
    {
      id: "b2b2c976-e5c5-4072-ae14-9640e690f632",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4af56416-33e5-4482-a9d7-8d52e2548a47",
      target: "32168247-a37b-4401-b5f9-f0c29e51031a"
    },
    {
      id: "b560821b-6ed6-48eb-8eb1-367089edc1b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4af56416-33e5-4482-a9d7-8d52e2548a47",
      target: "479b6606-d49b-4fe5-88c7-f4f4c95b0585"
    },
    {
      id: "7e1b4618-df01-4e5e-ad59-0fcf53c4164d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4af56416-33e5-4482-a9d7-8d52e2548a47",
      target: "bf0f2f61-4604-42f7-8a44-b75532890447"
    },
    {
      id: "a4fc3b2c-e737-4aed-82f1-55d36a3d0a08",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "32168247-a37b-4401-b5f9-f0c29e51031a",
      target: "99c76171-a13d-45b6-b825-38f4d5bea816"
    },
    {
      id: "fb9025e4-4f53-46c2-9289-72332701a639",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32168247-a37b-4401-b5f9-f0c29e51031a",
      target: "3c733d7a-dc8b-414c-8d68-e65562d5bebc"
    },
    {
      id: "4fddf005-1217-46e2-9c09-ff661f2b8b96",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "99c76171-a13d-45b6-b825-38f4d5bea816",
      target: "c326228f-8c65-44f9-bab9-b8f64730433f"
    },
    {
      id: "801a98a5-c661-416c-b8db-8148345626a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99c76171-a13d-45b6-b825-38f4d5bea816",
      target: "32649675-5f9a-4c00-91f6-aa2ef8b70d4f"
    },
    {
      id: "d43a65cd-5196-4958-8ce8-8669dc13d09c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c326228f-8c65-44f9-bab9-b8f64730433f",
      target: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe"
    },
    {
      id: "9d872f89-f54f-48f4-9405-c125b5199d91",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c326228f-8c65-44f9-bab9-b8f64730433f",
      target: "42ce33d6-85a8-43a4-9df8-1e057e94d91e"
    },
    {
      id: "e8ec732d-3f35-4f02-9ec2-70b0231a615b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c326228f-8c65-44f9-bab9-b8f64730433f",
      target: "93267209-24ee-446c-bcec-37f8a12946cd"
    },
    {
      id: "4fbb8756-e67a-4fac-a8ba-6ddda459807e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c326228f-8c65-44f9-bab9-b8f64730433f",
      target: "858a959c-41a7-4d86-8b40-78d80e3f8433"
    },
    {
      id: "21078b8d-bbb5-46f9-9e1d-6b81ba881909",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "858a959c-41a7-4d86-8b40-78d80e3f8433",
      target: "93267209-24ee-446c-bcec-37f8a12946cd"
    },
    {
      id: "852e2361-1e4f-4be2-821e-1cddbb82a288",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "858a959c-41a7-4d86-8b40-78d80e3f8433",
      target: "60c968a0-95b9-47f0-b58e-3e8974073d1d"
    },
    {
      id: "40a5f223-fa8d-489f-811d-f4ea64216864",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "858a959c-41a7-4d86-8b40-78d80e3f8433",
      target: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe"
    },
    {
      id: "8b50fbdb-eac6-489d-bb58-50eadc311c22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "858a959c-41a7-4d86-8b40-78d80e3f8433",
      target: "9076309b-cd3b-4e72-a3fe-bfe6658b53a7"
    },
    {
      id: "2ce5f7cc-f324-4a2b-9e99-f6bed68035a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9076309b-cd3b-4e72-a3fe-bfe6658b53a7",
      target: "93267209-24ee-446c-bcec-37f8a12946cd"
    },
    {
      id: "ae02f2a0-6e00-4db0-a6cc-77d831c6c8ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9076309b-cd3b-4e72-a3fe-bfe6658b53a7",
      target: "ead5cc6b-1e9f-4e41-a379-f5e4b730fdbe"
    },
    {
      id: "18c7374a-11f9-4e5c-b163-da8b2aaa50c8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4aef762f-166e-412d-b1d3-51be4aeddccf",
      target: "86f6ad65-38f0-4598-a223-a655c7f555fc"
    },
    {
      id: "672759f8-83cb-4909-8b83-793ae4ae8133",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4aef762f-166e-412d-b1d3-51be4aeddccf",
      target: "22b989cf-85fd-429a-9e42-130c8689b5f9"
    },
    {
      id: "83d5eb34-9c41-47e5-a950-1a42b9c0a53c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "86f6ad65-38f0-4598-a223-a655c7f555fc",
      target: "5791a32a-afaa-4585-a454-56bdd6f1d6b1"
    },
    {
      id: "b6a4a95e-9a36-429f-8489-d527564ffc42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86f6ad65-38f0-4598-a223-a655c7f555fc",
      target: "09654b2c-e592-4a63-9486-ab8550d78b28"
    },
    {
      id: "93d84b60-c4b5-4248-9920-46ff02e3918c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5791a32a-afaa-4585-a454-56bdd6f1d6b1",
      target: "3c238586-ddab-405d-af44-e1ca2dac8412"
    },
    {
      id: "81ead02d-d398-40b1-99ab-6defcef717cc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5791a32a-afaa-4585-a454-56bdd6f1d6b1",
      target: "09654b2c-e592-4a63-9486-ab8550d78b28"
    },
    {
      id: "c11c54f3-0c8f-43f3-a61e-a11c9fa62859",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5791a32a-afaa-4585-a454-56bdd6f1d6b1",
      target: "6eaf241b-c837-4e4e-ae35-788d9d0b8347"
    },
    {
      id: "404575c5-08ef-456a-ac9f-265681bcdc6e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09654b2c-e592-4a63-9486-ab8550d78b28",
      target: "963add96-1857-4130-80f5-cf03290831e1"
    },
    {
      id: "b6c63329-0674-4a85-b694-0ad8bba1ab02",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "09654b2c-e592-4a63-9486-ab8550d78b28",
      target: "6eaf241b-c837-4e4e-ae35-788d9d0b8347"
    },
    {
      id: "6845e00c-1a59-4da4-addf-86186e2f8bdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09654b2c-e592-4a63-9486-ab8550d78b28",
      target: "be9a3cae-a5bc-4239-9b4c-05ac5c53f89f"
    },
    {
      id: "ca17b8b9-e870-48e9-b734-1598d08359cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c238586-ddab-405d-af44-e1ca2dac8412",
      target: "d939c3d6-2c9b-4f9b-bb83-a9d053e91b55"
    },
    {
      id: "1db5945a-dd71-4b48-93d3-f7321a0cb24e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c238586-ddab-405d-af44-e1ca2dac8412",
      target: "6eaf241b-c837-4e4e-ae35-788d9d0b8347"
    },
    {
      id: "599aef94-42e5-4107-ac04-3edbf2527770",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6eaf241b-c837-4e4e-ae35-788d9d0b8347",
      target: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f"
    },
    {
      id: "7d040131-032e-429d-ba07-e13389319d36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6eaf241b-c837-4e4e-ae35-788d9d0b8347",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "184565e2-0697-4125-afc1-921c92f10426",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6eaf241b-c837-4e4e-ae35-788d9d0b8347",
      target: "d692450c-aea9-4c48-894e-a0870dec709c"
    },
    {
      id: "698b2eb2-72a1-47b7-8164-b1b7100c1a5f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6eaf241b-c837-4e4e-ae35-788d9d0b8347",
      target: "963add96-1857-4130-80f5-cf03290831e1"
    },
    {
      id: "815afa50-3b19-4497-8157-e0892ff8a4de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f",
      target: "026e3909-8c5e-443b-830c-4d8cfc419135"
    },
    {
      id: "08d4affc-7e89-4740-9a0b-b13e97bd6bb0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f",
      target: "d692450c-aea9-4c48-894e-a0870dec709c"
    },
    {
      id: "2310e15e-2481-423e-89f9-f99c60d768cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f",
      target: "aecb3155-a072-400f-ac87-21c55b5bc4be"
    },
    {
      id: "fd6fe30a-86fe-4d99-99f9-05e0afb30f51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3457f3dc-c264-4bd6-8a27-8b0ca8c63f3f",
      target: "8269f368-6921-403e-a18a-f9a2f424bb7a"
    },
    {
      id: "a8fb55b7-90c0-4f60-8e49-ffed59a54fae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8269f368-6921-403e-a18a-f9a2f424bb7a",
      target: "d692450c-aea9-4c48-894e-a0870dec709c"
    },
    {
      id: "6af514fa-e651-4037-8a49-446ccffc21a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8269f368-6921-403e-a18a-f9a2f424bb7a",
      target: "026e3909-8c5e-443b-830c-4d8cfc419135"
    },
    {
      id: "2fe7a99b-cf22-491e-b5d5-f59fdc530630",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22b989cf-85fd-429a-9e42-130c8689b5f9",
      target: "90048737-b66d-45c4-aaf8-f6ed96c52b65"
    },
    {
      id: "cd998762-b422-40a9-858a-b47e68764e0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90048737-b66d-45c4-aaf8-f6ed96c52b65",
      target: "d9daeef8-71e8-4668-a999-3f46fe2b356d"
    },
    {
      id: "1ebba4bb-ea4e-46fd-9b7f-0a8efc9fbb17",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d9daeef8-71e8-4668-a999-3f46fe2b356d",
      target: "5fadcab1-1647-4a91-9e20-0bbeb8331a28"
    },
    {
      id: "9d64fa57-e30f-4444-b6ad-edcc86434e33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9daeef8-71e8-4668-a999-3f46fe2b356d",
      target: "df07a5bd-4110-44ee-9bec-2d86c528f2f5"
    },
    {
      id: "d24bfff2-393b-4100-b7ee-c246d5a39205",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9daeef8-71e8-4668-a999-3f46fe2b356d",
      target: "65317120-a9f6-4f06-95cb-94e066f777b7"
    },
    {
      id: "fd9ffdaf-3f6f-4e45-9b30-d927ae79904f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fadcab1-1647-4a91-9e20-0bbeb8331a28",
      target: "a8404001-50fe-4ad5-9496-6ac0bb33cfd8"
    },
    {
      id: "7ef5dc66-5a24-4a6e-bc40-7280453c0a65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fadcab1-1647-4a91-9e20-0bbeb8331a28",
      target: "df07a5bd-4110-44ee-9bec-2d86c528f2f5"
    },
    {
      id: "cc0949ec-bb65-4190-b2e9-6ae5b9e68858",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fadcab1-1647-4a91-9e20-0bbeb8331a28",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "a1879937-fa72-4e2b-ba0f-4ffb02c6a0f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8",
      target: "828e2b04-6e5a-4259-94a4-828c11f3f999"
    },
    {
      id: "f2ddb2b3-5807-45b2-9ad5-6d2511315650",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8",
      target: "c79a70af-d9ce-4920-b3c9-f8eac61a2ed3"
    },
    {
      id: "34096e27-2251-4014-aeff-10d3f2cd98b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8",
      target: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346"
    },
    {
      id: "6b8d5075-8404-4579-8257-0c019a10afe2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "abb99ed0-8a95-466e-99dd-475492996a6a",
      target: "283ccf29-de5d-439d-b58f-c58db84dee49"
    },
    {
      id: "8b0af52f-73cd-46a9-bf0a-5f6c7c9ed050",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "abb99ed0-8a95-466e-99dd-475492996a6a",
      target: "283ccf29-de5d-439d-b58f-c58db84dee49"
    },
    {
      id: "3bf5aec5-c6a2-40e7-b954-4ad54f3a279a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "283ccf29-de5d-439d-b58f-c58db84dee49",
      target: "d8d5bc1a-4c14-4246-a66d-42e171342cd4"
    },
    {
      id: "1e78ba58-d6c8-4918-bfcd-9f718bf1346b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "283ccf29-de5d-439d-b58f-c58db84dee49",
      target: "dc4f7c12-f003-4b56-b9ad-9c47268fa8ca"
    },
    {
      id: "d57438ec-108b-4d45-885a-9d4ee2964926",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dc4f7c12-f003-4b56-b9ad-9c47268fa8ca",
      target: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8"
    },
    {
      id: "5ecd569f-5183-4f5d-98e6-6a15729a2015",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "07597252-10db-4c9b-8c6a-3b80dfe714fb"
    },
    {
      id: "02256a82-8d92-426f-960c-a0e04d9f4380",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "009d22ab-ab20-4945-89c3-10a7608e60e2"
    },
    {
      id: "d02734b5-3291-45ea-83c6-cd43dadb3ad9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "2e3c3a5f-c10e-4f9e-8ea9-66f71ebcca3c"
    },
    {
      id: "a6c25aa4-33a0-4723-b97f-f1dedb551f4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6"
    },
    {
      id: "6175c84d-48b0-417f-a651-fb2f4f6d06a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "0e38b366-0370-44f3-98bc-11d1f59d7bcd"
    },
    {
      id: "a33b1e3e-0d1b-4c8f-a1b5-b2054a35e0df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "9c1b5dd9-f405-4ac4-b975-1e3b584533fb"
    },
    {
      id: "fab1062a-6c69-4d61-bfb6-29a0877deb34",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "492dd585-663c-4e43-9251-2677e89f9334",
      target: "e9e23379-a129-4ebb-b80c-e8552edee979"
    },
    {
      id: "96d5c36f-ed01-4a55-b563-0ed51de66372",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "3230f31f-ea7e-4e45-91e9-783440d1103f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4",
      target: "2fa140d4-6e65-4b79-a55f-189dcae41a1f"
    },
    {
      id: "a019ce70-d424-4079-9628-fee9e23e5788",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b59c5ff3-e4aa-4cd6-949c-2d9feb6aa3e4",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "eacbc2ed-8600-4f3f-9f8e-5881e8530e1e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "01146062-a3b3-4b1c-a6f6-82cd7891b826",
      target: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f"
    },
    {
      id: "2282a31a-e96b-4a84-9fec-10d98469969b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "01146062-a3b3-4b1c-a6f6-82cd7891b826",
      target: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f"
    },
    {
      id: "84b05540-3ea5-4af4-aa8e-cb23c49ec191",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6e8dd9e7-9304-4294-a080-e8a803cfa7bd",
      target: "416e56f1-651a-42f2-b5e9-a5dc39061a55"
    },
    {
      id: "98679af4-eb88-4a10-b67f-0a647c852f4a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f",
      target: "4a121ac5-3f0c-4f5d-a5e9-a4f821e0ee48"
    },
    {
      id: "6b09460f-f82c-4c88-9927-f2982f7976f4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f",
      target: "87d31044-91f0-4602-ad3f-fb2e6f10955c"
    },
    {
      id: "9b4eb461-2eeb-41ea-8cfd-57a4f3e08d2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f",
      target: "52cdb49b-fa91-43cc-a713-e781a47f993c"
    },
    {
      id: "d450188b-e378-48ca-b0d6-09d9c422e359",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f",
      target: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70"
    },
    {
      id: "cf69eaf1-fea3-45bd-9b83-ddf5c6102900",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52cdb49b-fa91-43cc-a713-e781a47f993c",
      target: "2b7905ca-abf2-478a-9e87-57603cb49322"
    },
    {
      id: "49189a3a-e0b2-46cf-bbfe-3436b32876c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b7905ca-abf2-478a-9e87-57603cb49322",
      target: "20b8f869-0c8e-4a21-9c77-0c6bac5e755d"
    },
    {
      id: "b1bd61d9-e9a8-4d36-a8d5-3ba38dbf266e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20b8f869-0c8e-4a21-9c77-0c6bac5e755d",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "f27c9ab8-8268-4d09-9538-258f0e1d7dd8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "416e56f1-651a-42f2-b5e9-a5dc39061a55",
      target: "d857659c-0d1c-413b-b8e0-5876ad2b7d6f"
    },
    {
      id: "5e4f6670-5ba0-48da-ba1e-eac68e059821",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "416e56f1-651a-42f2-b5e9-a5dc39061a55",
      target: "01146062-a3b3-4b1c-a6f6-82cd7891b826"
    },
    {
      id: "19661cca-2522-47f6-8f2e-2bb30ab56ba8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "416e56f1-651a-42f2-b5e9-a5dc39061a55",
      target: "01146062-a3b3-4b1c-a6f6-82cd7891b826"
    },
    {
      id: "e7081e6e-d06a-4257-ab1d-34c02a97ea0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fa140d4-6e65-4b79-a55f-189dcae41a1f",
      target: "e679dffd-23f0-4679-9bde-06d466c544eb"
    },
    {
      id: "4b20b424-754e-4f34-badf-c1d38418b7dc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2fa140d4-6e65-4b79-a55f-189dcae41a1f",
      target: "3425e907-188e-4aa2-a053-383ec1447e12"
    },
    {
      id: "b82f5f3e-090f-4780-a25f-1ec8a963316c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e679dffd-23f0-4679-9bde-06d466c544eb",
      target: "87d31044-91f0-4602-ad3f-fb2e6f10955c"
    },
    {
      id: "c17f43e8-c86f-4ed0-bf53-3d8f51962782",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e679dffd-23f0-4679-9bde-06d466c544eb",
      target: "817722c1-e053-4a58-a9fe-2de4c72680d8"
    },
    {
      id: "2dad63d6-7664-4198-bfac-586defb0708d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "817722c1-e053-4a58-a9fe-2de4c72680d8",
      target: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0"
    },
    {
      id: "3414e5c4-5dfa-4052-8ae1-8a62e7ec41ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "817722c1-e053-4a58-a9fe-2de4c72680d8",
      target: "bd992907-f5c4-4168-bbe9-ccb2db5a56ca"
    },
    {
      id: "b99beaa6-0858-4d61-a061-078b8ac1fbec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd992907-f5c4-4168-bbe9-ccb2db5a56ca",
      target: "0372fb69-b3c6-488a-8a0a-4032aeb49725"
    },
    {
      id: "ced2d489-eabd-431e-a06b-795c4e3fbfef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd992907-f5c4-4168-bbe9-ccb2db5a56ca",
      target: "ae7d5631-0e66-4aa4-a199-d819775a27d0"
    },
    {
      id: "05dd061b-2ba4-4e5f-8ab9-df2d3ebc05c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0372fb69-b3c6-488a-8a0a-4032aeb49725",
      target: "3892f785-2396-4be5-b68b-89b6399eaf36"
    },
    {
      id: "fcadc6f7-b848-4bc5-a130-220e329893f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0372fb69-b3c6-488a-8a0a-4032aeb49725",
      target: "46a201c1-27ca-4726-ae3b-537532fb4b64"
    },
    {
      id: "87496c7e-6239-49c4-bfa7-bcde65c13f98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3892f785-2396-4be5-b68b-89b6399eaf36",
      target: "6e8dd9e7-9304-4294-a080-e8a803cfa7bd"
    },
    {
      id: "277f05ef-073d-4cae-98a3-94ee4bf59a00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87d31044-91f0-4602-ad3f-fb2e6f10955c",
      target: "ac1292d8-552e-42fd-a671-f7d1df6a508b"
    },
    {
      id: "1ac6198e-2d05-4b72-8f97-f7b4f6941098",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87d31044-91f0-4602-ad3f-fb2e6f10955c",
      target: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70"
    },
    {
      id: "4466ef95-db77-422a-ae4e-d4520f875679",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87d31044-91f0-4602-ad3f-fb2e6f10955c",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "6bde13f5-3ae2-49bf-810e-a95a9db1b5f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac1292d8-552e-42fd-a671-f7d1df6a508b",
      target: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d"
    },
    {
      id: "61e71533-1de9-4ae0-8713-ed7c729a83f4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d",
      target: "824c45aa-79aa-44c1-9452-028364ab53b0"
    },
    {
      id: "63c6ae53-4ed4-42f3-8354-75adbb1e8911",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d",
      target: "c2ba5953-47b1-495e-9759-8f696fa33150"
    },
    {
      id: "a323b468-1c05-43aa-a77c-38eadfb66b7b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d",
      target: "824c45aa-79aa-44c1-9452-028364ab53b0"
    },
    {
      id: "0060560a-c1b1-461d-854c-0d030d2507da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d6671f9-63e0-48d7-8fa2-9cf81dc3565d",
      target: "916f6428-167e-48fa-ad3d-b588500f6de3"
    },
    {
      id: "e65296dc-6036-4510-9718-e55835f595d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      target: "6dd06b46-cefc-408b-b842-c9dc9ddca936"
    },
    {
      id: "2cd7926a-01d2-47f5-bff9-5361f4413495",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      target: "14796376-b4a8-47d0-a072-4d7d7b938edb"
    },
    {
      id: "2c4699d2-974c-4c09-9589-d4f00f9cc806",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "faec8832-efe5-48c5-9c00-7a62a71524fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      target: "14796376-b4a8-47d0-a072-4d7d7b938edb"
    },
    {
      id: "d345808f-69cb-45a5-932b-e4755ea49241",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae7d5631-0e66-4aa4-a199-d819775a27d0",
      target: "14311162-e5f2-4a9a-a047-a5f6a8e31db0"
    },
    {
      id: "6333cf04-3061-4dfa-9300-d85b41a1f258",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6dd06b46-cefc-408b-b842-c9dc9ddca936",
      target: "6ccf8e11-2550-49a1-9505-eda80e16d169"
    },
    {
      id: "97c0b102-4363-4fe2-8080-c9c0e4df7d63",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6dd06b46-cefc-408b-b842-c9dc9ddca936",
      target: "8ed1a712-75d7-4b2d-8ca6-1c60cafd45f4"
    },
    {
      id: "600d8643-4717-4234-8881-51fa52e2ed5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6dd06b46-cefc-408b-b842-c9dc9ddca936",
      target: "e6c023fe-80ab-4201-b7a2-197edcdc60cd"
    },
    {
      id: "ce3820dc-8798-438d-b8a3-af8180421fb7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6dd06b46-cefc-408b-b842-c9dc9ddca936",
      target: "5a31b882-80c6-49fd-928e-34632a831486"
    },
    {
      id: "03e1ca9b-7926-4a33-8615-e92c2d154347",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5a31b882-80c6-49fd-928e-34632a831486",
      target: "7465548e-3752-46b9-a9de-de74fa0cde36"
    },
    {
      id: "1a8648ec-d544-4390-8256-e93a77b20d6b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5a31b882-80c6-49fd-928e-34632a831486",
      target: "7465548e-3752-46b9-a9de-de74fa0cde36"
    },
    {
      id: "8fc5d54d-d5c5-45da-bd60-11802188aee3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e6c023fe-80ab-4201-b7a2-197edcdc60cd",
      target: "71710f75-81d5-4eaf-891b-683fe501afec"
    },
    {
      id: "8f0a6fd8-9fcf-4172-8384-3002cb59fe3c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6c023fe-80ab-4201-b7a2-197edcdc60cd",
      target: "c337f453-3ddf-4941-897e-2c0840b1969a"
    },
    {
      id: "1851ee5c-a1d3-4203-8368-8a1c86d9e716",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ccf8e11-2550-49a1-9505-eda80e16d169",
      target: "992febb7-4f25-43fa-a90f-fe56ed7dff43"
    },
    {
      id: "1e1d1799-b041-4995-a1e4-ade3b427b64d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b57cc1f2-2e5e-4535-aff2-4d0bc5e98ad2",
      target: "2c03a27c-9f28-4721-8193-3dd1f3ff7394"
    },
    {
      id: "1e7e6495-5384-4f47-a5b1-9ba77ec666ad",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b57cc1f2-2e5e-4535-aff2-4d0bc5e98ad2",
      target: "2c03a27c-9f28-4721-8193-3dd1f3ff7394"
    },
    {
      id: "bdaacb52-3455-4f79-999a-4c752a959bfe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2c03a27c-9f28-4721-8193-3dd1f3ff7394",
      target: "4f7f364d-e265-46e7-8a2a-1d99cdaf4f20"
    },
    {
      id: "4e172d8d-9ba0-40b0-91e7-7d4ec30471cc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2c03a27c-9f28-4721-8193-3dd1f3ff7394",
      target: "4f7f364d-e265-46e7-8a2a-1d99cdaf4f20"
    },
    {
      id: "835cff70-72a5-4d0f-b6fb-c3f36515adc3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2c03a27c-9f28-4721-8193-3dd1f3ff7394",
      target: "527d81e1-c1f2-451f-a6a7-2901ef53f45b"
    },
    {
      id: "496bf35d-b0e1-45fc-a877-78dd95f4d8f2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4f7f364d-e265-46e7-8a2a-1d99cdaf4f20",
      target: "52739a62-3ec3-4d82-a355-74615201eff7"
    },
    {
      id: "71a46fe6-6663-4969-9e69-a834accc5031",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4f7f364d-e265-46e7-8a2a-1d99cdaf4f20",
      target: "52739a62-3ec3-4d82-a355-74615201eff7"
    },
    {
      id: "a4b248db-0275-463a-b142-efbe59d9c60c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52739a62-3ec3-4d82-a355-74615201eff7",
      target: "61d8a848-a111-42d4-80f2-e97260d63199"
    },
    {
      id: "de1edf70-bd47-4208-ad40-af0cc91e4083",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7465548e-3752-46b9-a9de-de74fa0cde36",
      target: "8b5b9430-3767-4927-b57d-e8aa7614519b"
    },
    {
      id: "7825710e-cf6b-4e1d-9ae9-eeb9b8e4915c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50abbfcc-c6d0-4c3b-8ea5-aa64950c1dbf",
      target: "6a044aad-9d8a-442e-821c-1b34590dad07"
    },
    {
      id: "b1b8b757-1795-4405-95ee-e09bfca489a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61d8a848-a111-42d4-80f2-e97260d63199",
      target: "ce2feedb-ff89-43ca-8110-742692dd5e83"
    },
    {
      id: "58446439-5ae9-45ba-88b5-e0cb82c0d091",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6e09fdd0-a78c-412b-a308-88e90ceb068c",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "2f5bf66b-f9b3-4c4a-b2eb-9a0109217777",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e09fdd0-a78c-412b-a308-88e90ceb068c",
      target: "b795d137-86ae-487b-be8d-5f1696045771"
    },
    {
      id: "c37ffa30-0214-42b3-a825-5506bd63b4aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b795d137-86ae-487b-be8d-5f1696045771",
      target: "0e38b366-0370-44f3-98bc-11d1f59d7bcd"
    },
    {
      id: "d842e0c3-a7bc-43cb-b0ea-ab2c3e139a90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b795d137-86ae-487b-be8d-5f1696045771",
      target: "9c1b5dd9-f405-4ac4-b975-1e3b584533fb"
    },
    {
      id: "4cf22655-cd4a-4c3d-b821-46b1c1594231",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b795d137-86ae-487b-be8d-5f1696045771",
      target: "b51749df-6609-4c25-bdc6-b2f98fe27360"
    },
    {
      id: "933c24d1-f43a-45f7-b71e-c8b9c63ce03f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ed1a712-75d7-4b2d-8ca6-1c60cafd45f4",
      target: "b57cc1f2-2e5e-4535-aff2-4d0bc5e98ad2"
    },
    {
      id: "11c226d0-59c9-4211-aa04-2d1215beec5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ed1a712-75d7-4b2d-8ca6-1c60cafd45f4",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "5fbd7628-e499-4614-947e-3c8b93cd06ae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8b5b9430-3767-4927-b57d-e8aa7614519b",
      target: "50abbfcc-c6d0-4c3b-8ea5-aa64950c1dbf"
    },
    {
      id: "d6823623-cb5e-4b51-b0e6-af6a1850b6b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8b5b9430-3767-4927-b57d-e8aa7614519b",
      target: "50abbfcc-c6d0-4c3b-8ea5-aa64950c1dbf"
    },
    {
      id: "a20b2e75-585d-4b66-9a69-4e42733ffc91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a044aad-9d8a-442e-821c-1b34590dad07",
      target: "d4e90eb6-671b-4c28-bfb6-75806bbb4e37"
    },
    {
      id: "4e0f7c62-b3f0-4f25-93f3-6d7b61069745",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce2feedb-ff89-43ca-8110-742692dd5e83",
      target: "6e09fdd0-a78c-412b-a308-88e90ceb068c"
    },
    {
      id: "d9b9fb67-bb84-40e7-9d8a-622a709664db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b51749df-6609-4c25-bdc6-b2f98fe27360",
      target: "0e38b366-0370-44f3-98bc-11d1f59d7bcd"
    },
    {
      id: "2b45aaa4-a53d-4301-a2d1-f7b024a5e348",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b51749df-6609-4c25-bdc6-b2f98fe27360",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "ce879430-5999-4927-8841-99a715b9a39c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b51749df-6609-4c25-bdc6-b2f98fe27360",
      target: "9c1b5dd9-f405-4ac4-b975-1e3b584533fb"
    },
    {
      id: "211edb04-6407-4fe0-abb1-4699baa5e02b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0",
      target: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5"
    },
    {
      id: "503eb790-19d0-4ec7-ac64-7309be01208a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0",
      target: "841df35d-6f24-4908-8c1e-3bcc4a3c2516"
    },
    {
      id: "769b09ab-983a-4d2f-a52d-53446186eb12",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a2cfdd99-9b0b-43ce-bd8a-936035f89ad0",
      target: "ce1318c2-0edb-4778-a5be-445c057c5c34"
    },
    {
      id: "720490fb-d6e4-4822-a4f8-1b395c3a5ea5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ebd7caf-1b83-4268-a22b-1309dea9dbe4",
      target: "bfa698a9-58a1-407b-aeb6-db5a052eb567"
    },
    {
      id: "3b14938f-4e34-4ee9-8638-c6b16c944e46",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "992febb7-4f25-43fa-a90f-fe56ed7dff43",
      target: "c337f453-3ddf-4941-897e-2c0840b1969a"
    },
    {
      id: "395a9d2a-e27d-497e-bbfc-f7809a63b0b0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "992febb7-4f25-43fa-a90f-fe56ed7dff43",
      target: "71710f75-81d5-4eaf-891b-683fe501afec"
    },
    {
      id: "72b5bf33-e94e-4d48-9ecc-f62f5ddf939d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c337f453-3ddf-4941-897e-2c0840b1969a",
      target: "71710f75-81d5-4eaf-891b-683fe501afec"
    },
    {
      id: "f7ecc945-fd2e-45a7-b2a6-0b4c84bcc84d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "527d81e1-c1f2-451f-a6a7-2901ef53f45b",
      target: "bfa698a9-58a1-407b-aeb6-db5a052eb567"
    },
    {
      id: "307177a6-df5a-46c2-b2c0-9f3014d37701",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "527d81e1-c1f2-451f-a6a7-2901ef53f45b",
      target: "fb85b6a3-c5a8-47b2-9ea7-8ffc1fc2d357"
    },
    {
      id: "f232d304-e489-4501-b59f-80a5464bff9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfa698a9-58a1-407b-aeb6-db5a052eb567",
      target: "cd47765e-6b89-42bd-a873-eb60411a31b9"
    },
    {
      id: "6c9e0656-34d6-410f-856f-9f1cb61d2c2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd47765e-6b89-42bd-a873-eb60411a31b9",
      target: "2e3c3a5f-c10e-4f9e-8ea9-66f71ebcca3c"
    },
    {
      id: "6e007420-148a-4d7a-89cd-3922408c19ae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cd47765e-6b89-42bd-a873-eb60411a31b9",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "1bd96fb6-708b-43e9-92d1-2c53efd1a34c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2e3c3a5f-c10e-4f9e-8ea9-66f71ebcca3c",
      target: "b795d137-86ae-487b-be8d-5f1696045771"
    },
    {
      id: "bf11ac62-3cbb-49ea-81dc-daa98bf7615a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e3c3a5f-c10e-4f9e-8ea9-66f71ebcca3c",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "dd420c14-74c1-45b5-9eed-6c55eb6d4bff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "841df35d-6f24-4908-8c1e-3bcc4a3c2516",
      target: "ce1318c2-0edb-4778-a5be-445c057c5c34"
    },
    {
      id: "0cdadc17-d11d-491d-abda-efba2b84b383",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "841df35d-6f24-4908-8c1e-3bcc4a3c2516",
      target: "5ebd7caf-1b83-4268-a22b-1309dea9dbe4"
    },
    {
      id: "fe528ed5-e9bb-4c63-a700-850efa729aa0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "841df35d-6f24-4908-8c1e-3bcc4a3c2516",
      target: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5"
    },
    {
      id: "79aa8579-ed89-4838-a9bc-08ac9e18cf88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71710f75-81d5-4eaf-891b-683fe501afec",
      target: "527d81e1-c1f2-451f-a6a7-2901ef53f45b"
    },
    {
      id: "24f3904c-51d9-4681-89a2-90f7f834a9cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46a201c1-27ca-4726-ae3b-537532fb4b64",
      target: "55a0fd5c-45ee-419c-9e39-4c1865299c37"
    },
    {
      id: "f29fda3f-b1ff-4ea7-9ad8-51a8492fccf3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55a0fd5c-45ee-419c-9e39-4c1865299c37",
      target: "fb85b6a3-c5a8-47b2-9ea7-8ffc1fc2d357"
    },
    {
      id: "4bfb62d6-45db-4e1c-bc0a-c2796307ec49",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fb85b6a3-c5a8-47b2-9ea7-8ffc1fc2d357",
      target: "7a5cd3b6-a925-43dd-9df1-20c410a102c6"
    },
    {
      id: "d25dd63f-ad2d-48c7-827f-bab003c540d3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fb85b6a3-c5a8-47b2-9ea7-8ffc1fc2d357",
      target: "7a5cd3b6-a925-43dd-9df1-20c410a102c6"
    },
    {
      id: "9202ab2c-f416-4a2e-a576-ac39de35465b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a5cd3b6-a925-43dd-9df1-20c410a102c6",
      target: "02b3d7c8-80d7-4f5a-966f-7131ef11254c"
    },
    {
      id: "8fb907c3-b8b1-4ea8-ac2a-d2566f1e3f9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02b3d7c8-80d7-4f5a-966f-7131ef11254c",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "eefc6dc4-1c45-4897-a855-2d00dba223cc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "02b3d7c8-80d7-4f5a-966f-7131ef11254c",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "6d43ffba-6f33-4fbd-a6a1-b61c7aef016c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3425e907-188e-4aa2-a053-383ec1447e12",
      target: "629e492e-82fc-4cf7-beab-04f919cf07fe"
    },
    {
      id: "a65df68a-6a06-4390-a407-fd903eca9865",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "629e492e-82fc-4cf7-beab-04f919cf07fe",
      target: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70"
    },
    {
      id: "fa2e5464-46b5-4d74-993d-a6638ae5834c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "629e492e-82fc-4cf7-beab-04f919cf07fe",
      target: "40407a0a-3c8b-4b27-980d-516d0baf25c8"
    },
    {
      id: "03d724b7-88f2-4405-a60f-62ae7c3015d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "40407a0a-3c8b-4b27-980d-516d0baf25c8",
      target: "88495794-a10c-4687-ae42-e93d34cae0b6"
    },
    {
      id: "cb89e64a-680f-40dd-a9c6-65cedc7eb937",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "40407a0a-3c8b-4b27-980d-516d0baf25c8",
      target: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5"
    },
    {
      id: "113d5e21-dcb8-41a3-ac3e-62db33232eee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88495794-a10c-4687-ae42-e93d34cae0b6",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "71d3f073-1276-467c-8381-b5bd9d500047",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88495794-a10c-4687-ae42-e93d34cae0b6",
      target: "ff622825-6d1e-4f1c-a095-0cac0495ccc3"
    },
    {
      id: "af6c14f1-8cc2-46a6-bb4b-89befebc2ce5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff622825-6d1e-4f1c-a095-0cac0495ccc3",
      target: "364804f1-dd1b-4b3c-b6b5-7c7841f23ae6"
    },
    {
      id: "b6527e6a-2e45-4b26-98f6-a2886e207c4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff622825-6d1e-4f1c-a095-0cac0495ccc3",
      target: "6aa2afa4-ef9a-49be-b9e3-7d04b7b5c79d"
    },
    {
      id: "8ebda7e2-463a-4675-939a-7fbeaada1831",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6aa2afa4-ef9a-49be-b9e3-7d04b7b5c79d",
      target: "6e8dd9e7-9304-4294-a080-e8a803cfa7bd"
    },
    {
      id: "d5ad1f88-d91b-4591-a53f-74b334147eb5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6aa2afa4-ef9a-49be-b9e3-7d04b7b5c79d",
      target: "82de2168-e717-48cd-85cc-c0d71269d36c"
    },
    {
      id: "56dda88b-16a2-426c-add5-5e6e50f2b453",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be3d8687-46f8-4faf-abfd-ea1f3fc0bf70",
      target: "824c45aa-79aa-44c1-9452-028364ab53b0"
    },
    {
      id: "67e894f8-76db-4f1e-8f21-2a12f335f2b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "824c45aa-79aa-44c1-9452-028364ab53b0",
      target: "916f6428-167e-48fa-ad3d-b588500f6de3"
    },
    {
      id: "27154efb-e12c-4085-93e2-59b9c086715e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "916f6428-167e-48fa-ad3d-b588500f6de3",
      target: "665be56c-ca32-41f1-b063-d66cc299b54d"
    },
    {
      id: "d3f15b97-0caf-49b7-8d97-e2520c13ab64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "665be56c-ca32-41f1-b063-d66cc299b54d",
      target: "c44a0923-e34d-491d-b45f-2e298a2641bb"
    },
    {
      id: "cf181ee6-76a8-4897-8284-536b6b9521f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "665be56c-ca32-41f1-b063-d66cc299b54d",
      target: "14796376-b4a8-47d0-a072-4d7d7b938edb"
    },
    {
      id: "df8043bc-c39c-4708-a9b3-e6c41b6c074d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c44a0923-e34d-491d-b45f-2e298a2641bb",
      target: "5c6f3038-7ae8-40d1-808f-5b07864c7aa4"
    },
    {
      id: "fd594758-dbb7-40b2-80a5-8711ed5d79dc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c44a0923-e34d-491d-b45f-2e298a2641bb",
      target: "0d7cbfaf-7842-41a9-979a-e42998cf714c"
    },
    {
      id: "c27b77ba-9ea5-4681-b1e0-1d10d111b79a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c44a0923-e34d-491d-b45f-2e298a2641bb",
      target: "05396eb4-aea4-4f7e-8120-7e2d36a26000"
    },
    {
      id: "5da323a4-dc78-4bf2-8905-79b37428426b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c44a0923-e34d-491d-b45f-2e298a2641bb",
      target: "4e35947f-14d0-40e5-bb6d-17eccc689ee4"
    },
    {
      id: "e3a320d6-c421-462d-8fac-747040aee427",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e35947f-14d0-40e5-bb6d-17eccc689ee4",
      target: "e822797a-5dbe-4e4b-8f94-1911d8e72630"
    },
    {
      id: "1a251bb5-1437-4b25-8221-10a5ec54a97f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e35947f-14d0-40e5-bb6d-17eccc689ee4",
      target: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154"
    },
    {
      id: "af350e7e-20e6-4277-8aef-58d3e9db33a4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e35947f-14d0-40e5-bb6d-17eccc689ee4",
      target: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154"
    },
    {
      id: "93a56603-4030-40b0-84b0-43d25103a711",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "05396eb4-aea4-4f7e-8120-7e2d36a26000",
      target: "f8eb7462-7197-46ab-adbe-b3b4e8d7c9c2"
    },
    {
      id: "aee9f9b3-ee5f-444e-ae44-88b8a1de4733",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "05396eb4-aea4-4f7e-8120-7e2d36a26000",
      target: "da68dcfd-799f-4659-8a7d-1bcf9db99802"
    },
    {
      id: "b5abbf30-2d51-4682-b658-d3a43d0f3783",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "05396eb4-aea4-4f7e-8120-7e2d36a26000",
      target: "f8eb7462-7197-46ab-adbe-b3b4e8d7c9c2"
    },
    {
      id: "ea7e77b2-e99a-47c6-be0d-a148f69a8d78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d7cbfaf-7842-41a9-979a-e42998cf714c",
      target: "a1178e13-fe81-479c-9255-7718bb819472"
    },
    {
      id: "f57086a0-3966-4241-b81e-c77ae2c0a2ed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "77dd5370-9411-40b1-9bba-a426f4b98ac3",
      target: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39"
    },
    {
      id: "e0e614d4-de42-456f-af89-8059210db9f7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "77dd5370-9411-40b1-9bba-a426f4b98ac3",
      target: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39"
    },
    {
      id: "11a16baa-b3f3-43df-afd4-c83eecfe7a9f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39",
      target: "1bab0fd2-f4c4-4a68-9156-34785e1c3198"
    },
    {
      id: "d1dd53cf-2a30-4833-a139-b1cd1c371712",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39",
      target: "e63b3f42-17bd-4cd7-b6f1-e2689d9887f9"
    },
    {
      id: "2d0e617b-06f4-431e-bd20-c263a4adce74",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5ca28967-bcd6-43d1-9a54-9c4cd4ca7e39",
      target: "1bab0fd2-f4c4-4a68-9156-34785e1c3198"
    },
    {
      id: "7fd778ec-a84b-408b-9aec-7994be0a0f8c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1bab0fd2-f4c4-4a68-9156-34785e1c3198",
      target: "a7837135-bdd2-4bfe-89ff-1893b6043c38"
    },
    {
      id: "cafa459e-8a09-4217-aecf-d349b1db7d39",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1bab0fd2-f4c4-4a68-9156-34785e1c3198",
      target: "a7837135-bdd2-4bfe-89ff-1893b6043c38"
    },
    {
      id: "8e25eb33-480d-4d5e-9409-033fc29aa9a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7837135-bdd2-4bfe-89ff-1893b6043c38",
      target: "bff24eab-c927-418e-bf14-170c666ca558"
    },
    {
      id: "48daf95f-0b19-45d8-85c1-a47eb5376eb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e822797a-5dbe-4e4b-8f94-1911d8e72630",
      target: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154"
    },
    {
      id: "ab5ab759-9d73-4a8b-8216-7f6975f13f58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "565e9aa9-3c11-473e-a494-f38925a3b1f9",
      target: "bff24eab-c927-418e-bf14-170c666ca558"
    },
    {
      id: "d4a0b09f-5e7f-4a89-9b84-9d13d2768535",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "565e9aa9-3c11-473e-a494-f38925a3b1f9",
      target: "908f3ddd-a033-46d0-afe5-7a49335c6963"
    },
    {
      id: "a91e861e-0f4d-4631-be91-90f94555feef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8e33e25-2772-4bc2-b198-030af753ecb3",
      target: "f1f821c9-5081-4d88-a35a-0e806c78a819"
    },
    {
      id: "6bc212a7-fae8-412d-81f0-aa4217a63212",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1f821c9-5081-4d88-a35a-0e806c78a819",
      target: "60e4c849-ff18-41e8-924d-91a859d865d3"
    },
    {
      id: "bef129ec-fc3d-4162-9ea3-1e3c7dd20ec6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f1f821c9-5081-4d88-a35a-0e806c78a819",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "cb8dd727-07d3-4eab-8cda-39db8e76f8e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60e4c849-ff18-41e8-924d-91a859d865d3",
      target: "ffb3f31e-e683-406b-9039-fc25fe6e5c80"
    },
    {
      id: "22c55ac4-6e1e-4c56-a6f4-f8933ac902f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60e4c849-ff18-41e8-924d-91a859d865d3",
      target: "009d22ab-ab20-4945-89c3-10a7608e60e2"
    },
    {
      id: "8cb6ea39-4fb1-4755-a922-b89ab4d05223",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c6f3038-7ae8-40d1-808f-5b07864c7aa4",
      target: "77dd5370-9411-40b1-9bba-a426f4b98ac3"
    },
    {
      id: "752046a6-67d8-4c9c-be54-2daec19ea9e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c6f3038-7ae8-40d1-808f-5b07864c7aa4",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "17901e31-ed7b-4a36-b25a-57c70ac2e619",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c6f3038-7ae8-40d1-808f-5b07864c7aa4",
      target: "93687a79-dfee-49b4-b1d4-b8335cfebe1e"
    },
    {
      id: "deff2941-c6ad-4c05-9acb-324ebe727435",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154",
      target: "908f3ddd-a033-46d0-afe5-7a49335c6963"
    },
    {
      id: "f2724815-625f-483e-aca2-3b1db556bb12",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154",
      target: "565e9aa9-3c11-473e-a494-f38925a3b1f9"
    },
    {
      id: "ba25bbec-7764-487a-96de-7525e04e9696",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f1a1ed0c-c0c4-4f55-b988-7dce6c0f4154",
      target: "565e9aa9-3c11-473e-a494-f38925a3b1f9"
    },
    {
      id: "4fa64f62-a9b4-42e1-a8fe-fb342454a399",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "908f3ddd-a033-46d0-afe5-7a49335c6963",
      target: "bff24eab-c927-418e-bf14-170c666ca558"
    },
    {
      id: "9a155ea4-b88b-4106-9db0-bb0a684e1abb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bff24eab-c927-418e-bf14-170c666ca558",
      target: "c8e33e25-2772-4bc2-b198-030af753ecb3"
    },
    {
      id: "18214310-b18f-4503-9fa2-fa43badfe3f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ffb3f31e-e683-406b-9039-fc25fe6e5c80",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "31883776-46ff-4fdf-b1a0-264bf0af241c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ffb3f31e-e683-406b-9039-fc25fe6e5c80",
      target: "009d22ab-ab20-4945-89c3-10a7608e60e2"
    },
    {
      id: "3c0b06b9-c085-47ad-ab21-1c033c2a8562",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31d0a2e9-0dff-44ac-8dee-d5d97b74e4d5",
      target: "ce1318c2-0edb-4778-a5be-445c057c5c34"
    },
    {
      id: "7e621158-6db7-436b-8d52-239deaac8595",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e1a6b22-298d-4d8c-bd96-96c144226a7a",
      target: "9be563d1-ed63-4665-abc2-c201e0459dff"
    },
    {
      id: "33638027-a4af-44fb-a42a-a328104b5a47",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a1178e13-fe81-479c-9255-7718bb819472",
      target: "da68dcfd-799f-4659-8a7d-1bcf9db99802"
    },
    {
      id: "bf7e4d26-3feb-4298-8c25-b96034532ffe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a1178e13-fe81-479c-9255-7718bb819472",
      target: "f8eb7462-7197-46ab-adbe-b3b4e8d7c9c2"
    },
    {
      id: "848aa025-ca67-4b97-8f5c-bdd57a6c4e8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da68dcfd-799f-4659-8a7d-1bcf9db99802",
      target: "e63b3f42-17bd-4cd7-b6f1-e2689d9887f9"
    },
    {
      id: "ad706a97-4a45-4992-b144-9ef61631d794",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e63b3f42-17bd-4cd7-b6f1-e2689d9887f9",
      target: "9be563d1-ed63-4665-abc2-c201e0459dff"
    },
    {
      id: "1e8f173a-d6dd-48f5-824e-8e80f2cde1a7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e63b3f42-17bd-4cd7-b6f1-e2689d9887f9",
      target: "2b11ac05-4186-4b5f-af73-3ee87235f0b1"
    },
    {
      id: "ab85444c-6421-49ef-9171-f99765ab1316",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9be563d1-ed63-4665-abc2-c201e0459dff",
      target: "2c680400-5591-4ad3-af30-0528b1f44615"
    },
    {
      id: "f609350a-e9eb-4449-94ba-8fd3bac627f3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2c680400-5591-4ad3-af30-0528b1f44615",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "f5c7140d-b52a-470f-9e09-4b844c1ef52d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c680400-5591-4ad3-af30-0528b1f44615",
      target: "07597252-10db-4c9b-8c6a-3b80dfe714fb"
    },
    {
      id: "06b5abab-4015-4baf-81d3-49254921591f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c680400-5591-4ad3-af30-0528b1f44615",
      target: "c79a70af-d9ce-4920-b3c9-f8eac61a2ed3"
    },
    {
      id: "64edd1a6-78ce-4218-a5df-26bfbab79b67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07597252-10db-4c9b-8c6a-3b80dfe714fb",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "a510ea1b-c52e-4866-8bca-2338b83004dc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "07597252-10db-4c9b-8c6a-3b80dfe714fb",
      target: "60e4c849-ff18-41e8-924d-91a859d865d3"
    },
    {
      id: "7b1f8be9-f8ad-4f15-993b-6f6b2c547d9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce1318c2-0edb-4778-a5be-445c057c5c34",
      target: "3e1a6b22-298d-4d8c-bd96-96c144226a7a"
    },
    {
      id: "7a6ac5bd-8624-4cfb-98b2-913d6be52f2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8eb7462-7197-46ab-adbe-b3b4e8d7c9c2",
      target: "da68dcfd-799f-4659-8a7d-1bcf9db99802"
    },
    {
      id: "4f77c3e5-4655-43a1-87cf-5d08b10a2f5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "364804f1-dd1b-4b3c-b6b5-7c7841f23ae6",
      target: "9b4c9a73-f00f-42aa-8c5c-01f50cb7c7c3"
    },
    {
      id: "fd47ee1d-5145-41ee-9dd9-1eb3f7de4ac4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b4c9a73-f00f-42aa-8c5c-01f50cb7c7c3",
      target: "2b11ac05-4186-4b5f-af73-3ee87235f0b1"
    },
    {
      id: "003d5c72-164e-496c-96c1-bcdd53c9e61c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b11ac05-4186-4b5f-af73-3ee87235f0b1",
      target: "3b1e050a-924b-4d02-965f-35ae275adecc"
    },
    {
      id: "1ca63104-807c-48a2-85eb-98cb313b6c23",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2b11ac05-4186-4b5f-af73-3ee87235f0b1",
      target: "3b1e050a-924b-4d02-965f-35ae275adecc"
    },
    {
      id: "c521e4a4-d620-43c1-976b-89d473c3e743",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b1e050a-924b-4d02-965f-35ae275adecc",
      target: "119f7be2-71ec-4be5-81c8-eca228889ad6"
    },
    {
      id: "8febea84-fbe8-492a-98b2-4931f1927cb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "119f7be2-71ec-4be5-81c8-eca228889ad6",
      target: "4f71cea6-1242-422e-b314-774cb4a09453"
    },
    {
      id: "600895be-4530-4f63-ae23-4ae8195773cf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "119f7be2-71ec-4be5-81c8-eca228889ad6",
      target: "492dd585-663c-4e43-9251-2677e89f9334"
    },
    {
      id: "8944093a-61b0-4036-a850-378da3d2c153",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "119f7be2-71ec-4be5-81c8-eca228889ad6",
      target: "60e4c849-ff18-41e8-924d-91a859d865d3"
    },
    {
      id: "cdcf34e6-5346-46ab-8c86-2a0db365e5f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c79a70af-d9ce-4920-b3c9-f8eac61a2ed3",
      target: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6"
    },
    {
      id: "fa1476e0-c82b-4d65-ab99-577808abb4fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c79a70af-d9ce-4920-b3c9-f8eac61a2ed3",
      target: "6c343024-3ee7-46e3-a040-d5959b762759"
    },
    {
      id: "1887a04b-6150-49dd-a24a-a5ea22c3c20c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c343024-3ee7-46e3-a040-d5959b762759",
      target: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346"
    },
    {
      id: "dc395cda-a659-4c3a-b7a4-04e0b4b5d586",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c343024-3ee7-46e3-a040-d5959b762759",
      target: "828e2b04-6e5a-4259-94a4-828c11f3f999"
    },
    {
      id: "4ca5cdaa-5ed5-4f6e-9575-de15079ce268",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1",
      target: "1c999f46-1e6c-4bf4-b009-23cddd1a13f6"
    },
    {
      id: "2e513a1b-2960-4d5e-98a7-3b3bbdfdc467",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "e5ab8fc3-0052-4d22-b7ec-a5e14b510a2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1",
      target: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09"
    },
    {
      id: "6b9a625d-14a0-454a-bebb-56a7a5dafa61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82de2168-e717-48cd-85cc-c0d71269d36c",
      target: "c2ba5953-47b1-495e-9759-8f696fa33150"
    },
    {
      id: "f8277443-8cf4-4c0d-a901-88509a3f0688",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82de2168-e717-48cd-85cc-c0d71269d36c",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "8bb2d702-fbbd-4235-abda-b718fc71302f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d2aee1f-d938-47b4-affa-9741c4ecca01",
      target: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e"
    },
    {
      id: "f39b1217-0ac8-48ee-94e2-93d95c3e1b5b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d2aee1f-d938-47b4-affa-9741c4ecca01",
      target: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e"
    },
    {
      id: "edbec569-5f68-48e2-b5eb-7aeaa3ccb9d7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e671f2a-872a-49a2-af64-db432bc7d2e6",
      target: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e"
    },
    {
      id: "eb9684e3-f704-4518-b12a-5a7d16e24436",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e671f2a-872a-49a2-af64-db432bc7d2e6",
      target: "9d2aee1f-d938-47b4-affa-9741c4ecca01"
    },
    {
      id: "4a1a4aaf-1036-4f53-a785-6e506613eb3d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e671f2a-872a-49a2-af64-db432bc7d2e6",
      target: "dbc30aa6-5af1-409d-8fc1-76346f414b5a"
    },
    {
      id: "d157e5e7-856f-4fbf-9159-17507526d9f5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4e671f2a-872a-49a2-af64-db432bc7d2e6",
      target: "9d2aee1f-d938-47b4-affa-9741c4ecca01"
    },
    {
      id: "e7bace2d-c527-449c-b2bf-217e877e0583",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e",
      target: "ea11542b-587f-4351-9d55-0a27d0fac9aa"
    },
    {
      id: "7f7ed276-b5b0-4cbe-97b1-b835af9ac2c1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e",
      target: "23a36a6d-79d5-474e-9a9f-3f95a1a79939"
    },
    {
      id: "4b6d7348-5da6-41f9-b43b-bcbf8605e677",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e",
      target: "51b3abdf-b191-44cd-a08b-dbab9f96f0ce"
    },
    {
      id: "12411f83-8831-4111-ac06-855c6c49cb5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51b3abdf-b191-44cd-a08b-dbab9f96f0ce",
      target: "07cfb042-bc3d-4e16-8126-bdb1ed5e81ab"
    },
    {
      id: "779ded9e-cc1f-402e-956e-d5ac9c3ee50a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07cfb042-bc3d-4e16-8126-bdb1ed5e81ab",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "f9f7ad7f-9ac6-4853-8b7c-2fb53f59ce19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07cfb042-bc3d-4e16-8126-bdb1ed5e81ab",
      target: "93687a79-dfee-49b4-b1d4-b8335cfebe1e"
    },
    {
      id: "f1b47e9e-f2e8-4f0a-97ee-ed91a44a9837",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "dbc30aa6-5af1-409d-8fc1-76346f414b5a",
      target: "9d2aee1f-d938-47b4-affa-9741c4ecca01"
    },
    {
      id: "693e87ef-e45a-4d78-9170-fd36ac94545e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbc30aa6-5af1-409d-8fc1-76346f414b5a",
      target: "55bc3fdb-53a9-432b-a61e-c08f02a09f4e"
    },
    {
      id: "1ae7c5c5-9ee0-40e4-9baa-e0a8d5b4183a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2ba5953-47b1-495e-9759-8f696fa33150",
      target: "e72d1b4a-3fcc-49d2-8088-50aa18812065"
    },
    {
      id: "c4c96eee-bc4f-41f5-8d36-24ce16c0cac5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c2ba5953-47b1-495e-9759-8f696fa33150",
      target: "11976427-8105-41c2-936d-1812f73f06be"
    },
    {
      id: "39a0bf6f-dbf8-4580-a9ba-ba25e7e55787",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e72d1b4a-3fcc-49d2-8088-50aa18812065",
      target: "23a36a6d-79d5-474e-9a9f-3f95a1a79939"
    },
    {
      id: "f05e5609-c755-4c35-bfc5-f8f0804dd0f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e72d1b4a-3fcc-49d2-8088-50aa18812065",
      target: "848cfcd1-d03e-42dc-a51e-e91b26a9c40f"
    },
    {
      id: "c7d3cb97-a4b2-4d73-869d-54d06df1be12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "848cfcd1-d03e-42dc-a51e-e91b26a9c40f",
      target: "16f4a518-f541-4a11-aea4-d2236977b1a6"
    },
    {
      id: "45c071a9-1739-473a-bcf2-e53e38d1f444",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "848cfcd1-d03e-42dc-a51e-e91b26a9c40f",
      target: "926c19d3-ae03-46ba-a506-346d424fde19"
    },
    {
      id: "d55e369a-64e8-44ae-8720-a686fbb241f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "926c19d3-ae03-46ba-a506-346d424fde19",
      target: "67ba77d8-0f1c-4f23-a5ac-1ba681a510b3"
    },
    {
      id: "6f605b9f-28bb-4213-95c5-a03b897e295c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "926c19d3-ae03-46ba-a506-346d424fde19",
      target: "e92b7494-9783-4351-9180-0e06f962291a"
    },
    {
      id: "cea0be6f-a2c9-41d8-9773-73cb6ef5ae3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67ba77d8-0f1c-4f23-a5ac-1ba681a510b3",
      target: "086c42d9-8735-443d-a45d-99800fe3c59d"
    },
    {
      id: "159c5aec-57cd-49b5-aa40-b1b25ea92921",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67ba77d8-0f1c-4f23-a5ac-1ba681a510b3",
      target: "8530504b-e7ad-48e3-a890-1ac6d5d3a8b4"
    },
    {
      id: "4e115b0a-bc1a-4051-a199-1d26f400cc9c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8530504b-e7ad-48e3-a890-1ac6d5d3a8b4",
      target: "4e671f2a-872a-49a2-af64-db432bc7d2e6"
    },
    {
      id: "484b4c83-364b-445c-9502-733098516b00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8530504b-e7ad-48e3-a890-1ac6d5d3a8b4",
      target: "23a36a6d-79d5-474e-9a9f-3f95a1a79939"
    },
    {
      id: "2c8abf40-865d-4d3a-b673-f6d87509e6d3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "23a36a6d-79d5-474e-9a9f-3f95a1a79939",
      target: "ea11542b-587f-4351-9d55-0a27d0fac9aa"
    },
    {
      id: "e9aec74b-6036-437b-8a32-1eb2496213f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23a36a6d-79d5-474e-9a9f-3f95a1a79939",
      target: "94a34034-ed82-415e-a0b8-93bc455737e2"
    },
    {
      id: "42f8174f-9dfb-42f8-9925-f07a100a40f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23a36a6d-79d5-474e-9a9f-3f95a1a79939",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "e51afea1-1500-413b-a499-0ebd015ebe8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94a34034-ed82-415e-a0b8-93bc455737e2",
      target: "808c8270-2317-4953-81e6-5d115b5a4142"
    },
    {
      id: "7d5599c3-d506-4052-b1d9-24cc11db5e28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "808c8270-2317-4953-81e6-5d115b5a4142",
      target: "e92b7494-9783-4351-9180-0e06f962291a"
    },
    {
      id: "f316de29-b475-4ace-b757-6077e5a2354b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e92b7494-9783-4351-9180-0e06f962291a",
      target: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef"
    },
    {
      id: "64da8390-1ff0-4964-a43f-2ebb6e696843",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e92b7494-9783-4351-9180-0e06f962291a",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "3938769c-1da1-44b4-b710-254486a6cd30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e92b7494-9783-4351-9180-0e06f962291a",
      target: "e8bb568c-a248-49de-8cab-1842f3f91dac"
    },
    {
      id: "30a0aece-a654-4675-9a3b-2b7a35d5a282",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef",
      target: "0865d74e-8b0c-48e0-b17b-b7b82d590b9c"
    },
    {
      id: "1bcd3057-3961-44e3-8740-c5e600a20cdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef",
      target: "e8cd07ec-6d8b-4f97-b855-17feef46ba8f"
    },
    {
      id: "7cd29cb1-3f6a-48f0-8d23-7b497852dd75",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef",
      target: "60b22ed4-5b6b-483e-a342-4ae86e519f13"
    },
    {
      id: "6e9d0010-c080-4508-b2a7-72a45feae0cc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e0cd31c4-4548-4448-b1c8-b0bcefe8a1ef",
      target: "642403c1-08c6-42d6-af56-a45514d470ca"
    },
    {
      id: "42c90864-0b06-49d6-842c-633048a6a324",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "60b22ed4-5b6b-483e-a342-4ae86e519f13",
      target: "d943c7b5-acce-473a-8da4-beb04f88b517"
    },
    {
      id: "a785d26b-84f5-4c88-a2d9-48453de361cd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "60b22ed4-5b6b-483e-a342-4ae86e519f13",
      target: "d943c7b5-acce-473a-8da4-beb04f88b517"
    },
    {
      id: "47028148-7472-4001-844d-496bedecb967",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0865d74e-8b0c-48e0-b17b-b7b82d590b9c",
      target: "1ec9245e-0784-47ce-8ceb-83761eb5b47b"
    },
    {
      id: "4bfcf528-349e-40e2-bd0f-1abb745314a0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0865d74e-8b0c-48e0-b17b-b7b82d590b9c",
      target: "1ec9245e-0784-47ce-8ceb-83761eb5b47b"
    },
    {
      id: "f737782d-d6c9-4813-b198-aea77d8dec1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8cd07ec-6d8b-4f97-b855-17feef46ba8f",
      target: "0c263f70-ba85-47c5-9d0b-f0b9076077af"
    },
    {
      id: "06383bd3-37ba-42fb-bd41-e43b55e5b6de",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4dbf067a-566d-4c7e-a8ba-35ae562faaac",
      target: "4899f493-60f8-48a4-aec6-46c0cf634580"
    },
    {
      id: "30851b89-0eee-4d66-a9b3-877fcb9951b1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4dbf067a-566d-4c7e-a8ba-35ae562faaac",
      target: "4899f493-60f8-48a4-aec6-46c0cf634580"
    },
    {
      id: "50dc7c08-144f-461f-bf34-06c08f85f018",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4899f493-60f8-48a4-aec6-46c0cf634580",
      target: "8b4938cb-a5b7-4660-b6e8-182433f3b671"
    },
    {
      id: "17c2ebf3-d9b7-4592-8aa2-1cf06d5d58ed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4899f493-60f8-48a4-aec6-46c0cf634580",
      target: "d0901cd5-f443-437d-b16c-d7c69f6d27cd"
    },
    {
      id: "bc77b10e-ca10-4e60-8ac7-78e63c7ffe6c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4899f493-60f8-48a4-aec6-46c0cf634580",
      target: "8b4938cb-a5b7-4660-b6e8-182433f3b671"
    },
    {
      id: "2dc402e5-9ab5-454f-8d52-b66a02a4ac11",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8b4938cb-a5b7-4660-b6e8-182433f3b671",
      target: "22b95600-70be-452b-bf64-73d094807f16"
    },
    {
      id: "3d9fb856-8728-478a-99e7-9c14b569083f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8b4938cb-a5b7-4660-b6e8-182433f3b671",
      target: "22b95600-70be-452b-bf64-73d094807f16"
    },
    {
      id: "c20fbbca-f03a-4495-bc19-628ee38819b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22b95600-70be-452b-bf64-73d094807f16",
      target: "bdb7d0fd-44a2-41c4-9393-b59abad9987e"
    },
    {
      id: "b2cb2281-9a4c-4355-83ae-693ad3902703",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d943c7b5-acce-473a-8da4-beb04f88b517",
      target: "249c258f-1cb8-4b3a-81d3-40dec86f5a74"
    },
    {
      id: "d78b9578-a63d-4e6c-8249-91ee92907250",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d943c7b5-acce-473a-8da4-beb04f88b517",
      target: "249c258f-1cb8-4b3a-81d3-40dec86f5a74"
    },
    {
      id: "07d8a625-3a9e-40db-959b-6a86d0a125a4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d943c7b5-acce-473a-8da4-beb04f88b517",
      target: "2fcfe7c1-2e91-4178-968b-b00d7a370595"
    },
    {
      id: "966a454d-1d41-41b2-9e7f-4a10c4ac7c2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "249c258f-1cb8-4b3a-81d3-40dec86f5a74",
      target: "7b6d8dd9-daa7-43d0-9d77-c72eb917d112"
    },
    {
      id: "6f37dc97-c64e-44bb-b599-c6f4f47d1aa7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "249c258f-1cb8-4b3a-81d3-40dec86f5a74",
      target: "3db3cf40-c0d6-4e97-827d-e7dc5bf46075"
    },
    {
      id: "a89a83c2-b01d-4427-831d-d2ffff7494ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e847e73-ae72-4d8b-8537-75b619b72bae",
      target: "2a22d0ce-4cea-4e73-81a6-13750bda9164"
    },
    {
      id: "e368388b-4412-42de-aac7-ca7e449233e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a22d0ce-4cea-4e73-81a6-13750bda9164",
      target: "74e49900-e86e-4a0e-a542-d2f9f436cfce"
    },
    {
      id: "68afdb7e-0010-481b-aaed-4250778f7126",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2a22d0ce-4cea-4e73-81a6-13750bda9164",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "36ed2fe4-fa78-4b03-8d1a-9c5614b4003d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74e49900-e86e-4a0e-a542-d2f9f436cfce",
      target: "f7c17f7a-84f1-4d1e-8498-0280fba93e4c"
    },
    {
      id: "4b66b8e3-05b5-4a75-8b85-43a60ddefaf8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "74e49900-e86e-4a0e-a542-d2f9f436cfce",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "bc9fa1e3-d1e8-4cc9-8164-64dc99150a69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "642403c1-08c6-42d6-af56-a45514d470ca",
      target: "4dbf067a-566d-4c7e-a8ba-35ae562faaac"
    },
    {
      id: "1a8be687-a439-4b3f-b9b0-79c248eccd4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "642403c1-08c6-42d6-af56-a45514d470ca",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "f72e1446-d3ad-4b4b-8535-4125e867ad54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "642403c1-08c6-42d6-af56-a45514d470ca",
      target: "93687a79-dfee-49b4-b1d4-b8335cfebe1e"
    },
    {
      id: "47a9b534-223c-4345-ac1b-ba6073e8e008",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2fcfe7c1-2e91-4178-968b-b00d7a370595",
      target: "249c258f-1cb8-4b3a-81d3-40dec86f5a74"
    },
    {
      id: "cddc023a-2938-4335-b9a6-c42820adb507",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3db3cf40-c0d6-4e97-827d-e7dc5bf46075",
      target: "3e847e73-ae72-4d8b-8537-75b619b72bae"
    },
    {
      id: "dc0e3fbc-06ba-4d86-81c8-471dc1d3b24e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdb7d0fd-44a2-41c4-9393-b59abad9987e",
      target: "2a22d0ce-4cea-4e73-81a6-13750bda9164"
    },
    {
      id: "81542ac1-bc66-4de9-b8e6-a515bd53c657",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7c17f7a-84f1-4d1e-8498-0280fba93e4c",
      target: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09"
    },
    {
      id: "087bc4df-bd00-4214-8bd6-d32fabb03f54",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f7c17f7a-84f1-4d1e-8498-0280fba93e4c",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "eaeb0384-e5b8-49f7-a7c8-f72b93ab5e07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7c17f7a-84f1-4d1e-8498-0280fba93e4c",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "47e9c23f-995a-46de-871f-843a08e3cc65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16f4a518-f541-4a11-aea4-d2236977b1a6",
      target: "ac49182b-8b0b-4e9b-b3e0-ec892bd082ed"
    },
    {
      id: "b5a9d088-154e-4cfe-8f34-cdbaa4cf49a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16f4a518-f541-4a11-aea4-d2236977b1a6",
      target: "c051fe49-5a30-45ed-9c5a-af987fe624d2"
    },
    {
      id: "930ca417-9ea7-4d4c-91d8-18b0da42b985",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23c09456-b762-4334-ba03-41ef82534a45",
      target: "4c131e97-35ff-42b2-aa1e-e082a239f55b"
    },
    {
      id: "e2aa36bb-2c53-45d2-84a4-dcea5ee630ad",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0c263f70-ba85-47c5-9d0b-f0b9076077af",
      target: "1ec9245e-0784-47ce-8ceb-83761eb5b47b"
    },
    {
      id: "5bde404c-d496-4d4d-9594-ff180b96e5bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ec9245e-0784-47ce-8ceb-83761eb5b47b",
      target: "76a91481-8334-4348-b0b0-4083aa3038b3"
    },
    {
      id: "578fdf9c-3c79-497c-a6ab-786d2f9c89f9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d0901cd5-f443-437d-b16c-d7c69f6d27cd",
      target: "24e11816-d070-43b5-bcf7-b6cc73c1d1b3"
    },
    {
      id: "bed7df98-478d-4f29-b65f-9e1ca3260c0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0901cd5-f443-437d-b16c-d7c69f6d27cd",
      target: "4c131e97-35ff-42b2-aa1e-e082a239f55b"
    },
    {
      id: "990205a6-35ec-4def-82dd-f3483291f626",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c131e97-35ff-42b2-aa1e-e082a239f55b",
      target: "89f5c053-9eda-47dc-936b-083b97812fe1"
    },
    {
      id: "031ecb3f-f792-4abc-ba87-2c1c5bd4154f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89f5c053-9eda-47dc-936b-083b97812fe1",
      target: "89cf7805-54c9-46b7-84b0-dc9faa83d01f"
    },
    {
      id: "10fabef1-9d7c-43d8-b3ae-3d329e3ec188",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "89f5c053-9eda-47dc-936b-083b97812fe1",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "5e99a07b-73b8-4014-9dc1-1c2f0a0ece3a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "89cf7805-54c9-46b7-84b0-dc9faa83d01f",
      target: "74e49900-e86e-4a0e-a542-d2f9f436cfce"
    },
    {
      id: "9fccc380-e0bb-4bb4-ab09-ac37b9a4802b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89cf7805-54c9-46b7-84b0-dc9faa83d01f",
      target: "520abc93-f6c9-4ba9-a853-d8ff2143e26d"
    },
    {
      id: "0d4b1125-887c-45dc-925e-c8d5420f07cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89cf7805-54c9-46b7-84b0-dc9faa83d01f",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "0e318847-a949-40b1-816e-af1a8c46b429",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c051fe49-5a30-45ed-9c5a-af987fe624d2",
      target: "80304145-e678-41e7-930f-619c16d31757"
    },
    {
      id: "729f5fe7-9560-4f95-83d5-62f91126dbff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c051fe49-5a30-45ed-9c5a-af987fe624d2",
      target: "23c09456-b762-4334-ba03-41ef82534a45"
    },
    {
      id: "4b208773-3873-4057-be05-6f9bcdf4a13c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "76a91481-8334-4348-b0b0-4083aa3038b3",
      target: "d0901cd5-f443-437d-b16c-d7c69f6d27cd"
    },
    {
      id: "cbced4b5-7e79-41ed-a266-6fadca6a6cde",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "086c42d9-8735-443d-a45d-99800fe3c59d",
      target: "a25a44c9-1575-43cf-995d-19c517844198"
    },
    {
      id: "beececcb-ba92-4597-a9de-a4273a15f409",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a25a44c9-1575-43cf-995d-19c517844198",
      target: "24e11816-d070-43b5-bcf7-b6cc73c1d1b3"
    },
    {
      id: "8a31e092-6052-444a-98f8-6e61eb4c2b8a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "24e11816-d070-43b5-bcf7-b6cc73c1d1b3",
      target: "dda3e4ac-cb6f-4d12-98da-1e933192f6ea"
    },
    {
      id: "8ff38d88-4544-48cc-b48e-043cf607ea1d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "24e11816-d070-43b5-bcf7-b6cc73c1d1b3",
      target: "dda3e4ac-cb6f-4d12-98da-1e933192f6ea"
    },
    {
      id: "74c55150-334d-4336-afd0-8a9d50f90506",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dda3e4ac-cb6f-4d12-98da-1e933192f6ea",
      target: "aac6cca3-7a4b-4cfa-8f13-07e3998183dc"
    },
    {
      id: "35d27d6f-1217-4b31-9f6e-caa2ec79b70c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aac6cca3-7a4b-4cfa-8f13-07e3998183dc",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "238d4484-af4e-48ef-9d21-a842b445ef97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aac6cca3-7a4b-4cfa-8f13-07e3998183dc",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "1e89ed26-eb39-471d-989b-432f81ace3a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11976427-8105-41c2-936d-1812f73f06be",
      target: "b504bddc-d052-46c5-bb15-6309969e393a"
    },
    {
      id: "62e849b1-4b6f-469a-8ac4-70dd5deac587",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b504bddc-d052-46c5-bb15-6309969e393a",
      target: "ea11542b-587f-4351-9d55-0a27d0fac9aa"
    },
    {
      id: "f368f65b-8c79-45e9-b0c1-7392dd8cd318",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b504bddc-d052-46c5-bb15-6309969e393a",
      target: "1908f518-40d5-4356-96a5-fe7b60604aaf"
    },
    {
      id: "0ba48ed6-07af-44ab-8112-be3c1f728c58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1908f518-40d5-4356-96a5-fe7b60604aaf",
      target: "0ca9d33d-ff30-4f12-b143-278fe80add01"
    },
    {
      id: "6d44a006-06cc-4ac6-8e24-8ebf82bb94d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1908f518-40d5-4356-96a5-fe7b60604aaf",
      target: "ac49182b-8b0b-4e9b-b3e0-ec892bd082ed"
    },
    {
      id: "a71bffee-2021-433c-8b1d-b0e3cda7cdbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ca9d33d-ff30-4f12-b143-278fe80add01",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "6563a6ca-1bf7-45fd-b3b6-9aaef4fef715",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ca9d33d-ff30-4f12-b143-278fe80add01",
      target: "2c891d1b-402c-4013-acd2-ae057b6e9343"
    },
    {
      id: "794a2ad9-7fab-4f6d-b2dd-3e5b400bc02f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c891d1b-402c-4013-acd2-ae057b6e9343",
      target: "6a6ff9fa-7b66-47b2-87b5-2e069a950edb"
    },
    {
      id: "5d679c1a-a792-48f7-878a-fa695148324c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c891d1b-402c-4013-acd2-ae057b6e9343",
      target: "aea5adf7-42b7-4797-8acb-11c265d10913"
    },
    {
      id: "20e1eb39-7240-4cc4-87ef-52d98efa6107",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aea5adf7-42b7-4797-8acb-11c265d10913",
      target: "4e671f2a-872a-49a2-af64-db432bc7d2e6"
    },
    {
      id: "c3564007-c650-46e1-b0ef-b59eb1460ef6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aea5adf7-42b7-4797-8acb-11c265d10913",
      target: "ea11542b-587f-4351-9d55-0a27d0fac9aa"
    },
    {
      id: "621a5c9b-6073-4099-b9c3-6dd08829a9f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea11542b-587f-4351-9d55-0a27d0fac9aa",
      target: "438b74e9-e317-416c-a103-d3a7d96c879b"
    },
    {
      id: "31d81919-bc91-4b45-8d7d-00431266d2f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "438b74e9-e317-416c-a103-d3a7d96c879b",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "ff1167e6-5a8b-447c-8af5-c60910166535",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "438b74e9-e317-416c-a103-d3a7d96c879b",
      target: "a3ecd9d2-7437-4303-b0e8-ab28653cb693"
    },
    {
      id: "f96ac078-bb5a-4403-b04d-c3ffd4a736d9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3ecd9d2-7437-4303-b0e8-ab28653cb693",
      target: "6f59f610-a665-434a-8add-a64caa1434c8"
    },
    {
      id: "77f53faa-1d84-43b4-8cad-03a79305c389",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f59f610-a665-434a-8add-a64caa1434c8",
      target: "e8bb568c-a248-49de-8cab-1842f3f91dac"
    },
    {
      id: "720995f3-1656-449f-a169-bb7e5e875ef8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f59f610-a665-434a-8add-a64caa1434c8",
      target: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3"
    },
    {
      id: "8d944877-62c3-46b9-962f-983ced931e58",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3",
      target: "8df6571f-36b6-4e33-bf2c-f35a98a9a416"
    },
    {
      id: "0ca28a91-7040-4d1f-a082-bc38470ade37",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3",
      target: "d37a751b-6609-4c17-8407-79d882177c2d"
    },
    {
      id: "e1650bb2-5f21-4e37-acab-bef53132beaf",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3",
      target: "be534141-357d-4c9f-8353-19591a73ef83"
    },
    {
      id: "b10d473f-6c34-404f-80b2-8c6bc671b8bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63f501f0-7e0d-4728-8c48-3deb4d72a6c3",
      target: "68a55c82-27f3-4e7e-9f63-dcc080f54ec9"
    },
    {
      id: "b8b1c3fa-59d2-4974-9237-ac80ec0cf4c5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8df6571f-36b6-4e33-bf2c-f35a98a9a416",
      target: "e633c469-f45c-48e6-80b7-26a25ee90887"
    },
    {
      id: "f696e172-a08f-4260-89fb-6dd95df6d1fe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8df6571f-36b6-4e33-bf2c-f35a98a9a416",
      target: "e633c469-f45c-48e6-80b7-26a25ee90887"
    },
    {
      id: "2d44eec5-58a8-473f-a5cd-d2f5b8745ef5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "68a55c82-27f3-4e7e-9f63-dcc080f54ec9",
      target: "d920a9b2-4524-4a47-a52f-e89105d5119a"
    },
    {
      id: "82dc8888-0199-44f1-8583-7375086bf682",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "68a55c82-27f3-4e7e-9f63-dcc080f54ec9",
      target: "d920a9b2-4524-4a47-a52f-e89105d5119a"
    },
    {
      id: "022c415f-9d52-46bb-9ea3-ffeba6c0b36c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be534141-357d-4c9f-8353-19591a73ef83",
      target: "b55dedcb-17c7-4a05-b140-4ffc11f41345"
    },
    {
      id: "c0a51de3-f5fb-41a0-b66e-afe8b12a6bd9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bb9f00e5-e4ae-41ac-bce0-1b77b41d8a04",
      target: "1685c1f9-40f0-48e7-a581-5cc660945576"
    },
    {
      id: "b265378f-f81a-4a4c-a521-e3adfce83ece",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bb9f00e5-e4ae-41ac-bce0-1b77b41d8a04",
      target: "1685c1f9-40f0-48e7-a581-5cc660945576"
    },
    {
      id: "a37d0675-3bce-4e58-834f-49e90e35884f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1685c1f9-40f0-48e7-a581-5cc660945576",
      target: "70d1ba73-1db0-4ad6-bced-2e9613c4fee0"
    },
    {
      id: "286878c4-c7d1-4746-bb15-7ecfd67ab461",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1685c1f9-40f0-48e7-a581-5cc660945576",
      target: "70d1ba73-1db0-4ad6-bced-2e9613c4fee0"
    },
    {
      id: "f0fce490-4b25-4f97-bcba-ff97a5354a8d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1685c1f9-40f0-48e7-a581-5cc660945576",
      target: "1c112190-5a48-483a-a023-f3c2bf5f2461"
    },
    {
      id: "623a3003-2b9a-4d4f-ab7e-d1a55ad25186",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70d1ba73-1db0-4ad6-bced-2e9613c4fee0",
      target: "6c6659fb-813c-4555-aa02-76492f8e8ac8"
    },
    {
      id: "5ccf07ba-ce02-48a8-baea-408a2b46bfa4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70d1ba73-1db0-4ad6-bced-2e9613c4fee0",
      target: "6c6659fb-813c-4555-aa02-76492f8e8ac8"
    },
    {
      id: "cb8832d8-596b-4491-996f-4b4a5859d514",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c6659fb-813c-4555-aa02-76492f8e8ac8",
      target: "408f68d7-09f0-4ee6-8b78-bd6b6a420cbb"
    },
    {
      id: "ad023c9d-9be6-49a7-aa4a-b8fb59fbddf1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e633c469-f45c-48e6-80b7-26a25ee90887",
      target: "d16166cb-6e09-437a-8683-a631affd33e2"
    },
    {
      id: "5772f659-7127-4e67-8247-f77ced3a110d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e633c469-f45c-48e6-80b7-26a25ee90887",
      target: "377b44b7-1e7a-4a2e-bfa6-6cb24b494197"
    },
    {
      id: "e47c8642-700a-49ab-aade-ff565553c38f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e633c469-f45c-48e6-80b7-26a25ee90887",
      target: "377b44b7-1e7a-4a2e-bfa6-6cb24b494197"
    },
    {
      id: "02598828-90e1-4f46-b29c-4f503188f201",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "377b44b7-1e7a-4a2e-bfa6-6cb24b494197",
      target: "27bca40a-ff50-49a1-958c-0b7972db37f7"
    },
    {
      id: "58a9b66d-fac5-408d-9dd4-6233af933937",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "408f68d7-09f0-4ee6-8b78-bd6b6a420cbb",
      target: "48fd4d4d-9360-4470-9510-527219ab1990"
    },
    {
      id: "ef0ed4ea-7117-4960-a272-ebb8ac411784",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bc7952a-d10c-47c9-ae3c-36045e2a7d93",
      target: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557"
    },
    {
      id: "6684f0ca-e96c-49e5-9d16-494e2e727216",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3bc7952a-d10c-47c9-ae3c-36045e2a7d93",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "eef19fee-4ee3-45fe-a62a-408d14415634",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "f628b978-4531-4c36-a787-d365b9a80912",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557",
      target: "ac8b443a-eb69-4f9d-a3d5-d9de834aa168"
    },
    {
      id: "9b96d738-9aca-4ccb-a1e6-ecf04d44bdd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d37a751b-6609-4c17-8407-79d882177c2d",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "6e396334-0903-4173-a011-b582e64180ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d37a751b-6609-4c17-8407-79d882177c2d",
      target: "93687a79-dfee-49b4-b1d4-b8335cfebe1e"
    },
    {
      id: "a16cb82f-211d-48b0-a3e7-7049adc39aea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d37a751b-6609-4c17-8407-79d882177c2d",
      target: "bb9f00e5-e4ae-41ac-bce0-1b77b41d8a04"
    },
    {
      id: "67cdc002-1aaa-42a0-933e-328ccfdbffda",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d16166cb-6e09-437a-8683-a631affd33e2",
      target: "377b44b7-1e7a-4a2e-bfa6-6cb24b494197"
    },
    {
      id: "49a8de1c-8524-4809-9dcd-fb32676e278a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27bca40a-ff50-49a1-958c-0b7972db37f7",
      target: "408f68d7-09f0-4ee6-8b78-bd6b6a420cbb"
    },
    {
      id: "2226384a-9d2b-4972-b912-bd03b8b3ad86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48fd4d4d-9360-4470-9510-527219ab1990",
      target: "3bc7952a-d10c-47c9-ae3c-36045e2a7d93"
    },
    {
      id: "0f732be9-b60f-4812-a72e-899c2aea1e7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac8b443a-eb69-4f9d-a3d5-d9de834aa168",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "a23bf98f-9453-4bbb-9f94-5f77da8530b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac8b443a-eb69-4f9d-a3d5-d9de834aa168",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "f118d15b-4eb5-40fc-91b5-d95782f9240e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac49182b-8b0b-4e9b-b3e0-ec892bd082ed",
      target: "80304145-e678-41e7-930f-619c16d31757"
    },
    {
      id: "6ee18516-bf27-462a-927c-0aec30823d82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1c51e1d-9c8c-45af-bef7-e8e22c3599a1",
      target: "2e04d002-0e78-4fb9-8997-22ad664d0d84"
    },
    {
      id: "b5ddbfc6-ff60-4868-8f53-3f4028766c13",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b55dedcb-17c7-4a05-b140-4ffc11f41345",
      target: "d920a9b2-4524-4a47-a52f-e89105d5119a"
    },
    {
      id: "b5bb1f21-6b30-4486-b17a-560e4051eb33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d920a9b2-4524-4a47-a52f-e89105d5119a",
      target: "ee31fe2e-2f19-4690-baf4-71a3de84117d"
    },
    {
      id: "bd4426d4-f3f4-4bd2-b9f6-efaf6c31b86a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c112190-5a48-483a-a023-f3c2bf5f2461",
      target: "40afa46f-847a-4149-82c6-51d41091e614"
    },
    {
      id: "34063c03-e212-4f7e-b2ee-c3dc8f98fc29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c112190-5a48-483a-a023-f3c2bf5f2461",
      target: "2e04d002-0e78-4fb9-8997-22ad664d0d84"
    },
    {
      id: "c6ae87fa-5b07-43a5-bbb9-5bc93a4ee722",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e04d002-0e78-4fb9-8997-22ad664d0d84",
      target: "b5199bb8-6208-4ff6-ab7a-fd5a5b9e6888"
    },
    {
      id: "ec55d120-5eed-4ca3-9b1c-31eb288bcb4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5199bb8-6208-4ff6-ab7a-fd5a5b9e6888",
      target: "520abc93-f6c9-4ba9-a853-d8ff2143e26d"
    },
    {
      id: "d30e4f85-32a6-4146-b36d-9dd9c919e286",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5199bb8-6208-4ff6-ab7a-fd5a5b9e6888",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "c4cee464-8bc0-47c6-844e-f28f1ec8130d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "520abc93-f6c9-4ba9-a853-d8ff2143e26d",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "0a3e6c50-39b8-4332-b2f7-75e05bcf73d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "520abc93-f6c9-4ba9-a853-d8ff2143e26d",
      target: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557"
    },
    {
      id: "96e8c73f-5afb-434b-af6e-818ccc5782d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80304145-e678-41e7-930f-619c16d31757",
      target: "c1c51e1d-9c8c-45af-bef7-e8e22c3599a1"
    },
    {
      id: "439d730a-a042-450a-b16c-ae4a9e11437c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ee31fe2e-2f19-4690-baf4-71a3de84117d",
      target: "1c112190-5a48-483a-a023-f3c2bf5f2461"
    },
    {
      id: "e58a1102-dcf1-458f-a20b-9440cec5bcfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a6ff9fa-7b66-47b2-87b5-2e069a950edb",
      target: "9245977a-af71-43c4-a39d-dae6bd706066"
    },
    {
      id: "af9bde9e-d8aa-4745-a1de-be6b4e94f53c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9245977a-af71-43c4-a39d-dae6bd706066",
      target: "40afa46f-847a-4149-82c6-51d41091e614"
    },
    {
      id: "70bba7d9-a4f0-4e6e-9d43-05baf8e69010",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "40afa46f-847a-4149-82c6-51d41091e614",
      target: "baa6a889-2ce3-4592-86ab-18dab8a9ec91"
    },
    {
      id: "0fd330a5-9c1d-4d00-bc92-eb7f897534fe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "40afa46f-847a-4149-82c6-51d41091e614",
      target: "baa6a889-2ce3-4592-86ab-18dab8a9ec91"
    },
    {
      id: "b479e754-8a2e-4826-8d0a-90326b23ea26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "baa6a889-2ce3-4592-86ab-18dab8a9ec91",
      target: "227e4277-f809-4052-8ee9-596efcaeadde"
    },
    {
      id: "3cf3ec4b-123d-46ed-818d-862e79eca9ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "227e4277-f809-4052-8ee9-596efcaeadde",
      target: "70db9058-eab2-46cb-8fed-6849cceba762"
    },
    {
      id: "5cfcb1ab-525e-4d1b-ac95-5ca092dfb0cf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "227e4277-f809-4052-8ee9-596efcaeadde",
      target: "7b075436-ff92-42b9-99e2-4c0f8fa5f3b1"
    },
    {
      id: "f2be2f4a-311e-403b-9260-e6970d8c6949",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "227e4277-f809-4052-8ee9-596efcaeadde",
      target: "0877374b-7cd0-4fbd-8d0a-a6d2aa344557"
    },
    {
      id: "2f16c95f-449f-423d-8dba-3a4a6c592262",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17c5a102-3a79-4569-872e-ad1c465bbbff",
      target: "2f39c398-464f-4f08-a802-85da1f9e7afd"
    },
    {
      id: "6d51d1df-23e5-4b9d-9842-e97453210547",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f39c398-464f-4f08-a802-85da1f9e7afd",
      target: "ba5d547c-dd87-45f6-80f8-6efe121db3ad"
    },
    {
      id: "8ec68b9d-db38-41ca-8bbf-5465621f4ea4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba5d547c-dd87-45f6-80f8-6efe121db3ad",
      target: "6699faf0-2337-45f8-a024-f6ba073019ff"
    },
    {
      id: "dacbaafe-b05e-4151-922f-2295b8b7bb68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6699faf0-2337-45f8-a024-f6ba073019ff",
      target: "4c20d981-76ae-4733-a74f-d28eada76950"
    },
    {
      id: "c1571ef0-4cb7-471e-b333-45bcf4cb5b7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6699faf0-2337-45f8-a024-f6ba073019ff",
      target: "0643a591-df62-4540-b40c-b55e8255b67c"
    },
    {
      id: "f7581496-5f46-4f60-b1eb-821cb5ee8d59",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "187da2f9-2d65-4b95-9f0c-74b9fdbfc170",
      target: "b927c50c-d897-4864-888c-d8f6122c9703"
    },
    {
      id: "f3a4ad9e-9575-4109-a95a-501be6f1da2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "36109036-900b-48c8-a03f-46d0108e0f8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "7fdbb9cd-57b1-4d68-b277-70b803118d05"
    },
    {
      id: "37f2e02c-4490-4f4a-b2fa-c83040af4f1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "c72046e1-d3c7-4a2d-a2fb-68105d8ff5af"
    },
    {
      id: "52016c74-e677-46ad-a2f4-9f513d6f07ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "9115becb-df28-4b8f-bc6b-f76537418602"
    },
    {
      id: "01c98360-7aa1-453c-92da-98891402a4dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "b5dc41fc-15bc-4af3-9da6-336849f71cee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "670aec9a-e1eb-4076-9b88-4d9eb7984678"
    },
    {
      id: "de3787dd-b3f9-4e2d-bf0e-15bec5c3d510",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4",
      target: "92382b5d-09f4-4be1-b2f5-b1899eed6f80"
    },
    {
      id: "f0a41516-1415-4325-913f-194440fa93b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8ae958b-366b-490f-9e68-81df6173416d",
      target: "187da2f9-2d65-4b95-9f0c-74b9fdbfc170"
    },
    {
      id: "cce7b792-3159-4bf0-a75e-dd7efd145cdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c20d981-76ae-4733-a74f-d28eada76950",
      target: "e8ae958b-366b-490f-9e68-81df6173416d"
    },
    {
      id: "53b3edff-0afa-4558-8d7d-23c1a37fbcd2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b927c50c-d897-4864-888c-d8f6122c9703",
      target: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4"
    },
    {
      id: "595381c5-3d12-4c65-b7a8-5d733a844ef7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b927c50c-d897-4864-888c-d8f6122c9703",
      target: "3244e47c-1feb-44a8-94d3-d3a90cfdf6f4"
    },
    {
      id: "c1c07ad9-9213-4278-9228-4502d1d41880",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b927c50c-d897-4864-888c-d8f6122c9703",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "b85ca9dd-e3b5-48c5-9005-61ff10e5fc5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6798a730-f88a-498d-9d8c-74f13928280f",
      target: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9"
    },
    {
      id: "2f3881b5-270f-40f8-b99b-3cd2611eeaa0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6798a730-f88a-498d-9d8c-74f13928280f",
      target: "4cea9e3c-828c-498d-9aa1-515455499cd6"
    },
    {
      id: "44e5d772-e448-4bd1-b74f-494b0a9fe8cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9",
      target: "4cea9e3c-828c-498d-9aa1-515455499cd6"
    },
    {
      id: "a1b99846-29b5-4e47-8488-2b6b8729fb2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bfdaaad-2109-46ab-bcdc-499e23bd75b9",
      target: "28417da3-1430-46f2-a529-29b6830c1d8b"
    },
    {
      id: "fbd17729-35ba-440a-a6c0-98b649a0d490",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28417da3-1430-46f2-a529-29b6830c1d8b",
      target: "4cea9e3c-828c-498d-9aa1-515455499cd6"
    },
    {
      id: "f64cdb9c-918f-49d8-9492-cd41852c241c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28417da3-1430-46f2-a529-29b6830c1d8b",
      target: "4cea9e3c-828c-498d-9aa1-515455499cd6"
    },
    {
      id: "dec638aa-1b29-467a-87d8-afda3eb250f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28417da3-1430-46f2-a529-29b6830c1d8b",
      target: "86a7299f-2c62-4d62-9b9c-35c1d26eff2d"
    },
    {
      id: "5dfba6dc-cac2-47b5-9a18-b2522b923014",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57f1d59f-978e-4245-96e3-e9e27f131456",
      target: "4cea9e3c-828c-498d-9aa1-515455499cd6"
    },
    {
      id: "87abe6f3-43f1-4cde-a3fc-ff1603e2fde6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57f1d59f-978e-4245-96e3-e9e27f131456",
      target: "6798a730-f88a-498d-9d8c-74f13928280f"
    },
    {
      id: "8216238c-c2fd-48fe-b6a5-bbded13e849b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57f1d59f-978e-4245-96e3-e9e27f131456",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "c63cf92d-9a72-462e-bb3f-bce94f705e8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "61340a98-908f-43b0-a857-036cd0e3257e"
    },
    {
      id: "1273f4ce-88b1-4da9-af4c-127615ae3292",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "04e876f5-e2e9-4116-af41-aff9550ebc46"
    },
    {
      id: "b1aa8022-df55-4dc4-9942-b0667f620c02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "3722bcc6-e411-4ccb-870c-4c921d9a5b51"
    },
    {
      id: "9107e03c-bd3e-4d66-9f97-59469e7c31b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "fb3b773d-6b3f-4a38-99a0-d2d6a90bd42c"
    },
    {
      id: "90eb65fa-91a2-4f17-8251-55f1b0e089e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "4070e4e5-f57a-4d04-a48e-a1ca3f85bbb6"
    },
    {
      id: "d3886b59-9fe4-442e-966b-387646178816",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "93c419fe-0544-4237-bb14-1541d7a0dc82"
    },
    {
      id: "feb40f38-31e5-455d-aa8d-10d1959936a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "bc26256c-deb1-4c63-813d-3a9a4f47c500"
    },
    {
      id: "70c48bed-d750-446d-91d4-605b5a80f240",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "23d6de3b-478c-4ff7-89f0-182b38e2e90d"
    },
    {
      id: "c0c5ca41-e969-4b81-a5b4-4a1027685dd9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "d66d5383-0992-47bc-a319-b3c126dd8fb3"
    },
    {
      id: "50acb8cf-ba20-4402-a9b7-e73bd49b96e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cea9e3c-828c-498d-9aa1-515455499cd6",
      target: "e525785a-854d-441a-b4d0-cc20a0fd9dec"
    },
    {
      id: "47db3d78-7962-4f6c-8ea6-ac1ce75805a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "93c419fe-0544-4237-bb14-1541d7a0dc82",
      target: "5cc6b2a1-28e2-432c-9333-957d8867107a"
    },
    {
      id: "001c5a29-b77e-45ab-852b-6c67537cd538",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      target: "681ea9f6-786d-48c6-8192-720a90052a9a"
    },
    {
      id: "cceefe23-1df3-4805-ac04-cfbc8d6a01aa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      target: "d72ed235-71e8-4748-ba35-530b4c3e04f0"
    },
    {
      id: "1e8acc85-696d-4cc4-bc9f-5e0404716fc9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      target: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8"
    },
    {
      id: "31a14fa2-d9df-4506-8494-f221569e3619",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      target: "81080fa9-e859-4c60-b484-4c7f65b917e8"
    },
    {
      id: "1cadf9c3-df71-49c0-ad58-231eff06e7d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "75c37b1d-e1ea-4de7-bc8e-744ab4fb6426",
      target: "abc1e34d-7fd5-4e5a-97a3-f978003f5cc3"
    },
    {
      id: "6fc0232c-7299-449a-8bfb-1f363ae5316c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "681ea9f6-786d-48c6-8192-720a90052a9a",
      target: "7f963270-d436-447c-bb7f-0dfa4164c6b5"
    },
    {
      id: "c980a301-4d1b-46c0-b03f-62d8ea14fd37",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "681ea9f6-786d-48c6-8192-720a90052a9a",
      target: "986de551-c44a-46a7-bf13-0aa72e9b9343"
    },
    {
      id: "9daf231c-b524-43c3-9b37-15d0a21e3677",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "681ea9f6-786d-48c6-8192-720a90052a9a",
      target: "986de551-c44a-46a7-bf13-0aa72e9b9343"
    },
    {
      id: "b63f9a1a-6640-4767-a346-13e31b6975f8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "681ea9f6-786d-48c6-8192-720a90052a9a",
      target: "7f963270-d436-447c-bb7f-0dfa4164c6b5"
    },
    {
      id: "6f4359da-73d6-4fea-a6a2-4a82c8b82fed",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "681ea9f6-786d-48c6-8192-720a90052a9a",
      target: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9"
    },
    {
      id: "eff84653-1173-4851-ba0a-047f131c7d83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81080fa9-e859-4c60-b484-4c7f65b917e8",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "f66b3b1c-1e24-4d41-b0d1-59350bec7134",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "986de551-c44a-46a7-bf13-0aa72e9b9343",
      target: "7bc17825-c661-4bee-9b20-33801d49338b"
    },
    {
      id: "7fd1af2d-a274-404b-b8bd-15af279f27a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "986de551-c44a-46a7-bf13-0aa72e9b9343",
      target: "7f963270-d436-447c-bb7f-0dfa4164c6b5"
    },
    {
      id: "1de8c083-d5b2-4626-80ec-a9093ea7cd0e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7f963270-d436-447c-bb7f-0dfa4164c6b5",
      target: "69836149-930c-48b4-b739-14f0a3f58793"
    },
    {
      id: "9370ec60-1732-4586-b0ed-e547c7bd4fd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f963270-d436-447c-bb7f-0dfa4164c6b5",
      target: "c3216b00-ae0a-46b8-8e12-c68d628dfea1"
    },
    {
      id: "8e45f92c-b7f4-422c-b07c-93250559a4c6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "69836149-930c-48b4-b739-14f0a3f58793",
      target: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5"
    },
    {
      id: "3a0bd092-f664-46cb-9f6c-409b8e8f112f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "69836149-930c-48b4-b739-14f0a3f58793",
      target: "b7ca906c-6386-415f-9637-8fae1d1c0499"
    },
    {
      id: "49ed2d93-32be-4ec5-b76b-4cd0ae24a7ff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b7ca906c-6386-415f-9637-8fae1d1c0499",
      target: "f5c0c82c-b783-4456-8607-fe7f19c53ea9"
    },
    {
      id: "6eb101f1-47d3-4def-b329-2cd978c93525",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7ca906c-6386-415f-9637-8fae1d1c0499",
      target: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5"
    },
    {
      id: "463c4ad5-41b0-486f-8504-9288ac8e3454",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a5d0db8b-db6d-4a2a-b0f9-6257aa6894d4",
      target: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10"
    },
    {
      id: "38d603b9-1dfe-4c14-88ca-57d1eb54ffe0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "a5d0db8b-db6d-4a2a-b0f9-6257aa6894d4"
    },
    {
      id: "96881d99-2572-4731-a096-86b57f8b20f8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "c9601c7a-8441-44a2-b189-201ef066c2d9"
    },
    {
      id: "85561bf4-1aa9-43fd-85d9-09f8ce084268",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9"
    },
    {
      id: "c1d52a90-d0af-426d-b9b0-5a58d3f32808",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "c9601c7a-8441-44a2-b189-201ef066c2d9"
    },
    {
      id: "0b699540-a908-46ed-8976-703471eca836",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "1875a1d7-f07f-45da-8bb1-42ce581297a7"
    },
    {
      id: "f4cee9dd-01b6-4e0f-864e-abf7af6a6d8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "caf010dc-1b40-4837-b245-a6f47c37b5a1"
    },
    {
      id: "ada8c3e5-6bdb-44e4-9942-f2d0f9127d9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d2c0d4b-a912-4db3-a164-b8bda5e021c8",
      target: "01ccb8cc-3724-469e-a3a9-490263f5af1e"
    },
    {
      id: "2162fbf5-c24f-4928-a07d-bd1fa8d5cb6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9601c7a-8441-44a2-b189-201ef066c2d9",
      target: "01ccb8cc-3724-469e-a3a9-490263f5af1e"
    },
    {
      id: "39d3f6cc-5a54-47fd-b1ef-b287237143e2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1875a1d7-f07f-45da-8bb1-42ce581297a7",
      target: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10"
    },
    {
      id: "7e59f309-83ea-4705-9510-17954159c99e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1875a1d7-f07f-45da-8bb1-42ce581297a7",
      target: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10"
    },
    {
      id: "e6c48757-e714-413d-8aa1-ba6e7d30db7d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "01ccb8cc-3724-469e-a3a9-490263f5af1e",
      target: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10"
    },
    {
      id: "0daad33b-fd46-446a-8b16-fadf8d8a8175",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "caf010dc-1b40-4837-b245-a6f47c37b5a1",
      target: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10"
    },
    {
      id: "5bfda8b1-086f-4fe8-9a9a-85f98aeeaf4f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10",
      target: "7ba68e98-91aa-4c6a-9158-f7d20bd00dd6"
    },
    {
      id: "241f9da6-361b-4554-9c4f-af641ba3a9dd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10",
      target: "0271206d-5a22-406a-a263-8c44b715c4b2"
    },
    {
      id: "90372f0e-fe2b-4720-bee5-3269ca059e9c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10",
      target: "0271206d-5a22-406a-a263-8c44b715c4b2"
    },
    {
      id: "ba6d7d8e-0e4a-4a41-9108-49c65ae3253d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ca0104ed-a788-4ba7-9b6a-94fb253b7c10",
      target: "7ba68e98-91aa-4c6a-9158-f7d20bd00dd6"
    },
    {
      id: "5ec1b87e-ae22-4aca-92eb-f7188512a7e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ba68e98-91aa-4c6a-9158-f7d20bd00dd6",
      target: "e183f4ef-b3e1-4262-9416-1236c0f36441"
    },
    {
      id: "dcdce850-bb17-4cb8-b690-72789cfcd33a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0271206d-5a22-406a-a263-8c44b715c4b2",
      target: "e183f4ef-b3e1-4262-9416-1236c0f36441"
    },
    {
      id: "bd2d1af0-fcf9-4e59-b9bc-8e2376db5551",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e183f4ef-b3e1-4262-9416-1236c0f36441",
      target: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90"
    },
    {
      id: "0efe9eef-8dda-40e4-b202-bd203ec037ae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0009692d-af4c-47b0-99bd-88a49bb14da7",
      target: "da85c0fc-26fe-489b-93bf-4d990e4138b1"
    },
    {
      id: "7d974c09-b2a2-4f80-ad1d-aa356fd79bd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "4d45f32e-8c7f-4f53-b2a4-e1f2ecc7f611"
    },
    {
      id: "949eb536-0a4d-4cf8-9302-6d86a4418873",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78"
    },
    {
      id: "7aeb6b21-dc7a-43bb-bd3b-0a72dfcc61e3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "c3216b00-ae0a-46b8-8e12-c68d628dfea1"
    },
    {
      id: "92e23b8d-71a2-4b76-b87e-6edefa3dc3a9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "7bc17825-c661-4bee-9b20-33801d49338b"
    },
    {
      id: "a9fb61b9-c104-4d0e-81e7-f17f74dc5308",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "0009692d-af4c-47b0-99bd-88a49bb14da7"
    },
    {
      id: "89287a1a-6d26-4539-ba54-bfd1086ec240",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "9b87906a-098d-47d8-b85c-3c3e56e14433"
    },
    {
      id: "81983f48-6326-4aba-a3c9-de35374fb7cd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78"
    },
    {
      id: "89c3d488-35cf-48d6-ae86-17fcf9e01c71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "da85c0fc-26fe-489b-93bf-4d990e4138b1"
    },
    {
      id: "28a6edc3-760e-4c51-8f5e-43cc873f1522",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2eace33a-e6ef-4653-ba15-e0f95b27f7c9",
      target: "a12dbec5-e76a-40b1-b197-84dea2c5cac1"
    },
    {
      id: "fe0cf2da-c76c-4af9-8744-af1de46345e4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78",
      target: "cc67d785-73b4-4612-847b-0c3e2759ac1b"
    },
    {
      id: "c0c5b9ef-5e15-47fa-b87c-8f8248e193f4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78",
      target: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa"
    },
    {
      id: "a14e86f4-3406-4515-98a9-fa0508c625d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e6d789b9-bbc9-4b09-89e3-f70fc5120b78",
      target: "4d45f32e-8c7f-4f53-b2a4-e1f2ecc7f611"
    },
    {
      id: "b52c68c7-7fc1-459f-b1c2-c43fdd1fab83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a12dbec5-e76a-40b1-b197-84dea2c5cac1",
      target: "da85c0fc-26fe-489b-93bf-4d990e4138b1"
    },
    {
      id: "392f23ae-a3eb-4ab7-82f9-f428785b1c2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b87906a-098d-47d8-b85c-3c3e56e14433",
      target: "da85c0fc-26fe-489b-93bf-4d990e4138b1"
    },
    {
      id: "811dfdc3-56cc-439a-b93a-3cbb308ca556",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4d45f32e-8c7f-4f53-b2a4-e1f2ecc7f611",
      target: "da85c0fc-26fe-489b-93bf-4d990e4138b1"
    },
    {
      id: "020812a9-57c1-4046-9e03-9ed44c6d7fb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9cb56bfc-bb07-4e70-bb70-587e22b2a6ba",
      target: "0121be95-59af-4e15-92d6-9c96714070dd"
    },
    {
      id: "09443ec8-4608-4cc6-8271-209acab01a6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "635fa1a3-4a0f-4e85-b7eb-69f8252fb9a7",
      target: "0121be95-59af-4e15-92d6-9c96714070dd"
    },
    {
      id: "05c2aa70-cfd4-410a-bb84-df162c88e89b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da85c0fc-26fe-489b-93bf-4d990e4138b1",
      target: "635fa1a3-4a0f-4e85-b7eb-69f8252fb9a7"
    },
    {
      id: "2ad40361-63cd-416b-ac44-42ac4abfe954",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da85c0fc-26fe-489b-93bf-4d990e4138b1",
      target: "635fa1a3-4a0f-4e85-b7eb-69f8252fb9a7"
    },
    {
      id: "cc144eef-9c97-498d-8adf-62deed541741",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da85c0fc-26fe-489b-93bf-4d990e4138b1",
      target: "9cb56bfc-bb07-4e70-bb70-587e22b2a6ba"
    },
    {
      id: "aec8aff4-4cf0-45a3-bfb0-12bb214d7226",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da85c0fc-26fe-489b-93bf-4d990e4138b1",
      target: "9cb56bfc-bb07-4e70-bb70-587e22b2a6ba"
    },
    {
      id: "0d174854-167e-4f42-9a94-d02f746846e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0121be95-59af-4e15-92d6-9c96714070dd",
      target: "18334722-94ca-454d-a407-c2ebe037779e"
    },
    {
      id: "8f7098b8-4ada-41ea-8b38-e3e664db1fd4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa",
      target: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c"
    },
    {
      id: "3c11f51e-8fdf-499b-9ef5-aed57c00a2be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa",
      target: "5f086f11-ca53-41de-a54b-d75a43515214"
    },
    {
      id: "12fbfb7b-cd54-4447-bda7-3dd2e5e464ed",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e6e4fa59-ce01-40f5-9800-b28ea0f9911b",
      target: "0d4e1ec3-301d-438a-830a-df078e8ea34c"
    },
    {
      id: "c57b1271-9f77-4a35-a2b5-1702f1710012",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "e5de2a0f-460d-40c0-84e3-84d2779ca56c"
    },
    {
      id: "5b763a7f-9ad8-40dc-a7ef-0b5dc2ca0288",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "4cf177df-cecb-427d-a866-dc61a330e4f6"
    },
    {
      id: "27078921-42ff-449c-a985-a03884d99b9c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa"
    },
    {
      id: "c81c838c-c0af-420b-88b0-66870c00b3ce",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "e6e4fa59-ce01-40f5-9800-b28ea0f9911b"
    },
    {
      id: "7984bb2e-07b7-46fe-9230-b478a73cf2ef",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "b4eca4bd-1322-4f27-9d56-311d2adfb9fa"
    },
    {
      id: "4ea5f430-b49c-4738-b112-531f3fbbc9c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "5f086f11-ca53-41de-a54b-d75a43515214"
    },
    {
      id: "27f1748d-8490-4524-9874-36f802d90f06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7bc17825-c661-4bee-9b20-33801d49338b",
      target: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5"
    },
    {
      id: "6d808fcb-e64f-4d79-9bb8-e72421b22a96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cf177df-cecb-427d-a866-dc61a330e4f6",
      target: "0d4e1ec3-301d-438a-830a-df078e8ea34c"
    },
    {
      id: "baa26773-471e-4297-9fe0-36008a7d9c4c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5de2a0f-460d-40c0-84e3-84d2779ca56c",
      target: "0d4e1ec3-301d-438a-830a-df078e8ea34c"
    },
    {
      id: "00afd933-ec8c-4a69-a0e2-6d1e9e02a03a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5f086f11-ca53-41de-a54b-d75a43515214",
      target: "0d4e1ec3-301d-438a-830a-df078e8ea34c"
    },
    {
      id: "1acb3a78-9226-4aad-b1e5-db2ccf4535cb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d4e1ec3-301d-438a-830a-df078e8ea34c",
      target: "b069564a-eddd-4292-aad6-f27eeb880557"
    },
    {
      id: "8f1cb70f-b99d-4ea2-a252-ca90b4ba40f0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0d4e1ec3-301d-438a-830a-df078e8ea34c",
      target: "01a216fb-b987-4bdb-82e2-a17937ef823b"
    },
    {
      id: "2a74d73a-da1f-4395-8d1a-18d55b12a738",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0d4e1ec3-301d-438a-830a-df078e8ea34c",
      target: "b069564a-eddd-4292-aad6-f27eeb880557"
    },
    {
      id: "901aaac4-84b0-4883-95de-da8ab5f85b68",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d4e1ec3-301d-438a-830a-df078e8ea34c",
      target: "01a216fb-b987-4bdb-82e2-a17937ef823b"
    },
    {
      id: "4b025a5f-70be-420b-958f-2af355cae3bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b069564a-eddd-4292-aad6-f27eeb880557",
      target: "708065cf-9a16-4b84-b7a7-e9d77054c890"
    },
    {
      id: "9cf9f8bb-430f-4789-bc7b-93610ddb2059",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01a216fb-b987-4bdb-82e2-a17937ef823b",
      target: "708065cf-9a16-4b84-b7a7-e9d77054c890"
    },
    {
      id: "b7e8bb87-256d-49be-984c-22d9c919707e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "708065cf-9a16-4b84-b7a7-e9d77054c890",
      target: "b218df79-3f16-4f70-ae08-fa91e4e95874"
    },
    {
      id: "92a93f53-b374-47c4-97c3-821768b8583e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cc67d785-73b4-4612-847b-0c3e2759ac1b",
      target: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56"
    },
    {
      id: "c29ae459-0caa-4d46-ab60-cde304c73afb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc67d785-73b4-4612-847b-0c3e2759ac1b",
      target: "2de9f875-30d6-4317-8de6-1e340e38c348"
    },
    {
      id: "8b7e8d73-9e28-486a-b94e-4c32c2524f55",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "557f4a5b-506c-4d2f-8d73-ccdac0d09b83",
      target: "34024419-c329-450e-9a35-0eea8e810828"
    },
    {
      id: "6902374a-fee9-4f8e-a189-9f8b3f5b26fb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "2de9f875-30d6-4317-8de6-1e340e38c348"
    },
    {
      id: "6f66c3fd-37c0-4d63-af2a-7a9e518df537",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "3a66d0d6-ea24-4400-803c-8305218bb78f"
    },
    {
      id: "ed31eb3b-917d-4088-8fab-32ede60fbdfc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "557f4a5b-506c-4d2f-8d73-ccdac0d09b83"
    },
    {
      id: "e7f5ad6e-8802-4893-ac2d-8255dcf1b7b8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "cc67d785-73b4-4612-847b-0c3e2759ac1b"
    },
    {
      id: "ab9cf1ed-670b-46ad-b958-b5892f4b7cb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "2de9f875-30d6-4317-8de6-1e340e38c348"
    },
    {
      id: "d11e1da8-fa5e-4a62-b2b8-c5f0e08a83d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "f5c0c82c-b783-4456-8607-fe7f19c53ea9"
    },
    {
      id: "4e3868ae-d395-404f-91f2-ba3d050d8663",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "1e24bee4-e9b7-4e93-b754-3e8ff99d386e"
    },
    {
      id: "6c030d22-0d9a-4901-a632-d265f77448c5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c3216b00-ae0a-46b8-8e12-c68d628dfea1",
      target: "cc67d785-73b4-4612-847b-0c3e2759ac1b"
    },
    {
      id: "b386fb86-1ac0-4538-ae58-fa8ef2d10903",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e24bee4-e9b7-4e93-b754-3e8ff99d386e",
      target: "34024419-c329-450e-9a35-0eea8e810828"
    },
    {
      id: "286d33c5-5f86-47dd-8feb-5bb95af8dd54",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3a66d0d6-ea24-4400-803c-8305218bb78f",
      target: "34024419-c329-450e-9a35-0eea8e810828"
    },
    {
      id: "fa7c4ca2-ead5-4605-b10b-c751d1e2660a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2de9f875-30d6-4317-8de6-1e340e38c348",
      target: "34024419-c329-450e-9a35-0eea8e810828"
    },
    {
      id: "75681c1f-4667-40b3-8edc-cd0463096dfa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "34024419-c329-450e-9a35-0eea8e810828",
      target: "57a27c76-2b94-401d-9035-4955837b0296"
    },
    {
      id: "8e8ec0d5-86d6-4d88-befb-c89da12cacfe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34024419-c329-450e-9a35-0eea8e810828",
      target: "57a27c76-2b94-401d-9035-4955837b0296"
    },
    {
      id: "ea84cf9a-c23f-4a6a-8085-57db95338b4c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "34024419-c329-450e-9a35-0eea8e810828",
      target: "e96a584d-ee96-4a5e-91f0-efee1a23481b"
    },
    {
      id: "1bc13f3b-61d5-4a62-9468-c9a3d74ecbf5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34024419-c329-450e-9a35-0eea8e810828",
      target: "e96a584d-ee96-4a5e-91f0-efee1a23481b"
    },
    {
      id: "c05262d6-02d7-4653-8f69-ac7093c88625",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e96a584d-ee96-4a5e-91f0-efee1a23481b",
      target: "11487d54-9fa5-4cff-b4e1-c23d07f3d65b"
    },
    {
      id: "0a377b3c-64b9-43e4-a8f0-e70b84b431e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57a27c76-2b94-401d-9035-4955837b0296",
      target: "11487d54-9fa5-4cff-b4e1-c23d07f3d65b"
    },
    {
      id: "9e669a63-4ff5-4c54-8395-97a5cfa5e8cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11487d54-9fa5-4cff-b4e1-c23d07f3d65b",
      target: "52ce9133-2749-4c15-81ba-1a3af7588a34"
    },
    {
      id: "4830e539-3680-41cf-9a39-93898c08b170",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c",
      target: "b99e24ae-e3de-4d45-9094-bb837f13fb4b"
    },
    {
      id: "aef422b7-8d16-4c0d-a3b2-b5b531bf763c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c",
      target: "99d743f0-19a5-450a-9923-5903819ebbee"
    },
    {
      id: "8c782574-53c5-4666-b016-26d4f83e35e8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3c4a8f39-7983-4edb-a75a-931e19671b4e",
      target: "801d90d3-308a-45d8-aa5a-84707a0f6168"
    },
    {
      id: "42b0d616-8769-4860-9840-761491345f46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "99d743f0-19a5-450a-9923-5903819ebbee"
    },
    {
      id: "ab1ae15b-7416-41d1-a8fd-e7f60702d583",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "3c4a8f39-7983-4edb-a75a-931e19671b4e"
    },
    {
      id: "8248691d-6149-4dce-ac45-ec5732b2c051",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c"
    },
    {
      id: "2eee4c41-1b48-4962-a693-0be637a185c4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "3e8d919a-1323-4e3d-b011-9634f8cdbaed"
    },
    {
      id: "be4c7c1f-c22a-4a60-9bae-0accab6b2453",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "9ce4ea74-414e-4bc4-a45b-3cc23d5d422c"
    },
    {
      id: "a82cb349-0751-4f5e-868d-55b08fd6f632",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8151b14c-0dc4-4df2-904f-e90aa28dd1f5",
      target: "6901006a-88f8-47d2-a665-e7c120f803c5"
    },
    {
      id: "99ca5a73-68bd-4706-886a-7ce0767edff0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e8d919a-1323-4e3d-b011-9634f8cdbaed",
      target: "801d90d3-308a-45d8-aa5a-84707a0f6168"
    },
    {
      id: "cdd0c965-9f62-4c40-ba2e-8dee59a6bcb3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6901006a-88f8-47d2-a665-e7c120f803c5",
      target: "801d90d3-308a-45d8-aa5a-84707a0f6168"
    },
    {
      id: "7db5782a-103d-41d3-8377-5b8b46731ea6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "99d743f0-19a5-450a-9923-5903819ebbee",
      target: "801d90d3-308a-45d8-aa5a-84707a0f6168"
    },
    {
      id: "a9339f61-9ff8-486e-8d7c-7debf02d83bc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "801d90d3-308a-45d8-aa5a-84707a0f6168",
      target: "7c6a153e-430f-42d8-87af-6431c1b0c4b6"
    },
    {
      id: "087a59f6-ccaa-46ff-b296-be3ccc9cf431",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "801d90d3-308a-45d8-aa5a-84707a0f6168",
      target: "e8554953-6a6f-4378-bfc5-cbe7872cda91"
    },
    {
      id: "4893e94e-cd88-4d8e-92bf-648feeea5536",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "801d90d3-308a-45d8-aa5a-84707a0f6168",
      target: "e8554953-6a6f-4378-bfc5-cbe7872cda91"
    },
    {
      id: "ba011fa2-2bf5-4ad0-a540-00a5294c836d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "801d90d3-308a-45d8-aa5a-84707a0f6168",
      target: "7c6a153e-430f-42d8-87af-6431c1b0c4b6"
    },
    {
      id: "23f728bb-51a1-4f7a-a53d-72bb86a40560",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8554953-6a6f-4378-bfc5-cbe7872cda91",
      target: "b689c116-9865-4106-b790-0f9b9203295e"
    },
    {
      id: "8b55f3e1-9f70-4ab9-9cd3-61809a581108",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c6a153e-430f-42d8-87af-6431c1b0c4b6",
      target: "b689c116-9865-4106-b790-0f9b9203295e"
    },
    {
      id: "b029d8e2-fdf7-4329-8570-1ce85492b7fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b689c116-9865-4106-b790-0f9b9203295e",
      target: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4"
    },
    {
      id: "0adb2d4d-0266-46da-95c9-b294e5d3c876",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0fe2ef5c-f13d-4358-8b45-bb6e458d345f",
      target: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b"
    },
    {
      id: "610ba346-0882-40da-8bb4-462c9da13e54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "a6296ed0-7331-46ac-8bec-051b7c5f3ecf"
    },
    {
      id: "e523f71a-ad1f-451a-a257-2b96da595d3b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56"
    },
    {
      id: "58b9665b-70e7-4b68-8098-9670756e4f4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "ec91474a-d4e9-4b87-b4a6-54f55adde5d3"
    },
    {
      id: "386a86b2-4c2c-4ef8-8519-2c6deb3a38e3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56"
    },
    {
      id: "bd378d12-e228-47ec-a2a8-c50221ad1a29",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "f3b17f9e-53fd-4d16-8368-5ad9f2d0972b"
    },
    {
      id: "ea5ebdc4-129f-4e08-8709-4495bc78fdf7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5c0c82c-b783-4456-8607-fe7f19c53ea9",
      target: "0fe2ef5c-f13d-4358-8b45-bb6e458d345f"
    },
    {
      id: "30c2ee82-a370-4f8f-a9bd-cc6d9a8edf62",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56",
      target: "b99e24ae-e3de-4d45-9094-bb837f13fb4b"
    },
    {
      id: "bf877ac8-613f-4dff-aa55-526af6bf8f20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96ceeced-f1eb-4ba0-a217-45fc1bf7bc56",
      target: "a6296ed0-7331-46ac-8bec-051b7c5f3ecf"
    },
    {
      id: "3b0a288e-478c-408d-a3e0-ef8d9329582f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3b17f9e-53fd-4d16-8368-5ad9f2d0972b",
      target: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b"
    },
    {
      id: "165992f1-3d27-4aad-a2a3-4079de2be7d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a6296ed0-7331-46ac-8bec-051b7c5f3ecf",
      target: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b"
    },
    {
      id: "af1db5df-e94b-4283-a16d-e359f3fc4842",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec91474a-d4e9-4b87-b4a6-54f55adde5d3",
      target: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b"
    },
    {
      id: "b1c331f8-725d-436b-9e84-4f679f6d4b36",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b",
      target: "bddc1376-21cc-4b85-a77f-3e45b164b74a"
    },
    {
      id: "d21da838-9179-4606-8daf-6d0a75fe0539",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b",
      target: "bddc1376-21cc-4b85-a77f-3e45b164b74a"
    },
    {
      id: "586fce55-68ee-4bfb-a6ff-ad9adbbab444",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b",
      target: "9d39ff96-e7cf-4a00-bb33-71eb46010f0c"
    },
    {
      id: "1b54824a-a671-473a-82a0-bba4fe322572",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "26dcd25e-7cdd-4abb-a106-c8404e6b4a6b",
      target: "9d39ff96-e7cf-4a00-bb33-71eb46010f0c"
    },
    {
      id: "66d1e948-3a56-4324-a1e3-14de06c8eb09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d39ff96-e7cf-4a00-bb33-71eb46010f0c",
      target: "f87dfe7d-589b-40bb-aa66-aec5c6c358e0"
    },
    {
      id: "44826f49-740f-41d3-b67b-a9adb9f16d15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bddc1376-21cc-4b85-a77f-3e45b164b74a",
      target: "f87dfe7d-589b-40bb-aa66-aec5c6c358e0"
    },
    {
      id: "fd449153-42a7-45b5-b263-a8b5ef1267f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f87dfe7d-589b-40bb-aa66-aec5c6c358e0",
      target: "ec977ce1-cb6b-468b-8406-d82c32cee200"
    },
    {
      id: "70345aa0-f31f-46c3-9259-97c0e6fc791c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "18334722-94ca-454d-a407-c2ebe037779e",
      target: "4b475fd7-db58-45e4-90cd-9e9e9fb2a75a"
    },
    {
      id: "958ff65d-01bd-400a-bff3-64eb15fc2f1c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "18334722-94ca-454d-a407-c2ebe037779e",
      target: "e268c818-d3e5-4b88-8a92-e9fe836f88aa"
    },
    {
      id: "6ac43e7c-1946-40a7-a1d6-50dff332b912",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "18334722-94ca-454d-a407-c2ebe037779e",
      target: "d759407a-4b29-4c26-bef9-8ce89bbf0990"
    },
    {
      id: "31bd2dfb-5cae-414f-9ae4-f1860f3503d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "18334722-94ca-454d-a407-c2ebe037779e",
      target: "e268c818-d3e5-4b88-8a92-e9fe836f88aa"
    },
    {
      id: "b0ae2960-d251-4c57-9fa6-d890669ffb4f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d759407a-4b29-4c26-bef9-8ce89bbf0990",
      target: "2c94f5ba-83f2-467a-a290-6024e28133eb"
    },
    {
      id: "f4742316-7bc0-4295-bcbe-c86e9f407928",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e268c818-d3e5-4b88-8a92-e9fe836f88aa",
      target: "2c94f5ba-83f2-467a-a290-6024e28133eb"
    },
    {
      id: "6e3b4207-ee15-47e4-a1e3-ea2a77ac2d8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e268c818-d3e5-4b88-8a92-e9fe836f88aa",
      target: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf"
    },
    {
      id: "c7411094-f9bf-4717-8bb1-822b64422ed0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c94f5ba-83f2-467a-a290-6024e28133eb",
      target: "0b934af1-dcd1-4172-97ef-4396b6e6bd4c"
    },
    {
      id: "cba6c77d-02ed-4c1c-8c3f-431d7158efc0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c94f5ba-83f2-467a-a290-6024e28133eb",
      target: "e7d07b71-af42-40fe-aa10-005bdd1435f1"
    },
    {
      id: "53975b9c-2648-47fa-ae4f-a9cc4ca3a39d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c94f5ba-83f2-467a-a290-6024e28133eb",
      target: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2"
    },
    {
      id: "714c7ff6-21f8-4287-ac2a-29a2be70f916",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c94f5ba-83f2-467a-a290-6024e28133eb",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "1eb360bf-4d9a-424a-b30a-054aec14fac4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e7d07b71-af42-40fe-aa10-005bdd1435f1",
      target: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90"
    },
    {
      id: "778b2b0b-edb0-4603-bd41-7838505fdd7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7d07b71-af42-40fe-aa10-005bdd1435f1",
      target: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98"
    },
    {
      id: "1e06413c-94fd-41fb-833d-fb63205fffce",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf",
      target: "e0e4c9da-e0b6-41ec-b9e5-c1178d84cf78"
    },
    {
      id: "2142cf23-c5ab-432a-8e60-c2c0338dd4ed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf",
      target: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f"
    },
    {
      id: "d0b4a15b-b92e-4d9f-8162-a14bbe1c7f8b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a7b78d6c-6d7e-48a8-abcb-999a92f611cf",
      target: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f"
    },
    {
      id: "77c9ad6d-22cd-4fb5-8d06-f15f4e99547b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e0e4c9da-e0b6-41ec-b9e5-c1178d84cf78",
      target: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2"
    },
    {
      id: "79c25c74-5e0b-471f-bfd5-40b23d996ac7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f",
      target: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2"
    },
    {
      id: "2c44a01b-c92e-4b32-b8a1-835368dd3a88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f",
      target: "b218df79-3f16-4f70-ae08-fa91e4e95874"
    },
    {
      id: "12793f12-1cb2-4505-b460-6244b5cb81ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f",
      target: "52ce9133-2749-4c15-81ba-1a3af7588a34"
    },
    {
      id: "e3308120-cd45-4f4e-b636-2dd3477fb468",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c63ee16b-e3f2-42e5-8c5e-b4e1e018862f",
      target: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2"
    },
    {
      id: "90c28225-7bc8-43e6-b24f-f04ac7f7ad87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2",
      target: "439475e7-fd6f-4100-91a8-ac58abcdbdcb"
    },
    {
      id: "c71b5eaa-e73d-4fc8-a839-8d8097c423f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2",
      target: "0b934af1-dcd1-4172-97ef-4396b6e6bd4c"
    },
    {
      id: "b9514436-d873-48cc-bde1-b373c046b104",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2",
      target: "5caf27a7-22fc-4391-b029-dc13fc811ea6"
    },
    {
      id: "ede7aa9b-6b4f-4062-af95-66e27fc65602",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b08d1fa-b2fc-47a6-a67e-554be3bcb1d2",
      target: "0e58febc-6d94-471f-a129-7e827930d4f5"
    },
    {
      id: "851a44f0-0b00-4d44-8529-85dd50521968",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0b934af1-dcd1-4172-97ef-4396b6e6bd4c",
      target: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f"
    },
    {
      id: "0fec581a-69e1-4884-8d8b-59bd0fd0d5b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b934af1-dcd1-4172-97ef-4396b6e6bd4c",
      target: "8d4d8256-409e-4d95-892b-af9af8c83747"
    },
    {
      id: "a89acb9f-1f61-4fff-a52f-9bb7b7e23f2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14d9c290-1711-4bef-9b8b-2bf6c1ec2076",
      target: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc"
    },
    {
      id: "5ecfe8a1-c2bf-43ea-9af0-c6b18c4fc6d3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b218df79-3f16-4f70-ae08-fa91e4e95874",
      target: "5125e72f-5be1-4d42-bf16-dbda07ff65d2"
    },
    {
      id: "4d938c3f-162a-4f79-a6e5-b4d7c0812012",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b218df79-3f16-4f70-ae08-fa91e4e95874",
      target: "14d9c290-1711-4bef-9b8b-2bf6c1ec2076"
    },
    {
      id: "f7337d7c-e515-49a5-81f0-6f8fde3ded40",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b218df79-3f16-4f70-ae08-fa91e4e95874",
      target: "5125e72f-5be1-4d42-bf16-dbda07ff65d2"
    },
    {
      id: "4b86d009-7bf4-4e8b-99a1-8c64fa3c8c43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5125e72f-5be1-4d42-bf16-dbda07ff65d2",
      target: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc"
    },
    {
      id: "38d15e78-d22c-467b-92cc-f76cd8973664",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5125e72f-5be1-4d42-bf16-dbda07ff65d2",
      target: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4"
    },
    {
      id: "b5239d0d-18c7-4d35-a02b-b16db8331ed0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc",
      target: "b292f9f6-cc9d-4599-bef3-7964fab7e2cb"
    },
    {
      id: "058b1550-9baa-436b-9c4b-a70173ca08aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc",
      target: "3839bbe2-3dff-4bf4-a60e-7864a1ffced6"
    },
    {
      id: "cd242e7d-e236-4c6a-8bdb-647c394c2f05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7d801f1-39d5-4b57-b8a7-747ab00e1edc",
      target: "085297a6-891e-42b9-abd5-3a092733cf40"
    },
    {
      id: "689ab7b2-f97c-4f00-98a4-4b23b307ac73",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3839bbe2-3dff-4bf4-a60e-7864a1ffced6",
      target: "36b79854-9774-4973-bd6b-578b4b168918"
    },
    {
      id: "ba28dff4-2c32-4a94-96dd-f5159f0f0d52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3839bbe2-3dff-4bf4-a60e-7864a1ffced6",
      target: "7988ad95-6910-4038-8432-6e3a16f2aaef"
    },
    {
      id: "2e3edb86-a37b-451c-986d-905e715725e7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3839bbe2-3dff-4bf4-a60e-7864a1ffced6",
      target: "7988ad95-6910-4038-8432-6e3a16f2aaef"
    },
    {
      id: "3bc71321-10ab-41fc-85f6-9f869d15eec4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3217259f-e02a-47f5-b0b4-01c6c0a67941",
      target: "b67b89c1-fee7-4663-91a4-e1613a1eb002"
    },
    {
      id: "1874f314-535a-428a-951a-90b99670e0c9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52ce9133-2749-4c15-81ba-1a3af7588a34",
      target: "3217259f-e02a-47f5-b0b4-01c6c0a67941"
    },
    {
      id: "9171f4ac-dfe0-441d-aea7-4613060fff58",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52ce9133-2749-4c15-81ba-1a3af7588a34",
      target: "5cba7266-2724-483c-adf5-63d041ec2d40"
    },
    {
      id: "0995f914-1489-4c69-b53f-efa29a1d267a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52ce9133-2749-4c15-81ba-1a3af7588a34",
      target: "5cba7266-2724-483c-adf5-63d041ec2d40"
    },
    {
      id: "ddd2c7ce-6d78-430d-b832-ac0f6d92e142",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cba7266-2724-483c-adf5-63d041ec2d40",
      target: "ec977ce1-cb6b-468b-8406-d82c32cee200"
    },
    {
      id: "2cd964f3-f3c6-47f2-81b1-a033e80ad1d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cba7266-2724-483c-adf5-63d041ec2d40",
      target: "b67b89c1-fee7-4663-91a4-e1613a1eb002"
    },
    {
      id: "2392f4ff-1564-4e17-b0c9-92a68501907d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b67b89c1-fee7-4663-91a4-e1613a1eb002",
      target: "b292f9f6-cc9d-4599-bef3-7964fab7e2cb"
    },
    {
      id: "0a27b99b-beb8-4ca6-9e8c-1428f5b7fd4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b67b89c1-fee7-4663-91a4-e1613a1eb002",
      target: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb"
    },
    {
      id: "b0fab1d9-e377-49a2-9c0e-6ac0c605d2eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b67b89c1-fee7-4663-91a4-e1613a1eb002",
      target: "030e073a-2b5b-4a22-ab03-3fdea7dce7da"
    },
    {
      id: "518d5ef1-6503-43b4-9da4-616f12c25b28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b67b89c1-fee7-4663-91a4-e1613a1eb002",
      target: "f7db4e21-dcef-428b-85cd-07788bc619e4"
    },
    {
      id: "0206e873-44cc-4903-9263-3728ba21748d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "030e073a-2b5b-4a22-ab03-3fdea7dce7da",
      target: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83"
    },
    {
      id: "4fd827fc-12b5-4b8f-9fcb-a0e0a2212de4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "030e073a-2b5b-4a22-ab03-3fdea7dce7da",
      target: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83"
    },
    {
      id: "299d897b-0539-4598-ac89-6e426574b7a5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "af9dc6c6-873c-4f3a-bae7-29917b860a05",
      target: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658"
    },
    {
      id: "4abf693e-4f2a-4eca-aafc-d4483ed6dc91",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4",
      target: "af9dc6c6-873c-4f3a-bae7-29917b860a05"
    },
    {
      id: "0649af76-6963-47fb-bb0b-7de54db9c61e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4",
      target: "21d08f23-b8b3-41f1-a04b-e7691b7446c3"
    },
    {
      id: "12f89580-2355-415d-8014-7ffd2d0d8bcb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b69c8d1-1580-4f6e-bd5b-50a5fb4498d4",
      target: "21d08f23-b8b3-41f1-a04b-e7691b7446c3"
    },
    {
      id: "6f26ed16-b60b-400b-afbb-104d079ef355",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21d08f23-b8b3-41f1-a04b-e7691b7446c3",
      target: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658"
    },
    {
      id: "7c3bddf5-2f93-4d09-b606-23f43a60c3e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658",
      target: "bf431cb9-c7ad-457d-989a-6f8a962d017c"
    },
    {
      id: "f06a9647-ecca-432b-81b8-00e5278af345",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658",
      target: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b"
    },
    {
      id: "ccf3254b-38f1-4418-9727-a799ca489c15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e887aef-da5c-4ac7-9ba4-c9ab65f9f658",
      target: "d952212a-7c20-4301-88c2-d4ea58766e1a"
    },
    {
      id: "ccfc68ef-3b3f-4c6a-8819-71ddbfdb3697",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bf431cb9-c7ad-457d-989a-6f8a962d017c",
      target: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75"
    },
    {
      id: "a282a25b-b7fa-4bdf-a745-e2215360db25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf431cb9-c7ad-457d-989a-6f8a962d017c",
      target: "78085b11-0144-408f-90e5-d30c70a38d19"
    },
    {
      id: "073b7500-39de-49ba-a7e8-6b0217c5024c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8fb0b86f-49a9-441a-b227-381decb9e778",
      target: "146c3a66-4e1a-4778-80c1-ce94beca75c3"
    },
    {
      id: "53e50185-0426-4f89-8b77-9d0cc6690c58",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "52a45269-8285-4ce1-9c6d-e8fff1ad8c0d"
    },
    {
      id: "24539ba6-15cb-4c90-8b32-f4963a7ca4a6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "52a45269-8285-4ce1-9c6d-e8fff1ad8c0d"
    },
    {
      id: "7c410a12-2c2d-4143-bd81-d6c81053f1ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "b28abcb9-0afc-42ff-bfe8-5ebb183e14ac",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "8fb0b86f-49a9-441a-b227-381decb9e778"
    },
    {
      id: "b42f451d-1c32-4782-a2dc-c780af538edf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "7b4da6bf-6556-4af6-b65d-5bf3858fe7f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec977ce1-cb6b-468b-8406-d82c32cee200",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "a0b5fd9e-eb68-433a-825b-1cdbf60f9793",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52a45269-8285-4ce1-9c6d-e8fff1ad8c0d",
      target: "146c3a66-4e1a-4778-80c1-ce94beca75c3"
    },
    {
      id: "33235b77-b7ae-4682-a3aa-ac508b52969c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52a45269-8285-4ce1-9c6d-e8fff1ad8c0d",
      target: "146c3a66-4e1a-4778-80c1-ce94beca75c3"
    },
    {
      id: "c8cb5369-b8cd-422b-948c-2c9d582ddbaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "146c3a66-4e1a-4778-80c1-ce94beca75c3",
      target: "d952212a-7c20-4301-88c2-d4ea58766e1a"
    },
    {
      id: "64f8ea9d-42a2-4cae-9b65-6e95f5bb5a9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "146c3a66-4e1a-4778-80c1-ce94beca75c3",
      target: "0cfa7d46-6fa8-4c2f-8681-6bbbbc779220"
    },
    {
      id: "fbeaae08-7a6c-479e-81c0-1128b7f8c5c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "146c3a66-4e1a-4778-80c1-ce94beca75c3",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "cc9dc290-75e7-402d-b5dd-31457606a2c6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0cfa7d46-6fa8-4c2f-8681-6bbbbc779220",
      target: "48b2aa32-8dee-49d1-8676-0ed9ca62a1b8"
    },
    {
      id: "c0b5c64c-7523-4b90-8ae3-805250bb0a4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cfa7d46-6fa8-4c2f-8681-6bbbbc779220",
      target: "78085b11-0144-408f-90e5-d30c70a38d19"
    },
    {
      id: "394ffa94-fce6-4e14-a8b3-cc1873b286a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90",
      target: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f"
    },
    {
      id: "68a66990-2480-45db-9492-c1353382724c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90",
      target: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98"
    },
    {
      id: "f899b1e9-49e8-40d3-8d3a-c18c442d7ea2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7d626466-5bec-4d60-b113-2805b273f2be",
      target: "de64d598-5090-4ed8-9101-2943b87ddf60"
    },
    {
      id: "c35c57ed-dde9-4dd3-a610-46936a0abcc4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98",
      target: "5ae0c693-710f-4d74-9f48-d4ffe3563328"
    },
    {
      id: "09d69444-5318-4a81-a521-4581bc4d2d0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98",
      target: "81b937c3-75df-4386-a79f-3240af9a410a"
    },
    {
      id: "9e58f314-59a8-4e77-8acc-a1117cb7b633",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c65ddca4-e059-4fd8-aea1-cf5ca3fe9e98",
      target: "7d626466-5bec-4d60-b113-2805b273f2be"
    },
    {
      id: "93d84562-1143-42ea-91ee-a701fbebaaac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81b937c3-75df-4386-a79f-3240af9a410a",
      target: "de64d598-5090-4ed8-9101-2943b87ddf60"
    },
    {
      id: "50dd518c-653c-4b1e-81eb-199ddb699ae4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "81b937c3-75df-4386-a79f-3240af9a410a",
      target: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62"
    },
    {
      id: "5b29c54a-9069-484f-a786-d500b60f402e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81b937c3-75df-4386-a79f-3240af9a410a",
      target: "8d4d8256-409e-4d95-892b-af9af8c83747"
    },
    {
      id: "f5f2f535-2a0d-4171-98e3-afbede9d4ba5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de64d598-5090-4ed8-9101-2943b87ddf60",
      target: "52247695-583d-420e-809e-ab1bacfff342"
    },
    {
      id: "79cc4c12-25e8-445d-99e9-8321222d2144",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de64d598-5090-4ed8-9101-2943b87ddf60",
      target: "5f651673-cd7b-48b1-8aac-3dda13dde63b"
    },
    {
      id: "e091253d-cf90-4d36-a8a5-ce2ca97146b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f",
      target: "36b79854-9774-4973-bd6b-578b4b168918"
    },
    {
      id: "7864c768-39c6-4517-8650-eb419386067e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f",
      target: "8d4d8256-409e-4d95-892b-af9af8c83747"
    },
    {
      id: "60a8de93-2f61-4313-b605-8230b2fe1d6a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "559ddd23-e068-48bf-a1f0-eaec878bdede",
      target: "e2c9a103-0fdb-446a-b227-46f9ff866c6a"
    },
    {
      id: "f8af708c-9773-426d-a2f9-bdd2fdedc823",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d4d8256-409e-4d95-892b-af9af8c83747",
      target: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62"
    },
    {
      id: "003961e5-2fc3-48f6-ad97-d55d9efceded",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8d4d8256-409e-4d95-892b-af9af8c83747",
      target: "559ddd23-e068-48bf-a1f0-eaec878bdede"
    },
    {
      id: "20c60d79-5296-4ca3-ab0c-efccc054ce9a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62",
      target: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc"
    },
    {
      id: "845f9b9c-477e-44ac-b331-bc7b52cd8352",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62",
      target: "7988ad95-6910-4038-8432-6e3a16f2aaef"
    },
    {
      id: "791aaa66-70dd-48b9-8dae-695a06dce6c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc0a0006-d6c9-4fd2-9a5d-d6f36ef8db62",
      target: "e2c9a103-0fdb-446a-b227-46f9ff866c6a"
    },
    {
      id: "6af73c8d-1fa7-4be0-9479-5487cad70f98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d"
    },
    {
      id: "36d13bb6-0a19-4308-806f-61cf4cbbada1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "7b9c4468-eb61-43fb-9126-d6bdc80e6065"
    },
    {
      id: "7f57b673-ed2c-481a-9427-753595243cad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "67b9a589-bf9a-46d6-bff8-ee11d8f70665"
    },
    {
      id: "1de3ad7b-c515-4ba3-8761-4c2fdd8cd204",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "23ac81e5-10ce-4f42-98f8-bfb47ada708a"
    },
    {
      id: "fa3a52d4-74d2-4b68-99ad-3a0782bf167b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468"
    },
    {
      id: "a76414a6-3548-48aa-a66b-9090c3ccbcbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "29feadab-5b97-4eb2-be3d-46e14988e14f"
    },
    {
      id: "5d01c7b5-a697-4f89-8f17-bb89e00cff25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2c9a103-0fdb-446a-b227-46f9ff866c6a",
      target: "f181a111-52cc-4662-bb49-ea19375faa96"
    },
    {
      id: "f2b3a14f-d181-4176-83be-4fca02e7bf2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36b79854-9774-4973-bd6b-578b4b168918",
      target: "7988ad95-6910-4038-8432-6e3a16f2aaef"
    },
    {
      id: "1f9d37cf-29aa-4893-9e13-9673d08ca150",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36b79854-9774-4973-bd6b-578b4b168918",
      target: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc"
    },
    {
      id: "7842d89a-b9e0-4210-b467-06a802f42a04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36b79854-9774-4973-bd6b-578b4b168918",
      target: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83"
    },
    {
      id: "13b3e73e-5978-4eeb-b5c9-592d2098ef34",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d158ae2a-501b-459b-9652-20322558222c",
      target: "be0bd94f-ffe7-410b-9d8b-67f3359888af"
    },
    {
      id: "2380f361-ec33-4e5b-99d7-3ef9a352bf48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7988ad95-6910-4038-8432-6e3a16f2aaef",
      target: "919a03ff-ed70-45e4-96c4-bdc368998a4d"
    },
    {
      id: "0d5ae61b-bcaf-40e3-9bd9-9489ca40d5a9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7988ad95-6910-4038-8432-6e3a16f2aaef",
      target: "d158ae2a-501b-459b-9652-20322558222c"
    },
    {
      id: "13a65eae-c6dd-43f5-9c39-4ca528c7e6a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7988ad95-6910-4038-8432-6e3a16f2aaef",
      target: "78085b11-0144-408f-90e5-d30c70a38d19"
    },
    {
      id: "033794d7-1d25-45dc-a1c4-fb7b05c153cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7988ad95-6910-4038-8432-6e3a16f2aaef",
      target: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc"
    },
    {
      id: "9e9d734e-45a5-4983-942b-db6521f14421",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc",
      target: "be0bd94f-ffe7-410b-9d8b-67f3359888af"
    },
    {
      id: "10028fe2-a6cb-423a-aae8-8a89c765be0d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0879ea3f-043a-4c12-956c-4b5ede7ff2fc",
      target: "b895aa3a-37d1-45c9-b2ba-5160fc999de8"
    },
    {
      id: "f1e86d0a-3abe-4be0-9f22-3ba85cff0169",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "49986074-60af-4a69-8655-a27f2870b244"
    },
    {
      id: "046b3d10-76ce-49c7-9ef5-44c90163fc2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "fcb414f2-390a-4870-a33e-898663fa8e82"
    },
    {
      id: "a97d12bc-a9eb-4c69-b5e4-acf3efea25b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "a5794235-9496-4110-bc2a-2645b05e22c1"
    },
    {
      id: "7d9e4e0b-692d-4938-a8d9-07479baab8fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "fd008f3f-b652-4ac0-b370-f9edcf3edfc5"
    },
    {
      id: "224b4e6c-165f-487f-9906-b96703c488c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "87f14436-2fcc-45cc-9e01-d0dabe0fe228"
    },
    {
      id: "632304d1-13d0-4b74-9e12-8953a986639e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7"
    },
    {
      id: "6e39f5e5-fe5f-407e-bdfa-515a3e5894a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "102950ef-021d-4ecc-b17c-21db92d5ad07"
    },
    {
      id: "4acc9df4-49a5-42f2-ad9a-fd34970a6a44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be0bd94f-ffe7-410b-9d8b-67f3359888af",
      target: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15"
    },
    {
      id: "9da61e71-6370-48f1-bc66-52e50dfbf21a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83",
      target: "919a03ff-ed70-45e4-96c4-bdc368998a4d"
    },
    {
      id: "5aec0995-3ca3-4851-ba6c-48f6d713f429",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83",
      target: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75"
    },
    {
      id: "56d42e80-547f-45e6-b772-98334901d1d0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "98e73b44-a413-40e1-b62a-a45425218193",
      target: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0"
    },
    {
      id: "0c2cb7c1-0aba-49bc-845b-c9fb17c27065",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "919a03ff-ed70-45e4-96c4-bdc368998a4d",
      target: "98e73b44-a413-40e1-b62a-a45425218193"
    },
    {
      id: "fffdfa36-8a25-479a-b60e-af598f4d0c0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "919a03ff-ed70-45e4-96c4-bdc368998a4d",
      target: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf"
    },
    {
      id: "24c6de30-465f-4b9d-ba2f-0854aebe3eeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "919a03ff-ed70-45e4-96c4-bdc368998a4d",
      target: "78085b11-0144-408f-90e5-d30c70a38d19"
    },
    {
      id: "f2743454-3980-41f5-93ec-d9cf9de04ec9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "919a03ff-ed70-45e4-96c4-bdc368998a4d",
      target: "b895aa3a-37d1-45c9-b2ba-5160fc999de8"
    },
    {
      id: "343e37c4-a122-4b67-881f-5d5064dfff36",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b895aa3a-37d1-45c9-b2ba-5160fc999de8",
      target: "d4cd48a2-e19f-4769-a609-b2c6dc1dd633"
    },
    {
      id: "4fa2237f-da41-4ae0-9409-45bc7f6ea481",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b895aa3a-37d1-45c9-b2ba-5160fc999de8",
      target: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0"
    },
    {
      id: "2bda5234-3902-4fd2-83a2-d894a666aaa1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc"
    },
    {
      id: "3f857cee-786d-4e6c-b4bf-b2f27a0088ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "95c3b4bc-b939-4c82-b20c-f5e408f1967f"
    },
    {
      id: "9d01ba56-956c-4836-8b41-67188cf00d8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "0135df10-1e3a-4c09-b454-cb88c7ad5510"
    },
    {
      id: "036ce0fd-4c53-4e27-84ec-1e7b0da94507",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "a3d7fee0-f942-4b24-b86b-37580a0f0f90"
    },
    {
      id: "15bbfa25-36f1-4bdf-bcf3-b3b6d33f14bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6"
    },
    {
      id: "58b76dfa-b7be-414a-962d-d074eb04e250",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00"
    },
    {
      id: "93757b22-e1cd-4395-a44c-3c826d5704db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "da4a993b-47fc-4eb2-adfe-a06962929a74"
    },
    {
      id: "87b98e43-456c-4049-8f9b-d02c3ed9e47b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "ce046f13-7690-47a8-b525-3d2dcb274d34"
    },
    {
      id: "ff072ed8-57d2-42b8-9b97-8df51b1e73bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2678b00-df5d-4ca0-a7d9-9b7591aaf2e0",
      target: "3b014aa5-c8cf-4762-9e05-d0a452c22035"
    },
    {
      id: "0b9ebd44-80f3-4ac2-8034-210bd7436151",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75",
      target: "48b2aa32-8dee-49d1-8676-0ed9ca62a1b8"
    },
    {
      id: "21a369eb-b8f8-4286-be02-ae57972ac5e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75",
      target: "78085b11-0144-408f-90e5-d30c70a38d19"
    },
    {
      id: "9c92d84b-ef59-4fae-a09c-1dbcfd58278a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0a56b3da-eaeb-41af-8802-22dc9e70e73d",
      target: "57ceed03-7023-4104-835e-17b5cb2af3f2"
    },
    {
      id: "1f80423b-ec56-40d6-bf47-66f475906585",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78085b11-0144-408f-90e5-d30c70a38d19",
      target: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf"
    },
    {
      id: "37dfee37-884d-4c05-86a9-91875bca2fde",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78085b11-0144-408f-90e5-d30c70a38d19",
      target: "d4cd48a2-e19f-4769-a609-b2c6dc1dd633"
    },
    {
      id: "df30dfed-a6db-440b-9063-7592f6d9347a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "78085b11-0144-408f-90e5-d30c70a38d19",
      target: "0a56b3da-eaeb-41af-8802-22dc9e70e73d"
    },
    {
      id: "66d4c2da-b221-48eb-a639-e9b19bd456ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4cd48a2-e19f-4769-a609-b2c6dc1dd633",
      target: "57ceed03-7023-4104-835e-17b5cb2af3f2"
    },
    {
      id: "ce55c803-6bd4-4d6d-9077-c0c303f92c09",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d4cd48a2-e19f-4769-a609-b2c6dc1dd633",
      target: "1141d702-60d3-444c-ab72-02e21ea12211"
    },
    {
      id: "d5765b1f-0960-4b1c-b59f-a4bd56e91941",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0"
    },
    {
      id: "c9425f7a-1067-478a-80e2-a43af351ef0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "4699d3cb-d8a0-4c04-adce-21fa7c2cd641"
    },
    {
      id: "f720342d-f0a3-49be-bf3f-6b3f2c6c5a9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5"
    },
    {
      id: "9f348001-76d1-4f6c-b39f-c28684cb89d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b"
    },
    {
      id: "f5e018c3-474e-4b7d-8bd7-9913c2ecdb2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "07a429d0-1de6-448a-9879-487c9e533b55"
    },
    {
      id: "a4820e25-a738-4505-ab41-1c6997a34ef4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "35dac405-8a5a-4f56-baa0-ee54071d0337"
    },
    {
      id: "f33ee9dc-c719-4172-ab28-bc246121f5f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ceed03-7023-4104-835e-17b5cb2af3f2",
      target: "def49e23-f658-4b58-83fd-d348d1d0a0fa"
    },
    {
      id: "56f3906f-5cfb-451e-b25f-75f124c994b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48b2aa32-8dee-49d1-8676-0ed9ca62a1b8",
      target: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf"
    },
    {
      id: "c7924243-951f-43a1-b4f6-fd3695c8ef47",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c3ce9ca1-8699-4b37-beeb-3b60498ef9f1",
      target: "9d976611-52ba-4900-b1ec-73a2442c5c26"
    },
    {
      id: "2e5b496b-9249-4eaa-b7c8-91c93db199f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf",
      target: "1141d702-60d3-444c-ab72-02e21ea12211"
    },
    {
      id: "aeda4c14-88c5-4acd-bbc1-6adf61b016c0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "24d8e5e9-c4a4-43f5-bc6d-4a1f105c52bf",
      target: "c3ce9ca1-8699-4b37-beeb-3b60498ef9f1"
    },
    {
      id: "de7408b5-882f-4fcc-8726-bcd3c11684a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1141d702-60d3-444c-ab72-02e21ea12211",
      target: "9d976611-52ba-4900-b1ec-73a2442c5c26"
    },
    {
      id: "c3f9889c-e928-4dc5-920a-d68d7befb83e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "d833d61a-29e5-405d-853f-b132b1771ed3"
    },
    {
      id: "d764acd6-17e6-4e7d-bd34-6e5dde34288d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "2e72af4c-7d12-4ae6-ac85-8f96fc525515"
    },
    {
      id: "f029e77d-c14d-4e0f-9df5-273db9c07509",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "6aac9d75-7734-46a2-ad90-bae35ba34d51"
    },
    {
      id: "d1ca326e-a0fb-4ab9-94b7-ea9e4b5dc39c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c"
    },
    {
      id: "4122213e-f374-4c5d-93ab-51dc451824d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b"
    },
    {
      id: "b4f47937-d829-42c2-ad21-d1c7fb941991",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d976611-52ba-4900-b1ec-73a2442c5c26",
      target: "290eb132-b609-43c0-8c0f-432a084001e6"
    },
    {
      id: "f6394a3e-f23c-4b08-a950-61ba8d89aa44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2",
      target: "daf6c419-f65a-4559-8fd1-b239240801bd"
    },
    {
      id: "baab01bf-afda-4d18-9ade-97c8048dc787",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "daf6c419-f65a-4559-8fd1-b239240801bd",
      target: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979"
    },
    {
      id: "8d2e37f2-9bd9-4035-8282-f8e9d4de2396",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      target: "d67155f8-5ebf-4c68-966c-908eb9747efa"
    },
    {
      id: "3ae492ca-6076-4418-9f71-73938756b8ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      target: "8c3e4bbb-70ef-44f9-83ec-83fe7e8a1460"
    },
    {
      id: "421b80b7-fe00-48eb-b69a-47e227dc0c1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      target: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5"
    },
    {
      id: "5e506aa5-c7e6-41c9-b317-c30faaabc3f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      target: "73d065ec-b2a2-4b51-b830-f548cf113290"
    },
    {
      id: "9bf76380-1384-4c60-9c16-4baab4dfd5e0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979",
      target: "3d974720-d6b4-46dc-8833-6ace68fc4ff1"
    },
    {
      id: "6bb3a98a-13c9-46a9-bae2-2b94550182e4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3d974720-d6b4-46dc-8833-6ace68fc4ff1",
      target: "c1cd519c-0717-437a-b53a-57050cfab4df"
    },
    {
      id: "8b01dbf9-cf9a-42f1-8a29-7da5565b48ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c3e4bbb-70ef-44f9-83ec-83fe7e8a1460",
      target: "c1cd519c-0717-437a-b53a-57050cfab4df"
    },
    {
      id: "cf82f331-7521-4653-857f-b4bfa022b5e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1cd519c-0717-437a-b53a-57050cfab4df",
      target: "c7da6cfd-4d2f-4191-9a0c-8213f859b0b0"
    },
    {
      id: "bf47e054-efec-4d6f-b9d4-9705b5cf8cd3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1cd519c-0717-437a-b53a-57050cfab4df",
      target: "eeb33de8-acc0-4d9a-9b90-25d1bb685059"
    },
    {
      id: "c6b755cd-3d4a-4249-975b-093d3e0e324c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1cd519c-0717-437a-b53a-57050cfab4df",
      target: "fd0da505-7ac6-4f33-b243-fa60110dacc1"
    },
    {
      id: "af6be2c0-f3ef-4a1d-ae8c-ea4c8862c4a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7da6cfd-4d2f-4191-9a0c-8213f859b0b0",
      target: "e79d2424-9f4b-489d-ab7e-be0866706ca4"
    },
    {
      id: "50837559-cf7d-4c00-9dcf-901d2713b229",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7da6cfd-4d2f-4191-9a0c-8213f859b0b0",
      target: "87fa564b-e670-471c-b54c-bd752209f121"
    },
    {
      id: "968fee0e-feab-4de2-9be3-37157f67a505",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87fa564b-e670-471c-b54c-bd752209f121",
      target: "0cdae1e4-86b9-4398-b004-dc07e31ce270"
    },
    {
      id: "a17bc493-5aa2-4816-8c9f-70c775226ae7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "439475e7-fd6f-4100-91a8-ac58abcdbdcb",
      target: "5dd1b4cb-a534-4471-9e4b-207b625c9e72"
    },
    {
      id: "deed73c0-4cd8-4bd4-abf7-549e80b7848b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5dd1b4cb-a534-4471-9e4b-207b625c9e72",
      target: "5d7f445c-bab8-459c-a2d9-76286a836653"
    },
    {
      id: "b5f920c2-d764-4fac-9745-98e6702b116b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "59ca1a3b-b178-4647-8534-2aa7ee9887fb"
    },
    {
      id: "b449031b-1377-498f-9ffc-d16196817cea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d"
    },
    {
      id: "feae3125-3f06-4126-90c3-da76946859bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "b7b25fc2-f423-4294-905f-82c550d8e451"
    },
    {
      id: "0face3f3-e890-4e78-b612-3084d3b9d78a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "ad416de4-3c9f-494d-88e0-4208e5a370fd"
    },
    {
      id: "81044e84-8a2f-4e7f-9c31-73f642d2c9dd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "f03a05b0-19e3-4304-947c-06a1bbdcdbde"
    },
    {
      id: "9dea03f5-8b1e-437a-9f09-a01ac50b3211",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d7f445c-bab8-459c-a2d9-76286a836653",
      target: "0e8b1ece-ca3e-4263-9a21-a0a0a2a405bc"
    },
    {
      id: "3486b6f4-cf26-4393-b966-f7ca5a52c874",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f03a05b0-19e3-4304-947c-06a1bbdcdbde",
      target: "ae0178eb-f4ce-400c-acb0-067206489a5c"
    },
    {
      id: "79c2c962-cc5d-47fa-9074-a1cc92b40f8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e8b1ece-ca3e-4263-9a21-a0a0a2a405bc",
      target: "ae0178eb-f4ce-400c-acb0-067206489a5c"
    },
    {
      id: "40571ad8-693b-49f2-b67d-5c36d52695c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae0178eb-f4ce-400c-acb0-067206489a5c",
      target: "fd0da505-7ac6-4f33-b243-fa60110dacc1"
    },
    {
      id: "5c002d9f-2395-40bb-9e48-66a15c8dbe69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae0178eb-f4ce-400c-acb0-067206489a5c",
      target: "e79d2424-9f4b-489d-ab7e-be0866706ca4"
    },
    {
      id: "ed281c77-2e5c-412f-8234-df02d7f56e64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e79d2424-9f4b-489d-ab7e-be0866706ca4",
      target: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb"
    },
    {
      id: "ae52d361-2cf7-478e-bcc0-c8a33a46deaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e79d2424-9f4b-489d-ab7e-be0866706ca4",
      target: "0cdae1e4-86b9-4398-b004-dc07e31ce270"
    },
    {
      id: "4c34c9a0-824c-450a-a637-d2df86360617",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cdae1e4-86b9-4398-b004-dc07e31ce270",
      target: "a4f79e44-64d8-4559-b616-c41d093a74bb"
    },
    {
      id: "f445017a-932a-4af5-841d-bb422511d06a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8174fd4d-f135-4ba3-9623-a7c312e6164a",
      target: "628f8803-1627-4104-b2c6-c7487fb47dfc"
    },
    {
      id: "6ed07e84-c4eb-4bdd-9408-16e9dbb33903",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "628f8803-1627-4104-b2c6-c7487fb47dfc",
      target: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618"
    },
    {
      id: "bc308b71-acd3-4de7-8aa6-a1737f18c6ab",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c255142-2967-461e-9558-6fe607d0d11d",
      target: "80358937-2b1a-41ae-aacb-c0cb4f862257"
    },
    {
      id: "41dbbfa0-e67e-44a8-a71a-98a423945b79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      target: "48765d17-c558-484e-9b2c-d26c1754da21"
    },
    {
      id: "90bf6bb7-52de-449b-8210-c1008cb82756",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      target: "abd0cea0-a044-4524-9874-930065f141fd"
    },
    {
      id: "8bf4faaf-f1e3-42fd-8f9b-cea743bbdaba",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      target: "9c255142-2967-461e-9558-6fe607d0d11d"
    },
    {
      id: "f05e95f5-de6d-423f-ace3-9110ce3fb2b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      target: "e4cff625-4671-4e31-909d-c91f23b1d76a"
    },
    {
      id: "9d248987-b412-43d3-b42c-d8899589418e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618",
      target: "07874df0-2f96-4435-8bcc-77b2ceb832a9"
    },
    {
      id: "b4d3c5e2-35ef-47b3-af28-c06587bd1c71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07874df0-2f96-4435-8bcc-77b2ceb832a9",
      target: "80358937-2b1a-41ae-aacb-c0cb4f862257"
    },
    {
      id: "3359851f-86d8-4c3c-b8b8-701da533607c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80358937-2b1a-41ae-aacb-c0cb4f862257",
      target: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc"
    },
    {
      id: "31ec2976-8fec-4d6d-b40a-3cb8049ce534",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80358937-2b1a-41ae-aacb-c0cb4f862257",
      target: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb"
    },
    {
      id: "21546838-7416-486f-a3d2-21de19ade77b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb",
      target: "6eb39590-fcae-422e-9779-77b82d79d4c5"
    },
    {
      id: "c7a305a8-d670-4013-ab87-9f78d1738b69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb",
      target: "a4f79e44-64d8-4559-b616-c41d093a74bb"
    },
    {
      id: "df6c7a8a-01c3-40f4-9d88-fbf717dd532f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4f79e44-64d8-4559-b616-c41d093a74bb",
      target: "bab4310e-57c3-4542-8777-f8dac058a2aa"
    },
    {
      id: "92614abe-20c5-484b-b6b1-df9be0924a7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6600c781-1202-481e-a52b-35cd0964ff47",
      target: "8d31128e-9113-4bd3-aa9d-a336011a7b05"
    },
    {
      id: "de30af60-6d1a-4ac9-94a4-7a003ebc78f5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8d31128e-9113-4bd3-aa9d-a336011a7b05",
      target: "9f6134a3-f146-4768-87a5-cf7d297d0fe3"
    },
    {
      id: "d90cc336-5e27-4690-a3f5-4d350c2e3f7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      target: "ea975beb-4b7f-4abd-9806-05c67f243e68"
    },
    {
      id: "6bac91b2-216f-47aa-9eed-c04abf0a39e9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      target: "cdb9662a-4d36-4ffc-810b-6f207678f0c6"
    },
    {
      id: "2fe5d79e-a128-4546-9597-956fe2cf37ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      target: "89a1abd8-4572-4cd6-9e2a-57a4c59d1444"
    },
    {
      id: "24420c69-e8c5-46a8-b880-1cc96caa05e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      target: "aac5add6-2a20-4a39-959d-8173a564edc9"
    },
    {
      id: "4d2adc50-6d9c-4ec2-8a8b-98820f69ee68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f6134a3-f146-4768-87a5-cf7d297d0fe3",
      target: "754b29f6-4c15-42ae-b7a9-ed0999e6bccc"
    },
    {
      id: "b1c516be-74f2-4dcc-a98c-e85e6d58e66a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cdb9662a-4d36-4ffc-810b-6f207678f0c6",
      target: "0d9c599d-5c47-456f-a47b-edea9a6e0d8e"
    },
    {
      id: "27181445-6f64-43c2-bb4b-4276dd079ddd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea975beb-4b7f-4abd-9806-05c67f243e68",
      target: "0d9c599d-5c47-456f-a47b-edea9a6e0d8e"
    },
    {
      id: "69b3ae5d-3374-461d-be63-dbd9f951f46c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d9c599d-5c47-456f-a47b-edea9a6e0d8e",
      target: "6eb39590-fcae-422e-9779-77b82d79d4c5"
    },
    {
      id: "1593bd62-75be-41e6-8c4c-c009d2d64583",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d9c599d-5c47-456f-a47b-edea9a6e0d8e",
      target: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0"
    },
    {
      id: "3d0c83a5-d976-445a-9201-daae81a9a0e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6eb39590-fcae-422e-9779-77b82d79d4c5",
      target: "bab4310e-57c3-4542-8777-f8dac058a2aa"
    },
    {
      id: "9db772dd-c717-4a60-9b13-e41aeab020ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6eb39590-fcae-422e-9779-77b82d79d4c5",
      target: "a47740c9-5cc0-48b9-82fd-69294a37101d"
    },
    {
      id: "40c8261a-3636-422b-ae30-f994bab57d9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bab4310e-57c3-4542-8777-f8dac058a2aa",
      target: "cc4b2444-15d5-4582-b6d0-d48dc3e4d02e"
    },
    {
      id: "03fc4ae2-e461-4ed9-8516-287f17608bf8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7c98bf0-15f2-4e60-9111-50290bda14d4",
      target: "81faa7d5-b271-463e-b720-973127863311"
    },
    {
      id: "ccd548ec-42d8-4371-afd9-6e857df1d78b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "81faa7d5-b271-463e-b720-973127863311",
      target: "73533502-6f43-4338-a644-e96d364dbd5f"
    },
    {
      id: "07e27129-ff78-4f0b-b8e8-69d2c0fad5e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73533502-6f43-4338-a644-e96d364dbd5f",
      target: "6375921a-2180-480e-b9f5-dcad87dd87bf"
    },
    {
      id: "6e5143a1-aee0-4957-94bf-01d75b774e60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73533502-6f43-4338-a644-e96d364dbd5f",
      target: "bf83dc35-3c91-4905-b1db-959f7b465647"
    },
    {
      id: "fcb2b0dc-1ec4-429c-af9b-cedfe97f7c44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73533502-6f43-4338-a644-e96d364dbd5f",
      target: "110e6ce1-858a-4287-ade9-76d223f05877"
    },
    {
      id: "5a6a3660-bf9d-490b-b812-4b48d597cf50",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73533502-6f43-4338-a644-e96d364dbd5f",
      target: "2251a03b-5b2c-4cb2-8dba-edc09b7bddc9"
    },
    {
      id: "2b65b31c-8740-4cef-937a-8fd9dbe40347",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "73533502-6f43-4338-a644-e96d364dbd5f",
      target: "b8b83fee-8725-480a-9fd8-241f75488a4e"
    },
    {
      id: "d55ef22c-8b30-4bd4-b464-45f481e1f8b8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b8b83fee-8725-480a-9fd8-241f75488a4e",
      target: "6725cdd6-3932-4749-933f-a357ed54d695"
    },
    {
      id: "56a6228e-dbfa-4bcb-bbdd-eb45bace80c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2251a03b-5b2c-4cb2-8dba-edc09b7bddc9",
      target: "6725cdd6-3932-4749-933f-a357ed54d695"
    },
    {
      id: "b5f2f008-f55e-4c09-ab76-4467a715f705",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6725cdd6-3932-4749-933f-a357ed54d695",
      target: "357c010b-aa25-4aeb-860c-f7b7b050e152"
    },
    {
      id: "57aa2725-22a3-47f1-ba3f-828190bfdea7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6725cdd6-3932-4749-933f-a357ed54d695",
      target: "a47740c9-5cc0-48b9-82fd-69294a37101d"
    },
    {
      id: "013168df-3496-43ed-a3f6-0f24a69fb35f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a47740c9-5cc0-48b9-82fd-69294a37101d",
      target: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0"
    },
    {
      id: "828f9cff-b896-4072-9092-cc9570cc9df5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a47740c9-5cc0-48b9-82fd-69294a37101d",
      target: "cc4b2444-15d5-4582-b6d0-d48dc3e4d02e"
    },
    {
      id: "d1d64e8b-3ca7-47a7-ac96-946bea00e66b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc4b2444-15d5-4582-b6d0-d48dc3e4d02e",
      target: "1295b4b6-67b6-40a3-842f-3dee76459aa2"
    },
    {
      id: "37af630f-f2e4-4e41-96c5-704159887bea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ce850f3-9e55-4e6b-912f-bcfe9c5a8eb6",
      target: "3cc250fd-7e22-4b4e-9df6-56142884eb6d"
    },
    {
      id: "b1c9e497-d668-4684-93c7-0ff91587936c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3cc250fd-7e22-4b4e-9df6-56142884eb6d",
      target: "f75086e3-4fc5-4d53-9959-32599c157446"
    },
    {
      id: "e104e622-6829-4dca-bab0-699964c7b7fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75086e3-4fc5-4d53-9959-32599c157446",
      target: "3eb7a46b-4380-444b-8d03-fdc6c8e59204"
    },
    {
      id: "2daf36cc-d0db-45d5-ad5f-0088313bcd89",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f75086e3-4fc5-4d53-9959-32599c157446",
      target: "f7ebcb3e-c5f0-48ed-be11-32253d3fd236"
    },
    {
      id: "b39a7252-bd6c-49c7-8449-c272d8f6f3c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75086e3-4fc5-4d53-9959-32599c157446",
      target: "45274fc4-697c-4dc2-ba51-e4b7e583ed48"
    },
    {
      id: "01454bea-e5d7-462c-97e7-8ad2e7beba83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75086e3-4fc5-4d53-9959-32599c157446",
      target: "941bb44b-8780-4ff6-a4bd-e63e335b7c70"
    },
    {
      id: "83847e46-503c-4acb-a1a2-d2a45113c409",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75086e3-4fc5-4d53-9959-32599c157446",
      target: "26ced265-6840-453a-9265-66ea6dffe757"
    },
    {
      id: "840c8b30-1abe-4fb8-88c9-59be9dc18359",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f7ebcb3e-c5f0-48ed-be11-32253d3fd236",
      target: "d20dc6e1-38aa-462a-a1ff-9a4e936a3658"
    },
    {
      id: "1be879d1-17c5-404d-9828-056a31ea5a2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45274fc4-697c-4dc2-ba51-e4b7e583ed48",
      target: "d20dc6e1-38aa-462a-a1ff-9a4e936a3658"
    },
    {
      id: "333eb5a5-faa7-4cc3-a3e3-6763f8643706",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d20dc6e1-38aa-462a-a1ff-9a4e936a3658",
      target: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0"
    },
    {
      id: "16fb8852-e321-47ed-8323-de3d6490d2e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d20dc6e1-38aa-462a-a1ff-9a4e936a3658",
      target: "c400db76-d6aa-4187-b34c-89cd23e11458"
    },
    {
      id: "7e1247e7-619e-4c32-92b0-80d7331dd545",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0",
      target: "1295b4b6-67b6-40a3-842f-3dee76459aa2"
    },
    {
      id: "a001e0db-06c7-4384-a86c-ea689ca0946a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0",
      target: "999a5b37-388c-4556-9e66-cefd7cb0cf85"
    },
    {
      id: "f568c463-e2af-49c3-88c3-986682061022",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1295b4b6-67b6-40a3-842f-3dee76459aa2",
      target: "c163c2c2-1247-4ae1-8866-8edc23e60da2"
    },
    {
      id: "8c65882b-3bde-4d5b-9e03-76dbdbed4278",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c142183-d997-400f-9a7d-43cc08f164da",
      target: "dfebc7b9-22bd-4180-950a-e0893c5c31a6"
    },
    {
      id: "b0b72681-e918-42c3-b613-ca97645f1075",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3c142183-d997-400f-9a7d-43cc08f164da",
      target: "43cbecd0-1dd2-45a8-aaff-e5d1a84db979"
    },
    {
      id: "3168a568-578e-4c3d-8b65-0cb08d87abf3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dfebc7b9-22bd-4180-950a-e0893c5c31a6",
      target: "ddfe9779-b4ac-47c1-8342-a17625b3bbc2"
    },
    {
      id: "56e918da-5863-49fc-a106-131400f61468",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ddfe9779-b4ac-47c1-8342-a17625b3bbc2",
      target: "531958eb-590d-4be5-9f25-a31225006c24"
    },
    {
      id: "8bd544ec-8b92-477a-bdf2-85064ae59f9a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ddfe9779-b4ac-47c1-8342-a17625b3bbc2",
      target: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012"
    },
    {
      id: "e4b57912-e59d-4c9a-a8da-bc26f4a0ebb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ddfe9779-b4ac-47c1-8342-a17625b3bbc2",
      target: "fd0da505-7ac6-4f33-b243-fa60110dacc1"
    },
    {
      id: "e8dcdf7b-7a67-450d-9fc2-cb0e9614307c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      target: "0e58febc-6d94-471f-a129-7e827930d4f5"
    },
    {
      id: "32f5efc3-ef4e-414d-a38a-36fb9332faa4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      target: "0a7b8101-358f-4e05-92f5-c2cc06e8a959"
    },
    {
      id: "72b77d4b-d127-4aab-a5a9-1115ded7c60c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      target: "8b27fcd3-be25-49ac-afd2-bbd7ece87c90"
    },
    {
      id: "c43dff04-18fa-4e4d-96cb-ea4736c74bfc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      target: "8a1d85c2-e9a9-4f8d-87ad-742248d0ecc2"
    },
    {
      id: "3b6bb83d-fb58-4408-8d56-127428fe8a72",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5caf27a7-22fc-4391-b029-dc13fc811ea6",
      target: "3c142183-d997-400f-9a7d-43cc08f164da"
    },
    {
      id: "0eac806f-14de-41d4-bd17-63bc19e4eaa9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb"
    },
    {
      id: "a068f8f1-78a8-4f5f-ac25-5ff0a51aaeed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "bc3997a9-2390-4cd0-868b-06e57a62a91f"
    },
    {
      id: "589e8197-2a90-40b0-99db-e1bce2bb22d4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "5794096a-1c2b-469a-b04b-3c07f7e5ee5f"
    },
    {
      id: "c123a9df-ddfe-4f2c-89cd-4fc68f63913f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "439475e7-fd6f-4100-91a8-ac58abcdbdcb"
    },
    {
      id: "78d9485f-1fbf-4f24-b6cc-420c2ebc27bc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "5d7f445c-bab8-459c-a2d9-76286a836653"
    },
    {
      id: "3d795f5b-5724-465d-a3a1-8777d950b832",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "085297a6-891e-42b9-abd5-3a092733cf40"
    },
    {
      id: "6f28629d-93dd-4af8-a61d-21b7dff4a972",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "f34ec909-44e0-43c6-b838-519286a54799"
    },
    {
      id: "4533b3da-7158-41b5-9267-5f97765aa2d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "60e23e29-304f-4974-b0e6-764f8ba14a48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "a4902310-fe36-4f67-81dc-c6698d7f9917"
    },
    {
      id: "89814948-a7c1-4b69-9a96-080e4135dc13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e58febc-6d94-471f-a129-7e827930d4f5",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "6bc380c7-e2cd-473d-91e6-c4c80c1eaaf8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "085297a6-891e-42b9-abd5-3a092733cf40",
      target: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b"
    },
    {
      id: "4c81f95d-ddb6-44e6-a14c-762b842d0944",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "085297a6-891e-42b9-abd5-3a092733cf40",
      target: "cd7ba8c5-1a5c-4a18-bcbf-25d408b17618"
    },
    {
      id: "5ac7088c-d510-4d69-8c0d-7acc20bd2adb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "085297a6-891e-42b9-abd5-3a092733cf40",
      target: "36b79854-9774-4973-bd6b-578b4b168918"
    },
    {
      id: "542f19cc-ed09-4dbe-b988-34330b53cc9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "085297a6-891e-42b9-abd5-3a092733cf40",
      target: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb"
    },
    {
      id: "a88d00d2-ab28-45cb-ab30-4e3615b27049",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "085297a6-891e-42b9-abd5-3a092733cf40",
      target: "8e02a0cc-de3f-4a70-87ed-929216ca8432"
    },
    {
      id: "d2347695-c21c-4d0a-9213-8d754ab6e6f1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb",
      target: "9f6134a3-f146-4768-87a5-cf7d297d0fe3"
    },
    {
      id: "01aa2adb-7b1c-49d8-a0fd-60881d9dc231",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb",
      target: "0c515027-30a1-4b74-9d8b-1e63fc4e2e83"
    },
    {
      id: "40948f48-7fc0-4ead-ad76-34e3c65f04c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb",
      target: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b"
    },
    {
      id: "8bcaee85-702a-4692-bc7e-6ea8df7ebccd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "887e832d-b0a3-4ae7-a45e-f01bea1eefbb",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "f8e8bccb-249c-4a06-a21d-2a114d732454",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "73533502-6f43-4338-a644-e96d364dbd5f"
    },
    {
      id: "cefcab50-addd-4e1b-9f11-c07ae88e9ea7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "c940bbf5-bc25-4bba-a858-85e0489531ff"
    },
    {
      id: "04f45338-6de1-41ac-ac3e-acc31f88e8f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "d7c98bf0-15f2-4e60-9111-50290bda14d4"
    },
    {
      id: "6d8128f4-382d-450b-85ea-31f07d7e7272",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "8174fd4d-f135-4ba3-9623-a7c312e6164a"
    },
    {
      id: "6862820d-e1e0-49c5-a2a3-24cc8d255f10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751"
    },
    {
      id: "4bd82b35-c0ec-4c1a-ac10-ea9b8d5b5ff6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e"
    },
    {
      id: "63e81adc-e82d-415a-9ac3-654f43c52372",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76"
    },
    {
      id: "35d87798-3e32-4943-8bc6-29c1807ef839",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "3eaa2e3f-f9dc-4467-9f3c-d5d661f3ee75"
    },
    {
      id: "dc4a616f-0388-4883-9707-495f08562021",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "17c5a102-3a79-4569-872e-ad1c465bbbff"
    },
    {
      id: "ef8d2c84-6d07-4b79-a677-31d4ee20a9a0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ae1f6fe4-d55d-42c6-b790-eaa3b767009b",
      target: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb"
    },
    {
      id: "a83bae67-434b-4564-9f77-668fcfd82158",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "6600c781-1202-481e-a52b-35cd0964ff47"
    },
    {
      id: "b38cc25e-b836-4d3c-803a-30fef9873d39",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751"
    },
    {
      id: "6d191be5-44ef-4fc0-b461-669137beb238",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e"
    },
    {
      id: "ff68dd23-5664-484f-8f73-c2301020a361",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "1ce850f3-9e55-4e6b-912f-bcfe9c5a8eb6"
    },
    {
      id: "6de3f71b-1af7-47bd-bc46-b1273e9d6a2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "17c5a102-3a79-4569-872e-ad1c465bbbff"
    },
    {
      id: "31efbb6c-c817-4189-8853-e34f13498a60",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "f75086e3-4fc5-4d53-9959-32599c157446"
    },
    {
      id: "726b9769-346d-4b28-a001-de36f756cb60",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "48b2aa32-8dee-49d1-8676-0ed9ca62a1b8"
    },
    {
      id: "9375cb13-3db8-4efc-a23e-e19cb5d9a7a1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb"
    },
    {
      id: "ebe2b5db-cfe9-485f-a28b-af1514554d76",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c940bbf5-bc25-4bba-a858-85e0489531ff",
      target: "7e297290-43c7-404a-b379-6ce4cea826e0"
    },
    {
      id: "2060eea9-7f9f-47ab-bf7f-9cfef7ed7706",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "312dc114-8970-4872-9ae8-2dbd44f0ebb5",
      target: "57a8a90f-c088-460f-9f45-ee695c3faf7a"
    },
    {
      id: "9d85d713-4941-48a8-ab17-c5d7ecedb72c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "312dc114-8970-4872-9ae8-2dbd44f0ebb5",
      target: "1332df75-3750-4cb1-bb9a-f0ed61683248"
    },
    {
      id: "d6948135-fcd5-485c-9e31-e443840766f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeb33de8-acc0-4d9a-9b90-25d1bb685059",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "77c0ec97-dfe2-40b4-9a63-17e716e29550",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeb33de8-acc0-4d9a-9b90-25d1bb685059",
      target: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0"
    },
    {
      id: "d437300e-f836-4c79-b6ac-f0f4b74173e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeb33de8-acc0-4d9a-9b90-25d1bb685059",
      target: "2fa2c90a-4117-4eba-8dfc-3d2b15c3088b"
    },
    {
      id: "c01a1177-ffd1-4eec-90af-2323d5a4a58d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "bbf90f72-3ab6-468e-999b-b67688429762"
    },
    {
      id: "7783afb3-e7b3-46dd-84d6-13601e10f524",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "c3c5a495-c4f7-4853-a2bf-87217331ba5d"
    },
    {
      id: "7e1a2212-ccf3-4439-b2fd-ef5328172a78",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "b0f8b31b-828a-4f07-9994-a48c929bd17a"
    },
    {
      id: "571cbc45-2cd2-4042-ab62-6b9efd0ce588",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "5f651673-cd7b-48b1-8aac-3dda13dde63b"
    },
    {
      id: "32547dbc-89ad-4110-9071-7a1e887a6245",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5"
    },
    {
      id: "a3a16b9b-5a1c-4b1a-bccd-8d7d8fa62b68",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "2dc13c4f-af7b-4930-8ac3-e0e2da6d455c"
    },
    {
      id: "3d254c22-749b-40ce-925f-7fc5b9ac72cd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "731caeb4-e25e-4854-96ca-86afa311f0b1"
    },
    {
      id: "bef63f47-5730-41f7-967b-4875df9f5089",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "b5935d97-c1ba-4de7-8191-fdf6e338c173"
    },
    {
      id: "2cbb8ea5-28ac-44eb-81a7-2d1ce8c96f35",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "77eba6c6-3172-4003-8d6d-2dd18ca98b81"
    },
    {
      id: "7b7446c7-b93c-47b2-ba58-39a2256c4dff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "fcdc9db0-f28d-4d1f-abdb-f2d9ca1b45e7"
    },
    {
      id: "89850911-5a6f-48e1-b70c-bdfa8546ce36",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "312dc114-8970-4872-9ae8-2dbd44f0ebb5"
    },
    {
      id: "e94e36ef-b31f-488e-931d-cc8bb28afb06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52247695-583d-420e-809e-ab1bacfff342",
      target: "fcb06be4-4928-4096-a4ef-2ccb755fe790"
    },
    {
      id: "75c76ee1-1cbc-4297-8675-828fde5eb8c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5935d97-c1ba-4de7-8191-fdf6e338c173",
      target: "8f93b811-ce91-476f-8cc1-bc63894883d2"
    },
    {
      id: "6f93994d-27ec-4970-a54f-4965697b9c46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dc13c4f-af7b-4930-8ac3-e0e2da6d455c",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "87a40535-42bf-42af-be46-95c170c5297a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcdc9db0-f28d-4d1f-abdb-f2d9ca1b45e7",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "fe489f92-7110-4d03-8d1a-fd928d4d5751",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3c5a495-c4f7-4853-a2bf-87217331ba5d",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "1ed799d9-e291-46cc-8d0b-d70755124446",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbf90f72-3ab6-468e-999b-b67688429762",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "b38aae3f-a02a-481f-b029-900215e0710d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "731caeb4-e25e-4854-96ca-86afa311f0b1",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "8024b9e0-e698-4554-a3fa-ca3a4e543d56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77eba6c6-3172-4003-8d6d-2dd18ca98b81",
      target: "17d0af7f-a628-4bbe-9f47-098668f0fb7d"
    },
    {
      id: "17d44038-c414-4d9a-ac52-4cb5f4beeafd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "77eba6c6-3172-4003-8d6d-2dd18ca98b81",
      target: "e65cf560-f777-4914-83f1-a1dddd577c7f"
    },
    {
      id: "7cfcb59f-7c8f-44f4-8c63-7228081deca0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e65cf560-f777-4914-83f1-a1dddd577c7f",
      target: "0c64ec9d-59dd-4c73-899d-d202963f14d8"
    },
    {
      id: "1c0dcefc-bbff-43e9-b8ac-ac8b5e65471b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17d0af7f-a628-4bbe-9f47-098668f0fb7d",
      target: "0c64ec9d-59dd-4c73-899d-d202963f14d8"
    },
    {
      id: "17eda2a1-acd0-4801-b051-2630064e3c4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "18168e50-5827-45ee-b0e9-cafa6e41255d"
    },
    {
      id: "c30740fd-3ef2-4308-be1e-df3637121ae7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "1a85a95d-368a-46a8-8339-2ce02d0feb9d"
    },
    {
      id: "e0b7777b-8919-41ad-acef-8ae25d537442",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "4146d9bf-f377-4b78-afee-5669b0a41f0b"
    },
    {
      id: "41948944-e138-48e0-a3b7-a12112ef5cdb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "ac1705ba-5c7a-4c3c-bfa1-a0bfa2e706a7"
    },
    {
      id: "ecd76ef2-1692-4b1f-8549-207c304b9693",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "f42d64c8-b2bd-4d87-8aa7-597c3e68303b"
    },
    {
      id: "e86029e1-9147-4614-9ac4-3bde9dae6830",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770"
    },
    {
      id: "120aeb0f-ac5a-48dd-b83e-5bbd88a207a8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2"
    },
    {
      id: "a4267074-f4c2-40b7-8721-6be1df11c0e5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012"
    },
    {
      id: "326b34bd-d039-4267-8a32-320bc7768145",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c64ec9d-59dd-4c73-899d-d202963f14d8",
      target: "8f93b811-ce91-476f-8cc1-bc63894883d2"
    },
    {
      id: "073c402c-c372-454f-9882-31f9b0e00e01",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "1a85a95d-368a-46a8-8339-2ce02d0feb9d"
    },
    {
      id: "44169b47-9e22-422b-aa90-e930303be5c3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770"
    },
    {
      id: "d6f8da89-c7d7-48a9-97b1-054b88782cf5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "f42d64c8-b2bd-4d87-8aa7-597c3e68303b"
    },
    {
      id: "450c516a-5b84-4512-9aac-285c99a35956",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "ac1705ba-5c7a-4c3c-bfa1-a0bfa2e706a7"
    },
    {
      id: "36a7a8ab-2bf2-4cac-bebf-2fca343d4157",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "18168e50-5827-45ee-b0e9-cafa6e41255d"
    },
    {
      id: "38551e2c-8511-438a-9dd0-2b214764ebad",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "bdf79de1-4d90-4d0a-a474-3bde0e6f2115"
    },
    {
      id: "c545fab2-efca-4a0d-97aa-8c5538586dde",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "8f93b811-ce91-476f-8cc1-bc63894883d2"
    },
    {
      id: "1cb4bd69-7f4f-41eb-a104-8c765b844a52",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2"
    },
    {
      id: "3685eea1-8206-44ae-a212-2f9fb43fce93",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa2c0f6f-5c3d-42bc-b816-e543eeaf3012",
      target: "4146d9bf-f377-4b78-afee-5669b0a41f0b"
    },
    {
      id: "dd48b729-a275-4194-8145-257fe07bab8e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1a85a95d-368a-46a8-8339-2ce02d0feb9d",
      target: "4146d9bf-f377-4b78-afee-5669b0a41f0b"
    },
    {
      id: "4e55e09f-3c0b-4e07-a141-7567590206fe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1a85a95d-368a-46a8-8339-2ce02d0feb9d",
      target: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2"
    },
    {
      id: "3f47d9bf-ba32-4f73-937d-909c7c1a9cba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f93b811-ce91-476f-8cc1-bc63894883d2",
      target: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e"
    },
    {
      id: "579dd2a7-cc27-42e7-a16f-117f2a151ada",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2",
      target: "18168e50-5827-45ee-b0e9-cafa6e41255d"
    },
    {
      id: "8165d766-82d5-49a7-a68b-6a57d7fe5307",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea2a5c48-1763-4ee8-a99b-a3d38bac94b2",
      target: "bdf79de1-4d90-4d0a-a474-3bde0e6f2115"
    },
    {
      id: "e54610f7-1ba3-49ed-b687-264a24dc438c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4146d9bf-f377-4b78-afee-5669b0a41f0b",
      target: "f42d64c8-b2bd-4d87-8aa7-597c3e68303b"
    },
    {
      id: "112d72eb-e4d0-4f10-bbfe-f116ea8dca78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4146d9bf-f377-4b78-afee-5669b0a41f0b",
      target: "bdf79de1-4d90-4d0a-a474-3bde0e6f2115"
    },
    {
      id: "1f069263-5ad9-4b98-93ce-ddda3cd67872",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f42d64c8-b2bd-4d87-8aa7-597c3e68303b",
      target: "ac1705ba-5c7a-4c3c-bfa1-a0bfa2e706a7"
    },
    {
      id: "b6519c7a-6ebf-45c5-bd33-3634e9dc96ed",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ac1705ba-5c7a-4c3c-bfa1-a0bfa2e706a7",
      target: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770"
    },
    {
      id: "c0223fab-dc6d-42bb-962f-f1cb439a71cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdf79de1-4d90-4d0a-a474-3bde0e6f2115",
      target: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e"
    },
    {
      id: "75551900-0c78-4e28-b259-e7a2563c4764",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "013ddcf5-68f7-48d2-86aa-45dbd5ad3770",
      target: "18168e50-5827-45ee-b0e9-cafa6e41255d"
    },
    {
      id: "3b3dcfdb-9b97-4d2f-8d3f-b94040122a3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18168e50-5827-45ee-b0e9-cafa6e41255d",
      target: "a13d4291-b872-4f47-83f1-68e56f0c81b9"
    },
    {
      id: "2c52e2a9-39d4-4ffc-8f95-7fb50741c4ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18168e50-5827-45ee-b0e9-cafa6e41255d",
      target: "5b52153d-4766-4358-8693-f95fc32925b5"
    },
    {
      id: "ec69655a-d0b2-4f7d-8875-fa05e3dd7085",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b52153d-4766-4358-8693-f95fc32925b5",
      target: "a13d4291-b872-4f47-83f1-68e56f0c81b9"
    },
    {
      id: "79592394-b05d-4b43-80e2-937b46ca0fa3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b52153d-4766-4358-8693-f95fc32925b5",
      target: "72cbdee6-37c4-4a7b-99cd-23f275f0296d"
    },
    {
      id: "c50d4ea0-b818-46ea-8829-0f504f053048",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a13d4291-b872-4f47-83f1-68e56f0c81b9",
      target: "31669510-e59d-4be6-b5cc-c39c01546c06"
    },
    {
      id: "de4c4864-303c-40ba-ad73-7962b0e2ddd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a13d4291-b872-4f47-83f1-68e56f0c81b9",
      target: "b4b05e12-c2ba-4c52-8723-03cc3396236b"
    },
    {
      id: "6d49bc90-86a1-4f83-8eb2-a243a27fc331",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a13d4291-b872-4f47-83f1-68e56f0c81b9",
      target: "56a3c0d5-3417-4023-8cb7-11411f07c760"
    },
    {
      id: "9c1ff3cc-6a79-466f-b05e-ccf3995b3a80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4b05e12-c2ba-4c52-8723-03cc3396236b",
      target: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e"
    },
    {
      id: "925684ad-1b74-43fa-b1a5-2a99bf595ade",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31669510-e59d-4be6-b5cc-c39c01546c06",
      target: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e"
    },
    {
      id: "d6bcd77a-0bcd-4780-b1f2-eddf8e9f9bba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56a3c0d5-3417-4023-8cb7-11411f07c760",
      target: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e"
    },
    {
      id: "9b9c630f-2213-44f3-b9f2-3e753091ab10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72cbdee6-37c4-4a7b-99cd-23f275f0296d",
      target: "aab14c12-8591-45a4-baab-35b4654b25d6"
    },
    {
      id: "e4e8acc1-18c0-4352-a35c-20eee5bd6605",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e",
      target: "cb1631e5-af5f-4223-a125-710ed0686609"
    },
    {
      id: "b0227ab5-6f92-4815-8fcf-edd61320d0ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "376f53ee-dd9c-4a5b-b243-775ca34f1b1e",
      target: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72"
    },
    {
      id: "7d6096f5-07fe-47d0-8f2e-1a411dad6fdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb1631e5-af5f-4223-a125-710ed0686609",
      target: "d6296d70-4cb9-49d5-a086-aa2fe674c745"
    },
    {
      id: "d2bba028-0b60-400c-abff-42aff58e1c9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb1631e5-af5f-4223-a125-710ed0686609",
      target: "542a85e9-eedf-4125-9b9c-19831993743b"
    },
    {
      id: "de2890fa-1bf0-468c-89a8-ca0cbd2263ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb1631e5-af5f-4223-a125-710ed0686609",
      target: "f262686e-0fe1-4db4-82dc-d54c3b697c5f"
    },
    {
      id: "1a506eed-8b62-4434-a6f6-e505441f4b91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb1631e5-af5f-4223-a125-710ed0686609",
      target: "11ef1af4-49c3-46f6-9fbf-7fb278e8dccf"
    },
    {
      id: "964e844e-d18c-4115-b83f-d7684c0d9fb0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      target: "4c4f953b-ed7e-4a3f-ae81-412817bd8c66"
    },
    {
      id: "eaad753f-4a4f-4d12-a121-0e2ef75d63be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      target: "f262686e-0fe1-4db4-82dc-d54c3b697c5f"
    },
    {
      id: "f4d121da-96ea-4d16-ad6e-53373625e3b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      target: "11ef1af4-49c3-46f6-9fbf-7fb278e8dccf"
    },
    {
      id: "15e6218e-d1c7-4334-8c48-9a17b6dd78b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      target: "542a85e9-eedf-4125-9b9c-19831993743b"
    },
    {
      id: "650c9b65-88dc-4c3e-98fa-77fcac73ae37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6c29d1-cceb-4512-88b8-1f87d7fd6c72",
      target: "d6296d70-4cb9-49d5-a086-aa2fe674c745"
    },
    {
      id: "3cea4bad-1b74-41af-8b02-1a2b428c082e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c4f953b-ed7e-4a3f-ae81-412817bd8c66",
      target: "03b59b82-39f9-4ef1-af1d-07d28a88ab7d"
    },
    {
      id: "5aa58768-7401-4521-abbd-57436c6c520b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6296d70-4cb9-49d5-a086-aa2fe674c745",
      target: "754035fd-b4b1-48c9-b32d-c27b2735124d"
    },
    {
      id: "1065c2be-0e6e-4164-af96-b143dff9f7a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11ef1af4-49c3-46f6-9fbf-7fb278e8dccf",
      target: "754035fd-b4b1-48c9-b32d-c27b2735124d"
    },
    {
      id: "87f7d4c7-1eef-424f-887b-eec55257e358",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f262686e-0fe1-4db4-82dc-d54c3b697c5f",
      target: "754035fd-b4b1-48c9-b32d-c27b2735124d"
    },
    {
      id: "39be7ec7-efe7-4566-9d07-7a3f028d7dec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03b59b82-39f9-4ef1-af1d-07d28a88ab7d",
      target: "1f73876b-6cea-46ce-a835-91832bb5d293"
    },
    {
      id: "18123522-ca03-42f2-9747-d64ac790134f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "542a85e9-eedf-4125-9b9c-19831993743b",
      target: "754035fd-b4b1-48c9-b32d-c27b2735124d"
    },
    {
      id: "63bc534a-ed1f-470a-86a4-69490e8ff379",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f73876b-6cea-46ce-a835-91832bb5d293",
      target: "96b6355b-571c-4374-9b17-0936c10f67f1"
    },
    {
      id: "64a3936d-1d89-4e62-bd94-5293f822eb21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "754035fd-b4b1-48c9-b32d-c27b2735124d",
      target: "aab14c12-8591-45a4-baab-35b4654b25d6"
    },
    {
      id: "0e83ee80-0d4b-4a48-9440-3e88d834bde8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "754035fd-b4b1-48c9-b32d-c27b2735124d",
      target: "96b6355b-571c-4374-9b17-0936c10f67f1"
    },
    {
      id: "97a4f674-7cca-4071-897d-52ee37efc207",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "754035fd-b4b1-48c9-b32d-c27b2735124d",
      target: "bb05ed26-7a05-4994-b01c-c4ff95337fb1"
    },
    {
      id: "53561448-bc85-4d5e-b904-58ed4a07dd4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb05ed26-7a05-4994-b01c-c4ff95337fb1",
      target: "96b6355b-571c-4374-9b17-0936c10f67f1"
    },
    {
      id: "1558662f-0ebc-49a4-936f-069672e3586b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96b6355b-571c-4374-9b17-0936c10f67f1",
      target: "966c0045-20bf-45d2-a8e1-f21d6d1907e8"
    },
    {
      id: "9108ebc5-56f2-4265-9bbf-3748e0ae0c71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "966c0045-20bf-45d2-a8e1-f21d6d1907e8",
      target: "aab14c12-8591-45a4-baab-35b4654b25d6"
    },
    {
      id: "dcfbc0b7-1e21-410c-b1a5-d80da40da957",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "966c0045-20bf-45d2-a8e1-f21d6d1907e8",
      target: "aab14c12-8591-45a4-baab-35b4654b25d6"
    },
    {
      id: "d03b1bed-6b2e-4442-b32c-2de25a81a496",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aab14c12-8591-45a4-baab-35b4654b25d6",
      target: "5c9ae33e-5f69-4888-bdde-75af599f05ca"
    },
    {
      id: "b0a82cd8-1a52-455d-ae31-8bdcf154c081",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5c9ae33e-5f69-4888-bdde-75af599f05ca",
      target: "d063a395-07dc-4681-9a7d-b35e9319f202"
    },
    {
      id: "87c1b841-a33a-48c9-b61a-22528faf7ea8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5c9ae33e-5f69-4888-bdde-75af599f05ca",
      target: "d063a395-07dc-4681-9a7d-b35e9319f202"
    },
    {
      id: "5ecd8d1f-f1e9-4910-8ef8-f0e114d78a6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d063a395-07dc-4681-9a7d-b35e9319f202",
      target: "f581bf1d-3ccd-4413-9d92-d725119f4ccf"
    },
    {
      id: "f51346b5-99be-4e2e-b74d-a1b53d7fc443",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f581bf1d-3ccd-4413-9d92-d725119f4ccf",
      target: "57a8a90f-c088-460f-9f45-ee695c3faf7a"
    },
    {
      id: "42a28c74-72e1-49cc-b061-9cf9da9b068e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f581bf1d-3ccd-4413-9d92-d725119f4ccf",
      target: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24"
    },
    {
      id: "b9e0815d-b174-46e8-944a-9d51cc727e66",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f581bf1d-3ccd-4413-9d92-d725119f4ccf",
      target: "d3590b0a-3223-4217-be38-88869cfa4fd2"
    },
    {
      id: "ca01bb66-63d1-41f0-a8fb-6df2aaf782a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57a8a90f-c088-460f-9f45-ee695c3faf7a",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "09aa2ff8-9c81-42c5-a2f9-6f7e9bb2a180",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06c14998-67a6-473c-a15f-e13fff4f61a9",
      target: "20b6c790-7b5f-416b-9f62-a1868cdd485f"
    },
    {
      id: "937e8771-7dc5-4afa-9691-4ffaf5750dfd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20b6c790-7b5f-416b-9f62-a1868cdd485f",
      target: "43e34b0b-c621-4f0a-a48a-916ec2d4ae87"
    },
    {
      id: "013953bc-a906-4d25-b43f-59bec6c9f739",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43e34b0b-c621-4f0a-a48a-916ec2d4ae87",
      target: "14ecb330-e4dc-49b9-9ed9-1c5cd2b2429b"
    },
    {
      id: "7ffa204b-fdcf-4e83-8aaa-a45f0c44213e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14ecb330-e4dc-49b9-9ed9-1c5cd2b2429b",
      target: "153adec9-99a1-4d84-b4d4-7d9869263d78"
    },
    {
      id: "28f7c0a4-6ece-4995-b693-71916d742304",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "153adec9-99a1-4d84-b4d4-7d9869263d78",
      target: "77f8951c-608c-4674-b9aa-5c7cdfb01f03"
    },
    {
      id: "16a60693-85e8-44b1-a1e7-5b0d33614a5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77f8951c-608c-4674-b9aa-5c7cdfb01f03",
      target: "6218b51c-4099-4730-8159-d4fece7b402e"
    },
    {
      id: "47c3667e-3c05-4866-84f1-179fd140e46e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6218b51c-4099-4730-8159-d4fece7b402e",
      target: "95d88811-b5b1-4855-ba9f-966986df19bb"
    },
    {
      id: "2ae5b5ae-f692-4001-b1aa-5f1b457a22b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1"
    },
    {
      id: "53822544-eb51-48eb-b86e-56a3993a5077",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "8ab887a8-e3a8-41b8-b8e4-a94372c27c06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "6f32893b-65f5-47f0-800b-bafb21a01e9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "1c342649-9101-4595-a4e8-2b5e24fb2d97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "973091c4-49f2-45a2-9636-55b87ba3a35b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d88811-b5b1-4855-ba9f-966986df19bb",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "86237adf-3673-4998-8698-a3b64cd25e4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99479f13-36a4-409f-b44c-024ee2b03f53",
      target: "759cfae2-a02b-4c92-9c18-78e7d5693907"
    },
    {
      id: "7d809eb2-b6f1-48cc-8110-7a6ca6d83d81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "759cfae2-a02b-4c92-9c18-78e7d5693907",
      target: "04bde596-890b-43b4-bee2-7ec958349cb7"
    },
    {
      id: "88805855-a109-4faa-88f7-6052f3710a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04bde596-890b-43b4-bee2-7ec958349cb7",
      target: "0bafdfde-72ea-4440-a561-3965b89a36bc"
    },
    {
      id: "a7d0103a-7c91-48c0-9cae-4080c4bfb42a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bafdfde-72ea-4440-a561-3965b89a36bc",
      target: "4b681102-efac-4828-8781-db44d2d71816"
    },
    {
      id: "31d8050b-1168-4dc8-a79b-acfced35a3e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b681102-efac-4828-8781-db44d2d71816",
      target: "20dbfc4c-9da0-482b-ba72-9b378a1d8429"
    },
    {
      id: "7d572862-e8d0-4cca-82e2-123385de17a9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4b681102-efac-4828-8781-db44d2d71816",
      target: "04dd5b0f-a51e-4c8c-b26a-2077e88c91d9"
    },
    {
      id: "6d7ec0a4-03ec-473f-9252-f5d1768ca02b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04dd5b0f-a51e-4c8c-b26a-2077e88c91d9",
      target: "20dbfc4c-9da0-482b-ba72-9b378a1d8429"
    },
    {
      id: "e1dabb6a-3887-435b-aa5c-f4e6c9af143d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20dbfc4c-9da0-482b-ba72-9b378a1d8429",
      target: "31793537-1478-4cb1-b6e8-0780d6de1c44"
    },
    {
      id: "0a13b0c7-dd48-4dd5-badf-a6364c51ce32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31793537-1478-4cb1-b6e8-0780d6de1c44",
      target: "75b8f2ec-1054-4e41-9ad3-75e67eeae400"
    },
    {
      id: "fa1e339a-ac82-481f-91e5-8409298b5c89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "2b7d6465-07ff-455e-a32f-5a3eb67c49a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "c654f5ab-86c8-49fd-8f1c-5d164231a78b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "ee2d079e-bf2c-44e6-bcb4-196f993f8f82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "5d0b208b-3ee7-4d72-8184-40733ccbf1a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "f74b5dbf-ad7b-4577-bf1a-d4ee5cb1cad2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75b8f2ec-1054-4e41-9ad3-75e67eeae400",
      target: "23d6de3b-478c-4ff7-89f0-182b38e2e90d"
    },
    {
      id: "106f1511-1c85-4314-afe2-661d6ba2e3b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "fcdc9db0-f28d-4d1f-abdb-f2d9ca1b45e7"
    },
    {
      id: "3f9d095c-cd68-4c0c-911f-4a91cdee4b4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "bbf90f72-3ab6-468e-999b-b67688429762"
    },
    {
      id: "45ec8543-4de9-4be6-9291-4f0eee45c069",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "731caeb4-e25e-4854-96ca-86afa311f0b1"
    },
    {
      id: "0c3f4fc5-3491-411d-85f6-7d3161c8ddf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "2dc13c4f-af7b-4930-8ac3-e0e2da6d455c"
    },
    {
      id: "a76ccd81-addb-46b0-90e6-a00170ebec96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "c3c5a495-c4f7-4853-a2bf-87217331ba5d"
    },
    {
      id: "ae13f6ea-8dc6-4cfb-81cb-28bcc02b224a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "b5935d97-c1ba-4de7-8191-fdf6e338c173"
    },
    {
      id: "4c151d51-2b9b-4815-a613-b9124ee835f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "77eba6c6-3172-4003-8d6d-2dd18ca98b81"
    },
    {
      id: "c3a716cd-b575-40b3-9bfb-69d966dd618b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb06be4-4928-4096-a4ef-2ccb755fe790",
      target: "9d0a37d9-829b-402b-b4fa-e91776d18818"
    },
    {
      id: "85c9ab80-b095-4155-8b37-15cbe94f3c77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d0a37d9-829b-402b-b4fa-e91776d18818",
      target: "1147ef4b-730a-4cf4-a6d8-00685d32e299"
    },
    {
      id: "9617af68-cd35-43f6-a250-7e9baa00702b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1147ef4b-730a-4cf4-a6d8-00685d32e299",
      target: "1123851f-8062-4ec1-8099-548b04aca54a"
    },
    {
      id: "adc22b90-8c87-448b-884f-908fd5dd2562",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1147ef4b-730a-4cf4-a6d8-00685d32e299",
      target: "727beeb8-9c2e-415b-a8d1-70f5295d599c"
    },
    {
      id: "b43a7090-0b67-4cab-9aff-11781c644788",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "727beeb8-9c2e-415b-a8d1-70f5295d599c",
      target: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5"
    },
    {
      id: "9b7d40db-d1be-4d9a-ae48-3861f83b6e8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5",
      target: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969"
    },
    {
      id: "252e2e22-5b59-40e7-bd09-dc9e2507cc7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5",
      target: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24"
    },
    {
      id: "8bb6df0b-e1d0-4c53-a144-b953b8bbb0ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad36a6ae-1274-4d93-9675-2cf1bc248dc5",
      target: "57a8a90f-c088-460f-9f45-ee695c3faf7a"
    },
    {
      id: "93c2ab07-6328-4de1-b414-b616c00c69ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      target: "d21d165e-9c90-44f5-b79e-b355adbed776"
    },
    {
      id: "aeb5abf2-9266-4d91-9caa-86f178e1a1a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      target: "06c14998-67a6-473c-a15f-e13fff4f61a9"
    },
    {
      id: "b729a637-91bd-4cf9-b800-401d1b1c730a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      target: "99479f13-36a4-409f-b44c-024ee2b03f53"
    },
    {
      id: "926e8c0d-039f-484e-9caf-39e78ca94ffa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      target: "06c14998-67a6-473c-a15f-e13fff4f61a9"
    },
    {
      id: "0421c12b-9240-4a83-a224-c42c59c4e74e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b2e69bb2-8e3b-49b7-8dad-0c6eb6d3c969",
      target: "99479f13-36a4-409f-b44c-024ee2b03f53"
    },
    {
      id: "436a30a8-91f4-4c4d-84a4-8ef43063e704",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d21d165e-9c90-44f5-b79e-b355adbed776",
      target: "fb07f730-204b-44da-830f-310ff7231535"
    },
    {
      id: "0bd8790a-8e6d-4bec-9399-398ca6834bdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb07f730-204b-44da-830f-310ff7231535",
      target: "c1bb9d42-1eae-46fb-96a5-d1289654ecd4"
    },
    {
      id: "0d296105-6bb4-42a7-a969-4b8e46a97e11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1bb9d42-1eae-46fb-96a5-d1289654ecd4",
      target: "103d453d-71c2-478d-8784-d16e4da7814f"
    },
    {
      id: "9cbd3e73-fa59-4050-8b19-697cff844969",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "103d453d-71c2-478d-8784-d16e4da7814f",
      target: "9a25fe95-d613-4fb7-a5c2-313f7a7cb34b"
    },
    {
      id: "0407bfec-070e-428a-bcf1-205efab2b515",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a25fe95-d613-4fb7-a5c2-313f7a7cb34b",
      target: "7208600e-0e2d-4fa7-8e6b-d04276389976"
    },
    {
      id: "8f220d9c-3a30-4ce2-9097-333b66199617",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7208600e-0e2d-4fa7-8e6b-d04276389976",
      target: "4dd2b68e-e2be-49c7-8d76-4ecea429f753"
    },
    {
      id: "1060fdcf-e684-47db-93de-7f0559e259ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dd2b68e-e2be-49c7-8d76-4ecea429f753",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "03f921a6-18f2-48e2-b668-af17db717a22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dd2b68e-e2be-49c7-8d76-4ecea429f753",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "28c890d5-7618-4112-858d-c7e03b7f0fc2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dd2b68e-e2be-49c7-8d76-4ecea429f753",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "692a7e79-83fd-4233-822e-9fd18b067160",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "2959dce4-ddfb-4823-90b6-9fc98aa74983"
    },
    {
      id: "5ef5d05a-0585-4bc7-ad2f-13386354b5de",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "9ab030f3-750a-4f16-a272-3f9edd13b884"
    },
    {
      id: "80e59901-6210-4481-8a7c-2690ac79a86e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "ef41caf1-070f-490d-8af6-fb3afc981237"
    },
    {
      id: "a66c125f-d569-45d8-8154-6cfcb5f380f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "87f14436-2fcc-45cc-9e01-d0dabe0fe228"
    },
    {
      id: "6f3a7659-eb5a-4e30-a17a-8ef745349147",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "e075993e-e6fa-47a0-b0aa-4cc1dd5ba690"
    },
    {
      id: "ec9d461e-ff97-45f9-9ce6-61057f21a798",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "c5a738df-69ea-44bf-9a4d-b9e0047fd9b8"
    },
    {
      id: "c7dfc99e-155b-408f-b327-9728223e62df",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "312dc114-8970-4872-9ae8-2dbd44f0ebb5"
    },
    {
      id: "fa969d5f-ba92-44c6-a76d-b18871fec534",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "0274c778-28b8-475e-aa20-9cf38a7e9426"
    },
    {
      id: "d8ff6af8-7ca0-48fa-a6fc-509d84427fe5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "59fb0607-d2d2-40f5-81ff-a8ad8254eadc"
    },
    {
      id: "f5b758fd-4708-4740-a8ef-93d32f696aac",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "aa68c170-638a-411b-b550-eae6381f816d"
    },
    {
      id: "3105cb53-a8cd-4ec2-bc54-04b3121ec534",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f651673-cd7b-48b1-8aac-3dda13dde63b",
      target: "73d065ec-b2a2-4b51-b830-f548cf113290"
    },
    {
      id: "6348c6cf-5525-4ec0-a8e8-b34abbe1bc55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5a738df-69ea-44bf-9a4d-b9e0047fd9b8",
      target: "d48eed1e-7f94-4fb5-97ad-32c0e2d79110"
    },
    {
      id: "6446c63b-66a5-4ab6-b298-8f13e4ecca6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef41caf1-070f-490d-8af6-fb3afc981237",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "ab83e8ce-0ef6-4c8e-a2a1-5c16c2372c28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ab030f3-750a-4f16-a272-3f9edd13b884",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "77b28ad3-48bb-43f6-90c0-3d237fc819e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0274c778-28b8-475e-aa20-9cf38a7e9426",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "1e8cedc0-6e9c-4014-ab0d-b267c4785cfc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e075993e-e6fa-47a0-b0aa-4cc1dd5ba690",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "42b1f24f-97e7-4aed-ada5-9259591bd6e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59fb0607-d2d2-40f5-81ff-a8ad8254eadc",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "563eca73-1bef-452a-9110-50e13315ad42",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aa68c170-638a-411b-b550-eae6381f816d",
      target: "ad0edfb7-03b7-4c07-9704-332acd6d612c"
    },
    {
      id: "b78c4885-8621-48e6-b04e-5329ed10c03f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa68c170-638a-411b-b550-eae6381f816d",
      target: "86b69653-a985-4a89-89b3-dea26bfa0490"
    },
    {
      id: "619705d5-e914-407d-8b1d-100b1aa7fb78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad0edfb7-03b7-4c07-9704-332acd6d612c",
      target: "d67155f8-5ebf-4c68-966c-908eb9747efa"
    },
    {
      id: "dc4ab42c-dbf4-4df5-88a0-b10e67f6ae15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86b69653-a985-4a89-89b3-dea26bfa0490",
      target: "d67155f8-5ebf-4c68-966c-908eb9747efa"
    },
    {
      id: "e3cdbc23-dcd1-420a-8bcb-c061cab4bba7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "67dad360-3ab1-4ac5-9354-cac19d849941"
    },
    {
      id: "24630ad1-8fcb-400c-a1e1-c060face0d5a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "5da618bd-dca9-404c-9bfa-3b7c3c5a0839"
    },
    {
      id: "795d304a-aa29-4c60-9bfa-3206820e4007",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "531958eb-590d-4be5-9f25-a31225006c24"
    },
    {
      id: "478c7865-78c3-417e-adb6-8382e09b8187",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "3dc533c2-433d-438a-81d8-00d099732cec",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "09c4286b-b6ce-454f-94cf-ab9f37922100"
    },
    {
      id: "f0ddae21-e51f-4764-9851-d45a79fa244e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "0d5f5bc7-bee5-4b93-b5ff-00f8e1fd515f"
    },
    {
      id: "15ebd577-5190-436e-839d-e4c03ef0ef26",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "a072cf4e-9c3d-489d-94c1-4c49e91a4115"
    },
    {
      id: "a48f0dad-a2a2-4389-8a54-0bb1d5ddc773",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "d48eed1e-7f94-4fb5-97ad-32c0e2d79110"
    },
    {
      id: "0c49d724-76e5-4bdd-87c5-834f0e09ef5d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d67155f8-5ebf-4c68-966c-908eb9747efa",
      target: "bba1d552-5c49-489f-b82e-5bc0942098bc"
    },
    {
      id: "ad8e4599-a2d3-4b1c-8776-2e663a77999b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "67dad360-3ab1-4ac5-9354-cac19d849941"
    },
    {
      id: "c69e0b36-1973-491b-be69-e2ab9ee6d9fd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "a072cf4e-9c3d-489d-94c1-4c49e91a4115"
    },
    {
      id: "2c84a343-a682-4f47-b224-6c50250d66ae",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "09c4286b-b6ce-454f-94cf-ab9f37922100"
    },
    {
      id: "fc97e404-cc29-4d5a-927d-26af75f4421a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "5da618bd-dca9-404c-9bfa-3b7c3c5a0839"
    },
    {
      id: "397d8dbe-1e92-4f76-b7c0-57415acb07b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "cd9cfcde-9123-4ee8-a7d0-2fe9db2937b0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "605cdf06-8d1e-41b4-b20f-86f6d7e4d916"
    },
    {
      id: "d6688a04-8954-4dfb-94f2-66d411c5dca8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "0d5f5bc7-bee5-4b93-b5ff-00f8e1fd515f"
    },
    {
      id: "d0b263a9-f876-450a-8932-af4240cb7372",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "bba1d552-5c49-489f-b82e-5bc0942098bc"
    },
    {
      id: "dbceac5e-f0b9-4d5d-9cc4-da313f0d1c17",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "531958eb-590d-4be5-9f25-a31225006c24",
      target: "d48eed1e-7f94-4fb5-97ad-32c0e2d79110"
    },
    {
      id: "b4f06237-3fa2-4db3-a067-5567798a4b5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d48eed1e-7f94-4fb5-97ad-32c0e2d79110",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "626dd4f2-feba-46f9-bcfa-67a6ec69df83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bba1d552-5c49-489f-b82e-5bc0942098bc",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "36db1b20-f52b-4d0a-a108-08596bac622c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5da618bd-dca9-404c-9bfa-3b7c3c5a0839",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "2f1975c3-1490-4499-84d4-b889c6c07a7c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a072cf4e-9c3d-489d-94c1-4c49e91a4115",
      target: "09c4286b-b6ce-454f-94cf-ab9f37922100"
    },
    {
      id: "4684d216-0c7c-4922-8532-ac7b119e58b7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a072cf4e-9c3d-489d-94c1-4c49e91a4115",
      target: "67dad360-3ab1-4ac5-9354-cac19d849941"
    },
    {
      id: "934631ae-ac32-4814-9a8a-d33b18059a1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67dad360-3ab1-4ac5-9354-cac19d849941",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "c863f56c-6f5b-44f8-8758-d260b70c0d5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67dad360-3ab1-4ac5-9354-cac19d849941",
      target: "605cdf06-8d1e-41b4-b20f-86f6d7e4d916"
    },
    {
      id: "5c6c1b90-979a-44e3-baf6-a9ccfe3620d6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "09c4286b-b6ce-454f-94cf-ab9f37922100",
      target: "0d5f5bc7-bee5-4b93-b5ff-00f8e1fd515f"
    },
    {
      id: "c441b35e-e59b-4f17-8e71-88f6f7d23a1a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "09c4286b-b6ce-454f-94cf-ab9f37922100",
      target: "605cdf06-8d1e-41b4-b20f-86f6d7e4d916"
    },
    {
      id: "03362d65-9eb0-45a6-b480-a7148123eaf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d5f5bc7-bee5-4b93-b5ff-00f8e1fd515f",
      target: "ef9f749c-a8f7-46eb-89ec-cc4e30665005"
    },
    {
      id: "024cdb84-7cf3-421c-8b7d-4b7181886ce0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cdf06-8d1e-41b4-b20f-86f6d7e4d916",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "d0b41fe0-cea3-4b86-8507-6b248c8eeced",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef9f749c-a8f7-46eb-89ec-cc4e30665005",
      target: "bffb2894-d9a1-4574-a38a-990de512a65d"
    },
    {
      id: "6f765cbf-904a-47a3-8f94-dbe40f5f5930",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef9f749c-a8f7-46eb-89ec-cc4e30665005",
      target: "ad44e771-dd21-4b11-9790-99bd8efe45d1"
    },
    {
      id: "fc8f19b3-8949-4c72-99ca-e963edacef07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad44e771-dd21-4b11-9790-99bd8efe45d1",
      target: "a217ea65-7f40-4457-9273-2743836d8d79"
    },
    {
      id: "78cc59a4-fc1a-4c46-b076-181da4fcb0c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad44e771-dd21-4b11-9790-99bd8efe45d1",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "10ca757e-dbb6-4bb4-a62b-1420b3630953",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bffb2894-d9a1-4574-a38a-990de512a65d",
      target: "75feb546-72f5-485e-9123-df0822ccf857"
    },
    {
      id: "08adbc44-9570-4043-ad3d-d32d57bb35cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bffb2894-d9a1-4574-a38a-990de512a65d",
      target: "781af709-acd5-4c71-94b0-6d76e653cda3"
    },
    {
      id: "cb31b03e-138e-4c3d-8fc2-ecfb2066e4df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bffb2894-d9a1-4574-a38a-990de512a65d",
      target: "80402b65-4269-4a8f-803a-3a0418c0fcbe"
    },
    {
      id: "d83b79cc-8934-4d07-bb71-2eccce007590",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80402b65-4269-4a8f-803a-3a0418c0fcbe",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "fa1b87f2-c557-44bf-9de1-bf1a74ad41b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "781af709-acd5-4c71-94b0-6d76e653cda3",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "23e5caab-3504-402d-88ea-f67ace804102",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75feb546-72f5-485e-9123-df0822ccf857",
      target: "a0833bca-df6a-49f0-b1e5-7db407efd172"
    },
    {
      id: "ebcbda47-00da-46bc-9aaf-086a86d8cb9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a217ea65-7f40-4457-9273-2743836d8d79",
      target: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5"
    },
    {
      id: "e542327b-86cb-4387-8036-90f067fa45d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0833bca-df6a-49f0-b1e5-7db407efd172",
      target: "33d830eb-a5d3-47f0-acf5-74bab99d10e4"
    },
    {
      id: "99592d90-f96d-4c5c-a7c2-f36869b4bd83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0833bca-df6a-49f0-b1e5-7db407efd172",
      target: "dc52f318-8847-4a84-be29-b5ec11e157fa"
    },
    {
      id: "645c04b8-4ffe-4a36-b765-3da6b866bbca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      target: "94ecbbac-8ec5-46f3-885d-1f25be5a2ce7"
    },
    {
      id: "8543df39-21e2-4422-994c-a456076a11d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      target: "b18d0f25-0e11-4cf1-9603-2511f8a95b2e"
    },
    {
      id: "97b08496-0a0a-4f0e-97b9-86ad2deabd3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      target: "61bdc405-056a-4272-8171-8143f5faa4f4"
    },
    {
      id: "017f7b88-d4b7-47c2-a2ed-b50778fb0cb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      target: "8bda10f8-ad88-4d6d-8ac1-bee43326318e"
    },
    {
      id: "30ba6578-9c0d-4819-a609-88c2a8797ca0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc52f318-8847-4a84-be29-b5ec11e157fa",
      target: "a00a3642-05ac-49ff-bf1f-832c418fa0b6"
    },
    {
      id: "528b2665-33df-43c7-b060-1d8cdbafe3e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33d830eb-a5d3-47f0-acf5-74bab99d10e4",
      target: "a00a3642-05ac-49ff-bf1f-832c418fa0b6"
    },
    {
      id: "fec470e6-8ef1-4bac-98a6-542a0ef4c951",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33d830eb-a5d3-47f0-acf5-74bab99d10e4",
      target: "8bda10f8-ad88-4d6d-8ac1-bee43326318e"
    },
    {
      id: "67cfa1e0-676b-44ba-9fb5-3c7a091d8a51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33d830eb-a5d3-47f0-acf5-74bab99d10e4",
      target: "94ecbbac-8ec5-46f3-885d-1f25be5a2ce7"
    },
    {
      id: "deaf7fcd-58c8-4e36-b7f0-f083f85a9560",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33d830eb-a5d3-47f0-acf5-74bab99d10e4",
      target: "b18d0f25-0e11-4cf1-9603-2511f8a95b2e"
    },
    {
      id: "afbf4cf7-e165-46b7-93ed-affddf3cd717",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61bdc405-056a-4272-8171-8143f5faa4f4",
      target: "3a811488-a6fd-4147-bcb0-45f64ab043e7"
    },
    {
      id: "350cda6d-d108-4ffa-bd77-3aa82fc262db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94ecbbac-8ec5-46f3-885d-1f25be5a2ce7",
      target: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4"
    },
    {
      id: "f2725a1d-d762-4faf-974f-01fb41d3a7f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a00a3642-05ac-49ff-bf1f-832c418fa0b6",
      target: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4"
    },
    {
      id: "46aeb199-3b90-4e64-8759-ef60c1abc5a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bda10f8-ad88-4d6d-8ac1-bee43326318e",
      target: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4"
    },
    {
      id: "5a2ce340-817f-4c2e-8761-de49c411cf93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a811488-a6fd-4147-bcb0-45f64ab043e7",
      target: "cf81abd6-5e91-4360-849d-fa9ececa96a1"
    },
    {
      id: "45525a5d-c606-4bbe-8ecc-1df78dc2e1c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b18d0f25-0e11-4cf1-9603-2511f8a95b2e",
      target: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4"
    },
    {
      id: "b01fb87e-eb46-41a4-8747-40a3ca3967fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf81abd6-5e91-4360-849d-fa9ececa96a1",
      target: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea"
    },
    {
      id: "47fe544c-d642-4b1f-bb64-63f1082c42d8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4",
      target: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea"
    },
    {
      id: "b7503a2c-b3e3-4d1d-a48e-7661fc7e7633",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4",
      target: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5"
    },
    {
      id: "ab7c2121-30b0-4228-aa03-df33902b2dd8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1f00907f-dd07-4d3f-a004-e0f7229e5ed4",
      target: "31d5c2f3-2b41-4def-9286-727a73af9d42"
    },
    {
      id: "4f405dd7-0bab-429d-8502-cfc5f66e0e22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31d5c2f3-2b41-4def-9286-727a73af9d42",
      target: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea"
    },
    {
      id: "ff33cbfd-fb35-456e-b6de-8af5699d3a11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7595d80a-2ae3-4f3a-8503-e0047ffe9aea",
      target: "aa209eb0-d113-4c31-95a3-4d93162c7a48"
    },
    {
      id: "8d5ac18e-abea-4ab8-8da1-5e29b79821cc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa209eb0-d113-4c31-95a3-4d93162c7a48",
      target: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5"
    },
    {
      id: "1651f92a-6cd4-4b27-99cc-777966a46688",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aa209eb0-d113-4c31-95a3-4d93162c7a48",
      target: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5"
    },
    {
      id: "65dc9502-9db9-4ea6-97d1-8a197f0e8ff5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f79bea1-dce7-4a01-a7f5-42b96fa7b1e5",
      target: "50ece6a7-a3be-472a-af0b-302205a22925"
    },
    {
      id: "172e9f7d-4e5e-40ce-92a6-215e5c719fac",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "50ece6a7-a3be-472a-af0b-302205a22925",
      target: "382038a3-5959-4356-bdb8-9f0ccb256552"
    },
    {
      id: "701b8376-34d7-477c-8588-c5f8345eab63",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "50ece6a7-a3be-472a-af0b-302205a22925",
      target: "382038a3-5959-4356-bdb8-9f0ccb256552"
    },
    {
      id: "0b27c298-ebe4-4602-b561-7a6010897961",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "382038a3-5959-4356-bdb8-9f0ccb256552",
      target: "d3590b0a-3223-4217-be38-88869cfa4fd2"
    },
    {
      id: "0caa006f-dfda-4496-8e89-6f91f546c086",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3590b0a-3223-4217-be38-88869cfa4fd2",
      target: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24"
    },
    {
      id: "ba67252e-7b8e-4463-b71b-d9969df082c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3590b0a-3223-4217-be38-88869cfa4fd2",
      target: "1332df75-3750-4cb1-bb9a-f0ed61683248"
    },
    {
      id: "022f77ef-f630-4d2d-a66e-3671f7341c11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1332df75-3750-4cb1-bb9a-f0ed61683248",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "a0ada141-5652-4b78-b898-4ebfbd339232",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1332df75-3750-4cb1-bb9a-f0ed61683248",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "21a140a9-1162-410a-8f29-887b968f1a87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f06e8202-a6e3-4d75-841c-ebac8691367d",
      target: "245368be-1a45-40d2-9e35-92b4cfc72553"
    },
    {
      id: "ddb10f31-2818-4b23-bf8c-62189fea9e6f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "245368be-1a45-40d2-9e35-92b4cfc72553",
      target: "427155f2-1f60-4004-9a69-be93e1f75748"
    },
    {
      id: "85b9578c-2f3f-46d2-b469-7f36a5245031",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "427155f2-1f60-4004-9a69-be93e1f75748",
      target: "01d66e6e-b425-49a4-9846-0b249e4cbaa7"
    },
    {
      id: "293e62bf-980a-4fd7-9b1b-f8c571ac3ea5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01d66e6e-b425-49a4-9846-0b249e4cbaa7",
      target: "dbf81c80-5ba4-4080-9975-73995bc6fe50"
    },
    {
      id: "bbffad61-fd5a-4dbc-80ca-4166fe38bbab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbf81c80-5ba4-4080-9975-73995bc6fe50",
      target: "f6715ee0-5b75-4ccd-823f-44d508bd40a1"
    },
    {
      id: "80a9d736-e4d2-4e02-a370-b5b5e284c3da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6715ee0-5b75-4ccd-823f-44d508bd40a1",
      target: "7c78cffd-2045-43ec-9f45-0c3c78fa6768"
    },
    {
      id: "23ff5b42-c4cd-42e9-a56d-88422cd54488",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c78cffd-2045-43ec-9f45-0c3c78fa6768",
      target: "77b89942-f033-4397-aff5-5e8aa5f6edff"
    },
    {
      id: "349ea864-0ac0-42c7-9781-fdff0617da87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "0606019b-3764-4968-9bb3-93f3a7c0d1ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "ca9f0a05-e1e1-4f0d-971e-64799366c637",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "75c55382-2d4e-4305-9a96-3747731aebc9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "90b6575b-4425-4532-88a1-edfa894e9833",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1"
    },
    {
      id: "c2ef4956-72d2-4485-bfed-ade9b59aa6a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b89942-f033-4397-aff5-5e8aa5f6edff",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "2017822d-0c44-445f-90e8-40c859653154",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "40625718-f733-4d7d-b680-1e6049d28304",
      target: "555318ca-ffb4-45f8-9d6c-9183f6a579cf"
    },
    {
      id: "c24b2912-d81e-4fd7-bed7-4fd604d54f6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "555318ca-ffb4-45f8-9d6c-9183f6a579cf",
      target: "d985b530-22fa-4af0-8aa7-184af455bfa8"
    },
    {
      id: "1e1a034b-6722-4dad-9f80-431bac94c775",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d985b530-22fa-4af0-8aa7-184af455bfa8",
      target: "136bfa09-240b-4afb-b99f-95a778f89769"
    },
    {
      id: "caa1b15b-a09e-4165-a894-cd1ae50b9f97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "136bfa09-240b-4afb-b99f-95a778f89769",
      target: "f7d2e4ca-fca3-4698-a92d-e7c59e40c80a"
    },
    {
      id: "ee2fbc94-2261-459d-bf3c-14ee9302d36c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f7d2e4ca-fca3-4698-a92d-e7c59e40c80a",
      target: "fb23b602-223b-43fd-a506-50b38bbe1ec8"
    },
    {
      id: "d3ffc565-410b-4491-a575-b2f619dade60",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f7d2e4ca-fca3-4698-a92d-e7c59e40c80a",
      target: "c5d5e20a-4789-425d-b6f2-f39accd58867"
    },
    {
      id: "1610ebf2-c28b-4279-b0d0-8ceea6322bec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb23b602-223b-43fd-a506-50b38bbe1ec8",
      target: "c5d5e20a-4789-425d-b6f2-f39accd58867"
    },
    {
      id: "48562cee-8596-4997-8c1b-f40a2727245c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5d5e20a-4789-425d-b6f2-f39accd58867",
      target: "e2fa4b2a-9685-4bcb-8036-9dc03a08509e"
    },
    {
      id: "c637b9a2-d2e0-4dcd-acef-50ff378703be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2fa4b2a-9685-4bcb-8036-9dc03a08509e",
      target: "2f6d1eec-2adf-42ae-a428-620f99fcec6a"
    },
    {
      id: "eca0d175-bede-4c22-84a8-bd13dddd14e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "a8629841-a5fb-4a61-8457-123f4db20005",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "3b34819f-3129-41c4-b811-13219cb258da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "fb3b773d-6b3f-4a38-99a0-d2d6a90bd42c"
    },
    {
      id: "c6e86018-502d-40d6-93cb-d165e3ea5d79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "75e9a60e-7310-45db-81f5-9a0147e31877",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "6c888054-a39f-48be-b10d-2134b4a1e67c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f6d1eec-2adf-42ae-a428-620f99fcec6a",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "6ed9372f-3927-45fe-a0a3-b0527c250e1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "59fb0607-d2d2-40f5-81ff-a8ad8254eadc"
    },
    {
      id: "2b6cb648-bc15-4203-924f-0631f97a9528",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "aa68c170-638a-411b-b550-eae6381f816d"
    },
    {
      id: "08166b37-9f3e-4efa-97bf-d883b52af01d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "ef41caf1-070f-490d-8af6-fb3afc981237"
    },
    {
      id: "b7a1c05a-f805-4b30-bc5c-95dea6576921",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "c5a738df-69ea-44bf-9a4d-b9e0047fd9b8"
    },
    {
      id: "957651e0-a70d-4433-9406-992d1fa0288f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "38252a54-135c-4c3e-83e6-74241779b223"
    },
    {
      id: "c891a7c0-2d32-4eeb-9bd1-5893349c5304",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "e075993e-e6fa-47a0-b0aa-4cc1dd5ba690"
    },
    {
      id: "766aa982-5196-4a96-82d3-10a27fb59e7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "9ab030f3-750a-4f16-a272-3f9edd13b884"
    },
    {
      id: "d4facba3-8295-4572-b58a-44e78b5f0156",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2959dce4-ddfb-4823-90b6-9fc98aa74983",
      target: "0274c778-28b8-475e-aa20-9cf38a7e9426"
    },
    {
      id: "472752bd-41fc-4c6a-b237-3faa25f4c05b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38252a54-135c-4c3e-83e6-74241779b223",
      target: "e0343347-e2ef-4132-8bc8-38a3ec8723e2"
    },
    {
      id: "0893edb8-fe11-45be-a112-80b1872d283e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0343347-e2ef-4132-8bc8-38a3ec8723e2",
      target: "d2222065-d580-47e5-a083-8658010b613d"
    },
    {
      id: "9804d445-540f-496e-a2e0-014fa8a8c72a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0343347-e2ef-4132-8bc8-38a3ec8723e2",
      target: "1123851f-8062-4ec1-8099-548b04aca54a"
    },
    {
      id: "f6547410-5ced-47f2-9447-c5c1e767d4ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2222065-d580-47e5-a083-8658010b613d",
      target: "73d065ec-b2a2-4b51-b830-f548cf113290"
    },
    {
      id: "7f7ea2b7-3f98-4615-95fa-7745da47bda1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d065ec-b2a2-4b51-b830-f548cf113290",
      target: "c39ef87d-806e-489f-8e37-34382dc62059"
    },
    {
      id: "108997f3-025f-4a02-8e14-6584c28ade16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d065ec-b2a2-4b51-b830-f548cf113290",
      target: "1332df75-3750-4cb1-bb9a-f0ed61683248"
    },
    {
      id: "b80f0c44-99e4-4c91-ab77-1babe9c027fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d065ec-b2a2-4b51-b830-f548cf113290",
      target: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24"
    },
    {
      id: "b740d6cf-9e19-45dc-82be-130971fc6f79",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c39ef87d-806e-489f-8e37-34382dc62059",
      target: "40625718-f733-4d7d-b680-1e6049d28304"
    },
    {
      id: "28b5ee41-d50d-4402-b52e-3e2db8b609ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c39ef87d-806e-489f-8e37-34382dc62059",
      target: "e0d10e3c-18b7-4dbc-a003-9dfca534f4de"
    },
    {
      id: "560ba332-ae7b-4c6f-b864-17f970725031",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c39ef87d-806e-489f-8e37-34382dc62059",
      target: "40625718-f733-4d7d-b680-1e6049d28304"
    },
    {
      id: "0edf4a51-cb72-4f77-b3e6-01954d61d439",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c39ef87d-806e-489f-8e37-34382dc62059",
      target: "f06e8202-a6e3-4d75-841c-ebac8691367d"
    },
    {
      id: "1c44fd9b-bb8a-42b2-ba87-68a66a369e7c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c39ef87d-806e-489f-8e37-34382dc62059",
      target: "f06e8202-a6e3-4d75-841c-ebac8691367d"
    },
    {
      id: "6592fcba-52ed-4efa-9b99-33633b932598",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0d10e3c-18b7-4dbc-a003-9dfca534f4de",
      target: "60f148c4-542d-4240-b597-482ec3840025"
    },
    {
      id: "090d8701-623e-4476-b08f-7a72563242d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60f148c4-542d-4240-b597-482ec3840025",
      target: "aebe8f53-4f40-46d5-bb10-9f8e0da59b1c"
    },
    {
      id: "f757dfaa-d3e7-42ba-9f9f-8b0666063671",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aebe8f53-4f40-46d5-bb10-9f8e0da59b1c",
      target: "45284d72-12f6-467b-8c15-cd1f91072d86"
    },
    {
      id: "78342e5c-7ec1-42bf-8476-7153963a4435",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45284d72-12f6-467b-8c15-cd1f91072d86",
      target: "30c2d9aa-2b2a-49b2-95e0-75b95b845202"
    },
    {
      id: "d78d30b8-1959-4045-acbe-c6651849c75f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30c2d9aa-2b2a-49b2-95e0-75b95b845202",
      target: "1de65947-ffaf-40f2-b078-4b50f9e89520"
    },
    {
      id: "70607560-9a25-485b-bdeb-223feab2ecf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1de65947-ffaf-40f2-b078-4b50f9e89520",
      target: "4da7e46e-b600-4b9a-9700-dd0e4edecae4"
    },
    {
      id: "c215b852-9295-4a4a-ac87-296e2a4b0d7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "9f6a5b77-9c53-44d1-b06c-c967d1351d04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "d0ba68b2-9bd2-4f85-a6d6-014d132ece0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "0f3faa89-ec98-4828-ab3b-a038884892e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "1f6563a5-97ea-437c-967f-249e736cf4f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7e46e-b600-4b9a-9700-dd0e4edecae4",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "c8864f8e-ddd5-458e-b1fe-95ff233c04b0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "21a7d107-4b36-4a1d-8809-18a4e6f812fe",
      target: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d"
    },
    {
      id: "0aede85e-99c9-44fb-8cf9-1253dcea2db6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0f964bab-830e-4bb2-88c8-cdbecc261450",
      target: "aa71d951-ed8c-41b4-9322-401064634cc6"
    },
    {
      id: "d8944f32-9a96-4b7d-9913-fdf693e27041",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bdab29e5-307d-4e06-a3e2-ae6bd26fac08",
      target: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a"
    },
    {
      id: "2abc393a-cf3a-4e07-9a8b-0afdd54b672f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7a92eae3-2638-416d-89b4-ab1f3f50dcb0",
      target: "b36d3e4e-d14d-4d7c-bd06-37af8e07a714"
    },
    {
      id: "217d32ff-7015-480d-a376-430b1f02ee41",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d13d1ef-4a25-43f0-a2d3-04d201b94a7d",
      target: "dbecec67-0211-4957-baa4-5fbc0d029363"
    },
    {
      id: "4e4d0d6d-2c16-432f-8558-51ef615fb0be",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d13d1ef-4a25-43f0-a2d3-04d201b94a7d",
      target: "3be33cd4-0000-4dcf-b947-833b127dbccf"
    },
    {
      id: "557d251f-5d57-4dd3-9603-77e93c7829a7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4edb0608-f719-4afb-a93a-30fe1ccd5592",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "f40d2774-0e7b-4d7e-b69b-b7e18488161a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4edb0608-f719-4afb-a93a-30fe1ccd5592",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "3031a03e-c805-4c3e-a553-d90d9cefc12b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a"
    },
    {
      id: "87a09656-db00-4e95-98c8-880047e1c06e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a"
    },
    {
      id: "47d1c9ef-4ffe-4256-bf5b-3473e5c652fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "67b9a589-bf9a-46d6-bff8-ee11d8f70665"
    },
    {
      id: "500357ff-5e75-4047-83cf-3a83443554fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "66f20d17-585b-4af9-aedb-e01009b9a088"
    },
    {
      id: "49e44aa5-4fb4-4c5d-9ea3-f3eb6696cfa8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "4a130107-010b-4615-9c6e-fe49ed9d70c8"
    },
    {
      id: "b53c0e6e-4f7d-4b2a-90e3-aa6aa78b7027",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "784e3f39-3786-45d6-a4ba-3ca93a358713"
    },
    {
      id: "7615fdbd-4551-4981-975f-04b1a66ce9d9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "4a130107-010b-4615-9c6e-fe49ed9d70c8"
    },
    {
      id: "87a9705d-205d-4e2f-944a-4637673975db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "87f14436-2fcc-45cc-9e01-d0dabe0fe228"
    },
    {
      id: "8241b536-bfef-49f7-96e3-952d7e00937f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "784e3f39-3786-45d6-a4ba-3ca93a358713"
    },
    {
      id: "b3d720b0-726f-440b-8a88-5b64045ccf0a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b9c4468-eb61-43fb-9126-d6bdc80e6065",
      target: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468"
    },
    {
      id: "265b3aea-0cb8-4c60-a863-a330faa32961",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4a130107-010b-4615-9c6e-fe49ed9d70c8",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "c10236cd-64f9-464b-84c5-f005dd6715da",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4a130107-010b-4615-9c6e-fe49ed9d70c8",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "41c333d2-34c2-4451-91bb-90e909d8532d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a130107-010b-4615-9c6e-fe49ed9d70c8",
      target: "abd622c8-97bd-48f6-a36d-9a080507f82d"
    },
    {
      id: "3ae524c3-79a5-408e-b8a5-40c4766a981f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "bde97e39-54e9-4dff-9937-d312316ed52b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a",
      target: "abd622c8-97bd-48f6-a36d-9a080507f82d"
    },
    {
      id: "ce2a16eb-60a3-4a0f-9bd6-d659675fc572",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8d7ba67a-496b-4f0d-a288-71efa6b7f22a",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "250efe90-f7de-4bb8-80bf-7c99632f55ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "784e3f39-3786-45d6-a4ba-3ca93a358713",
      target: "abd622c8-97bd-48f6-a36d-9a080507f82d"
    },
    {
      id: "2f9eed51-3555-4e2c-a90e-ce9f8a1796a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "784e3f39-3786-45d6-a4ba-3ca93a358713",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "e2a417b9-b289-4204-9e67-45bbd84359a1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "784e3f39-3786-45d6-a4ba-3ca93a358713",
      target: "394d882e-1e6d-49d7-a8fb-6026f159fb2e"
    },
    {
      id: "b56a80d1-fd56-4017-acff-b0cc5522ee7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "394d882e-1e6d-49d7-a8fb-6026f159fb2e",
      target: "f496dec9-10cd-4871-a202-a0843dd883f8"
    },
    {
      id: "314c7b31-a00c-4675-8c84-58ac0abafcca",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "394d882e-1e6d-49d7-a8fb-6026f159fb2e",
      target: "da24255a-bc70-4d21-9e35-7a8c48eddcd9"
    },
    {
      id: "fedbe79a-73f7-42e2-94b5-be729db90a36",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "394d882e-1e6d-49d7-a8fb-6026f159fb2e",
      target: "def39e4e-f750-4fdc-bd38-039a1def91e6"
    },
    {
      id: "1c8ab712-73e1-4624-a2a7-df406be7d99b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "394d882e-1e6d-49d7-a8fb-6026f159fb2e",
      target: "f5524dd2-24a8-45da-ba1e-ecc6b0f0619b"
    },
    {
      id: "a663b7c6-ddd8-4fc1-8821-d6f275792dfa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da24255a-bc70-4d21-9e35-7a8c48eddcd9",
      target: "f496dec9-10cd-4871-a202-a0843dd883f8"
    },
    {
      id: "019c2cf1-4320-4aeb-b654-ab9250c74489",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5524dd2-24a8-45da-ba1e-ecc6b0f0619b",
      target: "f496dec9-10cd-4871-a202-a0843dd883f8"
    },
    {
      id: "b0402678-c27a-4083-9de7-7283d6b6652f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "def39e4e-f750-4fdc-bd38-039a1def91e6",
      target: "f496dec9-10cd-4871-a202-a0843dd883f8"
    },
    {
      id: "6ada1e0d-857c-425c-8ea0-9c75896c9c87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f496dec9-10cd-4871-a202-a0843dd883f8",
      target: "94a23c5d-d8e0-4463-a045-2fefe18288f7"
    },
    {
      id: "b711918e-60e0-45bb-b16c-109e1f570950",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f496dec9-10cd-4871-a202-a0843dd883f8",
      target: "d919a8af-a1c6-4060-98f3-7692faa4fe61"
    },
    {
      id: "d8531281-b370-41dd-9097-8ad7cb211cc4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d919a8af-a1c6-4060-98f3-7692faa4fe61",
      target: "81123ef1-f56a-48b6-b091-fc65ba386b38"
    },
    {
      id: "84f35648-7820-4cf1-92f6-b008612d458c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94a23c5d-d8e0-4463-a045-2fefe18288f7",
      target: "81123ef1-f56a-48b6-b091-fc65ba386b38"
    },
    {
      id: "d4427dcf-601e-4ba2-af08-dfe938bed4cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81123ef1-f56a-48b6-b091-fc65ba386b38",
      target: "3ac7dba0-deef-4885-b7c1-f9cf9b2a669d"
    },
    {
      id: "55e8e7f3-fade-41b8-8df7-177a58b54678",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ac7dba0-deef-4885-b7c1-f9cf9b2a669d",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "843e22f5-a443-4d65-bac0-bdb03085810e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3ac7dba0-deef-4885-b7c1-f9cf9b2a669d",
      target: "abd622c8-97bd-48f6-a36d-9a080507f82d"
    },
    {
      id: "df4bf7d9-4b99-43f2-a677-3ef69f66b6a9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce",
      target: "7a92eae3-2638-416d-89b4-ab1f3f50dcb0"
    },
    {
      id: "fe1014c7-77f9-478f-a56b-ac9b89ffeac7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce",
      target: "e00c7895-8ce4-4189-aa94-ead11b56e278"
    },
    {
      id: "65e6210f-24e5-40f2-a192-f1ed1fe35d80",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce",
      target: "3ef449ea-d160-48e6-9c6c-1f5fbedf706d"
    },
    {
      id: "6967fcdd-2f45-462f-afcf-0125719dfce2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "697eda6e-fea2-466d-9c67-b44a4f47ecf1",
      target: "450dc1a3-5efe-4cb7-a597-6adc60877d25"
    },
    {
      id: "4ee34bc4-2bb4-4dec-84eb-9df7965a549e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e00c7895-8ce4-4189-aa94-ead11b56e278",
      target: "5354ff5b-e6ce-4339-8b57-672492991239"
    },
    {
      id: "0a778374-a4d1-47bc-8319-6eb21a8a26e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e00c7895-8ce4-4189-aa94-ead11b56e278",
      target: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3"
    },
    {
      id: "7049fecb-9646-4442-ab62-482f165d696b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e00c7895-8ce4-4189-aa94-ead11b56e278",
      target: "0d13d1ef-4a25-43f0-a2d3-04d201b94a7d"
    },
    {
      id: "7e3e7ac4-05a2-4098-99f8-32f031e309ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5354ff5b-e6ce-4339-8b57-672492991239",
      target: "c62cd328-48ae-4f63-a1b5-b25c61207db6"
    },
    {
      id: "cf62875d-a323-4f3b-beb2-c2a32f13bbe5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5354ff5b-e6ce-4339-8b57-672492991239",
      target: "697eda6e-fea2-466d-9c67-b44a4f47ecf1"
    },
    {
      id: "b2a351b2-58e7-441e-a363-f69948120d1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450dc1a3-5efe-4cb7-a597-6adc60877d25",
      target: "95fff06a-c765-49fa-9cd3-5e8597b61f18"
    },
    {
      id: "4fd06a35-37a0-40da-a60e-8aac649a46f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450dc1a3-5efe-4cb7-a597-6adc60877d25",
      target: "c62cd328-48ae-4f63-a1b5-b25c61207db6"
    },
    {
      id: "2bbc6d26-9caa-4174-a62a-6ff72a053ca9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c62cd328-48ae-4f63-a1b5-b25c61207db6",
      target: "11775c5c-821e-449a-a1b5-959ed185f805"
    },
    {
      id: "d92ae335-0629-4865-b273-3752e49ebb7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c62cd328-48ae-4f63-a1b5-b25c61207db6",
      target: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3"
    },
    {
      id: "e2f767a6-a1e1-410e-bdd1-7217ca379fe4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95fff06a-c765-49fa-9cd3-5e8597b61f18",
      target: "863cba8d-56cd-42b4-8e65-2ee4696e69fa"
    },
    {
      id: "426fdb6e-e386-405a-af8d-52281d0c86ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95fff06a-c765-49fa-9cd3-5e8597b61f18",
      target: "1b2bff5a-55e7-41b1-98cd-623394979a5b"
    },
    {
      id: "061eb8f5-91f1-4fd0-8cc1-4469d66420c1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3",
      target: "3be33cd4-0000-4dcf-b947-833b127dbccf"
    },
    {
      id: "8a7d74ac-8bbc-4c8f-bd73-d4ce39a1824f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3",
      target: "827ea0dc-8cda-400a-8001-c1f65f5dcfc3"
    },
    {
      id: "abed5665-469b-4516-888e-9aac16c03d7f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1b2bff5a-55e7-41b1-98cd-623394979a5b",
      target: "33063251-efce-455a-a250-cab7d9a84c1a"
    },
    {
      id: "515ce4b9-c304-4b15-b2aa-0c86af712325",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1b2bff5a-55e7-41b1-98cd-623394979a5b",
      target: "4edb0608-f719-4afb-a93a-30fe1ccd5592"
    },
    {
      id: "e4bc9dc5-5706-43a5-95ab-6bcbd277ffbb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1b2bff5a-55e7-41b1-98cd-623394979a5b",
      target: "28e7e979-7bf1-45d1-befc-dbee0d206497"
    },
    {
      id: "b281de2d-b6d6-4a7b-b4fa-7e51e61be8a3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "863cba8d-56cd-42b4-8e65-2ee4696e69fa",
      target: "33063251-efce-455a-a250-cab7d9a84c1a"
    },
    {
      id: "32d22da5-02cb-452b-a013-d70ff6f81d34",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "863cba8d-56cd-42b4-8e65-2ee4696e69fa",
      target: "4edb0608-f719-4afb-a93a-30fe1ccd5592"
    },
    {
      id: "a3bd5349-32f1-415a-965b-22893e12b03f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "863cba8d-56cd-42b4-8e65-2ee4696e69fa",
      target: "28e7e979-7bf1-45d1-befc-dbee0d206497"
    },
    {
      id: "64633435-4013-443f-a533-b068001b2a00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3be33cd4-0000-4dcf-b947-833b127dbccf",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "e2033dda-d479-464c-833e-9f15ba56c118",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28e7e979-7bf1-45d1-befc-dbee0d206497",
      target: "33063251-efce-455a-a250-cab7d9a84c1a"
    },
    {
      id: "54cdfad5-aef0-4084-8a47-dd07815825f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33063251-efce-455a-a250-cab7d9a84c1a",
      target: "7b2b2b49-e469-44e0-97c1-fd532e029aef"
    },
    {
      id: "02387e78-f541-439c-8b32-30fd1947c8c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33063251-efce-455a-a250-cab7d9a84c1a",
      target: "4c878dc4-d252-4cfd-a46c-08269c37c510"
    },
    {
      id: "c377f19f-a7d1-4d46-93c6-98f77fbbd508",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33063251-efce-455a-a250-cab7d9a84c1a",
      target: "0ec644a3-a831-47f0-8fa9-a5662a80b501"
    },
    {
      id: "e77bb8e9-1852-4c6d-9ec9-710cb60233b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33063251-efce-455a-a250-cab7d9a84c1a",
      target: "ef078086-45cd-4944-9dac-55511cd2cdc0"
    },
    {
      id: "7b4499f2-9d94-4cff-ab13-70b86a1be917",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c878dc4-d252-4cfd-a46c-08269c37c510",
      target: "11775c5c-821e-449a-a1b5-959ed185f805"
    },
    {
      id: "fa85e623-93ec-4b2c-999a-2d37391dafe2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef078086-45cd-4944-9dac-55511cd2cdc0",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "8d7e131c-0e25-4977-8bb2-6b0c6a80d1b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b2b2b49-e469-44e0-97c1-fd532e029aef",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "dec61ca2-fa3b-4655-8705-9e73e7b5080e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11775c5c-821e-449a-a1b5-959ed185f805",
      target: "827ea0dc-8cda-400a-8001-c1f65f5dcfc3"
    },
    {
      id: "231473bf-736d-4f25-ae4b-7f76d02d3d3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ec644a3-a831-47f0-8fa9-a5662a80b501",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "51f1c5bb-88f1-46c9-b637-adcbe5141003",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "827ea0dc-8cda-400a-8001-c1f65f5dcfc3",
      target: "0ec644a3-a831-47f0-8fa9-a5662a80b501"
    },
    {
      id: "98df7aa9-d328-4adb-802a-793597481cbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e8c0791-484f-4914-9287-0377f0681b71",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "6d5e2582-0601-43b4-a64c-1a85303bf291",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e8c0791-484f-4914-9287-0377f0681b71",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "5471a68d-2a84-49a2-9f7d-9c4a8823f865",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66f20d17-585b-4af9-aedb-e01009b9a088",
      target: "c6758e12-3fb2-44b2-a5bf-ef703df2ba9f"
    },
    {
      id: "a900f0a0-d429-4008-b713-a67fad70bf0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6758e12-3fb2-44b2-a5bf-ef703df2ba9f",
      target: "3d9f0349-2201-41b3-b818-15466b464b64"
    },
    {
      id: "89b09417-3e6c-41ed-92b3-741d6eb46dfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6758e12-3fb2-44b2-a5bf-ef703df2ba9f",
      target: "4eeb88dc-df2d-404a-a0eb-1c891eb234f6"
    },
    {
      id: "e09b3dd7-bbc4-40c2-84cc-4122a1b3adef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d9f0349-2201-41b3-b818-15466b464b64",
      target: "2091270a-1d07-4366-8ed9-66b537e2de76"
    },
    {
      id: "05d11c77-b753-43c4-9623-d0ba81a07f25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4eeb88dc-df2d-404a-a0eb-1c891eb234f6",
      target: "2091270a-1d07-4366-8ed9-66b537e2de76"
    },
    {
      id: "e54a8dea-0147-497d-a267-d24ab2aa7ccf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2091270a-1d07-4366-8ed9-66b537e2de76",
      target: "d6bfe962-7f86-41ad-b9a2-539ac9c384e6"
    },
    {
      id: "ff5cc11a-28af-4c4d-bf9f-5ec3fb441173",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6bfe962-7f86-41ad-b9a2-539ac9c384e6",
      target: "44eb5560-a427-4685-a8d9-0903ab91829f"
    },
    {
      id: "3bc1ec6b-9407-4498-8270-fb38a7752228",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6bfe962-7f86-41ad-b9a2-539ac9c384e6",
      target: "4d27fb88-a53c-4d20-8bcf-25e49b8bdbd5"
    },
    {
      id: "17f809b5-af65-46ba-9834-6cbaa240be86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d27fb88-a53c-4d20-8bcf-25e49b8bdbd5",
      target: "9482bac4-f768-4970-ad63-881ee69aeb7f"
    },
    {
      id: "5bc4cc27-28b1-4900-a1d3-5ce950c28e7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44eb5560-a427-4685-a8d9-0903ab91829f",
      target: "9482bac4-f768-4970-ad63-881ee69aeb7f"
    },
    {
      id: "dd29b080-9913-4641-9fcc-f6bd426c84eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9482bac4-f768-4970-ad63-881ee69aeb7f",
      target: "ec4b4b8f-a387-4529-a886-f917de362573"
    },
    {
      id: "360ac476-1e73-4ee1-bc3d-0cfcd26614d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9482bac4-f768-4970-ad63-881ee69aeb7f",
      target: "2fa2c90a-4117-4eba-8dfc-3d2b15c3088b"
    },
    {
      id: "f5ada117-127f-402b-98aa-6afffc15498b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f4fd83ad-859b-4b50-b160-2f551ba8e129",
      target: "375e41f1-0a7b-4bee-9fc1-fe48ac5e5c08"
    },
    {
      id: "c0b7b999-a31a-41d0-93f4-2403ab5350a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec4b4b8f-a387-4529-a886-f917de362573",
      target: "375e41f1-0a7b-4bee-9fc1-fe48ac5e5c08"
    },
    {
      id: "eaa5926f-72bc-4a06-860b-bbf21a8c780f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec4b4b8f-a387-4529-a886-f917de362573",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "9b99a2fc-3635-4284-8651-08c467a9afda",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec4b4b8f-a387-4529-a886-f917de362573",
      target: "f4fd83ad-859b-4b50-b160-2f551ba8e129"
    },
    {
      id: "c4507023-3b91-422e-906b-e4b65bf2dd91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec4b4b8f-a387-4529-a886-f917de362573",
      target: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456"
    },
    {
      id: "d977f84a-a016-4067-b8a6-3a8494874de1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d41f8ad-1d39-4004-9dd5-db4f61c4d456",
      target: "375e41f1-0a7b-4bee-9fc1-fe48ac5e5c08"
    },
    {
      id: "5578ad52-a9b6-4ff5-8013-2ebae3c32187",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "375e41f1-0a7b-4bee-9fc1-fe48ac5e5c08",
      target: "be61e71d-dd82-4425-80f8-3c57f34621f1"
    },
    {
      id: "a24d8707-8dcf-4b16-b155-d52ed8166249",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      target: "94c73420-8b4d-48ab-98c0-a37d2190ed38"
    },
    {
      id: "429d9ea6-e3e5-429d-8654-f21a91de319b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      target: "123f8d50-d5a3-4c5a-925e-1f3afd393450"
    },
    {
      id: "ecaf2c0a-603f-417a-aa83-1dcdd4d5e220",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      target: "23189029-db36-4e9f-823e-9b0709dd4b92"
    },
    {
      id: "f98d5936-1a3b-4d94-b42d-3ef1dac0c3f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      target: "3ee81fdd-d51b-4c67-9cad-93187f39d1a3"
    },
    {
      id: "bf6da307-7fc8-4d4c-8c31-daf768717b7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be61e71d-dd82-4425-80f8-3c57f34621f1",
      target: "77060a70-8e8e-4639-962a-c35a4dc18f4d"
    },
    {
      id: "7e93a0a1-b604-451d-ad46-c33917b14194",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94c73420-8b4d-48ab-98c0-a37d2190ed38",
      target: "0bdaae5b-baa7-4974-a4c0-6219ba060fe7"
    },
    {
      id: "3584d527-74f2-4743-97fb-c96d7325bbe1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23189029-db36-4e9f-823e-9b0709dd4b92",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "7fb6cf06-f066-40ec-8ab9-4038efbd6a2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23189029-db36-4e9f-823e-9b0709dd4b92",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "fbf9ef6e-486d-4558-a10a-fe91b1bcb7af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bdaae5b-baa7-4974-a4c0-6219ba060fe7",
      target: "b4cc41db-c251-43e2-af75-c1eb97081db4"
    },
    {
      id: "f12579c1-a111-4e8d-86a1-d76f85f5d2ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4cc41db-c251-43e2-af75-c1eb97081db4",
      target: "cb41f056-4be4-42db-980a-4c50319cf390"
    },
    {
      id: "ff267af0-9b3a-4dd3-8c7d-84a5eea90896",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb41f056-4be4-42db-980a-4c50319cf390",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "67cb53c8-2c48-4509-8cb9-c694a4877637",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb41f056-4be4-42db-980a-4c50319cf390",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "4d98720d-3047-4030-9368-6a8d5055ea71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "abd622c8-97bd-48f6-a36d-9a080507f82d",
      target: "4fb70027-0210-4b7b-bbed-e3fee42f9358"
    },
    {
      id: "7e886aeb-6d36-4318-9239-5c342cff45ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abd622c8-97bd-48f6-a36d-9a080507f82d",
      target: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce"
    },
    {
      id: "0aa330a9-4bc5-4650-8609-cc1ead5585e7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "abd622c8-97bd-48f6-a36d-9a080507f82d",
      target: "0f964bab-830e-4bb2-88c8-cdbecc261450"
    },
    {
      id: "fce03fb1-27ce-4c07-b315-a392ba776df7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fb70027-0210-4b7b-bbed-e3fee42f9358",
      target: "2a7dbe84-71a7-40ac-9f65-43a5b8b89fce"
    },
    {
      id: "796e83fc-932f-4edc-ae42-82309a5c6aa4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fb70027-0210-4b7b-bbed-e3fee42f9358",
      target: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0"
    },
    {
      id: "47d15c0b-3f58-4718-86bd-f1ac8ee94626",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0",
      target: "9acc1cfe-ea3f-45de-ae94-09b0286da607"
    },
    {
      id: "710f1379-6326-489b-a613-5c6827ead047",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0",
      target: "bdab29e5-307d-4e06-a3e2-ae6bd26fac08"
    },
    {
      id: "06d9ef24-cfd3-46fd-a852-cd39174623cd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "937bed8e-c7d1-4f06-adb7-870cd1dc79b0",
      target: "9acc1cfe-ea3f-45de-ae94-09b0286da607"
    },
    {
      id: "df7abce3-bf5b-4ab2-9f4c-66cb4ee5fdf7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9acc1cfe-ea3f-45de-ae94-09b0286da607",
      target: "7b3732ac-c7bb-496f-bba4-9d92d4df0cbc"
    },
    {
      id: "06b7663f-2fff-4b1a-ae9f-2fdecc068344",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9acc1cfe-ea3f-45de-ae94-09b0286da607",
      target: "7b3732ac-c7bb-496f-bba4-9d92d4df0cbc"
    },
    {
      id: "a7e8baf0-f55b-438d-8b7f-c139125c16d5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7b3732ac-c7bb-496f-bba4-9d92d4df0cbc",
      target: "95fff06a-c765-49fa-9cd3-5e8597b61f18"
    },
    {
      id: "06298226-cba2-4536-ae8d-c85f733462a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b3732ac-c7bb-496f-bba4-9d92d4df0cbc",
      target: "524e098f-79f8-44dc-9074-a6a20c6527b1"
    },
    {
      id: "5e59bec3-a13e-4335-ba1a-929ea526184b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "524e098f-79f8-44dc-9074-a6a20c6527b1",
      target: "a622cbd7-8c22-4ac6-b430-5ec203d5956b"
    },
    {
      id: "15958cdf-1288-4292-96c7-2499d9bb8dfc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a622cbd7-8c22-4ac6-b430-5ec203d5956b",
      target: "3d2561bb-dde6-46f8-b7d6-703c822cf45c"
    },
    {
      id: "2b2c4fa6-c1a2-4a96-ac3b-6d8b3165f26b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d2561bb-dde6-46f8-b7d6-703c822cf45c",
      target: "485cd59e-91fe-4ef9-81de-43347ec44cda"
    },
    {
      id: "a18a0e54-a263-4b95-b4bc-25c6275731b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "485cd59e-91fe-4ef9-81de-43347ec44cda",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "381baa08-2c29-4968-916f-775858068d24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "485cd59e-91fe-4ef9-81de-43347ec44cda",
      target: "3e8c0791-484f-4914-9287-0377f0681b71"
    },
    {
      id: "1ee712a2-7814-48d1-9a1c-baaccd701c6e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      target: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f"
    },
    {
      id: "0b17d859-ea4a-43be-b067-e8670925367a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      target: "21a7d107-4b36-4a1d-8809-18a4e6f812fe"
    },
    {
      id: "f28cd088-1e3a-400f-9106-b28779b3bea8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      target: "c80a95d0-5594-4d76-bf5d-7c39d721f499"
    },
    {
      id: "2528a687-1623-4fed-aa93-d9571171bf7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      target: "87f14436-2fcc-45cc-9e01-d0dabe0fe228"
    },
    {
      id: "cb87ae6c-8f3d-4daa-b798-8d38ffa09d2f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8bcbe407-9a70-4f2c-ab55-dbcd5b80e468",
      target: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f"
    },
    {
      id: "183030a6-0fdd-4259-b854-5474417d7f9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48ef2841-c4d6-4ab5-856d-56174516e12d",
      target: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d"
    },
    {
      id: "6a556521-c299-4883-b8a3-4cd14d3d07e5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "48ef2841-c4d6-4ab5-856d-56174516e12d",
      target: "14bd6195-e9e7-4be9-9a85-f9e5781858b7"
    },
    {
      id: "4fe5a28d-7630-4b9d-9bb6-7cf0e3663a49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48ef2841-c4d6-4ab5-856d-56174516e12d",
      target: "aa71d951-ed8c-41b4-9322-401064634cc6"
    },
    {
      id: "50442b88-3f3e-4be9-a268-f34e327e882e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "48ef2841-c4d6-4ab5-856d-56174516e12d",
      target: "14bd6195-e9e7-4be9-9a85-f9e5781858b7"
    },
    {
      id: "27d86c38-2127-4319-8001-e2f5aff3e8c2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6769b16d-66d8-4b2b-afbc-63e2c90bf383",
      target: "14bd6195-e9e7-4be9-9a85-f9e5781858b7"
    },
    {
      id: "3b180a94-1db3-4390-a973-9b19e7fc11ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6769b16d-66d8-4b2b-afbc-63e2c90bf383",
      target: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d"
    },
    {
      id: "f77396ab-324f-4474-8d82-39f8dc0e3153",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6769b16d-66d8-4b2b-afbc-63e2c90bf383",
      target: "aa71d951-ed8c-41b4-9322-401064634cc6"
    },
    {
      id: "7b05acbc-2424-4a71-be53-b1c9bf8a0931",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6769b16d-66d8-4b2b-afbc-63e2c90bf383",
      target: "14bd6195-e9e7-4be9-9a85-f9e5781858b7"
    },
    {
      id: "d1f26587-c9d8-45f5-a84a-caee5e0976fd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f",
      target: "48ef2841-c4d6-4ab5-856d-56174516e12d"
    },
    {
      id: "ac7b194b-d1eb-4b77-83b9-eedad354b4e4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f",
      target: "6769b16d-66d8-4b2b-afbc-63e2c90bf383"
    },
    {
      id: "550bb66a-f8db-41a2-a53e-7333275b85ca",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f",
      target: "6769b16d-66d8-4b2b-afbc-63e2c90bf383"
    },
    {
      id: "5d2fd217-3db5-4d27-ab24-5237360c92f0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3340830f-c244-4ab5-a9a5-e3e117bd1f3f",
      target: "48ef2841-c4d6-4ab5-856d-56174516e12d"
    },
    {
      id: "7f0ca7f5-d1b2-4f8b-906b-ac868561e83a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "062f617e-f4cd-4dde-ae51-01bb700d93ad",
      target: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2"
    },
    {
      id: "ef18b689-c5a2-4f3e-9a77-2d790e29f4a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eded72c6-97b9-4111-961e-23e2e5a9d02f",
      target: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2"
    },
    {
      id: "91233345-1814-4c8b-bd84-9060c4320fb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba6ff22d-0f1a-4135-97b3-d14f6955b995",
      target: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2"
    },
    {
      id: "f7059587-bbf6-400a-acb1-1616b3774921",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "eded72c6-97b9-4111-961e-23e2e5a9d02f"
    },
    {
      id: "84c85af5-550e-45ee-a812-8e46434c45c4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "062f617e-f4cd-4dde-ae51-01bb700d93ad"
    },
    {
      id: "d61c985c-fa57-4ce0-92ae-c070a38e6544",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "ba6ff22d-0f1a-4135-97b3-d14f6955b995"
    },
    {
      id: "73c4ea6f-172c-42a0-825e-6c2c1ca42586",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2"
    },
    {
      id: "bcd2c6e7-3e2f-4cfd-9566-803bfb7144bb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "062f617e-f4cd-4dde-ae51-01bb700d93ad"
    },
    {
      id: "e9837a12-9b3e-4ea2-9a55-33984c7ee3b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "eded72c6-97b9-4111-961e-23e2e5a9d02f"
    },
    {
      id: "2dcd0935-fb0c-40b9-98d5-7ef30c16e197",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "14bd6195-e9e7-4be9-9a85-f9e5781858b7",
      target: "ba6ff22d-0f1a-4135-97b3-d14f6955b995"
    },
    {
      id: "b87b5367-ade5-4368-9ec8-161a4be89c26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b4b9a0b-ed04-4bca-8019-1978f57ef4d2",
      target: "8d7917b6-d2c7-40c1-abb9-362057f3a7ed"
    },
    {
      id: "0e4c4f07-c486-49c6-acd7-eb780797ed3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f2df1d6-8d67-4d87-8068-e8fac54a2c7d",
      target: "df15e95a-c41b-4d4a-9a26-aee0a0d2240f"
    },
    {
      id: "0ea0ebec-b1f2-4d69-b839-8849d6baa34d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d7917b6-d2c7-40c1-abb9-362057f3a7ed",
      target: "0b3995c7-15f1-4301-a795-2c3e168d2c6b"
    },
    {
      id: "8fbe816c-b397-4b26-94a5-825be5a82af8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b3995c7-15f1-4301-a795-2c3e168d2c6b",
      target: "df15e95a-c41b-4d4a-9a26-aee0a0d2240f"
    },
    {
      id: "1a42654e-2513-43d3-a551-6cf9f8faa3e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df15e95a-c41b-4d4a-9a26-aee0a0d2240f",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "487b3efc-67d4-4a20-a9fe-d54f6664f22d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "df15e95a-c41b-4d4a-9a26-aee0a0d2240f",
      target: "aa71d951-ed8c-41b4-9322-401064634cc6"
    },
    {
      id: "263a82d9-1ab4-460b-91ce-1c313284f564",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "431c4952-3318-4958-8110-7b5dfede44b6",
      target: "f0d62a9f-d597-45a7-90b4-44ab761c820b"
    },
    {
      id: "a3389263-0ae6-4e4e-80af-c903ec5eab6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "431c4952-3318-4958-8110-7b5dfede44b6",
      target: "b41cb521-532d-41d9-b985-74b4cfb32b13"
    },
    {
      id: "a38b563d-a72d-4076-adcc-e28b389fd693",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b36d3e4e-d14d-4d7c-bd06-37af8e07a714",
      target: "df988812-a62c-4468-8839-b1ffff168ac2"
    },
    {
      id: "b8001599-c662-432e-a86e-e089eae1df24",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "df988812-a62c-4468-8839-b1ffff168ac2",
      target: "927ad730-9778-4d08-85c6-fcb58e18862a"
    },
    {
      id: "7a3d7d6c-2064-4741-9a05-fc1745a541ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df988812-a62c-4468-8839-b1ffff168ac2",
      target: "77060a70-8e8e-4639-962a-c35a4dc18f4d"
    },
    {
      id: "40da28b6-a199-406f-b8aa-129d4461c31f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "df988812-a62c-4468-8839-b1ffff168ac2",
      target: "0d13d1ef-4a25-43f0-a2d3-04d201b94a7d"
    },
    {
      id: "511446e8-636a-45a0-bf2e-b563a2d4c3cd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "927ad730-9778-4d08-85c6-fcb58e18862a",
      target: "7ab0eccc-cce0-47fe-bda9-8dca285ccb6f"
    },
    {
      id: "b3292344-2857-4b9e-9e69-80c712c99683",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "927ad730-9778-4d08-85c6-fcb58e18862a",
      target: "431c4952-3318-4958-8110-7b5dfede44b6"
    },
    {
      id: "519a4454-8810-49d4-a07c-da12fb22ce75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0d62a9f-d597-45a7-90b4-44ab761c820b",
      target: "514b6680-a142-4962-b825-1ce3a0c38530"
    },
    {
      id: "2915ef16-649b-4724-86f4-14e57a8a50c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0d62a9f-d597-45a7-90b4-44ab761c820b",
      target: "7ab0eccc-cce0-47fe-bda9-8dca285ccb6f"
    },
    {
      id: "dcd5b765-fb21-46e5-bd60-4cee1bc4801d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ab0eccc-cce0-47fe-bda9-8dca285ccb6f",
      target: "8a4a3438-8ac6-4998-8089-b67abc2eac74"
    },
    {
      id: "a1d6e465-475f-449f-a71b-8de495dbda8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ab0eccc-cce0-47fe-bda9-8dca285ccb6f",
      target: "77060a70-8e8e-4639-962a-c35a4dc18f4d"
    },
    {
      id: "bb79f632-b1c0-41e9-9b97-178303ff169f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "514b6680-a142-4962-b825-1ce3a0c38530",
      target: "a8af12a2-deb2-4e1f-bf1d-3f2ad48fa7d6"
    },
    {
      id: "1d46168f-9aff-4315-ac0a-31ebfbd305b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "514b6680-a142-4962-b825-1ce3a0c38530",
      target: "d7a08e17-f8f6-4a72-9c29-3b3ec57cec52"
    },
    {
      id: "1c444bad-a1f6-4374-a570-32584ecce7ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "514b6680-a142-4962-b825-1ce3a0c38530",
      target: "7359fe81-7390-40a2-b51c-77967c923179"
    },
    {
      id: "a0a55c28-0fdf-47d7-a88e-3bcf106069de",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "77060a70-8e8e-4639-962a-c35a4dc18f4d",
      target: "dbecec67-0211-4957-baa4-5fbc0d029363"
    },
    {
      id: "7c91e2c5-9ddb-4e55-af49-55ddb8f717d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77060a70-8e8e-4639-962a-c35a4dc18f4d",
      target: "add75385-5534-43ed-8e50-b78ae61d909a"
    },
    {
      id: "aa717699-33ed-4b85-825e-cba707398300",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7359fe81-7390-40a2-b51c-77967c923179",
      target: "4edb0608-f719-4afb-a93a-30fe1ccd5592"
    },
    {
      id: "1bc537e8-fb3c-4c14-8441-086ad1c1ce79",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7359fe81-7390-40a2-b51c-77967c923179",
      target: "a8af12a2-deb2-4e1f-bf1d-3f2ad48fa7d6"
    },
    {
      id: "0ab60f86-58d5-49d5-81bf-44f55b7c529c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7359fe81-7390-40a2-b51c-77967c923179",
      target: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e"
    },
    {
      id: "b41aed3b-cd23-4e41-a135-f6d43e6b18d5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d7a08e17-f8f6-4a72-9c29-3b3ec57cec52",
      target: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e"
    },
    {
      id: "ef30b2b8-34ce-488c-a129-a2a9fe8923a0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d7a08e17-f8f6-4a72-9c29-3b3ec57cec52",
      target: "4edb0608-f719-4afb-a93a-30fe1ccd5592"
    },
    {
      id: "86c3ceb1-a6c6-4f29-a864-fd87c4cc98f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d7a08e17-f8f6-4a72-9c29-3b3ec57cec52",
      target: "a8af12a2-deb2-4e1f-bf1d-3f2ad48fa7d6"
    },
    {
      id: "2f1edd12-56d1-4c5b-8bac-b93c928c32ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8af12a2-deb2-4e1f-bf1d-3f2ad48fa7d6",
      target: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e"
    },
    {
      id: "9304175f-9898-4b87-b330-367ac4dd5890",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b41cb521-532d-41d9-b985-74b4cfb32b13",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "8c62b3e5-92bf-408f-87b9-8fbc2be8db07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbecec67-0211-4957-baa4-5fbc0d029363",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "00bf359e-d0fc-4357-b859-69ed0bd5d337",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      target: "b41cb521-532d-41d9-b985-74b4cfb32b13"
    },
    {
      id: "67df3aad-89ba-46d6-903c-9e1069aa514f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      target: "20872aa2-d7af-43f1-a3dd-a82ee57e4bfc"
    },
    {
      id: "b867e8ec-0cc5-4a21-888c-5e2b2e813d76",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      target: "5c627ef8-1f56-4f8c-840e-0b21ed447544"
    },
    {
      id: "b10fa76f-6195-44fa-8234-5d064d511bc5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      target: "90e8d5c9-7016-4e05-8700-b5a0fa75b0e2"
    },
    {
      id: "f46e4786-2f9b-48bc-bc27-41ab4171b2ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c040f6f0-5c0d-4a73-a5e8-bac3b7c4955e",
      target: "6ff70167-146a-4d1f-923e-828742b7551a"
    },
    {
      id: "b1fa4cc1-798f-48b5-8b35-a647a9e2f8eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20872aa2-d7af-43f1-a3dd-a82ee57e4bfc",
      target: "8a4a3438-8ac6-4998-8089-b67abc2eac74"
    },
    {
      id: "3a171670-5072-45fa-848f-808fa27fb80f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90e8d5c9-7016-4e05-8700-b5a0fa75b0e2",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "d3d5c122-228c-4d80-9075-2fa5e17603fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ff70167-146a-4d1f-923e-828742b7551a",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "98cb176e-c36b-4cbd-8b6a-e1fc828e5a5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a4a3438-8ac6-4998-8089-b67abc2eac74",
      target: "add75385-5534-43ed-8e50-b78ae61d909a"
    },
    {
      id: "2b3c84dc-cf4f-4c0c-896c-c15a01822245",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "add75385-5534-43ed-8e50-b78ae61d909a",
      target: "5c627ef8-1f56-4f8c-840e-0b21ed447544"
    },
    {
      id: "31470433-d6a3-445b-9c56-52b244aee959",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c627ef8-1f56-4f8c-840e-0b21ed447544",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "ab22f275-dc8c-4f9d-ac90-df7862788809",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c3f7f50-fa5d-4354-8890-58b977f64113",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "004915e3-56e9-4481-a984-e052bfbb971a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c3f7f50-fa5d-4354-8890-58b977f64113",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "69562e42-1034-443c-a439-95a4bad57bef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c80a95d0-5594-4d76-bf5d-7c39d721f499",
      target: "659cbae2-73ce-4383-b984-b48bd1a8e3f8"
    },
    {
      id: "7940b168-7307-49d1-95a3-144a3d95dc7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "659cbae2-73ce-4383-b984-b48bd1a8e3f8",
      target: "6081c9d9-8ad1-4bf1-a52c-71d03c66a501"
    },
    {
      id: "5c5e4b38-dde2-4749-ac32-7273f3e8810f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "659cbae2-73ce-4383-b984-b48bd1a8e3f8",
      target: "a4c12ef8-c502-41c6-abf8-2941c777d83e"
    },
    {
      id: "49033eb6-177d-4f08-be4c-4bad3fbffdba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6081c9d9-8ad1-4bf1-a52c-71d03c66a501",
      target: "495fa92e-2af1-4449-b96c-298a3e20e135"
    },
    {
      id: "94d608cf-0eef-4362-be1a-8a0663afeae8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4c12ef8-c502-41c6-abf8-2941c777d83e",
      target: "495fa92e-2af1-4449-b96c-298a3e20e135"
    },
    {
      id: "38281662-9065-4db7-a323-11a7b51ae270",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "495fa92e-2af1-4449-b96c-298a3e20e135",
      target: "fefac47e-ab7d-4989-973c-27002a407ce9"
    },
    {
      id: "634fd7bf-896d-4619-9342-54a9c271f0dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fefac47e-ab7d-4989-973c-27002a407ce9",
      target: "c2097344-8d59-4832-b32d-5e1bb2b8ec2d"
    },
    {
      id: "219a2c2b-11e7-4dec-8940-59fbf6a8ce00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fefac47e-ab7d-4989-973c-27002a407ce9",
      target: "f0accd47-7da3-4e9d-b4f2-1255ec47066f"
    },
    {
      id: "e357c8b3-ed43-4847-a338-17a3b6860c8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0accd47-7da3-4e9d-b4f2-1255ec47066f",
      target: "c286ea02-1b1b-4331-8456-6f924e582e78"
    },
    {
      id: "a917df3a-7588-4bfe-bbba-6eec6c90c139",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2097344-8d59-4832-b32d-5e1bb2b8ec2d",
      target: "c286ea02-1b1b-4331-8456-6f924e582e78"
    },
    {
      id: "c24785c7-3e31-4bfd-82f2-9acef1cc3c48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c286ea02-1b1b-4331-8456-6f924e582e78",
      target: "97846682-9174-4834-a904-9e98234abb5c"
    },
    {
      id: "919171dd-cee6-4a8c-8591-04debbad0e28",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "778cfbc4-154f-4404-9b73-054b2f2b9b33",
      target: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb"
    },
    {
      id: "8772d621-af06-43d1-9447-a08de75de202",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "7dbeb408-2d1b-4d37-981c-87dd06776cf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "b10b3a35-c221-41a0-a012-2ec2acb8cbdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "94e42a73-c094-42b9-bf96-cc2358fbeb81"
    },
    {
      id: "e908fc30-0425-4751-b5ec-65d0b60dd495",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb"
    },
    {
      id: "77c8644d-bbf3-4850-a3f3-b263b540a795",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "34bf07dd-cc9f-4aed-aa77-66ce165c1371",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "97846682-9174-4834-a904-9e98234abb5c",
      target: "778cfbc4-154f-4404-9b73-054b2f2b9b33"
    },
    {
      id: "ea298114-05b3-4e9c-b61b-d4ad38ecb29f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "94e42a73-c094-42b9-bf96-cc2358fbeb81",
      target: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb"
    },
    {
      id: "445b558f-7db8-4add-bf32-74b495fe14f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5eadca1d-b012-4ff3-999a-b69c5a8fd7fb",
      target: "6c24a029-8a6f-4e33-bcdc-811590af8cff"
    },
    {
      id: "bbd6bb20-ddb3-4b17-8f0f-a98b4ec3034c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c24a029-8a6f-4e33-bcdc-811590af8cff",
      target: "77060a70-8e8e-4639-962a-c35a4dc18f4d"
    },
    {
      id: "f00552eb-f784-4fa7-8348-36c9b5171012",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c24a029-8a6f-4e33-bcdc-811590af8cff",
      target: "44b8754d-eb21-48b0-8364-8e0ef42e38ab"
    },
    {
      id: "9deac169-e98e-40ca-86f8-b5a9f45c6c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c24a029-8a6f-4e33-bcdc-811590af8cff",
      target: "c7e805d0-a92b-4e82-89e5-fa872a7609dc"
    },
    {
      id: "09f519a7-770e-4068-bfe5-305f704615e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44b8754d-eb21-48b0-8364-8e0ef42e38ab",
      target: "4b7f47b0-c8b9-41da-93d4-160f9939bca6"
    },
    {
      id: "7be28548-acd9-4ae9-936a-9e966cfe2dae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7e805d0-a92b-4e82-89e5-fa872a7609dc",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "70a27abc-a19c-49a6-99c5-31084f204b2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7e805d0-a92b-4e82-89e5-fa872a7609dc",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "4d45eb28-8fec-46aa-aa33-f3c6fd76ec0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b7f47b0-c8b9-41da-93d4-160f9939bca6",
      target: "4b824c59-f5cd-4171-b76f-776a5a37398e"
    },
    {
      id: "486cc98c-062c-4749-a495-51ac9f2fb011",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b824c59-f5cd-4171-b76f-776a5a37398e",
      target: "8caa99bf-a3f0-49b4-819e-f79899f10d60"
    },
    {
      id: "5e86eed7-a329-4448-b570-e6d620f187a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8caa99bf-a3f0-49b4-819e-f79899f10d60",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "48701c5a-7f56-494a-888f-077c4694aaa8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8caa99bf-a3f0-49b4-819e-f79899f10d60",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "f7b49638-ba14-4f10-abe1-38447717e26f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aa71d951-ed8c-41b4-9322-401064634cc6",
      target: "95d9fd3b-7233-41a7-ac06-e4e1783bc252"
    },
    {
      id: "b7253f48-c638-45ec-938e-cf6407433dc3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d9fd3b-7233-41a7-ac06-e4e1783bc252",
      target: "b36d3e4e-d14d-4d7c-bd06-37af8e07a714"
    },
    {
      id: "508bdb22-7b0d-4412-91ed-b306da479b7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95d9fd3b-7233-41a7-ac06-e4e1783bc252",
      target: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a"
    },
    {
      id: "668e412d-44a1-44df-aaa4-8d2a93adfe97",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a",
      target: "a900c3e3-4d6d-4583-a9f6-1e02cb862f19"
    },
    {
      id: "d6c71ce4-d97c-4e97-bcbf-9e1e0ef59740",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87adc9e0-bb60-4b36-8f0e-f8e7944e544a",
      target: "a900c3e3-4d6d-4583-a9f6-1e02cb862f19"
    },
    {
      id: "ab779620-7288-4293-847a-37e3ec52c2a8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a900c3e3-4d6d-4583-a9f6-1e02cb862f19",
      target: "162dd7ea-4592-492c-a0e3-91e8bc0df67f"
    },
    {
      id: "336e4d1f-8176-4f59-af2b-d51ed3c431d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a900c3e3-4d6d-4583-a9f6-1e02cb862f19",
      target: "162dd7ea-4592-492c-a0e3-91e8bc0df67f"
    },
    {
      id: "e7fc6779-9e31-42de-b6d1-9de7338c9dce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "162dd7ea-4592-492c-a0e3-91e8bc0df67f",
      target: "9c368871-a61f-466d-86b1-18d21734512f"
    },
    {
      id: "4cefb128-7b81-4a31-8457-1a90ebbc1707",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "162dd7ea-4592-492c-a0e3-91e8bc0df67f",
      target: "514b6680-a142-4962-b825-1ce3a0c38530"
    },
    {
      id: "c3be025d-d4ae-4496-aee8-b752063ca3f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c368871-a61f-466d-86b1-18d21734512f",
      target: "1450b882-7a9c-49ed-94b5-2e53182107c6"
    },
    {
      id: "11911c22-5acf-48f2-a76e-efddff0b705c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1450b882-7a9c-49ed-94b5-2e53182107c6",
      target: "b968e3a9-a7db-47f1-a38e-71a6c4f452f3"
    },
    {
      id: "a8c96f4d-8688-4e5c-aa20-c809cbaa591a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b968e3a9-a7db-47f1-a38e-71a6c4f452f3",
      target: "20d293bf-3f90-4a0c-aa77-b62a3e884271"
    },
    {
      id: "39543480-1548-47ba-9498-4bebcad87e37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20d293bf-3f90-4a0c-aa77-b62a3e884271",
      target: "8c3f7f50-fa5d-4354-8890-58b977f64113"
    },
    {
      id: "4360d8d0-365a-4976-82b9-b03418b78164",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20d293bf-3f90-4a0c-aa77-b62a3e884271",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "d16c73e3-9d36-43af-b3fa-b0097ddfffdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d",
      target: "879cd5c6-a8f9-41d0-95d9-f6231708cd22"
    },
    {
      id: "30cf1d0f-d5a1-4622-a250-a74ceb1ecae6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d",
      target: "67b9a589-bf9a-46d6-bff8-ee11d8f70665"
    },
    {
      id: "c4243fa0-3694-402c-bdc6-07319653209a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9fbabeb3-dac5-4c7f-8854-21e1afcea10d",
      target: "e83af6fb-81e2-4758-aa2f-90b56e081c3f"
    },
    {
      id: "b5a7e34f-5204-4fa6-8738-05a5e65bca64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "0cbb8d91-a163-4e44-a985-7c9923a50bd1"
    },
    {
      id: "190a8d5e-ece3-4e61-8a4f-9718c7f832b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "50bb0af6-dd60-4e81-8b34-caf205f920b4"
    },
    {
      id: "cb6fb4b5-5fc9-48cc-9f2d-ff4740556300",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "f7fb22f7-9a94-4ce8-a31e-bdeca3263a4e"
    },
    {
      id: "391cdf3c-a5ca-4a5e-bb0d-b1141e349fb0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "5fb26a39-2e42-4fd4-baad-a8b7c927c408"
    },
    {
      id: "4da29df4-e307-4026-afe5-6e1d17bd56de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "7afae281-2c6a-4641-860a-2692ae80df78"
    },
    {
      id: "cdef9337-5a40-4c45-a424-7c9a903c6dc4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67b9a589-bf9a-46d6-bff8-ee11d8f70665",
      target: "f2ecc5b5-e60e-4734-9ef5-8d4465b980c4"
    },
    {
      id: "9b3166c8-4767-4407-a346-fbd4542c22d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7afae281-2c6a-4641-860a-2692ae80df78",
      target: "8f8550d5-adb1-4f94-9660-07c4011a5c9d"
    },
    {
      id: "740fd643-4acd-49e1-9a15-ce78a9844242",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fb26a39-2e42-4fd4-baad-a8b7c927c408",
      target: "e09962c2-1280-44e4-b721-8c9cefb6d762"
    },
    {
      id: "f7267567-97a0-46ef-852e-dd97a14b2bde",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50bb0af6-dd60-4e81-8b34-caf205f920b4",
      target: "31eec9cd-e990-473d-8e92-96658cb5fa78"
    },
    {
      id: "7445a18c-4e5f-43e1-bee3-26b6f0d6d3d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cbb8d91-a163-4e44-a985-7c9923a50bd1",
      target: "e09962c2-1280-44e4-b721-8c9cefb6d762"
    },
    {
      id: "c2e7a0b4-29e2-4732-847b-66eaa5fe6256",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f2ecc5b5-e60e-4734-9ef5-8d4465b980c4",
      target: "e09962c2-1280-44e4-b721-8c9cefb6d762"
    },
    {
      id: "25380bf0-7817-4fb3-8185-20a2ad4c1dfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7fb22f7-9a94-4ce8-a31e-bdeca3263a4e",
      target: "e09962c2-1280-44e4-b721-8c9cefb6d762"
    },
    {
      id: "ced7b828-603f-404c-aa4a-44720a11c4b2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e09962c2-1280-44e4-b721-8c9cefb6d762",
      target: "7f585744-1012-4da5-b19a-bc3958544f66"
    },
    {
      id: "2d915ff1-7b59-4a19-ae41-c9b743e1f6b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e09962c2-1280-44e4-b721-8c9cefb6d762",
      target: "796c370d-3581-49f3-8a97-a1459bd2664e"
    },
    {
      id: "77387a30-dd6c-4cf4-890b-4c35a954c8f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31eec9cd-e990-473d-8e92-96658cb5fa78",
      target: "8f8550d5-adb1-4f94-9660-07c4011a5c9d"
    },
    {
      id: "42c9520d-7c03-4ce1-a299-af5eb0c60ad1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8550d5-adb1-4f94-9660-07c4011a5c9d",
      target: "ad416de4-3c9f-494d-88e0-4208e5a370fd"
    },
    {
      id: "6bd041f6-1b2a-4898-943b-d285894f4cad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad416de4-3c9f-494d-88e0-4208e5a370fd",
      target: "3523fe14-da7a-489d-8e7d-8da4c3423537"
    },
    {
      id: "aada1a43-d65f-4948-ac1d-ee6483531fb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3523fe14-da7a-489d-8e7d-8da4c3423537",
      target: "4e349ed9-c1eb-458b-b82d-0ea8510cd35e"
    },
    {
      id: "ac99c513-24ce-4f5e-b819-7e4cbb04d5cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3523fe14-da7a-489d-8e7d-8da4c3423537",
      target: "ecc3f1fc-bd90-49be-b50b-bcb760bf5fc6"
    },
    {
      id: "157893ea-405b-4d2f-82c6-bd23ed76b269",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3523fe14-da7a-489d-8e7d-8da4c3423537",
      target: "7cb0c710-fd70-44f4-9524-2948ee09818e"
    },
    {
      id: "6f81962a-4d96-45f6-bb38-757ca2015deb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecc3f1fc-bd90-49be-b50b-bcb760bf5fc6",
      target: "192687e0-64e7-4862-863a-1c828a9af852"
    },
    {
      id: "232a1d78-773d-4f5e-af80-536292ecd8a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb0c710-fd70-44f4-9524-2948ee09818e",
      target: "796c370d-3581-49f3-8a97-a1459bd2664e"
    },
    {
      id: "1584666e-646e-4ba8-bfbd-c58f80f0634d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb0c710-fd70-44f4-9524-2948ee09818e",
      target: "7f585744-1012-4da5-b19a-bc3958544f66"
    },
    {
      id: "cda59c99-5d2b-4ee0-9782-a6525ead7485",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb0c710-fd70-44f4-9524-2948ee09818e",
      target: "c49c78bb-12c0-469f-9703-150af487655a"
    },
    {
      id: "fbb0fa3e-38bf-4172-ae58-9b4912a700c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f585744-1012-4da5-b19a-bc3958544f66",
      target: "729390bf-29c0-4fb1-b281-1f7a51e114ab"
    },
    {
      id: "b982d942-3c81-4151-98e1-e8ef8491dbb4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "796c370d-3581-49f3-8a97-a1459bd2664e",
      target: "729390bf-29c0-4fb1-b281-1f7a51e114ab"
    },
    {
      id: "08b7af3d-57d6-4b80-b51f-7859a7b79aae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c49c78bb-12c0-469f-9703-150af487655a",
      target: "729390bf-29c0-4fb1-b281-1f7a51e114ab"
    },
    {
      id: "117655de-f22e-4bde-b4f4-7f94bcc3377e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "192687e0-64e7-4862-863a-1c828a9af852",
      target: "2ee97197-cf56-4325-b866-578348fbee31"
    },
    {
      id: "e8f4e1cb-54d7-4fa9-8751-6461b4b2d336",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ee97197-cf56-4325-b866-578348fbee31",
      target: "729390bf-29c0-4fb1-b281-1f7a51e114ab"
    },
    {
      id: "149efec1-bdce-4c33-b97c-bd4b969e4ad1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "729390bf-29c0-4fb1-b281-1f7a51e114ab",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "93780101-23da-4ebd-9eae-12261af568ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "729390bf-29c0-4fb1-b281-1f7a51e114ab",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "3f390a1f-fa07-4bd3-b542-e90413b8a993",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "729390bf-29c0-4fb1-b281-1f7a51e114ab",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "1ba4064e-2a2a-445b-af37-4d97c669bba0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "729390bf-29c0-4fb1-b281-1f7a51e114ab",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "cbd8d875-679a-4210-9e5b-0535423f3a1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e349ed9-c1eb-458b-b82d-0ea8510cd35e",
      target: "d00d12b2-df1a-411b-a437-661925afea4f"
    },
    {
      id: "aada47bd-dbd8-4aa4-ba06-b07aabd53571",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d00d12b2-df1a-411b-a437-661925afea4f",
      target: "2bbca2bc-ce2a-4037-bb48-b173feb3744c"
    },
    {
      id: "cb6d2f6c-f651-411c-8df0-041e6e25a0ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bbca2bc-ce2a-4037-bb48-b173feb3744c",
      target: "580b75ff-8420-4c95-99bd-7c9dba8183ca"
    },
    {
      id: "5c43436f-e3e7-409d-8460-daa3ff6b7704",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "580b75ff-8420-4c95-99bd-7c9dba8183ca",
      target: "6854c402-b599-4cd9-9d12-0520e4515eb4"
    },
    {
      id: "f40d26e2-caa4-4c2d-8241-3ab8db2a534e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "580b75ff-8420-4c95-99bd-7c9dba8183ca",
      target: "2de29078-c64e-4e5d-88c9-4421b0fe933d"
    },
    {
      id: "30abd8ad-8184-45ee-8d3b-5782c35d706a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2de29078-c64e-4e5d-88c9-4421b0fe933d",
      target: "e5b8fd80-16cd-40b2-a357-daaa22ae6b7e"
    },
    {
      id: "99ba016a-0a7e-4281-8fa8-2deec9594fe8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6854c402-b599-4cd9-9d12-0520e4515eb4",
      target: "b7925a2b-1607-4009-9f05-517da87660fd"
    },
    {
      id: "2d5b7171-4b7a-4d42-92d1-a965877c3b2a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5b8fd80-16cd-40b2-a357-daaa22ae6b7e",
      target: "b7925a2b-1607-4009-9f05-517da87660fd"
    },
    {
      id: "f0d6958a-ce3d-40f8-8658-06979fc89d6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7925a2b-1607-4009-9f05-517da87660fd",
      target: "691913a7-5763-4234-9842-ee608ee73d01"
    },
    {
      id: "a62559ee-c566-4bd1-bbcc-a4d5942db074",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "691913a7-5763-4234-9842-ee608ee73d01",
      target: "e63031a6-8107-4789-8e77-f22bd14756d2"
    },
    {
      id: "70db3ceb-5a06-4615-b848-87263ca72260",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e63031a6-8107-4789-8e77-f22bd14756d2",
      target: "729390bf-29c0-4fb1-b281-1f7a51e114ab"
    },
    {
      id: "581d9585-a23f-4550-9afe-6ffb92b677a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "879cd5c6-a8f9-41d0-95d9-f6231708cd22",
      target: "29feadab-5b97-4eb2-be3d-46e14988e14f"
    },
    {
      id: "7e798abb-76d1-40df-b447-c961801bbac5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "b9314653-77f0-48d1-bde5-474d6e0c7b50"
    },
    {
      id: "9736e2bd-788d-432a-8bfd-7f924ab0a3af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "347092d5-4329-4c95-8ab1-8c8bd8464704"
    },
    {
      id: "6f9e38d0-3b76-4986-8cdb-f7ebe4d5cf71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "c70718a1-8ea1-4a5e-9684-0fbedec14a57"
    },
    {
      id: "f4144c36-9deb-4954-975f-63300a385fe3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "290bb770-987c-4351-9b79-8bd7a8d13876"
    },
    {
      id: "6758edfc-a9e8-4fd4-96c6-ef3a0afa4d45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "27154e49-b6fa-42a1-a75c-2c5f068ce6a8"
    },
    {
      id: "fa1a5f5e-f79b-47d5-876f-aa763a250e29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "e4dc277f-f22d-49ff-863a-b65f22979638"
    },
    {
      id: "be3ea020-c509-4e49-9da2-8194b74bcc78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7"
    },
    {
      id: "1f53b66d-f3bb-47e5-abef-1b373564d1ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feadab-5b97-4eb2-be3d-46e14988e14f",
      target: "6bef790a-6ff6-4f20-b09b-e512ebc08dc3"
    },
    {
      id: "8346fa76-8228-4dea-b5b0-35f3f90bc59d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c70718a1-8ea1-4a5e-9684-0fbedec14a57",
      target: "1cdd472a-682f-4de0-8803-4f3b594e6d94"
    },
    {
      id: "f2643755-7ba5-49e1-a1b0-caebd1636280",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9314653-77f0-48d1-bde5-474d6e0c7b50",
      target: "9d01169b-98f2-4dd2-aafa-d09a0d22d779"
    },
    {
      id: "722bf06c-4728-48fb-bc55-c50ccfc00187",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4dc277f-f22d-49ff-863a-b65f22979638",
      target: "2867df5e-a08b-4239-bba0-5b860f308f68"
    },
    {
      id: "c520a1b8-92a6-444e-9747-72c577dd65a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bef790a-6ff6-4f20-b09b-e512ebc08dc3",
      target: "9d01169b-98f2-4dd2-aafa-d09a0d22d779"
    },
    {
      id: "e5a00a25-a633-4780-82fb-b372a6125c1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "347092d5-4329-4c95-8ab1-8c8bd8464704",
      target: "9d01169b-98f2-4dd2-aafa-d09a0d22d779"
    },
    {
      id: "d19ff5d7-ef88-4202-931e-fb92a9ea5a67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290bb770-987c-4351-9b79-8bd7a8d13876",
      target: "9d01169b-98f2-4dd2-aafa-d09a0d22d779"
    },
    {
      id: "65fcb37d-f1a6-4d1f-bd62-bb58142b47c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2867df5e-a08b-4239-bba0-5b860f308f68",
      target: "1cdd472a-682f-4de0-8803-4f3b594e6d94"
    },
    {
      id: "395e0f35-5021-47c1-95e8-035011002396",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d01169b-98f2-4dd2-aafa-d09a0d22d779",
      target: "cd45a412-c5fb-489b-9017-427b73ac339d"
    },
    {
      id: "e569cb83-eef2-4ac6-986c-a7ccf3f4228e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d01169b-98f2-4dd2-aafa-d09a0d22d779",
      target: "8add8f37-6016-4f1b-9c23-56d20d4278ab"
    },
    {
      id: "77ae59a4-9be7-4b33-8743-f9537b6eec1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cdd472a-682f-4de0-8803-4f3b594e6d94",
      target: "b7b25fc2-f423-4294-905f-82c550d8e451"
    },
    {
      id: "e62e19e5-36b0-41d0-b5c3-65834d54c5fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7b25fc2-f423-4294-905f-82c550d8e451",
      target: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c"
    },
    {
      id: "14fe80ee-61c9-4e9d-a1fd-7a8481058d50",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c",
      target: "8127850e-496c-4570-98b4-625b77cd1a69"
    },
    {
      id: "3270b99d-64cb-448b-afc3-9c7d681b2159",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c",
      target: "132f642a-4b74-4169-a1d1-13b9d87a0cb2"
    },
    {
      id: "ad420d5f-dab2-42c6-af64-e9ea903e3eed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c",
      target: "336bb83c-4838-41ea-8c5f-6b9ff0d6aadb"
    },
    {
      id: "ddb599bb-033c-4b20-9e86-0690e718e513",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ecad1ac4-80c6-4b90-a8db-0fd050e7505c",
      target: "595b507d-b492-416a-90ca-ccfdb2c3e142"
    },
    {
      id: "1125ac17-5f72-449f-af67-495f0a74cea9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8127850e-496c-4570-98b4-625b77cd1a69",
      target: "b0c19626-3c01-4217-a9a3-046ef7fc1609"
    },
    {
      id: "e9365a48-106d-447e-a45c-d885899cb340",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "132f642a-4b74-4169-a1d1-13b9d87a0cb2",
      target: "cd45a412-c5fb-489b-9017-427b73ac339d"
    },
    {
      id: "03ca36de-dd41-45c7-96cc-f11f2732263f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "132f642a-4b74-4169-a1d1-13b9d87a0cb2",
      target: "307c9bdc-11aa-430f-855c-ae0468bb9bd5"
    },
    {
      id: "4bcb85c5-0836-4a8f-8ec5-74f84d840ae3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "132f642a-4b74-4169-a1d1-13b9d87a0cb2",
      target: "8add8f37-6016-4f1b-9c23-56d20d4278ab"
    },
    {
      id: "f5d79a2e-f6de-4a6d-9db9-0397d16970a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd45a412-c5fb-489b-9017-427b73ac339d",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "2598301b-6d51-4b5a-8fa4-670a6ba933df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8add8f37-6016-4f1b-9c23-56d20d4278ab",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "919a1213-602b-4245-9378-2dcb968aec3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0c19626-3c01-4217-a9a3-046ef7fc1609",
      target: "28bfbbc5-cffa-4c72-94f6-e54abcc5f55e"
    },
    {
      id: "6fabbb6e-ed77-4ffd-bf15-e506d151261f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "307c9bdc-11aa-430f-855c-ae0468bb9bd5",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "6d81db4c-5757-4088-8c32-6c4a3e0a0ab3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28bfbbc5-cffa-4c72-94f6-e54abcc5f55e",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "7cb18031-cac6-4ab3-9b91-b990bfba669d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "0dbfe540-7c41-47ab-80b1-be2a8afa5ee3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "da7d934c-5a0c-41df-a43c-bec90ff2ae16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "4e3a9645-8602-4d39-abd3-a092fef8b1d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "43b0e06f-fe92-45fd-8cfc-7574d048585f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "336bb83c-4838-41ea-8c5f-6b9ff0d6aadb",
      target: "fd64bc2b-7a87-4d34-9274-f7eb64ec7976"
    },
    {
      id: "6d676fdf-9867-4687-b21c-88de62b4a108",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd64bc2b-7a87-4d34-9274-f7eb64ec7976",
      target: "b8de3189-4705-434f-98fb-e69fad6858b4"
    },
    {
      id: "9863aa78-4015-4c45-a68b-95e97ed8e09e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8de3189-4705-434f-98fb-e69fad6858b4",
      target: "0df4326a-90b6-4546-9714-42a348c699ef"
    },
    {
      id: "b810a9ad-d614-4e4c-ba8e-257ad9212484",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0df4326a-90b6-4546-9714-42a348c699ef",
      target: "b8ea20d5-b98b-42f7-aee5-fed060a753ae"
    },
    {
      id: "80a9834e-b667-4f31-99c4-9a19247c5b15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0df4326a-90b6-4546-9714-42a348c699ef",
      target: "a4d4f525-9806-4cc5-bb76-69b28522293c"
    },
    {
      id: "8271a070-7833-4c09-aa40-1b4e0b0d313f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8ea20d5-b98b-42f7-aee5-fed060a753ae",
      target: "71ce8baf-563c-4d08-a7bc-e5fc10a1f06a"
    },
    {
      id: "021badc7-a696-4514-9738-a84fa4bd5c56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4d4f525-9806-4cc5-bb76-69b28522293c",
      target: "233dfe43-74e4-43b1-a244-be069e5d322d"
    },
    {
      id: "c8db4a21-79e1-4f7c-bf32-c3e35583be63",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71ce8baf-563c-4d08-a7bc-e5fc10a1f06a",
      target: "233dfe43-74e4-43b1-a244-be069e5d322d"
    },
    {
      id: "56a988f4-f05a-4d1b-b5bf-13ff389260f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "233dfe43-74e4-43b1-a244-be069e5d322d",
      target: "d89e4703-8027-49ec-89d9-8c22ed9ed0bb"
    },
    {
      id: "55cc86c7-a587-4af4-9927-b632f733372a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d89e4703-8027-49ec-89d9-8c22ed9ed0bb",
      target: "184797a9-40f5-44ea-82a4-eb38a79b9c00"
    },
    {
      id: "320432ef-ceaf-4b04-ae42-c08a5a7a837a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "184797a9-40f5-44ea-82a4-eb38a79b9c00",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "fdb9365d-78ae-4bbb-aa55-9ec9ca024877",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "595b507d-b492-416a-90ca-ccfdb2c3e142",
      target: "5682fe95-70e0-4a0e-a209-96fd4d6be09a"
    },
    {
      id: "e6e02439-38a0-42dd-89fb-b99c584b7d67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5682fe95-70e0-4a0e-a209-96fd4d6be09a",
      target: "e0fdaa51-4cb1-4b83-a09d-a447f638353c"
    },
    {
      id: "b4cc4d51-7ef9-45c4-92d8-33f850fe4500",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0fdaa51-4cb1-4b83-a09d-a447f638353c",
      target: "a3f38060-4ee9-44a8-82d3-0ae1d8d78e12"
    },
    {
      id: "c8ce2c6f-b534-467d-9480-a06e7436d393",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3f38060-4ee9-44a8-82d3-0ae1d8d78e12",
      target: "488facb6-6e40-4b50-96a6-d899882d3b19"
    },
    {
      id: "30bcd66b-9cde-4862-8a7b-471e22e92d47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3f38060-4ee9-44a8-82d3-0ae1d8d78e12",
      target: "630fc7b8-dbbe-4d1f-909f-c543ba8860e8"
    },
    {
      id: "0e679132-8036-4ff4-8202-c2c46a1a6b9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "488facb6-6e40-4b50-96a6-d899882d3b19",
      target: "439adca3-2d5f-48f1-902e-af195e35a295"
    },
    {
      id: "9bf1790b-1594-4f28-b9b9-b7d17aee28d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "630fc7b8-dbbe-4d1f-909f-c543ba8860e8",
      target: "115d14d1-96a9-4453-b70d-27986bcbc4ca"
    },
    {
      id: "b744a485-1b58-45bf-bb70-8aa22c926469",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "439adca3-2d5f-48f1-902e-af195e35a295",
      target: "115d14d1-96a9-4453-b70d-27986bcbc4ca"
    },
    {
      id: "3090f693-f581-4ac1-85cf-4552acb78fca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "115d14d1-96a9-4453-b70d-27986bcbc4ca",
      target: "3f315edb-3a69-451c-8b43-955290d9ea95"
    },
    {
      id: "da86dd15-5ba2-47ff-b3a0-0ce130e3008f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3f315edb-3a69-451c-8b43-955290d9ea95",
      target: "e9ca5da5-9dc3-4322-abfb-99c988501781"
    },
    {
      id: "cd5ebf31-9f15-4b5f-a2f7-fa47f5d3043e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9ca5da5-9dc3-4322-abfb-99c988501781",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "21d0c476-ef3b-4eba-8e2b-9b4298d8c616",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27154e49-b6fa-42a1-a75c-2c5f068ce6a8",
      target: "5b32e6b4-bde3-4733-bdaa-3b2445f9e1fd"
    },
    {
      id: "c603f33e-87da-4074-8171-243f779f7a99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b32e6b4-bde3-4733-bdaa-3b2445f9e1fd",
      target: "47b72397-9ff6-4ddd-9a83-e9fce4799059"
    },
    {
      id: "6c2b74e0-251b-44cb-987d-69ad259d77fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47b72397-9ff6-4ddd-9a83-e9fce4799059",
      target: "0d19c91c-7976-49fc-8fed-f3c2a447f81f"
    },
    {
      id: "0bf6c3d5-7b35-4f38-b5bf-52ddcfb0eef7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d19c91c-7976-49fc-8fed-f3c2a447f81f",
      target: "d175c038-a349-426b-a5b0-fea7057cda97"
    },
    {
      id: "e892560f-5d61-4291-ae31-72513067d203",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d175c038-a349-426b-a5b0-fea7057cda97",
      target: "3e28be71-2de3-4166-9221-b89e63cb0544"
    },
    {
      id: "8c3e6de3-c21e-4f17-891f-1cd7db33f462",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e28be71-2de3-4166-9221-b89e63cb0544",
      target: "cec4a492-53a7-45e4-8318-0444a2ea10bd"
    },
    {
      id: "492dace3-9363-4231-8de5-8577ddc4ecd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cec4a492-53a7-45e4-8318-0444a2ea10bd",
      target: "41aa398e-63d7-4b9f-9fca-e652fd1763e5"
    },
    {
      id: "5b9a5619-f21c-4cfe-bf9d-27bc59208fe2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "d6cd2904-873f-4c2a-bda1-6ad2c2b7d862",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "e1c1c785-b1d1-4c59-8a2e-316f0277947b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "2bf26306-03e7-4c22-a9aa-29ca8adbb3bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "22c5879a-3afb-4e87-ac89-f0cb2fa23c59"
    },
    {
      id: "95ab159b-60a4-41a1-bb8a-46ad23cfdc58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "ab70c7a9-fab0-463f-a353-f7a5893341d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "a997fbd9-fa5b-4b36-9a04-05020a84421e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41aa398e-63d7-4b9f-9fca-e652fd1763e5",
      target: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1"
    },
    {
      id: "38df885b-cd2b-49d3-af39-24507f3eb696",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "fcb414f2-390a-4870-a33e-898663fa8e82"
    },
    {
      id: "e4256182-0964-4d6b-a145-ed7502ddf0be",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "102950ef-021d-4ecc-b17c-21db92d5ad07"
    },
    {
      id: "fa8788cd-76f0-4ad3-89ea-683acc48d3a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "83ca5c4c-ea2d-4317-b93f-4ae7ffc47fde"
    },
    {
      id: "2602c641-2efc-41b2-a55d-d3f8a77767be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "29ef6d5b-0fe1-4b38-a371-e70ef05d6544"
    },
    {
      id: "f8649988-4a8e-4d2b-816d-d08c76e413a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "e3c7fbf0-37e7-4b1a-8032-53b253358dd1"
    },
    {
      id: "b7f1ca85-6082-45c5-9708-c021fb1488b2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "49986074-60af-4a69-8655-a27f2870b244"
    },
    {
      id: "afb71df9-40d6-450e-b454-6fe3ca721749",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "5ead4bd9-e05e-44f2-a601-bd7d84f9a97f"
    },
    {
      id: "7292f627-553c-4715-8be4-43aa3846ca6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98b584fa-8fb4-41c6-ba2c-b6cf6787b2f7",
      target: "d96cd478-efd9-4133-9998-aaed95a88824"
    },
    {
      id: "bce61c78-e2cd-43cc-8862-96a839fa8c8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83ca5c4c-ea2d-4317-b93f-4ae7ffc47fde",
      target: "7f103629-f681-4cdd-9abb-9474c656c554"
    },
    {
      id: "ca6e5b72-afb7-4744-bdc9-fca90401ac8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ead4bd9-e05e-44f2-a601-bd7d84f9a97f",
      target: "d4472b8a-39ec-4821-9924-8dff6f4fcd51"
    },
    {
      id: "f9a31970-ec03-491e-8f15-d29049d33601",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d96cd478-efd9-4133-9998-aaed95a88824",
      target: "1f0b601a-65c2-4e21-9ddf-a98ffccb9e82"
    },
    {
      id: "5aa067f6-1e72-497d-a4cf-157ebd5620ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29ef6d5b-0fe1-4b38-a371-e70ef05d6544",
      target: "d4472b8a-39ec-4821-9924-8dff6f4fcd51"
    },
    {
      id: "bd4d7697-e09d-4025-b0bd-ca08e28cf08f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3c7fbf0-37e7-4b1a-8032-53b253358dd1",
      target: "d4472b8a-39ec-4821-9924-8dff6f4fcd51"
    },
    {
      id: "fc1cc4b3-8d94-472a-8185-6114496135f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f0b601a-65c2-4e21-9ddf-a98ffccb9e82",
      target: "7f103629-f681-4cdd-9abb-9474c656c554"
    },
    {
      id: "d0101570-5489-4b32-981f-4450d3de2f4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4472b8a-39ec-4821-9924-8dff6f4fcd51",
      target: "18cedcb7-b697-423f-9ec6-c1c364cb8d5c"
    },
    {
      id: "fa5dea6b-dd69-4a9a-b244-e9f486a2c5c0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d4472b8a-39ec-4821-9924-8dff6f4fcd51",
      target: "b24c2f80-a3c7-4af5-b0f5-006fc4c42cf8"
    },
    {
      id: "9a90bedb-6c03-4c00-a5e3-5007f61cd09e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f103629-f681-4cdd-9abb-9474c656c554",
      target: "abd0cea0-a044-4524-9874-930065f141fd"
    },
    {
      id: "a89eaf67-6334-4a1e-9aab-336cab197f5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abd0cea0-a044-4524-9874-930065f141fd",
      target: "86b147cb-cbfe-4863-bb5b-52adde86f2de"
    },
    {
      id: "40eccefe-d407-42a8-b91d-d4e68e8e2aa5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86b147cb-cbfe-4863-bb5b-52adde86f2de",
      target: "69a83544-4e6e-402f-be0d-e4b90e5b3ac3"
    },
    {
      id: "a26f8b68-e79c-4bc9-a8e6-2c171207bd85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86b147cb-cbfe-4863-bb5b-52adde86f2de",
      target: "8356cb2e-551f-469a-9129-87aa622891bb"
    },
    {
      id: "82f468a7-e7ad-4026-ab95-60541d6c62f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69a83544-4e6e-402f-be0d-e4b90e5b3ac3",
      target: "334732a6-1994-490c-9503-c812c26050b9"
    },
    {
      id: "175811fb-c6b2-4cda-8357-63db4cd67f97",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "69a83544-4e6e-402f-be0d-e4b90e5b3ac3",
      target: "832981e9-4ea4-4ad2-951e-0ab4460d32ad"
    },
    {
      id: "5aa4d348-85a6-495f-b1e6-cdc1ae71167c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8356cb2e-551f-469a-9129-87aa622891bb",
      target: "b24c2f80-a3c7-4af5-b0f5-006fc4c42cf8"
    },
    {
      id: "ccec5990-a95e-4d26-aff2-5ee85d85c0dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8356cb2e-551f-469a-9129-87aa622891bb",
      target: "18cedcb7-b697-423f-9ec6-c1c364cb8d5c"
    },
    {
      id: "def4bca6-fb52-46bb-b32a-d735361ba6d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8356cb2e-551f-469a-9129-87aa622891bb",
      target: "1ec7094b-6b88-4d57-9049-d2fa2f1bec68"
    },
    {
      id: "842f6dda-d9d2-48ff-88a9-dc6c95a02b5b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "334732a6-1994-490c-9503-c812c26050b9",
      target: "832981e9-4ea4-4ad2-951e-0ab4460d32ad"
    },
    {
      id: "60bdd1dd-17bf-46f7-ae9c-233cf2606477",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "334732a6-1994-490c-9503-c812c26050b9",
      target: "0bf2bcd8-b382-499b-bf41-1128480a235c"
    },
    {
      id: "6f0ec173-008d-4851-84fd-d20b8e7826d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ec7094b-6b88-4d57-9049-d2fa2f1bec68",
      target: "4e4ecf78-df25-44e3-b7e0-d880d601b742"
    },
    {
      id: "a5d6a758-f7e7-4a95-ba09-9366a835f33b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ec7094b-6b88-4d57-9049-d2fa2f1bec68",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "b0062541-ffdc-4675-862e-31390fc5e7eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b24c2f80-a3c7-4af5-b0f5-006fc4c42cf8",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "dd09f54c-b976-41d4-b7f3-6e7f17a76281",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18cedcb7-b697-423f-9ec6-c1c364cb8d5c",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "b130808b-d327-4db5-9faf-3576f0c528a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "832981e9-4ea4-4ad2-951e-0ab4460d32ad",
      target: "292add02-6549-410d-a4fc-736e4a87e40b"
    },
    {
      id: "1223c22b-7d19-45d4-bc83-9a27dc6e761f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bf2bcd8-b382-499b-bf41-1128480a235c",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "eaffb391-c42c-4152-a124-b137f67f0283",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "292add02-6549-410d-a4fc-736e4a87e40b",
      target: "96876223-bcd9-490c-bd78-0bf14b3f33f8"
    },
    {
      id: "fa3ca0a1-d473-4a49-9e32-d84eff6ac891",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96876223-bcd9-490c-bd78-0bf14b3f33f8",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "44eb70d4-d7ed-43cd-b1c8-3985b95b46a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c",
      target: "347a5a1c-1296-4577-bd61-0caa76198185"
    },
    {
      id: "0f74cc41-9b42-47ed-91e2-337990731122",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "0efc73fe-47e8-4c7b-a64d-e44837dc0c4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "aac1fca0-3af1-4f61-96b4-cee219a43f46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c",
      target: "d66d5383-0992-47bc-a319-b3c126dd8fb3"
    },
    {
      id: "6790e730-de19-4675-b962-06f7c2aaa7f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49986074-60af-4a69-8655-a27f2870b244",
      target: "e4c2ae14-0c46-442a-8a4f-8bab00a534ec"
    },
    {
      id: "d7a34374-1534-4d87-a2ae-fba8c4b6bbaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49986074-60af-4a69-8655-a27f2870b244",
      target: "4d1811b9-c839-49a4-ac38-aee0b2b3b21c"
    },
    {
      id: "bc26dc20-abce-435b-89fc-024976f2bdfd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49986074-60af-4a69-8655-a27f2870b244",
      target: "7fcc67fd-c50c-44ab-97a1-a7f81b14a909"
    },
    {
      id: "446ba895-d536-41ee-a087-b0f562c4a6fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49986074-60af-4a69-8655-a27f2870b244",
      target: "071cf308-1ae1-457e-99c2-c6d91e0e1672"
    },
    {
      id: "a9d1eeb2-cfe5-4a81-90ed-56fe3ed35a4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49986074-60af-4a69-8655-a27f2870b244",
      target: "fd304b43-3efb-4e9b-8579-e7ec1cc17d3a"
    },
    {
      id: "fdf699ff-33c5-4649-a5c2-e892c8b592c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7fcc67fd-c50c-44ab-97a1-a7f81b14a909",
      target: "092dfe14-2916-495d-81e2-61c6c3a99c06"
    },
    {
      id: "e1a4d57c-29da-47ae-9f78-ecfd6ba50c15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4c2ae14-0c46-442a-8a4f-8bab00a534ec",
      target: "68c1b064-77f7-4bce-b15d-6cb1deec4b17"
    },
    {
      id: "5faa051c-fcec-456f-8def-ea8da35ac81b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d1811b9-c839-49a4-ac38-aee0b2b3b21c",
      target: "1b775b3f-8d0b-4287-aecf-b2ab308e9682"
    },
    {
      id: "d1f78905-1a2c-426f-a716-efcb7f72a70e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd304b43-3efb-4e9b-8579-e7ec1cc17d3a",
      target: "68c1b064-77f7-4bce-b15d-6cb1deec4b17"
    },
    {
      id: "ec8c981e-5661-48db-a8d6-396bd262de11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "071cf308-1ae1-457e-99c2-c6d91e0e1672",
      target: "68c1b064-77f7-4bce-b15d-6cb1deec4b17"
    },
    {
      id: "b7b5f44b-0dc9-433a-a5e2-d215d6f5d165",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b775b3f-8d0b-4287-aecf-b2ab308e9682",
      target: "092dfe14-2916-495d-81e2-61c6c3a99c06"
    },
    {
      id: "03271d9d-6416-4531-8bad-b5ec535fdc23",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "68c1b064-77f7-4bce-b15d-6cb1deec4b17",
      target: "3af97ea3-28f6-4c3b-b276-d7c1b252861f"
    },
    {
      id: "dc874208-91ea-4452-b23c-153242b3dee6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68c1b064-77f7-4bce-b15d-6cb1deec4b17",
      target: "7e6102d1-02d3-4e4f-bf97-7b12df6db4f1"
    },
    {
      id: "237492d8-d2ba-429c-bb67-2dab3b5d989c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "092dfe14-2916-495d-81e2-61c6c3a99c06",
      target: "1c7db9d7-9299-4149-86e9-653c289d3de4"
    },
    {
      id: "cdd8da9c-abbd-4207-91c4-6790dcaccecb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c7db9d7-9299-4149-86e9-653c289d3de4",
      target: "fbe66827-31ea-4a2d-b5cc-a00140f8c47f"
    },
    {
      id: "ca9fc3c7-1a33-40fe-a117-7ed8da3eed0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbe66827-31ea-4a2d-b5cc-a00140f8c47f",
      target: "02527047-34bf-4eb5-8178-60681bbc6185"
    },
    {
      id: "211f24b3-6689-4b02-aac9-570d75461e44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02527047-34bf-4eb5-8178-60681bbc6185",
      target: "3af97ea3-28f6-4c3b-b276-d7c1b252861f"
    },
    {
      id: "f885c17d-f1e7-4ae9-b83d-64b8896c6c07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02527047-34bf-4eb5-8178-60681bbc6185",
      target: "29b3bc87-c2eb-48de-a236-07244017ee38"
    },
    {
      id: "7d9f9f5d-1f46-4418-8dd7-32837bf9fcfb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "02527047-34bf-4eb5-8178-60681bbc6185",
      target: "5879d744-df34-4e9d-9087-5b631f1b38bd"
    },
    {
      id: "0adffa29-21eb-4b85-89be-a75e075e9410",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02527047-34bf-4eb5-8178-60681bbc6185",
      target: "9130718b-0c0b-47c8-9499-733194076ce7"
    },
    {
      id: "aaa9b6fc-cde8-44b7-bcb2-0e59d144240c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02527047-34bf-4eb5-8178-60681bbc6185",
      target: "7e6102d1-02d3-4e4f-bf97-7b12df6db4f1"
    },
    {
      id: "cf80fbee-ccdc-448c-98ae-3ea3d942cbce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29b3bc87-c2eb-48de-a236-07244017ee38",
      target: "4e4ecf78-df25-44e3-b7e0-d880d601b742"
    },
    {
      id: "d9120554-1817-4694-bc2f-40ff65d01a28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29b3bc87-c2eb-48de-a236-07244017ee38",
      target: "e2ded763-0af7-44d2-bd42-ab2f0174d181"
    },
    {
      id: "d8aba641-c0fb-4b02-93bf-ae745bdaf332",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3af97ea3-28f6-4c3b-b276-d7c1b252861f",
      target: "e2ded763-0af7-44d2-bd42-ab2f0174d181"
    },
    {
      id: "d1ca08e3-d9e3-4e30-a219-f1db364856ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e6102d1-02d3-4e4f-bf97-7b12df6db4f1",
      target: "e2ded763-0af7-44d2-bd42-ab2f0174d181"
    },
    {
      id: "da890d4e-42eb-472e-8331-b6108b76375d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5879d744-df34-4e9d-9087-5b631f1b38bd",
      target: "e87e871a-aa38-4544-a91e-0527e07cde1a"
    },
    {
      id: "47e23a82-5cc2-49d1-81e4-19a132c56837",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9130718b-0c0b-47c8-9499-733194076ce7",
      target: "5879d744-df34-4e9d-9087-5b631f1b38bd"
    },
    {
      id: "2e684e88-fcb0-42bd-916a-439979052947",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9130718b-0c0b-47c8-9499-733194076ce7",
      target: "13dfb0cc-ff57-49a7-9900-0e7eb3455ef2"
    },
    {
      id: "71ea618f-0b44-40ac-a015-5a78ffdaff07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e87e871a-aa38-4544-a91e-0527e07cde1a",
      target: "5d72a611-530f-409f-b90f-1d4f9773e85a"
    },
    {
      id: "7b92eb62-ca20-4cb1-ab4a-67330132d3e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "13dfb0cc-ff57-49a7-9900-0e7eb3455ef2",
      target: "e2ded763-0af7-44d2-bd42-ab2f0174d181"
    },
    {
      id: "6e046d92-ed09-4479-b58e-ea1c4ae652df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d72a611-530f-409f-b90f-1d4f9773e85a",
      target: "e2ded763-0af7-44d2-bd42-ab2f0174d181"
    },
    {
      id: "4ee0415b-2976-4978-915c-9de6f1bfc66c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2ded763-0af7-44d2-bd42-ab2f0174d181",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "1f583756-fe58-429e-8b0c-f8611fdf74e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2ded763-0af7-44d2-bd42-ab2f0174d181",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "8b565e97-3f74-4f58-a619-bfbe62eb4878",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2ded763-0af7-44d2-bd42-ab2f0174d181",
      target: "23b10f07-b4fe-43f3-a565-d567bcaca24f"
    },
    {
      id: "5bb7ee52-0d2f-4eaf-a183-9a6e29eb7a42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2ded763-0af7-44d2-bd42-ab2f0174d181",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "ee5b05bf-8816-4eab-8a94-0ec591734827",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      target: "dfead9a8-3eb3-4481-ae1a-58e1dcd1b3e9"
    },
    {
      id: "28c3f31b-7121-41ef-8504-4ab004c0383d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      target: "1d192237-419b-45d3-a879-286866c93bec"
    },
    {
      id: "7eef7f30-545f-4f31-8a31-1e820ba523e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      target: "fb0ab18a-1103-414c-b826-aed4493e6901"
    },
    {
      id: "979e2ec4-7e81-4131-9a7e-774ce80e4464",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      target: "f500a6d2-8d94-4b8b-a387-3da7d39c03a0"
    },
    {
      id: "179a3073-6a4e-4bfd-bf3f-6f7a54db9dbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "102950ef-021d-4ecc-b17c-21db92d5ad07",
      target: "d0b37b78-eae0-4404-a1cc-de01eb4005d5"
    },
    {
      id: "a2563d21-8752-414d-84cb-cdef0b42e74f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d192237-419b-45d3-a879-286866c93bec",
      target: "38bb5abc-4a24-42e2-abfe-472449237910"
    },
    {
      id: "ca3d5342-2fb9-44c8-a596-b2eecfe80270",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dfead9a8-3eb3-4481-ae1a-58e1dcd1b3e9",
      target: "5596366c-b3a7-49ce-a349-65eaf0150524"
    },
    {
      id: "6b63db93-a567-4a8e-ad09-ac41dbb1f7bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb0ab18a-1103-414c-b826-aed4493e6901",
      target: "cca3496f-2fd3-4614-954b-6ae9bb9daaf7"
    },
    {
      id: "fa701f5e-2d1b-40ff-bf66-d949c5132a0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0b37b78-eae0-4404-a1cc-de01eb4005d5",
      target: "5596366c-b3a7-49ce-a349-65eaf0150524"
    },
    {
      id: "bdf70044-b186-4a25-8f00-0aeede77b2d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f500a6d2-8d94-4b8b-a387-3da7d39c03a0",
      target: "5596366c-b3a7-49ce-a349-65eaf0150524"
    },
    {
      id: "3cc5b676-e416-483b-b0d2-51ae25271ac5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cca3496f-2fd3-4614-954b-6ae9bb9daaf7",
      target: "38bb5abc-4a24-42e2-abfe-472449237910"
    },
    {
      id: "0ebb1b7d-b67d-4051-8de7-7da369c0e117",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5596366c-b3a7-49ce-a349-65eaf0150524",
      target: "a00ded8b-ecc9-4d53-985f-34c25dcf76ac"
    },
    {
      id: "8a9f1f1e-0108-4a34-9206-c916e2f3c455",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5596366c-b3a7-49ce-a349-65eaf0150524",
      target: "b10f89e5-6e11-47b4-a6ed-92e4cdb7d903"
    },
    {
      id: "46b4ee5d-85ba-4533-b607-6602ca0d263b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38bb5abc-4a24-42e2-abfe-472449237910",
      target: "a5322cc4-5d2c-445e-95eb-a2ec0ee92b63"
    },
    {
      id: "81e658c2-8950-4550-b7e1-43b5a572ab13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5322cc4-5d2c-445e-95eb-a2ec0ee92b63",
      target: "59d957cd-c9b3-47f5-9c8f-a704a603e32c"
    },
    {
      id: "003691d9-37f1-4461-8642-4d7a70b2bf9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59d957cd-c9b3-47f5-9c8f-a704a603e32c",
      target: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9"
    },
    {
      id: "5e8d0cbf-00dc-4ad5-8e38-cd3a190464f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      target: "a00ded8b-ecc9-4d53-985f-34c25dcf76ac"
    },
    {
      id: "87d75f4a-2267-4c7b-b2a7-71af64a95ead",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      target: "b10f89e5-6e11-47b4-a6ed-92e4cdb7d903"
    },
    {
      id: "9d827efb-0d9f-4293-9ce9-bcece44b416c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      target: "84249298-053f-4bed-89cc-a4382c9f1fa6"
    },
    {
      id: "d7c71dae-ed28-462e-b146-295c2430d7c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      target: "68d1dfde-3f4b-4389-8d3e-6feff58dc640"
    },
    {
      id: "13839a55-b9b1-489a-b16a-992236d7ef2c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f33d8dfc-1e3e-42ed-9a0f-d4db41e4dfe9",
      target: "a81feec3-c833-4eba-b6a2-ef63cd01e43b"
    },
    {
      id: "02b26a39-782f-4ea1-99d8-6f6a4d935c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84249298-053f-4bed-89cc-a4382c9f1fa6",
      target: "b1abd6b2-55fa-4947-9480-0769f73dcd30"
    },
    {
      id: "81cb4133-ee8f-405c-9241-8acc52ff9df7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84249298-053f-4bed-89cc-a4382c9f1fa6",
      target: "4e4ecf78-df25-44e3-b7e0-d880d601b742"
    },
    {
      id: "7f6078ff-bf52-420f-ac2d-c316656db261",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b10f89e5-6e11-47b4-a6ed-92e4cdb7d903",
      target: "b1abd6b2-55fa-4947-9480-0769f73dcd30"
    },
    {
      id: "0ec74e10-3ec1-4e16-a3e8-25be8b521898",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a00ded8b-ecc9-4d53-985f-34c25dcf76ac",
      target: "b1abd6b2-55fa-4947-9480-0769f73dcd30"
    },
    {
      id: "8ce97899-39ae-4966-8498-5055d2bcb903",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a81feec3-c833-4eba-b6a2-ef63cd01e43b",
      target: "f2c14ded-4438-4665-973b-0774f27d4c7b"
    },
    {
      id: "9e3083d7-f228-4a93-871c-ea4b5656795a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68d1dfde-3f4b-4389-8d3e-6feff58dc640",
      target: "c77e0f92-3b07-449c-96fa-d2b6bf76effd"
    },
    {
      id: "b1047781-863c-4b5a-b7cb-f4eba3a4b44c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "68d1dfde-3f4b-4389-8d3e-6feff58dc640",
      target: "a81feec3-c833-4eba-b6a2-ef63cd01e43b"
    },
    {
      id: "f23e8df1-3490-4b79-8fe2-f40007f48fd9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f2c14ded-4438-4665-973b-0774f27d4c7b",
      target: "ca1ccbd8-2a35-49f0-b37e-da2ec19961e4"
    },
    {
      id: "6a7bdda7-af9b-40f3-835d-4e1a56280012",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c77e0f92-3b07-449c-96fa-d2b6bf76effd",
      target: "b1abd6b2-55fa-4947-9480-0769f73dcd30"
    },
    {
      id: "a238f184-39d2-451d-8f49-e2bdeba186a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca1ccbd8-2a35-49f0-b37e-da2ec19961e4",
      target: "b1abd6b2-55fa-4947-9480-0769f73dcd30"
    },
    {
      id: "8c353974-ff40-4dc7-8def-bced3531cb8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1abd6b2-55fa-4947-9480-0769f73dcd30",
      target: "567f16c3-9d29-45e9-9a26-eb3b2ec6b12c"
    },
    {
      id: "623653a1-db74-4db0-bc36-dec97b4e47cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1abd6b2-55fa-4947-9480-0769f73dcd30",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "fe161e7d-3207-4723-8e3e-e579cc4fbe45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1abd6b2-55fa-4947-9480-0769f73dcd30",
      target: "23b10f07-b4fe-43f3-a565-d567bcaca24f"
    },
    {
      id: "9f5a386d-e1a1-413b-bac9-b246f59d60d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1abd6b2-55fa-4947-9480-0769f73dcd30",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "010464f3-8680-4b4b-87ec-2485e30cbe46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe7d7efc-c1f4-43cd-8d2d-b2e69d15aabc",
      target: "58979e2c-d924-45a6-af73-baa12f1084e1"
    },
    {
      id: "7d30f83d-4a0c-4d8d-b4e2-40df17be08fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58979e2c-d924-45a6-af73-baa12f1084e1",
      target: "3691a4a5-2c48-476d-a402-7b0b32cf5858"
    },
    {
      id: "7bd70ce0-d60c-4943-8e85-4c2cdf7cafc7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3691a4a5-2c48-476d-a402-7b0b32cf5858",
      target: "939d4020-9def-41d4-b828-539db572d917"
    },
    {
      id: "1bf0a51d-86a2-4f68-ad54-fbed096ebaba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "939d4020-9def-41d4-b828-539db572d917",
      target: "82150e10-0ee4-44ad-b04f-c8e7979d7bd7"
    },
    {
      id: "3ed5dc99-0740-4359-84fa-b44c93dee901",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "939d4020-9def-41d4-b828-539db572d917",
      target: "45216dd4-2797-483a-9307-63633ec30356"
    },
    {
      id: "46f6d091-8eb6-45fa-aebf-15138e201fe8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82150e10-0ee4-44ad-b04f-c8e7979d7bd7",
      target: "c875ef17-1edb-46fe-aca3-8692566e29d3"
    },
    {
      id: "f200f119-af04-45f4-aa06-a15f78ef97c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45216dd4-2797-483a-9307-63633ec30356",
      target: "c5da019b-8006-4178-9500-48ec2ab31d05"
    },
    {
      id: "fd079c38-4fd7-4dba-926c-905529668ff3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c875ef17-1edb-46fe-aca3-8692566e29d3",
      target: "c5da019b-8006-4178-9500-48ec2ab31d05"
    },
    {
      id: "200a1d46-1add-4e15-89cb-958d06412d4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5da019b-8006-4178-9500-48ec2ab31d05",
      target: "0c48ba22-cee0-4e6a-b634-1a74458dcefc"
    },
    {
      id: "4e95b2cf-6b14-4f0e-8415-4560ddf9caaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c48ba22-cee0-4e6a-b634-1a74458dcefc",
      target: "6ca14f1a-0790-424e-8917-ef78671e14e1"
    },
    {
      id: "956ca6c0-b8f4-443d-9114-fc1949d70e2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ca14f1a-0790-424e-8917-ef78671e14e1",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "5865348c-9edf-45ce-a79f-1361107ef0f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce046f13-7690-47a8-b525-3d2dcb274d34",
      target: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6"
    },
    {
      id: "8ede35bc-2fbd-4a1b-82d6-0e414c39f25b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "a2533a20-0d53-45ea-b590-91cd67e41c2a"
    },
    {
      id: "4a9f7c1a-79d5-41bd-bc3c-9ac5d7d2afd7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "38a7e1b1-d0ea-4658-a6c9-ebadcab872da"
    },
    {
      id: "26be9787-04f4-410c-a03b-edf2a4f43105",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "a3d7fee0-f942-4b24-b86b-37580a0f0f90"
    },
    {
      id: "abc19499-ac86-4ba8-a592-74bff1e886c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "a7334d00-d180-4864-acad-043be0fce54a"
    },
    {
      id: "7758170d-50a0-4da1-aff5-7bdfb5ef7646",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "9f2285bd-838a-4496-b283-72265a23b8d8"
    },
    {
      id: "e6988844-af1f-4561-ad40-51ef5773becb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ab3e3b1-06c7-42ef-9ec9-32a837bf55a6",
      target: "4984fa1c-2dfc-4802-a4b5-4c5a9c0fb8b8"
    },
    {
      id: "dde4d54a-dcb6-4274-b1f5-dedaafd125db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7334d00-d180-4864-acad-043be0fce54a",
      target: "c7da7e10-345f-4491-8a28-72d9ccefb82a"
    },
    {
      id: "03ddc8a8-93d5-4b55-a273-6be20677431f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38a7e1b1-d0ea-4658-a6c9-ebadcab872da",
      target: "c7da7e10-345f-4491-8a28-72d9ccefb82a"
    },
    {
      id: "329915aa-b95e-4d89-b5db-06155a178d42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4984fa1c-2dfc-4802-a4b5-4c5a9c0fb8b8",
      target: "ad393807-f0aa-44dd-8bbd-05a4e7a3efdc"
    },
    {
      id: "3120a2bf-d715-4686-ad99-5aca2a594fa2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2533a20-0d53-45ea-b590-91cd67e41c2a",
      target: "c7da7e10-345f-4491-8a28-72d9ccefb82a"
    },
    {
      id: "6011170e-5ac4-4dd4-8641-16a5f4ef82ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f2285bd-838a-4496-b283-72265a23b8d8",
      target: "f47fcebd-ce11-4804-a0e4-6f2cb92f0ed3"
    },
    {
      id: "ed645941-5f87-4919-84bb-d812e29a8cf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f2285bd-838a-4496-b283-72265a23b8d8",
      target: "1351f692-8022-4e54-8888-a6468600c729"
    },
    {
      id: "e9acc163-b43e-4ed7-ac94-b4002c21da36",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c7da7e10-345f-4491-8a28-72d9ccefb82a",
      target: "7b14a916-deaa-4e4b-b674-03855ba5477c"
    },
    {
      id: "eaa9df82-04b4-4a52-adb2-1e851affd177",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7da7e10-345f-4491-8a28-72d9ccefb82a",
      target: "d39027c5-3342-4100-9261-ff860958971f"
    },
    {
      id: "d1a4120c-4f9b-4c84-b15a-f7a612d51278",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f47fcebd-ce11-4804-a0e4-6f2cb92f0ed3",
      target: "ad393807-f0aa-44dd-8bbd-05a4e7a3efdc"
    },
    {
      id: "f2e19f69-3781-45e7-a24d-d464218d302c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad393807-f0aa-44dd-8bbd-05a4e7a3efdc",
      target: "89a1abd8-4572-4cd6-9e2a-57a4c59d1444"
    },
    {
      id: "72582f2b-963c-459a-927a-02c6c9b90328",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89a1abd8-4572-4cd6-9e2a-57a4c59d1444",
      target: "86aacc13-abda-4617-989d-90f786abb89d"
    },
    {
      id: "823c1ebb-384c-4c9e-a295-2c84bb43f68d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86aacc13-abda-4617-989d-90f786abb89d",
      target: "922a62c7-3b0b-43b6-83ec-8061154b1c11"
    },
    {
      id: "e13775d9-b64f-4161-80da-95a33d26c314",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86aacc13-abda-4617-989d-90f786abb89d",
      target: "41f23984-1504-46d5-b342-56ef67c1024b"
    },
    {
      id: "afb39ce1-b8e0-438b-93b3-9319f60bc75e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86aacc13-abda-4617-989d-90f786abb89d",
      target: "fe7d7efc-c1f4-43cd-8d2d-b2e69d15aabc"
    },
    {
      id: "c886cba3-97e2-4132-b349-1c9ca69dc224",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "922a62c7-3b0b-43b6-83ec-8061154b1c11",
      target: "10dbb8d9-5c42-4ec4-871a-d221c1819aa0"
    },
    {
      id: "30bd4cb5-87ac-4c93-846b-bb68fb20588a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41f23984-1504-46d5-b342-56ef67c1024b",
      target: "7b14a916-deaa-4e4b-b674-03855ba5477c"
    },
    {
      id: "516c974e-b3d9-4d11-a856-771ea033d172",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41f23984-1504-46d5-b342-56ef67c1024b",
      target: "d39027c5-3342-4100-9261-ff860958971f"
    },
    {
      id: "a2b158e4-9503-4bdc-b466-b0233aec76a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41f23984-1504-46d5-b342-56ef67c1024b",
      target: "32197d4f-991d-4a60-a244-d393e14fa540"
    },
    {
      id: "87b19ae9-4d26-430b-9c42-e54d2402ed4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10dbb8d9-5c42-4ec4-871a-d221c1819aa0",
      target: "36942aef-cbe4-4d9e-a92b-23e741e20fd9"
    },
    {
      id: "041b002b-813f-4c47-9837-cc29d610dd47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b14a916-deaa-4e4b-b674-03855ba5477c",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "39e56ad2-9484-407f-96e5-ce0b0e2a61d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d39027c5-3342-4100-9261-ff860958971f",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "0df1d760-428d-427e-b5ab-da1474d88a21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32197d4f-991d-4a60-a244-d393e14fa540",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "ef82dc62-baf5-4c72-80f3-5b76118b4434",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32197d4f-991d-4a60-a244-d393e14fa540",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "c06839cc-b75b-4fa8-81d6-c3609746e3c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36942aef-cbe4-4d9e-a92b-23e741e20fd9",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "289371f9-b739-468b-84ee-c767706d6b33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "32ae8b71-2c75-4a65-af29-b15816a7a289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "1fc07893-c99f-4124-9a33-7ba4b221c7e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "bc26256c-deb1-4c63-813d-3a9a4f47c500"
    },
    {
      id: "96f28cf2-7b40-4b7d-bd8b-5fd3b0540223",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "d89953e0-55ff-4513-8fbe-1e1753f5b1de",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "4feac8d0-93be-4e82-b90d-84faa0be2957",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b733a21d-1483-4162-a070-02eed079bbb3",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "862a891d-3f6f-4580-98d0-d782e457be5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      target: "3b1a539b-1a08-4b84-8de7-1878451261e1"
    },
    {
      id: "f784e6ce-ec3d-4630-a147-34b6a8fb0d4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      target: "1d27fe08-66ca-4f61-919a-bad62b8d0cc8"
    },
    {
      id: "a7577b1f-eab2-4d8a-97e3-7a9aacb377db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      target: "10e6894b-4c13-4324-81c1-6839443e5099"
    },
    {
      id: "a40b4ad0-cd81-4339-9f3e-17d9776eddb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      target: "67777782-c5f2-4197-8228-5816389a65e2"
    },
    {
      id: "382ddac6-50f9-41f0-93c0-23ade7d2b6c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d7fee0-f942-4b24-b86b-37580a0f0f90",
      target: "1351f692-8022-4e54-8888-a6468600c729"
    },
    {
      id: "8d96176b-3774-49bc-bf7c-46b81cb8dcb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67777782-c5f2-4197-8228-5816389a65e2",
      target: "583c034a-1e6c-49c5-aad2-01bf4f1a4ef8"
    },
    {
      id: "52c98503-60ed-40ae-b450-770aa51dc15f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d27fe08-66ca-4f61-919a-bad62b8d0cc8",
      target: "42181f84-4685-4207-803b-0c0549cf83be"
    },
    {
      id: "c190588c-7700-4c28-b3ba-6dc916ac231d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1351f692-8022-4e54-8888-a6468600c729",
      target: "85daca7c-faff-48a2-bbbd-5cd315f37ba3"
    },
    {
      id: "16f1f162-ba47-4da2-8c1b-e13afb4b898b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b1a539b-1a08-4b84-8de7-1878451261e1",
      target: "42181f84-4685-4207-803b-0c0549cf83be"
    },
    {
      id: "f146f151-568d-4a0f-a5dc-0d0ed22e21ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10e6894b-4c13-4324-81c1-6839443e5099",
      target: "42181f84-4685-4207-803b-0c0549cf83be"
    },
    {
      id: "5c4ef87f-c6cc-449e-a52a-449a6d254a4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85daca7c-faff-48a2-bbbd-5cd315f37ba3",
      target: "583c034a-1e6c-49c5-aad2-01bf4f1a4ef8"
    },
    {
      id: "995351b5-c302-470d-ab7b-b292f7b6073d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "42181f84-4685-4207-803b-0c0549cf83be",
      target: "10ed9297-3fb3-46a9-8fc0-d26bd6f8467f"
    },
    {
      id: "571df6a3-ee82-40f3-8c87-a7c0ceee5ece",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42181f84-4685-4207-803b-0c0549cf83be",
      target: "665d38bf-4370-4cc4-a231-4348a32236da"
    },
    {
      id: "6885146a-eb4a-4f9d-ae29-c899ce2aefb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "583c034a-1e6c-49c5-aad2-01bf4f1a4ef8",
      target: "b2bf8efa-9f46-4ebe-a15b-98a3a8191296"
    },
    {
      id: "a49ed50e-9234-4907-b964-dbb50123b940",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2bf8efa-9f46-4ebe-a15b-98a3a8191296",
      target: "c24201dc-823c-44b6-82cc-3f9b8200e716"
    },
    {
      id: "7c14342b-c190-4ef9-8cad-6075e155a676",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c24201dc-823c-44b6-82cc-3f9b8200e716",
      target: "3cd7186c-518e-40a3-a348-69fa6a639817"
    },
    {
      id: "94ea81f4-0652-4efd-b1ce-154f7e6706eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd7186c-518e-40a3-a348-69fa6a639817",
      target: "8c42d50e-c3f1-4e8c-94e0-e8a626ae18bb"
    },
    {
      id: "4a9e46d2-9361-443d-b82b-1451dcab8c2c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3cd7186c-518e-40a3-a348-69fa6a639817",
      target: "eaf7c69a-484a-4ab0-a199-b4436346dec8"
    },
    {
      id: "33ce7a1b-b8ad-448a-a4f1-0b95c526e072",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd7186c-518e-40a3-a348-69fa6a639817",
      target: "665d38bf-4370-4cc4-a231-4348a32236da"
    },
    {
      id: "968da5ce-569f-4d5e-897c-8d1a83dd02d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd7186c-518e-40a3-a348-69fa6a639817",
      target: "10ed9297-3fb3-46a9-8fc0-d26bd6f8467f"
    },
    {
      id: "69144403-1267-4206-a9a2-7f4b7b9b0ce4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd7186c-518e-40a3-a348-69fa6a639817",
      target: "ac485bab-b7a8-486c-a3ba-c48f7d21ed99"
    },
    {
      id: "a1f641c9-80ff-4822-8aec-b523cbdc2f1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac485bab-b7a8-486c-a3ba-c48f7d21ed99",
      target: "971a2961-8489-47aa-b6eb-58d54e716b86"
    },
    {
      id: "3232ef7f-21c6-4f55-a6e5-2f54e1fc005b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac485bab-b7a8-486c-a3ba-c48f7d21ed99",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "0952e174-eba4-482f-b77a-8c57dac18cc5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10ed9297-3fb3-46a9-8fc0-d26bd6f8467f",
      target: "971a2961-8489-47aa-b6eb-58d54e716b86"
    },
    {
      id: "36f9d236-16b8-40cc-8e7e-9edaf0a1bc6f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "665d38bf-4370-4cc4-a231-4348a32236da",
      target: "971a2961-8489-47aa-b6eb-58d54e716b86"
    },
    {
      id: "4f5da0b9-dcec-4bb7-9579-948c5b0c6995",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eaf7c69a-484a-4ab0-a199-b4436346dec8",
      target: "6142b5a6-5085-4013-b75a-161e1b24f0a4"
    },
    {
      id: "69bd3e2b-757c-49ae-b62f-eff7f484bdbd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8c42d50e-c3f1-4e8c-94e0-e8a626ae18bb",
      target: "eaf7c69a-484a-4ab0-a199-b4436346dec8"
    },
    {
      id: "b532f53d-7f2a-44aa-9934-a0a631d57af2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c42d50e-c3f1-4e8c-94e0-e8a626ae18bb",
      target: "7046f8c6-bbe0-4936-8f84-a466deb40f32"
    },
    {
      id: "e9bcf3f6-19ff-4e20-a876-c1dc3354f5e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6142b5a6-5085-4013-b75a-161e1b24f0a4",
      target: "e8f9c7d3-11e6-4ca9-be0f-e5958e45c929"
    },
    {
      id: "6823e351-72aa-4301-ab03-36f4d7023d87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7046f8c6-bbe0-4936-8f84-a466deb40f32",
      target: "971a2961-8489-47aa-b6eb-58d54e716b86"
    },
    {
      id: "c8638341-c800-471a-b515-2c97bff13868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8f9c7d3-11e6-4ca9-be0f-e5958e45c929",
      target: "971a2961-8489-47aa-b6eb-58d54e716b86"
    },
    {
      id: "efef2d7a-3bd2-4938-b277-848facf0fa7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "971a2961-8489-47aa-b6eb-58d54e716b86",
      target: "b733a21d-1483-4162-a070-02eed079bbb3"
    },
    {
      id: "e2ac67b7-600e-4370-ae69-4d12f9405774",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "971a2961-8489-47aa-b6eb-58d54e716b86",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "17f8b8de-16b2-4db2-b3f0-90a36b5d2728",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "971a2961-8489-47aa-b6eb-58d54e716b86",
      target: "9b392fd7-450f-4ead-a14e-cec5e6b13630"
    },
    {
      id: "1d2d9d71-dbd2-425d-a757-ae4a1fadf6a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "971a2961-8489-47aa-b6eb-58d54e716b86",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "54b685ad-cf7d-4e12-b2f1-e214c53df7c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f181a111-52cc-4662-bb49-ea19375faa96",
      target: "23ac81e5-10ce-4f42-98f8-bfb47ada708a"
    },
    {
      id: "cf3c6eea-7eeb-4640-829a-18d5838dc699",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "980633c9-3fcd-4932-b20f-2d50122837b7"
    },
    {
      id: "afc957a3-f12a-4d11-9df7-fbab2e8891de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "df125867-a6eb-444d-a4f8-ee5c816596a2"
    },
    {
      id: "2707adb7-e1a2-4c6c-8117-630cc005e3be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "71a3d173-ebfb-4922-9117-d061cce6217b"
    },
    {
      id: "ac355f75-6253-4b3c-89b1-dc8fc5f15690",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "e1399b89-ab93-4919-8688-8310e829fe41"
    },
    {
      id: "3a3a0929-927a-43b8-8016-4c02d8caf6e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "bb214aea-e7e6-4f1c-ada4-9396abe8bbcd"
    },
    {
      id: "065acb09-01c1-43a3-a10f-aa46ff7d8868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "95ab1f1c-0ae5-44af-adb9-8225b7058cef"
    },
    {
      id: "2054938b-1ce2-40e1-b4be-6597f1f668d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23ac81e5-10ce-4f42-98f8-bfb47ada708a",
      target: "a541a224-bc86-42a2-82a7-4415b24374e1"
    },
    {
      id: "04869abb-441e-4cb6-a525-aab6f79fc33a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "980633c9-3fcd-4932-b20f-2d50122837b7",
      target: "bf5b3812-aeb9-48bd-8e73-c3593e735648"
    },
    {
      id: "a4a5f703-a5dc-44fa-91b8-dcfb3efd642f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71a3d173-ebfb-4922-9117-d061cce6217b",
      target: "758147f6-cdd0-4f5b-b882-ebc2374e4b40"
    },
    {
      id: "3103df19-2e5a-49fd-9486-76596c2ef42e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a541a224-bc86-42a2-82a7-4415b24374e1",
      target: "2e6fd349-9798-4d77-b947-f922686d4d0d"
    },
    {
      id: "980f356f-7a32-41a5-a2f7-baa63eccfe82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb214aea-e7e6-4f1c-ada4-9396abe8bbcd",
      target: "758147f6-cdd0-4f5b-b882-ebc2374e4b40"
    },
    {
      id: "5ec0865c-c9a8-44e5-9812-d648aa9096aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95ab1f1c-0ae5-44af-adb9-8225b7058cef",
      target: "758147f6-cdd0-4f5b-b882-ebc2374e4b40"
    },
    {
      id: "9edaa233-adb9-407d-aca4-b2fa35ae5567",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1399b89-ab93-4919-8688-8310e829fe41",
      target: "758147f6-cdd0-4f5b-b882-ebc2374e4b40"
    },
    {
      id: "0887cff2-b651-4b23-94fa-c523b7e09446",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "758147f6-cdd0-4f5b-b882-ebc2374e4b40",
      target: "082579cd-1314-4a33-a310-f58092660932"
    },
    {
      id: "b08fc527-2baa-4214-86e2-ce0dd70647c7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "758147f6-cdd0-4f5b-b882-ebc2374e4b40",
      target: "6e354b29-5a6a-4c70-b1fe-fbea803605ce"
    },
    {
      id: "7df682c4-0f2d-4ff6-a952-8260a56f1a95",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6fd349-9798-4d77-b947-f922686d4d0d",
      target: "bf5b3812-aeb9-48bd-8e73-c3593e735648"
    },
    {
      id: "3460933c-221c-40d7-be92-7c1bb30e0fc1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf5b3812-aeb9-48bd-8e73-c3593e735648",
      target: "59ca1a3b-b178-4647-8534-2aa7ee9887fb"
    },
    {
      id: "982b4e45-92e3-461d-bd65-8ee8596156f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59ca1a3b-b178-4647-8534-2aa7ee9887fb",
      target: "32239216-1d56-4b8c-8717-cb39ff680350"
    },
    {
      id: "0fbc3666-e0d5-4d82-bd5f-180a6578a4c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32239216-1d56-4b8c-8717-cb39ff680350",
      target: "3d773bed-6608-45df-840f-bf38db676f7a"
    },
    {
      id: "86e47f1b-b3af-4f1f-943e-0497d4520ec8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32239216-1d56-4b8c-8717-cb39ff680350",
      target: "60156f69-4668-4fde-837d-f44706e6da8d"
    },
    {
      id: "e0c9b4d4-9f97-4393-9abd-bbd11e3ec335",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32239216-1d56-4b8c-8717-cb39ff680350",
      target: "990e7047-18a5-4f35-8d46-972739abe902"
    },
    {
      id: "987b95b8-bb2c-4c93-b027-89498a077f3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32239216-1d56-4b8c-8717-cb39ff680350",
      target: "c662b4ef-8ce9-4062-afd3-76e0f22e8157"
    },
    {
      id: "4b0eee8e-2cd4-449d-b2f8-ce43acd93f68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60156f69-4668-4fde-837d-f44706e6da8d",
      target: "7d4323cc-0b3f-43ba-9910-904cab280417"
    },
    {
      id: "c2d735dd-4cdd-4f7f-b88a-0332f1ba0251",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d773bed-6608-45df-840f-bf38db676f7a",
      target: "082579cd-1314-4a33-a310-f58092660932"
    },
    {
      id: "846b63b5-0dd7-4eec-b0de-d4fd3df5d4c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d773bed-6608-45df-840f-bf38db676f7a",
      target: "42b85903-0569-451d-99c5-b076a5e46f01"
    },
    {
      id: "1e46045c-a615-4cfa-9312-0412b29d805d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d773bed-6608-45df-840f-bf38db676f7a",
      target: "6e354b29-5a6a-4c70-b1fe-fbea803605ce"
    },
    {
      id: "cbd599b5-a3ac-4769-9f11-d025490f3c93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d4323cc-0b3f-43ba-9910-904cab280417",
      target: "9d27a7bb-0b3e-4370-98e3-5fd0c9b6865d"
    },
    {
      id: "c41eace4-25e7-43da-b38c-0c6acca70d68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e354b29-5a6a-4c70-b1fe-fbea803605ce",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "d81fc3fd-b4e5-4142-b86f-11d3446c3c5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "082579cd-1314-4a33-a310-f58092660932",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "70176ebd-1f0b-4070-8e09-e78f32f2f500",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42b85903-0569-451d-99c5-b076a5e46f01",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "f3acdc9e-81db-4b94-ba1e-f235a7ee1f47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d27a7bb-0b3e-4370-98e3-5fd0c9b6865d",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "156434a6-52f7-401b-8064-881d7dd60e3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4909fc-685a-4acb-8c64-cdb640f6e236",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "184f6007-f015-4fea-8c41-091c7ef72052",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4909fc-685a-4acb-8c64-cdb640f6e236",
      target: "75983700-34ca-4bef-a5b8-95b3d5be2fe0"
    },
    {
      id: "d1c73879-c207-4a95-87f1-b5fe252e8b23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4909fc-685a-4acb-8c64-cdb640f6e236",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "2d5bd362-71b1-4c84-b9df-5a8a03d09a46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b4909fc-685a-4acb-8c64-cdb640f6e236",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "c2c17c9c-e0b6-492d-ab56-c655907526f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "990e7047-18a5-4f35-8d46-972739abe902",
      target: "95889109-3260-43ba-893a-e3bdf76351dd"
    },
    {
      id: "e1655589-27c0-4a43-8b1c-c42ccdb07628",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95889109-3260-43ba-893a-e3bdf76351dd",
      target: "80cf1291-915a-49f3-81de-94c6598fe971"
    },
    {
      id: "558c0e22-48b5-4f67-899f-decf3170e198",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80cf1291-915a-49f3-81de-94c6598fe971",
      target: "d35d841b-61b4-47a6-bfce-efcc34d1e4aa"
    },
    {
      id: "f04f8fe6-61e8-41d8-9782-65edb21e3aa9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d35d841b-61b4-47a6-bfce-efcc34d1e4aa",
      target: "32eec1a6-6915-4c79-a7cd-c5cc8bfa57fd"
    },
    {
      id: "44b74896-b363-4dd6-b4bc-9edc29a49e89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d35d841b-61b4-47a6-bfce-efcc34d1e4aa",
      target: "3a6975cb-05be-484e-ad90-774be5bbff35"
    },
    {
      id: "c4dc3ed0-0821-47e6-9c97-9076c66c7f75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32eec1a6-6915-4c79-a7cd-c5cc8bfa57fd",
      target: "0256923c-cf68-4d03-b14b-d50d74261f0c"
    },
    {
      id: "29822b22-7e92-47ef-8a22-69d61b142a28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a6975cb-05be-484e-ad90-774be5bbff35",
      target: "2d7810a9-51bb-4800-933f-6d4c89f7268f"
    },
    {
      id: "c38e37bd-b8a6-4f2a-adb7-e3fec919cfaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0256923c-cf68-4d03-b14b-d50d74261f0c",
      target: "2d7810a9-51bb-4800-933f-6d4c89f7268f"
    },
    {
      id: "b780c1f3-2696-4cd5-a872-51012966677f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d7810a9-51bb-4800-933f-6d4c89f7268f",
      target: "c3ca8ee2-0a61-489f-b8c6-fe806ddaa3e2"
    },
    {
      id: "6a9b37ea-3224-41d8-b162-ee94894d218c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3ca8ee2-0a61-489f-b8c6-fe806ddaa3e2",
      target: "bfed2800-deca-4e25-90e9-11fe61e97f4d"
    },
    {
      id: "2019f38c-4d43-4909-9050-2dc3f4f7bbdc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfed2800-deca-4e25-90e9-11fe61e97f4d",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "db952e95-2e94-4395-af86-9cc34b018768",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c662b4ef-8ce9-4062-afd3-76e0f22e8157",
      target: "3488d7eb-3de5-4bc5-aa74-827557aafac9"
    },
    {
      id: "b23df88b-9971-40c7-a400-60b52eee618d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3488d7eb-3de5-4bc5-aa74-827557aafac9",
      target: "f614e5dc-bf45-4ce0-8d65-918cf4f7efbb"
    },
    {
      id: "71a7f3cb-5094-4e7b-bb46-519fc2fd6e38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f614e5dc-bf45-4ce0-8d65-918cf4f7efbb",
      target: "a9ca1925-4d3f-468a-9607-35fe07b468fb"
    },
    {
      id: "ebe66a52-09b0-4f8d-95b6-291de487ca44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9ca1925-4d3f-468a-9607-35fe07b468fb",
      target: "90b94368-430f-4f0f-a6e6-026bac123681"
    },
    {
      id: "beb023d8-72b3-46a4-a1e9-4cecba59aeeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9ca1925-4d3f-468a-9607-35fe07b468fb",
      target: "18034876-d990-48c1-a98b-f345b9729865"
    },
    {
      id: "5ec585c8-31ef-49fd-ac74-cbbf3a8d31ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "90b94368-430f-4f0f-a6e6-026bac123681",
      target: "1ae91f04-7bd0-4120-a9ec-abf196c0be1d"
    },
    {
      id: "eb1c1945-a5bc-4e3a-ae1d-b736d88e03aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18034876-d990-48c1-a98b-f345b9729865",
      target: "6d617624-6758-4414-b292-5cbc0249c40d"
    },
    {
      id: "91e59186-2d86-45ad-b783-de4cf8006c5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ae91f04-7bd0-4120-a9ec-abf196c0be1d",
      target: "6d617624-6758-4414-b292-5cbc0249c40d"
    },
    {
      id: "57c8585c-4c3c-4706-9fde-402bd65e06fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d617624-6758-4414-b292-5cbc0249c40d",
      target: "dafcedc3-46c9-4d69-bb77-e2cd9c0e22b8"
    },
    {
      id: "89725941-7afc-450e-8006-2f3521fa6ab1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dafcedc3-46c9-4d69-bb77-e2cd9c0e22b8",
      target: "99bd6d34-dcc8-44a2-b361-21698415a6d6"
    },
    {
      id: "907b3653-ab3d-40fa-ab07-fa40ca6d7ce0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99bd6d34-dcc8-44a2-b361-21698415a6d6",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "a0d2ad5d-6daa-47c5-a9be-b0299b7c4f11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df125867-a6eb-444d-a4f8-ee5c816596a2",
      target: "918dd7b1-d031-4c21-b771-1664d4c0fd81"
    },
    {
      id: "b4807825-5967-4669-bced-ffc5e8f56108",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "918dd7b1-d031-4c21-b771-1664d4c0fd81",
      target: "5317568f-1f66-44b8-919a-1d0ab5351796"
    },
    {
      id: "a7fec0db-b806-4330-b5e0-04f7a48c06bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5317568f-1f66-44b8-919a-1d0ab5351796",
      target: "a5af6e72-a5c1-4335-a495-64ee36264f2d"
    },
    {
      id: "ec2a9549-9cd4-432b-bb54-532f34d72963",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5af6e72-a5c1-4335-a495-64ee36264f2d",
      target: "35f8862a-e544-42b7-a308-c23b212e7d90"
    },
    {
      id: "c880edf2-5909-4393-928d-2552f29c83ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35f8862a-e544-42b7-a308-c23b212e7d90",
      target: "a30805a1-908f-4f5c-9e23-30230e8de167"
    },
    {
      id: "22165add-6edf-40ab-b579-cb686ad873ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a30805a1-908f-4f5c-9e23-30230e8de167",
      target: "da5287b0-2e40-4902-bfef-ea8fcb680728"
    },
    {
      id: "b4f05ae5-0329-4cc1-934b-bc49287569a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da5287b0-2e40-4902-bfef-ea8fcb680728",
      target: "686340e1-eb79-49ab-a0c5-0dbd2807b140"
    },
    {
      id: "6e5e2b09-225c-43f5-858e-d44e5cf2807c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "0063a949-8eb5-4008-acd7-2ddda72b7db7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "c048762d-b888-4a2b-8b77-d0b842a67069"
    },
    {
      id: "196a9848-ec6f-4842-b5df-0e101b0a7d24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "2c4e5ecc-cf3b-41e7-a038-473f384d9c71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "3b4909fc-685a-4acb-8c64-cdb640f6e236"
    },
    {
      id: "832c1117-1a7d-412f-b57c-bcb06500b661",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "d1ee35c0-ab7f-416a-8e2d-c3526227a0a1"
    },
    {
      id: "7e4afbbb-cf43-44fe-8f2c-3bb9fb449fc2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "9543b335-4d67-4a0a-82a0-208931651285",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "686340e1-eb79-49ab-a0c5-0dbd2807b140",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "9e70976f-2f0e-40fb-9db3-45b4324636f6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "ddd25096-11f7-4bde-bdba-86892e987ce6"
    },
    {
      id: "e033cff7-825b-4f14-a3dd-f76456524cde",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "ea84c061-1b01-4ab2-a0c0-3c77acd34fb5"
    },
    {
      id: "685967f4-e93f-4a17-b7b0-872a0d813bf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "def49e23-f658-4b58-83fd-d348d1d0a0fa"
    },
    {
      id: "ffb9f851-3fa3-4f6f-8ee8-866eeb00f791",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "a5794235-9496-4110-bc2a-2645b05e22c1"
    },
    {
      id: "25967dd2-3c60-45b5-9f1a-37300ee8326c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "fcb414f2-390a-4870-a33e-898663fa8e82"
    },
    {
      id: "3e9c1682-dbfc-476b-aa0f-17152f604da7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "f7ff0818-aa27-46f3-b0d1-bfeff763e5c3"
    },
    {
      id: "2b6b4b0a-3da1-4d0b-a179-6f12eb5249e7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "ddd25096-11f7-4bde-bdba-86892e987ce6"
    },
    {
      id: "be6e7bae-f301-4565-bd85-f817b1ec1182",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87f14436-2fcc-45cc-9e01-d0dabe0fe228",
      target: "da4a993b-47fc-4eb2-adfe-a06962929a74"
    },
    {
      id: "683a26e7-ef90-4ee1-b810-89c748450ed9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ddd25096-11f7-4bde-bdba-86892e987ce6",
      target: "48765d17-c558-484e-9b2c-d26c1754da21"
    },
    {
      id: "45e5cac4-7b05-4e83-a01e-a344306a65f2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ddd25096-11f7-4bde-bdba-86892e987ce6",
      target: "dd986823-19df-4887-8874-e07a81769ca1"
    },
    {
      id: "26a71e45-aee4-4a0f-9256-b1c37f24b005",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ea84c061-1b01-4ab2-a0c0-3c77acd34fb5",
      target: "37b73365-da5f-44bf-a3a9-4cc2c41642fa"
    },
    {
      id: "f0d52823-7f93-40ab-96a3-6b54e60397cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7ff0818-aa27-46f3-b0d1-bfeff763e5c3",
      target: "dd986823-19df-4887-8874-e07a81769ca1"
    },
    {
      id: "4e1b239b-d7b3-4a21-a712-8d59cca38839",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd986823-19df-4887-8874-e07a81769ca1",
      target: "9e72c1c8-f8b4-498c-958f-8757010c1955"
    },
    {
      id: "a707c0ed-df48-4283-b118-2be65a011d0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48765d17-c558-484e-9b2c-d26c1754da21",
      target: "37b73365-da5f-44bf-a3a9-4cc2c41642fa"
    },
    {
      id: "bb4fc958-8a55-4c5e-8e40-e0646fab8311",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e72c1c8-f8b4-498c-958f-8757010c1955",
      target: "37b73365-da5f-44bf-a3a9-4cc2c41642fa"
    },
    {
      id: "b4b06e31-125b-49e0-9daa-a96a5ad805e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37b73365-da5f-44bf-a3a9-4cc2c41642fa",
      target: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc"
    },
    {
      id: "deecdb42-d277-4ca1-adee-34837ca6f2c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37b73365-da5f-44bf-a3a9-4cc2c41642fa",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "414b2343-d083-4086-beeb-672b5d32bf4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37b73365-da5f-44bf-a3a9-4cc2c41642fa",
      target: "7cf24f9c-0c7e-499c-8d04-f19c6648404e"
    },
    {
      id: "24baa041-216c-440d-b37a-11b2725c27c2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7cf24f9c-0c7e-499c-8d04-f19c6648404e",
      target: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc"
    },
    {
      id: "323ee4c5-efd3-4deb-8871-3d75d468eb00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf24f9c-0c7e-499c-8d04-f19c6648404e",
      target: "c249ab2c-cfe1-452a-9c38-a2a761b1553c"
    },
    {
      id: "cc6c5b57-12e0-48d6-a266-29e20b273d51",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf24f9c-0c7e-499c-8d04-f19c6648404e",
      target: "26e8617e-7c73-4a22-8dce-c8a81f5672da"
    },
    {
      id: "8e4a03b9-5b3b-44c6-89e9-073d457fa692",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc",
      target: "8a69e383-0c26-404f-9dfa-f2a8f7ec976f"
    },
    {
      id: "bef94bb7-d488-410f-a274-cc1d78d72cbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ff9bc92-ce77-4390-8a2e-17b4fbe134cc",
      target: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52"
    },
    {
      id: "cdee1015-ec49-4263-8eb1-dc2bb8cfdb43",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8a69e383-0c26-404f-9dfa-f2a8f7ec976f",
      target: "727c2ac2-cf76-45d9-996e-41d67311c83d"
    },
    {
      id: "042d2180-c971-4a0b-b563-95a04922121e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "727c2ac2-cf76-45d9-996e-41d67311c83d",
      target: "e6649980-f177-481c-950e-d733e9a7c689"
    },
    {
      id: "38b7ddf1-c335-4503-8a32-ffc92c8a6f90",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e6649980-f177-481c-950e-d733e9a7c689",
      target: "035e22cc-18b7-4458-b571-7d0325364652"
    },
    {
      id: "4bd10c16-11a1-48ef-bbe3-e0a356f96664",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6649980-f177-481c-950e-d733e9a7c689",
      target: "035e22cc-18b7-4458-b571-7d0325364652"
    },
    {
      id: "97c87be6-0534-40c3-9907-1783cb2b4b8f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e6649980-f177-481c-950e-d733e9a7c689",
      target: "4700a17a-41de-4d09-932d-646af5bef852"
    },
    {
      id: "38ef832f-2ccb-4d02-bb05-97cc28b5e79b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "035e22cc-18b7-4458-b571-7d0325364652",
      target: "3ef449ea-d160-48e6-9c6c-1f5fbedf706d"
    },
    {
      id: "034918f4-a09e-4f12-aa65-6e79c5d6f080",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "035e22cc-18b7-4458-b571-7d0325364652",
      target: "6e38b4b2-a555-4b02-8d54-8eee0c45ce03"
    },
    {
      id: "8230a96e-7b03-44b1-83f6-c95dfad57ef0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26e8617e-7c73-4a22-8dce-c8a81f5672da",
      target: "ec1a8792-c342-40d1-89c5-b1b3edd3acbf"
    },
    {
      id: "6e1a9a56-ac23-4fe3-8f27-ed04f136029a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6e38b4b2-a555-4b02-8d54-8eee0c45ce03",
      target: "cdb770a0-3e26-4554-9542-71296c77983c"
    },
    {
      id: "ef2dbf5a-bf60-4d32-b7ca-58de45a41899",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cdb770a0-3e26-4554-9542-71296c77983c",
      target: "ec1a8792-c342-40d1-89c5-b1b3edd3acbf"
    },
    {
      id: "ed2c89fa-2a67-4730-92ae-6500b097bc11",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec1a8792-c342-40d1-89c5-b1b3edd3acbf",
      target: "31461867-6580-433d-94cd-33c955774fc0"
    },
    {
      id: "16c54344-9215-43a2-9219-2b02e3758473",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4700a17a-41de-4d09-932d-646af5bef852",
      target: "6817dfc1-0273-4e9f-a884-cfbf3a513d62"
    },
    {
      id: "3587309c-1c22-4bbc-92da-430cb2377c9c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "31461867-6580-433d-94cd-33c955774fc0",
      target: "8378fdd1-5f48-4fe7-9aa0-90e91ba14421"
    },
    {
      id: "a62fc51f-3482-4e46-a59c-07edbaac6241",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8378fdd1-5f48-4fe7-9aa0-90e91ba14421",
      target: "bd2743ee-f5f7-4244-9acd-de51e09905e0"
    },
    {
      id: "7b064e20-e887-4a38-b888-ccdc0fd54c03",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bd2743ee-f5f7-4244-9acd-de51e09905e0",
      target: "62da7c81-f2c5-4332-9024-f2763b07aca5"
    },
    {
      id: "ea9a78d6-fc6f-433d-b541-fbccb4d59987",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bd2743ee-f5f7-4244-9acd-de51e09905e0",
      target: "3dc9e2db-503d-47a6-bb0d-9c66b3706040"
    },
    {
      id: "c3eb4dcc-c555-48d8-96bb-4f78c7c15787",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bd2743ee-f5f7-4244-9acd-de51e09905e0",
      target: "ae2bab53-e1d4-4395-8ca9-6c3a7a61cbc3"
    },
    {
      id: "4e9aed7e-7947-4b4d-a9d7-22941c70b865",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "62da7c81-f2c5-4332-9024-f2763b07aca5",
      target: "5f56be1c-c476-403f-a5dd-4a3329f06fd6"
    },
    {
      id: "502a30e3-639d-406b-8e5c-7714cca0e4f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62da7c81-f2c5-4332-9024-f2763b07aca5",
      target: "14fe8d85-e744-4eb3-816d-a9b7a41f7f7a"
    },
    {
      id: "5553fd6b-834f-4a4a-9b39-a7f7bb0c7e1d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae2bab53-e1d4-4395-8ca9-6c3a7a61cbc3",
      target: "a359f2e6-2c6b-41eb-8fb1-79ed9f89b547"
    },
    {
      id: "dc5d6530-afa8-41be-ac72-a84c582011dc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae2bab53-e1d4-4395-8ca9-6c3a7a61cbc3",
      target: "195b01c7-ca3f-4020-81af-4c8389420740"
    },
    {
      id: "46b53ec7-3bdb-4cc8-9d33-b7df54029be3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3dc9e2db-503d-47a6-bb0d-9c66b3706040",
      target: "12e2f435-f4a8-4b0d-a09f-8e43870a1c8c"
    },
    {
      id: "c3f7e6c0-942b-401b-8a49-921d407012d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3dc9e2db-503d-47a6-bb0d-9c66b3706040",
      target: "5f56be1c-c476-403f-a5dd-4a3329f06fd6"
    },
    {
      id: "fb37cbbe-606a-4f57-8209-3ca1fcfdbdbe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5f56be1c-c476-403f-a5dd-4a3329f06fd6",
      target: "533e7156-a315-4056-8900-2579f62f2ca0"
    },
    {
      id: "85b30b5f-794e-4391-bb82-9de739402404",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "12e2f435-f4a8-4b0d-a09f-8e43870a1c8c",
      target: "8eff4dd1-d6ce-48b1-b262-9c04c2549570"
    },
    {
      id: "46c7127f-a285-43b9-a145-7d5974d7a4a9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a359f2e6-2c6b-41eb-8fb1-79ed9f89b547",
      target: "b426f8b7-5e94-4a14-9d9c-0f35f9996105"
    },
    {
      id: "7af81de7-593d-4fda-82a7-dea6edf929c2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "195b01c7-ca3f-4020-81af-4c8389420740",
      target: "b426f8b7-5e94-4a14-9d9c-0f35f9996105"
    },
    {
      id: "86d80b5c-840e-49b3-9397-e7a81b4f3310",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b426f8b7-5e94-4a14-9d9c-0f35f9996105",
      target: "5cc7e252-0392-492b-8525-3cd43e06ffa9"
    },
    {
      id: "75d9596e-bc31-449f-83c7-2670abe252ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b426f8b7-5e94-4a14-9d9c-0f35f9996105",
      target: "533e7156-a315-4056-8900-2579f62f2ca0"
    },
    {
      id: "16217d6d-539b-4aff-9cb2-43bb9d1e0e95",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "533e7156-a315-4056-8900-2579f62f2ca0",
      target: "8eff4dd1-d6ce-48b1-b262-9c04c2549570"
    },
    {
      id: "f0eebc27-04b6-4240-9a2c-e7bbddfea4f8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8eff4dd1-d6ce-48b1-b262-9c04c2549570",
      target: "527b9b01-fa31-4ffa-93cf-bb586a4058f5"
    },
    {
      id: "e2699494-df9a-4f92-9f31-a23e25ecf670",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8eff4dd1-d6ce-48b1-b262-9c04c2549570",
      target: "acbf35b3-a9f3-44a3-8930-8f19a6e02524"
    },
    {
      id: "96275c57-08b3-4793-895b-76231da319c0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8eff4dd1-d6ce-48b1-b262-9c04c2549570",
      target: "a3586561-e9c6-4a5a-9d0b-1cedba88d7bb"
    },
    {
      id: "318a0d5f-c9f9-41b3-a701-ce601ff887ba",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8eff4dd1-d6ce-48b1-b262-9c04c2549570",
      target: "ebaa5692-ddb2-48ba-b3d1-e12d6fe7b00c"
    },
    {
      id: "3f9bcb96-7846-431c-a7a3-de5af8e79e6e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5cc7e252-0392-492b-8525-3cd43e06ffa9",
      target: "6060f3e2-f7f3-4f5e-8a19-b27573204d71"
    },
    {
      id: "f0412bc0-85c5-430f-b02a-6e6ac4e279d3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14fe8d85-e744-4eb3-816d-a9b7a41f7f7a",
      target: "5f56be1c-c476-403f-a5dd-4a3329f06fd6"
    },
    {
      id: "83000b83-11c4-44b5-84a9-800618dbb085",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3586561-e9c6-4a5a-9d0b-1cedba88d7bb",
      target: "6060f3e2-f7f3-4f5e-8a19-b27573204d71"
    },
    {
      id: "a39be8aa-50a4-4c18-9b7e-9d382c73170e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "acbf35b3-a9f3-44a3-8930-8f19a6e02524",
      target: "6060f3e2-f7f3-4f5e-8a19-b27573204d71"
    },
    {
      id: "8767a10b-9987-4f47-92b7-7779be4b040f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "527b9b01-fa31-4ffa-93cf-bb586a4058f5",
      target: "6060f3e2-f7f3-4f5e-8a19-b27573204d71"
    },
    {
      id: "62cd496d-a9ec-4c3b-a07f-6aaa9c77012c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ebaa5692-ddb2-48ba-b3d1-e12d6fe7b00c",
      target: "6060f3e2-f7f3-4f5e-8a19-b27573204d71"
    },
    {
      id: "b4fee02b-7cbd-4109-a008-7e7b45a06109",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6060f3e2-f7f3-4f5e-8a19-b27573204d71",
      target: "cec926f1-5e70-4454-ab31-860802bff000"
    },
    {
      id: "82f87004-f947-42b6-ae96-6a27f759b3e0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cec926f1-5e70-4454-ab31-860802bff000",
      target: "a0f193ed-2cfb-4127-8716-6072ecb0d7ec"
    },
    {
      id: "96f55690-7206-475d-bf48-e2eb95a075ce",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a0f193ed-2cfb-4127-8716-6072ecb0d7ec",
      target: "fa98095d-1b81-4c23-ae9f-f333318f61bd"
    },
    {
      id: "9b1c06c2-af8d-4926-90c8-7cc9fcd60db7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fa98095d-1b81-4c23-ae9f-f333318f61bd",
      target: "29b867ba-3259-4b2f-b3af-9e62932d8146"
    },
    {
      id: "9232d542-eee7-4b3b-9f6d-7776896dc778",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "29b867ba-3259-4b2f-b3af-9e62932d8146",
      target: "6817dfc1-0273-4e9f-a884-cfbf3a513d62"
    },
    {
      id: "a7b349c5-e40d-4d8a-ab8d-76cda8e3d1cd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6817dfc1-0273-4e9f-a884-cfbf3a513d62",
      target: "f9694fe6-22e6-41c1-a548-8d45e738a205"
    },
    {
      id: "4d93a6bb-5662-40ea-8b9e-27e7160fb655",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6817dfc1-0273-4e9f-a884-cfbf3a513d62",
      target: "347a5a1c-1296-4577-bd61-0caa76198185"
    },
    {
      id: "81861c99-b3fb-46e0-a0c6-da85075d28d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9694fe6-22e6-41c1-a548-8d45e738a205",
      target: "923c2b3b-00ed-4e98-8732-fd637793ae9c"
    },
    {
      id: "ce959f43-6245-4f34-880e-83555228ced0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "923c2b3b-00ed-4e98-8732-fd637793ae9c",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "79dae671-e659-4ca2-af92-be752f97efec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "923c2b3b-00ed-4e98-8732-fd637793ae9c",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "171f6549-d874-472e-91e6-1c3a20ffb856",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "4b9350f6-eca7-4f51-93c2-67a0fa8f0b29"
    },
    {
      id: "cb83e138-64bd-40ef-b7f6-6a66a5214c84",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "83ffac24-2ea4-4829-b741-541365942fb8"
    },
    {
      id: "714c9aae-d9da-4e01-bb5c-a52209f4ff63",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "240727d0-87c1-4e65-a6df-607f81f86df4"
    },
    {
      id: "7780521e-aa6b-411c-8191-0913e6cfd908",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "4b9350f6-eca7-4f51-93c2-67a0fa8f0b29"
    },
    {
      id: "8f823b50-0fe7-4eb6-9c62-e6eb460d4dbe",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "240727d0-87c1-4e65-a6df-607f81f86df4"
    },
    {
      id: "d6cfe2a5-5167-404c-bf45-d6b617767039",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a5794235-9496-4110-bc2a-2645b05e22c1",
      target: "83ffac24-2ea4-4829-b741-541365942fb8"
    },
    {
      id: "5ad2eb16-bb59-46d8-93e0-684b056b7c26",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4b9350f6-eca7-4f51-93c2-67a0fa8f0b29",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "4767dd4c-a555-473e-b954-1ff53fce23cc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b9350f6-eca7-4f51-93c2-67a0fa8f0b29",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "572875b3-51f3-442b-b731-836687e1a617",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c85d693-2cec-42fa-814f-5d26ed8dbb21",
      target: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd"
    },
    {
      id: "bfaca7a3-9a80-4873-bf86-867d9d2b625b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c85d693-2cec-42fa-814f-5d26ed8dbb21",
      target: "206283d0-e423-4c0a-a891-8e8b3ddff94a"
    },
    {
      id: "ab2689c1-d607-49bc-aeac-4f031fcc2c6b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c85d693-2cec-42fa-814f-5d26ed8dbb21",
      target: "cd81e48d-988c-4708-ba0f-1a8b696c93e7"
    },
    {
      id: "abd113e7-02bb-4a2c-bac1-a981272fe7e6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0c85d693-2cec-42fa-814f-5d26ed8dbb21",
      target: "015154f2-cb25-462f-8497-1e3d1adfe3c4"
    },
    {
      id: "2011349b-cae9-485a-968e-865e1a590cc4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "83ffac24-2ea4-4829-b741-541365942fb8",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "056b1b62-36f8-4178-8616-411556815d62",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "83ffac24-2ea4-4829-b741-541365942fb8",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "b9e12d64-c7fe-4302-a9a7-911ccb98376f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "240727d0-87c1-4e65-a6df-607f81f86df4",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "ae0ebb0b-d0ce-4e3e-8df3-8ce2b6b10a32",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "240727d0-87c1-4e65-a6df-607f81f86df4",
      target: "0c85d693-2cec-42fa-814f-5d26ed8dbb21"
    },
    {
      id: "8cde3398-9553-4864-b6ee-892101d6c072",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "206283d0-e423-4c0a-a891-8e8b3ddff94a",
      target: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd"
    },
    {
      id: "d564973c-fd15-4b67-8542-3ec953e9e4b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "015154f2-cb25-462f-8497-1e3d1adfe3c4",
      target: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd"
    },
    {
      id: "a5ce52d9-7d7e-4e00-9c7c-dfabaaf3c53e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd81e48d-988c-4708-ba0f-1a8b696c93e7",
      target: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd"
    },
    {
      id: "0ff6d709-d034-46c4-b177-1b828dfa2f8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cef1bdd-ef48-4e88-96a1-c174f0870dbd",
      target: "7d23d5da-b4d3-4825-b653-c67882cf9119"
    },
    {
      id: "58cacb41-3dde-4d82-8549-159c0be0f83c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d23d5da-b4d3-4825-b653-c67882cf9119",
      target: "689af013-a550-48af-af52-783a8539b04b"
    },
    {
      id: "91261e5d-b55c-48a4-9637-53cf5ecc8363",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "689af013-a550-48af-af52-783a8539b04b",
      target: "7399a800-e9a3-4edf-b0c7-4b2a0a775252"
    },
    {
      id: "950f52cf-d787-4611-a604-d78a211c396a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7399a800-e9a3-4edf-b0c7-4b2a0a775252",
      target: "a14cdfc7-32e6-4af5-b4d2-362c933730a6"
    },
    {
      id: "a9cd5900-2735-4ca3-b818-a69e8c01f078",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7fba55dc-c5cc-414d-810b-b8e69060b0ef",
      target: "f36c53df-cfbe-48a6-b8b8-271d701046cd"
    },
    {
      id: "c07d3ef5-3b07-437b-87d4-29e4dcffe62d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a14cdfc7-32e6-4af5-b4d2-362c933730a6",
      target: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed"
    },
    {
      id: "7057eba3-15a5-47d2-9f6d-74109920207f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a14cdfc7-32e6-4af5-b4d2-362c933730a6",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "dbb2ddb2-03e9-4200-a529-b048e4cc06af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a14cdfc7-32e6-4af5-b4d2-362c933730a6",
      target: "7fba55dc-c5cc-414d-810b-b8e69060b0ef"
    },
    {
      id: "8bbd31b2-c099-409d-95ef-c34680d6d614",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a14cdfc7-32e6-4af5-b4d2-362c933730a6",
      target: "f36c53df-cfbe-48a6-b8b8-271d701046cd"
    },
    {
      id: "c06b012d-cf4e-4acd-a260-42456081f697",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "164c629b-c18a-4d1b-80c0-f4e3fdd9d5ed",
      target: "f36c53df-cfbe-48a6-b8b8-271d701046cd"
    },
    {
      id: "20195b00-1822-40c1-811b-2f4aa0447d97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f36c53df-cfbe-48a6-b8b8-271d701046cd",
      target: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b"
    },
    {
      id: "4dd7c719-3eee-46cd-876c-a70bb464d5b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b",
      target: "b509c79a-66c1-4a87-96dd-916a294eaedf"
    },
    {
      id: "3f1d206f-53a0-4870-b0ab-60242b046e8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b",
      target: "c24910e2-0e08-4555-90b6-fb591bcaa902"
    },
    {
      id: "3274e754-d202-4a08-a7e6-1a0f43e8cc33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b",
      target: "c9226b38-9346-4a61-922b-67e00a464dbd"
    },
    {
      id: "c0717371-b4bf-4c35-a4bb-ddd8af5df44a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "944e98c6-e7c4-4c6d-b016-9a42a1dabc6b",
      target: "4a8c31db-194a-4f51-a869-7d3ca3982a01"
    },
    {
      id: "51268bc7-0b47-4845-a9c8-5f57f68b7dad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9226b38-9346-4a61-922b-67e00a464dbd",
      target: "6817dfc1-0273-4e9f-a884-cfbf3a513d62"
    },
    {
      id: "3cf49290-b5a4-4596-855d-0ef4e40e38fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a8c31db-194a-4f51-a869-7d3ca3982a01",
      target: "4ce3608d-1ea4-40c3-8781-148bfbee66aa"
    },
    {
      id: "3a31c405-7405-454c-869b-2334511b4415",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a8c31db-194a-4f51-a869-7d3ca3982a01",
      target: "4e4ecf78-df25-44e3-b7e0-d880d601b742"
    },
    {
      id: "3747d98c-532e-4eb1-9ab0-030061e5ddec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b509c79a-66c1-4a87-96dd-916a294eaedf",
      target: "4ce3608d-1ea4-40c3-8781-148bfbee66aa"
    },
    {
      id: "4ddb457f-107f-4391-8eb5-cbaa609117cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ce3608d-1ea4-40c3-8781-148bfbee66aa",
      target: "fc7d4283-3c27-4ee5-86cf-7b1e8a9643de"
    },
    {
      id: "0eaa28e5-72bc-409c-af49-41038f8564c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc7d4283-3c27-4ee5-86cf-7b1e8a9643de",
      target: "ae3cc965-2d14-4059-84ab-eccd5d498d8e"
    },
    {
      id: "949d82d6-ac50-4e86-94e6-f78845d5b51f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae3cc965-2d14-4059-84ab-eccd5d498d8e",
      target: "6817dfc1-0273-4e9f-a884-cfbf3a513d62"
    },
    {
      id: "5ed895e2-7a19-41a2-a070-1c6eeacb0952",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52",
      target: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e"
    },
    {
      id: "02d4c9a5-2d3a-479d-937e-277f115746d9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52",
      target: "833743d9-0d1e-4f92-aeff-61f84c09f416"
    },
    {
      id: "32516359-c886-42a9-af24-70db858f6fbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54d99ab3-6763-46e9-92cd-87b7cc2fcb52",
      target: "3ebf2ec1-0742-4fd5-b1f4-42239dfd77c1"
    },
    {
      id: "e78fb439-3479-4081-a7c5-a91623033070",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "833743d9-0d1e-4f92-aeff-61f84c09f416",
      target: "5f497766-2796-4921-b67d-7291ce48d6c4"
    },
    {
      id: "df4f4ad3-451b-49e9-8367-bf6ecfaf13b9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "833743d9-0d1e-4f92-aeff-61f84c09f416",
      target: "98dc0b17-09c2-49df-9ff7-aa04e55420b2"
    },
    {
      id: "d00840da-4b3b-4d38-b238-a5ac75ecbfeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "833743d9-0d1e-4f92-aeff-61f84c09f416",
      target: "d30a5345-e996-411f-8835-bf6612bc2f94"
    },
    {
      id: "f20da814-60b2-4061-a87e-b5ee54ca4c4e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "98dc0b17-09c2-49df-9ff7-aa04e55420b2",
      target: "1786ba2c-e011-4e1b-8712-52937aec48e9"
    },
    {
      id: "51133207-6816-4bf2-8669-9768078fb1ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98dc0b17-09c2-49df-9ff7-aa04e55420b2",
      target: "96d016f5-9a3c-47a8-9bfc-152eea730483"
    },
    {
      id: "75707184-5a01-4c6b-a1f5-7a37b85db580",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98dc0b17-09c2-49df-9ff7-aa04e55420b2",
      target: "a2dc4dbb-83f5-475a-a0d9-9d0f242836e3"
    },
    {
      id: "0f4351fd-900e-4eba-ba78-c4cb1b8edf33",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1786ba2c-e011-4e1b-8712-52937aec48e9",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "1733abf2-d189-4929-99a9-bb5ea38f46cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1786ba2c-e011-4e1b-8712-52937aec48e9",
      target: "680e9b60-f75e-43fe-8142-3007a5446254"
    },
    {
      id: "67a332e2-d6cf-44c2-a514-5c8df77a8638",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1786ba2c-e011-4e1b-8712-52937aec48e9",
      target: "64874121-0ebf-4f71-8823-901722c12bf7"
    },
    {
      id: "a3e184cc-a8c2-4643-b6c5-bc0641548e99",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3ebf2ec1-0742-4fd5-b1f4-42239dfd77c1",
      target: "d30a5345-e996-411f-8835-bf6612bc2f94"
    },
    {
      id: "5ac5b935-88fb-44b1-a356-48a8a18821e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ebf2ec1-0742-4fd5-b1f4-42239dfd77c1",
      target: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e"
    },
    {
      id: "7edf5b67-7f55-46ef-97e7-411ad9a32ee4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d30a5345-e996-411f-8835-bf6612bc2f94",
      target: "a2dc4dbb-83f5-475a-a0d9-9d0f242836e3"
    },
    {
      id: "8e5cbd0a-f983-4fc8-85ad-83595d74b583",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d30a5345-e996-411f-8835-bf6612bc2f94",
      target: "5f497766-2796-4921-b67d-7291ce48d6c4"
    },
    {
      id: "8f43d33e-bfc7-406d-bddf-cdee9d13ae7f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a2dc4dbb-83f5-475a-a0d9-9d0f242836e3",
      target: "64874121-0ebf-4f71-8823-901722c12bf7"
    },
    {
      id: "615fe4e9-cac7-4ebd-9eac-67f636b9d868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2dc4dbb-83f5-475a-a0d9-9d0f242836e3",
      target: "96d016f5-9a3c-47a8-9bfc-152eea730483"
    },
    {
      id: "92f80126-db11-4b50-ad1d-a9774c7a3a90",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64874121-0ebf-4f71-8823-901722c12bf7",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "bed16ae4-7a37-4c92-acc5-56c3536206e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64874121-0ebf-4f71-8823-901722c12bf7",
      target: "680e9b60-f75e-43fe-8142-3007a5446254"
    },
    {
      id: "f6526b0b-eb24-43aa-8ee7-6441ac42d48c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64874121-0ebf-4f71-8823-901722c12bf7",
      target: "680e9b60-f75e-43fe-8142-3007a5446254"
    },
    {
      id: "abe24dbb-b6cc-4648-bca0-b9a470001f86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd008f3f-b652-4ac0-b370-f9edcf3edfc5",
      target: "fcb414f2-390a-4870-a33e-898663fa8e82"
    },
    {
      id: "74765971-e21a-4e97-abdd-ebe5a48784ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "09141679-aaef-480d-b587-ffc86af0ed79"
    },
    {
      id: "91adb49c-2084-44b3-8c12-af94fcd4630d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "278d83f2-fd8d-4ff7-821d-aba3447b99a0"
    },
    {
      id: "5525f44a-c4bf-4a21-981f-33e600fd2054",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15"
    },
    {
      id: "7391706f-f2e1-4dbf-92ef-bd7f95b17520",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "794b4bc4-ebbd-4019-9768-e30e6b6da046"
    },
    {
      id: "fbf2043e-3077-4dd9-b599-6b1d00ce4329",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "29aea85f-78e6-4f8f-aebd-6838c4522a88"
    },
    {
      id: "d8ac53f2-7f3b-4eac-ae30-eb4d2deb5432",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcb414f2-390a-4870-a33e-898663fa8e82",
      target: "4f4606b3-f68d-44b0-945d-7d54e8b3b4f9"
    },
    {
      id: "2b562a9d-6866-4073-9f6d-0dd6f5e54900",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "278d83f2-fd8d-4ff7-821d-aba3447b99a0",
      target: "3a9b1564-f121-497c-8782-824ffa45a30e"
    },
    {
      id: "f418ea53-5d52-498e-a3b9-e43975578154",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f4606b3-f68d-44b0-945d-7d54e8b3b4f9",
      target: "4fb95960-4a97-4979-b16c-ddeb13b84af7"
    },
    {
      id: "c5f2fb53-85d6-4b4f-9e6c-daf321c9a1b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29aea85f-78e6-4f8f-aebd-6838c4522a88",
      target: "bf709ce3-7004-4925-88e1-84537d179125"
    },
    {
      id: "4d3cefce-df6c-4a0f-8efd-4bd84e0f5991",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "794b4bc4-ebbd-4019-9768-e30e6b6da046",
      target: "4fb95960-4a97-4979-b16c-ddeb13b84af7"
    },
    {
      id: "0b0b10ed-7b23-4e54-b87e-dc6ef9270089",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09141679-aaef-480d-b587-ffc86af0ed79",
      target: "4fb95960-4a97-4979-b16c-ddeb13b84af7"
    },
    {
      id: "4ae747f8-3998-42bf-b788-7a6aba9e0eec",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4fb95960-4a97-4979-b16c-ddeb13b84af7",
      target: "1af4f676-6072-41af-8ad8-43551eeca6e3"
    },
    {
      id: "b6f0806b-e79f-4fa3-99ab-935dcc2ee845",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fb95960-4a97-4979-b16c-ddeb13b84af7",
      target: "7fe894b4-f8b7-40a4-ab6f-abb8346ee14e"
    },
    {
      id: "5997e731-4075-40a1-9137-4fbf8f9b2463",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf709ce3-7004-4925-88e1-84537d179125",
      target: "3a9b1564-f121-497c-8782-824ffa45a30e"
    },
    {
      id: "b8090a7c-af0b-4bad-8c3f-d9a2502052e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a9b1564-f121-497c-8782-824ffa45a30e",
      target: "e4cff625-4671-4e31-909d-c91f23b1d76a"
    },
    {
      id: "47f7ee58-4f56-47af-a4e6-a35ebe445927",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4cff625-4671-4e31-909d-c91f23b1d76a",
      target: "e96928d1-30b8-4f17-af14-164b20aee7c4"
    },
    {
      id: "792812c1-9fbe-4b7a-a6ae-f7fc415d43e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e96928d1-30b8-4f17-af14-164b20aee7c4",
      target: "e3cfcd7e-c5d5-47c7-8cbc-4ec50d0e8a51"
    },
    {
      id: "2aac7f3c-8c3f-4f5c-ac9c-0fb5ebbb234d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e96928d1-30b8-4f17-af14-164b20aee7c4",
      target: "e6ee1a47-00c1-438a-bf5f-47dc81062bef"
    },
    {
      id: "179c11eb-ec1e-44ba-b557-3c8a5b2f6314",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd5c1efe-569c-4b49-8fb6-db71c9e2e20b",
      target: "fdcaa3e4-3c93-483c-abda-22ed1ceeebbe"
    },
    {
      id: "39688afe-8285-4654-8a86-5763ecdd8cf1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6ee1a47-00c1-438a-bf5f-47dc81062bef",
      target: "cd5c1efe-569c-4b49-8fb6-db71c9e2e20b"
    },
    {
      id: "02c3cf65-74c7-4db5-ad03-21d0ea8651a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e6ee1a47-00c1-438a-bf5f-47dc81062bef",
      target: "c23e83d4-a064-4972-9a5f-7ac9a210012b"
    },
    {
      id: "4bfd10e1-ba39-4d7f-a584-55a81e1b3d42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3cfcd7e-c5d5-47c7-8cbc-4ec50d0e8a51",
      target: "7fe894b4-f8b7-40a4-ab6f-abb8346ee14e"
    },
    {
      id: "fd5ac946-7d21-4fbb-8af7-5fb496ebc328",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3cfcd7e-c5d5-47c7-8cbc-4ec50d0e8a51",
      target: "1af4f676-6072-41af-8ad8-43551eeca6e3"
    },
    {
      id: "b27eca00-b6a2-4bd9-8c26-230b496018ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3cfcd7e-c5d5-47c7-8cbc-4ec50d0e8a51",
      target: "518e8f16-eed9-4ae6-bc01-b215655bde57"
    },
    {
      id: "3cf9cf39-ce6b-48bb-a42c-061cddc81f20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c23e83d4-a064-4972-9a5f-7ac9a210012b",
      target: "ac66801f-b705-448b-8b15-b3b22af3edc9"
    },
    {
      id: "9d275f7b-2dd1-4837-9db7-2eddbf1ce772",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1af4f676-6072-41af-8ad8-43551eeca6e3",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "8edc02f7-db4c-45be-b466-9a3debba1465",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7fe894b4-f8b7-40a4-ab6f-abb8346ee14e",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "a96f951a-17a4-4b56-980d-b91dcb43d184",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fdcaa3e4-3c93-483c-abda-22ed1ceeebbe",
      target: "4d2a0e22-c5a7-4200-aa31-12b022fa86c0"
    },
    {
      id: "5b19b426-398d-4960-bb81-af4778fb5742",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "518e8f16-eed9-4ae6-bc01-b215655bde57",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "cda7d2b1-af82-4ff0-afee-1168e25bfdc3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac66801f-b705-448b-8b15-b3b22af3edc9",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "1b36a8ca-875a-469c-9bac-1e2adf60abea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d2a0e22-c5a7-4200-aa31-12b022fa86c0",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "209ca650-d9c5-4a4b-840d-5a253ac7ad0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52ffef0b-d4e6-4196-8083-acfffc8e4b75",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "9abca0ab-7bdd-4ecc-9e23-f4ff0d9ed894",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52ffef0b-d4e6-4196-8083-acfffc8e4b75",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "bf502f46-2af4-4560-b570-7e2b696a7c1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52ffef0b-d4e6-4196-8083-acfffc8e4b75",
      target: "347a5a1c-1296-4577-bd61-0caa76198185"
    },
    {
      id: "b38a1315-9028-454c-b38e-3c298b4a200c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52ffef0b-d4e6-4196-8083-acfffc8e4b75",
      target: "d66d5383-0992-47bc-a319-b3c126dd8fb3"
    },
    {
      id: "1cf18296-d923-4af8-ac0e-24d41267526f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      target: "ad6ea47d-0227-4c90-93ae-18a23b637e99"
    },
    {
      id: "3f96e856-66ce-44fa-a428-cd0be50127d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      target: "393e7de8-7297-4526-a043-795c3f04b087"
    },
    {
      id: "74b8b869-04cb-42cd-8c0a-242139db2e6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      target: "ee7f244a-80cc-4705-bc08-2d1ae5d0b6ce"
    },
    {
      id: "92483e77-54ab-4c8d-b9fd-dfa82fd7bd99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      target: "3991cbac-00d3-48a9-82eb-22134e507401"
    },
    {
      id: "06c2d797-784d-445b-9878-456137ce0c70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31e750ec-fb3a-4f94-a7e6-d867b6d98e15",
      target: "f56ab0ae-e50b-4f1f-97b6-30d3049a1490"
    },
    {
      id: "a6c534bd-77ce-4cbb-96e1-9d569193b490",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "393e7de8-7297-4526-a043-795c3f04b087",
      target: "e8d10710-ab8c-4ea3-aa8a-7094dd1c8c31"
    },
    {
      id: "14a731dc-ac71-42f7-a12b-5cebbc453113",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3991cbac-00d3-48a9-82eb-22134e507401",
      target: "3ce3502c-ccdd-4010-83e8-d248a4631e44"
    },
    {
      id: "42737dc9-7800-4620-9ebc-7036f87603b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f56ab0ae-e50b-4f1f-97b6-30d3049a1490",
      target: "a2e8f15d-684a-40cf-836a-e18ddc2f9c9a"
    },
    {
      id: "ac2e34f0-45ee-4ace-b0c9-2e2a2c1fe5ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ee7f244a-80cc-4705-bc08-2d1ae5d0b6ce",
      target: "3ce3502c-ccdd-4010-83e8-d248a4631e44"
    },
    {
      id: "2b9953d2-0e3e-4252-a30a-5b85268b573c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad6ea47d-0227-4c90-93ae-18a23b637e99",
      target: "3ce3502c-ccdd-4010-83e8-d248a4631e44"
    },
    {
      id: "c9f22a58-c11c-4941-b171-a6c7fb2c28bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2e8f15d-684a-40cf-836a-e18ddc2f9c9a",
      target: "e8d10710-ab8c-4ea3-aa8a-7094dd1c8c31"
    },
    {
      id: "fadb9df2-0efe-4d53-b6d4-37ed017ec755",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3ce3502c-ccdd-4010-83e8-d248a4631e44",
      target: "8f38d3e4-419b-454c-a76c-d85621f6cccd"
    },
    {
      id: "f8e7559e-1dce-4608-8482-4f6b35e54abd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ce3502c-ccdd-4010-83e8-d248a4631e44",
      target: "245e9022-350f-4cad-bd3d-bffc722f5bee"
    },
    {
      id: "306cd103-046d-4a4a-b24c-00d62c21b05f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8d10710-ab8c-4ea3-aa8a-7094dd1c8c31",
      target: "32a4a0d7-5912-4a82-adab-446b50869c46"
    },
    {
      id: "a3c1756d-cd43-4adb-b7d9-27f55cbb8c5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32a4a0d7-5912-4a82-adab-446b50869c46",
      target: "d888d97e-a902-4859-90aa-62bfc6839c88"
    },
    {
      id: "16376e8c-88c5-4b4a-a816-554243365e67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d888d97e-a902-4859-90aa-62bfc6839c88",
      target: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d"
    },
    {
      id: "7954eef9-7736-4a31-8673-6de803ff6ddc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      target: "27bca850-e0a0-4a4e-a0fb-0ee1e0e6e37c"
    },
    {
      id: "2f9db870-356a-4bc6-8dda-85d3e7db3222",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      target: "8392942d-42bd-4f26-ba93-f77096494997"
    },
    {
      id: "57e7a125-50ec-468f-9703-13aeaa994a31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      target: "8f38d3e4-419b-454c-a76c-d85621f6cccd"
    },
    {
      id: "2270e8f4-6c74-420c-9825-159e4d077f17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      target: "245e9022-350f-4cad-bd3d-bffc722f5bee"
    },
    {
      id: "c2dbe99a-846d-41ee-9c4e-6d12ecfd559d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd0a9f8c-e9ce-4d3f-b029-3497348cf54d",
      target: "5530e123-637d-4ca1-abdc-554d85775ec3"
    },
    {
      id: "6c92e9f2-eb76-48b8-b84b-54f813e5c6d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5530e123-637d-4ca1-abdc-554d85775ec3",
      target: "14c3d512-4930-4e8b-8006-fa1e89546196"
    },
    {
      id: "76322d9d-c92c-42b9-b552-a8b87d7b3d18",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f38d3e4-419b-454c-a76c-d85621f6cccd",
      target: "14c3d512-4930-4e8b-8006-fa1e89546196"
    },
    {
      id: "5192cedf-4a1c-45dc-b85e-0d43d96c07d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "245e9022-350f-4cad-bd3d-bffc722f5bee",
      target: "14c3d512-4930-4e8b-8006-fa1e89546196"
    },
    {
      id: "abd2a419-8903-4fa9-835d-626118cbddfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8392942d-42bd-4f26-ba93-f77096494997",
      target: "7e449c27-d141-490d-8c59-9ffeb2a1b855"
    },
    {
      id: "d36cd79d-d8ba-49ca-8be9-e2fa22a82834",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27bca850-e0a0-4a4e-a0fb-0ee1e0e6e37c",
      target: "e0299bc3-ac94-4026-a3e5-0572b8cd2e65"
    },
    {
      id: "eee9f6f2-327f-4ba1-940d-7d0629ee00ad",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "27bca850-e0a0-4a4e-a0fb-0ee1e0e6e37c",
      target: "8392942d-42bd-4f26-ba93-f77096494997"
    },
    {
      id: "a0f7c2f9-7be1-4c6b-b521-b2d2216c9949",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e449c27-d141-490d-8c59-9ffeb2a1b855",
      target: "4bf9a9ea-19b1-4e3f-a5e2-6fa22e066902"
    },
    {
      id: "a2644f8c-90f6-4db5-94aa-12dd137dc775",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0299bc3-ac94-4026-a3e5-0572b8cd2e65",
      target: "14c3d512-4930-4e8b-8006-fa1e89546196"
    },
    {
      id: "1e250d1a-8577-4300-8a12-9fd87c0f1899",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4bf9a9ea-19b1-4e3f-a5e2-6fa22e066902",
      target: "14c3d512-4930-4e8b-8006-fa1e89546196"
    },
    {
      id: "e69c612b-c71d-42b6-b0a4-f86aede1973a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14c3d512-4930-4e8b-8006-fa1e89546196",
      target: "23b10f07-b4fe-43f3-a565-d567bcaca24f"
    },
    {
      id: "e4a3cb60-b0b3-4f06-8bfa-74ef0f1ff54d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14c3d512-4930-4e8b-8006-fa1e89546196",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "4c3d9d78-b3af-4248-b089-01ad81859705",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14c3d512-4930-4e8b-8006-fa1e89546196",
      target: "52ffef0b-d4e6-4196-8083-acfffc8e4b75"
    },
    {
      id: "953cd2cd-9e48-4ca3-928e-d83b83841a84",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14c3d512-4930-4e8b-8006-fa1e89546196",
      target: "65fd5fa5-8b27-4329-abe5-0aa91e7f9177"
    },
    {
      id: "49fb0e88-8f6e-483e-94c7-79f422b97869",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "3f1b55f2-6946-41af-864d-721593cfe926"
    },
    {
      id: "f4a9625e-62dc-45a3-bdf7-f5eebb8a899b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "e81dfe27-6de2-426d-a9e9-d3d1748ffe89"
    },
    {
      id: "707ada51-68ea-450b-aa68-1fde7682733d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "e81dfe27-6de2-426d-a9e9-d3d1748ffe89"
    },
    {
      id: "1a4dd2c2-8360-4980-b6c5-dcfe1c871bdb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "160e27aa-e51b-4b59-9cf9-62bce45a94be"
    },
    {
      id: "61682a1d-7495-439c-9248-9418e3491e87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "def49e23-f658-4b58-83fd-d348d1d0a0fa"
    },
    {
      id: "aa478992-34dc-4927-8f54-ccb99cdf6ec7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "2e72af4c-7d12-4ae6-ac85-8f96fc525515"
    },
    {
      id: "1e6eb923-63d1-431f-b234-b8b51d23a849",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da4a993b-47fc-4eb2-adfe-a06962929a74",
      target: "95c3b4bc-b939-4c82-b20c-f5e408f1967f"
    },
    {
      id: "fe98a894-96f3-4367-9c50-a4a891f0212f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e81dfe27-6de2-426d-a9e9-d3d1748ffe89",
      target: "754b29f6-4c15-42ae-b7a9-ed0999e6bccc"
    },
    {
      id: "c0fe2564-904d-4596-838f-894c3de3fa71",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e81dfe27-6de2-426d-a9e9-d3d1748ffe89",
      target: "96758d24-41d4-4fa4-81b4-ec2b5400d4c2"
    },
    {
      id: "25efccac-329f-4cb2-9be4-574bb94860c6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3f1b55f2-6946-41af-864d-721593cfe926",
      target: "8625a852-145a-4a75-a37e-e3b127b50f09"
    },
    {
      id: "f6f8371a-3cbb-43ba-a3a9-c7b65cebe661",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "160e27aa-e51b-4b59-9cf9-62bce45a94be",
      target: "96758d24-41d4-4fa4-81b4-ec2b5400d4c2"
    },
    {
      id: "af229400-f277-4676-8af9-dfb1aa07c122",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96758d24-41d4-4fa4-81b4-ec2b5400d4c2",
      target: "7720d7e1-a2ff-4456-87f4-fab63c5f2483"
    },
    {
      id: "8937b4ff-440c-4776-a9cd-ef5634a8acfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7720d7e1-a2ff-4456-87f4-fab63c5f2483",
      target: "8625a852-145a-4a75-a37e-e3b127b50f09"
    },
    {
      id: "0c752d30-a891-442f-aa3a-43c8520b680b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7720d7e1-a2ff-4456-87f4-fab63c5f2483",
      target: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0"
    },
    {
      id: "803b4c1a-dce6-4a36-929b-749df28addd3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "754b29f6-4c15-42ae-b7a9-ed0999e6bccc",
      target: "8625a852-145a-4a75-a37e-e3b127b50f09"
    },
    {
      id: "4ea0b5a8-0dda-439e-9f1f-b8069b20dfd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8625a852-145a-4a75-a37e-e3b127b50f09",
      target: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0"
    },
    {
      id: "d683c57b-604d-4050-9307-e06c98412360",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8625a852-145a-4a75-a37e-e3b127b50f09",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "efad374c-ffd3-4565-816a-ab732f1a996f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8625a852-145a-4a75-a37e-e3b127b50f09",
      target: "c249ab2c-cfe1-452a-9c38-a2a761b1553c"
    },
    {
      id: "d32f1b4a-c54d-4c71-bee3-60ecfb2c26af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c249ab2c-cfe1-452a-9c38-a2a761b1553c",
      target: "b916b544-f22a-4548-824e-57b2a8ccb9b4"
    },
    {
      id: "c42876c6-3e9f-4e55-9164-8fc199d1b0a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c249ab2c-cfe1-452a-9c38-a2a761b1553c",
      target: "e07b437e-c887-4bac-85aa-e0c6b6ca5494"
    },
    {
      id: "22b3e583-f4db-41e7-9225-6c47e5f46586",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c249ab2c-cfe1-452a-9c38-a2a761b1553c",
      target: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0"
    },
    {
      id: "22881345-47cb-4818-a763-36416ee9f84d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0",
      target: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e"
    },
    {
      id: "6ad37ea0-df26-4f73-941c-0cab635ab0c4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fd7cc41b-77d1-4d00-99fa-f36f2827c8f0",
      target: "db5214ff-8117-4566-a491-822577c55101"
    },
    {
      id: "130fb794-2180-49f1-8fdd-1771cd212c54",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "db5214ff-8117-4566-a491-822577c55101",
      target: "7bffd7ca-56a1-4658-9c5a-9a85a570f179"
    },
    {
      id: "46dc40a3-5aae-4a56-b319-65e6ae4d1e14",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7bffd7ca-56a1-4658-9c5a-9a85a570f179",
      target: "5e602f59-1eaf-46c1-97e8-ccef8095cb6b"
    },
    {
      id: "5938c3c8-bcce-4af4-bf4f-6fd58de65a0a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5e602f59-1eaf-46c1-97e8-ccef8095cb6b",
      target: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a"
    },
    {
      id: "c2150e07-75ad-4a2e-a4d2-8d97da267422",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5e602f59-1eaf-46c1-97e8-ccef8095cb6b",
      target: "30a13332-1047-4c9f-ad09-b526b962ef76"
    },
    {
      id: "4aecc43c-e043-41b6-95ba-f34a70476b86",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5e602f59-1eaf-46c1-97e8-ccef8095cb6b",
      target: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a"
    },
    {
      id: "dc8b5e86-7065-4ce4-afce-0ef8840e15e5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a",
      target: "f2d08268-17a3-4a53-828e-f39d2e9d23db"
    },
    {
      id: "82bedb49-3d51-4e8f-a0f9-ce76820561d9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "221b07b0-2a6f-4484-8e1a-b4825e90ca8a",
      target: "3ef449ea-d160-48e6-9c6c-1f5fbedf706d"
    },
    {
      id: "5e52f6ff-6249-4d4d-bc83-0e05f66e66f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b916b544-f22a-4548-824e-57b2a8ccb9b4",
      target: "b199a1e6-cd22-493b-b634-8549d0c9b3cc"
    },
    {
      id: "f0a4f7bf-a204-48ae-afdb-a136275314c8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f2d08268-17a3-4a53-828e-f39d2e9d23db",
      target: "26598ba9-76b5-452c-b1be-4c7c04919258"
    },
    {
      id: "d56e6e5c-debe-4d37-90da-03f1492721db",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "26598ba9-76b5-452c-b1be-4c7c04919258",
      target: "b199a1e6-cd22-493b-b634-8549d0c9b3cc"
    },
    {
      id: "09f4be04-e2aa-45a0-ab4f-573252d452a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26598ba9-76b5-452c-b1be-4c7c04919258",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "a0ad65d0-75ac-4e93-9d00-7c956f24bb0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30a13332-1047-4c9f-ad09-b526b962ef76",
      target: "aed18f02-ad61-4e86-92cc-8a44725df702"
    },
    {
      id: "72e691fa-d421-4e91-b71b-37917f8aaa57",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b199a1e6-cd22-493b-b634-8549d0c9b3cc",
      target: "48fc00e1-5e72-4adf-8abf-9845dda9b95b"
    },
    {
      id: "504ca115-0bbd-468e-845e-c87b8b706678",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "48fc00e1-5e72-4adf-8abf-9845dda9b95b",
      target: "0cec6626-41db-4afb-883e-5bb2221ba79f"
    },
    {
      id: "b4466c82-1f66-4e81-bc36-ef7abcd7a959",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0cec6626-41db-4afb-883e-5bb2221ba79f",
      target: "72852f06-5dba-43f7-a5f4-0b083b6f20d6"
    },
    {
      id: "4d2331c3-9c5e-4bea-9e97-1903c1d5235e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "72852f06-5dba-43f7-a5f4-0b083b6f20d6",
      target: "667de3dc-f114-4221-952f-36890972a4c9"
    },
    {
      id: "0438b900-e571-43c9-a00e-8745395684ee",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "72852f06-5dba-43f7-a5f4-0b083b6f20d6",
      target: "b0a1dc8f-0534-4180-bc09-7ecaeb67015d"
    },
    {
      id: "408bb563-14a4-47cd-8575-e3a4828ba5c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "72852f06-5dba-43f7-a5f4-0b083b6f20d6",
      target: "4efd5231-7150-4744-96e0-273c2f8e1536"
    },
    {
      id: "b1cf28b8-e544-4202-b1e1-b187d7072b00",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b0a1dc8f-0534-4180-bc09-7ecaeb67015d",
      target: "84ce3930-8fb0-4311-82a6-b2416384c17a"
    },
    {
      id: "3b11900d-dcd0-4bda-b363-2b67635a9b30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0a1dc8f-0534-4180-bc09-7ecaeb67015d",
      target: "907c1351-c46b-48ce-8331-08f0ab5d822f"
    },
    {
      id: "a13ef3ae-ec44-48e6-9e61-4c0d8e471fb3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "667de3dc-f114-4221-952f-36890972a4c9",
      target: "2d97a66c-7be9-4680-9090-107428a05ca6"
    },
    {
      id: "1bc1500e-39ef-40c6-9dd8-a98aab5c76e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "667de3dc-f114-4221-952f-36890972a4c9",
      target: "55f72cea-55f0-4c12-acb6-e37e273b4c68"
    },
    {
      id: "df3a5af2-36fd-4ae4-8959-5dfe428c822c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4efd5231-7150-4744-96e0-273c2f8e1536",
      target: "70094d4e-f7bd-413a-9caf-a73bb1031c7f"
    },
    {
      id: "cff97923-44c8-45da-999c-d62f8182eb84",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4efd5231-7150-4744-96e0-273c2f8e1536",
      target: "84ce3930-8fb0-4311-82a6-b2416384c17a"
    },
    {
      id: "fdba231b-4666-4aaf-b690-168dbbeea675",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2d97a66c-7be9-4680-9090-107428a05ca6",
      target: "8b1c55d4-111f-48db-b134-efc649b1f14b"
    },
    {
      id: "5b1a4c59-ed55-4f65-aa76-c74e2ac5b9c0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "84ce3930-8fb0-4311-82a6-b2416384c17a",
      target: "171c0117-c074-4b63-bbec-700ef043fb6a"
    },
    {
      id: "1b6082d4-d05d-4928-bc0e-d79345172eee",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70094d4e-f7bd-413a-9caf-a73bb1031c7f",
      target: "303bc0b0-19d9-4996-90c8-75148ad426cd"
    },
    {
      id: "75376fca-2e22-4d79-9d46-74f036bab98e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "55f72cea-55f0-4c12-acb6-e37e273b4c68",
      target: "8b1c55d4-111f-48db-b134-efc649b1f14b"
    },
    {
      id: "32bcdbdc-f653-4a5d-a588-3e942a2625db",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8b1c55d4-111f-48db-b134-efc649b1f14b",
      target: "a18cde12-ef8f-4633-ad31-4337e90ee1f2"
    },
    {
      id: "3d877ea3-1e81-4fdf-87bf-d96b039b7792",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8b1c55d4-111f-48db-b134-efc649b1f14b",
      target: "171c0117-c074-4b63-bbec-700ef043fb6a"
    },
    {
      id: "5282bc61-97ed-4169-872e-8b5665900baf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a18cde12-ef8f-4633-ad31-4337e90ee1f2",
      target: "287494f9-4979-494e-b4f9-1766d55d66a5"
    },
    {
      id: "94a6835c-41d1-4615-b49f-0246036d0893",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "171c0117-c074-4b63-bbec-700ef043fb6a",
      target: "303bc0b0-19d9-4996-90c8-75148ad426cd"
    },
    {
      id: "be479704-eabd-4d41-ad14-bbfbfaf4039e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "303bc0b0-19d9-4996-90c8-75148ad426cd",
      target: "2d4312e1-0f2d-4d43-897b-8edc0c454a2b"
    },
    {
      id: "8578706d-3c70-4cfa-b750-ce198142025e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "303bc0b0-19d9-4996-90c8-75148ad426cd",
      target: "76dbb63f-e2b5-4ff9-98af-f566475f94da"
    },
    {
      id: "b6796f9a-a2c9-4f71-b53f-0a4463bcf9b0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "303bc0b0-19d9-4996-90c8-75148ad426cd",
      target: "83c6985e-fea6-443f-94e2-60f9ed8b43bf"
    },
    {
      id: "b51eb324-f74a-41fa-833b-3544da884aac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "303bc0b0-19d9-4996-90c8-75148ad426cd",
      target: "e3df7dae-a7dc-464f-b17e-801d34dd0f97"
    },
    {
      id: "e5247912-8caa-4428-b82b-73bbdd75c129",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "907c1351-c46b-48ce-8331-08f0ab5d822f",
      target: "84ce3930-8fb0-4311-82a6-b2416384c17a"
    },
    {
      id: "ff535a9c-3448-42f7-b7d0-d3b170d3d031",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "76dbb63f-e2b5-4ff9-98af-f566475f94da",
      target: "287494f9-4979-494e-b4f9-1766d55d66a5"
    },
    {
      id: "654a1da8-0d18-4866-bbe7-5038becf56bc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3df7dae-a7dc-464f-b17e-801d34dd0f97",
      target: "287494f9-4979-494e-b4f9-1766d55d66a5"
    },
    {
      id: "72f549d5-80f7-4fc0-a3f7-312ce2fabbb7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "83c6985e-fea6-443f-94e2-60f9ed8b43bf",
      target: "287494f9-4979-494e-b4f9-1766d55d66a5"
    },
    {
      id: "5837d564-3091-4ef6-9ebf-f1691ab0f4ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2d4312e1-0f2d-4d43-897b-8edc0c454a2b",
      target: "287494f9-4979-494e-b4f9-1766d55d66a5"
    },
    {
      id: "9562e257-a5f6-416c-9552-4c927fc25586",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "287494f9-4979-494e-b4f9-1766d55d66a5",
      target: "4d3555c8-0ee9-4d0d-95a0-26b160540a01"
    },
    {
      id: "8155a924-1488-4864-8282-4c7859806267",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4d3555c8-0ee9-4d0d-95a0-26b160540a01",
      target: "8bf7e77a-1de6-4ac3-a90e-b630f0eca710"
    },
    {
      id: "ae12ff5c-13d8-4bf8-b207-6c476190d8e6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "03e28f86-f603-4b29-b598-2bded4b4233f",
      target: "79cb3721-e11a-48e8-aa4f-c5e13406b815"
    },
    {
      id: "c324bf82-c88e-4454-ac49-24b5e41d75ad",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "79cb3721-e11a-48e8-aa4f-c5e13406b815",
      target: "aed18f02-ad61-4e86-92cc-8a44725df702"
    },
    {
      id: "6366f97f-00e7-4672-998f-507c7928f381",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bf7e77a-1de6-4ac3-a90e-b630f0eca710",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "c22647d0-752d-4eb1-b125-47dbd8a5df6d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8bf7e77a-1de6-4ac3-a90e-b630f0eca710",
      target: "03e28f86-f603-4b29-b598-2bded4b4233f"
    },
    {
      id: "c9aba98d-8b74-429e-ac8f-e86d27cc0f23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aed18f02-ad61-4e86-92cc-8a44725df702",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "b50908ea-04ec-4857-a9f6-f7e3347e54b6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aed18f02-ad61-4e86-92cc-8a44725df702",
      target: "3be01b15-6f84-4259-b42d-9a31ecef8f03"
    },
    {
      id: "62b17f59-a158-4c25-a1a7-d8db09e16999",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3be01b15-6f84-4259-b42d-9a31ecef8f03",
      target: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d"
    },
    {
      id: "942cc5c9-08bb-4615-9693-74fb38897044",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "3411f8e1-d3fb-4267-8289-729033157e97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "e7634d40-f248-431b-a17e-164358eaf692",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "9e50d735-5b6b-4dc8-8ec0-63d071a02c14",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "173f1a48-63dc-4255-ac71-4753804f6d22"
    },
    {
      id: "7e699694-6e4f-42f7-bd14-bc9b6e5da0e3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "656acec0-9b65-4159-be15-d0607975a7e1"
    },
    {
      id: "6c7a2903-c327-4de3-aa64-364685adc9b5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "5def9170-b350-4622-a43d-e617cf2bdb35"
    },
    {
      id: "769111f4-6da2-4886-adb5-13054591e1d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "173f1a48-63dc-4255-ac71-4753804f6d22"
    },
    {
      id: "278133ce-0f7c-4059-9a46-ffe381fba229",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "656acec0-9b65-4159-be15-d0607975a7e1"
    },
    {
      id: "6baaa5e3-27bb-4679-bb1d-1dbafc72868d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95c3b4bc-b939-4c82-b20c-f5e408f1967f",
      target: "5def9170-b350-4622-a43d-e617cf2bdb35"
    },
    {
      id: "158343f6-4e58-48a7-b5d8-76b2374ad83a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "173f1a48-63dc-4255-ac71-4753804f6d22",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "c1b296a1-72dc-4154-b3cd-1c2f9e9cca92",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "173f1a48-63dc-4255-ac71-4753804f6d22",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "118a7ab2-ab04-43a0-81ae-ec674d66e653",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "beec48dd-423f-4c51-b7b9-a66ca4e524ab",
      target: "22b094e2-d114-4611-93cf-8d54204c0657"
    },
    {
      id: "97593728-452d-4dbd-b5c5-0270191ca19b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "beec48dd-423f-4c51-b7b9-a66ca4e524ab",
      target: "b481cb3f-09d7-48c7-b500-ed168d828fd3"
    },
    {
      id: "5ffc6da5-2eb8-4fb3-9069-8eb27a370140",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "beec48dd-423f-4c51-b7b9-a66ca4e524ab",
      target: "4452f889-9581-4c2c-833a-cbb8d4422e1a"
    },
    {
      id: "fa205a41-5435-4302-8e02-f1c31ec709f6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "beec48dd-423f-4c51-b7b9-a66ca4e524ab",
      target: "b0fab1bf-bd43-4295-b95d-f890aef0ab33"
    },
    {
      id: "7349795e-f1cf-45cf-8feb-e24162abde2c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "656acec0-9b65-4159-be15-d0607975a7e1",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "2c518c09-793a-4188-ac06-a23ef5978946",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "656acec0-9b65-4159-be15-d0607975a7e1",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "ed864f31-a7e9-4cd2-8071-30f5af79a65d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5def9170-b350-4622-a43d-e617cf2bdb35",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "3ff860f2-f656-4621-88fe-a81222178c38",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5def9170-b350-4622-a43d-e617cf2bdb35",
      target: "beec48dd-423f-4c51-b7b9-a66ca4e524ab"
    },
    {
      id: "48106536-ec41-42e4-9831-8d0059494aff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22b094e2-d114-4611-93cf-8d54204c0657",
      target: "b481cb3f-09d7-48c7-b500-ed168d828fd3"
    },
    {
      id: "a1c0ffaf-8e8b-45df-b5b5-f441a3773308",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0fab1bf-bd43-4295-b95d-f890aef0ab33",
      target: "b481cb3f-09d7-48c7-b500-ed168d828fd3"
    },
    {
      id: "fb05f810-1525-4b15-9999-29b479d1e0e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4452f889-9581-4c2c-833a-cbb8d4422e1a",
      target: "b481cb3f-09d7-48c7-b500-ed168d828fd3"
    },
    {
      id: "708f917a-38ee-42be-a11f-888989ace09c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b481cb3f-09d7-48c7-b500-ed168d828fd3",
      target: "85f26379-1771-49b5-b3f4-50e67ec11345"
    },
    {
      id: "aa186a9e-5c8c-4c59-93d3-4bd6a43f6a4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85f26379-1771-49b5-b3f4-50e67ec11345",
      target: "2067e93a-473a-4c84-bffe-b102a2be0c70"
    },
    {
      id: "0f67b5ce-e5e8-49c1-bbf2-c614a3c668e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2067e93a-473a-4c84-bffe-b102a2be0c70",
      target: "624ef655-c92e-43ec-b894-256bdbec4852"
    },
    {
      id: "5f343c70-d49e-429e-ac68-846df570643e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "624ef655-c92e-43ec-b894-256bdbec4852",
      target: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c"
    },
    {
      id: "e0c60df7-e461-4ffd-879a-31b81e963aa6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "945df35f-ffbb-41c0-bdbd-712cd08e3b88",
      target: "22160898-4722-4d54-98bd-c5a65765f5a4"
    },
    {
      id: "f81737ea-3e37-40dc-9858-00e89a005730",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      target: "22160898-4722-4d54-98bd-c5a65765f5a4"
    },
    {
      id: "7002bcd8-c690-4e60-b581-7ecd5a8f4ec0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "ccc6a560-39a6-4256-8284-d3348b1f12a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      target: "354050cf-901f-4ed1-9211-6bfb8f0873bb"
    },
    {
      id: "cd72b958-df3d-4d3b-ae5e-0cab1ae08cfd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      target: "945df35f-ffbb-41c0-bdbd-712cd08e3b88"
    },
    {
      id: "78ea36cf-3f25-42d5-97fb-421ced8b75eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1796c37-8204-4a7a-ab6f-31fbcd2f158c",
      target: "235e502b-fa1c-4257-baa2-57b00c9a2002"
    },
    {
      id: "65441375-04f0-483b-813c-cf9ff0f80b4e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "354050cf-901f-4ed1-9211-6bfb8f0873bb",
      target: "22160898-4722-4d54-98bd-c5a65765f5a4"
    },
    {
      id: "b29f514b-d468-494b-a90d-c45dd58d8ad8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22160898-4722-4d54-98bd-c5a65765f5a4",
      target: "e64544ae-3f43-4a46-aab5-680b38464edf"
    },
    {
      id: "04a39380-8a49-4373-a535-d2e568b10afe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e64544ae-3f43-4a46-aab5-680b38464edf",
      target: "19fdb366-9d8b-4b64-8bbb-eca8ba62f361"
    },
    {
      id: "b6e986cf-d9ea-4bf7-92a0-a7db50dfb977",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e64544ae-3f43-4a46-aab5-680b38464edf",
      target: "97cd702a-7b4a-4e7a-a600-483bc208f74d"
    },
    {
      id: "eca45a30-27d3-4747-afdc-6cbe13e0bafb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e64544ae-3f43-4a46-aab5-680b38464edf",
      target: "ce7cbeee-1b3c-4618-a488-ab281e1755a4"
    },
    {
      id: "8ee01797-1820-4b05-ac44-994cbcefa56c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e64544ae-3f43-4a46-aab5-680b38464edf",
      target: "c01ca0f6-d7a1-4fdc-9d49-f9b9e368b240"
    },
    {
      id: "97d89933-6122-43d9-9d0d-dde58d6217e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97cd702a-7b4a-4e7a-a600-483bc208f74d",
      target: "0b9d31c6-1031-4830-9028-c8fd13ab522d"
    },
    {
      id: "c82d8720-f077-40df-a78f-69f3cd9ab32f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c01ca0f6-d7a1-4fdc-9d49-f9b9e368b240",
      target: "aed18f02-ad61-4e86-92cc-8a44725df702"
    },
    {
      id: "8d808603-2639-4dcb-831f-e2fb649568ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce7cbeee-1b3c-4618-a488-ab281e1755a4",
      target: "0b9d31c6-1031-4830-9028-c8fd13ab522d"
    },
    {
      id: "d8c19ba5-5b4d-4665-8cc0-46d648c75159",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce7cbeee-1b3c-4618-a488-ab281e1755a4",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "f5d7edea-b8c3-4f42-ba3a-06aff7c1aa89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b9d31c6-1031-4830-9028-c8fd13ab522d",
      target: "c02e40c4-107e-4b5a-92cd-87edcd5b033e"
    },
    {
      id: "6b456a80-513a-40d1-b906-7e3ec9f382ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c02e40c4-107e-4b5a-92cd-87edcd5b033e",
      target: "1167f1b9-3593-4dae-828b-053796d82752"
    },
    {
      id: "02a43900-20fc-4dca-ae96-1d4c07abca13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1167f1b9-3593-4dae-828b-053796d82752",
      target: "aed18f02-ad61-4e86-92cc-8a44725df702"
    },
    {
      id: "7868060c-030f-4bcf-9293-719ebfe382d0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e",
      target: "5f497766-2796-4921-b67d-7291ce48d6c4"
    },
    {
      id: "3f5bfa48-dd9d-4f00-a3df-91a0bb8fc52e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e",
      target: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61"
    },
    {
      id: "134b437e-ac64-4a2a-8724-5cdfae1722c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c177d48-7243-4a5a-9b63-a8bbc3d57e4e",
      target: "f5dde7a0-97f9-4300-812c-a05c2e9ab261"
    },
    {
      id: "b8a61c87-7b02-4bd8-bedf-20fbbe16b4db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f497766-2796-4921-b67d-7291ce48d6c4",
      target: "590c6b80-78b8-413f-9298-b28a850c095c"
    },
    {
      id: "6ef120fc-c57a-4f44-a204-6ccb5748c09d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5f497766-2796-4921-b67d-7291ce48d6c4",
      target: "96d016f5-9a3c-47a8-9bfc-152eea730483"
    },
    {
      id: "209c05d8-d179-4edd-ba79-cfafbf096c9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f497766-2796-4921-b67d-7291ce48d6c4",
      target: "9e5d8da1-330b-4423-a31f-bf03e353e6e0"
    },
    {
      id: "0c0da01a-60e0-4a4e-9437-d715409350b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96d016f5-9a3c-47a8-9bfc-152eea730483",
      target: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81"
    },
    {
      id: "48d30279-49a9-490a-8e6b-f5b3ff87f6e7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "96d016f5-9a3c-47a8-9bfc-152eea730483",
      target: "680e9b60-f75e-43fe-8142-3007a5446254"
    },
    {
      id: "500800b8-f6a0-4003-ba3a-e23e9cf91a86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96d016f5-9a3c-47a8-9bfc-152eea730483",
      target: "9b419884-ac6d-4c1f-9dda-375d0a487a3d"
    },
    {
      id: "ddbdf120-d613-44a5-825c-348f7659b39d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "680e9b60-f75e-43fe-8142-3007a5446254",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "9849bdd5-46a7-4d75-9ed8-bf99917d2568",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "680e9b60-f75e-43fe-8142-3007a5446254",
      target: "465afcde-3dcc-4b35-bae7-843bfd3b95f3"
    },
    {
      id: "192b5022-fef7-4aae-88b8-3ad1117eb5e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "680e9b60-f75e-43fe-8142-3007a5446254",
      target: "3f911c1e-9fc2-4c0e-82af-a72d6f0c82ab"
    },
    {
      id: "4021935c-fae5-48ae-a81a-3b516b646f38",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f5dde7a0-97f9-4300-812c-a05c2e9ab261",
      target: "9e5d8da1-330b-4423-a31f-bf03e353e6e0"
    },
    {
      id: "ec172f75-e88e-419a-ba35-9181465a4889",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5dde7a0-97f9-4300-812c-a05c2e9ab261",
      target: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61"
    },
    {
      id: "76a3ce12-a741-485f-86fd-38fc3273a5a0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9e5d8da1-330b-4423-a31f-bf03e353e6e0",
      target: "9b419884-ac6d-4c1f-9dda-375d0a487a3d"
    },
    {
      id: "b1761bf6-8a87-4255-ac3e-b76830ed557d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e5d8da1-330b-4423-a31f-bf03e353e6e0",
      target: "590c6b80-78b8-413f-9298-b28a850c095c"
    },
    {
      id: "548f4cfc-167a-4f27-9bdf-b803d2951871",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9b419884-ac6d-4c1f-9dda-375d0a487a3d",
      target: "3f911c1e-9fc2-4c0e-82af-a72d6f0c82ab"
    },
    {
      id: "83cce8c8-f8e5-41dd-b312-fd3a4669f965",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b419884-ac6d-4c1f-9dda-375d0a487a3d",
      target: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81"
    },
    {
      id: "d1bdd3ff-cee6-45ab-864c-d6eae2110a3d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3f911c1e-9fc2-4c0e-82af-a72d6f0c82ab",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "3e18b0d9-b740-4bea-a244-d44d07d25378",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3f911c1e-9fc2-4c0e-82af-a72d6f0c82ab",
      target: "465afcde-3dcc-4b35-bae7-843bfd3b95f3"
    },
    {
      id: "6c843b8f-4a32-4ae0-9d45-c6036b83d45a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00"
    },
    {
      id: "e98faf74-d7ab-4546-9f2c-31b1875b0194",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "2846edff-99e8-4751-8834-4f20df3d5c19"
    },
    {
      id: "ea28831f-479d-4f4a-a57c-be8e704f9057",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "d3947ced-e5aa-4d96-8db0-0a1574e24fac"
    },
    {
      id: "e5e3ac6b-86d1-40c9-b047-b6f313982825",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "45eb8282-a391-4188-92ae-13b6806efa35"
    },
    {
      id: "eb7bbc6c-1822-4183-b77f-e3d636e4df2f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc"
    },
    {
      id: "48565340-52e3-46d0-9830-403aa8afa377",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "bdef2b94-7931-4a69-b1f6-be9c4d6a9f55"
    },
    {
      id: "2e6fee89-ce6b-40e2-bfd6-b2f5b712af97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0135df10-1e3a-4c09-b454-cb88c7ad5510",
      target: "dc7d2dd6-d734-4372-a0f8-36c27e8a318f"
    },
    {
      id: "d46c7702-085c-41ee-a85a-8b497d8a06c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3947ced-e5aa-4d96-8db0-0a1574e24fac",
      target: "99543c36-bac6-4afc-9da4-f27a16a479e3"
    },
    {
      id: "03b433f7-4f09-4e61-84c2-c58d2642d89b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc7d2dd6-d734-4372-a0f8-36c27e8a318f",
      target: "99543c36-bac6-4afc-9da4-f27a16a479e3"
    },
    {
      id: "5176c9df-3133-4fbd-8c0b-8be549c1a26b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45eb8282-a391-4188-92ae-13b6806efa35",
      target: "84186393-ecde-4829-a602-78b7e3b0c994"
    },
    {
      id: "41e9c170-dfdb-41e9-931a-8649537bb228",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2846edff-99e8-4751-8834-4f20df3d5c19",
      target: "99543c36-bac6-4afc-9da4-f27a16a479e3"
    },
    {
      id: "066d37b9-192c-4f87-9f7e-690b3e7a2073",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdef2b94-7931-4a69-b1f6-be9c4d6a9f55",
      target: "26d5a9eb-551e-420d-8b46-2ae818c18137"
    },
    {
      id: "83bb8164-011e-4ce0-aef9-1d3fbaef580c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdef2b94-7931-4a69-b1f6-be9c4d6a9f55",
      target: "b08dc945-e156-46ba-8571-1c59f1c88531"
    },
    {
      id: "7d0c4385-9fd5-4883-a015-16c7daa71c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26d5a9eb-551e-420d-8b46-2ae818c18137",
      target: "84186393-ecde-4829-a602-78b7e3b0c994"
    },
    {
      id: "e68ec989-e83d-404b-85f3-c4037a8581fe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "99543c36-bac6-4afc-9da4-f27a16a479e3",
      target: "ed3ad6f3-bf27-4991-8291-fff7f6e012c1"
    },
    {
      id: "c3cd821e-c144-44fe-99bb-90eb8c0d04c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99543c36-bac6-4afc-9da4-f27a16a479e3",
      target: "e0e42120-2ca4-41f2-bd91-655f59c20f7e"
    },
    {
      id: "9f5cf2a8-29be-44b6-8c1d-0cb873e6b488",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84186393-ecde-4829-a602-78b7e3b0c994",
      target: "aac5add6-2a20-4a39-959d-8173a564edc9"
    },
    {
      id: "0f372e7a-8ac1-41e9-a80b-e6436da4a908",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aac5add6-2a20-4a39-959d-8173a564edc9",
      target: "2ed13a1a-4937-4a5a-8086-fa20f62e5db3"
    },
    {
      id: "638beee8-815d-4de9-a136-5fa1dc027137",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ed13a1a-4937-4a5a-8086-fa20f62e5db3",
      target: "c5448f94-aac6-4083-902d-84b19be1cc0f"
    },
    {
      id: "a41c1d29-1f45-4cf1-94c3-d6baea60b628",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ed13a1a-4937-4a5a-8086-fa20f62e5db3",
      target: "c5ee9381-912b-4187-b5a6-c4dcc7c931a1"
    },
    {
      id: "87f7f2e2-ad57-4ab5-aa2c-1c22a04496f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5448f94-aac6-4083-902d-84b19be1cc0f",
      target: "781f5776-36c9-47be-9361-3dfc2c009a46"
    },
    {
      id: "f9711d4b-1528-4db8-abf5-b2655a4aa28c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5ee9381-912b-4187-b5a6-c4dcc7c931a1",
      target: "d884d210-c31e-46e8-acf9-3a0714b9f8b7"
    },
    {
      id: "8e73d649-7c27-4ece-925c-96d9092b5f3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5ee9381-912b-4187-b5a6-c4dcc7c931a1",
      target: "e0e42120-2ca4-41f2-bd91-655f59c20f7e"
    },
    {
      id: "c7f83fd5-0e3b-4a6d-ba80-c8a25bff8ef7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5ee9381-912b-4187-b5a6-c4dcc7c931a1",
      target: "ed3ad6f3-bf27-4991-8291-fff7f6e012c1"
    },
    {
      id: "3157ba9f-2b1d-4274-a1e5-2aebcd50f86d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "781f5776-36c9-47be-9361-3dfc2c009a46",
      target: "ea0e8a31-0808-4cc4-bb46-cdbd5a64a029"
    },
    {
      id: "f77c19d2-04c4-48d8-a765-0ec0b2d8c00d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed3ad6f3-bf27-4991-8291-fff7f6e012c1",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "0cf95585-e16e-405e-8be5-1a8f07f5c931",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0e42120-2ca4-41f2-bd91-655f59c20f7e",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "c0a3cb59-38de-4692-a9a7-a5e83001f89c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d884d210-c31e-46e8-acf9-3a0714b9f8b7",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "1fda7fd8-a5c1-4e5f-9e6a-62e26efa4394",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d884d210-c31e-46e8-acf9-3a0714b9f8b7",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "42c4c438-5d22-4f4f-bdf8-692b942dae07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea0e8a31-0808-4cc4-bb46-cdbd5a64a029",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "1674d730-bf3d-47ef-be15-ef33ef2bef05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "36c58347-b7f7-4df4-b10a-cb4330162eeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "3f13b856-b308-4c93-8f19-d0fc886913a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "f1220bf7-ef78-41da-9c70-c066e7de7a5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5",
      target: "bc26256c-deb1-4c63-813d-3a9a4f47c500"
    },
    {
      id: "03673737-a9aa-4c35-a67e-b6e2ea403591",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b014aa5-c8cf-4762-9e05-d0a452c22035",
      target: "0135df10-1e3a-4c09-b454-cb88c7ad5510"
    },
    {
      id: "c06223d5-2a34-4450-81a0-718e8cca85f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b014aa5-c8cf-4762-9e05-d0a452c22035",
      target: "4699d3cb-d8a0-4c04-adce-21fa7c2cd641"
    },
    {
      id: "9144e4e6-05f0-4340-9710-37a6df9182fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      target: "1c9276aa-3f44-453b-b647-ef177655cfd0"
    },
    {
      id: "ccf2ab16-426a-4d29-af89-e493498ad0e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      target: "b08dc945-e156-46ba-8571-1c59f1c88531"
    },
    {
      id: "57312c49-9e85-41be-b788-861dc15bf1b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      target: "d02e14e0-b3b2-4499-afea-b4a6b376a21c"
    },
    {
      id: "c9a0fd76-8db1-43dc-aa17-2e2b32bcbb99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      target: "4c752bc7-d400-4200-90d3-25e9a3d0b97c"
    },
    {
      id: "5df9bc9e-5255-44cd-bf01-4fc5498a5b22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca443178-ffc3-4a30-a4f1-cdb8e76265fc",
      target: "b2c0c497-5e9a-4e33-9695-45fbf75f6135"
    },
    {
      id: "577c8040-7357-442f-9777-419dac9eaf8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c752bc7-d400-4200-90d3-25e9a3d0b97c",
      target: "d070eea9-3a87-4e64-9150-62af34dfceec"
    },
    {
      id: "d9602725-d21f-4dcf-b35c-ab5e9a38aa5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2c0c497-5e9a-4e33-9695-45fbf75f6135",
      target: "b6ff84de-9def-408f-9921-7d5b15bb56e0"
    },
    {
      id: "41992f24-a917-47f1-a870-29c4804211cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b08dc945-e156-46ba-8571-1c59f1c88531",
      target: "27488122-4468-47dd-9cd1-2ec50bdd594f"
    },
    {
      id: "a386b457-e1c4-4790-9ba5-98d439e0e3db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b08dc945-e156-46ba-8571-1c59f1c88531",
      target: "cddbc8c3-6848-4da0-aa6e-16306ae9cadf"
    },
    {
      id: "3f6f92e3-6878-4837-b817-628dc50c495f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d02e14e0-b3b2-4499-afea-b4a6b376a21c",
      target: "b6ff84de-9def-408f-9921-7d5b15bb56e0"
    },
    {
      id: "edea8aa8-a022-493c-a73f-763087c126df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c9276aa-3f44-453b-b647-ef177655cfd0",
      target: "b6ff84de-9def-408f-9921-7d5b15bb56e0"
    },
    {
      id: "de095b5e-02ce-4a5a-9f7d-65814a66579b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27488122-4468-47dd-9cd1-2ec50bdd594f",
      target: "d070eea9-3a87-4e64-9150-62af34dfceec"
    },
    {
      id: "91380be6-ed2e-4b8a-b23d-785c518cc0b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6ff84de-9def-408f-9921-7d5b15bb56e0",
      target: "7ddfe567-675a-45e2-89f7-b8b15c5075e9"
    },
    {
      id: "754ca4f6-b3c4-4d74-af97-a0241a2ace5c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b6ff84de-9def-408f-9921-7d5b15bb56e0",
      target: "f981f9aa-e670-49b2-b5c6-b18b956ee853"
    },
    {
      id: "57a0cc1d-70a6-47fa-962c-c6e4039c4adf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d070eea9-3a87-4e64-9150-62af34dfceec",
      target: "663a2db9-12db-4dd3-978d-f78acc7ceaf2"
    },
    {
      id: "f69a49e4-bc99-49f7-83fb-bffdf414ff93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663a2db9-12db-4dd3-978d-f78acc7ceaf2",
      target: "321aed74-6602-4bcf-9551-e88ad2a90aee"
    },
    {
      id: "8c05f599-0280-4cb5-8567-02ff5a0377a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "321aed74-6602-4bcf-9551-e88ad2a90aee",
      target: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed"
    },
    {
      id: "d374e6f6-042b-4d6c-a1fd-6d12d71a3a7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      target: "f981f9aa-e670-49b2-b5c6-b18b956ee853"
    },
    {
      id: "3e3bf07b-8ac7-4f2e-a1b4-f811419efd2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      target: "28f8337d-b553-43c2-9031-1716482638ac"
    },
    {
      id: "347278f3-3488-41f0-a6da-2911008f2ab7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      target: "887205f0-59bd-4e1c-a04c-800fa721c007"
    },
    {
      id: "72f684fa-f223-4474-8e57-fd2316cbdf4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      target: "7ddfe567-675a-45e2-89f7-b8b15c5075e9"
    },
    {
      id: "538cbb33-b695-4174-9eb3-13b8d72fd339",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0468a36-9bae-47f5-bbeb-f09ae3e72bed",
      target: "b91354dd-90da-428d-8013-c5c267d8063e"
    },
    {
      id: "c8529183-33e5-4f2f-8bb6-1821478b46d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28f8337d-b553-43c2-9031-1716482638ac",
      target: "30b56b0f-2062-49fe-bbe3-0e8f74c93603"
    },
    {
      id: "44732f3b-5e60-4b42-a5a4-9a86bc30602c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f981f9aa-e670-49b2-b5c6-b18b956ee853",
      target: "30b56b0f-2062-49fe-bbe3-0e8f74c93603"
    },
    {
      id: "d28c3c79-8785-4583-8d09-8896aca19f17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddfe567-675a-45e2-89f7-b8b15c5075e9",
      target: "30b56b0f-2062-49fe-bbe3-0e8f74c93603"
    },
    {
      id: "d088eadd-457a-4d6b-a091-b2c8239e79c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "887205f0-59bd-4e1c-a04c-800fa721c007",
      target: "fde509e0-182d-4d99-8df9-c211ab1f6171"
    },
    {
      id: "5dde07b3-1ea5-4be2-b7ab-a4ccd646925c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b91354dd-90da-428d-8013-c5c267d8063e",
      target: "e860efb6-be26-4d2d-aef3-6af76ce6a187"
    },
    {
      id: "1741bf82-08b4-4664-ae10-27577ccfda32",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b91354dd-90da-428d-8013-c5c267d8063e",
      target: "887205f0-59bd-4e1c-a04c-800fa721c007"
    },
    {
      id: "6375ef10-6538-4ded-a937-3b5ce7d9b54e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fde509e0-182d-4d99-8df9-c211ab1f6171",
      target: "c8f14d39-2814-497d-b207-521ed31fc9dd"
    },
    {
      id: "46d21ec3-5732-4c58-b2e7-c9fc984477a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e860efb6-be26-4d2d-aef3-6af76ce6a187",
      target: "30b56b0f-2062-49fe-bbe3-0e8f74c93603"
    },
    {
      id: "646a9fa2-0e43-4bbd-9663-c5caca3285d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f14d39-2814-497d-b207-521ed31fc9dd",
      target: "30b56b0f-2062-49fe-bbe3-0e8f74c93603"
    },
    {
      id: "a9221196-e88c-49cb-a4ff-3de33be1e8f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      target: "9b392fd7-450f-4ead-a14e-cec5e6b13630"
    },
    {
      id: "26ab92db-d000-4f8b-bf3b-5b8b8f10d553",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "1c53a37a-4157-4341-a8c1-ee4ea80d62ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "a377088f-d730-4f3c-8d89-71f92d3ac45a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "2cbcaa3b-be1e-4bfd-9c9b-f0bca4d7a71e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "30b56b0f-2062-49fe-bbe3-0e8f74c93603",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "9275c557-f340-4aef-99f9-41913a190384",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      target: "cddbc8c3-6848-4da0-aa6e-16306ae9cadf"
    },
    {
      id: "86528549-84a3-46a8-956d-ef3e7ed4e6fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      target: "aed2600b-a779-42e5-9e21-c05ae757a964"
    },
    {
      id: "4cb76087-72a5-441a-a4cb-5406d4127478",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      target: "334cbf16-efb3-4308-90ac-8d37399c784b"
    },
    {
      id: "6fbf0120-16fc-41aa-bd53-c9c68aebee64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      target: "28d413d4-625a-49c1-8fa7-781f9878b8db"
    },
    {
      id: "5ea476c9-b01e-4902-bbae-e2b4e5a8c463",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3cdbdd0-bdf7-4079-a3d5-a32366ddef00",
      target: "306e399b-90ee-437d-8279-8e05faadfc37"
    },
    {
      id: "87d48c46-9d4a-45b2-82b9-6b2abc53efa4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aed2600b-a779-42e5-9e21-c05ae757a964",
      target: "1a1e33fa-df12-461b-8561-8dc7b80fc8b3"
    },
    {
      id: "81adfe90-3be0-42ee-85d9-34c2ae809d65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "306e399b-90ee-437d-8279-8e05faadfc37",
      target: "86f6a138-f42f-494f-88ff-6328921697fc"
    },
    {
      id: "3286db1c-fbd5-43c2-aa90-71053c533e2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cddbc8c3-6848-4da0-aa6e-16306ae9cadf",
      target: "4182d51a-8148-423b-bac4-1b9d91a8d69c"
    },
    {
      id: "8c5a46b6-a79b-42e6-b614-e7b8d1abdbfa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28d413d4-625a-49c1-8fa7-781f9878b8db",
      target: "86f6a138-f42f-494f-88ff-6328921697fc"
    },
    {
      id: "57e05c66-73c4-4b5f-b70f-de075435b6c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "334cbf16-efb3-4308-90ac-8d37399c784b",
      target: "86f6a138-f42f-494f-88ff-6328921697fc"
    },
    {
      id: "aa34f54a-fdf5-4778-a4b5-625b68ecb34b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4182d51a-8148-423b-bac4-1b9d91a8d69c",
      target: "1a1e33fa-df12-461b-8561-8dc7b80fc8b3"
    },
    {
      id: "c4eebfc1-75d2-432c-bd52-17b09a9bcb00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86f6a138-f42f-494f-88ff-6328921697fc",
      target: "6f08a868-e0dd-4986-abc5-38b9e51263cd"
    },
    {
      id: "b8ba42d2-057a-4ca7-af07-f1fa4125d9b8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "86f6a138-f42f-494f-88ff-6328921697fc",
      target: "53d3b873-e557-402e-9667-2069e633678d"
    },
    {
      id: "561f8759-00ae-4771-a0db-3bd106f9e2dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a1e33fa-df12-461b-8561-8dc7b80fc8b3",
      target: "241e4023-04e5-4699-bbca-d33cd4f5e1cd"
    },
    {
      id: "fea47e13-3724-4409-bee0-5dca281e54c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "241e4023-04e5-4699-bbca-d33cd4f5e1cd",
      target: "bc49cdda-185a-4f8f-9d26-b967b66003d1"
    },
    {
      id: "1712efa5-a8f0-45f5-98a1-bdbd3998cde8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc49cdda-185a-4f8f-9d26-b967b66003d1",
      target: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472"
    },
    {
      id: "7f6e1280-328d-428f-be47-0f1ad80aa0f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      target: "287d835c-892a-4506-8655-68d940de31a2"
    },
    {
      id: "552fc97a-7654-44aa-8a03-63bdbd08d755",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      target: "53d3b873-e557-402e-9667-2069e633678d"
    },
    {
      id: "51ff02f0-b161-4b48-9a45-900d754d5bf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      target: "fd22fbef-ea49-4357-97bd-8c3c51ee3194"
    },
    {
      id: "2d06897e-54ed-4567-8438-acfca26e1d83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      target: "6f08a868-e0dd-4986-abc5-38b9e51263cd"
    },
    {
      id: "f5a3f65d-8e17-4b5b-87cb-93a8562a1039",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2cbecb54-fcfa-4c5a-aba6-2cf5030c9472",
      target: "7a49a70e-9086-46bc-9ccb-172317c9ab06"
    },
    {
      id: "21ce4000-9f07-4332-a47b-88acfff58bcf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd22fbef-ea49-4357-97bd-8c3c51ee3194",
      target: "d0881ff2-384f-44c8-8d68-f9f849b81b06"
    },
    {
      id: "9620d148-80ff-499c-b1e8-29a41ee04bde",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd22fbef-ea49-4357-97bd-8c3c51ee3194",
      target: "74ee1cf2-98e1-40e1-8689-20385d55fcf0"
    },
    {
      id: "3870132a-dbad-4794-922c-d48c6351301c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53d3b873-e557-402e-9667-2069e633678d",
      target: "d0881ff2-384f-44c8-8d68-f9f849b81b06"
    },
    {
      id: "5af0c90a-8713-4687-8592-8f6c98a21eb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f08a868-e0dd-4986-abc5-38b9e51263cd",
      target: "d0881ff2-384f-44c8-8d68-f9f849b81b06"
    },
    {
      id: "0591f70d-ef5b-4b29-90bd-e7beeef8c51b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a49a70e-9086-46bc-9ccb-172317c9ab06",
      target: "be78994f-33b0-46f0-9c36-8f392580b686"
    },
    {
      id: "0cf03c00-aed5-4338-ab96-da63d0bf5156",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "287d835c-892a-4506-8655-68d940de31a2",
      target: "2bf0857a-e200-41b7-b339-1135d4ca569f"
    },
    {
      id: "f801b3f7-f2f7-408d-b21d-e9dc42359b3a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "287d835c-892a-4506-8655-68d940de31a2",
      target: "7a49a70e-9086-46bc-9ccb-172317c9ab06"
    },
    {
      id: "38f12dd2-7f20-4379-aca8-f657ba41c118",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be78994f-33b0-46f0-9c36-8f392580b686",
      target: "518a90e8-ed2b-4f72-a141-a3c13a9a3642"
    },
    {
      id: "69e78a54-8d22-4818-811c-085d7a8c4068",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bf0857a-e200-41b7-b339-1135d4ca569f",
      target: "d0881ff2-384f-44c8-8d68-f9f849b81b06"
    },
    {
      id: "1f158d03-171c-433d-8e6e-937ea6daa126",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "518a90e8-ed2b-4f72-a141-a3c13a9a3642",
      target: "d0881ff2-384f-44c8-8d68-f9f849b81b06"
    },
    {
      id: "e645783b-d64e-406e-a53c-0d10f83295e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0881ff2-384f-44c8-8d68-f9f849b81b06",
      target: "647c6a43-beb6-4657-9f02-65549581d252"
    },
    {
      id: "08569e4b-143a-4dc3-b610-5ed4723de630",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0881ff2-384f-44c8-8d68-f9f849b81b06",
      target: "6fd75974-191d-47b0-a1b4-5ac1dc6207c5"
    },
    {
      id: "1cee8667-9fde-4154-bbe3-94a945758eb4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0881ff2-384f-44c8-8d68-f9f849b81b06",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "16ec9556-5600-4160-8211-0ffae1c76512",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0881ff2-384f-44c8-8d68-f9f849b81b06",
      target: "9b392fd7-450f-4ead-a14e-cec5e6b13630"
    },
    {
      id: "9e6100b3-1905-4ad3-8878-85184da72d4c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "adb3b71f-953f-4372-82df-5655ae3eba48",
      target: "da20ac2d-283e-4a76-b8f0-fb083084a68c"
    },
    {
      id: "d944f032-d153-4836-ad69-022c0119b240",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "35dac405-8a5a-4f56-baa0-ee54071d0337"
    },
    {
      id: "1cd1d08a-0018-44a5-af8f-a6d2d53e74dd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "814fca88-0179-4f5a-bd8c-e1a9aed498f6"
    },
    {
      id: "a3772772-00de-4a41-9ee2-07afbc88268a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "49c2db29-f8b7-4697-9ee9-50894cfe766d"
    },
    {
      id: "ba402450-806a-465b-b968-d01a13afa8ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "2e72af4c-7d12-4ae6-ac85-8f96fc525515"
    },
    {
      id: "5918d68e-3dd7-4cf9-af0d-2e8821fcfcdb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "adb3b71f-953f-4372-82df-5655ae3eba48"
    },
    {
      id: "da0698ed-e86f-4b0d-84f7-617f2c25b043",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8"
    },
    {
      id: "3ce104d1-6263-4da0-86d1-bb08476978f5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "47514918-2b02-4579-a20b-6c15c940201c"
    },
    {
      id: "46e9b865-a7a2-4528-b986-5b7395515c87",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "def49e23-f658-4b58-83fd-d348d1d0a0fa",
      target: "814fca88-0179-4f5a-bd8c-e1a9aed498f6"
    },
    {
      id: "1c56bf15-01d0-4c3f-8e59-7a60f554be42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "814fca88-0179-4f5a-bd8c-e1a9aed498f6",
      target: "6375921a-2180-480e-b9f5-dcad87dd87bf"
    },
    {
      id: "0beed86b-bec4-440a-b15c-bdb85e8548b1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "814fca88-0179-4f5a-bd8c-e1a9aed498f6",
      target: "cc36ae56-fade-4d41-8b71-86a48085d358"
    },
    {
      id: "43e63e3b-4e27-4300-8c6d-d10d1d441974",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47514918-2b02-4579-a20b-6c15c940201c",
      target: "cc36ae56-fade-4d41-8b71-86a48085d358"
    },
    {
      id: "accfa05c-d74e-43cf-936c-328fa6bac26d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc36ae56-fade-4d41-8b71-86a48085d358",
      target: "57671927-a311-474e-8989-77df905ce949"
    },
    {
      id: "28e228da-5d1b-45c2-8ce8-19c9f36b297d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6375921a-2180-480e-b9f5-dcad87dd87bf",
      target: "da20ac2d-283e-4a76-b8f0-fb083084a68c"
    },
    {
      id: "75429383-a6df-4d41-ac3f-0452ba9460a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57671927-a311-474e-8989-77df905ce949",
      target: "da20ac2d-283e-4a76-b8f0-fb083084a68c"
    },
    {
      id: "8828c6d6-5dd8-43e0-b786-286fefc52c52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57671927-a311-474e-8989-77df905ce949",
      target: "357c010b-aa25-4aeb-860c-f7b7b050e152"
    },
    {
      id: "6e41baa2-357f-495f-a800-6c23fee2746b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da20ac2d-283e-4a76-b8f0-fb083084a68c",
      target: "e07b437e-c887-4bac-85aa-e0c6b6ca5494"
    },
    {
      id: "029f7c0f-f3d5-46a3-8f88-295393ed06d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da20ac2d-283e-4a76-b8f0-fb083084a68c",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "25cadecd-9df2-4d47-8254-602029c6aea1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e07b437e-c887-4bac-85aa-e0c6b6ca5494",
      target: "0a248c1d-062c-4597-ad94-5ac5d0d85c27"
    },
    {
      id: "319fb189-f775-4511-a311-1c379a1e1c60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e07b437e-c887-4bac-85aa-e0c6b6ca5494",
      target: "22141bd9-5118-4e5e-8e51-b8899985c4cd"
    },
    {
      id: "7998921d-6514-40f2-9fdf-94491765c3f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e07b437e-c887-4bac-85aa-e0c6b6ca5494",
      target: "357c010b-aa25-4aeb-860c-f7b7b050e152"
    },
    {
      id: "3245a4a6-57e5-4a68-8307-ab89cd873629",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a248c1d-062c-4597-ad94-5ac5d0d85c27",
      target: "c6107663-54c4-4d6f-a472-cef71cfcb858"
    },
    {
      id: "14fc1d9b-7cfd-401a-bf6a-d8b2f761d0fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a248c1d-062c-4597-ad94-5ac5d0d85c27",
      target: "119cc502-8ae5-49f3-a97c-5258d4f4a413"
    },
    {
      id: "b23b6776-8b78-4e24-a781-ac6b54b67287",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "357c010b-aa25-4aeb-860c-f7b7b050e152",
      target: "6cbfcb39-0259-4bd9-b4ac-b08d35a87371"
    },
    {
      id: "f8377e99-df4b-493a-931d-46f867906dce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "357c010b-aa25-4aeb-860c-f7b7b050e152",
      target: "c400db76-d6aa-4187-b34c-89cd23e11458"
    },
    {
      id: "fe5a9b14-b189-4d49-b834-bbbc2a5738e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "357c010b-aa25-4aeb-860c-f7b7b050e152",
      target: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61"
    },
    {
      id: "8f0a3719-4910-4e1c-8e2e-c49aa55820b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6cbfcb39-0259-4bd9-b4ac-b08d35a87371",
      target: "19953082-3717-43fe-93f3-417e81747798"
    },
    {
      id: "7255ab5d-c240-48fa-a637-fef0e34b25fd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "19953082-3717-43fe-93f3-417e81747798",
      target: "91160375-ff37-4074-b7a4-e2bceca5e402"
    },
    {
      id: "b1462377-b300-4416-85cd-3d39a2c4fcb8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "91160375-ff37-4074-b7a4-e2bceca5e402",
      target: "2f5a0a67-3f19-4a87-a681-72a97dd49a86"
    },
    {
      id: "e08e92ac-1872-4882-b975-a809978374b4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "91160375-ff37-4074-b7a4-e2bceca5e402",
      target: "23b83478-dc78-4be9-9125-02e1d278076d"
    },
    {
      id: "595a97d6-e7ba-4c2e-bf8e-a37853325cc8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f5a0a67-3f19-4a87-a681-72a97dd49a86",
      target: "e1434d18-0cf0-456c-88d6-6d6373063f18"
    },
    {
      id: "e54478e2-b35d-4e27-bbdd-0e239f5d6dd3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e1434d18-0cf0-456c-88d6-6d6373063f18",
      target: "ebbeb88c-3fc4-4ff4-bbb0-88342eee3836"
    },
    {
      id: "2b113283-6b39-4625-b91b-ea6c2da7f1cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1434d18-0cf0-456c-88d6-6d6373063f18",
      target: "2a45531e-2d53-4926-9c51-38cb8f4abf65"
    },
    {
      id: "23fb39a5-240f-4cb0-b045-bec0496ebde9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebbeb88c-3fc4-4ff4-bbb0-88342eee3836",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "8120224f-b3e2-45f9-9b18-4dca020c427a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ebbeb88c-3fc4-4ff4-bbb0-88342eee3836",
      target: "c6107663-54c4-4d6f-a472-cef71cfcb858"
    },
    {
      id: "ead6092c-98b8-4b50-a9d0-aaae1af49330",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23b83478-dc78-4be9-9125-02e1d278076d",
      target: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366"
    },
    {
      id: "0ccbf637-0dc9-4492-acc3-2d41043e47e0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c6107663-54c4-4d6f-a472-cef71cfcb858",
      target: "95e6e290-9351-45cb-a9b6-158d608044a0"
    },
    {
      id: "84a42cb7-d671-4c75-9df2-086d25de8a13",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95e6e290-9351-45cb-a9b6-158d608044a0",
      target: "567614ba-0249-4af4-9377-ebf35bea90df"
    },
    {
      id: "f753c21e-86e3-49e7-8692-9e7b1803de03",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "567614ba-0249-4af4-9377-ebf35bea90df",
      target: "862633a3-0830-40e4-b052-c3bfe6286a90"
    },
    {
      id: "123560da-ed14-4f47-8889-be1d1219f7b2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "862633a3-0830-40e4-b052-c3bfe6286a90",
      target: "01615c95-a9a0-4728-9877-6ca9d72bb5c5"
    },
    {
      id: "92ace635-4bab-420d-b362-4e633f2bbecf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "862633a3-0830-40e4-b052-c3bfe6286a90",
      target: "6b1600de-c4dd-40df-8c6b-037320e91e8e"
    },
    {
      id: "3701b732-efea-45f3-9e83-9c27f959bc78",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "862633a3-0830-40e4-b052-c3bfe6286a90",
      target: "f0e9db08-4cbb-458d-8b7c-f71051caadd9"
    },
    {
      id: "43a2c7e0-6297-440a-b3d6-f163a7c03224",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "01615c95-a9a0-4728-9877-6ca9d72bb5c5",
      target: "ff4b586d-725c-4f81-a0cc-24910d8529df"
    },
    {
      id: "8f324167-f3af-4990-b4d3-fc298f7ed788",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "01615c95-a9a0-4728-9877-6ca9d72bb5c5",
      target: "014c8355-07c5-4c4f-b07e-770c03345b1a"
    },
    {
      id: "17376271-0702-405b-8a44-51a8ec14e0ca",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f0e9db08-4cbb-458d-8b7c-f71051caadd9",
      target: "7c62768a-aa63-4990-a121-038315d2c3b0"
    },
    {
      id: "e87a35e9-e40e-4078-ba63-79d8817a8713",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f0e9db08-4cbb-458d-8b7c-f71051caadd9",
      target: "38a275b8-5885-4a5a-917c-c853ccc68de5"
    },
    {
      id: "26594809-8133-4e16-847a-5271c7db670b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b1600de-c4dd-40df-8c6b-037320e91e8e",
      target: "014c8355-07c5-4c4f-b07e-770c03345b1a"
    },
    {
      id: "44783adf-270d-4585-94fd-9cbf6691dbdb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b1600de-c4dd-40df-8c6b-037320e91e8e",
      target: "55e82dd7-8d81-48cc-a359-59bf9baf85ad"
    },
    {
      id: "c7a85097-55f3-40f6-b196-2769474d388f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "014c8355-07c5-4c4f-b07e-770c03345b1a",
      target: "7fcec3d5-a52c-46a2-afc9-d813553836a9"
    },
    {
      id: "0968c888-df3c-46f3-a52a-6894dbf32eab",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "55e82dd7-8d81-48cc-a359-59bf9baf85ad",
      target: "1c07ecc8-327e-426b-8911-b50d65c80ab2"
    },
    {
      id: "bbe3a04f-f118-45c6-b295-2b6983743d33",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7c62768a-aa63-4990-a121-038315d2c3b0",
      target: "fc40cb84-1494-4112-8454-d1d04e8a4201"
    },
    {
      id: "f0479314-9836-453d-9f84-cc1fb36d1307",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "38a275b8-5885-4a5a-917c-c853ccc68de5",
      target: "fc40cb84-1494-4112-8454-d1d04e8a4201"
    },
    {
      id: "bc283087-e0a3-4577-acf3-e151d3073f80",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fc40cb84-1494-4112-8454-d1d04e8a4201",
      target: "6e1c97e4-389e-491f-93f9-57de37f6c03f"
    },
    {
      id: "a3aa4dbc-446c-476e-8199-543f23200330",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fc40cb84-1494-4112-8454-d1d04e8a4201",
      target: "7fcec3d5-a52c-46a2-afc9-d813553836a9"
    },
    {
      id: "ee27f1fd-81ae-4ae2-b2d2-325d864b20c4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7fcec3d5-a52c-46a2-afc9-d813553836a9",
      target: "1c07ecc8-327e-426b-8911-b50d65c80ab2"
    },
    {
      id: "a1437162-5f38-4223-8eb5-ca38e1708aa7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c07ecc8-327e-426b-8911-b50d65c80ab2",
      target: "11124115-e84b-48a2-b3b3-96ff6467f7a9"
    },
    {
      id: "76d276ae-8b91-4eaf-9800-67c7312f25d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c07ecc8-327e-426b-8911-b50d65c80ab2",
      target: "a3fc6847-0c20-4b3b-a642-c54f7b39504e"
    },
    {
      id: "1846e30f-718c-41a1-9dd1-294b0698da09",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c07ecc8-327e-426b-8911-b50d65c80ab2",
      target: "57476b2f-e2af-4635-9fc6-c8ec51bdd64f"
    },
    {
      id: "aa933342-15d2-429d-9f7c-2e4bf7de5593",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c07ecc8-327e-426b-8911-b50d65c80ab2",
      target: "243331d7-08a6-44da-9d57-491ac509deba"
    },
    {
      id: "3fef37e3-dcc2-4125-b96c-f3554c053ef8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6e1c97e4-389e-491f-93f9-57de37f6c03f",
      target: "f443b980-3700-420e-b9fd-97b1edb2dd7c"
    },
    {
      id: "562def1a-31b8-4048-90ca-48311a9d5032",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ff4b586d-725c-4f81-a0cc-24910d8529df",
      target: "014c8355-07c5-4c4f-b07e-770c03345b1a"
    },
    {
      id: "3b423cd0-9380-4db1-952a-9e675f29df9a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3fc6847-0c20-4b3b-a642-c54f7b39504e",
      target: "f443b980-3700-420e-b9fd-97b1edb2dd7c"
    },
    {
      id: "fc8abffe-0769-4cc1-87ad-bc47b118cc97",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "243331d7-08a6-44da-9d57-491ac509deba",
      target: "f443b980-3700-420e-b9fd-97b1edb2dd7c"
    },
    {
      id: "9f0c0b2a-b51e-407f-a4d0-de43ef120b89",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "57476b2f-e2af-4635-9fc6-c8ec51bdd64f",
      target: "f443b980-3700-420e-b9fd-97b1edb2dd7c"
    },
    {
      id: "ef0e3126-463f-4bd0-ad44-5d508bf0f4d0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "11124115-e84b-48a2-b3b3-96ff6467f7a9",
      target: "f443b980-3700-420e-b9fd-97b1edb2dd7c"
    },
    {
      id: "b681e360-7345-46ea-8e11-5602bc1d1fa4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f443b980-3700-420e-b9fd-97b1edb2dd7c",
      target: "0d815e2a-7138-48ef-91d5-36b004cf7776"
    },
    {
      id: "d0f3f0ba-54d3-4204-9362-9a293bcb0b51",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d815e2a-7138-48ef-91d5-36b004cf7776",
      target: "59d90d4d-34c5-402c-ab7d-327de960ab5a"
    },
    {
      id: "f213b30f-2661-467f-8690-93803de6fc67",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "59d90d4d-34c5-402c-ab7d-327de960ab5a",
      target: "00929af5-44cf-4d8e-8ab5-6e0c69870a54"
    },
    {
      id: "03b03258-6716-43a1-b7ae-4102c1b378bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59d90d4d-34c5-402c-ab7d-327de960ab5a",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "4d15c140-4737-40b8-8a63-d8e72982f66b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "00929af5-44cf-4d8e-8ab5-6e0c69870a54",
      target: "4bc3f1e6-fe3d-47d7-b115-a69c1ce2d288"
    },
    {
      id: "cdd21dc6-7541-4332-9e58-63ccd90aa7d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4bc3f1e6-fe3d-47d7-b115-a69c1ce2d288",
      target: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366"
    },
    {
      id: "c402ce50-1f8b-4594-a4f6-e20351de5b82",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366",
      target: "5da6c4f0-606f-4c55-8cd5-61bd95f19baf"
    },
    {
      id: "b8f73a37-80fa-49e1-b930-a92f926ca4f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "ed50fb9b-01b6-46f1-8bc8-94181f45115c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5da6c4f0-606f-4c55-8cd5-61bd95f19baf",
      target: "7581676d-2b94-4609-b168-7764e4136f48"
    },
    {
      id: "d69c01e9-a9df-4c44-ad6d-fdd02a23a97b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7581676d-2b94-4609-b168-7764e4136f48",
      target: "91934193-29f3-4677-9b89-832aaad7d820"
    },
    {
      id: "b819d26f-016d-49af-ae6e-d072aaca42e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7581676d-2b94-4609-b168-7764e4136f48",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "fe9ee851-661b-4fc9-ac5d-bc593169551e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "b6353a66-bba0-4814-8480-84e8a9beda36"
    },
    {
      id: "57b5c5ba-d9ea-4f89-a57a-22f3580ece8c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "4a213102-ecdd-4d3c-87e6-1eca8cf0725b"
    },
    {
      id: "a585bf38-ecd1-4ef9-96ef-28f881640727",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "cfc5354b-ec39-4c10-80c0-476fdce6b389"
    },
    {
      id: "ce4375dc-c0b6-4cca-8538-03394661c374",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "4a213102-ecdd-4d3c-87e6-1eca8cf0725b"
    },
    {
      id: "5dc8fc25-3869-4cce-9816-6a8dde7fe283",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "b6353a66-bba0-4814-8480-84e8a9beda36"
    },
    {
      id: "82dff977-9285-475d-aa47-76b0a5b51792",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35dac405-8a5a-4f56-baa0-ee54071d0337",
      target: "cfc5354b-ec39-4c10-80c0-476fdce6b389"
    },
    {
      id: "69d7bfda-f5df-4d95-8f23-09c0d0f12e1c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cfc5354b-ec39-4c10-80c0-476fdce6b389",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "c4f43bd8-8c48-4e31-90fa-50b03d35ea1a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cfc5354b-ec39-4c10-80c0-476fdce6b389",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "121edf85-da90-4893-b8c4-69ecbded108e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "304302ca-1b65-44d6-b642-0ee01206a910",
      target: "3ecc29de-0bef-426d-88a8-e44589e45dcd"
    },
    {
      id: "1aebe4f2-f7e5-4d29-9945-99519b0ae497",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "304302ca-1b65-44d6-b642-0ee01206a910",
      target: "ee2d3707-daf6-4648-b2e6-de4d670e2f04"
    },
    {
      id: "59feb52a-d3ff-4ccb-a79e-0ebb45b71915",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "304302ca-1b65-44d6-b642-0ee01206a910",
      target: "512c7e2f-0143-4a3c-b17f-a8688702d3d8"
    },
    {
      id: "b3b135a4-f4e6-4294-aca1-c3510ea79188",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "304302ca-1b65-44d6-b642-0ee01206a910",
      target: "c1e92bd0-aeae-42bb-9459-8d0be7fc458c"
    },
    {
      id: "355d34b1-8626-4608-bf96-9415a7409167",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b6353a66-bba0-4814-8480-84e8a9beda36",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "1da1723e-c422-4b1c-8d37-479de499caa9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b6353a66-bba0-4814-8480-84e8a9beda36",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "81e50e5d-66ba-4f14-bd75-7356ed0f127d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4a213102-ecdd-4d3c-87e6-1eca8cf0725b",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "1de9667d-2dc5-497f-ac5a-66ffed24f856",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4a213102-ecdd-4d3c-87e6-1eca8cf0725b",
      target: "304302ca-1b65-44d6-b642-0ee01206a910"
    },
    {
      id: "9422468d-fadd-40f3-87cf-cf888bdb826a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ee2d3707-daf6-4648-b2e6-de4d670e2f04",
      target: "3ecc29de-0bef-426d-88a8-e44589e45dcd"
    },
    {
      id: "1ce1a078-e3ee-4061-bb1a-23d4edeb3557",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c1e92bd0-aeae-42bb-9459-8d0be7fc458c",
      target: "3ecc29de-0bef-426d-88a8-e44589e45dcd"
    },
    {
      id: "96835e29-3580-4ed7-95cd-eaff81dd0aca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "512c7e2f-0143-4a3c-b17f-a8688702d3d8",
      target: "3ecc29de-0bef-426d-88a8-e44589e45dcd"
    },
    {
      id: "16dfb82b-877b-466a-b9ab-22681fa77f44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ecc29de-0bef-426d-88a8-e44589e45dcd",
      target: "16bd69c7-82fb-4a43-ad8c-ae161f901385"
    },
    {
      id: "e79f9e2e-d8ac-4b88-b9b9-d1554f19a182",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16bd69c7-82fb-4a43-ad8c-ae161f901385",
      target: "8d9201fa-93a1-4b66-8cfe-8313bf582b0e"
    },
    {
      id: "ab634ce2-f7b3-49a7-8a18-bc4f858b13d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d9201fa-93a1-4b66-8cfe-8313bf582b0e",
      target: "1e3995d9-25be-4a16-ac68-39d4044b8042"
    },
    {
      id: "6f814077-1882-4725-9aa9-b9798686a44e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e3995d9-25be-4a16-ac68-39d4044b8042",
      target: "b06342ba-a0bf-4fd7-8674-6a69f2993a46"
    },
    {
      id: "273ade1d-5063-46ac-a2fe-b2902990d376",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "504713b3-e1c8-415d-b748-c4372ff0382b",
      target: "8ed1802e-75ea-4963-8ba0-cf9c15f0419d"
    },
    {
      id: "42298bab-9d40-43ca-9c14-96ce73e1ead5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "bbabb219-fc1c-4129-b72e-4c69569e041b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      target: "504713b3-e1c8-415d-b748-c4372ff0382b"
    },
    {
      id: "bf32493b-afc0-486d-8f6f-bcf2950e3b74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      target: "8ed1802e-75ea-4963-8ba0-cf9c15f0419d"
    },
    {
      id: "0cd2bce6-fc74-4fd5-90bf-f089339826db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      target: "0dfba42c-1508-428c-9ce2-6df1c46ebea7"
    },
    {
      id: "e786ef09-4301-4ab8-86ae-58b61b9f9dce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b06342ba-a0bf-4fd7-8674-6a69f2993a46",
      target: "e1279ce9-5049-4fae-bc19-b170eb75f399"
    },
    {
      id: "baedc531-3b40-4585-838a-27f10adda4cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ed1802e-75ea-4963-8ba0-cf9c15f0419d",
      target: "4dbf8682-7b49-4bd8-875b-912c9a62186c"
    },
    {
      id: "7e046b71-3d51-4fe1-a94a-89cf6c554b7a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0dfba42c-1508-428c-9ce2-6df1c46ebea7",
      target: "8ed1802e-75ea-4963-8ba0-cf9c15f0419d"
    },
    {
      id: "869cf418-8662-42b9-94b3-0db238ffda54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dbf8682-7b49-4bd8-875b-912c9a62186c",
      target: "8432736e-acec-4682-8d2a-3ea945f9fe05"
    },
    {
      id: "9777e9bc-6ffb-48fb-ab10-c3014609f54a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dbf8682-7b49-4bd8-875b-912c9a62186c",
      target: "0a63157d-2a02-43f0-9a8e-f26af83b655f"
    },
    {
      id: "f8e979d4-e27a-427c-bec4-10e3ae331560",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dbf8682-7b49-4bd8-875b-912c9a62186c",
      target: "2b687114-0497-4328-8745-8ddfe24fd8c9"
    },
    {
      id: "49b3840e-ffd6-41c8-a0e2-8a99506099a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dbf8682-7b49-4bd8-875b-912c9a62186c",
      target: "7d4609c8-6296-4f67-8f00-7399939d7683"
    },
    {
      id: "8a7147ff-e220-4b79-8fe0-66d609933c8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d4609c8-6296-4f67-8f00-7399939d7683",
      target: "8e199a5b-a211-4967-bc69-cb2cb0ac65de"
    },
    {
      id: "9373416c-e43e-4116-af77-5b348149ec77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8432736e-acec-4682-8d2a-3ea945f9fe05",
      target: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366"
    },
    {
      id: "a086e767-1ec5-4992-88ae-985592534456",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b687114-0497-4328-8745-8ddfe24fd8c9",
      target: "8e199a5b-a211-4967-bc69-cb2cb0ac65de"
    },
    {
      id: "04d51488-dee0-460a-ac8b-198cef9b4f78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b687114-0497-4328-8745-8ddfe24fd8c9",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "3eb6feef-82d7-4286-86ee-c20a9eef327d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e199a5b-a211-4967-bc69-cb2cb0ac65de",
      target: "e17bbfbd-e978-4085-a0cf-46e9a690e99a"
    },
    {
      id: "9b5c2a91-23d4-439d-9f80-51f23a8ef3e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e17bbfbd-e978-4085-a0cf-46e9a690e99a",
      target: "ce2a1ce2-f17e-473f-b202-b5e4093a77c6"
    },
    {
      id: "5065ce69-e6fe-4aab-96b5-f1d4f1f462a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce2a1ce2-f17e-473f-b202-b5e4093a77c6",
      target: "34eef9b1-54b2-4ea8-80d6-6dd0e0c44366"
    },
    {
      id: "2da63877-5a66-4bb5-a0fd-2fd81a916889",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61",
      target: "590c6b80-78b8-413f-9298-b28a850c095c"
    },
    {
      id: "f40da81e-4888-4283-9e8f-916753419040",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61",
      target: "98a5d32d-2029-4533-a0a7-ca859f808f68"
    },
    {
      id: "9608ed58-11e3-4f1f-a036-4c73ef4be77c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfb9245f-3bf6-4033-af2d-abb04f9ceb61",
      target: "262de4d5-857d-44f1-9c96-1dcfa716764b"
    },
    {
      id: "c02a4b9e-b85b-4b75-bbb8-db11a4cde5e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "590c6b80-78b8-413f-9298-b28a850c095c",
      target: "732a8b76-e31a-4493-a6e9-31c7d1d0008a"
    },
    {
      id: "7c7eda94-e532-4648-ab47-c5eb6343e2af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "590c6b80-78b8-413f-9298-b28a850c095c",
      target: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81"
    },
    {
      id: "67b97562-29ff-4f5e-8c03-ca191933fcfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "590c6b80-78b8-413f-9298-b28a850c095c",
      target: "32dd8d3d-362d-48b0-ba56-b735b6556b11"
    },
    {
      id: "a9d70484-fa01-4036-a375-10ffa1537c30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81",
      target: "5debe745-9862-414a-b073-b42917687ff4"
    },
    {
      id: "604322be-f224-4079-8d36-93c635af02c6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81",
      target: "465afcde-3dcc-4b35-bae7-843bfd3b95f3"
    },
    {
      id: "7531e5fc-0b7f-4e0e-9da1-4f540b257e3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ce64d3c-3ebc-455f-9fa7-6102789b2c81",
      target: "49d33848-79d4-4f84-926b-2a2ad57df1b4"
    },
    {
      id: "e44596a7-ea01-4203-9f93-fc4659754eeb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "465afcde-3dcc-4b35-bae7-843bfd3b95f3",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "4dadf026-b59a-4901-b987-172e97c0a3fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "465afcde-3dcc-4b35-bae7-843bfd3b95f3",
      target: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec"
    },
    {
      id: "25c3177a-265b-4574-9941-1958e98deca0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "465afcde-3dcc-4b35-bae7-843bfd3b95f3",
      target: "d374f729-28ce-44ea-a8ee-84b337261347"
    },
    {
      id: "74c69504-bfe4-4052-860f-24ac0366968d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "262de4d5-857d-44f1-9c96-1dcfa716764b",
      target: "32dd8d3d-362d-48b0-ba56-b735b6556b11"
    },
    {
      id: "a921887c-ef3c-498c-8f82-057b3ab105e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "262de4d5-857d-44f1-9c96-1dcfa716764b",
      target: "98a5d32d-2029-4533-a0a7-ca859f808f68"
    },
    {
      id: "6792a645-c353-44dd-9cb1-18ddc87fe09f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "32dd8d3d-362d-48b0-ba56-b735b6556b11",
      target: "49d33848-79d4-4f84-926b-2a2ad57df1b4"
    },
    {
      id: "5ae75e60-56f2-4b86-80f2-3b5a8849b1b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32dd8d3d-362d-48b0-ba56-b735b6556b11",
      target: "732a8b76-e31a-4493-a6e9-31c7d1d0008a"
    },
    {
      id: "3dc953b5-f84b-4dc3-9acb-6de10f78f4ae",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "49d33848-79d4-4f84-926b-2a2ad57df1b4",
      target: "d374f729-28ce-44ea-a8ee-84b337261347"
    },
    {
      id: "354c016d-a600-4bdd-8d1b-50d6adb0ad40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49d33848-79d4-4f84-926b-2a2ad57df1b4",
      target: "5debe745-9862-414a-b073-b42917687ff4"
    },
    {
      id: "c11290a8-ed56-41b0-b466-e37016f4ca64",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d374f729-28ce-44ea-a8ee-84b337261347",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "7c29142e-75a2-42ed-be3a-8e80359aab22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d374f729-28ce-44ea-a8ee-84b337261347",
      target: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec"
    },
    {
      id: "d87b0588-f679-40e8-89ec-6a6c358877fa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d374f729-28ce-44ea-a8ee-84b337261347",
      target: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec"
    },
    {
      id: "a4db7b43-200d-48dc-979f-5f8c69855041",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "925cae29-3bdc-44d3-9e8b-e3e88ca8ee7a"
    },
    {
      id: "f667e44f-9876-4651-bd3c-4ad2f9287f26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "00e78dd0-bce3-47ca-8c9a-fa95fe35a73d"
    },
    {
      id: "c6be978a-a307-444a-a5c6-ae084ead97d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "3edd199b-ca7b-4066-8faf-3bcaaf3cb119"
    },
    {
      id: "dc2d2159-b983-4367-bff7-9725ae4c4512",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5"
    },
    {
      id: "ba420982-2e84-4fff-b61f-ecd3d0d7a02d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "6a90a127-28fd-4775-a98d-e17c6c84f2cf"
    },
    {
      id: "46472470-8f65-4644-9990-b2a5e69e8d2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07a429d0-1de6-448a-9879-487c9e533b55",
      target: "adb4861e-b395-4297-98a4-97a757b9a357"
    },
    {
      id: "fad18378-5029-4ef8-b752-f9395b91fbfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00e78dd0-bce3-47ca-8c9a-fa95fe35a73d",
      target: "3dad5883-0038-409a-9d17-1854e369f85d"
    },
    {
      id: "722352b0-4047-4587-8648-e62f85b5fd11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "adb4861e-b395-4297-98a4-97a757b9a357",
      target: "3dad5883-0038-409a-9d17-1854e369f85d"
    },
    {
      id: "d14a942b-20d2-4512-bf8e-9333074903b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "925cae29-3bdc-44d3-9e8b-e3e88ca8ee7a",
      target: "3dad5883-0038-409a-9d17-1854e369f85d"
    },
    {
      id: "33e47e53-371b-4199-923f-45a614e4303d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a90a127-28fd-4775-a98d-e17c6c84f2cf",
      target: "cb3dd730-ec2f-44fe-9102-b7eb06e50111"
    },
    {
      id: "2dc61003-d8fc-40f9-81a8-b169db310f3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3edd199b-ca7b-4066-8faf-3bcaaf3cb119",
      target: "f9b5979d-3be3-4855-b1ba-cd7985f44884"
    },
    {
      id: "95c0b22f-2287-43ce-87d7-ff156fea5c53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb3dd730-ec2f-44fe-9102-b7eb06e50111",
      target: "f9b5979d-3be3-4855-b1ba-cd7985f44884"
    },
    {
      id: "98e66ae3-4cbd-457c-8722-036c077e13c6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3dad5883-0038-409a-9d17-1854e369f85d",
      target: "e8c10fa9-fc51-430a-97d0-c66993f2cbe6"
    },
    {
      id: "535026a5-3037-433c-a599-7311216cbc99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3dad5883-0038-409a-9d17-1854e369f85d",
      target: "8d985d3d-d7d5-4fec-aaa9-a17e966bc701"
    },
    {
      id: "b9a79cd5-680b-41d5-b3cf-ff61736a5d44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9b5979d-3be3-4855-b1ba-cd7985f44884",
      target: "bf83dc35-3c91-4905-b1db-959f7b465647"
    },
    {
      id: "4b77e55f-02d7-459a-8b96-3f43fc5c5c28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf83dc35-3c91-4905-b1db-959f7b465647",
      target: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7"
    },
    {
      id: "01ab4c9a-001f-4647-aa0d-c5f21a36e5b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7",
      target: "62f8196f-0ff5-491f-bb2b-95b6b33c77a5"
    },
    {
      id: "f2f0a6b2-3c18-4d7f-93f5-11e9bb96c82b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7",
      target: "c9ad3d23-754a-4671-ad56-20d0365599db"
    },
    {
      id: "b83da140-caa8-45bc-a7f0-16e146604012",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7",
      target: "61f5fcd7-5f32-4bfe-9f35-40db96d584ef"
    },
    {
      id: "a6deb434-2bb9-45f2-a748-97ecb0431549",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "715594fa-d190-4fed-a3ac-d58e5f5f8ac7",
      target: "543fd443-71ab-4709-8f6f-7db7a8c373ea"
    },
    {
      id: "67c51d40-a544-404c-9447-04df0fbb2664",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9ad3d23-754a-4671-ad56-20d0365599db",
      target: "5c1c5bf9-70c3-48d3-962f-31f06bda80fe"
    },
    {
      id: "ad1e291e-7525-45be-ad57-2f51b91bc4b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "543fd443-71ab-4709-8f6f-7db7a8c373ea",
      target: "e8c10fa9-fc51-430a-97d0-c66993f2cbe6"
    },
    {
      id: "cd2f18e3-a485-412a-845f-868f5e7fe677",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "543fd443-71ab-4709-8f6f-7db7a8c373ea",
      target: "a94aec1e-7229-490b-b6ec-195d995d268a"
    },
    {
      id: "53f3f22b-5ae7-44fa-a372-ceb3942f1ddc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "543fd443-71ab-4709-8f6f-7db7a8c373ea",
      target: "8d985d3d-d7d5-4fec-aaa9-a17e966bc701"
    },
    {
      id: "d8e5842f-bf89-426e-9146-6d780ea7ad98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c1c5bf9-70c3-48d3-962f-31f06bda80fe",
      target: "49afa6bd-1404-4027-a9f6-b75a881b6c9d"
    },
    {
      id: "04d14068-3c77-4f09-9a16-b482c42122ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a94aec1e-7229-490b-b6ec-195d995d268a",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "6ed94d61-586f-4d48-9649-4d106520e8a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a94aec1e-7229-490b-b6ec-195d995d268a",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "b49988a2-212b-4368-813e-6f13f608267f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8c10fa9-fc51-430a-97d0-c66993f2cbe6",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "3afaba18-726c-4708-9cff-240c58c04234",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d985d3d-d7d5-4fec-aaa9-a17e966bc701",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "9b1abeac-1c9d-4f2f-bbe9-078fbe825e3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "49afa6bd-1404-4027-a9f6-b75a881b6c9d",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "e585a91d-16e7-4a26-8355-6a2fd2568ed6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "044651ee-c262-4fd1-a2de-ffaf92ba5963",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "5b71dbdb-8041-43c3-8cbd-e6062f795f71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a",
      target: "91934193-29f3-4677-9b89-832aaad7d820"
    },
    {
      id: "cf9bbb0e-ac2a-47d9-affb-c85efd4f2c89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62f8196f-0ff5-491f-bb2b-95b6b33c77a5",
      target: "e0c445d5-4ec8-48e9-a52e-97b737412b93"
    },
    {
      id: "40e3aa48-8752-4d2b-813b-babc06c155ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0c445d5-4ec8-48e9-a52e-97b737412b93",
      target: "f99e57c9-ea00-4656-847e-0f3ca7bacc96"
    },
    {
      id: "603972c2-bf66-49bb-9181-362249761911",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f99e57c9-ea00-4656-847e-0f3ca7bacc96",
      target: "8e6cd7c8-d32d-4eba-bb19-2df58436f161"
    },
    {
      id: "48b9b2f9-a9e4-4101-a80a-613b3fd032da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e6cd7c8-d32d-4eba-bb19-2df58436f161",
      target: "37ba63b9-445e-4c23-b2f0-55c7dd0198e6"
    },
    {
      id: "2cac0547-ac9a-4674-b2ed-8ec9a3ed9187",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e6cd7c8-d32d-4eba-bb19-2df58436f161",
      target: "c9609c4d-19d8-4300-ae1e-02cc7bb08b16"
    },
    {
      id: "0662616d-aeb4-42ed-9ffb-5bb57d753cfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37ba63b9-445e-4c23-b2f0-55c7dd0198e6",
      target: "81653fb2-2628-422e-9882-31ff7c58e09f"
    },
    {
      id: "0863b08f-925c-4daf-8a80-eb2fa5ad9a68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9609c4d-19d8-4300-ae1e-02cc7bb08b16",
      target: "578e4efb-394e-4710-b082-79db1ce54fe1"
    },
    {
      id: "e57d5cb2-e90b-4f1e-b9b9-97741ca2b87a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81653fb2-2628-422e-9882-31ff7c58e09f",
      target: "578e4efb-394e-4710-b082-79db1ce54fe1"
    },
    {
      id: "c8496b58-4758-43b1-b4e2-4ca10685bbdf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "578e4efb-394e-4710-b082-79db1ce54fe1",
      target: "f903e28c-4906-4080-bf57-47788d7d475a"
    },
    {
      id: "21d9d6f2-ea56-44e3-96e1-387498a8ba64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f903e28c-4906-4080-bf57-47788d7d475a",
      target: "cef65ab2-1eb1-4d88-93c8-e5579b8d4c75"
    },
    {
      id: "9739993d-c252-4254-aeff-e3000786be29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cef65ab2-1eb1-4d88-93c8-e5579b8d4c75",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "32ac6642-8bc4-4579-8500-9d93bffbfcc8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61f5fcd7-5f32-4bfe-9f35-40db96d584ef",
      target: "5a5bcb62-e1a7-41ee-9487-414ac395de8b"
    },
    {
      id: "29c00cc9-dab7-4bf4-a726-152d00b69fe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a5bcb62-e1a7-41ee-9487-414ac395de8b",
      target: "a7847c6a-8535-4909-81d3-95239178755f"
    },
    {
      id: "64941bc1-bfd6-416e-a30c-4091d0e2f5c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7847c6a-8535-4909-81d3-95239178755f",
      target: "9acce500-15d1-40e1-8695-be97fd7544ca"
    },
    {
      id: "139f3511-6d54-48b6-9160-cce8d344f481",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9acce500-15d1-40e1-8695-be97fd7544ca",
      target: "aa484bd1-228b-4d55-8c12-92a1cdff3942"
    },
    {
      id: "8032ad48-fae9-4cd8-95a7-0b8d2246d4fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9acce500-15d1-40e1-8695-be97fd7544ca",
      target: "cf3055ff-4f2c-47a3-a4b7-d3567cce3760"
    },
    {
      id: "9c5686d2-26f1-4483-94b2-e69d63f707ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa484bd1-228b-4d55-8c12-92a1cdff3942",
      target: "133e49c0-4321-4385-a537-e1d6fbe38160"
    },
    {
      id: "9ad3939e-c598-44e2-b9da-c42dd742c72c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf3055ff-4f2c-47a3-a4b7-d3567cce3760",
      target: "f5687045-e840-4e35-a83a-988bd79c8da2"
    },
    {
      id: "96a677a5-74e9-470c-9a35-b92b4d0055d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "133e49c0-4321-4385-a537-e1d6fbe38160",
      target: "f5687045-e840-4e35-a83a-988bd79c8da2"
    },
    {
      id: "c54d277c-5f89-4677-a1e8-a09b865c6601",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5687045-e840-4e35-a83a-988bd79c8da2",
      target: "d18df9ed-00e2-4ba1-8a33-1deaaed8d03e"
    },
    {
      id: "cead32fb-7373-486b-aa96-2564df4b4e8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d18df9ed-00e2-4ba1-8a33-1deaaed8d03e",
      target: "95083085-3c7d-4cb9-9e03-25a54f77c6c9"
    },
    {
      id: "3d8c2f54-e443-486e-a4f7-38a95e6f6bed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95083085-3c7d-4cb9-9e03-25a54f77c6c9",
      target: "ed091bf5-1ccf-49c8-bcf0-9ab6a4d3f23a"
    },
    {
      id: "41d3ffc6-b81e-40f0-af66-f5932cb947d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4699d3cb-d8a0-4c04-adce-21fa7c2cd641",
      target: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5"
    },
    {
      id: "d194e722-3873-4a39-b6eb-ac40cc4cf88c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4699d3cb-d8a0-4c04-adce-21fa7c2cd641",
      target: "6aac9d75-7734-46a2-ad90-bae35ba34d51"
    },
    {
      id: "369775c2-ecf6-4f4f-a9fa-89eacee2f40a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "ed7dbef1-2034-4840-b525-42186058830d"
    },
    {
      id: "4d2a0867-a3be-4d83-82ac-5b9217a46d8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "5306793e-af2a-4042-a75e-256b21d5f175"
    },
    {
      id: "92c6b8fb-a8b1-45f3-ba2d-6a83d4818d26",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b"
    },
    {
      id: "fb39c7a7-7e0b-45cb-8b76-5a8a11b382ef",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0"
    },
    {
      id: "40ebb449-de5f-45a3-b067-b607396cccd7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b"
    },
    {
      id: "d3963c81-8107-4829-83c7-c958aae5c5e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "cedeb8b1-272c-49fb-a5a4-d879e3270874"
    },
    {
      id: "5904bf08-dc5a-45f9-8e15-2edc90a7a550",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0"
    },
    {
      id: "650277f5-c923-4069-87e3-ce5778aa5d62",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "d6015d46-abf0-42b7-a87e-0d68d7c85fb9"
    },
    {
      id: "6839f1a0-03ec-45a9-abf6-8ba3885ee0c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b03efa6e-fb92-4dc4-ba10-17ff2d795dd5",
      target: "706b87a2-dbac-4cf0-a069-f49413855482"
    },
    {
      id: "1b9d85e1-38b1-4193-9634-981a45674b1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed7dbef1-2034-4840-b525-42186058830d",
      target: "51d604b9-f5df-40e9-aaeb-48c0025ccc98"
    },
    {
      id: "52a56528-7ba6-4961-ad4f-c76ec576463b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5306793e-af2a-4042-a75e-256b21d5f175",
      target: "51d604b9-f5df-40e9-aaeb-48c0025ccc98"
    },
    {
      id: "6b851b35-e83f-43e6-bfcc-7822f9774a65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cedeb8b1-272c-49fb-a5a4-d879e3270874",
      target: "9a133269-2707-4959-a1ba-fd01eb52aa65"
    },
    {
      id: "4124b6ad-4a11-4480-9eb1-4301fa9d3c2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "706b87a2-dbac-4cf0-a069-f49413855482",
      target: "51d604b9-f5df-40e9-aaeb-48c0025ccc98"
    },
    {
      id: "35160964-719b-4519-9390-b74d869227df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6015d46-abf0-42b7-a87e-0d68d7c85fb9",
      target: "ac9fbb09-e961-4d23-92f6-cf1cdaca8d55"
    },
    {
      id: "c9980c96-c42e-447c-854a-19a8094a3239",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6015d46-abf0-42b7-a87e-0d68d7c85fb9",
      target: "88ed6019-6a5e-4cce-9a63-1f4a15a6ea23"
    },
    {
      id: "ef1bcc08-87d5-4d98-b85d-3bca0d48b533",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51d604b9-f5df-40e9-aaeb-48c0025ccc98",
      target: "1f96de7a-a7a5-46cd-b42e-26be905753da"
    },
    {
      id: "efbdd10e-4ff7-43ba-a661-46151ed3fa38",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51d604b9-f5df-40e9-aaeb-48c0025ccc98",
      target: "231a1018-61f1-44f4-b872-bf390102cbda"
    },
    {
      id: "49178174-153a-4352-86a8-6e1ca7be5e9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac9fbb09-e961-4d23-92f6-cf1cdaca8d55",
      target: "9a133269-2707-4959-a1ba-fd01eb52aa65"
    },
    {
      id: "cc6379dd-2519-414f-8dd6-083c2125f674",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a133269-2707-4959-a1ba-fd01eb52aa65",
      target: "110e6ce1-858a-4287-ade9-76d223f05877"
    },
    {
      id: "b935f078-5d2d-41bc-ba4e-47545e82408d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "110e6ce1-858a-4287-ade9-76d223f05877",
      target: "8c5ec9b4-0ed6-4c34-83f2-4621a41da10c"
    },
    {
      id: "0df57730-86a3-4540-9e29-24483b551790",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c5ec9b4-0ed6-4c34-83f2-4621a41da10c",
      target: "37bb25b9-8e38-43b3-9af7-767e4ef099d0"
    },
    {
      id: "2e98d240-fe29-4903-a468-26e70d5f66c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c5ec9b4-0ed6-4c34-83f2-4621a41da10c",
      target: "ed8a657b-30c7-472b-b051-253d5386824f"
    },
    {
      id: "27e5513f-a14e-4778-be0b-39b33259fd2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed8a657b-30c7-472b-b051-253d5386824f",
      target: "40622e37-3df6-4e80-89d7-61c1c3cff41c"
    },
    {
      id: "e0d47339-8b38-460e-94e2-01f0f80a9c5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37bb25b9-8e38-43b3-9af7-767e4ef099d0",
      target: "310f92cf-32c3-427c-8b32-c5f28ab15089"
    },
    {
      id: "6dd2250a-700d-4cab-9c97-96d5abd90f96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37bb25b9-8e38-43b3-9af7-767e4ef099d0",
      target: "1f96de7a-a7a5-46cd-b42e-26be905753da"
    },
    {
      id: "9de2ec2e-2ee6-4f7d-bf70-3f8b66e574e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37bb25b9-8e38-43b3-9af7-767e4ef099d0",
      target: "231a1018-61f1-44f4-b872-bf390102cbda"
    },
    {
      id: "4b90fa6d-711f-47a5-ae81-4ec8f5bb7e7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "40622e37-3df6-4e80-89d7-61c1c3cff41c",
      target: "a8200659-a901-4147-b422-d34fb3df3a14"
    },
    {
      id: "d243ef72-c769-4319-9ac7-c6cdc242d5f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "231a1018-61f1-44f4-b872-bf390102cbda",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "12840050-15db-44e5-b48d-199f6d5f0a85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f96de7a-a7a5-46cd-b42e-26be905753da",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "0dafcf09-b00f-4cd1-8bd0-732cdda3552f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310f92cf-32c3-427c-8b32-c5f28ab15089",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "8e94e35f-5411-408c-973e-30ab8fc04c75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310f92cf-32c3-427c-8b32-c5f28ab15089",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "935ebfd8-ada1-4476-8a4f-e4f12ff06dbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8200659-a901-4147-b422-d34fb3df3a14",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "1eb71c5e-f117-43d0-8c2e-a82d9024c439",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82255e02-d597-4e98-aef0-4ad73e04d931",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "29c14c32-b849-483f-aa3c-129fbc23909d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82255e02-d597-4e98-aef0-4ad73e04d931",
      target: "91934193-29f3-4677-9b89-832aaad7d820"
    },
    {
      id: "afa5c3aa-4bfd-4f7d-8d6e-73431c273fd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82255e02-d597-4e98-aef0-4ad73e04d931",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "5608f39f-857a-474b-99a6-53996c26af11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82255e02-d597-4e98-aef0-4ad73e04d931",
      target: "04e876f5-e2e9-4116-af41-aff9550ebc46"
    },
    {
      id: "c9c9ab86-b19a-4f14-a6b6-02f651d4c824",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      target: "f0884f83-24fa-4e1c-9f99-28b3bfdb0f94"
    },
    {
      id: "905fa937-f3e7-472e-b267-b0b3474ca01c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      target: "68c2e9eb-72fc-4028-92be-108879b7b463"
    },
    {
      id: "3dcba08d-ec0f-4125-84a1-0224a599c792",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      target: "88ed6019-6a5e-4cce-9a63-1f4a15a6ea23"
    },
    {
      id: "a9bbd3b9-bbfb-41de-a608-3eed0a207e42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      target: "cd93d015-8ec0-499a-b624-af24e2c68cd1"
    },
    {
      id: "88687b3b-4649-4b0f-b454-fda6471c6cd4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a46bd97b-c929-4cf3-a1e1-a76127d81a3b",
      target: "dbb0c3fc-db8d-4417-9a83-7fd31a39070c"
    },
    {
      id: "9648739e-28ba-40c4-98d5-0ea8dab20a6b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68c2e9eb-72fc-4028-92be-108879b7b463",
      target: "6891621d-986f-45a6-b0b8-afbffc80b13c"
    },
    {
      id: "3eb7ab97-103d-444e-bb64-172fe2fcbdee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbb0c3fc-db8d-4417-9a83-7fd31a39070c",
      target: "6891621d-986f-45a6-b0b8-afbffc80b13c"
    },
    {
      id: "dafa0bd7-4b8c-475b-8e89-424b71f2504d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f0884f83-24fa-4e1c-9f99-28b3bfdb0f94",
      target: "829e341a-f8e1-4ff9-9e2d-281c503ea784"
    },
    {
      id: "cff8a1d6-df8b-4d9b-a08d-c8d9d185c894",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd93d015-8ec0-499a-b624-af24e2c68cd1",
      target: "6891621d-986f-45a6-b0b8-afbffc80b13c"
    },
    {
      id: "2a5111ce-fb83-40d7-a37d-c9110ce93731",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88ed6019-6a5e-4cce-9a63-1f4a15a6ea23",
      target: "c2925f12-f929-4bdc-866b-6f6965cb9037"
    },
    {
      id: "0d7331b0-ffb3-4390-b25e-093257c91bcc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88ed6019-6a5e-4cce-9a63-1f4a15a6ea23",
      target: "209053fa-c921-4edb-969f-6bbfbf4119c6"
    },
    {
      id: "dee3dd68-72c5-4cc8-8409-2408bfa69e34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2925f12-f929-4bdc-866b-6f6965cb9037",
      target: "829e341a-f8e1-4ff9-9e2d-281c503ea784"
    },
    {
      id: "a3c6116c-3d87-41b3-9871-791cb7267d85",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6891621d-986f-45a6-b0b8-afbffc80b13c",
      target: "32b33467-1611-40e9-bc96-46384d8c1eaa"
    },
    {
      id: "bea161c2-dc92-42b1-8c80-86b7faa264a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6891621d-986f-45a6-b0b8-afbffc80b13c",
      target: "ebb3c17e-bdaf-43ac-8996-e2d131b81404"
    },
    {
      id: "13128d73-3d00-44de-9421-92ac65ead32e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "829e341a-f8e1-4ff9-9e2d-281c503ea784",
      target: "6f16a3b0-5b7b-4356-ae2c-3aa6d94f835e"
    },
    {
      id: "7b4ec748-b270-4b15-9142-4e6d75e60deb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f16a3b0-5b7b-4356-ae2c-3aa6d94f835e",
      target: "0b7accdd-1d96-404e-a601-f06046601bd5"
    },
    {
      id: "6309c41c-ef23-465b-ab2d-f3d30623c279",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b7accdd-1d96-404e-a601-f06046601bd5",
      target: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b"
    },
    {
      id: "5396382a-3f5b-46ed-b832-9cf2d11ea05a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      target: "a730483e-8e8e-4296-8460-9970b3854ecf"
    },
    {
      id: "59e2e9b2-e8eb-45ad-95fa-f15469fae2ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      target: "ebb3c17e-bdaf-43ac-8996-e2d131b81404"
    },
    {
      id: "d1ca63f8-71b6-422d-99d9-3c7e70fd2b71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      target: "56a47bbc-86ba-4f6d-bdcb-ced25f42be1f"
    },
    {
      id: "e4b5f031-ae5b-4469-811f-031a5f6ae036",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      target: "32b33467-1611-40e9-bc96-46384d8c1eaa"
    },
    {
      id: "ad128fe2-30a4-4ee1-a098-ff8341ebad3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db763c5d-cc37-4d1a-b30f-7fc7dcfe968b",
      target: "4b2ccbf5-ac0d-4c64-a01b-42e199315640"
    },
    {
      id: "7dce61ab-4a7d-4aa4-b3da-dc0a12c23497",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a730483e-8e8e-4296-8460-9970b3854ecf",
      target: "d3d27037-5c6a-48a2-bc6f-4dc790721d91"
    },
    {
      id: "fbceaeda-825e-4970-8df7-a16b08b17b3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b2ccbf5-ac0d-4c64-a01b-42e199315640",
      target: "9d4397d9-9c8f-4e49-9c4f-9a45d31633a3"
    },
    {
      id: "b9569a3d-7bbf-4f3a-a698-a9e0924677b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4b2ccbf5-ac0d-4c64-a01b-42e199315640",
      target: "a730483e-8e8e-4296-8460-9970b3854ecf"
    },
    {
      id: "dfe65ab1-449e-45a1-8caf-b3fb806aebae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56a47bbc-86ba-4f6d-bdcb-ced25f42be1f",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "be3abae2-5676-4714-a184-a2eab03ab310",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56a47bbc-86ba-4f6d-bdcb-ced25f42be1f",
      target: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651"
    },
    {
      id: "520161ed-0b77-4181-83f7-0f87a2369fd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32b33467-1611-40e9-bc96-46384d8c1eaa",
      target: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651"
    },
    {
      id: "fcfdb6a0-30b5-4ad3-bed5-bd5f65af11b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebb3c17e-bdaf-43ac-8996-e2d131b81404",
      target: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651"
    },
    {
      id: "d9e63694-d9db-452b-99b4-b46e358fceea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3d27037-5c6a-48a2-bc6f-4dc790721d91",
      target: "cef9533d-10dc-42cf-97c8-faaec8f8ec18"
    },
    {
      id: "2a8aa493-3beb-4b63-bf65-0eee393bcb87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d4397d9-9c8f-4e49-9c4f-9a45d31633a3",
      target: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651"
    },
    {
      id: "299d65dc-f18e-4277-9ecd-c9c52eef762f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cef9533d-10dc-42cf-97c8-faaec8f8ec18",
      target: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651"
    },
    {
      id: "77faafaa-7b38-4258-83f7-d2365b7c4cac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651",
      target: "91934193-29f3-4677-9b89-832aaad7d820"
    },
    {
      id: "673eb893-ba5c-4a11-9ab8-9ac0d4654a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "2c20432a-b342-4b5e-a88c-20075e4311bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "208774ac-6a5a-4838-8914-4b80eb2a66b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4333f7a3-19e6-45e2-a0c4-6b1be1e84651",
      target: "dd597037-1f8d-46e0-b78b-c620a11d3f59"
    },
    {
      id: "ccb71ad1-416e-4df5-ae73-8d52ffc7e17f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      target: "f5178bab-9aee-43b4-9ec8-fded356154cf"
    },
    {
      id: "cfa6ea98-b391-4ea4-8d43-5e7f09001433",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      target: "6a20c832-3531-4522-8322-a05e770741b6"
    },
    {
      id: "45b77655-32b9-42ba-92b6-2b92eda61def",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      target: "4a722dfa-a7bb-4096-8c50-630793b2965a"
    },
    {
      id: "4530d7ce-d34b-4efb-9363-92c1f9ba911f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      target: "95945817-0690-41e2-8250-61def180102c"
    },
    {
      id: "ed21a028-1b23-413a-acf5-acba526198cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8f2bcfe-58d3-460d-8755-43e772a0d6e0",
      target: "209053fa-c921-4edb-969f-6bbfbf4119c6"
    },
    {
      id: "7056d015-dcc5-4f1a-80b7-f88365b82349",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95945817-0690-41e2-8250-61def180102c",
      target: "8300723c-7ec3-4ec1-a798-b6dade312f79"
    },
    {
      id: "0767f58d-21b4-49f3-b2f3-c79ab6fb12fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a20c832-3531-4522-8322-a05e770741b6",
      target: "8300723c-7ec3-4ec1-a798-b6dade312f79"
    },
    {
      id: "c68b96ca-d694-4ff2-be46-335b31729ae3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5178bab-9aee-43b4-9ec8-fded356154cf",
      target: "db8e4f83-e512-4808-ad1b-fe724b1af006"
    },
    {
      id: "3267a40c-101f-49c8-bfcb-c1b163214168",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a722dfa-a7bb-4096-8c50-630793b2965a",
      target: "8300723c-7ec3-4ec1-a798-b6dade312f79"
    },
    {
      id: "b8c54267-746d-4e88-9e76-fcc4f5336f61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "209053fa-c921-4edb-969f-6bbfbf4119c6",
      target: "8e969182-8f7b-4315-a953-15e292ae012b"
    },
    {
      id: "f1c9e83c-e27b-411b-9e93-770366cb3fee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e969182-8f7b-4315-a953-15e292ae012b",
      target: "db8e4f83-e512-4808-ad1b-fe724b1af006"
    },
    {
      id: "a3baaa1c-1e39-4a8f-a70b-b64aeed4ed1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8300723c-7ec3-4ec1-a798-b6dade312f79",
      target: "c656b628-342f-44cf-9db2-d204c99097f4"
    },
    {
      id: "4f56cbfc-1450-4b1a-9d64-fa52d5079bac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8300723c-7ec3-4ec1-a798-b6dade312f79",
      target: "9906626a-c957-4685-beaa-193160dab216"
    },
    {
      id: "343a967d-fa11-4e3c-bd15-d1ab27f7f423",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db8e4f83-e512-4808-ad1b-fe724b1af006",
      target: "f2e17054-7851-4e08-bb8e-5043e5281c7d"
    },
    {
      id: "6758767b-bfef-4465-9c62-f81746465279",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f2e17054-7851-4e08-bb8e-5043e5281c7d",
      target: "eb6b7324-2f65-43e9-81fb-e1ff7e6da51a"
    },
    {
      id: "fc23e6de-3a75-4ebc-883c-a56f71069ecd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb6b7324-2f65-43e9-81fb-e1ff7e6da51a",
      target: "18b435f2-a6b1-404c-9269-a7c0415411ba"
    },
    {
      id: "46273a96-d6af-4a54-a8da-f355ee7fb7a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      target: "9906626a-c957-4685-beaa-193160dab216"
    },
    {
      id: "91de4166-4022-4289-b2bf-9f28c08491ce",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      target: "32114684-d80e-47b0-b1ed-dc8ddfcee013"
    },
    {
      id: "578a9657-c0a9-4d97-a6e7-5256ebc10790",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      target: "c656b628-342f-44cf-9db2-d204c99097f4"
    },
    {
      id: "fc679232-41fb-4a64-ad80-b4696204ab95",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      target: "876f1f7f-6b1d-4eb9-83ab-0b91c84d32d8"
    },
    {
      id: "a653cb75-3524-466b-85ea-ea39ae81bb4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18b435f2-a6b1-404c-9269-a7c0415411ba",
      target: "4f4f527f-f123-4699-b4d2-dcb0fd0c1c6e"
    },
    {
      id: "4460acd8-8f6f-440a-9ca7-66a61c23a8b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f4f527f-f123-4699-b4d2-dcb0fd0c1c6e",
      target: "074dcc52-1170-4a4b-86f6-d821db2d584f"
    },
    {
      id: "42b010db-e030-41e4-9d7d-4c62ec7c13a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f4f527f-f123-4699-b4d2-dcb0fd0c1c6e",
      target: "c81276ea-7ac2-4289-aa3c-96c92f22ecb6"
    },
    {
      id: "c5b80633-1983-45dd-af87-d67e29d90b90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9906626a-c957-4685-beaa-193160dab216",
      target: "074dcc52-1170-4a4b-86f6-d821db2d584f"
    },
    {
      id: "09246540-a05d-4570-acab-4128885f39f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c656b628-342f-44cf-9db2-d204c99097f4",
      target: "074dcc52-1170-4a4b-86f6-d821db2d584f"
    },
    {
      id: "18842347-df77-46d7-9439-4524b51f1add",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32114684-d80e-47b0-b1ed-dc8ddfcee013",
      target: "84f1cb2d-4c9e-4d25-b395-c4d43195c72c"
    },
    {
      id: "49bac52d-4fd5-40b3-905e-2f65cbf5c32e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "876f1f7f-6b1d-4eb9-83ab-0b91c84d32d8",
      target: "32114684-d80e-47b0-b1ed-dc8ddfcee013"
    },
    {
      id: "2b4f7e6a-87bc-4781-b556-65c92dbe12cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "876f1f7f-6b1d-4eb9-83ab-0b91c84d32d8",
      target: "a6db81bd-7c57-4e77-9f6c-7bb86bc07980"
    },
    {
      id: "933be618-726e-4f02-9bb0-f0cc087f20e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84f1cb2d-4c9e-4d25-b395-c4d43195c72c",
      target: "8b73533e-a37d-4356-a710-42a89f5aa2bf"
    },
    {
      id: "80587fa5-0574-4e8a-a7ab-24e0d9dd78c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6db81bd-7c57-4e77-9f6c-7bb86bc07980",
      target: "074dcc52-1170-4a4b-86f6-d821db2d584f"
    },
    {
      id: "c5e3f4cd-26ac-4227-b794-2ed3d3f007aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b73533e-a37d-4356-a710-42a89f5aa2bf",
      target: "3125c09c-538a-4eef-9f3f-213a2ca6ba6c"
    },
    {
      id: "6daccae6-883d-4441-9205-386af73c3293",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b73533e-a37d-4356-a710-42a89f5aa2bf",
      target: "074dcc52-1170-4a4b-86f6-d821db2d584f"
    },
    {
      id: "6563dbdd-357a-48ab-af35-00e08e9a8e71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "074dcc52-1170-4a4b-86f6-d821db2d584f",
      target: "82255e02-d597-4e98-aef0-4ad73e04d931"
    },
    {
      id: "d001dc4e-3b71-4ebe-bbb1-96d854ed98f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "074dcc52-1170-4a4b-86f6-d821db2d584f",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "48841efc-36f4-4ebc-ae99-2fa217feecfd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "074dcc52-1170-4a4b-86f6-d821db2d584f",
      target: "91934193-29f3-4677-9b89-832aaad7d820"
    },
    {
      id: "0e5f67ce-917e-430c-b71b-e86559e642ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "074dcc52-1170-4a4b-86f6-d821db2d584f",
      target: "dd597037-1f8d-46e0-b78b-c620a11d3f59"
    },
    {
      id: "6a122d20-81a8-4be6-923a-af60acc95114",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "904ae244-f22d-4b22-8fe1-ee87d6f3fab8"
    },
    {
      id: "62a3b409-09df-4768-a1d2-29bc1f65ab71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "904ae244-f22d-4b22-8fe1-ee87d6f3fab8"
    },
    {
      id: "35f75474-53f4-4038-840b-4c1fea689826",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "5d98bb0f-1888-4338-9228-c4f17c29aba8"
    },
    {
      id: "655fa5d3-aa3d-4d7b-806c-c2c409630e45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8"
    },
    {
      id: "9b67ca73-4b0e-435b-8387-ea5450cb07a2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "2ad9aa9a-2894-4453-b919-9aff0f442d6f"
    },
    {
      id: "ba6cc6ba-a6cf-4c70-8ffa-e093a6bf0279",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "7607e97b-3881-43c4-8b6a-06f0087f28ff"
    },
    {
      id: "b4d8daee-1629-44be-a3e6-40a900bd26dc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2e72af4c-7d12-4ae6-ac85-8f96fc525515",
      target: "d833d61a-29e5-405d-853f-b132b1771ed3"
    },
    {
      id: "b03f44fd-bd46-4f1e-ab05-0278623ab1e1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5d98bb0f-1888-4338-9228-c4f17c29aba8",
      target: "9f97c6d2-6032-4618-adc4-3abff952695d"
    },
    {
      id: "b330ba31-e384-4525-bb2e-1192b7781dbb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "904ae244-f22d-4b22-8fe1-ee87d6f3fab8",
      target: "3eb7a46b-4380-444b-8d03-fdc6c8e59204"
    },
    {
      id: "b10b1ebf-a1dc-4095-b4aa-71ac4d5c035a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "904ae244-f22d-4b22-8fe1-ee87d6f3fab8",
      target: "c3921b42-f753-4731-8f7b-a092cb5b752f"
    },
    {
      id: "18a10d17-ce0e-414e-a441-da1f972ade9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ad9aa9a-2894-4453-b919-9aff0f442d6f",
      target: "c3921b42-f753-4731-8f7b-a092cb5b752f"
    },
    {
      id: "cdf389e2-002d-4e46-8022-3ec24112faa5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3921b42-f753-4731-8f7b-a092cb5b752f",
      target: "de24ae8e-0898-4f38-9280-beb84ca3df27"
    },
    {
      id: "f890d3f7-e3a1-4297-a5ae-f13d42b80518",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3eb7a46b-4380-444b-8d03-fdc6c8e59204",
      target: "9f97c6d2-6032-4618-adc4-3abff952695d"
    },
    {
      id: "5c8903e0-42be-4c40-97a8-60c1fd85e5e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de24ae8e-0898-4f38-9280-beb84ca3df27",
      target: "9f97c6d2-6032-4618-adc4-3abff952695d"
    },
    {
      id: "285df506-d0cf-4625-acda-c28e8cf95483",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de24ae8e-0898-4f38-9280-beb84ca3df27",
      target: "c400db76-d6aa-4187-b34c-89cd23e11458"
    },
    {
      id: "4ecd183c-304f-4333-beb3-154f3876975f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f97c6d2-6032-4618-adc4-3abff952695d",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "5d8292a6-61f9-46d8-b4db-4c409139d8e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f97c6d2-6032-4618-adc4-3abff952695d",
      target: "22141bd9-5118-4e5e-8e51-b8899985c4cd"
    },
    {
      id: "e7a4a514-8028-4d7c-9c4a-3e31ec682dd7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22141bd9-5118-4e5e-8e51-b8899985c4cd",
      target: "6fd82713-1b4a-4d61-8d34-8d8ed4dfd55d"
    },
    {
      id: "b10d2858-e0a7-47f6-b8bd-ddd2b8a0a303",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22141bd9-5118-4e5e-8e51-b8899985c4cd",
      target: "44ea152d-6915-4b4a-848a-9f905fb08eb8"
    },
    {
      id: "b1de2178-a8de-4a6b-87f5-53b228e3ea73",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "22141bd9-5118-4e5e-8e51-b8899985c4cd",
      target: "c400db76-d6aa-4187-b34c-89cd23e11458"
    },
    {
      id: "7b1ac96d-edeb-47a4-96d9-2701f3ce8713",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd82713-1b4a-4d61-8d34-8d8ed4dfd55d",
      target: "d3227ab1-a793-4b42-9587-e31ab9a6c991"
    },
    {
      id: "d11c19d3-09f0-4da6-8053-165d8d926595",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c400db76-d6aa-4187-b34c-89cd23e11458",
      target: "98a5d32d-2029-4533-a0a7-ca859f808f68"
    },
    {
      id: "26cd60a3-217a-4d23-83b1-cf3fb274c2bc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c400db76-d6aa-4187-b34c-89cd23e11458",
      target: "4ef1f5b4-ad92-432e-a00b-b5b855055c39"
    },
    {
      id: "3459f590-46ae-405b-8faf-81be51ed67d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c400db76-d6aa-4187-b34c-89cd23e11458",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "5925345f-a76d-4fa4-90aa-238baa04843a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4ef1f5b4-ad92-432e-a00b-b5b855055c39",
      target: "7f1ef01b-90b6-4b68-b020-7e6586ec3bf0"
    },
    {
      id: "cf173ff2-7cb3-4ddf-9ac0-24c7c61d79cb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7f1ef01b-90b6-4b68-b020-7e6586ec3bf0",
      target: "7a320eae-aa57-425a-ae22-f8f43b8286f5"
    },
    {
      id: "16bf5d03-27b5-4ccc-b0fb-d5078f5ab758",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7a320eae-aa57-425a-ae22-f8f43b8286f5",
      target: "a8070082-6987-4f1a-ad1e-e918ac33e006"
    },
    {
      id: "9f871a95-2810-433d-b863-8e5c1b78b8f6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7a320eae-aa57-425a-ae22-f8f43b8286f5",
      target: "9c478c7b-64ca-4d18-8d48-2710b79dbb3e"
    },
    {
      id: "959aa3a4-f760-4329-b2ad-ad5aecdc6ae7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c478c7b-64ca-4d18-8d48-2710b79dbb3e",
      target: "2a45531e-2d53-4926-9c51-38cb8f4abf65"
    },
    {
      id: "e5559198-7abd-41eb-8982-cf12f91812e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c478c7b-64ca-4d18-8d48-2710b79dbb3e",
      target: "471d1405-1daa-4156-863f-71099cb2bf78"
    },
    {
      id: "f953aa15-e8ae-4bd1-8312-945fb07f9992",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2a45531e-2d53-4926-9c51-38cb8f4abf65",
      target: "4106b35c-0df3-4c56-8c2e-68d3d654f751"
    },
    {
      id: "e871314e-d88c-4b3d-bcee-9d8f7d419636",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a45531e-2d53-4926-9c51-38cb8f4abf65",
      target: "14a93288-a9ec-4a1e-9927-b17a4c6587db"
    },
    {
      id: "f0ecb426-d13f-4283-8915-d45838303e29",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4106b35c-0df3-4c56-8c2e-68d3d654f751",
      target: "d3227ab1-a793-4b42-9587-e31ab9a6c991"
    },
    {
      id: "2b42295b-7f44-4027-8270-fa1a5cf93645",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4106b35c-0df3-4c56-8c2e-68d3d654f751",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "e98fd30b-8bfc-41ab-9d7e-1577d0f23e76",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d3227ab1-a793-4b42-9587-e31ab9a6c991",
      target: "d0037e20-5d27-46bf-922a-1c9b9e992101"
    },
    {
      id: "831da58f-1c40-4a6c-8238-9ad17515c819",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3227ab1-a793-4b42-9587-e31ab9a6c991",
      target: "1d174025-b93d-437c-a8b7-faa7f7c2712e"
    },
    {
      id: "c3a48deb-0a15-4dac-bc13-7e1d40913ed1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8070082-6987-4f1a-ad1e-e918ac33e006",
      target: "e8be9ff4-f33b-49de-9fda-cb65d7032498"
    },
    {
      id: "bad2e147-a9d5-4448-b5f5-99d0af99d435",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d0037e20-5d27-46bf-922a-1c9b9e992101",
      target: "b37d9ee6-fd80-48a5-af58-6df4e380a676"
    },
    {
      id: "489c5d65-9e64-4c1e-beb3-16d3c04b48a5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b37d9ee6-fd80-48a5-af58-6df4e380a676",
      target: "f46ca132-06e7-4cc2-89b2-466e7173b185"
    },
    {
      id: "466b8f04-d1fa-4687-aef6-e04920818013",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f46ca132-06e7-4cc2-89b2-466e7173b185",
      target: "5ecb607e-775d-43de-9e28-e84b3e84f988"
    },
    {
      id: "06a1d65f-eaaa-4528-909c-96f02d01a498",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f46ca132-06e7-4cc2-89b2-466e7173b185",
      target: "3c7e11fd-8e72-453d-9652-3239d4518993"
    },
    {
      id: "6f7de846-9f25-4b64-8ed1-7a914241c1e8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f46ca132-06e7-4cc2-89b2-466e7173b185",
      target: "f5487c10-f21d-41c2-aa9b-5f722204ff81"
    },
    {
      id: "f4f5c482-3acb-453d-b278-22696d9960b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c7e11fd-8e72-453d-9652-3239d4518993",
      target: "552d5874-7e69-4a6d-a8b1-dde31aa2fc51"
    },
    {
      id: "68b5add7-1162-4499-85fb-63bdf19c9d0e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3c7e11fd-8e72-453d-9652-3239d4518993",
      target: "ce08d940-d067-48cc-942b-0a6b0c1fc75b"
    },
    {
      id: "cd78ae34-79d7-498e-8dde-5447b816c5c3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ecb607e-775d-43de-9e28-e84b3e84f988",
      target: "3dd3466e-0ee7-4d59-81d0-2319033b54df"
    },
    {
      id: "85b0bc3e-8c62-42e6-9dd4-407a3dcd1fe0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ecb607e-775d-43de-9e28-e84b3e84f988",
      target: "a43b526a-fc14-4c28-ab85-db98d74d496c"
    },
    {
      id: "e0694ef1-beb5-4746-933a-30b9b3604ec3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f5487c10-f21d-41c2-aa9b-5f722204ff81",
      target: "dc10b468-dff7-43c9-9d8f-429a4d33d464"
    },
    {
      id: "ddebb68e-8a6e-407d-912a-67da439a7116",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f5487c10-f21d-41c2-aa9b-5f722204ff81",
      target: "ce08d940-d067-48cc-942b-0a6b0c1fc75b"
    },
    {
      id: "3d03210c-b27f-4234-b799-5c987af92f27",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a43b526a-fc14-4c28-ab85-db98d74d496c",
      target: "a4df9c68-0fd1-46c0-960c-4b00b6e2808a"
    },
    {
      id: "0d686ab3-fa8b-422b-bd53-144a617a3457",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ce08d940-d067-48cc-942b-0a6b0c1fc75b",
      target: "bfb5cc5c-7778-4d3c-abe9-79b59f95e755"
    },
    {
      id: "7beb1ce0-d28f-4046-869f-47549cc5ce09",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dc10b468-dff7-43c9-9d8f-429a4d33d464",
      target: "98101063-399f-45c8-bbc8-fb801425baeb"
    },
    {
      id: "eeb69741-71c1-45a9-b1f1-c9dc2ffd8780",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3dd3466e-0ee7-4d59-81d0-2319033b54df",
      target: "a4df9c68-0fd1-46c0-960c-4b00b6e2808a"
    },
    {
      id: "96a34b5d-058e-454f-8f0f-a89c10feb359",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a4df9c68-0fd1-46c0-960c-4b00b6e2808a",
      target: "1c607db6-60aa-4542-a2fd-2b76e1fe910c"
    },
    {
      id: "63ed0ad5-884f-4f7e-8bef-bbe38223f6a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a4df9c68-0fd1-46c0-960c-4b00b6e2808a",
      target: "bfb5cc5c-7778-4d3c-abe9-79b59f95e755"
    },
    {
      id: "597fb9e6-fd30-4ea1-aeb8-05a8b3b5a26c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bfb5cc5c-7778-4d3c-abe9-79b59f95e755",
      target: "98101063-399f-45c8-bbc8-fb801425baeb"
    },
    {
      id: "d2c64920-fafb-4b4e-9e53-bf8ca9eee698",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "98101063-399f-45c8-bbc8-fb801425baeb",
      target: "2b83d52c-6feb-4ca8-bc19-b50595aef73d"
    },
    {
      id: "056cb7a6-6ba5-4629-b93c-25e816148af8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "98101063-399f-45c8-bbc8-fb801425baeb",
      target: "38ebd75d-0cc7-4043-8a3e-58beeb90e070"
    },
    {
      id: "06956488-0890-4363-87a5-9c3c75302747",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "98101063-399f-45c8-bbc8-fb801425baeb",
      target: "fde5ae59-4b28-4cc4-af3f-b303cadb53a5"
    },
    {
      id: "91779af3-0278-4f0a-b8cc-bc1612c8d6f2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "98101063-399f-45c8-bbc8-fb801425baeb",
      target: "d3b505a3-d247-47de-833e-581cfb088f1d"
    },
    {
      id: "22fb4461-8b78-4f4a-bcc3-6c65ea04b2c8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c607db6-60aa-4542-a2fd-2b76e1fe910c",
      target: "10f43da3-9126-4ce3-982b-181f5f132b3e"
    },
    {
      id: "fa47902c-c8a1-4805-86e1-63ab5817b44e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "552d5874-7e69-4a6d-a8b1-dde31aa2fc51",
      target: "ce08d940-d067-48cc-942b-0a6b0c1fc75b"
    },
    {
      id: "8a5e507d-677e-4dc7-9f67-afcc8bf51f06",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fde5ae59-4b28-4cc4-af3f-b303cadb53a5",
      target: "10f43da3-9126-4ce3-982b-181f5f132b3e"
    },
    {
      id: "de9dfd9b-a52f-4c78-9a8c-18388c04f93b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2b83d52c-6feb-4ca8-bc19-b50595aef73d",
      target: "10f43da3-9126-4ce3-982b-181f5f132b3e"
    },
    {
      id: "7f5c0cc8-1d8c-4071-8f0b-95cae3ac8b0f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "38ebd75d-0cc7-4043-8a3e-58beeb90e070",
      target: "10f43da3-9126-4ce3-982b-181f5f132b3e"
    },
    {
      id: "88493124-7f2d-4f67-8290-5f5cbf00e3b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d3b505a3-d247-47de-833e-581cfb088f1d",
      target: "10f43da3-9126-4ce3-982b-181f5f132b3e"
    },
    {
      id: "c83f3f69-349b-4f8d-bb6c-af6365e65987",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "10f43da3-9126-4ce3-982b-181f5f132b3e",
      target: "bdc43c16-54bc-4ecd-86f0-1d5a58acf9e4"
    },
    {
      id: "9e71938c-3b13-4c2a-9cc9-da9e25976fb1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bdc43c16-54bc-4ecd-86f0-1d5a58acf9e4",
      target: "a2e1f58b-9733-4810-af90-0a253d494902"
    },
    {
      id: "c7e81350-b0ec-4d6d-b325-996983544081",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a2e1f58b-9733-4810-af90-0a253d494902",
      target: "e64353a9-6760-4f62-b561-80f07c1c457e"
    },
    {
      id: "f8e93904-76bb-468c-bfbc-eae3e95485c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2e1f58b-9733-4810-af90-0a253d494902",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "6269d6ab-bd3f-4863-8bb5-c4ffcb2b5098",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e64353a9-6760-4f62-b561-80f07c1c457e",
      target: "b3192a13-b4b1-42f8-8c2f-a05a330c5488"
    },
    {
      id: "f083e02c-1aa1-4de2-b50d-bf40a9dd0471",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b3192a13-b4b1-42f8-8c2f-a05a330c5488",
      target: "e8be9ff4-f33b-49de-9fda-cb65d7032498"
    },
    {
      id: "6d1770e0-dfb7-40eb-901d-4c4adc77abfa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8be9ff4-f33b-49de-9fda-cb65d7032498",
      target: "9d77e203-2558-4082-95d5-8a88999f2e4e"
    },
    {
      id: "901f70a3-c263-4e58-a7ab-4a03ebd2682d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e8be9ff4-f33b-49de-9fda-cb65d7032498",
      target: "b2835994-c51c-4a7f-aee1-aa18a70f9331"
    },
    {
      id: "47b28d02-b827-4508-81f9-93ba97baae4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2835994-c51c-4a7f-aee1-aa18a70f9331",
      target: "1a22ad96-5141-4656-b61b-78c924924007"
    },
    {
      id: "86bfa44c-db94-4666-8d2c-a768c00fca48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a22ad96-5141-4656-b61b-78c924924007",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "7e7b8fb4-9fc2-40ba-beef-2a10ff4a7b64",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a22ad96-5141-4656-b61b-78c924924007",
      target: "01c0d7ea-27bf-4f36-9ab7-149723ddc836"
    },
    {
      id: "ac843dc3-a63f-4ef7-b13d-19759498f2ad",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "6eb707fe-64b7-4766-bce1-e198dea069d3"
    },
    {
      id: "122edc8f-d222-45a4-9021-9ce5dd59153b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "8dee6ef6-7b88-4d32-aea4-46f6b20209bd"
    },
    {
      id: "33e31e94-a111-4590-be6f-06d7224c72a4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "d73e1f73-7c1a-47b6-aa65-8c0d0751f983"
    },
    {
      id: "4794601d-431a-4375-9c60-cb50f501a2e5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "8dee6ef6-7b88-4d32-aea4-46f6b20209bd"
    },
    {
      id: "0f2f3fd5-2e65-4d40-820a-777c21161522",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "d73e1f73-7c1a-47b6-aa65-8c0d0751f983"
    },
    {
      id: "e643d9d3-687a-4bf3-bd9e-78870c764045",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d833d61a-29e5-405d-853f-b132b1771ed3",
      target: "6eb707fe-64b7-4766-bce1-e198dea069d3"
    },
    {
      id: "43e632dd-5932-4ef6-90e3-80db1a600da4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d73e1f73-7c1a-47b6-aa65-8c0d0751f983",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "17d8b52f-04bf-4269-9ec1-4694bd9ccf13",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d73e1f73-7c1a-47b6-aa65-8c0d0751f983",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "fec11b3e-6c70-479c-97c3-b8992307ebcf",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "432f8af0-1e02-4aca-a6ac-03ecb4f29211",
      target: "f4875174-c0e3-4caa-a104-28a17d1580aa"
    },
    {
      id: "4377b93d-5767-4133-9e78-c25b1b8c6c0d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "432f8af0-1e02-4aca-a6ac-03ecb4f29211",
      target: "1e2b9f11-da25-404b-bddc-3da71ecd9912"
    },
    {
      id: "022502f8-0473-4d20-89e5-3da8d0b922cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "432f8af0-1e02-4aca-a6ac-03ecb4f29211",
      target: "2bba753e-4024-4a09-8b76-7988bfa3f392"
    },
    {
      id: "e5b8e23c-9842-42cb-9365-e88a140d6d35",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "432f8af0-1e02-4aca-a6ac-03ecb4f29211",
      target: "f69fc444-58e9-4c56-a680-e7aab3bc3b1f"
    },
    {
      id: "84ded026-1f6c-4a88-9e47-8002aad70f6e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8dee6ef6-7b88-4d32-aea4-46f6b20209bd",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "02f665e4-55af-4bca-a245-25f1d16ece9a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8dee6ef6-7b88-4d32-aea4-46f6b20209bd",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "ef7e116f-90c6-4040-951c-6ab09fc7ba50",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6eb707fe-64b7-4766-bce1-e198dea069d3",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "e07fb918-4068-4eef-9386-ac383643ec74",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6eb707fe-64b7-4766-bce1-e198dea069d3",
      target: "432f8af0-1e02-4aca-a6ac-03ecb4f29211"
    },
    {
      id: "e3193f10-c467-4b97-858f-4604719dabf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f69fc444-58e9-4c56-a680-e7aab3bc3b1f",
      target: "2bba753e-4024-4a09-8b76-7988bfa3f392"
    },
    {
      id: "84d6d3c5-9bf4-486b-90be-9cf7a4b613d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4875174-c0e3-4caa-a104-28a17d1580aa",
      target: "2bba753e-4024-4a09-8b76-7988bfa3f392"
    },
    {
      id: "7ef9a3f5-f96c-418d-8b5c-21ecd1f52302",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e2b9f11-da25-404b-bddc-3da71ecd9912",
      target: "2bba753e-4024-4a09-8b76-7988bfa3f392"
    },
    {
      id: "a66df737-0ea9-424f-98a1-306c4967537a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bba753e-4024-4a09-8b76-7988bfa3f392",
      target: "298681a4-7398-4abc-bc37-7786f86bcde2"
    },
    {
      id: "bf8548be-3684-4018-8e08-fd66766bd483",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "298681a4-7398-4abc-bc37-7786f86bcde2",
      target: "d0287dc1-c65c-4022-ae75-c41f07d80eee"
    },
    {
      id: "3414227e-d8f5-4c37-891d-fbed70295239",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0287dc1-c65c-4022-ae75-c41f07d80eee",
      target: "11d7d8f3-192b-48e0-a965-b2bc2099ba7e"
    },
    {
      id: "da25db2a-cdaa-4396-a020-4161a6fcba2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11d7d8f3-192b-48e0-a965-b2bc2099ba7e",
      target: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce"
    },
    {
      id: "670ebf6a-497a-4d72-bba7-b2384f570993",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6e03fc84-0b85-4655-a3c9-a2ad5197d0a6",
      target: "e21c36c1-917f-435e-bf13-1f54fde6a4cc"
    },
    {
      id: "10f6d023-3afc-4aea-bbb7-9c2a97d3b34c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      target: "ba74f83b-512b-4cbc-b83c-3f67902a5573"
    },
    {
      id: "91bf97ee-faea-4410-8be6-222e84ef1b51",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      target: "6e03fc84-0b85-4655-a3c9-a2ad5197d0a6"
    },
    {
      id: "3b2e9a78-94b1-4118-b791-f768d0b73acc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      target: "e21c36c1-917f-435e-bf13-1f54fde6a4cc"
    },
    {
      id: "1e77bd05-591e-496d-b16a-08b3bb76e22d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "fe407128-0d14-436f-ac68-2455e92fb5e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdaa026b-4b1d-4284-bdb7-d44672c5f0ce",
      target: "42ee2f33-8ce4-4200-8912-c84ca5afb80a"
    },
    {
      id: "5fb28e33-e29f-48f0-90d6-1e82b87356b0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ba74f83b-512b-4cbc-b83c-3f67902a5573",
      target: "e21c36c1-917f-435e-bf13-1f54fde6a4cc"
    },
    {
      id: "1c6ed57a-f1a0-459d-acd2-8a2591bcda30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba74f83b-512b-4cbc-b83c-3f67902a5573",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "816c9953-1d49-46d2-8316-75c55773329c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e21c36c1-917f-435e-bf13-1f54fde6a4cc",
      target: "73e64bac-6343-4a65-a1e1-ca0a14623eab"
    },
    {
      id: "99e14a8a-b3b0-4b82-b87f-300a9ce6af27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e21c36c1-917f-435e-bf13-1f54fde6a4cc",
      target: "b76548b6-fbb8-4060-93d6-96869bb2790b"
    },
    {
      id: "e498e0bb-c906-4c00-8b75-05735c1bd47e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      target: "19f12c43-2633-4673-99ab-4081cac795ba"
    },
    {
      id: "12f94a78-f0a2-4235-8212-36398b212352",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      target: "f4b92e54-d674-407e-a509-d513b9d9c313"
    },
    {
      id: "d69c43a2-df52-45c5-8ecd-fdb3f74c2824",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      target: "44660d2f-4a5f-4b5a-94bb-e18a8ccd3d78"
    },
    {
      id: "f17e566b-8ad9-49f2-a0d0-d8b7a5c35927",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      target: "63a3c528-3960-46b2-82c2-76c8cc24f39f"
    },
    {
      id: "d4ccb9fa-5cf7-4d8e-881d-206df79a7419",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73e64bac-6343-4a65-a1e1-ca0a14623eab",
      target: "f66200c5-a477-4687-85d7-7b0b6c427cf3"
    },
    {
      id: "5f8fa122-55dd-4b91-9754-ac9ca03bbae4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19f12c43-2633-4673-99ab-4081cac795ba",
      target: "e8be9ff4-f33b-49de-9fda-cb65d7032498"
    },
    {
      id: "6f81de18-39e8-41d3-8bec-7c92c0673057",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19f12c43-2633-4673-99ab-4081cac795ba",
      target: "677df6e9-5929-42e4-b67e-3f5eae9ee718"
    },
    {
      id: "9bd9b642-5ff2-41b5-995b-b5179d38f3cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f66200c5-a477-4687-85d7-7b0b6c427cf3",
      target: "f949ff60-a25b-4a06-8058-76d06e9d36f4"
    },
    {
      id: "93b50607-ef7c-4508-8e82-7ecedfa84d0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63a3c528-3960-46b2-82c2-76c8cc24f39f",
      target: "f949ff60-a25b-4a06-8058-76d06e9d36f4"
    },
    {
      id: "c9426866-51eb-4059-9329-cbe522792d56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63a3c528-3960-46b2-82c2-76c8cc24f39f",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "f607a9e5-ee18-4dd1-bff1-2a391c9008a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f949ff60-a25b-4a06-8058-76d06e9d36f4",
      target: "6a94fee7-ba3b-43f6-aa22-37ca9bf2ad58"
    },
    {
      id: "42b36079-c254-4749-8b99-3eaeeb23ba41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a94fee7-ba3b-43f6-aa22-37ca9bf2ad58",
      target: "68feb5e5-43c6-4bf7-b20f-305fa178afd8"
    },
    {
      id: "b5db7513-4151-43e5-9e05-4ccb6e95f9d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68feb5e5-43c6-4bf7-b20f-305fa178afd8",
      target: "e8be9ff4-f33b-49de-9fda-cb65d7032498"
    },
    {
      id: "c313c3c6-1888-4462-8c48-5b7bbafd6c72",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "98a5d32d-2029-4533-a0a7-ca859f808f68",
      target: "732a8b76-e31a-4493-a6e9-31c7d1d0008a"
    },
    {
      id: "b3e58905-35ff-4b15-9074-eb944f349797",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a5d32d-2029-4533-a0a7-ca859f808f68",
      target: "5debe745-9862-414a-b073-b42917687ff4"
    },
    {
      id: "795b8247-1ac0-4275-99d4-710cfdd9ef46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a5d32d-2029-4533-a0a7-ca859f808f68",
      target: "55ae2949-c2d8-484c-8216-2698a056d696"
    },
    {
      id: "714729db-9635-4e85-b478-59cfa304b116",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a5d32d-2029-4533-a0a7-ca859f808f68",
      target: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1"
    },
    {
      id: "5ddaa96a-3e1e-4ce4-92a0-7f074a649375",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "732a8b76-e31a-4493-a6e9-31c7d1d0008a",
      target: "5debe745-9862-414a-b073-b42917687ff4"
    },
    {
      id: "2ae2bb20-8003-431a-aed7-c1fbdf226175",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "732a8b76-e31a-4493-a6e9-31c7d1d0008a",
      target: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec"
    },
    {
      id: "49c64f18-7e6a-4ca5-a433-b37ee9c24257",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "732a8b76-e31a-4493-a6e9-31c7d1d0008a",
      target: "e8bb7480-605d-40b8-bf0b-d4e05dd219f6"
    },
    {
      id: "1c3e1b83-9d95-4585-a5dd-2c21e6679bf2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5debe745-9862-414a-b073-b42917687ff4",
      target: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec"
    },
    {
      id: "5e7276ce-8b94-4b5d-86f3-4f4cf240a67b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5debe745-9862-414a-b073-b42917687ff4",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "2dba7ea4-ccaa-4171-8b35-82dcdb32b853",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5debe745-9862-414a-b073-b42917687ff4",
      target: "e6271eaf-ae4f-4e57-95e8-73e39245e53c"
    },
    {
      id: "a2b127ac-a13c-4d5e-af6f-aac666376ede",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "780ca8cc-75c9-4bf2-892c-d89213971737",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "875cc849-3728-4b4e-a5d4-5fd01c9aa7ec",
      target: "2f177ddd-db3f-4deb-bfaa-13eba28aca44"
    },
    {
      id: "f75265ee-4317-40c2-8bf8-8d29358b4bda",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "55ae2949-c2d8-484c-8216-2698a056d696",
      target: "e8bb7480-605d-40b8-bf0b-d4e05dd219f6"
    },
    {
      id: "0a4e4790-3427-4971-8870-e5822a308cd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55ae2949-c2d8-484c-8216-2698a056d696",
      target: "e6271eaf-ae4f-4e57-95e8-73e39245e53c"
    },
    {
      id: "9817a748-023d-4639-8cf7-81f172236dc2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e8bb7480-605d-40b8-bf0b-d4e05dd219f6",
      target: "e6271eaf-ae4f-4e57-95e8-73e39245e53c"
    },
    {
      id: "47279ed4-598d-4eec-9a5a-2f248e26ebc0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8bb7480-605d-40b8-bf0b-d4e05dd219f6",
      target: "2f177ddd-db3f-4deb-bfaa-13eba28aca44"
    },
    {
      id: "604f68bb-f151-4530-bdd0-16e1c828a4fb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e6271eaf-ae4f-4e57-95e8-73e39245e53c",
      target: "2f177ddd-db3f-4deb-bfaa-13eba28aca44"
    },
    {
      id: "21e19b5b-6673-4a8e-8ced-63be604b5c38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e6271eaf-ae4f-4e57-95e8-73e39245e53c",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "cf52d0aa-8329-4904-b9e7-6e3af48e9801",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f177ddd-db3f-4deb-bfaa-13eba28aca44",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "e3328db5-8657-43d2-b336-3ed3571a3526",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f177ddd-db3f-4deb-bfaa-13eba28aca44",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "c33e39be-719f-4a06-9bd3-b12f7e14cdbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "1265476e-f63d-4d25-a4c1-20b3aa6bb9d1"
    },
    {
      id: "fbe91a6c-79b5-49b2-af5f-b048b6678ab7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b"
    },
    {
      id: "acada02b-de4f-45bd-ac3e-042c3dae8eb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "da7727f3-7935-47df-8cb9-6e5ff72654ac"
    },
    {
      id: "8c50db83-82da-4244-a837-cb183c26bf28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "77d4c7c9-7763-459c-96c7-e26d063ec128"
    },
    {
      id: "37e9421a-98a3-4b6c-8c28-869c37f6c5c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "024d71ac-19c8-4bb6-b95e-9275f25b04ff"
    },
    {
      id: "6deca596-2708-4547-a735-e0beadc5fe8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "290eb132-b609-43c0-8c0f-432a084001e6",
      target: "3d191c74-f499-449a-a053-531f073348a5"
    },
    {
      id: "5b104fa5-94eb-4857-aefb-6bddd1c9ab5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d191c74-f499-449a-a053-531f073348a5",
      target: "dbfcb2a2-ca21-4281-882c-d69d430ba0d2"
    },
    {
      id: "6712fa9b-19bf-4f55-947a-2455eba0ad63",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "024d71ac-19c8-4bb6-b95e-9275f25b04ff",
      target: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70"
    },
    {
      id: "bc90b22f-2ea9-4f35-950a-f262caded33e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77d4c7c9-7763-459c-96c7-e26d063ec128",
      target: "59d90de0-1f2e-4a8a-9f0c-37c611b3db76"
    },
    {
      id: "b91a2827-224c-4cd0-b1d5-e705f3678266",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1265476e-f63d-4d25-a4c1-20b3aa6bb9d1",
      target: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70"
    },
    {
      id: "2696a310-ee9b-4a88-8d18-b3a567df6edc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da7727f3-7935-47df-8cb9-6e5ff72654ac",
      target: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70"
    },
    {
      id: "e2911b99-b27e-4d55-b67f-105fc8e071a7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70",
      target: "9710916a-6fea-462d-af55-06288c189947"
    },
    {
      id: "22a33856-0f81-49bd-8428-4cb0a2109a07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f7c862b-f0f6-4fdf-a4d4-1b952f975b70",
      target: "78328bd2-0c8c-4c95-a304-3ad7bc0381ca"
    },
    {
      id: "9b7c7931-332b-41ad-baf6-6b2ae0f9e000",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59d90de0-1f2e-4a8a-9f0c-37c611b3db76",
      target: "dbfcb2a2-ca21-4281-882c-d69d430ba0d2"
    },
    {
      id: "1e42b209-8924-4015-94ab-8c201e476c09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbfcb2a2-ca21-4281-882c-d69d430ba0d2",
      target: "941bb44b-8780-4ff6-a4bd-e63e335b7c70"
    },
    {
      id: "61f1a6c0-1030-44f4-9d71-b0afdc96025b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "941bb44b-8780-4ff6-a4bd-e63e335b7c70",
      target: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e"
    },
    {
      id: "844e7a88-3e0b-479a-b8dc-59cb9ce99e9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e",
      target: "8330e26c-e0c4-4216-848c-9a29ee130104"
    },
    {
      id: "57ce89c9-cf30-425c-86ce-e326267bdc09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e",
      target: "235aec86-ec4c-4cb0-8070-8efa49ad8434"
    },
    {
      id: "eedbf1e4-8c84-4bde-ba94-31481c53f92a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e",
      target: "e4ea102d-324f-4849-a9b5-b14e60f58f2d"
    },
    {
      id: "fe485107-a306-4948-8f1f-2ff529f12327",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb1d7a40-47eb-4fc6-a471-d8f1e952332e",
      target: "155b4250-7e35-4b94-a2be-2339d8ac64ef"
    },
    {
      id: "f0955e04-caa5-4a01-82f9-fca41056a317",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "155b4250-7e35-4b94-a2be-2339d8ac64ef",
      target: "47b84e71-6d8b-4a4f-9c83-b37a773abb1e"
    },
    {
      id: "aa1ba242-f5f7-4779-8e99-347b8d0fc873",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8330e26c-e0c4-4216-848c-9a29ee130104",
      target: "9710916a-6fea-462d-af55-06288c189947"
    },
    {
      id: "b7106830-bece-4450-8e03-9e092416b597",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8330e26c-e0c4-4216-848c-9a29ee130104",
      target: "74be69cd-47de-49a4-b624-a3bf56d9cdcf"
    },
    {
      id: "ddc0d641-07d0-40db-ab95-a46d7a2c7b11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8330e26c-e0c4-4216-848c-9a29ee130104",
      target: "78328bd2-0c8c-4c95-a304-3ad7bc0381ca"
    },
    {
      id: "cfc2a4c5-7ffd-4028-b870-748e8f408ab7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9710916a-6fea-462d-af55-06288c189947",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "6d7ab917-3eaa-4d9a-a47a-0795128fed20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78328bd2-0c8c-4c95-a304-3ad7bc0381ca",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "cecef840-2ec6-4da3-bd14-a86e277bf5d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74be69cd-47de-49a4-b624-a3bf56d9cdcf",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "88d779bb-6f5f-4da9-bcf0-48d2dfd7dc1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74be69cd-47de-49a4-b624-a3bf56d9cdcf",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "1a12e786-857d-4da5-a9b2-e147bd28ee5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47b84e71-6d8b-4a4f-9c83-b37a773abb1e",
      target: "e77c32f4-8784-45a7-b68b-1000bbf8bf68"
    },
    {
      id: "94afc820-fd98-4efa-9fa7-94275fdacaa7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e77c32f4-8784-45a7-b68b-1000bbf8bf68",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "e498bb39-c5a7-4d27-8125-0a343401f95a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e996890-0198-459c-8ada-f462147097da",
      target: "9d77e203-2558-4082-95d5-8a88999f2e4e"
    },
    {
      id: "dd3de7eb-40a0-4a6f-aa02-ee5f5b66bb70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e996890-0198-459c-8ada-f462147097da",
      target: "01c0d7ea-27bf-4f36-9ab7-149723ddc836"
    },
    {
      id: "dfbbcb71-12dc-4f62-8892-e396e80cb9c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e996890-0198-459c-8ada-f462147097da",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "42dc2d8e-9476-4d29-b8e7-648968bdb96e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e4ea102d-324f-4849-a9b5-b14e60f58f2d",
      target: "54e84b4f-6e70-489b-bf06-4ee2ba15d7e0"
    },
    {
      id: "1f714828-a69e-4aef-b1de-0a5fd021f383",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54e84b4f-6e70-489b-bf06-4ee2ba15d7e0",
      target: "c16f82c3-46d7-45ca-81f1-b909e7d6921f"
    },
    {
      id: "4a1679e8-3320-4a3b-b04d-76282039ee06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c16f82c3-46d7-45ca-81f1-b909e7d6921f",
      target: "3b958be2-8fae-4c83-a7f3-621ec4b5cfcf"
    },
    {
      id: "fa0c5f02-0730-488c-b5fe-e8f94882cfe6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b958be2-8fae-4c83-a7f3-621ec4b5cfcf",
      target: "7c37b6b6-2b71-4bdf-882e-701d0bb49b4c"
    },
    {
      id: "4fb86902-d7a6-439a-bcda-3f7b48949eb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b958be2-8fae-4c83-a7f3-621ec4b5cfcf",
      target: "d6c0114c-ac51-4de5-974b-e8eccc5b4cda"
    },
    {
      id: "7a4ec961-bfd9-48c3-858e-ec3bff4ea3a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6c0114c-ac51-4de5-974b-e8eccc5b4cda",
      target: "b2f457b5-1e95-47e6-9ff6-9410bed9b93c"
    },
    {
      id: "10307013-03a1-4be6-bf67-b57a2095ebf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c37b6b6-2b71-4bdf-882e-701d0bb49b4c",
      target: "56854466-7380-4fe7-aef0-c48550ba66ca"
    },
    {
      id: "8e14a410-edf8-4ce2-a697-5c4ce6133ca6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2f457b5-1e95-47e6-9ff6-9410bed9b93c",
      target: "56854466-7380-4fe7-aef0-c48550ba66ca"
    },
    {
      id: "b0c83175-ad48-4702-88d7-5fc51d53ef61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56854466-7380-4fe7-aef0-c48550ba66ca",
      target: "1b8f56af-e805-4fda-9407-164053e74315"
    },
    {
      id: "58933695-7e57-46ab-b158-958833312e66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b8f56af-e805-4fda-9407-164053e74315",
      target: "0745b271-8802-45ec-8d9a-b0b6b88f83da"
    },
    {
      id: "ad1589e4-ee58-447e-88e6-ecd598de91c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0745b271-8802-45ec-8d9a-b0b6b88f83da",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "c9c5bdd8-162a-46cf-9e30-276b149e8685",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "235aec86-ec4c-4cb0-8070-8efa49ad8434",
      target: "7004f583-46a7-40f1-8bfa-da5a4ea0707f"
    },
    {
      id: "2f9d9dc1-ffa0-4465-b749-e925e58c0df6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7004f583-46a7-40f1-8bfa-da5a4ea0707f",
      target: "bce9e531-f801-41ab-a447-17ec45e8b2b8"
    },
    {
      id: "dbb9f71f-d489-4df8-a13a-996fea04cc4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bce9e531-f801-41ab-a447-17ec45e8b2b8",
      target: "6fa69d15-5639-48e3-ad8b-97f09a014ca8"
    },
    {
      id: "08ed2b07-834b-4c43-8994-84cfa4690fbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fa69d15-5639-48e3-ad8b-97f09a014ca8",
      target: "8bd7f19e-3ccc-4b04-8087-e7a51f844c69"
    },
    {
      id: "edb4d038-042d-4791-9d7a-e17484096994",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fa69d15-5639-48e3-ad8b-97f09a014ca8",
      target: "60bcbab5-c809-4195-9169-6b22033f2022"
    },
    {
      id: "006c799c-025f-461c-8b7d-2117e6109c56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bd7f19e-3ccc-4b04-8087-e7a51f844c69",
      target: "698eddcb-208e-4585-b50a-02298ce39c26"
    },
    {
      id: "136cf441-6bd2-4fea-9e5d-3755e1bac513",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60bcbab5-c809-4195-9169-6b22033f2022",
      target: "23870b29-3148-4b71-ab9b-0b185a5f87d2"
    },
    {
      id: "a21b31fb-1c1e-4e4b-8bc3-9aa143462a2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "698eddcb-208e-4585-b50a-02298ce39c26",
      target: "23870b29-3148-4b71-ab9b-0b185a5f87d2"
    },
    {
      id: "da984fd4-94d7-4172-b616-f357b7617410",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23870b29-3148-4b71-ab9b-0b185a5f87d2",
      target: "98a17640-5a44-4c01-8f45-7e5c07194b8d"
    },
    {
      id: "cc511266-6976-44e9-b10a-aba739d6cffa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a17640-5a44-4c01-8f45-7e5c07194b8d",
      target: "9558fc2d-f9ce-4a1e-8305-7e1b12077a4f"
    },
    {
      id: "34718d62-d55d-4f99-87b4-2f726f22ce88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9558fc2d-f9ce-4a1e-8305-7e1b12077a4f",
      target: "8e996890-0198-459c-8ada-f462147097da"
    },
    {
      id: "522c1658-ff36-4806-afa8-067ee6f9d800",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6aac9d75-7734-46a2-ad90-bae35ba34d51",
      target: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b"
    },
    {
      id: "e432b37e-f003-4af6-a03b-147e1b530805",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "f7b8e85d-3861-4bab-afd0-eaa17c4aba0b"
    },
    {
      id: "dc62a5e9-d5fe-4bf7-8cdf-56bbf347c249",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "d19cc398-dc11-4acb-a221-8436a158ff3f"
    },
    {
      id: "fcff6cbe-2316-4ee5-9f31-6caf72279686",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c"
    },
    {
      id: "aab0592f-1480-41d4-aa2d-2b7924100099",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "4ebe65dc-eb87-4b8c-8c39-477b23101e36"
    },
    {
      id: "0b10bb8c-6af5-4a76-bb2c-6d8971b0da62",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c"
    },
    {
      id: "c92a3649-7896-413d-90ae-53da55580cf3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "6940e702-d644-4f22-b07b-cecadc0a3af9"
    },
    {
      id: "ae31e06d-0af0-47fb-94da-5c89b437a22a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5181f6b7-37e3-4bf3-9a4b-969210fcc73b",
      target: "a247b351-bc53-43c6-9cce-4f9025d4fe1b"
    },
    {
      id: "90321f92-7ec8-4a80-b2eb-08aa14b525f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7b8e85d-3861-4bab-afd0-eaa17c4aba0b",
      target: "da68efed-c11c-46e6-a991-5f7744fdd0da"
    },
    {
      id: "0bca41d6-40cb-4c3b-a7c2-abe7e30456c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ebe65dc-eb87-4b8c-8c39-477b23101e36",
      target: "ea9a21bf-e817-43c1-bcc8-763009f2c839"
    },
    {
      id: "a54c2c22-b6fb-4fb4-8960-6fd596ea2b46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6940e702-d644-4f22-b07b-cecadc0a3af9",
      target: "1bc461ac-67a2-4da1-9214-c81596c667af"
    },
    {
      id: "9c9fd9ca-0d78-4bdb-91fd-853707d7d850",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6940e702-d644-4f22-b07b-cecadc0a3af9",
      target: "df5b0f03-ca4f-43a8-af94-1c909c18d19e"
    },
    {
      id: "8ecd543e-c052-470a-bb3e-b53f309090f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a247b351-bc53-43c6-9cce-4f9025d4fe1b",
      target: "ea9a21bf-e817-43c1-bcc8-763009f2c839"
    },
    {
      id: "13546ec5-45c1-41fe-80c5-fec85faacda9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d19cc398-dc11-4acb-a221-8436a158ff3f",
      target: "ea9a21bf-e817-43c1-bcc8-763009f2c839"
    },
    {
      id: "ca3afd59-7400-4685-be7d-eee5838ebb56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea9a21bf-e817-43c1-bcc8-763009f2c839",
      target: "c0354f8e-a2ee-4268-a208-e0af86428c86"
    },
    {
      id: "4879bba0-2d83-45f6-ba4f-918a60bd12f7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ea9a21bf-e817-43c1-bcc8-763009f2c839",
      target: "cf4003fe-f163-41cf-9bd3-59d7784829fd"
    },
    {
      id: "0b56a74c-8812-499a-be4a-14fdbc5398db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1bc461ac-67a2-4da1-9214-c81596c667af",
      target: "da68efed-c11c-46e6-a991-5f7744fdd0da"
    },
    {
      id: "2c782022-0ad9-4e6b-a595-17e6a5b2d9a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da68efed-c11c-46e6-a991-5f7744fdd0da",
      target: "26ced265-6840-453a-9265-66ea6dffe757"
    },
    {
      id: "e2f3baff-38ed-436b-9ddc-9125f4f1dc91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26ced265-6840-453a-9265-66ea6dffe757",
      target: "92890cee-b82f-47a3-8277-5ccaddb10542"
    },
    {
      id: "6244e4cd-60d7-4b92-ab8f-ea00fb34d577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92890cee-b82f-47a3-8277-5ccaddb10542",
      target: "c75eae43-a879-4112-95b5-3aa7ce69c216"
    },
    {
      id: "20df26ae-d94d-41c0-af6f-30cc88f4409f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92890cee-b82f-47a3-8277-5ccaddb10542",
      target: "a7f53700-1c36-42cf-a0e0-117ba3d6d805"
    },
    {
      id: "490d7d4f-b479-41ee-8e70-0146bd0d32a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7f53700-1c36-42cf-a0e0-117ba3d6d805",
      target: "cf077eae-d31d-4cba-a666-eb3849bbc805"
    },
    {
      id: "c0973190-5cb8-454d-bfa9-4953b19a3bcc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c75eae43-a879-4112-95b5-3aa7ce69c216",
      target: "c0354f8e-a2ee-4268-a208-e0af86428c86"
    },
    {
      id: "00ae4703-3742-43f8-acdd-866e73a6c8c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c75eae43-a879-4112-95b5-3aa7ce69c216",
      target: "cf4003fe-f163-41cf-9bd3-59d7784829fd"
    },
    {
      id: "42e1b990-6eb8-4d8f-adca-40b39e30daaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c75eae43-a879-4112-95b5-3aa7ce69c216",
      target: "d4ee83e1-7770-4986-af5c-46b6379689f5"
    },
    {
      id: "32f37f3c-225f-400b-9a6b-b83c475837f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf4003fe-f163-41cf-9bd3-59d7784829fd",
      target: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d"
    },
    {
      id: "3e02296c-b081-4356-b1fb-cd531ea7bc28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c0354f8e-a2ee-4268-a208-e0af86428c86",
      target: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d"
    },
    {
      id: "70c76c54-6b5c-4763-8cf1-569ec16bd351",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4ee83e1-7770-4986-af5c-46b6379689f5",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "e9691091-21ee-4aa2-abb8-082c8036a1cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d4ee83e1-7770-4986-af5c-46b6379689f5",
      target: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d"
    },
    {
      id: "2580445c-835e-4951-9566-475014705161",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf077eae-d31d-4cba-a666-eb3849bbc805",
      target: "8f131f06-23b7-4eb0-8d9c-61ba0a2a9397"
    },
    {
      id: "b0edbcbe-2a26-4063-a499-d4acef872437",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f131f06-23b7-4eb0-8d9c-61ba0a2a9397",
      target: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d"
    },
    {
      id: "4255d8ad-ef80-4fb7-b890-b00b5a8f301d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "b810317c-94f8-44a2-b2ef-03ce0b5b22bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d",
      target: "01c0d7ea-27bf-4f36-9ab7-149723ddc836"
    },
    {
      id: "9c6e472b-779c-452d-828a-a64daf0aae28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d",
      target: "e525785a-854d-441a-b4d0-cc20a0fd9dec"
    },
    {
      id: "9d51896c-39e1-436b-b98f-f765c2515873",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d",
      target: "9d77e203-2558-4082-95d5-8a88999f2e4e"
    },
    {
      id: "ef6ada94-86f7-4374-bb9b-ee25652c82a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      target: "d80db510-2ed7-4232-abb6-0f43a4f5e8b1"
    },
    {
      id: "5bd9b983-32d7-423e-9c6c-d8565db745ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      target: "8ee4c4ad-81a5-48ff-8281-1f243e2ea0fb"
    },
    {
      id: "f244f52a-4b7a-4644-b905-a8db98b00776",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      target: "67827417-dfd8-4da1-b3b6-04a5b75a8242"
    },
    {
      id: "11f3f08c-d82a-4be3-a55c-fe75539e1cdc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      target: "049ea951-1102-4aa0-941a-b0f8c6f69d1a"
    },
    {
      id: "0890ce5a-b787-425a-8e79-b2043045d179",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ded45ef8-8fc7-4ae1-aab4-1ce175fb8e4c",
      target: "df5b0f03-ca4f-43a8-af94-1c909c18d19e"
    },
    {
      id: "bd4656b3-ad0b-40f7-80ed-189195642cf9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67827417-dfd8-4da1-b3b6-04a5b75a8242",
      target: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb"
    },
    {
      id: "cda227ca-54dc-478e-b547-de458713e6d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d80db510-2ed7-4232-abb6-0f43a4f5e8b1",
      target: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb"
    },
    {
      id: "c3b49ce3-1ae2-4833-93a1-d86b091326ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ee4c4ad-81a5-48ff-8281-1f243e2ea0fb",
      target: "82b868f8-d095-4060-813a-8059a48e1dc6"
    },
    {
      id: "9065c97f-57d8-460a-bb62-3a9c9413d820",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "049ea951-1102-4aa0-941a-b0f8c6f69d1a",
      target: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb"
    },
    {
      id: "db0c7637-024b-4802-8795-8227567c993a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df5b0f03-ca4f-43a8-af94-1c909c18d19e",
      target: "595fb797-dd50-45a1-8c84-a268b1db9396"
    },
    {
      id: "0f522f92-38ed-4770-bf97-7d138b9ba784",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "595fb797-dd50-45a1-8c84-a268b1db9396",
      target: "82b868f8-d095-4060-813a-8059a48e1dc6"
    },
    {
      id: "7098b4b1-3667-42fe-be24-0f3f89d790c3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb",
      target: "69fc4d02-ae4f-4d62-be16-c6a479ebd269"
    },
    {
      id: "9a557976-7eeb-4c4c-9833-92845a2828d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "772bfc9b-34f1-4494-a48f-c3dfb284cbfb",
      target: "3ab78e21-d10c-4068-96fd-77bff928aa24"
    },
    {
      id: "44affae9-9274-4ef9-a320-da0410e3e5c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82b868f8-d095-4060-813a-8059a48e1dc6",
      target: "5472af19-77cd-4bcd-b2d9-7a1026442ee4"
    },
    {
      id: "4f088d79-9342-47a3-ab3e-cc2d67b5f595",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5472af19-77cd-4bcd-b2d9-7a1026442ee4",
      target: "c0ce5d1b-0fbc-4bef-a7ae-eb1586c5f9c2"
    },
    {
      id: "c0648c6c-d20d-40d5-82e5-2027817f7176",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c0ce5d1b-0fbc-4bef-a7ae-eb1586c5f9c2",
      target: "88e827a6-307b-4432-b687-23df5d182744"
    },
    {
      id: "a967f025-c21b-4a19-a2e9-ec0d1e1b293d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88e827a6-307b-4432-b687-23df5d182744",
      target: "b5ad5128-eebf-48f0-80cf-fab926f53225"
    },
    {
      id: "08a2a69f-8a42-4d3c-881a-b4d5c1a1e8ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88e827a6-307b-4432-b687-23df5d182744",
      target: "9591fb7e-3354-423a-8514-0b7d93053a0e"
    },
    {
      id: "e93f64b6-f4a7-4e0d-9e9f-2941152ccc1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88e827a6-307b-4432-b687-23df5d182744",
      target: "69fc4d02-ae4f-4d62-be16-c6a479ebd269"
    },
    {
      id: "4f10b8e5-02af-4d1d-8c1f-5349bea1fa2e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "88e827a6-307b-4432-b687-23df5d182744",
      target: "7e94a2e0-495e-49dc-a503-d9e4acd075da"
    },
    {
      id: "80b22e86-12bf-4ec9-ae1c-71bffc65ba81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88e827a6-307b-4432-b687-23df5d182744",
      target: "3ab78e21-d10c-4068-96fd-77bff928aa24"
    },
    {
      id: "bfd3eb82-dd53-4357-b2b9-c2d4eec6c4be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ab78e21-d10c-4068-96fd-77bff928aa24",
      target: "8e36182b-56a6-4925-a1a9-cd6d8fc09205"
    },
    {
      id: "7880fc0d-2aa4-43eb-9a39-7214d91b4eba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e94a2e0-495e-49dc-a503-d9e4acd075da",
      target: "3405b6d8-58ed-488c-9932-f54373a803ce"
    },
    {
      id: "00d5f24f-6ce7-4f8e-b054-446faf96bd25",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b5ad5128-eebf-48f0-80cf-fab926f53225",
      target: "7e94a2e0-495e-49dc-a503-d9e4acd075da"
    },
    {
      id: "2752835d-ee43-4681-b4a3-2b10a630dba6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5ad5128-eebf-48f0-80cf-fab926f53225",
      target: "d97a88a1-8975-43c9-8f6a-404cc691b45a"
    },
    {
      id: "90cf66c3-0a80-4e0b-abd9-f015b25dbed3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9591fb7e-3354-423a-8514-0b7d93053a0e",
      target: "8e36182b-56a6-4925-a1a9-cd6d8fc09205"
    },
    {
      id: "346eaf6b-86f8-443d-b4bd-789314cca359",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9591fb7e-3354-423a-8514-0b7d93053a0e",
      target: "d2122c78-55fe-482c-88c1-30ff5b193643"
    },
    {
      id: "d5649531-a4dc-44ec-b26d-3d26ba707574",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69fc4d02-ae4f-4d62-be16-c6a479ebd269",
      target: "8e36182b-56a6-4925-a1a9-cd6d8fc09205"
    },
    {
      id: "2750fc47-7e05-4129-9231-9cf8122e6cc9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3405b6d8-58ed-488c-9932-f54373a803ce",
      target: "2f436069-737b-4d27-be8a-72db4ab8e581"
    },
    {
      id: "887d52e3-8899-42b1-8b4b-2c46ed061599",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d97a88a1-8975-43c9-8f6a-404cc691b45a",
      target: "8e36182b-56a6-4925-a1a9-cd6d8fc09205"
    },
    {
      id: "8084f308-10b0-4a5d-92a3-203e66db081a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f436069-737b-4d27-be8a-72db4ab8e581",
      target: "8e36182b-56a6-4925-a1a9-cd6d8fc09205"
    },
    {
      id: "fd095988-251d-4cf7-8c82-e4f7bc45843a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e36182b-56a6-4925-a1a9-cd6d8fc09205",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "8cf36841-335d-4c8a-994f-3bfbea514045",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e36182b-56a6-4925-a1a9-cd6d8fc09205",
      target: "01c0d7ea-27bf-4f36-9ab7-149723ddc836"
    },
    {
      id: "974b23b5-d526-440c-bd49-bc4cf7617e9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e36182b-56a6-4925-a1a9-cd6d8fc09205",
      target: "3125c09c-538a-4eef-9f3f-213a2ca6ba6c"
    },
    {
      id: "5f943921-2d83-498b-8e1c-0bcba3a9b2ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e36182b-56a6-4925-a1a9-cd6d8fc09205",
      target: "0a5ae84c-fa61-4717-a0ab-d3883e9f012d"
    },
    {
      id: "993c190a-070c-47c8-a3b4-514253ead955",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61e6b9a3-bc28-4d7c-bef3-e90de2d417c0",
      target: "6b1091f1-bc56-46af-b0a9-7f5086f9635a"
    },
    {
      id: "70e028d0-2747-47aa-bfec-518fb3daf33e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ae65f9e-5e56-43c7-ba73-f6cf69798256",
      target: "1c86e773-0a6c-4587-a20a-9192a5a2145f"
    },
    {
      id: "79a39976-8ac3-49ac-9767-fce1752e6e1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ae65f9e-5e56-43c7-ba73-f6cf69798256",
      target: "f167a6a8-f349-4333-9ee9-4eec52bf4647"
    },
    {
      id: "17a2d9ed-91e4-4438-8424-396e1915d63e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3353933-f5e1-444c-8fa4-fee82a71d295",
      target: "d3a05a41-6613-4067-bcf6-6d2df2091c72"
    },
    {
      id: "cdddbbb9-f47c-4f4d-80c6-c1f38ae1ed20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e02a0cc-de3f-4a70-87ed-929216ca8432",
      target: "68ecaf80-c642-4843-bc39-d61797959061"
    },
    {
      id: "8d5c47c2-aa0d-4024-8f9f-91413b710ea6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e02a0cc-de3f-4a70-87ed-929216ca8432",
      target: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb"
    },
    {
      id: "33ef8ca3-bbdf-41cf-b369-a841a52a02c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e02a0cc-de3f-4a70-87ed-929216ca8432",
      target: "f6b36f48-cc99-4421-b0fe-655c9cc30b57"
    },
    {
      id: "d3e6927a-4ef3-44f1-9df3-1342846d801a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8e02a0cc-de3f-4a70-87ed-929216ca8432",
      target: "e3353933-f5e1-444c-8fa4-fee82a71d295"
    },
    {
      id: "a5e4ff6b-7845-43fb-a73c-c5cc3c6c7026",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68ecaf80-c642-4843-bc39-d61797959061",
      target: "6b1091f1-bc56-46af-b0a9-7f5086f9635a"
    },
    {
      id: "0edea653-42a4-4b0e-a18e-65fefb1cc9c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68ecaf80-c642-4843-bc39-d61797959061",
      target: "c7da6cfd-4d2f-4191-9a0c-8213f859b0b0"
    },
    {
      id: "e2ab727f-cd87-416e-80e1-00619c60544e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ceada45c-fed4-43a1-9503-2998abb8c1f5",
      target: "d3a05a41-6613-4067-bcf6-6d2df2091c72"
    },
    {
      id: "80635be8-74a8-4fb5-a0bf-5b643bd3425c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "361414dd-f1b6-4928-8acb-b8fd11b0e41c",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "15364503-b0db-4481-9cb5-20ff976c1307",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcfca05d-8864-4acd-934e-c4730a3c620b",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "e4e13323-9202-4556-bad6-39c2ead56f7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcfca05d-8864-4acd-934e-c4730a3c620b",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "ca3c10f1-c980-4837-bd45-3c5bd7e9580d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6b1091f1-bc56-46af-b0a9-7f5086f9635a",
      target: "ceada45c-fed4-43a1-9503-2998abb8c1f5"
    },
    {
      id: "405c3715-4ced-44cb-954a-4cc81e772199",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b1091f1-bc56-46af-b0a9-7f5086f9635a",
      target: "87c017a0-015b-47db-ac47-e1ec73a54e67"
    },
    {
      id: "2e121695-d0dd-4452-af30-46d19c932148",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b1091f1-bc56-46af-b0a9-7f5086f9635a",
      target: "53793cda-dcfd-4e01-9b7c-6babb33665c1"
    },
    {
      id: "c97e9574-7ae5-40fd-98d2-4007485ef0a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      target: "1c86e773-0a6c-4587-a20a-9192a5a2145f"
    },
    {
      id: "a32203ae-6d58-4090-b377-d116f4e07137",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      target: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4"
    },
    {
      id: "e081765c-abe8-4f9e-9d89-79d271936808",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      target: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4"
    },
    {
      id: "294c735c-2fda-46c4-9a1a-48f831f614d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      target: "7a0b2618-317a-46d4-8757-670464cb46bb"
    },
    {
      id: "5b7f29a2-960b-4ef3-a40f-b8d55108f6a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53793cda-dcfd-4e01-9b7c-6babb33665c1",
      target: "123f8d50-d5a3-4c5a-925e-1f3afd393450"
    },
    {
      id: "8e370e0d-665f-4868-b098-a4bb93248a79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "123f8d50-d5a3-4c5a-925e-1f3afd393450",
      target: "52b9c922-db25-4ac8-8655-ed1b944fb377"
    },
    {
      id: "15cfe5e5-b5bb-41b1-a6b2-d840248bfd7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "123f8d50-d5a3-4c5a-925e-1f3afd393450",
      target: "bf8bdde0-b2c0-4334-b770-2740dd083778"
    },
    {
      id: "764f27ff-a9f6-4dd9-9f5b-8ac1f4e0bdac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf8bdde0-b2c0-4334-b770-2740dd083778",
      target: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364"
    },
    {
      id: "e5f9b331-3858-4be8-a5ff-0885fb71e6fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf8bdde0-b2c0-4334-b770-2740dd083778",
      target: "eaacb991-d9c9-4574-a070-2714b8e61d93"
    },
    {
      id: "0db4a1bf-a60e-4d5f-83d1-e7d317dedce6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eaacb991-d9c9-4574-a070-2714b8e61d93",
      target: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa"
    },
    {
      id: "04b4a6d1-f2af-4ed1-9fb9-c2640cb0071d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87c017a0-015b-47db-ac47-e1ec73a54e67",
      target: "7a0b2618-317a-46d4-8757-670464cb46bb"
    },
    {
      id: "579754bb-5ad9-4c2f-a9cb-2a0d96e67b82",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87c017a0-015b-47db-ac47-e1ec73a54e67",
      target: "7a0b2618-317a-46d4-8757-670464cb46bb"
    },
    {
      id: "fad1d1ff-5288-4351-ae0e-e581083ac344",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7a0b2618-317a-46d4-8757-670464cb46bb",
      target: "52b9c922-db25-4ac8-8655-ed1b944fb377"
    },
    {
      id: "34163e92-3f52-4c5b-a322-fc44b0240ce2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a0b2618-317a-46d4-8757-670464cb46bb",
      target: "61547741-734d-4f19-a7ee-b90d9fe6d39e"
    },
    {
      id: "c673b55a-7fdc-49c3-a57e-0a879c3d814a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52b9c922-db25-4ac8-8655-ed1b944fb377",
      target: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364"
    },
    {
      id: "2605de01-6644-41a3-99f3-423172736ceb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52b9c922-db25-4ac8-8655-ed1b944fb377",
      target: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364"
    },
    {
      id: "762ee837-33bd-47f4-bce7-c6be940c66b3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364",
      target: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa"
    },
    {
      id: "d8343012-4935-40ea-a4ec-4562ca7eea77",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cdc486fb-2df1-4ad6-ad46-6b3e58dbd364",
      target: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa"
    },
    {
      id: "7c69fbc0-c498-4515-a271-06fbed320f38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "0018b83a-04f3-4178-bfff-1cdfab700f19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd67e2b0-c8c0-4b73-8f37-b89e5b4d54aa",
      target: "d3a05a41-6613-4067-bcf6-6d2df2091c72"
    },
    {
      id: "314e05c6-7aea-495f-b58d-a0caff9f7b7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61547741-734d-4f19-a7ee-b90d9fe6d39e",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "7545a2f4-401b-406d-8e60-3cee2abf8e82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61547741-734d-4f19-a7ee-b90d9fe6d39e",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "07d36b85-5fa1-4ef2-93fd-7b31494984be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61547741-734d-4f19-a7ee-b90d9fe6d39e",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "eff0b5c2-96a2-4be9-b74b-02ce32414889",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      target: "903106db-3f7f-4fe0-bf6d-f172e317cd5d"
    },
    {
      id: "a360c046-7320-456d-aa2f-7fe6e541ac31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "aea0a59e-e98c-44d7-bab7-dd765d6ea661",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "62a14818-c58d-429b-b34b-5568446b06e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "a731dafb-f085-4bd6-8502-c86831ddb200",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3a05a41-6613-4067-bcf6-6d2df2091c72",
      target: "5a7ce840-aeef-4a14-94fd-4cb53291355e"
    },
    {
      id: "9fc1200d-96c2-4901-b245-211bc604c39b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b292f9f6-cc9d-4599-bef3-7964fab7e2cb",
      target: "14311162-e5f2-4a9a-a047-a5f6a8e31db0"
    },
    {
      id: "fa0fe8f8-9839-432d-a201-9f15b3b2985a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14311162-e5f2-4a9a-a047-a5f6a8e31db0",
      target: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6"
    },
    {
      id: "aa069210-1623-4ab4-906e-caba22f49959",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6",
      target: "e72f0194-c429-4f01-9356-19b7cc7a656b"
    },
    {
      id: "1187e8f5-e855-4a7a-8be4-31437638e7b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6",
      target: "0865d74e-8b0c-48e0-b17b-b7b82d590b9c"
    },
    {
      id: "dea4ede3-c119-4985-884b-e72e9ba97d28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6",
      target: "e6c023fe-80ab-4201-b7a2-197edcdc60cd"
    },
    {
      id: "32efb640-f7b7-44cd-ad7c-287be3c48608",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5abf2b51-8970-4aa8-9cf1-5e41286d5ab6",
      target: "61e6b9a3-bc28-4d7c-bef3-e90de2d417c0"
    },
    {
      id: "41e136c6-ad20-4be5-b007-f7c6953b1b25",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "d4e80aa4-ba16-44e2-b703-ad6213ea27bb"
    },
    {
      id: "fce79595-1a0a-4fa9-afe7-53a525da73e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "0d7a54d4-3851-4f73-8055-0143ee995909",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b"
    },
    {
      id: "b179b370-b6cb-4294-be08-155e922a06b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "5bd9b57c-59a2-4742-a817-d35f86a414ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "d24501a4-3025-48eb-a1ff-98862810740f"
    },
    {
      id: "03eb25a7-ebd1-49e8-9815-357d9bdd31d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "b21e463b-648b-46af-9693-ac63d688da09",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "df3a87fb-ee6e-4f5c-8016-17e721e18e5f"
    },
    {
      id: "85c9b610-a1d2-45da-8ff7-ad0333536634",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "75bced8e-c5ec-47be-bc53-70499005906b"
    },
    {
      id: "a99aba53-b519-400d-9d3e-319d04e60a95",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e"
    },
    {
      id: "4f5f7839-10c1-4c5a-8164-d4ae55996ba5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "ce5653aa-9a95-4c95-b318-c031b4aa58ad"
    },
    {
      id: "92a07129-5c94-4fd2-bfb8-d60c55dda032",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fba5883-d28b-4e81-9639-8cad4c7dbbeb",
      target: "dcfca05d-8864-4acd-934e-c4730a3c620b"
    },
    {
      id: "0224fae5-020f-40e7-9975-c4cbbba2bb83",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "75bced8e-c5ec-47be-bc53-70499005906b",
      target: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25"
    },
    {
      id: "39228abe-134c-4c69-875a-d941c3dcc700",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b",
      target: "0f162480-e95a-4913-9fbe-f16b2f5a6dbb"
    },
    {
      id: "39c8868b-4b78-49e4-a122-892a369f4095",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b",
      target: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4"
    },
    {
      id: "4c4b1c45-0ef2-4617-adc8-e24652ebcc22",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb6b8652-9a23-41c4-aa46-51a7b5aca09b",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "1e1e6176-ea86-4877-94b3-63f316965be5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7c86e854-bbc3-45b8-ae6a-cc608532fb6b",
      target: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25"
    },
    {
      id: "610ac313-ad02-45bc-8d4e-e336692d9762",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df3a87fb-ee6e-4f5c-8016-17e721e18e5f",
      target: "923c2b3b-00ed-4e98-8732-fd637793ae9c"
    },
    {
      id: "154a08dd-1d82-46cd-a1de-bd9288f55075",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e72f0194-c429-4f01-9356-19b7cc7a656b",
      target: "61e6b9a3-bc28-4d7c-bef3-e90de2d417c0"
    },
    {
      id: "652e28c0-b79b-47a2-bc6b-3fc2b53dbbf2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4",
      target: "34c8624c-7f37-4a45-9ae3-129542ad11fa"
    },
    {
      id: "ad7c7b23-f81b-41f5-8dcb-8f80962eaace",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4",
      target: "7c86e854-bbc3-45b8-ae6a-cc608532fb6b"
    },
    {
      id: "810f4c13-9579-427f-b596-160294944ade",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b0b70f8-e6b8-44d2-97c0-a880cb7eaef4",
      target: "f88884fa-3014-4a68-8ab9-51163c4a8f1c"
    },
    {
      id: "ecc3ed3b-8e4e-4949-8bfa-cc00154f7efe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f88884fa-3014-4a68-8ab9-51163c4a8f1c",
      target: "c24910e2-0e08-4555-90b6-fb591bcaa902"
    },
    {
      id: "6abcc11a-96df-4436-8ce8-8b08700f85b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f88884fa-3014-4a68-8ab9-51163c4a8f1c",
      target: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7"
    },
    {
      id: "b0767b59-cee3-4ab5-8eef-fd11e956316f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f88884fa-3014-4a68-8ab9-51163c4a8f1c",
      target: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a"
    },
    {
      id: "aab17bdd-13ce-4568-b787-d7a9599a439f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c24910e2-0e08-4555-90b6-fb591bcaa902",
      target: "83690d38-f66b-48b5-93b4-5a3f24aa9039"
    },
    {
      id: "ede4c625-2828-4470-bb17-38976be818f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c24910e2-0e08-4555-90b6-fb591bcaa902",
      target: "12f2bac7-8d1b-4970-b4e0-3aa5e3f714bd"
    },
    {
      id: "d490160e-b66a-4c49-955d-e3cc6551d29b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "83690d38-f66b-48b5-93b4-5a3f24aa9039",
      target: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25"
    },
    {
      id: "6740bd1e-6de2-4841-9d0c-4bbe4454f436",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83690d38-f66b-48b5-93b4-5a3f24aa9039",
      target: "8c7aa885-082b-4a1b-b751-f6d39fe13836"
    },
    {
      id: "f7c5da33-140b-4484-b1c4-ca0fe78a6881",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "34c8624c-7f37-4a45-9ae3-129542ad11fa",
      target: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a"
    },
    {
      id: "e31c306f-ddcc-444f-8cf2-8b2eaea9e806",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34c8624c-7f37-4a45-9ae3-129542ad11fa",
      target: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a"
    },
    {
      id: "fc5442bb-86ba-4e0f-9b26-43071338f45a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a",
      target: "d24501a4-3025-48eb-a1ff-98862810740f"
    },
    {
      id: "d577a601-505b-47a6-84d4-4c798d0e6ae5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d32a64b-4c8b-4a40-952c-c2c14bec8c7a",
      target: "12f2bac7-8d1b-4970-b4e0-3aa5e3f714bd"
    },
    {
      id: "d62f0ddc-9eb0-4c52-85f9-f61c78979112",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "12f2bac7-8d1b-4970-b4e0-3aa5e3f714bd",
      target: "8c7aa885-082b-4a1b-b751-f6d39fe13836"
    },
    {
      id: "8d06249f-7fab-4249-9ef0-a55d11ca2951",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "12f2bac7-8d1b-4970-b4e0-3aa5e3f714bd",
      target: "8c7aa885-082b-4a1b-b751-f6d39fe13836"
    },
    {
      id: "81562a53-3ebf-4e34-a741-e7284e4973c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8c7aa885-082b-4a1b-b751-f6d39fe13836",
      target: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25"
    },
    {
      id: "8a575522-418b-482a-9b58-05c90fa4401a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8c7aa885-082b-4a1b-b751-f6d39fe13836",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "76ce50dd-b923-4a65-afbf-6b169ca7a63b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "c75f4a6d-8b3d-489e-a831-08a6397f5df3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "99cdf535-1942-4a5c-a8f3-330ab9942adb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25",
      target: "903106db-3f7f-4fe0-bf6d-f172e317cd5d"
    },
    {
      id: "a4f97f27-5448-4acf-bb35-486452929c19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca01ca8b-4d6d-445a-96e2-12c2dde29b25",
      target: "d757e4ea-7f64-459f-9d06-b480a681de4c"
    },
    {
      id: "3e6350c7-a8ba-4fc3-ab10-90f4c23769a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d24501a4-3025-48eb-a1ff-98862810740f",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "95f9e4ed-90c5-4e2d-965f-b43d89ce26b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d24501a4-3025-48eb-a1ff-98862810740f",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "b5bcf4ea-82ec-4e76-bf87-500d8f8c3b31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7db4e21-dcef-428b-85cd-07788bc619e4",
      target: "f40f4c36-844f-40d8-8db1-2eb41533108d"
    },
    {
      id: "2043a4f4-99fd-4088-ad49-7002008be66e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f40f4c36-844f-40d8-8db1-2eb41533108d",
      target: "10155cf9-9391-4881-a0b2-bfae4089309e"
    },
    {
      id: "78f214cb-4553-4224-aa66-65f72a5a88b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10155cf9-9391-4881-a0b2-bfae4089309e",
      target: "6b1091f1-bc56-46af-b0a9-7f5086f9635a"
    },
    {
      id: "5f1696e0-f1d3-4ca8-9110-41f2e5212ad6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "10155cf9-9391-4881-a0b2-bfae4089309e",
      target: "4ae65f9e-5e56-43c7-ba73-f6cf69798256"
    },
    {
      id: "7bf7e386-6afd-4f37-a581-d40faed0c9a5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "10155cf9-9391-4881-a0b2-bfae4089309e",
      target: "98c13818-11ac-4bb8-849c-5ab4193c0b0f"
    },
    {
      id: "807bdf87-7e36-4cf2-8367-72153f7cf88d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98c13818-11ac-4bb8-849c-5ab4193c0b0f",
      target: "4ae65f9e-5e56-43c7-ba73-f6cf69798256"
    },
    {
      id: "aefc44ad-55b8-42f5-85b4-15a23488ab14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98c13818-11ac-4bb8-849c-5ab4193c0b0f",
      target: "1c86e773-0a6c-4587-a20a-9192a5a2145f"
    },
    {
      id: "52712180-a45a-4d01-858b-eb8b15d5882e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ddd3b316-5da9-45c4-b13f-856d2f2c32f2",
      target: "878c4134-a00b-4a43-8636-78dd27899f13"
    },
    {
      id: "d3a868f8-1f61-4e10-9789-40d4440a0031",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751"
    },
    {
      id: "d0e9a1c4-3d03-4ec3-9a41-9d7262f688b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "8510fb12-1bfb-40a4-b424-6f393f570a79",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "ddd3b316-5da9-45c4-b13f-856d2f2c32f2"
    },
    {
      id: "a6b98489-75cd-4f6b-b4d8-25966e4e2746",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "dada54a9-e647-41f2-a0e7-1d6b1fa6fcce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "fd1228a0-6f03-4c62-9674-1fbb992f3690"
    },
    {
      id: "afd0a473-6f87-4a2e-a22f-719be0ac9080",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "814ea38b-c0af-4e69-9a05-48b4d34fe4da"
    },
    {
      id: "231a4908-4866-4a5e-b548-76a93745f76c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "6b0eab76-2efa-4856-94fd-8f9875c33373"
    },
    {
      id: "e043bdc6-46a8-4df3-b252-e4e154e521be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "0830d001-8258-44f2-a17c-d8657d40e66d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2a2aa8fa-eeac-46d7-9df2-f9ff344b3b9e",
      target: "3e71cb4f-8b87-4f81-8d02-55d47b4dcb10"
    },
    {
      id: "66674538-5dc5-49c3-a1d4-0a4e820d6c1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd1228a0-6f03-4c62-9674-1fbb992f3690",
      target: "1c86e773-0a6c-4587-a20a-9192a5a2145f"
    },
    {
      id: "1cd12238-d81f-45f2-82a7-2266fb67a2a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd1228a0-6f03-4c62-9674-1fbb992f3690",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "a54f9c59-3cdf-4e0c-bb8f-bc85bfb6016c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd1228a0-6f03-4c62-9674-1fbb992f3690",
      target: "6eb39590-fcae-422e-9779-77b82d79d4c5"
    },
    {
      id: "b2c27826-12ef-4564-8321-649fea85e336",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "814ea38b-c0af-4e69-9a05-48b4d34fe4da",
      target: "4a9b51ca-c4ad-474b-a02c-3182dcffd81d"
    },
    {
      id: "3dbe9864-a6ef-465f-9cb2-e150eac75304",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4da5b7a6-7452-449d-85a8-aa82f2c3c9e6",
      target: "878c4134-a00b-4a43-8636-78dd27899f13"
    },
    {
      id: "6ebec923-c9bf-469c-bbaa-d9b8202ce9a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c86e773-0a6c-4587-a20a-9192a5a2145f",
      target: "0b2d4edc-0504-4883-ac3c-29318117328f"
    },
    {
      id: "b4098f15-72e5-4894-8242-c0cbc28cb91e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c86e773-0a6c-4587-a20a-9192a5a2145f",
      target: "da769131-1105-41b0-a2db-e3db97ff9d98"
    },
    {
      id: "3adb8dc0-0f37-4656-ab99-ed4124ec3531",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c86e773-0a6c-4587-a20a-9192a5a2145f",
      target: "4da5b7a6-7452-449d-85a8-aa82f2c3c9e6"
    },
    {
      id: "fb9ade2c-963d-4446-b877-76862d83a17a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da769131-1105-41b0-a2db-e3db97ff9d98",
      target: "1cd228e5-fb3a-4160-b25b-7b34435c4866"
    },
    {
      id: "2c6f73f5-fe5f-49c1-9df5-7545b70c1386",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da769131-1105-41b0-a2db-e3db97ff9d98",
      target: "19fdb366-9d8b-4b64-8bbb-eca8ba62f361"
    },
    {
      id: "dc2a8644-efb2-40db-8f0e-ce92975c4a60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da769131-1105-41b0-a2db-e3db97ff9d98",
      target: "771e9e6f-c882-4110-ad86-b3a340fc1f5b"
    },
    {
      id: "1bfd8667-5470-49e3-ae0c-3f44c076be99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19fdb366-9d8b-4b64-8bbb-eca8ba62f361",
      target: "685a2a7b-06f7-496e-baa7-a599fba664dd"
    },
    {
      id: "7a15143d-cc46-4b82-87b1-cef5c24553e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19fdb366-9d8b-4b64-8bbb-eca8ba62f361",
      target: "235e502b-fa1c-4257-baa2-57b00c9a2002"
    },
    {
      id: "8e2387d3-192f-4750-be89-8e27e521ea97",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "235e502b-fa1c-4257-baa2-57b00c9a2002",
      target: "0c4ad431-16f2-44fb-ab08-bd5d3dae8022"
    },
    {
      id: "9096b43c-c0b1-4eed-87a9-96270fc7dbbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "235e502b-fa1c-4257-baa2-57b00c9a2002",
      target: "f76bb9ff-116d-4f70-8644-7b3d064ac299"
    },
    {
      id: "dcd49648-d9ec-4974-bf59-954c0bdad795",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c4ad431-16f2-44fb-ab08-bd5d3dae8022",
      target: "a0e52b8b-692d-430b-b316-a56abd7c8e6f"
    },
    {
      id: "2ee1bc38-6be6-4431-aca7-8b93a57f11b8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0b2d4edc-0504-4883-ac3c-29318117328f",
      target: "771e9e6f-c882-4110-ad86-b3a340fc1f5b"
    },
    {
      id: "028b3341-c851-43c0-a00b-23fd7078546d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0b2d4edc-0504-4883-ac3c-29318117328f",
      target: "771e9e6f-c882-4110-ad86-b3a340fc1f5b"
    },
    {
      id: "cdd9c2d6-aea4-4db7-9152-f67054c38996",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "771e9e6f-c882-4110-ad86-b3a340fc1f5b",
      target: "685a2a7b-06f7-496e-baa7-a599fba664dd"
    },
    {
      id: "52cbe0c9-6f99-4bb3-a22e-3f18d74f846e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "771e9e6f-c882-4110-ad86-b3a340fc1f5b",
      target: "6b0eab76-2efa-4856-94fd-8f9875c33373"
    },
    {
      id: "c2933ff5-10ad-432d-af20-2dea74bed9f1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "685a2a7b-06f7-496e-baa7-a599fba664dd",
      target: "f76bb9ff-116d-4f70-8644-7b3d064ac299"
    },
    {
      id: "a1d635f9-7844-43ca-9d3c-ef547d1ed6a8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "685a2a7b-06f7-496e-baa7-a599fba664dd",
      target: "f76bb9ff-116d-4f70-8644-7b3d064ac299"
    },
    {
      id: "8f8d1a3a-4a4d-4ff9-9101-298b8ddef910",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f76bb9ff-116d-4f70-8644-7b3d064ac299",
      target: "a0e52b8b-692d-430b-b316-a56abd7c8e6f"
    },
    {
      id: "10a83ea0-e989-492a-a353-a1216d988f93",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f76bb9ff-116d-4f70-8644-7b3d064ac299",
      target: "a0e52b8b-692d-430b-b316-a56abd7c8e6f"
    },
    {
      id: "853b7ffa-fb36-4a48-b518-c079fb45e538",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a0e52b8b-692d-430b-b316-a56abd7c8e6f",
      target: "878c4134-a00b-4a43-8636-78dd27899f13"
    },
    {
      id: "76f4c6d5-014b-4e4e-ac97-51757e092de1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a0e52b8b-692d-430b-b316-a56abd7c8e6f",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "7e828a0f-b239-493d-9e5f-f10038107618",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b0eab76-2efa-4856-94fd-8f9875c33373",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "cb0758bc-a74d-46c9-8235-f77fae6e015e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b0eab76-2efa-4856-94fd-8f9875c33373",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "35178057-32bd-4f8f-b50c-508f82dc6689",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b0eab76-2efa-4856-94fd-8f9875c33373",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "ccdcb6d8-7229-4273-8667-ad152bd0fd06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "878c4134-a00b-4a43-8636-78dd27899f13",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "c4b29a3c-7438-45cb-a414-16b8bf0bb382",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "878c4134-a00b-4a43-8636-78dd27899f13",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "3a42a5a8-c602-43a3-9034-bc8947c07a00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "878c4134-a00b-4a43-8636-78dd27899f13",
      target: "5a7ce840-aeef-4a14-94fd-4cb53291355e"
    },
    {
      id: "2c248c39-d7e2-46ad-a05d-e6b0cb4d1cc6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0eb36f79-ca35-4824-959a-30cf91e12746",
      target: "7202ea17-3b80-4fcd-8035-d8cd0c789b71"
    },
    {
      id: "58f47d6f-1a7f-40e1-802d-b2bac6e22157",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "92bc073d-eda8-4c1d-a80c-2fee99bcb7c2"
    },
    {
      id: "87545de8-22b4-4ffb-9ae8-2285f9e60d36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "2091ad73-f72d-4add-bcc0-88da115186f3"
    },
    {
      id: "4e48196f-5d88-4f8c-a20c-d30d73b7b176",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751"
    },
    {
      id: "9285ffae-3182-4399-bfe5-921e499fd8bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "844d619f-03b4-44dc-b4f9-172eb2f534f6"
    },
    {
      id: "02c75661-3dfb-41b4-bb0a-9878feff2eed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "dcfca05d-8864-4acd-934e-c4730a3c620b"
    },
    {
      id: "b99c6c12-612e-4e9b-aa99-69043fa249b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "274d59ba-a095-44ee-9dc5-b0fa534c67ca",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "0eb36f79-ca35-4824-959a-30cf91e12746"
    },
    {
      id: "bf23d5de-3774-430f-9d17-403db1b7b737",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce5653aa-9a95-4c95-b318-c031b4aa58ad",
      target: "6244fe39-242c-4213-9ac1-2bc00708c95b"
    },
    {
      id: "f0b5411f-e745-468a-a7ef-f62e736b5671",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "844d619f-03b4-44dc-b4f9-172eb2f534f6",
      target: "a47740c9-5cc0-48b9-82fd-69294a37101d"
    },
    {
      id: "716ea8b0-3780-429b-bfb9-0f409d2e328c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "844d619f-03b4-44dc-b4f9-172eb2f534f6",
      target: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7"
    },
    {
      id: "2dbd5f20-41ce-4705-8467-493a23876ad2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2091ad73-f72d-4add-bcc0-88da115186f3",
      target: "7581676d-2b94-4609-b168-7764e4136f48"
    },
    {
      id: "c007971b-32bc-4518-9471-fdb38987099a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "94158ed9-67f1-4363-8e4e-738370d23654",
      target: "7202ea17-3b80-4fcd-8035-d8cd0c789b71"
    },
    {
      id: "ab6a692d-0e8d-42ea-ab9e-9688bfc1297a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7",
      target: "5896d681-5ae2-4a70-ad65-2b2f88abdd23"
    },
    {
      id: "ed1cd465-96d1-4fdd-a5c5-96de5cfa1e56",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7",
      target: "2081ef8d-21c8-486b-ae6e-9fbc7d0c54e9"
    },
    {
      id: "97ef6218-a582-4318-836a-aeca6334a552",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7",
      target: "94158ed9-67f1-4363-8e4e-738370d23654"
    },
    {
      id: "a1cbe31b-a010-41a7-8028-3298e83cff4b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5896d681-5ae2-4a70-ad65-2b2f88abdd23",
      target: "92bc073d-eda8-4c1d-a80c-2fee99bcb7c2"
    },
    {
      id: "dfc87e89-2ba2-4d05-b1da-06ab34da2ed7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5896d681-5ae2-4a70-ad65-2b2f88abdd23",
      target: "0a63157d-2a02-43f0-9a8e-f26af83b655f"
    },
    {
      id: "7930e390-96be-4ab3-99b8-ed0ba02004e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5896d681-5ae2-4a70-ad65-2b2f88abdd23",
      target: "066375d5-aab5-42ce-b66a-30c6bf08e337"
    },
    {
      id: "0d0ccad0-131f-43a2-88cd-fbe2071123d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a63157d-2a02-43f0-9a8e-f26af83b655f",
      target: "e1279ce9-5049-4fae-bc19-b170eb75f399"
    },
    {
      id: "c6c50c73-3df4-4d06-b947-7abe38183fb7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a63157d-2a02-43f0-9a8e-f26af83b655f",
      target: "c8a2d86c-c399-47b0-b74f-79311fc5e34b"
    },
    {
      id: "7930c48f-093c-4279-a070-5f4a18d4ee1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1279ce9-5049-4fae-bc19-b170eb75f399",
      target: "e572f8b6-cc02-40ed-b5da-85b282dcdbb8"
    },
    {
      id: "10de10d0-f81b-40e5-8ff1-4cee0eb96747",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1279ce9-5049-4fae-bc19-b170eb75f399",
      target: "d185c091-680c-4cc0-9628-0a768f0df849"
    },
    {
      id: "f23d45d7-ea11-4310-8bd2-b9e72fbffe07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e572f8b6-cc02-40ed-b5da-85b282dcdbb8",
      target: "88e70f29-86af-4380-8c62-f8b99a4c5bfe"
    },
    {
      id: "2f160fda-10f5-4bc9-a725-e8f5d369bbf0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2081ef8d-21c8-486b-ae6e-9fbc7d0c54e9",
      target: "066375d5-aab5-42ce-b66a-30c6bf08e337"
    },
    {
      id: "7023f959-f9b5-4a01-a6f4-46a752f45375",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2081ef8d-21c8-486b-ae6e-9fbc7d0c54e9",
      target: "066375d5-aab5-42ce-b66a-30c6bf08e337"
    },
    {
      id: "b05614a7-bebf-4f90-aa6c-f0dd49c1781d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "066375d5-aab5-42ce-b66a-30c6bf08e337",
      target: "c8a2d86c-c399-47b0-b74f-79311fc5e34b"
    },
    {
      id: "618daac1-1434-458c-a7f7-f551cf8598be",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "066375d5-aab5-42ce-b66a-30c6bf08e337",
      target: "c8a2d86c-c399-47b0-b74f-79311fc5e34b"
    },
    {
      id: "0536ef14-4f48-4e7f-a35a-4fd39711c823",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c8a2d86c-c399-47b0-b74f-79311fc5e34b",
      target: "d185c091-680c-4cc0-9628-0a768f0df849"
    },
    {
      id: "6fbc145f-61a3-4a2c-844f-36482520918d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c8a2d86c-c399-47b0-b74f-79311fc5e34b",
      target: "d185c091-680c-4cc0-9628-0a768f0df849"
    },
    {
      id: "790b1861-418d-4c4b-8dc4-929967210044",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d185c091-680c-4cc0-9628-0a768f0df849",
      target: "88e70f29-86af-4380-8c62-f8b99a4c5bfe"
    },
    {
      id: "0707459b-dc10-462e-a431-2993c8077ab6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d185c091-680c-4cc0-9628-0a768f0df849",
      target: "88e70f29-86af-4380-8c62-f8b99a4c5bfe"
    },
    {
      id: "6d93151d-c466-4060-9a32-a41f7142d033",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "88e70f29-86af-4380-8c62-f8b99a4c5bfe",
      target: "7202ea17-3b80-4fcd-8035-d8cd0c789b71"
    },
    {
      id: "e9115e05-2904-4115-866c-d1ce937edded",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88e70f29-86af-4380-8c62-f8b99a4c5bfe",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "e914c366-038e-45ae-8659-e0db753351f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92bc073d-eda8-4c1d-a80c-2fee99bcb7c2",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "fdfd24e5-7a92-489d-b658-ee17c1277e6e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92bc073d-eda8-4c1d-a80c-2fee99bcb7c2",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "8183f412-fa38-4eb7-8fae-05b19844c113",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7202ea17-3b80-4fcd-8035-d8cd0c789b71",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "7211c7bc-517c-499f-99ea-bd810d06b041",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7202ea17-3b80-4fcd-8035-d8cd0c789b71",
      target: "3c5a86a2-800a-4135-94db-14253d17693d"
    },
    {
      id: "f0f3f3af-475a-4da0-aae9-b734454c8b85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7202ea17-3b80-4fcd-8035-d8cd0c789b71",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "53d82ff1-d4ae-4a81-beab-982a5428bfa5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5103ab08-e938-4718-8559-b5089f2da12f",
      target: "6b740a7f-f87a-46d1-a60f-bedfbce446aa"
    },
    {
      id: "121b7761-f8e6-4617-abe4-a2f45bf1e9b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751",
      target: "3fdb2534-673f-49b9-a93b-c564b17a20ef"
    },
    {
      id: "21c309bc-6d25-4d20-a43f-407eb42c24b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751",
      target: "5103ab08-e938-4718-8559-b5089f2da12f"
    },
    {
      id: "3d35c2b8-0011-4657-8605-da56f4ac5e42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751",
      target: "8af65a37-dd4c-4361-bc42-10142c179b20"
    },
    {
      id: "38bbbd6a-1186-4790-a236-44385938bbe0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "951db51c-ec9f-4cbc-92b6-3c4e4f44f751",
      target: "6244fe39-242c-4213-9ac1-2bc00708c95b"
    },
    {
      id: "c03392af-98b3-4707-b227-7d526bd3e8c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8af65a37-dd4c-4361-bc42-10142c179b20",
      target: "1cd228e5-fb3a-4160-b25b-7b34435c4866"
    },
    {
      id: "e6e1983a-156f-4ec5-8e38-28c1e5cc8fb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8af65a37-dd4c-4361-bc42-10142c179b20",
      target: "68e024e3-9c5b-4eb1-a538-2b142f1b73c0"
    },
    {
      id: "2836fdb2-ca40-4a80-9599-ddea433ffd9f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8e2b70ce-f130-410b-a9ac-31a2e52d1148",
      target: "6b740a7f-f87a-46d1-a60f-bedfbce446aa"
    },
    {
      id: "037590a6-fe58-4bf7-b17b-36849e79e230",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6244fe39-242c-4213-9ac1-2bc00708c95b",
      target: "1a22ad96-5141-4656-b61b-78c924924007"
    },
    {
      id: "e7ddb054-4217-42ca-9d7b-1fcd5ee97684",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cd228e5-fb3a-4160-b25b-7b34435c4866",
      target: "1a475c0b-ae36-404a-809b-3520552e883a"
    },
    {
      id: "814522d6-33a1-4aa1-b395-bf8c4fa36795",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1cd228e5-fb3a-4160-b25b-7b34435c4866",
      target: "8e2b70ce-f130-410b-a9ac-31a2e52d1148"
    },
    {
      id: "1cf95b94-7577-4189-afac-9c83b9a3ba2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cd228e5-fb3a-4160-b25b-7b34435c4866",
      target: "b5de7f76-7175-497d-8627-a55c129b76fe"
    },
    {
      id: "1aa102db-6679-4c52-ab0d-507d5d7093b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a475c0b-ae36-404a-809b-3520552e883a",
      target: "44660d2f-4a5f-4b5a-94bb-e18a8ccd3d78"
    },
    {
      id: "bcdb446e-4b29-44a7-af92-bdf3814111a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a475c0b-ae36-404a-809b-3520552e883a",
      target: "4951abd8-85ad-4287-8980-ae5abe73325e"
    },
    {
      id: "a51b77f2-a78e-49c2-8eeb-eb7368061ca0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44660d2f-4a5f-4b5a-94bb-e18a8ccd3d78",
      target: "6d72f4e9-8597-4231-8af2-cbf01f5eb892"
    },
    {
      id: "6ea2e507-1041-4444-81e2-69fb4ce516d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44660d2f-4a5f-4b5a-94bb-e18a8ccd3d78",
      target: "42ee2f33-8ce4-4200-8912-c84ca5afb80a"
    },
    {
      id: "a4ac854a-6be4-44ba-9eb5-48cac129df96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42ee2f33-8ce4-4200-8912-c84ca5afb80a",
      target: "7b616c69-001d-443a-b32c-4288a474e3ca"
    },
    {
      id: "85b7e32f-3d7a-41d1-90f4-5cb1efdb304f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42ee2f33-8ce4-4200-8912-c84ca5afb80a",
      target: "bbc435a8-d8f2-4a9a-86ef-b28b7c718a20"
    },
    {
      id: "0f9092b5-f565-442f-ac92-1266ac5a225c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbc435a8-d8f2-4a9a-86ef-b28b7c718a20",
      target: "f819cfb3-4a72-4cb5-97d6-d23eb9b3b289"
    },
    {
      id: "5abe48b8-f73b-47bb-9157-44fe3584fcc8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b5de7f76-7175-497d-8627-a55c129b76fe",
      target: "4951abd8-85ad-4287-8980-ae5abe73325e"
    },
    {
      id: "4a02c431-f0ca-4077-9185-3a19dc9479e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5de7f76-7175-497d-8627-a55c129b76fe",
      target: "4951abd8-85ad-4287-8980-ae5abe73325e"
    },
    {
      id: "12b1feb7-c857-45c1-bcca-4a22a4711737",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4951abd8-85ad-4287-8980-ae5abe73325e",
      target: "3fdb2534-673f-49b9-a93b-c564b17a20ef"
    },
    {
      id: "d4fc7b87-ade7-45ae-9fdd-1d012c47b86c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4951abd8-85ad-4287-8980-ae5abe73325e",
      target: "6d72f4e9-8597-4231-8af2-cbf01f5eb892"
    },
    {
      id: "00a8f7d9-0d40-4931-b673-5101ff47ecf0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6d72f4e9-8597-4231-8af2-cbf01f5eb892",
      target: "7b616c69-001d-443a-b32c-4288a474e3ca"
    },
    {
      id: "d90ea278-aae2-40c2-ae48-8e43ac8aaba3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6d72f4e9-8597-4231-8af2-cbf01f5eb892",
      target: "7b616c69-001d-443a-b32c-4288a474e3ca"
    },
    {
      id: "a57dc3e7-569c-499e-9999-81abdc79339e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7b616c69-001d-443a-b32c-4288a474e3ca",
      target: "f819cfb3-4a72-4cb5-97d6-d23eb9b3b289"
    },
    {
      id: "e918c1ad-c006-4a78-b0ca-a65cae9802f0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b616c69-001d-443a-b32c-4288a474e3ca",
      target: "f819cfb3-4a72-4cb5-97d6-d23eb9b3b289"
    },
    {
      id: "fcd1cd05-12b3-4ccd-9dad-1c72fe1069a2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f819cfb3-4a72-4cb5-97d6-d23eb9b3b289",
      target: "6b740a7f-f87a-46d1-a60f-bedfbce446aa"
    },
    {
      id: "621764f1-3427-45f3-a546-0f82f93865a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fdb2534-673f-49b9-a93b-c564b17a20ef",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "cb9a51dd-8e53-4470-89a3-9e9eec25c75b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fdb2534-673f-49b9-a93b-c564b17a20ef",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "b22a9144-643b-4311-bd27-111656b479aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fdb2534-673f-49b9-a93b-c564b17a20ef",
      target: "7c9a664d-2bb9-40a6-aedd-590cf3098c75"
    },
    {
      id: "24fa3bc6-70d6-40b8-8ebf-10d98fb7ed2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b740a7f-f87a-46d1-a60f-bedfbce446aa",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "0e84a2af-7ad8-4fc6-b4ad-d5c0b7a595d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b740a7f-f87a-46d1-a60f-bedfbce446aa",
      target: "cd9f3e87-af7b-46f9-a9a2-8d684a47ee5f"
    },
    {
      id: "38e51a03-4858-4b91-ab00-7bd264e5aa68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b740a7f-f87a-46d1-a60f-bedfbce446aa",
      target: "d3c644e8-b911-4561-8a09-2ce148f4320b"
    },
    {
      id: "ecf01a08-0744-4f76-ba6a-ae790baef2ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b740a7f-f87a-46d1-a60f-bedfbce446aa",
      target: "e9ea4763-c9bb-42cf-a721-eed0a5f66f67"
    },
    {
      id: "e7593697-b3ed-4f3c-904d-499483712715",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9c54de4e-b35c-4127-9489-c910ca13b49a",
      target: "9519d4bf-014d-4593-997a-2437187fc868"
    },
    {
      id: "4575fbf9-e77b-46b9-bb35-549671e55aec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c54de4e-b35c-4127-9489-c910ca13b49a",
      target: "e55b463d-aa5d-494c-a126-242c52dc6736"
    },
    {
      id: "88b1a7e9-3ad7-4dbe-b857-5a33a52fcfed",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c54de4e-b35c-4127-9489-c910ca13b49a",
      target: "9519d4bf-014d-4593-997a-2437187fc868"
    },
    {
      id: "3009ca21-a69e-4326-93f4-31bf9a5c0676",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c54de4e-b35c-4127-9489-c910ca13b49a",
      target: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e"
    },
    {
      id: "ff35379a-9c7a-4f44-be3c-1f30f6de3f2a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9519d4bf-014d-4593-997a-2437187fc868",
      target: "e55b463d-aa5d-494c-a126-242c52dc6736"
    },
    {
      id: "2d9f1b72-b01c-4b2d-8b01-09c32dbfeac4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9519d4bf-014d-4593-997a-2437187fc868",
      target: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e"
    },
    {
      id: "4491a845-26d4-4c70-a8ec-8b18eab45258",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9519d4bf-014d-4593-997a-2437187fc868",
      target: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e"
    },
    {
      id: "098f3773-d438-48cb-aed8-20377226bcf3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9519d4bf-014d-4593-997a-2437187fc868",
      target: "e55b463d-aa5d-494c-a126-242c52dc6736"
    },
    {
      id: "7ad3b02e-92ec-4bd2-b1bd-5360c8ad7332",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9519d4bf-014d-4593-997a-2437187fc868",
      target: "9fc02960-0011-4b76-bed9-0f7cd12efb69"
    },
    {
      id: "cc9c3c30-3469-41c2-9af7-7603e90bc018",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      target: "17550e9f-710a-4082-aeeb-c0832f387333"
    },
    {
      id: "e8098c02-431e-41d8-b38d-a4d9aced562a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      target: "e55b463d-aa5d-494c-a126-242c52dc6736"
    },
    {
      id: "89f8ea31-28c5-46c1-aa57-808819c7d45e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      target: "e55b463d-aa5d-494c-a126-242c52dc6736"
    },
    {
      id: "3b22378c-e652-4be3-b16a-9df5aab0de38",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      target: "b2ba9f8e-75f7-4ee7-af8b-48bf32b59331"
    },
    {
      id: "8cf5a329-6f0e-453d-b06a-12758bc7c856",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a9f1ca66-89a9-4980-9223-d9c15ca69d1e",
      target: "6d917d99-c6c5-4d8e-bcd2-3cc43ee37b8c"
    },
    {
      id: "293ceada-0605-4cea-aebc-a77b3559645e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e55b463d-aa5d-494c-a126-242c52dc6736",
      target: "6d917d99-c6c5-4d8e-bcd2-3cc43ee37b8c"
    },
    {
      id: "d03a385d-b508-4cb9-a5e3-f3ca48cdaf37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e55b463d-aa5d-494c-a126-242c52dc6736",
      target: "9fc02960-0011-4b76-bed9-0f7cd12efb69"
    },
    {
      id: "05ba6aeb-bd69-4904-a7cb-2419bd6cec1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e55b463d-aa5d-494c-a126-242c52dc6736",
      target: "17550e9f-710a-4082-aeeb-c0832f387333"
    },
    {
      id: "701c44c7-d9ea-4dc1-bb97-5471b9c24c10",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e55b463d-aa5d-494c-a126-242c52dc6736",
      target: "b2ba9f8e-75f7-4ee7-af8b-48bf32b59331"
    },
    {
      id: "94737eba-b277-4a24-88f7-efc76733ce1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17550e9f-710a-4082-aeeb-c0832f387333",
      target: "e3a1cce3-1baf-4b6c-8bdd-43ccb92f94ef"
    },
    {
      id: "a869f6d3-7acb-40d0-a7fe-ac55a9aca695",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2ba9f8e-75f7-4ee7-af8b-48bf32b59331",
      target: "6d917d99-c6c5-4d8e-bcd2-3cc43ee37b8c"
    },
    {
      id: "9fed9e77-2bc0-40d2-9def-8caa76473847",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2ba9f8e-75f7-4ee7-af8b-48bf32b59331",
      target: "06737829-e188-48c8-90e1-05746ef0b9f8"
    },
    {
      id: "752b08d6-b18b-4cee-b9c9-c3713a8dab5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d917d99-c6c5-4d8e-bcd2-3cc43ee37b8c",
      target: "06e00a3b-2e24-4b3f-972b-0809cf2f0ec3"
    },
    {
      id: "2912d62d-e857-46bc-b534-563b23fadb11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3a1cce3-1baf-4b6c-8bdd-43ccb92f94ef",
      target: "d6c6b1be-83c9-420a-bc49-4915bbc465ca"
    },
    {
      id: "af93c63e-48a0-4651-82e9-16a68881b337",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7ccfef2-7405-4c1b-b335-d12d308d8549",
      target: "06737829-e188-48c8-90e1-05746ef0b9f8"
    },
    {
      id: "b659e121-a8dc-43eb-a26e-cbb99cf4337d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7ccfef2-7405-4c1b-b335-d12d308d8549",
      target: "170e2595-2df7-4872-99b1-901f40cee5d8"
    },
    {
      id: "6cb7cb31-cdb8-4b82-85bb-5aabeefd1dc7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c7ccfef2-7405-4c1b-b335-d12d308d8549",
      target: "bc5ec2f7-07dc-4fe7-83d1-80fccc064128"
    },
    {
      id: "a4040bf0-0d46-49a0-b07c-559f0d190ded",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7ccfef2-7405-4c1b-b335-d12d308d8549",
      target: "57f1d59f-978e-4245-96e3-e9e27f131456"
    },
    {
      id: "24ece66e-ae94-4ae6-a992-6bdf17c3ac31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06737829-e188-48c8-90e1-05746ef0b9f8",
      target: "6a3aaf47-1ab6-4956-afd7-b30ef3fb8615"
    },
    {
      id: "68420d25-13d2-4137-8ef9-7dbf04f2143f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "06737829-e188-48c8-90e1-05746ef0b9f8",
      target: "712d81d9-6ca6-4f52-84aa-ae332305f731"
    },
    {
      id: "227f4176-9a86-48ee-bb7b-aec653260471",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "06737829-e188-48c8-90e1-05746ef0b9f8",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "4cc0d5a6-6b47-45cb-aee8-1270044a0424",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06737829-e188-48c8-90e1-05746ef0b9f8",
      target: "06e00a3b-2e24-4b3f-972b-0809cf2f0ec3"
    },
    {
      id: "f4d701dc-e675-4efc-aa30-7287786df7c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6c6b1be-83c9-420a-bc49-4915bbc465ca",
      target: "1b487435-c4ee-4b4e-969f-cc9c858302f6"
    },
    {
      id: "9b7f445a-f725-4115-9a68-a1146826ac0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6c6b1be-83c9-420a-bc49-4915bbc465ca",
      target: "06737829-e188-48c8-90e1-05746ef0b9f8"
    },
    {
      id: "bd818daa-0387-43de-b28c-43405b30a2a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b487435-c4ee-4b4e-969f-cc9c858302f6",
      target: "8b913b23-ed56-4f5f-aaad-64c3ff935a74"
    },
    {
      id: "cd2cae6e-2f4e-43ec-861b-234f8609a47b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06e00a3b-2e24-4b3f-972b-0809cf2f0ec3",
      target: "71b8d0d7-44f7-4f48-ae4f-7d551b498a27"
    },
    {
      id: "5f41355d-c67c-45d5-a8d7-d0a1e4d17420",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b913b23-ed56-4f5f-aaad-64c3ff935a74",
      target: "1f7c6c3d-39d3-4685-8566-fa5c50da80dc"
    },
    {
      id: "2bdbca72-54c6-4163-b731-587a59b5571c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71b8d0d7-44f7-4f48-ae4f-7d551b498a27",
      target: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547"
    },
    {
      id: "d334f90a-d6b2-46cf-b2a0-c87a07c656af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71b8d0d7-44f7-4f48-ae4f-7d551b498a27",
      target: "6a3aaf47-1ab6-4956-afd7-b30ef3fb8615"
    },
    {
      id: "0fe47e41-5775-4ac0-a12a-90b4606d83b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1f7c6c3d-39d3-4685-8566-fa5c50da80dc",
      target: "9f950378-b1a8-4c00-b309-841d44ffae07"
    },
    {
      id: "5a3cc947-25cc-4080-8ca9-e2b37b89ca35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4293a7a1-e84d-4c1e-b66e-304e829292cf",
      target: "86890de1-e223-4c86-b288-11a6d50d3e9e"
    },
    {
      id: "2d57bf1d-f02f-4387-83fc-af37541ffc35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86890de1-e223-4c86-b288-11a6d50d3e9e",
      target: "667c27ca-08fb-4433-a08b-d330c1dbd5f4"
    },
    {
      id: "bc4e1897-9b56-452b-a2ad-51b4ad2970cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "667c27ca-08fb-4433-a08b-d330c1dbd5f4",
      target: "3ce5428a-e0ce-4ed4-b70f-a9dd03aacf17"
    },
    {
      id: "c18c80ab-6b68-4149-baf3-ace4b8f80200",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      target: "159ec191-4048-4d6b-8cba-2bc768d29399"
    },
    {
      id: "cb6cfbfd-f3e1-490e-88c0-5d33cbb1c43e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      target: "a73b3451-0cb3-4ccb-b96e-18f360181fcd"
    },
    {
      id: "1f2876d6-4a34-4c2e-847a-a8e4c54cccdb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      target: "159ec191-4048-4d6b-8cba-2bc768d29399"
    },
    {
      id: "189b3b20-d104-4af1-a387-87642ee8ef70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      target: "e531743d-ea6b-48df-8ffa-6f028eb0c556"
    },
    {
      id: "f349b49f-afde-4882-81f1-7a850570df2a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "881ad8b2-4dbd-4f4d-9fe8-6c26c6df1547",
      target: "8511dc97-c3c7-4750-8595-9ff466cf02c9"
    },
    {
      id: "ae0df862-2f20-4baa-9611-47f7c4b23a1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "159ec191-4048-4d6b-8cba-2bc768d29399",
      target: "566ab706-2a55-4fb9-93c5-0746b8f140df"
    },
    {
      id: "58c0f0eb-f916-42b7-bbaf-40d59d2f1992",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "566ab706-2a55-4fb9-93c5-0746b8f140df",
      target: "f741b8f2-6453-47de-895f-ab5c08bf6317"
    },
    {
      id: "abd15079-408a-48b4-9045-0930057f0df8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "566ab706-2a55-4fb9-93c5-0746b8f140df",
      target: "e5cac6ba-7547-482d-92aa-035ba395db61"
    },
    {
      id: "c6bcbde9-6589-4e79-a464-a92cd706402e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f741b8f2-6453-47de-895f-ab5c08bf6317",
      target: "e5cac6ba-7547-482d-92aa-035ba395db61"
    },
    {
      id: "ac054ddd-171b-412b-9eb9-83b721d66318",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e5cac6ba-7547-482d-92aa-035ba395db61",
      target: "b4d139ca-770c-4809-9b30-0bbb0abd868c"
    },
    {
      id: "06585efa-97f7-4a7e-91f1-e6b253ea420a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5cac6ba-7547-482d-92aa-035ba395db61",
      target: "b4d139ca-770c-4809-9b30-0bbb0abd868c"
    },
    {
      id: "63092f82-508c-45a5-84ba-cbb3f8fa1eff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e5cac6ba-7547-482d-92aa-035ba395db61",
      target: "599bc1f3-73df-470a-af9b-2ccd6bd099fc"
    },
    {
      id: "2aa83e36-f226-47fb-ab6b-3a97a316bdb0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5cac6ba-7547-482d-92aa-035ba395db61",
      target: "599bc1f3-73df-470a-af9b-2ccd6bd099fc"
    },
    {
      id: "3a895971-b473-4685-b3d5-d3430638b065",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5cac6ba-7547-482d-92aa-035ba395db61",
      target: "712d81d9-6ca6-4f52-84aa-ae332305f731"
    },
    {
      id: "731298d3-7974-4fbb-8aca-b74fc75dfc10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "599bc1f3-73df-470a-af9b-2ccd6bd099fc",
      target: "8abf03f9-5e78-404b-a8c3-388a1010400a"
    },
    {
      id: "2932e772-5bba-4751-a6e5-2c0b8444e62a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4d139ca-770c-4809-9b30-0bbb0abd868c",
      target: "190f6a18-d05a-4953-94d5-86ec3362ab5a"
    },
    {
      id: "e9db520a-da1a-4def-9268-60efa77f49cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "712d81d9-6ca6-4f52-84aa-ae332305f731",
      target: "9f950378-b1a8-4c00-b309-841d44ffae07"
    },
    {
      id: "59d7e04d-707a-4d4a-b1b5-8ead48e60243",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8abf03f9-5e78-404b-a8c3-388a1010400a",
      target: "a42610ba-a51a-44e6-9991-c6c0975022bb"
    },
    {
      id: "56e60619-152a-49fc-9a51-6082d87b5afe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "190f6a18-d05a-4953-94d5-86ec3362ab5a",
      target: "5fb80f52-0f5b-43c0-861b-91af0a622d62"
    },
    {
      id: "64b1840d-f0ea-44c0-afad-74bf440261a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f950378-b1a8-4c00-b309-841d44ffae07",
      target: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe"
    },
    {
      id: "504ec096-5e65-4f40-b376-45bc500441e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f950378-b1a8-4c00-b309-841d44ffae07",
      target: "32c086ed-ec22-4ece-a778-4e5c254ab396"
    },
    {
      id: "275fd642-8109-4966-bc38-60d38eb24dac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f950378-b1a8-4c00-b309-841d44ffae07",
      target: "e7d26732-3faf-4110-bea8-4a8367261afc"
    },
    {
      id: "a4f784a7-5552-4ad5-a19f-51af8c6133b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a42610ba-a51a-44e6-9991-c6c0975022bb",
      target: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe"
    },
    {
      id: "f9cff933-9777-457d-af76-b4f6474d012a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fb80f52-0f5b-43c0-861b-91af0a622d62",
      target: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe"
    },
    {
      id: "f9ba21d1-9ae0-479e-a124-283639a160ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fb80f52-0f5b-43c0-861b-91af0a622d62",
      target: "29adde29-7d38-4dd5-a276-c7d3c7eb7491"
    },
    {
      id: "568a17b7-2f75-432a-a9c8-f8741d5a7049",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29adde29-7d38-4dd5-a276-c7d3c7eb7491",
      target: "04dc8626-687d-4e94-86c3-5bfc2e92baba"
    },
    {
      id: "71a219bb-6fc8-4978-8525-e9246d92f9fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      target: "566ab706-2a55-4fb9-93c5-0746b8f140df"
    },
    {
      id: "da8fb36b-b73d-4ad2-a04f-3b319bbba92f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      target: "e5cac6ba-7547-482d-92aa-035ba395db61"
    },
    {
      id: "bff07e44-7f12-44ee-abf7-a3395f940c5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      target: "599bc1f3-73df-470a-af9b-2ccd6bd099fc"
    },
    {
      id: "48c1efb1-4db8-479b-a56c-a52db4b40157",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      target: "b4d139ca-770c-4809-9b30-0bbb0abd868c"
    },
    {
      id: "a631a219-3ea6-4ff6-86c4-f3bdc7ef2906",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e531743d-ea6b-48df-8ffa-6f028eb0c556",
      target: "712d81d9-6ca6-4f52-84aa-ae332305f731"
    },
    {
      id: "3a02a8a7-3173-4bfa-b395-6de0d232ac5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95ca3871-1f26-4053-9a42-b39ea8935a20",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "accb70d6-c8da-4010-9e2f-f6d9ff8e2b2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95ca3871-1f26-4053-9a42-b39ea8935a20",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "ec5304ab-75b2-4f6c-b335-e3c248c61546",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95ca3871-1f26-4053-9a42-b39ea8935a20",
      target: "04dc8626-687d-4e94-86c3-5bfc2e92baba"
    },
    {
      id: "444a8e9f-350c-4b0e-be65-019a8512b79d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95ca3871-1f26-4053-9a42-b39ea8935a20",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "536f3b90-9662-4886-9aea-30f0ad9b846a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8511dc97-c3c7-4750-8595-9ff466cf02c9",
      target: "64afed6b-a7a8-4420-a7e8-3f33826f45f9"
    },
    {
      id: "b44466e8-ec67-48e7-8393-9342b3ee1006",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8511dc97-c3c7-4750-8595-9ff466cf02c9",
      target: "66af152a-a06e-4f23-b0bf-67d83d82786a"
    },
    {
      id: "69f62b2a-6cc4-4fad-afe0-ff775514e869",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8511dc97-c3c7-4750-8595-9ff466cf02c9",
      target: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b"
    },
    {
      id: "526f3b60-c308-4a5c-be68-1fb184a16a46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64afed6b-a7a8-4420-a7e8-3f33826f45f9",
      target: "77070421-e838-41b8-ad2a-109fd4b9fc92"
    },
    {
      id: "f17cbbdf-09ec-4a04-b613-ebd39b3ff059",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64afed6b-a7a8-4420-a7e8-3f33826f45f9",
      target: "95ca3871-1f26-4053-9a42-b39ea8935a20"
    },
    {
      id: "a82e2b6e-5243-46c4-a952-54c7231f2830",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "77070421-e838-41b8-ad2a-109fd4b9fc92",
      target: "7f3ef5e8-9081-48b4-af55-10930869a8bc"
    },
    {
      id: "ffab18c7-3717-4cb8-9709-37359073ec7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77070421-e838-41b8-ad2a-109fd4b9fc92",
      target: "de70fb63-7575-4b3d-8361-c02ff8ef150e"
    },
    {
      id: "55879184-dfc8-4f7b-9864-e2e572f6c6d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f3ef5e8-9081-48b4-af55-10930869a8bc",
      target: "de70fb63-7575-4b3d-8361-c02ff8ef150e"
    },
    {
      id: "f951ddad-d7af-4488-89bb-754ce255a4c6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      target: "96928091-be5e-4d0b-905e-275d70cc308b"
    },
    {
      id: "2b38e836-c2ec-49ca-97be-956c8ff7b91a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      target: "96928091-be5e-4d0b-905e-275d70cc308b"
    },
    {
      id: "f09e828c-a587-47d0-94dd-5476f81a5e79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      target: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe"
    },
    {
      id: "03a0881f-5e04-4fca-917b-2c676c1c6f9b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      target: "c361004c-1309-4bfa-989d-0467cf7dc8ea"
    },
    {
      id: "72f7b5b6-1463-4c1b-8f88-2e59de2b3f26",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "de70fb63-7575-4b3d-8361-c02ff8ef150e",
      target: "c361004c-1309-4bfa-989d-0467cf7dc8ea"
    },
    {
      id: "0c83bfed-5baf-49d1-a8a8-e197fdbef05c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96928091-be5e-4d0b-905e-275d70cc308b",
      target: "32c086ed-ec22-4ece-a778-4e5c254ab396"
    },
    {
      id: "4b072dcc-70b6-40b8-ae10-ffa5ecccc531",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c361004c-1309-4bfa-989d-0467cf7dc8ea",
      target: "e7d26732-3faf-4110-bea8-4a8367261afc"
    },
    {
      id: "1ac60d5a-6f6c-49a1-ad8e-1a9fe2dddc3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8efc4e5-0cd0-4f13-989e-bcf76f57bbbe",
      target: "695605b9-4f22-47f3-b7ea-fd59871d34cd"
    },
    {
      id: "7b5409db-6883-4afe-bf58-76ea6630d314",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c086ed-ec22-4ece-a778-4e5c254ab396",
      target: "9880ddc5-41c3-4ec8-b8df-9785c9e1f1ff"
    },
    {
      id: "c240faa9-e2c8-44ef-b4cc-412e7c22224a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7d26732-3faf-4110-bea8-4a8367261afc",
      target: "e77a0b64-8729-4402-ae64-a99c43ef4805"
    },
    {
      id: "c879d7b6-f9d8-462e-b864-cf29083b5dd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "695605b9-4f22-47f3-b7ea-fd59871d34cd",
      target: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea"
    },
    {
      id: "458bc87c-0ff2-44fb-baa7-a806d3c92c4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9880ddc5-41c3-4ec8-b8df-9785c9e1f1ff",
      target: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea"
    },
    {
      id: "35b874ea-29b8-4a2a-9b37-970132b9b79b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9880ddc5-41c3-4ec8-b8df-9785c9e1f1ff",
      target: "1dfa4935-21ee-49ef-a8ab-561f799e9ffd"
    },
    {
      id: "e5c4cf2d-0e3e-44fa-8ffd-7e3d863b5074",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e77a0b64-8729-4402-ae64-a99c43ef4805",
      target: "07306f8a-c20c-4135-a710-c8366e60895f"
    },
    {
      id: "357db662-d316-4db1-9e61-f6b7009bfbf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e77a0b64-8729-4402-ae64-a99c43ef4805",
      target: "04dc8626-687d-4e94-86c3-5bfc2e92baba"
    },
    {
      id: "969e3f8b-dfe3-473d-803f-f4993b7bb167",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e77a0b64-8729-4402-ae64-a99c43ef4805",
      target: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea"
    },
    {
      id: "a212eade-1575-43cb-9c52-e86be1666efd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04dc8626-687d-4e94-86c3-5bfc2e92baba",
      target: "fd4a671c-7efc-4d4e-bf32-7236ea165132"
    },
    {
      id: "69e45631-a928-4a3a-aba3-a5edc034fd79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66af152a-a06e-4f23-b0bf-67d83d82786a",
      target: "77070421-e838-41b8-ad2a-109fd4b9fc92"
    },
    {
      id: "44285447-8f60-430a-9a21-74d6fcfd12df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b",
      target: "fe83b577-f749-49c0-82b3-96c745c5fe93"
    },
    {
      id: "fb04daca-08c6-46e3-9d94-feba7d162db2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b",
      target: "80e23ce1-ed4b-4104-9452-6078f30f51c2"
    },
    {
      id: "28b41eb8-b134-45a2-8119-987846979045",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abf3b1c9-bb4d-4dd2-9d0a-5b785672885b",
      target: "4cb4ee67-ae43-423f-b23c-0b9fbec64286"
    },
    {
      id: "41c52d98-e111-42b7-9734-254ba8300db5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe83b577-f749-49c0-82b3-96c745c5fe93",
      target: "9b59ba30-4f53-474d-91f2-380d4431197d"
    },
    {
      id: "cc142389-7176-4a8f-b363-56ff269cd7d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b59ba30-4f53-474d-91f2-380d4431197d",
      target: "262b2b73-c247-4367-90c2-466d3b26ba3f"
    },
    {
      id: "5a3b91f6-3990-4169-b8bd-df447f975b21",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b59ba30-4f53-474d-91f2-380d4431197d",
      target: "6d26cd39-c180-4ab0-af56-f39a58493ef9"
    },
    {
      id: "15bc0b2c-4291-4652-83fe-50b98e45174c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d26cd39-c180-4ab0-af56-f39a58493ef9",
      target: "262b2b73-c247-4367-90c2-466d3b26ba3f"
    },
    {
      id: "c0b93314-9612-45a7-bd80-353b7688041a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      target: "86b01ff3-2b17-4ccd-9114-93c883a3e941"
    },
    {
      id: "d92d5726-d9b3-493e-859a-4d97266513c9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      target: "86b01ff3-2b17-4ccd-9114-93c883a3e941"
    },
    {
      id: "c914d1d6-02e4-480e-88f2-12bcdcfeae54",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      target: "27f0799a-7d99-4c4d-86b2-e78e471ba8aa"
    },
    {
      id: "5635c9c4-2606-4490-afa6-03187a7cc505",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      target: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea"
    },
    {
      id: "f45d37ef-d5a5-4ad5-ba04-01731b276b17",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "262b2b73-c247-4367-90c2-466d3b26ba3f",
      target: "27f0799a-7d99-4c4d-86b2-e78e471ba8aa"
    },
    {
      id: "c0325143-16a6-491e-ba31-ecf211b450a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27f0799a-7d99-4c4d-86b2-e78e471ba8aa",
      target: "1dfa4935-21ee-49ef-a8ab-561f799e9ffd"
    },
    {
      id: "f76da890-7ef6-4666-a327-ab85d8cbf080",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86b01ff3-2b17-4ccd-9114-93c883a3e941",
      target: "07306f8a-c20c-4135-a710-c8366e60895f"
    },
    {
      id: "b5b751a0-ecc1-40f2-b438-7f8de2006ae8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1dfa4935-21ee-49ef-a8ab-561f799e9ffd",
      target: "145fb35d-9191-4ce2-bf5e-a0d5629bf5eb"
    },
    {
      id: "55e8c716-5853-4b6d-aac7-ef6bd7908cd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07306f8a-c20c-4135-a710-c8366e60895f",
      target: "71457749-85f8-44fd-a3d0-0c22f531884b"
    },
    {
      id: "3560876d-bcd6-4daa-9e61-e6997d8e0323",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c02bc64-f72f-4311-a1a6-6c69cd9973ea",
      target: "89b51122-ef2a-45e3-b198-e03287a439ec"
    },
    {
      id: "c0151c7b-4226-4f33-954b-1610375c5865",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89b51122-ef2a-45e3-b198-e03287a439ec",
      target: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f"
    },
    {
      id: "f70a998c-7c47-433f-b7ad-0497616e5f5d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "145fb35d-9191-4ce2-bf5e-a0d5629bf5eb",
      target: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f"
    },
    {
      id: "39fa38cc-e101-44e1-86c8-95cf7abab6ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "145fb35d-9191-4ce2-bf5e-a0d5629bf5eb",
      target: "c7df0e1d-3cea-45b8-9dd8-fbce5afd3d0e"
    },
    {
      id: "4fa11471-52a0-4751-bb68-21fd0772b709",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71457749-85f8-44fd-a3d0-0c22f531884b",
      target: "414841dc-7c73-4921-aa99-ce721fc76f94"
    },
    {
      id: "dc95b4fb-4771-4113-8064-89ee6a61f86c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71457749-85f8-44fd-a3d0-0c22f531884b",
      target: "fd4a671c-7efc-4d4e-bf32-7236ea165132"
    },
    {
      id: "1bc87152-685b-44cb-86e2-d44a714707ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71457749-85f8-44fd-a3d0-0c22f531884b",
      target: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f"
    },
    {
      id: "dfb7c4aa-6704-4f0a-8ed6-ed65ed615416",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd4a671c-7efc-4d4e-bf32-7236ea165132",
      target: "e20126e8-8f6a-4ec8-9149-317f70a98a77"
    },
    {
      id: "3922e6af-ce05-4bae-8bc3-2cd69f98e71a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80e23ce1-ed4b-4104-9452-6078f30f51c2",
      target: "9b59ba30-4f53-474d-91f2-380d4431197d"
    },
    {
      id: "edd27ba0-ac9d-45e7-942e-c2cfb07438c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cb4ee67-ae43-423f-b23c-0b9fbec64286",
      target: "2edce70b-fdf4-4bdd-a96c-47f91331becc"
    },
    {
      id: "e2bfe6aa-00a5-4560-8f62-65ff891e4988",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cb4ee67-ae43-423f-b23c-0b9fbec64286",
      target: "02a073d8-cbd9-4dd9-9bc5-4d3542e867d4"
    },
    {
      id: "29d935a3-980d-4509-819a-23cf515c65aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4cb4ee67-ae43-423f-b23c-0b9fbec64286",
      target: "29d8126e-d41e-44c0-ac74-b21977de94af"
    },
    {
      id: "228251ff-0605-4ed1-ac39-f4e9d822a389",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2edce70b-fdf4-4bdd-a96c-47f91331becc",
      target: "651ab799-cc77-4309-a031-9040d3552726"
    },
    {
      id: "7ab96bbc-2d06-4037-a029-c4ed9ab3ed36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "651ab799-cc77-4309-a031-9040d3552726",
      target: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3"
    },
    {
      id: "9c581a60-543b-49a7-8a12-bfbd0aa6fdd8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "651ab799-cc77-4309-a031-9040d3552726",
      target: "9383a3ca-5027-45ac-8498-7424f91cf7fe"
    },
    {
      id: "61cff599-1806-4a90-91f9-8edbb2a3f63b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9383a3ca-5027-45ac-8498-7424f91cf7fe",
      target: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3"
    },
    {
      id: "b86ffc60-df78-444a-91b7-bedd7cb86bac",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      target: "6a134ced-0b47-4ff2-8ea9-23dc9d4bb641"
    },
    {
      id: "99ec2b3a-3339-4615-8707-ece28a11f047",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      target: "6a134ced-0b47-4ff2-8ea9-23dc9d4bb641"
    },
    {
      id: "1129798c-d49b-4b3e-9ed2-890cc8f6133f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      target: "66532f16-45fc-4ca5-ba91-f451d7280803"
    },
    {
      id: "cbae13ce-a6b1-4ad3-84df-27761942a1e9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      target: "66532f16-45fc-4ca5-ba91-f451d7280803"
    },
    {
      id: "fbd9d756-2955-4bac-8aa3-9acc5935075e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "480ce85b-4f56-49aa-9fcf-e28c12fa0ce3",
      target: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f"
    },
    {
      id: "8e7cfe5b-013f-4c33-a109-043a1749744b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66532f16-45fc-4ca5-ba91-f451d7280803",
      target: "c7df0e1d-3cea-45b8-9dd8-fbce5afd3d0e"
    },
    {
      id: "6173d208-d93f-4236-b981-e7fb645d6f02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a134ced-0b47-4ff2-8ea9-23dc9d4bb641",
      target: "414841dc-7c73-4921-aa99-ce721fc76f94"
    },
    {
      id: "278165bc-3524-4ec8-9514-8ccff68a0ac5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f6a8aca-9b33-4b27-ae53-6f0e56621a6f",
      target: "ac82282b-b699-43c5-83f4-32d5b0f63861"
    },
    {
      id: "8f2b11d3-9b3a-4961-ab2a-274811753614",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7df0e1d-3cea-45b8-9dd8-fbce5afd3d0e",
      target: "de12af0e-eb14-45e2-9d7e-1d3ef063f4a2"
    },
    {
      id: "57f4e931-b16b-4437-ab3d-b4206e3bb30e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "414841dc-7c73-4921-aa99-ce721fc76f94",
      target: "f8b0866b-c610-4290-9360-f129e2048d7b"
    },
    {
      id: "38ea2764-47a5-4700-9b7b-7ded7995c100",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac82282b-b699-43c5-83f4-32d5b0f63861",
      target: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664"
    },
    {
      id: "85fb06c9-aaa4-4188-a5fa-afe29c917a07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de12af0e-eb14-45e2-9d7e-1d3ef063f4a2",
      target: "56d2e782-08b3-4159-bc1b-c4b6af629223"
    },
    {
      id: "81f3cae5-59e3-4828-9bf6-95d555840653",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de12af0e-eb14-45e2-9d7e-1d3ef063f4a2",
      target: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664"
    },
    {
      id: "42506bca-a8b1-4f2a-a559-b3d8f4e6e7d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8b0866b-c610-4290-9360-f129e2048d7b",
      target: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664"
    },
    {
      id: "a625f793-8c36-44a6-9eaa-5e0eb5ad4a95",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8b0866b-c610-4290-9360-f129e2048d7b",
      target: "3de266fe-517d-480a-97ed-db6e2d84b97d"
    },
    {
      id: "def245c7-ddfa-4d2d-80b1-6cdb1cddaa40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8b0866b-c610-4290-9360-f129e2048d7b",
      target: "e20126e8-8f6a-4ec8-9149-317f70a98a77"
    },
    {
      id: "36fcaa55-5317-4d88-9e62-ba36205c699e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8b0866b-c610-4290-9360-f129e2048d7b",
      target: "4293a7a1-e84d-4c1e-b66e-304e829292cf"
    },
    {
      id: "4e2768f8-fbe5-47c7-81c7-4e9b2798a364",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e20126e8-8f6a-4ec8-9149-317f70a98a77",
      target: "a6a85663-c215-407f-a1bd-f784e5af0796"
    },
    {
      id: "7e5867b3-57f9-4d13-a885-b47d4c52a261",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02a073d8-cbd9-4dd9-9bc5-4d3542e867d4",
      target: "651ab799-cc77-4309-a031-9040d3552726"
    },
    {
      id: "b98dee97-a000-45eb-bd94-6db949be6945",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d2eb201-1fe4-414c-8927-81b1ca95ba24",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "71da8f48-b0fd-4823-aecd-e43225e28af8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d2eb201-1fe4-414c-8927-81b1ca95ba24",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "eca77c44-8e0e-49b1-a63f-a35f486758bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d2eb201-1fe4-414c-8927-81b1ca95ba24",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "3d30bbc2-7004-4016-a88a-f86c92ef2a0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d2eb201-1fe4-414c-8927-81b1ca95ba24",
      target: "a6a85663-c215-407f-a1bd-f784e5af0796"
    },
    {
      id: "9bf0ae53-2ea6-4e67-873c-edadff091e1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29d8126e-d41e-44c0-ac74-b21977de94af",
      target: "ea689582-9d51-496e-b534-36c3c65ac960"
    },
    {
      id: "128881ca-a5c5-4996-91b1-bbc996ae1c03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29d8126e-d41e-44c0-ac74-b21977de94af",
      target: "6dee8a69-99ed-4008-89be-f46e1e2c9021"
    },
    {
      id: "1f578a4d-b3df-4fdf-b957-dac16cdce9fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29d8126e-d41e-44c0-ac74-b21977de94af",
      target: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea"
    },
    {
      id: "5e8cfe45-f603-463e-b00b-233380d6d712",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea689582-9d51-496e-b534-36c3c65ac960",
      target: "bbd610ef-d3e9-4a85-adcb-8f7a3b171d48"
    },
    {
      id: "f9a871d8-252a-4dd6-830a-bf3bba9dea47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea689582-9d51-496e-b534-36c3c65ac960",
      target: "0d2eb201-1fe4-414c-8927-81b1ca95ba24"
    },
    {
      id: "981caf6b-90af-42c1-bd50-018eaa6fd401",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbd610ef-d3e9-4a85-adcb-8f7a3b171d48",
      target: "b5042521-6d1c-4384-938b-98120cdd8b82"
    },
    {
      id: "ee5eff6f-4cbc-45f0-8616-08bb88d07324",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bbd610ef-d3e9-4a85-adcb-8f7a3b171d48",
      target: "d48fc8ee-18e6-4cee-8439-dc9f297b58cb"
    },
    {
      id: "85a1e9e1-110f-466b-ade2-20b7a5e177d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d48fc8ee-18e6-4cee-8439-dc9f297b58cb",
      target: "b5042521-6d1c-4384-938b-98120cdd8b82"
    },
    {
      id: "8e8b11c6-397e-47ec-b495-9e2401546a53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5042521-6d1c-4384-938b-98120cdd8b82",
      target: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664"
    },
    {
      id: "a3e1dcac-3bbe-4145-b24a-c7f56802ab06",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5042521-6d1c-4384-938b-98120cdd8b82",
      target: "1052d4ad-79dc-4cd7-8c87-3a06a04e0ddb"
    },
    {
      id: "7834ab68-56ba-4964-874a-b844676e47fa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b5042521-6d1c-4384-938b-98120cdd8b82",
      target: "48b18a85-7036-42d0-8dd2-fac74b55edc3"
    },
    {
      id: "f3070b04-a9a6-4400-9b7a-f8d2d8a100c6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5042521-6d1c-4384-938b-98120cdd8b82",
      target: "48b18a85-7036-42d0-8dd2-fac74b55edc3"
    },
    {
      id: "8087e6a9-93d5-4315-876b-24f1161cc23e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b5042521-6d1c-4384-938b-98120cdd8b82",
      target: "1052d4ad-79dc-4cd7-8c87-3a06a04e0ddb"
    },
    {
      id: "819c6d99-af56-442c-8dce-426eedb07be4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48b18a85-7036-42d0-8dd2-fac74b55edc3",
      target: "56d2e782-08b3-4159-bc1b-c4b6af629223"
    },
    {
      id: "1f316769-6a0c-4cbb-84e7-e75602167ffb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1052d4ad-79dc-4cd7-8c87-3a06a04e0ddb",
      target: "3de266fe-517d-480a-97ed-db6e2d84b97d"
    },
    {
      id: "8589a9df-22b7-4c71-8dbc-cb191b43ab7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ad9ca3b-ec70-4871-8ff7-ef6418e10664",
      target: "28756360-db55-43cc-b1d2-cb7f1ca84032"
    },
    {
      id: "13fcbdb3-037e-4faa-97e2-812394a3e84a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56d2e782-08b3-4159-bc1b-c4b6af629223",
      target: "b63ef7b2-6a31-41e7-926f-9c5afbe2f2c9"
    },
    {
      id: "330c10cc-21d0-4e4c-96bd-6890d0a0b771",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3de266fe-517d-480a-97ed-db6e2d84b97d",
      target: "cf35acea-f4a0-48b2-99a5-186d8c018df7"
    },
    {
      id: "735bd965-d5b8-4bce-ae57-9715a185f604",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28756360-db55-43cc-b1d2-cb7f1ca84032",
      target: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4"
    },
    {
      id: "530f825c-10bd-44a7-8a0e-d074f56c987c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b63ef7b2-6a31-41e7-926f-9c5afbe2f2c9",
      target: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4"
    },
    {
      id: "ad644131-bf61-42da-b3bc-c2a1312eb171",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b63ef7b2-6a31-41e7-926f-9c5afbe2f2c9",
      target: "38b570aa-f1c1-4b79-9e11-bc6119e5d614"
    },
    {
      id: "a62a9af8-d7c7-4667-a817-1c269ad3110f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf35acea-f4a0-48b2-99a5-186d8c018df7",
      target: "a6a85663-c215-407f-a1bd-f784e5af0796"
    },
    {
      id: "222104df-7965-411c-bdfe-ee4daf5632b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf35acea-f4a0-48b2-99a5-186d8c018df7",
      target: "60c3171d-7b99-4a6b-b887-89a23e4c714e"
    },
    {
      id: "52fa52bb-5af1-4751-99a3-92c96b94c9a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf35acea-f4a0-48b2-99a5-186d8c018df7",
      target: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4"
    },
    {
      id: "3869e258-c40a-4570-bc4f-0c1f4b9d0c11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6a85663-c215-407f-a1bd-f784e5af0796",
      target: "ac0da6ca-5aa4-444e-a1fa-017465c576c3"
    },
    {
      id: "f8d2ee65-249c-4adb-9e15-eca96d0bc8fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6dee8a69-99ed-4008-89be-f46e1e2c9021",
      target: "bbd610ef-d3e9-4a85-adcb-8f7a3b171d48"
    },
    {
      id: "70d26a4f-8a59-4ff9-9de6-3707c40352a3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea",
      target: "d30c3576-6b1d-48cb-b3c9-4ad5620191b8"
    },
    {
      id: "da7f59af-a6c5-43a6-8a46-3c13e13bd010",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea",
      target: "0134279a-2dc0-4bf4-b8a6-b8d457d7336d"
    },
    {
      id: "62ef3536-58e2-41fc-99c4-3f645e2ccfc9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a128c04-2211-4d1b-a2a2-2e1108ccdcea",
      target: "84b2c487-8d68-483b-b6f2-2a89b54fccb9"
    },
    {
      id: "f5822063-592c-4dfb-af65-d56d431f8eab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d30c3576-6b1d-48cb-b3c9-4ad5620191b8",
      target: "0fea50f6-4ecb-4fa7-ae88-36e076effadc"
    },
    {
      id: "6e840cd5-6231-4641-bbd0-3bc5004bab0b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0fea50f6-4ecb-4fa7-ae88-36e076effadc",
      target: "b4649b4d-c634-4e62-a712-26baaa6eefc3"
    },
    {
      id: "8d8e72e5-3725-449e-94a9-e7a800d2d7cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0fea50f6-4ecb-4fa7-ae88-36e076effadc",
      target: "152632b7-2595-4479-a2ec-7fc9fd18a382"
    },
    {
      id: "4f7e7c73-0a0e-442a-ae2e-101c3e37aabe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4649b4d-c634-4e62-a712-26baaa6eefc3",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "7ef8697f-6c8d-4119-bcc6-43c83ad06128",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4649b4d-c634-4e62-a712-26baaa6eefc3",
      target: "361414dd-f1b6-4928-8acb-b8fd11b0e41c"
    },
    {
      id: "49bd2744-f97e-495f-9462-05e27af1dd5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4649b4d-c634-4e62-a712-26baaa6eefc3",
      target: "152632b7-2595-4479-a2ec-7fc9fd18a382"
    },
    {
      id: "6d4d2d00-5d6e-4735-ac7b-966358209dfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "4a9bf09a-f345-4ef4-8f38-92b7d1937843"
    },
    {
      id: "5745c9e2-c483-4f29-aeb5-b80a2b3d2213",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "793cf237-fce7-47f2-b3ee-00cd5892d60b"
    },
    {
      id: "0408d1e7-a5c9-4a84-8454-7d45a7b24524",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "793cf237-fce7-47f2-b3ee-00cd5892d60b"
    },
    {
      id: "550f0e4e-fb4b-40ef-8664-16c71957afec",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "5ad6c77b-5a7c-48c5-b47c-25c950c95582"
    },
    {
      id: "a2440388-7481-4944-8417-82e37f505291",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "5ad6c77b-5a7c-48c5-b47c-25c950c95582"
    },
    {
      id: "aed8fe39-a827-4a87-909b-3418a0006e85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "152632b7-2595-4479-a2ec-7fc9fd18a382",
      target: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4"
    },
    {
      id: "e114d9ce-4e50-40f4-b6e6-f043d3780b53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "793cf237-fce7-47f2-b3ee-00cd5892d60b",
      target: "38b570aa-f1c1-4b79-9e11-bc6119e5d614"
    },
    {
      id: "1ac880c0-31bc-453b-8133-9dc80f176a4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ad6c77b-5a7c-48c5-b47c-25c950c95582",
      target: "60c3171d-7b99-4a6b-b887-89a23e4c714e"
    },
    {
      id: "c43b3743-6562-4ba4-9c77-83c462025fa5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4",
      target: "7f611119-4e97-4289-b4a0-954de58da84b"
    },
    {
      id: "5a619d70-d355-4aff-930c-4ea720df9c32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42dc22f8-e8e6-452d-8af3-d7bed829e3e4",
      target: "a2de943d-9ec6-4578-a401-3bd550906b78"
    },
    {
      id: "c8300aa3-e7b7-465f-8b11-996549c618b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38b570aa-f1c1-4b79-9e11-bc6119e5d614",
      target: "17b6b45a-e94d-474a-ab36-b22735d1b304"
    },
    {
      id: "354965ea-710c-4a98-8118-35e6164cb7e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60c3171d-7b99-4a6b-b887-89a23e4c714e",
      target: "f8c890e4-88e7-4026-a2d1-dc17de52c4c0"
    },
    {
      id: "d117e70b-424c-4165-bc09-66539f8eecc3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a2de943d-9ec6-4578-a401-3bd550906b78",
      target: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c"
    },
    {
      id: "c94cb8ad-6645-4afe-bc8d-56bace658d20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2de943d-9ec6-4578-a401-3bd550906b78",
      target: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c"
    },
    {
      id: "668e2779-05eb-4cbc-8545-3d1967776e9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17b6b45a-e94d-474a-ab36-b22735d1b304",
      target: "44c04805-901b-4212-95e8-8143f388131c"
    },
    {
      id: "67751695-44da-416c-862c-0dbac00e1cf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17b6b45a-e94d-474a-ab36-b22735d1b304",
      target: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c"
    },
    {
      id: "7276736a-e5eb-4ea1-88b6-9d0489902f57",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8c890e4-88e7-4026-a2d1-dc17de52c4c0",
      target: "ac0da6ca-5aa4-444e-a1fa-017465c576c3"
    },
    {
      id: "58610007-8a23-4335-8b50-77027c3c1968",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8c890e4-88e7-4026-a2d1-dc17de52c4c0",
      target: "456497f5-6864-43df-bbd4-d63d16d4d467"
    },
    {
      id: "c469c0f7-0040-465a-a431-e97b3627a29c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8c890e4-88e7-4026-a2d1-dc17de52c4c0",
      target: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c"
    },
    {
      id: "573afbf9-0dd2-4af9-85ba-cc2d7243097e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac0da6ca-5aa4-444e-a1fa-017465c576c3",
      target: "04d62129-263a-4ab0-9fc1-c2c428956bdb"
    },
    {
      id: "94823b8b-53c8-4f9b-be70-4457aaba5c5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0134279a-2dc0-4bf4-b8a6-b8d457d7336d",
      target: "0fea50f6-4ecb-4fa7-ae88-36e076effadc"
    },
    {
      id: "e5ba50e0-d549-4b43-a9e6-bda5018840a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84b2c487-8d68-483b-b6f2-2a89b54fccb9",
      target: "b2e53f57-6b31-4f4a-967e-b356ac799b79"
    },
    {
      id: "c97d8578-9a01-4b5e-ba36-d253bd39968d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84b2c487-8d68-483b-b6f2-2a89b54fccb9",
      target: "1c0ddb56-864a-4ae2-807a-27ceb9f2f576"
    },
    {
      id: "3c5673fe-598e-40eb-9efe-8ff280342519",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "84b2c487-8d68-483b-b6f2-2a89b54fccb9",
      target: "eac066a0-891a-4d9e-b0a4-469228a55362"
    },
    {
      id: "a9b9799f-8b5d-47a9-a32a-653e39715073",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b2e53f57-6b31-4f4a-967e-b356ac799b79",
      target: "c95bf24f-1875-4cae-ad03-3cdaaef52eae"
    },
    {
      id: "c8a7794f-09a6-4b23-a356-601151612b70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c95bf24f-1875-4cae-ad03-3cdaaef52eae",
      target: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f"
    },
    {
      id: "5e7d01d0-c585-4970-9f81-600727825fde",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c95bf24f-1875-4cae-ad03-3cdaaef52eae",
      target: "3747081e-04b5-4630-ad5f-3905662ade2b"
    },
    {
      id: "384cd34c-32c6-4b65-b119-dbdbf0585b73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3747081e-04b5-4630-ad5f-3905662ade2b",
      target: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f"
    },
    {
      id: "4272f1b8-3285-493a-9d03-0f2afe8bbe14",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      target: "630e51a9-595a-49bf-905c-cd4c1fd11f9b"
    },
    {
      id: "f29883c3-6cdc-423f-90f5-680a7e198b5a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      target: "5ec5385f-7785-4fbb-82c6-06e1066ff1ed"
    },
    {
      id: "6d456e6a-c03d-42de-bf15-9a912ccbe71f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      target: "630e51a9-595a-49bf-905c-cd4c1fd11f9b"
    },
    {
      id: "aeeaf356-f10c-463c-9e5c-7bf6d982f8a7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      target: "5ec5385f-7785-4fbb-82c6-06e1066ff1ed"
    },
    {
      id: "3f75a0bd-e845-41fc-9dba-39f6fcf7333c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c9ed6c8f-328d-4ede-aba0-ba403e0c836f",
      target: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c"
    },
    {
      id: "8051bca4-1577-489a-b87a-c16b16f0c0b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ec5385f-7785-4fbb-82c6-06e1066ff1ed",
      target: "44c04805-901b-4212-95e8-8143f388131c"
    },
    {
      id: "63ef27b4-ed9e-435b-9f33-760297c2fd2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "630e51a9-595a-49bf-905c-cd4c1fd11f9b",
      target: "456497f5-6864-43df-bbd4-d63d16d4d467"
    },
    {
      id: "876d69ea-4963-4f88-9d05-49224ba5b9f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7fc3fbc6-aa4a-493f-b2a5-34c064f76a9c",
      target: "57c60288-b67a-41a4-bf8a-826cec69bc3e"
    },
    {
      id: "01ecdd90-2ab6-48bf-8695-b991beacf295",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44c04805-901b-4212-95e8-8143f388131c",
      target: "0ed50256-e659-41ad-b5ff-2c9c088bc72c"
    },
    {
      id: "ca3fdddf-754f-43a6-a599-766d738339d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "456497f5-6864-43df-bbd4-d63d16d4d467",
      target: "e744e458-1dee-4f3d-8774-0fdd9191e294"
    },
    {
      id: "f0e0f4a7-3c1a-48c6-ace1-f55a283234cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57c60288-b67a-41a4-bf8a-826cec69bc3e",
      target: "d0e819bb-a11b-40eb-b54d-89d6687be513"
    },
    {
      id: "ca660f21-1800-4424-a176-8601cd1d1f02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ed50256-e659-41ad-b5ff-2c9c088bc72c",
      target: "22e2ef48-896b-472d-9ffb-c764f79206fd"
    },
    {
      id: "a7eaedf3-ebe4-4cb9-bb43-966beddd31e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ed50256-e659-41ad-b5ff-2c9c088bc72c",
      target: "d0e819bb-a11b-40eb-b54d-89d6687be513"
    },
    {
      id: "8359a142-54d6-4549-a0e8-02376c6a75da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e744e458-1dee-4f3d-8774-0fdd9191e294",
      target: "d0e819bb-a11b-40eb-b54d-89d6687be513"
    },
    {
      id: "04a2deb9-862d-41dc-ae96-2f3f4bd83b19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e744e458-1dee-4f3d-8774-0fdd9191e294",
      target: "b342a75c-3a4f-4f75-8bdd-acfd08a4e619"
    },
    {
      id: "31248732-796a-4b59-81d0-0462e7ccff49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e744e458-1dee-4f3d-8774-0fdd9191e294",
      target: "04d62129-263a-4ab0-9fc1-c2c428956bdb"
    },
    {
      id: "2074396a-27c1-45e0-b8a7-5213fa482cf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04d62129-263a-4ab0-9fc1-c2c428956bdb",
      target: "795a626b-0afc-4b18-9356-9a8fdb3cecf1"
    },
    {
      id: "7bcbb2b4-9397-4553-8ba6-b16b82bfd773",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c0ddb56-864a-4ae2-807a-27ceb9f2f576",
      target: "c95bf24f-1875-4cae-ad03-3cdaaef52eae"
    },
    {
      id: "e1f630a6-659e-4dc8-a073-855b54d9059e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f576b5f-da2a-46d4-a303-305280bc06fa",
      target: "795a626b-0afc-4b18-9356-9a8fdb3cecf1"
    },
    {
      id: "f0c5baaa-b77e-437f-aeff-eb409391a815",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f576b5f-da2a-46d4-a303-305280bc06fa",
      target: "dcfca05d-8864-4acd-934e-c4730a3c620b"
    },
    {
      id: "7c4843ea-b8fd-460f-8a52-ca71e26da304",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f576b5f-da2a-46d4-a303-305280bc06fa",
      target: "2e1193a4-d7f7-43f7-a02d-70ac9bfd0c84"
    },
    {
      id: "7945927c-9bcc-43c0-8b05-0b074faa3b7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f576b5f-da2a-46d4-a303-305280bc06fa",
      target: "ac899d05-1cea-4c66-ac62-acae0311db54"
    },
    {
      id: "69a695c4-fe64-4bad-aeaf-7b551fd75cf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eac066a0-891a-4d9e-b0a4-469228a55362",
      target: "209e315a-9bed-43eb-8125-f463ac7a17bd"
    },
    {
      id: "e8679bdc-b918-4e36-8d26-cc71e0fe2e13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eac066a0-891a-4d9e-b0a4-469228a55362",
      target: "cb74270e-a844-4a32-9461-b15618793e69"
    },
    {
      id: "9c894377-656b-485f-83de-95db350e23e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eac066a0-891a-4d9e-b0a4-469228a55362",
      target: "62282871-afe9-4a4d-995a-7a4479435a38"
    },
    {
      id: "f9f1ed4c-f342-487b-916e-4f2c5861ec94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "209e315a-9bed-43eb-8125-f463ac7a17bd",
      target: "6f576b5f-da2a-46d4-a303-305280bc06fa"
    },
    {
      id: "33233c5d-0e73-4e93-a8e8-f0c7c390f19c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "209e315a-9bed-43eb-8125-f463ac7a17bd",
      target: "e5b1d906-589c-41b8-bf27-953076bed5eb"
    },
    {
      id: "3042d923-3155-4267-9221-d5f440214157",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5b1d906-589c-41b8-bf27-953076bed5eb",
      target: "b9cf049c-c742-4b08-a60f-36fba6040dee"
    },
    {
      id: "3bad5540-89e3-481f-aade-7329396aa63f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5b1d906-589c-41b8-bf27-953076bed5eb",
      target: "42a0929b-62e9-4588-849e-1a190a3d5d20"
    },
    {
      id: "f6d56b81-6f2b-49be-b47c-591b8d67b688",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42a0929b-62e9-4588-849e-1a190a3d5d20",
      target: "b9cf049c-c742-4b08-a60f-36fba6040dee"
    },
    {
      id: "32ea84be-52ea-43f5-a9e2-e938af4c3f90",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      target: "47d90987-1e11-4908-8485-1e5889c0d266"
    },
    {
      id: "0a00971f-59f0-4997-80ac-90b76f2e3b7f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      target: "50134eff-4018-4fb8-99f6-4ad4c56060be"
    },
    {
      id: "cc156a2b-ac78-4d57-84ec-01d81763f8b9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      target: "50134eff-4018-4fb8-99f6-4ad4c56060be"
    },
    {
      id: "826119e7-0652-432f-b6ee-deb9c2e1095b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      target: "47d90987-1e11-4908-8485-1e5889c0d266"
    },
    {
      id: "91e2b97d-7af2-45cd-afc9-b77f558bcd60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9cf049c-c742-4b08-a60f-36fba6040dee",
      target: "d0e819bb-a11b-40eb-b54d-89d6687be513"
    },
    {
      id: "78f76fdb-2324-479c-a3bd-bbb307453c14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47d90987-1e11-4908-8485-1e5889c0d266",
      target: "22e2ef48-896b-472d-9ffb-c764f79206fd"
    },
    {
      id: "580bccad-c437-465a-9079-ceb37e91da54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50134eff-4018-4fb8-99f6-4ad4c56060be",
      target: "b342a75c-3a4f-4f75-8bdd-acfd08a4e619"
    },
    {
      id: "40b918fc-381b-4f32-85e0-2c8418c455da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0e819bb-a11b-40eb-b54d-89d6687be513",
      target: "7bc2f2ad-bfa2-4706-9f4b-e8289791a672"
    },
    {
      id: "6b410680-d7bd-4b09-ac51-6e1d718d842c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22e2ef48-896b-472d-9ffb-c764f79206fd",
      target: "7d49411b-461e-4953-a7b5-2016d23aba05"
    },
    {
      id: "347e31d2-723e-43f8-96f0-b5c18f54add1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b342a75c-3a4f-4f75-8bdd-acfd08a4e619",
      target: "fb67c078-673b-4328-9cd4-a78a08085d8c"
    },
    {
      id: "8836ab80-0adb-44af-8996-82a465d33d9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7bc2f2ad-bfa2-4706-9f4b-e8289791a672",
      target: "6e960331-d195-47e6-8456-62d515dbad0e"
    },
    {
      id: "2dc3b32e-d7c8-4309-b448-428e9f12925c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d49411b-461e-4953-a7b5-2016d23aba05",
      target: "6e960331-d195-47e6-8456-62d515dbad0e"
    },
    {
      id: "46a49396-67b2-425c-b972-96f47c8ccf94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb67c078-673b-4328-9cd4-a78a08085d8c",
      target: "795a626b-0afc-4b18-9356-9a8fdb3cecf1"
    },
    {
      id: "9839380e-a30c-45af-9275-384349fd483f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb67c078-673b-4328-9cd4-a78a08085d8c",
      target: "6e960331-d195-47e6-8456-62d515dbad0e"
    },
    {
      id: "e829c5b9-abea-41b0-9ce1-0e72c732317d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "795a626b-0afc-4b18-9356-9a8fdb3cecf1",
      target: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9"
    },
    {
      id: "835f389e-7372-4f14-b748-16d9a127f9fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb74270e-a844-4a32-9461-b15618793e69",
      target: "e5b1d906-589c-41b8-bf27-953076bed5eb"
    },
    {
      id: "244405ce-2511-45a6-8d8d-cb809c6a4a2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62282871-afe9-4a4d-995a-7a4479435a38",
      target: "7f8b9512-6f23-4e42-a8af-e234219c044a"
    },
    {
      id: "2b821725-0548-4c7e-8242-4bcafb0a10c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62282871-afe9-4a4d-995a-7a4479435a38",
      target: "fb530ced-bdce-4605-99a0-4f3b546e3840"
    },
    {
      id: "16495187-41f1-4062-b9c9-11b4933d92a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62282871-afe9-4a4d-995a-7a4479435a38",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "f590844d-0cf5-4e5a-b5fb-5c895f6fbfe6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f8b9512-6f23-4e42-a8af-e234219c044a",
      target: "3cd8ec1f-1e3e-4087-b12a-e5518bb90884"
    },
    {
      id: "a27feb8e-2bc5-49fb-acf0-0a33c9c3ee8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cd8ec1f-1e3e-4087-b12a-e5518bb90884",
      target: "580b5614-d6b8-46b4-8e37-75111e6f449c"
    },
    {
      id: "e9f0c357-7645-4428-86b7-3e803f1bb2ef",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3cd8ec1f-1e3e-4087-b12a-e5518bb90884",
      target: "71320fed-794a-4dc5-a1a9-c09d8ed3b149"
    },
    {
      id: "e3a712b4-d98b-4f7d-9e44-3559e6175a73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71320fed-794a-4dc5-a1a9-c09d8ed3b149",
      target: "dcfca05d-8864-4acd-934e-c4730a3c620b"
    },
    {
      id: "4a134853-e87b-4d60-88cb-e07fe4a2bd57",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71320fed-794a-4dc5-a1a9-c09d8ed3b149",
      target: "6244fe39-242c-4213-9ac1-2bc00708c95b"
    },
    {
      id: "858d39f9-43e0-4e75-b9f0-4478c0797c61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71320fed-794a-4dc5-a1a9-c09d8ed3b149",
      target: "c0dc662c-8200-4f0e-90a0-2d410ebc3806"
    },
    {
      id: "fc724feb-e400-4d5d-8b37-755869e65628",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71320fed-794a-4dc5-a1a9-c09d8ed3b149",
      target: "580b5614-d6b8-46b4-8e37-75111e6f449c"
    },
    {
      id: "975a25f4-9b00-4279-8df7-8de4f3fd3dc1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "6e960331-d195-47e6-8456-62d515dbad0e"
    },
    {
      id: "6cf4ebf5-b1cf-49e7-9f20-7f44be690407",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "192ac6d3-7f7c-4716-b8f9-b58bd3a44b17"
    },
    {
      id: "beaeff5c-582f-4ea4-8a98-27755df9c652",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "0232fc47-754a-4ece-856c-465c3f0da2b7"
    },
    {
      id: "263736b4-1400-4baa-98c1-ff3ddf3db115",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "0232fc47-754a-4ece-856c-465c3f0da2b7"
    },
    {
      id: "6d34368a-08d2-42db-92db-c3dabcdea03a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "a3778628-c454-42d0-b0d6-a496585837ec"
    },
    {
      id: "1a62081b-c0eb-480f-9018-923b90a4d5ce",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "580b5614-d6b8-46b4-8e37-75111e6f449c",
      target: "a3778628-c454-42d0-b0d6-a496585837ec"
    },
    {
      id: "997d73a9-c50a-4b25-87e0-c76940df2b90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0232fc47-754a-4ece-856c-465c3f0da2b7",
      target: "56cf27dc-0790-45ef-9408-4bd9d3a7dfe7"
    },
    {
      id: "462ab733-8488-463e-8f44-0656f7114203",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3778628-c454-42d0-b0d6-a496585837ec",
      target: "d168862b-bafd-49cd-9ca9-0f88bf9ae139"
    },
    {
      id: "214f4ab8-d0de-4742-bdaf-195e76e4dacf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e960331-d195-47e6-8456-62d515dbad0e",
      target: "19ed5841-5a0f-468b-ad94-546da0261ac0"
    },
    {
      id: "51839884-3bf6-468b-b874-9faafee44c81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56cf27dc-0790-45ef-9408-4bd9d3a7dfe7",
      target: "7b264714-6639-42fb-acf6-d10033c7e16b"
    },
    {
      id: "878c3a44-c74b-4103-91e3-b6df50d49f1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d168862b-bafd-49cd-9ca9-0f88bf9ae139",
      target: "3ce5428a-e0ce-4ed4-b70f-a9dd03aacf17"
    },
    {
      id: "af8ee187-bf60-4be6-ab74-02fa232cc5f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19ed5841-5a0f-468b-ad94-546da0261ac0",
      target: "442bfdfa-b2cf-4f68-a9b7-4ea41c6296a6"
    },
    {
      id: "f7315573-971b-47e5-98b2-b99bed5c6662",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b264714-6639-42fb-acf6-d10033c7e16b",
      target: "442bfdfa-b2cf-4f68-a9b7-4ea41c6296a6"
    },
    {
      id: "ab7a009f-75ec-4ce7-ade1-3786039259df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ce5428a-e0ce-4ed4-b70f-a9dd03aacf17",
      target: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9"
    },
    {
      id: "bda084d0-7319-4d89-aee2-66d648f46444",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ce5428a-e0ce-4ed4-b70f-a9dd03aacf17",
      target: "442bfdfa-b2cf-4f68-a9b7-4ea41c6296a6"
    },
    {
      id: "d77209ef-645a-4c28-80a8-1dc785b96691",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9",
      target: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d"
    },
    {
      id: "62696ba3-82d1-4d5d-b1bc-fa488f51de0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "f89bba4b-9d2a-4029-a419-d3116ef7e011",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c977ebf-9bf6-48ab-a788-56d1adce4dc9",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "aca071ca-b4a9-4d93-b4da-282054412fd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb530ced-bdce-4605-99a0-4f3b546e3840",
      target: "3cd8ec1f-1e3e-4087-b12a-e5518bb90884"
    },
    {
      id: "78d11d35-26e3-40ed-be38-31b6ecf39915",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "581a598c-7287-4fb8-9097-9ac1998a928c",
      target: "4a9bf09a-f345-4ef4-8f38-92b7d1937843"
    },
    {
      id: "a52c7489-2df3-4a1e-958f-867a376b759f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "581a598c-7287-4fb8-9097-9ac1998a928c",
      target: "580b5614-d6b8-46b4-8e37-75111e6f449c"
    },
    {
      id: "58485fee-c5a1-4582-a2f7-c6d02ee4c344",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a73b3451-0cb3-4ccb-b96e-18f360181fcd",
      target: "71320fed-794a-4dc5-a1a9-c09d8ed3b149"
    },
    {
      id: "0263a299-2968-4fa4-8fcf-3f5c209d7992",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f611119-4e97-4289-b4a0-954de58da84b",
      target: "d53ed77b-c3ef-4dbd-b6f6-d629c431ab2a"
    },
    {
      id: "4990ef14-aa1a-4c53-83fc-3935109b18c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a9bf09a-f345-4ef4-8f38-92b7d1937843",
      target: "6a7ee994-a33a-4fb6-b4c5-d2cadd8990b7"
    },
    {
      id: "36809e0d-13ca-4713-8c3f-366f1752648b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a9bf09a-f345-4ef4-8f38-92b7d1937843",
      target: "192ac6d3-7f7c-4716-b8f9-b58bd3a44b17"
    },
    {
      id: "70094e47-0bd5-42cb-8124-e0660ad297d6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4a9bf09a-f345-4ef4-8f38-92b7d1937843",
      target: "613b7208-4628-4f41-be4d-244470010d71"
    },
    {
      id: "2944e089-99e9-4794-b40b-d76eb0b55047",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d53ed77b-c3ef-4dbd-b6f6-d629c431ab2a",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "4a20f803-fcd5-4bbb-b420-cb867406c42e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "613b7208-4628-4f41-be4d-244470010d71",
      target: "29507403-1346-424f-881f-30f2eefcfb73"
    },
    {
      id: "02f49e01-324f-483a-b018-38d24f67d1cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "613b7208-4628-4f41-be4d-244470010d71",
      target: "3cbcb558-9d4b-4cf1-959c-1687b2622933"
    },
    {
      id: "49500db9-df4d-4db8-b885-0ecbf10c006d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "78e8f5d9-3d4e-4448-be74-cd3e36269d75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3"
    },
    {
      id: "c5131c65-5ea7-42d9-90b0-4a98469dc40e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "4e06db18-1ae2-432a-9644-e8afdc75485e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "29507403-1346-424f-881f-30f2eefcfb73"
    },
    {
      id: "aca74b40-7754-4a09-8797-1d24211840df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3"
    },
    {
      id: "b4837937-9814-4aa8-9421-4172a98dd5e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cbcb558-9d4b-4cf1-959c-1687b2622933",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "e048ed1b-30b4-480b-b923-862bef8ba702",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "192ac6d3-7f7c-4716-b8f9-b58bd3a44b17",
      target: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d"
    },
    {
      id: "094ee30b-cdbf-475c-a014-249e7c2a7180",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "192ac6d3-7f7c-4716-b8f9-b58bd3a44b17",
      target: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d"
    },
    {
      id: "81cf84a7-f3b0-42bf-af21-dac97dc9aa9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "442bfdfa-b2cf-4f68-a9b7-4ea41c6296a6",
      target: "83316e03-c554-4a9a-a25d-b00017f31279"
    },
    {
      id: "f2173433-2a9a-4243-9999-0fc6436243f3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "83316e03-c554-4a9a-a25d-b00017f31279",
      target: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d"
    },
    {
      id: "53c5c988-5037-4895-a72a-ab99eb083f32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83316e03-c554-4a9a-a25d-b00017f31279",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "087fbded-2a3b-4b11-a092-2e2272f00ff3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83316e03-c554-4a9a-a25d-b00017f31279",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "739e2eca-1264-4089-98c0-bf62f45676ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "d6141c37-de61-4e48-bd0f-48fc17c40c10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d",
      target: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3"
    },
    {
      id: "8993cd43-b9a3-4f35-9a45-c741a14c6fa7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "e771b006-3748-4520-bb49-338c11032caa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf6ec044-e3ef-47e5-bf8f-b5b2b8fc573d",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "346a1748-8036-4ce2-ad54-865d84a97a29",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "00ef6860-f91b-40fb-b664-4fe169ed8a61",
      target: "21588d6c-2910-4504-b789-b6ea7fc3a800"
    },
    {
      id: "72907f83-752e-4bc2-9238-54727f207a8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00ef6860-f91b-40fb-b664-4fe169ed8a61",
      target: "21588d6c-2910-4504-b789-b6ea7fc3a800"
    },
    {
      id: "925c13d4-0142-4c1a-8003-25a997b32d2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c8d7f44-9755-44dd-ba6f-f721914766e3",
      target: "21588d6c-2910-4504-b789-b6ea7fc3a800"
    },
    {
      id: "40005907-18ac-4268-9a4a-c5ef2bba7f52",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2c8d7f44-9755-44dd-ba6f-f721914766e3",
      target: "00ef6860-f91b-40fb-b664-4fe169ed8a61"
    },
    {
      id: "89f32102-968f-4abf-9674-18ba8b43d0c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "121f217b-0422-4d1e-931f-a0aba3b16769",
      target: "21588d6c-2910-4504-b789-b6ea7fc3a800"
    },
    {
      id: "d8e8cf40-ae5d-4996-9cfc-3f1c91593392",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "121f217b-0422-4d1e-931f-a0aba3b16769",
      target: "2c8d7f44-9755-44dd-ba6f-f721914766e3"
    },
    {
      id: "565ea5cc-7f5c-408a-8a67-40f89939959c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "07feb5ed-73dc-4cda-9a3c-332e80ec5e3f",
      target: "121f217b-0422-4d1e-931f-a0aba3b16769"
    },
    {
      id: "632aa36c-6c09-476d-b729-5b11077fb24e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "07feb5ed-73dc-4cda-9a3c-332e80ec5e3f",
      target: "21588d6c-2910-4504-b789-b6ea7fc3a800"
    },
    {
      id: "e224dc0c-dee7-4ea8-a777-d1a1700551ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "ac49455c-7179-4c7d-95ba-045d3be2c497"
    },
    {
      id: "af6d4953-424c-4929-a0b5-39bdc92eca0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "8ccfacba-ab24-49cf-8b6a-8eabb3a22dd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "a530a7df-8470-4ebe-9bce-c0482f5a1f32"
    },
    {
      id: "10e64186-50fc-4fb1-8b7c-1b5500177444",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce"
    },
    {
      id: "01dc1f09-686b-40e0-ab70-bae1f5c01238",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "7d4adfc5-bd88-454b-a4ce-cb80a6a12d91"
    },
    {
      id: "087c78eb-497d-4d1d-b72f-786e5738f1bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "01cbdcd8-d861-4695-b8f2-1b32af653079",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21588d6c-2910-4504-b789-b6ea7fc3a800",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "013833cd-fa67-48d4-9b8e-54a22f38d04e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7d4adfc5-bd88-454b-a4ce-cb80a6a12d91",
      target: "1f419ff1-e532-4006-a0e9-07d0aad30a72"
    },
    {
      id: "4bb8c77b-d379-4c53-93b2-3336c56eaa29",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "e1993bc2-04a0-4898-b288-71b058cd68ac"
    },
    {
      id: "902daa60-0099-4283-94af-5ea72381f444",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "310a05d1-1d8b-4d1e-883c-fe00c8e228ce"
    },
    {
      id: "f529cc4c-c203-4440-af26-2dd8ea6dbb91",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "310a05d1-1d8b-4d1e-883c-fe00c8e228ce"
    },
    {
      id: "8ffa5c7a-ca09-4ce3-8032-a70ea452527a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "fbbb176d-f550-48ec-9980-38b65c1ebf17"
    },
    {
      id: "f07adfa0-32db-438a-b327-5c5947ab91c3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "2b321b6a-3033-4d36-818d-1894068ccc36"
    },
    {
      id: "dbfd15bd-bca2-4902-8327-bdd91a249370",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "46fb7ed9-6b6c-47e8-8642-11e8de70efa5",
      target: "ecef52da-83fc-44d1-ba1f-56501ee5e577"
    },
    {
      id: "8a1ebdb4-4173-443d-97b2-fb5fb2735862",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310a05d1-1d8b-4d1e-883c-fe00c8e228ce",
      target: "e08f5205-30bf-473e-a063-adec8e0acd9a"
    },
    {
      id: "a509453d-fb6b-4ec8-a750-39d0f658917a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbbb176d-f550-48ec-9980-38b65c1ebf17",
      target: "2d75a1d9-401e-411c-9627-acf88f9e4735"
    },
    {
      id: "acdd68f0-5b85-44df-8e2c-212df9d2fdba",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fbbb176d-f550-48ec-9980-38b65c1ebf17",
      target: "e08f5205-30bf-473e-a063-adec8e0acd9a"
    },
    {
      id: "e208ceb5-1ff0-4d1a-9fab-a31aefd1ce08",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e08f5205-30bf-473e-a063-adec8e0acd9a",
      target: "3b9ab8ce-ac79-49e1-9b68-a00b573d4ce9"
    },
    {
      id: "433cfb1b-4ac5-4d30-a1a8-d449ade2d6ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e08f5205-30bf-473e-a063-adec8e0acd9a",
      target: "e1005323-b570-4e7b-9372-bd513d48298d"
    },
    {
      id: "f04c1aed-8681-4e27-b2ed-fc783d4181b3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3b9ab8ce-ac79-49e1-9b68-a00b573d4ce9",
      target: "b8a5144b-9969-420f-9d75-238d9fa89e22"
    },
    {
      id: "3d6302f2-4365-4b22-b794-0e1886f915f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b9ab8ce-ac79-49e1-9b68-a00b573d4ce9",
      target: "d143a46d-fb23-4aab-9a9d-ab5437094a76"
    },
    {
      id: "2123d18a-6d42-4496-b229-dfa228a4ba96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8a5144b-9969-420f-9d75-238d9fa89e22",
      target: "6fbf2eb3-8f19-4627-89a7-aec878173fff"
    },
    {
      id: "97ad1d40-160c-49b5-973a-b4da0e70119f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f3285826-75e2-4eee-a5de-2d5fcafb0dda",
      target: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a"
    },
    {
      id: "f1b2e30b-02c4-4f8e-88b4-fb40bd0891a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "e2265c6c-2019-4f34-9100-eeadcfcb56b1"
    },
    {
      id: "b10e0963-f6ae-46cb-b137-703f77e5ff2d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "2d75a1d9-401e-411c-9627-acf88f9e4735"
    },
    {
      id: "2be2c5c7-7085-4774-b62c-6ed5cc0e9cbb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "f3285826-75e2-4eee-a5de-2d5fcafb0dda"
    },
    {
      id: "893b703d-3a77-4dda-ba35-5b4b921a4aa2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "9a0af33b-f2fb-4888-9d90-267300162d89"
    },
    {
      id: "be9c0181-2cee-405f-93d2-1707ff201bd6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "b99e24ae-e3de-4d45-9094-bb837f13fb4b"
    },
    {
      id: "f9ba6956-54e5-4cb4-8b24-f1a1e9824858",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "ad67dbc7-f76d-40bd-b506-435bcbce4b21"
    },
    {
      id: "66eaa281-7dce-4da8-8137-ac1a87039182",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e1993bc2-04a0-4898-b288-71b058cd68ac",
      target: "b99e24ae-e3de-4d45-9094-bb837f13fb4b"
    },
    {
      id: "e2f79f46-2786-4ca1-9210-e7864736f8a0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b99e24ae-e3de-4d45-9094-bb837f13fb4b",
      target: "663029a7-4ced-4347-bfaa-aec34f42efb3"
    },
    {
      id: "9aa242e2-93b4-4873-b18f-3f40d63a4939",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b99e24ae-e3de-4d45-9094-bb837f13fb4b",
      target: "ad67dbc7-f76d-40bd-b506-435bcbce4b21"
    },
    {
      id: "f4c7933c-3e9c-4e10-9581-cafff8c05d74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a0af33b-f2fb-4888-9d90-267300162d89",
      target: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a"
    },
    {
      id: "8333baf5-05e4-4aa6-9643-d889e5985952",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ad67dbc7-f76d-40bd-b506-435bcbce4b21",
      target: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a"
    },
    {
      id: "58fa8321-584e-4654-993a-cb917024ff66",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e2265c6c-2019-4f34-9100-eeadcfcb56b1",
      target: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a"
    },
    {
      id: "98907d64-fa61-4a1a-9276-0a8b32f12296",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d78e3b8-9590-4a9c-ba66-69172899af35",
      target: "1d68be14-3b60-47a5-aa53-0d47031be75c"
    },
    {
      id: "e2d0ccae-1662-45f1-a50d-19d95f33c508",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc20f290-9a5a-42e2-8714-d79834e4e626",
      target: "1d68be14-3b60-47a5-aa53-0d47031be75c"
    },
    {
      id: "5f8f6cba-c1bb-441e-8d44-35aaedf97b4e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a",
      target: "8d78e3b8-9590-4a9c-ba66-69172899af35"
    },
    {
      id: "710c05e6-cba4-4f2d-aae4-75f5d04af805",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a",
      target: "bc20f290-9a5a-42e2-8714-d79834e4e626"
    },
    {
      id: "69ded4e9-a5a5-44b5-8c8f-77c137519336",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a",
      target: "8d78e3b8-9590-4a9c-ba66-69172899af35"
    },
    {
      id: "831ec09b-84a0-423e-848b-1fa36c8720c8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "87384b17-7fc8-4ddb-bf0f-d3c8b813c08a",
      target: "bc20f290-9a5a-42e2-8714-d79834e4e626"
    },
    {
      id: "550879a1-cd78-495c-953c-8a28a7d61b57",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d68be14-3b60-47a5-aa53-0d47031be75c",
      target: "51370ae4-75d9-4cef-9ae2-da90bb8354b8"
    },
    {
      id: "a054e7c0-230b-40e3-ad82-9a0096a8dcc8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "94ad6811-c767-4392-a448-36a57456902a",
      target: "9b2e135e-9a83-4879-bc85-bba2e2876bcc"
    },
    {
      id: "47b727e1-66e5-4b52-9efb-e0ba23f2a3dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "e4b8cd12-941c-4b48-8c09-0bbc18e187ef"
    },
    {
      id: "804db5f9-6b5e-426d-bb11-df6c67960229",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "94ad6811-c767-4392-a448-36a57456902a"
    },
    {
      id: "08d6ae3d-6e68-446f-ac85-9a634d81c2a6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "ee0ce781-26bc-41c7-9651-662383cbc198"
    },
    {
      id: "e16c7d06-87b5-4476-8f2f-aa35df1fc9ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "c346d21a-2d3f-4186-814e-b1d3fa714fec"
    },
    {
      id: "c1ce7b52-92db-4bde-a28c-c5474734a1a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "d143a46d-fb23-4aab-9a9d-ab5437094a76"
    },
    {
      id: "9b277aea-99c1-4f21-a799-b72e4d1ab021",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "e1005323-b570-4e7b-9372-bd513d48298d"
    },
    {
      id: "7d1e8789-a7b2-4491-bcc9-68918134dbc2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d75a1d9-401e-411c-9627-acf88f9e4735",
      target: "663029a7-4ced-4347-bfaa-aec34f42efb3"
    },
    {
      id: "5d955d29-540c-4133-9b71-e5ea43f74ab9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "663029a7-4ced-4347-bfaa-aec34f42efb3",
      target: "03896984-e578-4d81-8e6f-b4daa727a03e"
    },
    {
      id: "d07438a4-f370-4ff7-86dd-690bccf3f084",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663029a7-4ced-4347-bfaa-aec34f42efb3",
      target: "e4b8cd12-941c-4b48-8c09-0bbc18e187ef"
    },
    {
      id: "ee5386c7-8d99-4186-80fe-05a178effbe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ee0ce781-26bc-41c7-9651-662383cbc198",
      target: "9b2e135e-9a83-4879-bc85-bba2e2876bcc"
    },
    {
      id: "0139909d-a814-45ef-97f6-a3c5b06f3866",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e4b8cd12-941c-4b48-8c09-0bbc18e187ef",
      target: "9b2e135e-9a83-4879-bc85-bba2e2876bcc"
    },
    {
      id: "66b62817-c38f-4cea-b119-8aa739eb2222",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c346d21a-2d3f-4186-814e-b1d3fa714fec",
      target: "9b2e135e-9a83-4879-bc85-bba2e2876bcc"
    },
    {
      id: "321cbf2e-2997-4fb1-b341-25eee638029d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "91dbf219-bc2a-4889-b5ad-11122a59714c"
    },
    {
      id: "e2df162e-e15c-49f1-9415-e32be39c0e25",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "78e6e2d9-fc47-4f0a-a2ae-976706f06f5c"
    },
    {
      id: "35d01d9d-c7ab-4e76-b12a-e357b0d52429",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "91dbf219-bc2a-4889-b5ad-11122a59714c"
    },
    {
      id: "84eae9dc-a9bb-4c55-8202-af0e638c45f5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "78e6e2d9-fc47-4f0a-a2ae-976706f06f5c"
    },
    {
      id: "ff1916b2-ffe8-45b8-9738-e4154e13736b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "91dbf219-bc2a-4889-b5ad-11122a59714c"
    },
    {
      id: "3fbea127-22c2-4bf3-b7ca-537aca82d13d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b2e135e-9a83-4879-bc85-bba2e2876bcc",
      target: "78e6e2d9-fc47-4f0a-a2ae-976706f06f5c"
    },
    {
      id: "b9b20691-9dff-42e6-b322-1c55a42fdc27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78e6e2d9-fc47-4f0a-a2ae-976706f06f5c",
      target: "9c39ad29-e2af-45a6-9371-8e5d24021b54"
    },
    {
      id: "e99eb43c-6afa-4b56-936b-979c62975285",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91dbf219-bc2a-4889-b5ad-11122a59714c",
      target: "9c39ad29-e2af-45a6-9371-8e5d24021b54"
    },
    {
      id: "72bfe7be-7637-476c-8d55-54c0713ecf54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c39ad29-e2af-45a6-9371-8e5d24021b54",
      target: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e"
    },
    {
      id: "505537ea-11f5-4606-a681-3299834e0cc1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6a65cf2b-b775-4416-8901-d28117f830c2",
      target: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632"
    },
    {
      id: "6bd688c1-c631-4961-becb-fc5e117186df",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "19fc44d1-990d-4df1-9b0f-fec1d2c5ae56"
    },
    {
      id: "d0350be7-6a9a-47f0-8870-6896b3553ed6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "19fc44d1-990d-4df1-9b0f-fec1d2c5ae56"
    },
    {
      id: "3e32bfee-99a0-4342-85cc-6c307dc24ab9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "6a65cf2b-b775-4416-8901-d28117f830c2"
    },
    {
      id: "236dc097-8ad1-4d6a-8c66-1ea8e2e31769",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "03896984-e578-4d81-8e6f-b4daa727a03e"
    },
    {
      id: "2ddb9f98-f6f0-476d-81f2-7f1cb302b68a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "6fbf2eb3-8f19-4627-89a7-aec878173fff"
    },
    {
      id: "ed9d41ca-84f4-4415-a8a1-2c8f103f8aa8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "d143a46d-fb23-4aab-9a9d-ab5437094a76"
    },
    {
      id: "0b91b4bc-7236-42bd-a609-18b5d9410de7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "4e8b7a7d-ec08-4858-95c9-a9ee08df8e6b"
    },
    {
      id: "0da79d0b-5a52-4103-9f6c-77b0f58cfd07",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e1005323-b570-4e7b-9372-bd513d48298d",
      target: "bf199754-1a16-4003-bd8b-7e4dbdbe1f7a"
    },
    {
      id: "84cbef31-eb0a-464e-8526-6f8555e2e2e4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "03896984-e578-4d81-8e6f-b4daa727a03e",
      target: "82087812-361d-45ba-b343-21f3c945ca1d"
    },
    {
      id: "bfce0638-cdfe-45d0-9bb0-1c48be702c1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03896984-e578-4d81-8e6f-b4daa727a03e",
      target: "4e8b7a7d-ec08-4858-95c9-a9ee08df8e6b"
    },
    {
      id: "59611716-2d12-46d3-85c3-67e111e34039",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf199754-1a16-4003-bd8b-7e4dbdbe1f7a",
      target: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632"
    },
    {
      id: "5af8d060-82a3-4905-9bfe-dd0464aea266",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4e8b7a7d-ec08-4858-95c9-a9ee08df8e6b",
      target: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632"
    },
    {
      id: "4d4f2401-ca59-484e-98f2-3b9abff5c2ae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "19fc44d1-990d-4df1-9b0f-fec1d2c5ae56",
      target: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632"
    },
    {
      id: "47cd6b99-73bb-4c72-b5d0-f1fc83e026a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "390a2070-20e5-4004-b193-4ac20d205c01",
      target: "f26e75a4-1291-458f-9ded-95a48f58db64"
    },
    {
      id: "4b19d524-4a8b-4d83-b931-817f5020c62c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef413f2e-fe35-40d1-962f-a64afdf70526",
      target: "f26e75a4-1291-458f-9ded-95a48f58db64"
    },
    {
      id: "8b4447be-f9d6-48cf-857f-5b0c885b2a9b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632",
      target: "390a2070-20e5-4004-b193-4ac20d205c01"
    },
    {
      id: "d0f063cd-c4a8-48a0-a3cb-3af6a4b48bb3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632",
      target: "ef413f2e-fe35-40d1-962f-a64afdf70526"
    },
    {
      id: "a508da5f-9d18-471d-82bd-e29faf3434b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632",
      target: "390a2070-20e5-4004-b193-4ac20d205c01"
    },
    {
      id: "9b1c16c9-3cd7-4c49-ad30-f356a81607a0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d420bb2b-1a96-4aa9-8bf8-3b10cdf5c632",
      target: "ef413f2e-fe35-40d1-962f-a64afdf70526"
    },
    {
      id: "5917bd4a-3ef7-4619-8cb0-16cbdcfb5903",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f26e75a4-1291-458f-9ded-95a48f58db64",
      target: "51370ae4-75d9-4cef-9ae2-da90bb8354b8"
    },
    {
      id: "93d705c0-d977-4fa1-bd51-0f23591d20e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "490ee11b-5c8c-4e75-b103-dbc2869fea2d",
      target: "51b7dd10-27ab-4a4f-a848-cc783925cf1c"
    },
    {
      id: "a137d4c5-7e7a-4828-bbe1-9a6ac5e1048e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "c0fb9fcd-6590-4a48-9d11-d1f796ce6715"
    },
    {
      id: "432fcc28-ad71-4167-80af-2ce7fb82c577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "7c976095-02e3-4e16-a5bc-8e12dc814d7a"
    },
    {
      id: "2a0c6810-5a7f-41b5-ba5a-1b5ef78fc159",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "82087812-361d-45ba-b343-21f3c945ca1d"
    },
    {
      id: "5f0a507b-a303-49db-919f-60ac820928d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "c0fb9fcd-6590-4a48-9d11-d1f796ce6715"
    },
    {
      id: "cb11434e-ebca-43aa-896c-090c8e12a9b7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "6ce8af76-476c-4f0d-85af-ff1a76906202"
    },
    {
      id: "47328eee-0bb3-4e7f-ae3e-d14e102a3fea",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "490ee11b-5c8c-4e75-b103-dbc2869fea2d"
    },
    {
      id: "de101b5f-e7ea-4ae4-8f29-b6abb70fdb94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d143a46d-fb23-4aab-9a9d-ab5437094a76",
      target: "6fbf2eb3-8f19-4627-89a7-aec878173fff"
    },
    {
      id: "54530d58-78b6-46e5-8664-66c04c0e1bdb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "82087812-361d-45ba-b343-21f3c945ca1d",
      target: "69e798ea-3a81-40ed-a5e8-230876e74e8d"
    },
    {
      id: "10e89e0e-fe00-4b22-8a35-f412989efda1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82087812-361d-45ba-b343-21f3c945ca1d",
      target: "7c976095-02e3-4e16-a5bc-8e12dc814d7a"
    },
    {
      id: "6f4708c4-0134-418f-8aaf-014c0b6beda0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ce8af76-476c-4f0d-85af-ff1a76906202",
      target: "51b7dd10-27ab-4a4f-a848-cc783925cf1c"
    },
    {
      id: "eccc44c5-7e93-4fa0-b8bf-34a5ab1d0c16",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7c976095-02e3-4e16-a5bc-8e12dc814d7a",
      target: "51b7dd10-27ab-4a4f-a848-cc783925cf1c"
    },
    {
      id: "94178c97-3d6a-4fe6-9968-c2284ad376d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c0fb9fcd-6590-4a48-9d11-d1f796ce6715",
      target: "51b7dd10-27ab-4a4f-a848-cc783925cf1c"
    },
    {
      id: "88afff90-a08f-423a-bf02-fe9d48e17220",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cfaf7920-164e-4d55-ad2a-a21cdfa185d2",
      target: "ddf2a130-7cb9-4046-8397-fb156a5859fc"
    },
    {
      id: "40d50129-694e-4489-ac9d-5fdd00e6c1dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bedf80e5-7afa-473a-bcf5-6160777214cf",
      target: "ddf2a130-7cb9-4046-8397-fb156a5859fc"
    },
    {
      id: "a845b979-3e14-450d-a84a-85c1b3a5dfb9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51b7dd10-27ab-4a4f-a848-cc783925cf1c",
      target: "bedf80e5-7afa-473a-bcf5-6160777214cf"
    },
    {
      id: "91893f2b-4b50-4605-b5e6-3b03f9b58224",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51b7dd10-27ab-4a4f-a848-cc783925cf1c",
      target: "cfaf7920-164e-4d55-ad2a-a21cdfa185d2"
    },
    {
      id: "9e2b4055-69c1-4d9d-b758-ef75eb42cf23",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51b7dd10-27ab-4a4f-a848-cc783925cf1c",
      target: "cfaf7920-164e-4d55-ad2a-a21cdfa185d2"
    },
    {
      id: "79660365-ce63-4f82-ac98-e1a9c0dca981",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51b7dd10-27ab-4a4f-a848-cc783925cf1c",
      target: "bedf80e5-7afa-473a-bcf5-6160777214cf"
    },
    {
      id: "8026561a-ea34-45c4-967b-e0599d07cfb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ddf2a130-7cb9-4046-8397-fb156a5859fc",
      target: "667ce647-d071-42f8-b869-3323345b606d"
    },
    {
      id: "767b9db9-37e2-4af0-9ca3-e52d7ddacf73",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "69e798ea-3a81-40ed-a5e8-230876e74e8d",
      target: "9d8f341a-3a96-42a1-8638-64d8e87ff245"
    },
    {
      id: "ffa00e5a-218c-467d-a650-810feaa85026",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69e798ea-3a81-40ed-a5e8-230876e74e8d",
      target: "caa908cc-3f97-4741-bd96-442cba3a118e"
    },
    {
      id: "37b9868e-a561-43d2-8c0b-5ab9921c3835",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69e798ea-3a81-40ed-a5e8-230876e74e8d",
      target: "ea73fbf5-4752-469c-a68f-24fd27e7f1cf"
    },
    {
      id: "f673aaac-e90a-4f94-8e02-94105601b30b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "db86ff6b-468b-465e-b41d-914e0b2dafcf",
      target: "f6044b69-2e06-4d52-911a-41bb2e4b683b"
    },
    {
      id: "1f25efe1-d7a3-4b76-af65-8f89ffcf541a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      target: "9d8f341a-3a96-42a1-8638-64d8e87ff245"
    },
    {
      id: "aa6cdd7b-1d54-466a-8111-e25099c3d842",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      target: "ea73fbf5-4752-469c-a68f-24fd27e7f1cf"
    },
    {
      id: "3c85e47a-c622-4f6e-a53b-423b949eb376",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      target: "caa908cc-3f97-4741-bd96-442cba3a118e"
    },
    {
      id: "eb267d6e-b6f1-400b-aba4-4c3ecfbadb93",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      target: "69e798ea-3a81-40ed-a5e8-230876e74e8d"
    },
    {
      id: "8a9550d9-31a5-489b-b3ab-849c683e0a69",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6fbf2eb3-8f19-4627-89a7-aec878173fff",
      target: "db86ff6b-468b-465e-b41d-914e0b2dafcf"
    },
    {
      id: "7a6f41bc-0d3c-463f-a387-8b359b9ac3ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d8f341a-3a96-42a1-8638-64d8e87ff245",
      target: "f6044b69-2e06-4d52-911a-41bb2e4b683b"
    },
    {
      id: "8cc9fae6-6745-4b6e-83bf-f89198a771ae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "caa908cc-3f97-4741-bd96-442cba3a118e",
      target: "f6044b69-2e06-4d52-911a-41bb2e4b683b"
    },
    {
      id: "494dde48-bfc1-4ee1-a745-ef3eeb22217b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ea73fbf5-4752-469c-a68f-24fd27e7f1cf",
      target: "f6044b69-2e06-4d52-911a-41bb2e4b683b"
    },
    {
      id: "9338f604-e087-4cc6-be9c-7130bc9e8a67",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6044b69-2e06-4d52-911a-41bb2e4b683b",
      target: "6ae80286-7bb3-4541-8340-5590923d551b"
    },
    {
      id: "17afc057-5b6a-440a-88f3-79af758237b3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f6044b69-2e06-4d52-911a-41bb2e4b683b",
      target: "6ae80286-7bb3-4541-8340-5590923d551b"
    },
    {
      id: "f2be0f81-3708-4f89-8085-02e23a9b7061",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f6044b69-2e06-4d52-911a-41bb2e4b683b",
      target: "1dd28142-ddc7-4088-a698-0827f8d5b870"
    },
    {
      id: "e5c63033-7d55-4617-9f8d-50ed7a86db42",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6044b69-2e06-4d52-911a-41bb2e4b683b",
      target: "1dd28142-ddc7-4088-a698-0827f8d5b870"
    },
    {
      id: "e5048c0a-8f9a-43ac-9f77-06f1ab072e33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1dd28142-ddc7-4088-a698-0827f8d5b870",
      target: "495599d2-0afc-40f8-bc50-b4aed093d3b3"
    },
    {
      id: "f82b889f-b39c-4ad6-bd39-b286aebeec48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ae80286-7bb3-4541-8340-5590923d551b",
      target: "495599d2-0afc-40f8-bc50-b4aed093d3b3"
    },
    {
      id: "e5a7f969-878e-4e25-a47b-5ac908d2406e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "495599d2-0afc-40f8-bc50-b4aed093d3b3",
      target: "95f06f01-4228-4104-a9ad-daffdae87ce6"
    },
    {
      id: "4f856398-1d3a-4b65-9463-1b8b15c0e78d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0ac1d778-7cb2-463e-9cce-fd72d14c288f",
      target: "187633d5-4d41-408f-82e8-aaf4af8236c4"
    },
    {
      id: "c91b2355-2a43-4892-bd13-84bb238c3dda",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51370ae4-75d9-4cef-9ae2-da90bb8354b8",
      target: "0ac1d778-7cb2-463e-9cce-fd72d14c288f"
    },
    {
      id: "dec3942a-59fc-4aa8-8ffe-c5d9aca12447",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51370ae4-75d9-4cef-9ae2-da90bb8354b8",
      target: "7e745a24-1acd-4964-a8c4-be98686c3c6f"
    },
    {
      id: "a555e522-8df2-4d5f-b546-fd336ad8fb80",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51370ae4-75d9-4cef-9ae2-da90bb8354b8",
      target: "7e745a24-1acd-4964-a8c4-be98686c3c6f"
    },
    {
      id: "a6c908b3-dfd1-43b9-a5a7-29c966a67835",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51370ae4-75d9-4cef-9ae2-da90bb8354b8",
      target: "79b21e2b-9e78-4e8f-957a-3654e2fdea61"
    },
    {
      id: "306351e0-cbdf-47ad-8b5b-da270b131032",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e745a24-1acd-4964-a8c4-be98686c3c6f",
      target: "187633d5-4d41-408f-82e8-aaf4af8236c4"
    },
    {
      id: "5088a5f2-cb40-4e89-85c0-784b90e83e14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e745a24-1acd-4964-a8c4-be98686c3c6f",
      target: "6b556992-b16c-4624-933a-047555c3af4f"
    },
    {
      id: "4e5d64d1-e109-4571-b35d-d08fb24d95a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e745a24-1acd-4964-a8c4-be98686c3c6f",
      target: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e"
    },
    {
      id: "729d742d-d703-474c-8fcf-20bde4e2dc12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "187633d5-4d41-408f-82e8-aaf4af8236c4",
      target: "439f0c0c-31ba-4794-bc29-3919a21d4eb9"
    },
    {
      id: "4b73c81d-dd8c-4514-8268-435308d28855",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "439f0c0c-31ba-4794-bc29-3919a21d4eb9",
      target: "5c52bd43-335d-443d-8a4e-f9a8b9da33c7"
    },
    {
      id: "e8514687-5236-426c-a668-3bf860a67c29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "439f0c0c-31ba-4794-bc29-3919a21d4eb9",
      target: "e147c76a-f21b-4eba-9050-9691792881f1"
    },
    {
      id: "ad7d88fd-66bf-48b5-85e0-bdaac9628e5c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c44c4f6c-2d81-439a-b235-b65f241133f7",
      target: "337dc302-bd6e-4e08-afb9-ba97c6503bf3"
    },
    {
      id: "5eb5588e-27a1-4864-b048-b07e65f529f7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e",
      target: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c"
    },
    {
      id: "27632d23-0a04-4cc8-9afb-e9c7d245a1bc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e",
      target: "c44c4f6c-2d81-439a-b235-b65f241133f7"
    },
    {
      id: "4b19d460-8b9c-4064-bf53-19e52b73b54c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c0962e1-0d64-46ac-8b41-dba272fe8d2e",
      target: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c"
    },
    {
      id: "931b85e2-553f-4add-8f79-a66e39d595ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c",
      target: "337dc302-bd6e-4e08-afb9-ba97c6503bf3"
    },
    {
      id: "aa5d8e7a-965d-4c25-b165-4bf2e61cccf4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c",
      target: "667ce647-d071-42f8-b869-3323345b606d"
    },
    {
      id: "17522e4f-f52c-4e6c-af66-34d14835d049",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f807f12-5cf2-4b68-b5fb-a0979f82c17c",
      target: "337dc302-bd6e-4e08-afb9-ba97c6503bf3"
    },
    {
      id: "bfa7f391-94ab-4508-8598-7a650fab1581",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "337dc302-bd6e-4e08-afb9-ba97c6503bf3",
      target: "8a070199-b6ff-4175-af1e-e04030bd4a41"
    },
    {
      id: "ad123bd6-4cdb-4559-90f5-5588bffb9366",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "337dc302-bd6e-4e08-afb9-ba97c6503bf3",
      target: "dc869448-8240-4498-97b0-195eeebf7afc"
    },
    {
      id: "74776311-873b-4f39-8763-366040118e11",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "dc869448-8240-4498-97b0-195eeebf7afc",
      target: "a78c948f-f3bd-4b71-a9b7-97fc7af1e375"
    },
    {
      id: "4b2142d2-3b05-4c4a-aba4-50ad52e0e731",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc869448-8240-4498-97b0-195eeebf7afc",
      target: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0"
    },
    {
      id: "6cb80deb-c74e-46b0-bb52-6428160f8af4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6b556992-b16c-4624-933a-047555c3af4f",
      target: "2dd5e89e-59fa-4ee2-a53e-5d0f0c8d6152"
    },
    {
      id: "5048d117-d2bc-414c-8865-a6b51141db0f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6b556992-b16c-4624-933a-047555c3af4f",
      target: "cc46a90d-fbfe-431a-953c-76d8483e2429"
    },
    {
      id: "c5aca8ae-6a62-4e9f-a4f0-98372cc49819",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b556992-b16c-4624-933a-047555c3af4f",
      target: "2dd5e89e-59fa-4ee2-a53e-5d0f0c8d6152"
    },
    {
      id: "a4240283-143e-4f06-97b8-725557ba7091",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cc46a90d-fbfe-431a-953c-76d8483e2429",
      target: "044ae072-44c6-4509-8a58-95183679d878"
    },
    {
      id: "c451b8dd-c83d-4163-854f-1676206a7966",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dd5e89e-59fa-4ee2-a53e-5d0f0c8d6152",
      target: "044ae072-44c6-4509-8a58-95183679d878"
    },
    {
      id: "18c432ba-63d4-4b02-94a4-c846d0da6792",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dd5e89e-59fa-4ee2-a53e-5d0f0c8d6152",
      target: "95f06f01-4228-4104-a9ad-daffdae87ce6"
    },
    {
      id: "dab8d4bc-2cfb-41fb-b345-c43f937f7afe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044ae072-44c6-4509-8a58-95183679d878",
      target: "8aeeda65-56ca-4ed2-b228-14a9238ade1f"
    },
    {
      id: "975bff4e-788d-4bd0-af84-ee3056ae6ab4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044ae072-44c6-4509-8a58-95183679d878",
      target: "63093767-f8ce-44d1-8142-2ed6229c04c9"
    },
    {
      id: "4e37ec21-619c-4f6d-8db6-6b913193219e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044ae072-44c6-4509-8a58-95183679d878",
      target: "d9b4bf3e-fb02-4ca1-92c7-2a7d791e068f"
    },
    {
      id: "b84426e9-777c-455d-965f-e993b59e7322",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d9b4bf3e-fb02-4ca1-92c7-2a7d791e068f",
      target: "095920e6-a996-4247-90f9-ea3b2164de0b"
    },
    {
      id: "8e197a6f-03a4-4d6e-9acc-7d8ad4fcd74a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9b4bf3e-fb02-4ca1-92c7-2a7d791e068f",
      target: "9287437c-e384-4366-8e16-d6d212da27dd"
    },
    {
      id: "a5e51c01-a614-4114-a53f-7ba90fbcf908",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "667ce647-d071-42f8-b869-3323345b606d",
      target: "1cb10928-4d0c-4981-b367-630dddd7d4a2"
    },
    {
      id: "3522b9aa-0d29-4f71-b611-b9929a823795",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "667ce647-d071-42f8-b869-3323345b606d",
      target: "41c6a663-b2c6-4385-8d87-5aa5fc2c8980"
    },
    {
      id: "45ded2d6-ff87-426e-9d0c-ed2619962abd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "667ce647-d071-42f8-b869-3323345b606d",
      target: "41c6a663-b2c6-4385-8d87-5aa5fc2c8980"
    },
    {
      id: "d581d9fb-96d2-4e98-ae94-602cf15fa0a3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1cb10928-4d0c-4981-b367-630dddd7d4a2",
      target: "6b06752b-87c7-4910-b4e1-d57317f50ce3"
    },
    {
      id: "e4c4e424-b3cf-4f43-83ef-48827a5abb45",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "41c6a663-b2c6-4385-8d87-5aa5fc2c8980",
      target: "6b06752b-87c7-4910-b4e1-d57317f50ce3"
    },
    {
      id: "92ade5df-3548-4fd6-816c-5bb3ceb4d4d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41c6a663-b2c6-4385-8d87-5aa5fc2c8980",
      target: "6b06752b-87c7-4910-b4e1-d57317f50ce3"
    },
    {
      id: "f76cbd40-bfbd-40bd-9460-e1e83c4f562d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b06752b-87c7-4910-b4e1-d57317f50ce3",
      target: "e073eccc-3f5f-4f21-a744-78c3b4a2a9e4"
    },
    {
      id: "9fc2158e-154c-4a51-a00e-06f479f33234",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b06752b-87c7-4910-b4e1-d57317f50ce3",
      target: "1f204fdb-6b2c-43d8-aa84-08395321c6b1"
    },
    {
      id: "ce76dd31-e1da-4182-a5e5-4d60174150b3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e073eccc-3f5f-4f21-a744-78c3b4a2a9e4",
      target: "f3bb6587-c43c-4ad2-b8b0-e68de35e4577"
    },
    {
      id: "9c3d8c89-4416-4da8-b851-c0a55a09952f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e073eccc-3f5f-4f21-a744-78c3b4a2a9e4",
      target: "43666a4e-1aee-436b-83c7-e5490a953421"
    },
    {
      id: "ab463784-1128-4c24-87cb-e53166f711f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "7b4888c8-28a1-4c59-b2b3-f6ba274f9490",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "b6fce1c3-c853-464b-9031-deaf389a90c0"
    },
    {
      id: "6f2b7947-4b41-4588-810a-10720de0c7da",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "01dda793-bff4-4724-8346-c0997fef1457"
    },
    {
      id: "506395c6-ee7b-420d-bf1c-766447ae7524",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "9fbd5493-3b5b-4129-a0a7-d6250e97ba6d"
    },
    {
      id: "586e5a99-416b-4dd1-befc-a0b9ed7321c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "514fd011-bf24-4893-b099-d913d65e9062"
    },
    {
      id: "893011e9-188c-4a93-96d7-105b0258230b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "9fbd5493-3b5b-4129-a0a7-d6250e97ba6d"
    },
    {
      id: "4a7be0b6-1031-4c20-9fa7-52c4705ac182",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95f06f01-4228-4104-a9ad-daffdae87ce6",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "6b809bfc-1a4d-45e3-a042-bd809ae49ae9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "01dda793-bff4-4724-8346-c0997fef1457",
      target: "d67b0569-6072-4d51-88e3-44e207941498"
    },
    {
      id: "16bee46a-47f9-44f2-9fc6-24095aa778be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9fbd5493-3b5b-4129-a0a7-d6250e97ba6d",
      target: "d67b0569-6072-4d51-88e3-44e207941498"
    },
    {
      id: "17dab18d-05ff-43ff-9fce-99480859cc73",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9fbd5493-3b5b-4129-a0a7-d6250e97ba6d",
      target: "d67b0569-6072-4d51-88e3-44e207941498"
    },
    {
      id: "0d14b124-4b01-425d-9ecc-3883af2270bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d67b0569-6072-4d51-88e3-44e207941498",
      target: "fcfe5293-993f-4ee5-b66b-796af915b6e8"
    },
    {
      id: "79990383-f82b-4b2b-a4e4-89fd078deca1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d67b0569-6072-4d51-88e3-44e207941498",
      target: "4f7055bf-142d-4b99-8e43-e8e1ce0a223e"
    },
    {
      id: "ece96c8a-6ddf-4527-8164-3c78cb4ac762",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fcfe5293-993f-4ee5-b66b-796af915b6e8",
      target: "1da1079c-3fca-4aba-89b5-cd3b2301e2f7"
    },
    {
      id: "4c7a2701-b702-4a3c-a8ed-2d585e277c79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcfe5293-993f-4ee5-b66b-796af915b6e8",
      target: "4b18be79-bf32-452c-a06b-f260d38ba0e4"
    },
    {
      id: "d406ca3c-d53e-4922-8f58-44e41c232546",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f28e0d8-9a4f-46cc-b5aa-639e59bbe890",
      target: "e3d654ff-aef9-4ac4-93e6-9552e6f83576"
    },
    {
      id: "b6be2f11-73ef-40d7-b9a4-15e3bd7e8046",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3d654ff-aef9-4ac4-93e6-9552e6f83576",
      target: "e677d5ef-4096-4d6a-85df-67e542e344ed"
    },
    {
      id: "20dbda37-b2a8-4197-98b7-e394d709c171",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "18b82ec0-070a-4054-87c3-069815864efe",
      target: "f9b17f31-7854-479b-b017-fee40ec70f8d"
    },
    {
      id: "3bad4efd-5b1d-4ad0-884b-2b3690e73686",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e677d5ef-4096-4d6a-85df-67e542e344ed",
      target: "631a9da3-4e12-4858-8213-16ceabad8397"
    },
    {
      id: "4b432927-5d5a-4373-b564-3a604f200a21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e677d5ef-4096-4d6a-85df-67e542e344ed",
      target: "74243b29-1644-445c-90c0-2ae0722c2640"
    },
    {
      id: "69219d2a-9d9c-4891-869d-229638a040e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e677d5ef-4096-4d6a-85df-67e542e344ed",
      target: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d"
    },
    {
      id: "7e94bb83-10ba-4eee-8df5-084e0895480d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e677d5ef-4096-4d6a-85df-67e542e344ed",
      target: "18b82ec0-070a-4054-87c3-069815864efe"
    },
    {
      id: "fbfeca6f-c6c1-48b3-a9e0-9b69f7fe54b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "74243b29-1644-445c-90c0-2ae0722c2640",
      target: "f9b17f31-7854-479b-b017-fee40ec70f8d"
    },
    {
      id: "be3815c0-dde7-49bb-9a4c-e8ba47a8c1ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9b17f31-7854-479b-b017-fee40ec70f8d",
      target: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b"
    },
    {
      id: "136ae2ce-67a5-4283-a03c-9d6aabdaaefc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9b17f31-7854-479b-b017-fee40ec70f8d",
      target: "9346e796-ac70-40ae-b08f-1cf53c86c028"
    },
    {
      id: "757706c3-1e5e-4504-84e5-b49d143cb846",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9b17f31-7854-479b-b017-fee40ec70f8d",
      target: "999a5b37-388c-4556-9e66-cefd7cb0cf85"
    },
    {
      id: "02e82713-f8dd-4622-9659-9125c89ebe67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "999a5b37-388c-4556-9e66-cefd7cb0cf85",
      target: "65a77fba-67a9-4fef-8fec-7ec7c140bdc6"
    },
    {
      id: "9a383aca-249f-43e3-aa71-beaf799bfe9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "999a5b37-388c-4556-9e66-cefd7cb0cf85",
      target: "c163c2c2-1247-4ae1-8866-8edc23e60da2"
    },
    {
      id: "248e3de8-6af9-43db-ae83-84defeb9f233",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c163c2c2-1247-4ae1-8866-8edc23e60da2",
      target: "b4ff44bd-e4f7-40eb-bc45-c40a8d28bef1"
    },
    {
      id: "cef2bdba-5d7b-40ee-bf96-3bcc093cb3b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "829f9e87-e103-4200-a8ff-a6b0daa48b58",
      target: "126a4134-1ae8-4cd2-b194-7885aac03c52"
    },
    {
      id: "e4c93de3-8784-481d-935b-f73886bb3241",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "126a4134-1ae8-4cd2-b194-7885aac03c52",
      target: "450bc5af-5b37-4cfc-abc8-6b78de04d845"
    },
    {
      id: "17eb62c4-f65e-422a-8e90-0fc86ec3f16e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      target: "72b88ae1-8587-42b2-b7eb-8f932042fbe1"
    },
    {
      id: "681a47ab-0752-4fa9-8bde-52dfcc7d0832",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      target: "3cb746d5-7da7-4ae2-9158-2a8f2b65f544"
    },
    {
      id: "1383ad37-0c0d-4657-ac1a-538503520708",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      target: "51d5c1c1-7aaf-40b6-9a0a-a8e8cdb437d6"
    },
    {
      id: "98e8dc30-f4eb-40af-9616-d142cfd14036",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      target: "68506006-d589-4d8a-a629-cea2657e4216"
    },
    {
      id: "80242cab-e69e-4824-a3c0-cb7f4aba7144",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "450bc5af-5b37-4cfc-abc8-6b78de04d845",
      target: "43744881-6f63-4765-ac73-c4430f424f77"
    },
    {
      id: "f8b80877-c866-4b08-be63-14062aa3d5d3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51d5c1c1-7aaf-40b6-9a0a-a8e8cdb437d6",
      target: "79436c82-c9f4-4f1d-a41c-adae8ff7fcd0"
    },
    {
      id: "6cb30824-b627-4f78-91bb-b2cacbb77541",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3cb746d5-7da7-4ae2-9158-2a8f2b65f544",
      target: "79436c82-c9f4-4f1d-a41c-adae8ff7fcd0"
    },
    {
      id: "39858879-16fa-44eb-a26f-cc32920c1e17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "79436c82-c9f4-4f1d-a41c-adae8ff7fcd0",
      target: "65a77fba-67a9-4fef-8fec-7ec7c140bdc6"
    },
    {
      id: "33187efa-b175-44ba-b4e0-c1b1327f6f68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "79436c82-c9f4-4f1d-a41c-adae8ff7fcd0",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "cfdbb25d-e671-4af9-8a41-0e72bf0f265d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65a77fba-67a9-4fef-8fec-7ec7c140bdc6",
      target: "b4ff44bd-e4f7-40eb-bc45-c40a8d28bef1"
    },
    {
      id: "c69c40bf-101a-4921-8616-783b88e7af0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65a77fba-67a9-4fef-8fec-7ec7c140bdc6",
      target: "cec068d6-061d-440d-8715-145782365d80"
    },
    {
      id: "18ca08ef-a830-40cf-a46f-7207ede05c0f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b4ff44bd-e4f7-40eb-bc45-c40a8d28bef1",
      target: "c7d489ae-fe79-40f1-acbf-69e1729b64dc"
    },
    {
      id: "5e669718-84ba-4534-b34a-ecee714ff0f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c35abc49-152c-4331-98d8-5370416ca04b",
      target: "10f5dfec-bbce-491b-a5ae-ef46a8aabbd2"
    },
    {
      id: "9bbe56e9-7779-4a22-8a04-196a7b376576",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "10f5dfec-bbce-491b-a5ae-ef46a8aabbd2",
      target: "605cd4c2-dbc1-4e93-b828-a22ff8394e47"
    },
    {
      id: "0b50e022-fca3-4243-8c71-42e970b60d43",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ed8ae6ee-b607-4e99-bb7f-d7a2b34d46b7",
      target: "8a5094f0-21ed-444e-8344-5cb358d522e0"
    },
    {
      id: "c5c8c7a3-6faf-4c00-b41b-032868f07fb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "8a748b1a-7e54-44d8-8a49-52cc3b117656"
    },
    {
      id: "679683d2-c2f3-4077-aa0a-35281fc135c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "d88e1970-06c1-4c02-a1bf-ce7897f49de8"
    },
    {
      id: "93fae7e4-0cce-4ad1-9174-735dd5ced708",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "ed8ae6ee-b607-4e99-bb7f-d7a2b34d46b7"
    },
    {
      id: "5dab4a57-9c41-41a3-bf4f-dc6d2756dace",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "752e1424-4966-438f-9f13-63617950bdd2"
    },
    {
      id: "801e7aa0-f25d-4238-99de-97f28f3bf5ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "d3864721-50a6-458e-9757-22d81dafb9fe"
    },
    {
      id: "57a1ef20-13b4-4407-a8c1-25f0fc5e2b94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "605cd4c2-dbc1-4e93-b828-a22ff8394e47",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "2f2586b1-9144-4cce-a021-cd6dca0fbb65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3864721-50a6-458e-9757-22d81dafb9fe",
      target: "8a5094f0-21ed-444e-8344-5cb358d522e0"
    },
    {
      id: "e9cf53be-1fc1-41b3-8839-3106e1afd98a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a5094f0-21ed-444e-8344-5cb358d522e0",
      target: "cec068d6-061d-440d-8715-145782365d80"
    },
    {
      id: "c0264783-0742-48d4-9d4d-11f0e38d6ebf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a5094f0-21ed-444e-8344-5cb358d522e0",
      target: "9a014585-bce5-4d8e-bf63-bc24dafe0459"
    },
    {
      id: "6dab821a-10d3-42ef-8a9e-3c8a613ef90e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cec068d6-061d-440d-8715-145782365d80",
      target: "5aa96d0f-3611-4599-b345-2abdc9204217"
    },
    {
      id: "121283ce-7bb6-4c32-94b1-70414f7eeea2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cec068d6-061d-440d-8715-145782365d80",
      target: "c7d489ae-fe79-40f1-acbf-69e1729b64dc"
    },
    {
      id: "a7fff413-963a-4b44-a535-cad57c658ea4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7d489ae-fe79-40f1-acbf-69e1729b64dc",
      target: "20c6c9b6-0917-47f5-8047-84a817f48a47"
    },
    {
      id: "c39b0881-6181-419e-96af-82c691756fb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09c06ca8-564f-4081-bffc-b19c58f69913",
      target: "05158e38-22d1-4982-9173-ef51acc8a698"
    },
    {
      id: "a5430f5b-a8a7-417a-b482-51c61e981262",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "05158e38-22d1-4982-9173-ef51acc8a698",
      target: "044a026a-3406-4f8f-a7dc-50b2e6ab2056"
    },
    {
      id: "be7d7031-2025-451a-acf8-b044b8f8cb1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      target: "8729c704-5316-40c9-a098-222574688c6a"
    },
    {
      id: "a8145ac5-5749-4bdc-af7a-4d9573edc11d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      target: "386cffa9-a238-403a-a0dc-007f3e7c0848"
    },
    {
      id: "9235c2e3-e7f4-4bc2-8bd5-e11e1aa3cf0c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      target: "141eb1c4-05d8-40d1-8f58-00736f1e4575"
    },
    {
      id: "099cd8be-4594-4a10-80e4-eab4b0f3efea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      target: "446db9ae-f692-47fb-ba0c-619dbb8c0ccf"
    },
    {
      id: "3e272c1e-07a5-479e-8b56-0eee996f158a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "044a026a-3406-4f8f-a7dc-50b2e6ab2056",
      target: "bb52d052-3765-4394-84d1-a4c52f532881"
    },
    {
      id: "4794e63b-c7a0-412b-9ebf-d39ab13109bc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bb52d052-3765-4394-84d1-a4c52f532881",
      target: "7693ecd2-83d3-4c81-9b3a-aca0b9b38525"
    },
    {
      id: "453c3cc9-819a-4634-aa60-6d56c2a73729",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "386cffa9-a238-403a-a0dc-007f3e7c0848",
      target: "7693ecd2-83d3-4c81-9b3a-aca0b9b38525"
    },
    {
      id: "ad0086af-1057-4166-a065-f0174e11e20f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7693ecd2-83d3-4c81-9b3a-aca0b9b38525",
      target: "5aa96d0f-3611-4599-b345-2abdc9204217"
    },
    {
      id: "43ef7163-dcf7-4fff-9626-c4dd04a11250",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7693ecd2-83d3-4c81-9b3a-aca0b9b38525",
      target: "119cc502-8ae5-49f3-a97c-5258d4f4a413"
    },
    {
      id: "25160004-1f5e-4b38-b99f-8604b38fa73b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aa96d0f-3611-4599-b345-2abdc9204217",
      target: "6efc3154-837c-4250-8c9c-73b144dec055"
    },
    {
      id: "a4496d99-c520-465f-92df-37da9e4e4639",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aa96d0f-3611-4599-b345-2abdc9204217",
      target: "20c6c9b6-0917-47f5-8047-84a817f48a47"
    },
    {
      id: "9c17da93-511b-40ae-b01b-8d95a3ec0887",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20c6c9b6-0917-47f5-8047-84a817f48a47",
      target: "48f4f1fa-d600-4534-9b2b-8c7139bf70d4"
    },
    {
      id: "cc76368b-570b-434f-b8cb-5cab014543c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b763aab-f0f5-492d-b7d2-832fcfac94f0",
      target: "d825dd3c-0eb8-4f39-8af8-e909889cfbcf"
    },
    {
      id: "7ce56f46-1047-4527-b9e9-2e290e462f92",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d825dd3c-0eb8-4f39-8af8-e909889cfbcf",
      target: "bb139fcd-3f99-430d-82b9-b48a4292c4b7"
    },
    {
      id: "9502aa38-d4c0-47ce-b1c3-1cc87289a8e0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "268d91c1-9d30-46e0-9562-67ba2b463daa",
      target: "310e6906-c51e-4130-b236-f0a9265afeae"
    },
    {
      id: "2673d06d-2a4c-49a6-b35c-40ca65de46a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      target: "28d12d42-a49d-43fc-b1d9-424f6b835c20"
    },
    {
      id: "b97f5e48-b76f-4e0b-acc2-e026f2d3e84c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      target: "a9b7a1af-02e1-4e89-9c04-d6c45066b5e8"
    },
    {
      id: "711baead-f431-44a6-8723-b61b526acb01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      target: "ff9c50c7-6273-48ce-82d9-04a35f1eba15"
    },
    {
      id: "29835e54-6474-4526-bfb2-815f2c02e5ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      target: "0f78e4b4-76e4-4499-96b9-9b8f62208a47"
    },
    {
      id: "e0c8311f-d474-4d91-9a38-d2ca7793588e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bb139fcd-3f99-430d-82b9-b48a4292c4b7",
      target: "268d91c1-9d30-46e0-9562-67ba2b463daa"
    },
    {
      id: "72afde5e-cf09-47cb-99a4-8dee505455d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "28d12d42-a49d-43fc-b1d9-424f6b835c20",
      target: "310e6906-c51e-4130-b236-f0a9265afeae"
    },
    {
      id: "a1b20680-247a-41bf-93ca-451a58bb31cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310e6906-c51e-4130-b236-f0a9265afeae",
      target: "6efc3154-837c-4250-8c9c-73b144dec055"
    },
    {
      id: "55318e20-0b1b-451f-be05-4c8317363f49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "310e6906-c51e-4130-b236-f0a9265afeae",
      target: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0"
    },
    {
      id: "767fba9e-1c03-4729-9519-ff930e7a4618",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6efc3154-837c-4250-8c9c-73b144dec055",
      target: "48f4f1fa-d600-4534-9b2b-8c7139bf70d4"
    },
    {
      id: "163755e1-9be7-41a1-90e5-860b33b4b872",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48f4f1fa-d600-4534-9b2b-8c7139bf70d4",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "efa31277-ecb7-4d21-a44e-5a0c83c2761d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5c52bd43-335d-443d-8a4e-f9a8b9da33c7",
      target: "e147c76a-f21b-4eba-9050-9691792881f1"
    },
    {
      id: "6705e9d9-f0d8-4aa8-b9c3-4e8a88b9404f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "328aa2d6-3da6-4a25-9205-f2c59752d210",
      target: "9753b40c-3365-4ec6-8f11-1301b172d698"
    },
    {
      id: "75daed46-9ce3-4090-84f1-579224668c6b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e147c76a-f21b-4eba-9050-9691792881f1",
      target: "d92df994-826b-451d-9959-0988bb8829ad"
    },
    {
      id: "f56b51c1-3417-4811-9026-aa88e4b004d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e147c76a-f21b-4eba-9050-9691792881f1",
      target: "226dba93-ba7b-4d64-91b0-417be5816107"
    },
    {
      id: "98744fc0-7157-47ec-ab2b-c8ab72c8b608",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e147c76a-f21b-4eba-9050-9691792881f1",
      target: "328aa2d6-3da6-4a25-9205-f2c59752d210"
    },
    {
      id: "5ea702a8-2d2c-4dca-b701-d153306bc1d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "226dba93-ba7b-4d64-91b0-417be5816107",
      target: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0"
    },
    {
      id: "e65e52c2-97ad-43c6-ab9d-76fea1a23b03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "226dba93-ba7b-4d64-91b0-417be5816107",
      target: "9753b40c-3365-4ec6-8f11-1301b172d698"
    },
    {
      id: "ac8f30b8-3c81-4e42-81e6-e2deded1e289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9753b40c-3365-4ec6-8f11-1301b172d698",
      target: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8"
    },
    {
      id: "d62d7ffc-e402-4f15-9e91-bb1070c882a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9753b40c-3365-4ec6-8f11-1301b172d698",
      target: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02"
    },
    {
      id: "3384b477-1468-42cb-b79e-5c66db6724f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9753b40c-3365-4ec6-8f11-1301b172d698",
      target: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb"
    },
    {
      id: "3bc3da08-405b-4f86-9703-0381fadfe663",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9753b40c-3365-4ec6-8f11-1301b172d698",
      target: "acd5d259-ab2a-4083-9779-8d509acf67ed"
    },
    {
      id: "f07a2587-25e8-420b-8c67-b060a6d367c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9753b40c-3365-4ec6-8f11-1301b172d698",
      target: "061b8cd8-5099-4281-8bf5-8ec50b7a4267"
    },
    {
      id: "ac94c0db-a7bd-472c-a0c2-674a40d5ba3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a78c948f-f3bd-4b71-a9b7-97fc7af1e375",
      target: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0"
    },
    {
      id: "b1f9a4c8-8c70-4eb9-a13d-91b29b626ece",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a95f34a8-a460-454f-b8dc-209c23d9d881",
      target: "0292069b-72d1-4e9e-83c4-4457ced2c771"
    },
    {
      id: "a3282384-d94d-4cbd-af11-2f4512e5fbf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0",
      target: "820d6ce5-7d14-47b1-ba0b-3ed260d2f495"
    },
    {
      id: "ce67d7ac-b689-49f1-b6af-0ab26dd767c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0",
      target: "9287437c-e384-4366-8e16-d6d212da27dd"
    },
    {
      id: "9edcb691-d8d2-4692-ac61-da855baced46",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9692c4de-fae0-4728-a1b8-9e8ed8f7edd0",
      target: "a95f34a8-a460-454f-b8dc-209c23d9d881"
    },
    {
      id: "1a081e6c-8e9d-4e4f-9ed8-853e69a49104",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "820d6ce5-7d14-47b1-ba0b-3ed260d2f495",
      target: "0292069b-72d1-4e9e-83c4-4457ced2c771"
    },
    {
      id: "9c750aac-eac8-4057-9cb5-73d9c7bbaab5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "c562e3ba-ce0d-4281-affc-f4a3182e06b8"
    },
    {
      id: "07e6105f-4246-4104-b115-1d67673f9426",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "21a4b145-e3d1-4c39-ac6d-a0789720a01d"
    },
    {
      id: "ffbfe19c-5936-42ab-b7ea-cff9b87ce749",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "d7116d46-50d6-4458-b6c5-af8e6fabd40c"
    },
    {
      id: "58916731-9b1e-4104-80b9-2c89fd85d1ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536"
    },
    {
      id: "f66b5f5a-8cd0-4fad-a53b-899590b4c43b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8"
    },
    {
      id: "112177f7-cda0-4fbb-a194-25c4809e86bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "9d160764-6b7a-4d92-acaa-d96e541bc5f1"
    },
    {
      id: "17ff6eab-9614-4ed1-b06c-49e8acab4469",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353"
    },
    {
      id: "d9fcfd4d-b878-4528-a053-880148a381e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "64a5e86d-b411-4655-b538-9440a526b176"
    },
    {
      id: "5b904aee-68df-4c83-b8f8-d5d7791a43d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0292069b-72d1-4e9e-83c4-4457ced2c771",
      target: "666d1c60-24a6-4d53-b322-e6d39e6ba01c"
    },
    {
      id: "536ff53b-a8bf-4d55-bdeb-24366da9311e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "095920e6-a996-4247-90f9-ea3b2164de0b",
      target: "9287437c-e384-4366-8e16-d6d212da27dd"
    },
    {
      id: "0d92e9de-211a-4905-8457-5f29d4439dbe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bb87195f-b1ce-4278-98af-ad6e1a725c18",
      target: "f9c8ca36-7892-4581-a9cb-208c910077d5"
    },
    {
      id: "e47a92fa-ed3c-4a50-90e9-6d2c20b2a358",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9287437c-e384-4366-8e16-d6d212da27dd",
      target: "c16ea63a-b9ec-4525-ab5b-97b4e455f9c4"
    },
    {
      id: "b9736ee7-3a26-4be7-8337-eee41cdb7835",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9287437c-e384-4366-8e16-d6d212da27dd",
      target: "bb87195f-b1ce-4278-98af-ad6e1a725c18"
    },
    {
      id: "b98b8a75-ca13-4b4e-9015-e0d7141a0e1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9287437c-e384-4366-8e16-d6d212da27dd",
      target: "43666a4e-1aee-436b-83c7-e5490a953421"
    },
    {
      id: "2087ea96-5143-437d-bf0a-308c545dfa10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c16ea63a-b9ec-4525-ab5b-97b4e455f9c4",
      target: "1aa8e7a1-f494-4b81-b1bf-7015a66751ac"
    },
    {
      id: "aafb2078-1269-49b7-ace3-752c9a2c77fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c16ea63a-b9ec-4525-ab5b-97b4e455f9c4",
      target: "f9c8ca36-7892-4581-a9cb-208c910077d5"
    },
    {
      id: "f36fa450-8e45-46b4-930c-7ff7bc49b8c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "52fe1192-f057-4287-a06e-48b6e9cf0bb4"
    },
    {
      id: "00535914-daa4-4e46-b5b5-6fe82c96e10b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "cf54332c-9ab7-45c9-87d4-5bea320c830f"
    },
    {
      id: "e6f49576-44f7-41d0-8d95-6de2b4bc024d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d"
    },
    {
      id: "13264640-bf72-44f3-b787-d2a71c04cbba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "25b2932a-9187-4591-88d1-d0b44210b49f"
    },
    {
      id: "617e42b7-0abe-49a5-99dc-ded1c065ebd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "7ddc007c-99de-40b8-9d93-70a323f96302"
    },
    {
      id: "6ea02f30-8887-4496-8e68-0cdb12024821",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22"
    },
    {
      id: "257df46e-811c-4ad4-b157-25f59a25c9cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "7607e97b-3881-43c4-8b6a-06f0087f28ff"
    },
    {
      id: "e91c2905-1fa3-4526-83d1-737717d8faac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9c8ca36-7892-4581-a9cb-208c910077d5",
      target: "f7078284-8d99-4766-9bdd-7543f2e26ef7"
    },
    {
      id: "b4db7a73-eff2-45a5-9924-4e95131ba47a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f3bb6587-c43c-4ad2-b8b0-e68de35e4577",
      target: "43666a4e-1aee-436b-83c7-e5490a953421"
    },
    {
      id: "a68a236e-9863-4fa9-b543-7bb8e56938ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "67e015d2-aab6-41d1-8e03-ad8605412648",
      target: "77b2a1b5-2faa-4544-9537-fdb949afb9e4"
    },
    {
      id: "d98fc211-73f8-4c0d-8548-684f2510ede3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "43666a4e-1aee-436b-83c7-e5490a953421",
      target: "67e015d2-aab6-41d1-8e03-ad8605412648"
    },
    {
      id: "f3e4b168-caa4-4e9a-a0c2-335b8b8669d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43666a4e-1aee-436b-83c7-e5490a953421",
      target: "1aa8e7a1-f494-4b81-b1bf-7015a66751ac"
    },
    {
      id: "f444ec3f-827b-4f67-b292-d2e32a49658e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "43666a4e-1aee-436b-83c7-e5490a953421",
      target: "4b18be79-bf32-452c-a06b-f260d38ba0e4"
    },
    {
      id: "16617a3f-2eed-4aed-859e-1bcbb3dc8816",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aa8e7a1-f494-4b81-b1bf-7015a66751ac",
      target: "77b2a1b5-2faa-4544-9537-fdb949afb9e4"
    },
    {
      id: "c5d49650-b321-44f6-99f2-9c820a7c5019",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1aa8e7a1-f494-4b81-b1bf-7015a66751ac",
      target: "f99a7478-9f2c-42a9-b8d9-e8dbed7f07d9"
    },
    {
      id: "aa3579f5-8a59-42e7-98a3-b14c5863c48a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "c5c2dcf7-42d9-45f7-9013-5a101d5931c8"
    },
    {
      id: "b856f7a3-6e23-41e8-a865-376d30fcbc66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "b9e3629b-8bd2-464e-a60c-2c2b32943bda"
    },
    {
      id: "4bfbf67a-5f15-4134-af74-f837c2601737",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "67f67df1-5b8f-468d-bd41-e9987e90a528"
    },
    {
      id: "1c582c91-431d-4c1a-9f74-76636e0b6be1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "47e725ae-8386-41be-905c-197027a8d882"
    },
    {
      id: "c1d5684b-24bd-4382-8b25-3b5747018983",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "bc6b0566-84da-4421-adbb-c29bb4256d70"
    },
    {
      id: "985ee712-15a6-4659-82ad-b9c44a76d736",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "631493f5-651b-43a7-bc33-071f4850db8b"
    },
    {
      id: "e1930c1b-6a7d-4072-bc1e-46686fcc67d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "e3e9c433-eaaa-471e-9b81-7792f0228545"
    },
    {
      id: "1829d161-b03b-4884-af61-5e1b807ad288",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77b2a1b5-2faa-4544-9537-fdb949afb9e4",
      target: "e19f29f6-4f45-404e-b334-cd4a91f27b60"
    },
    {
      id: "63481496-26e6-4557-8853-e73e1809248b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1da1079c-3fca-4aba-89b5-cd3b2301e2f7",
      target: "4b18be79-bf32-452c-a06b-f260d38ba0e4"
    },
    {
      id: "4cc1fb07-8ca7-4f37-b54d-a68f6a470e35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b18be79-bf32-452c-a06b-f260d38ba0e4",
      target: "f99a7478-9f2c-42a9-b8d9-e8dbed7f07d9"
    },
    {
      id: "c1d2557f-a769-4a8c-9d8f-e2a930756ca7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b18be79-bf32-452c-a06b-f260d38ba0e4",
      target: "ed7deb49-ca4e-4b2b-888b-59bc1e4264c8"
    },
    {
      id: "2cf4e1e6-e28f-42f7-a694-763b757e2726",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ed7deb49-ca4e-4b2b-888b-59bc1e4264c8",
      target: "a9c8980e-ae47-4854-9c54-d9ea933163dc"
    },
    {
      id: "7a310aa1-8839-4e87-9dee-9f00d68e907c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f99a7478-9f2c-42a9-b8d9-e8dbed7f07d9",
      target: "a9c8980e-ae47-4854-9c54-d9ea933163dc"
    },
    {
      id: "2318da20-bfc6-46e2-a32d-6afb98c70017",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf"
    },
    {
      id: "bcef3f32-8b22-47a3-839f-acea2dc0b720",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2"
    },
    {
      id: "098ce239-a723-4417-b49b-feacc0885376",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "c579c42d-8117-4e95-992b-8033ccbb27ac"
    },
    {
      id: "a3678d61-8b94-4900-9612-3a30f823e667",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "5b2d2ae6-4ca3-441d-96a8-e408faadc217",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e"
    },
    {
      id: "a5ce5f7c-f889-4078-ba7d-35ef4507952f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9c8980e-ae47-4854-9c54-d9ea933163dc",
      target: "d5f395af-487c-4217-9d5f-219617efce48"
    },
    {
      id: "8d22d9cd-a25b-40d1-a12c-55a986ef8685",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9ce46dcd-6136-4213-ba99-50c5d46bc9c3",
      target: "e677d5ef-4096-4d6a-85df-67e542e344ed"
    },
    {
      id: "d4b80e56-9cd1-4e2a-95d6-68d57b8733e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ce46dcd-6136-4213-ba99-50c5d46bc9c3",
      target: "b6935558-e269-48b5-9d3a-58f50aa9c697"
    },
    {
      id: "8fd4eb58-277f-445c-8c21-e0d307be8d1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6935558-e269-48b5-9d3a-58f50aa9c697",
      target: "f1af65f9-3654-4afc-b2f7-5da348865ff4"
    },
    {
      id: "12a33736-c440-4a7a-aec2-e7e801b0226c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1af65f9-3654-4afc-b2f7-5da348865ff4",
      target: "532d2c6e-2c95-4dcc-8b28-853d48f9f8c7"
    },
    {
      id: "6c3d0414-e233-4dd4-a95d-f9b5e7bd8738",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "532d2c6e-2c95-4dcc-8b28-853d48f9f8c7",
      target: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b"
    },
    {
      id: "44208595-05a8-493e-a25d-6d2bcf2fdb26",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "532d2c6e-2c95-4dcc-8b28-853d48f9f8c7",
      target: "9346e796-ac70-40ae-b08f-1cf53c86c028"
    },
    {
      id: "c361d019-d2f5-4a4c-8f3f-b07b17a21706",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "5c52bd43-335d-443d-8a4e-f9a8b9da33c7"
    },
    {
      id: "a167de8a-5197-4c77-90cc-0653444abd74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "872919ad-2548-48a6-91c7-3ef0be71c798",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "514fd011-bf24-4893-b099-d913d65e9062"
    },
    {
      id: "68523983-55a3-4b87-a0e9-8470174fb773",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "b6fce1c3-c853-464b-9031-deaf389a90c0"
    },
    {
      id: "3b70c18b-09bb-472e-a58a-103873d57fce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "a68785ca-5179-44d9-8c53-bc8f66352efa"
    },
    {
      id: "cacf2d92-b1d5-42dd-a2ca-bc59e1a25a8a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "c7b21fff-59b1-4351-ae73-34e1aa35e758"
    },
    {
      id: "bb41744e-d7c8-4d8c-9728-f3d74c097fea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "4f28e0d8-9a4f-46cc-b5aa-639e59bbe890"
    },
    {
      id: "d9e7816a-afdc-4c01-9d16-a49aee0118c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "8a070199-b6ff-4175-af1e-e04030bd4a41"
    },
    {
      id: "c85a35db-e09d-40c1-92d6-20667d99f7d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "e677d5ef-4096-4d6a-85df-67e542e344ed"
    },
    {
      id: "ffe489bf-fb01-4b96-b072-18d0525f8365",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "526a274e-9cc5-4013-9d2a-d47f3275397a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aeeda65-56ca-4ed2-b228-14a9238ade1f",
      target: "9ce46dcd-6136-4213-ba99-50c5d46bc9c3"
    },
    {
      id: "382f8619-fa14-48d4-bb06-d3281adf55f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "0ef68479-a73e-44d5-8cf6-7186bbdae44f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      target: "a78c948f-f3bd-4b71-a9b7-97fc7af1e375"
    },
    {
      id: "5358ae0c-80f3-42ab-bd1f-7e203c404cbb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      target: "450bc5af-5b37-4cfc-abc8-6b78de04d845"
    },
    {
      id: "d85adb37-38b7-4c03-a38f-25e9c268cbf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      target: "829f9e87-e103-4200-a8ff-a6b0daa48b58"
    },
    {
      id: "51e62c5e-92fd-4902-ab6d-718f1345ea16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a070199-b6ff-4175-af1e-e04030bd4a41",
      target: "a68785ca-5179-44d9-8c53-bc8f66352efa"
    },
    {
      id: "a399c1ef-647f-46f9-895d-a8c09d0c67a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      target: "1f204fdb-6b2c-43d8-aa84-08395321c6b1"
    },
    {
      id: "4ccd4f69-9ffd-4012-9c41-3015777fbf2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      target: "c35abc49-152c-4331-98d8-5370416ca04b"
    },
    {
      id: "cc8e3dc4-dd6d-45ca-98d2-bf49adf55353",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      target: "095920e6-a996-4247-90f9-ea3b2164de0b"
    },
    {
      id: "fc786466-c32f-4d32-bd74-0adb3cf5afcf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      target: "16772213-e8e7-4430-9271-e32d23148879"
    },
    {
      id: "291e410d-584a-444b-a4c2-abfb717a73bf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a68785ca-5179-44d9-8c53-bc8f66352efa",
      target: "605cd4c2-dbc1-4e93-b828-a22ff8394e47"
    },
    {
      id: "475caad3-0db6-47a7-8dff-114e8c7b9382",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      target: "547e49e5-1db2-4c6c-973e-35a2b28a24bf"
    },
    {
      id: "94537995-9f0c-4dfa-80eb-723aa9468357",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      target: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76"
    },
    {
      id: "bae706b7-5c1d-47f9-b246-d8eda41aa6e6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      target: "044a026a-3406-4f8f-a7dc-50b2e6ab2056"
    },
    {
      id: "0788739f-8603-4aa2-8fed-05ecbc07dbe2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      target: "f3bb6587-c43c-4ad2-b8b0-e68de35e4577"
    },
    {
      id: "7de02421-50b4-4c93-b02f-129ae67b7aea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f204fdb-6b2c-43d8-aa84-08395321c6b1",
      target: "16772213-e8e7-4430-9271-e32d23148879"
    },
    {
      id: "7b0cfd5a-ada3-470b-91b1-4a07ba6571d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16772213-e8e7-4430-9271-e32d23148879",
      target: "077cbf67-e6b9-4ef9-a925-b08d253ac77b"
    },
    {
      id: "2ab28c2f-dc02-4d6f-8770-b2b74f105b11",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "16772213-e8e7-4430-9271-e32d23148879",
      target: "bb139fcd-3f99-430d-82b9-b48a4292c4b7"
    },
    {
      id: "727f9753-e2d3-4ccd-be36-e97e174d85fd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "16772213-e8e7-4430-9271-e32d23148879",
      target: "a22556d9-2392-4203-ae05-8629494d46e2"
    },
    {
      id: "285c108e-8698-42f4-a625-92f8f17bd224",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16772213-e8e7-4430-9271-e32d23148879",
      target: "a60b1c60-082a-432c-8ac6-7d6487a44ad8"
    },
    {
      id: "7ce1b544-365e-4e1e-84ef-d7e596093aff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "16772213-e8e7-4430-9271-e32d23148879",
      target: "1da1079c-3fca-4aba-89b5-cd3b2301e2f7"
    },
    {
      id: "a4f65219-2ba9-4e25-9990-69fde98ab865",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11fec865-82fd-4d55-9837-1d0b01e9ed09",
      target: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365"
    },
    {
      id: "1b783b17-66a1-42d0-8337-fbe226d3be48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11fec865-82fd-4d55-9837-1d0b01e9ed09",
      target: "0bc000c0-a4a6-48c2-b637-fdec31501313"
    },
    {
      id: "bb8bf705-c039-412d-8abd-e2be40976ca8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb"
    },
    {
      id: "39fccfa1-b948-4f3a-886e-10663a2042b1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "35902e13-7819-4cc8-9f37-be61c40d5c55"
    },
    {
      id: "defa55d3-ec8a-4cdf-8474-8a4cf1cbfafc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "7c92018d-4ef4-44d4-b45d-f78f6e1f432b"
    },
    {
      id: "868c43b0-21c0-4e43-8920-2a3775771346",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "80cf852a-b67e-4e92-9873-dbb6d23e3f09"
    },
    {
      id: "3bb86ed8-5255-4205-a9d9-87d289d95472",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "6c5115da-258d-42c7-aaeb-764762e8bf7d"
    },
    {
      id: "b050ce9e-6146-4258-8fc1-39835f2633c6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "f9f209a6-05a3-491c-8a4f-9b1cd1d20320"
    },
    {
      id: "bec5b746-5478-4bda-a153-5b4fc2113561",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "de1c604e-259c-455b-aba8-b8672d8d9090"
    },
    {
      id: "8cbb7f64-6fbd-4a8c-8124-593707e86ae6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2b7859ff-3ce8-4c74-bba1-7a88279cd8c8",
      target: "48e84d90-b240-4940-8943-ff56c16d17fb"
    },
    {
      id: "449cf41b-8d35-4d84-a705-74ec70d72588",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f9f209a6-05a3-491c-8a4f-9b1cd1d20320",
      target: "bdeffa65-18e5-4bfb-aec1-113fa5d5b78c"
    },
    {
      id: "a42677a1-0c8f-4cc5-b32c-2c5b38d6802a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c92018d-4ef4-44d4-b45d-f78f6e1f432b",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "d2d27bd8-4fe4-4d42-8760-7282d3b0725a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80cf852a-b67e-4e92-9873-dbb6d23e3f09",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "d1d9cf6d-0adc-4be3-be52-48d4187c8fd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35902e13-7819-4cc8-9f37-be61c40d5c55",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "90625134-b5ad-42e4-b7b0-5f16361442a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de1c604e-259c-455b-aba8-b8672d8d9090",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "5467eeff-7dbb-4212-a8b7-3cc14333ab00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c5115da-258d-42c7-aaeb-764762e8bf7d",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "cb490ed0-2d1a-40d6-b16c-1257dacf85ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48e84d90-b240-4940-8943-ff56c16d17fb",
      target: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea"
    },
    {
      id: "dcfaced2-911c-4984-af08-2a6fb66d8a9f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "48e84d90-b240-4940-8943-ff56c16d17fb",
      target: "d13373ef-6938-4ae5-a189-45a7468673f4"
    },
    {
      id: "8a728eb9-8649-4e3e-a7d8-030eae9a9f21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d13373ef-6938-4ae5-a189-45a7468673f4",
      target: "631a9da3-4e12-4858-8213-16ceabad8397"
    },
    {
      id: "60a6629e-9f40-4b17-bd83-64c69f333d9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea",
      target: "631a9da3-4e12-4858-8213-16ceabad8397"
    },
    {
      id: "7db088f1-3964-43ef-9b57-90ec01d1b05e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8aaada86-3f5f-4aee-9b8d-67d5dab93bea",
      target: "acd5d259-ab2a-4083-9779-8d509acf67ed"
    },
    {
      id: "05ac5a2a-7c1e-4c9c-bb69-958efc04586f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "9346e796-ac70-40ae-b08f-1cf53c86c028"
    },
    {
      id: "6e6518ff-f2d4-4743-b2c9-4cf295f5d87f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "c7024785-c02e-4646-abe6-842adce73ae2"
    },
    {
      id: "98eb1dbf-b03f-4280-8d21-2e2a50e03fed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "d426c6ea-5246-425d-93d9-fc6d44805b6d"
    },
    {
      id: "3304f675-1d6f-4db3-8357-b4504f57cee9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "59d03ba3-0931-419c-8f52-273d08dd5677",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "bdeffa65-18e5-4bfb-aec1-113fa5d5b78c"
    },
    {
      id: "7a2328d0-055d-42ae-81a9-ccc83ec5392c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "1eb6eec4-7ab1-4793-9a26-f5c0223841db"
    },
    {
      id: "f34f0208-570b-42b8-997c-e62123ed8441",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "8203e406-f0f6-4aaf-859d-d66383b5d901"
    },
    {
      id: "858985ad-d172-4da3-b0b6-889a7c3ac2b6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "a3b051f5-2345-4b02-b5b9-adf72c69821d"
    },
    {
      id: "108c9659-eaad-4c79-a316-ef9c654e0ff8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631a9da3-4e12-4858-8213-16ceabad8397",
      target: "9f8d6d99-64b3-493a-a11f-6f2819d1197a"
    },
    {
      id: "019c083c-9785-41e9-8c2b-b96dbcbfb0ff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "8203e406-f0f6-4aaf-859d-d66383b5d901"
    },
    {
      id: "ace1c9d3-e1e8-4658-b4bd-3183a83f6a3b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "1eb6eec4-7ab1-4793-9a26-f5c0223841db"
    },
    {
      id: "ca14aa0a-896b-4c2e-a735-4d009e221d80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "e69277ce-4372-44c6-b25b-76e89756a2b2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "d426c6ea-5246-425d-93d9-fc6d44805b6d"
    },
    {
      id: "adb1e03e-6da1-4cc5-9784-61bfbf293dd4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "94535701-0b2c-47fb-8884-38987644a8c3"
    },
    {
      id: "160bcc36-fcdd-4139-89b0-8b6f4eda1570",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "bdeffa65-18e5-4bfb-aec1-113fa5d5b78c"
    },
    {
      id: "0b2aefb6-fe05-43c2-8be9-3b0d4a863964",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "a3b051f5-2345-4b02-b5b9-adf72c69821d"
    },
    {
      id: "65c4e824-059e-45ce-9f81-85f9002f1a7e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "9f8d6d99-64b3-493a-a11f-6f2819d1197a"
    },
    {
      id: "ef58585e-1381-4fd0-9ffd-b7975158a6fa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9346e796-ac70-40ae-b08f-1cf53c86c028",
      target: "c7024785-c02e-4646-abe6-842adce73ae2"
    },
    {
      id: "0e777e82-1d13-4c4c-b618-d8d5fd0c29de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdeffa65-18e5-4bfb-aec1-113fa5d5b78c",
      target: "58e48c73-3f84-4822-83a6-f0ae02bb561a"
    },
    {
      id: "42dd5b13-9507-4a38-a4bb-9e407ec091b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d426c6ea-5246-425d-93d9-fc6d44805b6d",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "55e3064d-5d9c-47be-a646-3dff022aac07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d426c6ea-5246-425d-93d9-fc6d44805b6d",
      target: "94535701-0b2c-47fb-8884-38987644a8c3"
    },
    {
      id: "f257a681-8b32-446a-ac10-395f6c4797cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8203e406-f0f6-4aaf-859d-d66383b5d901",
      target: "94535701-0b2c-47fb-8884-38987644a8c3"
    },
    {
      id: "92a4dabc-fb0a-4ba9-9b50-36b7aa1b0b53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8203e406-f0f6-4aaf-859d-d66383b5d901",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "81017a46-3647-46fc-b984-e283aa36cbf8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3b051f5-2345-4b02-b5b9-adf72c69821d",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "abb8034c-9964-4e80-8d6f-9aa179da06d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7024785-c02e-4646-abe6-842adce73ae2",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "f9ba6f8a-df70-4667-8b45-4423e7be6f90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f8d6d99-64b3-493a-a11f-6f2819d1197a",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "5d27a037-4287-4918-a7a5-0437551f74d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1eb6eec4-7ab1-4793-9a26-f5c0223841db",
      target: "ce7cb5f0-235d-4c03-92b0-77a564aac29b"
    },
    {
      id: "48d1930f-5a50-4e5b-9f60-15550585036b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce7cb5f0-235d-4c03-92b0-77a564aac29b",
      target: "99cbbd15-4939-4671-988d-7a8f895f9753"
    },
    {
      id: "0d8350c5-8059-4e27-9683-51794227a3a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94535701-0b2c-47fb-8884-38987644a8c3",
      target: "58e48c73-3f84-4822-83a6-f0ae02bb561a"
    },
    {
      id: "8d6404a4-9f0f-4fef-9f01-076f178bfb76",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99cbbd15-4939-4671-988d-7a8f895f9753",
      target: "18f6549c-2d1d-4618-aa99-e759b881d1e0"
    },
    {
      id: "6a534ece-49d8-4d37-8863-facf028075b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99cbbd15-4939-4671-988d-7a8f895f9753",
      target: "2d4e0451-9b9a-4336-9df3-08aedb856e2c"
    },
    {
      id: "c6f44b80-47f7-4f13-8107-f1a9db1aceac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99cbbd15-4939-4671-988d-7a8f895f9753",
      target: "824a85a2-b289-4507-b314-eb4bc62c0cf5"
    },
    {
      id: "d1efb13f-e479-40ba-9f56-a22e65c37676",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18f6549c-2d1d-4618-aa99-e759b881d1e0",
      target: "58e48c73-3f84-4822-83a6-f0ae02bb561a"
    },
    {
      id: "f3195fca-af9d-454d-ae92-365d67e75e5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "824a85a2-b289-4507-b314-eb4bc62c0cf5",
      target: "58e48c73-3f84-4822-83a6-f0ae02bb561a"
    },
    {
      id: "85db8e48-8918-4f0d-82c5-c42fa26d404f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d4e0451-9b9a-4336-9df3-08aedb856e2c",
      target: "58e48c73-3f84-4822-83a6-f0ae02bb561a"
    },
    {
      id: "c4e62d29-dd4a-4371-a84b-27c983184373",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58e48c73-3f84-4822-83a6-f0ae02bb561a",
      target: "67e997d3-7920-495b-96b5-9b07c45c40b8"
    },
    {
      id: "095e3962-752a-4c93-a085-41931930b6ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58e48c73-3f84-4822-83a6-f0ae02bb561a",
      target: "f75648e6-476e-4497-9e63-3a1b53a93c46"
    },
    {
      id: "ad5300b0-4551-4912-be5c-58fff4883e52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75648e6-476e-4497-9e63-3a1b53a93c46",
      target: "3629411e-29c8-40a6-97e6-4f6f01e9cecb"
    },
    {
      id: "5bbfbd23-e078-4afc-ade4-36b27168642e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75648e6-476e-4497-9e63-3a1b53a93c46",
      target: "9e08144e-63eb-4a7a-af34-eaa7b194218e"
    },
    {
      id: "0b5706c2-8b3e-448b-a7ab-03236957be37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75648e6-476e-4497-9e63-3a1b53a93c46",
      target: "a2312a1a-59ba-4a5a-abcd-1caa5a1c9d79"
    },
    {
      id: "444f09b7-d84e-4550-926b-99d13d7d4911",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75648e6-476e-4497-9e63-3a1b53a93c46",
      target: "edb74c16-cc04-43f5-99a4-e42d4d4c2874"
    },
    {
      id: "244e6087-9a6e-4720-bc60-911d2b626699",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      target: "3629411e-29c8-40a6-97e6-4f6f01e9cecb"
    },
    {
      id: "afe51dbc-0975-43c7-aeae-28942b4dcdbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      target: "9e08144e-63eb-4a7a-af34-eaa7b194218e"
    },
    {
      id: "a5ecc46d-f9ff-4e13-b452-c00202d82b38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      target: "a2312a1a-59ba-4a5a-abcd-1caa5a1c9d79"
    },
    {
      id: "ef0fdac6-a9c5-4561-94fb-5dd8795f365f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      target: "46e56e0c-0cde-489b-b6c3-385c7fad9390"
    },
    {
      id: "610602d7-595a-4020-b358-9260a628226d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "67e997d3-7920-495b-96b5-9b07c45c40b8",
      target: "edb74c16-cc04-43f5-99a4-e42d4d4c2874"
    },
    {
      id: "778a008d-ce8c-4b3f-a207-fae163d77c16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46e56e0c-0cde-489b-b6c3-385c7fad9390",
      target: "973f1515-8913-4dde-8810-139103574822"
    },
    {
      id: "e27aa5a6-3a9d-431a-913f-1a3ebbb22ed7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "973f1515-8913-4dde-8810-139103574822",
      target: "6adae03f-5c9c-48b4-8f46-f5c29ada199e"
    },
    {
      id: "e925578e-c9ff-4bdf-bbdd-1b58e38a3d47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edb74c16-cc04-43f5-99a4-e42d4d4c2874",
      target: "b1180801-66be-4b3c-8312-7b72561ddb83"
    },
    {
      id: "c2efd6d4-49cb-4885-9884-91513c1ec24d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e08144e-63eb-4a7a-af34-eaa7b194218e",
      target: "b1180801-66be-4b3c-8312-7b72561ddb83"
    },
    {
      id: "7c2db4cc-1007-401f-9b00-a9f14f175328",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3629411e-29c8-40a6-97e6-4f6f01e9cecb",
      target: "b1180801-66be-4b3c-8312-7b72561ddb83"
    },
    {
      id: "2ba5dd84-3da0-4103-89c1-593c772e294f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2312a1a-59ba-4a5a-abcd-1caa5a1c9d79",
      target: "b1180801-66be-4b3c-8312-7b72561ddb83"
    },
    {
      id: "a297c661-5f4a-442e-b63d-232c4629bcbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6adae03f-5c9c-48b4-8f46-f5c29ada199e",
      target: "1f73dc1e-53be-4d7a-aba4-9bca5bef8348"
    },
    {
      id: "253116fa-2201-43ae-9227-9d9458f2b51e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b28c5c6-661a-489f-b668-4e0eb274e4eb",
      target: "1f73dc1e-53be-4d7a-aba4-9bca5bef8348"
    },
    {
      id: "3a1bb1fa-9745-429d-afa3-dcbbc244d3dd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b1180801-66be-4b3c-8312-7b72561ddb83",
      target: "6b28c5c6-661a-489f-b668-4e0eb274e4eb"
    },
    {
      id: "92a4c5a6-469d-44ef-989c-ffa249257b46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1180801-66be-4b3c-8312-7b72561ddb83",
      target: "ba49dc6d-1ba5-4905-a8fd-0cce32088ffc"
    },
    {
      id: "7e5f3476-ce4d-4c83-a0a2-8c44cb4349af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b1180801-66be-4b3c-8312-7b72561ddb83",
      target: "1f73dc1e-53be-4d7a-aba4-9bca5bef8348"
    },
    {
      id: "d9752452-93ca-42f8-824a-6972f7e7e2e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f73dc1e-53be-4d7a-aba4-9bca5bef8348",
      target: "aff69d35-3ccf-4f09-96e3-c01e2717eacd"
    },
    {
      id: "0940a315-10d6-4667-aece-277d2bd3ddcb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "aff69d35-3ccf-4f09-96e3-c01e2717eacd",
      target: "e96128c0-cee5-4dd2-9304-c284387627bb"
    },
    {
      id: "a41d38f0-8be1-463f-98d0-83fb8da671a6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aff69d35-3ccf-4f09-96e3-c01e2717eacd",
      target: "ba49dc6d-1ba5-4905-a8fd-0cce32088ffc"
    },
    {
      id: "e99961d1-b0ed-4217-a3b2-204459f09ea8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ba49dc6d-1ba5-4905-a8fd-0cce32088ffc",
      target: "e96128c0-cee5-4dd2-9304-c284387627bb"
    },
    {
      id: "32a61281-16df-48fd-bc7d-77a187e3e203",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d05b14e-8092-4263-a869-e1aa9684708b",
      target: "65fb539d-2884-4e5b-929c-9b64174cbc72"
    },
    {
      id: "099dc39c-8e64-44f4-a035-a1a1910b15ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e96128c0-cee5-4dd2-9304-c284387627bb",
      target: "4d05b14e-8092-4263-a869-e1aa9684708b"
    },
    {
      id: "1c1da3de-8a74-48d7-97b0-1b058e015bff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e96128c0-cee5-4dd2-9304-c284387627bb",
      target: "4d05b14e-8092-4263-a869-e1aa9684708b"
    },
    {
      id: "aa2d85c6-de71-4ea5-80f0-b47e648e7a17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65fb539d-2884-4e5b-929c-9b64174cbc72",
      target: "afb52c0f-ded1-4d02-87df-7d1e15b940db"
    },
    {
      id: "cd35be54-d0aa-477a-8c10-470bbb550e38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "65fb539d-2884-4e5b-929c-9b64174cbc72",
      target: "0bc000c0-a4a6-48c2-b637-fdec31501313"
    },
    {
      id: "c0fd1883-4f65-4ce7-a5f3-d2ee8d4e4a32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bc000c0-a4a6-48c2-b637-fdec31501313",
      target: "b8bf1adb-9818-411c-99cd-e3af7577367d"
    },
    {
      id: "4612b968-d468-4005-b678-947580ce246e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bc000c0-a4a6-48c2-b637-fdec31501313",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "e6936491-aef4-4046-b067-a09c1674bb0c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33b66c03-5d4f-41d0-9e72-ad3eec5e406a",
      target: "80fc92d8-19b9-4d59-a99f-fd12ecb81788"
    },
    {
      id: "28784b04-4573-4bb1-a7d5-a501b369fb48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "483eca18-28d5-4caf-9111-a35672f93c2d",
      target: "52278f4a-12b3-4bea-8257-b0cbcb0970f5"
    },
    {
      id: "0e3b0b9c-e37f-431e-9282-1add6c5c2f43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3fe2faa5-3259-4b61-94f6-4dea7db724d6",
      target: "48d1d251-23e1-4a82-a01d-599d571d4767"
    },
    {
      id: "839a09a5-25f3-43ac-bc8e-e4b9c5052982",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78379811-55be-4062-a0ae-3a83ee9504dd",
      target: "52278f4a-12b3-4bea-8257-b0cbcb0970f5"
    },
    {
      id: "c4856d3c-f43c-41e7-9e82-72d1d690b028",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "313067ee-9a0b-46a8-9653-1002e5481ee9",
      target: "52278f4a-12b3-4bea-8257-b0cbcb0970f5"
    },
    {
      id: "2aa9491b-e2df-4c97-9544-3d4a64cc0967",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc93e67c-506a-4812-b130-fbe06295ed97",
      target: "52278f4a-12b3-4bea-8257-b0cbcb0970f5"
    },
    {
      id: "605dc2bc-eb1d-4494-a688-4e74a08d8df5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52278f4a-12b3-4bea-8257-b0cbcb0970f5",
      target: "a1e50c0f-32aa-4860-b4ff-e27de2cbd78d"
    },
    {
      id: "d3bb824e-7b3b-4836-96ac-00b3cd87c82c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52278f4a-12b3-4bea-8257-b0cbcb0970f5",
      target: "662f6f65-5382-49f8-ad7b-73485ade0333"
    },
    {
      id: "ba5ca885-0e22-441d-890f-21ae9d318755",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "48d1d251-23e1-4a82-a01d-599d571d4767",
      target: "80fc92d8-19b9-4d59-a99f-fd12ecb81788"
    },
    {
      id: "a914f4fd-a95a-451b-a0c2-364a6f3b65f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80fc92d8-19b9-4d59-a99f-fd12ecb81788",
      target: "734e9261-e49a-48e8-bbc9-f2b6165c342a"
    },
    {
      id: "a668898b-15c2-4fe2-953f-ae2c942709b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "734e9261-e49a-48e8-bbc9-f2b6165c342a",
      target: "a1d2668d-517b-419d-ae83-f7e3aa88721a"
    },
    {
      id: "62b0e721-b6ee-4b3e-afe3-e593b143d59d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1d2668d-517b-419d-ae83-f7e3aa88721a",
      target: "46a19152-5ebc-47d3-89d8-887c11a3eae2"
    },
    {
      id: "d08f5c1c-df29-4208-a315-83ec28e8fe82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1d2668d-517b-419d-ae83-f7e3aa88721a",
      target: "bf911267-61f9-4a45-932f-27b42afeee34"
    },
    {
      id: "5858af6c-dec9-4900-a0b1-d360dfe4c583",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1d2668d-517b-419d-ae83-f7e3aa88721a",
      target: "a743ba5d-b49f-4e1d-b106-26c85a6eb0fc"
    },
    {
      id: "404ce59b-a974-4989-ab39-ffa1177fe049",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1d2668d-517b-419d-ae83-f7e3aa88721a",
      target: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad"
    },
    {
      id: "abec3a6b-a9c4-4a51-becf-93ffa152846e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad",
      target: "662f6f65-5382-49f8-ad7b-73485ade0333"
    },
    {
      id: "f7f6adb6-4e9e-4896-acaa-2d1e03a85452",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad",
      target: "59e7d533-0202-4d55-9b67-3defcf48ed34"
    },
    {
      id: "f5635088-acc0-46a6-895d-d64ffe80268e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad",
      target: "a1e50c0f-32aa-4860-b4ff-e27de2cbd78d"
    },
    {
      id: "3f41a0fb-4a46-4408-a7af-d871286fe63b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83c13c34-f8da-4601-94e4-0ea97f4cb1ad",
      target: "37a64b19-679a-4612-9e9d-d9ee450fb456"
    },
    {
      id: "3803eedb-6c3a-4c37-8e90-a35267ae88b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46a19152-5ebc-47d3-89d8-887c11a3eae2",
      target: "662f6f65-5382-49f8-ad7b-73485ade0333"
    },
    {
      id: "f1eb163e-9df7-4607-84f3-190c22ef6204",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46a19152-5ebc-47d3-89d8-887c11a3eae2",
      target: "37a64b19-679a-4612-9e9d-d9ee450fb456"
    },
    {
      id: "35171790-0920-4f26-9bf4-7fb3c0ead7ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46a19152-5ebc-47d3-89d8-887c11a3eae2",
      target: "a1e50c0f-32aa-4860-b4ff-e27de2cbd78d"
    },
    {
      id: "f700600b-9cc1-4dc3-a73d-ae3cb9b12874",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37a64b19-679a-4612-9e9d-d9ee450fb456",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "661b2f22-26e5-4160-a1c0-846bce667a37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "662f6f65-5382-49f8-ad7b-73485ade0333",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "f2ce8ae6-3099-4f6d-9dc2-2c9579e05b83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1e50c0f-32aa-4860-b4ff-e27de2cbd78d",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "052869b3-8db5-4574-a937-ef24668a4e3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59e7d533-0202-4d55-9b67-3defcf48ed34",
      target: "68a44023-5b0c-40f1-9ebc-de8169a80bba"
    },
    {
      id: "59cb879f-1cf0-491e-84fe-4ec8a0e2f5ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68a44023-5b0c-40f1-9ebc-de8169a80bba",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "2370dde5-d0a9-4f0e-a5d8-5962fdad24e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5001e7cf-5af8-4b18-be45-c03477429479",
      target: "0bc000c0-a4a6-48c2-b637-fdec31501313"
    },
    {
      id: "e3e92efb-d957-451c-b4ed-282a69c870cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5001e7cf-5af8-4b18-be45-c03477429479",
      target: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8"
    },
    {
      id: "436dd52d-8540-44a6-971e-094d2c09a445",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "bc93e67c-506a-4812-b130-fbe06295ed97"
    },
    {
      id: "21d514f6-3ea5-4daa-b94d-9b09bcb806a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "78379811-55be-4062-a0ae-3a83ee9504dd"
    },
    {
      id: "fd308dfc-545a-4c50-94f2-c351ee43952f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "d160a1b3-d6be-4739-b254-2df997a1dfa2"
    },
    {
      id: "2ed1175a-d25d-4300-beeb-508dec07067d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "5cd05ebf-e3f6-418a-b4a4-5e2b32f12b30"
    },
    {
      id: "58b7891c-5d23-4540-a858-e70b4d04d4bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "313067ee-9a0b-46a8-9653-1002e5481ee9"
    },
    {
      id: "b766ecd8-172c-498b-bc82-6824a5408504",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "3fe2faa5-3259-4b61-94f6-4dea7db724d6"
    },
    {
      id: "f84d27ad-55c3-4264-b520-79d36a633e62",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "33b66c03-5d4f-41d0-9e72-ad3eec5e406a"
    },
    {
      id: "789a18e4-7148-4caa-a974-b13884d542dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd5d259-ab2a-4083-9779-8d509acf67ed",
      target: "483eca18-28d5-4caf-9111-a35672f93c2d"
    },
    {
      id: "001cb81a-2242-484a-a169-8637993df063",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a743ba5d-b49f-4e1d-b106-26c85a6eb0fc",
      target: "61932347-a07c-4afd-b767-fdd5f24e3878"
    },
    {
      id: "9a8debd1-9c28-4351-b7f1-48671a5d6e81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61932347-a07c-4afd-b767-fdd5f24e3878",
      target: "73d45fb1-cf70-4062-be84-9a0187710d0f"
    },
    {
      id: "e7c37288-4316-4812-a6f7-11b77b0eef2a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d45fb1-cf70-4062-be84-9a0187710d0f",
      target: "4f6868f3-0d9d-45a5-9d7c-eb4cc9efc93b"
    },
    {
      id: "84f80067-9a54-4a02-b2db-d82f8b400ed3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f6868f3-0d9d-45a5-9d7c-eb4cc9efc93b",
      target: "e1b04186-76b7-44f4-bacd-4c5523139381"
    },
    {
      id: "0fbb5886-a9ec-4fbd-81e9-5635cd611acc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f6868f3-0d9d-45a5-9d7c-eb4cc9efc93b",
      target: "a1319814-a9bd-433f-a01e-23b0901c449b"
    },
    {
      id: "aa358cc3-d5c6-443f-a950-c30737f4b459",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1319814-a9bd-433f-a01e-23b0901c449b",
      target: "1cd5d6e0-2628-4a52-b015-4495ca01939d"
    },
    {
      id: "a2dc5760-6268-45df-8e24-361e663ac138",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1b04186-76b7-44f4-bacd-4c5523139381",
      target: "c15bba6e-fca1-48cd-9062-95de94b290f7"
    },
    {
      id: "3300fb6d-f66a-4588-b86c-fca6799100dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cd5d6e0-2628-4a52-b015-4495ca01939d",
      target: "c15bba6e-fca1-48cd-9062-95de94b290f7"
    },
    {
      id: "3f4526f2-3d18-44fc-ae20-3f2217941a6f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c15bba6e-fca1-48cd-9062-95de94b290f7",
      target: "3ec8b8b3-4277-47ed-803a-60817f06b87b"
    },
    {
      id: "67c36d21-d3f7-46e8-ad1a-382b5d32da08",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ec8b8b3-4277-47ed-803a-60817f06b87b",
      target: "98a2c595-43fb-4a3d-94e0-39f5e289d6fa"
    },
    {
      id: "a3f62322-c5c1-4eb0-9f11-3ac9052f0301",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a2c595-43fb-4a3d-94e0-39f5e289d6fa",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "22ffd87c-3e14-461b-b2e5-201a4d1758f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf911267-61f9-4a45-932f-27b42afeee34",
      target: "56df9d12-a20d-40b8-9f2e-462f4fab565a"
    },
    {
      id: "94ab7bae-7209-45bd-a8d1-8b410daa0431",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56df9d12-a20d-40b8-9f2e-462f4fab565a",
      target: "798e6053-4095-4d32-abe0-3e15913219d5"
    },
    {
      id: "b8b3f575-3ed4-4547-956b-35d160ae3c4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "798e6053-4095-4d32-abe0-3e15913219d5",
      target: "37518056-3e59-4260-b045-055eb02daf0d"
    },
    {
      id: "1cf585c9-d32e-49bd-b5e8-51d4c01c6d74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37518056-3e59-4260-b045-055eb02daf0d",
      target: "2125dffd-eb96-4124-881d-893a6efb78d8"
    },
    {
      id: "86b57474-ddd8-4c1f-8dc9-d0eedf0ea8ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37518056-3e59-4260-b045-055eb02daf0d",
      target: "2cd5ff34-bbe2-42c3-8131-bac1e3822c9a"
    },
    {
      id: "be8ac97a-ff93-43d9-a11e-5cc99008568a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cd5ff34-bbe2-42c3-8131-bac1e3822c9a",
      target: "0c4e2242-92cb-47ee-9f3a-1332cb5c28ce"
    },
    {
      id: "df792cc7-5c7b-412e-ab82-7e2f2e95acb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2125dffd-eb96-4124-881d-893a6efb78d8",
      target: "5eb03678-14dc-4243-a1cd-00a97485235d"
    },
    {
      id: "0b89148d-2e62-4fc6-a1a7-2fa818c7cd35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c4e2242-92cb-47ee-9f3a-1332cb5c28ce",
      target: "5eb03678-14dc-4243-a1cd-00a97485235d"
    },
    {
      id: "196c5ed7-a831-49fa-ac81-23151fa97308",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5eb03678-14dc-4243-a1cd-00a97485235d",
      target: "cec8a63a-3153-445d-aeb7-cc2c33e5af85"
    },
    {
      id: "f2a77864-df90-4462-a75d-a95eebe5e047",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cec8a63a-3153-445d-aeb7-cc2c33e5af85",
      target: "0b91b206-4834-49db-8c68-87228c7823a7"
    },
    {
      id: "b3d61f9c-b628-4dd2-86f5-d19860c4058e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b91b206-4834-49db-8c68-87228c7823a7",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "7dcd6466-4fe0-4bea-8bd1-e82d0cced70f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cd05ebf-e3f6-418a-b4a4-5e2b32f12b30",
      target: "ec41ab89-7900-47bd-ac5c-05f52ad5d233"
    },
    {
      id: "9c6d373c-f7cb-45c8-9bd0-9a763a129943",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec41ab89-7900-47bd-ac5c-05f52ad5d233",
      target: "25c5bdeb-186a-4e2d-ad2e-78c22078f356"
    },
    {
      id: "3405e0ab-689b-4590-8690-eacb3669442d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "25c5bdeb-186a-4e2d-ad2e-78c22078f356",
      target: "771cb3a0-c1e6-4ba2-a434-0169e82336f5"
    },
    {
      id: "b799e22c-c178-47c4-8ea0-8a9a41ff3fd3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "771cb3a0-c1e6-4ba2-a434-0169e82336f5",
      target: "242b840f-4286-4024-ad0c-d23559852167"
    },
    {
      id: "8b9ae20d-086c-45ea-8929-501752604cf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "242b840f-4286-4024-ad0c-d23559852167",
      target: "acfcd823-2062-4638-9352-8bd5cc797749"
    },
    {
      id: "cf0d3775-a7b7-4b6d-8371-de2aa76c351c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acfcd823-2062-4638-9352-8bd5cc797749",
      target: "a6f6f4c4-075a-42f0-96f1-691c91e026d3"
    },
    {
      id: "f31264a8-e4e5-43c1-b9c3-c025cf409d69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6f6f4c4-075a-42f0-96f1-691c91e026d3",
      target: "abb1ce78-a034-4016-b693-11a6ada2d524"
    },
    {
      id: "ed407b33-dc3f-4718-b78b-2c2987de9c71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb1ce78-a034-4016-b693-11a6ada2d524",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "f8cac8d4-7690-4d3e-b303-b81ea3baf52c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb1ce78-a034-4016-b693-11a6ada2d524",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "ea1d809e-da0c-45bf-be6f-8a7ab3e8507c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb1ce78-a034-4016-b693-11a6ada2d524",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "6649b25c-0b81-43cf-9840-a3a65bd0fd8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb1ce78-a034-4016-b693-11a6ada2d524",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "a2f0b25a-2256-4604-ac9b-0e52f66b50b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abb1ce78-a034-4016-b693-11a6ada2d524",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "f30b0ef2-dd73-4f0d-a343-fa130b50ad6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d160a1b3-d6be-4739-b254-2df997a1dfa2",
      target: "37dfb47a-9eea-4843-9e5a-d54c0928c451"
    },
    {
      id: "fcdebcda-52f5-45e4-ba2b-48cea76b59be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37dfb47a-9eea-4843-9e5a-d54c0928c451",
      target: "37decd77-16ae-4502-9315-7fb05660e29e"
    },
    {
      id: "3e620983-b2c4-46d2-9858-c0625afc6b7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37decd77-16ae-4502-9315-7fb05660e29e",
      target: "ee41aa4a-6e7e-4641-bd29-b9c3facf6a2e"
    },
    {
      id: "bb04cea3-34c7-4be7-b9e9-70c2ff47b1e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ee41aa4a-6e7e-4641-bd29-b9c3facf6a2e",
      target: "7c5f9a71-0fb6-43a9-8af5-472f34d8949e"
    },
    {
      id: "b5a9aaa2-2db3-4415-bef3-513d42bb67bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c5f9a71-0fb6-43a9-8af5-472f34d8949e",
      target: "568ddf74-0210-4ab7-aa8e-7756a7e1c6f0"
    },
    {
      id: "81e7c229-8332-4665-8cfe-93b8c4a54bb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "568ddf74-0210-4ab7-aa8e-7756a7e1c6f0",
      target: "52ac4f47-3c08-4052-acad-659841dd549a"
    },
    {
      id: "876bedb6-fd9a-439f-87eb-b0d670f4ad5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52ac4f47-3c08-4052-acad-659841dd549a",
      target: "8a91548d-9140-48f3-94ca-1cf5257649eb"
    },
    {
      id: "fe2e5396-8a2a-437a-b4f7-1fd9d10534fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "11c6def0-f9e8-4061-93a4-589aa9609372",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "d7098230-8940-469b-8f7e-7c5e4e69b731",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "5ec6d022-0486-480e-9e4f-c0936857422e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      target: "5001e7cf-5af8-4b18-be45-c03477429479"
    },
    {
      id: "e6283b87-2d77-4ddf-b480-585e19994216",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a91548d-9140-48f3-94ca-1cf5257649eb",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "7a1854dc-029f-4031-9065-8d14e0e2a271",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "7e53c3fc-077a-469b-9bd3-28c013d7b1ae"
    },
    {
      id: "58c6d154-bad8-4e96-ba68-ad9a694399d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "16062421-2efe-49ff-8f60-1166653c5e5a"
    },
    {
      id: "75ad4a20-cd32-4fcd-89ea-e85dd3bf222f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "921f6ec7-e1b3-49d0-abd7-8ef1995db419"
    },
    {
      id: "98266f2c-11f1-4ac4-80c0-bb36caa88e77",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "92c2b146-eba7-411a-bbaa-1f913c1b2dc8"
    },
    {
      id: "1ffe3f5c-6b9f-47aa-a9e5-ea43ee515e86",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "5fc00194-0044-41dd-91c0-def3952f5bc9"
    },
    {
      id: "275274b0-5381-42f8-9255-8e8ebb669de2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "11fec865-82fd-4d55-9837-1d0b01e9ed09"
    },
    {
      id: "2e44ca2a-757c-4a33-a1f9-095bffe0a968",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "7487f917-9201-4929-bdfe-a4192e4496dd"
    },
    {
      id: "aed44a1f-17be-4339-82b0-6de2bf1dd82b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "92c2b146-eba7-411a-bbaa-1f913c1b2dc8"
    },
    {
      id: "06985f8b-bc24-4e5a-8a00-ed4e37e9bbc5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "16062421-2efe-49ff-8f60-1166653c5e5a"
    },
    {
      id: "1e6cb990-092c-481b-9831-fbceb1ea3b71",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "921f6ec7-e1b3-49d0-abd7-8ef1995db419"
    },
    {
      id: "1719b23d-1e07-4d12-9dff-95153d813cc3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "7487f917-9201-4929-bdfe-a4192e4496dd"
    },
    {
      id: "34c4dbb6-8b95-4143-b3a4-422173a2ecc7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "38449171-2983-4540-b062-063db31f6ad1"
    },
    {
      id: "b1a5cc56-de89-41c6-92ea-4e5d7e4c5554",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "38449171-2983-4540-b062-063db31f6ad1"
    },
    {
      id: "dca95f98-fb0a-4e3d-9b50-d97cf8b59024",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "7e53c3fc-077a-469b-9bd3-28c013d7b1ae"
    },
    {
      id: "18ef772d-0647-430b-9c2b-f93fda5977d6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7fed5d-5a9f-4e0b-a5b2-4267b618b9cb",
      target: "5fc00194-0044-41dd-91c0-def3952f5bc9"
    },
    {
      id: "c2597c03-33d0-4810-b2f8-301f652fd07b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16062421-2efe-49ff-8f60-1166653c5e5a",
      target: "478f4b22-0e5d-4360-a1a8-fb79d4a93143"
    },
    {
      id: "47fcc623-ba6a-4fee-9e0e-dfc3996e75ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5fc00194-0044-41dd-91c0-def3952f5bc9",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "c47a2df0-35c8-4c3f-aa92-195b09814fcc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "38449171-2983-4540-b062-063db31f6ad1",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "6d7b7ed9-eb51-475c-9318-518a5eecb3bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7487f917-9201-4929-bdfe-a4192e4496dd",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "db4d3ded-d3e3-4956-a585-3fed57e248a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "92c2b146-eba7-411a-bbaa-1f913c1b2dc8",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "aa075d5a-b6c6-413d-bc24-956a861cca4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e53c3fc-077a-469b-9bd3-28c013d7b1ae",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "7e8a1ba8-c623-4d4a-8121-002681bb9cde",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "921f6ec7-e1b3-49d0-abd7-8ef1995db419",
      target: "f75fdba4-3527-4f6a-b273-f020b5f776ca"
    },
    {
      id: "d3cd358d-dcaa-40b2-8631-581ef8b17952",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "921f6ec7-e1b3-49d0-abd7-8ef1995db419",
      target: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0"
    },
    {
      id: "ccde5e45-da39-4598-b9d3-d0d667839fa9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f75fdba4-3527-4f6a-b273-f020b5f776ca",
      target: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d"
    },
    {
      id: "89091a98-e020-42ed-bdb8-d99d2f39a835",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0",
      target: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d"
    },
    {
      id: "498a7ba6-599d-4558-aaeb-cf9c186fa721",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1e174db-2e54-4dc6-bd87-3a26e6ec4ee0",
      target: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02"
    },
    {
      id: "b0b20482-e6b6-43bc-ae86-655c3491b505",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "a25541c6-ceca-4623-bc06-44d1b4b6ae3b"
    },
    {
      id: "dc71cfbd-c54e-4ce8-8c10-0a73b6c37ac3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "14424aa9-97fa-4efb-94e1-46697b93c640"
    },
    {
      id: "923c9957-cd25-4e25-9c20-088ac895baf1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "6d2754c4-13ac-44a3-82f8-b9c4be704ae6"
    },
    {
      id: "5a0a8a6d-0a80-4797-8929-aae0e1ef6f44",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "7dc87caa-654d-427b-971f-54d347b25bf1"
    },
    {
      id: "37bc8806-32fd-4294-b563-106e73a1cea6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "7c667fef-461d-49e7-92f6-3ef47796ec0e"
    },
    {
      id: "368d46b1-74d1-487f-9998-206baa0fd87a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "584d9f01-6047-49cc-a263-7db299d95a15",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "04c38332-9bab-4f9e-ba02-cac3faefc964"
    },
    {
      id: "c5a8020c-93e4-4769-a619-c8b7304a0717",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "478f4b22-0e5d-4360-a1a8-fb79d4a93143"
    },
    {
      id: "b9fbfccc-153e-4192-939e-e8560eb38586",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "487fd19c-e0bb-4d1c-b954-e6acfed9d60d",
      target: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b"
    },
    {
      id: "6c9a677f-4ccb-4913-827f-19bab3d44b36",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "7c667fef-461d-49e7-92f6-3ef47796ec0e"
    },
    {
      id: "da99abe4-d84a-42ac-9d2a-ebf77a47abf9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "217c98f3-fb71-4a2e-bfaa-1acfcab44f02"
    },
    {
      id: "b50cf84d-df77-4128-8212-41f67378ced2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "7b23f9eb-0c96-4d88-92d7-a21115d94733",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "6d2754c4-13ac-44a3-82f8-b9c4be704ae6"
    },
    {
      id: "8d74edcb-2fd5-401c-97d2-aa1f451aedbc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "14424aa9-97fa-4efb-94e1-46697b93c640"
    },
    {
      id: "0dc5642d-9248-47ee-a14a-cc9b84ead879",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "04c38332-9bab-4f9e-ba02-cac3faefc964"
    },
    {
      id: "9f094a61-e4fb-4707-a9ec-53bc99c0ab10",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "a25541c6-ceca-4623-bc06-44d1b4b6ae3b"
    },
    {
      id: "ef7eb1d8-2f2f-4ac5-9eec-5357f363033a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "478f4b22-0e5d-4360-a1a8-fb79d4a93143"
    },
    {
      id: "67b3d08e-a612-4dca-81ad-0b1995fefde0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec7bfd22-7e03-4922-a518-e40bbe6bdb5b",
      target: "7dc87caa-654d-427b-971f-54d347b25bf1"
    },
    {
      id: "02d6e0b0-2c20-45c9-9be5-b93c0c83d33c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "478f4b22-0e5d-4360-a1a8-fb79d4a93143",
      target: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644"
    },
    {
      id: "ebc04bf6-d25f-4b34-8389-12c039a66fe9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a25541c6-ceca-4623-bc06-44d1b4b6ae3b",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "7f0e7a7f-b257-4af7-bdea-8505a72b8a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a25541c6-ceca-4623-bc06-44d1b4b6ae3b",
      target: "217c98f3-fb71-4a2e-bfaa-1acfcab44f02"
    },
    {
      id: "e8b46f38-10d3-4121-96f1-eec99b624b6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d2754c4-13ac-44a3-82f8-b9c4be704ae6",
      target: "217c98f3-fb71-4a2e-bfaa-1acfcab44f02"
    },
    {
      id: "f6a386f6-c0d5-4dff-9e4b-443c509dc157",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d2754c4-13ac-44a3-82f8-b9c4be704ae6",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "23735068-8e82-439d-9484-b2b7fcc30c41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7dc87caa-654d-427b-971f-54d347b25bf1",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "b9e2b398-48e7-4872-aca4-44c46bc0019e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04c38332-9bab-4f9e-ba02-cac3faefc964",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "21118988-1cd5-461c-8ab1-7f677a73141f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c667fef-461d-49e7-92f6-3ef47796ec0e",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "c25304b8-25f5-4fd2-b357-1d89753b4282",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14424aa9-97fa-4efb-94e1-46697b93c640",
      target: "bc63b7e8-c261-4c29-801a-3ee0059780cd"
    },
    {
      id: "bd193864-0a6e-4b44-aa4e-a40ed4dbc411",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "217c98f3-fb71-4a2e-bfaa-1acfcab44f02",
      target: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644"
    },
    {
      id: "ef368d54-fc1c-4ce8-afeb-35a5e7ba59e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc63b7e8-c261-4c29-801a-3ee0059780cd",
      target: "8b8d9e67-9e52-4f01-8fe5-5de3ea4f7787"
    },
    {
      id: "6da0c0ed-f088-4216-af29-82cae0981b6d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b8d9e67-9e52-4f01-8fe5-5de3ea4f7787",
      target: "869a25ab-7325-4b11-92ab-5d67cd19f1b4"
    },
    {
      id: "e4f6d36c-cc74-4098-8261-7d89d9163314",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b8d9e67-9e52-4f01-8fe5-5de3ea4f7787",
      target: "be385840-ddf5-4459-b03d-3e46bb06e85a"
    },
    {
      id: "6dd2ffc0-aea4-404b-89d2-d9a853f63730",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b8d9e67-9e52-4f01-8fe5-5de3ea4f7787",
      target: "a183a617-56fe-4e7f-9618-2a6398e4dc53"
    },
    {
      id: "031df9e5-ea2a-40c1-9413-daf3ef143eda",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "869a25ab-7325-4b11-92ab-5d67cd19f1b4",
      target: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644"
    },
    {
      id: "010f5015-f297-407a-a762-2525689e3a6f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be385840-ddf5-4459-b03d-3e46bb06e85a",
      target: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644"
    },
    {
      id: "a18006b4-632c-4323-a833-d69bbdb642ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a183a617-56fe-4e7f-9618-2a6398e4dc53",
      target: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644"
    },
    {
      id: "2ffee9b9-f54e-4076-96e0-fda771d36373",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644",
      target: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d"
    },
    {
      id: "6be910e9-a172-4e5c-a021-77354709603f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d49cecc6-78c4-4f07-a2a2-bf0e9acce644",
      target: "82776877-17c6-4167-b7d2-8129286a7a23"
    },
    {
      id: "4a7655eb-b9ee-411f-b4d6-dd0062a16d06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82776877-17c6-4167-b7d2-8129286a7a23",
      target: "d538b943-489c-4266-828e-8fb777bf9199"
    },
    {
      id: "dcb09f97-6d92-4882-a420-faa6f6213b01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82776877-17c6-4167-b7d2-8129286a7a23",
      target: "ccd9eadc-eeca-45cc-ab9a-053bee02a5d1"
    },
    {
      id: "d7197a3a-5ad1-412f-8056-69787f05dcbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82776877-17c6-4167-b7d2-8129286a7a23",
      target: "e9eae808-a58b-4101-b24c-f2e4860ee49b"
    },
    {
      id: "e765c5fa-dcf7-4d52-b236-003477c7a528",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82776877-17c6-4167-b7d2-8129286a7a23",
      target: "ca21d338-b1a3-4b67-a07e-26057f0500ec"
    },
    {
      id: "3dae34e2-3bd2-4050-b5f8-38f4ae0e80ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      target: "37ce2097-b79f-4202-888a-e2567ba22652"
    },
    {
      id: "bf588be0-fcae-486d-932e-80d8637927e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      target: "e9eae808-a58b-4101-b24c-f2e4860ee49b"
    },
    {
      id: "9ca39dc8-ec3e-4616-9144-02120ad437ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      target: "d538b943-489c-4266-828e-8fb777bf9199"
    },
    {
      id: "b5d1938a-9cfa-4c6e-80be-ddab659fa868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      target: "ccd9eadc-eeca-45cc-ab9a-053bee02a5d1"
    },
    {
      id: "f50268d3-ab2c-4703-b542-fda4b0b25d4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f8da500-0760-4c71-9ce0-08cf9e6c4f2d",
      target: "ca21d338-b1a3-4b67-a07e-26057f0500ec"
    },
    {
      id: "f4b57ee6-e7cb-4305-8cb0-e99d4fac6818",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37ce2097-b79f-4202-888a-e2567ba22652",
      target: "5e23355f-0b9f-4bd3-9347-bc985bca315d"
    },
    {
      id: "7953c058-4007-4f8c-b853-76445e4a5b20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca21d338-b1a3-4b67-a07e-26057f0500ec",
      target: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce"
    },
    {
      id: "3268abd7-fb1a-40e1-9ec1-744e09377550",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ccd9eadc-eeca-45cc-ab9a-053bee02a5d1",
      target: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce"
    },
    {
      id: "d8f750ae-1de9-4792-9e50-accaa75322b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9eae808-a58b-4101-b24c-f2e4860ee49b",
      target: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce"
    },
    {
      id: "62170c8a-c1ca-4be8-be14-d8c1f7f642fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d538b943-489c-4266-828e-8fb777bf9199",
      target: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce"
    },
    {
      id: "1ddb0bcc-271e-4070-b237-c1b7f083c69f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e23355f-0b9f-4bd3-9347-bc985bca315d",
      target: "40893fd5-64b3-4680-b21f-bcca4f48556f"
    },
    {
      id: "d0d1b054-8c10-4f8f-a0b0-afb06a120303",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "40893fd5-64b3-4680-b21f-bcca4f48556f",
      target: "7e7a2d37-8a90-4f62-a952-2571c980458a"
    },
    {
      id: "59ff21a5-16f6-4f31-9795-a389c6a246c1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce",
      target: "7e7a2d37-8a90-4f62-a952-2571c980458a"
    },
    {
      id: "f0ddccf1-8415-46a4-9562-f390dc04797d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce",
      target: "66a8db73-01b3-4dc0-a370-a4954cd2aff5"
    },
    {
      id: "6c1e7db7-1d06-4d87-9b8d-7142350f6cf0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ca9e690-6c50-4c46-8c40-69ed1b29a4ce",
      target: "bdfe14a4-f314-4780-b892-2d253d9342b1"
    },
    {
      id: "56ef8c98-3ee5-4631-8897-2bf8f3bae456",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66a8db73-01b3-4dc0-a370-a4954cd2aff5",
      target: "7e7a2d37-8a90-4f62-a952-2571c980458a"
    },
    {
      id: "a6e8fb48-035a-46b6-848f-89e3c296ba0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e7a2d37-8a90-4f62-a952-2571c980458a",
      target: "ec71d562-c41f-41f7-8958-27cf0c3f9758"
    },
    {
      id: "8ba7fa67-2d23-4655-8615-4d3a11bcdaeb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec71d562-c41f-41f7-8958-27cf0c3f9758",
      target: "bdfe14a4-f314-4780-b892-2d253d9342b1"
    },
    {
      id: "6edcef63-59a0-4dfb-8f8e-1470d3a8b6b8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec71d562-c41f-41f7-8958-27cf0c3f9758",
      target: "bdfe14a4-f314-4780-b892-2d253d9342b1"
    },
    {
      id: "079c4ed5-715a-4e14-abfe-a5251ed7c71d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdfe14a4-f314-4780-b892-2d253d9342b1",
      target: "708fe5f6-29a5-4972-b644-5e551f18e445"
    },
    {
      id: "5c183907-7214-4dbd-9d75-3501fb85ca05",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "708fe5f6-29a5-4972-b644-5e551f18e445",
      target: "4dd354ce-4a4a-4fec-b3fe-164a91c94931"
    },
    {
      id: "3adc5fa0-9e02-4665-abe9-f0a016758c91",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "708fe5f6-29a5-4972-b644-5e551f18e445",
      target: "4dd354ce-4a4a-4fec-b3fe-164a91c94931"
    },
    {
      id: "e60c5cd1-23fd-44e1-9852-7dc772dfcecd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4dd354ce-4a4a-4fec-b3fe-164a91c94931",
      target: "afb52c0f-ded1-4d02-87df-7d1e15b940db"
    },
    {
      id: "1379ce12-f00e-4acf-a89d-92a013443166",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "afb52c0f-ded1-4d02-87df-7d1e15b940db",
      target: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365"
    },
    {
      id: "5c25cbcc-2af1-4ba6-94ee-d03cba6f018a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "d863857a-149c-4695-b397-30b15e5cb930",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365",
      target: "b8bf1adb-9818-411c-99cd-e3af7577367d"
    },
    {
      id: "83693d04-4312-4d29-9423-8332c8e1634c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "15326198-a4f4-4581-b541-5a50d9d098f8"
    },
    {
      id: "05e6e7ed-a7d9-430e-98e1-1a4d83e1347b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "fb688aa4-c0b6-4a08-a692-19a070e75ead"
    },
    {
      id: "87f1222b-aa8d-4d35-924d-3bcadaff254d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "d04c4b2b-8c64-4841-855b-eca9f99ff44d"
    },
    {
      id: "f13cd0b8-050d-4412-bac3-b4c3ddfbc6c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "0b0da2a3-31d0-4e50-979a-074686b2fc60"
    },
    {
      id: "a1119b0d-0d61-4000-b49c-8d5eb8275954",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "d08b3fe3-cba3-47bc-b2ec-a561d0c417a2"
    },
    {
      id: "15655028-b08b-47d3-acea-88d76ada38d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "f5895a3e-d374-4a6c-b3fa-c30ecba87ba4"
    },
    {
      id: "5056558a-69b5-4331-a339-da9408538217",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "4f228d5a-0f87-449d-a336-4d2f781436d1"
    },
    {
      id: "5cc70d26-b12b-4d56-ba94-ba7dd568e4f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b4f9795-4618-4bbe-8f5d-c1a69c55ce02",
      target: "797a59a1-c2e0-4669-96f6-3f1509ffd9d8"
    },
    {
      id: "368f7316-f101-45ec-976d-9124cd77a54b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "797a59a1-c2e0-4669-96f6-3f1509ffd9d8",
      target: "1c91e76e-71e6-4fc1-8749-69745656f328"
    },
    {
      id: "d2f51315-1fa4-408e-9925-1ed794124fee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5895a3e-d374-4a6c-b3fa-c30ecba87ba4",
      target: "1c91e76e-71e6-4fc1-8749-69745656f328"
    },
    {
      id: "c1d7dead-9239-4718-8fbb-e93490ddbd75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b0da2a3-31d0-4e50-979a-074686b2fc60",
      target: "1c91e76e-71e6-4fc1-8749-69745656f328"
    },
    {
      id: "9dba7d33-4d65-4a0b-87e7-fd0a88c392e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d08b3fe3-cba3-47bc-b2ec-a561d0c417a2",
      target: "0a5e5b9c-7544-42f3-9c25-33035a54a93e"
    },
    {
      id: "82e4cfac-e786-4949-a4d0-ad9bb7a4343a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "15326198-a4f4-4581-b541-5a50d9d098f8",
      target: "1c91e76e-71e6-4fc1-8749-69745656f328"
    },
    {
      id: "eafc2e40-1d92-4925-b209-1bc8c407031a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb688aa4-c0b6-4a08-a692-19a070e75ead",
      target: "00d8d983-10e1-40dc-a561-18003959c515"
    },
    {
      id: "dadead1e-b418-409e-b4d2-3066822cfbdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c91e76e-71e6-4fc1-8749-69745656f328",
      target: "bbb88200-af8c-4c86-af49-c71faebcf7b9"
    },
    {
      id: "c200f999-1e4e-4779-96c1-63f5808f8b65",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c91e76e-71e6-4fc1-8749-69745656f328",
      target: "cb54386c-d258-42b2-a7e0-b0cbed7829b6"
    },
    {
      id: "4ad8b255-bf66-4049-9db6-0863bff89db4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00d8d983-10e1-40dc-a561-18003959c515",
      target: "0a5e5b9c-7544-42f3-9c25-33035a54a93e"
    },
    {
      id: "8bd0bcb5-5294-42af-9c78-71b879bb3f30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a5e5b9c-7544-42f3-9c25-33035a54a93e",
      target: "772ef034-da98-4dd3-bbff-ae983f99d0e5"
    },
    {
      id: "8086b2bc-3b35-4b42-ac3c-87c8dfeee42e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "772ef034-da98-4dd3-bbff-ae983f99d0e5",
      target: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8"
    },
    {
      id: "9a8664a8-f064-4556-b7bd-6dcbba79defe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8",
      target: "8804404b-bdd4-4bc3-8942-e458aa99c89f"
    },
    {
      id: "a214c95b-f609-439a-9ee5-5d86b0857eac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8",
      target: "9580999a-4c4c-4988-83ac-4c63b205e54c"
    },
    {
      id: "1e4f05f1-99fb-42e5-acba-5bf4c0b235ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8",
      target: "21ca4579-a34a-49a5-9281-c916d9780229"
    },
    {
      id: "b04dc88f-0643-4b17-b857-962587c027c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d01871f-a29e-4ffb-8425-ef41ba5c94e8",
      target: "acc27af2-8c46-4bb0-8d06-25e3ae0274bd"
    },
    {
      id: "0b4e75b5-db10-47dc-9a15-881556b7a17e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acc27af2-8c46-4bb0-8d06-25e3ae0274bd",
      target: "6ea7b8d2-4d66-40d9-bdb9-cae113bfef94"
    },
    {
      id: "78284aad-3b36-4882-b3a7-c7e012ac2e00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8804404b-bdd4-4bc3-8942-e458aa99c89f",
      target: "922804f8-a04a-40b3-bfcd-4bf5e405444e"
    },
    {
      id: "26cc2226-4850-4b2a-98b5-9e51cb1bc139",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8804404b-bdd4-4bc3-8942-e458aa99c89f",
      target: "cb54386c-d258-42b2-a7e0-b0cbed7829b6"
    },
    {
      id: "589e9423-1671-43d5-9d55-bdad8287d48c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8804404b-bdd4-4bc3-8942-e458aa99c89f",
      target: "bbb88200-af8c-4c86-af49-c71faebcf7b9"
    },
    {
      id: "ad950db3-16d3-406b-b486-b2d20c16048f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ea7b8d2-4d66-40d9-bdb9-cae113bfef94",
      target: "1408ad3b-7be3-48a2-beeb-930ec7f724ab"
    },
    {
      id: "d8a5b3ab-73f0-41b9-867b-12cdfdd3ef7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "922804f8-a04a-40b3-bfcd-4bf5e405444e",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "ff92db08-8d8f-4dc2-9026-1bbc9458c8cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb54386c-d258-42b2-a7e0-b0cbed7829b6",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "dd6e1026-d325-4c09-af4a-edcac7cf6671",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bbb88200-af8c-4c86-af49-c71faebcf7b9",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "d64f1e24-7ef9-4434-8e93-bc1bc94f45b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1408ad3b-7be3-48a2-beeb-930ec7f724ab",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "96082a6f-7918-4f13-beff-60fd4a012bd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85",
      target: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8"
    },
    {
      id: "7560b1bd-5c20-4125-91ed-d9d46f8e9d6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85",
      target: "88a5ff91-a5f1-49bb-9dc5-7de7d9630365"
    },
    {
      id: "c7f01746-7cfa-4416-8b51-cf18b4b3f0d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9580999a-4c4c-4988-83ac-4c63b205e54c",
      target: "513d473e-9095-411f-a640-812a54427afc"
    },
    {
      id: "ce28e32a-afeb-4b73-a19c-346346c8d0a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "513d473e-9095-411f-a640-812a54427afc",
      target: "7df11e13-587a-460a-bcd6-cfdd73630988"
    },
    {
      id: "1497c9c3-1f40-412e-a5e2-4f1e7819e3e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7df11e13-587a-460a-bcd6-cfdd73630988",
      target: "70257f37-f3fc-43c0-a48c-d7174bfaf3a0"
    },
    {
      id: "effe1459-9935-4cb4-a10c-63a2c52d9576",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70257f37-f3fc-43c0-a48c-d7174bfaf3a0",
      target: "3c3cabfc-0a08-455c-b5f2-540f9a0812e8"
    },
    {
      id: "52e92b68-8b0a-41b4-8aa6-1ea93ea67b5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70257f37-f3fc-43c0-a48c-d7174bfaf3a0",
      target: "42b7422a-c88a-41d1-9960-0386ba772f36"
    },
    {
      id: "deb3aa94-c4b3-4655-94ae-ce88c2cb202a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c3cabfc-0a08-455c-b5f2-540f9a0812e8",
      target: "e24710c8-84f0-4739-8ad1-5ad18f9d3dda"
    },
    {
      id: "218564f6-8c42-4b0c-8eb5-167fae64a9ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42b7422a-c88a-41d1-9960-0386ba772f36",
      target: "5756c002-94ce-4682-b2df-0eedae69fed5"
    },
    {
      id: "7b3cbf2c-2c36-4cfe-ab0f-2402c0bbaf66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e24710c8-84f0-4739-8ad1-5ad18f9d3dda",
      target: "5756c002-94ce-4682-b2df-0eedae69fed5"
    },
    {
      id: "8cc10ee4-0a8e-40d3-a7c0-cdc461924049",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5756c002-94ce-4682-b2df-0eedae69fed5",
      target: "66f7893c-8d52-49e2-9553-32185ed55567"
    },
    {
      id: "dd3456d9-eede-4805-9628-ba7e12e0cb9a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66f7893c-8d52-49e2-9553-32185ed55567",
      target: "37fbd780-08a1-4a12-876d-54b337755932"
    },
    {
      id: "cdbf234b-a53e-46a3-801f-95b07d5f1664",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37fbd780-08a1-4a12-876d-54b337755932",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "4d839b96-59ca-43dd-8174-d33bdfeab90d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21ca4579-a34a-49a5-9281-c916d9780229",
      target: "2b64ef56-ac34-4a46-8d6c-c262e0698cdc"
    },
    {
      id: "2d5ab208-b768-4d65-93eb-b6247af36b72",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b64ef56-ac34-4a46-8d6c-c262e0698cdc",
      target: "8dbaca25-853f-4dd2-8d78-bbaaa785a357"
    },
    {
      id: "053755ca-d439-41fe-8ac3-d250d92c1385",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8dbaca25-853f-4dd2-8d78-bbaaa785a357",
      target: "e7693bb5-22a2-45fb-91b3-07523ba6b3ce"
    },
    {
      id: "01656219-e30b-454e-aa6c-75e840d7b108",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7693bb5-22a2-45fb-91b3-07523ba6b3ce",
      target: "c15df593-87de-45ec-8261-3f57af4f3c95"
    },
    {
      id: "9baeffcb-4d79-4afd-8670-0b1230b25f18",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7693bb5-22a2-45fb-91b3-07523ba6b3ce",
      target: "c2937076-4e17-428c-9265-039cc7bc1a3a"
    },
    {
      id: "d5653f78-5f72-4e31-92d3-44dc3ec2b221",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c15df593-87de-45ec-8261-3f57af4f3c95",
      target: "cb48e525-d5a6-45cb-809f-1165d090a3af"
    },
    {
      id: "d62b3dd3-d7ea-441f-9a53-3812428d0a83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2937076-4e17-428c-9265-039cc7bc1a3a",
      target: "1402a3d2-66a0-41d0-861d-d7694cda6cb4"
    },
    {
      id: "a07a5c2e-5834-4121-b6c3-3ac262051392",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb48e525-d5a6-45cb-809f-1165d090a3af",
      target: "1402a3d2-66a0-41d0-861d-d7694cda6cb4"
    },
    {
      id: "9588a05a-bb00-417a-813e-7d55b82a8823",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1402a3d2-66a0-41d0-861d-d7694cda6cb4",
      target: "3d82739f-538c-45f9-9ff3-ef46627954e9"
    },
    {
      id: "dce2f37d-491a-4d99-ade3-04e5744bcaba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d82739f-538c-45f9-9ff3-ef46627954e9",
      target: "5bad728e-eb0f-48d5-8b43-6fe06d949d38"
    },
    {
      id: "80c3e98a-1a08-4c02-bc47-04f16962cf75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5bad728e-eb0f-48d5-8b43-6fe06d949d38",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "40f5321e-490b-4d7d-8e69-54842c620e16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f228d5a-0f87-449d-a336-4d2f781436d1",
      target: "e3c1d2d5-aa63-400f-a922-7a19c07f0148"
    },
    {
      id: "7013675f-c683-4c11-9948-f910438832e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e3c1d2d5-aa63-400f-a922-7a19c07f0148",
      target: "2bf45bfe-4a88-42a7-b314-225149ae1236"
    },
    {
      id: "364aa518-6c1c-477d-a286-518756f5a6cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2bf45bfe-4a88-42a7-b314-225149ae1236",
      target: "a340044a-a044-4363-a31b-a60c636f2ffb"
    },
    {
      id: "9eec08e1-c4bc-4406-9eea-2595cc8f1fa3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a340044a-a044-4363-a31b-a60c636f2ffb",
      target: "c832106d-03db-4ac2-81ea-f439c4d85963"
    },
    {
      id: "ee160abc-0cb1-4876-b7cd-af5f0b9e5e3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c832106d-03db-4ac2-81ea-f439c4d85963",
      target: "26dfc994-8133-46f9-84cd-3b48426244e1"
    },
    {
      id: "11af1485-a596-4d40-b3eb-324396ca7890",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26dfc994-8133-46f9-84cd-3b48426244e1",
      target: "936814a6-8a12-4b5e-bd62-72980c21e965"
    },
    {
      id: "e46cb03e-515a-4f12-b866-3d3f6a56ea41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "936814a6-8a12-4b5e-bd62-72980c21e965",
      target: "66091a39-2efc-4b44-9d54-98d9f340e28f"
    },
    {
      id: "36fc57bb-c1bc-4112-89af-55ec7d7ea077",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "093e0f63-bc5b-4543-9172-e00d7950dc1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "a9f1f9c2-4ecd-4d9b-812c-d1988584f0dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "52c18b5d-aa22-4ae5-8316-a8601534b3f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "7047203a-f4bb-4184-8c86-8628b2b4a798",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66091a39-2efc-4b44-9d54-98d9f340e28f",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "a8a71382-dd2a-4aa4-bbbb-b3b8e0bbfdb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d04c4b2b-8c64-4841-855b-eca9f99ff44d",
      target: "5508a6c8-39d2-4155-b216-fb7cabcd7b28"
    },
    {
      id: "565f3c9a-e4a2-43c1-b48e-d7795fd3bc8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5508a6c8-39d2-4155-b216-fb7cabcd7b28",
      target: "6e0d2a71-1c69-4b0d-9ef9-3946c4c90d9f"
    },
    {
      id: "6d0b98a3-1afd-4b12-a31b-f832391c4b27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e0d2a71-1c69-4b0d-9ef9-3946c4c90d9f",
      target: "a62dc703-3cc4-4c31-8dc0-4c422ce3a681"
    },
    {
      id: "e822f8be-2e40-41d5-b86c-114955857509",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a62dc703-3cc4-4c31-8dc0-4c422ce3a681",
      target: "00158869-5cc2-47a8-83bc-c60af231dc88"
    },
    {
      id: "4020065d-4c80-4aef-93a0-9e00f451749b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00158869-5cc2-47a8-83bc-c60af231dc88",
      target: "681ea83e-2207-4fd2-b708-4226a66e2574"
    },
    {
      id: "15ae5bf1-e3c6-4d84-b640-bf2f19ff100f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "681ea83e-2207-4fd2-b708-4226a66e2574",
      target: "0d77f9cf-1119-431b-840c-f4ed8725aaa7"
    },
    {
      id: "ffa1d880-b77a-4cc3-b11a-cc1cad2ed5bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d77f9cf-1119-431b-840c-f4ed8725aaa7",
      target: "a6624a92-3f0d-46c8-a536-1623e2c71e70"
    },
    {
      id: "d460d464-e88b-4475-9907-8a1abefcfb2c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "704d337c-bbcc-478b-bcf9-839c84e071e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      target: "8fbfbcb7-304d-4948-b7d2-d53a4d14ae85"
    },
    {
      id: "a63dc183-8738-4134-8eec-f9044e641c4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "15c1b860-b13e-4534-a878-bfc7966ed24e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "bfbd3870-4447-4da8-a370-39b8f5020896",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6624a92-3f0d-46c8-a536-1623e2c71e70",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "ef6f0985-f2be-425e-87c4-3a44212ae2b4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5f2638a5-ed91-40d2-9403-c88672e15d2f",
      target: "415a7e3c-d7ef-4670-a303-95b1b2983458"
    },
    {
      id: "cd2e12f0-1235-4c51-849e-a5d2c5f77d3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "b80ee220-876c-4296-9a79-3377bac5baf8"
    },
    {
      id: "4ac531e7-4d37-4263-b0a7-22c6d23dd379",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "7607e97b-3881-43c4-8b6a-06f0087f28ff"
    },
    {
      id: "319ab12c-34ac-43b1-a07d-1ca982da6e41",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "874ea700-71ea-4030-8bc9-592481826f26"
    },
    {
      id: "5ff2057d-2ae2-429d-95f8-2fe847aa6dd9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "5f2638a5-ed91-40d2-9403-c88672e15d2f"
    },
    {
      id: "993f0947-f915-4c07-acbe-fae76799990b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "9d160764-6b7a-4d92-acaa-d96e541bc5f1"
    },
    {
      id: "ce138b6e-3f5d-4164-96c1-328956b45c03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "bc6b0566-84da-4421-adbb-c29bb4256d70"
    },
    {
      id: "2aa699b3-3a1f-4f60-833d-7a7884ff17a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "c562e3ba-ce0d-4281-affc-f4a3182e06b8"
    },
    {
      id: "e2e5d08e-1ece-4ae9-97f9-4e97510e4501",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1c3faf84-ce72-4cee-b8d8-c9b94c0c8ef8",
      target: "874ea700-71ea-4030-8bc9-592481826f26"
    },
    {
      id: "11511382-6a85-4653-ac9e-5202ff62e4bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "874ea700-71ea-4030-8bc9-592481826f26",
      target: "68506006-d589-4d8a-a629-cea2657e4216"
    },
    {
      id: "b28ddde3-0950-4254-be24-3046333d8b4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "874ea700-71ea-4030-8bc9-592481826f26",
      target: "7a3cdc68-7b33-4766-8474-e785e7943d34"
    },
    {
      id: "556855b5-363a-446e-b3db-e26c963703b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b80ee220-876c-4296-9a79-3377bac5baf8",
      target: "7a3cdc68-7b33-4766-8474-e785e7943d34"
    },
    {
      id: "fd9aa0d8-9b64-43df-8c5d-9f8d3c0df1a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a3cdc68-7b33-4766-8474-e785e7943d34",
      target: "81cb96a8-6ea8-406e-bb0c-0e9cf4c2eac2"
    },
    {
      id: "30d1958a-2c1b-4d37-b7b5-150863eaa40a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68506006-d589-4d8a-a629-cea2657e4216",
      target: "415a7e3c-d7ef-4670-a303-95b1b2983458"
    },
    {
      id: "18c575eb-4f84-4b53-a24d-d84bbd11a72a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81cb96a8-6ea8-406e-bb0c-0e9cf4c2eac2",
      target: "415a7e3c-d7ef-4670-a303-95b1b2983458"
    },
    {
      id: "e7e96fa0-9241-4df0-90ef-b3ebdeb28766",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415a7e3c-d7ef-4670-a303-95b1b2983458",
      target: "6555168b-5348-47cf-96a4-00868784ed13"
    },
    {
      id: "02fff7d4-298e-4893-b8d1-9ce436e6f83c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415a7e3c-d7ef-4670-a303-95b1b2983458",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "5a3758b8-3ad3-4872-8cf4-93d7828acdfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415a7e3c-d7ef-4670-a303-95b1b2983458",
      target: "44ea152d-6915-4b4a-848a-9f905fb08eb8"
    },
    {
      id: "2874b181-becf-4b17-aa4c-d46f3ddbfa26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44ea152d-6915-4b4a-848a-9f905fb08eb8",
      target: "6578e9d9-ca51-45cc-8726-cf66b2a066ee"
    },
    {
      id: "e8a3036d-dbc2-429b-aeb1-94a84921896e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "44ea152d-6915-4b4a-848a-9f905fb08eb8",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "ac101cf1-f263-4a7c-a80d-d22868340c92",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44ea152d-6915-4b4a-848a-9f905fb08eb8",
      target: "1e1781f2-5393-47a7-bd2a-64c57adfd4b6"
    },
    {
      id: "6d13c3d1-663d-4127-8c56-837b25a1a48e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "44ea152d-6915-4b4a-848a-9f905fb08eb8",
      target: "70c248b3-7c26-480e-8a9c-fe4c54aeac5c"
    },
    {
      id: "00cd3cc4-27ac-426f-aae0-02bbaf0472bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e1781f2-5393-47a7-bd2a-64c57adfd4b6",
      target: "1d174025-b93d-437c-a8b7-faa7f7c2712e"
    },
    {
      id: "1f36059c-1e0d-46fc-aa90-f646dc2d6bd6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e1781f2-5393-47a7-bd2a-64c57adfd4b6",
      target: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca"
    },
    {
      id: "a75b4cbd-ed0c-4707-8af9-f7c19e8a43df",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca",
      target: "a2e3a003-1bcb-4562-8df8-2e7430ab3b1c"
    },
    {
      id: "50517aa7-8d37-439b-a252-4c594232f0ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "93951a37-f97f-4ecc-a5e2-fb7a8cd9bcca",
      target: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1"
    },
    {
      id: "8ead3403-e1cf-48cc-8ee5-e5a3dc27e8bd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a2e3a003-1bcb-4562-8df8-2e7430ab3b1c",
      target: "64db0f31-937a-4a98-b914-fd22e0b42b09"
    },
    {
      id: "62028be6-2769-4b3f-a8fb-3e28bb86c07c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64db0f31-937a-4a98-b914-fd22e0b42b09",
      target: "a3d46ce7-d3a0-4bc9-9451-b0d47dee01ad"
    },
    {
      id: "8c6162d7-ae55-457a-b01e-af177a9e02d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3d46ce7-d3a0-4bc9-9451-b0d47dee01ad",
      target: "471d1405-1daa-4156-863f-71099cb2bf78"
    },
    {
      id: "36a78316-9457-4e04-8487-599948cbd8d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a3d46ce7-d3a0-4bc9-9451-b0d47dee01ad",
      target: "834a2c87-fdd3-4526-ae51-271999f71498"
    },
    {
      id: "c62c0fc5-56a2-471e-ba9f-b056cc33f0b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "471d1405-1daa-4156-863f-71099cb2bf78",
      target: "38dfa9ba-a89e-42bf-a519-ae07b2f7ccac"
    },
    {
      id: "9336735a-f612-4644-bd05-d5223aae0320",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "471d1405-1daa-4156-863f-71099cb2bf78",
      target: "14a93288-a9ec-4a1e-9927-b17a4c6587db"
    },
    {
      id: "a9595d1b-8315-4b89-9073-02108e47f420",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14a93288-a9ec-4a1e-9927-b17a4c6587db",
      target: "d9411721-bf5d-4996-a5c7-df15dd61391c"
    },
    {
      id: "d6b05d4d-df09-4449-9b91-b9c608d4c360",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9411721-bf5d-4996-a5c7-df15dd61391c",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "46162976-ca0e-454a-a040-85a44dfa0c84",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d9411721-bf5d-4996-a5c7-df15dd61391c",
      target: "1d174025-b93d-437c-a8b7-faa7f7c2712e"
    },
    {
      id: "cd9c6b26-4d52-4d38-b42f-83269d4c47ee",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1d174025-b93d-437c-a8b7-faa7f7c2712e",
      target: "1a888afe-aa20-4b68-8759-09312e214b3a"
    },
    {
      id: "66a519ec-58d0-4b7c-a9b2-6bc54a172be1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "834a2c87-fdd3-4526-ae51-271999f71498",
      target: "70b95beb-de03-4f99-b648-a03ebeddc017"
    },
    {
      id: "ca8e6f00-4faa-4602-b14c-bee92292c091",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1a888afe-aa20-4b68-8759-09312e214b3a",
      target: "fb628d61-e100-41e1-8151-615c8477897f"
    },
    {
      id: "d137ae25-31c5-4596-a212-fd8802b9fa18",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fb628d61-e100-41e1-8151-615c8477897f",
      target: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5"
    },
    {
      id: "b1f40dfe-e112-4788-9919-524ee751d073",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5",
      target: "778f5620-57d9-4756-a30b-6519f6c05951"
    },
    {
      id: "af2e3a56-cfb3-4099-b7da-0b493e342e13",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5",
      target: "28b7bf91-ee9e-40ea-83bd-94ca2ca53097"
    },
    {
      id: "a5e93512-5d1e-4544-babf-1379c5b05d42",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "859ce0ad-d186-4569-b6f5-a8a11ad0b4a5",
      target: "64d5abea-2873-4e85-a875-c54e7d27d9da"
    },
    {
      id: "874f5400-1a68-4e33-8de1-0c3dc3c35a24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64d5abea-2873-4e85-a875-c54e7d27d9da",
      target: "b8a99b16-97da-4f37-bd19-f46b14a28fee"
    },
    {
      id: "9f2baec4-4993-4104-9a4c-bc3e55e5ac38",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64d5abea-2873-4e85-a875-c54e7d27d9da",
      target: "8dabe4e5-612d-468d-96f3-8de7d4eb74d8"
    },
    {
      id: "493571cc-f647-491e-8c10-7884cdcaa56a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28b7bf91-ee9e-40ea-83bd-94ca2ca53097",
      target: "1b19049d-d282-4e0d-8ad1-c234eeb36c26"
    },
    {
      id: "ccadfbb6-1e77-4ea9-9cd9-1b5fcbf09d10",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "28b7bf91-ee9e-40ea-83bd-94ca2ca53097",
      target: "dc32c057-9dcc-4ceb-ab27-25589b917f9e"
    },
    {
      id: "6e3cb21d-a763-44d3-8894-6f99e3c21383",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "778f5620-57d9-4756-a30b-6519f6c05951",
      target: "f648ff66-d798-4edd-a570-f8625c3e24c8"
    },
    {
      id: "b22809aa-ce70-4dff-bb54-e30114ee6b86",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "778f5620-57d9-4756-a30b-6519f6c05951",
      target: "8dabe4e5-612d-468d-96f3-8de7d4eb74d8"
    },
    {
      id: "c9da928a-8b26-46e0-b7db-7c510d346e1b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1b19049d-d282-4e0d-8ad1-c234eeb36c26",
      target: "387f4452-75b6-4e66-b65d-74f8b9eacaf4"
    },
    {
      id: "3a39639e-2a32-4af6-bca4-ae64a0c59e82",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8dabe4e5-612d-468d-96f3-8de7d4eb74d8",
      target: "e62985ef-ff43-4812-b7c0-b9605c6775dd"
    },
    {
      id: "c237f741-7a0d-4c19-bfb7-8817f7d4b7b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f648ff66-d798-4edd-a570-f8625c3e24c8",
      target: "522edb03-75a2-4166-8d66-50f140352491"
    },
    {
      id: "9aee5fb8-ddb9-443e-83dd-ca0cb73c17b2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dc32c057-9dcc-4ceb-ab27-25589b917f9e",
      target: "387f4452-75b6-4e66-b65d-74f8b9eacaf4"
    },
    {
      id: "ff1457e9-d42e-4060-aae9-9f37874547d8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "387f4452-75b6-4e66-b65d-74f8b9eacaf4",
      target: "e62985ef-ff43-4812-b7c0-b9605c6775dd"
    },
    {
      id: "eab2991a-b9f5-4546-b23f-b461d89c9e37",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "387f4452-75b6-4e66-b65d-74f8b9eacaf4",
      target: "139facf2-362a-4710-971b-85a5725804a7"
    },
    {
      id: "44745675-1100-4ca2-9848-c82687c84d42",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e62985ef-ff43-4812-b7c0-b9605c6775dd",
      target: "522edb03-75a2-4166-8d66-50f140352491"
    },
    {
      id: "519ce99b-4105-4a2d-ada7-d857d79516c7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "139facf2-362a-4710-971b-85a5725804a7",
      target: "5a76a616-ef35-416e-b75a-9c99fcdaff46"
    },
    {
      id: "8b85792d-b564-4e9f-bf8c-d9725640b239",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b8a99b16-97da-4f37-bd19-f46b14a28fee",
      target: "8dabe4e5-612d-468d-96f3-8de7d4eb74d8"
    },
    {
      id: "2621825c-1d2f-4e9e-a47a-130817489cbe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "522edb03-75a2-4166-8d66-50f140352491",
      target: "a657002a-ede9-4c60-8a8b-8a0b0ada3247"
    },
    {
      id: "7441a2fa-1932-4384-8f25-c147fb3dc7b1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "522edb03-75a2-4166-8d66-50f140352491",
      target: "4889d387-b0c5-4853-971b-9debbabbb9db"
    },
    {
      id: "6d4ad86f-1976-4ac6-8780-6ee0c5eb4b41",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "522edb03-75a2-4166-8d66-50f140352491",
      target: "43ffb775-89e0-48aa-9afc-2940cd091a80"
    },
    {
      id: "29c6f077-746b-464d-b0ed-9f9d5949d08e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "522edb03-75a2-4166-8d66-50f140352491",
      target: "4f477a94-9215-46cb-9ded-d5fc9fba33cc"
    },
    {
      id: "b5bb44eb-8de2-47e0-a648-32d470a5e1e6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4889d387-b0c5-4853-971b-9debbabbb9db",
      target: "5a76a616-ef35-416e-b75a-9c99fcdaff46"
    },
    {
      id: "ad101ea8-b472-493d-8d1a-5950653d6cff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "43ffb775-89e0-48aa-9afc-2940cd091a80",
      target: "5a76a616-ef35-416e-b75a-9c99fcdaff46"
    },
    {
      id: "32a3c891-1f49-4aea-8310-9ea0d0055b8a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4f477a94-9215-46cb-9ded-d5fc9fba33cc",
      target: "5a76a616-ef35-416e-b75a-9c99fcdaff46"
    },
    {
      id: "82f2007d-43ea-4782-a755-aa115da704f4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a657002a-ede9-4c60-8a8b-8a0b0ada3247",
      target: "5a76a616-ef35-416e-b75a-9c99fcdaff46"
    },
    {
      id: "d317b898-b5b6-4959-a35f-f5736dd6eb90",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5a76a616-ef35-416e-b75a-9c99fcdaff46",
      target: "a1f79bb1-c893-476b-8ab9-10ef5259f2ad"
    },
    {
      id: "d635cb59-e2c9-4dd4-87c7-8846096561aa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a1f79bb1-c893-476b-8ab9-10ef5259f2ad",
      target: "b5bd4fcc-7fcb-4def-8c59-61197e71cadb"
    },
    {
      id: "5746328d-b721-4d48-8cbb-a425f497d7a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b5bd4fcc-7fcb-4def-8c59-61197e71cadb",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "f688bd90-ee5f-48d9-b40c-42caab4ca2af",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b5bd4fcc-7fcb-4def-8c59-61197e71cadb",
      target: "4e119cf9-d7f2-435a-b1c3-d2d11f8ab037"
    },
    {
      id: "6a9368b3-444b-4d7b-bf76-ec38050d6fae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4e119cf9-d7f2-435a-b1c3-d2d11f8ab037",
      target: "a25255f9-5a0e-484f-b4b1-bd95f214fa7f"
    },
    {
      id: "a004b1d0-e0f4-46c8-96fe-d9c083d3d37c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a25255f9-5a0e-484f-b4b1-bd95f214fa7f",
      target: "70b95beb-de03-4f99-b648-a03ebeddc017"
    },
    {
      id: "c02c208c-f336-4af4-a39c-f5419e0ff9ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70b95beb-de03-4f99-b648-a03ebeddc017",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "b2137ad4-a711-44ab-b5b2-8df0843b9d1c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70b95beb-de03-4f99-b648-a03ebeddc017",
      target: "79ea0bfa-70c2-4ab3-886b-2654634c1dfb"
    },
    {
      id: "0e56f2f1-8b43-4729-be6d-abd873e53d00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "79ea0bfa-70c2-4ab3-886b-2654634c1dfb",
      target: "b506e9a8-aa7b-4b85-b1c5-9583ed7c8603"
    },
    {
      id: "38a13568-3034-4461-a53e-7a2a95f90d45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b506e9a8-aa7b-4b85-b1c5-9583ed7c8603",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "3599b8d3-bf09-469c-9b1f-2e56bd38a04a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b506e9a8-aa7b-4b85-b1c5-9583ed7c8603",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "8e7d0aff-7005-4f8e-aa78-c1ff0c2f9d09",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "5c6b1ba1-dad4-4c3c-9d08-18f1056a3aef"
    },
    {
      id: "8ff7f14b-2fcf-4a6c-a880-9fe66722f168",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "5c6b1ba1-dad4-4c3c-9d08-18f1056a3aef"
    },
    {
      id: "2bdabc29-af23-4ff1-acf3-3bc8ff5d4263",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "520b9b73-2cae-4c9d-aa69-11a16d57879d"
    },
    {
      id: "0a432ab0-27a0-4ef5-95de-d2cf9d8a58b0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "520b9b73-2cae-4c9d-aa69-11a16d57879d"
    },
    {
      id: "334691b2-912a-4ec5-9600-d3c0c3a119e9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "ec8bbfbd-62b0-4e1d-98c9-31dc156e3b76"
    },
    {
      id: "e40ae182-c3fb-4de9-8b0d-ab2547085c1d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d160764-6b7a-4d92-acaa-d96e541bc5f1",
      target: "ec8bbfbd-62b0-4e1d-98c9-31dc156e3b76"
    },
    {
      id: "4b206084-0011-47f9-a644-4654335ccd4c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec8bbfbd-62b0-4e1d-98c9-31dc156e3b76",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "fe441ce2-c0ca-4b28-84ad-82cdde1ee3c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec8bbfbd-62b0-4e1d-98c9-31dc156e3b76",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "24a7840c-66f6-460d-aee7-80b0e274af25",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4403f6dd-1701-4c20-8acf-13f5a649f033",
      target: "c204c6e7-83b4-4f9f-bd4b-86f615a29e46"
    },
    {
      id: "f0b4f997-bdc8-4ada-bafe-c5d27bbc6b12",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4403f6dd-1701-4c20-8acf-13f5a649f033",
      target: "efcd15ea-dcd3-47a4-a25e-f864b38838d9"
    },
    {
      id: "54bef22f-c70e-48f5-bfe1-d0a38a4d21ff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4403f6dd-1701-4c20-8acf-13f5a649f033",
      target: "3dadaf33-c413-4bb6-ab2d-9b47a3458a3b"
    },
    {
      id: "405172db-869a-4b76-90d1-32e7eec88900",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4403f6dd-1701-4c20-8acf-13f5a649f033",
      target: "52111880-f074-41b4-8a0d-a4e2c5db4490"
    },
    {
      id: "e73d34c7-1573-44be-8d2c-fea89fe80f93",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5c6b1ba1-dad4-4c3c-9d08-18f1056a3aef",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "0c3b3c78-4ec4-4847-9c69-eb41a68b766d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5c6b1ba1-dad4-4c3c-9d08-18f1056a3aef",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "5cf1534b-0b5c-4e7a-98bf-96d32e9739e9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "520b9b73-2cae-4c9d-aa69-11a16d57879d",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "110fd185-5f26-48f1-955a-b382adbd6224",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "520b9b73-2cae-4c9d-aa69-11a16d57879d",
      target: "4403f6dd-1701-4c20-8acf-13f5a649f033"
    },
    {
      id: "e7bb8b07-50a0-43fb-b2d3-5cfec184e2ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c204c6e7-83b4-4f9f-bd4b-86f615a29e46",
      target: "52111880-f074-41b4-8a0d-a4e2c5db4490"
    },
    {
      id: "b0c1780d-7fb0-45f1-ab2d-6a42fc1df929",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3dadaf33-c413-4bb6-ab2d-9b47a3458a3b",
      target: "52111880-f074-41b4-8a0d-a4e2c5db4490"
    },
    {
      id: "90fff08f-f295-4556-b220-830a8e434028",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "efcd15ea-dcd3-47a4-a25e-f864b38838d9",
      target: "52111880-f074-41b4-8a0d-a4e2c5db4490"
    },
    {
      id: "e4c229be-8f8c-423e-8c21-da13dfdb1c3b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52111880-f074-41b4-8a0d-a4e2c5db4490",
      target: "dcd062f4-fb1c-4c80-aed9-5b61f82b637f"
    },
    {
      id: "c428839a-ba61-4237-90d6-7ef8e6512793",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcd062f4-fb1c-4c80-aed9-5b61f82b637f",
      target: "bec6b574-14c8-4263-a9b5-6b36180ebd3d"
    },
    {
      id: "9d0d72a4-582a-41a4-9308-bb8fc7b2a8c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bec6b574-14c8-4263-a9b5-6b36180ebd3d",
      target: "a3d8a10a-8e6b-4b46-b41b-13129526f875"
    },
    {
      id: "ef3095f7-347b-4c2c-a4f0-a8b2cad0c020",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3d8a10a-8e6b-4b46-b41b-13129526f875",
      target: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6"
    },
    {
      id: "1e3bffa3-69f0-4923-aa66-4e58ac56ea6e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0b68c4dc-c508-4ba5-97ba-d56e39f6d625",
      target: "b76548b6-fbb8-4060-93d6-96869bb2790b"
    },
    {
      id: "38aa5e15-66b8-45a1-a7d5-0747ddca5d29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6",
      target: "ea730a35-0276-4f13-8f08-7c61d90758ac"
    },
    {
      id: "cb9001d7-7203-40e7-8d57-5ae5c8c48160",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6",
      target: "0b68c4dc-c508-4ba5-97ba-d56e39f6d625"
    },
    {
      id: "434b7182-0356-4d08-a43f-32695952f4c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81e6008e-d4f7-42a0-ad31-8976e9fe1cd6",
      target: "b76548b6-fbb8-4060-93d6-96869bb2790b"
    },
    {
      id: "1c6452e8-fa35-4b0c-8e96-0261a05d3a70",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ea730a35-0276-4f13-8f08-7c61d90758ac",
      target: "b76548b6-fbb8-4060-93d6-96869bb2790b"
    },
    {
      id: "20dc4eff-d5c4-4211-a4a8-e619fbf2c17d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b76548b6-fbb8-4060-93d6-96869bb2790b",
      target: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43"
    },
    {
      id: "6a1033f8-f754-40fd-95a9-58f7fb5ef200",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43",
      target: "5231452f-a8a5-481f-b2a2-e7602e53969d"
    },
    {
      id: "39299544-896a-4f52-9da3-da52d850db90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43",
      target: "ff4ce29a-fe13-4f4b-9c21-da7e4d5fd554"
    },
    {
      id: "341212cb-4eb7-4ece-814b-0d50cfd51e7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43",
      target: "677df6e9-5929-42e4-b67e-3f5eae9ee718"
    },
    {
      id: "771867a4-2c1e-4981-9063-85cabec3add0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acd21cf8-c048-4a0d-9a5b-2f07e90d0a43",
      target: "89f10edb-b109-4a99-92b4-c0fb31a58927"
    },
    {
      id: "91ecb052-899c-4f6e-a124-2e32a4f175d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89f10edb-b109-4a99-92b4-c0fb31a58927",
      target: "bad32c28-e0bc-4d75-b432-1f917c7b63c2"
    },
    {
      id: "7fdf9405-4ca4-4eaa-902b-398ee0d5a1b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89f10edb-b109-4a99-92b4-c0fb31a58927",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "1c3b07d2-78f2-4070-87f4-0479068f4394",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff4ce29a-fe13-4f4b-9c21-da7e4d5fd554",
      target: "bad32c28-e0bc-4d75-b432-1f917c7b63c2"
    },
    {
      id: "32f7e666-d741-48de-a3b0-d623559f1316",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "677df6e9-5929-42e4-b67e-3f5eae9ee718",
      target: "70b95beb-de03-4f99-b648-a03ebeddc017"
    },
    {
      id: "478a80fb-0e7c-4803-84d4-4ddf00fcea5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bad32c28-e0bc-4d75-b432-1f917c7b63c2",
      target: "7a27052a-152c-48a0-8eaf-98c9ad1e94e8"
    },
    {
      id: "ec079e82-14b8-457f-b4cb-ae1251d9cddc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a27052a-152c-48a0-8eaf-98c9ad1e94e8",
      target: "9a6cce23-901c-4384-8f62-9bd0d3eda8a2"
    },
    {
      id: "3745c325-c184-4c8f-ad2b-711b4a70fdad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a6cce23-901c-4384-8f62-9bd0d3eda8a2",
      target: "70b95beb-de03-4f99-b648-a03ebeddc017"
    },
    {
      id: "7bc6e00f-cfac-4403-b34f-02724ce9eafe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1",
      target: "2d44d520-a537-4ad7-8497-b8a3633f9a96"
    },
    {
      id: "b8e2f67b-284f-4765-9130-aad9fb104e59",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1",
      target: "4521e9ff-16bc-4e4b-babf-85154075a147"
    },
    {
      id: "f51eb885-7cbe-48c1-aa84-7999d59f4f27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5aad4100-ec99-4358-9bcd-5f139c7d5ab1",
      target: "0a84fa40-786a-4c7b-a359-5a951849a6bc"
    },
    {
      id: "2df9056c-7c8d-4c4d-96b1-7df80524a5c7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4521e9ff-16bc-4e4b-babf-85154075a147",
      target: "826defa0-bab9-41a4-9328-11c1e8e045e2"
    },
    {
      id: "6cafa688-5462-40a5-a033-9a18bf2033f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4521e9ff-16bc-4e4b-babf-85154075a147",
      target: "4e155fc3-8361-429e-9a8b-807103168d8b"
    },
    {
      id: "f2441bf7-1679-4a97-9a4c-ca531ec8ee30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4521e9ff-16bc-4e4b-babf-85154075a147",
      target: "34cc8481-431d-4c29-b3da-c2ad6501b4d6"
    },
    {
      id: "bd072e77-af2c-422a-a65a-445d49a1d862",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "826defa0-bab9-41a4-9328-11c1e8e045e2",
      target: "94b778f5-3fd0-4108-9900-4bc4bf597151"
    },
    {
      id: "3754d103-35e3-444a-b075-5768d4ff0aef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "826defa0-bab9-41a4-9328-11c1e8e045e2",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "be30a414-55ac-4b82-a86d-8fa1372d2634",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "826defa0-bab9-41a4-9328-11c1e8e045e2",
      target: "2754e163-f563-4dbd-96b7-51f6783df49b"
    },
    {
      id: "e6a221f0-716f-4172-9ba9-d78318dc1f37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "826defa0-bab9-41a4-9328-11c1e8e045e2",
      target: "e0306b80-1005-4076-8974-2fe1bf17eebd"
    },
    {
      id: "edabc4a3-e24c-44e0-b80d-8d4cdeef95b9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "94b778f5-3fd0-4108-9900-4bc4bf597151",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "6ddd9f5d-86db-49aa-9b0c-5641c3c0a9c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94b778f5-3fd0-4108-9900-4bc4bf597151",
      target: "0ab563fa-599a-429d-8244-197aea2ebe1a"
    },
    {
      id: "f06d9587-6d85-48ce-a4c1-2e34d75271fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94b778f5-3fd0-4108-9900-4bc4bf597151",
      target: "547aff1c-6649-4ed1-8f66-c47d71d1a735"
    },
    {
      id: "7b6f5a6f-107a-4b56-bc5f-ff3eaf35cee2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0a84fa40-786a-4c7b-a359-5a951849a6bc",
      target: "4e155fc3-8361-429e-9a8b-807103168d8b"
    },
    {
      id: "752f9615-436e-470b-94f0-d1cfda152c99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a84fa40-786a-4c7b-a359-5a951849a6bc",
      target: "2d44d520-a537-4ad7-8497-b8a3633f9a96"
    },
    {
      id: "4c90f454-2125-4b69-8696-2fafbffc7a68",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4e155fc3-8361-429e-9a8b-807103168d8b",
      target: "2754e163-f563-4dbd-96b7-51f6783df49b"
    },
    {
      id: "9b24acc3-2a77-4752-bcc6-bd91f083433f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e155fc3-8361-429e-9a8b-807103168d8b",
      target: "34cc8481-431d-4c29-b3da-c2ad6501b4d6"
    },
    {
      id: "3bad5b1a-fa3a-4d63-9cbd-d9ff3bcca3f5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2754e163-f563-4dbd-96b7-51f6783df49b",
      target: "0ab563fa-599a-429d-8244-197aea2ebe1a"
    },
    {
      id: "8955652b-a9f4-4405-8164-d37459f5d8b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2754e163-f563-4dbd-96b7-51f6783df49b",
      target: "e0306b80-1005-4076-8974-2fe1bf17eebd"
    },
    {
      id: "5abc1e90-d749-4733-abe0-2307092a7410",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0ab563fa-599a-429d-8244-197aea2ebe1a",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "b7cdc9de-7cfa-4324-8aec-3fea209689ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ab563fa-599a-429d-8244-197aea2ebe1a",
      target: "547aff1c-6649-4ed1-8f66-c47d71d1a735"
    },
    {
      id: "1afe52e4-d08f-4188-ac1d-1ba148a01f8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64a5e86d-b411-4655-b538-9440a526b176",
      target: "5cc06ab5-92a7-4e7d-9ef2-61ece064ce5e"
    },
    {
      id: "1a0cdbe3-0fbb-4f12-96cc-f9617e7446c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64a5e86d-b411-4655-b538-9440a526b176",
      target: "52fe1192-f057-4287-a06e-48b6e9cf0bb4"
    },
    {
      id: "1f6b9965-73d6-4911-a19e-9718f6bc436b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64a5e86d-b411-4655-b538-9440a526b176",
      target: "c562e3ba-ce0d-4281-affc-f4a3182e06b8"
    },
    {
      id: "dbec1fcd-7cf3-4192-989f-5d97531a2216",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "061c3d7a-01a7-4e3a-b039-ff534b392178"
    },
    {
      id: "148fb111-8266-47ac-b9a6-3d0c456bf762",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "9001437d-6b98-45b4-a4ce-c021d340e89e"
    },
    {
      id: "661cd440-5073-4d1a-8328-441519ac66d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "8d80126e-8321-432b-bc11-bbbc9e279276"
    },
    {
      id: "37087a6a-ae19-4988-a0c7-ad122bd22f94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "dd8192df-620e-45ac-b2df-0fb594c7f8f6"
    },
    {
      id: "b77e05b4-5565-45c1-bc15-7d6a4a31cd3d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "21a4b145-e3d1-4c39-ac6d-a0789720a01d"
    },
    {
      id: "c87839f5-2f79-4864-9447-cb658866eeca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "05844c7d-896c-4a81-8914-4abaad03a157"
    },
    {
      id: "e6348bfa-dafe-45de-8c6f-6132a44c4286",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536"
    },
    {
      id: "7bbf752f-3237-4fcf-833e-4978bcd47b38",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "21a4b145-e3d1-4c39-ac6d-a0789720a01d"
    },
    {
      id: "416b6100-f37f-48d2-95e3-5ca1016cad88",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "d7116d46-50d6-4458-b6c5-af8e6fabd40c"
    },
    {
      id: "30a9fc19-4848-42dd-a6d1-7e5334d9afdb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c562e3ba-ce0d-4281-affc-f4a3182e06b8",
      target: "d7116d46-50d6-4458-b6c5-af8e6fabd40c"
    },
    {
      id: "79089d2c-ee3a-4ff2-b66f-ea397301c3f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "05844c7d-896c-4a81-8914-4abaad03a157",
      target: "f278a494-c8a8-47e0-bde3-877dc8157ea1"
    },
    {
      id: "80210d1a-d900-4629-a585-fd7dbf5e0263",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "061c3d7a-01a7-4e3a-b039-ff534b392178",
      target: "f278a494-c8a8-47e0-bde3-877dc8157ea1"
    },
    {
      id: "03fc1d53-417e-475e-ac2a-98504967d1ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd8192df-620e-45ac-b2df-0fb594c7f8f6",
      target: "8787aa3b-3758-4afe-8e7c-459106f3786b"
    },
    {
      id: "c9e30dba-31f6-497c-9715-55d55ba202f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9001437d-6b98-45b4-a4ce-c021d340e89e",
      target: "f278a494-c8a8-47e0-bde3-877dc8157ea1"
    },
    {
      id: "3ccc0214-dc22-4f1c-b730-c163f8b16f83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d80126e-8321-432b-bc11-bbbc9e279276",
      target: "9f34293e-7961-4abe-b736-9bcb89c09c60"
    },
    {
      id: "a11deee1-2219-48ae-8c7e-95c485b70723",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d80126e-8321-432b-bc11-bbbc9e279276",
      target: "a986bbd8-925e-4eb8-9cdc-f55be8038ef4"
    },
    {
      id: "98c85d31-eab6-4209-972d-cd403d91e17f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f278a494-c8a8-47e0-bde3-877dc8157ea1",
      target: "057d63bd-0a4d-434e-a7ca-5122ccde1b73"
    },
    {
      id: "6d1331d2-51cc-425a-864b-761658bfa24e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f278a494-c8a8-47e0-bde3-877dc8157ea1",
      target: "0d359103-b31f-4090-855a-9d205ce6a5cf"
    },
    {
      id: "c29ea32a-fa7e-4746-9a67-8f59f78fc1df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f34293e-7961-4abe-b736-9bcb89c09c60",
      target: "8787aa3b-3758-4afe-8e7c-459106f3786b"
    },
    {
      id: "0d92bad2-4929-48a3-aece-7f4d01155736",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8787aa3b-3758-4afe-8e7c-459106f3786b",
      target: "43744881-6f63-4765-ac73-c4430f424f77"
    },
    {
      id: "baca13bd-f85f-429c-9247-abf9b2907d8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43744881-6f63-4765-ac73-c4430f424f77",
      target: "a4817a0a-6c14-4fcd-a3e8-933fc0591d13"
    },
    {
      id: "0c704bd0-e409-4201-858c-d5d43df8c289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4817a0a-6c14-4fcd-a3e8-933fc0591d13",
      target: "0cbde58a-db23-4c77-a8dc-98ff59357956"
    },
    {
      id: "79ba852d-c97c-4827-a9cc-496effcd4555",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4817a0a-6c14-4fcd-a3e8-933fc0591d13",
      target: "08a210dc-133f-4b25-8355-b4b2f3b8be40"
    },
    {
      id: "7fe0d607-1b13-47c9-ad64-64da97e95f96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "08a210dc-133f-4b25-8355-b4b2f3b8be40",
      target: "0278e20e-1d9d-4cd2-b8ed-e0c44401b413"
    },
    {
      id: "d23f80b2-f166-4ba7-865b-42f6383b5e44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cbde58a-db23-4c77-a8dc-98ff59357956",
      target: "0d359103-b31f-4090-855a-9d205ce6a5cf"
    },
    {
      id: "02c82fb9-562c-4e16-8379-463b10daf657",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cbde58a-db23-4c77-a8dc-98ff59357956",
      target: "057d63bd-0a4d-434e-a7ca-5122ccde1b73"
    },
    {
      id: "691a4c55-d74c-412b-8a1e-7dfcf67cb378",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0cbde58a-db23-4c77-a8dc-98ff59357956",
      target: "c147d70b-133b-48d0-ac94-9a2dea317ff0"
    },
    {
      id: "038f3ce6-5839-4e27-a9f1-b04e3b1cf38f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0278e20e-1d9d-4cd2-b8ed-e0c44401b413",
      target: "3ed65afc-abd6-4636-8e00-2b3e35d63785"
    },
    {
      id: "fafb5530-9446-4841-9b23-0a297c0a20a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d359103-b31f-4090-855a-9d205ce6a5cf",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "b29bb12a-2893-48d6-8189-52e365b0aea5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "057d63bd-0a4d-434e-a7ca-5122ccde1b73",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "b426b55f-a678-4c29-80c1-5552a12f94fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c147d70b-133b-48d0-ac94-9a2dea317ff0",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "b31e437f-41bf-44e8-a9c7-bf7ed248f7e5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c147d70b-133b-48d0-ac94-9a2dea317ff0",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "19a414f1-a61b-49b3-a1ee-d94e35770b49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3ed65afc-abd6-4636-8e00-2b3e35d63785",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "6811d939-85df-4bd3-95c4-62bdc17b969c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d6b61b4-8b2e-4901-821d-125438c2d3e1",
      target: "a530a7df-8470-4ebe-9bce-c0482f5a1f32"
    },
    {
      id: "9426aa5a-a030-4831-a560-85e030f86c4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d6b61b4-8b2e-4901-821d-125438c2d3e1",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "b56a0baa-c725-413f-9701-3fc91be84798",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d6b61b4-8b2e-4901-821d-125438c2d3e1",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "d4db81c5-54e6-4479-ac82-3f06d05705db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      target: "a986bbd8-925e-4eb8-9cdc-f55be8038ef4"
    },
    {
      id: "bc5666b7-803f-4f26-8c46-a8f9525c560a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      target: "a829eec0-3e4f-49de-a8c3-3fdca7e9e157"
    },
    {
      id: "6cb2c1e7-51c1-4bbb-a224-1d8f1b2b5b4c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      target: "58e94545-4197-4edd-89ef-707997c1586e"
    },
    {
      id: "0338c054-5b78-4b63-8fb1-e0409c86aa69",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      target: "6a8be261-5c5f-41a0-9142-f7d2d4155195"
    },
    {
      id: "28699bd7-7600-4d2c-b003-4c1c87d27310",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21a4b145-e3d1-4c39-ac6d-a0789720a01d",
      target: "f27f3e64-32fe-4fd7-96c6-d2bbf1f08dd1"
    },
    {
      id: "1c2ab9d7-eedc-47df-9cb3-521504c96878",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f27f3e64-32fe-4fd7-96c6-d2bbf1f08dd1",
      target: "c3841731-6ce1-42dd-b83f-cf49d4eddc41"
    },
    {
      id: "73ca675e-3538-4811-8f81-fc6d74fbf02f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a829eec0-3e4f-49de-a8c3-3fdca7e9e157",
      target: "72334aef-2df0-447d-9bfa-745351fa577c"
    },
    {
      id: "8e7ce37a-5e3e-49f9-b446-a81dd5bb16cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a986bbd8-925e-4eb8-9cdc-f55be8038ef4",
      target: "39423d85-09da-4665-9168-25726a6a44fc"
    },
    {
      id: "2691e70b-210e-42f7-9d40-889b828701d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a986bbd8-925e-4eb8-9cdc-f55be8038ef4",
      target: "4ac15812-9e9e-4259-8d4c-5fba895745fc"
    },
    {
      id: "99785e57-d7a0-444f-b547-8ac5f541e3d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58e94545-4197-4edd-89ef-707997c1586e",
      target: "72334aef-2df0-447d-9bfa-745351fa577c"
    },
    {
      id: "5110d757-3a2e-4647-9037-9a059c59e2f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a8be261-5c5f-41a0-9142-f7d2d4155195",
      target: "72334aef-2df0-447d-9bfa-745351fa577c"
    },
    {
      id: "ee1e9a9d-bd83-477f-a8fe-61c4bd4c0d5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "39423d85-09da-4665-9168-25726a6a44fc",
      target: "c3841731-6ce1-42dd-b83f-cf49d4eddc41"
    },
    {
      id: "0fd0c995-8230-402c-ac4d-71c13ece7fe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72334aef-2df0-447d-9bfa-745351fa577c",
      target: "08f864e1-e348-44d3-b572-20c9a0dcf496"
    },
    {
      id: "0b5fa221-c112-4a32-9eaf-28ae60ea203c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "72334aef-2df0-447d-9bfa-745351fa577c",
      target: "a312a493-b127-46dc-80ba-8f6ca5f888de"
    },
    {
      id: "17bac5cc-87bb-46cc-9871-92c095ecbb20",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3841731-6ce1-42dd-b83f-cf49d4eddc41",
      target: "25ae1d52-5d50-4b4f-b961-139eaa0b4756"
    },
    {
      id: "b605d24d-a342-4ce4-b0ce-c356592d85f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "25ae1d52-5d50-4b4f-b961-139eaa0b4756",
      target: "3b798bb2-0d45-402b-aace-562d29adc534"
    },
    {
      id: "d4360b2d-258d-48c9-aa33-176af3573b3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3b798bb2-0d45-402b-aace-562d29adc534",
      target: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3"
    },
    {
      id: "9c0e39f2-d080-4cb2-a3a3-3486c087ea13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      target: "1f8684f7-a981-49d6-8a09-5640ea4d3b7a"
    },
    {
      id: "b59af340-3172-43fe-b6bf-cf55fbcb9688",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      target: "2f3e4660-858d-4118-9009-800cc103b7e0"
    },
    {
      id: "5c7f2937-7406-40ff-b937-1844506b8038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      target: "a312a493-b127-46dc-80ba-8f6ca5f888de"
    },
    {
      id: "53597827-e3f2-476f-b51e-4f84a35b9a4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      target: "08f864e1-e348-44d3-b572-20c9a0dcf496"
    },
    {
      id: "850395f6-0725-48f1-9f76-cb086812944d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "592ceb3f-a0dd-4b90-a82a-0b336ee047c3",
      target: "70152441-2a85-45da-b325-6014f470680a"
    },
    {
      id: "ea3218dc-9893-438e-be49-0ee7ca0e29fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f8684f7-a981-49d6-8a09-5640ea4d3b7a",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "1c15bec2-8b89-4771-8b1e-ecf084c5f6a6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1f8684f7-a981-49d6-8a09-5640ea4d3b7a",
      target: "b976b124-dea5-4d7e-bf5a-bb842e781a6b"
    },
    {
      id: "2656361d-5cfd-4598-9bde-3fed0ac3eac0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a312a493-b127-46dc-80ba-8f6ca5f888de",
      target: "b976b124-dea5-4d7e-bf5a-bb842e781a6b"
    },
    {
      id: "687fd56b-8121-4d2c-af90-caf0f58590a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "08f864e1-e348-44d3-b572-20c9a0dcf496",
      target: "b976b124-dea5-4d7e-bf5a-bb842e781a6b"
    },
    {
      id: "e6d086c2-e9cd-4b15-ae0c-e876f53b2147",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2f3e4660-858d-4118-9009-800cc103b7e0",
      target: "6fd8490f-4a09-4e79-9a09-a9f4911f3206"
    },
    {
      id: "d148f3f1-d348-4435-bb88-9bf9b42dfb7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70152441-2a85-45da-b325-6014f470680a",
      target: "eeebdf7d-b0c8-4805-b83d-fa308a0f41be"
    },
    {
      id: "78af58f6-08f8-455e-8b8b-8e1b003754f6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70152441-2a85-45da-b325-6014f470680a",
      target: "2f3e4660-858d-4118-9009-800cc103b7e0"
    },
    {
      id: "3391ce37-2c25-43d4-9c36-bdd2f06a9b9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6fd8490f-4a09-4e79-9a09-a9f4911f3206",
      target: "a4cca5c4-bec2-4b39-8728-e316501776da"
    },
    {
      id: "853f4994-7fa5-4947-82aa-aa3217289006",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeebdf7d-b0c8-4805-b83d-fa308a0f41be",
      target: "b976b124-dea5-4d7e-bf5a-bb842e781a6b"
    },
    {
      id: "c6e4ab27-df3d-4060-8f5c-5740548dc8b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4cca5c4-bec2-4b39-8728-e316501776da",
      target: "b976b124-dea5-4d7e-bf5a-bb842e781a6b"
    },
    {
      id: "57d8230c-c006-46dd-b11a-fc678d9c916d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b976b124-dea5-4d7e-bf5a-bb842e781a6b",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "65349f6a-4334-435c-8419-df89ef5fa96a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b976b124-dea5-4d7e-bf5a-bb842e781a6b",
      target: "1d314deb-145a-4291-845c-6265c36e459a"
    },
    {
      id: "25ebcf31-0166-4988-ab39-6ed466194c7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b976b124-dea5-4d7e-bf5a-bb842e781a6b",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "3b6821d3-65bf-4a9f-8d00-e8ab348779d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      target: "9943b970-1777-4ae7-8e66-ce20ddbd341b"
    },
    {
      id: "8b0e9894-10f6-4203-ae7f-30b7eea219c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      target: "c60c5278-1433-4174-9598-486d74d53204"
    },
    {
      id: "d04eadf7-65fc-4d14-99df-2b5558499bfa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      target: "8dfba035-7dd7-4d9a-8815-dcbdab6d6ead"
    },
    {
      id: "af58488d-72c9-4580-83f9-5d7865ddf584",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      target: "69665203-6cf0-42df-b0f5-54356551c93f"
    },
    {
      id: "d6c5d393-9de1-4deb-a455-6778b0a777de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7116d46-50d6-4458-b6c5-af8e6fabd40c",
      target: "4ac15812-9e9e-4259-8d4c-5fba895745fc"
    },
    {
      id: "d9bc1896-f4a9-4632-b9f7-3f0c2448c1d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8dfba035-7dd7-4d9a-8815-dcbdab6d6ead",
      target: "434e09f1-6149-420d-a10e-3a5f5a279eee"
    },
    {
      id: "23798e8d-03fb-45e2-9d48-88598e36e522",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69665203-6cf0-42df-b0f5-54356551c93f",
      target: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d"
    },
    {
      id: "528a9385-a5b6-4e2c-8053-91aea213b6a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ac15812-9e9e-4259-8d4c-5fba895745fc",
      target: "53c9a6e9-fb4e-4050-afd8-3489cd9fd586"
    },
    {
      id: "1585e144-9d2f-4061-b038-bc5b97a006c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9943b970-1777-4ae7-8e66-ce20ddbd341b",
      target: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d"
    },
    {
      id: "f22fcdaf-5533-401a-8bb3-1fe4970c5c2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c60c5278-1433-4174-9598-486d74d53204",
      target: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d"
    },
    {
      id: "d4f062b1-7e28-4b1b-a353-0ab6b6856279",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53c9a6e9-fb4e-4050-afd8-3489cd9fd586",
      target: "434e09f1-6149-420d-a10e-3a5f5a279eee"
    },
    {
      id: "bde6c427-45fe-4f8d-83e1-f873b4151f66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d",
      target: "14dd7026-97aa-4a4a-8661-bd96e3898dda"
    },
    {
      id: "cf909b25-daa0-49f7-87dc-8d678f2f30b2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "57a7ff2c-842b-425b-a15f-fd9b9ccda26d",
      target: "b24f4699-923a-404a-88fc-9f097768e13f"
    },
    {
      id: "af563620-6c22-4434-987b-9e3590835238",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "434e09f1-6149-420d-a10e-3a5f5a279eee",
      target: "262a0d87-2f90-4eb6-a570-bfbfe5a8b556"
    },
    {
      id: "c1fcc4ce-5c2b-458b-ac43-34592fac677e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "262a0d87-2f90-4eb6-a570-bfbfe5a8b556",
      target: "a3168fca-209e-4712-bab1-e0349ac881e8"
    },
    {
      id: "b80ca622-6923-4e6c-88b7-becbdc72c45b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3168fca-209e-4712-bab1-e0349ac881e8",
      target: "30516502-2e91-4a7b-bb80-a2e01f452038"
    },
    {
      id: "759041da-ce46-431f-b3ad-2abd64f9064c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "30516502-2e91-4a7b-bb80-a2e01f452038",
      target: "53d4bc53-71ab-465b-9b5c-2ffbe6d887aa"
    },
    {
      id: "638dd653-43aa-45d0-9850-46cff16c67e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30516502-2e91-4a7b-bb80-a2e01f452038",
      target: "b24f4699-923a-404a-88fc-9f097768e13f"
    },
    {
      id: "a5848c9e-14ff-493e-a735-c8c2b0a1842d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30516502-2e91-4a7b-bb80-a2e01f452038",
      target: "ff68b3dd-a4a4-4715-a799-2aa656cf93c2"
    },
    {
      id: "bb555432-68dc-4d2b-906f-ec71d8336f9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30516502-2e91-4a7b-bb80-a2e01f452038",
      target: "14dd7026-97aa-4a4a-8661-bd96e3898dda"
    },
    {
      id: "dac60528-7632-41b5-93d4-f2fe43ae4610",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30516502-2e91-4a7b-bb80-a2e01f452038",
      target: "6834fe2e-eabc-450c-9f15-e11bb2c0a456"
    },
    {
      id: "891b430e-d761-48e7-9f20-1fe6ca4b8115",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6834fe2e-eabc-450c-9f15-e11bb2c0a456",
      target: "fa7c6ea4-d312-44f8-a93c-cf51af232331"
    },
    {
      id: "6a38de4d-b564-4404-8a83-89140376d20f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6834fe2e-eabc-450c-9f15-e11bb2c0a456",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "5ddc0cc4-0b8a-48ec-bb21-12dc9bf0b4ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b24f4699-923a-404a-88fc-9f097768e13f",
      target: "fa7c6ea4-d312-44f8-a93c-cf51af232331"
    },
    {
      id: "9bd0e2c0-b601-41c5-b684-ed0407104428",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14dd7026-97aa-4a4a-8661-bd96e3898dda",
      target: "fa7c6ea4-d312-44f8-a93c-cf51af232331"
    },
    {
      id: "fb85e6f5-f2df-4eb8-bbeb-fb0b8539d3ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53d4bc53-71ab-465b-9b5c-2ffbe6d887aa",
      target: "acb78903-07c0-4dda-ad65-37ccc29818e7"
    },
    {
      id: "b7de741b-e945-4658-bc23-3c51e9cd5d8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff68b3dd-a4a4-4715-a799-2aa656cf93c2",
      target: "f19d5158-9866-45eb-b654-7edfba9a5c6d"
    },
    {
      id: "913b5d5b-21fa-4f21-8405-f9443506b6c0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ff68b3dd-a4a4-4715-a799-2aa656cf93c2",
      target: "53d4bc53-71ab-465b-9b5c-2ffbe6d887aa"
    },
    {
      id: "429f65c0-c141-43a9-ad54-f05cb0905645",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acb78903-07c0-4dda-ad65-37ccc29818e7",
      target: "11fec43e-cfa4-4cde-be18-8b365ff358a7"
    },
    {
      id: "3a155ee1-a367-42ed-9a7b-132f71b6384a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f19d5158-9866-45eb-b654-7edfba9a5c6d",
      target: "fa7c6ea4-d312-44f8-a93c-cf51af232331"
    },
    {
      id: "256a5dd5-726c-4d71-a1c0-dce9154f93d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11fec43e-cfa4-4cde-be18-8b365ff358a7",
      target: "fa7c6ea4-d312-44f8-a93c-cf51af232331"
    },
    {
      id: "16b7ebf7-7056-42a8-b71c-17e02c64d906",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa7c6ea4-d312-44f8-a93c-cf51af232331",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "834212ff-9811-440d-abe9-d25e249264c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa7c6ea4-d312-44f8-a93c-cf51af232331",
      target: "5d6b61b4-8b2e-4901-821d-125438c2d3e1"
    },
    {
      id: "7481fa3b-694d-4318-abe2-ff435690f3dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa7c6ea4-d312-44f8-a93c-cf51af232331",
      target: "1d314deb-145a-4291-845c-6265c36e459a"
    },
    {
      id: "939e99af-04ef-42f0-80d3-92f0a8085fc1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5cc06ab5-92a7-4e7d-9ef2-61ece064ce5e",
      target: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536"
    },
    {
      id: "8e4b933c-7d14-4ca8-a986-8551d3009cf3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "4b1d15f5-7710-4930-a02e-4ce90445eb71"
    },
    {
      id: "960c07ca-1e55-4905-add8-2e89e4cc8b7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "d3ccd2d0-9f36-4a67-a054-8012a25ce12d"
    },
    {
      id: "6ec229cb-f273-4e7d-80e5-efd970ae05ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "abac7b65-cccd-4286-a5b0-390254902430"
    },
    {
      id: "bdca1207-388d-44f4-8ead-fe5e7906fdbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "43d6197c-7136-457b-9591-fd45d51df0cb"
    },
    {
      id: "9a4372d0-4bb2-405e-b2d6-2c8c32c97941",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353"
    },
    {
      id: "6d2aefc8-1d80-4d50-bc65-705ee54ffd00",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353"
    },
    {
      id: "517d37f9-1e9a-4e3f-9bd4-63b16f16e1e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6b3416f-4ecd-4f62-b6ae-e5c0405d4536",
      target: "0836a228-0278-4103-9648-c0291d2dcd59"
    },
    {
      id: "72122d84-6536-4047-9f95-90c3d21000db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0836a228-0278-4103-9648-c0291d2dcd59",
      target: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618"
    },
    {
      id: "16c3ad67-193a-4886-95f8-e4f7775bc928",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d3ccd2d0-9f36-4a67-a054-8012a25ce12d",
      target: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618"
    },
    {
      id: "04d2cffd-a4db-4e08-873d-4ee0954bab77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b1d15f5-7710-4930-a02e-4ce90445eb71",
      target: "9a548f49-0376-44cc-a0a2-f30c07480762"
    },
    {
      id: "10832f6b-d6e6-40a0-9466-99f9155be1d0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "abac7b65-cccd-4286-a5b0-390254902430",
      target: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618"
    },
    {
      id: "da918bef-3474-4111-876b-f7d1a16cefd1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43d6197c-7136-457b-9591-fd45d51df0cb",
      target: "cd1295e0-1c90-4bd4-af92-f3500ca14548"
    },
    {
      id: "611bbd65-c10e-4705-9a48-f1dbe5acacc3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43d6197c-7136-457b-9591-fd45d51df0cb",
      target: "4c61909e-e3ce-48e2-a4a6-53b5d7d40471"
    },
    {
      id: "be6d9f16-5ef3-4929-a3ad-d52cbba18a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618",
      target: "8b311f7c-6070-4db4-8e0d-186b9dc5ac49"
    },
    {
      id: "fd9f7c5c-90e3-4bf1-b273-5d5f30369824",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2e67fd00-bc47-4a1b-a9ce-5b58488e4618",
      target: "b69200e1-2621-439d-beea-baaf20ef03f1"
    },
    {
      id: "5b01b41e-048a-4521-8a85-4f699dba49fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd1295e0-1c90-4bd4-af92-f3500ca14548",
      target: "9a548f49-0376-44cc-a0a2-f30c07480762"
    },
    {
      id: "df05c32f-4779-46fc-a951-d5aed8c38917",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a548f49-0376-44cc-a0a2-f30c07480762",
      target: "72b88ae1-8587-42b2-b7eb-8f932042fbe1"
    },
    {
      id: "eaf8eab9-3f4c-4480-8c92-48dddbbaa934",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72b88ae1-8587-42b2-b7eb-8f932042fbe1",
      target: "4e389728-e415-4a59-8423-e0e2916efc56"
    },
    {
      id: "f8f260fb-375d-4b50-941e-3904d3260fca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e389728-e415-4a59-8423-e0e2916efc56",
      target: "d1127824-715e-4f69-a6f6-ec2be70f6e9f"
    },
    {
      id: "40d197ad-7813-40ce-9058-b95a292b2ce8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e389728-e415-4a59-8423-e0e2916efc56",
      target: "7a764c24-46fa-433f-8538-20c230e46ca8"
    },
    {
      id: "273462ce-0d8e-4880-991d-179a5523eca0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a764c24-46fa-433f-8538-20c230e46ca8",
      target: "43a7fcf4-0b26-4e24-a817-3f6a3fccc8d6"
    },
    {
      id: "62262a54-0090-4d9b-80a3-7095b0a7a6f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1127824-715e-4f69-a6f6-ec2be70f6e9f",
      target: "8b311f7c-6070-4db4-8e0d-186b9dc5ac49"
    },
    {
      id: "0a184f0d-cb15-4200-ad4c-8db243e6d16a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1127824-715e-4f69-a6f6-ec2be70f6e9f",
      target: "b69200e1-2621-439d-beea-baaf20ef03f1"
    },
    {
      id: "7fe49454-d1ed-44de-91d4-74e1523ce9bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1127824-715e-4f69-a6f6-ec2be70f6e9f",
      target: "d891792d-cfac-4918-8676-d7f4b4e620cb"
    },
    {
      id: "08021e15-f0f0-4dbe-a59e-4356f867c7c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43a7fcf4-0b26-4e24-a817-3f6a3fccc8d6",
      target: "bf9f4177-95ed-4cb0-b7ea-a3a9a194ee65"
    },
    {
      id: "3de05125-fd48-40c0-b1f3-041e6b026afb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b69200e1-2621-439d-beea-baaf20ef03f1",
      target: "d302ebf8-480a-4480-98e8-95b57a21e0bb"
    },
    {
      id: "7e0cf2ae-9f52-41f3-bd47-3c5e28e61986",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b311f7c-6070-4db4-8e0d-186b9dc5ac49",
      target: "d302ebf8-480a-4480-98e8-95b57a21e0bb"
    },
    {
      id: "35d02a3a-9a19-49f3-aa8d-7b97fd745873",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d891792d-cfac-4918-8676-d7f4b4e620cb",
      target: "d302ebf8-480a-4480-98e8-95b57a21e0bb"
    },
    {
      id: "016d8502-b900-4d43-aca6-84fdd512cf8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bf9f4177-95ed-4cb0-b7ea-a3a9a194ee65",
      target: "d302ebf8-480a-4480-98e8-95b57a21e0bb"
    },
    {
      id: "28cb4c12-aa7e-4a1d-84b2-d6d8f5a737f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d302ebf8-480a-4480-98e8-95b57a21e0bb",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "11265597-124a-42cf-ba69-a8aa1ed5add1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d302ebf8-480a-4480-98e8-95b57a21e0bb",
      target: "a530a7df-8470-4ebe-9bce-c0482f5a1f32"
    },
    {
      id: "452ed464-cbcb-4389-aa0d-64744b1415c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d302ebf8-480a-4480-98e8-95b57a21e0bb",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "ff89579e-3d61-4913-8d11-42978450cf52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      target: "8dfdc9bd-40e1-45b4-b960-4270525057fd"
    },
    {
      id: "a7dbb765-cdb0-4751-9b1d-37568b28e1e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      target: "dd2d09af-f119-45dc-a7a4-77a29c8615b9"
    },
    {
      id: "095a7ee5-1297-46b6-853a-1839f5ebdcc8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      target: "a2964479-5c5e-4859-a1ca-27c718652a9d"
    },
    {
      id: "473b91f8-24b0-47bd-8a16-c714bcd0bc02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      target: "3c770400-513d-4113-ae9a-5b8161608f3f"
    },
    {
      id: "6f73756d-b10c-485c-a97f-27326a1215bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a33b692-a3d9-47b6-b35c-c33d1cb0e353",
      target: "4c61909e-e3ce-48e2-a4a6-53b5d7d40471"
    },
    {
      id: "fa7ed2ee-741c-4723-a176-3c7709324345",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c770400-513d-4113-ae9a-5b8161608f3f",
      target: "68653b4e-705a-414d-8c18-7eb7442e2036"
    },
    {
      id: "be997441-0aa3-46a2-8d48-5ff342396c11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8dfdc9bd-40e1-45b4-b960-4270525057fd",
      target: "d1105f58-85cd-499a-b014-ff15c6300089"
    },
    {
      id: "01d9ea6e-842c-4e6d-8ce4-5127fe278b40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c61909e-e3ce-48e2-a4a6-53b5d7d40471",
      target: "f487bf81-6138-4387-9fa1-ff6e2e4171dc"
    },
    {
      id: "31f6c8a8-1c6c-4f65-9194-d856025a81c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd2d09af-f119-45dc-a7a4-77a29c8615b9",
      target: "d1105f58-85cd-499a-b014-ff15c6300089"
    },
    {
      id: "bd882009-6eee-4fb9-9730-548cb1efa52a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a2964479-5c5e-4859-a1ca-27c718652a9d",
      target: "d1105f58-85cd-499a-b014-ff15c6300089"
    },
    {
      id: "d6581963-0d2a-48aa-a70b-87bc85059751",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f487bf81-6138-4387-9fa1-ff6e2e4171dc",
      target: "68653b4e-705a-414d-8c18-7eb7442e2036"
    },
    {
      id: "eff00c81-b2d7-44ed-b99d-cf5d9f8857f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1105f58-85cd-499a-b014-ff15c6300089",
      target: "9e71e842-0dd8-4fdd-bf57-c970443541ec"
    },
    {
      id: "ab0e74a2-8a6d-4065-b979-5f235f19827a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d1105f58-85cd-499a-b014-ff15c6300089",
      target: "ab6020ca-b7f2-4a90-a390-743c5968fa60"
    },
    {
      id: "c88fe3a9-bc66-41e0-aa9f-0210e8967d43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68653b4e-705a-414d-8c18-7eb7442e2036",
      target: "6f95fff8-f1f8-4092-9a6e-10f6b1a2d946"
    },
    {
      id: "a498893a-2f79-4dab-8507-a81a285129b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f95fff8-f1f8-4092-9a6e-10f6b1a2d946",
      target: "193ac790-6241-4c4d-8b9b-2d8dbeb9d2f7"
    },
    {
      id: "519c0c54-b03c-482b-8ebf-f763ffc80399",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "193ac790-6241-4c4d-8b9b-2d8dbeb9d2f7",
      target: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596"
    },
    {
      id: "20e2e273-c9f2-47d3-8fda-a3110c589913",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      target: "3a1f2661-10c8-4f6c-99b3-2bb4ad934c0e"
    },
    {
      id: "3fb70c74-0bb5-4985-ba88-0d58f4aa6f1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      target: "aad612cb-5df2-49ab-8f2e-e80272da8a25"
    },
    {
      id: "76add50e-3162-4674-8333-b28a1ea88313",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      target: "ab6020ca-b7f2-4a90-a390-743c5968fa60"
    },
    {
      id: "136f2b27-08ce-4ea6-b76a-98df6381644e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      target: "fc995a77-06a1-4ddc-a685-38eaee1cf2cf"
    },
    {
      id: "86919b82-ac97-43ef-a7ed-a6e044ef4478",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a400ca7-9b8f-45d6-9016-2f5bb46e7596",
      target: "9e71e842-0dd8-4fdd-bf57-c970443541ec"
    },
    {
      id: "7ec953c0-7e25-4e5a-bbe7-90f02fdaeff0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a1f2661-10c8-4f6c-99b3-2bb4ad934c0e",
      target: "5a87ebd8-615f-4259-a1a3-f0ac70e94174"
    },
    {
      id: "dc82215d-b88d-4ebd-9d38-e4d50a713558",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a1f2661-10c8-4f6c-99b3-2bb4ad934c0e",
      target: "4a394329-1f20-4ba6-ba96-af2c24a7f240"
    },
    {
      id: "97208e9d-c89c-444c-81f8-59d554d0737a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ab6020ca-b7f2-4a90-a390-743c5968fa60",
      target: "4a394329-1f20-4ba6-ba96-af2c24a7f240"
    },
    {
      id: "4e092b46-4e4b-42b2-b007-2144599bbcbe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e71e842-0dd8-4fdd-bf57-c970443541ec",
      target: "4a394329-1f20-4ba6-ba96-af2c24a7f240"
    },
    {
      id: "42804142-0de9-40df-8281-d478710a4bfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fc995a77-06a1-4ddc-a685-38eaee1cf2cf",
      target: "f715f119-44b4-4cf3-a3b8-4fcfa534a19f"
    },
    {
      id: "6586f0ae-3d32-4e78-a57d-cd8b352a10de",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aad612cb-5df2-49ab-8f2e-e80272da8a25",
      target: "fc995a77-06a1-4ddc-a685-38eaee1cf2cf"
    },
    {
      id: "a86c3efb-343b-4bc7-bdaf-aa9c1be3f7b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aad612cb-5df2-49ab-8f2e-e80272da8a25",
      target: "cb4f66b6-5fd3-4bb8-9062-f89db19b4771"
    },
    {
      id: "0b9396b9-fc86-4480-9eb5-c20c59fe1472",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f715f119-44b4-4cf3-a3b8-4fcfa534a19f",
      target: "06a3be6c-b5de-4abc-94d0-4c2ce243f7e0"
    },
    {
      id: "2e4d9565-8170-4fcd-9881-1df202121e9e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb4f66b6-5fd3-4bb8-9062-f89db19b4771",
      target: "4a394329-1f20-4ba6-ba96-af2c24a7f240"
    },
    {
      id: "0f049e43-f88d-44ac-bad7-6adbc815c300",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06a3be6c-b5de-4abc-94d0-4c2ce243f7e0",
      target: "4a394329-1f20-4ba6-ba96-af2c24a7f240"
    },
    {
      id: "ea311d4c-70b4-4dce-89ee-4f6aa0dc5936",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a394329-1f20-4ba6-ba96-af2c24a7f240",
      target: "f38f33ac-e3d5-4a5a-9931-13e111e24a3a"
    },
    {
      id: "a3efb7a4-621d-4bee-b7fa-78d27e7277c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a394329-1f20-4ba6-ba96-af2c24a7f240",
      target: "1d314deb-145a-4291-845c-6265c36e459a"
    },
    {
      id: "af093b79-eeda-445d-93a7-63b1d973c585",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a394329-1f20-4ba6-ba96-af2c24a7f240",
      target: "d302ebf8-480a-4480-98e8-95b57a21e0bb"
    },
    {
      id: "14f4c67e-52de-4e2a-a9f1-e0d00aa25a85",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bd66cb46-a83b-4343-a7d4-12d68b9d29cf",
      target: "a4ea5949-5450-4bfb-88c8-41264315f483"
    },
    {
      id: "e205999a-ebda-47fe-9a94-84e40d182374",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "319cad03-f286-4cf3-a0ca-2508bae43bd6"
    },
    {
      id: "a32323e3-2ed5-411d-a89c-a6dc350cf515",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "bd66cb46-a83b-4343-a7d4-12d68b9d29cf"
    },
    {
      id: "1a1aea63-1495-4a58-912d-d818ebf6b66f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "4005f465-801e-4fea-a79b-889c0bd10235",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "207912f4-26eb-4930-8525-f8087ab8d1a4"
    },
    {
      id: "cd65cfc9-bac9-4123-8aef-43479c61c98c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "cf54332c-9ab7-45c9-87d4-5bea320c830f"
    },
    {
      id: "8519f77d-07f3-439c-9786-94e012e5d3c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "bc6b0566-84da-4421-adbb-c29bb4256d70"
    },
    {
      id: "22f79982-f0e1-46d2-b362-b4ad094720af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "319cad03-f286-4cf3-a0ca-2508bae43bd6"
    },
    {
      id: "8a64a33e-8e26-4841-91ab-b2a32ca08c4c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7607e97b-3881-43c4-8b6a-06f0087f28ff",
      target: "25b2932a-9187-4591-88d1-d0b44210b49f"
    },
    {
      id: "cd4fee47-e31e-41ac-bef0-4e2182a5061d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "319cad03-f286-4cf3-a0ca-2508bae43bd6",
      target: "ff8762d0-f06d-4f2d-a558-754d08237efd"
    },
    {
      id: "72695090-18e1-4d3c-94cb-c86cc62c5dbc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "319cad03-f286-4cf3-a0ca-2508bae43bd6",
      target: "752e1424-4966-438f-9f13-63617950bdd2"
    },
    {
      id: "7cecfbd4-8a35-493a-83f7-1c938ed017b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "207912f4-26eb-4930-8525-f8087ab8d1a4",
      target: "ff8762d0-f06d-4f2d-a558-754d08237efd"
    },
    {
      id: "8a0f4de3-d204-48c0-9e02-c53d17f35dbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff8762d0-f06d-4f2d-a558-754d08237efd",
      target: "754fc69d-b798-452e-a865-47a7a190ce80"
    },
    {
      id: "69c635d4-8ff6-4044-8b64-99f86f86061f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ff8762d0-f06d-4f2d-a558-754d08237efd",
      target: "bc6b0566-84da-4421-adbb-c29bb4256d70"
    },
    {
      id: "99e78ff1-1f3f-4aba-a810-e74dea4b3f96",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "752e1424-4966-438f-9f13-63617950bdd2",
      target: "a4ea5949-5450-4bfb-88c8-41264315f483"
    },
    {
      id: "0573e5d8-5ca7-4058-8f86-25bac3ee6790",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "754fc69d-b798-452e-a865-47a7a190ce80",
      target: "a4ea5949-5450-4bfb-88c8-41264315f483"
    },
    {
      id: "f6da1eaf-7d80-4752-a31b-9bf91b220b3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "754fc69d-b798-452e-a865-47a7a190ce80",
      target: "9a014585-bce5-4d8e-bf63-bc24dafe0459"
    },
    {
      id: "525a5fb2-3bb0-4091-b923-f7cb9a78d725",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4ea5949-5450-4bfb-88c8-41264315f483",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "4327f457-91e7-4051-89c3-63abf4aa3823",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4ea5949-5450-4bfb-88c8-41264315f483",
      target: "6578e9d9-ca51-45cc-8726-cf66b2a066ee"
    },
    {
      id: "8039003b-2a2a-4adf-a4ff-128d21bbba23",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6578e9d9-ca51-45cc-8726-cf66b2a066ee",
      target: "9a014585-bce5-4d8e-bf63-bc24dafe0459"
    },
    {
      id: "7ad88252-dbfd-4139-96a1-acb5de42e858",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6578e9d9-ca51-45cc-8726-cf66b2a066ee",
      target: "68a8d25d-3804-4628-8a6c-2155632ed6e1"
    },
    {
      id: "4ef5f93a-c4d7-4d9a-8444-077178a07ce4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6578e9d9-ca51-45cc-8726-cf66b2a066ee",
      target: "6d9a179c-138d-41ae-8419-5346393de16e"
    },
    {
      id: "c70849fe-3f78-4a8c-b3f5-89e19d6d4f5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d9a179c-138d-41ae-8419-5346393de16e",
      target: "6da7e5b6-cf76-4f81-afdb-d45d765ec174"
    },
    {
      id: "69b1cdb0-da53-4fda-9757-e88c179f6257",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d9a179c-138d-41ae-8419-5346393de16e",
      target: "9a014585-bce5-4d8e-bf63-bc24dafe0459"
    },
    {
      id: "88e78b2e-5fd8-4ec6-ae26-bcb00ed64696",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a014585-bce5-4d8e-bf63-bc24dafe0459",
      target: "2d44d520-a537-4ad7-8497-b8a3633f9a96"
    },
    {
      id: "529e38b8-1d67-410f-a324-b572d1bf883a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9a014585-bce5-4d8e-bf63-bc24dafe0459",
      target: "24b28ae6-80d0-4f83-83f5-84a3255480da"
    },
    {
      id: "11841176-170e-4655-ba43-afb6078f7c7d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "24b28ae6-80d0-4f83-83f5-84a3255480da",
      target: "d60e5d74-84ee-43dc-8ae9-114b9e9d043b"
    },
    {
      id: "efc0bc08-6f10-4df1-966a-69616c8ee879",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d60e5d74-84ee-43dc-8ae9-114b9e9d043b",
      target: "9a40c74c-0517-4c16-bd48-c4c4ad122b9b"
    },
    {
      id: "cb7e7af5-dd4f-489d-8fb7-d6041d343366",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9a40c74c-0517-4c16-bd48-c4c4ad122b9b",
      target: "f1623286-778b-4ba2-8a13-427cb953b423"
    },
    {
      id: "0fc87e83-92b6-4586-8719-b8513bec3677",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9a40c74c-0517-4c16-bd48-c4c4ad122b9b",
      target: "14902242-0aa9-44e2-a0d4-0c8d86470433"
    },
    {
      id: "c529af03-c169-4fee-ae54-a7ab4e207077",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14902242-0aa9-44e2-a0d4-0c8d86470433",
      target: "1aab4538-58f4-4246-8a27-60f4012d85d6"
    },
    {
      id: "0a9df1fd-e525-4796-828a-cc3b28d1a037",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1aab4538-58f4-4246-8a27-60f4012d85d6",
      target: "37de87a5-7c12-4763-95c3-bd1586a52de8"
    },
    {
      id: "089afd7b-6325-4942-98ec-7ecf581e20d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37de87a5-7c12-4763-95c3-bd1586a52de8",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "d03ff1c0-2ad8-45bc-959a-8156a97fd8b4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "37de87a5-7c12-4763-95c3-bd1586a52de8",
      target: "6da7e5b6-cf76-4f81-afdb-d45d765ec174"
    },
    {
      id: "6c9c7b8d-5d2f-4676-bb47-e10808e6f534",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6da7e5b6-cf76-4f81-afdb-d45d765ec174",
      target: "f300c1c1-efdb-4e47-8bbb-a0cfbc3391f6"
    },
    {
      id: "d47ff6f0-2698-44f2-84b4-51249f78333f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1623286-778b-4ba2-8a13-427cb953b423",
      target: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c"
    },
    {
      id: "363eb26c-714a-4223-8cb7-1b522e4427c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f300c1c1-efdb-4e47-8bbb-a0cfbc3391f6",
      target: "b72687f8-5862-451e-afde-3cf80999acfb"
    },
    {
      id: "e2d4ba5b-32d4-4862-96a8-d32d85beb8c7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b72687f8-5862-451e-afde-3cf80999acfb",
      target: "0dd13668-e3a3-4dc1-9a64-c942c4ec6174"
    },
    {
      id: "2d9df333-4bf1-4c9f-bffd-d58af4e75c71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0dd13668-e3a3-4dc1-9a64-c942c4ec6174",
      target: "5556f3d9-5f68-4d27-a631-3ea52a86e32c"
    },
    {
      id: "53053660-24cf-4590-b5a2-4830c046eea7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0dd13668-e3a3-4dc1-9a64-c942c4ec6174",
      target: "a740fcc5-a56f-4367-8cff-c757f5c937d9"
    },
    {
      id: "7d26581a-cd38-4701-8b64-7e633794d3cf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0dd13668-e3a3-4dc1-9a64-c942c4ec6174",
      target: "b48817fe-1eac-4caa-a97a-f669f829c86c"
    },
    {
      id: "1577cf95-bbef-4502-ae9a-ba92b264317a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a740fcc5-a56f-4367-8cff-c757f5c937d9",
      target: "7d349ec9-b5b0-46eb-9861-cc3e5d3c1039"
    },
    {
      id: "b14c37b0-463e-49ab-acd3-8cb538373d42",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a740fcc5-a56f-4367-8cff-c757f5c937d9",
      target: "45735b5d-f763-4159-9283-12a672462f7c"
    },
    {
      id: "d4e624f3-c169-4c1d-ba5a-472d3559f613",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b48817fe-1eac-4caa-a97a-f669f829c86c",
      target: "770fc0bd-3ef4-4dc1-baf3-ba46b4c4f6d6"
    },
    {
      id: "8cd4a8aa-aa59-4836-a4f7-04b1b9b5e4a2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b48817fe-1eac-4caa-a97a-f669f829c86c",
      target: "7db0ee12-4437-4c14-8fd2-f69485405b43"
    },
    {
      id: "8c8b0ba1-6153-4e69-bd5e-6be85a3ef61a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5556f3d9-5f68-4d27-a631-3ea52a86e32c",
      target: "45735b5d-f763-4159-9283-12a672462f7c"
    },
    {
      id: "f83aa0f5-0881-4df0-9590-b32c5fec6ae4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5556f3d9-5f68-4d27-a631-3ea52a86e32c",
      target: "d3471800-12a4-4b40-bd54-482e98c2ef65"
    },
    {
      id: "6dec451c-28d8-470b-8c27-03a199bcd385",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "770fc0bd-3ef4-4dc1-baf3-ba46b4c4f6d6",
      target: "95762aa0-d832-412b-b282-97cbe0ea5891"
    },
    {
      id: "662073b1-0e57-42e7-a77b-4f45bf389ec7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "45735b5d-f763-4159-9283-12a672462f7c",
      target: "e6085549-a03f-45d5-a865-2a6f25e2ad64"
    },
    {
      id: "b2e0a4db-4797-48cb-8c0b-2c7416312b85",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d3471800-12a4-4b40-bd54-482e98c2ef65",
      target: "3369bd3a-4a9c-4256-99ba-9a4fd892669a"
    },
    {
      id: "c177dbca-aa4d-4e38-9e5c-0023d12bdb78",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7db0ee12-4437-4c14-8fd2-f69485405b43",
      target: "95762aa0-d832-412b-b282-97cbe0ea5891"
    },
    {
      id: "31be8f14-0ca8-4773-8133-005b16b83b7b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95762aa0-d832-412b-b282-97cbe0ea5891",
      target: "e6085549-a03f-45d5-a865-2a6f25e2ad64"
    },
    {
      id: "dbc12ab6-d89c-4cdd-b98c-57424ed332b5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95762aa0-d832-412b-b282-97cbe0ea5891",
      target: "d06c7db2-eb01-4d57-8d91-7b4cd07b4e6d"
    },
    {
      id: "0ac2af9d-7df8-4224-8fea-0ce2b65e942b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e6085549-a03f-45d5-a865-2a6f25e2ad64",
      target: "3369bd3a-4a9c-4256-99ba-9a4fd892669a"
    },
    {
      id: "5832dd40-ba62-4da5-a258-ffad4ff7155f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d06c7db2-eb01-4d57-8d91-7b4cd07b4e6d",
      target: "4d03258e-82b0-490e-ad68-41d63b50d143"
    },
    {
      id: "5f3b66ef-db61-42e6-abc2-9d63f7a8c8f5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7d349ec9-b5b0-46eb-9861-cc3e5d3c1039",
      target: "45735b5d-f763-4159-9283-12a672462f7c"
    },
    {
      id: "9cf8f7e8-c191-41f0-83b6-edc743427d1c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3369bd3a-4a9c-4256-99ba-9a4fd892669a",
      target: "0cb8d2d6-9f62-452e-8872-7a2a92cdb29f"
    },
    {
      id: "751ccedf-f4ac-402f-839e-2c03dbaeaff8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3369bd3a-4a9c-4256-99ba-9a4fd892669a",
      target: "99c03453-6452-4bb4-9fe6-6be008a5da2a"
    },
    {
      id: "8db2890e-a2a9-4faa-be5f-e6c1563d1977",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3369bd3a-4a9c-4256-99ba-9a4fd892669a",
      target: "4615220c-de4a-44f0-85e6-bb0d52ee1741"
    },
    {
      id: "6d23cc3e-9e40-4891-b904-4b217f9dc1f2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3369bd3a-4a9c-4256-99ba-9a4fd892669a",
      target: "9bbd8dae-b3dd-490f-abaf-34673426dd19"
    },
    {
      id: "00663f66-00b0-4292-8707-ecd8dd44e516",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "99c03453-6452-4bb4-9fe6-6be008a5da2a",
      target: "4d03258e-82b0-490e-ad68-41d63b50d143"
    },
    {
      id: "893a69ca-005d-4f6f-92ba-d93fb3624382",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0cb8d2d6-9f62-452e-8872-7a2a92cdb29f",
      target: "4d03258e-82b0-490e-ad68-41d63b50d143"
    },
    {
      id: "19acc553-5982-4a79-9238-bc54ab5cd3e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9bbd8dae-b3dd-490f-abaf-34673426dd19",
      target: "4d03258e-82b0-490e-ad68-41d63b50d143"
    },
    {
      id: "fdf5a946-8f1e-422c-b548-3f8e2ef894a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4615220c-de4a-44f0-85e6-bb0d52ee1741",
      target: "4d03258e-82b0-490e-ad68-41d63b50d143"
    },
    {
      id: "f8215ab0-f72b-4cd8-bcfa-1b153f3467fb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4d03258e-82b0-490e-ad68-41d63b50d143",
      target: "ccba67c8-adc4-4740-beb2-3df108bebc9a"
    },
    {
      id: "f3984600-1a5e-4428-930e-37947e6903aa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ccba67c8-adc4-4740-beb2-3df108bebc9a",
      target: "c452041a-3361-46b1-9ccb-b1a9d87eec29"
    },
    {
      id: "6fc333d3-5758-4e25-b6b4-5c71fae195a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c452041a-3361-46b1-9ccb-b1a9d87eec29",
      target: "4e35fcfa-0392-428a-96ae-f2acb0a1cb46"
    },
    {
      id: "81f20bea-5dee-4ca9-b4f2-36b5a70c8443",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c452041a-3361-46b1-9ccb-b1a9d87eec29",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "cf090fe6-2f66-4f9d-a6d8-061a993dbbce",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4e35fcfa-0392-428a-96ae-f2acb0a1cb46",
      target: "35da25ca-6f7a-4029-80ca-d3567c9c5330"
    },
    {
      id: "9e3645a2-1799-4ee2-8deb-4438c74337d4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "35da25ca-6f7a-4029-80ca-d3567c9c5330",
      target: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c"
    },
    {
      id: "026a2dca-5e1a-41b4-aaf2-901ae1639e24",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c",
      target: "ce0557bc-a3c0-4b61-8182-6c8634289b86"
    },
    {
      id: "b0a7de36-bea7-44e7-90e7-2f63cda6057a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "f0bc43ae-0811-4dd0-a963-95fc383d960f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ce0557bc-a3c0-4b61-8182-6c8634289b86",
      target: "ad824291-d506-42f6-a968-e48d853eec45"
    },
    {
      id: "a0c25fc4-fb19-40bc-858c-a2f05df6ff1c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad824291-d506-42f6-a968-e48d853eec45",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "f87a868f-ac78-4f4b-a1b4-51975f1b884e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad824291-d506-42f6-a968-e48d853eec45",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "41e57162-82c4-44eb-b1e1-badebb512646",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "d981fa4d-70ed-4e80-b45c-4cecd0e62e10"
    },
    {
      id: "c2ced2f6-decf-4973-8c64-e77653e9513a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "ee8df115-d04f-4d4f-b0f0-1dc48af24fee"
    },
    {
      id: "a8bb08d3-5176-45db-9296-49e9c5802e69",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "ecbbfa11-10ac-4fdc-851d-a73792f09398"
    },
    {
      id: "812d8c97-020f-4788-829e-78b176abae36",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "ee8df115-d04f-4d4f-b0f0-1dc48af24fee"
    },
    {
      id: "47a7da69-8ee3-4d77-86f2-6be1ed3e67c0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "ecbbfa11-10ac-4fdc-851d-a73792f09398"
    },
    {
      id: "95072716-9424-4871-92e9-0bf3dd1ecde9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "25b2932a-9187-4591-88d1-d0b44210b49f",
      target: "d981fa4d-70ed-4e80-b45c-4cecd0e62e10"
    },
    {
      id: "154a00dd-9657-45cb-b9fd-c13b52cb6ad8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ee8df115-d04f-4d4f-b0f0-1dc48af24fee",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "9ed28d8a-4fc1-4f8d-8689-7ea9e6db312a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ee8df115-d04f-4d4f-b0f0-1dc48af24fee",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "4850fe6a-c8ef-4c31-80ec-192500b32217",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9",
      target: "ec0f34e5-946f-492c-a72e-105f868af682"
    },
    {
      id: "8ec3d5fd-5f23-48f0-afb5-ff01562e26c5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9",
      target: "7ced8c30-c0f2-42f2-95e4-44502bd2bbbb"
    },
    {
      id: "5b57299a-cbf8-45d8-b7d8-9d4e0a61880f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9",
      target: "ed3c6361-1794-4939-becf-26ee70d23a50"
    },
    {
      id: "57813d85-74d1-4172-9522-5483d115588d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9",
      target: "2785ff53-c134-47fa-975d-29f89716444e"
    },
    {
      id: "54faf11d-bf7a-4910-96fc-61e78042a999",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ecbbfa11-10ac-4fdc-851d-a73792f09398",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "bff62724-cd27-4ab4-b25a-92240d954c0f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ecbbfa11-10ac-4fdc-851d-a73792f09398",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "551c104a-e7d0-41d6-9321-ff8680c617e9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d981fa4d-70ed-4e80-b45c-4cecd0e62e10",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "c82ddd86-0d15-4da3-b77e-04d1ebbde5d8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d981fa4d-70ed-4e80-b45c-4cecd0e62e10",
      target: "2d845e8f-c327-45d1-8780-85f7fcc5ebe9"
    },
    {
      id: "1a43fcac-00e1-4ca6-914c-9e91a8db43fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ced8c30-c0f2-42f2-95e4-44502bd2bbbb",
      target: "ed3c6361-1794-4939-becf-26ee70d23a50"
    },
    {
      id: "4b3d4d0b-08ca-4875-922e-5f38ddde7a7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec0f34e5-946f-492c-a72e-105f868af682",
      target: "ed3c6361-1794-4939-becf-26ee70d23a50"
    },
    {
      id: "282f0b96-0a62-41fe-a761-a5cd81c00b77",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2785ff53-c134-47fa-975d-29f89716444e",
      target: "ed3c6361-1794-4939-becf-26ee70d23a50"
    },
    {
      id: "421a21ec-42cf-45aa-9285-1d87618df844",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed3c6361-1794-4939-becf-26ee70d23a50",
      target: "57a30ae1-48d2-4fa9-a0b3-45a9285d5609"
    },
    {
      id: "e94d8cb7-6c2e-4b89-907b-0b0764ed61a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57a30ae1-48d2-4fa9-a0b3-45a9285d5609",
      target: "11fdd4e2-de70-4a39-831b-622b2548281f"
    },
    {
      id: "72e5ebdc-37c6-484d-bc6a-479bf56e3a00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11fdd4e2-de70-4a39-831b-622b2548281f",
      target: "1ab67361-6d06-4b8e-b1fd-9818595a468e"
    },
    {
      id: "36f40a6c-e059-4435-b893-9bd433086036",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1ab67361-6d06-4b8e-b1fd-9818595a468e",
      target: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94"
    },
    {
      id: "92079f85-c480-4635-91a7-a34ddd024dd0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "eda016c9-3d34-48eb-8f61-afef736f7f35",
      target: "b47fe8d5-c884-488a-ac51-bae777be354d"
    },
    {
      id: "db9125e8-5389-4afa-ba92-dd951fcb86c7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94",
      target: "eda016c9-3d34-48eb-8f61-afef736f7f35"
    },
    {
      id: "f2e90f1a-0af7-4106-bd48-541985561b36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94",
      target: "6df746c4-e7a6-469c-add3-701a0e2ae3ef"
    },
    {
      id: "cb1fbb82-6db8-4b25-ac16-b4c32b09599b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94",
      target: "b47fe8d5-c884-488a-ac51-bae777be354d"
    },
    {
      id: "728454cf-9088-4f19-990a-ba1a1d68aeaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9c5b0fb-ef9a-4ba8-aaf8-1bb63f6afc94",
      target: "37304d8d-d453-4d1d-ad01-4a7fc9af3ea2"
    },
    {
      id: "412aa280-bae6-486d-919a-045553a8c4f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6df746c4-e7a6-469c-add3-701a0e2ae3ef",
      target: "b47fe8d5-c884-488a-ac51-bae777be354d"
    },
    {
      id: "2f18e9c3-75cb-40d0-9a0e-8c2598ee186a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b47fe8d5-c884-488a-ac51-bae777be354d",
      target: "b43dff38-96d8-477b-bc05-4d03eb53e781"
    },
    {
      id: "a837a8f6-2ee9-493c-a741-4a083d686463",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b43dff38-96d8-477b-bc05-4d03eb53e781",
      target: "342f8138-4dc8-4da1-9348-431caf8de132"
    },
    {
      id: "b7fdc6c7-2462-475d-8252-f8f1fa560d79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b43dff38-96d8-477b-bc05-4d03eb53e781",
      target: "d8dfd39a-369b-45cd-9ca6-3e4d96e7db83"
    },
    {
      id: "f6482de8-aed3-4e53-9ea3-78a80e39bbe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b43dff38-96d8-477b-bc05-4d03eb53e781",
      target: "99792bed-9a5d-495f-9110-16ad29e1982c"
    },
    {
      id: "8620caa3-2ae3-4ca0-af72-d42dd13820f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b43dff38-96d8-477b-bc05-4d03eb53e781",
      target: "7a1ffe3a-b0ef-4afc-abb2-f0320e1dff02"
    },
    {
      id: "7f3b6fe0-be5f-4556-9e98-005ad4b92c3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "342f8138-4dc8-4da1-9348-431caf8de132",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "6b646eb2-5310-4ccb-9074-ddb644b4a08b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "342f8138-4dc8-4da1-9348-431caf8de132",
      target: "8a07150f-e272-4881-891f-4897d14425ab"
    },
    {
      id: "eb9b002a-752f-4247-acb9-6502b6cfe12a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99792bed-9a5d-495f-9110-16ad29e1982c",
      target: "8a07150f-e272-4881-891f-4897d14425ab"
    },
    {
      id: "97385af0-7413-4c43-8d02-37fd798988f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8dfd39a-369b-45cd-9ca6-3e4d96e7db83",
      target: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c"
    },
    {
      id: "f782437b-aaa9-4d94-bdd7-8f6faf2bc9aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a07150f-e272-4881-891f-4897d14425ab",
      target: "3541fb3f-7ff2-4335-8a2d-2fb84f4471cb"
    },
    {
      id: "e43848e1-7117-4e3d-994f-483fa8aad33f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3541fb3f-7ff2-4335-8a2d-2fb84f4471cb",
      target: "cf73a802-a304-4c4f-90b5-b45e9a94b862"
    },
    {
      id: "c31fa1b2-a2a0-490a-8d4b-d28cd1850e43",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf73a802-a304-4c4f-90b5-b45e9a94b862",
      target: "2a9f9d27-83da-409a-bb57-1a2ea32ac38c"
    },
    {
      id: "3c373ddc-456d-4650-abd3-9702c3d62eb5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d44d520-a537-4ad7-8497-b8a3633f9a96",
      target: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f"
    },
    {
      id: "f1cb920f-861e-4a08-b14c-c64f93b1c469",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d44d520-a537-4ad7-8497-b8a3633f9a96",
      target: "34cc8481-431d-4c29-b3da-c2ad6501b4d6"
    },
    {
      id: "03d31a11-a82f-413b-a7e3-087edd8491f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d44d520-a537-4ad7-8497-b8a3633f9a96",
      target: "97a0cbdc-8ad9-4673-9660-96ac28a83626"
    },
    {
      id: "729a858a-06ac-46ba-9065-548ec75719f3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "34cc8481-431d-4c29-b3da-c2ad6501b4d6",
      target: "e0306b80-1005-4076-8974-2fe1bf17eebd"
    },
    {
      id: "f5a78a44-6ba4-45f6-a159-1b94ab365290",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34cc8481-431d-4c29-b3da-c2ad6501b4d6",
      target: "09b79ccd-8edf-4589-baec-fc3da020e460"
    },
    {
      id: "0776e962-9652-4167-87f5-0d38f855f448",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34cc8481-431d-4c29-b3da-c2ad6501b4d6",
      target: "da79f507-1c3f-4ca4-ac94-7c99b6ec5c5c"
    },
    {
      id: "d58b4d6d-2586-45ec-b0fc-b31d17c39922",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e0306b80-1005-4076-8974-2fe1bf17eebd",
      target: "547aff1c-6649-4ed1-8f66-c47d71d1a735"
    },
    {
      id: "a2ca3378-7195-4d97-ac79-3db11543327a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0306b80-1005-4076-8974-2fe1bf17eebd",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "1a978b26-9d4b-469e-ac37-01e66dbd6091",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0306b80-1005-4076-8974-2fe1bf17eebd",
      target: "6085fb25-50fd-4b16-bef7-eb44c01cba07"
    },
    {
      id: "fb22406a-c704-44bc-bd4b-05d5f8b1c470",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "547aff1c-6649-4ed1-8f66-c47d71d1a735",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "94e37b63-fe16-4599-b77c-ad4dd4b4e58e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "547aff1c-6649-4ed1-8f66-c47d71d1a735",
      target: "55e03959-56ce-4429-881c-823715df79c8"
    },
    {
      id: "1951fb5f-d5f6-442c-b2fc-0a42c2364e11",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "97a0cbdc-8ad9-4673-9660-96ac28a83626",
      target: "da79f507-1c3f-4ca4-ac94-7c99b6ec5c5c"
    },
    {
      id: "762f88cd-4509-4868-8940-c07fd04be668",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97a0cbdc-8ad9-4673-9660-96ac28a83626",
      target: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f"
    },
    {
      id: "4a9ef62f-5788-4dd5-baf6-4809f815d192",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "da79f507-1c3f-4ca4-ac94-7c99b6ec5c5c",
      target: "6085fb25-50fd-4b16-bef7-eb44c01cba07"
    },
    {
      id: "303a04dc-cdf7-4499-a07a-e4b5bc816e5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da79f507-1c3f-4ca4-ac94-7c99b6ec5c5c",
      target: "09b79ccd-8edf-4589-baec-fc3da020e460"
    },
    {
      id: "8da963af-7acc-42ba-8648-68ff6168da4c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6085fb25-50fd-4b16-bef7-eb44c01cba07",
      target: "55e03959-56ce-4429-881c-823715df79c8"
    },
    {
      id: "7a6f0e91-0780-463a-8230-1e241ccceaaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6085fb25-50fd-4b16-bef7-eb44c01cba07",
      target: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8"
    },
    {
      id: "2e0cf610-2589-4cdc-929c-f7d7213e815c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "55e03959-56ce-4429-881c-823715df79c8",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "c2103395-5bcb-4af4-be12-e2154738c182",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55e03959-56ce-4429-881c-823715df79c8",
      target: "44ec1edf-2c44-44a5-9a05-1c5cc6147b1f"
    },
    {
      id: "180d7246-b33a-4d21-8926-1f35280d5260",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52fe1192-f057-4287-a06e-48b6e9cf0bb4",
      target: "ae6106a3-55f9-4620-ba25-fb37b62aa6e8"
    },
    {
      id: "f34e60c9-4416-4302-b13d-b54d21374411",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "52fe1192-f057-4287-a06e-48b6e9cf0bb4",
      target: "cf54332c-9ab7-45c9-87d4-5bea320c830f"
    },
    {
      id: "144853b3-f157-465f-97b4-fb835ccfad8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "4c88b08d-2f91-40df-a03f-ebfda5ff1320"
    },
    {
      id: "c58f0bf3-5a36-44e2-b436-11e3917db348",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "eda52b05-1778-43c6-a48b-377e6928d9f4"
    },
    {
      id: "e5be260e-b34a-471a-a5ce-1831b5a66b7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "ff53d551-6056-453b-b5d4-b4bc76bfcae3"
    },
    {
      id: "a7567401-0579-4cd3-9c99-bc4e2dac60d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "83f1bd96-7269-4687-8cd4-2e2f38661a53"
    },
    {
      id: "f0139ef8-c33b-4abf-a89c-483c45d24c4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "ace0d89f-4e49-4bc6-9b86-f04eb1070053"
    },
    {
      id: "64838c93-2b4d-4ca2-98f9-f0ca2aa6fee7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22"
    },
    {
      id: "8b3e8f04-9f23-4818-ac82-92df526839ab",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cf54332c-9ab7-45c9-87d4-5bea320c830f",
      target: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22"
    },
    {
      id: "dac2a98d-9a45-47e6-b67e-726826c0ce81",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4c88b08d-2f91-40df-a03f-ebfda5ff1320",
      target: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0"
    },
    {
      id: "9fc99473-ed1c-4cf5-885f-a179aaf34e78",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eda52b05-1778-43c6-a48b-377e6928d9f4",
      target: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0"
    },
    {
      id: "30123101-d580-479c-9e92-3d6a5ef873c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ace0d89f-4e49-4bc6-9b86-f04eb1070053",
      target: "8e622819-a993-4900-a9f7-128ffbb661a4"
    },
    {
      id: "a5f08fb0-349d-41fb-b33a-d38dffce775f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83f1bd96-7269-4687-8cd4-2e2f38661a53",
      target: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0"
    },
    {
      id: "39f3d14b-6ed2-4b4a-9128-5e98be3ccda6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff53d551-6056-453b-b5d4-b4bc76bfcae3",
      target: "e291665c-b8f5-44a2-a7c6-b9f4e0458651"
    },
    {
      id: "75ea612a-27a3-46cb-9374-7dc6d12e7004",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff53d551-6056-453b-b5d4-b4bc76bfcae3",
      target: "ad9b77cc-4b44-4de1-8c07-7cbdb2a25444"
    },
    {
      id: "d5b93fd8-0054-4df7-836a-235aba974c58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0",
      target: "b221284c-7100-4bfe-8546-fe95302ef837"
    },
    {
      id: "0be680a7-b16a-4421-8f93-234a3d913943",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3e260afd-e2d8-404d-9ce2-dc9fa44343e0",
      target: "dd7f8cac-5b60-4a7f-9e8d-d68bc32d4e87"
    },
    {
      id: "8fcbd88d-4d79-4c8f-8868-9b7bd507ab54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e291665c-b8f5-44a2-a7c6-b9f4e0458651",
      target: "8e622819-a993-4900-a9f7-128ffbb661a4"
    },
    {
      id: "d73ec22e-7768-42c3-b960-2e5ab1df27aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e622819-a993-4900-a9f7-128ffbb661a4",
      target: "d88e1970-06c1-4c02-a1bf-ce7897f49de8"
    },
    {
      id: "1cc332e1-f088-4006-bd1d-747bc30ac64d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d88e1970-06c1-4c02-a1bf-ce7897f49de8",
      target: "2c8b47e3-5872-46f5-8d95-7bd87fb59a37"
    },
    {
      id: "e3c32640-e830-4d55-bf53-e90652a06dd4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c8b47e3-5872-46f5-8d95-7bd87fb59a37",
      target: "5029b4a2-cd99-4b01-a2f3-bf847879ed24"
    },
    {
      id: "7b1d32be-849e-4af8-b75b-7cd2df05df32",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c8b47e3-5872-46f5-8d95-7bd87fb59a37",
      target: "a9674e15-12bf-4446-90ed-08d24d420f70"
    },
    {
      id: "8761753e-f1b5-44eb-bc29-9c73a05ccbad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5029b4a2-cd99-4b01-a2f3-bf847879ed24",
      target: "5848f7a4-c9ff-42b8-88d5-cd6198ffb112"
    },
    {
      id: "41d23d09-d255-4f7e-a9c7-81efeae3fad8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9674e15-12bf-4446-90ed-08d24d420f70",
      target: "b221284c-7100-4bfe-8546-fe95302ef837"
    },
    {
      id: "917a83e1-fb7a-4b6d-aa6d-3433f180db73",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9674e15-12bf-4446-90ed-08d24d420f70",
      target: "dd7f8cac-5b60-4a7f-9e8d-d68bc32d4e87"
    },
    {
      id: "b2996035-6a85-405e-b815-f9af6fa61477",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9674e15-12bf-4446-90ed-08d24d420f70",
      target: "377993d1-5eed-4c64-bf35-1d51f4056477"
    },
    {
      id: "215389a9-1b0f-4006-935b-3ed06c739dfe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5848f7a4-c9ff-42b8-88d5-cd6198ffb112",
      target: "b0598ceb-6fee-4932-a96e-9a7372d12748"
    },
    {
      id: "1c868fa7-792b-4ade-b276-fc2420f92323",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5848f7a4-c9ff-42b8-88d5-cd6198ffb112",
      target: "b0598ceb-6fee-4932-a96e-9a7372d12748"
    },
    {
      id: "6016e3e8-d769-4d8c-81a0-c82fd996ead1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dd7f8cac-5b60-4a7f-9e8d-d68bc32d4e87",
      target: "f102e27f-c1e5-4620-9935-2dec61b6deb8"
    },
    {
      id: "f8665b87-076a-47b3-84c2-d5e9b1520380",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b221284c-7100-4bfe-8546-fe95302ef837",
      target: "f102e27f-c1e5-4620-9935-2dec61b6deb8"
    },
    {
      id: "a7c5876f-db0e-4ba0-815e-606f875a97b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "377993d1-5eed-4c64-bf35-1d51f4056477",
      target: "f102e27f-c1e5-4620-9935-2dec61b6deb8"
    },
    {
      id: "6c9df8eb-19db-47e6-aad4-aaea6fa00064",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "377993d1-5eed-4c64-bf35-1d51f4056477",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "39b35005-c4b7-4bba-91b2-51af53ce5e9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0598ceb-6fee-4932-a96e-9a7372d12748",
      target: "f102e27f-c1e5-4620-9935-2dec61b6deb8"
    },
    {
      id: "40e20489-1140-4cc3-8c3a-15d93a35a7af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f102e27f-c1e5-4620-9935-2dec61b6deb8",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "7db4c222-cc7e-4652-83ca-049348255b1e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f102e27f-c1e5-4620-9935-2dec61b6deb8",
      target: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce"
    },
    {
      id: "399cba7b-e7be-4482-acef-08935496ff7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f102e27f-c1e5-4620-9935-2dec61b6deb8",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "61e2955c-f23c-4e07-8e99-dc34217a3f13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      target: "ad9b77cc-4b44-4de1-8c07-7cbdb2a25444"
    },
    {
      id: "d4ddb1c9-0235-4eee-9e8b-1bdbdc60d64c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      target: "0e9931e1-320e-4766-9831-2835a4254660"
    },
    {
      id: "fcd1caae-0a3a-46df-8280-a944166c7c1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      target: "fe53f24b-505a-4847-bb04-e50fa7e3eff4"
    },
    {
      id: "7b83adfa-34da-4b44-ada1-b325decf0457",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      target: "66f89bfc-e1f3-444d-ae26-1345719d1d60"
    },
    {
      id: "747f3b0c-1c2c-4564-bc06-13352682ce95",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4de930c3-f1d1-4a3e-a4c0-59b9fe4b9e22",
      target: "fa13b8e5-c32e-4214-a2d6-d4fc53ba0540"
    },
    {
      id: "f1647c9a-34ee-43f2-a24c-988ddc7bd973",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe53f24b-505a-4847-bb04-e50fa7e3eff4",
      target: "27a53205-7fd2-4c3e-892d-b6146f651dba"
    },
    {
      id: "61e1345d-bb8f-4cbb-b43f-002231ccf29f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66f89bfc-e1f3-444d-ae26-1345719d1d60",
      target: "27a53205-7fd2-4c3e-892d-b6146f651dba"
    },
    {
      id: "3e8f7e73-7881-4c42-b96f-63e9bfdfa65c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e9931e1-320e-4766-9831-2835a4254660",
      target: "9ebe6678-c0b9-4911-b104-b5a4c6175ccd"
    },
    {
      id: "d60c4026-07dc-4a30-a169-b5c7f4f30ef2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa13b8e5-c32e-4214-a2d6-d4fc53ba0540",
      target: "27a53205-7fd2-4c3e-892d-b6146f651dba"
    },
    {
      id: "3883af5b-dd23-4850-9e51-d8b2abfafa68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad9b77cc-4b44-4de1-8c07-7cbdb2a25444",
      target: "61b5b01b-b4e7-4f95-a490-b8a04ae023cd"
    },
    {
      id: "633da4c6-170c-4437-9e49-3581df8969f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61b5b01b-b4e7-4f95-a490-b8a04ae023cd",
      target: "9ebe6678-c0b9-4911-b104-b5a4c6175ccd"
    },
    {
      id: "05631e34-c845-40d2-be44-b2457bdacf59",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "27a53205-7fd2-4c3e-892d-b6146f651dba",
      target: "e1e3094f-a301-4f4f-a2c2-92a85aabecee"
    },
    {
      id: "bc32dc69-6d6c-469b-a21c-403f35ee41a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27a53205-7fd2-4c3e-892d-b6146f651dba",
      target: "0235af60-0458-4363-b792-77a2466a45a7"
    },
    {
      id: "de0c22b8-55eb-45ad-9740-8717deb967b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ebe6678-c0b9-4911-b104-b5a4c6175ccd",
      target: "189ccc66-a3ae-42bc-888b-b1b808f4bca6"
    },
    {
      id: "1891fd5c-92bb-44df-8ee0-36d1b61499c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "189ccc66-a3ae-42bc-888b-b1b808f4bca6",
      target: "838f5bd8-994a-4a5d-bae5-0954ba298079"
    },
    {
      id: "8ace9a31-57b8-4c88-9f01-93cfc3151141",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "838f5bd8-994a-4a5d-bae5-0954ba298079",
      target: "5dea1993-57a9-444f-8a18-074e225e4f66"
    },
    {
      id: "c86f4960-e921-4860-80f3-56a88f83cc9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5dea1993-57a9-444f-8a18-074e225e4f66",
      target: "51fffb00-b3c5-4525-884a-61373d22b1fe"
    },
    {
      id: "6f5e0a3b-d2f9-4831-a34a-06da35bd7050",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5dea1993-57a9-444f-8a18-074e225e4f66",
      target: "e1e3094f-a301-4f4f-a2c2-92a85aabecee"
    },
    {
      id: "877ac51f-a5a9-414a-936c-df05c9d6bca4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5dea1993-57a9-444f-8a18-074e225e4f66",
      target: "19026280-2181-479c-b868-57dd673909a0"
    },
    {
      id: "2d52a4ae-534d-445b-9c7b-582f79eb1e4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5dea1993-57a9-444f-8a18-074e225e4f66",
      target: "0235af60-0458-4363-b792-77a2466a45a7"
    },
    {
      id: "0f9d5f36-c95f-49fa-beaf-14403d852335",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5dea1993-57a9-444f-8a18-074e225e4f66",
      target: "953a1605-7beb-4246-9d00-29478bb5313c"
    },
    {
      id: "9415a34c-23e7-4ed0-a0c7-2116460fa776",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1e3094f-a301-4f4f-a2c2-92a85aabecee",
      target: "123bf9e4-d984-4550-8552-c982b6d44c73"
    },
    {
      id: "36c7c218-1a51-465e-957a-f144602f7ff3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0235af60-0458-4363-b792-77a2466a45a7",
      target: "123bf9e4-d984-4550-8552-c982b6d44c73"
    },
    {
      id: "99589abb-9c5e-4462-85b7-c0a4de366059",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19026280-2181-479c-b868-57dd673909a0",
      target: "7ba011a2-9dca-4252-ae6f-67961d89d001"
    },
    {
      id: "ae1d287a-b414-4788-93a9-7753c6a7bac2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "953a1605-7beb-4246-9d00-29478bb5313c",
      target: "19026280-2181-479c-b868-57dd673909a0"
    },
    {
      id: "864790a9-1829-417c-8625-6f03aea31046",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "953a1605-7beb-4246-9d00-29478bb5313c",
      target: "a7ca121a-2dd4-48fe-9417-0dc11fe4b967"
    },
    {
      id: "a9d6be3a-59d7-40f2-bb56-43ef2f8e5d65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51fffb00-b3c5-4525-884a-61373d22b1fe",
      target: "123bf9e4-d984-4550-8552-c982b6d44c73"
    },
    {
      id: "6c2f5b86-c177-4e30-8a2b-2a71b9466f86",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51fffb00-b3c5-4525-884a-61373d22b1fe",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "6b76cfd6-7eae-4473-9ed5-89e51b487075",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ba011a2-9dca-4252-ae6f-67961d89d001",
      target: "68c843ba-c453-447e-b630-0d80c7f9344a"
    },
    {
      id: "394b3daf-35cb-4b2b-8f65-f8454eb0755c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7ca121a-2dd4-48fe-9417-0dc11fe4b967",
      target: "123bf9e4-d984-4550-8552-c982b6d44c73"
    },
    {
      id: "a65bb4a1-1216-4c30-8d48-82c8c4bca8b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68c843ba-c453-447e-b630-0d80c7f9344a",
      target: "123bf9e4-d984-4550-8552-c982b6d44c73"
    },
    {
      id: "882ee626-849e-4c9a-a1a7-ceb726559c61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "123bf9e4-d984-4550-8552-c982b6d44c73",
      target: "0a44da7c-f803-4818-bd5b-8e8169df7615"
    },
    {
      id: "e8ed4af9-5ba6-41df-854c-8e1e0ae2b146",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "123bf9e4-d984-4550-8552-c982b6d44c73",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "12622d91-21d1-4411-ab32-e8ffe5a6c347",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "123bf9e4-d984-4550-8552-c982b6d44c73",
      target: "f102e27f-c1e5-4620-9935-2dec61b6deb8"
    },
    {
      id: "7c3cb7e5-b7b7-40e5-b6de-358fa25c7d7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae6106a3-55f9-4620-ba25-fb37b62aa6e8",
      target: "7ddc007c-99de-40b8-9d93-70a323f96302"
    },
    {
      id: "f165c1a7-65c9-4d03-8675-1a57548c58f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae6106a3-55f9-4620-ba25-fb37b62aa6e8",
      target: "c5c2dcf7-42d9-45f7-9013-5a101d5931c8"
    },
    {
      id: "1a9bd8ad-ef19-447b-929c-c7a701195797",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "bb9ae4cf-13f0-487d-b3fa-850677bf2e90"
    },
    {
      id: "3567769d-e02d-4dab-94f9-778e66157921",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "3d7b1217-fbe3-4f4e-bcb4-2c5dfa1b29ec"
    },
    {
      id: "bd9c6296-0b7e-4566-870f-8816750ba63d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d"
    },
    {
      id: "8d15261a-71e3-4424-b74c-e1e10485a5cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "fbd37e7f-c1c0-43f1-b4cd-6bf1e400a5e6"
    },
    {
      id: "79ec1560-8755-40f1-ab26-36030641b1e2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "f7078284-8d99-4766-9bdd-7543f2e26ef7"
    },
    {
      id: "b5fe2c52-0d2f-463b-8b75-b2e4988b9fcc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "f7078284-8d99-4766-9bdd-7543f2e26ef7"
    },
    {
      id: "02c65619-e80a-4be4-a737-3604cc683678",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d"
    },
    {
      id: "b0e2ae86-3703-48d0-a55d-0c35d165c302",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "3bccf6e3-3d99-4aae-8cf2-3bfb15ee06ef"
    },
    {
      id: "495a053a-bbc0-405d-869b-58ec4c3b5528",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ddc007c-99de-40b8-9d93-70a323f96302",
      target: "da1fe208-5966-4a45-aae4-20418703f1a5"
    },
    {
      id: "8b9e3f81-b6c9-403a-96ff-a9a5f1ddcc8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bccf6e3-3d99-4aae-8cf2-3bfb15ee06ef",
      target: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03"
    },
    {
      id: "bcd8c67c-7981-4e88-89da-e7f1b03b16c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d7b1217-fbe3-4f4e-bcb4-2c5dfa1b29ec",
      target: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03"
    },
    {
      id: "ba1463aa-67ed-441b-b5e2-18f9a995392f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da1fe208-5966-4a45-aae4-20418703f1a5",
      target: "b6cf968e-4332-4bdb-b154-82c4d2b1f9b9"
    },
    {
      id: "b925e30c-df97-4269-95e5-15f1e9d0960e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbd37e7f-c1c0-43f1-b4cd-6bf1e400a5e6",
      target: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03"
    },
    {
      id: "de3eed76-d7f1-42f7-a02c-85225012d209",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb9ae4cf-13f0-487d-b3fa-850677bf2e90",
      target: "1524a761-f8a6-4d36-80db-aea7d3a6b097"
    },
    {
      id: "d16f1731-4075-441d-a877-6ff42543b106",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb9ae4cf-13f0-487d-b3fa-850677bf2e90",
      target: "41901dd2-45be-40e3-a80a-95922259ddad"
    },
    {
      id: "674dd156-b84f-467d-9bac-83a1fb4d1c35",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03",
      target: "722fbeb9-fe8f-4e06-8333-c6655669e837"
    },
    {
      id: "ed116d3b-07eb-4fb3-beff-8c030f462b0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36a4acaf-a2f8-4fd3-b00d-b73f1e78fa03",
      target: "357928b4-594c-4b0e-a88b-371966429ca8"
    },
    {
      id: "9925538d-5240-47d9-afe6-4f1019f7a7d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1524a761-f8a6-4d36-80db-aea7d3a6b097",
      target: "b6cf968e-4332-4bdb-b154-82c4d2b1f9b9"
    },
    {
      id: "7a2198da-5772-4c87-a02e-fd0d73d31909",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6cf968e-4332-4bdb-b154-82c4d2b1f9b9",
      target: "8a748b1a-7e54-44d8-8a49-52cc3b117656"
    },
    {
      id: "c8b04133-1c34-45a3-899c-02156b452efb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8a748b1a-7e54-44d8-8a49-52cc3b117656",
      target: "c222a7f2-1ef1-464a-9101-8a6b6dee3cea"
    },
    {
      id: "e2f794d4-d0a1-4960-9f4d-a3830ed4b586",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c222a7f2-1ef1-464a-9101-8a6b6dee3cea",
      target: "8edcc91f-b98f-458e-ae88-c7697c251245"
    },
    {
      id: "90e9b323-5b7c-4bed-825a-7afa6c2537e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c222a7f2-1ef1-464a-9101-8a6b6dee3cea",
      target: "7cbd4707-b5c4-49a0-824e-49ceb17978ef"
    },
    {
      id: "c7bb9d0c-aa36-4b22-bf6c-66e67deb20f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8edcc91f-b98f-458e-ae88-c7697c251245",
      target: "0d76a41d-c2c5-49e2-abb5-619ead8f0c7c"
    },
    {
      id: "c729e97d-28d4-449c-b19f-dd04618dae8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cbd4707-b5c4-49a0-824e-49ceb17978ef",
      target: "1546480d-27e7-4770-b1a8-3f314926d94e"
    },
    {
      id: "410a36f1-c819-4a38-8178-3ba80a178fc6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cbd4707-b5c4-49a0-824e-49ceb17978ef",
      target: "357928b4-594c-4b0e-a88b-371966429ca8"
    },
    {
      id: "d9ae623f-01d0-4ed5-b7f6-7f5c4b9f29cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cbd4707-b5c4-49a0-824e-49ceb17978ef",
      target: "722fbeb9-fe8f-4e06-8333-c6655669e837"
    },
    {
      id: "7a48fc83-e855-4870-aaaf-3aa7ce7d2954",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d76a41d-c2c5-49e2-abb5-619ead8f0c7c",
      target: "c479cdbf-674e-411b-bee8-0067bd583957"
    },
    {
      id: "655c1add-41b4-44f5-857b-2a4cc7ded289",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "722fbeb9-fe8f-4e06-8333-c6655669e837",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "842ad809-6567-436c-8c3b-b44d78a47522",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "357928b4-594c-4b0e-a88b-371966429ca8",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "77fec614-9906-48c0-8ed4-feddb0b5f281",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1546480d-27e7-4770-b1a8-3f314926d94e",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "ba3f6535-c395-49e5-8d82-573c570be854",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1546480d-27e7-4770-b1a8-3f314926d94e",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "b6ee1f47-d2eb-4a59-b711-963353b7045c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c479cdbf-674e-411b-bee8-0067bd583957",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "a9dfc122-8fc8-44b0-a4c9-3def65df182a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57af004f-91ff-4c96-86c9-3aa68e1db3c0",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "d335a316-65fc-4633-b1c2-7305a6226054",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57af004f-91ff-4c96-86c9-3aa68e1db3c0",
      target: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce"
    },
    {
      id: "b54506f9-ccc5-4422-8914-99d345d19ac2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "57af004f-91ff-4c96-86c9-3aa68e1db3c0",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "0aa0391a-6aed-4828-a847-55059d082282",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57af004f-91ff-4c96-86c9-3aa68e1db3c0",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "3d701cfc-2d83-42ba-90a6-6744da239e84",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      target: "ff7aa94c-a80a-43c5-b0e6-39eaed32358e"
    },
    {
      id: "0a962d99-50ba-403b-8c32-775181d331db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      target: "a18c735e-d5fc-4285-b70f-9bbd9fb3fe96"
    },
    {
      id: "abc18771-9058-47b4-881b-1b4e2541fe79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      target: "8bc1b444-1525-40b1-aae2-5a44fd44a41e"
    },
    {
      id: "4fd8f994-ab5b-41f0-a9f2-298007365d29",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      target: "45ec47db-5bae-4d80-a97e-2cafa2ffbd32"
    },
    {
      id: "ef9c0e46-b1ab-42e1-87d7-bdd4af4c94d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f7078284-8d99-4766-9bdd-7543f2e26ef7",
      target: "41901dd2-45be-40e3-a80a-95922259ddad"
    },
    {
      id: "332b63da-cace-4399-a74c-68e1ddb07a8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a18c735e-d5fc-4285-b70f-9bbd9fb3fe96",
      target: "f6f51ffe-cd8a-44f6-8bf4-1bd591fc0413"
    },
    {
      id: "8c29350d-4cdc-4ee6-b7f9-4d50967c8147",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bc1b444-1525-40b1-aae2-5a44fd44a41e",
      target: "d8358450-9d1c-4ceb-9c90-8d882c4480f7"
    },
    {
      id: "b3784bc4-55c7-4c95-bcc5-718211c3a693",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41901dd2-45be-40e3-a80a-95922259ddad",
      target: "5527aa8e-25d2-4a3e-989e-6421a5276a08"
    },
    {
      id: "6065aa6f-c8b7-4075-85d5-115801b94f94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "41901dd2-45be-40e3-a80a-95922259ddad",
      target: "ca0407a9-b7c9-4931-886c-eddc4a9c1390"
    },
    {
      id: "4dfb98e7-a45b-42ba-ae3b-b116ba0a0451",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff7aa94c-a80a-43c5-b0e6-39eaed32358e",
      target: "d8358450-9d1c-4ceb-9c90-8d882c4480f7"
    },
    {
      id: "c6770d9e-7714-4a8a-8a75-26d96def9ea2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45ec47db-5bae-4d80-a97e-2cafa2ffbd32",
      target: "d8358450-9d1c-4ceb-9c90-8d882c4480f7"
    },
    {
      id: "d9fc82eb-cfc8-491a-b13b-8d51f7917678",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5527aa8e-25d2-4a3e-989e-6421a5276a08",
      target: "f6f51ffe-cd8a-44f6-8bf4-1bd591fc0413"
    },
    {
      id: "cb8cf7ad-6ec4-40ca-8a8c-e640d5e8d127",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8358450-9d1c-4ceb-9c90-8d882c4480f7",
      target: "4904011b-ade9-4838-bed6-0bd5330c5989"
    },
    {
      id: "1da26391-0c76-4d57-95f4-3417643ec5ff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d8358450-9d1c-4ceb-9c90-8d882c4480f7",
      target: "3bb3643f-d947-49ba-83ab-b27416edc884"
    },
    {
      id: "033c7506-6121-4130-ad65-22391e42dcf8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f6f51ffe-cd8a-44f6-8bf4-1bd591fc0413",
      target: "9dd3115b-6f94-4c45-808f-22130b072a70"
    },
    {
      id: "40908b8c-046d-4ac6-8359-d3407eed0c89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9dd3115b-6f94-4c45-808f-22130b072a70",
      target: "71e2ed77-fe57-458d-aadc-3eeb5cab854b"
    },
    {
      id: "6e775a95-c5e7-4ac7-8c0e-b4a2f7913d8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71e2ed77-fe57-458d-aadc-3eeb5cab854b",
      target: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2"
    },
    {
      id: "486a2f98-a44d-4a79-b77e-3b5826d7f9c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      target: "e610cbe7-010f-49d6-bfeb-8278bcfe59b0"
    },
    {
      id: "034bfdb1-7e84-4216-b8ba-678d7b791cd7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      target: "4904011b-ade9-4838-bed6-0bd5330c5989"
    },
    {
      id: "25f21f30-df3b-4067-9bc8-119cfad9b51a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      target: "c4685307-7acd-4cc8-b09b-8ec3e8040c0b"
    },
    {
      id: "e7f174d6-ad97-420d-a967-8dd64cbdd9a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      target: "23e66f15-d8a9-44eb-8047-0a79afa820e0"
    },
    {
      id: "108a88b7-63ba-4807-bba6-5594ffe64059",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b511f52-f0c9-4f4d-a29b-019cf34e57b2",
      target: "3bb3643f-d947-49ba-83ab-b27416edc884"
    },
    {
      id: "df1c492d-2ae9-4323-a1d5-94190c08508a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e610cbe7-010f-49d6-bfeb-8278bcfe59b0",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "191616c8-b054-4ea2-a7cb-b9f31f69e097",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e610cbe7-010f-49d6-bfeb-8278bcfe59b0",
      target: "bfdeab33-e791-4d9d-82c5-afe1292f3f19"
    },
    {
      id: "3a99c831-2fc0-47c8-9c2a-9d200bb21bc6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3bb3643f-d947-49ba-83ab-b27416edc884",
      target: "bfdeab33-e791-4d9d-82c5-afe1292f3f19"
    },
    {
      id: "512f192c-922a-4d00-b6cb-ddff5f837bd1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4904011b-ade9-4838-bed6-0bd5330c5989",
      target: "bfdeab33-e791-4d9d-82c5-afe1292f3f19"
    },
    {
      id: "f1811afe-07fa-4a34-affc-e7b43fc7f44c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c4685307-7acd-4cc8-b09b-8ec3e8040c0b",
      target: "0afc9f69-eb7d-49f3-b5bd-cab03497529a"
    },
    {
      id: "4bcbdf47-7e74-4ee7-bc6d-6364e4d175be",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "23e66f15-d8a9-44eb-8047-0a79afa820e0",
      target: "c4685307-7acd-4cc8-b09b-8ec3e8040c0b"
    },
    {
      id: "a67c13fe-44d1-48b1-a137-161cb5eae83c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23e66f15-d8a9-44eb-8047-0a79afa820e0",
      target: "a6159eb0-62ed-4251-853c-a798dec3d0a8"
    },
    {
      id: "3f4acf85-8219-4b77-a25b-a84ea64063d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0afc9f69-eb7d-49f3-b5bd-cab03497529a",
      target: "d1fcfedd-54b1-435f-a501-f62f385650b5"
    },
    {
      id: "87bbd35d-a9c9-4aa6-9bf0-c20c5dcffe21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6159eb0-62ed-4251-853c-a798dec3d0a8",
      target: "bfdeab33-e791-4d9d-82c5-afe1292f3f19"
    },
    {
      id: "f2aba749-8a17-426b-a4fa-51a9a446ed7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1fcfedd-54b1-435f-a501-f62f385650b5",
      target: "bfdeab33-e791-4d9d-82c5-afe1292f3f19"
    },
    {
      id: "c69cccbc-33ff-4294-ab25-5ae9db42608a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfdeab33-e791-4d9d-82c5-afe1292f3f19",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "8d226645-23d7-47aa-8a57-e4896aec1bf5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfdeab33-e791-4d9d-82c5-afe1292f3f19",
      target: "0a44da7c-f803-4818-bd5b-8e8169df7615"
    },
    {
      id: "9d6727a2-96e3-468f-b178-db4e3e520a8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bfdeab33-e791-4d9d-82c5-afe1292f3f19",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "2347e630-f6b8-42aa-83af-8735983e74e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      target: "ca0407a9-b7c9-4931-886c-eddc4a9c1390"
    },
    {
      id: "cf24d6e1-a7ae-4771-97bb-90b8e3f31d0c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      target: "f2f64e05-c4f1-4e4f-ab46-24e24c2b3db6"
    },
    {
      id: "fd63b2de-1e6e-4384-b8b1-31eed52ed55a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      target: "5536764d-f897-48b7-97b3-1f2180c5753c"
    },
    {
      id: "0fcca227-d0cb-42ad-9782-2baa9a101be2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      target: "f1c8b869-f598-4fab-bec9-738168c61de7"
    },
    {
      id: "5480c117-bf1d-46b3-b2ad-d4d08fcaa39b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea37f3f9-4e5c-4f6a-8cd2-03eb3a891b3d",
      target: "780d972c-dc9b-4abb-a824-322441c2e5ca"
    },
    {
      id: "512f1c5d-dbe0-4388-acc6-920bd67d4c28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1c8b869-f598-4fab-bec9-738168c61de7",
      target: "947205c5-5a11-4986-983a-ac9b8fd49e14"
    },
    {
      id: "ea3764ad-5228-451a-a3ae-61d792b8aebc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f2f64e05-c4f1-4e4f-ab46-24e24c2b3db6",
      target: "f148cead-a147-46c3-8132-31fe9374d8e3"
    },
    {
      id: "602fef39-aef3-4caf-ab1e-ed6e7ee0b48c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca0407a9-b7c9-4931-886c-eddc4a9c1390",
      target: "c8daf8ce-fd62-4394-b49d-f6aa118c90fc"
    },
    {
      id: "32085ae4-22db-455f-8f3e-bbb321e2a644",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "780d972c-dc9b-4abb-a824-322441c2e5ca",
      target: "f148cead-a147-46c3-8132-31fe9374d8e3"
    },
    {
      id: "052cb7cc-b018-488e-8b19-b14e99f409b8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5536764d-f897-48b7-97b3-1f2180c5753c",
      target: "f148cead-a147-46c3-8132-31fe9374d8e3"
    },
    {
      id: "e458f7c6-a2f6-45df-81f8-542d069d12ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c8daf8ce-fd62-4394-b49d-f6aa118c90fc",
      target: "947205c5-5a11-4986-983a-ac9b8fd49e14"
    },
    {
      id: "496a992b-3343-4480-ae55-b382f20b9a3c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f148cead-a147-46c3-8132-31fe9374d8e3",
      target: "0b85ca12-43d2-4c17-acd4-269a6497f9d6"
    },
    {
      id: "c2cf0364-d91f-417d-844f-985e45fd729f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f148cead-a147-46c3-8132-31fe9374d8e3",
      target: "5f50c853-b639-4545-8a89-996935d18d66"
    },
    {
      id: "6fc6e364-a962-4f67-af3a-f5e716ff7416",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "947205c5-5a11-4986-983a-ac9b8fd49e14",
      target: "2a418e1c-a9bc-4def-82e4-af3354c9c999"
    },
    {
      id: "8580c7bc-fb06-4e94-bc2f-d61eabbf47a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2a418e1c-a9bc-4def-82e4-af3354c9c999",
      target: "748c5257-670d-4aaf-b781-e49f2afda907"
    },
    {
      id: "9f5e0c96-0fe9-41d9-9791-03134c950e08",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "748c5257-670d-4aaf-b781-e49f2afda907",
      target: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9"
    },
    {
      id: "fc166e7a-c287-4946-b2b9-2d9812c13d34",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      target: "0b85ca12-43d2-4c17-acd4-269a6497f9d6"
    },
    {
      id: "dbcae024-bb15-4fc8-80c7-794b283acad6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      target: "e03ba4ef-728a-4129-a456-a8df9cd4d597"
    },
    {
      id: "2502c0a2-4f86-4d87-b0f6-a588550648fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      target: "c14b6681-79e2-4d8f-8396-984000dfb685"
    },
    {
      id: "cfd72daf-21d8-4c5f-b61e-9db2af258ace",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      target: "9b3c6789-4852-4295-9750-2142140748b3"
    },
    {
      id: "2a875f36-4656-4ea6-8c8d-73597b11c897",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f49568b7-cf46-46a3-b29f-7ddb7b2dcab9",
      target: "5f50c853-b639-4545-8a89-996935d18d66"
    },
    {
      id: "a99601c9-1b9a-4f27-8173-b238e5e3f0ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c14b6681-79e2-4d8f-8396-984000dfb685",
      target: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1"
    },
    {
      id: "5d3ca9ad-f4d9-47bf-ba9e-e3a27a2ec0b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c14b6681-79e2-4d8f-8396-984000dfb685",
      target: "538fc6c9-bb4f-4f2c-bd27-f7c727136670"
    },
    {
      id: "9dfac277-d9c6-4b58-ac00-169a152e67d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b85ca12-43d2-4c17-acd4-269a6497f9d6",
      target: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1"
    },
    {
      id: "411517bb-a13f-4ab8-a45c-59d9949f7ff4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5f50c853-b639-4545-8a89-996935d18d66",
      target: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1"
    },
    {
      id: "8682bed9-139c-4344-ad66-2c405cbe4b50",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b3c6789-4852-4295-9750-2142140748b3",
      target: "d6f813d9-79d2-44a8-9724-f3cc328d9b81"
    },
    {
      id: "7f046977-3c50-4da1-89b6-e8a4c9f03791",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e03ba4ef-728a-4129-a456-a8df9cd4d597",
      target: "86d4db97-d3fe-481d-a291-1c0ed012a4e1"
    },
    {
      id: "7adb8593-da0f-4fac-ad47-6e88a97b6e86",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e03ba4ef-728a-4129-a456-a8df9cd4d597",
      target: "9b3c6789-4852-4295-9750-2142140748b3"
    },
    {
      id: "70ca4de4-745c-41b4-913e-5d4b44d3ac6b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6f813d9-79d2-44a8-9724-f3cc328d9b81",
      target: "20251cd5-70d1-4539-8e49-10e0938be5e9"
    },
    {
      id: "eac66698-2c31-4b41-9614-4e633412cf72",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86d4db97-d3fe-481d-a291-1c0ed012a4e1",
      target: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1"
    },
    {
      id: "8538d331-efbe-44fc-ae9b-0ae145a7d907",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20251cd5-70d1-4539-8e49-10e0938be5e9",
      target: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1"
    },
    {
      id: "56a67f4b-c59c-4d29-9802-16feb6850da8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1",
      target: "0a44da7c-f803-4818-bd5b-8e8169df7615"
    },
    {
      id: "815cd59b-2be2-4572-b2b4-f1769df9521c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1",
      target: "f6f996da-39a7-46ab-af62-c26c74ce326e"
    },
    {
      id: "0593e42d-a12b-4f22-9273-a712c85b65dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eab01d2b-3bc4-4f9c-9c29-4288ec7e77b1",
      target: "57af004f-91ff-4c96-86c9-3aa68e1db3c0"
    },
    {
      id: "ee2dd3b7-8133-4829-9040-3e1d34341839",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b73b7110-66c4-4442-8045-dba93d833e09",
      target: "c5614c28-3f86-4810-9254-86e0fa00afde"
    },
    {
      id: "72fc2e90-0d6c-4687-933a-f3d431845609",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "9b9ce206-7e4e-47b0-9890-33f680ff09ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "e19f29f6-4f45-404e-b334-cd4a91f27b60"
    },
    {
      id: "f5f9ad11-6d47-44a3-9ca8-b08bafc4f265",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "b73b7110-66c4-4442-8045-dba93d833e09"
    },
    {
      id: "eddd6da5-27ed-4c1b-bac1-17576d2d7a9d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "67f67df1-5b8f-468d-bd41-e9987e90a528"
    },
    {
      id: "8bc98312-d6f7-4390-8cb2-f5d188eb7b5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "c6fe840f-be52-4ca8-9561-7bcdf0c15e44"
    },
    {
      id: "5f51fae6-4788-4a62-919f-9277a338271a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "8fcbeb5f-6592-40f9-af4c-e632e01c1b54"
    },
    {
      id: "5374bc7d-c5ed-4b16-b7bd-05dc83070d0b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "8fcbeb5f-6592-40f9-af4c-e632e01c1b54"
    },
    {
      id: "06c1adde-3140-4b67-8e2e-2ba5ffdb9be3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bc6b0566-84da-4421-adbb-c29bb4256d70",
      target: "e3e9c433-eaaa-471e-9b81-7792f0228545"
    },
    {
      id: "35c2fcd5-3bab-4fae-a7fd-2de16da71390",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fcbeb5f-6592-40f9-af4c-e632e01c1b54",
      target: "141eb1c4-05d8-40d1-8f58-00736f1e4575"
    },
    {
      id: "2e5b673e-cc35-4254-8717-70c2b7ec3b4f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8fcbeb5f-6592-40f9-af4c-e632e01c1b54",
      target: "59510490-4817-4444-81b7-b5a0365cbed2"
    },
    {
      id: "9a35f81e-722c-4ee3-b742-a6bccbca2a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6fe840f-be52-4ca8-9561-7bcdf0c15e44",
      target: "59510490-4817-4444-81b7-b5a0365cbed2"
    },
    {
      id: "6d071df7-7771-45d3-ab1a-4405de838517",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "141eb1c4-05d8-40d1-8f58-00736f1e4575",
      target: "c5614c28-3f86-4810-9254-86e0fa00afde"
    },
    {
      id: "ac999bb7-30b0-4680-86ac-1b2e6b8b7183",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "141eb1c4-05d8-40d1-8f58-00736f1e4575",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "149bd183-4315-4d8c-b5d4-ee5e675985e4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59510490-4817-4444-81b7-b5a0365cbed2",
      target: "f86301b1-0c36-4abf-9ded-349e58977e73"
    },
    {
      id: "b512fe8d-f385-48f3-be80-bcf3795eeac2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59510490-4817-4444-81b7-b5a0365cbed2",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "e673bdc0-42b8-428a-a185-d96efa4ad908",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f86301b1-0c36-4abf-9ded-349e58977e73",
      target: "119cc502-8ae5-49f3-a97c-5258d4f4a413"
    },
    {
      id: "986fb6ee-9796-4b69-8050-400aaf58f880",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f86301b1-0c36-4abf-9ded-349e58977e73",
      target: "c5614c28-3f86-4810-9254-86e0fa00afde"
    },
    {
      id: "87b1bec5-ee86-406f-9a57-64c872546bef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5614c28-3f86-4810-9254-86e0fa00afde",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "18ec1a4f-6135-43e2-b5bd-d441374541c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5614c28-3f86-4810-9254-86e0fa00afde",
      target: "68a8d25d-3804-4628-8a6c-2155632ed6e1"
    },
    {
      id: "f9fc2153-5dc8-440d-a3de-e057f1336f5d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c5614c28-3f86-4810-9254-86e0fa00afde",
      target: "0ab0a760-a3f9-4f53-952d-979f81188747"
    },
    {
      id: "42abfb65-c567-45ef-8d2a-7099692c687c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68a8d25d-3804-4628-8a6c-2155632ed6e1",
      target: "13ea5675-19f8-49a3-9fb7-17b110890694"
    },
    {
      id: "13597959-9237-4635-bbc0-284c3cb48284",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "68a8d25d-3804-4628-8a6c-2155632ed6e1",
      target: "119cc502-8ae5-49f3-a97c-5258d4f4a413"
    },
    {
      id: "45aed3ef-0a9a-4023-a26e-6a3867a7dbcf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "68a8d25d-3804-4628-8a6c-2155632ed6e1",
      target: "e5763380-a411-4792-baed-3b3531818bac"
    },
    {
      id: "edf999b3-a997-4481-8524-28a460e03c36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "119cc502-8ae5-49f3-a97c-5258d4f4a413",
      target: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f"
    },
    {
      id: "b23f519e-7086-46d5-80c4-f62498f5a574",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "119cc502-8ae5-49f3-a97c-5258d4f4a413",
      target: "0b1b586a-c09b-4b81-96f1-3bbd4df80534"
    },
    {
      id: "606afe6d-61b9-4f5a-adb0-758dc2ed9c84",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0b1b586a-c09b-4b81-96f1-3bbd4df80534",
      target: "b63c12e5-6455-40a0-bbbe-d4fa8ed7f996"
    },
    {
      id: "e0d7c3bf-4d3b-4646-a8f2-f468a9aeadf5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b63c12e5-6455-40a0-bbbe-d4fa8ed7f996",
      target: "39e5fca2-53a7-4367-866e-de694f3a679b"
    },
    {
      id: "9432ea9d-35ee-417c-b64c-26ece08e769b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "39e5fca2-53a7-4367-866e-de694f3a679b",
      target: "e8abec90-5214-48f2-a94f-7e2c3e0b5c78"
    },
    {
      id: "f9839bf2-fb5f-4244-82a9-f978b4b55fc4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "39e5fca2-53a7-4367-866e-de694f3a679b",
      target: "a627fdb8-2e87-4669-bfc1-1db6d55acded"
    },
    {
      id: "22192748-f88c-402f-976f-400e47b43944",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5763380-a411-4792-baed-3b3531818bac",
      target: "3d2430cc-754c-4f4f-bddb-86c58f6b5409"
    },
    {
      id: "3e2eb400-78a3-4778-9f3f-5115c2f1de52",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a627fdb8-2e87-4669-bfc1-1db6d55acded",
      target: "3666d7c1-202c-4c17-81ce-cea597a7a6a1"
    },
    {
      id: "fd69e4c1-0f29-4ea7-add4-c35dc06ba734",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3666d7c1-202c-4c17-81ce-cea597a7a6a1",
      target: "4f6ae5c3-f5da-4c81-9266-2a6c3771c00e"
    },
    {
      id: "82f28fdc-1d49-4eb6-a60f-40d173d4e5b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f6ae5c3-f5da-4c81-9266-2a6c3771c00e",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "81562f51-d52c-48ea-9552-f94030a0c72c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4f6ae5c3-f5da-4c81-9266-2a6c3771c00e",
      target: "3d2430cc-754c-4f4f-bddb-86c58f6b5409"
    },
    {
      id: "d569b8b6-2004-4271-af91-b4e2f264f586",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3d2430cc-754c-4f4f-bddb-86c58f6b5409",
      target: "b79ea657-bc0e-4b1e-840b-32639bcd2c81"
    },
    {
      id: "44c1e675-22fb-4651-a4fe-70f32f81f353",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8abec90-5214-48f2-a94f-7e2c3e0b5c78",
      target: "0b0a8df9-746a-4831-914b-36c5e976f13c"
    },
    {
      id: "b35ee66c-97cf-4391-9bb4-1e8d23c5d39a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b79ea657-bc0e-4b1e-840b-32639bcd2c81",
      target: "3df91b93-dd42-43d9-a2b9-b556dfa5969a"
    },
    {
      id: "6430a452-10e2-4032-8990-14aae34ae171",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3df91b93-dd42-43d9-a2b9-b556dfa5969a",
      target: "3031ed11-c18a-4953-8b25-94f6d881c2c9"
    },
    {
      id: "46000d2f-03a0-4557-85c3-e975b1b85e8b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3031ed11-c18a-4953-8b25-94f6d881c2c9",
      target: "00cf1250-f7aa-4db9-b212-6d61f70ddcec"
    },
    {
      id: "bb67da13-f55b-4142-84d6-34ff4a12c774",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3031ed11-c18a-4953-8b25-94f6d881c2c9",
      target: "f2690989-2ad5-4c11-9291-a12049f93277"
    },
    {
      id: "d2931f2b-3235-4ef1-90a0-4bae3b11b7c4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3031ed11-c18a-4953-8b25-94f6d881c2c9",
      target: "e8f16f4e-82dd-4998-918c-85a10065862f"
    },
    {
      id: "37d17760-dc50-44a6-9ee1-10517041424e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00cf1250-f7aa-4db9-b212-6d61f70ddcec",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "ad00c174-e2db-4ab9-8fcc-93038acf2e45",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "00cf1250-f7aa-4db9-b212-6d61f70ddcec",
      target: "a0ba5485-7b0b-42c9-925f-08fcc76612a7"
    },
    {
      id: "da4e1f52-8117-41d6-9df3-1862f88babd7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "00cf1250-f7aa-4db9-b212-6d61f70ddcec",
      target: "4452f354-5177-4ee2-aa07-72081789d9e9"
    },
    {
      id: "37c643fe-4a1a-41c9-96cf-68a2763063cb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e8f16f4e-82dd-4998-918c-85a10065862f",
      target: "63793101-e14b-4321-a459-422912adc441"
    },
    {
      id: "05d60617-8645-4b65-b4fc-8d13a01d3afe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e8f16f4e-82dd-4998-918c-85a10065862f",
      target: "3a531dc2-39de-4500-b3cb-b9c0d4a4197b"
    },
    {
      id: "60b6ef7c-b463-4efc-bf18-09b50424017a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f2690989-2ad5-4c11-9291-a12049f93277",
      target: "4c2d79a0-af18-4343-9bc6-6ca945d19d60"
    },
    {
      id: "45dadcd4-6e2d-429e-ae36-16beaa1cfb3b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f2690989-2ad5-4c11-9291-a12049f93277",
      target: "a0ba5485-7b0b-42c9-925f-08fcc76612a7"
    },
    {
      id: "369dcc6a-fa01-4476-bb38-455c00df0aaa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3a531dc2-39de-4500-b3cb-b9c0d4a4197b",
      target: "60fc83b9-36e1-409f-ac80-3e8eac71c4e0"
    },
    {
      id: "150c78a3-3575-4198-8e2a-e77dd9b0a398",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a0ba5485-7b0b-42c9-925f-08fcc76612a7",
      target: "a0781e82-3329-4853-81d9-8aef27ea089f"
    },
    {
      id: "03c2ede0-ae8a-47af-90e4-5f0835f88ebf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4c2d79a0-af18-4343-9bc6-6ca945d19d60",
      target: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f"
    },
    {
      id: "f54bc552-7625-456b-8eb9-05b305b0a8c9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "63793101-e14b-4321-a459-422912adc441",
      target: "60fc83b9-36e1-409f-ac80-3e8eac71c4e0"
    },
    {
      id: "1385c072-09f7-4dea-bec5-fa6b35a5ee15",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "60fc83b9-36e1-409f-ac80-3e8eac71c4e0",
      target: "a0781e82-3329-4853-81d9-8aef27ea089f"
    },
    {
      id: "8385f1a8-340c-467b-a475-55cb128851de",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "60fc83b9-36e1-409f-ac80-3e8eac71c4e0",
      target: "3e16f800-ce34-4ca3-baa0-34213b8cae96"
    },
    {
      id: "bbb0cf75-a557-4464-bfa9-b43d8b308ccf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3e16f800-ce34-4ca3-baa0-34213b8cae96",
      target: "18a248ee-4bc3-40e6-a028-66f4afbf49fb"
    },
    {
      id: "84894777-7ec7-47e4-83e4-ae956c181b79",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a0781e82-3329-4853-81d9-8aef27ea089f",
      target: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f"
    },
    {
      id: "236ae653-e953-419b-a84b-7baa78fb62ea",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4452f354-5177-4ee2-aa07-72081789d9e9",
      target: "a0ba5485-7b0b-42c9-925f-08fcc76612a7"
    },
    {
      id: "4bcd506f-d805-4106-b285-0925aac41a40",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f",
      target: "c9a81071-196f-4344-9d39-aa8b296f2ad3"
    },
    {
      id: "5bd49bd8-f2fb-48f4-bd27-63eae3d841f2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f",
      target: "4f305649-165c-4d5b-9b13-7ce7d5ae2862"
    },
    {
      id: "4b9ee35a-bb62-4563-acb3-60ceb3fe23d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f",
      target: "a9f7bafc-e2ba-4b92-99ef-1fa9ffe7b59a"
    },
    {
      id: "58d204c5-8a12-4cb6-993c-134a64f905ac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ec8658a-dbe5-4ba9-9f4c-20eb5d641d4f",
      target: "f4ea5fb6-6272-4861-9d67-9f10dd8634bd"
    },
    {
      id: "c241f440-2c00-4240-aa61-1fce5d63b94d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a9f7bafc-e2ba-4b92-99ef-1fa9ffe7b59a",
      target: "18a248ee-4bc3-40e6-a028-66f4afbf49fb"
    },
    {
      id: "77a4b3c1-505a-46ab-ad22-61219e97c7e5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f4ea5fb6-6272-4861-9d67-9f10dd8634bd",
      target: "18a248ee-4bc3-40e6-a028-66f4afbf49fb"
    },
    {
      id: "d883c8ba-4dd5-4d61-94e4-1c2cd9ae28f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c9a81071-196f-4344-9d39-aa8b296f2ad3",
      target: "18a248ee-4bc3-40e6-a028-66f4afbf49fb"
    },
    {
      id: "2a7d1708-c6df-49c3-aeb8-837dd51809f6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4f305649-165c-4d5b-9b13-7ce7d5ae2862",
      target: "18a248ee-4bc3-40e6-a028-66f4afbf49fb"
    },
    {
      id: "189b442f-00ff-44c5-ab5f-400bd7d0a2a0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "18a248ee-4bc3-40e6-a028-66f4afbf49fb",
      target: "c5a9dcf1-db4a-46b5-8b9b-f8f6051f6011"
    },
    {
      id: "9e2abd7c-8407-4a8f-8ee5-f4d1785f4e05",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c5a9dcf1-db4a-46b5-8b9b-f8f6051f6011",
      target: "95cfcc66-2158-4019-a073-c195691fb1bb"
    },
    {
      id: "39f8fa04-fc7e-4c90-a066-89490cea9182",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95cfcc66-2158-4019-a073-c195691fb1bb",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "a994b14b-439d-4eb1-adb4-1afdd01d7fe0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "95cfcc66-2158-4019-a073-c195691fb1bb",
      target: "8b1cfe3f-622a-4018-96c6-d9be6db603c2"
    },
    {
      id: "1a1904ac-0ea9-47d2-ab84-078719c5be7e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8b1cfe3f-622a-4018-96c6-d9be6db603c2",
      target: "b6c3de34-0c10-4283-9111-530216ad6292"
    },
    {
      id: "eb93bf5f-06b1-4c3b-8335-91a36974064e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b6c3de34-0c10-4283-9111-530216ad6292",
      target: "0b0a8df9-746a-4831-914b-36c5e976f13c"
    },
    {
      id: "4d70a4df-7eee-4616-8052-07322a891639",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0b0a8df9-746a-4831-914b-36c5e976f13c",
      target: "a5090960-932a-4336-89f0-e05dd288536f"
    },
    {
      id: "8270fe01-d3c8-4bab-94ed-d1a8ca3a1868",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0b0a8df9-746a-4831-914b-36c5e976f13c",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "7abd061f-e695-46ca-852b-1f7812042060",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5090960-932a-4336-89f0-e05dd288536f",
      target: "1d9febe4-3b3c-4fee-b924-6d98635b05a6"
    },
    {
      id: "3e6af89f-f8d0-49c7-be7a-70603022f6eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d9febe4-3b3c-4fee-b924-6d98635b05a6",
      target: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927"
    },
    {
      id: "2625fce1-9eed-44af-8a33-4cd336d07abf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d9febe4-3b3c-4fee-b924-6d98635b05a6",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "c475cd52-1df7-4c7b-af9a-7fd0c464ae2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "08b76e55-41a7-4738-a5d9-999cd803be80",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "01cd4a8f-4fbf-4f11-a501-b78a79a4a225",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "08b76e55-41a7-4738-a5d9-999cd803be80",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "9676a0e3-c8bd-4610-95bd-06202a2eb037",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6",
      target: "6cf1677c-66bc-43c1-a4c4-22794e9d686d"
    },
    {
      id: "078eba86-3686-4c4a-9692-38efe6dab334",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6",
      target: "6521a463-cfdf-4a35-ba39-b77c3b90aa72"
    },
    {
      id: "6025649e-b9fd-4cb6-9342-e97f402aac81",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6",
      target: "1b5db001-67cd-4097-8a61-68359e05f8d0"
    },
    {
      id: "efd6f214-1495-44de-91f8-74b77f2dad46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6",
      target: "f43b88cf-ccae-4010-bdee-8680c9453e22"
    },
    {
      id: "220cb4cd-e36d-4408-a294-60fe4a56c57f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4be358d3-f79d-4aa4-8e87-3566a76e5e1d",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "8014da03-d4c0-43b6-b5ec-457bac11df20",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4be358d3-f79d-4aa4-8e87-3566a76e5e1d",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "b9022981-a3d9-49d9-8b03-d9a21c4ef201",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d9a46c0c-dedf-4a19-bd8e-5069f5ad7df6",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "9f1bfb90-f840-4678-8628-d145112fad45",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d9a46c0c-dedf-4a19-bd8e-5069f5ad7df6",
      target: "8ce10fe8-fdac-4ba6-8851-de725fb4a0c6"
    },
    {
      id: "b22036fa-072d-4c21-b23c-0f38488eae94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6cf1677c-66bc-43c1-a4c4-22794e9d686d",
      target: "f43b88cf-ccae-4010-bdee-8680c9453e22"
    },
    {
      id: "3f849c3d-8cde-4c27-bea2-0a26f72a7ab2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1b5db001-67cd-4097-8a61-68359e05f8d0",
      target: "f43b88cf-ccae-4010-bdee-8680c9453e22"
    },
    {
      id: "ce4bf70a-2b0e-49a7-b296-fc7b8351abe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6521a463-cfdf-4a35-ba39-b77c3b90aa72",
      target: "f43b88cf-ccae-4010-bdee-8680c9453e22"
    },
    {
      id: "0a26f9b7-022e-4bd8-b9f0-9b63907b8bb4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f43b88cf-ccae-4010-bdee-8680c9453e22",
      target: "22160751-fdd7-4e28-9bf6-e436206a6e25"
    },
    {
      id: "fc91aae5-5b45-409c-948a-13a4a73991ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22160751-fdd7-4e28-9bf6-e436206a6e25",
      target: "70a3e62d-12a1-4ab7-988f-fc5c250b2b1d"
    },
    {
      id: "8f56226b-8bed-4e08-a9ae-095e272efe44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70a3e62d-12a1-4ab7-988f-fc5c250b2b1d",
      target: "2dce8b57-10b4-4bd4-86f0-33c584798f34"
    },
    {
      id: "29ff7198-7358-4d32-a72c-1994fac0ba88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dce8b57-10b4-4bd4-86f0-33c584798f34",
      target: "e0400250-d276-4e1f-a64d-9281daddabfa"
    },
    {
      id: "633b268a-dfc7-46d8-a08f-9ee3539aef44",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c564465c-020b-4753-8e67-a48c4a5e5f86",
      target: "77dbc1da-f58d-4774-a6e9-1a7bf3fec7a6"
    },
    {
      id: "66453e47-c4bb-45b3-9779-7e5a385afb12",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e0400250-d276-4e1f-a64d-9281daddabfa",
      target: "c564465c-020b-4753-8e67-a48c4a5e5f86"
    },
    {
      id: "4a8706b0-3bf2-4932-a882-34a5c8a1fe0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0400250-d276-4e1f-a64d-9281daddabfa",
      target: "77dbc1da-f58d-4774-a6e9-1a7bf3fec7a6"
    },
    {
      id: "1107b045-22ca-4676-929c-9566360c7ac0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0400250-d276-4e1f-a64d-9281daddabfa",
      target: "05cfe7b3-61a5-42ad-a516-dbad1252fc95"
    },
    {
      id: "5e63f660-70a5-47bd-8ce2-e195f04f22a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0400250-d276-4e1f-a64d-9281daddabfa",
      target: "460387f3-8d9e-4736-878f-1a9c8ae4ed44"
    },
    {
      id: "760654d7-2acb-49e3-9bf9-e29a93095637",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "05cfe7b3-61a5-42ad-a516-dbad1252fc95",
      target: "77dbc1da-f58d-4774-a6e9-1a7bf3fec7a6"
    },
    {
      id: "8938dca8-5a86-496b-a338-9dac649e56e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77dbc1da-f58d-4774-a6e9-1a7bf3fec7a6",
      target: "3651607f-c77a-402c-a830-1117193d4b62"
    },
    {
      id: "d6ec37e4-68a4-4cfd-b7bc-99d38464d1fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3651607f-c77a-402c-a830-1117193d4b62",
      target: "dca8ffda-be52-413d-9368-db56579d09e5"
    },
    {
      id: "4154e0ee-0ce8-445e-b1b9-575e762d50d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3651607f-c77a-402c-a830-1117193d4b62",
      target: "6df58375-5083-47ae-b1ca-cfde0da13f35"
    },
    {
      id: "20ff699c-989a-4453-ad29-85a3aaf3bb36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3651607f-c77a-402c-a830-1117193d4b62",
      target: "af9419ae-c23e-48e4-b592-87c16a8a04cd"
    },
    {
      id: "2b448e7a-aece-4c7c-b7f8-cf9105675a0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3651607f-c77a-402c-a830-1117193d4b62",
      target: "a127f3d4-ff0e-4154-baed-a5027afb4c78"
    },
    {
      id: "e0c1130e-3017-4f81-ba88-5ae2471295f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dca8ffda-be52-413d-9368-db56579d09e5",
      target: "02c47d40-3206-445b-aece-2151225873d2"
    },
    {
      id: "4bbef329-983a-4466-940b-390124e671c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dca8ffda-be52-413d-9368-db56579d09e5",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "a33d217a-2c6c-4831-b7a7-965348bf947a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a127f3d4-ff0e-4154-baed-a5027afb4c78",
      target: "02c47d40-3206-445b-aece-2151225873d2"
    },
    {
      id: "d39cef6a-acb8-48a5-aea3-e8160cb339d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6df58375-5083-47ae-b1ca-cfde0da13f35",
      target: "0b0a8df9-746a-4831-914b-36c5e976f13c"
    },
    {
      id: "1f78e764-71d6-4500-b8ed-2198aeabcdb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "02c47d40-3206-445b-aece-2151225873d2",
      target: "6ac2baac-eb0a-40af-87f9-caca9fe3c708"
    },
    {
      id: "b7016042-29a4-431a-abd0-d4696c942f52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ac2baac-eb0a-40af-87f9-caca9fe3c708",
      target: "fb98b840-03c4-44e3-b2d7-2b27ca8f0a03"
    },
    {
      id: "4fbae0ba-63cc-4edb-879d-1b1442b19159",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb98b840-03c4-44e3-b2d7-2b27ca8f0a03",
      target: "0b0a8df9-746a-4831-914b-36c5e976f13c"
    },
    {
      id: "14a7adf8-b710-4b1b-88f3-18b706cd90f1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "08b76e55-41a7-4738-a5d9-999cd803be80"
    },
    {
      id: "a743ca31-0879-44e7-9c50-9f67fa6173af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "d9a46c0c-dedf-4a19-bd8e-5069f5ad7df6"
    },
    {
      id: "d1d54a2d-fa25-405e-a6bf-d499058320ba",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "4be358d3-f79d-4aa4-8e87-3566a76e5e1d"
    },
    {
      id: "4f642a77-d2c0-43e4-b8e3-dc684459250a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "08b76e55-41a7-4738-a5d9-999cd803be80"
    },
    {
      id: "32bf3153-4241-4299-b29b-d4b2a49abb2f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "4be358d3-f79d-4aa4-8e87-3566a76e5e1d"
    },
    {
      id: "2ee9d964-eff7-4a5b-83eb-e46dcbc784c3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e3e9c433-eaaa-471e-9b81-7792f0228545",
      target: "d9a46c0c-dedf-4a19-bd8e-5069f5ad7df6"
    },
    {
      id: "770e9176-1c29-4f0e-9695-88100049d246",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f",
      target: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9"
    },
    {
      id: "0b3519cf-2d27-4778-96d7-544866e87b69",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f",
      target: "09b79ccd-8edf-4589-baec-fc3da020e460"
    },
    {
      id: "194b242a-aa4b-4d10-a004-ae5a91f16fab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc26b6aa-5c8e-4e6a-b80e-31d3fc3bcb6f",
      target: "33f9d545-3835-4e65-b5b9-12a6700fb9a7"
    },
    {
      id: "c7be25ad-3a79-4d20-81df-c327ccb61838",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "09b79ccd-8edf-4589-baec-fc3da020e460",
      target: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8"
    },
    {
      id: "c8c50c40-569c-4e19-9c1f-fdea6161e345",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09b79ccd-8edf-4589-baec-fc3da020e460",
      target: "37b2ef8c-0d12-48ec-ac0f-d5e30fc8bf97"
    },
    {
      id: "6e61cd25-aac5-4966-9d76-9d8a7200ffdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09b79ccd-8edf-4589-baec-fc3da020e460",
      target: "417cebdf-db83-426a-a837-c66a1ce529a1"
    },
    {
      id: "af67251d-c9c8-4f95-9ab0-4ddd653bbbc2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8",
      target: "44ec1edf-2c44-44a5-9a05-1c5cc6147b1f"
    },
    {
      id: "a606de48-55a3-4f70-83a3-6cf422784385",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "0a54cc97-b04d-4b41-b53d-028b17a6728c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ac5e94a-f6db-4639-a53a-fc8ab0429ef8",
      target: "3a343c17-53ff-48a5-8893-78f2791bca9f"
    },
    {
      id: "3339b179-1ea7-4020-9e60-175138aa08a3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "44ec1edf-2c44-44a5-9a05-1c5cc6147b1f",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "f16094e6-241e-4319-9970-96e0f8f1b80c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "44ec1edf-2c44-44a5-9a05-1c5cc6147b1f",
      target: "a1712f69-196c-4cb1-b138-9f1b1913279d"
    },
    {
      id: "4a401b5f-9f68-4289-9c28-6410a3e2c667",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "33f9d545-3835-4e65-b5b9-12a6700fb9a7",
      target: "37b2ef8c-0d12-48ec-ac0f-d5e30fc8bf97"
    },
    {
      id: "21d448a6-7a34-40e2-b223-31d0e57a6354",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33f9d545-3835-4e65-b5b9-12a6700fb9a7",
      target: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9"
    },
    {
      id: "64d20d5f-d90d-4101-a206-6d455f03c87c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "37b2ef8c-0d12-48ec-ac0f-d5e30fc8bf97",
      target: "3a343c17-53ff-48a5-8893-78f2791bca9f"
    },
    {
      id: "e302115c-f67e-4d42-965a-4707c1f80816",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37b2ef8c-0d12-48ec-ac0f-d5e30fc8bf97",
      target: "417cebdf-db83-426a-a837-c66a1ce529a1"
    },
    {
      id: "0ed39143-e028-4a28-9f92-7093a665bcb3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3a343c17-53ff-48a5-8893-78f2791bca9f",
      target: "a1712f69-196c-4cb1-b138-9f1b1913279d"
    },
    {
      id: "36c670da-373d-42a5-acf3-1fe5c8f031ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3a343c17-53ff-48a5-8893-78f2791bca9f",
      target: "ca7dcf5a-c382-434e-be4c-62f7790b15e8"
    },
    {
      id: "64468139-226f-4fd0-af48-647eb48b66f9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a1712f69-196c-4cb1-b138-9f1b1913279d",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "6a2415ed-2679-4104-8275-34038fa4d256",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1712f69-196c-4cb1-b138-9f1b1913279d",
      target: "f35c623f-a74d-4e3e-ae38-c74d5b4f66aa"
    },
    {
      id: "b795d9f2-46fc-4f95-ac70-0345c3785acc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "b9e3629b-8bd2-464e-a60c-2c2b32943bda"
    },
    {
      id: "e2fe35d5-0d06-49b9-853a-fb9497d70e85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "73d74f88-0190-42dc-ab09-f92e5dd28894"
    },
    {
      id: "1eafc366-1829-4f66-b480-e218e2224e76",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "b9e3629b-8bd2-464e-a60c-2c2b32943bda"
    },
    {
      id: "7ea94968-6e17-42bf-9b86-3d8afd4459a7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "47e725ae-8386-41be-905c-197027a8d882"
    },
    {
      id: "901c7b81-f0a8-45f9-bfe3-192b00086627",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "47e725ae-8386-41be-905c-197027a8d882"
    },
    {
      id: "e30fc82a-8d43-45b5-8009-98b92e30f41e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "ea8227d1-d3f7-4e5e-9219-667a8bb5d41b"
    },
    {
      id: "a8adb30b-73ca-490b-808c-e38b89d641ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "12b9d796-8640-4dc0-8f20-2033aed26fc5"
    },
    {
      id: "5ea5663f-6b6a-400c-a3c1-9c71939ba0ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "fcf7f38e-4a8b-41fd-a396-2af83c242463"
    },
    {
      id: "29515200-8672-4acd-bc81-d2f8adb6dc14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "631493f5-651b-43a7-bc33-071f4850db8b",
      target: "17670139-3138-4fa5-a7cb-2096b7544123"
    },
    {
      id: "f2a7b7b0-ecf4-4352-8a32-2a6c205ca60f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea8227d1-d3f7-4e5e-9219-667a8bb5d41b",
      target: "ae393f7a-b536-4e92-93ab-c70d1e17f566"
    },
    {
      id: "a51729ac-dc25-4eaf-8a42-73034efd1551",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "17670139-3138-4fa5-a7cb-2096b7544123",
      target: "ae393f7a-b536-4e92-93ab-c70d1e17f566"
    },
    {
      id: "9e7d2b65-591b-4b14-8676-d20c7934a85c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcf7f38e-4a8b-41fd-a396-2af83c242463",
      target: "1177768d-69e3-4705-9ebf-4fe868ce700f"
    },
    {
      id: "760a2e6b-df83-441b-bc5b-dfabe3163f28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12b9d796-8640-4dc0-8f20-2033aed26fc5",
      target: "ae393f7a-b536-4e92-93ab-c70d1e17f566"
    },
    {
      id: "25220982-9812-42b3-ad82-a995aa3f3edf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d74f88-0190-42dc-ab09-f92e5dd28894",
      target: "f1f60748-baed-4a2d-bc7a-2dd1c8f29486"
    },
    {
      id: "7f2aad5d-8cb4-451b-b0b3-3277b5300fb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73d74f88-0190-42dc-ab09-f92e5dd28894",
      target: "fe4071fe-909e-4a85-aa83-ef00792d503f"
    },
    {
      id: "85bb3b11-25b6-45cb-bcdf-7c14e9ff8585",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae393f7a-b536-4e92-93ab-c70d1e17f566",
      target: "5574c361-0300-4741-ac4a-d7b9dbf385fe"
    },
    {
      id: "a6a4cb8b-a62d-4df1-97e4-dec68653b3c5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae393f7a-b536-4e92-93ab-c70d1e17f566",
      target: "2645519a-3380-412c-8fac-33e4f25a07b3"
    },
    {
      id: "f32d28d3-a4e4-4b44-873e-ae31d04c19b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1f60748-baed-4a2d-bc7a-2dd1c8f29486",
      target: "1177768d-69e3-4705-9ebf-4fe868ce700f"
    },
    {
      id: "0a26333a-ecc5-404a-bfc8-113cc22a0bd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1177768d-69e3-4705-9ebf-4fe868ce700f",
      target: "8729c704-5316-40c9-a098-222574688c6a"
    },
    {
      id: "46dc86f5-cc66-4d48-b737-967876f94031",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8729c704-5316-40c9-a098-222574688c6a",
      target: "d58cc4e8-f3b2-4fb2-8f96-5b29c346ec4b"
    },
    {
      id: "5d133bd7-2b7a-42e2-893a-062247108f68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d58cc4e8-f3b2-4fb2-8f96-5b29c346ec4b",
      target: "711d8fd5-c3b2-45cd-9880-a000d9e4ac00"
    },
    {
      id: "a7bced35-67fd-4c31-921d-272f87543fc3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d58cc4e8-f3b2-4fb2-8f96-5b29c346ec4b",
      target: "eb4403f2-df57-43c9-a25b-261c7f96903b"
    },
    {
      id: "848a0282-d60d-48eb-9caf-8c1578643d3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb4403f2-df57-43c9-a25b-261c7f96903b",
      target: "50fdd7f5-b49f-4823-928d-578670dc488b"
    },
    {
      id: "de2ec515-841b-43df-997a-08b141e0db55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "711d8fd5-c3b2-45cd-9880-a000d9e4ac00",
      target: "6ebad0a7-f96c-4980-ba51-78607a494e83"
    },
    {
      id: "59c8ebc3-f4ba-4cb9-a645-69bf4ea332d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "711d8fd5-c3b2-45cd-9880-a000d9e4ac00",
      target: "5574c361-0300-4741-ac4a-d7b9dbf385fe"
    },
    {
      id: "79b27633-d78d-414b-ada7-d783157d5bac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "711d8fd5-c3b2-45cd-9880-a000d9e4ac00",
      target: "2645519a-3380-412c-8fac-33e4f25a07b3"
    },
    {
      id: "c88a117d-2055-4fc5-9fff-b1de45d744bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50fdd7f5-b49f-4823-928d-578670dc488b",
      target: "d847da25-e96a-49ad-818b-2b3297a9b3bc"
    },
    {
      id: "0d250dc4-3d51-415b-9559-ebd2786bfbba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2645519a-3380-412c-8fac-33e4f25a07b3",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "0096485b-8aa5-4ab1-94e0-df1987b1bdf0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5574c361-0300-4741-ac4a-d7b9dbf385fe",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "a500a384-1868-4437-9842-f5872a5e4efc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ebad0a7-f96c-4980-ba51-78607a494e83",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "d272991b-9578-4fce-be90-782f14961530",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6ebad0a7-f96c-4980-ba51-78607a494e83",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "55681912-acc5-4eef-913f-8d334d08b172",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d847da25-e96a-49ad-818b-2b3297a9b3bc",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "ca3f4cbd-67b0-4759-8d62-9faec10b27cf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "fe835d38-3248-4dce-86fc-c64570578a63",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed",
      target: "ac49455c-7179-4c7d-95ba-045d3be2c497"
    },
    {
      id: "b149894a-7f8b-4ca2-9da5-f287a42cec33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed",
      target: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927"
    },
    {
      id: "e4331c9b-9d47-436c-b0cf-09fc310b050c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "3bdb797f-27b7-4e9e-8723-03736931fca4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5c2dcf7-42d9-45f7-9013-5a101d5931c8",
      target: "631493f5-651b-43a7-bc33-071f4850db8b"
    },
    {
      id: "452ce290-b87a-46b2-9a70-33790eb5bb3a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c5c2dcf7-42d9-45f7-9013-5a101d5931c8",
      target: "d5f395af-487c-4217-9d5f-219617efce48"
    },
    {
      id: "4bd458b8-44be-4cb7-bfdd-76a7c637fe48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e725ae-8386-41be-905c-197027a8d882",
      target: "ead3e791-a451-4c3b-8bb6-f6fd268878bf"
    },
    {
      id: "05e63d81-d0a1-4abf-a0b9-7b58783879cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e725ae-8386-41be-905c-197027a8d882",
      target: "26ffae8b-688d-40b0-b9f0-30ed56867102"
    },
    {
      id: "70e241f6-b82b-476e-8381-c1bd26264f8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e725ae-8386-41be-905c-197027a8d882",
      target: "27f9fd5a-b31c-4d1c-a3bb-cfa01b9aef75"
    },
    {
      id: "050082a1-0e18-401e-bea1-a8aa2db17895",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e725ae-8386-41be-905c-197027a8d882",
      target: "fe4071fe-909e-4a85-aa83-ef00792d503f"
    },
    {
      id: "eb3db5b0-6dcb-483d-be76-76325d645a99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "47e725ae-8386-41be-905c-197027a8d882",
      target: "6e2a8468-9352-470f-a935-1a4f384833cb"
    },
    {
      id: "27026cea-2977-40ea-af45-5c8852ea8dc5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26ffae8b-688d-40b0-b9f0-30ed56867102",
      target: "57ec90db-0b26-4757-9b22-6003e84f3fbf"
    },
    {
      id: "d118c562-49cd-4370-973d-1216b0154632",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27f9fd5a-b31c-4d1c-a3bb-cfa01b9aef75",
      target: "14662752-c8c0-46e0-8c14-bd33dd0e07bb"
    },
    {
      id: "10f25b8d-510b-4f04-b442-222365b1d8d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe4071fe-909e-4a85-aa83-ef00792d503f",
      target: "9b3fcf84-ebdc-44c5-8288-08c89b726dc7"
    },
    {
      id: "24b2c296-00eb-41c2-86d5-0610e59fd48b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe4071fe-909e-4a85-aa83-ef00792d503f",
      target: "0603ac53-b38b-4aaf-ac07-7009e740acc0"
    },
    {
      id: "672c314d-c547-4b1d-a2e6-14a080f60353",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ead3e791-a451-4c3b-8bb6-f6fd268878bf",
      target: "14662752-c8c0-46e0-8c14-bd33dd0e07bb"
    },
    {
      id: "d44a3abc-1b98-433a-ac6f-b0b3526f9ea6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e2a8468-9352-470f-a935-1a4f384833cb",
      target: "14662752-c8c0-46e0-8c14-bd33dd0e07bb"
    },
    {
      id: "0b099270-59a6-494c-9280-702c9eb8bf2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b3fcf84-ebdc-44c5-8288-08c89b726dc7",
      target: "57ec90db-0b26-4757-9b22-6003e84f3fbf"
    },
    {
      id: "5b0cc890-5343-477f-a137-58c40e1a00d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "14662752-c8c0-46e0-8c14-bd33dd0e07bb",
      target: "5534f605-e779-4607-8940-2bd768ce169f"
    },
    {
      id: "7747a702-adc9-450e-a34e-03dbb0764281",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14662752-c8c0-46e0-8c14-bd33dd0e07bb",
      target: "5149dc2a-6118-4bc4-b8ed-2a232cd9fc0b"
    },
    {
      id: "be923a3a-1af4-4d51-bc0e-a6983e976382",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57ec90db-0b26-4757-9b22-6003e84f3fbf",
      target: "a8df5053-478a-4e75-913c-62ee1afcb093"
    },
    {
      id: "528f5241-7971-4336-8a8e-af6231ec906f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8df5053-478a-4e75-913c-62ee1afcb093",
      target: "bcc46726-ab89-4826-95bc-2795611434f2"
    },
    {
      id: "c04436af-e07c-4e0a-b84b-b8406deffada",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bcc46726-ab89-4826-95bc-2795611434f2",
      target: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7"
    },
    {
      id: "748a797c-4338-421b-9fd4-c01489b5e540",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      target: "212dda32-6ec5-467d-b017-b72859d32a5f"
    },
    {
      id: "4aab90d1-4b0a-4501-8ac3-5a8c9fda12c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      target: "5534f605-e779-4607-8940-2bd768ce169f"
    },
    {
      id: "a38d4c11-d4d2-4fbe-a665-3f97739fdb8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      target: "5149dc2a-6118-4bc4-b8ed-2a232cd9fc0b"
    },
    {
      id: "916f888a-c381-4d27-a8fb-69d7e1e3c885",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      target: "5220153c-b126-4e34-a61c-047ed1f0b5b3"
    },
    {
      id: "acc3dfa4-631d-4108-add5-d3e18fc7ec66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4d78e50-4cb3-4e32-83de-77f3f3a02db7",
      target: "0702b875-ef25-41d8-bc54-5bf0600a31b7"
    },
    {
      id: "dff9ba98-09d5-4f14-a300-9d713a4abdbe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0702b875-ef25-41d8-bc54-5bf0600a31b7",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "5c19c4f5-042f-4ee0-b5f7-bf1b3a50f30c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0702b875-ef25-41d8-bc54-5bf0600a31b7",
      target: "3e05f150-c9a6-4d83-bbc4-250752106327"
    },
    {
      id: "4ffccf79-9b8a-4fea-973f-955ecd267e28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5534f605-e779-4607-8940-2bd768ce169f",
      target: "3e05f150-c9a6-4d83-bbc4-250752106327"
    },
    {
      id: "6a2bd8d6-8e33-4a19-a06d-8884d9e82a13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5149dc2a-6118-4bc4-b8ed-2a232cd9fc0b",
      target: "3e05f150-c9a6-4d83-bbc4-250752106327"
    },
    {
      id: "c8bcf73b-b632-4cc6-8edd-7208dce0dc3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5220153c-b126-4e34-a61c-047ed1f0b5b3",
      target: "94809bf2-cd90-4603-a7c0-8e4ab5a90173"
    },
    {
      id: "165886db-8b87-479b-bda5-58de45a81f86",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "212dda32-6ec5-467d-b017-b72859d32a5f",
      target: "5220153c-b126-4e34-a61c-047ed1f0b5b3"
    },
    {
      id: "ca279901-dc75-4ed4-b279-56bed6845335",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "212dda32-6ec5-467d-b017-b72859d32a5f",
      target: "04535453-e825-4e39-946c-dda78f65eeb3"
    },
    {
      id: "6cb191c4-6531-4d7f-9432-fb86ca37fcc2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94809bf2-cd90-4603-a7c0-8e4ab5a90173",
      target: "cd4287b6-8d72-4989-970a-d3aaca99840d"
    },
    {
      id: "6ce5e827-cab7-443c-bb4e-8de2ca55c06a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04535453-e825-4e39-946c-dda78f65eeb3",
      target: "3e05f150-c9a6-4d83-bbc4-250752106327"
    },
    {
      id: "620a7bb5-a170-419d-b03b-49e807301662",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd4287b6-8d72-4989-970a-d3aaca99840d",
      target: "3e05f150-c9a6-4d83-bbc4-250752106327"
    },
    {
      id: "d1590d5a-5b01-42e5-9262-2f4b13e29174",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e05f150-c9a6-4d83-bbc4-250752106327",
      target: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927"
    },
    {
      id: "12fe9b81-bb0d-4cf8-8cb9-16d81bf36615",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e05f150-c9a6-4d83-bbc4-250752106327",
      target: "bacc9779-e175-435d-8b8a-abbbf13f7902"
    },
    {
      id: "9d5a7a21-e190-4d56-84e9-c78da9e71fbd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3e05f150-c9a6-4d83-bbc4-250752106327",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "04851734-d01f-4adc-a815-998c666b08b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      target: "bff7cb41-a76c-46f3-9db8-e2014bf430a1"
    },
    {
      id: "56000528-d029-434d-a518-74a47b54f708",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      target: "fbf09de8-1e78-4ba5-94bf-3b04fd044756"
    },
    {
      id: "ea376235-ad3f-45c1-a029-8c1dce6b727b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      target: "bd6b2ce5-d103-40ab-92e5-def05736dae7"
    },
    {
      id: "ddc49fc7-db01-40a5-8e3a-e5ff55ae7d48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      target: "3c2016a7-5cee-448c-9844-c1e76ead6713"
    },
    {
      id: "3451b09b-5163-4d84-944c-1ae62b08b48e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9e3629b-8bd2-464e-a60c-2c2b32943bda",
      target: "0603ac53-b38b-4aaf-ac07-7009e740acc0"
    },
    {
      id: "3d0c7f8f-06bc-4b70-8769-382bcc4051d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbf09de8-1e78-4ba5-94bf-3b04fd044756",
      target: "14ecde25-a3d6-493e-8687-7a255f86dc23"
    },
    {
      id: "8d3129e7-9c94-4cd1-acdd-5d5ce275856f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bff7cb41-a76c-46f3-9db8-e2014bf430a1",
      target: "58970856-58a0-405f-8e3d-1255df3bdd79"
    },
    {
      id: "b22173a0-2099-436f-8b81-a12158c44925",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0603ac53-b38b-4aaf-ac07-7009e740acc0",
      target: "6d6fce69-8759-4441-9d3a-c5e9942272cb"
    },
    {
      id: "3a1074d0-22bb-4a71-9f13-dac8ee70cb6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c2016a7-5cee-448c-9844-c1e76ead6713",
      target: "58970856-58a0-405f-8e3d-1255df3bdd79"
    },
    {
      id: "fae6a7e3-6445-4109-a8b5-fb1a2d990aec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd6b2ce5-d103-40ab-92e5-def05736dae7",
      target: "58970856-58a0-405f-8e3d-1255df3bdd79"
    },
    {
      id: "72199640-19da-4155-bd79-47fc23d3ed71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d6fce69-8759-4441-9d3a-c5e9942272cb",
      target: "14ecde25-a3d6-493e-8687-7a255f86dc23"
    },
    {
      id: "5f35452e-c431-41a7-92b2-c8defd00666c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "58970856-58a0-405f-8e3d-1255df3bdd79",
      target: "4574a98d-1bb7-4e8e-a726-f5294d913b8e"
    },
    {
      id: "4c3c3f86-d322-49ed-8500-7902080d08e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58970856-58a0-405f-8e3d-1255df3bdd79",
      target: "7245901a-c8fb-4512-917e-31e360191e20"
    },
    {
      id: "225a4fad-188f-408d-941b-c986e4d2d3f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14ecde25-a3d6-493e-8687-7a255f86dc23",
      target: "f49b68eb-5a5d-470c-8445-43456b534234"
    },
    {
      id: "d9150596-e6ef-4d09-942b-8e1c2fbaea8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f49b68eb-5a5d-470c-8445-43456b534234",
      target: "cd26e6bc-f395-4680-9b52-b7f7a84376b2"
    },
    {
      id: "dc8f12b5-b258-43e4-abb4-683059735672",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd26e6bc-f395-4680-9b52-b7f7a84376b2",
      target: "aa815a22-c5d7-4847-98ef-09487b0d1aa4"
    },
    {
      id: "521715f2-3076-435e-b3dd-4cbab83153a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      target: "7245901a-c8fb-4512-917e-31e360191e20"
    },
    {
      id: "d4700ba3-81c8-4ecc-b600-b941a2b1ff1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      target: "e5715b5c-ca0f-4650-bcb3-9f82f2b94ae6"
    },
    {
      id: "c0947b9a-a3bc-4e46-aeef-1fdb142e2455",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      target: "83c41607-7a7e-4117-b19b-40dda9367b03"
    },
    {
      id: "aeb736a9-4182-43e2-8320-6b3a5af29ac8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      target: "4574a98d-1bb7-4e8e-a726-f5294d913b8e"
    },
    {
      id: "36e7a4a3-a250-4b72-a537-d842a9f77990",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa815a22-c5d7-4847-98ef-09487b0d1aa4",
      target: "baa4c000-a4d3-4505-b695-7df6a1e72fb1"
    },
    {
      id: "bdb1ac34-f5bf-41ca-9200-5ef2da6aa9c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5715b5c-ca0f-4650-bcb3-9f82f2b94ae6",
      target: "7f7651ef-2b96-41db-b783-a6aeaeab96b0"
    },
    {
      id: "f1ad1c81-d993-4e79-b211-d0ccec85b713",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5715b5c-ca0f-4650-bcb3-9f82f2b94ae6",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "4f4e3bdf-1a68-4f49-bf91-d97ce4f20a2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4574a98d-1bb7-4e8e-a726-f5294d913b8e",
      target: "7f7651ef-2b96-41db-b783-a6aeaeab96b0"
    },
    {
      id: "bdc5b372-74a2-4995-a1c9-efd7c70bf02a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7245901a-c8fb-4512-917e-31e360191e20",
      target: "7f7651ef-2b96-41db-b783-a6aeaeab96b0"
    },
    {
      id: "f6e8058a-55e9-416f-8798-55f554c0970e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "83c41607-7a7e-4117-b19b-40dda9367b03",
      target: "ea7b3771-f0f9-480b-bcff-1b4e6a8055b6"
    },
    {
      id: "04620283-c386-4ddf-940b-b85f03e765df",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "baa4c000-a4d3-4505-b695-7df6a1e72fb1",
      target: "83c41607-7a7e-4117-b19b-40dda9367b03"
    },
    {
      id: "fff41bbe-e961-4288-8aa1-d86ba5833781",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "baa4c000-a4d3-4505-b695-7df6a1e72fb1",
      target: "9b27af97-2fcb-4e8c-8c5c-c914e3cb7a7c"
    },
    {
      id: "886b281d-650e-44ea-9764-0c39e12be42c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea7b3771-f0f9-480b-bcff-1b4e6a8055b6",
      target: "42832c2c-fc45-4b3c-b184-9a2b8ffa9506"
    },
    {
      id: "053a8fb6-d130-42d7-9f4b-65cf0550cb47",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b27af97-2fcb-4e8c-8c5c-c914e3cb7a7c",
      target: "7f7651ef-2b96-41db-b783-a6aeaeab96b0"
    },
    {
      id: "04f6484c-79c4-40d5-b2c5-0cb875789f4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42832c2c-fc45-4b3c-b184-9a2b8ffa9506",
      target: "7f7651ef-2b96-41db-b783-a6aeaeab96b0"
    },
    {
      id: "75c3ca8a-26ac-4fc8-bd47-426b3cf84854",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f7651ef-2b96-41db-b783-a6aeaeab96b0",
      target: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927"
    },
    {
      id: "bc87b921-f0bc-4f0e-b6ca-51bd5a226ca4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f7651ef-2b96-41db-b783-a6aeaeab96b0",
      target: "bacc9779-e175-435d-8b8a-abbbf13f7902"
    },
    {
      id: "4398cb6f-f252-41ac-afb7-f9a123722bec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f7651ef-2b96-41db-b783-a6aeaeab96b0",
      target: "877d7b90-ab2b-48bb-8425-e0fcc929a5ed"
    },
    {
      id: "a1cf4e53-ab12-48a1-be76-6c28047a3088",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "984d6f13-ec1e-4dea-b22d-2a2af28f5c80"
    },
    {
      id: "60cbe4e3-2103-4941-8cc9-913c06b837a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "73ecfbec-c9c6-4c5d-8356-d669e1b485e4"
    },
    {
      id: "367bed5b-243b-4ae7-9dab-22ec0f683c7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "43a46004-fef5-4e61-afef-6cb1eedb3dbc"
    },
    {
      id: "372abf7c-b14c-44c2-bf8a-d34c5bb443eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "21f942e1-8dbf-41ab-83c3-e410d4fa5303"
    },
    {
      id: "a1d5c233-9a61-4c06-abed-a2672ba07aaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "631493f5-651b-43a7-bc33-071f4850db8b"
    },
    {
      id: "c9b4acba-c479-46f4-8534-18f6b33e969c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e19f29f6-4f45-404e-b334-cd4a91f27b60",
      target: "f061cf85-98b1-4a41-8f55-df23ad164a6e"
    },
    {
      id: "c439e316-e031-4962-97b6-70ae0dbabcb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "73ecfbec-c9c6-4c5d-8356-d669e1b485e4",
      target: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed"
    },
    {
      id: "136a9d9d-e31f-4a2f-8d31-aa50d7aa5905",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43a46004-fef5-4e61-afef-6cb1eedb3dbc",
      target: "9a413c5e-c45b-40ce-a86f-b27382622d01"
    },
    {
      id: "55f63de8-dbfa-49e4-8966-78945f710f58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43a46004-fef5-4e61-afef-6cb1eedb3dbc",
      target: "73d74f88-0190-42dc-ab09-f92e5dd28894"
    },
    {
      id: "c2caf7d6-70e7-47f7-94cc-b0abe0319b87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "21f942e1-8dbf-41ab-83c3-e410d4fa5303",
      target: "08424bd0-4312-4bc4-bf95-fc8eeef4a1a3"
    },
    {
      id: "e423c36f-7e65-4460-9ee0-6983e9c8408c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "984d6f13-ec1e-4dea-b22d-2a2af28f5c80",
      target: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed"
    },
    {
      id: "eba23a4c-c9d7-4665-baba-739d2a801c4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f061cf85-98b1-4a41-8f55-df23ad164a6e",
      target: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed"
    },
    {
      id: "dc7d4ab9-ac79-4d0c-93d9-e8a3d847dc5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9a413c5e-c45b-40ce-a86f-b27382622d01",
      target: "08424bd0-4312-4bc4-bf95-fc8eeef4a1a3"
    },
    {
      id: "f6a566fc-510f-42eb-a349-02e821c9cd48",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed",
      target: "e1842088-2ad3-4b25-852d-e7ceec6ddd8b"
    },
    {
      id: "d8bcf9f4-fb93-4b7d-bcce-f0a96d551ebc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d97da2e-a96d-4f7b-bc96-dc5e6db02aed",
      target: "8cd3a88a-b943-4134-a113-4544add2b0c5"
    },
    {
      id: "8e2ad150-673e-4d87-8b7f-169762059b94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "08424bd0-4312-4bc4-bf95-fc8eeef4a1a3",
      target: "446db9ae-f692-47fb-ba0c-619dbb8c0ccf"
    },
    {
      id: "9874ac53-e718-4634-b058-fc7f72deac8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "446db9ae-f692-47fb-ba0c-619dbb8c0ccf",
      target: "978072b6-b67f-4e92-a133-d8ac814c8ccd"
    },
    {
      id: "7d05a81c-0292-4232-b4f9-176dea7f6d80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "8bc22fdb-792a-44dd-8cb1-f81136adcddf"
    },
    {
      id: "4028d027-b305-4a65-8604-766040213ad9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "7265e2c8-8ef3-4c20-9bbf-20d252a68851"
    },
    {
      id: "1084efb5-8145-41af-92fc-73a22cccada0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "b75524e3-9b9a-4c73-bbd0-d2f3c8df13db"
    },
    {
      id: "f4f3739e-0755-464f-a906-658e877669d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "e1842088-2ad3-4b25-852d-e7ceec6ddd8b"
    },
    {
      id: "c6fffcc0-f5cc-4989-9409-c2ff9af28812",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "7f831430-ce60-4cdb-8002-5ec846431633"
    },
    {
      id: "750d05fe-aa9c-42d1-a727-33e186fa6a98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "978072b6-b67f-4e92-a133-d8ac814c8ccd",
      target: "8cd3a88a-b943-4134-a113-4544add2b0c5"
    },
    {
      id: "01e78d1a-63be-44a4-9dbf-e208faf716c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7265e2c8-8ef3-4c20-9bbf-20d252a68851",
      target: "8f687476-a96f-460f-b9e0-6896008bb4a5"
    },
    {
      id: "73c56382-41da-4e3b-b4f3-d82d8264b870",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f831430-ce60-4cdb-8002-5ec846431633",
      target: "84578b5c-1cdd-4361-8b5a-5000093df4c1"
    },
    {
      id: "1400942e-b48b-47b1-8c05-252e371c2795",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f831430-ce60-4cdb-8002-5ec846431633",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "61e27c3d-7a6a-474e-ad0b-7b100ebc956a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1842088-2ad3-4b25-852d-e7ceec6ddd8b",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "42f020c9-0de0-4beb-bf47-2d43dd4149ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8cd3a88a-b943-4134-a113-4544add2b0c5",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "2283d648-104e-44ad-8fa7-fa934f8fe11e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8f687476-a96f-460f-b9e0-6896008bb4a5",
      target: "54e6c5f1-e313-4f5d-8be6-a5c24f8241b6"
    },
    {
      id: "822110a6-0649-4db0-bfd1-c072b1815efe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "54e6c5f1-e313-4f5d-8be6-a5c24f8241b6",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "948c8465-bbb2-4d6f-bc05-ec7893c2c081",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "f1a2c421-f72e-4c6e-b557-a4e2b9c75652",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "1a1e8687-5787-463e-887d-8fca62fd5a24",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23",
      target: "34bbbf05-1a81-4dc3-a6a0-d47a48aa6927"
    },
    {
      id: "f7548494-2995-41fa-9f6f-95aa2eb70455",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b75524e3-9b9a-4c73-bbd0-d2f3c8df13db",
      target: "ffdf9776-3a56-4b4c-9ba1-bc0c2dfd01a9"
    },
    {
      id: "b1b4f19d-596d-4785-9d6c-51c2d031d935",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ffdf9776-3a56-4b4c-9ba1-bc0c2dfd01a9",
      target: "a7607f8c-afbf-4fe8-852f-eddfb333fda5"
    },
    {
      id: "ec8b02de-40fb-4e85-b51b-837a7d29ee37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a7607f8c-afbf-4fe8-852f-eddfb333fda5",
      target: "7c383a6f-d997-4822-8e5d-60fe7f1ffca1"
    },
    {
      id: "5af9c9b2-d027-4463-93bb-1a2ba924a237",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c383a6f-d997-4822-8e5d-60fe7f1ffca1",
      target: "5a613ad5-0b86-4630-a161-3b57398dfb55"
    },
    {
      id: "0003be83-55a8-4fc9-90ab-031623befab9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c383a6f-d997-4822-8e5d-60fe7f1ffca1",
      target: "cf9227b7-4c03-4a45-a94f-4b075f8246cd"
    },
    {
      id: "c184eb2d-920d-4977-bf39-2ac4714c40ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a613ad5-0b86-4630-a161-3b57398dfb55",
      target: "f1f58f12-9c41-49d6-9222-aa02d7a11667"
    },
    {
      id: "1460be1e-6652-499d-bc25-c5315c43ca46",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cf9227b7-4c03-4a45-a94f-4b075f8246cd",
      target: "7061328a-235e-4531-b0cd-54cc3d67e8b6"
    },
    {
      id: "dede0beb-e496-474b-83b1-ad5a1c67f75f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1f58f12-9c41-49d6-9222-aa02d7a11667",
      target: "7061328a-235e-4531-b0cd-54cc3d67e8b6"
    },
    {
      id: "dc119339-d08a-49fc-b27f-7d9a5425495e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7061328a-235e-4531-b0cd-54cc3d67e8b6",
      target: "2afb7d0f-1e67-4513-8a45-1eac89fe7f03"
    },
    {
      id: "71092c9c-638a-45b0-8f1a-42bbb220402b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2afb7d0f-1e67-4513-8a45-1eac89fe7f03",
      target: "7f9a52ce-9a4c-4dba-b918-4310c51d5848"
    },
    {
      id: "309e1110-5ba2-4a85-8795-d6692624c5ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7f9a52ce-9a4c-4dba-b918-4310c51d5848",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "50dd5139-3353-464a-906d-b2a07c074f8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8bc22fdb-792a-44dd-8cb1-f81136adcddf",
      target: "d7e326ee-8e9b-4892-b354-aabf20099af6"
    },
    {
      id: "49f45085-466e-4ff3-896d-9f85a9c5a6b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7e326ee-8e9b-4892-b354-aabf20099af6",
      target: "407c4104-58c9-4abc-ba55-72d26fcb7aba"
    },
    {
      id: "cc06756e-0b5c-4f45-b1c7-3b37dd7908c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "407c4104-58c9-4abc-ba55-72d26fcb7aba",
      target: "27e5365d-cfcc-4ec3-a644-9d8ca0eea1e7"
    },
    {
      id: "42ac44fc-80c3-4872-9b2e-7363339f2df6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27e5365d-cfcc-4ec3-a644-9d8ca0eea1e7",
      target: "e7cd3b17-9525-472a-9f9b-573d1515725a"
    },
    {
      id: "544117a9-c70e-42ba-9c2c-625cad7c1f91",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27e5365d-cfcc-4ec3-a644-9d8ca0eea1e7",
      target: "98a55e82-65bf-4b88-a3bb-b32c5ff3a1e0"
    },
    {
      id: "1f7df2fe-93c7-40ec-b549-e8c1b9f581fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "98a55e82-65bf-4b88-a3bb-b32c5ff3a1e0",
      target: "7ae66464-179d-4eda-a881-6d3b26d9f395"
    },
    {
      id: "e19bcddf-ea75-4470-a7d5-e4002e6125b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7cd3b17-9525-472a-9f9b-573d1515725a",
      target: "e0aca220-f8f7-43b5-bd2f-8ad1d45275d3"
    },
    {
      id: "c1e0b966-3023-4f46-80af-3d264fdcb2d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ae66464-179d-4eda-a881-6d3b26d9f395",
      target: "e0aca220-f8f7-43b5-bd2f-8ad1d45275d3"
    },
    {
      id: "be9655f2-ce37-4164-905e-ef29c300a828",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0aca220-f8f7-43b5-bd2f-8ad1d45275d3",
      target: "b04611ed-47c0-4d18-b647-7a707ee436bb"
    },
    {
      id: "d5581609-f1cd-4547-a4eb-0a9d3a0a2cdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b04611ed-47c0-4d18-b647-7a707ee436bb",
      target: "6f634469-8cf0-444f-9055-8ee00bcaa112"
    },
    {
      id: "049cdd7c-ee5c-452c-9b74-85b0f2746bef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f634469-8cf0-444f-9055-8ee00bcaa112",
      target: "378bdc1e-ffa7-46b5-92e9-ab7b3b29bd23"
    },
    {
      id: "e84b73a8-b5e8-43e1-bd0e-2bd972996453",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "19fe44fb-a1b8-4acd-a5bb-caedd4b8a79b"
    },
    {
      id: "260edf3b-522a-4478-bf04-3226cc9132aa",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf"
    },
    {
      id: "2d8f7114-f1ff-4099-a1bd-7feed3f2ed54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "72e94fbf-c40f-4ce4-aeed-5ce24d9af1bb"
    },
    {
      id: "61854183-1f7f-40b8-b3f5-1cb41603d04e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "19fe44fb-a1b8-4acd-a5bb-caedd4b8a79b"
    },
    {
      id: "0afd2257-c98a-48a6-9efa-d6947c4f1c92",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "4bd7ed7d-ef6d-4239-beb1-62e0d0e3fd80"
    },
    {
      id: "94e57885-ae5b-422c-a956-d2a20fc018dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ab0a760-a3f9-4f53-952d-979f81188747",
      target: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e"
    },
    {
      id: "5519ec7c-8903-4648-a901-d768837f2270",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19fe44fb-a1b8-4acd-a5bb-caedd4b8a79b",
      target: "0f78e4b4-76e4-4499-96b9-9b8f62208a47"
    },
    {
      id: "54a35b00-339d-4999-8587-a1336502003e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "19fe44fb-a1b8-4acd-a5bb-caedd4b8a79b",
      target: "87e40065-edac-422c-9029-9d578d47e7ef"
    },
    {
      id: "bfa6c099-18c1-4a52-9f48-72aa7a47efc3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "72e94fbf-c40f-4ce4-aeed-5ce24d9af1bb",
      target: "793df7df-1822-43b3-869a-eb19322f41ff"
    },
    {
      id: "87a62922-710a-4c19-9a0b-d3e87633cc87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4bd7ed7d-ef6d-4239-beb1-62e0d0e3fd80",
      target: "87e40065-edac-422c-9029-9d578d47e7ef"
    },
    {
      id: "8a67f2c2-8a71-4aeb-902c-a4b27ee27ee9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f78e4b4-76e4-4499-96b9-9b8f62208a47",
      target: "793df7df-1822-43b3-869a-eb19322f41ff"
    },
    {
      id: "f1c310a1-9b57-4267-a877-dce34bfaf369",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87e40065-edac-422c-9029-9d578d47e7ef",
      target: "ebad7460-caeb-4971-b637-b9040af3ff5c"
    },
    {
      id: "4b057940-005f-4fa1-9d5b-be4f04666337",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebad7460-caeb-4971-b637-b9040af3ff5c",
      target: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0"
    },
    {
      id: "7da03f0f-0d4d-4f0c-852b-4e2d5eecba7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebad7460-caeb-4971-b637-b9040af3ff5c",
      target: "793df7df-1822-43b3-869a-eb19322f41ff"
    },
    {
      id: "aaf58374-583f-4963-a0f9-b9f6667b6c48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "793df7df-1822-43b3-869a-eb19322f41ff",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "a4f7cbc0-c8ab-4da6-8ad6-1507c3bbeb7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "793df7df-1822-43b3-869a-eb19322f41ff",
      target: "13ea5675-19f8-49a3-9fb7-17b110890694"
    },
    {
      id: "9a900300-47e4-4b1a-adee-79360b01a40f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "13ea5675-19f8-49a3-9fb7-17b110890694",
      target: "3f17bfa7-37ba-4dc3-aa24-a7910ffb1bf1"
    },
    {
      id: "a15bc5fa-2392-403e-88b2-eca3b1b8c210",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "13ea5675-19f8-49a3-9fb7-17b110890694",
      target: "f8a5c63a-a641-45a1-80a4-ff46fa878512"
    },
    {
      id: "e5ca0d52-7f4d-4332-8263-06459b6e9486",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "13ea5675-19f8-49a3-9fb7-17b110890694",
      target: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0"
    },
    {
      id: "3ede1497-ff9f-4f6b-a092-8be7959cf42f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3f17bfa7-37ba-4dc3-aa24-a7910ffb1bf1",
      target: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0"
    },
    {
      id: "ceddc915-7cf0-4b42-8c1e-39cae2d29581",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0",
      target: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9"
    },
    {
      id: "4fe89ea5-46c2-469b-8d47-fc9da2578b5a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5d2094bf-ce7e-49ba-a2e7-48b5187db8f0",
      target: "5d53e708-d117-4cf3-8998-040429394f2a"
    },
    {
      id: "8f4635ec-af3f-4db2-8a93-a140057d9974",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5d53e708-d117-4cf3-8998-040429394f2a",
      target: "c4bd9212-6008-43f2-848f-e4175161de6b"
    },
    {
      id: "7ac360dd-7a6e-41f7-8859-d4929d548cc0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c4bd9212-6008-43f2-848f-e4175161de6b",
      target: "ab40e558-979d-49bb-ac76-0d395322e733"
    },
    {
      id: "55d02978-535e-4ffe-8cae-2bde5a692738",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ab40e558-979d-49bb-ac76-0d395322e733",
      target: "11af5222-36a9-44e5-be26-07ec3d02d40a"
    },
    {
      id: "3249740c-8880-444b-adda-4285fa4a820f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ab40e558-979d-49bb-ac76-0d395322e733",
      target: "27e0b6b6-6cfa-42e5-baef-e08293ffa233"
    },
    {
      id: "07cae63b-938e-4d48-bfcc-0588fdd0b011",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "11af5222-36a9-44e5-be26-07ec3d02d40a",
      target: "f07e08a6-ffeb-499f-ae9a-822b799d247c"
    },
    {
      id: "8c7d1275-d6f1-4961-a971-fb50bb181116",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f07e08a6-ffeb-499f-ae9a-822b799d247c",
      target: "ae895390-9721-49b3-a0dc-a8fb8392ec80"
    },
    {
      id: "09eeb8c3-6280-483d-94d7-c8332d5951ff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ae895390-9721-49b3-a0dc-a8fb8392ec80",
      target: "f8a5c63a-a641-45a1-80a4-ff46fa878512"
    },
    {
      id: "be5b1263-c48f-4e6f-bf6b-4c0a00b84fd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ae895390-9721-49b3-a0dc-a8fb8392ec80",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "8b67983d-b23b-4093-84cd-f3759d8e0fe6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f8a5c63a-a641-45a1-80a4-ff46fa878512",
      target: "0999498e-5331-457d-ad44-a789bbca4339"
    },
    {
      id: "00a12e59-00de-4aaf-925e-98ae139fb2ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27e0b6b6-6cfa-42e5-baef-e08293ffa233",
      target: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b"
    },
    {
      id: "75089d33-77a5-4966-bba0-cc39981c423b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0999498e-5331-457d-ad44-a789bbca4339",
      target: "bcf1cb30-ac46-4353-be20-536b09b7e94a"
    },
    {
      id: "e9e877e7-f490-40a1-a65c-0b9cd2bd26a6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bcf1cb30-ac46-4353-be20-536b09b7e94a",
      target: "6094bc01-b3a8-4162-8143-7fb7f7001adc"
    },
    {
      id: "120bda38-cf7b-4cd9-9f7f-9ada4e4cf21c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6094bc01-b3a8-4162-8143-7fb7f7001adc",
      target: "dbfeceab-f990-4193-8efd-0ef0cda93a8a"
    },
    {
      id: "41226580-7796-45d5-9958-f24fd8f358ce",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6094bc01-b3a8-4162-8143-7fb7f7001adc",
      target: "2ec3c8eb-cae4-4df2-9b54-b45fd03ce5a2"
    },
    {
      id: "1ffea12d-69bf-461e-a80b-12b7352264a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6094bc01-b3a8-4162-8143-7fb7f7001adc",
      target: "2ed99712-5bfd-474f-8a23-ffbecb59328c"
    },
    {
      id: "afe35e12-d197-42cb-8c9a-928cddda07f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dbfeceab-f990-4193-8efd-0ef0cda93a8a",
      target: "81ef8cbb-9c53-4d9b-a99d-84219f2cf80e"
    },
    {
      id: "33898d6c-1013-421a-9770-022d0efa39a2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dbfeceab-f990-4193-8efd-0ef0cda93a8a",
      target: "600eb0c0-be10-42dc-868c-fff6b4c2497f"
    },
    {
      id: "2a522cb3-b87c-4ff8-aedb-8f496f6c1aec",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2ec3c8eb-cae4-4df2-9b54-b45fd03ce5a2",
      target: "1c91e947-3011-427b-a657-a2d71bd06bf1"
    },
    {
      id: "4abd4e9c-a01c-4ca4-ac59-073b66596d2b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2ec3c8eb-cae4-4df2-9b54-b45fd03ce5a2",
      target: "a77ef004-74a9-4cbe-a83a-896e2f07d751"
    },
    {
      id: "49484ddd-7e39-4b59-b90f-e3cb174ef598",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2ed99712-5bfd-474f-8a23-ffbecb59328c",
      target: "7d22006d-9ae6-4099-bf6f-653b392a7059"
    },
    {
      id: "976aa0b6-cff0-404e-84b9-af5d318b042d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2ed99712-5bfd-474f-8a23-ffbecb59328c",
      target: "600eb0c0-be10-42dc-868c-fff6b4c2497f"
    },
    {
      id: "40ca8e91-1e65-484a-af47-5bab00303681",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7d22006d-9ae6-4099-bf6f-653b392a7059",
      target: "ef4dd395-ab3b-4897-962a-8738f00ccb65"
    },
    {
      id: "9036c1bd-4dd4-40ab-9fa4-8c6b39dd1d6f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a77ef004-74a9-4cbe-a83a-896e2f07d751",
      target: "9649d7f7-b59f-4800-b945-443ed4c486a6"
    },
    {
      id: "527744a6-5ed6-4260-9925-c23e3e873130",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "600eb0c0-be10-42dc-868c-fff6b4c2497f",
      target: "30b30b3b-8ddd-48ec-a902-eb6df39052af"
    },
    {
      id: "fd8312a0-dc46-4510-a39b-72e4e2173287",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c91e947-3011-427b-a657-a2d71bd06bf1",
      target: "9649d7f7-b59f-4800-b945-443ed4c486a6"
    },
    {
      id: "fbc9bdb6-8224-488e-a7f7-6c4c9cbe0646",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9649d7f7-b59f-4800-b945-443ed4c486a6",
      target: "165e2c1a-fc51-495d-818e-a376cd54b355"
    },
    {
      id: "0db6e6c7-cc9e-428e-8ec4-910a8bc27c80",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9649d7f7-b59f-4800-b945-443ed4c486a6",
      target: "30b30b3b-8ddd-48ec-a902-eb6df39052af"
    },
    {
      id: "af786c4c-75cb-4446-8222-fa0c13c87311",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "30b30b3b-8ddd-48ec-a902-eb6df39052af",
      target: "ef4dd395-ab3b-4897-962a-8738f00ccb65"
    },
    {
      id: "46618f60-6c31-4717-a5b9-875a3fc8afa7",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "165e2c1a-fc51-495d-818e-a376cd54b355",
      target: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b"
    },
    {
      id: "fff75670-5b04-4778-8bad-5632ded2808b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "81ef8cbb-9c53-4d9b-a99d-84219f2cf80e",
      target: "600eb0c0-be10-42dc-868c-fff6b4c2497f"
    },
    {
      id: "c4ea2e8c-c110-4a45-9e68-4dd83dba22d0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ef4dd395-ab3b-4897-962a-8738f00ccb65",
      target: "66f9bb26-894e-45a5-aff0-4d0a73e0bb84"
    },
    {
      id: "cf6dad4d-185c-4f73-9bde-9ed3fa3882ab",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ef4dd395-ab3b-4897-962a-8738f00ccb65",
      target: "40535452-533a-4cc6-b446-2c85cc034c55"
    },
    {
      id: "5916cd62-b3f4-46b4-a668-383f7967eab9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ef4dd395-ab3b-4897-962a-8738f00ccb65",
      target: "3e6924ef-4acc-45a0-8bb1-fd95a13e6e9e"
    },
    {
      id: "f576f736-aac6-46dd-8a2f-e10dc5f85c27",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ef4dd395-ab3b-4897-962a-8738f00ccb65",
      target: "bd1ef6c2-eb94-4237-be7e-008089d82669"
    },
    {
      id: "ac8851f0-b762-4caf-973f-ea4382c463e8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "66f9bb26-894e-45a5-aff0-4d0a73e0bb84",
      target: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b"
    },
    {
      id: "e20cf1fb-9233-4655-b3ae-27f75bb37ab5",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "40535452-533a-4cc6-b446-2c85cc034c55",
      target: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b"
    },
    {
      id: "3df313af-3c96-491c-9751-d627f0009497",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bd1ef6c2-eb94-4237-be7e-008089d82669",
      target: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b"
    },
    {
      id: "074655cc-45c0-4b56-9af1-495fd3e6f51f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3e6924ef-4acc-45a0-8bb1-fd95a13e6e9e",
      target: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b"
    },
    {
      id: "922654fe-d31f-4cf0-ab2a-0c4c9444c4dd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9abc2632-ed36-49d9-8958-8b9eaeda9c1b",
      target: "da003499-08ce-4ed3-af01-8e22dae83772"
    },
    {
      id: "9b3bcbb5-92df-4d1b-a4c5-f4aa63403cff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da003499-08ce-4ed3-af01-8e22dae83772",
      target: "4d8012f8-784e-4a61-b265-aeddc9169a8f"
    },
    {
      id: "8de58997-3e81-44eb-b302-a2eec3ed87f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4d8012f8-784e-4a61-b265-aeddc9169a8f",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "1ea7f11a-f4f4-499b-af0b-2e770be9aec0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4d8012f8-784e-4a61-b265-aeddc9169a8f",
      target: "4c58fab9-a2ff-4a2e-baf5-90e36cba5085"
    },
    {
      id: "d5ea377c-b25a-46e8-b7c0-a6c0f7700e03",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4c58fab9-a2ff-4a2e-baf5-90e36cba5085",
      target: "e5020467-4af6-4092-820c-446974548234"
    },
    {
      id: "115babac-a01a-4b43-9c40-d47c3c7b5058",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5020467-4af6-4092-820c-446974548234",
      target: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b"
    },
    {
      id: "32fbf03d-5a81-4111-a125-e2a8739e6111",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b",
      target: "a8cb18bb-f8c6-43c0-abd5-e4f3202dc7ea"
    },
    {
      id: "835a4de2-5ca3-4bf7-af6a-cbddf0935242",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "d215ff2f-8100-4afa-b9d6-28523e890266",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a8cb18bb-f8c6-43c0-abd5-e4f3202dc7ea",
      target: "081cf95d-1a9b-4486-a2d5-a24d02b883b3"
    },
    {
      id: "2183618d-1db2-41e4-8093-390ccd288d12",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "081cf95d-1a9b-4486-a2d5-a24d02b883b3",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "5ec2f212-6d17-48de-a23b-c9a8369980fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "081cf95d-1a9b-4486-a2d5-a24d02b883b3",
      target: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b"
    },
    {
      id: "876061fe-12e2-4fe8-b3b2-706aefee0fdd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "5d0e7750-f0eb-405c-9b6a-3f3ae0f65b47"
    },
    {
      id: "8fa506ea-217d-4b6c-aa81-9b4753a03a2d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "cc19acbe-a89b-4ff4-bc45-da41efc17936"
    },
    {
      id: "4aafeb92-c8a5-4f94-bcb7-a37e59087fd6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "70d859ab-820c-4b3a-89f9-73567442d08b"
    },
    {
      id: "c6b98198-7734-4971-9911-f75ad8f1a1c7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "70d859ab-820c-4b3a-89f9-73567442d08b"
    },
    {
      id: "59e927e2-5052-40bc-8c50-bbd45c9e7328",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "5d0e7750-f0eb-405c-9b6a-3f3ae0f65b47"
    },
    {
      id: "db2f4cff-713b-4d29-9103-9dcd26881ea0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2f07522e-6ae0-481c-a1c1-0b16f3b582cf",
      target: "cc19acbe-a89b-4ff4-bc45-da41efc17936"
    },
    {
      id: "1bfbe306-b8d7-40c8-818b-f69ba2c396b4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "70d859ab-820c-4b3a-89f9-73567442d08b",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "bd87b502-bd8f-4957-a46a-a7a0c752184a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "70d859ab-820c-4b3a-89f9-73567442d08b",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "fc6bb355-b8fd-45af-9fcc-5b20fab753ab",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "eccf8c7d-f695-48cd-8781-1f4dfa09af12",
      target: "2c166bbf-dfb5-4967-89e2-1b16c076b300"
    },
    {
      id: "4fec5013-7816-46b3-930d-8dc8edee0194",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "eccf8c7d-f695-48cd-8781-1f4dfa09af12",
      target: "d9158d21-9e6a-4bbb-bcc2-91c56b3ffc6a"
    },
    {
      id: "0cb44822-ae9b-429d-8dc3-a7fc4aeeddb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eccf8c7d-f695-48cd-8781-1f4dfa09af12",
      target: "5b5c2b55-e054-4921-b7de-090dc8aad851"
    },
    {
      id: "d2f92de3-e3c5-411f-90b5-f4cb0a519705",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "eccf8c7d-f695-48cd-8781-1f4dfa09af12",
      target: "b72cea7b-83d1-4abf-81e1-76685eb79b35"
    },
    {
      id: "7bb873a3-09d4-465b-90cd-f78a8f02d53d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "cc19acbe-a89b-4ff4-bc45-da41efc17936",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "9a1d0b2a-c9f0-483b-a141-94c483584fa8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cc19acbe-a89b-4ff4-bc45-da41efc17936",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "2f62c611-75e2-4713-a3b8-c91d20774ffe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5d0e7750-f0eb-405c-9b6a-3f3ae0f65b47",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "4b22a84c-2a3f-4765-ae1f-3de61a35c45f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5d0e7750-f0eb-405c-9b6a-3f3ae0f65b47",
      target: "eccf8c7d-f695-48cd-8781-1f4dfa09af12"
    },
    {
      id: "ba7d4678-4748-456d-a555-7afc85777734",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b72cea7b-83d1-4abf-81e1-76685eb79b35",
      target: "5b5c2b55-e054-4921-b7de-090dc8aad851"
    },
    {
      id: "5ae001bd-5984-40da-ad49-7ea36eea7577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c166bbf-dfb5-4967-89e2-1b16c076b300",
      target: "5b5c2b55-e054-4921-b7de-090dc8aad851"
    },
    {
      id: "dd782d9e-1fe6-4f36-bf31-3212df64db1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9158d21-9e6a-4bbb-bcc2-91c56b3ffc6a",
      target: "5b5c2b55-e054-4921-b7de-090dc8aad851"
    },
    {
      id: "cee83700-5da6-4de2-a254-4b7951eb10f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b5c2b55-e054-4921-b7de-090dc8aad851",
      target: "89edab3b-a5e8-421a-aa96-5171a069eaee"
    },
    {
      id: "cc60a3cd-8692-4a12-82b4-d1846e4ac9b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "89edab3b-a5e8-421a-aa96-5171a069eaee",
      target: "3827116c-d2ce-4b4d-9d95-d9babf2ef69a"
    },
    {
      id: "ca8ef291-fc90-4221-b5c0-db3015c128c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3827116c-d2ce-4b4d-9d95-d9babf2ef69a",
      target: "a80dddbe-a709-4f29-ac5d-d3cbe5d97f2e"
    },
    {
      id: "29aca883-a6a0-4e27-a65e-2d30b9cbe16d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a80dddbe-a709-4f29-ac5d-d3cbe5d97f2e",
      target: "799927a3-4e60-4c91-b624-8e9b57176a79"
    },
    {
      id: "74b8b3e7-eca8-454b-88cf-fce4500aa3a9",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b00bb5cb-a037-487d-a554-e78fde91b896",
      target: "24754848-1156-4161-a0b7-6c6b2331b915"
    },
    {
      id: "8ef1983a-dde9-452c-abb2-62e917670808",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "799927a3-4e60-4c91-b624-8e9b57176a79",
      target: "b00bb5cb-a037-487d-a554-e78fde91b896"
    },
    {
      id: "e48692d0-fc2d-432b-8bcd-46181ce2ce65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "799927a3-4e60-4c91-b624-8e9b57176a79",
      target: "8a594828-e48a-40c0-95f9-dd97a6adc7fd"
    },
    {
      id: "3eac8cd9-26a1-49fa-82e9-6d768a2e2578",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "799927a3-4e60-4c91-b624-8e9b57176a79",
      target: "24754848-1156-4161-a0b7-6c6b2331b915"
    },
    {
      id: "12d9652c-f2f0-499a-a582-85371f9dc081",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "799927a3-4e60-4c91-b624-8e9b57176a79",
      target: "75d436dd-74fe-4150-bb06-5bde0dff116c"
    },
    {
      id: "22daee26-234d-446e-82f7-41391c7f0501",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8a594828-e48a-40c0-95f9-dd97a6adc7fd",
      target: "24754848-1156-4161-a0b7-6c6b2331b915"
    },
    {
      id: "dc9e512e-7e83-4000-b303-cdbd81ed0393",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "24754848-1156-4161-a0b7-6c6b2331b915",
      target: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7"
    },
    {
      id: "d06fe589-c175-44ba-a62b-d39f8f0531f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7",
      target: "a66f914c-9f61-4dd6-8a01-abc3ad94d3c7"
    },
    {
      id: "1909220b-a3ce-4d48-a3dd-491adb6223d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7",
      target: "33af645e-c859-43d2-99ff-4bef45a62368"
    },
    {
      id: "489675ac-563b-40d3-a52d-972e528c0a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7",
      target: "a791ae22-853b-4fa7-a2ee-cd8b54a001da"
    },
    {
      id: "6a84785e-96f6-47fb-b48f-8c5a6b13dd0a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf61aa4-bee5-4dd8-a89d-324001a69fc7",
      target: "35e2108f-8537-4bb3-af72-7147126da563"
    },
    {
      id: "6e14fd08-aba0-445e-b18b-edc126744d87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a66f914c-9f61-4dd6-8a01-abc3ad94d3c7",
      target: "9c7b9c45-e1f7-48cb-9367-6b9667c318a9"
    },
    {
      id: "cd0044dc-1189-4e30-96f3-ffce8dfb350c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a66f914c-9f61-4dd6-8a01-abc3ad94d3c7",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "15f92f6b-264b-494b-b56e-e89476192720",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a791ae22-853b-4fa7-a2ee-cd8b54a001da",
      target: "9c7b9c45-e1f7-48cb-9367-6b9667c318a9"
    },
    {
      id: "634d7daa-d0a8-4554-b2ce-7b64e79f54b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33af645e-c859-43d2-99ff-4bef45a62368",
      target: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b"
    },
    {
      id: "f0af7643-b1c6-4a40-8932-1919df40a23d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c7b9c45-e1f7-48cb-9367-6b9667c318a9",
      target: "55eed6f0-7247-4461-8cfd-1f3fd9df3d4c"
    },
    {
      id: "cfa12d3e-8eb1-48f6-a759-417b323247a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55eed6f0-7247-4461-8cfd-1f3fd9df3d4c",
      target: "f8812fdc-6bb2-4375-8c46-7fe716f71918"
    },
    {
      id: "506072b0-4ebf-49a1-908e-bfcafead1aeb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8812fdc-6bb2-4375-8c46-7fe716f71918",
      target: "57a6f7e8-6204-4d01-9e08-1a7bc0b24e0b"
    },
    {
      id: "53a423ad-ff6c-4617-9be9-64e98da96796",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9",
      target: "417cebdf-db83-426a-a837-c66a1ce529a1"
    },
    {
      id: "bd50cd63-fc0a-4873-bba0-f2d9f035c4bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8e2ec15b-3b84-41b7-8e70-f8678e4eafd9",
      target: "c7cc0d73-9cfd-4561-813e-c597573cb5d7"
    },
    {
      id: "62e38c3f-5447-4cb8-8150-3b250255211f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "417cebdf-db83-426a-a837-c66a1ce529a1",
      target: "ca7dcf5a-c382-434e-be4c-62f7790b15e8"
    },
    {
      id: "63b9544b-a893-45f6-acad-07b2fe5da1b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "417cebdf-db83-426a-a837-c66a1ce529a1",
      target: "37a12727-fc32-4909-bd72-674264e22d8e"
    },
    {
      id: "c3db6a01-e752-4376-875d-98d5f13ea21e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ca7dcf5a-c382-434e-be4c-62f7790b15e8",
      target: "f35c623f-a74d-4e3e-ae38-c74d5b4f66aa"
    },
    {
      id: "1ce3f289-3f57-42fd-aa6b-b1b0aed7fdac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca7dcf5a-c382-434e-be4c-62f7790b15e8",
      target: "0ee4e98b-820a-4428-9a8e-701184cde28c"
    },
    {
      id: "ee35fbe4-6628-49dd-972b-1a71b249902e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f35c623f-a74d-4e3e-ae38-c74d5b4f66aa",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "09a80e5d-ca2d-4809-89c9-9be557da6e8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f35c623f-a74d-4e3e-ae38-c74d5b4f66aa",
      target: "5ad95125-4ed7-4ee8-ad00-2a35b61df06c"
    },
    {
      id: "419fab96-baa5-4295-abb6-d70ac72a27cc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c7cc0d73-9cfd-4561-813e-c597573cb5d7",
      target: "37a12727-fc32-4909-bd72-674264e22d8e"
    },
    {
      id: "53a63bb9-e78b-4be1-ad86-d82f626476ae",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "37a12727-fc32-4909-bd72-674264e22d8e",
      target: "0ee4e98b-820a-4428-9a8e-701184cde28c"
    },
    {
      id: "f4e18cf6-7476-49d4-9c81-b7549bb9df99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37a12727-fc32-4909-bd72-674264e22d8e",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "e346fea0-758b-4b98-a44c-d25339cc9c3f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0ee4e98b-820a-4428-9a8e-701184cde28c",
      target: "5ad95125-4ed7-4ee8-ad00-2a35b61df06c"
    },
    {
      id: "51fac4cd-5902-49a0-b68e-be2156d30716",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ee4e98b-820a-4428-9a8e-701184cde28c",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "9b9713af-f5b1-406c-9db2-c5e97a5be7a4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5ad95125-4ed7-4ee8-ad00-2a35b61df06c",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "41f8d96a-57aa-411c-9a4e-357204d1b5f2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d5f395af-487c-4217-9d5f-219617efce48",
      target: "c579c42d-8117-4e95-992b-8033ccbb27ac"
    },
    {
      id: "9c7da8fb-80f2-490d-947b-47e21f8afe41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "6c0b3c4f-4c99-408f-a55d-1a154c725591"
    },
    {
      id: "ed5f986a-75c7-4203-a499-e42dad743ec8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2"
    },
    {
      id: "0c4e957a-30c7-4b93-902c-4eb5e6dbebe5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "acea461b-0492-401c-8342-d9709ca15201"
    },
    {
      id: "7f769068-8930-426c-9cd1-484849feff89",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "aca5987f-8831-4d4e-b5b7-29a94dc6bb73"
    },
    {
      id: "a55a7ef6-8ecb-4518-8e81-5b049861f660",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2"
    },
    {
      id: "dd9dd207-9220-49c3-8e61-b48efa5bd190",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "c6f567a1-7265-49cc-ab1b-192c7d15c776"
    },
    {
      id: "cca0e0b2-9f39-4f2e-a2e8-75898109e7cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c579c42d-8117-4e95-992b-8033ccbb27ac",
      target: "7ab234d8-d8d1-4e94-ac48-9917f3b7bc51"
    },
    {
      id: "dc39a25d-6f45-42a6-bfa7-5ea826115a17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aca5987f-8831-4d4e-b5b7-29a94dc6bb73",
      target: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9"
    },
    {
      id: "bc1847f8-9ba9-4fe1-96d3-d55c9d8d6b23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6c0b3c4f-4c99-408f-a55d-1a154c725591",
      target: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9"
    },
    {
      id: "6645a0eb-d0ee-4fd3-8f14-8e2086aad291",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "acea461b-0492-401c-8342-d9709ca15201",
      target: "b33a3880-3a89-4b11-a0c8-595baef8251d"
    },
    {
      id: "f297bde4-c8e6-4b97-b588-699a9c2b1ced",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c6f567a1-7265-49cc-ab1b-192c7d15c776",
      target: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9"
    },
    {
      id: "3a3752f9-93a3-4b6b-8b7f-f24828aa1858",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ab234d8-d8d1-4e94-ac48-9917f3b7bc51",
      target: "e06668a3-b613-4982-a7bf-8415dba63891"
    },
    {
      id: "1bf250bf-0341-42ec-a401-b5afcda4020c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ab234d8-d8d1-4e94-ac48-9917f3b7bc51",
      target: "3de03668-1ef1-48cb-b798-b17a3933219a"
    },
    {
      id: "ec872ab3-eea1-484f-a280-646445db73f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9",
      target: "55a7801c-a46b-4031-b203-4429c2a14fff"
    },
    {
      id: "4465a454-e5a9-4ff9-bc26-a57f4c949947",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "97276b19-8d7c-4dc2-89a6-dd8858f7dbd9",
      target: "6471d422-b6c6-4f70-b523-b50fee871ede"
    },
    {
      id: "351da157-245b-474b-a7b6-f5be77dd9c7c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e06668a3-b613-4982-a7bf-8415dba63891",
      target: "b33a3880-3a89-4b11-a0c8-595baef8251d"
    },
    {
      id: "10b4cefb-ff6d-4ca5-9510-98a7017b903f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b33a3880-3a89-4b11-a0c8-595baef8251d",
      target: "ff9c50c7-6273-48ce-82d9-04a35f1eba15"
    },
    {
      id: "7e76e99c-23db-4b86-8980-e0288491b2f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ff9c50c7-6273-48ce-82d9-04a35f1eba15",
      target: "8178d928-7a8a-4139-a44b-c580ede45952"
    },
    {
      id: "c375c05c-dee4-4af4-9897-1783a7c7f1fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8178d928-7a8a-4139-a44b-c580ede45952",
      target: "0a6b1d56-7242-4666-9d25-f6d170e3a30c"
    },
    {
      id: "ad984399-1b59-4d06-8d66-3496d515f035",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8178d928-7a8a-4139-a44b-c580ede45952",
      target: "16e91e00-cf59-47a4-98bb-1c0986a5d9b3"
    },
    {
      id: "d53fdc68-a92b-41f2-96fc-68fe8b02f420",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a6b1d56-7242-4666-9d25-f6d170e3a30c",
      target: "c10179e0-c836-46db-b29d-7305c9e494c8"
    },
    {
      id: "769d62ff-aeb1-4878-a5b2-51cef76f19db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16e91e00-cf59-47a4-98bb-1c0986a5d9b3",
      target: "55a7801c-a46b-4031-b203-4429c2a14fff"
    },
    {
      id: "86a3a75e-c4f5-4014-978a-8c7c88efca83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16e91e00-cf59-47a4-98bb-1c0986a5d9b3",
      target: "6892a1d6-5f3d-47a1-8a24-d85b217130c8"
    },
    {
      id: "84b5d86a-386c-4f53-a249-5bf2cbb0245a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16e91e00-cf59-47a4-98bb-1c0986a5d9b3",
      target: "6471d422-b6c6-4f70-b523-b50fee871ede"
    },
    {
      id: "18972f4c-4912-406a-8cd1-094a1741e628",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c10179e0-c836-46db-b29d-7305c9e494c8",
      target: "fd3d8b4b-e38a-40db-a77f-069df925520f"
    },
    {
      id: "8dca8aa9-4847-4d6d-8bb7-d1551b056038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6471d422-b6c6-4f70-b523-b50fee871ede",
      target: "d0922209-7513-4b64-b7d0-b99ee12ec293"
    },
    {
      id: "a7d91dec-84d7-4c73-8e9b-bd770e3ceb13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "55a7801c-a46b-4031-b203-4429c2a14fff",
      target: "d0922209-7513-4b64-b7d0-b99ee12ec293"
    },
    {
      id: "ad72e897-2dc1-4c68-938f-300eaa7757be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6892a1d6-5f3d-47a1-8a24-d85b217130c8",
      target: "d0922209-7513-4b64-b7d0-b99ee12ec293"
    },
    {
      id: "fd72ea0f-3d7e-489c-8816-fe8cc9b821ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6892a1d6-5f3d-47a1-8a24-d85b217130c8",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "370725e6-d196-4136-9fa9-de862ae7d337",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fd3d8b4b-e38a-40db-a77f-069df925520f",
      target: "d0922209-7513-4b64-b7d0-b99ee12ec293"
    },
    {
      id: "a9d9ef6d-1233-4a12-bfe1-3d35b526b327",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0922209-7513-4b64-b7d0-b99ee12ec293",
      target: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b"
    },
    {
      id: "9b4d50ae-a19f-48fe-8fe6-d93a4722e5e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0922209-7513-4b64-b7d0-b99ee12ec293",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "8805478d-d6ac-4663-972b-b1c8ef9e92d2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d0922209-7513-4b64-b7d0-b99ee12ec293",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "4f8beb88-e4de-411a-90df-acfa9751f7b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0922209-7513-4b64-b7d0-b99ee12ec293",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "3b3fa83b-91ea-4a35-b70f-4a85feae6eaf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      target: "414c2350-bebf-40c2-b2c0-1f263a0bc8ca"
    },
    {
      id: "4be849c4-a2e8-4dc6-8dee-f80455ec36a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      target: "3de03668-1ef1-48cb-b798-b17a3933219a"
    },
    {
      id: "4b0b619a-ffef-4ffc-96f9-e80e4e687044",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      target: "09ab5321-6148-4313-a3a2-5c604a97f59a"
    },
    {
      id: "82c4c413-77ac-4e2a-b6eb-f0a574aea37d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      target: "e7e419f2-3130-403a-a3db-89348cd9f4cd"
    },
    {
      id: "b640b600-b49f-4467-b766-8cd5bca4480e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ea1c029a-9729-44ea-bf8c-e1c6dc9497d2",
      target: "99e60647-ebc4-4f10-a959-28095d9a25a7"
    },
    {
      id: "19b6aa3f-d74f-41bf-8c03-c9f64b29b8c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99e60647-ebc4-4f10-a959-28095d9a25a7",
      target: "31b5d869-779d-41ba-ac57-0632f9646f55"
    },
    {
      id: "18d17d0d-37f5-411d-b4fd-54fe0db85b90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "09ab5321-6148-4313-a3a2-5c604a97f59a",
      target: "890be0e6-7ddd-4afb-9208-5be8d777d0f6"
    },
    {
      id: "48b7333f-a525-45ba-abd8-19f36635ce93",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3de03668-1ef1-48cb-b798-b17a3933219a",
      target: "270aaa81-3717-43c5-81b9-37c53c87aaba"
    },
    {
      id: "da9ceeb7-b282-4ade-a5ff-bef26d709092",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "414c2350-bebf-40c2-b2c0-1f263a0bc8ca",
      target: "890be0e6-7ddd-4afb-9208-5be8d777d0f6"
    },
    {
      id: "c9ef6bce-2ec3-4ebe-938e-5cf1874858f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e7e419f2-3130-403a-a3db-89348cd9f4cd",
      target: "890be0e6-7ddd-4afb-9208-5be8d777d0f6"
    },
    {
      id: "779ca6f8-eadf-4ecc-8795-a97a591bb101",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "270aaa81-3717-43c5-81b9-37c53c87aaba",
      target: "31b5d869-779d-41ba-ac57-0632f9646f55"
    },
    {
      id: "c33cdce8-164c-46ae-8f7d-a128691f53a6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "890be0e6-7ddd-4afb-9208-5be8d777d0f6",
      target: "410bdc8c-729a-4ecd-99de-d83ed4b9c47f"
    },
    {
      id: "141abe39-dd1d-4f8b-9278-36d6416efa41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "890be0e6-7ddd-4afb-9208-5be8d777d0f6",
      target: "c780465c-342b-4c65-930a-5e676c2857df"
    },
    {
      id: "8f52ea1b-fc87-40ee-a996-d9a7414288e1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31b5d869-779d-41ba-ac57-0632f9646f55",
      target: "1a02e549-e5a9-47a5-aaca-4900287d18d3"
    },
    {
      id: "6f901b28-2dea-4a9b-8992-251c2e3b34d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a02e549-e5a9-47a5-aaca-4900287d18d3",
      target: "a3e968c8-943d-4297-8a1a-53f1e27e760d"
    },
    {
      id: "3e7620f7-de92-45b5-826a-fb9d3d648882",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a3e968c8-943d-4297-8a1a-53f1e27e760d",
      target: "4fd6aaac-2a27-4129-801b-7031f9987c2f"
    },
    {
      id: "105a67c2-8624-4a1f-8113-8e2b6bfedd3c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      target: "410bdc8c-729a-4ecd-99de-d83ed4b9c47f"
    },
    {
      id: "b0b839aa-ef19-473b-aece-817dfd0592fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      target: "c780465c-342b-4c65-930a-5e676c2857df"
    },
    {
      id: "9c293dae-2406-403c-afcc-0030c97b7f25",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      target: "143d583f-19d5-4146-b2ac-d9a8356ece24"
    },
    {
      id: "f63fe09c-555e-453a-b8e6-05e087cf2fe0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      target: "b8c1abae-4087-464e-b7cf-c0f7c27aaf38"
    },
    {
      id: "05688ca9-b040-4225-a628-74b289df9f94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4fd6aaac-2a27-4129-801b-7031f9987c2f",
      target: "4338b789-606e-4a01-9ac9-363419bb5417"
    },
    {
      id: "d228359f-67f0-4319-aec6-c1d2ab42696d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8c1abae-4087-464e-b7cf-c0f7c27aaf38",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "fb033563-8fa2-4827-8f14-e7fc92b7b271",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8c1abae-4087-464e-b7cf-c0f7c27aaf38",
      target: "278b2471-3528-4a87-814a-fb976208c6df"
    },
    {
      id: "c622915b-ee8b-407f-9970-0280b48cb95a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "410bdc8c-729a-4ecd-99de-d83ed4b9c47f",
      target: "278b2471-3528-4a87-814a-fb976208c6df"
    },
    {
      id: "7de159d2-8168-425a-b586-71f2bffab859",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c780465c-342b-4c65-930a-5e676c2857df",
      target: "278b2471-3528-4a87-814a-fb976208c6df"
    },
    {
      id: "2220cfff-4ff8-4130-b530-a1524229dbc2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "143d583f-19d5-4146-b2ac-d9a8356ece24",
      target: "e8d8fbc0-2457-40b0-b8a5-44cfd05180a5"
    },
    {
      id: "88b3f3ad-625e-4731-94c3-0b55aab561e5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4338b789-606e-4a01-9ac9-363419bb5417",
      target: "143d583f-19d5-4146-b2ac-d9a8356ece24"
    },
    {
      id: "ecc98c1c-8b2c-469d-8f7b-212e387f1ba6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4338b789-606e-4a01-9ac9-363419bb5417",
      target: "12a7a55e-3344-4ec1-9751-a922c8a2ba50"
    },
    {
      id: "02169068-45d5-44f2-80b3-d1beedb9294a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e8d8fbc0-2457-40b0-b8a5-44cfd05180a5",
      target: "85b7d3ea-5339-4772-8aed-799cc26f33aa"
    },
    {
      id: "aa600127-b647-4f78-91b4-8bee87e101dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12a7a55e-3344-4ec1-9751-a922c8a2ba50",
      target: "278b2471-3528-4a87-814a-fb976208c6df"
    },
    {
      id: "3f230f97-b03f-4f82-a5a9-9fde02f7bdf2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85b7d3ea-5339-4772-8aed-799cc26f33aa",
      target: "278b2471-3528-4a87-814a-fb976208c6df"
    },
    {
      id: "b170b187-7ae0-410a-8361-b7e3b4566005",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "278b2471-3528-4a87-814a-fb976208c6df",
      target: "daf3fc35-13f6-4999-9921-45e66e1700e8"
    },
    {
      id: "e95f2fdc-1efa-48ae-87d3-d0cf2f8fc71b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "278b2471-3528-4a87-814a-fb976208c6df",
      target: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b"
    },
    {
      id: "02e0afec-1ac1-41b0-8d8e-7baf05058aa4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "278b2471-3528-4a87-814a-fb976208c6df",
      target: "d0922209-7513-4b64-b7d0-b99ee12ec293"
    },
    {
      id: "f8b37094-20cf-4202-ad4f-41a4ed0e456d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "df5a88d9-1079-4b84-aa75-de910209e6fb"
    },
    {
      id: "f06c0128-d116-4c6c-b24e-7556536241cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "ca3a70ce-ebd7-4ff4-a028-60e0ee019e90"
    },
    {
      id: "3fc1e325-0d96-4b0b-84a8-887afc9076a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "51ca251c-ab79-4e40-ad49-4330d374b341"
    },
    {
      id: "a4a15fc9-6ed8-4cac-b765-c982d449dd41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "688e2ee9-2485-40df-8525-5862f3338be7"
    },
    {
      id: "e34e2d35-32c6-429a-9c0b-5a1fc59bb3ed",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "fdd08f87-943d-4f29-810a-c64b8bbc8c73"
    },
    {
      id: "9c9538a1-b640-4453-91a9-33ab93c01227",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d51bf6ae-b40e-44d0-a5fe-5d0ad0050c6e",
      target: "c579c42d-8117-4e95-992b-8033ccbb27ac"
    },
    {
      id: "b605d55d-e13f-4ef0-a626-1dee1793796e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "688e2ee9-2485-40df-8525-5862f3338be7",
      target: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a"
    },
    {
      id: "82187c39-779f-42c6-b59d-5f5dcbf1f58f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca3a70ce-ebd7-4ff4-a028-60e0ee019e90",
      target: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a"
    },
    {
      id: "d42ba017-933d-4db0-a6b0-4b37f7bef227",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51ca251c-ab79-4e40-ad49-4330d374b341",
      target: "5e68ca63-8752-43d3-9430-b8902d9a7cbb"
    },
    {
      id: "ad5b05ff-cad0-48ed-9f16-4a99f10946c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fdd08f87-943d-4f29-810a-c64b8bbc8c73",
      target: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a"
    },
    {
      id: "b33ebd34-ef47-4d87-b970-e5204071f1b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df5a88d9-1079-4b84-aa75-de910209e6fb",
      target: "3084302a-c4fb-42bb-8ade-d9205702469e"
    },
    {
      id: "93264a67-c5e5-4697-9e95-7bed63282669",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df5a88d9-1079-4b84-aa75-de910209e6fb",
      target: "7ab234d8-d8d1-4e94-ac48-9917f3b7bc51"
    },
    {
      id: "3468a104-9600-4bc3-984f-5dc20867642e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3084302a-c4fb-42bb-8ade-d9205702469e",
      target: "5e68ca63-8752-43d3-9430-b8902d9a7cbb"
    },
    {
      id: "ee36db2c-5b5b-43dd-ae5a-6d16712cdd05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a",
      target: "bd41fbbd-26fa-466d-9f39-a0af92ec00a8"
    },
    {
      id: "5824d2b0-8e70-430d-ac53-69c0ffb4d307",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c17cec3b-c4c9-40c7-a7f0-e46772b4b60a",
      target: "7ab0d032-7181-45eb-90dc-eddef0a3efa2"
    },
    {
      id: "0a7b09eb-a9af-4f4b-a7b3-b1d826131c2b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e68ca63-8752-43d3-9430-b8902d9a7cbb",
      target: "a9b7a1af-02e1-4e89-9c04-d6c45066b5e8"
    },
    {
      id: "00223a1f-725f-49f5-8b51-43621026d7b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9b7a1af-02e1-4e89-9c04-d6c45066b5e8",
      target: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e"
    },
    {
      id: "f3235763-a164-47e1-9613-2634f042b2ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "43e34f46-cb5c-482c-b889-f5b2e80cdb94"
    },
    {
      id: "7a3fdafc-7061-4a92-8f28-1092ae72cb6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "57f56bd9-6efa-4388-ac15-59b161054478"
    },
    {
      id: "640ed378-cf11-4f4d-a25e-1983236693a7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "c2ffb523-dd52-4ded-94c6-d8c4c3ac7f40"
    },
    {
      id: "f7cf1de1-2a2a-4bdf-9c31-afb96d2224c4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "bd41fbbd-26fa-466d-9f39-a0af92ec00a8"
    },
    {
      id: "82d5ac67-40de-428a-aa30-abf1084e6ae7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "7ab0d032-7181-45eb-90dc-eddef0a3efa2"
    },
    {
      id: "7ffee073-dfeb-461a-8e86-b40cca977c13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c4e4b0c-0c2b-4588-8591-b4994c3df51e",
      target: "717a8229-924b-4895-8c35-45ceaaf5396f"
    },
    {
      id: "44973863-af18-4557-90d8-c9e365d173c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43e34f46-cb5c-482c-b889-f5b2e80cdb94",
      target: "96112eca-427a-4b2a-b656-28897abb9779"
    },
    {
      id: "5a296fb8-8df1-4806-8aea-44cd9b01c115",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "717a8229-924b-4895-8c35-45ceaaf5396f",
      target: "ded7d458-6e3a-4ffd-9126-3f8a05e1bc74"
    },
    {
      id: "fa34b689-87a5-40d0-aaed-c0a5ad7a2247",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "717a8229-924b-4895-8c35-45ceaaf5396f",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "342fa0ac-e907-4422-8e5d-20c4d8c891a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96112eca-427a-4b2a-b656-28897abb9779",
      target: "18dc7d52-67db-4f7d-ab44-0580d04cd8ca"
    },
    {
      id: "d9ea8208-9f3f-45aa-99a7-726fc874d2ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7ab0d032-7181-45eb-90dc-eddef0a3efa2",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "e1215241-b31a-4853-9d40-7de1aa191a58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd41fbbd-26fa-466d-9f39-a0af92ec00a8",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "0571950f-1424-4856-87e9-1a161a81a4b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18dc7d52-67db-4f7d-ab44-0580d04cd8ca",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "0d34cdf6-887d-40cc-b2b0-5782265311ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448c6c82-74c5-49dd-b8de-5ceef5fa8940",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "e9cdcaa9-31fa-49f6-9080-bbfd4d086b17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448c6c82-74c5-49dd-b8de-5ceef5fa8940",
      target: "b1bb1c79-6a57-444a-85db-7b5629e2cd0b"
    },
    {
      id: "31c6c5f0-6e2f-4450-89f3-32bef82263af",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448c6c82-74c5-49dd-b8de-5ceef5fa8940",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "4d6a8a00-d58b-4e11-b96c-ba2c02375aea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2ffb523-dd52-4ded-94c6-d8c4c3ac7f40",
      target: "5060a97b-9582-4317-a961-fd2d58fbe78f"
    },
    {
      id: "1ff037f0-f0ff-43da-8344-11b4799f0972",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5060a97b-9582-4317-a961-fd2d58fbe78f",
      target: "5b840173-dcdf-4dc4-87cb-568de87b9576"
    },
    {
      id: "a615d8c4-46bb-4dcb-ae3b-ae5d7284842a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b840173-dcdf-4dc4-87cb-568de87b9576",
      target: "217de0c3-abbe-46ce-87d6-37a30b52d505"
    },
    {
      id: "3c0af523-b0ee-4c85-bebb-057c194c40f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "217de0c3-abbe-46ce-87d6-37a30b52d505",
      target: "e46c2b3c-5f81-464d-9e0c-91be0f87b50b"
    },
    {
      id: "8eaff5d4-c6d3-4ba8-af8c-be3c5ad47dd8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "217de0c3-abbe-46ce-87d6-37a30b52d505",
      target: "2cf00f3c-2e1b-4859-813d-9c33ecfc636e"
    },
    {
      id: "2cb8d2f8-bed0-41d5-affc-4409262f6f07",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2cf00f3c-2e1b-4859-813d-9c33ecfc636e",
      target: "550f3cdc-e2f8-46fb-a9c2-41cdd1e0e939"
    },
    {
      id: "f2156fa0-9f7b-4dc7-8ef7-aecf9b36efc1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e46c2b3c-5f81-464d-9e0c-91be0f87b50b",
      target: "9bee263f-4d07-40c5-8829-554635a69f9c"
    },
    {
      id: "606ae0c9-a206-4765-a5a7-2dd736e1c73d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "550f3cdc-e2f8-46fb-a9c2-41cdd1e0e939",
      target: "9bee263f-4d07-40c5-8829-554635a69f9c"
    },
    {
      id: "cdac439f-3fd1-4e0f-8636-cdc30e3d4674",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9bee263f-4d07-40c5-8829-554635a69f9c",
      target: "996a4ddf-b5a2-40c4-81fa-ab07714e3030"
    },
    {
      id: "a4de0546-3b62-49d3-af57-6f98c51fe6d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "996a4ddf-b5a2-40c4-81fa-ab07714e3030",
      target: "cbc278bf-e7b8-4a81-a55f-e07bc474745c"
    },
    {
      id: "29e1aedf-3f80-43b2-8da0-0e29d0763aae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cbc278bf-e7b8-4a81-a55f-e07bc474745c",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "ac3d8ec7-9079-4ae0-b1aa-a04e1eef42c2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57f56bd9-6efa-4388-ac15-59b161054478",
      target: "9c2ae6f0-7235-41f3-ae7f-54f99afa455c"
    },
    {
      id: "5418f746-6836-4f13-a1be-1ae58e103249",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c2ae6f0-7235-41f3-ae7f-54f99afa455c",
      target: "95eb0fe7-ed5b-4955-8712-6580cda3dbbc"
    },
    {
      id: "997d4795-0469-40dd-a0aa-41111b9cbd9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95eb0fe7-ed5b-4955-8712-6580cda3dbbc",
      target: "d8e9652a-71e7-4530-a5fd-e90941a312c5"
    },
    {
      id: "b8caff3c-48e4-4bc8-92d3-453d42d1095d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8e9652a-71e7-4530-a5fd-e90941a312c5",
      target: "b9c10788-605a-42ef-b511-980d064c65b9"
    },
    {
      id: "d495480c-0154-46f6-909d-aa0907ef90cf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8e9652a-71e7-4530-a5fd-e90941a312c5",
      target: "b26170cd-2d5a-4580-9a11-b2d308e596d8"
    },
    {
      id: "07c53db9-d7c1-4d76-bd37-6db1db93239f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8e9652a-71e7-4530-a5fd-e90941a312c5",
      target: "217de0c3-abbe-46ce-87d6-37a30b52d505"
    },
    {
      id: "721adf68-331d-4bfd-8453-723027fce032",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9c10788-605a-42ef-b511-980d064c65b9",
      target: "23e5880b-5068-4d04-a976-1f3e3bd3c149"
    },
    {
      id: "ee6e4a1e-d5de-4a5f-b0ac-e27b8d7c05e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b26170cd-2d5a-4580-9a11-b2d308e596d8",
      target: "c3dcad83-26ea-4f1f-897f-320c0768f4c2"
    },
    {
      id: "2ae29e32-4df5-44c1-95d9-b6fbc8529f3e",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b26170cd-2d5a-4580-9a11-b2d308e596d8",
      target: "e46c2b3c-5f81-464d-9e0c-91be0f87b50b"
    },
    {
      id: "e412fd94-c77b-4063-afca-eea3c758beea",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b26170cd-2d5a-4580-9a11-b2d308e596d8",
      target: "e46c2b3c-5f81-464d-9e0c-91be0f87b50b"
    },
    {
      id: "941d4b1e-48c0-42a3-ad59-236dc9aa3e5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23e5880b-5068-4d04-a976-1f3e3bd3c149",
      target: "c3dcad83-26ea-4f1f-897f-320c0768f4c2"
    },
    {
      id: "6c672cfb-7f10-4b21-886c-a0e8cb9377ae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3dcad83-26ea-4f1f-897f-320c0768f4c2",
      target: "10863bda-8e83-4746-b50e-13c00d34b238"
    },
    {
      id: "b73853c9-6fc7-46ab-b7bb-92f21a33fd38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10863bda-8e83-4746-b50e-13c00d34b238",
      target: "d8755f57-1ef0-4f93-8ae4-e717b9f2d8c3"
    },
    {
      id: "657a159b-36d5-40a7-b2ee-89d0c6e507bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8755f57-1ef0-4f93-8ae4-e717b9f2d8c3",
      target: "448c6c82-74c5-49dd-b8de-5ceef5fa8940"
    },
    {
      id: "7d6a5c47-e1a4-4ecd-8b3a-069fc64e7a3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb73a1f9-fda5-4fef-8296-6f8eeb63c600",
      target: "e5862044-0aeb-40d6-b111-9bb0dad28651"
    },
    {
      id: "f4925d31-b2c3-4473-9906-c760ce0c3550",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb73a1f9-fda5-4fef-8296-6f8eeb63c600",
      target: "34cb53d4-3578-4690-9e18-bed8bf706fe5"
    },
    {
      id: "93ecfab4-1b5a-4690-bb9d-85973e809e15",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10d43805-4d10-4d5f-9691-885af22ff632",
      target: "7c486acd-5df0-4e23-b208-fcccfc7d0b14"
    },
    {
      id: "d7a2f64c-b77c-4e8c-af2a-8d0df2ca4ae4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63093767-f8ce-44d1-8142-2ed6229c04c9",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "aa859c5f-4860-47f0-a080-e482627de3d1",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "63093767-f8ce-44d1-8142-2ed6229c04c9",
      target: "da766588-484d-4c59-8c8a-6ead32da372c"
    },
    {
      id: "3a3b979a-16e5-439a-a4cb-174157e39519",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63093767-f8ce-44d1-8142-2ed6229c04c9",
      target: "e95237f4-3c52-4fdb-86e9-0dee2aecb54e"
    },
    {
      id: "db5f40bb-2ba6-4956-89cc-c6af42e25665",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "63093767-f8ce-44d1-8142-2ed6229c04c9",
      target: "7532238e-3647-45de-b131-f44f81d631d1"
    },
    {
      id: "ea3803a5-aeb9-4c45-a3d0-1dc58478ac2f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "da766588-484d-4c59-8c8a-6ead32da372c",
      target: "0152f816-00ed-4e1f-b34b-83afe9b985f9"
    },
    {
      id: "99a75fdd-7702-47a3-95c1-ee3a46015067",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e95237f4-3c52-4fdb-86e9-0dee2aecb54e",
      target: "cd745684-2268-4d67-9108-311eed425b56"
    },
    {
      id: "a7a63748-1f71-4b6e-830f-5fa68f3f5330",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cd745684-2268-4d67-9108-311eed425b56",
      target: "3c87948c-85dd-4896-bd9c-585d039a57e0"
    },
    {
      id: "0db43209-8e2b-45d0-99e1-474662295a57",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "cd745684-2268-4d67-9108-311eed425b56",
      target: "eb73a1f9-fda5-4fef-8296-6f8eeb63c600"
    },
    {
      id: "3e3abaa7-e2ec-4ec9-a9d3-9dfa9b3ff988",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      target: "72311a6f-7112-488b-83e2-719c937c7f6c"
    },
    {
      id: "aed943b8-c4ab-4b25-b9b8-e80c362c1cdb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      target: "a22556d9-2392-4203-ae05-8629494d46e2"
    },
    {
      id: "2659957d-a99f-4594-9a77-e607bd627ea2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      target: "d14d0c88-2ba5-406f-a462-75af420345b4"
    },
    {
      id: "fbbe0c9f-ab1e-4ba3-8600-39f71193eacc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      target: "da766588-484d-4c59-8c8a-6ead32da372c"
    },
    {
      id: "79854bde-ec4d-4c2a-a101-eed59b6691b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "42c20fc9-8c58-4150-84b5-e8e0fed4ca76",
      target: "32c8f527-63bc-4d21-9f50-8dd4f8f56287"
    },
    {
      id: "f141cacf-8190-4612-a06c-e55774aa1c00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c87948c-85dd-4896-bd9c-585d039a57e0",
      target: "eb73a1f9-fda5-4fef-8296-6f8eeb63c600"
    },
    {
      id: "5005b6dd-e2ea-464f-9588-3e5e7706d64f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d14d0c88-2ba5-406f-a462-75af420345b4",
      target: "999a5b37-388c-4556-9e66-cefd7cb0cf85"
    },
    {
      id: "2726dfbe-f624-40b0-8592-57998db1ddb4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d14d0c88-2ba5-406f-a462-75af420345b4",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "05f05e20-c70c-4ef9-8593-e36b6c0b0b6a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "41282a1c-37f1-444a-a339-bae8480964d4",
      target: "0152f816-00ed-4e1f-b34b-83afe9b985f9"
    },
    {
      id: "a85bcc76-a4a4-46b4-aea9-31e40d8994e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "effd8d58-dc6c-49f8-badf-8daf3e609d1e",
      target: "b506e9a8-aa7b-4b85-b1c5-9583ed7c8603"
    },
    {
      id: "464227d5-fd4c-4947-8c21-9ee9a73a7135",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "effd8d58-dc6c-49f8-badf-8daf3e609d1e",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "0ce33292-1f7a-4c14-8671-c09242f84457",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5862044-0aeb-40d6-b111-9bb0dad28651",
      target: "214107b4-1a14-4e34-b575-03c9fe7c605a"
    },
    {
      id: "2b12387e-79d5-4ce1-b4cd-dde9ca0da6eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5862044-0aeb-40d6-b111-9bb0dad28651",
      target: "8be250bd-0710-4348-a24f-3f6f4b0b01c5"
    },
    {
      id: "16f59d68-1b15-4728-807f-b7d61071547a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e5862044-0aeb-40d6-b111-9bb0dad28651",
      target: "41282a1c-37f1-444a-a339-bae8480964d4"
    },
    {
      id: "78d020bd-6e76-4ba3-ab38-516dac6afcd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8be250bd-0710-4348-a24f-3f6f4b0b01c5",
      target: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9"
    },
    {
      id: "90d56d23-92dc-4f49-b9d6-06af70f19190",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8be250bd-0710-4348-a24f-3f6f4b0b01c5",
      target: "e246861c-bbe9-4cbe-8eba-3fc48c057f33"
    },
    {
      id: "ce439f6a-fe72-495b-9d24-d14a1a2539d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8be250bd-0710-4348-a24f-3f6f4b0b01c5",
      target: "5231452f-a8a5-481f-b2a2-e7602e53969d"
    },
    {
      id: "c28edd8a-e368-47bb-a21c-93cadfb93ebb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5231452f-a8a5-481f-b2a2-e7602e53969d",
      target: "4acae406-bb7e-4a50-bc5e-58361dc1b779"
    },
    {
      id: "4ed91e73-890d-4975-a2af-c9114b7c4ed1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5231452f-a8a5-481f-b2a2-e7602e53969d",
      target: "34086c88-4b53-4b77-a887-9cc7b3f2276a"
    },
    {
      id: "2e6a3151-7558-4fbf-9b27-5fe019e3a47e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34086c88-4b53-4b77-a887-9cc7b3f2276a",
      target: "222d87ba-37a6-49cc-9fe0-90a7aa9fc2ca"
    },
    {
      id: "222e1279-09ac-48a9-bcf5-8565a8406474",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "214107b4-1a14-4e34-b575-03c9fe7c605a",
      target: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9"
    },
    {
      id: "cb31fa4d-b809-4e26-bc20-020828643e43",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "214107b4-1a14-4e34-b575-03c9fe7c605a",
      target: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9"
    },
    {
      id: "a735972e-b0ef-4fa2-9962-0cc82071f675",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9",
      target: "66cbfc93-d5a4-4bad-9333-abfa5afcf154"
    },
    {
      id: "42409e4c-567a-40fb-8983-58b2854b1377",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6e2106e0-9ebc-4f72-94cf-2a440c71cff9",
      target: "4acae406-bb7e-4a50-bc5e-58361dc1b779"
    },
    {
      id: "7ab4fa9f-dec3-4d0c-8c30-b76e6f77e808",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4acae406-bb7e-4a50-bc5e-58361dc1b779",
      target: "222d87ba-37a6-49cc-9fe0-90a7aa9fc2ca"
    },
    {
      id: "94ae3633-8d8c-494a-a62b-f6e7f43dcba3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4acae406-bb7e-4a50-bc5e-58361dc1b779",
      target: "222d87ba-37a6-49cc-9fe0-90a7aa9fc2ca"
    },
    {
      id: "f0139848-7b7a-4085-9288-9addec4118cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "222d87ba-37a6-49cc-9fe0-90a7aa9fc2ca",
      target: "0152f816-00ed-4e1f-b34b-83afe9b985f9"
    },
    {
      id: "20c99eec-89b0-46bf-8308-1b719ae1e34c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66cbfc93-d5a4-4bad-9333-abfa5afcf154",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "db22d32c-405a-427c-9aff-cd904ec76a1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66cbfc93-d5a4-4bad-9333-abfa5afcf154",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "67d20529-560e-4272-9c82-5dda3da14496",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "66cbfc93-d5a4-4bad-9333-abfa5afcf154",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "7db5154a-20fd-4c9e-a0b1-105e438dd64f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0152f816-00ed-4e1f-b34b-83afe9b985f9",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "8287f270-f301-40f7-be62-e84fa4b67c5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0152f816-00ed-4e1f-b34b-83afe9b985f9",
      target: "d34d7cb0-44dc-45d6-a43e-4cf75688b937"
    },
    {
      id: "fdc9a85a-317c-495c-b454-0d61e565845b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0152f816-00ed-4e1f-b34b-83afe9b985f9",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "10b2db7b-efdf-4ad2-b844-f5af579c6c65",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0062596b-8279-44a2-b159-821545ec9d11",
      target: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4"
    },
    {
      id: "bafa851a-9d94-4bdc-95bb-63b251b21665",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7532238e-3647-45de-b131-f44f81d631d1",
      target: "0062596b-8279-44a2-b159-821545ec9d11"
    },
    {
      id: "1dcbfb7e-698f-4415-b69a-c6010e7bdcf9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7532238e-3647-45de-b131-f44f81d631d1",
      target: "a1861aa0-eade-4375-bea0-f5700fe520f3"
    },
    {
      id: "eef1d7ba-2aa4-4e60-8cb4-d9c4e7bdefcf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4"
    },
    {
      id: "e77ad1ef-c66f-439c-904b-889420872643",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "8867c60e-a98b-47a7-8cff-14f96a885d9c"
    },
    {
      id: "cc2d0acf-3d68-41fa-9434-733883cf6365",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "0062596b-8279-44a2-b159-821545ec9d11"
    },
    {
      id: "60414f8d-2a8d-46ac-ab9c-8b5728496b49",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "80536356-cae6-49dc-990c-8963343d17d1"
    },
    {
      id: "e04b10e4-0e3d-48b9-baf8-f63af6ca2388",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "de35fad7-420f-4394-bb45-7342e09216b2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "300f59b9-9631-4775-aec5-e4eeb9a08aad"
    },
    {
      id: "7193b0a2-e1b5-4696-9004-e33c57632171",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a22556d9-2392-4203-ae05-8629494d46e2",
      target: "f58c34d3-47ec-4a99-a4f2-5e85145a7450"
    },
    {
      id: "b7779fe2-f906-491b-a43a-9812ad3d860c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a1861aa0-eade-4375-bea0-f5700fe520f3",
      target: "6b8a5918-9218-40e6-9c5d-1ceb484db936"
    },
    {
      id: "8bb2a0ab-1974-4bce-8132-51aff3bdae11",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b8a5918-9218-40e6-9c5d-1ceb484db936",
      target: "10d43805-4d10-4d5f-9691-885af22ff632"
    },
    {
      id: "9461a6d8-5b60-4da7-857b-d051e71f0ed4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b8a5918-9218-40e6-9c5d-1ceb484db936",
      target: "34cb53d4-3578-4690-9e18-bed8bf706fe5"
    },
    {
      id: "27cf7254-e0d0-45a2-8f23-2f939aeda5da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "300f59b9-9631-4775-aec5-e4eeb9a08aad",
      target: "cec068d6-061d-440d-8715-145782365d80"
    },
    {
      id: "1c9b58ea-db51-4a4b-ac9c-4fab73fcc9c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "300f59b9-9631-4775-aec5-e4eeb9a08aad",
      target: "7c486acd-5df0-4e23-b208-fcccfc7d0b14"
    },
    {
      id: "955ec36e-5bcd-4b0e-afa3-ad7f7780fc5f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "300f59b9-9631-4775-aec5-e4eeb9a08aad",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "a95e1282-2554-4aea-bc10-3880320f492c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8867c60e-a98b-47a7-8cff-14f96a885d9c",
      target: "ad824291-d506-42f6-a968-e48d853eec45"
    },
    {
      id: "16f8813f-23cf-487f-8239-34c892c76c72",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34cb53d4-3578-4690-9e18-bed8bf706fe5",
      target: "10d43805-4d10-4d5f-9691-885af22ff632"
    },
    {
      id: "1c5bd3a4-81eb-44c9-a0ad-6d9ea6b828fe",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e777b038-b4ed-4f24-b3e1-75b3bc7303be",
      target: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4"
    },
    {
      id: "c738161a-8ca9-4efd-bbbd-bd4bfa997a30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c486acd-5df0-4e23-b208-fcccfc7d0b14",
      target: "d1564e53-0f63-48b4-ae6b-e7ec3580fd7a"
    },
    {
      id: "1366d953-0cf3-4b5d-a1a3-80293d1ad7a8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c486acd-5df0-4e23-b208-fcccfc7d0b14",
      target: "899e114e-67d1-4001-9bb4-8031ee08bd20"
    },
    {
      id: "38ed0529-9805-49fb-a454-6f6a9b8757af",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7c486acd-5df0-4e23-b208-fcccfc7d0b14",
      target: "e777b038-b4ed-4f24-b3e1-75b3bc7303be"
    },
    {
      id: "92e45982-becd-4a7f-8359-c961faf81adb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "899e114e-67d1-4001-9bb4-8031ee08bd20",
      target: "7a1ffe3a-b0ef-4afc-abb2-f0320e1dff02"
    },
    {
      id: "95c8d853-de60-462b-8653-342df2f28a6c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "899e114e-67d1-4001-9bb4-8031ee08bd20",
      target: "aa6a78f7-d6eb-4b90-896c-f58d01899073"
    },
    {
      id: "2fda98bf-6747-4d7c-8e36-a150a4f41162",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a1ffe3a-b0ef-4afc-abb2-f0320e1dff02",
      target: "1998b076-f4b5-44a4-96c6-02088efd7891"
    },
    {
      id: "58643d74-445e-431b-8916-e13e383f2c4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7a1ffe3a-b0ef-4afc-abb2-f0320e1dff02",
      target: "37304d8d-d453-4d1d-ad01-4a7fc9af3ea2"
    },
    {
      id: "d97063bd-6f86-42a6-a8d9-1fe83a6ceec5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37304d8d-d453-4d1d-ad01-4a7fc9af3ea2",
      target: "cfaf7968-43c8-45b2-a897-d16a83eb5efb"
    },
    {
      id: "76d6609c-a9c5-4a2d-8e73-59fcf79816c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "37304d8d-d453-4d1d-ad01-4a7fc9af3ea2",
      target: "f6a4ea17-0052-472a-99f8-6ce1d3124f93"
    },
    {
      id: "843948d1-a0b5-4b10-9292-88a6e5c9baa2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cfaf7968-43c8-45b2-a897-d16a83eb5efb",
      target: "d00a0a38-b927-41af-8b4a-4a500416a835"
    },
    {
      id: "500ce80b-377d-4fd7-8950-b51cc5d019f0",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d1564e53-0f63-48b4-ae6b-e7ec3580fd7a",
      target: "aa6a78f7-d6eb-4b90-896c-f58d01899073"
    },
    {
      id: "4e58e261-94f9-4425-abf3-9faccb11aac4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d1564e53-0f63-48b4-ae6b-e7ec3580fd7a",
      target: "aa6a78f7-d6eb-4b90-896c-f58d01899073"
    },
    {
      id: "d1e28284-749a-4d55-a500-23295d80f8fe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa6a78f7-d6eb-4b90-896c-f58d01899073",
      target: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4"
    },
    {
      id: "bb40ff51-16ea-4c3e-8d3f-6bcdebc5b933",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa6a78f7-d6eb-4b90-896c-f58d01899073",
      target: "392df1ce-4a4a-420c-a02b-c7cc50f88edc"
    },
    {
      id: "a25dc074-6774-4503-b18d-1f920eb75962",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aa6a78f7-d6eb-4b90-896c-f58d01899073",
      target: "e246861c-bbe9-4cbe-8eba-3fc48c057f33"
    },
    {
      id: "87175e69-416c-4e47-96e1-05955d926062",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aa6a78f7-d6eb-4b90-896c-f58d01899073",
      target: "1998b076-f4b5-44a4-96c6-02088efd7891"
    },
    {
      id: "bc0d2ea9-958f-43f6-9b30-71ab18161d71",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1998b076-f4b5-44a4-96c6-02088efd7891",
      target: "f6a4ea17-0052-472a-99f8-6ce1d3124f93"
    },
    {
      id: "04d5ead3-7344-4d66-b8c2-64bbe9f8fb1a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1998b076-f4b5-44a4-96c6-02088efd7891",
      target: "f6a4ea17-0052-472a-99f8-6ce1d3124f93"
    },
    {
      id: "6346f025-de73-4297-99aa-5190e0179212",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f6a4ea17-0052-472a-99f8-6ce1d3124f93",
      target: "d00a0a38-b927-41af-8b4a-4a500416a835"
    },
    {
      id: "0ad0696d-7c67-4be7-b5be-91c385559748",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f6a4ea17-0052-472a-99f8-6ce1d3124f93",
      target: "d00a0a38-b927-41af-8b4a-4a500416a835"
    },
    {
      id: "7c57d27b-1228-4e93-983b-402b49ce02fa",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d00a0a38-b927-41af-8b4a-4a500416a835",
      target: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4"
    },
    {
      id: "3913bd5c-e473-4d8f-a9e2-1d08149a2716",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d00a0a38-b927-41af-8b4a-4a500416a835",
      target: "9734eb9a-fd01-4b43-b058-ea660800e142"
    },
    {
      id: "1a66f3db-8f45-490c-a73a-f294ff849c3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "9ee1e055-3df3-47fc-8a50-0e377fb9521a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "1ec38759-8802-472b-93e9-52456855e6ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bb3ce8f3-1e78-4179-80aa-94f8f3dd89a4",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "40963f2d-b778-430c-80fd-831623520ae7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "58b0afd2-e275-4613-bdb7-66267d0df82a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e589d59b-6c09-4c68-a9bc-d1a8de6ee9c4",
      target: "d34d7cb0-44dc-45d6-a43e-4cf75688b937"
    },
    {
      id: "c20570f8-2a9f-4847-b69e-1f15df69a2da",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f1fe2607-f433-484c-8b00-a3613a5933bc",
      target: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5"
    },
    {
      id: "8ecc8e96-162e-4153-86c8-54583ef2f9a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5"
    },
    {
      id: "fb87d096-107c-4bf9-b404-a6e46a9ea0b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "31847245-1765-42f0-b786-1c126c3849bd"
    },
    {
      id: "a7e86634-229b-4664-9716-4f9077594bbc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "f1fe2607-f433-484c-8b00-a3613a5933bc"
    },
    {
      id: "031803c3-5853-4f5d-a1b5-039a50ef45d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "012336d8-292d-4c0f-8958-76c2bdd9deb6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "effd8d58-dc6c-49f8-badf-8daf3e609d1e"
    },
    {
      id: "41168e66-88f8-4956-a756-8090a240acdf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "32c8f527-63bc-4d21-9f50-8dd4f8f56287",
      target: "1037813e-cf0e-4b3b-a3ab-8618cb9d780c"
    },
    {
      id: "f4adf91e-a9b0-47fb-b18c-16791e11faa8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5",
      target: "5aa96d0f-3611-4599-b345-2abdc9204217"
    },
    {
      id: "42f95139-2c9c-4919-94e0-c72771728c17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0ab0470-3760-4cb4-b304-38d4e7f4aec5",
      target: "e246861c-bbe9-4cbe-8eba-3fc48c057f33"
    },
    {
      id: "3387b56a-e218-4491-8b87-7f361ed89ad8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1037813e-cf0e-4b3b-a3ab-8618cb9d780c",
      target: "1d9febe4-3b3c-4fee-b924-6d98635b05a6"
    },
    {
      id: "acb5d098-0999-48d2-a371-5b1278771289",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0f9ea7ed-922f-49c6-a51c-4fce48117730",
      target: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5"
    },
    {
      id: "073852f0-ca12-462c-901a-5a9cb644da76",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e246861c-bbe9-4cbe-8eba-3fc48c057f33",
      target: "0f9ea7ed-922f-49c6-a51c-4fce48117730"
    },
    {
      id: "e9cf3507-c7cc-480e-a92a-ee092925ed90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e246861c-bbe9-4cbe-8eba-3fc48c057f33",
      target: "87aec155-33ca-41f4-80fc-22a787f4edc9"
    },
    {
      id: "fef1c42c-7499-43d5-8efd-0b7e670bdac1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e246861c-bbe9-4cbe-8eba-3fc48c057f33",
      target: "100e1d20-7d31-4eec-a91f-fdf843704f31"
    },
    {
      id: "8bdda48b-dc2a-4a9a-95e2-b5455c302da4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87aec155-33ca-41f4-80fc-22a787f4edc9",
      target: "29feba74-9b96-4c8d-b52c-e77c234ed3ba"
    },
    {
      id: "cc22e00e-22a0-4338-b2fd-9c526bea6d45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "87aec155-33ca-41f4-80fc-22a787f4edc9",
      target: "af9419ae-c23e-48e4-b592-87c16a8a04cd"
    },
    {
      id: "2adc3a12-6de1-42e8-8eb2-b70d84e228c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af9419ae-c23e-48e4-b592-87c16a8a04cd",
      target: "460387f3-8d9e-4736-878f-1a9c8ae4ed44"
    },
    {
      id: "16dc795e-fc25-4853-9e9c-3d686d15e9b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af9419ae-c23e-48e4-b592-87c16a8a04cd",
      target: "7589d0bf-f286-4541-8d9d-437ff1f97ab9"
    },
    {
      id: "5781091b-ccca-496b-b705-b2179b0c8d18",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "460387f3-8d9e-4736-878f-1a9c8ae4ed44",
      target: "efe9f773-401a-4846-9bf5-ddd4e151cc7c"
    },
    {
      id: "667f0686-cf08-436e-b015-bc9f121d96e7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "460387f3-8d9e-4736-878f-1a9c8ae4ed44",
      target: "04eea52a-164c-469e-87b0-71ae63bdd8bc"
    },
    {
      id: "7e158dfe-f24e-4ed4-8504-32c76f247670",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "efe9f773-401a-4846-9bf5-ddd4e151cc7c",
      target: "b557678c-5c21-4537-be28-fde8b1584424"
    },
    {
      id: "5cf8c460-8ab6-4ded-b72a-fe54b879f377",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "100e1d20-7d31-4eec-a91f-fdf843704f31",
      target: "29feba74-9b96-4c8d-b52c-e77c234ed3ba"
    },
    {
      id: "fb89ed0b-af6e-49b5-9bfc-c803763424eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "100e1d20-7d31-4eec-a91f-fdf843704f31",
      target: "29feba74-9b96-4c8d-b52c-e77c234ed3ba"
    },
    {
      id: "2165627f-dd2e-4cff-9b24-40dd991cbb55",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "29feba74-9b96-4c8d-b52c-e77c234ed3ba",
      target: "7589d0bf-f286-4541-8d9d-437ff1f97ab9"
    },
    {
      id: "79cd3b52-403d-4b85-9ead-0e734834f480",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "29feba74-9b96-4c8d-b52c-e77c234ed3ba",
      target: "31847245-1765-42f0-b786-1c126c3849bd"
    },
    {
      id: "ff8a62eb-b8cd-4d40-b77b-a38f577a450a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7589d0bf-f286-4541-8d9d-437ff1f97ab9",
      target: "04eea52a-164c-469e-87b0-71ae63bdd8bc"
    },
    {
      id: "882dcba8-0b12-43d2-8cef-ba326be4546c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7589d0bf-f286-4541-8d9d-437ff1f97ab9",
      target: "04eea52a-164c-469e-87b0-71ae63bdd8bc"
    },
    {
      id: "513d636f-bc70-4cf4-b763-61638c4c6409",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "04eea52a-164c-469e-87b0-71ae63bdd8bc",
      target: "b557678c-5c21-4537-be28-fde8b1584424"
    },
    {
      id: "465a0f05-9a16-408f-9b55-f8d5111e933d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "04eea52a-164c-469e-87b0-71ae63bdd8bc",
      target: "b557678c-5c21-4537-be28-fde8b1584424"
    },
    {
      id: "1f4321d2-a5f9-4bc0-b706-da3e8cef655d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b557678c-5c21-4537-be28-fde8b1584424",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "091421f0-112e-46e8-aa7d-7bf0ef69f7bd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b557678c-5c21-4537-be28-fde8b1584424",
      target: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5"
    },
    {
      id: "ca364a37-6b21-4160-9046-1584cee420c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31847245-1765-42f0-b786-1c126c3849bd",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "9c4ff295-d4a0-4215-b5d2-cdae284c4ccf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31847245-1765-42f0-b786-1c126c3849bd",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "daebad16-db5c-4a4b-8fe5-f37dadd6c5a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31847245-1765-42f0-b786-1c126c3849bd",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "70dd85fc-77fa-4fcc-ad60-a5d87b9eb556",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "de00a39d-a5b4-4b97-91c0-527244cf6607",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45ab9b94-77f7-40c4-ad9b-834a61dda1c5",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "03717e66-0962-4205-803d-d85199ce0bff",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "920c3f23-c495-404b-874e-11586810c7da",
      target: "b7276775-282b-41bf-b68f-4f43ce404d58"
    },
    {
      id: "adb8a144-a266-4c31-97b8-ec4bf6c4c6c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "680102a5-98d3-4616-a73d-a7177e4a70d4"
    },
    {
      id: "4f7e17e8-2538-4433-8a16-fbbe0366a32c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "920c3f23-c495-404b-874e-11586810c7da"
    },
    {
      id: "c98d78b7-1120-4e41-9213-6020a1854f7a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "6c5eeda7-0b66-400a-a7c5-59c71f9bd9fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "40e4070f-74e6-4aae-9b1b-1bf7b5a8c613",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f"
    },
    {
      id: "aee0f2ce-02ad-40c0-9c7c-1a240bf9d333",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "3de0d5dd-6df8-405d-9fb7-0b00ecead8b6"
    },
    {
      id: "e97c88a4-f8eb-4c09-ab11-babbcec2b8f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f58c34d3-47ec-4a99-a4f2-5e85145a7450",
      target: "514fd011-bf24-4893-b099-d913d65e9062"
    },
    {
      id: "7a53a86b-dce4-4fd5-a133-3efb869dcab2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "680102a5-98d3-4616-a73d-a7177e4a70d4",
      target: "6efc3154-837c-4250-8c9c-73b144dec055"
    },
    {
      id: "599c3cdb-7c5e-4436-9482-9876eab5d352",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "680102a5-98d3-4616-a73d-a7177e4a70d4",
      target: "392df1ce-4a4a-420c-a02b-c7cc50f88edc"
    },
    {
      id: "c7b0fd5c-a1ff-40bc-afd2-43fe1b3b838a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3de0d5dd-6df8-405d-9fb7-0b00ecead8b6",
      target: "081cf95d-1a9b-4486-a2d5-a24d02b883b3"
    },
    {
      id: "ca151a63-36c8-4886-ad86-af10472ea097",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8add724b-b353-4269-86fb-29af286a4fdd",
      target: "b7276775-282b-41bf-b68f-4f43ce404d58"
    },
    {
      id: "59f376f9-c536-429f-832a-0c1dca2859bc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "392df1ce-4a4a-420c-a02b-c7cc50f88edc",
      target: "4a7345b9-e113-4c51-9023-864b5f92c511"
    },
    {
      id: "841dc9f5-533a-436e-a827-e4e57c2fc144",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "392df1ce-4a4a-420c-a02b-c7cc50f88edc",
      target: "6f9a426c-7f48-434e-ab76-ef844e171819"
    },
    {
      id: "9626fc96-77bf-4567-9f02-9a013297075a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f9a426c-7f48-434e-ab76-ef844e171819",
      target: "35e2108f-8537-4bb3-af72-7147126da563"
    },
    {
      id: "4ba91d6e-16ba-4cbb-8756-5e74bdbafe44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f9a426c-7f48-434e-ab76-ef844e171819",
      target: "77401d30-e087-409c-926b-760a5e2afb49"
    },
    {
      id: "c91fa9cc-6653-4090-b8f1-8d764e6768f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35e2108f-8537-4bb3-af72-7147126da563",
      target: "f4b92e54-d674-407e-a509-d513b9d9c313"
    },
    {
      id: "e0126a6e-3e1d-43c0-b7dc-48f5c6acc0e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "35e2108f-8537-4bb3-af72-7147126da563",
      target: "75d436dd-74fe-4150-bb06-5bde0dff116c"
    },
    {
      id: "89dd4f00-3ccc-427e-ac8d-15c8d4deeadc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75d436dd-74fe-4150-bb06-5bde0dff116c",
      target: "b68c4bfd-342f-4276-b864-c869ddf28b74"
    },
    {
      id: "62cf1168-0c44-41e9-8252-e42104409600",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75d436dd-74fe-4150-bb06-5bde0dff116c",
      target: "1e68bea4-28a7-40f8-a493-aa3602dcec38"
    },
    {
      id: "d6f7304f-a241-4420-b340-4567fffdeddf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1e68bea4-28a7-40f8-a493-aa3602dcec38",
      target: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86"
    },
    {
      id: "f454c9e6-7a3c-42f1-93e5-f46bde155ffd",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4a7345b9-e113-4c51-9023-864b5f92c511",
      target: "8add724b-b353-4269-86fb-29af286a4fdd"
    },
    {
      id: "b49d545d-d354-48a0-88d2-e8f8e5e59771",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4a7345b9-e113-4c51-9023-864b5f92c511",
      target: "77401d30-e087-409c-926b-760a5e2afb49"
    },
    {
      id: "8fad7630-871b-4c78-b613-9ceccc555398",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4a7345b9-e113-4c51-9023-864b5f92c511",
      target: "77401d30-e087-409c-926b-760a5e2afb49"
    },
    {
      id: "c5944bb5-4999-480b-9629-670904454d93",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "77401d30-e087-409c-926b-760a5e2afb49",
      target: "f4b92e54-d674-407e-a509-d513b9d9c313"
    },
    {
      id: "37b23a8c-eb1b-4198-a534-358d6a9ba64e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "77401d30-e087-409c-926b-760a5e2afb49",
      target: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f"
    },
    {
      id: "34bcd905-bbe0-4050-86b3-62d4fba5fe64",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f4b92e54-d674-407e-a509-d513b9d9c313",
      target: "b68c4bfd-342f-4276-b864-c869ddf28b74"
    },
    {
      id: "26efe32f-66c3-4759-a4e0-ca649c282ce4",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f4b92e54-d674-407e-a509-d513b9d9c313",
      target: "b68c4bfd-342f-4276-b864-c869ddf28b74"
    },
    {
      id: "086c4c68-d4c3-4212-91be-0a1920bc619a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b68c4bfd-342f-4276-b864-c869ddf28b74",
      target: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86"
    },
    {
      id: "5e6d52f9-ab7d-405d-bcb8-a0a474b8b08d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b68c4bfd-342f-4276-b864-c869ddf28b74",
      target: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86"
    },
    {
      id: "e8e02171-40fb-4a69-8037-e9972d455e8f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86",
      target: "b7276775-282b-41bf-b68f-4f43ce404d58"
    },
    {
      id: "d9a48d2b-450d-43db-ae37-d1e93d316af2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "914ae7c2-5f03-48a5-ad9b-5058fa3f4d86",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "90f9774d-514e-4741-89de-4576da9841c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "8d23c678-7020-4f01-9ee2-70fc710d92d8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "7b478cea-e742-48a0-874f-bad55d1873d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c98cd0df-0ba9-455b-a8ad-66964f57aa9f",
      target: "4f35a163-c5a8-49b1-ab38-b1b6fcbd1c49"
    },
    {
      id: "408c53b7-e012-4df8-a9c1-62395574e039",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7276775-282b-41bf-b68f-4f43ce404d58",
      target: "06cc82f0-f677-410f-9e3f-f98cbe836508"
    },
    {
      id: "01ff3016-8819-4a61-a83d-1d12cdaca44f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7276775-282b-41bf-b68f-4f43ce404d58",
      target: "110ae5f5-17a4-4936-893a-12dd48117817"
    },
    {
      id: "72f1aaeb-e773-4a25-a809-ef2c21380b4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9fc02960-0011-4b76-bed9-0f7cd12efb69",
      target: "3b299e1e-0904-4e57-8f27-5571141efbf9"
    },
    {
      id: "e4640f84-5b28-4496-b2f6-89a5ba3fab7a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9fc02960-0011-4b76-bed9-0f7cd12efb69",
      target: "f4c80d29-97ad-4b76-9746-0daaa2d75a51"
    },
    {
      id: "00a9fd7d-ba9f-4cc3-99e2-c12b55e2d016",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9fc02960-0011-4b76-bed9-0f7cd12efb69",
      target: "f4c80d29-97ad-4b76-9746-0daaa2d75a51"
    },
    {
      id: "5aaa1e8b-dc90-4984-bb0a-6bd5695daeaa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4c80d29-97ad-4b76-9746-0daaa2d75a51",
      target: "62fef0d4-9d43-4611-98d6-e390de33ea94"
    },
    {
      id: "7da53e33-3d8f-4ba4-abea-6e63f7f0d145",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f4c80d29-97ad-4b76-9746-0daaa2d75a51",
      target: "3b299e1e-0904-4e57-8f27-5571141efbf9"
    },
    {
      id: "d7495039-11f2-4fb0-8cfc-f9f367c35c0c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f4c80d29-97ad-4b76-9746-0daaa2d75a51",
      target: "3b299e1e-0904-4e57-8f27-5571141efbf9"
    },
    {
      id: "7e9dc0a1-f191-4eef-b1be-3f29b74cd84e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "3b299e1e-0904-4e57-8f27-5571141efbf9",
      target: "62fef0d4-9d43-4611-98d6-e390de33ea94"
    },
    {
      id: "2cfcc925-9744-4dea-a3f4-9f02ca183872",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3b299e1e-0904-4e57-8f27-5571141efbf9",
      target: "62fef0d4-9d43-4611-98d6-e390de33ea94"
    },
    {
      id: "d9dd6d24-7a12-453b-9ded-9bf87cd39795",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "3b299e1e-0904-4e57-8f27-5571141efbf9",
      target: "45fde9bd-5bbd-49bb-b65b-333d8afc29fd"
    },
    {
      id: "5b53e9b5-8d12-46e5-8ac5-071cc92f039f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "62fef0d4-9d43-4611-98d6-e390de33ea94",
      target: "7b323a55-def1-45a9-a444-6364d37527f1"
    },
    {
      id: "6255be39-6dba-40ed-8edb-684d34f422c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45fde9bd-5bbd-49bb-b65b-333d8afc29fd",
      target: "1d5bccf2-4375-4c8f-bfc0-cfd07432de0d"
    },
    {
      id: "2ab877a5-393e-451a-a41a-e9dcd3572159",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7b323a55-def1-45a9-a444-6364d37527f1",
      target: "0bf114cf-77c0-4475-9c6b-2d91c4adead9"
    },
    {
      id: "463bd775-0b21-4f55-9125-56015d8a3ea9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d5bccf2-4375-4c8f-bfc0-cfd07432de0d",
      target: "f8a6cf98-8c2e-41d8-808e-f36acbfcb0ea"
    },
    {
      id: "988908d8-ec0e-4181-a2e6-34fa27cbb006",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0bf114cf-77c0-4475-9c6b-2d91c4adead9",
      target: "ca7ff64d-8bbf-4f5b-b35a-4e29f76db6f6"
    },
    {
      id: "72aab5f3-3f44-4eed-97d2-69888cc1325c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71d10656-f648-4453-bdd4-cdc3a3406072",
      target: "2b210983-46a3-4c16-8a63-bf0c2ef06ffa"
    },
    {
      id: "6ef9d8d6-d69c-4ac9-964e-daee81ebe5cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71d10656-f648-4453-bdd4-cdc3a3406072",
      target: "4f060e97-4d69-46da-94e0-43573784cb47"
    },
    {
      id: "e484d820-cec7-4822-a217-74c9f7b31b90",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "71d10656-f648-4453-bdd4-cdc3a3406072",
      target: "4b19a73f-18fe-4bd9-a7ea-e241e72d3bff"
    },
    {
      id: "ebf0df41-431d-4661-97e9-11c2b8c669a0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca7ff64d-8bbf-4f5b-b35a-4e29f76db6f6",
      target: "30b61d81-9fef-4f68-828a-de3a5c38171d"
    },
    {
      id: "7471323b-d597-469e-9404-37256cda5b8b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca7ff64d-8bbf-4f5b-b35a-4e29f76db6f6",
      target: "2b210983-46a3-4c16-8a63-bf0c2ef06ffa"
    },
    {
      id: "b293f000-946e-4f6f-b001-35ce08171577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b210983-46a3-4c16-8a63-bf0c2ef06ffa",
      target: "f8a6cf98-8c2e-41d8-808e-f36acbfcb0ea"
    },
    {
      id: "963176a1-dd07-474f-93ed-bbcf2b54ac68",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30b61d81-9fef-4f68-828a-de3a5c38171d",
      target: "94561b30-dd39-4260-ba38-3600e1e60cf7"
    },
    {
      id: "51a1753e-d4f9-47b6-af41-d90a84945f54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94561b30-dd39-4260-ba38-3600e1e60cf7",
      target: "f5d1cc2d-788c-412d-966c-6e3467dd077d"
    },
    {
      id: "8a74b917-81f4-412a-9412-cc84bad7a103",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f8a6cf98-8c2e-41d8-808e-f36acbfcb0ea",
      target: "c3c6b00c-aba4-42a3-ab4d-ff382e606bf4"
    },
    {
      id: "5e87577e-af23-4d9d-8ad8-3eb856effd67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f5d1cc2d-788c-412d-966c-6e3467dd077d",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "b5c7cba3-9b2e-4704-989a-c51596be2220",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c3c6b00c-aba4-42a3-ab4d-ff382e606bf4",
      target: "b1b593a1-4940-40f6-a98b-d4f19f77e57d"
    },
    {
      id: "e5404f42-97ef-47e9-b082-08be87471bed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0df78865-60c8-4bad-aa6c-6afed85458a3",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "249a1bff-ff80-4546-ad9b-29bf2dfb97fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0df78865-60c8-4bad-aa6c-6afed85458a3",
      target: "e78ba449-11b3-432e-87b3-d70f9eb5fc1b"
    },
    {
      id: "4c877535-e427-4a51-94c0-d7763885b57a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e78ba449-11b3-432e-87b3-d70f9eb5fc1b",
      target: "de63d88b-d875-4799-affc-e40d06712eb0"
    },
    {
      id: "114ac618-4a19-455b-bb1f-90ef74f9e3a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "de63d88b-d875-4799-affc-e40d06712eb0",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "3bff7de6-9fb5-46dd-ab14-eb6b62e4574a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9934ee9b-957d-4d28-af13-b16c42d00a52",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "65534356-98d4-44e6-b1fb-b1c9f798ecb2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9934ee9b-957d-4d28-af13-b16c42d00a52",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "de712364-ad33-4ff0-a0a1-347a10eda96c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1b593a1-4940-40f6-a98b-d4f19f77e57d",
      target: "9478365f-6a8c-4157-b13b-f5a3a975e229"
    },
    {
      id: "29532d58-b019-4383-9b15-502b0a8dae04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1b593a1-4940-40f6-a98b-d4f19f77e57d",
      target: "aee97459-2415-41ba-a558-125048895c07"
    },
    {
      id: "2608cd95-cedc-46c5-9639-b2026008edb8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1b593a1-4940-40f6-a98b-d4f19f77e57d",
      target: "d6f961d4-1b78-4dff-b024-572f5b564b45"
    },
    {
      id: "716062f4-9a41-4680-8687-8c355d009aca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1b593a1-4940-40f6-a98b-d4f19f77e57d",
      target: "c37f6611-3252-4a1e-8659-3064bc280094"
    },
    {
      id: "ac99c2f7-631f-42f0-a3ce-69675a1f57ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9478365f-6a8c-4157-b13b-f5a3a975e229",
      target: "9b7849e7-4127-4091-8d27-e9bb17383514"
    },
    {
      id: "cf525704-6eef-4df7-b47d-581f84f5621f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9478365f-6a8c-4157-b13b-f5a3a975e229",
      target: "9934ee9b-957d-4d28-af13-b16c42d00a52"
    },
    {
      id: "0a86beb6-66dd-4d9f-886c-a4b4d07c597c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b7849e7-4127-4091-8d27-e9bb17383514",
      target: "718288bc-dc43-488f-837b-e5cfdcdbc6ad"
    },
    {
      id: "2647af07-e493-4ff2-b218-33cccf3d780b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b7849e7-4127-4091-8d27-e9bb17383514",
      target: "4e41781d-3b60-401b-807d-2741cb0cc5c5"
    },
    {
      id: "4a134706-7b69-4d64-99a2-96792144dd86",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9b7849e7-4127-4091-8d27-e9bb17383514",
      target: "d8f90d79-7005-4b5f-8785-c133d4725c88"
    },
    {
      id: "70fd89b5-a908-4d4a-b63b-45c8d5787bac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b7849e7-4127-4091-8d27-e9bb17383514",
      target: "53884058-3473-4eca-b10f-8002fe79b78a"
    },
    {
      id: "ec04db11-11d0-414a-ab15-0500ef1bd9b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8f90d79-7005-4b5f-8785-c133d4725c88",
      target: "4e41781d-3b60-401b-807d-2741cb0cc5c5"
    },
    {
      id: "18444f8b-bf62-49c2-b14a-218fe7778c3d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e41781d-3b60-401b-807d-2741cb0cc5c5",
      target: "12635d9d-3a76-46a8-835c-ac67fdd25209"
    },
    {
      id: "7333632c-2f1a-4f30-8988-d57688ba8a33",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "53884058-3473-4eca-b10f-8002fe79b78a",
      target: "c385aca0-4ede-4be3-a5aa-795231043061"
    },
    {
      id: "36a92ada-74b4-4625-84f9-4571961db2e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "718288bc-dc43-488f-837b-e5cfdcdbc6ad",
      target: "af3d37a4-80ef-4595-be29-ccdceed37961"
    },
    {
      id: "a549805e-634c-43e6-b41d-b3ff8f2313b7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12635d9d-3a76-46a8-835c-ac67fdd25209",
      target: "460ca71b-aa75-4358-a0fc-ea97f09ab8e9"
    },
    {
      id: "79919995-7015-4d8d-ad67-c563bad184eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c385aca0-4ede-4be3-a5aa-795231043061",
      target: "69322edc-df55-4f4a-b4f7-7c64478ebc35"
    },
    {
      id: "550db658-3d88-44fd-8068-001792ed9955",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af3d37a4-80ef-4595-be29-ccdceed37961",
      target: "5151eaab-2fa7-4780-b2ea-518c54011be4"
    },
    {
      id: "b5da4004-10cc-4dfc-a03b-656085e0c913",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "460ca71b-aa75-4358-a0fc-ea97f09ab8e9",
      target: "95942b49-8cc2-4727-8c5c-c892c766937c"
    },
    {
      id: "2a98c7a3-a59a-48de-a90a-a17e96566006",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "69322edc-df55-4f4a-b4f7-7c64478ebc35",
      target: "95942b49-8cc2-4727-8c5c-c892c766937c"
    },
    {
      id: "c25baf6b-c841-432b-81da-6b57ec665478",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5151eaab-2fa7-4780-b2ea-518c54011be4",
      target: "ef4bc87a-5f7d-44da-907b-d4c2745214b8"
    },
    {
      id: "62cdc010-62c4-4647-99a1-8f285f1ad081",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5151eaab-2fa7-4780-b2ea-518c54011be4",
      target: "95942b49-8cc2-4727-8c5c-c892c766937c"
    },
    {
      id: "fd5a0df2-f18b-4bfd-8d35-14b223fdc41c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef4bc87a-5f7d-44da-907b-d4c2745214b8",
      target: "182eb0a8-c8a3-4365-a0ae-96426cdba0d2"
    },
    {
      id: "99f25815-9d20-4603-b78a-b44babf0cc8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6f961d4-1b78-4dff-b024-572f5b564b45",
      target: "9b7849e7-4127-4091-8d27-e9bb17383514"
    },
    {
      id: "d57a1874-cd7b-4a26-b84e-ff6333616f0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c37f6611-3252-4a1e-8659-3064bc280094",
      target: "2914d626-e82d-4b3d-be7e-523764ac4ce2"
    },
    {
      id: "e5ee5a08-a38f-46f3-bdb4-a206979d4303",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c37f6611-3252-4a1e-8659-3064bc280094",
      target: "99342262-539e-4a89-9db5-728c05c3d3cb"
    },
    {
      id: "f962d8cd-0746-4c07-a5bd-a3845ceeeecf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c37f6611-3252-4a1e-8659-3064bc280094",
      target: "58d7b1e7-47c2-48aa-9974-1f34d580d295"
    },
    {
      id: "897a6133-cdf2-4177-9b81-47a5d6ba21f1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2914d626-e82d-4b3d-be7e-523764ac4ce2",
      target: "6a90ebf2-8f87-404e-8afe-0b81d587a812"
    },
    {
      id: "7938805c-632e-442f-9ecc-7b83489a7cae",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6a90ebf2-8f87-404e-8afe-0b81d587a812",
      target: "7024a539-1e27-4d44-9394-cd0cb414b4f8"
    },
    {
      id: "2e0465dc-17f7-445c-a488-8102e83b0477",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a90ebf2-8f87-404e-8afe-0b81d587a812",
      target: "4a484421-8677-4582-b1c2-bf084eda3a6e"
    },
    {
      id: "6323d082-437a-4727-8602-ead884cd2658",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a90ebf2-8f87-404e-8afe-0b81d587a812",
      target: "8df302e0-ce4b-4751-92fb-c7a6aabd4cf7"
    },
    {
      id: "7101d15b-c56d-46e9-ad6c-a0182f0e3f60",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6a90ebf2-8f87-404e-8afe-0b81d587a812",
      target: "4f15fc11-4302-46f9-bf8c-5915bf7b710e"
    },
    {
      id: "6dcbf774-4310-4013-8a77-f2a3e66639b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7024a539-1e27-4d44-9394-cd0cb414b4f8",
      target: "4f15fc11-4302-46f9-bf8c-5915bf7b710e"
    },
    {
      id: "dbcfb60c-b95d-4b5d-b7c1-fde1ba9229fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f15fc11-4302-46f9-bf8c-5915bf7b710e",
      target: "95942b49-8cc2-4727-8c5c-c892c766937c"
    },
    {
      id: "0b1bb08e-b851-43cd-8f8e-3635583de869",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8df302e0-ce4b-4751-92fb-c7a6aabd4cf7",
      target: "cb51919a-1622-40c2-8ef2-b8d016e5936a"
    },
    {
      id: "17a35ec5-5404-4379-9a02-d0d9a31f168f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4a484421-8677-4582-b1c2-bf084eda3a6e",
      target: "255e7e40-55ee-4e1a-84ef-521216aab2b2"
    },
    {
      id: "a26f0eb1-df46-4dbb-9797-8e11f6ea1258",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95942b49-8cc2-4727-8c5c-c892c766937c",
      target: "97f20729-8bf3-434f-b95e-51d046df0f22"
    },
    {
      id: "20b08c46-6e07-45b6-813e-201fa5708608",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cb51919a-1622-40c2-8ef2-b8d016e5936a",
      target: "ad26aff8-ebc1-4079-b5f2-0ba8509da261"
    },
    {
      id: "d2108b97-a85f-4684-828a-285248ad2717",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "255e7e40-55ee-4e1a-84ef-521216aab2b2",
      target: "0c7cef71-749b-479e-b852-0874ef4090ed"
    },
    {
      id: "38060e28-5d2c-4ba3-bb8c-e01144c3960c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "97f20729-8bf3-434f-b95e-51d046df0f22",
      target: "10d6132e-af3e-4946-a1ac-d3f8723691e0"
    },
    {
      id: "5fb98d33-9ddb-4377-93ac-56a9c61cb43d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad26aff8-ebc1-4079-b5f2-0ba8509da261",
      target: "10d6132e-af3e-4946-a1ac-d3f8723691e0"
    },
    {
      id: "80a3e4ad-8b7e-41c1-b66d-958e4df38bb1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c7cef71-749b-479e-b852-0874ef4090ed",
      target: "182eb0a8-c8a3-4365-a0ae-96426cdba0d2"
    },
    {
      id: "a1291045-5360-4e61-bb0f-17ae85c28e28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c7cef71-749b-479e-b852-0874ef4090ed",
      target: "10d6132e-af3e-4946-a1ac-d3f8723691e0"
    },
    {
      id: "8bcdaa0d-ccda-4136-aad7-f43ee196d2d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "182eb0a8-c8a3-4365-a0ae-96426cdba0d2",
      target: "91520a4a-d795-4ef1-a8dd-bbca46f31c00"
    },
    {
      id: "dbd3840b-4911-411d-9b28-d271844eb52d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "99342262-539e-4a89-9db5-728c05c3d3cb",
      target: "6a90ebf2-8f87-404e-8afe-0b81d587a812"
    },
    {
      id: "829d1f9b-ec17-4bf0-baa5-57973c55fb63",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d1fd528-15ba-4b0a-b9fe-6db5c2cf7dc6",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "92721c70-f008-4a9c-a308-ed1428975260",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d1fd528-15ba-4b0a-b9fe-6db5c2cf7dc6",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "5983d84c-fe2b-49b9-9be6-2b807db5ff19",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58d7b1e7-47c2-48aa-9974-1f34d580d295",
      target: "b0a0be6f-c27b-4f12-bd96-5e75d61c6b30"
    },
    {
      id: "a500f87a-94eb-4149-aac2-db0955d82240",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58d7b1e7-47c2-48aa-9974-1f34d580d295",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "220c9a5b-522a-45db-a2d2-18bc9ffcb763",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58d7b1e7-47c2-48aa-9974-1f34d580d295",
      target: "709297a5-547d-446e-a726-780540dac865"
    },
    {
      id: "5000b868-42cb-4fc9-b654-1c30acfd5817",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "58d7b1e7-47c2-48aa-9974-1f34d580d295",
      target: "1736fc13-a761-4ead-9995-4f12c77a69b1"
    },
    {
      id: "c5e3da03-3574-49b7-8daa-dd97101b3872",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0a0be6f-c27b-4f12-bd96-5e75d61c6b30",
      target: "2d1fd528-15ba-4b0a-b9fe-6db5c2cf7dc6"
    },
    {
      id: "69b9b7c8-4c7c-4fe9-90ad-26a7db946aca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b0a0be6f-c27b-4f12-bd96-5e75d61c6b30",
      target: "c860143a-268a-4c26-a550-24782dd68030"
    },
    {
      id: "ec83849b-70bf-44f3-ac63-2e39767783a6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "c860143a-268a-4c26-a550-24782dd68030",
      target: "081832f7-b3b1-4bd7-9370-24fb18b4c698"
    },
    {
      id: "455d8695-5c92-43c0-b072-7951d33dbc0b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c860143a-268a-4c26-a550-24782dd68030",
      target: "e1a50cf9-01c9-40e3-82ee-86c74229ea77"
    },
    {
      id: "788ff2c7-309e-495b-abc6-83773a362cf2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c860143a-268a-4c26-a550-24782dd68030",
      target: "652f2110-2640-43d1-a516-940cd51ee8e6"
    },
    {
      id: "b431f18b-e21d-4b32-b725-80b30e98582e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c860143a-268a-4c26-a550-24782dd68030",
      target: "4e12a895-47e2-4fea-9409-b26dbde1e9e5"
    },
    {
      id: "a90e7a88-c142-48f3-87ff-2bcdac628378",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "081832f7-b3b1-4bd7-9370-24fb18b4c698",
      target: "e1a50cf9-01c9-40e3-82ee-86c74229ea77"
    },
    {
      id: "323d81c3-5b37-4244-99e0-6c11de44a129",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e1a50cf9-01c9-40e3-82ee-86c74229ea77",
      target: "10d6132e-af3e-4946-a1ac-d3f8723691e0"
    },
    {
      id: "cd31c60c-9bf5-4c24-8cec-90f1dfd6bfd4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4e12a895-47e2-4fea-9409-b26dbde1e9e5",
      target: "563acf81-2601-48a9-8475-3b199c4ad204"
    },
    {
      id: "d7b9b5bd-68dd-42f9-9ec4-57c7588a3766",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "652f2110-2640-43d1-a516-940cd51ee8e6",
      target: "e24747f5-816d-4bf2-9173-eb8c929bf49a"
    },
    {
      id: "b9aa54af-91f9-4020-8719-dbe5f4ceb8f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "10d6132e-af3e-4946-a1ac-d3f8723691e0",
      target: "95aba7da-d379-46ce-879c-8c8f743a9f50"
    },
    {
      id: "e48fca4d-c0c5-4099-b09c-fee58184339a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "563acf81-2601-48a9-8475-3b199c4ad204",
      target: "bdd6bcc9-6cee-478a-9438-c01d15187d91"
    },
    {
      id: "9693b320-197e-4677-aa26-9c8839e1279c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e24747f5-816d-4bf2-9173-eb8c929bf49a",
      target: "cc1d02ba-1984-4145-b198-531dd6c14d25"
    },
    {
      id: "99c0213c-641f-4e54-abff-c22d0e6a75fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95aba7da-d379-46ce-879c-8c8f743a9f50",
      target: "3853d88d-339f-4ae8-908a-4179da4bf774"
    },
    {
      id: "20b1d9fa-cd84-4344-b22f-48618fa6ea39",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdd6bcc9-6cee-478a-9438-c01d15187d91",
      target: "3853d88d-339f-4ae8-908a-4179da4bf774"
    },
    {
      id: "861f52fc-811c-4ad3-ac0c-80657f4f3577",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc1d02ba-1984-4145-b198-531dd6c14d25",
      target: "91520a4a-d795-4ef1-a8dd-bbca46f31c00"
    },
    {
      id: "e4c5a0bc-3565-4408-a0eb-a1c7972ffece",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc1d02ba-1984-4145-b198-531dd6c14d25",
      target: "3853d88d-339f-4ae8-908a-4179da4bf774"
    },
    {
      id: "d4455753-563e-4c97-b24f-07b9fc16837e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91520a4a-d795-4ef1-a8dd-bbca46f31c00",
      target: "ed7dd393-fd7e-464c-898a-edacf37d512b"
    },
    {
      id: "8ad7a65d-50a7-4d7e-89f1-113ef5db1ea0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "709297a5-547d-446e-a726-780540dac865",
      target: "c860143a-268a-4c26-a550-24782dd68030"
    },
    {
      id: "171d3bbd-fa03-4a5f-bd6f-6e341e85fe3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1736fc13-a761-4ead-9995-4f12c77a69b1",
      target: "3343dfa3-8d89-4dea-b9e4-bc6003a58e32"
    },
    {
      id: "08c06b29-44ec-4ad6-8952-44520fcf2db7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1736fc13-a761-4ead-9995-4f12c77a69b1",
      target: "12776a45-9909-4c8a-8258-6a75b852bdba"
    },
    {
      id: "9db73f37-92bd-44dd-b0a4-6aeff2e07add",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1736fc13-a761-4ead-9995-4f12c77a69b1",
      target: "223ba065-6c21-4807-b711-f005d438d0c7"
    },
    {
      id: "e9a1243e-4b1c-40c8-b0b3-e126ff41f5b6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3343dfa3-8d89-4dea-b9e4-bc6003a58e32",
      target: "b703f064-2122-4c51-9118-8de2a8062aee"
    },
    {
      id: "b7ecbe5e-699f-445a-90a6-0ca4025924ef",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b703f064-2122-4c51-9118-8de2a8062aee",
      target: "228f0caf-751b-4c4b-8a9a-b80fc683303d"
    },
    {
      id: "849d270b-9a80-4331-855e-96522d219e27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b703f064-2122-4c51-9118-8de2a8062aee",
      target: "e836e317-00e8-4486-8dc1-35dcfca1db61"
    },
    {
      id: "6d36dffa-03b2-4dde-9b9e-6a1324cdb730",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b703f064-2122-4c51-9118-8de2a8062aee",
      target: "3d493c5a-a2fa-4047-ab7a-3ecda09d5464"
    },
    {
      id: "01788464-4658-47a4-b70c-d029938f8363",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b703f064-2122-4c51-9118-8de2a8062aee",
      target: "9babbde7-21a0-417a-8a39-3490e28568ed"
    },
    {
      id: "0b540fc8-4a2b-4bcf-b05b-884d91af9fd2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "228f0caf-751b-4c4b-8a9a-b80fc683303d",
      target: "e836e317-00e8-4486-8dc1-35dcfca1db61"
    },
    {
      id: "8b06f16e-a2b2-4c71-8dbd-6fe3d99cb091",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e836e317-00e8-4486-8dc1-35dcfca1db61",
      target: "3853d88d-339f-4ae8-908a-4179da4bf774"
    },
    {
      id: "10163dcb-dcb9-454a-96b5-f5da39a00bd5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d493c5a-a2fa-4047-ab7a-3ecda09d5464",
      target: "695ee57c-988e-4f3c-98ce-cffafd905cad"
    },
    {
      id: "1e81b126-3ef4-40df-b281-2804d613373d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9babbde7-21a0-417a-8a39-3490e28568ed",
      target: "2b3e640a-0ddf-4df8-b656-3100b2422ab8"
    },
    {
      id: "b1de2f15-e5c5-4371-b7b0-646b9beb296d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3853d88d-339f-4ae8-908a-4179da4bf774",
      target: "59ab9f2a-e795-4791-aaee-5242b1540274"
    },
    {
      id: "e538766b-70f0-4fb1-8f55-09e31acdbb3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "695ee57c-988e-4f3c-98ce-cffafd905cad",
      target: "d2bafa63-41bc-4ea8-b5c0-3878b473b020"
    },
    {
      id: "cfcb648b-2b41-4e37-8e1e-e8d3ab41d380",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2b3e640a-0ddf-4df8-b656-3100b2422ab8",
      target: "bdfc8e43-0d5e-4804-a923-09335b93520b"
    },
    {
      id: "ca74d399-f7df-426b-92d2-bf91feb79ae4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59ab9f2a-e795-4791-aaee-5242b1540274",
      target: "b42b685a-9160-415a-8bd2-0f1009adfcc7"
    },
    {
      id: "2073b0ba-f726-4658-9f35-731d222e60df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2bafa63-41bc-4ea8-b5c0-3878b473b020",
      target: "b42b685a-9160-415a-8bd2-0f1009adfcc7"
    },
    {
      id: "8791758b-f718-46d6-9d82-967dfeb2d866",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdfc8e43-0d5e-4804-a923-09335b93520b",
      target: "b42b685a-9160-415a-8bd2-0f1009adfcc7"
    },
    {
      id: "4d0bbf30-59cf-4694-b635-1bbfb2bc4828",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bdfc8e43-0d5e-4804-a923-09335b93520b",
      target: "ed7dd393-fd7e-464c-898a-edacf37d512b"
    },
    {
      id: "f9a451db-2c23-47f5-bde3-a2d44b2581a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ed7dd393-fd7e-464c-898a-edacf37d512b",
      target: "485c9ae3-1503-474c-a626-391e5d2b494e"
    },
    {
      id: "2770b14f-6a71-4bb1-a533-3565ef3b93f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "12776a45-9909-4c8a-8258-6a75b852bdba",
      target: "b703f064-2122-4c51-9118-8de2a8062aee"
    },
    {
      id: "9bcfa34f-146c-499f-a53f-8153bd96d394",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "223ba065-6c21-4807-b711-f005d438d0c7",
      target: "f24708ae-3472-4332-a5d3-8daad7ccff0b"
    },
    {
      id: "8108f4b4-f01a-45d1-b010-2ad634c2b766",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "223ba065-6c21-4807-b711-f005d438d0c7",
      target: "881cdbd2-ea67-413b-81e0-5200f2773df9"
    },
    {
      id: "e9d70f9c-4ff3-41ae-aa89-94cafb584a39",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "223ba065-6c21-4807-b711-f005d438d0c7",
      target: "04f774a3-5265-4330-9d5b-d31481486089"
    },
    {
      id: "b0e1cc86-b58d-41f8-9746-001e64a03ee4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f24708ae-3472-4332-a5d3-8daad7ccff0b",
      target: "0d0af951-e907-4302-a30d-347bd603f2db"
    },
    {
      id: "54e32316-b363-4024-84be-b619fb9a399e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f24708ae-3472-4332-a5d3-8daad7ccff0b",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "09e9d3f9-2400-4198-b640-17914bfccc98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d0af951-e907-4302-a30d-347bd603f2db",
      target: "0e638283-18ef-4adb-a7ce-064ebc7df6fd"
    },
    {
      id: "d3a56ed3-10f8-474e-94eb-b937d19565c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d0af951-e907-4302-a30d-347bd603f2db",
      target: "e768cad3-45de-4e6d-8577-f42b9df4b3ae"
    },
    {
      id: "978147c2-5de3-48c8-89d7-6875970d976c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0d0af951-e907-4302-a30d-347bd603f2db",
      target: "ac7067c5-84d2-40b2-8dad-e4a29c924c6e"
    },
    {
      id: "0a1072d4-1c2c-4b75-b66e-3142abf4d48f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0d0af951-e907-4302-a30d-347bd603f2db",
      target: "728b0680-5a9d-42ed-9bab-c06a6ac71d41"
    },
    {
      id: "fd74d25d-1779-46e4-ba22-836cd1f3f683",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "728b0680-5a9d-42ed-9bab-c06a6ac71d41",
      target: "e768cad3-45de-4e6d-8577-f42b9df4b3ae"
    },
    {
      id: "e9dd7d58-9e1d-4614-ae34-668c4f8699c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e768cad3-45de-4e6d-8577-f42b9df4b3ae",
      target: "b42b685a-9160-415a-8bd2-0f1009adfcc7"
    },
    {
      id: "50f9c39f-06c8-4a8e-9a9d-3eb3689ada36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac7067c5-84d2-40b2-8dad-e4a29c924c6e",
      target: "972c4f41-09b7-4b18-89cd-89f2984b7637"
    },
    {
      id: "699a888f-5d8c-42cd-af04-aa190dcb5893",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e638283-18ef-4adb-a7ce-064ebc7df6fd",
      target: "fe6ed863-f98f-4dec-9f27-15c250e7170c"
    },
    {
      id: "42e6c16f-f9f8-440c-b0ae-3bf4b1944208",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b42b685a-9160-415a-8bd2-0f1009adfcc7",
      target: "007e9ce2-35ab-48f7-b076-9a6bf08a756b"
    },
    {
      id: "82ecc1cd-93c1-4755-a7b0-28af0954cbf6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "972c4f41-09b7-4b18-89cd-89f2984b7637",
      target: "46d1dfef-3c3f-4b1d-9637-a20b18a1a139"
    },
    {
      id: "a350507b-1cdb-4672-ab03-f7f5fdfe4d99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fe6ed863-f98f-4dec-9f27-15c250e7170c",
      target: "27774246-5e3a-4ebc-b3a5-eff91665cdc0"
    },
    {
      id: "f117b4b9-f10d-4b25-8f1c-5c44ed233bb9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "007e9ce2-35ab-48f7-b076-9a6bf08a756b",
      target: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3"
    },
    {
      id: "886f1ab7-99c7-49d0-8f38-2d9557f7cf35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46d1dfef-3c3f-4b1d-9637-a20b18a1a139",
      target: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3"
    },
    {
      id: "44e470e2-d163-49c8-83aa-16ddec571c83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27774246-5e3a-4ebc-b3a5-eff91665cdc0",
      target: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3"
    },
    {
      id: "513f927b-0fa8-4b56-96ea-9ea34e3878bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "27774246-5e3a-4ebc-b3a5-eff91665cdc0",
      target: "485c9ae3-1503-474c-a626-391e5d2b494e"
    },
    {
      id: "6dfd348a-9d17-4f79-8abe-ea2b09f31646",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "485c9ae3-1503-474c-a626-391e5d2b494e",
      target: "d22ec166-8389-4a47-b802-6340e6461c6b"
    },
    {
      id: "cae41df3-9c2f-4d79-ae98-a66715f5770c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "881cdbd2-ea67-413b-81e0-5200f2773df9",
      target: "0d0af951-e907-4302-a30d-347bd603f2db"
    },
    {
      id: "bdb930be-816f-48f0-9385-85b76cd32372",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db2e9e89-180f-4675-9000-19af8c9e6c88",
      target: "fc703e84-7503-42d6-8ac8-cc0c0c5b888d"
    },
    {
      id: "e5768505-3566-4dff-ac67-91ac8d9b5213",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "db2e9e89-180f-4675-9000-19af8c9e6c88",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "4e0178e9-c8e9-4242-a2ad-e8cbf0946a9b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04f774a3-5265-4330-9d5b-d31481486089",
      target: "43d42ebe-27bd-4d84-bb35-170cf20f2b46"
    },
    {
      id: "6ba72989-414c-41c8-a18c-2d1109b02209",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04f774a3-5265-4330-9d5b-d31481486089",
      target: "b51a00f8-c294-4f79-8a59-46f0176024a8"
    },
    {
      id: "a493e559-7221-47b7-a725-c6bc70f3aec7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04f774a3-5265-4330-9d5b-d31481486089",
      target: "c44f2f8c-314c-4a74-ade0-0ffc414d3176"
    },
    {
      id: "c8e034b5-fb24-42f1-be3a-1626dcfe45c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43d42ebe-27bd-4d84-bb35-170cf20f2b46",
      target: "db2e9e89-180f-4675-9000-19af8c9e6c88"
    },
    {
      id: "fe3b07ba-0e5a-4fe3-a70c-e8d392cf4678",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "43d42ebe-27bd-4d84-bb35-170cf20f2b46",
      target: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1"
    },
    {
      id: "057c2e0f-ec30-4258-b425-675e7b40ac45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1",
      target: "7e4d0455-701f-4f8d-9b1a-571e5c9a1fc5"
    },
    {
      id: "baa317d4-8c29-45e0-9226-7bbb77c428d5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1",
      target: "5b1579e2-572a-4454-b067-6883bf03177b"
    },
    {
      id: "5e03c26e-0eeb-4f9c-a376-f7d84166ee02",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1",
      target: "80e77f40-76c0-4a7a-ae17-09e0655312dd"
    },
    {
      id: "5b346cc6-e816-4368-9a27-094a854df2f8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1",
      target: "60fde966-b2db-4672-b592-2bdc8d06f1d2"
    },
    {
      id: "c24269b1-6998-4dfd-b3e7-b9054553eca6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60fde966-b2db-4672-b592-2bdc8d06f1d2",
      target: "5b1579e2-572a-4454-b067-6883bf03177b"
    },
    {
      id: "985a2553-f019-4f99-bfbe-a8ee31b6eb28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b1579e2-572a-4454-b067-6883bf03177b",
      target: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3"
    },
    {
      id: "f1825ea0-f673-4c16-8b05-0f6f21ab0398",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7e4d0455-701f-4f8d-9b1a-571e5c9a1fc5",
      target: "d7202a85-e01b-4fa0-a22d-b443d9c29d15"
    },
    {
      id: "79aff184-1bf8-4d3a-99ed-77bc02f74798",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "80e77f40-76c0-4a7a-ae17-09e0655312dd",
      target: "6cb5740c-921b-4c90-9648-0e073cfc6e31"
    },
    {
      id: "eb36f393-6053-42b2-bd29-27787b6d42ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03b81c0c-19fc-411b-aa47-5b98dd64fbb3",
      target: "0e30c19f-2d41-468b-aad0-54a4e34d2ca4"
    },
    {
      id: "02a97d46-3dbd-4c0f-9922-ec138c12180b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7202a85-e01b-4fa0-a22d-b443d9c29d15",
      target: "d36283d5-6b98-441f-9a29-0e88634ff546"
    },
    {
      id: "009a5fc2-1f25-47d4-8f06-ed03395dbbca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6cb5740c-921b-4c90-9648-0e073cfc6e31",
      target: "31ddad05-7693-4918-890c-6785812b5182"
    },
    {
      id: "fd746fdd-b226-4921-9fec-a301e7db9ad2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e30c19f-2d41-468b-aad0-54a4e34d2ca4",
      target: "bc79d762-9494-4e90-adc4-400081a65a92"
    },
    {
      id: "3efa3490-9644-465c-a898-24b2c0ec3f1d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d36283d5-6b98-441f-9a29-0e88634ff546",
      target: "bc79d762-9494-4e90-adc4-400081a65a92"
    },
    {
      id: "ed90a453-8bfc-4cab-a936-54478cb08ea9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31ddad05-7693-4918-890c-6785812b5182",
      target: "d22ec166-8389-4a47-b802-6340e6461c6b"
    },
    {
      id: "084693c3-181e-4a33-9cec-bc0d5bfe0a0e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "31ddad05-7693-4918-890c-6785812b5182",
      target: "bc79d762-9494-4e90-adc4-400081a65a92"
    },
    {
      id: "0cd6b02c-3019-4ff7-85b2-2ce51e021549",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d22ec166-8389-4a47-b802-6340e6461c6b",
      target: "7cf722b6-2bf1-47dc-be2b-b2f9c40eb113"
    },
    {
      id: "1b878786-b18a-46c2-9b14-e6ae649030f8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b51a00f8-c294-4f79-8a59-46f0176024a8",
      target: "4b901f2d-b292-4ce1-83a0-5c080e1ecfc1"
    },
    {
      id: "0f100832-1a7f-40a2-8733-03cdbc7cd4c1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c44f2f8c-314c-4a74-ade0-0ffc414d3176",
      target: "906ea534-9c2d-4898-8b72-bbc05f7a23c9"
    },
    {
      id: "c266c6ea-358c-4795-83cd-1f1d0ec8a09e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c44f2f8c-314c-4a74-ade0-0ffc414d3176",
      target: "870f2979-608f-4349-94c0-af2a81850811"
    },
    {
      id: "fde61d8a-fb5d-463e-8a3d-71f3a8085bcd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c44f2f8c-314c-4a74-ade0-0ffc414d3176",
      target: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f"
    },
    {
      id: "824daf55-8ff8-4bc0-b71d-6c5cb18ca55f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "906ea534-9c2d-4898-8b72-bbc05f7a23c9",
      target: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd"
    },
    {
      id: "3228a60a-e576-49eb-a3f8-5cc83e665978",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd",
      target: "669551d8-12a4-4f88-813b-aab27dcf4b63"
    },
    {
      id: "0e514566-bec0-4809-bb66-369c52d3d5f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd",
      target: "6f7c798d-db7b-498b-8f2b-b7693ae46690"
    },
    {
      id: "fb4384da-cd86-4298-ab81-afc4292eff1f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd",
      target: "af4069ae-940a-4275-a19a-93e19b691a7c"
    },
    {
      id: "48537dfe-7b9c-4444-9100-e0f03f5f416b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd",
      target: "c2a2b756-e3e1-4cdd-81fd-d1606bba7c95"
    },
    {
      id: "0ec693c9-7da3-4bca-b901-9a121209b304",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "669551d8-12a4-4f88-813b-aab27dcf4b63",
      target: "af4069ae-940a-4275-a19a-93e19b691a7c"
    },
    {
      id: "022d1edc-2e89-4ac7-b1ea-b6173973d281",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "af4069ae-940a-4275-a19a-93e19b691a7c",
      target: "bc79d762-9494-4e90-adc4-400081a65a92"
    },
    {
      id: "a1a805bf-6930-4755-b825-508c995e0062",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6f7c798d-db7b-498b-8f2b-b7693ae46690",
      target: "2940ae46-ce59-4161-b8b2-d53ca7bfc4c7"
    },
    {
      id: "97a9deca-48aa-409e-8807-b1ec8996a756",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2a2b756-e3e1-4cdd-81fd-d1606bba7c95",
      target: "b6df6ecb-e802-4ece-8ab5-1c6c30c6c3cb"
    },
    {
      id: "e2a79d40-11d0-49e8-a37c-c140e4660af2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc79d762-9494-4e90-adc4-400081a65a92",
      target: "1441fcff-90b8-44d7-91cc-2e2bd1c9a1d0"
    },
    {
      id: "fc78b2ff-b09d-4b9c-9a02-3e1f41d73526",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2940ae46-ce59-4161-b8b2-d53ca7bfc4c7",
      target: "2dd17f0b-6599-4106-bfb9-f19dee480171"
    },
    {
      id: "04a6feb8-1558-4a95-907f-e1850483a25f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6df6ecb-e802-4ece-8ab5-1c6c30c6c3cb",
      target: "a227880f-59ea-42d0-9b8d-f43ef4b21fb7"
    },
    {
      id: "f41f554d-b9e8-4a44-8268-762fc1f7ee5b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1441fcff-90b8-44d7-91cc-2e2bd1c9a1d0",
      target: "85ed5f66-b495-4c78-8526-5e496be64016"
    },
    {
      id: "a2a61e08-696c-4b95-976b-6856885e8cc2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2dd17f0b-6599-4106-bfb9-f19dee480171",
      target: "85ed5f66-b495-4c78-8526-5e496be64016"
    },
    {
      id: "f8cbd01b-cc96-4fde-b204-767a02e92db4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a227880f-59ea-42d0-9b8d-f43ef4b21fb7",
      target: "85ed5f66-b495-4c78-8526-5e496be64016"
    },
    {
      id: "4fdbce38-70f3-4eac-a05b-31a4c80aff8e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a227880f-59ea-42d0-9b8d-f43ef4b21fb7",
      target: "7cf722b6-2bf1-47dc-be2b-b2f9c40eb113"
    },
    {
      id: "c0161666-3f24-46b4-8e91-a3d215240c54",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cf722b6-2bf1-47dc-be2b-b2f9c40eb113",
      target: "0a1468d6-af14-4368-bf7a-778b22713dd5"
    },
    {
      id: "9a09d819-0c7c-43b3-9ba2-57b54fab70f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "870f2979-608f-4349-94c0-af2a81850811",
      target: "fcbfdeba-c858-4a0c-bba6-7c0a21655ffd"
    },
    {
      id: "2da86215-38d3-446e-81d6-fcd9c021545d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f",
      target: "3d72c927-328e-4896-a719-ac1d8a442e91"
    },
    {
      id: "df12501e-6b87-4f85-978c-80fde3bbeeee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "81c57c8b-3fe5-4165-bac8-bca3de86cf2f",
      target: "b984189e-966b-4dde-bb44-3dc7ce7c198b"
    },
    {
      id: "342861f7-8664-46c3-aea2-b4d6bec45afd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d72c927-328e-4896-a719-ac1d8a442e91",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "c64c951e-63ad-401a-a594-e60529448d27",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3d72c927-328e-4896-a719-ac1d8a442e91",
      target: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce"
    },
    {
      id: "818b0e1b-3e35-4396-a473-102a224a123c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce",
      target: "e0fcef82-240d-47ff-9032-8c96d8374b78"
    },
    {
      id: "2936f0f5-043f-4531-96bf-00f4a2c7322f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce",
      target: "b9d8df39-d15a-4838-9afd-6c53841fe141"
    },
    {
      id: "03954a94-5add-475e-9b89-e123d6d2cef8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce",
      target: "bc4d521c-1316-4309-b8ce-31f2d56b230b"
    },
    {
      id: "70ece784-860d-46c6-8021-3c38aa54a827",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce",
      target: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd"
    },
    {
      id: "066c672e-eabf-438c-9a97-17506a65f892",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd",
      target: "effd8d58-dc6c-49f8-badf-8daf3e609d1e"
    },
    {
      id: "97e1c5bc-7601-4fb7-b64a-5c224f69c95c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd",
      target: "0df78865-60c8-4bad-aa6c-6afed85458a3"
    },
    {
      id: "e7a248ad-7060-451b-9fa7-c443ead3dea7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd",
      target: "b9d8df39-d15a-4838-9afd-6c53841fe141"
    },
    {
      id: "df2fbfd8-ed99-45a8-ae27-1983866bf0b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b9d8df39-d15a-4838-9afd-6c53841fe141",
      target: "85ed5f66-b495-4c78-8526-5e496be64016"
    },
    {
      id: "153004c5-984a-49ba-8c17-78e2e18f4029",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b9d8df39-d15a-4838-9afd-6c53841fe141",
      target: "0df78865-60c8-4bad-aa6c-6afed85458a3"
    },
    {
      id: "7d70e379-193a-4b80-bd2f-f5a6edf6f3d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc4d521c-1316-4309-b8ce-31f2d56b230b",
      target: "f4fffe37-0e28-475b-8a02-ceaea1b08640"
    },
    {
      id: "0ca2f23d-1496-416a-a296-2114d0dbce9f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bc4d521c-1316-4309-b8ce-31f2d56b230b",
      target: "0df78865-60c8-4bad-aa6c-6afed85458a3"
    },
    {
      id: "05247e77-fe56-444c-ad37-754933f8057b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e0fcef82-240d-47ff-9032-8c96d8374b78",
      target: "1a307ad1-9b1d-40cb-b332-5059f338ba19"
    },
    {
      id: "0d633cb2-9ad2-4970-a353-d6b6a36d1bcf",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e0fcef82-240d-47ff-9032-8c96d8374b78",
      target: "0df78865-60c8-4bad-aa6c-6afed85458a3"
    },
    {
      id: "c6937018-99db-4e5e-8b27-19d86fc6f33f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "85ed5f66-b495-4c78-8526-5e496be64016",
      target: "d209a79f-e610-4e56-ae59-10cfa26208d2"
    },
    {
      id: "ca81b92a-b57a-4d37-9297-b19cc0a57366",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f4fffe37-0e28-475b-8a02-ceaea1b08640",
      target: "5d1d3835-af93-4615-b481-7ed2c7075bf8"
    },
    {
      id: "499dad93-1352-4ccc-ba3a-cc5d412e6f45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1a307ad1-9b1d-40cb-b332-5059f338ba19",
      target: "8638001b-82c2-4817-8236-55342481c5a7"
    },
    {
      id: "2d5cca50-3dab-41ac-a25c-a5be8dc73a37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d209a79f-e610-4e56-ae59-10cfa26208d2",
      target: "de63d88b-d875-4799-affc-e40d06712eb0"
    },
    {
      id: "e8a6b827-d05a-4c3a-a35a-2c4dfe02a869",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d1d3835-af93-4615-b481-7ed2c7075bf8",
      target: "de63d88b-d875-4799-affc-e40d06712eb0"
    },
    {
      id: "ebf5fbce-ba96-496a-aae6-e4016ac73a48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8638001b-82c2-4817-8236-55342481c5a7",
      target: "de63d88b-d875-4799-affc-e40d06712eb0"
    },
    {
      id: "5ab952b9-e6e0-4a85-92c5-0b096e2ce0f9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8638001b-82c2-4817-8236-55342481c5a7",
      target: "0a1468d6-af14-4368-bf7a-778b22713dd5"
    },
    {
      id: "232bcf0a-c0d6-43c0-894b-4cabd32f4270",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0a1468d6-af14-4368-bf7a-778b22713dd5",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "d1b4ea01-aeca-40d5-b417-c3bfdb71a111",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b984189e-966b-4dde-bb44-3dc7ce7c198b",
      target: "a5759b5f-7fd5-47f0-9359-5c6baa6f64ce"
    },
    {
      id: "e44130cd-4a3d-457b-aa75-c9e4aa625c11",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aee97459-2415-41ba-a558-125048895c07",
      target: "8638001b-82c2-4817-8236-55342481c5a7"
    },
    {
      id: "76857cbf-9738-4d1f-af38-613cbcf03f4e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "aee97459-2415-41ba-a558-125048895c07",
      target: "520f5e0f-9ae8-49a8-aae9-8bc4dd12fe8a"
    },
    {
      id: "bc96fcdf-20e0-48c2-bde7-f538ec55939d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "520f5e0f-9ae8-49a8-aae9-8bc4dd12fe8a",
      target: "5ada196f-e4bb-4805-93b9-8a0265c7cdcd"
    },
    {
      id: "056474fb-b31d-493c-8be4-8ea1a37b345d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "479b6606-d49b-4fe5-88c7-f4f4c95b0585",
      target: "60c968a0-95b9-47f0-b58e-3e8974073d1d"
    },
    {
      id: "e2d5f9b3-0c63-4cff-820e-96d08a0d382f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "479b6606-d49b-4fe5-88c7-f4f4c95b0585",
      target: "8baf8aa6-de03-40c5-b789-393f90891135"
    },
    {
      id: "bf559370-bb52-4fb4-be15-a97f2bac21aa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0db73a88-707d-4f71-add5-96bcc57042dd",
      target: "aecb3155-a072-400f-ac87-21c55b5bc4be"
    },
    {
      id: "4bb7140a-9ce2-4cc2-b74d-a825a3f7800a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8baf8aa6-de03-40c5-b789-393f90891135",
      target: "0db73a88-707d-4f71-add5-96bcc57042dd"
    },
    {
      id: "ee497b18-b4ff-4289-9c07-5962797f3635",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8baf8aa6-de03-40c5-b789-393f90891135",
      target: "60c968a0-95b9-47f0-b58e-3e8974073d1d"
    },
    {
      id: "8c391a16-c0d6-49ed-aede-5d55803a8ad9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "863e77f4-e6c7-4844-a3d2-f3f230182965",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "6bb53d69-5516-4f45-b94d-670238a74097",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f34ec909-44e0-43c6-b838-519286a54799",
      target: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7"
    },
    {
      id: "5e717c3f-baa2-4883-b618-58b09df15be8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f34ec909-44e0-43c6-b838-519286a54799",
      target: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402"
    },
    {
      id: "9ff871c3-81fd-48d1-aff8-bc6255c8009a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f34ec909-44e0-43c6-b838-519286a54799",
      target: "863e77f4-e6c7-4844-a3d2-f3f230182965"
    },
    {
      id: "87e6a47c-7678-461d-9d5d-5071212d6e25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402",
      target: "b3045a71-cc67-46fe-8b41-5077137d1d69"
    },
    {
      id: "2682564b-32c9-4528-822f-89a0623ead52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ec4fbe8d-2ad3-4725-a433-7dfac2c5e402",
      target: "a6195c81-df9e-4adb-9255-efb1e48d1cf8"
    },
    {
      id: "a526160e-ecc9-4de8-84e4-364e44edbd82",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6195c81-df9e-4adb-9255-efb1e48d1cf8",
      target: "3722bcc6-e411-4ccb-870c-4c921d9a5b51"
    },
    {
      id: "21f7f9be-7a2b-43a5-a8fd-a51f463c58ea",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a6195c81-df9e-4adb-9255-efb1e48d1cf8",
      target: "712026df-e261-4bf5-83f6-fde03953e676"
    },
    {
      id: "7e4d42e2-49fe-4f9c-8e36-7b743257d89c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "712026df-e261-4bf5-83f6-fde03953e676",
      target: "2054a24c-df62-464a-ab5a-a0762c98e1de"
    },
    {
      id: "df14e060-e2bf-46df-b8c0-66d0ee98b761",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2054a24c-df62-464a-ab5a-a0762c98e1de",
      target: "ac899d05-1cea-4c66-ac62-acae0311db54"
    },
    {
      id: "2fac1fd7-d605-4d01-a3af-8a38cea207c7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac899d05-1cea-4c66-ac62-acae0311db54",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "d3c12e88-1a5c-4b81-b21e-92c6ac80bdc7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac899d05-1cea-4c66-ac62-acae0311db54",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "4fcdfe95-7361-4ae6-9ce9-1a88bc92ad83",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac899d05-1cea-4c66-ac62-acae0311db54",
      target: "2050da74-3800-4e4d-8d44-81a7e62d3473"
    },
    {
      id: "fd73830e-7221-49d2-a8fa-b033b1d25f65",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac899d05-1cea-4c66-ac62-acae0311db54",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "9c650c73-ffd1-4ccb-9941-bc1f8a8be782",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2050da74-3800-4e4d-8d44-81a7e62d3473",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "cb6d093a-b6da-4431-9561-4c1b2382708f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2050da74-3800-4e4d-8d44-81a7e62d3473",
      target: "6244fe39-242c-4213-9ac1-2bc00708c95b"
    },
    {
      id: "639ba046-e88e-4d6a-a2af-f2e0611ec115",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2050da74-3800-4e4d-8d44-81a7e62d3473",
      target: "92382b5d-09f4-4be1-b2f5-b1899eed6f80"
    },
    {
      id: "012e45c5-e579-444a-a786-c5eb417ce4a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2050da74-3800-4e4d-8d44-81a7e62d3473",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "f25bddf6-dc74-4b84-b4fb-6be5b52665a9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "30a5ddbe-ccd0-44a1-879b-7494dd1846a7",
      target: "a4902310-fe36-4f67-81dc-c6698d7f9917"
    },
    {
      id: "e10ac34c-c271-4bfc-9dfa-856e4962d8d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4902310-fe36-4f67-81dc-c6698d7f9917",
      target: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec"
    },
    {
      id: "63d70426-ec0e-4e0c-baaf-4ae214925c42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4902310-fe36-4f67-81dc-c6698d7f9917",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "fab58e58-c2bc-4ecb-b456-a72a437b0a25",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4902310-fe36-4f67-81dc-c6698d7f9917",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "40e006c9-f5aa-4ee8-8ffe-0104378bac16",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3722bcc6-e411-4ccb-870c-4c921d9a5b51",
      target: "23d6de3b-478c-4ff7-89f0-182b38e2e90d"
    },
    {
      id: "c87cd607-ee60-485b-88b2-95fb195370e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3722bcc6-e411-4ccb-870c-4c921d9a5b51",
      target: "7cb8621a-c516-48e9-8951-35e09b5803af"
    },
    {
      id: "6a803c1c-ef13-4971-bc93-3e04e3f475ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "23d6de3b-478c-4ff7-89f0-182b38e2e90d",
      target: "fb3b773d-6b3f-4a38-99a0-d2d6a90bd42c"
    },
    {
      id: "68b1db1b-bb3c-459d-93f6-9ae7e169d5dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fb3b773d-6b3f-4a38-99a0-d2d6a90bd42c",
      target: "4070e4e5-f57a-4d04-a48e-a1ca3f85bbb6"
    },
    {
      id: "7b76fd1b-5e89-4b95-9bcd-8c17154bcee5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4070e4e5-f57a-4d04-a48e-a1ca3f85bbb6",
      target: "61340a98-908f-43b0-a857-036cd0e3257e"
    },
    {
      id: "defe1e82-383e-421f-8938-632eb6872262",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61340a98-908f-43b0-a857-036cd0e3257e",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "0b4bc459-f598-4d9b-93e7-3bb0fc20bfa3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61340a98-908f-43b0-a857-036cd0e3257e",
      target: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c"
    },
    {
      id: "9f0587c2-142e-41db-9538-5d84efe6cefb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61340a98-908f-43b0-a857-036cd0e3257e",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "49fba017-f171-455c-9bfc-83ab4f759dc4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d66d5383-0992-47bc-a319-b3c126dd8fb3",
      target: "bc26256c-deb1-4c63-813d-3a9a4f47c500"
    },
    {
      id: "27c27e11-f5e9-48ab-b266-470425168fd0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d66d5383-0992-47bc-a319-b3c126dd8fb3",
      target: "347a5a1c-1296-4577-bd61-0caa76198185"
    },
    {
      id: "126128e5-6da7-47fe-9452-d43209987576",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d66d5383-0992-47bc-a319-b3c126dd8fb3",
      target: "57d0c9cd-3314-4818-8c8b-1da7e8c26151"
    },
    {
      id: "e46bbd22-b1ce-4ec3-a066-aa9352b23acf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc26256c-deb1-4c63-813d-3a9a4f47c500",
      target: "6e25f688-d12e-453f-9fac-0b6552fe54c9"
    },
    {
      id: "5cd01122-2f84-4182-bd4b-8429db86e446",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc26256c-deb1-4c63-813d-3a9a4f47c500",
      target: "04e876f5-e2e9-4116-af41-aff9550ebc46"
    },
    {
      id: "a25fb4ff-998d-4977-a02f-87d4f323da98",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bc26256c-deb1-4c63-813d-3a9a4f47c500",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "b70871ed-ca21-4fed-82f7-1725c6fafeb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04e876f5-e2e9-4116-af41-aff9550ebc46",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "ac6b5804-4e37-4823-a130-d3690dcb658f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04e876f5-e2e9-4116-af41-aff9550ebc46",
      target: "e525785a-854d-441a-b4d0-cc20a0fd9dec"
    },
    {
      id: "181e01b4-d09b-44dd-9059-45f82ebab887",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04e876f5-e2e9-4116-af41-aff9550ebc46",
      target: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016"
    },
    {
      id: "1ea84e30-3cf4-45f5-9422-acd3555ab42e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e525785a-854d-441a-b4d0-cc20a0fd9dec",
      target: "9d77e203-2558-4082-95d5-8a88999f2e4e"
    },
    {
      id: "570df349-9942-42c1-9268-3b6a64ee0928",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e525785a-854d-441a-b4d0-cc20a0fd9dec",
      target: "df62d19e-fb4e-443b-8a45-ddfaaf477694"
    },
    {
      id: "5f657a2c-b91f-4c01-9c76-de329a02b0de",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "33a147ac-f3bd-4827-8edc-e72977ca1c89"
    },
    {
      id: "826b3b2e-e1cd-4471-9707-88d2c1cbf795",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "c326228f-8c65-44f9-bab9-b8f64730433f"
    },
    {
      id: "16314b33-9dd8-4d16-bd17-92e66266d523",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "6eaf241b-c837-4e4e-ae35-788d9d0b8347"
    },
    {
      id: "4883a989-d36f-47c9-a16e-385634ab31e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "c84d3fdb-ea40-4fb4-8a46-023e0894a76f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb"
    },
    {
      id: "766da807-2dda-463e-a39c-d7fad407b8c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "5fadcab1-1647-4a91-9e20-0bbeb8331a28"
    },
    {
      id: "f59fb625-bd47-4b7f-a362-ed89cf2b2277",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "d66d5383-0992-47bc-a319-b3c126dd8fb3"
    },
    {
      id: "82d1a1ae-ac0c-4b2b-a8fc-55cd51193d9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2c0aa8e9-9041-4798-a518-f56f6e2c7f4c",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "d43d5121-016b-48d4-b6bf-9747ba350c42",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "3ac712e2-feea-4609-8252-c01b2d26fb01",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "347a5a1c-1296-4577-bd61-0caa76198185"
    },
    {
      id: "d24333ad-568c-4313-87c0-64739802530a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "f2570ac1-d93b-476e-b34f-0058465d0994",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "2c824a29-b625-4f37-a78f-907d6feaa77a"
    },
    {
      id: "bb9b4ddd-cf69-4a7f-a238-f1d8a6f10de2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "d878e5ad-598a-4bf6-8b48-6ad6087f03f3"
    },
    {
      id: "3e8e40df-2117-4dfd-8b5f-166b0e606c58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "9526bebb-4162-46bc-b1e8-52ab3e918068",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c048762d-b888-4a2b-8b77-d0b842a67069",
      target: "630aa7bf-92c2-498c-bb8b-83bd815e0475"
    },
    {
      id: "e30cab78-6be9-495b-b0e8-3ebd3779e0fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb",
      target: "630aa7bf-92c2-498c-bb8b-83bd815e0475"
    },
    {
      id: "9c8dddf3-d4e8-4f7a-b3c5-890ccf70d8c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb",
      target: "2c824a29-b625-4f37-a78f-907d6feaa77a"
    },
    {
      id: "07a50d73-886b-43bf-94dd-bcb84467244a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb",
      target: "e244cb5b-85f4-496d-b363-4d80ef240aef"
    },
    {
      id: "5ac1b5b8-2d7e-420c-80f3-13329d008b23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "82bb0085-a419-4f2d-a5b5-458a4d35c6eb",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "6d5590e6-3a5e-4bf6-9b0a-b9fa297bb165",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "5ef13ffd-36c1-415b-b6b8-875944a8de5a"
    },
    {
      id: "603be6c6-6f1c-429f-a629-f511b469c534",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "fbc6cd71-5a90-417c-8c22-e9957a99d91e"
    },
    {
      id: "ff7fa0f4-7929-40cb-93c7-528efc82ee79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "c7699246-bbba-4ca3-8a23-77c106b18bfa"
    },
    {
      id: "39e96d3f-a7af-4659-8efc-8d18c82efb28",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "8ef542cf-c45d-4953-90b7-97d7cfad9871"
    },
    {
      id: "f4c29986-fefb-4264-8adb-8ddb802870b5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "5fa0d780-9990-44cb-b4c7-aca5b7984910",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "347a5a1c-1296-4577-bd61-0caa76198185",
      target: "630aa7bf-92c2-498c-bb8b-83bd815e0475"
    },
    {
      id: "e1eb77d4-b287-4a87-a17e-d70a19848a4d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ef542cf-c45d-4953-90b7-97d7cfad9871",
      target: "556f6761-f13c-4fd4-b607-ba5bc889528f"
    },
    {
      id: "3cc44e47-8589-4349-852e-95addddf0993",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ef542cf-c45d-4953-90b7-97d7cfad9871",
      target: "f358bc82-0fcc-4b78-88c6-ee3bc4381404"
    },
    {
      id: "ab3f8786-634a-41a4-a2b0-c00f10dfa798",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ef542cf-c45d-4953-90b7-97d7cfad9871",
      target: "20a05c16-c7e4-4249-a243-ab32370d297d"
    },
    {
      id: "ce4928eb-a892-4679-b12b-4d5835cb733f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "20a05c16-c7e4-4249-a243-ab32370d297d",
      target: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd"
    },
    {
      id: "d81004df-1903-49b4-9ce0-91ff1f477881",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "20a05c16-c7e4-4249-a243-ab32370d297d",
      target: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0"
    },
    {
      id: "bbd66251-41e1-462d-9b51-49579506db6b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "20a05c16-c7e4-4249-a243-ab32370d297d",
      target: "9d77e203-2558-4082-95d5-8a88999f2e4e"
    },
    {
      id: "d2fc3636-8d15-452b-89a2-4d9f87a11c8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20a05c16-c7e4-4249-a243-ab32370d297d",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "473a9b2d-8aa6-47f0-8804-4046da78775e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "20a05c16-c7e4-4249-a243-ab32370d297d",
      target: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd"
    },
    {
      id: "56b20fe7-8405-48d5-90d8-cfb6954d114f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d77e203-2558-4082-95d5-8a88999f2e4e",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "97d28970-52d3-40a6-8a3e-ad4849558250",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9d77e203-2558-4082-95d5-8a88999f2e4e",
      target: "5d181cbf-c802-4ba2-95c7-642599af24b6"
    },
    {
      id: "da58a3cd-480e-4512-9bd5-53aa97b39bda",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d77e203-2558-4082-95d5-8a88999f2e4e",
      target: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e"
    },
    {
      id: "547b4073-ecdc-4696-bc0d-3bc9ae6bcf7a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d878e5ad-598a-4bf6-8b48-6ad6087f03f3",
      target: "fbc6cd71-5a90-417c-8c22-e9957a99d91e"
    },
    {
      id: "9a5b24ab-ca09-454e-8f87-11ab82c17a44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d878e5ad-598a-4bf6-8b48-6ad6087f03f3",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "cb7ad12b-c5ef-4475-ba05-dd233c531601",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e244cb5b-85f4-496d-b363-4d80ef240aef",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "41a3405b-7227-417e-93ca-e2aead7f5f52",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fbc6cd71-5a90-417c-8c22-e9957a99d91e",
      target: "f358bc82-0fcc-4b78-88c6-ee3bc4381404"
    },
    {
      id: "01ce0f09-ec5f-46ec-a191-0c427281bb21",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbc6cd71-5a90-417c-8c22-e9957a99d91e",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "fb32df27-8122-4d4a-ae9e-f4e0558105db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fbc6cd71-5a90-417c-8c22-e9957a99d91e",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "c3143865-2dc8-4a46-a131-295df498ec5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f358bc82-0fcc-4b78-88c6-ee3bc4381404",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "e6ace1a1-bf9c-40c9-9c0a-1a0b21920e04",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f358bc82-0fcc-4b78-88c6-ee3bc4381404",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "aeeee29e-4368-4b7e-89cb-31d69481f8ed",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f358bc82-0fcc-4b78-88c6-ee3bc4381404",
      target: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0"
    },
    {
      id: "20205249-1f9f-4eb7-a4e4-5f7cc64c1ea9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "0457337d-35eb-4191-bed4-8be00ce4c46e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0",
      target: "5d181cbf-c802-4ba2-95c7-642599af24b6"
    },
    {
      id: "09136a25-bcc4-468e-9c15-8f8552029a4e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c0772a5c-b5c7-4f87-8a8d-7f824c022eb0",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "44a28b1a-81d9-4ad1-a93c-86aa672950fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d181cbf-c802-4ba2-95c7-642599af24b6",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "bdce03c0-cfae-4180-8ae7-989c64053bb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5d181cbf-c802-4ba2-95c7-642599af24b6",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "0d8a93bd-b51f-4595-b270-0b3289966e7a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7cb8621a-c516-48e9-8951-35e09b5803af",
      target: "57d0c9cd-3314-4818-8c8b-1da7e8c26151"
    },
    {
      id: "484e7d6a-9081-46f6-b88c-cce15501f2ef",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb8621a-c516-48e9-8951-35e09b5803af",
      target: "3d7692ee-e39e-4203-8386-e67ef0a74a9d"
    },
    {
      id: "a89e71e7-072a-4632-b5ac-23ab8848e743",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7cb8621a-c516-48e9-8951-35e09b5803af",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "435250f0-be38-4d88-b030-a5a70517448f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "9cbc53e8-09f9-41f6-b23c-d1284bcf1e54",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      target: "6e25f688-d12e-453f-9fac-0b6552fe54c9"
    },
    {
      id: "22733299-5054-4bf1-994c-f6107a0ebf37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "70296b2f-68cd-46e9-83ec-a8617a0d6f7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      target: "c7699246-bbba-4ca3-8a23-77c106b18bfa"
    },
    {
      id: "f52d947c-658a-405e-b0ec-f9b28bb92477",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "57d0c9cd-3314-4818-8c8b-1da7e8c26151",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "4c91d2d9-ec91-4d83-9b09-7fa27386effe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e25f688-d12e-453f-9fac-0b6552fe54c9",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "2664e36a-9651-4611-b76c-134c32cbef5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e25f688-d12e-453f-9fac-0b6552fe54c9",
      target: "556f6761-f13c-4fd4-b607-ba5bc889528f"
    },
    {
      id: "ae0a6f05-54bf-47c7-bd9f-ec608004a393",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6e25f688-d12e-453f-9fac-0b6552fe54c9",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "780ab95d-2b47-4a8d-a766-5b6abcfb6a77",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6e25f688-d12e-453f-9fac-0b6552fe54c9",
      target: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016"
    },
    {
      id: "e1011eb5-c67d-4e2e-bf91-8aa1360b0a23",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016",
      target: "df62d19e-fb4e-443b-8a45-ddfaaf477694"
    },
    {
      id: "b7db201b-fcd6-46e1-a1b2-f78925b0daac",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016",
      target: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd"
    },
    {
      id: "78e90c32-038d-4f4f-8619-bf77d46d6cb3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f1bbb8c9-5ef1-4e01-9ed9-d353fe5de016",
      target: "85041fd8-78a1-4ff2-a4b7-b857b9a542dd"
    },
    {
      id: "1e939374-de2f-4cde-b50b-c2c1db8554ff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df62d19e-fb4e-443b-8a45-ddfaaf477694",
      target: "5d9c9d68-f05c-4ab9-83fd-3bc02f51e85e"
    },
    {
      id: "e80786e2-ef10-4608-a29e-a93c06b080b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "ea932586-e703-4e35-bf7a-20e308f9942a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4ecee945-c6aa-4ac2-85fc-5f582f50bbec",
      target: "16b6b02c-c823-4efe-a251-44d995b20682"
    },
    {
      id: "2009b627-cc50-4130-8124-faab2b173ac2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "16b6b02c-c823-4efe-a251-44d995b20682",
      target: "ad29afc0-cad3-44f3-ba65-4af58ed0a655"
    },
    {
      id: "71ece567-05b8-414b-b0e3-04efa77f6eff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad29afc0-cad3-44f3-ba65-4af58ed0a655",
      target: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd"
    },
    {
      id: "f93d0c26-f5ae-40a5-8548-4bf0ba26d276",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd",
      target: "2e6b32d5-383a-4f8f-9a89-a29c542e3246"
    },
    {
      id: "da124d26-9f3a-43f9-a71b-1648109f1a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d14cd34f-5aa7-43b4-af0d-192c78c9cfcd",
      target: "9ee725fd-e35d-4991-8cae-cb37d821d273"
    },
    {
      id: "c890b874-ddaf-45b7-b706-4339889265fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e6b32d5-383a-4f8f-9a89-a29c542e3246",
      target: "86dd4423-66ad-47a2-a560-82d0629aea42"
    },
    {
      id: "144fca08-f029-4566-9527-5e92fe0a852c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86dd4423-66ad-47a2-a560-82d0629aea42",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "8dc35377-c0e5-459f-a174-1d957d54a132",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "86dd4423-66ad-47a2-a560-82d0629aea42",
      target: "f66d0a54-fc2e-421b-8a9c-5536072633b2"
    },
    {
      id: "3f0e5ee3-4bca-4cdf-9cc9-57a817d327ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f66d0a54-fc2e-421b-8a9c-5536072633b2",
      target: "95688cc7-421b-4580-8842-888675a97d23"
    },
    {
      id: "82a40e4b-c6f0-41dd-9032-1ba8e1639971",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f66d0a54-fc2e-421b-8a9c-5536072633b2",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "53c1258d-b3c8-4503-a662-9501c4ac7d8c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95688cc7-421b-4580-8842-888675a97d23",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "c2ce8425-9a62-4630-88b9-6ad1272034d7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95688cc7-421b-4580-8842-888675a97d23",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "8f882583-15f0-4e03-83aa-4957e63f4f9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95688cc7-421b-4580-8842-888675a97d23",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "a6846ef2-f87b-418e-be00-cf482d64fc36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9ee725fd-e35d-4991-8cae-cb37d821d273",
      target: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd"
    },
    {
      id: "7e819105-666f-41fc-a7c4-177a51508c3f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd",
      target: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8"
    },
    {
      id: "eee2286e-601e-4524-bd78-f8899de248e8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "c6d5a329-0a34-45e2-824c-0b29be73a26f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fad303fc-4d6b-4630-9e7f-2c8c46a5c1dd",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "dc165f09-193d-4043-bffc-f82bb1f0e9c3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a530a7df-8470-4ebe-9bce-c0482f5a1f32",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "976bcfe1-1e14-4f42-a454-ded03985ee28",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a530a7df-8470-4ebe-9bce-c0482f5a1f32",
      target: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8"
    },
    {
      id: "0cd0e6ab-012b-417a-976b-64fde3a7a7ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a530a7df-8470-4ebe-9bce-c0482f5a1f32",
      target: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce"
    },
    {
      id: "c8ef2812-ba75-4bf6-b105-7ce2b60560c9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "dcfc0a3e-46b7-46b1-bdc1-f15695b72e87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce",
      target: "ac49455c-7179-4c7d-95ba-045d3be2c497"
    },
    {
      id: "9a111daa-8edc-4bee-83fc-9cedc15afa74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9f3c94fb-4cdf-407b-8e36-6d52a03c35ce",
      target: "edcf6a0a-db04-4020-9363-0d7b36f4189d"
    },
    {
      id: "ee84f10e-0454-4133-990b-cfba67f313e2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac49455c-7179-4c7d-95ba-045d3be2c497",
      target: "3602a410-68ba-4154-8b20-3e149c2946bb"
    },
    {
      id: "c919f354-330e-4e26-a8c9-ebafb182cfee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac49455c-7179-4c7d-95ba-045d3be2c497",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "d6d0704d-1091-4d26-829a-4226989d11e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ac49455c-7179-4c7d-95ba-045d3be2c497",
      target: "ebd73eea-8078-4c0b-b794-26a40ddde444"
    },
    {
      id: "f263f29b-9bc3-41c9-b38f-d5700333b6d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3602a410-68ba-4154-8b20-3e149c2946bb",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "267c6395-aff3-4a23-ba33-8870cb1656da",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3602a410-68ba-4154-8b20-3e149c2946bb",
      target: "eb0df072-338a-4a4d-a048-74d54b57f126"
    },
    {
      id: "5a907298-7c41-44b7-b659-3ece53b6f4ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "1028e4e5-117b-4d4c-ab57-be7d97fa9a03",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "e52fe108-5fc9-4cf1-ac5c-98b6123f0be6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      target: "fefe7594-ed27-420e-8c8f-fafdde3b6399"
    },
    {
      id: "724c8861-5b60-4c6a-aa39-55983450693b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      target: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09"
    },
    {
      id: "56b14fd9-f4ff-41d0-bdd7-1a709ac89497",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b13ab82-1718-4e4e-aedd-5d3c6be50ae8",
      target: "7d42f996-04d9-4694-b075-de33ad444174"
    },
    {
      id: "b8470325-7451-4d8c-93d6-86482a949c7d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fefe7594-ed27-420e-8c8f-fafdde3b6399",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "918311d6-5d39-45bd-8364-a1a469bd676c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fefe7594-ed27-420e-8c8f-fafdde3b6399",
      target: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa"
    },
    {
      id: "ca4db2cb-6192-4a26-ab65-3e9ec05ba3a8",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fefe7594-ed27-420e-8c8f-fafdde3b6399",
      target: "91a6aa4b-b69b-4592-9dd4-f873407e8dae"
    },
    {
      id: "ec6e1780-4e45-4686-9f4d-68dac0e61741",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      target: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6"
    },
    {
      id: "491cfed1-d34b-41ae-9282-969bee485b49",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "f2de3e3f-64d3-45e6-b81d-feb20379947b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "2e434744-83aa-4f4a-a475-74de7f51aa20",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      target: "1cee4967-0a22-4e88-9c12-72d45544684a"
    },
    {
      id: "94e375de-602a-4c86-b3a6-040a499563be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95dd1c0d-72aa-49b7-bc49-c161af4df3aa",
      target: "dd888cf3-c150-454d-a756-d731ae84c8be"
    },
    {
      id: "75490af2-5525-42ed-84c8-04aca5f7a7be",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1cee4967-0a22-4e88-9c12-72d45544684a",
      target: "801c45de-c08d-43b2-85ae-c95b2af0143b"
    },
    {
      id: "55520a7e-a040-4152-9932-1f4953feeaca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cee4967-0a22-4e88-9c12-72d45544684a",
      target: "0b1b385e-5b7e-4978-859b-4f7f47a21776"
    },
    {
      id: "826bc7ee-26ee-42f0-beaf-f5819c46d08e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cee4967-0a22-4e88-9c12-72d45544684a",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "08e454ba-9259-4af1-a61e-86b1ac608b93",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1cee4967-0a22-4e88-9c12-72d45544684a",
      target: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd"
    },
    {
      id: "a79d608e-8c5d-453f-a210-a9724a6a831b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1cee4967-0a22-4e88-9c12-72d45544684a",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "32c68dd3-c627-448d-ac7e-ff216ccf390d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "ff2ac0c4-c6f3-4843-be89-f2969e177727",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      target: "94c84b47-fe68-47e5-8d41-48f07b23bc83"
    },
    {
      id: "cbef2404-5c49-49af-a454-91ed0ba9d8e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "9e8d44ba-402b-4416-a919-7fd3ef07f6ff",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      target: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8"
    },
    {
      id: "bb81b9a9-05d4-4341-bd95-5d269bada02e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5830178c-51ea-4a8f-ac0c-4bae3e9c17fd",
      target: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4"
    },
    {
      id: "8fd5e5a9-f17b-4f9b-88fa-ef210fdb0b61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8",
      target: "c6bde09b-8153-44fd-a653-a7dffa1f104a"
    },
    {
      id: "957edf4c-c2ef-4267-80ca-9924ef6c1224",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8",
      target: "9c3b2836-225a-4e71-ad6d-304f86a5ab4a"
    },
    {
      id: "7f3d405f-002d-450f-965c-5cebfbc057fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "4fd06661-ac4b-4da6-b1ab-5279264cffe1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa3ea6d3-0aab-4c12-9031-e7a9cdebf5c8",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "4481b797-8610-48eb-815d-6b6a42092c9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91a6aa4b-b69b-4592-9dd4-f873407e8dae",
      target: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb"
    },
    {
      id: "665ca2de-ca65-4022-bb8e-9445782264b0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91a6aa4b-b69b-4592-9dd4-f873407e8dae",
      target: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6"
    },
    {
      id: "f54444d5-25a8-470d-8a90-ad48a429060a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "91a6aa4b-b69b-4592-9dd4-f873407e8dae",
      target: "7106e614-e14a-4029-bf17-8ea4bd60029d"
    },
    {
      id: "3bddb8de-a40d-4888-8796-0606c0175872",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "af75b302-daed-411a-9498-b964f4ab6eae",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "c9d8e516-0591-4c1a-b18f-b16e19fe4391",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5e6b2be8-beb3-4c05-a43e-e73f06b4cfa6",
      target: "801c45de-c08d-43b2-85ae-c95b2af0143b"
    },
    {
      id: "d27913b5-244a-4f08-9340-06a7ccdbaaa5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "801c45de-c08d-43b2-85ae-c95b2af0143b",
      target: "94c84b47-fe68-47e5-8d41-48f07b23bc83"
    },
    {
      id: "96aeecba-d640-499d-b96c-bd253f05bea8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "801c45de-c08d-43b2-85ae-c95b2af0143b",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "ca5e8d11-89ee-4753-9001-95b584dfe00c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "801c45de-c08d-43b2-85ae-c95b2af0143b",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "7d49c938-d0dc-4469-8c2d-277cf32e069d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94c84b47-fe68-47e5-8d41-48f07b23bc83",
      target: "9c3b2836-225a-4e71-ad6d-304f86a5ab4a"
    },
    {
      id: "b465e178-c35e-4639-a5e5-bc84fb2e3e5c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94c84b47-fe68-47e5-8d41-48f07b23bc83",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "5073d2fe-de79-4dc1-a8f7-a4be44d91bdf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "94c84b47-fe68-47e5-8d41-48f07b23bc83",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "188c1172-5dfb-4361-8c96-227f0b196ce6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c3b2836-225a-4e71-ad6d-304f86a5ab4a",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "a0859d0b-5190-4d58-9455-d6de316da038",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9c3b2836-225a-4e71-ad6d-304f86a5ab4a",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "974e2f1e-9f13-47e7-8112-599ae1dbc344",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8",
      target: "dd888cf3-c150-454d-a756-d731ae84c8be"
    },
    {
      id: "8189b53b-f077-4d1a-9851-4eec5f77059e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "d5240714-e3f1-48bb-bc09-4408c76f072d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8",
      target: "edcf6a0a-db04-4020-9363-0d7b36f4189d"
    },
    {
      id: "b87afb7f-4d75-4df4-a751-a34e9521b57a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6d2d8b92-cf76-45f5-82ce-37edbc845dd8",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "16155c2a-4af6-40b7-af48-618c6bd187a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edcf6a0a-db04-4020-9363-0d7b36f4189d",
      target: "0b1b385e-5b7e-4978-859b-4f7f47a21776"
    },
    {
      id: "c5c37e4b-f2ab-4327-9c5a-8fc20041bc37",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edcf6a0a-db04-4020-9363-0d7b36f4189d",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "e73310cc-1c01-41ea-9db6-efb992c35848",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "edcf6a0a-db04-4020-9363-0d7b36f4189d",
      target: "ebd73eea-8078-4c0b-b794-26a40ddde444"
    },
    {
      id: "6c81b350-b0a1-4745-8047-117d553e8a30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "edcf6a0a-db04-4020-9363-0d7b36f4189d",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "7f126c2c-d0e4-42c8-88b3-5d81234f321e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ebd73eea-8078-4c0b-b794-26a40ddde444",
      target: "eb0df072-338a-4a4d-a048-74d54b57f126"
    },
    {
      id: "db2b0132-2ecb-4fc3-9dba-2462ea7186cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebd73eea-8078-4c0b-b794-26a40ddde444",
      target: "8fcf11c8-cc2d-48fa-95d1-e44979de1ba4"
    },
    {
      id: "0f53e005-b79b-4e23-8021-c15b5625cc61",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebd73eea-8078-4c0b-b794-26a40ddde444",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "27b5b87c-4e14-4497-9915-0de1f7687945",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebd73eea-8078-4c0b-b794-26a40ddde444",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "0ccc1278-f441-443b-827e-327cbb19ecdc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb0df072-338a-4a4d-a048-74d54b57f126",
      target: "c6bde09b-8153-44fd-a653-a7dffa1f104a"
    },
    {
      id: "86fab7c6-9cc3-4ada-a0ce-d0271c261a2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb0df072-338a-4a4d-a048-74d54b57f126",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "2fe5f24c-4a1a-4c28-8d2e-934046e20a75",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eb0df072-338a-4a4d-a048-74d54b57f126",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "64f87483-d790-4f37-942f-e26f24faf1e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eecabc0b-b15b-44a3-b7b3-0b433a9fe17c",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "5a4751b5-ae8c-4c94-a07a-692b91d18428",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ebe5993d-841c-4ccc-b2a6-6dc80951fe69",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "eb4dff66-62b7-442a-b1c8-cb84798abea5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "95c3937e-7cb7-4e72-afd0-9ddaa5348180",
      target: "0f5ed88f-713f-41ca-9c17-a38491a57787"
    },
    {
      id: "d1642caf-725f-43e0-8d9e-df98a4c3e7eb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2be7a4ad-05b3-4680-9025-f562fe5417cf",
      target: "0f5ed88f-713f-41ca-9c17-a38491a57787"
    },
    {
      id: "2c95e2d2-296f-4397-b811-c1c3877d09ac",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8b101403-d69e-4cbf-89d2-d57dfe579918",
      target: "415d197c-8721-4070-b7d2-497fb58e0d02"
    },
    {
      id: "0c555de5-7673-4991-9ab2-b0ffa8527d00",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8ef8d50e-92d0-4d03-984b-806318da250c",
      target: "415d197c-8721-4070-b7d2-497fb58e0d02"
    },
    {
      id: "3c55bae1-785a-4126-a1ad-0449aebc0c9f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ad355aea-c3eb-4d10-a36e-0951e66d23c6",
      target: "d7744250-088c-49da-926f-6abe9af37939"
    },
    {
      id: "bcc003c3-985a-4fef-a728-337cd19078a4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "04625d21-10c3-4bbc-8fce-c40a18b4f846",
      target: "d7744250-088c-49da-926f-6abe9af37939"
    },
    {
      id: "825252be-4c6e-4152-a622-ccfc09d9396c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75983700-34ca-4bef-a5b8-95b3d5be2fe0",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "9fea52bf-3cef-4da2-a42a-5972b51927bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "75983700-34ca-4bef-a5b8-95b3d5be2fe0",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "7b0292a6-93db-4ea6-af9b-4c3c4011f2f0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "75983700-34ca-4bef-a5b8-95b3d5be2fe0",
      target: "1c22d9c7-73fc-4807-9067-e87d5b9a8017"
    },
    {
      id: "bcf038ba-8cc1-4095-8e6d-bf246ef4a445",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "75983700-34ca-4bef-a5b8-95b3d5be2fe0",
      target: "be3ed880-38fb-4e2c-bcbe-e436a37d5ac6"
    },
    {
      id: "914212a0-8385-4ed5-bdd7-5b0b5fda621a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24",
      target: "bb4ba05f-e504-462c-a449-4229236823ac"
    },
    {
      id: "2b08bc38-554b-4b56-b4cc-af12f2a332c6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "b2290160-7be4-4095-ac9c-dfeffdac6c53",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "dc22e4cf-a58f-4c4b-b0c9-6f8999034f24",
      target: "70eaeb12-8cb8-45b9-a5bd-789b4aae88d8"
    },
    {
      id: "d335591b-b079-4580-929b-959fd6abff44",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c22d9c7-73fc-4807-9067-e87d5b9a8017",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "3be87dc6-7b9f-479b-87fd-7d0ee05596b8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c22d9c7-73fc-4807-9067-e87d5b9a8017",
      target: "56b53c19-ad96-4fd5-a1e7-89aceb850c87"
    },
    {
      id: "8a602ed3-33a7-4519-8d05-6b306c87c844",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c22d9c7-73fc-4807-9067-e87d5b9a8017",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "f951d418-7cdd-4392-8117-c1319d4c74d1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1c22d9c7-73fc-4807-9067-e87d5b9a8017",
      target: "0ec11c16-6c17-4576-bd17-9ee8666f2d17"
    },
    {
      id: "c6506064-80df-44c9-9197-f759671fceee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ec11c16-6c17-4576-bd17-9ee8666f2d17",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "68a9fddd-5df6-4b0a-ab7d-10f43aae0afc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0ec11c16-6c17-4576-bd17-9ee8666f2d17",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "68c919a8-e3d6-45d8-a99b-f74a208454b8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0ec11c16-6c17-4576-bd17-9ee8666f2d17",
      target: "34969fc4-6301-4034-be1e-1be102445f8e"
    },
    {
      id: "d314bf90-2017-4f43-8c17-26f23cc55624",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0ec11c16-6c17-4576-bd17-9ee8666f2d17",
      target: "06f3c8e9-3016-46d0-945f-a50315a94b24"
    },
    {
      id: "d6a81f94-8e58-48a3-8be5-2e1c97569545",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34969fc4-6301-4034-be1e-1be102445f8e",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "720551d9-5c62-4772-adbb-5d94891b5edb",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34969fc4-6301-4034-be1e-1be102445f8e",
      target: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a"
    },
    {
      id: "c86ed3e3-2d84-4fc2-8da4-8a604ed3a12e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "34969fc4-6301-4034-be1e-1be102445f8e",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "a40ec8ae-2bfa-44cf-8218-13f66cdfae14",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "34969fc4-6301-4034-be1e-1be102445f8e",
      target: "ca726eb6-39fd-49d2-ad5a-1b5f3e4fbb64"
    },
    {
      id: "1605b39b-b8a9-4786-9626-6cf594aa1c70",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "3419ef64-ec8c-4357-8fcd-4ee30069b363",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "77b2ffbb-ed21-480d-81d4-5d8fd47b41df",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e5f23b26-b1e3-4e4c-9d98-ac233f5b217a",
      target: "6763bb71-859c-4913-bfa4-514ccc75fe1a"
    },
    {
      id: "2d6bf585-eacc-489d-950e-b83b0db3ee2e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be3ed880-38fb-4e2c-bcbe-e436a37d5ac6",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "1089ad85-c151-4c66-a3b5-4ef8ead23405",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "70eaeb12-8cb8-45b9-a5bd-789b4aae88d8",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "b4d72305-c88d-48e9-8a9b-f9dfe4ba5635",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56b53c19-ad96-4fd5-a1e7-89aceb850c87",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "e465816e-4cef-44fc-a0e2-5a03062abcf1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "56b53c19-ad96-4fd5-a1e7-89aceb850c87",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "b3cca181-6af8-4c0e-b095-2e826ba12231",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06f3c8e9-3016-46d0-945f-a50315a94b24",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "c9441654-b11e-41c8-b280-893d6412a6fb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "06f3c8e9-3016-46d0-945f-a50315a94b24",
      target: "4b230b21-0d2b-4d57-a8d8-67226d0d800c"
    },
    {
      id: "2561ae7b-6433-4365-8eaf-54a692b8390b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca726eb6-39fd-49d2-ad5a-1b5f3e4fbb64",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "521ddde2-0db4-40b6-bfea-1c57356515cd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ca726eb6-39fd-49d2-ad5a-1b5f3e4fbb64",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "03274361-b027-451b-aa81-5f31605c72ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6763bb71-859c-4913-bfa4-514ccc75fe1a",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "19b229e9-8358-4009-b72a-5c7400feb3d6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6763bb71-859c-4913-bfa4-514ccc75fe1a",
      target: "f453b346-22b9-4b8c-b610-24c5e4675f62"
    },
    {
      id: "19c920ab-9116-4eb7-942b-810189113f38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e38b366-0370-44f3-98bc-11d1f59d7bcd",
      target: "009d22ab-ab20-4945-89c3-10a7608e60e2"
    },
    {
      id: "45cbbb7b-434c-43a7-96c6-8a1521188a35",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e38b366-0370-44f3-98bc-11d1f59d7bcd",
      target: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b"
    },
    {
      id: "bc893333-174a-4a3c-96c6-32aad85d3d58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "009d22ab-ab20-4945-89c3-10a7608e60e2",
      target: "31bf0bfd-e249-4ea9-8c9b-ef0b9f34730d"
    },
    {
      id: "1a2e1d61-3d4a-4017-8b50-892f6b5092d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "4fec3700-0e38-46c4-b517-008f4dc3be7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      target: "903106db-3f7f-4fe0-bf6d-f172e317cd5d"
    },
    {
      id: "4b5eb14a-fa9b-4450-a2c0-0216e3c61c7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      target: "d757e4ea-7f64-459f-9d06-b480a681de4c"
    },
    {
      id: "3a02124e-c1a9-47bb-92ae-2c16cf8143ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      target: "6203ee0b-d544-4410-b314-8e5add762a00"
    },
    {
      id: "2f020455-d6a3-447e-805b-5c43460686a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "03f417dd-17f8-405d-93cb-b3bd0dc83e1b",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "2740cdf5-37d9-4b59-bb2b-8e8c9e0c23a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6203ee0b-d544-4410-b314-8e5add762a00",
      target: "903106db-3f7f-4fe0-bf6d-f172e317cd5d"
    },
    {
      id: "8fb90b10-36cc-4019-9f57-9a992a2d905a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "44ace62e-e020-404b-92de-bd5a168f9c68"
    },
    {
      id: "54a70039-c14e-42c5-8bc5-44256dfbd599",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a"
    },
    {
      id: "95aa54fb-9331-451b-a231-3e9b31881430",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a"
    },
    {
      id: "b0b8f69a-f4b9-4304-a1f6-4d132dbda6c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "5a7ce840-aeef-4a14-94fd-4cb53291355e"
    },
    {
      id: "f79ee479-c792-47ad-bbab-2b24218f9e5a",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "e743d157-d4bf-4e79-ba02-788774267bfc"
    },
    {
      id: "efdcceab-6d9b-4d6e-a526-9fa4c76e5118",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "03bfed0e-f197-4cdf-878d-46664e57ea65"
    },
    {
      id: "1cc42f4f-ab86-41c6-a440-dc6871c5c652",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "903106db-3f7f-4fe0-bf6d-f172e317cd5d",
      target: "df40bd6b-351f-433f-8a79-17b222e06f0f"
    },
    {
      id: "e044dfc9-8acb-44c0-a6f7-e307868bc704",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "cc151cd6-c099-4849-ad83-f4b5e8927bd7"
    },
    {
      id: "0e1cfeec-d1fd-4bdc-8f0c-434b0a4365c0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "06356746-ce95-4fc7-820c-cac1a3ae84f3"
    },
    {
      id: "560e163c-76f9-4bf1-8625-09513e6d11b9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "711361d7-7ffe-4250-ac6d-1ddc52dc54f3"
    },
    {
      id: "ab353e87-d8aa-4cc5-8678-a2feb1593ccd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "2f0e2a77-bf1c-4f6c-9bec-b6e0fe84b3e5"
    },
    {
      id: "30304467-398e-4419-9a2c-2c4e8f05e2b1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "cc151cd6-c099-4849-ad83-f4b5e8927bd7"
    },
    {
      id: "e02ceb46-2feb-4880-9038-60c2b52a95bc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5a7ce840-aeef-4a14-94fd-4cb53291355e",
      target: "e4652728-c076-442a-b3eb-842b636b01aa"
    },
    {
      id: "eeb5ae35-115b-476b-9594-2ec2f058ab53",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "780eba6e-3edc-4064-8db0-2e185bec8e8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "444591c0-ef6a-4003-83af-7d83228b1379",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2"
    },
    {
      id: "d71338ea-349c-4802-a41c-ad44a580861b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "8b7ee1dc-fbc8-4786-bfb5-130013a7f82d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "d757e4ea-7f64-459f-9d06-b480a681de4c"
    },
    {
      id: "d36b719b-0ee9-4423-817c-60eb48c96e13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d6fd26f8-b031-4926-b947-2e21d1cb2b7a",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "cda699c6-a09e-4c6c-bcf9-9b1f3771918e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc151cd6-c099-4849-ad83-f4b5e8927bd7",
      target: "d757e4ea-7f64-459f-9d06-b480a681de4c"
    },
    {
      id: "615d07b8-c09d-4fcc-91f6-1cce67426c9c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc151cd6-c099-4849-ad83-f4b5e8927bd7",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "fac818a6-40c7-4817-bab6-f79b48391f3e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc151cd6-c099-4849-ad83-f4b5e8927bd7",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "24943713-09da-4c1c-8488-59552780264b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cc151cd6-c099-4849-ad83-f4b5e8927bd7",
      target: "c565da9e-b058-48b9-b693-253cb1774d3b"
    },
    {
      id: "8cf9997a-0e0b-4192-907e-3be58e9125e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c5a86a2-800a-4135-94db-14253d17693d",
      target: "cd9f3e87-af7b-46f9-a9a2-8d684a47ee5f"
    },
    {
      id: "59b3e9af-8251-4f46-a2de-c602584e1f87",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "3c5a86a2-800a-4135-94db-14253d17693d",
      target: "22e77ee8-8fa8-4302-b3c8-4a3c60a98c6d"
    },
    {
      id: "65b60b1c-7cd9-46a4-b0f2-d41a3f7d49c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "cd9f3e87-af7b-46f9-a9a2-8d684a47ee5f",
      target: "2e0b08be-32e4-4542-8567-e52e463197a1"
    },
    {
      id: "c58473c2-29c0-4a14-851b-6fea8802ca05",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "22e77ee8-8fa8-4302-b3c8-4a3c60a98c6d",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "6fbe5700-3b57-4310-9eb8-c36bdb3c62fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2e0b08be-32e4-4542-8567-e52e463197a1",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "33b65f8f-01fb-429c-a696-a2562bdc97b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "0c912ad6-7054-429f-b427-26fabfdfaea7"
    },
    {
      id: "1a06f573-aa4a-40a2-8be2-49956a41b47a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "896a7f9a-055f-44eb-b193-57b733e56bc6",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "9194dc8f-640b-4d87-958e-4b6998f0d0cd"
    },
    {
      id: "70e5aa42-05ec-4f82-97e1-de9eb8884845",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "eb30d885-2f44-4628-aac3-7c6cca2f55fa",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "2f8ab6ed-c976-4862-b923-431fbf43ae48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "2241a113-dd4c-43d7-a985-8f8dbb5fa2d3"
    },
    {
      id: "e2b8e97a-ac0d-4e62-ad6d-0d418ec464ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b7c8c25-1d87-4699-bca2-d93a2a5186e3",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "53a7cce7-4816-454a-b03b-83be444bfb80",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0c912ad6-7054-429f-b427-26fabfdfaea7",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "325a4db1-ecbe-43b3-ad28-18e8f851015a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0c912ad6-7054-429f-b427-26fabfdfaea7",
      target: "bb3e3f73-bca9-458a-8dfe-7e6a8aec5b3c"
    },
    {
      id: "5dbd1427-182d-465f-a618-2b2d0af65a74",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0c912ad6-7054-429f-b427-26fabfdfaea7",
      target: "764226b4-1845-478e-acbb-28aa60f66f32"
    },
    {
      id: "309e97a9-fc79-422c-baab-70ef1be7773e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      target: "2af75056-6a2d-4ee1-a19d-b97049236c3b"
    },
    {
      id: "b24e22fb-097a-4ef6-a71c-0eb337d91749",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "3532a301-8855-44fd-a2bd-eed9f45d79f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      target: "03b46ffc-4f12-4c97-bddf-5b0faf01aaca"
    },
    {
      id: "17746ff2-d4da-481d-9aab-2ae495ee9e6b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      target: "33b65098-085e-400d-9d1a-636057e978d8"
    },
    {
      id: "97efae3c-4672-4fda-9a67-6083e7fe816c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "e5f879d2-0013-4a75-8a71-e26e34fa8895",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      target: "e85e86a3-2e43-4831-8b75-c7f6616ff48e"
    },
    {
      id: "b468f807-e50b-481e-95fd-61b931ab2704",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      target: "4f1da317-0146-4673-8bf4-c6c307a4177c"
    },
    {
      id: "7228a587-be64-4e0e-874e-95416d9bed2e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      target: "307e4193-b874-4d2f-a568-29c3a6952e9d"
    },
    {
      id: "984d1380-c45b-47c9-a8ee-6174145905f3",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      target: "764226b4-1845-478e-acbb-28aa60f66f32"
    },
    {
      id: "b8766b21-941a-474b-a555-ee8433881a6c",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d757e4ea-7f64-459f-9d06-b480a681de4c",
      target: "89cb16bb-25b2-4e5f-bb8c-a9ab72eb9905"
    },
    {
      id: "965393f3-501c-4f3c-bced-b95981876b3e",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2",
      target: "18a14275-6a54-4ab1-a1cb-afdfceea337c"
    },
    {
      id: "07ade7f5-6373-4aba-b818-a8fb37a31b3d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e36e10ef-35cd-4605-bef6-9c1d43ccc1f2",
      target: "18a14275-6a54-4ab1-a1cb-afdfceea337c"
    },
    {
      id: "6e0ae97d-37df-45b1-b964-2a2b67332c10",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "764226b4-1845-478e-acbb-28aa60f66f32",
      target: "edc6bbd2-58cb-4892-a4b0-b8a7558c1314"
    },
    {
      id: "0aba81bb-9014-4cc2-a45e-d773fb259a7e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "764226b4-1845-478e-acbb-28aa60f66f32",
      target: "f9d86652-6a1c-40f5-a401-c4ba776bb6ef"
    },
    {
      id: "e4576d05-3d05-4a39-af17-eb99d973c9f3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "764226b4-1845-478e-acbb-28aa60f66f32",
      target: "d0fe2a47-291c-4527-8865-41785c38f7e5"
    },
    {
      id: "d7845d7c-376c-4a8e-8d52-d080d7b790db",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "18a14275-6a54-4ab1-a1cb-afdfceea337c",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "8229083e-7c24-4ba5-b947-fabff0d7fa71",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d0fe2a47-291c-4527-8865-41785c38f7e5",
      target: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b"
    },
    {
      id: "56713005-4255-46bb-aee8-8f00d18a0c7b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "acf308a3-9fe6-4359-bda6-d15cd588591a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b",
      target: "557162ae-f57f-46d5-b338-f37e8aea54e5"
    },
    {
      id: "6fd69ced-9a0a-42e2-b03a-652795a2a14c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9e8a70ad-a79b-4463-bfa7-9a5f2cfb255b",
      target: "ab0f24d8-ea95-4882-bd0e-dd47c6396a3f"
    },
    {
      id: "c3862489-796c-4074-8d46-1fb8cc32027d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c2c3ce2d-4dd9-4502-9124-4ac33d40a6bd",
      target: "1fdeffe6-6f22-44ae-9570-5cfebf2c8a2a"
    },
    {
      id: "6f6c07ec-6041-4698-a54b-65338763cadc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176",
      target: "2af75056-6a2d-4ee1-a19d-b97049236c3b"
    },
    {
      id: "dd5c21f1-a994-468c-8f4d-a1a62ad0e5ca",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "8a5172a0-54df-4627-a055-f6f67c6e397f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176",
      target: "fbe8845d-e5f8-4e72-8322-b9477c26aeb1"
    },
    {
      id: "68ec3dc7-610b-4c78-95a3-8ea09fe6ab1b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f5ed88f-713f-41ca-9c17-a38491a57787",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "b7bacd0e-4460-49f9-b2af-29a9254f79b3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f5ed88f-713f-41ca-9c17-a38491a57787",
      target: "2d4d1a7f-96fe-4a31-85ca-634b28f3acfb"
    },
    {
      id: "3fc503ae-852c-44cb-99da-f071aa88e6ec",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0f5ed88f-713f-41ca-9c17-a38491a57787",
      target: "379311ae-7a7f-4ac2-8a18-7ea1aedbe955"
    },
    {
      id: "d7ac6d47-f616-45fa-b0a4-9ecd17575e21",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "e85e86a3-2e43-4831-8b75-c7f6616ff48e",
      target: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6"
    },
    {
      id: "925dd656-fe92-48c4-8524-f9f14928f499",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "e85e86a3-2e43-4831-8b75-c7f6616ff48e",
      target: "7989b2b6-5240-47f3-adab-3b89fbe05185"
    },
    {
      id: "7f2b9405-d53a-48a4-990c-21217289b7fc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e85e86a3-2e43-4831-8b75-c7f6616ff48e",
      target: "76044c4a-8691-42d0-8c22-77d05c84bf4e"
    },
    {
      id: "0be68c85-48bc-42fb-990b-ec7fae025b61",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4f1da317-0146-4673-8bf4-c6c307a4177c",
      target: "f06b8d6a-49a8-4648-9cd6-56338ac04e84"
    },
    {
      id: "333956f8-99ab-4569-8e4a-ab8c11b7222c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4f1da317-0146-4673-8bf4-c6c307a4177c",
      target: "ec74b241-b5f5-41a8-8422-5bac868bbf11"
    },
    {
      id: "7a3fee54-d368-4aaa-969b-b8d2ab843d46",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4f1da317-0146-4673-8bf4-c6c307a4177c",
      target: "224c29f3-50e4-422c-bd57-6a816887eef6"
    },
    {
      id: "b352c000-2c82-4893-ab93-b0099085518c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4f1da317-0146-4673-8bf4-c6c307a4177c",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "00b9f5d7-e454-498e-b14d-84b013ea40dc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec74b241-b5f5-41a8-8422-5bac868bbf11",
      target: "6af58e79-450a-4edc-84a8-c4ec77919c3a"
    },
    {
      id: "0bdf281e-14b4-4cab-89ac-d83f23826e01",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "ec74b241-b5f5-41a8-8422-5bac868bbf11",
      target: "3212d75d-e709-4b9e-93ea-a8046f26bea6"
    },
    {
      id: "76a30e50-be71-4042-9e01-62808a083dbc",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec74b241-b5f5-41a8-8422-5bac868bbf11",
      target: "a456564a-992b-4e6c-9164-49268d7f3239"
    },
    {
      id: "9a733e37-674a-4eb6-85e2-ebc7997de8a5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "ec74b241-b5f5-41a8-8422-5bac868bbf11",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "efe99971-782c-4377-a49e-974b981a87fb",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8ad8975e-64a1-47f8-801f-d0470b7b123f",
      target: "d2d9b972-c72e-4341-8a57-68637848f221"
    },
    {
      id: "2be35af7-92da-48b1-abaf-eaee0b3d2892",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8ad8975e-64a1-47f8-801f-d0470b7b123f",
      target: "ef397edc-462c-4006-acc9-d03515ffeae3"
    },
    {
      id: "007da7cb-e02f-473c-a873-383240c91925",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "d517dea9-ead9-4174-b1ea-660298bde894"
    },
    {
      id: "dbcf0050-8ab5-4739-a333-9791dcad60c6",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "b96d24d4-c13f-4983-b74b-ded82c920b30",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "8ad8975e-64a1-47f8-801f-d0470b7b123f"
    },
    {
      id: "11f11a44-d520-4f65-a663-393ea11f349a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "9e5c2df4-8494-4990-94af-2feaba4a3d0b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "ac3576b3-6f4d-4c97-8b58-3fb7161d4453"
    },
    {
      id: "97983c54-604a-44e4-afbe-c4989c22d4bc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "a6571f80-018d-4be0-938e-a6e7749692cc"
    },
    {
      id: "6e68562c-b02a-4382-bcee-3a5acd29fe84",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "60a2c16d-1fe7-4717-b09c-89299c2ca1d6",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "04290f99-f420-464e-a530-4706d83ce23e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d517dea9-ead9-4174-b1ea-660298bde894",
      target: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d"
    },
    {
      id: "20bfcd55-9ab3-4006-bc41-24f657d3a8a7",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "f06b8d6a-49a8-4648-9cd6-56338ac04e84",
      target: "d9cb8451-406d-462d-bdc3-9144490a4baa"
    },
    {
      id: "aca90b8a-62cd-4cef-b760-f98a1a384366",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "f06b8d6a-49a8-4648-9cd6-56338ac04e84",
      target: "fa16ae15-5182-435e-9db9-54f24b26a2c5"
    },
    {
      id: "03790f8b-4086-4e80-b388-1b56b08a1de1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "f06b8d6a-49a8-4648-9cd6-56338ac04e84",
      target: "8144fc35-4877-49b3-a9c9-6b0660cf06f3"
    },
    {
      id: "c59e7813-c4d9-4468-b460-0ba91e5f8d5a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "fa16ae15-5182-435e-9db9-54f24b26a2c5",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "d2c20b43-dec9-4888-ba34-386e6e8899f9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6af58e79-450a-4edc-84a8-c4ec77919c3a",
      target: "26f1cf31-606a-4fe4-9ccd-752c4c7bf548"
    },
    {
      id: "00c903f9-13ca-4b8a-8c27-63823c84d248",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6af58e79-450a-4edc-84a8-c4ec77919c3a",
      target: "4da7a290-7f30-4d69-83c0-1451d3a41917"
    },
    {
      id: "ba99f65c-22c6-4fc3-9807-fd852db20655",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6af58e79-450a-4edc-84a8-c4ec77919c3a",
      target: "ce60ea35-b881-429a-b6ce-44412076bd61"
    },
    {
      id: "e275c46d-f1e7-463f-a26b-58ab83526732",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4da7a290-7f30-4d69-83c0-1451d3a41917",
      target: "1615638a-a40f-4417-8464-768dddb76836"
    },
    {
      id: "f1951681-6b29-45da-9760-b4fe64316284",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d2d9b972-c72e-4341-8a57-68637848f221",
      target: "f9f97a49-1437-47e9-b2e5-da7ac58d0aef"
    },
    {
      id: "b47cfff5-9362-4085-81ad-8df68ed31d55",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2d9b972-c72e-4341-8a57-68637848f221",
      target: "587a14b0-c535-417d-9dc3-25f34dbe27a3"
    },
    {
      id: "587bfb5a-3203-4de4-a075-8d823c6c275c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d2d9b972-c72e-4341-8a57-68637848f221",
      target: "36613527-b84c-499c-a9a1-695a5bc84d19"
    },
    {
      id: "f202c8e9-9b6c-445a-8386-8ba4d2eb8b8b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d2d9b972-c72e-4341-8a57-68637848f221",
      target: "663380fc-5e84-44c8-9084-4e7d770f64a0"
    },
    {
      id: "577d4dc8-e15d-4e5d-aeb3-09ece9f87c85",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "36613527-b84c-499c-a9a1-695a5bc84d19",
      target: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315"
    },
    {
      id: "a331eaf3-9186-4fa8-9283-af7d44093082",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      target: "28c6b98f-7a79-46c0-872d-87d148c820c6"
    },
    {
      id: "4e3e9309-0ccf-4e86-8f09-c6174e29b541",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      target: "6af58e79-450a-4edc-84a8-c4ec77919c3a"
    },
    {
      id: "3843e555-7567-48a7-aa23-4633a7fc887f",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      target: "aaf377c8-e087-4ad1-b7b3-39b23fec96e4"
    },
    {
      id: "a035a82b-be6b-4196-866e-c1a8ce434c99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      target: "7921ff89-a38c-4e3c-b3e2-8ebcd06e2176"
    },
    {
      id: "b52ea3b1-540a-4f26-b0ab-449f2c37149b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0e188fa0-0872-42d5-9a01-fe392fe2fc1d",
      target: "2fcf0191-1f51-4df3-81ff-7d35e15961ab"
    },
    {
      id: "5e16b661-bba5-4b9e-9026-ae67e11e8eff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b903073-2098-4b98-9550-1e7bdbdc6268",
      target: "eecabc0b-b15b-44a3-b7b3-0b433a9fe17c"
    },
    {
      id: "af19dba4-2b3a-44f0-80d0-5026e1a8f975",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6b903073-2098-4b98-9550-1e7bdbdc6268",
      target: "ebe5993d-841c-4ccc-b2a6-6dc80951fe69"
    },
    {
      id: "e47448cd-daa3-402a-9e13-7680c15161a1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6b903073-2098-4b98-9550-1e7bdbdc6268",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "cc7230bf-2995-46ad-95ba-4c8ca1e85e59",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      target: "6b903073-2098-4b98-9550-1e7bdbdc6268"
    },
    {
      id: "caaa1562-e31c-4c16-82e6-61d06de7bd6b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      target: "d2d9b972-c72e-4341-8a57-68637848f221"
    },
    {
      id: "49246ad0-f536-483b-86ff-304897cd5470",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      target: "abb34534-4301-4812-9794-66b861e59015"
    },
    {
      id: "5fdab551-40a5-458e-b9f0-3c1284f07eb5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      target: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6"
    },
    {
      id: "2f053f67-4364-48bb-aa70-33e42c7369b5",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2fcf0191-1f51-4df3-81ff-7d35e15961ab",
      target: "6328e14c-1810-407b-b9c8-5ded1d2580c5"
    },
    {
      id: "67d161b9-e6af-4776-ab25-df6404ae7011",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1615638a-a40f-4417-8464-768dddb76836",
      target: "28b639e4-8219-4846-9660-222d96e37b8e"
    },
    {
      id: "7b71e26f-afeb-4cad-8a0f-ef91a13e2e58",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1615638a-a40f-4417-8464-768dddb76836",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "8f46fb15-4955-4cba-a867-d18719f7fa9f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1615638a-a40f-4417-8464-768dddb76836",
      target: "2c4a6049-53c8-4785-b464-67fe218a6310"
    },
    {
      id: "0c908b53-8ad8-4607-a71d-98386332ea23",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1615638a-a40f-4417-8464-768dddb76836",
      target: "e747de92-3612-4383-a084-d397869ed83b"
    },
    {
      id: "4274742c-481b-481a-a54a-db1fff659958",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1615638a-a40f-4417-8464-768dddb76836",
      target: "d34d7cb0-44dc-45d6-a43e-4cf75688b937"
    },
    {
      id: "2ce77ce5-3fd9-4e5b-8984-fa17a08a33a5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeb27339-fb79-41c1-bec2-a7a79b829d2d",
      target: "95c3937e-7cb7-4e72-afd0-9ddaa5348180"
    },
    {
      id: "59de6816-22b8-4123-a89f-bf91b76e5281",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "eeb27339-fb79-41c1-bec2-a7a79b829d2d",
      target: "9006db31-a2f1-40cd-a8a9-82b0d70fec2a"
    },
    {
      id: "50cefde0-d9a3-40b2-95b5-332ce9f58340",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eeb27339-fb79-41c1-bec2-a7a79b829d2d",
      target: "2be7a4ad-05b3-4680-9025-f562fe5417cf"
    },
    {
      id: "5589d7bc-9f9c-44ca-bc28-8614b531cf2f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e747de92-3612-4383-a084-d397869ed83b",
      target: "0f5ed88f-713f-41ca-9c17-a38491a57787"
    },
    {
      id: "7d9ca58e-8d0e-4eec-9049-9c19cf1a66a8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315",
      target: "ec33f3ff-9607-4ee3-890e-0100e4de0b96"
    },
    {
      id: "f9fdc49a-4c71-4e76-b373-dd4249287db8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315",
      target: "eeb27339-fb79-41c1-bec2-a7a79b829d2d"
    },
    {
      id: "2d1ef134-28b2-4195-9b43-c0a77ed2897f",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "1d308a07-dfde-4cc0-9e7e-3a7dcff0f315",
      target: "c2712515-d233-47d4-ab35-a158eeac18dc"
    },
    {
      id: "0d9dd2d4-3477-4e0b-b30c-dc167d72bed8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8bf1adb-9818-411c-99cd-e3af7577367d",
      target: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db"
    },
    {
      id: "236bb677-a96f-484b-8ef9-2902c469a22a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8bf1adb-9818-411c-99cd-e3af7577367d",
      target: "115373ba-c948-4106-807f-766f2afd1633"
    },
    {
      id: "dc2ca351-6010-47e0-9ec1-0c1005996339",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b8bf1adb-9818-411c-99cd-e3af7577367d",
      target: "a9e6da2e-d346-4bdc-902e-a515ca7eb37f"
    },
    {
      id: "1e128dd9-0433-4ec6-9551-ebf7617c1d31",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b8bf1adb-9818-411c-99cd-e3af7577367d",
      target: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb"
    },
    {
      id: "9e685c60-f1a2-4a12-a66b-2a130ba61c38",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "115373ba-c948-4106-807f-766f2afd1633",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "3a8dcb90-90d8-442d-ac15-90b8e1df8c88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "115373ba-c948-4106-807f-766f2afd1633",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "335b1e08-2221-4983-991c-1ea77d0fd0b3",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "115373ba-c948-4106-807f-766f2afd1633",
      target: "bd2cd522-a21f-427a-9611-ec203d20cdc7"
    },
    {
      id: "ddc51d19-9bc5-488a-b679-8a985a6bed69",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "115373ba-c948-4106-807f-766f2afd1633",
      target: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3"
    },
    {
      id: "a7205571-366f-4801-8661-399b17d5986d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3",
      target: "d1e53723-a9e4-40c8-8c3f-a76ece4b98a5"
    },
    {
      id: "2e5a83f1-9f4f-4417-aebc-3364c8c8be19",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3",
      target: "d5033bbc-0b77-4713-81b2-0015044edc5d"
    },
    {
      id: "59ac9e0d-c4d8-4ce8-975c-9250fd0fc7d1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "e72bc9cd-6e23-4638-8916-7260ed546aff",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b96a26ad-19ad-4255-bb54-6a7ca0dc9fa3",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "149069cf-b43f-41ab-906b-8307a52872c4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d5033bbc-0b77-4713-81b2-0015044edc5d",
      target: "78efea14-0b1b-4c66-88e4-582fdf00a3c9"
    },
    {
      id: "1880b532-447c-4eeb-b903-8ca5ff3f7a66",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d5033bbc-0b77-4713-81b2-0015044edc5d",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "14ad2c60-3206-4e74-bcc0-fb2d2fadaca6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d5033bbc-0b77-4713-81b2-0015044edc5d",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "7636cff4-ef36-4621-89c5-d981483ba2f1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "d5033bbc-0b77-4713-81b2-0015044edc5d",
      target: "4be2b649-4fcc-4b45-ac23-4164f85486e6"
    },
    {
      id: "898aba7b-1814-4182-9ce2-10eb23e03134",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4be2b649-4fcc-4b45-ac23-4164f85486e6",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "60342a09-5ed6-4da0-add8-1b85b6cd61c2",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4be2b649-4fcc-4b45-ac23-4164f85486e6",
      target: "448b4847-644e-4690-8d9e-4b40fa0e33b2"
    },
    {
      id: "fc9314c8-6fb8-49c6-b405-377f85e0c587",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4be2b649-4fcc-4b45-ac23-4164f85486e6",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "b54c3cdb-7a09-4677-a552-2f3aab9754fd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9e6da2e-d346-4bdc-902e-a515ca7eb37f",
      target: "bd2cd522-a21f-427a-9611-ec203d20cdc7"
    },
    {
      id: "82c70fdc-1803-4c9a-901b-6fcd5ef0d6dc",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a9e6da2e-d346-4bdc-902e-a515ca7eb37f",
      target: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db"
    },
    {
      id: "2e499f9f-c62e-4fce-818b-4fdc3870fc4b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd2cd522-a21f-427a-9611-ec203d20cdc7",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "5dc6c296-d977-47b0-9070-e5ee61ff739a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "bd2cd522-a21f-427a-9611-ec203d20cdc7",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "49948c8e-883d-4f91-af59-b193698e25f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1e53723-a9e4-40c8-8c3f-a76ece4b98a5",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "b8653cf0-9474-419a-abb3-75c4244e7013",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d1e53723-a9e4-40c8-8c3f-a76ece4b98a5",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "86547988-5585-4bc8-9bb9-99fde78403ab",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78efea14-0b1b-4c66-88e4-582fdf00a3c9",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "42ab7d0e-e0c0-4ed9-952e-c637d93173bb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "78efea14-0b1b-4c66-88e4-582fdf00a3c9",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "78dea1bc-79a7-4deb-8e09-67d70d783d4a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448b4847-644e-4690-8d9e-4b40fa0e33b2",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "aae17e04-29a5-4b89-a5b6-98e2fddef3bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "448b4847-644e-4690-8d9e-4b40fa0e33b2",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "0680c365-aee4-48a9-8f98-687bd4f33fc1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "5080eddb-27ca-4a28-82ec-053e5a6d88db",
      target: "2ebc6d16-4aed-4085-9462-fbd38edacb2b"
    },
    {
      id: "1ee1ba3d-9cf9-4831-a7e8-79b207cd08d9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5080eddb-27ca-4a28-82ec-053e5a6d88db",
      target: "951e7f90-d5c3-4bf4-852f-4bce5c0dd488"
    },
    {
      id: "7c268476-13b2-48e3-b001-77650a0f65bd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5080eddb-27ca-4a28-82ec-053e5a6d88db",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "597c8391-8f6f-45f7-bbf7-4ecf31dfa2f2",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "5080eddb-27ca-4a28-82ec-053e5a6d88db",
      target: "96c4da44-9951-472e-8a46-30de0eeb2781"
    },
    {
      id: "bd1e122a-43f5-4a0d-8cd1-80e97f989804",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "96c4da44-9951-472e-8a46-30de0eeb2781",
      target: "f8a54d36-e2e7-46fe-ac2f-b0ff914573f5"
    },
    {
      id: "12b94a87-44c1-48f0-8da6-fcdf8a8d7310",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "96c4da44-9951-472e-8a46-30de0eeb2781",
      target: "1455a002-7d07-41c4-85f5-43fec32823fd"
    },
    {
      id: "a6365826-6b36-425b-baae-c33702639d9d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "96c4da44-9951-472e-8a46-30de0eeb2781",
      target: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb"
    },
    {
      id: "eb86454d-ed25-4b7c-ac33-e038d8e9a33b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09",
      target: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8"
    },
    {
      id: "755db232-7803-4826-b126-3460a4819e63",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09",
      target: "3edf62c5-ed13-4a70-8fc9-86bc47e82617"
    },
    {
      id: "93f3d2d6-9797-4463-952d-3f7990244e85",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09",
      target: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6"
    },
    {
      id: "f1a682c6-0619-4d2c-a3c5-5b2916b5955e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d8c22c0b-9afe-456e-9d80-7bd9d4370c09",
      target: "54713288-8bfb-4bd0-b6ab-6748b6747919"
    },
    {
      id: "a388f7f2-85c8-46ab-aaa3-9ece40333a4d",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6a987797-26f3-4d47-9f6e-ea550c1bd8a8",
      target: "17a792bc-8b6c-4f60-acfc-43a939ecba81"
    },
    {
      id: "a1ac6d31-95c9-4a3d-8799-7d16f720a6dd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6",
      target: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db"
    },
    {
      id: "0f8b4c3a-3986-4333-adde-6bd65e2fd751",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6",
      target: "14aea842-8ba1-4827-9295-2495d96c3d79"
    },
    {
      id: "e414e7d5-4475-41a4-ac1a-929fc0e1ee14",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6",
      target: "d34d7cb0-44dc-45d6-a43e-4cf75688b937"
    },
    {
      id: "96046882-ac75-4275-bca6-66bae114da45",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e87ce244-ecf8-496b-8a30-8b7cdcd54eb6",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "f6118ec3-fb12-4de2-b83b-cd8cd9c4434d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14aea842-8ba1-4827-9295-2495d96c3d79",
      target: "ebeccaa7-5cce-479e-adab-4ec5dea93232"
    },
    {
      id: "e3d2663a-5d41-4397-b025-6b667f609eb7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14aea842-8ba1-4827-9295-2495d96c3d79",
      target: "d34d7cb0-44dc-45d6-a43e-4cf75688b937"
    },
    {
      id: "972519d9-1758-46a4-9254-711d4dfe7033",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14aea842-8ba1-4827-9295-2495d96c3d79",
      target: "5080eddb-27ca-4a28-82ec-053e5a6d88db"
    },
    {
      id: "66250bca-42d9-41ee-b19d-37e007fcfecf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "14aea842-8ba1-4827-9295-2495d96c3d79",
      target: "587a14b0-c535-417d-9dc3-25f34dbe27a3"
    },
    {
      id: "415c5554-46b8-47b0-955b-29c46bb100e6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d34d7cb0-44dc-45d6-a43e-4cf75688b937",
      target: "587a14b0-c535-417d-9dc3-25f34dbe27a3"
    },
    {
      id: "126ecb59-9c0a-4833-8727-4ef8f8d320ee",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d34d7cb0-44dc-45d6-a43e-4cf75688b937",
      target: "ef487ed0-e0ea-4897-a739-b0eccec45793"
    },
    {
      id: "626fc4a9-3ed1-41b8-a3e0-cf57537a7c8a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "587a14b0-c535-417d-9dc3-25f34dbe27a3",
      target: "a4f41d60-c40a-4f4b-90e0-ff5c21b42307"
    },
    {
      id: "de5c2e02-6b0c-4cc5-959a-ae473969fcdb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef487ed0-e0ea-4897-a739-b0eccec45793",
      target: "448174b9-0afa-4c0c-a7a9-79c9f1bd4830"
    },
    {
      id: "bdb528c0-309d-42d7-9912-8c67d804a7be",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef487ed0-e0ea-4897-a739-b0eccec45793",
      target: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db"
    },
    {
      id: "d9bf3be8-a2f0-4823-a4b7-c339b24be34a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef487ed0-e0ea-4897-a739-b0eccec45793",
      target: "7c11424d-9f50-4f85-ac6d-e6717c1416f5"
    },
    {
      id: "efcececa-ec8a-4edf-84d3-292665b282ce",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "ef487ed0-e0ea-4897-a739-b0eccec45793",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "6e45ca9e-cc88-4711-a505-5b8e525c01e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4f41d60-c40a-4f4b-90e0-ff5c21b42307",
      target: "bb7e01b6-6f50-43b1-b716-8c8007cb068b"
    },
    {
      id: "d0096b5c-12f0-4add-bfe7-1a2d42941f74",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "a4f41d60-c40a-4f4b-90e0-ff5c21b42307",
      target: "52e6e47e-5b3e-4672-a8f3-0c4290d05425"
    },
    {
      id: "4de0762c-7339-4593-81b4-64c0ff7f1175",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db",
      target: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb"
    },
    {
      id: "9d6b6952-e460-4565-b1cf-ad8c872cdf67",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8630d6f6-27ea-4b9e-a986-5ca89cdbe0db",
      target: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776"
    },
    {
      id: "abce7a78-b2a7-4efd-9b98-398bd94f32ad",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e2bb8954-ec6f-482d-ae87-8bb73b73ebcb",
      target: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776"
    },
    {
      id: "8efc1b15-9ec3-4ed3-8058-7b304f03eec6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415d197c-8721-4070-b7d2-497fb58e0d02",
      target: "3e60f626-2a1e-4750-9366-6b50c125d012"
    },
    {
      id: "e9ddba11-40fa-4d42-9912-9ac36fd33c6a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415d197c-8721-4070-b7d2-497fb58e0d02",
      target: "706b62e5-8002-44b8-9153-6007b53cd464"
    },
    {
      id: "a2ac7bc2-536d-45e3-9a00-91db68b1f7c0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415d197c-8721-4070-b7d2-497fb58e0d02",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "95f3ffc9-53ae-4e2f-93d6-c804b8b02394",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "415d197c-8721-4070-b7d2-497fb58e0d02",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "f443296d-a240-4d57-a7c0-14c6d6522fa3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7744250-088c-49da-926f-6abe9af37939",
      target: "ba107032-7cc6-4140-8d80-66eac9c10862"
    },
    {
      id: "e8e2e97f-d219-48dd-82c1-aa431f5eebf3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7744250-088c-49da-926f-6abe9af37939",
      target: "8a925966-ce5b-4931-a282-e3043b01a1ab"
    },
    {
      id: "bf53cc94-7fa0-405a-991b-6a3c6a410998",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d7744250-088c-49da-926f-6abe9af37939",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    },
    {
      id: "6223d923-954c-4659-903b-677ba126abfe",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "7c11424d-9f50-4f85-ac6d-e6717c1416f5",
      target: "8a74d03f-f968-44c2-9b53-777ec90bbc73"
    },
    {
      id: "c612a842-201e-40fb-9526-eb0b696982c8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "7c11424d-9f50-4f85-ac6d-e6717c1416f5",
      target: "8664c72e-35ac-4eb1-8948-e96b5ab4a80b"
    },
    {
      id: "0b82f55f-8009-4a86-b600-3a685e1546db",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "7c11424d-9f50-4f85-ac6d-e6717c1416f5",
      target: "64b9fffe-cd95-4ebe-9d96-44888cb955ad"
    },
    {
      id: "76ff0f29-6cd3-4605-a026-92a63005a457",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bb7e01b6-6f50-43b1-b716-8c8007cb068b",
      target: "460505ba-5b31-4e46-9b79-a5bcd8a855b1"
    },
    {
      id: "14e32c21-7193-4bf1-867e-bb39563c81e1",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "bb7e01b6-6f50-43b1-b716-8c8007cb068b",
      target: "d8aa8460-29aa-4d9b-a12b-9dac6158488a"
    },
    {
      id: "4490d401-3478-4905-82c9-5442d3692448",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "bb7e01b6-6f50-43b1-b716-8c8007cb068b",
      target: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776"
    },
    {
      id: "e54f8376-a37f-43b2-8430-213a7b8b52cc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "8a74d03f-f968-44c2-9b53-777ec90bbc73",
      target: "a203770b-2c7b-4121-a8f4-84dd5e8b7563"
    },
    {
      id: "8d13aee6-c9d7-4297-a12f-eac496e86fef",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8a74d03f-f968-44c2-9b53-777ec90bbc73",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "81f161b1-e07f-4891-8a73-c97baa26f834",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "8a74d03f-f968-44c2-9b53-777ec90bbc73",
      target: "d7fa1c3b-2db9-46e4-b999-f7db7ff856a2"
    },
    {
      id: "1e7e7010-30c9-49c8-bdbb-e21cfe663fba",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52e6e47e-5b3e-4672-a8f3-0c4290d05425",
      target: "4169ba48-50aa-43c0-93f6-c64d4090cbb1"
    },
    {
      id: "b1f4d7d5-55d9-4bf4-9d47-a59e579c1b48",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "52e6e47e-5b3e-4672-a8f3-0c4290d05425",
      target: "9994c5c0-df16-4a8a-9cf8-1349b4dc3f48"
    },
    {
      id: "90dbdcf5-771a-428c-9337-3064cb641122",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "52e6e47e-5b3e-4672-a8f3-0c4290d05425",
      target: "a245aa08-11aa-4809-ad44-52e2c2572582"
    },
    {
      id: "39cb3e56-ee8a-4091-899b-af07007d99d8",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "64b9fffe-cd95-4ebe-9d96-44888cb955ad",
      target: "919fde6b-6525-430d-974f-fc044576fa3a"
    },
    {
      id: "941a6c0c-bf99-45e0-a394-b6b77cb4a18d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "64b9fffe-cd95-4ebe-9d96-44888cb955ad",
      target: "3450f3ae-4523-482a-bd62-921a761ee582"
    },
    {
      id: "9f3709ae-9f64-4c19-9720-829c4dddb570",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "64b9fffe-cd95-4ebe-9d96-44888cb955ad",
      target: "eed9c4c6-0bd1-4a9b-88e3-f11ce163b390"
    },
    {
      id: "bdc9e1cf-c2bd-4e0e-a174-1b25e5fe624d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eed9c4c6-0bd1-4a9b-88e3-f11ce163b390",
      target: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864"
    },
    {
      id: "258260d8-2ea3-4e3e-a31f-057794ab2aee",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776",
      target: "412a5e01-9a29-48d8-9544-d974c84e6443"
    },
    {
      id: "4a10c885-c221-4872-9cc6-5e6de9dd0cbf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776",
      target: "480dc9b0-680e-4a83-890b-4635b31b6983"
    },
    {
      id: "f1357608-be9d-448b-8b7d-0ca93923a372",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "b1fcd097-0b4e-48a0-9ea9-12c623fbc776",
      target: "6da0772f-bc9d-4678-a56b-1ee395993af4"
    },
    {
      id: "4ebb7548-d68f-4b20-94f3-551ac81673e9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "480dc9b0-680e-4a83-890b-4635b31b6983",
      target: "eea96588-e7a0-4154-b8e1-8832accf4710"
    },
    {
      id: "9a6952a5-ad0f-43b5-bd0e-9ca25c84ade9",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "9afaeea2-2bf3-4cea-bf21-85e7728d6234",
      target: "4504c57c-90c8-40fe-bd78-a8ef31b054bf"
    },
    {
      id: "aa1bdd55-eace-4635-b8d1-09a980ada0df",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9afaeea2-2bf3-4cea-bf21-85e7728d6234",
      target: "df2d46ff-cec6-4c94-ab1c-f55d3dc7e3e9"
    },
    {
      id: "9cf02593-6695-4dcc-8db6-146586be6d22",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9afaeea2-2bf3-4cea-bf21-85e7728d6234",
      target: "a7e191ac-ae65-47ee-8772-9b034e366c04"
    },
    {
      id: "fac93e96-7be7-4296-a969-da1f532ba0d2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "df2d46ff-cec6-4c94-ab1c-f55d3dc7e3e9",
      target: "0af04484-5114-40f9-855c-6978bac455d4"
    },
    {
      id: "df9e2302-b9ba-4256-bf2f-79917c69c46b",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "4169ba48-50aa-43c0-93f6-c64d4090cbb1",
      target: "66d5fb70-4127-4bd5-acfc-d7e8b903a2f0"
    },
    {
      id: "b91bb21b-54be-43e5-b3e8-539fe78dd995",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "4169ba48-50aa-43c0-93f6-c64d4090cbb1",
      target: "2ba2b7e0-2211-4698-8c1c-2b8867193aa1"
    },
    {
      id: "179910e1-a852-4c6b-8ee2-2f629747b07b",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "4169ba48-50aa-43c0-93f6-c64d4090cbb1",
      target: "b78830d7-dbe7-4fed-add3-f652a8bd3832"
    },
    {
      id: "174627fe-3761-4fbc-bcf7-a527e8d2e921",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2ba2b7e0-2211-4698-8c1c-2b8867193aa1",
      target: "51d0027b-585e-4c3f-9f2f-0c3910e28559"
    },
    {
      id: "609b037b-cb8f-4dc9-9d8a-7e9133db9d48",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      target: "9afaeea2-2bf3-4cea-bf21-85e7728d6234"
    },
    {
      id: "6fc0b69d-c0b6-485d-a59e-fd5b3485de0a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      target: "4d719932-f0c2-4ea5-903c-c125369ea801"
    },
    {
      id: "a62d6de1-c153-4843-ad8f-d8353260cde7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      target: "eea96588-e7a0-4154-b8e1-8832accf4710"
    },
    {
      id: "0e88f230-8972-44d6-afe0-372d35244c25",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      target: "3b4a4ecc-e5c6-4f03-98fb-ec4afc6885de"
    },
    {
      id: "c55c0284-934a-480a-bf9b-fb78925a1a10",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "6bcb3ac5-7cd1-4e0c-bcd1-7762b4fcf864",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "3ad96063-f19d-44e7-807a-55e6a6aed0f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "169464c2-4976-4da3-8162-fc3b0d8df6d0",
      target: "8ef8d50e-92d0-4d03-984b-806318da250c"
    },
    {
      id: "898dea8e-309b-44ee-bd4b-a31b632bfada",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "169464c2-4976-4da3-8162-fc3b0d8df6d0",
      target: "8b101403-d69e-4cbf-89d2-d57dfe579918"
    },
    {
      id: "5f6a29a2-821c-4afb-b62b-0ccc7e4c98b4",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "169464c2-4976-4da3-8162-fc3b0d8df6d0",
      target: "81ab71bd-6025-4df1-8730-74f01fab7d68"
    },
    {
      id: "5934fc03-c2d0-4645-a2fb-0c26bc2536f7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "169464c2-4976-4da3-8162-fc3b0d8df6d0",
      target: "415d197c-8721-4070-b7d2-497fb58e0d02"
    },
    {
      id: "bcf0c41e-bf4a-47b2-bded-b5591418ad2d",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "eea96588-e7a0-4154-b8e1-8832accf4710",
      target: "4d632449-757e-42d0-af24-30435e124aef"
    },
    {
      id: "5da89513-5612-4b21-8c18-ad2ee7b23217",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "eea96588-e7a0-4154-b8e1-8832accf4710",
      target: "54fa6b99-2ac8-4823-8b12-d16a43354a24"
    },
    {
      id: "7faa4731-da42-4078-9a9a-64f1aaa26030",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eea96588-e7a0-4154-b8e1-8832accf4710",
      target: "169464c2-4976-4da3-8162-fc3b0d8df6d0"
    },
    {
      id: "6f80da4a-6954-411c-81e6-a8e6a3789e93",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "0af04484-5114-40f9-855c-6978bac455d4",
      target: "0baaf4d0-808b-43e7-8c3c-4c3885424656"
    },
    {
      id: "72f0ce9b-5af7-46f9-9bb3-e3123367acf7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "0af04484-5114-40f9-855c-6978bac455d4",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "517f074d-14e1-452f-b31f-65c2b966f631",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "0af04484-5114-40f9-855c-6978bac455d4",
      target: "120c5a87-9675-41d5-91c8-c4c60524fa89"
    },
    {
      id: "48df5cf4-0913-41db-83e7-d9d7fc3fbdbc",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "26da9252-5527-471f-b6cd-064be6fea286",
      target: "6413bb2a-cb70-4f6c-879a-840667f54942"
    },
    {
      id: "0a40f672-235c-496c-813f-1a3ec043487c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26da9252-5527-471f-b6cd-064be6fea286",
      target: "04625d21-10c3-4bbc-8fce-c40a18b4f846"
    },
    {
      id: "99c6b06a-e610-4a1f-9cdb-349be62cfd26",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "26da9252-5527-471f-b6cd-064be6fea286",
      target: "ad355aea-c3eb-4d10-a36e-0951e66d23c6"
    },
    {
      id: "2cd9bc4a-5c81-4135-a605-f5301ba4a6e0",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "51d0027b-585e-4c3f-9f2f-0c3910e28559",
      target: "3437cc2b-aff8-43b6-8f66-cd47ff78ff5f"
    },
    {
      id: "bd2dda09-e26c-45c9-b394-8899e8fc6d82",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "51d0027b-585e-4c3f-9f2f-0c3910e28559",
      target: "ae43484f-bbad-4916-9ae4-5630dee3996c"
    },
    {
      id: "60a49e38-6c10-4c44-b301-3e899fe71d88",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "51d0027b-585e-4c3f-9f2f-0c3910e28559",
      target: "26da9252-5527-471f-b6cd-064be6fea286"
    },
    {
      id: "16b9bf2f-86ca-4504-8fe4-b553d30ae7a2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "aad2ee27-75d9-4b82-a5af-932ef4a31fad",
      target: "006347af-648b-4dcc-a410-6e226dbac75e"
    },
    {
      id: "b2256777-be52-45ce-a3c6-f0d5e2a858f5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346",
      target: "d0fe2a47-291c-4527-8865-41785c38f7e5"
    },
    {
      id: "defdf4b8-0dd9-4f50-9eef-62c198325b94",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346",
      target: "c4989ce3-5dc9-4610-8e1e-2406f305d3e6"
    },
    {
      id: "9e3c9fb5-d1d5-4750-a77c-5642445d960d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "663e5a33-0ec2-4f2d-8e4c-d19595a4a346",
      target: "e9e23379-a129-4ebb-b80c-e8552edee979"
    },
    {
      id: "a894c44c-7b8f-4268-8d2f-de39cb73a935",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "33b65098-085e-400d-9d1a-636057e978d8",
      target: "96af88c9-9303-4517-8063-d5291d0ec79d"
    },
    {
      id: "5473bb40-dd71-4c9b-967c-d6c5d1363d06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9211a90-3325-4503-946c-da72e8ca4e4d",
      target: "e9e23379-a129-4ebb-b80c-e8552edee979"
    },
    {
      id: "18630c7b-b028-4287-b381-bd3d702b9240",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "d9211a90-3325-4503-946c-da72e8ca4e4d",
      target: "1fda8693-bdc9-47c0-9dd9-f1ce430884e8"
    },
    {
      id: "13dc8f11-5c1d-4c40-b738-ed0d4b0654cb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b13b2083-0b59-41eb-bba0-f29dd1ee78ed",
      target: "eff587e0-9b20-4414-8570-445f04d4ed9e"
    },
    {
      id: "57254f84-322c-4736-89d1-854d20c17278",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b13b2083-0b59-41eb-bba0-f29dd1ee78ed",
      target: "405159c3-279f-4a22-ab08-21372783d94a"
    },
    {
      id: "52e85768-23b4-466c-afb1-34cc9a8dce7f",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eff587e0-9b20-4414-8570-445f04d4ed9e",
      target: "fd234342-f0d8-40a3-8318-20c783e1e6d0"
    },
    {
      id: "d4b87330-afb4-4a80-89af-176b996663e3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eff587e0-9b20-4414-8570-445f04d4ed9e",
      target: "5b8e6dfe-1fa4-460e-b6d8-920b332477ed"
    },
    {
      id: "26d764c0-8fdd-4119-a387-095d510dd583",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "eff587e0-9b20-4414-8570-445f04d4ed9e",
      target: "dcd35ac1-e25d-43a7-808d-439be1ef88c7"
    },
    {
      id: "7475a4c7-a42c-46c3-96ab-1125d74ed0c5",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "405159c3-279f-4a22-ab08-21372783d94a",
      target: "be41b8d4-c507-48e7-9772-7bcb4cbffe70"
    },
    {
      id: "4f926b81-fb30-4ea5-95fe-5355f67e8b06",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "405159c3-279f-4a22-ab08-21372783d94a",
      target: "5b8e6dfe-1fa4-460e-b6d8-920b332477ed"
    },
    {
      id: "3d76f2a5-5e4c-4f1a-83f7-bd7ee229a9d9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "405159c3-279f-4a22-ab08-21372783d94a",
      target: "dcd35ac1-e25d-43a7-808d-439be1ef88c7"
    },
    {
      id: "a5775063-c427-43a9-a1d3-ce8691753ddd",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "fd234342-f0d8-40a3-8318-20c783e1e6d0",
      target: "ea0de3c5-d25b-4e5d-93d9-a4baa884db3b"
    },
    {
      id: "e8c9fbcc-f9a2-459f-ad4e-e35a58f437ba",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be41b8d4-c507-48e7-9772-7bcb4cbffe70",
      target: "41ed3436-5df8-40a7-8776-c4f214dfa777"
    },
    {
      id: "2a14ce84-e3e2-4fdc-ab15-bc8496c8e2b9",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be41b8d4-c507-48e7-9772-7bcb4cbffe70",
      target: "c5f76e06-e89e-4a2e-b9f4-4aa3cb73c734"
    },
    {
      id: "2157184e-c28f-449e-8c54-8e03ffca647d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "be41b8d4-c507-48e7-9772-7bcb4cbffe70",
      target: "5565e178-4b72-4587-bdca-3728e274025f"
    },
    {
      id: "3359160d-e06a-49bc-92d4-66ef977f2820",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b8e6dfe-1fa4-460e-b6d8-920b332477ed",
      target: "fd234342-f0d8-40a3-8318-20c783e1e6d0"
    },
    {
      id: "0c2cc818-9573-4056-8920-5280c51f9415",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "5b8e6dfe-1fa4-460e-b6d8-920b332477ed",
      target: "be41b8d4-c507-48e7-9772-7bcb4cbffe70"
    },
    {
      id: "d14fcfa4-ecff-4d19-bf35-9ff957cfe368",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "dcd35ac1-e25d-43a7-808d-439be1ef88c7",
      target: "be41b8d4-c507-48e7-9772-7bcb4cbffe70"
    },
    {
      id: "087ec161-bbfd-4d1b-bce4-3fefd1189e1a",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b3358cb7-9a51-4f12-a11c-43e133cd5f85",
      target: "8d13ff6b-0d1a-434c-93e9-e19b1d5421ec"
    },
    {
      id: "66ccd163-6e6d-487c-9312-6ff76c4778f4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "2d33af29-1e4e-4310-ac3d-148b228c2e32",
      target: "8d13ff6b-0d1a-434c-93e9-e19b1d5421ec"
    },
    {
      id: "298a2372-4e4c-4a73-90c0-816656d5624c",
      gantt_link_type: {
        id: 1,
        value: "start_to_start"
      },
      source: "2d33af29-1e4e-4310-ac3d-148b228c2e32",
      target: "b3358cb7-9a51-4f12-a11c-43e133cd5f85"
    },
    {
      id: "ad34b770-3bf6-4999-a9ca-38d680916cfb",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "8d13ff6b-0d1a-434c-93e9-e19b1d5421ec",
      target: "61807e5c-16ed-443c-81dd-a36d98ef965d"
    },
    {
      id: "f4c10db3-cb05-45ea-a374-4747df3c1d5e",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "61807e5c-16ed-443c-81dd-a36d98ef965d",
      target: "1ecca2ad-412b-4657-a1ea-a21befefd009"
    },
    {
      id: "88e807f6-a0ce-498a-83db-97f82c337fdd",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9df1507b-8921-42e3-b144-cf7e9024176f",
      target: "28dc52fb-1a39-4cc2-91bc-f365281cd27d"
    },
    {
      id: "965e12c8-8966-47d2-a6b3-1d1dda906b02",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "9df1507b-8921-42e3-b144-cf7e9024176f",
      target: "43c532d0-be4c-496e-86c4-0eea88b87e23"
    },
    {
      id: "e0ef3962-b65f-47ec-8331-887c31196805",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e301e0be-f7f8-46c4-8204-68b86cb3e42a",
      target: "9b9ca51f-3732-42a7-9ec8-81140732591d"
    },
    {
      id: "5ecbd2f5-72ad-414e-a2b4-ca318c88a4bf",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9b9ca51f-3732-42a7-9ec8-81140732591d",
      target: "510381a3-4332-49de-8527-36dc5f282b3c"
    },
    {
      id: "f4231654-5d01-43e4-ac85-3d700b635475",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "510381a3-4332-49de-8527-36dc5f282b3c",
      target: "85de7da8-34c4-4e4d-80d0-bce6ba58d896"
    },
    {
      id: "b4be4fe5-94a0-41b1-a54d-6e7b537332b1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "510381a3-4332-49de-8527-36dc5f282b3c",
      target: "6dd38d3a-408d-4f08-be6b-fc28e0f9e1ed"
    },
    {
      id: "e83844f0-6e0d-4787-9feb-45873564b69a",
      gantt_link_type: {
        id: 2,
        value: "finish_to_finish"
      },
      source: "510381a3-4332-49de-8527-36dc5f282b3c",
      target: "a1f49bec-c97d-49f6-9fec-96d8136336ed"
    },
    {
      id: "d772e0f8-d35d-4fb9-866f-caa20f990119",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "50b67990-912a-4528-969d-ecb49f0307ee",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "86fa43c3-7958-416e-9474-ad3bf6275a36",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "805559b8-977c-468b-9080-42c618feb295",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "de98bd2d-2b04-46a2-bd61-5783a239a8c8",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "11758442-99fc-4cb5-92f0-2e4875d8c296",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "f7a87c9f-fb70-4111-9494-1b2495790d41",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "59137c5e-a4c4-472d-9a7c-a8c5b53f55a4",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "30fdbe88-8bd0-4d7f-a163-c69c3afabec7",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "c843df31-38a5-4705-819d-f3c428d72755",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "cf6eca3b-7f91-4573-a62d-e02f95cb220b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e9d2b8d9-edb9-40f3-884b-c7d0d7742c53",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "dcfd3ade-e7d4-420c-9397-2de4a418ec0d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e49c3a7d-4a9a-4b57-b6f9-066e45d695ee",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "1b3ac957-a665-4ab8-a09d-5278648bb45c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "e81c75e4-bb55-4435-a062-96ab7ab7401f",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "49915081-e00c-422a-a751-0ddda86898a1",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "da9806b4-2d71-4501-8c5c-b4e6b9537279",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "a198eaba-d3fd-4e90-9a3c-5c0862d04b79",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45f9325e-cbba-47d5-8f66-00c081e6aa73",
      target: "028cb7c0-7617-4664-8fcd-d6d41251d127"
    },
    {
      id: "86cce8f0-d03f-4cfb-ba1f-12ec45c60d13",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "45f9325e-cbba-47d5-8f66-00c081e6aa73",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "47ebeb42-dc43-419e-ade5-f4d72b00a95b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "028cb7c0-7617-4664-8fcd-d6d41251d127",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "7dee995f-40c2-41d7-bd0b-fc4456445309",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "1c543080-2ce6-46a7-b9a0-852ddc8a5be2",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "4e38fe7d-d79c-43ee-9fa9-a120a635aea2",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "adaa990b-7ce7-4dab-b72f-00794844510c",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "fd74f1fe-7555-4aec-842a-34c415def89d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "46821895-f91c-4fa1-a1d6-ba135d144d08",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "d1df3f18-fa46-4097-8e2b-f145dbe13ba4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b7c33fc5-0abe-4837-beb7-2a4c40a39f3d",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "dd7e3858-981c-4d7a-9711-b65c65c328d3",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "9d0d146a-3778-457c-b05e-28988fa2922d"
    },
    {
      id: "01a4103d-d616-412e-9213-3c112e6480f6",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "c843df31-38a5-4705-819d-f3c428d72755"
    },
    {
      id: "ffd339d5-d414-44d7-9deb-84a4d726c7f0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "50b67990-912a-4528-969d-ecb49f0307ee"
    },
    {
      id: "f5732d7a-fdb0-485d-aa32-88d6de966544",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "805559b8-977c-468b-9080-42c618feb295"
    },
    {
      id: "37149884-76f4-4c5f-8b4a-003e9d0161e0",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "11758442-99fc-4cb5-92f0-2e4875d8c296"
    },
    {
      id: "0babbff8-d292-4487-922b-427a1950e165",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "59137c5e-a4c4-472d-9a7c-a8c5b53f55a4"
    },
    {
      id: "2aff81e1-f01a-41d4-80fc-bfc2d591df52",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "1c543080-2ce6-46a7-b9a0-852ddc8a5be2"
    },
    {
      id: "9f8d5b20-d50b-44dc-9ec7-33a73caba69b",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "e9d2b8d9-edb9-40f3-884b-c7d0d7742c53"
    },
    {
      id: "50f4592c-ba5f-4872-898b-28a9f1ee488d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "b7c33fc5-0abe-4837-beb7-2a4c40a39f3d"
    },
    {
      id: "390a5fff-a316-4709-9bae-ff0ba5b3fb40",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "45f9325e-cbba-47d5-8f66-00c081e6aa73"
    },
    {
      id: "85d9eca6-0732-4e1f-96f7-f8eb420a7a17",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "e49c3a7d-4a9a-4b57-b6f9-066e45d695ee"
    },
    {
      id: "7b07298e-4591-4793-b770-6c80069694d4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "028cb7c0-7617-4664-8fcd-d6d41251d127"
    },
    {
      id: "c774f8db-6b05-49b0-bf45-7395afce5c8d",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "e81c75e4-bb55-4435-a062-96ab7ab7401f"
    },
    {
      id: "7b51c7c9-5385-4a5a-a2fc-5f99f44ef4b4",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "da9806b4-2d71-4501-8c5c-b4e6b9537279"
    },
    {
      id: "1a147fc5-58da-49e3-ae58-af746a9a5b99",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "adaa990b-7ce7-4dab-b72f-00794844510c"
    },
    {
      id: "d1b0ef4e-a7a2-4ef1-8d5b-0e88d603c483",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "b6282542-918a-4c3f-a27e-693fef05f4f7",
      target: "46821895-f91c-4fa1-a1d6-ba135d144d08"
    },
    {
      id: "07f0efcc-4c65-480b-87bd-1c949c7f069c",
      gantt_link_type: {
        id: 0,
        value: "finish_to_start"
      },
      source: "9d0d146a-3778-457c-b05e-28988fa2922d",
      target: "244e2659-62ad-403e-bf8f-b143d2d8816e"
    }
  ]
};
